(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.l.kA === region.i.kA)
	{
		return 'on line ' + region.l.kA;
	}
	return 'on lines ' + region.l.kA + ' through ' + region.i.kA;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nk,
		impl.pA,
		impl.pp,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		nH: func(record.nH),
		pm: record.pm,
		oW: record.oW
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.nH;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.pm;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.oW) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nk,
		impl.pA,
		impl.pp,
		function(sendToApp, initialModel) {
			var view = impl.pC;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nk,
		impl.pA,
		impl.pp,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.ix && impl.ix(sendToApp)
			var view = impl.pC;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.getElementById("elmIsolationContainer");
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.f$);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.iS) && (_VirtualDom_doc.title = title = doc.iS);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.oH;
	var onUrlRequest = impl.oI;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		ix: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.oY === next.oY
							&& curr.ng === next.ng
							&& curr.oS.a === next.oS.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		nk: function(flags)
		{
			return A3(impl.nk, flags, _Browser_getUrl(), key);
		},
		pC: impl.pC,
		pA: impl.pA,
		pp: impl.pp
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { nd: 'hidden', mu: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { nd: 'mozHidden', mu: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { nd: 'msHidden', mu: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { nd: 'webkitHidden', mu: 'webkitvisibilitychange' }
		: { nd: 'hidden', mu: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		lu: _Browser_getScene(),
		l0: {
			l4: _Browser_window.pageXOffset,
			l5: _Browser_window.pageYOffset,
			dR: _Browser_doc.documentElement.clientWidth,
			gQ: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		dR: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		gQ: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			lu: {
				dR: node.scrollWidth,
				gQ: node.scrollHeight
			},
			l0: {
				l4: node.scrollLeft,
				l5: node.scrollTop,
				dR: node.clientWidth,
				gQ: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			lu: _Browser_getScene(),
			l0: {
				l4: x,
				l5: y,
				dR: _Browser_doc.documentElement.clientWidth,
				gQ: _Browser_doc.documentElement.clientHeight
			},
			mS: {
				l4: x + rect.left,
				l5: y + rect.top,
				dR: rect.width,
				gQ: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.mW.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.mW.b, xhr)); });
		$elm$core$Maybe$isJust(request.pz) && _Http_track(router, xhr, request.pz.a);

		try {
			xhr.open(request.eX, request.iV, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.iV));
		}

		_Http_configureRequest(xhr, request);

		request.f$.a && xhr.setRequestHeader('Content-Type', request.f$.a);
		xhr.send(request.f$.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.nc; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.pv.a || 0;
	xhr.responseType = request.mW.d;
	xhr.withCredentials = request.mg;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		iV: xhr.responseURL,
		pk: xhr.status,
		pl: xhr.statusText,
		nc: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			ph: event.loaded,
			aO: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			o1: event.loaded,
			aO: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.kE) { flags += 'm'; }
	if (options.jn) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}



// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}


// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });
var $author$project$Msg$OnUrlChange = function (a) {
	return {$: 2, a: a};
};
var $author$project$Msg$OnUrlRequest = function (a) {
	return {$: 1, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.r) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.v),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.v);
		} else {
			var treeLen = builder.r * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.x) : builder.x;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.r);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.v) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.v);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{x: nodeList, r: (len / $elm$core$Array$branchFactor) | 0, v: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {m0: fragment, ng: host, oP: path, oS: port_, oY: protocol, ll: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Msg$GotLogoutResult = function (a) {
	return {$: 7, a: a};
};
var $author$project$Msg$Login = function (a) {
	return {$: 5, a: a};
};
var $author$project$Msg$NotAuthorized = function (a) {
	return {$: 4, a: a};
};
var $author$project$Msg$NotFound = function (a) {
	return {$: 3, a: a};
};
var $author$project$Msg$OfferDetails = function (a) {
	return {$: 11, a: a};
};
var $author$project$Msg$Payment = function (a) {
	return {$: 9, a: a};
};
var $author$project$Msg$PolicyDetails = function (a) {
	return {$: 10, a: a};
};
var $author$project$Msg$Search = function (a) {
	return {$: 8, a: a};
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$browser$Browser$Navigation$back = F2(
	function (key, n) {
		return A2(_Browser_go, key, -n);
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.pk));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $author$project$Env$logoutPath = function (_v0) {
	var environment = _v0;
	return environment.c5;
};
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {lq: reqs, lR: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.pz;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.lq));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.lR)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					mg: r.mg,
					f$: r.f$,
					mW: A2(_Http_mapExpect, func, r.mW),
					nc: r.nc,
					eX: r.eX,
					pv: r.pv,
					pz: r.pz,
					iV: r.iV
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{mg: true, f$: r.f$, mW: r.mW, nc: r.nc, eX: r.eX, pv: r.pv, pz: r.pz, iV: r.iV}));
};
var $author$project$Utils$executeLogout = F3(
	function (env, urlExtractor, tagger) {
		return $elm$http$Http$riskyRequest(
			{
				f$: $elm$http$Http$emptyBody,
				mW: $elm$http$Http$expectWhatever(tagger),
				nc: _List_Nil,
				eX: 'POST',
				pv: $elm$core$Maybe$Nothing,
				pz: $elm$core$Maybe$Nothing,
				iV: _Utils_ap(
					urlExtractor(env),
					$author$project$Env$logoutPath(env))
			});
	});
var $author$project$Env$languageOverride = function (_v0) {
	var environment = _v0;
	return environment.c$;
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Env$newApiUrl = function (_v0) {
	var environment = _v0;
	return environment.c7;
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$Page$Login$Msg$GotAuthCheckResult = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $dillonkearns$elm_graphql$Graphql$Http$HttpError = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Task$fail = _Scheduler_fail;
var $dillonkearns$elm_graphql$Graphql$Http$failTaskOnHttpSuccessWithErrors = function (successOrError) {
	if (!successOrError.$) {
		var value = successOrError.a;
		return $elm$core$Task$succeed(value);
	} else {
		var _v1 = successOrError.a;
		var possiblyParsedData = _v1.a;
		var graphqlErrorGraphqlErrorList = _v1.b;
		return $elm$core$Task$fail(
			A2($dillonkearns$elm_graphql$Graphql$Http$GraphqlError, possiblyParsedData, graphqlErrorGraphqlErrorList));
	}
};
var $elm$core$Task$mapError = F2(
	function (convert, task) {
		return A2(
			$elm$core$Task$onError,
			A2($elm$core$Basics$composeL, $elm$core$Task$fail, convert),
			task);
	});
var $dillonkearns$elm_graphql$Graphql$Http$BadPayload = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$BadStatus = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$NetworkError = {$: 2};
var $dillonkearns$elm_graphql$Graphql$Http$Timeout = {$: 1};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $dillonkearns$elm_graphql$Graphql$Http$jsonResolver = function (decoder) {
	return $elm$http$Http$stringResolver(
		function (response) {
			switch (response.$) {
				case 0:
					var url = response.a;
					return $elm$core$Result$Err(
						$dillonkearns$elm_graphql$Graphql$Http$BadUrl(url));
				case 1:
					return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$Timeout);
				case 2:
					return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$NetworkError);
				case 3:
					var metadata = response.a;
					var body = response.b;
					return $elm$core$Result$Err(
						A2($dillonkearns$elm_graphql$Graphql$Http$BadStatus, metadata, body));
				default:
					var metadata = response.a;
					var body = response.b;
					var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
					if (!_v1.$) {
						var value = _v1.a;
						return $elm$core$Result$Ok(value);
					} else {
						var err = _v1.a;
						return $elm$core$Result$Err(
							$dillonkearns$elm_graphql$Graphql$Http$BadPayload(err));
					}
			}
		});
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Get = 0;
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Post = 1;
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength = 2000;
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation = F2(
	function (replacements, _v0) {
		var match = _v0.c6;
		var ordinalString = A2(
			$elm$core$Basics$composeL,
			$elm$core$String$dropLeft(1),
			$elm$core$String$dropRight(1))(match);
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function (value) {
					return A2($elm$core$Array$get, value, replacements);
				},
				$elm$core$String$toInt(ordinalString)));
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{x: nodeList, r: nodeListSize, v: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {d: index, c6: match, n_: number, lQ: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{jn: false, kE: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\\{\\d+\\}'));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolate = F2(
	function (string, args) {
		var asArray = $elm$core$Array$fromList(args);
		return A3(
			$elm$regex$Regex$replace,
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex,
			$lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation(asArray),
			string);
	});
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $dillonkearns$elm_graphql$Graphql$Document$Hash$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {bA: charsProcessed, bK: hash, bj: seed, cf: shift};
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$c1 = 3432918353;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$c2 = 461845907;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize = function (data) {
	var acc = (!(!data.bK)) ? (data.bj ^ A2(
		$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
		$dillonkearns$elm_graphql$Graphql$Document$Hash$c2,
		A2(
			$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
			15,
			A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, data.bK)))) : data.bj;
	var h0 = acc ^ data.bA;
	var h1 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$mix = F2(
	function (h1, k1) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
			5,
			A2(
				$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
				13,
				h1 ^ A2(
					$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
					$dillonkearns$elm_graphql$Graphql$Document$Hash$c2,
					A2(
						$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
						15,
						A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, k1))))) + 3864292196;
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold = F2(
	function (c, data) {
		var res = data.bK | ((255 & $elm$core$Char$toCode(c)) << data.cf);
		var _v0 = data.cf;
		if (_v0 === 24) {
			return {
				bA: data.bA + 1,
				bK: 0,
				bj: A2($dillonkearns$elm_graphql$Graphql$Document$Hash$mix, data.bj, res),
				cf: 0
			};
		} else {
			return {bA: data.bA + 1, bK: res, bj: data.bj, cf: data.cf + 8};
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashString = F2(
	function (seed, str) {
		return $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize(
			A3(
				$elm$core$String$foldl,
				$dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold,
				A4($dillonkearns$elm_graphql$Graphql$Document$Hash$HashData, 0, seed, 0, 0),
				str));
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$List = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object = function (a) {
	return {$: 3, a: a};
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize = function (value) {
	var serializeJson = function (json) {
		var decoder = $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeL,
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$List,
						$elm$core$List$map($dillonkearns$elm_graphql$Graphql$Internal$Encode$Json)),
					$elm$json$Json$Decode$list($elm$json$Json$Decode$value)),
					A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeL,
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$Object,
						$elm$core$List$map(
							$elm$core$Tuple$mapSecond($dillonkearns$elm_graphql$Graphql$Internal$Encode$Json))),
					$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value))
				]));
		var _v2 = A2($elm$json$Json$Decode$decodeValue, decoder, json);
		if (!_v2.$) {
			var v = _v2.a;
			return $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(v);
		} else {
			return A2($elm$json$Json$Encode$encode, 0, json);
		}
	};
	switch (value.$) {
		case 0:
			var enumValue = value.a;
			return enumValue;
		case 1:
			var json = value.a;
			return serializeJson(json);
		case 2:
			var values = value.a;
			return '[' + (A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize, values)) + ']');
		default:
			var keyValuePairs = value.a;
			return '{' + (A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function (_v1) {
						var key = _v1.a;
						var objectValue = _v1.b;
						return key + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(objectValue));
					},
					keyValuePairs)) + '}');
	}
};
var $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return name + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(value));
};
var $dillonkearns$elm_graphql$Graphql$Document$Argument$serialize = function (args) {
	if (!args.b) {
		return '';
	} else {
		var nonemptyArgs = args;
		return '(' + (A2(
			$elm$core$String$join,
			', ',
			A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString, nonemptyArgs)) + ')');
	}
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash = function (field) {
	return A2(
		$elm$core$Maybe$map,
		$dillonkearns$elm_graphql$Graphql$Document$Hash$hashString(0),
		function () {
			if (!field.$) {
				var name = field.a;
				var _arguments = field.b;
				var children = field.c;
				return $elm$core$List$isEmpty(_arguments) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments));
			} else {
				var typeString = field.a.lZ;
				var fieldName = field.a.jY;
				var _arguments = field.b;
				return (fieldName === '__typename') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$elm$core$String$concat(
						A2(
							$elm$core$List$append,
							_List_fromArray(
								[typeString]),
							$elm$core$List$singleton(
								$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments)))));
			}
		}());
};
var $dillonkearns$elm_graphql$Graphql$RawField$name = function (field) {
	if (!field.$) {
		var fieldName = field.a;
		var argumentList = field.b;
		var fieldList = field.c;
		return fieldName;
	} else {
		var typeString = field.a.lZ;
		var fieldName = field.a.jY;
		var argumentList = field.b;
		return fieldName;
	}
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$alias = function (field) {
	return A2(
		$elm$core$Maybe$map,
		function (aliasHash) {
			return _Utils_ap(
				$dillonkearns$elm_graphql$Graphql$RawField$name(field),
				$elm$core$String$fromInt(aliasHash));
		},
		$dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash(field));
};
var $j_maas$elm_ordered_containers$OrderedDict$OrderedDict = $elm$core$Basics$identity;
var $j_maas$elm_ordered_containers$OrderedDict$empty = {o: $elm$core$Dict$empty, oM: _List_Nil};
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $elm$core$Set$singleton = function (key) {
	return A2($elm$core$Dict$singleton, key, 0);
};
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$findConflictingTypeFields = function (rawFields) {
	var compositeCount = $elm$core$List$length(
		A2(
			$elm$core$List$filterMap,
			function (field) {
				if (!field.$) {
					return $elm$core$Maybe$Just(0);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			rawFields));
	if (compositeCount <= 1) {
		return $elm$core$Set$empty;
	} else {
		var levelBelowNodes = A2(
			$elm$core$List$concatMap,
			function (field) {
				if (field.$ === 1) {
					return _List_Nil;
				} else {
					var children = field.c;
					return children;
				}
			},
			rawFields);
		var fieldTypes = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, acc) {
					var fieldName = _v1.a;
					var fieldType = _v1.b;
					return A3(
						$elm$core$Dict$update,
						fieldName,
						function (maybeFieldTypes) {
							if (maybeFieldTypes.$ === 1) {
								return $elm$core$Maybe$Just(
									$elm$core$Set$singleton(fieldType));
							} else {
								var fieldTypes_ = maybeFieldTypes.a;
								return $elm$core$Maybe$Just(
									A2($elm$core$Set$insert, fieldType, fieldTypes_));
							}
						},
						acc);
				}),
			$elm$core$Dict$empty,
			A2(
				$elm$core$List$filterMap,
				function (field) {
					if (field.$ === 1) {
						var typeString = field.a.lZ;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								$dillonkearns$elm_graphql$Graphql$RawField$name(field),
								typeString));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				levelBelowNodes));
		return $elm$core$Set$fromList(
			$elm$core$Dict$keys(
				A2(
					$elm$core$Dict$filter,
					F2(
						function (fieldType, fields) {
							return function (size) {
								return size > 1;
							}(
								$elm$core$Set$size(fields));
						}),
					fieldTypes)));
	}
};
var $j_maas$elm_ordered_containers$OrderedDict$get = F2(
	function (key, _v0) {
		var orderedDict = _v0;
		return A2($elm$core$Dict$get, key, orderedDict.o);
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $j_maas$elm_ordered_containers$OrderedDict$insert = F3(
	function (key, value, _v0) {
		var orderedDict = _v0;
		var filteredOrder = A2($elm$core$Dict$member, key, orderedDict.o) ? A2(
			$elm$core$List$filter,
			function (k) {
				return !_Utils_eq(k, key);
			},
			orderedDict.oM) : orderedDict.oM;
		var newOrder = _Utils_ap(
			filteredOrder,
			_List_fromArray(
				[key]));
		return {
			o: A3($elm$core$Dict$insert, key, value, orderedDict.o),
			oM: newOrder
		};
	});
var $j_maas$elm_ordered_containers$OrderedDict$remove = F2(
	function (key, _v0) {
		var orderedDict = _v0;
		return {
			o: A2($elm$core$Dict$remove, key, orderedDict.o),
			oM: A2($elm$core$Dict$member, key, orderedDict.o) ? A2(
				$elm$core$List$filter,
				function (k) {
					return !_Utils_eq(k, key);
				},
				orderedDict.oM) : orderedDict.oM
		};
	});
var $j_maas$elm_ordered_containers$OrderedDict$update = F3(
	function (key, alter, original) {
		var orderedDict = original;
		var _v0 = A2($elm$core$Dict$get, key, orderedDict.o);
		if (!_v0.$) {
			var oldItem = _v0.a;
			var _v1 = alter(
				$elm$core$Maybe$Just(oldItem));
			if (!_v1.$) {
				var newItem = _v1.a;
				return {
					o: A3(
						$elm$core$Dict$update,
						key,
						$elm$core$Basics$always(
							$elm$core$Maybe$Just(newItem)),
						orderedDict.o),
					oM: orderedDict.oM
				};
			} else {
				return A2($j_maas$elm_ordered_containers$OrderedDict$remove, key, original);
			}
		} else {
			var _v2 = alter($elm$core$Maybe$Nothing);
			if (!_v2.$) {
				var newItem = _v2.a;
				return A3($j_maas$elm_ordered_containers$OrderedDict$insert, key, newItem, original);
			} else {
				return original;
			}
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$canAllowHashing = F2(
	function (forceHashing, rawFields) {
		var fieldCounts = A3(
			$elm$core$List$foldl,
			F2(
				function (fld, acc) {
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						fld,
						function (val) {
							return $elm$core$Maybe$Just(
								function () {
									if (val.$ === 1) {
										return 0;
									} else {
										var count = val.a;
										return count + 1;
									}
								}());
						},
						acc);
				}),
			$j_maas$elm_ordered_containers$OrderedDict$empty,
			A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$RawField$name, rawFields));
		var conflictingTypeFields = $dillonkearns$elm_graphql$Graphql$Document$Field$findConflictingTypeFields(rawFields);
		return A2(
			$elm$core$List$map,
			function (field) {
				return _Utils_Tuple3(
					field,
					A2(
						$elm$core$Set$member,
						$dillonkearns$elm_graphql$Graphql$RawField$name(field),
						forceHashing) ? $dillonkearns$elm_graphql$Graphql$Document$Field$alias(field) : ((!A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$j_maas$elm_ordered_containers$OrderedDict$get,
							$dillonkearns$elm_graphql$Graphql$RawField$name(field),
							fieldCounts))) ? $elm$core$Maybe$Nothing : $dillonkearns$elm_graphql$Graphql$Document$Field$alias(field)),
					conflictingTypeFields);
			},
			rawFields);
	});
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $dillonkearns$elm_graphql$Graphql$Document$Indent$generate = function (indentationLevel) {
	return A2($elm$core$String$repeat, indentationLevel, '  ');
};
var $dillonkearns$elm_graphql$Graphql$RawField$Composite = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName = function (field) {
	return A2(
		$elm$core$Maybe$withDefault,
		$dillonkearns$elm_graphql$Graphql$RawField$name(field),
		$dillonkearns$elm_graphql$Graphql$Document$Field$alias(field));
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$mergeFields = function (rawFields) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (field, mergedSoFar) {
				if (!field.$) {
					var newChildren = field.c;
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(field),
						function (maybeChildrenSoFar) {
							if (maybeChildrenSoFar.$ === 1) {
								return $elm$core$Maybe$Just(field);
							} else {
								if (!maybeChildrenSoFar.a.$) {
									var _v2 = maybeChildrenSoFar.a;
									var existingFieldName = _v2.a;
									var existingArgs = _v2.b;
									var existingChildren = _v2.c;
									return $elm$core$Maybe$Just(
										A3(
											$dillonkearns$elm_graphql$Graphql$RawField$Composite,
											existingFieldName,
											existingArgs,
											_Utils_ap(existingChildren, newChildren)));
								} else {
									return $elm$core$Maybe$Just(field);
								}
							}
						},
						mergedSoFar);
				} else {
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(field),
						function (maybeChildrenSoFar) {
							return $elm$core$Maybe$Just(
								A2($elm$core$Maybe$withDefault, field, maybeChildrenSoFar));
						},
						mergedSoFar);
				}
			}),
		$j_maas$elm_ordered_containers$OrderedDict$empty,
		rawFields);
};
var $j_maas$elm_ordered_containers$OrderedDict$values = function (_v0) {
	var orderedDict = _v0;
	return A2(
		$elm$core$List$filterMap,
		function (key) {
			return A2($elm$core$Dict$get, key, orderedDict.o);
		},
		orderedDict.oM);
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$mergedFields = function (children) {
	return $j_maas$elm_ordered_containers$OrderedDict$values(
		$dillonkearns$elm_graphql$Graphql$Document$Field$mergeFields(children));
};
var $dillonkearns$elm_graphql$Graphql$RawField$Leaf = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$RawField$typename = A2(
	$dillonkearns$elm_graphql$Graphql$RawField$Leaf,
	{jY: '__typename', lZ: ''},
	_List_Nil);
var $dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren = function (children) {
	return $elm$core$List$isEmpty(children) ? A2($elm$core$List$cons, $dillonkearns$elm_graphql$Graphql$RawField$typename, children) : children;
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$serialize = F4(
	function (forceHashing, aliasName, mIndentationLevel, field) {
		var prefix = function () {
			if (!aliasName.$) {
				var aliasName_ = aliasName.a;
				return _Utils_ap(
					aliasName_,
					function () {
						if (!mIndentationLevel.$) {
							return ': ';
						} else {
							return ':';
						}
					}());
			} else {
				return '';
			}
		}();
		return A2(
			$elm$core$Maybe$map,
			function (string) {
				return _Utils_ap(
					$dillonkearns$elm_graphql$Graphql$Document$Indent$generate(
						A2($elm$core$Maybe$withDefault, 0, mIndentationLevel)),
					_Utils_ap(prefix, string));
			},
			function () {
				if (!field.$) {
					var fieldName = field.a;
					var args = field.b;
					var children = field.c;
					if (mIndentationLevel.$ === 1) {
						return $elm$core$Maybe$Just(
							(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + ('{' + A3($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildrenHelp, forceHashing, $elm$core$Maybe$Nothing, children)))) + '}');
					} else {
						var indentationLevel = mIndentationLevel.a;
						return $elm$core$Maybe$Just(
							(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + (' {\n' + A3(
								$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildrenHelp,
								forceHashing,
								$elm$core$Maybe$Just(indentationLevel),
								children)))) + ('\n' + ($dillonkearns$elm_graphql$Graphql$Document$Indent$generate(indentationLevel) + '}')));
					}
				} else {
					var fieldName = field.a.jY;
					var args = field.b;
					return $elm$core$Maybe$Just(
						_Utils_ap(
							fieldName,
							$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args)));
				}
			}());
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildrenHelp = F3(
	function (forceHashing, indentationLevel, children) {
		return A2(
			$elm$core$String$join,
			function () {
				if (!indentationLevel.$) {
					return '\n';
				} else {
					return ' ';
				}
			}(),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$map,
					function (_v0) {
						var field = _v0.a;
						var maybeAlias = _v0.b;
						var conflictingTypeFields = _v0.c;
						return A4(
							$dillonkearns$elm_graphql$Graphql$Document$Field$serialize,
							conflictingTypeFields,
							maybeAlias,
							A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$add(1),
								indentationLevel),
							field);
					},
					A2(
						$dillonkearns$elm_graphql$Graphql$Document$Field$canAllowHashing,
						forceHashing,
						$dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren(
							$dillonkearns$elm_graphql$Graphql$Document$Field$mergedFields(children))))));
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren = F2(
	function (indentationLevel, children) {
		return A3($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildrenHelp, $elm$core$Set$empty, indentationLevel, children);
	});
var $dillonkearns$elm_graphql$Graphql$Document$serialize = F2(
	function (operationType, queries) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} {\n{1}\n}',
			_List_fromArray(
				[
					operationType,
					A2(
					$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren,
					$elm$core$Maybe$Just(0),
					queries)
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeQuery = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'query', fields);
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return '{' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}');
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return 'query ' + (operationName + (' {' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}')));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName = F3(
	function (operationType, operationName, queries) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} {1} {\n{2}\n}',
			_List_fromArray(
				[
					operationType,
					operationName,
					A2(
					$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren,
					$elm$core$Maybe$Just(0),
					queries)
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'query', operationName, fields);
	});
var $elm$json$Json$Encode$string = _Json_wrap;
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace = F2(
	function (old, _new) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$String$split(old),
			$elm$core$String$join(_new));
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace, '%20', '+'));
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(key) + ('=' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(value));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded = function (args) {
	return A2(
		$elm$core$String$join,
		'&',
		A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair, args));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams = F2(
	function (queryParams, url) {
		return $elm$core$List$isEmpty(queryParams) ? url : (url + ('?' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded(queryParams)));
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build = F5(
	function (forceMethod, url, queryParams, maybeOperationName, queryDocument) {
		var _v0 = function () {
			if (!maybeOperationName.$) {
				var operationName = maybeOperationName.a;
				return _Utils_Tuple2(
					A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName, operationName, queryDocument),
					_List_fromArray(
						[
							_Utils_Tuple2('operationName', operationName)
						]));
			} else {
				return _Utils_Tuple2(
					$dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl(queryDocument),
					_List_Nil);
			}
		}();
		var serializedQueryForGetRequest = _v0.a;
		var operationNameParamForGetRequest = _v0.b;
		var urlForGetRequest = A2(
			$dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams,
			_Utils_ap(
				queryParams,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2('query', serializedQueryForGetRequest),
					operationNameParamForGetRequest)),
			url);
		if (_Utils_eq(
			forceMethod,
			$elm$core$Maybe$Just(1)) || ((_Utils_cmp(
			$elm$core$String$length(urlForGetRequest),
			$dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength) > -1) && (!_Utils_eq(
			forceMethod,
			$elm$core$Maybe$Just(0))))) {
			var _v2 = function () {
				if (!maybeOperationName.$) {
					var operationName = maybeOperationName.a;
					return _Utils_Tuple2(
						A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName, operationName, queryDocument),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'operationName',
								$elm$json$Json$Encode$string(operationName))
							]));
				} else {
					return _Utils_Tuple2(
						$dillonkearns$elm_graphql$Graphql$Document$serializeQuery(queryDocument),
						_List_Nil);
				}
			}();
			var serializedQuery = _v2.a;
			var operationNameParamForPostRequest = _v2.b;
			return {
				f$: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'query',
								$elm$json$Json$Encode$string(serializedQuery)),
							operationNameParamForPostRequest))),
				eX: 1,
				iV: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, queryParams, url)
			};
		} else {
			return {f$: $elm$http$Http$emptyBody, eX: 0, iV: urlForGetRequest};
		}
	});
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError = F3(
	function (message, locations, details) {
		return {mP: details, nz: locations, nH: message};
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location = F2(
	function (line, column) {
		return {jx: column, kA: line};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder = A3(
	$elm$json$Json$Decode$map2,
	$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location,
	A2($elm$json$Json$Decode$field, 'line', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'column', $elm$json$Json$Decode$int));
var $elm$json$Json$Decode$map3 = _Json_map3;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm$json$Json$Decode$string = _Json_decodeString;
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder = A2(
	$elm$json$Json$Decode$field,
	'errors',
	$elm$json$Json$Decode$list(
		A4(
			$elm$json$Json$Decode$map3,
			$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError,
			A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$field,
					'locations',
					$elm$json$Json$Decode$list($dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder))),
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Dict$remove('locations'),
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Dict$remove('message'),
					$elm$json$Json$Decode$dict($elm$json$Json$Decode$value))))));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData = function (data) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Result$Err,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Tuple$pair(data),
			$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder));
};
var $dillonkearns$elm_graphql$Graphql$Http$nullJsonValue = function (a) {
	nullJsonValue:
	while (true) {
		var _v0 = A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, 'null');
		if (!_v0.$) {
			var value = _v0.a;
			return value;
		} else {
			var $temp$a = 0;
			a = $temp$a;
			continue nullJsonValue;
		}
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$errorDecoder = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				A2($elm$json$Json$Decode$map, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData, decoder)),
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				A2(
					$elm$json$Json$Decode$map,
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData,
					A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value))),
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				$elm$json$Json$Decode$succeed(
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData(
						$dillonkearns$elm_graphql$Graphql$Http$nullJsonValue(0))))
			]));
};
var $dillonkearns$elm_graphql$Graphql$Http$decoderOrError = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_graphql$Graphql$Http$errorDecoder(decoder),
				A2($elm$json$Json$Decode$map, $elm$core$Result$Ok, decoder)
			]));
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeMutation = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'mutation', fields);
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'mutation', operationName, fields);
	});
var $dillonkearns$elm_graphql$Graphql$Http$toReadyRequest = function (_v0) {
	var request = _v0;
	var _v1 = request.mP;
	if (!_v1.$) {
		var forcedRequestMethod = _v1.a;
		var querySelectionSet = _v1.b;
		var queryRequestDetails = A5(
			$dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build,
			function () {
				if (!forcedRequestMethod.$) {
					if (!forcedRequestMethod.a) {
						var _v4 = forcedRequestMethod.a;
						return $elm$core$Maybe$Just(0);
					} else {
						var _v5 = forcedRequestMethod.a;
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Just(1);
				}
			}(),
			request.cA,
			request.bf,
			request.bb,
			querySelectionSet);
		return {
			f$: queryRequestDetails.f$,
			A: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.mW),
			nc: request.nc,
			eX: function () {
				var _v2 = queryRequestDetails.eX;
				if (!_v2) {
					return 'GET';
				} else {
					return 'Post';
				}
			}(),
			pv: request.pv,
			iV: queryRequestDetails.iV
		};
	} else {
		var mutationSelectionSet = _v1.a;
		var serializedMutation = function () {
			var _v7 = request.bb;
			if (!_v7.$) {
				var operationName = _v7.a;
				return A2($dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName, operationName, mutationSelectionSet);
			} else {
				return $dillonkearns$elm_graphql$Graphql$Document$serializeMutation(mutationSelectionSet);
			}
		}();
		return {
			f$: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'query',
								$elm$json$Json$Encode$string(serializedMutation))
							]),
						function () {
							var _v6 = request.bb;
							if (!_v6.$) {
								var operationName = _v6.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'operationName',
										$elm$json$Json$Encode$string(operationName))
									]);
							} else {
								return _List_Nil;
							}
						}()))),
			A: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.mW),
			nc: request.nc,
			eX: 'POST',
			pv: request.pv,
			iV: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, request.bf, request.cA)
		};
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$resolver = function (request) {
	return $dillonkearns$elm_graphql$Graphql$Http$jsonResolver(
		$dillonkearns$elm_graphql$Graphql$Http$toReadyRequest(request).A);
};
var $elm$http$Http$resultToTask = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$riskyTask = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{mg: true, f$: r.f$, mW: r.o9, nc: r.nc, eX: r.eX, pv: r.pv, pz: $elm$core$Maybe$Nothing, iV: r.iV});
};
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{mg: false, f$: r.f$, mW: r.o9, nc: r.nc, eX: r.eX, pv: r.pv, pz: $elm$core$Maybe$Nothing, iV: r.iV});
};
var $dillonkearns$elm_graphql$Graphql$Http$toTask = function (fullRequest) {
	var request = fullRequest;
	return A2(
		$elm$core$Task$andThen,
		$dillonkearns$elm_graphql$Graphql$Http$failTaskOnHttpSuccessWithErrors,
		A2(
			$elm$core$Task$mapError,
			$dillonkearns$elm_graphql$Graphql$Http$HttpError,
			function (readyRequest) {
				return (request.bo ? $elm$http$Http$riskyTask : $elm$http$Http$task)(
					{
						f$: readyRequest.f$,
						nc: readyRequest.nc,
						eX: readyRequest.eX,
						o9: $dillonkearns$elm_graphql$Graphql$Http$resolver(fullRequest),
						pv: readyRequest.pv,
						iV: readyRequest.iV
					});
			}(
				$dillonkearns$elm_graphql$Graphql$Http$toReadyRequest(fullRequest))));
};
var $dillonkearns$elm_graphql$Graphql$Http$Request = $elm$core$Basics$identity;
var $dillonkearns$elm_graphql$Graphql$Http$withCredentials = function (_v0) {
	var request = _v0;
	return _Utils_update(
		request,
		{bo: true});
};
var $dillonkearns$elm_graphql$Graphql$Http$withOperationName = F2(
	function (operationName, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				bb: $elm$core$Maybe$Just(operationName)
			});
	});
var $author$project$Api$executeNewGraphqlOperation = F5(
	function (env, operationName, operation, selectionSet, tagger) {
		return A2(
			$elm$core$Task$attempt,
			tagger,
			$dillonkearns$elm_graphql$Graphql$Http$toTask(
				A2(
					$dillonkearns$elm_graphql$Graphql$Http$withOperationName,
					operationName,
					$dillonkearns$elm_graphql$Graphql$Http$withCredentials(
						A2(
							operation,
							$author$project$Env$newApiUrl(env) + '/graphql',
							selectionSet)))));
	});
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite = F3(
	function (fieldName, args, fields) {
		return A3($dillonkearns$elm_graphql$Graphql$RawField$Composite, fieldName, args, fields);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField = F4(
	function (fieldName, args, _v0, decoderTransform) {
		var fields = _v0.a;
		var decoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)
				]),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$field,
						fieldName,
						decoderTransform(decoder)),
						A2(
						$elm$json$Json$Decode$field,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(
							A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)),
						decoderTransform(decoder))
					])));
	});
var $author$project$New$Gql$Platform$Query$permissions = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'permissions', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$User$BackofficeUserData = function (permissions) {
	return {de: permissions};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf = F2(
	function (details, args) {
		return A2($dillonkearns$elm_graphql$Graphql$RawField$Leaf, details, args);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField = F4(
	function (typeString, fieldName, args, decoder) {
		var newLeaf = A2(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf,
			{jY: fieldName, lZ: typeString},
			args);
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_List_fromArray(
				[newLeaf]),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, fieldName, decoder),
						A2(
						$elm$json$Json$Decode$field,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(newLeaf),
						decoder)
					])));
	});
var $author$project$New$Gql$Platform$Object$PermissionsOutput$permissions = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List String)',
	'permissions',
	_List_Nil,
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed = function (constructor) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
		_List_Nil,
		$elm$json$Json$Decode$succeed(constructor));
};
var $dillonkearns$elm_graphql$Graphql$SelectionSet$with = F2(
	function (_v0, _v1) {
		var selectionFields1 = _v0.a;
		var selectionDecoder1 = _v0.b;
		var selectionFields2 = _v1.a;
		var selectionDecoder2 = _v1.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_Utils_ap(selectionFields1, selectionFields2),
			A3($elm$json$Json$Decode$map2, $elm$core$Basics$apR, selectionDecoder1, selectionDecoder2));
	});
var $author$project$Page$Login$Gql$permissionsSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PermissionsOutput$permissions,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$User$BackofficeUserData));
var $dillonkearns$elm_graphql$Graphql$Http$Query = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Document$decoder = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($elm$json$Json$Decode$field, 'data', decoder_);
};
var $dillonkearns$elm_graphql$Graphql$Http$queryRequest = F2(
	function (baseUrl, query) {
		return {
			cA: baseUrl,
			mP: A2($dillonkearns$elm_graphql$Graphql$Http$Query, $elm$core$Maybe$Nothing, query),
			mW: $dillonkearns$elm_graphql$Graphql$Document$decoder(query),
			nc: _List_Nil,
			bb: $elm$core$Maybe$Nothing,
			bf: _List_Nil,
			pv: $elm$core$Maybe$Nothing,
			bo: false
		};
	});
var $author$project$Page$Login$Effect$runEffect = F3(
	function (env, _v0, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'permissions',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$New$Gql$Platform$Query$permissions($author$project$Page$Login$Gql$permissionsSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$Login$Msg$GotAuthCheckResult));
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Page$NotAuthorized$Effect$runEffect = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Page$NotFound$Effect$runEffect = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Page$OfferDetails$Msg$EmailSent = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$OfferDetails$Msg$FetchedClaimHistory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$OfferDetails$Msg$FetchedClaimHistoryPricingAction = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$OfferDetails$Msg$FetchedCoverSelection = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$OfferDetails$Msg$FetchedCustomerId = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$OfferDetails$Msg$FetchedOffer = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$OfferDetails$Msg$FetchedPaymentMethod = function (a) {
	return {$: 19, a: a};
};
var $author$project$Page$OfferDetails$Msg$GotCurrentDate = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$OfferDetails$Msg$OfferCoverageEffectiveDateAmended = function (a) {
	return {$: 8, a: a};
};
var $author$project$Common$Gql$CoverSelection$OfferId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$Gql$CustomerId$OfferId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$Gql$PaymentMethod$OfferId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$OfferDetails$Msg$SaveGreatLakesOptInConsentResponse = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {jw: col, mC: contextStack, oX: problem, pf: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.pf, s.jw, x, s.mB));
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.e, s.iB);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{jw: 1, mB: s.mB, j: s.j, e: s.e + 1, pf: s.pf + 1, iB: s.iB}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{jw: s.jw + 1, mB: s.mB, j: s.j, e: newOffset, pf: s.pf, iB: s.iB}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.oX;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.iB),
			s.e) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.e, s1.e, s0.iB),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.e, s.pf, s.jw, s.iB);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{jw: newCol, mB: s.mB, j: s.j, e: newOffset, pf: newRow, iB: s.iB});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$modBy = _Basics_modBy;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('month ' + ($elm$core$String$fromInt(mn) + ' is out of range')) + (' (1 to 12)' + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))) : ((!A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('day ' + ($elm$core$String$fromInt(d) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(
				A2(
					$justinmimbs$date$Date$daysInMonth,
					y,
					$justinmimbs$date$Date$numberToMonth(mn))) + ')')) + ((' for ' + $justinmimbs$date$Date$monthToName(
				$justinmimbs$date$Date$numberToMonth(mn))) + ((((mn === 2) && (d === 29)) ? (' (' + ($elm$core$String$fromInt(y) + ' is not a leap year)')) : '') + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))))) : $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		var daysInYear = $justinmimbs$date$Date$isLeapYear(y) ? 366 : 365;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, daysInYear, od)) ? $elm$core$Result$Err(
			'Invalid ordinal date: ' + (('ordinal-day ' + ($elm$core$String$fromInt(od) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(daysInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(y)) + ('; received (year ' + ($elm$core$String$fromInt(y) + (', ordinal-day ' + ($elm$core$String$fromInt(od) + ')')))))))) : $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		var weeksInYear = $justinmimbs$date$Date$is53WeekYear(wy) ? 53 : 52;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, weeksInYear, wn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('week ' + ($elm$core$String$fromInt(wn) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(weeksInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(wy)) + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')')))))))))) : ((!A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('weekday ' + ($elm$core$String$fromInt(wdn) + ' is out of range')) + (' (1 to 7)' + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')'))))))))) : $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {jw: col, oX: problem, pf: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.pf, p.jw, p.oX);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{jw: 1, mB: _List_Nil, j: 1, e: 0, pf: 1, iB: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {mJ: d, nM: m, pG: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		h2: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		pG: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.pG, 0, date.h2);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.mJ;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.nM;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.h2;
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		l1: 1 + (((rd - week1Day1) / 7) | 0),
		l2: wy,
		pD: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.l1;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.l2;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.eZ(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.ho(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.eZ(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.gk(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.bn(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.bn(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.bn(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.i5(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.bn(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.bn(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.iB);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.e, offset) < 0,
					0,
					{jw: col, mB: s0.mB, j: s0.j, e: offset, pf: row, iB: s0.iB});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.e, s.pf, s.jw, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.e, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	gk: $justinmimbs$date$Date$withOrdinalSuffix,
	ho: $justinmimbs$date$Date$monthToName,
	eZ: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	i5: $justinmimbs$date$Date$weekdayToName,
	bn: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$NewScalarCodecs$codecDate = function () {
	var resultDecoder = function (res) {
		if (!res.$) {
			var date = res.a;
			return $elm$json$Json$Decode$succeed(date);
		} else {
			var err = res.a;
			return $elm$json$Json$Decode$fail(
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'wrong format from server: {}',
					_List_fromArray(
						[err])));
		}
	};
	return {
		A: A2(
			$elm$json$Json$Decode$andThen,
			resultDecoder,
			A2($elm$json$Json$Decode$map, $justinmimbs$date$Date$fromIsoString, $elm$json$Json$Decode$string)),
		as: A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toIsoString, $elm$json$Json$Encode$string)
	};
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.l, posixMinutes) < 0) {
					return posixMinutes + era.e;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		mJ: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		nM: month,
		pG: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).mJ;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).nM;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			'0',
			$elm$core$String$fromInt(time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).pG;
	});
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Basics$round = _Basics_round;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $author$project$NewScalarCodecs$codecDateTime = {
	A: A2(
		$elm$json$Json$Decode$andThen,
		function (maybeTime) {
			if (!maybeTime.$) {
				var time = maybeTime.a;
				return $elm$json$Json$Decode$succeed(time);
			} else {
				return $elm$json$Json$Decode$fail('Cannot be converted to POSIX time.');
			}
		},
		A2(
			$elm$json$Json$Decode$map,
			A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime, $elm$core$Result$toMaybe),
			$elm$json$Json$Decode$string)),
	as: A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, $elm$json$Json$Encode$string)
};
var $prikhi$decimal$Decimal$Decimal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $cmditch$elm_bigint$BigInt$Negative = 1;
var $cmditch$elm_bigint$BigInt$Positive = 0;
var $cmditch$elm_bigint$BigInt$Magnitude = $elm$core$Basics$identity;
var $elm_community$maybe_extra$Maybe$Extra$combineHelp = F2(
	function (list, acc) {
		combineHelp:
		while (true) {
			if (list.b) {
				var head = list.a;
				var tail = list.b;
				if (!head.$) {
					var a = head.a;
					var $temp$list = tail,
						$temp$acc = A2($elm$core$List$cons, a, acc);
					list = $temp$list;
					acc = $temp$acc;
					continue combineHelp;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Just(
					$elm$core$List$reverse(acc));
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$combine = function (list) {
	return A2($elm_community$maybe_extra$Maybe$Extra$combineHelp, list, _List_Nil);
};
var $elm_community$list_extra$List$Extra$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			if (!list.b) {
				return _List_Nil;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					var $temp$predicate = predicate,
						$temp$list = xs;
					predicate = $temp$predicate;
					list = $temp$list;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var $cmditch$elm_bigint$BigInt$emptyZero = function (_v0) {
	var xs = _v0;
	var _v1 = A2(
		$elm_community$list_extra$List$Extra$dropWhile,
		$elm$core$Basics$eq(0),
		xs);
	if (!_v1.b) {
		return _List_Nil;
	} else {
		return xs;
	}
};
var $elm$core$String$fromList = _String_fromList;
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, list) {
		if ((size <= 0) || (step <= 0)) {
			return _List_Nil;
		} else {
			var go = F2(
				function (xs, acc) {
					go:
					while (true) {
						if ($elm$core$List$isEmpty(xs)) {
							return $elm$core$List$reverse(acc);
						} else {
							var $temp$xs = A2($elm$core$List$drop, step, xs),
								$temp$acc = A2(
								$elm$core$List$cons,
								A2($elm$core$List$take, size, xs),
								acc);
							xs = $temp$xs;
							acc = $temp$acc;
							continue go;
						}
					}
				});
			return A2(go, list, _List_Nil);
		}
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $cmditch$elm_bigint$Constants$maxDigitMagnitude = 7;
var $cmditch$elm_bigint$BigInt$fromString_ = function (x) {
	return A2(
		$elm$core$Maybe$map,
		A2($elm$core$Basics$composeL, $cmditch$elm_bigint$BigInt$emptyZero, $elm$core$Basics$identity),
		$elm_community$maybe_extra$Maybe$Extra$combine(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$reverse,
					A2($elm$core$Basics$composeR, $elm$core$String$fromList, $elm$core$String$toInt)),
				A2(
					$elm_community$list_extra$List$Extra$greedyGroupsOf,
					$cmditch$elm_bigint$Constants$maxDigitMagnitude,
					$elm$core$List$reverse(x)))));
};
var $cmditch$elm_bigint$BigInt$Neg = function (a) {
	return {$: 1, a: a};
};
var $cmditch$elm_bigint$BigInt$Pos = function (a) {
	return {$: 0, a: a};
};
var $cmditch$elm_bigint$BigInt$Zer = {$: 2};
var $cmditch$elm_bigint$BigInt$mkBigInt = F2(
	function (s, mag) {
		var digits = mag;
		if ($elm$core$List$isEmpty(digits)) {
			return $cmditch$elm_bigint$BigInt$Zer;
		} else {
			switch (s) {
				case 2:
					return $cmditch$elm_bigint$BigInt$Zer;
				case 0:
					return $cmditch$elm_bigint$BigInt$Pos(mag);
				default:
					return $cmditch$elm_bigint$BigInt$Neg(mag);
			}
		}
	});
var $elm$core$String$toLower = _String_toLower;
var $cmditch$elm_bigint$BigInt$fromString = function (x) {
	var _v0 = $elm$core$String$toList(
		$elm$core$String$toLower(x));
	if (!_v0.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		switch (_v0.a) {
			case '-':
				if (!_v0.b.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var xs = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						$cmditch$elm_bigint$BigInt$mkBigInt(1),
						$cmditch$elm_bigint$BigInt$fromString_(xs));
				}
			case '+':
				if (!_v0.b.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var xs = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						$cmditch$elm_bigint$BigInt$mkBigInt(0),
						$cmditch$elm_bigint$BigInt$fromString_(xs));
				}
			default:
				var xs = _v0;
				return A2(
					$elm$core$Maybe$map,
					$cmditch$elm_bigint$BigInt$mkBigInt(0),
					$cmditch$elm_bigint$BigInt$fromString_(xs));
		}
	}
};
var $prikhi$decimal$Decimal$fromString = function (str) {
	var stringToDecimal = function (s) {
		var stringIntToDecimal = F2(
			function (s_, e) {
				var _v8 = $cmditch$elm_bigint$BigInt$fromString(s_);
				if (_v8.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var a = _v8.a;
					return $elm$core$Maybe$Just(
						A2($prikhi$decimal$Decimal$Decimal, a, e));
				}
			});
		var _v6 = A2($elm$core$String$split, '.', s);
		_v6$2:
		while (true) {
			if (_v6.b) {
				if (_v6.b.b) {
					if (!_v6.b.b.b) {
						var a = _v6.a;
						var _v7 = _v6.b;
						var b = _v7.a;
						return A2(
							stringIntToDecimal,
							_Utils_ap(a, b),
							-$elm$core$String$length(b));
					} else {
						break _v6$2;
					}
				} else {
					var a = _v6.a;
					return A2(stringIntToDecimal, a, 0);
				}
			} else {
				break _v6$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	};
	var splitMantissaExponent = function (s) {
		var _v4 = A2(
			$elm$core$String$split,
			'e',
			$elm$core$String$toLower(s));
		_v4$2:
		while (true) {
			if (_v4.b) {
				if (!_v4.b.b) {
					var s1 = _v4.a;
					return _Utils_Tuple2(
						stringToDecimal(s1),
						$elm$core$Maybe$Just(0));
				} else {
					if (!_v4.b.b.b) {
						var s1 = _v4.a;
						var _v5 = _v4.b;
						var s2 = _v5.a;
						return _Utils_Tuple2(
							stringToDecimal(s1),
							$elm$core$String$toInt(s2));
					} else {
						break _v4$2;
					}
				}
			} else {
				break _v4$2;
			}
		}
		return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
	};
	var makeMantissa = function (s) {
		var _v2 = A2($elm$core$String$split, '.', s);
		_v2$2:
		while (true) {
			if (_v2.b) {
				if (!_v2.b.b) {
					var s1 = _v2.a;
					return stringToDecimal(s1);
				} else {
					if (!_v2.b.b.b) {
						var s1 = _v2.a;
						var _v3 = _v2.b;
						var s2 = _v3.a;
						return stringToDecimal(
							A2(
								$elm$core$String$join,
								'',
								_List_fromArray(
									[s1, s2])));
					} else {
						break _v2$2;
					}
				}
			} else {
				break _v2$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	};
	var _v0 = splitMantissaExponent(str);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var _v1 = _v0.a.a;
		var m = _v1.a;
		var a = _v1.b;
		var e = _v0.b.a;
		return $elm$core$Maybe$Just(
			A2($prikhi$decimal$Decimal$Decimal, m, e + a));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $cmditch$elm_bigint$BigInt$BigIntNotNormalised = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $cmditch$elm_bigint$BigInt$MagnitudeNotNormalised = $elm$core$Basics$identity;
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $cmditch$elm_bigint$BigInt$isNegativeMagnitude = function (digits) {
	var _v0 = $elm_community$list_extra$List$Extra$last(digits);
	if (_v0.$ === 1) {
		return false;
	} else {
		var x = _v0.a;
		return x < 0;
	}
};
var $cmditch$elm_bigint$BigInt$mkBigIntNotNormalised = F2(
	function (s, digits) {
		return A2($cmditch$elm_bigint$BigInt$BigIntNotNormalised, s, digits);
	});
var $elm_community$list_extra$List$Extra$dropWhileRight = function (p) {
	return A2(
		$elm$core$List$foldr,
		F2(
			function (x, xs) {
				return (p(x) && $elm$core$List$isEmpty(xs)) ? _List_Nil : A2($elm$core$List$cons, x, xs);
			}),
		_List_Nil);
};
var $cmditch$elm_bigint$BigInt$dropZeroes = $elm_community$list_extra$List$Extra$dropWhileRight(
	$elm$core$Basics$eq(0));
var $elm$core$Basics$pow = _Basics_pow;
var $cmditch$elm_bigint$Constants$maxDigitValue = (-1) + A2($elm$core$Basics$pow, 10, $cmditch$elm_bigint$Constants$maxDigitMagnitude);
var $cmditch$elm_bigint$BigInt$baseDigit = $cmditch$elm_bigint$Constants$maxDigitValue + 1;
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $cmditch$elm_bigint$BigInt$normaliseDigit = function (x) {
	return (x < 0) ? A2(
		$elm$core$Tuple$mapFirst,
		$elm$core$Basics$add(-1),
		$cmditch$elm_bigint$BigInt$normaliseDigit(x + $cmditch$elm_bigint$BigInt$baseDigit)) : _Utils_Tuple2((x / $cmditch$elm_bigint$BigInt$baseDigit) | 0, x % $cmditch$elm_bigint$BigInt$baseDigit);
};
var $cmditch$elm_bigint$BigInt$normaliseDigitList = F2(
	function (carry, xs) {
		normaliseDigitList:
		while (true) {
			if (!xs.b) {
				if (_Utils_cmp(carry, $cmditch$elm_bigint$BigInt$baseDigit) > 0) {
					var $temp$carry = 0,
						$temp$xs = _List_fromArray(
						[carry]);
					carry = $temp$carry;
					xs = $temp$xs;
					continue normaliseDigitList;
				} else {
					return _List_fromArray(
						[carry]);
				}
			} else {
				var x = xs.a;
				var xs_ = xs.b;
				var _v1 = $cmditch$elm_bigint$BigInt$normaliseDigit(x + carry);
				var newCarry = _v1.a;
				var x_ = _v1.b;
				return A2(
					$elm$core$List$cons,
					x_,
					A2($cmditch$elm_bigint$BigInt$normaliseDigitList, newCarry, xs_));
			}
		}
	});
var $cmditch$elm_bigint$BigInt$normaliseMagnitude = function (_v0) {
	var xs = _v0;
	return $cmditch$elm_bigint$BigInt$dropZeroes(
		A2($cmditch$elm_bigint$BigInt$normaliseDigitList, 0, xs));
};
var $cmditch$elm_bigint$BigInt$reverseMagnitude = $elm$core$List$map($elm$core$Basics$negate);
var $cmditch$elm_bigint$BigInt$Zero = 2;
var $cmditch$elm_bigint$BigInt$signNegate = function (sign_) {
	switch (sign_) {
		case 0:
			return 1;
		case 1:
			return 0;
		default:
			return 2;
	}
};
var $cmditch$elm_bigint$BigInt$normalise = function (_v0) {
	normalise:
	while (true) {
		var s = _v0.a;
		var digits = _v0.b;
		var _v1 = $cmditch$elm_bigint$BigInt$normaliseMagnitude(digits);
		var normalisedMag = _v1;
		if ($cmditch$elm_bigint$BigInt$isNegativeMagnitude(normalisedMag)) {
			var $temp$_v0 = A2(
				$cmditch$elm_bigint$BigInt$mkBigIntNotNormalised,
				$cmditch$elm_bigint$BigInt$signNegate(s),
				$cmditch$elm_bigint$BigInt$reverseMagnitude(normalisedMag));
			_v0 = $temp$_v0;
			continue normalise;
		} else {
			return A2($cmditch$elm_bigint$BigInt$mkBigInt, s, normalisedMag);
		}
	}
};
var $cmditch$elm_bigint$BigInt$signFromInt = function (x) {
	var _v0 = A2($elm$core$Basics$compare, x, 0);
	switch (_v0) {
		case 0:
			return 1;
		case 2:
			return 0;
		default:
			return 2;
	}
};
var $cmditch$elm_bigint$BigInt$fromInt = function (x) {
	return $cmditch$elm_bigint$BigInt$normalise(
		A2(
			$cmditch$elm_bigint$BigInt$BigIntNotNormalised,
			$cmditch$elm_bigint$BigInt$signFromInt(x),
			_List_fromArray(
				[
					$elm$core$Basics$abs(x)
				])));
};
var $cmditch$elm_bigint$BigInt$compareMagnitude = F4(
	function (x, y, xs, ys) {
		compareMagnitude:
		while (true) {
			var _v0 = _Utils_Tuple2(xs, ys);
			if (!_v0.a.b) {
				if (!_v0.b.b) {
					return A2($elm$core$Basics$compare, x, y);
				} else {
					return 0;
				}
			} else {
				if (!_v0.b.b) {
					return 2;
				} else {
					var _v1 = _v0.a;
					var x_ = _v1.a;
					var xss = _v1.b;
					var _v2 = _v0.b;
					var y_ = _v2.a;
					var yss = _v2.b;
					if (_Utils_eq(x_, y_)) {
						var $temp$x = x,
							$temp$y = y,
							$temp$xs = xss,
							$temp$ys = yss;
						x = $temp$x;
						y = $temp$y;
						xs = $temp$xs;
						ys = $temp$ys;
						continue compareMagnitude;
					} else {
						var $temp$x = x_,
							$temp$y = y_,
							$temp$xs = xss,
							$temp$ys = yss;
						x = $temp$x;
						y = $temp$y;
						xs = $temp$xs;
						ys = $temp$ys;
						continue compareMagnitude;
					}
				}
			}
		}
	});
var $cmditch$elm_bigint$BigInt$orderNegate = function (x) {
	switch (x) {
		case 0:
			return 2;
		case 1:
			return 1;
		default:
			return 0;
	}
};
var $cmditch$elm_bigint$BigInt$compare = F2(
	function (int1, int2) {
		var _v0 = _Utils_Tuple2(int1, int2);
		switch (_v0.a.$) {
			case 0:
				if (!_v0.b.$) {
					var mag1 = _v0.a.a;
					var mag2 = _v0.b.a;
					return A4($cmditch$elm_bigint$BigInt$compareMagnitude, 0, 0, mag1, mag2);
				} else {
					return 2;
				}
			case 1:
				if (_v0.b.$ === 1) {
					var mag1 = _v0.a.a;
					var mag2 = _v0.b.a;
					return $cmditch$elm_bigint$BigInt$orderNegate(
						A4($cmditch$elm_bigint$BigInt$compareMagnitude, 0, 0, mag1, mag2));
				} else {
					return 0;
				}
			default:
				switch (_v0.b.$) {
					case 0:
						var _v1 = _v0.a;
						return 0;
					case 2:
						var _v2 = _v0.a;
						var _v3 = _v0.b;
						return 1;
					default:
						var _v4 = _v0.a;
						return 2;
				}
		}
	});
var $cmditch$elm_bigint$BigInt$lt = F2(
	function (x, y) {
		return !A2($cmditch$elm_bigint$BigInt$compare, x, y);
	});
var $cmditch$elm_bigint$BigInt$gte = F2(
	function (x, y) {
		return !A2($cmditch$elm_bigint$BigInt$lt, x, y);
	});
var $prikhi$decimal$Decimal$insert_decimal_period = F2(
	function (pos, s) {
		var extra_zeros = pos - $elm$core$String$length(s);
		var padded_s = (extra_zeros >= 0) ? _Utils_ap(
			A2($elm$core$String$repeat, extra_zeros + 1, '0'),
			s) : s;
		var before = A2($elm$core$String$dropRight, pos, padded_s);
		var after = A2($elm$core$String$right, pos, padded_s);
		return before + ('.' + after);
	});
var $cmditch$elm_bigint$BigInt$negate = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return $cmditch$elm_bigint$BigInt$Zer;
		case 0:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$Neg(mag);
		default:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$Pos(mag);
	}
};
var $cmditch$elm_bigint$BigInt$fillZeroes = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$String$padLeft, $cmditch$elm_bigint$Constants$maxDigitMagnitude, '0'),
	$elm$core$String$fromInt);
var $cmditch$elm_bigint$BigInt$revMagnitudeToString = function (_v0) {
	var digits = _v0;
	var _v1 = $elm$core$List$reverse(digits);
	if (!_v1.b) {
		return '0';
	} else {
		var x = _v1.a;
		var xs = _v1.b;
		return $elm$core$String$concat(
			A2(
				$elm$core$List$cons,
				$elm$core$String$fromInt(x),
				A2($elm$core$List$map, $cmditch$elm_bigint$BigInt$fillZeroes, xs)));
	}
};
var $cmditch$elm_bigint$BigInt$toString = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return '0';
		case 0:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$revMagnitudeToString(mag);
		default:
			var mag = bigInt.a;
			return '-' + $cmditch$elm_bigint$BigInt$revMagnitudeToString(mag);
	}
};
var $prikhi$decimal$Decimal$toString = function (_v0) {
	var m = _v0.a;
	var e = _v0.b;
	var sign = A2(
		$cmditch$elm_bigint$BigInt$gte,
		m,
		$cmditch$elm_bigint$BigInt$fromInt(0)) ? '' : '-';
	var add_zeros = function (n) {
		return A2($elm$core$String$repeat, n, '0');
	};
	var abs_m = A2(
		$cmditch$elm_bigint$BigInt$gte,
		m,
		$cmditch$elm_bigint$BigInt$fromInt(0)) ? m : $cmditch$elm_bigint$BigInt$negate(m);
	var s = $cmditch$elm_bigint$BigInt$toString(abs_m);
	var _v1 = A2($elm$core$Basics$compare, e, 0);
	switch (_v1) {
		case 1:
			return _Utils_ap(sign, s);
		case 2:
			return _Utils_ap(
				sign,
				_Utils_ap(
					s,
					add_zeros(e)));
		default:
			return _Utils_ap(
				sign,
				A2($prikhi$decimal$Decimal$insert_decimal_period, 0 - e, s));
	}
};
var $author$project$NewScalarCodecs$codecDecimal = {
	A: A2(
		$elm$json$Json$Decode$andThen,
		function (maybeDecimal) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Decode$fail('Cannot be converted to Decimal'),
				A2($elm$core$Maybe$map, $elm$json$Json$Decode$succeed, maybeDecimal));
		},
		A2($elm$json$Json$Decode$map, $prikhi$decimal$Decimal$fromString, $elm$json$Json$Decode$string)),
	as: A2($elm$core$Basics$composeR, $prikhi$decimal$Decimal$toString, $elm$json$Json$Encode$string)
};
var $author$project$NewScalarCodecs$codecGqlDecimal = {
	A: A2(
		$elm$json$Json$Decode$andThen,
		function (maybeDecimal) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Decode$fail('Cannot be converted to Decimal'),
				A2($elm$core$Maybe$map, $elm$json$Json$Decode$succeed, maybeDecimal));
		},
		A2($elm$json$Json$Decode$map, $prikhi$decimal$Decimal$fromString, $elm$json$Json$Decode$string)),
	as: A2($elm$core$Basics$composeR, $prikhi$decimal$Decimal$toString, $elm$json$Json$Encode$string)
};
var $danyx23$elm_uuid$Uuid$Uuid = $elm$core$Basics$identity;
var $elm$regex$Regex$contains = _Regex_contains;
var $danyx23$elm_uuid$Uuid$Barebones$uuidRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[1-5][0-9A-Fa-f]{3,3}-[8-9A-Ba-b][0-9A-Fa-f]{3,3}-[0-9A-Fa-f]{12,12}$'));
var $danyx23$elm_uuid$Uuid$Barebones$isValidUuid = function (uuidAsString) {
	return A2($elm$regex$Regex$contains, $danyx23$elm_uuid$Uuid$Barebones$uuidRegex, uuidAsString);
};
var $danyx23$elm_uuid$Uuid$fromString = function (text) {
	return $danyx23$elm_uuid$Uuid$Barebones$isValidUuid(text) ? $elm$core$Maybe$Just(
		$elm$core$String$toLower(text)) : $elm$core$Maybe$Nothing;
};
var $author$project$NewScalarCodecs$maybeDecoder = function (res) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$json$Json$Decode$fail('wrong uuid format'),
		A2($elm$core$Maybe$map, $elm$json$Json$Decode$succeed, res));
};
var $danyx23$elm_uuid$Uuid$toString = function (_v0) {
	var internalString = _v0;
	return internalString;
};
var $author$project$NewScalarCodecs$codecUuid = {
	A: A2(
		$elm$json$Json$Decode$andThen,
		$author$project$NewScalarCodecs$maybeDecoder,
		A2($elm$json$Json$Decode$map, $danyx23$elm_uuid$Uuid$fromString, $elm$json$Json$Decode$string)),
	as: A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$json$Json$Encode$string)
};
var $author$project$New$Gql$Platform$Scalar$Codecs = $elm$core$Basics$identity;
var $author$project$New$Gql$Platform$Scalar$defineCodecs = function (definitions) {
	return definitions;
};
var $author$project$NewScalarCodecs$codecs = $author$project$New$Gql$Platform$Scalar$defineCodecs(
	{mx: $author$project$NewScalarCodecs$codecDate, N: $author$project$NewScalarCodecs$codecDateTime, my: $author$project$NewScalarCodecs$codecDecimal, mz: $author$project$NewScalarCodecs$codecGqlDecimal, t: $author$project$NewScalarCodecs$codecUuid});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject = function (maybeValues) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object(
		A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var key = _v0.a;
				var value = _v0.b;
				return A2(
					$elm$core$Maybe$andThen,
					function (actualValue) {
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(key, actualValue));
					},
					value);
			},
			maybeValues));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson = function (jsonValue) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(jsonValue);
};
var $author$project$New$Gql$Platform$Scalar$unwrapEncoder = F2(
	function (getter, _v0) {
		var unwrappedCodecs = _v0;
		return A2(
			$elm$core$Basics$composeR,
			getter(unwrappedCodecs).as,
			$dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson);
	});
var $author$project$New$Gql$Platform$InputObject$encodeAmendOfferCoverageEffectiveDateInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'offerId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$NewScalarCodecs$codecs)(input____.n$))),
				_Utils_Tuple2(
				'coverageEffectiveDate',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.mx;
						},
						$author$project$NewScalarCodecs$codecs)(input____.mF)))
			]));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required = F3(
	function (fieldName, raw, encode) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument,
			fieldName,
			encode(raw));
	});
var $author$project$New$Gql$Platform$Mutation$amendOfferCoverageEffectiveDate = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'amendOfferCoverageEffectiveDate',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nm, $author$project$New$Gql$Platform$InputObject$encodeAmendOfferCoverageEffectiveDateInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Common$Gql$Offer$amendOfferCoverageEffectiveDateArguments = F2(
	function (offerId, coverageEffectiveDate) {
		return {
			nm: {mF: coverageEffectiveDate, n$: offerId}
		};
	});
var $author$project$Common$AmendOfferCoverageEffectiveDateResult$CurrentDateStillValid = 2;
var $author$project$Common$AmendOfferCoverageEffectiveDateResult$Failure = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$AmendOfferCoverageEffectiveDateResult$OutOfFutureRange = 1;
var $author$project$Common$AmendOfferCoverageEffectiveDateResult$PastCoverageEffectiveDate = 0;
var $author$project$Common$AmendOfferCoverageEffectiveDateResult$Success = {$: 0};
var $dillonkearns$elm_graphql$Graphql$SelectionSet$FragmentSelectionSet = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment = F2(
	function (fragmentTypeName, _v0) {
		var fields = _v0.a;
		var decoder = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$SelectionSet$FragmentSelectionSet, fragmentTypeName, fields, decoder);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFailureMessage = F2(
	function (typeSpecificSelections, typeName) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'Unhandled type `{0}` in exhaustive fragment handling. The following types had handlers registered to handle them: [{1}]. This happens if you are parsing either a Union or Interface. Do you need to rerun the `@dillonkearns/elm-graphql` command line tool?',
			_List_fromArray(
				[
					typeName,
					A2(
					$elm$core$String$join,
					', ',
					A2(
						$elm$core$List$map,
						function (_v0) {
							var fragmentType = _v0.a;
							var fields = _v0.b;
							var decoder = _v0.c;
							return fragmentType;
						},
						typeSpecificSelections))
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection = function (typeSpecificSelections) {
	var selections = A2(
		$elm$core$List$map,
		function (_v1) {
			var typeName = _v1.a;
			var fields = _v1.b;
			var decoder = _v1.c;
			return A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, '...on ' + typeName, _List_Nil, fields);
		},
		typeSpecificSelections);
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
		A2($elm$core$List$cons, $dillonkearns$elm_graphql$Graphql$RawField$typename, selections),
		A2(
			$elm$json$Json$Decode$andThen,
			function (typeName) {
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Decode$fail(
						A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFailureMessage, typeSpecificSelections, typeName)),
					A2(
						$elm$core$Dict$get,
						typeName,
						$elm$core$Dict$fromList(
							A2(
								$elm$core$List$map,
								function (_v0) {
									var thisTypeName = _v0.a;
									var fields = _v0.b;
									var decoder = _v0.c;
									return _Utils_Tuple2(thisTypeName, decoder);
								},
								typeSpecificSelections))));
			},
			A2(
				$elm$json$Json$Decode$field,
				$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName($dillonkearns$elm_graphql$Graphql$RawField$typename),
				$elm$json$Json$Decode$string)));
};
var $author$project$New$Gql$Platform$Union$AmendOfferCoverageEffectiveDateOutput$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'AmendOfferCoverageEffectiveDateOk', selections____.n1),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PastCoverageEffectiveDateErr', selections____.oA),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'OutOfFutureRangeErr', selections____.oz),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CurrentDateStillValidErr', selections____.oq)
			]));
};
var $author$project$Common$Gql$Offer$amendOfferCoverageEffectiveDateSelectionSet = $author$project$New$Gql$Platform$Union$AmendOfferCoverageEffectiveDateOutput$fragments(
	{
		n1: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$AmendOfferCoverageEffectiveDateResult$Success),
		oq: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
			$author$project$Common$AmendOfferCoverageEffectiveDateResult$Failure(2)),
		oz: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
			$author$project$Common$AmendOfferCoverageEffectiveDateResult$Failure(1)),
		oA: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
			$author$project$Common$AmendOfferCoverageEffectiveDateResult$Failure(0))
	});
var $author$project$Gql$Platform$Query$ClaimsHistoryRequiredArguments = function (quoteId) {
	return {o_: quoteId};
};
var $author$project$Common$Gql$ClaimHistory$claimHistoryByQuoteIdRequiredArguments = function (quoteId) {
	return $author$project$Gql$Platform$Query$ClaimsHistoryRequiredArguments(quoteId);
};
var $author$project$Common$ClaimHistory$ClaimHistory = F6(
	function (id, sincoInfo, sincoNumber, claimDeclaredWithFaultByCustomer, claimDeclaredBySinco, actionNeeded) {
		return {fI: actionNeeded, jq: claimDeclaredBySinco, f4: claimDeclaredWithFaultByCustomer, kg: id, lH: sincoInfo, lI: sincoNumber};
	});
var $author$project$Gql$Platform$Union$SincoReturnCode$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'KnownSincoReturnCode', selections____.ov),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UnknownSincoReturnCode', selections____.oG)
			]));
};
var $author$project$Gql$Platform$Enum$SincoCode$Code00 = 0;
var $author$project$Gql$Platform$Enum$SincoCode$Code01 = 1;
var $author$project$Gql$Platform$Enum$SincoCode$Code05 = 2;
var $author$project$Gql$Platform$Enum$SincoCode$Code08 = 3;
var $author$project$Gql$Platform$Enum$SincoCode$Code11 = 4;
var $author$project$Gql$Platform$Enum$SincoCode$Code12 = 5;
var $author$project$Gql$Platform$Enum$SincoCode$Code21 = 6;
var $author$project$Gql$Platform$Enum$SincoCode$Code31 = 7;
var $author$project$Gql$Platform$Enum$SincoCode$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'CODE_00':
				return $elm$json$Json$Decode$succeed(0);
			case 'CODE_01':
				return $elm$json$Json$Decode$succeed(1);
			case 'CODE_05':
				return $elm$json$Json$Decode$succeed(2);
			case 'CODE_08':
				return $elm$json$Json$Decode$succeed(3);
			case 'CODE_11':
				return $elm$json$Json$Decode$succeed(4);
			case 'CODE_12':
				return $elm$json$Json$Decode$succeed(5);
			case 'CODE_21':
				return $elm$json$Json$Decode$succeed(6);
			case 'CODE_31':
				return $elm$json$Json$Decode$succeed(7);
			default:
				return $elm$json$Json$Decode$fail('Invalid SincoCode type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$KnownSincoReturnCode$code = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.SincoCode.SincoCode', 'code', _List_Nil, $author$project$Gql$Platform$Enum$SincoCode$decoder);
var $dillonkearns$elm_graphql$Graphql$SelectionSet$map = F2(
	function (mapFunction, _v0) {
		var selectionFields = _v0.a;
		var selectionDecoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			selectionFields,
			A2($elm$json$Json$Decode$map, mapFunction, selectionDecoder));
	});
var $author$project$Gql$Platform$Enum$SincoCode$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'CODE_00';
		case 1:
			return 'CODE_01';
		case 2:
			return 'CODE_05';
		case 3:
			return 'CODE_08';
		case 4:
			return 'CODE_11';
		case 5:
			return 'CODE_12';
		case 6:
			return 'CODE_21';
		default:
			return 'CODE_31';
	}
};
var $author$project$Common$Gql$ClaimHistory$knownSincoReturnCodeSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Gql$Platform$Enum$SincoCode$toString, $author$project$Gql$Platform$Object$KnownSincoReturnCode$code);
var $author$project$Gql$Platform$Object$UnknownSincoReturnCode$unknownCode = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'unknownCode', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$ClaimHistory$unknownSincoReturnCodeSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Gql$Platform$Object$UnknownSincoReturnCode$unknownCode);
var $author$project$Common$Gql$ClaimHistory$decodeSincoReturnCode = $author$project$Gql$Platform$Union$SincoReturnCode$fragments(
	{ov: $author$project$Common$Gql$ClaimHistory$knownSincoReturnCodeSelectionSet, oG: $author$project$Common$Gql$ClaimHistory$unknownSincoReturnCodeSelectionSet});
var $author$project$Common$Count$Unknown = {$: 2};
var $author$project$Common$Count$default = $author$project$Common$Count$Unknown;
var $author$project$Common$PricingAction$PricingAction = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$PricingAction$default = $author$project$Common$PricingAction$PricingAction('');
var $author$project$Gql$Platform$Object$BackofficeClaimsHistory$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded = F2(
	function (constant, _v0) {
		var objectFields = _v0.a;
		var objectDecoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			objectFields,
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Basics$apR,
				$elm$json$Json$Decode$succeed(constant),
				objectDecoder));
	});
var $author$project$Gql$Platform$Object$BackofficeClaimsHistory$sincoNumber = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'sincoNumber', _List_Nil, $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Gql$Platform$Object$BackofficeClaimsHistory$sincoReturnCode = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'sincoReturnCode',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Gql$Platform$Object$BackofficeClaimsHistory$totalClaimsFound = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'totalClaimsFound',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Gql$Platform$Object$Count$count = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'count', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Common$Gql$ClaimHistory$totalClaimsFoundSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Gql$Platform$Object$Count$count);
var $dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault = function (_default) {
	return $dillonkearns$elm_graphql$Graphql$SelectionSet$map(
		$elm$core$Maybe$withDefault(_default));
};
var $author$project$Common$Gql$ClaimHistory$claimHistorySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	$author$project$Common$PricingAction$default,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeClaimsHistory$totalClaimsFound($author$project$Common$Gql$ClaimHistory$totalClaimsFoundSelectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
			$author$project$Common$Count$default,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeClaimsHistory$sincoNumber,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
						'',
						$author$project$Gql$Platform$Object$BackofficeClaimsHistory$sincoReturnCode($author$project$Common$Gql$ClaimHistory$decodeSincoReturnCode)),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficeClaimsHistory$documentId,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$ClaimHistory$ClaimHistory)))))));
var $author$project$Gql$Platform$Scalar$CreditCardLastFourDigits = $elm$core$Basics$identity;
var $author$project$Gql$Platform$Scalar$DateTime = $elm$core$Basics$identity;
var $author$project$Gql$Platform$Scalar$GqlDecimal = $elm$core$Basics$identity;
var $author$project$Gql$Platform$Scalar$Id = $elm$core$Basics$identity;
var $author$project$Gql$Platform$Scalar$NaiveDate = $elm$core$Basics$identity;
var $author$project$Gql$Platform$Scalar$NonEmptyString = $elm$core$Basics$identity;
var $author$project$Gql$Platform$Scalar$Uuid = $elm$core$Basics$identity;
var $author$project$Gql$Platform$Scalar$YearMonth = $elm$core$Basics$identity;
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$core$String$fromFloat = _String_fromNumber;
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$string,
			A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int),
			A2(
			$elm$json$Json$Decode$map,
			function (bool) {
				return bool ? 'true' : 'false';
			},
			$elm$json$Json$Decode$bool)
		]));
var $author$project$Gql$Platform$Scalar$defaultCodecs = {
	jt: {
		A: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		as: function (_v0) {
			var raw = _v0;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	N: {
		A: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		as: function (_v1) {
			var raw = _v1;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	mz: {
		A: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		as: function (_v2) {
			var raw = _v2;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	ju: {
		A: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		as: function (_v3) {
			var raw = _v3;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	cG: {
		A: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		as: function (_v4) {
			var raw = _v4;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	bB: {
		A: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		as: function (_v5) {
			var raw = _v5;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	t: {
		A: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		as: function (_v6) {
			var raw = _v6;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	jv: {
		A: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		as: function (_v7) {
			var raw = _v7;
			return $elm$json$Json$Encode$string(raw);
		}
	}
};
var $author$project$Gql$Platform$Scalar$Codecs = $elm$core$Basics$identity;
var $author$project$Gql$Platform$Scalar$defineCodecs = function (definitions) {
	return definitions;
};
var $author$project$ScalarCodecs$codecs = function () {
	var resultDecoder = function (res) {
		if (!res.$) {
			var date = res.a;
			return $elm$json$Json$Decode$succeed(date);
		} else {
			var err = res.a;
			return $elm$json$Json$Decode$fail(
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'wrong format from server: {}',
					_List_fromArray(
						[err])));
		}
	};
	var maybeDecoder = function (res) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('wrong uuid format'),
			A2($elm$core$Maybe$map, $elm$json$Json$Decode$succeed, res));
	};
	return $author$project$Gql$Platform$Scalar$defineCodecs(
		{
			jt: {A: $elm$json$Json$Decode$string, as: $elm$json$Json$Encode$string},
			N: {
				A: A2(
					$elm$json$Json$Decode$andThen,
					function (maybeDateTime) {
						if (!maybeDateTime.$) {
							var dateTime = maybeDateTime.a;
							return $elm$json$Json$Decode$succeed(dateTime);
						} else {
							return $elm$json$Json$Decode$fail('Cannot be converted to POSIX time.');
						}
					},
					A2(
						$elm$json$Json$Decode$map,
						A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime, $elm$core$Result$toMaybe),
						$elm$json$Json$Decode$string)),
				as: A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, $elm$json$Json$Encode$string)
			},
			mz: {
				A: A2(
					$elm$json$Json$Decode$andThen,
					function (maybeDecimal) {
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Cannot be converted to Decimal'),
							A2($elm$core$Maybe$map, $elm$json$Json$Decode$succeed, maybeDecimal));
					},
					A2($elm$json$Json$Decode$map, $prikhi$decimal$Decimal$fromString, $elm$json$Json$Decode$string)),
				as: A2($elm$core$Basics$composeR, $prikhi$decimal$Decimal$toString, $elm$json$Json$Encode$string)
			},
			ju: $author$project$Gql$Platform$Scalar$defaultCodecs.ju,
			cG: {
				A: A2(
					$elm$json$Json$Decode$andThen,
					resultDecoder,
					A2($elm$json$Json$Decode$map, $justinmimbs$date$Date$fromIsoString, $elm$json$Json$Decode$string)),
				as: A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toIsoString, $elm$json$Json$Encode$string)
			},
			bB: $author$project$Gql$Platform$Scalar$defaultCodecs.bB,
			t: {
				A: A2(
					$elm$json$Json$Decode$andThen,
					maybeDecoder,
					A2($elm$json$Json$Decode$map, $danyx23$elm_uuid$Uuid$fromString, $elm$json$Json$Decode$string)),
				as: A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$json$Json$Encode$string)
			},
			jv: $author$project$Gql$Platform$Scalar$defaultCodecs.jv
		});
}();
var $author$project$Gql$Platform$Scalar$unwrapEncoder = F2(
	function (getter, _v0) {
		var unwrappedCodecs = _v0;
		return A2(
			$elm$core$Basics$composeR,
			getter(unwrappedCodecs).as,
			$dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson);
	});
var $author$project$Gql$Platform$Query$claimsHistory = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'claimsHistory',
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
					'quoteId',
					requiredArgs____.o_,
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$ScalarCodecs$codecs))
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Env$apiUrl = function (_v0) {
	var environment = _v0;
	return environment.cy;
};
var $author$project$Api$executeGraphqlOperation = F4(
	function (env, operation, selectionSet, tagger) {
		return A2(
			$elm$core$Task$attempt,
			tagger,
			$dillonkearns$elm_graphql$Graphql$Http$toTask(
				$dillonkearns$elm_graphql$Graphql$Http$withCredentials(
					A2(
						operation,
						$author$project$Env$apiUrl(env),
						selectionSet))));
	});
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent = {$: 1};
var $author$project$New$Gql$Platform$InputObject$CoverSelectionInputRequiredFields = function (offerOrPolicyIdentifier) {
	return {db: offerOrPolicyIdentifier};
};
var $author$project$New$Gql$Platform$Query$CoverSelectionRequiredArguments = function (input) {
	return {nm: input};
};
var $author$project$New$Gql$Platform$InputObject$OfferIdentifier = F2(
	function (offerId, offerCfid) {
		return {bY: offerCfid, n$: offerId};
	});
var $author$project$New$Gql$Platform$InputObject$OfferOrPolicyIdentifier = F2(
	function (offer, policy) {
		return {F: offer, k: policy};
	});
var $author$project$New$Gql$Platform$InputObject$PolicyIdentifier = function (policyId) {
	return {oQ: policyId};
};
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present = function (a) {
	return {$: 0, a: a};
};
var $author$project$New$Gql$Platform$InputObject$buildCoverSelectionInput = function (required____) {
	return {db: required____.db};
};
var $author$project$Common$Gql$CoverSelection$buildCoverContinuityQueryArg = function (args) {
	var buildPolicyInput = function (policyId) {
		return A2(
			$author$project$New$Gql$Platform$InputObject$OfferOrPolicyIdentifier,
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				$author$project$New$Gql$Platform$InputObject$PolicyIdentifier(
					$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(policyId))));
	};
	var buildOfferInput = function (offerId) {
		return function (offerIdentifier) {
			return A2($author$project$New$Gql$Platform$InputObject$OfferOrPolicyIdentifier, offerIdentifier, $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent);
		}(
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				A2(
					$author$project$New$Gql$Platform$InputObject$OfferIdentifier,
					$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(offerId),
					$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent)));
	};
	var input = function () {
		if (!args.$) {
			var policyId = args.a;
			return buildPolicyInput(policyId);
		} else {
			var offerId = args.a;
			return buildOfferInput(offerId);
		}
	}();
	var buildCoverSelectionInput = function (coverContinuityArg) {
		return $author$project$New$Gql$Platform$Query$CoverSelectionRequiredArguments(
			$author$project$New$Gql$Platform$InputObject$buildCoverSelectionInput(
				$author$project$New$Gql$Platform$InputObject$CoverSelectionInputRequiredFields(coverContinuityArg)));
	};
	return buildCoverSelectionInput(input);
};
var $author$project$New$Gql$Platform$Object$CoverSelectionOutput$coverSelection = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'coverSelection', _List_Nil, object____, $elm$core$Basics$identity);
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$null = $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json($elm$json$Json$Encode$null);
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$optional = F2(
	function (optionalValue, toValue) {
		switch (optionalValue.$) {
			case 0:
				var value = optionalValue.a;
				return $elm$core$Maybe$Just(
					toValue(value));
			case 1:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$null);
		}
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$string = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$string(value));
};
var $author$project$New$Gql$Platform$InputObject$encodeOfferIdentifier = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'offerId',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.n$,
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$NewScalarCodecs$codecs))),
				_Utils_Tuple2(
				'offerCfid',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$New$Gql$Platform$InputObject$encodePolicyIdentifier = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyId',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.oQ,
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$NewScalarCodecs$codecs)))
			]));
};
var $author$project$New$Gql$Platform$InputObject$encodeOfferOrPolicyIdentifier = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'offer',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$New$Gql$Platform$InputObject$encodeOfferIdentifier)),
				_Utils_Tuple2(
				'policy',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $author$project$New$Gql$Platform$InputObject$encodePolicyIdentifier))
			]));
};
var $author$project$New$Gql$Platform$InputObject$encodeCoverSelectionInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'offerOrPolicyIdentifier',
				$elm$core$Maybe$Just(
					$author$project$New$Gql$Platform$InputObject$encodeOfferOrPolicyIdentifier(input____.db)))
			]));
};
var $author$project$New$Gql$Platform$Query$coverSelection = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'coverSelection',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nm, $author$project$New$Gql$Platform$InputObject$encodeCoverSelectionInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$New$Gql$Platform$Object$CoverSelection$ancillaries = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'ancillaries', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$CoverSelection$AncillaryProducts = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Common$CoverSelection$ancillaryProducts = $author$project$Common$CoverSelection$AncillaryProducts;
var $author$project$New$Gql$Platform$Enum$AncillaryCoverType$RoadsideAssistancePremium = 0;
var $author$project$New$Gql$Platform$Enum$AncillaryCoverType$SubstitutionVehicle = 1;
var $author$project$New$Gql$Platform$Enum$AncillaryCoverType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'ROADSIDE_ASSISTANCE_PREMIUM':
				return $elm$json$Json$Decode$succeed(0);
			case 'SUBSTITUTION_VEHICLE':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid AncillaryCoverType type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$AncillaryCover$coverName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.AncillaryCoverType.AncillaryCoverType', 'coverName', _List_Nil, $author$project$New$Gql$Platform$Enum$AncillaryCoverType$decoder);
var $author$project$Common$CoverSelection$RoadsideAssistance = 0;
var $author$project$Common$CoverSelection$SubstitutionVehicle = 1;
var $author$project$Common$Gql$CoverSelection$decodeAncillaryType = function (ancillaryType) {
	if (!ancillaryType) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Common$Price$Euro = 0;
var $author$project$Common$Price$Price = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Common$Price$new = F2(
	function (amount, currency) {
		return A2($author$project$Common$Price$Price, amount, currency);
	});
var $author$project$Common$Price$euro = function (amount) {
	return A2($author$project$Common$Price$new, amount, 0);
};
var $author$project$New$Gql$Platform$Scalar$unwrapCodecs = function (_v0) {
	var unwrappedCodecs = _v0;
	return unwrappedCodecs;
};
var $author$project$New$Gql$Platform$Object$AncillaryCover$grossPrice = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'grossPrice',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).my.A);
var $author$project$Pyxis$Components$IconSet$Car = 193;
var $author$project$Pyxis$Components$IconSet$car = 193;
var $author$project$Translations$coversAncillaryRoadsideAssistencePremium = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Premium roadside assistance';
	} else {
		return 'Asistencia en carretera premium';
	}
};
var $author$project$Translations$coversAncillarySubstitutionVehicle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Substitution vehicle';
	} else {
		return 'Vehículo de sustitución';
	}
};
var $author$project$Pyxis$Components$IconSet$VehicleRoadsideAssistance = 9;
var $author$project$Pyxis$Components$IconSet$vehicleRoadsideAssistance = 9;
var $author$project$Common$CoverSelection$newAncillary = F2(
	function (ancillaryType, grossPrice) {
		var icon = function () {
			if (!ancillaryType) {
				return $author$project$Pyxis$Components$IconSet$vehicleRoadsideAssistance;
			} else {
				return $author$project$Pyxis$Components$IconSet$car;
			}
		}();
		var i18nDescription = function () {
			if (!ancillaryType) {
				return $author$project$Translations$coversAncillaryRoadsideAssistencePremium;
			} else {
				return $author$project$Translations$coversAncillarySubstitutionVehicle;
			}
		}();
		return {cT: grossPrice, ke: i18nDescription, kf: icon};
	});
var $author$project$Common$Gql$CoverSelection$ancillarySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$AncillaryCover$grossPrice),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$CoverSelection$decodeAncillaryType, $author$project$New$Gql$Platform$Object$AncillaryCover$coverName),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverSelection$newAncillary)));
var $author$project$New$Gql$Platform$Object$AncillaryCovers$selected = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'selected',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$New$Gql$Platform$Object$AncillaryCovers$unselected = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'unselected',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Common$Gql$CoverSelection$ancillaryCoversSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$AncillaryCovers$unselected($author$project$Common$Gql$CoverSelection$ancillarySelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$AncillaryCovers$selected($author$project$Common$Gql$CoverSelection$ancillarySelectionSet),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverSelection$ancillaryProducts)));
var $author$project$New$Gql$Platform$Union$Ancillaries$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'AncillaryCovers', selections____.n3),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreAncillary', selections____.oB)
			]));
};
var $author$project$Common$CoverSelection$PreAncillaries = {$: 0};
var $author$project$Common$CoverSelection$preAncillaries = $author$project$Common$CoverSelection$PreAncillaries;
var $author$project$Common$Gql$CoverSelection$preAncillarySelectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverSelection$preAncillaries);
var $author$project$Common$Gql$CoverSelection$ancillariesSelectionSet = $author$project$New$Gql$Platform$Union$Ancillaries$fragments(
	{n3: $author$project$Common$Gql$CoverSelection$ancillaryCoversSelectionSet, oB: $author$project$Common$Gql$CoverSelection$preAncillarySelectionSet});
var $author$project$New$Gql$Platform$Object$CoverSelection$bundlePrice = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'bundlePrice',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).my.A);
var $author$project$New$Gql$Platform$Enum$BundleSlug$TercerosAmpliado = 1;
var $author$project$New$Gql$Platform$Enum$BundleSlug$TercerosBasico = 0;
var $author$project$New$Gql$Platform$Enum$BundleSlug$TodoRiesgoConFranquicia = 2;
var $author$project$New$Gql$Platform$Enum$BundleSlug$TodoRiesgoConFranquicia300 = 3;
var $author$project$New$Gql$Platform$Enum$BundleSlug$TodoRiesgoConFranquicia500 = 4;
var $author$project$New$Gql$Platform$Enum$BundleSlug$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'TERCEROS_BASICO':
				return $elm$json$Json$Decode$succeed(0);
			case 'TERCEROS_AMPLIADO':
				return $elm$json$Json$Decode$succeed(1);
			case 'TODO_RIESGO_CON_FRANQUICIA':
				return $elm$json$Json$Decode$succeed(2);
			case 'TODO_RIESGO_CON_FRANQUICIA_300':
				return $elm$json$Json$Decode$succeed(3);
			case 'TODO_RIESGO_CON_FRANQUICIA_500':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid BundleSlug type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$CoverSelection$bundleSlug = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BundleSlug.BundleSlug', 'bundleSlug', _List_Nil, $author$project$New$Gql$Platform$Enum$BundleSlug$decoder);
var $author$project$New$Gql$Platform$Object$CoverSelection$chosenExcess = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe NewScalarCodecs.Decimal)',
	'chosenExcess',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).my.A));
var $author$project$Common$Product$TercerosAmpliado = 1;
var $author$project$Common$Product$TercerosBasico = 0;
var $author$project$Common$Product$TodoRiesgoConFranquicia = 2;
var $author$project$Common$Gql$BundleSlug$decodeNewBundleSlug = function (bundleSlug) {
	switch (bundleSlug) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 2;
		default:
			return 2;
	}
};
var $author$project$Common$CoverSelection$CoverSelection = F4(
	function (bundle, bundleGrossPrice, chosenExcess, ancillaries) {
		return {mi: ancillaries, f0: bundle, f1: bundleGrossPrice, f3: chosenExcess};
	});
var $author$project$Common$CoverSelection$new = $author$project$Common$CoverSelection$CoverSelection;
var $author$project$Common$Gql$CoverSelection$coverSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$CoverSelection$ancillaries($author$project$Common$Gql$CoverSelection$ancillariesSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			$elm$core$Maybe$map($author$project$Common$Price$euro),
			$author$project$New$Gql$Platform$Object$CoverSelection$chosenExcess),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$CoverSelection$bundlePrice),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$BundleSlug$decodeNewBundleSlug, $author$project$New$Gql$Platform$Object$CoverSelection$bundleSlug),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverSelection$new)))));
var $author$project$Common$Gql$CoverSelection$getCoverSelection = function (queryArg) {
	return A2(
		$author$project$New$Gql$Platform$Query$coverSelection,
		$author$project$Common$Gql$CoverSelection$buildCoverContinuityQueryArg(queryArg),
		$author$project$New$Gql$Platform$Object$CoverSelectionOutput$coverSelection($author$project$Common$Gql$CoverSelection$coverSelectionSet));
};
var $author$project$Gql$Platform$Query$CustomerIdRequiredArguments = function (request) {
	return {ca: request};
};
var $author$project$Common$Gql$CustomerId$buildCustomerIdQueryArg = function (args) {
	if (!args.$) {
		var policyId = args.a;
		return $author$project$Gql$Platform$Query$CustomerIdRequiredArguments(
			{
				j0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				j1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					{
						oQ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(policyId)
					})
			});
	} else {
		var offerId = args.a;
		return $author$project$Gql$Platform$Query$CustomerIdRequiredArguments(
			{
				j0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					{
						mI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
						n$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(offerId)
					}),
				j1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
			});
	}
};
var $author$project$Gql$Platform$InputObject$encodeOfferIdentifier = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'customerFacingId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mI, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'offerId',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.n$,
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$ScalarCodecs$codecs)))
			]));
};
var $author$project$Gql$Platform$InputObject$encodePolicyIdentifier = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyId',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.oQ,
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$ScalarCodecs$codecs)))
			]));
};
var $author$project$Gql$Platform$InputObject$encodeCustomerIdRequest = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'forOffer',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j0, $author$project$Gql$Platform$InputObject$encodeOfferIdentifier)),
				_Utils_Tuple2(
				'forPolicy',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j1, $author$project$Gql$Platform$InputObject$encodePolicyIdentifier))
			]));
};
var $author$project$Gql$Platform$Query$customerId = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'(Maybe String)',
		'customerId',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'request', requiredArgs____.ca, $author$project$Gql$Platform$InputObject$encodeCustomerIdRequest)
			]),
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
};
var $author$project$Common$Gql$CustomerId$getCustomerId = function (customerIdQueryArg) {
	return $author$project$Gql$Platform$Query$customerId(
		$author$project$Common$Gql$CustomerId$buildCustomerIdQueryArg(customerIdQueryArg));
};
var $author$project$Gql$Platform$Query$GetPreviousPaymentMethodRequiredArguments = function (forA) {
	return {j$: forA};
};
var $author$project$Common$Gql$PaymentMethod$buildPaymentMethodArg = function (args) {
	if (!args.$) {
		var policyId = args.a;
		return $author$project$Gql$Platform$Query$GetPreviousPaymentMethodRequiredArguments(
			{
				j1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(policyId),
				j2: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
			});
	} else {
		var offerId = args.a;
		return $author$project$Gql$Platform$Query$GetPreviousPaymentMethodRequiredArguments(
			{
				j1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				j2: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					{
						mI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
						n$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(offerId)
					})
			});
	}
};
var $author$project$Gql$Platform$Union$PaymentMethod$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CreditCard', selections____.op)
			]));
};
var $author$project$Common$PaymentMethod$PaymentMethod = F4(
	function (brand, cardNumber, cardValidity, expirationDate) {
		return {bv: brand, cE: cardNumber, d5: cardValidity, cO: expirationDate};
	});
var $author$project$Gql$Platform$Object$CreditCard$brand = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'brand', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$CreditCard$cardNumber = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'cardNumber', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$PaymentMethod$Expired = 1;
var $author$project$Common$PaymentMethod$Valid = 0;
var $author$project$Common$Gql$PaymentMethod$decodeValidity = function (cardValidity) {
	if (cardValidity === 1) {
		return 1;
	} else {
		return 0;
	}
};
var $author$project$Gql$Platform$Object$CreditCard$expirationDate = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'expirationDate', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$PaymentMethod$Maestro = {$: 2};
var $author$project$Common$PaymentMethod$MasterCard = {$: 1};
var $author$project$Common$PaymentMethod$Other = function (a) {
	return {$: 3, a: a};
};
var $author$project$Common$PaymentMethod$Visa = {$: 0};
var $author$project$Gql$Platform$Union$Brand$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Visa', selections____.oJ),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Mastercard', selections____.ox),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Maestro', selections____.ow),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'OtherCard', selections____.oy)
			]));
};
var $author$project$Gql$Platform$Object$OtherCard$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$PaymentMethod$onBrandSelectionSet = $author$project$Gql$Platform$Union$Brand$fragments(
	{
		ow: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$PaymentMethod$Maestro),
		ox: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$PaymentMethod$MasterCard),
		oy: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$PaymentMethod$Other, $author$project$Gql$Platform$Object$OtherCard$name),
		oJ: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$PaymentMethod$Visa)
	});
var $author$project$Gql$Platform$Enum$CreditCardValidity$Expired = 1;
var $author$project$Gql$Platform$Enum$CreditCardValidity$Valid = 0;
var $author$project$Gql$Platform$Enum$CreditCardValidity$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'VALID':
				return $elm$json$Json$Decode$succeed(0);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid CreditCardValidity type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$CreditCard$validity = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.CreditCardValidity.CreditCardValidity', 'validity', _List_Nil, $author$project$Gql$Platform$Enum$CreditCardValidity$decoder);
var $author$project$Common$Gql$PaymentMethod$onCreditCardSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$CreditCard$expirationDate,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$PaymentMethod$decodeValidity, $author$project$Gql$Platform$Object$CreditCard$validity),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$CreditCard$cardNumber,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$CreditCard$brand($author$project$Common$Gql$PaymentMethod$onBrandSelectionSet),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$PaymentMethod$PaymentMethod)))));
var $author$project$Common$Gql$PaymentMethod$getPaymentMethodSelectionSet = $author$project$Gql$Platform$Union$PaymentMethod$fragments(
	{op: $author$project$Common$Gql$PaymentMethod$onCreditCardSelectionSet});
var $author$project$Gql$Platform$InputObject$encodePreviousPaymentMethodRequest = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'forPolicy',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.j1,
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'forRenewalOffer',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j2, $author$project$Gql$Platform$InputObject$encodeOfferIdentifier))
			]));
};
var $author$project$Gql$Platform$Query$getPreviousPaymentMethod = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'getPreviousPaymentMethod',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'forA', requiredArgs____.j$, $author$project$Gql$Platform$InputObject$encodePreviousPaymentMethodRequest)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Common$Gql$PaymentMethod$getPaymentMethod = function (paymentMethodArg) {
	return A2(
		$author$project$Gql$Platform$Query$getPreviousPaymentMethod,
		$author$project$Common$Gql$PaymentMethod$buildPaymentMethodArg(paymentMethodArg),
		$author$project$Common$Gql$PaymentMethod$getPaymentMethodSelectionSet);
};
var $dillonkearns$elm_graphql$Graphql$Http$Mutation = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$mutationRequest = F2(
	function (baseUrl, mutationSelectionSet) {
		return {
			cA: baseUrl,
			mP: $dillonkearns$elm_graphql$Graphql$Http$Mutation(mutationSelectionSet),
			mW: $dillonkearns$elm_graphql$Graphql$Document$decoder(mutationSelectionSet),
			nc: _List_Nil,
			bb: $elm$core$Maybe$Nothing,
			bf: _List_Nil,
			pv: $elm$core$Maybe$Nothing,
			bo: false
		};
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Gql$Platform$Query$OfferV2RequiredArguments = function (identifier) {
	return {bM: identifier};
};
var $author$project$Common$Gql$Offer$offerByCfidRequiredArguments = function (cfid) {
	return $author$project$Gql$Platform$Query$OfferV2RequiredArguments(
		{
			mI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(cfid),
			n$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
		});
};
var $author$project$Common$Offer$BlockedType = 3;
var $author$project$Gql$Platform$Object$BackofficeBlockedOffer$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Gql$Platform$Scalar$unwrapCodecs = function (_v0) {
	var unwrappedCodecs = _v0;
	return unwrappedCodecs;
};
var $author$project$Gql$Platform$Object$BackofficeBlockedOffer$blockedQuoteId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'blockedQuoteId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).t.A);
var $author$project$Gql$Platform$Enum$BackofficeBlockedOfferStatus$Blocked = 0;
var $author$project$Gql$Platform$Enum$BackofficeBlockedOfferStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		if (string === 'BLOCKED') {
			return $elm$json$Json$Decode$succeed(0);
		} else {
			return $elm$json$Json$Decode$fail('Invalid BackofficeBlockedOfferStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeBlockedOffer$blockedStatus = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeBlockedOfferStatus.BackofficeBlockedOfferStatus', 'blockedStatus', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeBlockedOfferStatus$decoder);
var $author$project$Gql$Platform$Object$BackofficeBlockedOffer$continuitySummary = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'continuitySummary', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Union$BackofficeCoverContinuitySummary$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NoPreviousCoverage', selections____.kV),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'TercerosBasicoSelected', selections____.k7),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoverageWithNoContinuityInformation', selections____.k_),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoveragePendingContinuityInformation', selections____.kZ),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoverageAndSelectedTercerosAmpliado', selections____.kW),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoverageAndSelectedTodoRiesgo', selections____.kX),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousPrimaBasicoCoverage', selections____.k0),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousPrimaAmpliadoCoverage', selections____.k$),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousPrimaTodoRiesgoCoverage', selections____.k1),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoverageGivenOnCheck24', selections____.kY)
			]));
};
var $author$project$Common$CoverContinuity$NoPreviousCoverage = {$: 0};
var $author$project$Common$CoverContinuity$newCoverContinuityWithNoPreviousPolicy = $author$project$Common$CoverContinuity$NoPreviousCoverage;
var $author$project$Common$Gql$CoverContinuity$onNoPreviousCoverageSelectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newCoverContinuityWithNoPreviousPolicy);
var $author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTercerosAmpliado$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTercerosAmpliado$hadLunas = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadLunas', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$CoverContinuity$ExternalCompany = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$CoverContinuity$ExternalCompanyInfo = $elm$core$Basics$identity;
var $author$project$Common$CoverContinuity$SelectedTercerosAmpliado = function (a) {
	return {$: 4, a: a};
};
var $author$project$Common$CoverContinuity$newPreviousExternalCoverContinuityTercerosAmpliado = F2(
	function (companyName, hadLunas) {
		return $author$project$Common$CoverContinuity$SelectedTercerosAmpliado(
			{
				I: $author$project$Common$CoverContinuity$ExternalCompany(companyName),
				aH: hadLunas
			});
	});
var $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoverageAndSelectedTercerosAmpliadoSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTercerosAmpliado$hadLunas,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTercerosAmpliado$companyName,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalCoverContinuityTercerosAmpliado)));
var $author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$hadDanosPropios = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadDanosPropios', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$hadLunas = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadLunas', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$CoverContinuity$SelectedTodoRiesgo = function (a) {
	return {$: 5, a: a};
};
var $author$project$Common$CoverContinuity$newPreviousExternalCoverContinuityTodoRiesgo = F3(
	function (companyName, hadLunas, hadDanosProprios) {
		return $author$project$Common$CoverContinuity$SelectedTodoRiesgo(
			{
				I: $author$project$Common$CoverContinuity$ExternalCompany(companyName),
				ez: hadDanosProprios,
				aH: hadLunas
			});
	});
var $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoverageAndSelectedTodoRiesgoSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$hadDanosPropios,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$hadLunas,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$companyName,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalCoverContinuityTodoRiesgo))));
var $author$project$Gql$Platform$Object$PreviousExternalCoverageGivenOnCheck24$bundleName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'bundleName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$PreviousExternalCoverageGivenOnCheck24$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$CoverContinuity$PreviousCoverageGivenOnCheck24 = function (a) {
	return {$: 6, a: a};
};
var $author$project$Common$CoverContinuity$newPreviousExternalCoverageGivenOnCheck24 = F2(
	function (companyName, bundleName) {
		return $author$project$Common$CoverContinuity$PreviousCoverageGivenOnCheck24(
			{
				f0: bundleName,
				I: $author$project$Common$CoverContinuity$ExternalCompany(companyName)
			});
	});
var $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoverageGivenOnCheck24SelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$PreviousExternalCoverageGivenOnCheck24$bundleName,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$PreviousExternalCoverageGivenOnCheck24$companyName,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalCoverageGivenOnCheck24)));
var $author$project$Gql$Platform$Object$PreviousExternalCoveragePendingContinuityInformation$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$CoverContinuity$PreviousExternalCoveragePendingCoverContinuityInformation = function (a) {
	return {$: 3, a: a};
};
var $author$project$Common$CoverContinuity$newCoverContinuityPendingInfo = A2($elm$core$Basics$composeL, $author$project$Common$CoverContinuity$PreviousExternalCoveragePendingCoverContinuityInformation, $elm$core$Basics$identity);
var $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoveragePendingContinuityInformationSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$PreviousExternalCoveragePendingContinuityInformation$companyName,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newCoverContinuityPendingInfo));
var $author$project$Gql$Platform$Object$PreviousExternalCoverageWithNoContinuityInformation$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$CoverContinuity$PreviousExternalCoverageWithNoCoverContinuityInformation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Common$CoverContinuity$newPreviousExternalCoverageWithNoCoverContinuityInformation = A2($elm$core$Basics$composeL, $author$project$Common$CoverContinuity$PreviousExternalCoverageWithNoCoverContinuityInformation, $elm$core$Basics$identity);
var $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoverageWithNoContinuityInformationSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$PreviousExternalCoverageWithNoContinuityInformation$companyName,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalCoverageWithNoCoverContinuityInformation));
var $author$project$Gql$Platform$Object$PreviousPrimaAmpliadoCoverage$hadLunas = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadLunas', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$CoverContinuity$Prima = {$: 0};
var $author$project$Common$CoverContinuity$newPrimaCoverContinuityTercerosAmpliado = function (hadLunas) {
	return $author$project$Common$CoverContinuity$SelectedTercerosAmpliado(
		{I: $author$project$Common$CoverContinuity$Prima, aH: hadLunas});
};
var $author$project$Common$Gql$CoverContinuity$onPreviousPrimaAmpliadoCoverageSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$PreviousPrimaAmpliadoCoverage$hadLunas,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPrimaCoverContinuityTercerosAmpliado));
var $author$project$Common$CoverContinuity$TercerosBasicoSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$CoverContinuity$newPrimaTercerosBasicoSelected = $author$project$Common$CoverContinuity$TercerosBasicoSelected($author$project$Common$CoverContinuity$Prima);
var $author$project$Common$Gql$CoverContinuity$onPreviousPrimaBasicoCoverageSelectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPrimaTercerosBasicoSelected);
var $author$project$Gql$Platform$Object$PreviousPrimaTodoRiesgoCoverage$hadDanosPropios = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadDanosPropios', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Gql$Platform$Object$PreviousPrimaTodoRiesgoCoverage$hadLunas = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadLunas', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$CoverContinuity$newPrimaCoverContinuityTodoRiesgo = F2(
	function (hadLunas, hadDanosProprios) {
		return $author$project$Common$CoverContinuity$SelectedTodoRiesgo(
			{I: $author$project$Common$CoverContinuity$Prima, ez: hadDanosProprios, aH: hadLunas});
	});
var $author$project$Common$Gql$CoverContinuity$onPreviousPrimaTodoRiesgoCoverageSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$PreviousPrimaTodoRiesgoCoverage$hadDanosPropios,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$PreviousPrimaTodoRiesgoCoverage$hadLunas,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPrimaCoverContinuityTodoRiesgo)));
var $author$project$Gql$Platform$Object$TercerosBasicoSelected$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$CoverContinuity$newPreviousExternalTercerosBasicoSelected = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$Basics$composeL, $author$project$Common$CoverContinuity$TercerosBasicoSelected, $author$project$Common$CoverContinuity$ExternalCompany),
	$elm$core$Basics$identity);
var $author$project$Common$Gql$CoverContinuity$onTercerosBasicoSelectedSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$TercerosBasicoSelected$companyName,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalTercerosBasicoSelected));
var $author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet = $author$project$Gql$Platform$Union$BackofficeCoverContinuitySummary$fragments(
	{kV: $author$project$Common$Gql$CoverContinuity$onNoPreviousCoverageSelectionSet, kW: $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoverageAndSelectedTercerosAmpliadoSelectionSet, kX: $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoverageAndSelectedTodoRiesgoSelectionSet, kY: $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoverageGivenOnCheck24SelectionSet, kZ: $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoveragePendingContinuityInformationSelectionSet, k_: $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoverageWithNoContinuityInformationSelectionSet, k$: $author$project$Common$Gql$CoverContinuity$onPreviousPrimaAmpliadoCoverageSelectionSet, k0: $author$project$Common$Gql$CoverContinuity$onPreviousPrimaBasicoCoverageSelectionSet, k1: $author$project$Common$Gql$CoverContinuity$onPreviousPrimaTodoRiesgoCoverageSelectionSet, k7: $author$project$Common$Gql$CoverContinuity$onTercerosBasicoSelectedSelectionSet});
var $author$project$Gql$Platform$Object$BackofficeBlockedOffer$customerData = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'customerData', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$applicationId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'applicationId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).t.A);
var $author$project$Common$ApplicationId$ApplicationId = $elm$core$Basics$identity;
var $author$project$Common$ApplicationId$new = $elm$core$Basics$identity;
var $author$project$Common$Gql$Offer$decodeApplicationId = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$ApplicationId$new, $author$project$Gql$Platform$Object$BackofficeOfferDetails$applicationId);
var $author$project$Gql$Platform$Enum$BackofficeApplicationSource$Acierto = 2;
var $author$project$Gql$Platform$Enum$BackofficeApplicationSource$Check24 = 3;
var $author$project$Gql$Platform$Enum$BackofficeApplicationSource$Prima = 0;
var $author$project$Gql$Platform$Enum$BackofficeApplicationSource$Rastreator = 1;
var $author$project$Gql$Platform$Enum$BackofficeApplicationSource$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'PRIMA':
				return $elm$json$Json$Decode$succeed(0);
			case 'RASTREATOR':
				return $elm$json$Json$Decode$succeed(1);
			case 'ACIERTO':
				return $elm$json$Json$Decode$succeed(2);
			case 'CHECK_24':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeApplicationSource type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$applicationSource = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeApplicationSource.BackofficeApplicationSource', 'applicationSource', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeApplicationSource$decoder);
var $author$project$Common$Source$Acierto = 0;
var $author$project$Common$Source$Check24 = 1;
var $author$project$Common$Source$Prima = 2;
var $author$project$Common$Source$Rastreator = 3;
var $author$project$Common$Gql$ApplicationSource$decodeApplicationSource = function (applicationSource) {
	switch (applicationSource) {
		case 2:
			return 0;
		case 3:
			return 1;
		case 0:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Common$Gql$Offer$decodeApplicationSource = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$ApplicationSource$decodeApplicationSource, $author$project$Gql$Platform$Object$BackofficeOfferDetails$applicationSource);
var $author$project$Common$Offer$AmendStartDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Gql$Platform$Object$BackofficeAmendOfferStartDate$offerId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'offerId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).t.A);
var $author$project$Common$Gql$Offer$decodeAmendStartDateAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeAmendOfferStartDate$offerId,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$AmendStartDate));
var $author$project$Common$Offer$Complete = function (a) {
	return {$: 2, a: a};
};
var $author$project$Gql$Platform$Object$BackofficeCompleteOffer$offerId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'offerId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).t.A);
var $author$project$Common$Gql$Offer$decodeCompleteAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeCompleteOffer$offerId,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$Complete));
var $author$project$Common$Offer$Edit = function (a) {
	return {$: 3, a: a};
};
var $author$project$Gql$Platform$Object$BackofficeEditOffer$offerId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'offerId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).t.A);
var $author$project$Common$Gql$Offer$decodeEditAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeEditOffer$offerId,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$Edit));
var $author$project$Common$Offer$EditCover = function (a) {
	return {$: 4, a: a};
};
var $author$project$Gql$Platform$Object$BackofficeShowEditCoverLink$link = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'link', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Offer$decodeEditCoverAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeShowEditCoverLink$link,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$EditCover));
var $author$project$Common$Offer$Purchase = function (a) {
	return {$: 0, a: a};
};
var $author$project$Gql$Platform$Object$BackofficePurchaseOffer$offerId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'offerId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).t.A);
var $author$project$Common$Gql$Offer$decodePurchaseAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficePurchaseOffer$offerId,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$Purchase));
var $author$project$Common$Offer$EditAncillaryCovers = function (a) {
	return {$: 5, a: a};
};
var $author$project$Gql$Platform$Object$BackofficeShowEditAncillaryCoversLink$link = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'link', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Offer$decodeShowEditAncillaryCoversAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$url$Url$fromString, $author$project$Gql$Platform$Object$BackofficeShowEditAncillaryCoversLink$link),
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$EditAncillaryCovers));
var $author$project$Gql$Platform$Union$BackofficeOfferAction$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficePurchaseOffer', selections____.od),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeAmendOfferStartDate', selections____.n6),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeCompleteOffer', selections____.n8),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeEditOffer', selections____.oa),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeShowEditCoverLink', selections____.oj),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeShowEditAncillaryCoversLink', selections____.oi)
			]));
};
var $author$project$Common$Gql$Offer$decodeAvailableActions = $author$project$Gql$Platform$Union$BackofficeOfferAction$fragments(
	{n6: $author$project$Common$Gql$Offer$decodeAmendStartDateAction, n8: $author$project$Common$Gql$Offer$decodeCompleteAction, oa: $author$project$Common$Gql$Offer$decodeEditAction, od: $author$project$Common$Gql$Offer$decodePurchaseAction, oi: $author$project$Common$Gql$Offer$decodeShowEditAncillaryCoversAction, oj: $author$project$Common$Gql$Offer$decodeEditCoverAction});
var $author$project$Common$Offer$Blocked = 5;
var $author$project$Common$Gql$Offer$decodeBlockedOfferStatus = function (_v0) {
	return 5;
};
var $author$project$Common$Offer$ComebackLinkStatusCorrect = function (a) {
	return {$: 2, a: a};
};
var $author$project$Common$Offer$ComebackLinkStatusIncorrect = {$: 1};
var $author$project$Common$Offer$ComebackLinkStatusNotPresent = {$: 0};
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$comebackLink = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'comebackLink',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$join = function (mx) {
	if (!mx.$) {
		var x = mx.a;
		return x;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Common$ComebackLink$ComebackLink = $elm$core$Basics$identity;
var $author$project$Common$ComebackLink$new = F2(
	function (url, nonce) {
		return {hx: nonce, iV: url, fC: $elm$core$Maybe$Nothing, fD: $elm$core$Maybe$Nothing, fE: $elm$core$Maybe$Nothing};
	});
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {a$: frag, bc: params, aR: unvisited, pB: value, bm: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.aR;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.pB);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.pB);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.oP),
					$elm$url$Url$Parser$prepareQuery(url.ll),
					url.m0,
					$elm$core$Basics$identity)));
	});
var $author$project$Common$ComebackLink$nonceQueryParamKey = 'nonce';
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.bm;
		var unvisited = _v1.aR;
		var params = _v1.bc;
		var frag = _v1.a$;
		var value = _v1.pB;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.bm;
		var unvisited = _v0.aR;
		var params = _v0.bc;
		var frag = _v0.a$;
		var value = _v0.pB;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$Common$ComebackLink$offerComeback = A2(
	$elm$url$Url$Parser$questionMark,
	$elm$url$Url$Parser$s('offer_comeback'),
	$elm$url$Url$Parser$Query$string($author$project$Common$ComebackLink$nonceQueryParamKey));
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $author$project$Common$ComebackLink$rastreatorOfferComeback = A2(
	$elm$url$Url$Parser$questionMark,
	$elm$url$Url$Parser$s('rtr_offer_landing'),
	$elm$url$Url$Parser$Query$string($author$project$Common$ComebackLink$nonceQueryParamKey));
var $author$project$Common$ComebackLink$renewalOfferComeback = A2(
	$elm$url$Url$Parser$questionMark,
	$elm$url$Url$Parser$s('renovacion'),
	$elm$url$Url$Parser$Query$string($author$project$Common$ComebackLink$nonceQueryParamKey));
var $author$project$Common$ComebackLink$urlParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[$author$project$Common$ComebackLink$offerComeback, $author$project$Common$ComebackLink$renewalOfferComeback, $author$project$Common$ComebackLink$rastreatorOfferComeback]));
var $author$project$Common$ComebackLink$tryFrom = function (unknownValue) {
	var _v0 = $elm$url$Url$fromString(unknownValue);
	if (_v0.$ === 1) {
		return $elm$core$Result$Err('The string provided as a Comeback Link is not a valid url');
	} else {
		var url = _v0.a;
		return A2(
			$elm$core$Result$fromMaybe,
			'The string provided as a Comeback Link has an unexpected shape',
			A2(
				$elm$core$Maybe$map,
				$author$project$Common$ComebackLink$new(url),
				$elm_community$maybe_extra$Maybe$Extra$join(
					A2($elm$url$Url$Parser$parse, $author$project$Common$ComebackLink$urlParser, url))));
	}
};
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Common$Gql$Offer$decodeComebackLink = function () {
	var tryToComebackLink = A2(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$author$project$Common$Offer$ComebackLinkStatusNotPresent,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Common$ComebackLink$tryFrom,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$map($author$project$Common$Offer$ComebackLinkStatusCorrect),
				$elm$core$Result$withDefault($author$project$Common$Offer$ComebackLinkStatusIncorrect))));
	return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, tryToComebackLink, $author$project$Gql$Platform$Object$BackofficeOfferDetails$comebackLink);
}();
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$creationAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.DateTime',
	'creationAt',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).N.A);
var $author$project$Common$Gql$Offer$decodeCreationDate = $author$project$Gql$Platform$Object$BackofficeOfferDetails$creationAt;
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$customerFacingId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'customerFacingId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Offer$decodeCustomerFacingId = $author$project$Gql$Platform$Object$BackofficeOfferDetails$customerFacingId;
var $author$project$Common$Person$AdditionalDriver = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Gql$Platform$Enum$AdditionalDriverDrivingLicenseYears$LessThanOne = 0;
var $author$project$Gql$Platform$Enum$AdditionalDriverDrivingLicenseYears$LessThanTwo = 1;
var $author$project$Gql$Platform$Enum$AdditionalDriverDrivingLicenseYears$MoreThanTwo = 3;
var $author$project$Gql$Platform$Enum$AdditionalDriverDrivingLicenseYears$OneToThree = 2;
var $author$project$Gql$Platform$Enum$AdditionalDriverDrivingLicenseYears$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'LESS_THAN_ONE':
				return $elm$json$Json$Decode$succeed(0);
			case 'LESS_THAN_TWO':
				return $elm$json$Json$Decode$succeed(1);
			case 'ONE_TO_THREE':
				return $elm$json$Json$Decode$succeed(2);
			case 'MORE_THAN_TWO':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Invalid AdditionalDriverDrivingLicenseYears type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$drivingLicenseYears = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.AdditionalDriverDrivingLicenseYears.AdditionalDriverDrivingLicenseYears)',
	'drivingLicenseYears',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$Gql$Platform$Enum$AdditionalDriverDrivingLicenseYears$decoder));
var $author$project$Common$Person$PersonData = F4(
	function (firstName, lastName, documentId, dateOfBirth) {
		return {aq: dateOfBirth, ar: documentId, aD: firstName, aJ: lastName};
	});
var $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$birthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.NaiveDate)',
	'birthDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).cG.A));
var $justinmimbs$date$Date$fromRataDie = function (rd) {
	return rd;
};
var $author$project$Common$Locale$defaultDate = $justinmimbs$date$Date$fromRataDie(1);
var $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$documentId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'documentId',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$firstName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'firstName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$lastName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'lastName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$Offer$fullAdditionalDriverPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Common$Locale$defaultDate, $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$birthDate),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$documentId),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$lastName),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$firstName),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$AdditionalDriverDrivingLicenseYears$LessThanOne = 0;
var $author$project$Common$AdditionalDriverDrivingLicenseYears$LessThanTwo = 1;
var $author$project$Common$AdditionalDriverDrivingLicenseYears$MoreThanTwo = 3;
var $author$project$Common$AdditionalDriverDrivingLicenseYears$OneToThree = 2;
var $author$project$Common$Gql$AdditionalDriverDrivingLicenseYears$decodeAdditionalDriverDrivingLicenseYears = function (drivingLicenseYears) {
	switch (drivingLicenseYears) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Common$Gql$AdditionalDriverDrivingLicenseYears$maybeDecodeAdditionalDriverDrivingLicenseYears = function (drivingLicenseYears) {
	return A2($elm$core$Maybe$map, $author$project$Common$Gql$AdditionalDriverDrivingLicenseYears$decodeAdditionalDriverDrivingLicenseYears, drivingLicenseYears);
};
var $author$project$Common$Gql$Offer$fullAdditionalDriverSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$AdditionalDriverDrivingLicenseYears$maybeDecodeAdditionalDriverDrivingLicenseYears, $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$drivingLicenseYears),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Common$Gql$Offer$fullAdditionalDriverPersonDataSelectionSet,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$AdditionalDriver)));
var $author$project$Gql$Platform$Object$BackofficeFullCustomerData$occasionalDriver = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'occasionalDriver', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodeFullAdditionalDriver = $author$project$Gql$Platform$Object$BackofficeFullCustomerData$occasionalDriver($author$project$Common$Gql$Offer$fullAdditionalDriverSelectionSet);
var $author$project$Gql$Platform$Object$BackofficeFullCustomerData$claimsDeclaredWithFault = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'claimsDeclaredWithFault',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Gql$Platform$Object$AtLeast$atLeast = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'atLeast', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Common$Count$Minimum = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$Count$minimum = $author$project$Common$Count$Minimum;
var $author$project$Common$Gql$ClaimsCount$atLeastTotalClaimsDeclaredWithFaultSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Count$minimum, $author$project$Gql$Platform$Object$AtLeast$atLeast);
var $author$project$Common$Count$Exact = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Count$exact = $author$project$Common$Count$Exact;
var $author$project$Common$Gql$ClaimsCount$countTotalClaimsDeclaredWithFaultSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Count$exact, $author$project$Gql$Platform$Object$Count$count);
var $author$project$Gql$Platform$Union$TotalClaimsCount$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Count', selections____.oo),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'AtLeast', selections____.n4)
			]));
};
var $author$project$Common$Gql$ClaimsCount$claimsDeclaredWithFaultSelectionSet = $author$project$Gql$Platform$Union$TotalClaimsCount$fragments(
	{n4: $author$project$Common$Gql$ClaimsCount$atLeastTotalClaimsDeclaredWithFaultSelectionSet, oo: $author$project$Common$Gql$ClaimsCount$countTotalClaimsDeclaredWithFaultSelectionSet});
var $author$project$Common$Gql$Offer$decodeFullClaimsDeclaredWithFault = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
	$author$project$Common$Count$default,
	$author$project$Gql$Platform$Object$BackofficeFullCustomerData$claimsDeclaredWithFault($author$project$Common$Gql$ClaimsCount$claimsDeclaredWithFaultSelectionSet));
var $author$project$Common$Person$Driver = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$address = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'address', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Address$Address = F4(
	function (streetName, streetNumber, province, postalCode) {
		return {oT: postalCode, oZ: province, pn: streetName, po: streetNumber};
	});
var $author$project$Gql$Platform$Object$BackofficeAddress$postalCode = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'postalCode', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeAddress$province = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'province', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeAddress$streetName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'streetName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Gql$Platform$Object$BackofficeAddress$streetNumber = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'streetNumber',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$Offer$addressSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeAddress$postalCode,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeAddress$province,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficeAddress$streetNumber),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficeAddress$streetName),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Address$Address)))));
var $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$drivingLicenseDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'drivingLicenseDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$isLicenseMoreThanTwoYearsOld = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Bool)',
	'isLicenseMoreThanTwoYearsOld',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool));
var $author$project$Common$Person$MainDriverDrivingLicenseData = F2(
	function (drivingLicenseDate, isMoreThanTwoYearsOld) {
		return {en: drivingLicenseDate, eL: isMoreThanTwoYearsOld};
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Common$Person$newMainDriverDrivingLicenseData = F2(
	function (drivingLicenseDate, isMoreThanTwoYearsOld) {
		return A3($elm$core$Maybe$map2, $author$project$Common$Person$MainDriverDrivingLicenseData, drivingLicenseDate, isMoreThanTwoYearsOld);
	});
var $author$project$Common$Gql$Offer$decodeMaybeFullMainDriverDrivingLicenseData = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeFullMainDriverData$isLicenseMoreThanTwoYearsOld,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeFullMainDriverData$drivingLicenseDate,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$newMainDriverDrivingLicenseData)));
var $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$birthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.NaiveDate',
	'birthDate',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).cG.A);
var $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$firstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'firstName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$lastName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Offer$fullMainDriverPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeFullMainDriverData$birthDate,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeFullMainDriverData$documentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeFullMainDriverData$lastName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeFullMainDriverData$firstName,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$recentInsuranceCompanyName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'recentInsuranceCompanyName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$Offer$fullMainDriverSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Common$Gql$Offer$decodeMaybeFullMainDriverDrivingLicenseData,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$recentInsuranceCompanyName),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeFullMainDriverData$address($author$project$Common$Gql$Offer$addressSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$Offer$fullMainDriverPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Driver)))));
var $author$project$Gql$Platform$Object$BackofficeFullCustomerData$mainDriver = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'mainDriver', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodeFullMainDriver = $author$project$Gql$Platform$Object$BackofficeFullCustomerData$mainDriver($author$project$Common$Gql$Offer$fullMainDriverSelectionSet);
var $author$project$Common$Person$PolicyHolder = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$address = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'address',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Common$Person$Contacts = F2(
	function (email, phoneNumber) {
		return {eq: email, h8: phoneNumber};
	});
var $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$email = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'email', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$phoneNumber = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'phoneNumber', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Offer$contactSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$phoneNumber,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$email,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Contacts)));
var $author$project$Common$Person$Dni = 0;
var $author$project$Common$Person$Nie = 1;
var $author$project$Common$Gql$Offer$decodeDocumentKind = function (status) {
	if (!status) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Common$Address$defaultAddress = A4($author$project$Common$Address$Address, '', '', '', '');
var $author$project$Gql$Platform$Enum$DocumentKind$Dni = 0;
var $author$project$Gql$Platform$Enum$DocumentKind$Nie = 1;
var $author$project$Gql$Platform$Enum$DocumentKind$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'DNI':
				return $elm$json$Json$Decode$succeed(0);
			case 'NIE':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid DocumentKind type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$documentKind = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.DocumentKind.DocumentKind', 'documentKind', _List_Nil, $author$project$Gql$Platform$Enum$DocumentKind$decoder);
var $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$birthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.NaiveDate',
	'birthDate',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).cG.A);
var $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$firstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'firstName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$lastName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Offer$fullPolicyHolderPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$birthDate,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$documentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$lastName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$firstName,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Offer$fullPolicyHolderSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeDocumentKind, $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$documentKind),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Common$Gql$Offer$contactSelectionSet,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
				$author$project$Common$Address$defaultAddress,
				$author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$address($author$project$Common$Gql$Offer$addressSelectionSet)),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$Offer$fullPolicyHolderPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PolicyHolder)))));
var $author$project$Gql$Platform$Object$BackofficeFullCustomerData$policyholder = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'policyholder', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodeFullPolicyHolder = $author$project$Gql$Platform$Object$BackofficeFullCustomerData$policyholder($author$project$Common$Gql$Offer$fullPolicyHolderSelectionSet);
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'TINTED_WINDOWS';
		case 1:
			return 'XENON_HEADLIGHTS';
		case 2:
			return 'TOW_BALL';
		case 3:
			return 'RIMS';
		case 4:
			return 'SKIRTS';
		case 5:
			return 'SPOILERS';
		case 6:
			return 'EXHAUST_PIPE';
		case 7:
			return 'ENGINE';
		default:
			return 'OTHER';
	}
};
var $author$project$Common$Gql$Vehicle$decodeAccessory = function (accessory) {
	return $author$project$Gql$Platform$Enum$BackofficeVehicleModification$toString(accessory);
};
var $author$project$Common$Gql$Vehicle$decodeAccessories = function (accessories) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (accs) {
				return A2($elm$core$List$map, $author$project$Common$Gql$Vehicle$decodeAccessory, accs);
			},
			accessories));
};
var $author$project$Gql$Platform$Enum$BackofficeFuelType$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'DIESEL';
		case 1:
			return 'GASOLINE';
		case 2:
			return 'ELECTRIC';
		case 3:
			return 'LIQUID_GAS';
		case 4:
			return 'HYDROGEN';
		case 5:
			return 'HYBRID_ELECTRIC_GASOLINE';
		case 6:
			return 'HYBRID_ELECTRIC_DIESEL';
		case 7:
			return 'HYBRID_PLUGIN_ELECTRIC_GASOLINE';
		case 8:
			return 'HYBRID_PLUGIN_ELECTRIC_DIESEL';
		case 9:
			return 'BIO_ETHANOL';
		case 10:
			return 'ELECTRIC_WITH_GASOLINE_BATTERY';
		case 11:
			return 'ELECTRIC_WITH_HYDROGEN_FUEL_CELL';
		default:
			return 'MILD_HYBRID_ELECTRIC_GASOLINE';
	}
};
var $author$project$Common$Gql$Vehicle$decodeFuelType = function (fuelType) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Gql$Platform$Enum$BackofficeFuelType$toString, fuelType));
};
var $author$project$Common$Gql$Vehicle$decodeMileage = function (mileage) {
	switch (mileage) {
		case 0:
			return 'Up to 2000';
		case 1:
			return '2000 - 4000';
		case 2:
			return '4000 - 6000';
		case 3:
			return '6000 - 8000';
		case 4:
			return '8000 - 10000';
		case 5:
			return '10000 - 12000';
		case 6:
			return '12000 - 14000';
		case 7:
			return '14000 - 16000';
		case 8:
			return '16000 - 18000';
		case 9:
			return '18000 - 20000';
		case 10:
			return '20000 - 22000';
		case 11:
			return '22000 - 24000';
		case 12:
			return '24000 - 26000';
		case 13:
			return '26000 - 28000';
		case 14:
			return '28000 - 30000';
		case 15:
			return '30000 - 32000';
		case 16:
			return '32000 - 34000';
		case 17:
			return '34000 - 36000';
		case 18:
			return '36000 - 38000';
		case 19:
			return '38000 - 40000';
		case 20:
			return '40000 - 45000';
		case 21:
			return '45000 - 50000';
		case 22:
			return 'More than 50000';
		case 23:
			return 'Missing Data';
		case 24:
			return 'Up to 6000';
		case 25:
			return '6000 - 10000';
		case 26:
			return '10000 - 14000';
		case 27:
			return '14000 - 20000';
		case 28:
			return '20000 - 30000';
		default:
			return '30000 - 50000';
	}
};
var $author$project$Gql$Platform$Enum$BackofficeVehicleUse$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'OCCASIONAL';
		case 1:
			return 'HABITUAL';
		case 2:
			return 'PROFESSIONAL_OCCASIONAL';
		case 3:
			return 'PROFESSIONAL_HABITUAL';
		default:
			return 'MISSING_DATA';
	}
};
var $author$project$Common$Gql$Vehicle$decodeUsage = function (usage) {
	return $author$project$Gql$Platform$Enum$BackofficeVehicleUse$toString(usage);
};
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$enginePower = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Int)',
	'enginePower',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$Gql$Platform$Enum$BackofficeMileage$From10To12 = 5;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From10To14 = 26;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From12To14 = 6;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From14To16 = 7;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From14To20 = 27;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From16To18 = 8;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From18To20 = 9;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From20To22 = 10;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From20To30 = 28;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From22To24 = 11;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From24To26 = 12;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From26To28 = 13;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From28To30 = 14;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From2To4 = 1;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From30To32 = 15;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From30To50 = 29;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From32To34 = 16;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From34To36 = 17;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From36To38 = 18;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From38To40 = 19;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From40To45 = 20;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From45To50 = 21;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From4To6 = 2;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From6To10 = 25;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From6To8 = 3;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From8To10 = 4;
var $author$project$Gql$Platform$Enum$BackofficeMileage$MissingData = 23;
var $author$project$Gql$Platform$Enum$BackofficeMileage$MoreThan50 = 22;
var $author$project$Gql$Platform$Enum$BackofficeMileage$UpTo2 = 0;
var $author$project$Gql$Platform$Enum$BackofficeMileage$UpTo6 = 24;
var $author$project$Gql$Platform$Enum$BackofficeMileage$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'UP_TO_2':
				return $elm$json$Json$Decode$succeed(0);
			case 'FROM_2_TO_4':
				return $elm$json$Json$Decode$succeed(1);
			case 'FROM_4_TO_6':
				return $elm$json$Json$Decode$succeed(2);
			case 'FROM_6_TO_8':
				return $elm$json$Json$Decode$succeed(3);
			case 'FROM_8_TO_10':
				return $elm$json$Json$Decode$succeed(4);
			case 'FROM_10_TO_12':
				return $elm$json$Json$Decode$succeed(5);
			case 'FROM_12_TO_14':
				return $elm$json$Json$Decode$succeed(6);
			case 'FROM_14_TO_16':
				return $elm$json$Json$Decode$succeed(7);
			case 'FROM_16_TO_18':
				return $elm$json$Json$Decode$succeed(8);
			case 'FROM_18_TO_20':
				return $elm$json$Json$Decode$succeed(9);
			case 'FROM_20_TO_22':
				return $elm$json$Json$Decode$succeed(10);
			case 'FROM_22_TO_24':
				return $elm$json$Json$Decode$succeed(11);
			case 'FROM_24_TO_26':
				return $elm$json$Json$Decode$succeed(12);
			case 'FROM_26_TO_28':
				return $elm$json$Json$Decode$succeed(13);
			case 'FROM_28_TO_30':
				return $elm$json$Json$Decode$succeed(14);
			case 'FROM_30_TO_32':
				return $elm$json$Json$Decode$succeed(15);
			case 'FROM_32_TO_34':
				return $elm$json$Json$Decode$succeed(16);
			case 'FROM_34_TO_36':
				return $elm$json$Json$Decode$succeed(17);
			case 'FROM_36_TO_38':
				return $elm$json$Json$Decode$succeed(18);
			case 'FROM_38_TO_40':
				return $elm$json$Json$Decode$succeed(19);
			case 'FROM_40_TO_45':
				return $elm$json$Json$Decode$succeed(20);
			case 'FROM_45_TO_50':
				return $elm$json$Json$Decode$succeed(21);
			case 'MORE_THAN_50':
				return $elm$json$Json$Decode$succeed(22);
			case 'MISSING_DATA':
				return $elm$json$Json$Decode$succeed(23);
			case 'UP_TO_6':
				return $elm$json$Json$Decode$succeed(24);
			case 'FROM_6_TO_10':
				return $elm$json$Json$Decode$succeed(25);
			case 'FROM_10_TO_14':
				return $elm$json$Json$Decode$succeed(26);
			case 'FROM_14_TO_20':
				return $elm$json$Json$Decode$succeed(27);
			case 'FROM_20_TO_30':
				return $elm$json$Json$Decode$succeed(28);
			case 'FROM_30_TO_50':
				return $elm$json$Json$Decode$succeed(29);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeMileage type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$expectedMileage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeMileage.BackofficeMileage', 'expectedMileage', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeMileage$decoder);
var $author$project$Gql$Platform$Enum$BackofficeFuelType$BioEthanol = 9;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$Diesel = 0;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$Electric = 2;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$ElectricWithGasolineBattery = 10;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$ElectricWithHydrogenFuelCell = 11;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$Gasoline = 1;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$HybridElectricDiesel = 6;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$HybridElectricGasoline = 5;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$HybridPluginElectricDiesel = 8;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$HybridPluginElectricGasoline = 7;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$Hydrogen = 4;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$LiquidGas = 3;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$MildHybridElectricGasoline = 12;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'DIESEL':
				return $elm$json$Json$Decode$succeed(0);
			case 'GASOLINE':
				return $elm$json$Json$Decode$succeed(1);
			case 'ELECTRIC':
				return $elm$json$Json$Decode$succeed(2);
			case 'LIQUID_GAS':
				return $elm$json$Json$Decode$succeed(3);
			case 'HYDROGEN':
				return $elm$json$Json$Decode$succeed(4);
			case 'HYBRID_ELECTRIC_GASOLINE':
				return $elm$json$Json$Decode$succeed(5);
			case 'HYBRID_ELECTRIC_DIESEL':
				return $elm$json$Json$Decode$succeed(6);
			case 'HYBRID_PLUGIN_ELECTRIC_GASOLINE':
				return $elm$json$Json$Decode$succeed(7);
			case 'HYBRID_PLUGIN_ELECTRIC_DIESEL':
				return $elm$json$Json$Decode$succeed(8);
			case 'BIO_ETHANOL':
				return $elm$json$Json$Decode$succeed(9);
			case 'ELECTRIC_WITH_GASOLINE_BATTERY':
				return $elm$json$Json$Decode$succeed(10);
			case 'ELECTRIC_WITH_HYDROGEN_FUEL_CELL':
				return $elm$json$Json$Decode$succeed(11);
			case 'MILD_HYBRID_ELECTRIC_GASOLINE':
				return $elm$json$Json$Decode$succeed(12);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeFuelType type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$fuelType = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.BackofficeFuelType.BackofficeFuelType)',
	'fuelType',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$Gql$Platform$Enum$BackofficeFuelType$decoder));
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$maker = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'maker', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$model = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'model', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$Engine = 7;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$ExhaustPipe = 6;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$Other = 8;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$Rims = 3;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$Skirts = 4;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$Spoilers = 5;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$TintedWindows = 0;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$TowBall = 2;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$XenonHeadlights = 1;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'TINTED_WINDOWS':
				return $elm$json$Json$Decode$succeed(0);
			case 'XENON_HEADLIGHTS':
				return $elm$json$Json$Decode$succeed(1);
			case 'TOW_BALL':
				return $elm$json$Json$Decode$succeed(2);
			case 'RIMS':
				return $elm$json$Json$Decode$succeed(3);
			case 'SKIRTS':
				return $elm$json$Json$Decode$succeed(4);
			case 'SPOILERS':
				return $elm$json$Json$Decode$succeed(5);
			case 'EXHAUST_PIPE':
				return $elm$json$Json$Decode$succeed(6);
			case 'ENGINE':
				return $elm$json$Json$Decode$succeed(7);
			case 'OTHER':
				return $elm$json$Json$Decode$succeed(8);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeVehicleModification type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$modifications = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe (List Enum.BackofficeVehicleModification.BackofficeVehicleModification))',
	'modifications',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$elm$json$Json$Decode$list($author$project$Gql$Platform$Enum$BackofficeVehicleModification$decoder)));
var $author$project$Common$Vehicle$Vehicle = $elm$core$Basics$identity;
var $author$project$Common$Vehicle$new = function (model) {
	return function (maker) {
		return function (plateNumber) {
			return function (mileage) {
				return function (registrationDate) {
					return function (usage) {
						return function (fuelType) {
							return function (version) {
								return function (enginePower) {
									return function (accessories) {
										return {fG: accessories, gw: enginePower, gG: fuelType, eV: maker, hl: mileage, eY: model, ia: plateNumber, ip: registrationDate, iW: usage, i4: version};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$plateNumber = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'plateNumber', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$registrationDate = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'registrationDate', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Enum$BackofficeVehicleUse$Habitual = 1;
var $author$project$Gql$Platform$Enum$BackofficeVehicleUse$MissingData = 4;
var $author$project$Gql$Platform$Enum$BackofficeVehicleUse$Occasional = 0;
var $author$project$Gql$Platform$Enum$BackofficeVehicleUse$ProfessionalHabitual = 3;
var $author$project$Gql$Platform$Enum$BackofficeVehicleUse$ProfessionalOccasional = 2;
var $author$project$Gql$Platform$Enum$BackofficeVehicleUse$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'OCCASIONAL':
				return $elm$json$Json$Decode$succeed(0);
			case 'HABITUAL':
				return $elm$json$Json$Decode$succeed(1);
			case 'PROFESSIONAL_OCCASIONAL':
				return $elm$json$Json$Decode$succeed(2);
			case 'PROFESSIONAL_HABITUAL':
				return $elm$json$Json$Decode$succeed(3);
			case 'MISSING_DATA':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeVehicleUse type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$usage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeVehicleUse.BackofficeVehicleUse', 'usage', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeVehicleUse$decoder);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$version = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'version', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Vehicle$fullVehicleSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeAccessories, $author$project$Gql$Platform$Object$BackofficeFullVehicleData$modifications),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeFullVehicleData$enginePower,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeFullVehicleData$version,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeFuelType, $author$project$Gql$Platform$Object$BackofficeFullVehicleData$fuelType),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeUsage, $author$project$Gql$Platform$Object$BackofficeFullVehicleData$usage),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficeFullVehicleData$registrationDate,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeMileage, $author$project$Gql$Platform$Object$BackofficeFullVehicleData$expectedMileage),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Gql$Platform$Object$BackofficeFullVehicleData$plateNumber,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficeFullVehicleData$maker,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficeFullVehicleData$model,
										$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Vehicle$new)))))))))));
var $author$project$Gql$Platform$Object$BackofficeFullCustomerData$vehicle = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'vehicle', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodeFullVehicle = $author$project$Gql$Platform$Object$BackofficeFullCustomerData$vehicle($author$project$Common$Gql$Vehicle$fullVehicleSelectionSet);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$address = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'address',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$birthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.NaiveDate)',
	'birthDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).cG.A));
var $author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$firstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'firstName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$lastName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Offer$fullVehicleOwnerPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Common$Locale$defaultDate, $author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$birthDate),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$documentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$lastName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$firstName,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Offer$fullVehicleOwnerSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	$elm$core$Maybe$Nothing,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
		'',
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
				$author$project$Common$Address$defaultAddress,
				$author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$address($author$project$Common$Gql$Offer$addressSelectionSet)),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$Offer$fullVehicleOwnerPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Driver)))));
var $author$project$Gql$Platform$Object$BackofficeFullCustomerData$vehicleOwner = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'vehicleOwner', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodeFullVehicleOwner = $author$project$Gql$Platform$Object$BackofficeFullCustomerData$vehicleOwner($author$project$Common$Gql$Offer$fullVehicleOwnerSelectionSet);
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$offerId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'offerId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).t.A);
var $author$project$Common$Gql$Offer$decodeId = $author$project$Gql$Platform$Object$BackofficeOfferDetails$offerId;
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$isARenewal = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isARenewal', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$Gql$Offer$decodeIsARenewal = $author$project$Gql$Platform$Object$BackofficeOfferDetails$isARenewal;
var $author$project$Common$QuoteId$QuoteId = $elm$core$Basics$identity;
var $author$project$Common$QuoteId$new = $elm$core$Basics$identity;
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$quoteId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'quoteId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).t.A);
var $author$project$Common$Gql$Offer$decodeQuoteId = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$QuoteId$new, $author$project$Gql$Platform$Object$BackofficeOfferDetails$quoteId);
var $author$project$Common$Gql$BundleSlug$decodeBackofficeBundleSlug = function (bundleSlug) {
	switch (bundleSlug) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 2;
		default:
			return 2;
	}
};
var $author$project$Gql$Platform$Enum$BackofficeBundleSlug$TercerosAmpliado = 1;
var $author$project$Gql$Platform$Enum$BackofficeBundleSlug$TercerosBasico = 0;
var $author$project$Gql$Platform$Enum$BackofficeBundleSlug$TodoRiesgoConFranquicia = 2;
var $author$project$Gql$Platform$Enum$BackofficeBundleSlug$TodoRiesgoConFranquicia300 = 3;
var $author$project$Gql$Platform$Enum$BackofficeBundleSlug$TodoRiesgoConFranquicia500 = 4;
var $author$project$Gql$Platform$Enum$BackofficeBundleSlug$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'TERCEROS_BASICO':
				return $elm$json$Json$Decode$succeed(0);
			case 'TERCEROS_AMPLIADO':
				return $elm$json$Json$Decode$succeed(1);
			case 'TODO_RIESGO_CON_FRANQUICIA':
				return $elm$json$Json$Decode$succeed(2);
			case 'TODO_RIESGO_CON_FRANQUICIA_300':
				return $elm$json$Json$Decode$succeed(3);
			case 'TODO_RIESGO_CON_FRANQUICIA_500':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeBundleSlug type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$selectedBundle = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeBundleSlug.BackofficeBundleSlug', 'selectedBundle', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeBundleSlug$decoder);
var $author$project$Common$Gql$Offer$decodeSelectedBundle = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$BundleSlug$decodeBackofficeBundleSlug, $author$project$Gql$Platform$Object$BackofficeOfferDetails$selectedBundle);
var $author$project$Common$Product$OfferProduct = F3(
	function (issuingCompany, bundleSlug, annualPrice) {
		return {jd: annualPrice, mt: bundleSlug, a3: issuingCompany};
	});
var $author$project$Gql$Platform$Object$BackofficeOfferProduct$annualPrice = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'annualPrice', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeOfferProduct$bundleSlug = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeBundleSlug.BackofficeBundleSlug', 'bundleSlug', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeBundleSlug$decoder);
var $author$project$Gql$Platform$Object$BackofficeOfferProduct$issuingCompany = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'issuingCompany', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Product$AnnualPrice = F5(
	function (gross, taxes, net, taxIps, taxSurcharges) {
		return {j8: gross, nS: net, ps: taxIps, pt: taxSurcharges, iN: taxes};
	});
var $author$project$Gql$Platform$Object$BackofficeAnnualPrice$gross = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'gross',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mz.A);
var $author$project$Gql$Platform$Object$BackofficeAnnualPrice$net = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'net',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mz.A);
var $author$project$Gql$Platform$Object$BackofficeAnnualPrice$taxIps = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'taxIps',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mz.A);
var $author$project$Gql$Platform$Object$BackofficeAnnualPrice$taxSurcharges = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'taxSurcharges',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mz.A);
var $author$project$Gql$Platform$Object$BackofficeAnnualPrice$taxes = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'taxes',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mz.A);
var $author$project$Common$Gql$OfferProduct$offerAnnualPriceV2Set = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$BackofficeAnnualPrice$taxSurcharges),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$BackofficeAnnualPrice$taxIps),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$BackofficeAnnualPrice$net),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$BackofficeAnnualPrice$taxes),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$BackofficeAnnualPrice$gross),
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Product$AnnualPrice))))));
var $author$project$Common$Gql$OfferProduct$offerProductV2SelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeOfferProduct$annualPrice($author$project$Common$Gql$OfferProduct$offerAnnualPriceV2Set),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$BundleSlug$decodeBackofficeBundleSlug, $author$project$Gql$Platform$Object$BackofficeOfferProduct$bundleSlug),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeOfferProduct$issuingCompany,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Product$OfferProduct))));
var $author$project$Common$Gql$Offer$offerProductSelectionSet = $author$project$Common$Gql$OfferProduct$offerProductV2SelectionSet;
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$selectedProducts = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'selectedProducts',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Common$Gql$Offer$decodeSelectedProducts = $author$project$Gql$Platform$Object$BackofficeOfferDetails$selectedProducts($author$project$Common$Gql$Offer$offerProductSelectionSet);
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$startAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.DateTime',
	'startAt',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).N.A);
var $author$project$Common$Gql$Offer$decodeStartDate = $author$project$Gql$Platform$Object$BackofficeOfferDetails$startAt;
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isGreatLakesRenewal', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$Offer$Offer = $elm$core$Basics$identity;
var $author$project$Common$Offer$new = function (id) {
	return function (customerFacingId) {
		return function (applicationId) {
			return function (quoteId) {
				return function (creationDate) {
					return function (startDate) {
						return function (status) {
							return function (quoteIdForClaimsHistoryQuery) {
								return function (mainDriver) {
									return function (policyHolder) {
										return function (additionalDriver) {
											return function (vehicleOwner) {
												return function (vehicle) {
													return function (claimsDeclaredWithFault) {
														return function (availableActions) {
															return function (products) {
																return function (offerType) {
																	return function (coverContinuity) {
																		return function (selectedBundle) {
																			return function (isRenewal) {
																				return function (source) {
																					return function (comebackLink) {
																						return function (requiresGreatLakesOptIn) {
																							return function (isGreatLakesRenewal) {
																								return {jb: additionalDriver, fO: applicationId, aS: availableActions, f5: claimsDeclaredWithFault, ga: comebackLink, jG: coverContinuity, gd: creationDate, mI: customerFacingId, kg: id, g0: isGreatLakesRenewal, eN: isRenewal, eU: mainDriver, e$: offerType, ib: policyHolder, dr: products, o_: quoteId, il: quoteIdForClaimsHistoryQuery, it: requiresGreatLakesOptIn, iw: selectedBundle, iA: source, lL: startDate, dx: status, i$: vehicle, l$: vehicleOwner};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'offerDetails', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'requiresGreatLakesOptInConsent', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$Gql$Offer$backofficeBlockedOfferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeComebackLink),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationSource),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeIsARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedBundle),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Gql$Platform$Object$BackofficeBlockedOffer$continuitySummary($author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
								3,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedProducts),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficeBlockedOffer$availableActions($author$project$Common$Gql$Offer$decodeAvailableActions),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Gql$Platform$Object$BackofficeBlockedOffer$customerData($author$project$Common$Gql$Offer$decodeFullClaimsDeclaredWithFault),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Gql$Platform$Object$BackofficeBlockedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicle),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Gql$Platform$Object$BackofficeBlockedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicleOwner),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Gql$Platform$Object$BackofficeBlockedOffer$customerData($author$project$Common$Gql$Offer$decodeFullAdditionalDriver),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Gql$Platform$Object$BackofficeBlockedOffer$customerData($author$project$Common$Gql$Offer$decodeFullPolicyHolder),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																$author$project$Gql$Platform$Object$BackofficeBlockedOffer$customerData($author$project$Common$Gql$Offer$decodeFullMainDriver),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																		$elm$core$Maybe$Just,
																		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$QuoteId$new, $author$project$Gql$Platform$Object$BackofficeBlockedOffer$blockedQuoteId)),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeBlockedOfferStatus, $author$project$Gql$Platform$Object$BackofficeBlockedOffer$blockedStatus),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeStartDate),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCreationDate),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeQuoteId),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationId),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCustomerFacingId),
																							A2(
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																								$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeId),
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$new)))))))))))))))))))))))));
var $author$project$Common$Offer$CompletedProvisionalType = 1;
var $author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Gql$Platform$Enum$BackofficeCompletedProvisionalOfferStatus$Available = 0;
var $author$project$Gql$Platform$Enum$BackofficeCompletedProvisionalOfferStatus$Expired = 1;
var $author$project$Gql$Platform$Enum$BackofficeCompletedProvisionalOfferStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'AVAILABLE':
				return $elm$json$Json$Decode$succeed(0);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeCompletedProvisionalOfferStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$completedProvisionalStatus = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeCompletedProvisionalOfferStatus.BackofficeCompletedProvisionalOfferStatus', 'completedProvisionalStatus', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeCompletedProvisionalOfferStatus$decoder);
var $author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$continuitySummary = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'continuitySummary', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$customerData = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'customerData', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Offer$Available = 8;
var $author$project$Common$Offer$Expired = 4;
var $author$project$Common$Gql$Offer$decodeCompletedProvisionalOfferStatus = function (status) {
	if (!status) {
		return 8;
	} else {
		return 4;
	}
};
var $author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'offerDetails', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$backofficeCompletedProvisionalOfferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeComebackLink),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationSource),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeIsARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedBundle),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$continuitySummary($author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
								1,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedProducts),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$availableActions($author$project$Common$Gql$Offer$decodeAvailableActions),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$customerData($author$project$Common$Gql$Offer$decodeFullClaimsDeclaredWithFault),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicle),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicleOwner),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$customerData($author$project$Common$Gql$Offer$decodeFullAdditionalDriver),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$customerData($author$project$Common$Gql$Offer$decodeFullPolicyHolder),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$customerData($author$project$Common$Gql$Offer$decodeFullMainDriver),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
																	$elm$core$Maybe$Nothing,
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeCompletedProvisionalOfferStatus, $author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$completedProvisionalStatus),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeStartDate),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeCreationDate),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeQuoteId),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationId),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeCustomerFacingId),
																							A2(
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																								$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeId),
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$new)))))))))))))))))))))))));
var $author$project$Common$Offer$FinalizedType = 5;
var $author$project$Gql$Platform$Object$BackofficeFinalizedOffer$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Gql$Platform$Object$BackofficeFinalizedOffer$continuitySummary = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'continuitySummary', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeFinalizedOffer$customerData = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'customerData', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Offer$MissingDocuments = 2;
var $author$project$Common$Offer$NewPrice = 0;
var $author$project$Common$Offer$NewProduct = 1;
var $author$project$Common$Offer$StartDateExpired = 3;
var $author$project$Common$Gql$Offer$decodeFinalizedOfferStatus = function (status) {
	switch (status) {
		case 2:
			return 8;
		case 5:
			return 4;
		case 4:
			return 2;
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 3;
	}
};
var $author$project$Gql$Platform$Enum$BackofficeFinalizedOfferStatus$Available = 2;
var $author$project$Gql$Platform$Enum$BackofficeFinalizedOfferStatus$Expired = 5;
var $author$project$Gql$Platform$Enum$BackofficeFinalizedOfferStatus$MissingDocuments = 4;
var $author$project$Gql$Platform$Enum$BackofficeFinalizedOfferStatus$NewPrice = 0;
var $author$project$Gql$Platform$Enum$BackofficeFinalizedOfferStatus$NewProduct = 1;
var $author$project$Gql$Platform$Enum$BackofficeFinalizedOfferStatus$StartDateExpired = 3;
var $author$project$Gql$Platform$Enum$BackofficeFinalizedOfferStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'NEW_PRICE':
				return $elm$json$Json$Decode$succeed(0);
			case 'NEW_PRODUCT':
				return $elm$json$Json$Decode$succeed(1);
			case 'AVAILABLE':
				return $elm$json$Json$Decode$succeed(2);
			case 'START_DATE_EXPIRED':
				return $elm$json$Json$Decode$succeed(3);
			case 'MISSING_DOCUMENTS':
				return $elm$json$Json$Decode$succeed(4);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(5);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeFinalizedOfferStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFinalizedOffer$finalizedStatus = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeFinalizedOfferStatus.BackofficeFinalizedOfferStatus', 'finalizedStatus', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeFinalizedOfferStatus$decoder);
var $author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'offerDetails', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeFinalizedOffer$quoteIdForClaimsHistory = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'quoteIdForClaimsHistory',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).t.A);
var $author$project$Common$Gql$Offer$backofficeFinalizedOfferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeComebackLink),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationSource),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeIsARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedBundle),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$continuitySummary($author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
								5,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedProducts),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$availableActions($author$project$Common$Gql$Offer$decodeAvailableActions),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$customerData($author$project$Common$Gql$Offer$decodeFullClaimsDeclaredWithFault),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicle),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicleOwner),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$customerData($author$project$Common$Gql$Offer$decodeFullAdditionalDriver),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$customerData($author$project$Common$Gql$Offer$decodeFullPolicyHolder),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$customerData($author$project$Common$Gql$Offer$decodeFullMainDriver),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																		$elm$core$Maybe$Just,
																		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$QuoteId$new, $author$project$Gql$Platform$Object$BackofficeFinalizedOffer$quoteIdForClaimsHistory)),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeFinalizedOfferStatus, $author$project$Gql$Platform$Object$BackofficeFinalizedOffer$finalizedStatus),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeStartDate),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCreationDate),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeQuoteId),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationId),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCustomerFacingId),
																							A2(
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																								$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeId),
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$new)))))))))))))))))))))))));
var $author$project$Common$Offer$ProvisionalType = 0;
var $author$project$Gql$Platform$Object$BackofficeProvisionalOffer$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Gql$Platform$Object$BackofficeProvisionalOffer$continuitySummary = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'continuitySummary', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficePartialCustomerData$occasionalDriver = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'occasionalDriver', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficePartialOccasionalDriverData$drivingLicenseYears = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.AdditionalDriverDrivingLicenseYears.AdditionalDriverDrivingLicenseYears)',
	'drivingLicenseYears',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$Gql$Platform$Enum$AdditionalDriverDrivingLicenseYears$decoder));
var $author$project$Gql$Platform$Object$BackofficePartialOccasionalDriverData$birthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.NaiveDate)',
	'birthDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).cG.A));
var $author$project$Common$Gql$Offer$partialAdditionalDriverPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Common$Locale$defaultDate, $author$project$Gql$Platform$Object$BackofficePartialOccasionalDriverData$birthDate),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
		'',
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
			'',
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
				'',
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Offer$partialOccasionalDriverSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$AdditionalDriverDrivingLicenseYears$maybeDecodeAdditionalDriverDrivingLicenseYears, $author$project$Gql$Platform$Object$BackofficePartialOccasionalDriverData$drivingLicenseYears),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Common$Gql$Offer$partialAdditionalDriverPersonDataSelectionSet,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$AdditionalDriver)));
var $author$project$Common$Gql$Offer$decodePartialAdditionalDriver = $author$project$Gql$Platform$Object$BackofficePartialCustomerData$occasionalDriver($author$project$Common$Gql$Offer$partialOccasionalDriverSelectionSet);
var $author$project$Gql$Platform$Object$BackofficePartialCustomerData$claimsDeclaredWithFault = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'claimsDeclaredWithFault',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Common$Gql$Offer$decodePartialClaimsDeclaredWithFault = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
	$author$project$Common$Count$default,
	$author$project$Gql$Platform$Object$BackofficePartialCustomerData$claimsDeclaredWithFault($author$project$Common$Gql$ClaimsCount$claimsDeclaredWithFaultSelectionSet));
var $author$project$Gql$Platform$Object$BackofficePartialCustomerData$mainDriver = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'mainDriver', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficePartialMainDriverData$address = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'address', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficePartialMainDriverData$drivingLicenseDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'drivingLicenseDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Gql$Platform$Object$BackofficePartialMainDriverData$isLicenseMoreThanTwoYearsOld = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Bool)',
	'isLicenseMoreThanTwoYearsOld',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool));
var $author$project$Common$Gql$Offer$decodeMaybePartialMainDriverDrivingLicenseData = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficePartialMainDriverData$isLicenseMoreThanTwoYearsOld,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficePartialMainDriverData$drivingLicenseDate,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$newMainDriverDrivingLicenseData)));
var $author$project$Gql$Platform$Object$BackofficePartialMainDriverData$birthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.NaiveDate',
	'birthDate',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).cG.A);
var $author$project$Common$Gql$Offer$partialMainDriverPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficePartialMainDriverData$birthDate,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
		'',
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
			'',
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
				'',
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Gql$Platform$Object$BackofficePartialMainDriverData$recentInsuranceCompanyName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'recentInsuranceCompanyName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$Offer$partialMainDriverSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Common$Gql$Offer$decodeMaybePartialMainDriverDrivingLicenseData,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficePartialMainDriverData$recentInsuranceCompanyName),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficePartialMainDriverData$address($author$project$Common$Gql$Offer$addressSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$Offer$partialMainDriverPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Driver)))));
var $author$project$Common$Gql$Offer$decodePartialMainDriver = $author$project$Gql$Platform$Object$BackofficePartialCustomerData$mainDriver($author$project$Common$Gql$Offer$partialMainDriverSelectionSet);
var $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$address = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'address',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$documentKind = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.DocumentKind.DocumentKind', 'documentKind', _List_Nil, $author$project$Gql$Platform$Enum$DocumentKind$decoder);
var $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$email = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'email',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$Offer$partialPolicyHolderContactDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	'',
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$email),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Contacts)));
var $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$birthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.NaiveDate)',
	'birthDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).cG.A));
var $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$firstName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'firstName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$lastName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'lastName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$Offer$partialPolicyHolderPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Common$Locale$defaultDate, $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$birthDate),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$documentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$lastName),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$firstName),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Offer$partialPolicyHolderSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeDocumentKind, $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$documentKind),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Common$Gql$Offer$partialPolicyHolderContactDataSelectionSet,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
				$author$project$Common$Address$defaultAddress,
				$author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$address($author$project$Common$Gql$Offer$addressSelectionSet)),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$Offer$partialPolicyHolderPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PolicyHolder)))));
var $author$project$Gql$Platform$Object$BackofficePartialCustomerData$policyholder = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'policyholder', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodePartialPolicyHolder = $author$project$Gql$Platform$Object$BackofficePartialCustomerData$policyholder($author$project$Common$Gql$Offer$partialPolicyHolderSelectionSet);
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$enginePower = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Int)',
	'enginePower',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$expectedMileage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeMileage.BackofficeMileage', 'expectedMileage', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeMileage$decoder);
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$fuelType = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.BackofficeFuelType.BackofficeFuelType)',
	'fuelType',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$Gql$Platform$Enum$BackofficeFuelType$decoder));
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$maker = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'maker', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$model = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'model', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$plateNumber = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'plateNumber',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$registrationDate = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'registrationDate', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$usage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeVehicleUse.BackofficeVehicleUse', 'usage', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeVehicleUse$decoder);
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$version = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'version', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Vehicle$partialVehicleOwnerSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	_List_Nil,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficePartialVehicleData$enginePower,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficePartialVehicleData$version,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeFuelType, $author$project$Gql$Platform$Object$BackofficePartialVehicleData$fuelType),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeUsage, $author$project$Gql$Platform$Object$BackofficePartialVehicleData$usage),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficePartialVehicleData$registrationDate,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeMileage, $author$project$Gql$Platform$Object$BackofficePartialVehicleData$expectedMileage),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficePartialVehicleData$plateNumber),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficePartialVehicleData$maker,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficePartialVehicleData$model,
										$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Vehicle$new)))))))))));
var $author$project$Gql$Platform$Object$BackofficePartialCustomerData$vehicle = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'vehicle', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodePartialVehicle = $author$project$Gql$Platform$Object$BackofficePartialCustomerData$vehicle($author$project$Common$Gql$Vehicle$partialVehicleOwnerSelectionSet);
var $author$project$Gql$Platform$Object$BackofficePartialVehicleOwnerData$address = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'address',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Gql$Platform$Object$BackofficePartialVehicleOwnerData$birthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.NaiveDate)',
	'birthDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).cG.A));
var $author$project$Common$Gql$Offer$partialVehicleOwnerPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Common$Locale$defaultDate, $author$project$Gql$Platform$Object$BackofficePartialVehicleOwnerData$birthDate),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
		'',
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
			'',
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
				'',
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Offer$partialVehicleOwnerSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	$elm$core$Maybe$Nothing,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
		'',
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
				$author$project$Common$Address$defaultAddress,
				$author$project$Gql$Platform$Object$BackofficePartialVehicleOwnerData$address($author$project$Common$Gql$Offer$addressSelectionSet)),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$Offer$partialVehicleOwnerPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Driver)))));
var $author$project$Gql$Platform$Object$BackofficePartialCustomerData$vehicleOwner = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'vehicleOwner', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodePartialVehicleOwner = $author$project$Gql$Platform$Object$BackofficePartialCustomerData$vehicleOwner($author$project$Common$Gql$Offer$partialVehicleOwnerSelectionSet);
var $author$project$Common$Gql$Offer$decodeProvisionalOfferStatus = function (status) {
	switch (status) {
		case 0:
			return 8;
		case 1:
			return 4;
		default:
			return 5;
	}
};
var $author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'offerDetails', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeProvisionalOffer$partialCustomerData = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'partialCustomerData', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Enum$BackofficeProvisionalOfferStatus$Available = 0;
var $author$project$Gql$Platform$Enum$BackofficeProvisionalOfferStatus$Blocked = 2;
var $author$project$Gql$Platform$Enum$BackofficeProvisionalOfferStatus$Expired = 1;
var $author$project$Gql$Platform$Enum$BackofficeProvisionalOfferStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'AVAILABLE':
				return $elm$json$Json$Decode$succeed(0);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(1);
			case 'BLOCKED':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeProvisionalOfferStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeProvisionalOffer$provisionalStatus = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeProvisionalOfferStatus.BackofficeProvisionalOfferStatus', 'provisionalStatus', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeProvisionalOfferStatus$decoder);
var $author$project$Common$Gql$Offer$backofficeProvisionalOfferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeComebackLink),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationSource),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeIsARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedBundle),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$continuitySummary($author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
								0,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedProducts),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$availableActions($author$project$Common$Gql$Offer$decodeAvailableActions),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$partialCustomerData($author$project$Common$Gql$Offer$decodePartialClaimsDeclaredWithFault),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$partialCustomerData($author$project$Common$Gql$Offer$decodePartialVehicle),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$partialCustomerData($author$project$Common$Gql$Offer$decodePartialVehicleOwner),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$partialCustomerData($author$project$Common$Gql$Offer$decodePartialAdditionalDriver),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$partialCustomerData($author$project$Common$Gql$Offer$decodePartialPolicyHolder),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$partialCustomerData($author$project$Common$Gql$Offer$decodePartialMainDriver),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
																	$elm$core$Maybe$Nothing,
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeProvisionalOfferStatus, $author$project$Gql$Platform$Object$BackofficeProvisionalOffer$provisionalStatus),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeStartDate),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeCreationDate),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeQuoteId),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationId),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeCustomerFacingId),
																							A2(
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																								$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeId),
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$new)))))))))))))))))))))))));
var $author$project$Common$Offer$PurchasedType = 6;
var $author$project$Gql$Platform$Object$BackofficePurchasedOffer$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Gql$Platform$Object$BackofficePurchasedOffer$continuitySummary = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'continuitySummary', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficePurchasedOffer$customerData = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'customerData', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Offer$Purchased = 7;
var $author$project$Common$Gql$Offer$decodePurchasedOfferStatus = function (_v0) {
	return 7;
};
var $author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'offerDetails', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Enum$BackofficePurchasedOfferStatus$Purchased = 0;
var $author$project$Gql$Platform$Enum$BackofficePurchasedOfferStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		if (string === 'PURCHASED') {
			return $elm$json$Json$Decode$succeed(0);
		} else {
			return $elm$json$Json$Decode$fail('Invalid BackofficePurchasedOfferStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficePurchasedOffer$purchasedStatus = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficePurchasedOfferStatus.BackofficePurchasedOfferStatus', 'purchasedStatus', _List_Nil, $author$project$Gql$Platform$Enum$BackofficePurchasedOfferStatus$decoder);
var $author$project$Gql$Platform$Object$BackofficePurchasedOffer$quoteIdForClaimsHistoryPurchased = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.Uuid)',
	'quoteIdForClaimsHistoryPurchased',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).t.A));
var $author$project$Common$Gql$Offer$backofficePurchasedOfferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeComebackLink),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationSource),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeIsARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedBundle),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Gql$Platform$Object$BackofficePurchasedOffer$continuitySummary($author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
								6,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedProducts),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficePurchasedOffer$availableActions($author$project$Common$Gql$Offer$decodeAvailableActions),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Gql$Platform$Object$BackofficePurchasedOffer$customerData($author$project$Common$Gql$Offer$decodeFullClaimsDeclaredWithFault),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Gql$Platform$Object$BackofficePurchasedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicle),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Gql$Platform$Object$BackofficePurchasedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicleOwner),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Gql$Platform$Object$BackofficePurchasedOffer$customerData($author$project$Common$Gql$Offer$decodeFullAdditionalDriver),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Gql$Platform$Object$BackofficePurchasedOffer$customerData($author$project$Common$Gql$Offer$decodeFullPolicyHolder),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																$author$project$Gql$Platform$Object$BackofficePurchasedOffer$customerData($author$project$Common$Gql$Offer$decodeFullMainDriver),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																		$elm$core$Maybe$map($author$project$Common$QuoteId$new),
																		$author$project$Gql$Platform$Object$BackofficePurchasedOffer$quoteIdForClaimsHistoryPurchased),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodePurchasedOfferStatus, $author$project$Gql$Platform$Object$BackofficePurchasedOffer$purchasedStatus),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeStartDate),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCreationDate),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeQuoteId),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationId),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCustomerFacingId),
																							A2(
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																								$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeId),
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$new)))))))))))))))))))))))));
var $author$project$Common$Offer$RenewalType = 7;
var $author$project$Gql$Platform$Object$BackofficeRenewalOffer$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Gql$Platform$Object$BackofficeRenewalOffer$continuitySummary = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'continuitySummary', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeRenewalOffer$customerData = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'customerData', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodeRenewalOfferStatus = function (status) {
	switch (status) {
		case 2:
			return 8;
		case 0:
			return 4;
		default:
			return 3;
	}
};
var $author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'offerDetails', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeRenewalOffer$quoteIdForClaimsHistory = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'quoteIdForClaimsHistory',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).t.A);
var $author$project$Gql$Platform$Enum$BackofficeRenewalOfferStatus$Available = 2;
var $author$project$Gql$Platform$Enum$BackofficeRenewalOfferStatus$Expired = 0;
var $author$project$Gql$Platform$Enum$BackofficeRenewalOfferStatus$StartDateExpired = 1;
var $author$project$Gql$Platform$Enum$BackofficeRenewalOfferStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(0);
			case 'START_DATE_EXPIRED':
				return $elm$json$Json$Decode$succeed(1);
			case 'AVAILABLE':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeRenewalOfferStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeRenewalOffer$renewalStatus = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeRenewalOfferStatus.BackofficeRenewalOfferStatus', 'renewalStatus', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeRenewalOfferStatus$decoder);
var $author$project$Common$Gql$Offer$backofficeRenewalOfferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeComebackLink),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationSource),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeIsARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedBundle),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Gql$Platform$Object$BackofficeRenewalOffer$continuitySummary($author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
								7,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedProducts),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficeRenewalOffer$availableActions($author$project$Common$Gql$Offer$decodeAvailableActions),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Gql$Platform$Object$BackofficeRenewalOffer$customerData($author$project$Common$Gql$Offer$decodeFullClaimsDeclaredWithFault),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Gql$Platform$Object$BackofficeRenewalOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicle),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Gql$Platform$Object$BackofficeRenewalOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicleOwner),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Gql$Platform$Object$BackofficeRenewalOffer$customerData($author$project$Common$Gql$Offer$decodeFullAdditionalDriver),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Gql$Platform$Object$BackofficeRenewalOffer$customerData($author$project$Common$Gql$Offer$decodeFullPolicyHolder),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																$author$project$Gql$Platform$Object$BackofficeRenewalOffer$customerData($author$project$Common$Gql$Offer$decodeFullMainDriver),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																		$elm$core$Maybe$Just,
																		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$QuoteId$new, $author$project$Gql$Platform$Object$BackofficeRenewalOffer$quoteIdForClaimsHistory)),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeRenewalOfferStatus, $author$project$Gql$Platform$Object$BackofficeRenewalOffer$renewalStatus),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeStartDate),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeCreationDate),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeQuoteId),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationId),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeCustomerFacingId),
																							A2(
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																								$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeId),
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$new)))))))))))))))))))))))));
var $author$project$Common$Offer$RequoteValidationFailedType = 2;
var $author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$continuitySummary = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'continuitySummary', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$customerData = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'customerData', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodeRequoteValidationFailedOfferStatus = function (status) {
	if (status === 1) {
		return 4;
	} else {
		return 2;
	}
};
var $author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$failedQuoteId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'failedQuoteId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).t.A);
var $author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'offerDetails', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Enum$BackofficeRequoteValidationFailedOfferStatus$Expired = 1;
var $author$project$Gql$Platform$Enum$BackofficeRequoteValidationFailedOfferStatus$MissingDocuments = 0;
var $author$project$Gql$Platform$Enum$BackofficeRequoteValidationFailedOfferStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'MISSING_DOCUMENTS':
				return $elm$json$Json$Decode$succeed(0);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeRequoteValidationFailedOfferStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$requotedValidationFailedStatus = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeRequoteValidationFailedOfferStatus.BackofficeRequoteValidationFailedOfferStatus', 'requotedValidationFailedStatus', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeRequoteValidationFailedOfferStatus$decoder);
var $author$project$Common$Gql$Offer$backofficeRequoteValidationFailedOfferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeComebackLink),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationSource),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeIsARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedBundle),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$continuitySummary($author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
								2,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedProducts),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$availableActions($author$project$Common$Gql$Offer$decodeAvailableActions),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$customerData($author$project$Common$Gql$Offer$decodeFullClaimsDeclaredWithFault),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicle),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicleOwner),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$customerData($author$project$Common$Gql$Offer$decodeFullAdditionalDriver),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$customerData($author$project$Common$Gql$Offer$decodeFullPolicyHolder),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$customerData($author$project$Common$Gql$Offer$decodeFullMainDriver),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																		$elm$core$Maybe$Just,
																		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$QuoteId$new, $author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$failedQuoteId)),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeRequoteValidationFailedOfferStatus, $author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$requotedValidationFailedStatus),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeStartDate),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCreationDate),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeQuoteId),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationId),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCustomerFacingId),
																							A2(
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																								$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeId),
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$new)))))))))))))))))))))))));
var $author$project$Common$Offer$RequotedType = 4;
var $author$project$Gql$Platform$Object$BackofficeRequotedOffer$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Gql$Platform$Object$BackofficeRequotedOffer$continuitySummary = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'continuitySummary', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeRequotedOffer$customerData = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'customerData', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Offer$Requoted = 6;
var $author$project$Common$Gql$Offer$decodeRequotedOfferStatus = function (_v0) {
	return 6;
};
var $author$project$Gql$Platform$Object$BackofficeRequotedOffer$newQuoteId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.Uuid)',
	'newQuoteId',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).t.A));
var $author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'offerDetails', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Enum$BackofficeRequotedOfferStatus$Requoted = 0;
var $author$project$Gql$Platform$Enum$BackofficeRequotedOfferStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		if (string === 'REQUOTED') {
			return $elm$json$Json$Decode$succeed(0);
		} else {
			return $elm$json$Json$Decode$fail('Invalid BackofficeRequotedOfferStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeRequotedOffer$requotedStatus = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeRequotedOfferStatus.BackofficeRequotedOfferStatus', 'requotedStatus', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeRequotedOfferStatus$decoder);
var $author$project$Common$Gql$Offer$backofficeRequotedOfferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeComebackLink),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationSource),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeIsARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedBundle),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Gql$Platform$Object$BackofficeRequotedOffer$continuitySummary($author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
								4,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedProducts),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficeRequotedOffer$availableActions($author$project$Common$Gql$Offer$decodeAvailableActions),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Gql$Platform$Object$BackofficeRequotedOffer$customerData($author$project$Common$Gql$Offer$decodeFullClaimsDeclaredWithFault),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Gql$Platform$Object$BackofficeRequotedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicle),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Gql$Platform$Object$BackofficeRequotedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicleOwner),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Gql$Platform$Object$BackofficeRequotedOffer$customerData($author$project$Common$Gql$Offer$decodeFullAdditionalDriver),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Gql$Platform$Object$BackofficeRequotedOffer$customerData($author$project$Common$Gql$Offer$decodeFullPolicyHolder),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																$author$project$Gql$Platform$Object$BackofficeRequotedOffer$customerData($author$project$Common$Gql$Offer$decodeFullMainDriver),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																		$elm$core$Maybe$map($author$project$Common$QuoteId$new),
																		$author$project$Gql$Platform$Object$BackofficeRequotedOffer$newQuoteId),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeRequotedOfferStatus, $author$project$Gql$Platform$Object$BackofficeRequotedOffer$requotedStatus),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeStartDate),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCreationDate),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeQuoteId),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationId),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCustomerFacingId),
																							A2(
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																								$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeId),
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$new)))))))))))))))))))))))));
var $author$project$Gql$Platform$Union$BackofficeOfferStateMachine$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeProvisionalOffer', selections____.oc),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeCompletedProvisionalOffer', selections____.n9),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeRequoteValidationFailedOffer', selections____.og),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeBlockedOffer', selections____.n7),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeRequotedOffer', selections____.oh),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeFinalizedOffer', selections____.ob),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeRenewalOffer', selections____.of),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficePurchasedOffer', selections____.oe)
			]));
};
var $author$project$Common$Gql$Offer$offerSelectionSet = $author$project$Gql$Platform$Union$BackofficeOfferStateMachine$fragments(
	{n7: $author$project$Common$Gql$Offer$backofficeBlockedOfferSelectionSet, n9: $author$project$Common$Gql$Offer$backofficeCompletedProvisionalOfferSelectionSet, ob: $author$project$Common$Gql$Offer$backofficeFinalizedOfferSelectionSet, oc: $author$project$Common$Gql$Offer$backofficeProvisionalOfferSelectionSet, oe: $author$project$Common$Gql$Offer$backofficePurchasedOfferSelectionSet, of: $author$project$Common$Gql$Offer$backofficeRenewalOfferSelectionSet, og: $author$project$Common$Gql$Offer$backofficeRequoteValidationFailedOfferSelectionSet, oh: $author$project$Common$Gql$Offer$backofficeRequotedOfferSelectionSet});
var $author$project$Gql$Platform$Query$offerV2 = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'offerV2',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'identifier', requiredArgs____.bM, $author$project$Gql$Platform$InputObject$encodeOfferIdentifier)
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Gql$Platform$Query$PricingActionRequiredArguments = function (requiredFor) {
	return {lr: requiredFor};
};
var $author$project$Common$Gql$ClaimHistory$pricingActionByOfferIdRequiredArguments = function (offerId) {
	return $author$project$Gql$Platform$Query$PricingActionRequiredArguments(
		{
			F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				{
					mI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
					n$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(offerId)
				}),
			k: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
		});
};
var $elm_community$string_extra$String$Extra$changeCase = F2(
	function (mutator, word) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var head = _v0.a;
					var tail = _v0.b;
					return A2(
						$elm$core$String$cons,
						mutator(head),
						tail);
				},
				$elm$core$String$uncons(word)));
	});
var $elm$core$Char$toUpper = _Char_toUpper;
var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
	return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
};
var $author$project$Gql$Platform$Enum$PricingAction$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'NONE';
		case 1:
			return 'ASK_FOR_SEVERITY_CERTIFICATE_POST_SALE';
		default:
			return 'REQUEST_CORRECT_5_DIGITS';
	}
};
var $author$project$Common$Gql$ClaimHistory$decodePricingAction = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$Basics$composeL, $elm_community$string_extra$String$Extra$toSentenceCase, $elm$core$String$toLower),
	$author$project$Gql$Platform$Enum$PricingAction$toString);
var $author$project$Gql$Platform$Enum$PricingAction$AskForSeverityCertificatePostSale = 1;
var $author$project$Gql$Platform$Enum$PricingAction$None = 0;
var $author$project$Gql$Platform$Enum$PricingAction$RequestCorrect5Digits = 2;
var $author$project$Gql$Platform$Enum$PricingAction$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'NONE':
				return $elm$json$Json$Decode$succeed(0);
			case 'ASK_FOR_SEVERITY_CERTIFICATE_POST_SALE':
				return $elm$json$Json$Decode$succeed(1);
			case 'REQUEST_CORRECT_5_DIGITS':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid PricingAction type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$InputObject$encodeBackofficeEntityIdentifier = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'offer',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Gql$Platform$InputObject$encodeOfferIdentifier)),
				_Utils_Tuple2(
				'policy',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $author$project$Gql$Platform$InputObject$encodePolicyIdentifier))
			]));
};
var $author$project$Gql$Platform$Query$pricingAction = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'(Maybe Enum.PricingAction.PricingAction)',
		'pricingAction',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'requiredFor', requiredArgs____.lr, $author$project$Gql$Platform$InputObject$encodeBackofficeEntityIdentifier)
			]),
		$elm$json$Json$Decode$nullable($author$project$Gql$Platform$Enum$PricingAction$decoder));
};
var $author$project$Common$Gql$ClaimHistory$pricingActionQuery = function (queryArguments) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$Maybe$map($author$project$Common$Gql$ClaimHistory$decodePricingAction),
		$author$project$Gql$Platform$Query$pricingAction(queryArguments));
};
var $author$project$Common$Gql$ClaimHistory$pricingActionByOfferIdQuery = function (offerId) {
	return $author$project$Common$Gql$ClaimHistory$pricingActionQuery(
		$author$project$Common$Gql$ClaimHistory$pricingActionByOfferIdRequiredArguments(offerId));
};
var $author$project$Tracker$encodeNormalizedUserEvent = function (_v0) {
	var type_ = _v0.bk;
	var payload = _v0.la;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(type_)),
				_Utils_Tuple2('payload', payload)
			]));
};
var $author$project$Tracker$encodeUserSearchPayload = function (_v0) {
	var searchType = _v0.lx;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'searchType',
				$elm$json$Json$Encode$string(searchType))
			]));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Tracker$encodeUserSendEmailPayload = function (_v0) {
	var emails = _v0.gu;
	var entity = _v0.gx;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'entity',
				$elm$json$Json$Encode$string(
					function () {
						if (!entity) {
							return 'offer';
						} else {
							return 'policy';
						}
					}())),
				_Utils_Tuple2(
				'emails',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, emails))
			]));
};
var $author$project$Tracker$NormalizedUserEvent = $elm$core$Basics$identity;
var $author$project$Tracker$normalizedUserEvent = F2(
	function (type_, payload) {
		return {la: payload, bk: type_};
	});
var $author$project$Tracker$userSearchEventName = 'userSearch';
var $author$project$Tracker$normalizeUserEvent = function (userEvent) {
	if (!userEvent.$) {
		var data = userEvent.a;
		return A2(
			$author$project$Tracker$normalizedUserEvent,
			$author$project$Tracker$userSearchEventName,
			$author$project$Tracker$encodeUserSearchPayload(data));
	} else {
		var data = userEvent.a;
		return A2(
			$author$project$Tracker$normalizedUserEvent,
			'userSendEmail',
			$author$project$Tracker$encodeUserSendEmailPayload(data));
	}
};
var $author$project$Tracker$encodeUserEvent = A2($elm$core$Basics$composeR, $author$project$Tracker$normalizeUserEvent, $author$project$Tracker$encodeNormalizedUserEvent);
var $author$project$Tracker$trackUserEvent = _Platform_outgoingPort('trackUserEvent', $elm$core$Basics$identity);
var $author$project$Tracker$publishUserEvent = A2($elm$core$Basics$composeR, $author$project$Tracker$encodeUserEvent, $author$project$Tracker$trackUserEvent);
var $author$project$Gql$Platform$Mutation$saveCustomerGreatLakesOptIn = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'Bool',
		'saveCustomerGreatLakesOptIn',
		_List_fromArray(
			[
				A3(
				$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
				'offerId',
				requiredArgs____.n$,
				A2(
					$author$project$Gql$Platform$Scalar$unwrapEncoder,
					function ($) {
						return $.t;
					},
					$author$project$ScalarCodecs$codecs))
			]),
		$elm$json$Json$Decode$bool);
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$Success = {$: 0};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$Failure = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$MissingEmail = 5;
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$OfferBlocked = 3;
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$OfferExpired = 0;
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$OfferIsRenewal = 6;
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$OfferPurchased = 2;
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$OfferRequoted = 4;
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$OfferStartDateExpired = 1;
var $author$project$Common$Gql$Offer$decodeReason = function (reason) {
	switch (reason) {
		case 3:
			return 3;
		case 5:
			return 5;
		case 0:
			return 0;
		case 2:
			return 2;
		case 4:
			return 4;
		case 1:
			return 1;
		default:
			return 6;
	}
};
var $author$project$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$MissingEmail = 5;
var $author$project$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$OfferBlocked = 3;
var $author$project$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$OfferExpired = 0;
var $author$project$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$OfferIsRenewal = 6;
var $author$project$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$OfferPurchased = 2;
var $author$project$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$OfferRequoted = 4;
var $author$project$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$OfferStartDateExpired = 1;
var $author$project$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'OFFER_EXPIRED':
				return $elm$json$Json$Decode$succeed(0);
			case 'OFFER_START_DATE_EXPIRED':
				return $elm$json$Json$Decode$succeed(1);
			case 'OFFER_PURCHASED':
				return $elm$json$Json$Decode$succeed(2);
			case 'OFFER_BLOCKED':
				return $elm$json$Json$Decode$succeed(3);
			case 'OFFER_REQUOTED':
				return $elm$json$Json$Decode$succeed(4);
			case 'MISSING_EMAIL':
				return $elm$json$Json$Decode$succeed(5);
			case 'OFFER_IS_RENEWAL':
				return $elm$json$Json$Decode$succeed(6);
			default:
				return $elm$json$Json$Decode$fail('Invalid SendNewBusinessOfferEmailFailureReason type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$SendNewBusinessOfferEmailFailure$reason = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.SendNewBusinessOfferEmailFailureReason.SendNewBusinessOfferEmailFailureReason', 'reason', _List_Nil, $author$project$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$decoder);
var $author$project$Common$Gql$Offer$decodeSendNewBusinessOfferEmailError = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeReason, $author$project$Gql$Platform$Object$SendNewBusinessOfferEmailFailure$reason),
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$ComponentUI$Modal$SendOfferEmail$Failure));
var $author$project$Gql$Platform$Union$SendNewBusinessOfferEmailResponse$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SendNewBusinessOfferEmailSuccess', selections____.oE),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SendNewBusinessOfferEmailFailure', selections____.oD)
			]));
};
var $author$project$Common$Gql$Offer$sendNewBusinessEmailSelectionSet = $author$project$Gql$Platform$Union$SendNewBusinessOfferEmailResponse$fragments(
	{
		oD: $author$project$Common$Gql$Offer$decodeSendNewBusinessOfferEmailError,
		oE: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$ComponentUI$Modal$SendOfferEmail$Success)
	});
var $author$project$Gql$Platform$Mutation$sendNewBusinessOfferEmail = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'sendNewBusinessOfferEmail',
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
					'offerId',
					requiredArgs____.n$,
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$ScalarCodecs$codecs))
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Common$Gql$Offer$sendNewBusinessEmail = function (offerId) {
	return A2(
		$author$project$Gql$Platform$Mutation$sendNewBusinessOfferEmail,
		{n$: offerId},
		$author$project$Common$Gql$Offer$sendNewBusinessEmailSelectionSet);
};
var $author$project$Common$Gql$Offer$sendOfferEmailMutation = function (option) {
	var offerId = option;
	return $author$project$Common$Gql$Offer$sendNewBusinessEmail(offerId);
};
var $author$project$Common$QuoteId$toUuid = function (_v0) {
	var quoteId = _v0;
	return quoteId;
};
var $author$project$Tracker$UserSendEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Tracker$userSendEmailEvent = $author$project$Tracker$UserSendEmail;
var $author$project$Tracker$Offer = 0;
var $author$project$Tracker$UserSendEmailPayload = $elm$core$Basics$identity;
var $author$project$Tracker$userSendEmailPayloadForOffer = function (emails) {
	return {gu: emails, gx: 0};
};
var $author$project$Page$OfferDetails$Effect$runEffect = F3(
	function (env, model, effect) {
		switch (effect.$) {
			case 14:
				return $elm$core$Platform$Cmd$none;
			case 0:
				var id = effect.a;
				return A4(
					$author$project$Api$executeGraphqlOperation,
					env,
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					A2(
						$author$project$Gql$Platform$Query$offerV2,
						$author$project$Common$Gql$Offer$offerByCfidRequiredArguments(id),
						$author$project$Common$Gql$Offer$offerSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$OfferDetails$Msg$FetchedOffer));
			case 6:
				var cmd = effect.a;
				return cmd;
			case 1:
				var quoteId = effect.a;
				return A4(
					$author$project$Api$executeGraphqlOperation,
					env,
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					A2(
						$author$project$Gql$Platform$Query$claimsHistory,
						$author$project$Common$Gql$ClaimHistory$claimHistoryByQuoteIdRequiredArguments(
							$author$project$Common$QuoteId$toUuid(quoteId)),
						$author$project$Common$Gql$ClaimHistory$claimHistorySelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$OfferDetails$Msg$FetchedClaimHistory));
			case 4:
				var offerId = effect.a;
				return A4(
					$author$project$Api$executeGraphqlOperation,
					env,
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$ClaimHistory$pricingActionByOfferIdQuery(offerId),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$OfferDetails$Msg$FetchedClaimHistoryPricingAction));
			case 2:
				var offerId = effect.a;
				return A4(
					$author$project$Api$executeGraphqlOperation,
					env,
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$CustomerId$getCustomerId(
						$author$project$Common$Gql$CustomerId$OfferId(offerId)),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$OfferDetails$Msg$FetchedCustomerId));
			case 5:
				var offerId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'fetchCoverSelection',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$CoverSelection$getCoverSelection(
						$author$project$Common$Gql$CoverSelection$OfferId(offerId)),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$OfferDetails$Msg$FetchedCoverSelection));
			case 8:
				var id = effect.a;
				var coverageEffectiveDate = effect.b;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'amendOfferCoverageEffectiveDate',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$amendOfferCoverageEffectiveDate,
						A2($author$project$Common$Gql$Offer$amendOfferCoverageEffectiveDateArguments, id, coverageEffectiveDate),
						$author$project$Common$Gql$Offer$amendOfferCoverageEffectiveDateSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$OfferDetails$Msg$OfferCoverageEffectiveDateAmended));
			case 7:
				return $elm$core$Platform$Cmd$none;
			case 9:
				return A2(
					$elm$core$Task$perform,
					$author$project$Page$OfferDetails$Msg$GotCurrentDate,
					A2(
						$elm$core$Task$map,
						$justinmimbs$date$Date$fromPosix($elm$time$Time$utc),
						$elm$time$Time$now));
			case 13:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						A2($author$project$Page$OfferDetails$Effect$runEffect, env, model),
						effects));
			case 3:
				var offerId = effect.a;
				return A4(
					$author$project$Api$executeGraphqlOperation,
					env,
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$PaymentMethod$getPaymentMethod(
						$author$project$Common$Gql$PaymentMethod$OfferId(offerId)),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$OfferDetails$Msg$FetchedPaymentMethod));
			case 10:
				var option = effect.a;
				return A4(
					$author$project$Api$executeGraphqlOperation,
					env,
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					$author$project$Common$Gql$Offer$sendOfferEmailMutation(option),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$OfferDetails$Msg$EmailSent));
			case 11:
				var emailOptions = effect.a;
				return $author$project$Tracker$publishUserEvent(
					$author$project$Tracker$userSendEmailEvent(
						$author$project$Tracker$userSendEmailPayloadForOffer(emailOptions)));
			default:
				var offerId = effect.a;
				var modalOrigin = effect.b;
				return A4(
					$author$project$Api$executeGraphqlOperation,
					env,
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					$author$project$Gql$Platform$Mutation$saveCustomerGreatLakesOptIn(
						{n$: offerId}),
					A2(
						$elm$core$Basics$composeR,
						$krisajenkins$remotedata$RemoteData$fromResult,
						$author$project$Page$OfferDetails$Msg$SaveGreatLakesOptInConsentResponse(modalOrigin)));
		}
	});
var $author$project$Page$Payment$Msg$GotBraintreeToken = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Payment$Msg$GotOfferProducts = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Payment$Msg$GotPolicy = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Payment$Ports$braintreeSetup = _Platform_outgoingPort('braintreeSetup', $elm$json$Json$Encode$string);
var $author$project$Utils$executeGraphqlOperation = F5(
	function (envData, urlExtractor, operation, selectionSet, tagger) {
		var effectRunner = function (env) {
			return $dillonkearns$elm_graphql$Graphql$Http$toTask(
				$dillonkearns$elm_graphql$Graphql$Http$withCredentials(
					A2(
						operation,
						urlExtractor(env),
						selectionSet)));
		};
		return A2(
			$elm$core$Task$attempt,
			tagger,
			effectRunner(envData));
	});
var $author$project$Gql$Platform$Object$ClientConfiguration$braintreeClientToken = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'braintreeClientToken', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Query$clientConfiguration = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'clientConfiguration', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Page$Payment$Gql$fetchBraintreeToken = $author$project$Gql$Platform$Query$clientConfiguration($author$project$Gql$Platform$Object$ClientConfiguration$braintreeClientToken);
var $author$project$Gql$Platform$Query$ProductsRequiredArguments = function (offerId) {
	return {n$: offerId};
};
var $author$project$Page$Payment$Gql$findProductsByOfferIdRequiredArguments = function (offerId) {
	return $author$project$Gql$Platform$Query$ProductsRequiredArguments(offerId);
};
var $author$project$Gql$Platform$Object$BackofficeProduct$annualPrice = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'annualPrice', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Enum$BundleSlug$TercerosAmpliado = 1;
var $author$project$Gql$Platform$Enum$BundleSlug$TercerosBasico = 0;
var $author$project$Gql$Platform$Enum$BundleSlug$TodoRiesgoConFranquicia = 2;
var $author$project$Gql$Platform$Enum$BundleSlug$TodoRiesgoConFranquicia300 = 3;
var $author$project$Gql$Platform$Enum$BundleSlug$TodoRiesgoConFranquicia500 = 4;
var $author$project$Gql$Platform$Enum$BundleSlug$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'TERCEROS_BASICO':
				return $elm$json$Json$Decode$succeed(0);
			case 'TERCEROS_AMPLIADO':
				return $elm$json$Json$Decode$succeed(1);
			case 'TODO_RIESGO_CON_FRANQUICIA':
				return $elm$json$Json$Decode$succeed(2);
			case 'TODO_RIESGO_CON_FRANQUICIA_300':
				return $elm$json$Json$Decode$succeed(3);
			case 'TODO_RIESGO_CON_FRANQUICIA_500':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid BundleSlug type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeProduct$bundleSlug = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BundleSlug.BundleSlug', 'bundleSlug', _List_Nil, $author$project$Gql$Platform$Enum$BundleSlug$decoder);
var $author$project$Common$Gql$BundleSlug$decodeBundleSlug = function (bundleSlug) {
	switch (bundleSlug) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 2;
		default:
			return 2;
	}
};
var $author$project$Gql$Platform$Object$BackofficeProduct$issuingCompany = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'issuingCompany', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$OfferAnnualPrice$gross = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'gross',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mz.A);
var $author$project$Gql$Platform$Object$OfferAnnualPrice$net = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'net',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mz.A);
var $author$project$Gql$Platform$Object$OfferAnnualPrice$taxIps = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'taxIps',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mz.A);
var $author$project$Gql$Platform$Object$OfferAnnualPrice$taxSurcharges = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'taxSurcharges',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mz.A);
var $author$project$Gql$Platform$Object$OfferAnnualPrice$taxes = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'taxes',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mz.A);
var $author$project$Common$Gql$OfferProduct$offerAnnualPriceSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$OfferAnnualPrice$taxSurcharges),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$OfferAnnualPrice$taxIps),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$OfferAnnualPrice$net),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$OfferAnnualPrice$taxes),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$OfferAnnualPrice$gross),
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Product$AnnualPrice))))));
var $author$project$Common$Gql$OfferProduct$offerProductSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeProduct$annualPrice($author$project$Common$Gql$OfferProduct$offerAnnualPriceSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$BundleSlug$decodeBundleSlug, $author$project$Gql$Platform$Object$BackofficeProduct$bundleSlug),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeProduct$issuingCompany,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Product$OfferProduct))));
var $author$project$Gql$Platform$Query$products = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'products',
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
					'offerId',
					requiredArgs____.n$,
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$ScalarCodecs$codecs))
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Page$Payment$Gql$findProductsByOfferId = function (offerId) {
	return A2(
		$author$project$Gql$Platform$Query$products,
		$author$project$Page$Payment$Gql$findProductsByOfferIdRequiredArguments(offerId),
		$author$project$Common$Gql$OfferProduct$offerProductSelectionSet);
};
var $author$project$Page$Payment$Ports$payWithCreditCard = _Platform_outgoingPort(
	'payWithCreditCard',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Gql$Platform$InputObject$MotoPaymentInfo = function (token) {
	return {ap: token};
};
var $author$project$Gql$Platform$Mutation$PurchaseOfferRequiredArguments = F2(
	function (offerId, paymentInfo) {
		return {n$: offerId, aL: paymentInfo};
	});
var $author$project$Gql$Platform$InputObject$encodeMotoPaymentInfo = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'token',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.ap)))
			]));
};
var $author$project$Gql$Platform$Mutation$purchaseOffer = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'ScalarCodecs.Uuid',
		'purchaseOffer',
		_List_fromArray(
			[
				A3(
				$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
				'offerId',
				requiredArgs____.n$,
				A2(
					$author$project$Gql$Platform$Scalar$unwrapEncoder,
					function ($) {
						return $.t;
					},
					$author$project$ScalarCodecs$codecs)),
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'paymentInfo', requiredArgs____.aL, $author$project$Gql$Platform$InputObject$encodeMotoPaymentInfo)
			]),
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).t.A);
};
var $author$project$Page$Payment$Gql$purchaseOffer = F2(
	function (nonce, offerId) {
		var paymentInfo = $author$project$Gql$Platform$InputObject$MotoPaymentInfo(nonce);
		return $author$project$Gql$Platform$Mutation$purchaseOffer(
			A2($author$project$Gql$Platform$Mutation$PurchaseOfferRequiredArguments, offerId, paymentInfo));
	});
var $author$project$Page$Payment$Effect$runEffect = F3(
	function (env, model, effect) {
		switch (effect.$) {
			case 3:
				var token = effect.a;
				return $author$project$Page$Payment$Ports$braintreeSetup(token);
			case 4:
				return A5(
					$author$project$Utils$executeGraphqlOperation,
					env,
					$author$project$Env$apiUrl,
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Page$Payment$Gql$fetchBraintreeToken,
					A2($elm$core$Basics$composeL, $author$project$Page$Payment$Msg$GotBraintreeToken, $krisajenkins$remotedata$RemoteData$fromResult));
			case 6:
				var offerId = effect.a;
				return A5(
					$author$project$Utils$executeGraphqlOperation,
					env,
					$author$project$Env$apiUrl,
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Page$Payment$Gql$findProductsByOfferId(offerId),
					A2($elm$core$Basics$composeL, $author$project$Page$Payment$Msg$GotOfferProducts, $krisajenkins$remotedata$RemoteData$fromResult));
			case 5:
				return $author$project$Page$Payment$Ports$payWithCreditCard(0);
			case 7:
				var nonce = effect.a;
				return A5(
					$author$project$Utils$executeGraphqlOperation,
					env,
					$author$project$Env$apiUrl,
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2($author$project$Page$Payment$Gql$purchaseOffer, nonce, model.n$),
					A2($elm$core$Basics$composeL, $author$project$Page$Payment$Msg$GotPolicy, $krisajenkins$remotedata$RemoteData$fromResult));
			case 0:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						A2($author$project$Page$Payment$Effect$runEffect, env, model),
						effects));
			case 8:
				return $elm$core$Platform$Cmd$none;
			case 1:
				return $elm$core$Platform$Cmd$none;
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Page$PolicyDetails$Msg$AmendInterruptionResponseReceived = F2(
	function (a, b) {
		return {$: 59, a: a, b: b};
	});
var $author$project$Page$PolicyDetails$Msg$CreateRefundResponseReceived = function (a) {
	return {$: 27, a: a};
};
var $author$project$Page$PolicyDetails$Msg$FetchedClaimHistory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$PolicyDetails$Msg$FetchedClaimHistoryPricingAction = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$PolicyDetails$Msg$FetchedCoverSelection = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$PolicyDetails$Msg$FetchedCustomerId = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$PolicyDetails$Msg$FetchedPaymentMethod = function (a) {
	return {$: 39, a: a};
};
var $author$project$Page$PolicyDetails$Msg$FetchedPolicy = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$PolicyDetails$Msg$GotAmendExpectedRefund = function (a) {
	return {$: 58, a: a};
};
var $author$project$Page$PolicyDetails$Msg$GotChangeEmailResponse = function (a) {
	return {$: 49, a: a};
};
var $author$project$Page$PolicyDetails$Msg$GotCurrentTime = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$PolicyDetails$Msg$GotExpectedRefund = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$PolicyDetails$Msg$GotRefund = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$PolicyDetails$Msg$InterruptionResponseReceived = function (a) {
	return {$: 22, a: a};
};
var $author$project$Page$PolicyDetails$Msg$IssueRefundResponseReceived = function (a) {
	return {$: 28, a: a};
};
var $author$project$Common$Gql$CoverSelection$PolicyId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Gql$CustomerId$PolicyId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Gql$PaymentMethod$PolicyId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$PolicyDetails$Msg$PolledForRefundCompletion = F2(
	function (a, b) {
		return {$: 63, a: a, b: b};
	});
var $author$project$Page$PolicyDetails$Msg$PolledForRefundUpdate = F3(
	function (a, b, c) {
		return {$: 61, a: a, b: b, c: c};
	});
var $author$project$Page$PolicyDetails$Msg$RenewalCancellationResponseReceived = function (a) {
	return {$: 36, a: a};
};
var $author$project$Page$PolicyDetails$Msg$SendPolicyContractEmailResponseReceived = function (a) {
	return {$: 41, a: a};
};
var $author$project$Page$PolicyDetails$Msg$WaitedBeforePollingRefundCompletion = function (a) {
	return {$: 64, a: a};
};
var $author$project$Page$PolicyDetails$Msg$WaitedBeforePollingRefundUpdate = F2(
	function (a, b) {
		return {$: 62, a: a, b: b};
	});
var $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$Chargeback = 2;
var $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$Fraud = 1;
var $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$InexactDeclarationDni = 3;
var $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$InexactDeclarationSinco = 0;
var $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$PhotoVerificationNotProvided = 5;
var $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$RiskAggravation = 4;
var $author$project$Common$AmendReason$companyReasonToGql = function (companyReason) {
	switch (companyReason) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		default:
			return 5;
	}
};
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe = function (maybeValue) {
	if (!maybeValue.$) {
		var value = maybeValue.a;
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(value);
	} else {
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
	}
};
var $author$project$Page$PolicyDetails$Gql$amendCompanyInterruption = function (_v0) {
	var id = _v0.kg;
	var requestedAt = _v0.h;
	var interruptionAt = _v0.a1;
	var reason = _v0.im;
	var description = _v0.mN;
	return {
		nm: {
			mN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(description),
			a1: interruptionAt,
			oQ: id,
			im: {
				V: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				Z: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Common$AmendReason$companyReasonToGql(reason))
			},
			h: requestedAt
		}
	};
};
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$CompetitorOffer = 0;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$CoverageChange = 12;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$DeceasedPolicyHolder = 11;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$DissatisfactionService = 13;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$DoesNotKnow = 5;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$IncorrectDataOther = 9;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$IncorrectEffectiveDate = 7;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$IncorrectPersonalData = 8;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$MovingToAnotherCountry = 15;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$NoInsuranceWanted = 4;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$Other = 19;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$PaymentMethodOrDate = 10;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$PolicyHolderChange = 17;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$ProductService = 16;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$SwitchToGreatLakes = 18;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$UnderwritingRules = 14;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$VehicleDeregistration = 3;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$VehicleNotPurchased = 2;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$VehicleSold = 1;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$WantsGreenCard = 6;
var $author$project$Common$AmendReason$customerReasonToGql = function (customerReason) {
	switch (customerReason) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		case 7:
			return 7;
		case 8:
			return 8;
		case 9:
			return 9;
		case 10:
			return 10;
		case 11:
			return 11;
		case 12:
			return 12;
		case 13:
			return 13;
		case 14:
			return 14;
		case 15:
			return 15;
		case 16:
			return 16;
		case 17:
			return 17;
		case 18:
			return 18;
		default:
			return 19;
	}
};
var $author$project$Page$PolicyDetails$Gql$amendCustomerInterruption = function (_v0) {
	var id = _v0.kg;
	var requestedAt = _v0.h;
	var interruptionAt = _v0.a1;
	var reason = _v0.im;
	var description = _v0.mN;
	return {
		nm: {
			mN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(description),
			a1: interruptionAt,
			oQ: id,
			im: {
				V: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Common$AmendReason$customerReasonToGql(reason)),
				Z: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
			},
			h: requestedAt
		}
	};
};
var $author$project$Page$PolicyDetails$Gql$amendDateCompanyInterruption = function (_v0) {
	var id = _v0.kg;
	var requestedAt = _v0.h;
	var interruptionAt = _v0.a1;
	return {
		bt: {
			V: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			Z: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				{kg: id, a1: interruptionAt, h: requestedAt})
		}
	};
};
var $author$project$Page$PolicyDetails$Gql$amendDateCustomerInterruption = function (_v0) {
	var id = _v0.kg;
	var requestedAt = _v0.h;
	var interruptionAt = _v0.a1;
	return {
		bt: {
			V: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				{kg: id, a1: interruptionAt, h: requestedAt}),
			Z: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
		}
	};
};
var $author$project$Gql$Platform$InputObject$encodeCustomerAmendTerminationDateInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$ScalarCodecs$codecs)(input____.kg))),
				_Utils_Tuple2(
				'requestedAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.N;
						},
						$author$project$ScalarCodecs$codecs)(input____.h))),
				_Utils_Tuple2(
				'interruptionAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.N;
						},
						$author$project$ScalarCodecs$codecs)(input____.a1)))
			]));
};
var $author$project$Gql$Platform$InputObject$encodePrimaAmendTerminationDateInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$ScalarCodecs$codecs)(input____.kg))),
				_Utils_Tuple2(
				'requestedAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.N;
						},
						$author$project$ScalarCodecs$codecs)(input____.h))),
				_Utils_Tuple2(
				'interruptionAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.N;
						},
						$author$project$ScalarCodecs$codecs)(input____.a1)))
			]));
};
var $author$project$Gql$Platform$InputObject$encodeAmendTerminationDateInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'customer',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.V, $author$project$Gql$Platform$InputObject$encodeCustomerAmendTerminationDateInput)),
				_Utils_Tuple2(
				'prima',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Z, $author$project$Gql$Platform$InputObject$encodePrimaAmendTerminationDateInput))
			]));
};
var $author$project$Gql$Platform$Mutation$amendTerminationDate = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'ScalarCodecs.Uuid',
		'amendTerminationDate',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'amendment', requiredArgs____.bt, $author$project$Gql$Platform$InputObject$encodeAmendTerminationDateInput)
			]),
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).t.A);
};
var $author$project$Common$AmendReason$isCustomerReason = function (reason) {
	if (!reason.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Page$PolicyDetails$Effect$amendDateInterruptionArgs = F2(
	function (reason, args) {
		return $author$project$Common$AmendReason$isCustomerReason(reason) ? $author$project$Gql$Platform$Mutation$amendTerminationDate(
			$author$project$Page$PolicyDetails$Gql$amendDateCustomerInterruption(args)) : $author$project$Gql$Platform$Mutation$amendTerminationDate(
			$author$project$Page$PolicyDetails$Gql$amendDateCompanyInterruption(args));
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum = F2(
	function (enumToString, value) {
		return $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue(
			enumToString(value));
	});
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'COMPETITOR_OFFER';
		case 1:
			return 'VEHICLE_SOLD';
		case 2:
			return 'VEHICLE_NOT_PURCHASED';
		case 3:
			return 'VEHICLE_DEREGISTRATION';
		case 4:
			return 'NO_INSURANCE_WANTED';
		case 5:
			return 'DOES_NOT_KNOW';
		case 6:
			return 'WANTS_GREEN_CARD';
		case 7:
			return 'INCORRECT_EFFECTIVE_DATE';
		case 8:
			return 'INCORRECT_PERSONAL_DATA';
		case 9:
			return 'INCORRECT_DATA_OTHER';
		case 10:
			return 'PAYMENT_METHOD_OR_DATE';
		case 11:
			return 'DECEASED_POLICY_HOLDER';
		case 12:
			return 'COVERAGE_CHANGE';
		case 13:
			return 'DISSATISFACTION_SERVICE';
		case 14:
			return 'UNDERWRITING_RULES';
		case 15:
			return 'MOVING_TO_ANOTHER_COUNTRY';
		case 16:
			return 'PRODUCT_SERVICE';
		case 17:
			return 'POLICY_HOLDER_CHANGE';
		case 18:
			return 'SWITCH_TO_GREAT_LAKES';
		default:
			return 'OTHER';
	}
};
var $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'INEXACT_DECLARATION_SINCO';
		case 1:
			return 'FRAUD';
		case 2:
			return 'CHARGEBACK';
		case 3:
			return 'INEXACT_DECLARATION_DNI';
		case 4:
			return 'RISK_AGGRAVATION';
		default:
			return 'PHOTO_VERIFICATION_NOT_PROVIDED';
	}
};
var $author$project$New$Gql$Platform$InputObject$encodeTerminateReason = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'customer',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.V,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString))),
				_Utils_Tuple2(
				'prima',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.Z,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString)))
			]));
};
var $author$project$New$Gql$Platform$InputObject$encodeAmendTerminationInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$NewScalarCodecs$codecs)(input____.oQ))),
				_Utils_Tuple2(
				'requestedAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.N;
						},
						$author$project$NewScalarCodecs$codecs)(input____.h))),
				_Utils_Tuple2(
				'interruptionAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.N;
						},
						$author$project$NewScalarCodecs$codecs)(input____.a1))),
				_Utils_Tuple2(
				'reason',
				$elm$core$Maybe$Just(
					$author$project$New$Gql$Platform$InputObject$encodeTerminateReason(input____.im))),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$New$Gql$Platform$Mutation$amendTermination = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'amendTermination',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nm, $author$project$New$Gql$Platform$InputObject$encodeAmendTerminationInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$New$Gql$Platform$Object$AmendTerminationOutput$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$Page$PolicyDetails$Gql$amendTerminationSelectionSet = $author$project$New$Gql$Platform$Object$AmendTerminationOutput$policyId;
var $author$project$Common$Policy$pickId = function (_v0) {
	var policy = _v0;
	return policy.kg;
};
var $author$project$Common$Gql$PolicyCheckEligibility$CheckEligibilityCommonData = F2(
	function (policyId, interruptionAt) {
		return {a1: interruptionAt, oQ: policyId};
	});
var $author$project$Common$Gql$PolicyCheckEligibility$TerminationByCustomer = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Common$Gql$PolicyCheckEligibility$terminationByCustomer = F3(
	function (policyId, interruptionDate, reason) {
		return A2(
			$author$project$Common$Gql$PolicyCheckEligibility$TerminationByCustomer,
			A2($author$project$Common$Gql$PolicyCheckEligibility$CheckEligibilityCommonData, policyId, interruptionDate),
			reason);
	});
var $author$project$Common$Gql$PolicyCheckEligibility$TerminationByPrima = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Common$Gql$PolicyCheckEligibility$terminationByPrima = F3(
	function (policyId, interruptionDate, reason) {
		return A2(
			$author$project$Common$Gql$PolicyCheckEligibility$TerminationByPrima,
			A2($author$project$Common$Gql$PolicyCheckEligibility$CheckEligibilityCommonData, policyId, interruptionDate),
			reason);
	});
var $author$project$Common$Gql$PolicyCheckEligibility$Withdrawal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Gql$PolicyCheckEligibility$withdrawal = F2(
	function (policyId, interruptionDate) {
		return $author$project$Common$Gql$PolicyCheckEligibility$Withdrawal(
			A2($author$project$Common$Gql$PolicyCheckEligibility$CheckEligibilityCommonData, policyId, interruptionDate));
	});
var $author$project$Page$PolicyDetails$Effect$createCheckEligibilityArgumentFromModel = F2(
	function (policy, kindData) {
		switch (kindData.$) {
			case 0:
				var data = kindData.a;
				return $elm$core$Maybe$Just(
					A2(
						$author$project$Common$Gql$PolicyCheckEligibility$withdrawal,
						$author$project$Common$Policy$pickId(policy),
						data.o6));
			case 1:
				var data = kindData.a;
				return A2(
					$elm$core$Maybe$map,
					A2(
						$author$project$Common$Gql$PolicyCheckEligibility$terminationByCustomer,
						$author$project$Common$Policy$pickId(policy),
						data.a1),
					data.kC);
			default:
				var data = kindData.a;
				return A2(
					$elm$core$Maybe$map,
					A2(
						$author$project$Common$Gql$PolicyCheckEligibility$terminationByPrima,
						$author$project$Common$Policy$pickId(policy),
						data.a1),
					data.kC);
		}
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$pickKindData = function (_v0) {
	var model = _v0;
	return model.at;
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$pickPolicy = function (_v0) {
	var model = _v0;
	return model.k;
};
var $author$project$Page$PolicyDetails$Effect$createCheckEligibilityArgument = function (_v0) {
	var interruptionModal = _v0.p;
	return $elm_community$maybe_extra$Maybe$Extra$join(
		A3(
			$elm$core$Maybe$map2,
			$author$project$Page$PolicyDetails$Effect$createCheckEligibilityArgumentFromModel,
			$author$project$Page$PolicyDetails$InterruptionModal$Model$pickPolicy(interruptionModal),
			$author$project$Page$PolicyDetails$InterruptionModal$Model$pickKindData(interruptionModal)));
};
var $author$project$New$Gql$Platform$InputObject$encodeCreateRefundInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$NewScalarCodecs$codecs)(input____.oQ)))
			]));
};
var $author$project$New$Gql$Platform$Mutation$createRefund = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'createRefund',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nm, $author$project$New$Gql$Platform$InputObject$encodeCreateRefundInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Page$PolicyDetails$Gql$createRefund = function (policyId) {
	return {
		nm: {oQ: policyId}
	};
};
var $author$project$New$Gql$Platform$Object$CreateRefundOutput$refundId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'refundId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$Page$PolicyDetails$Gql$createRefundSelectionSet = $author$project$New$Gql$Platform$Object$CreateRefundOutput$refundId;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'COMPETITOR_OFFER';
		case 1:
			return 'VEHICLE_SOLD';
		case 2:
			return 'VEHICLE_NOT_PURCHASED';
		case 3:
			return 'VEHICLE_DEREGISTRATION';
		case 4:
			return 'NO_INSURANCE_WANTED';
		case 5:
			return 'DOES_NOT_KNOW';
		case 6:
			return 'WANTS_GREEN_CARD';
		case 7:
			return 'INCORRECT_EFFECTIVE_DATE';
		case 8:
			return 'INCORRECT_PERSONAL_DATA';
		case 9:
			return 'INCORRECT_DATA_OTHER';
		case 10:
			return 'PAYMENT_METHOD_OR_DATE';
		case 11:
			return 'DECEASED_POLICY_HOLDER';
		case 12:
			return 'COVERAGE_CHANGE';
		case 13:
			return 'DISSATISFACTION_SERVICE';
		case 14:
			return 'UNDERWRITING_RULES';
		case 15:
			return 'MOVING_TO_ANOTHER_COUNTRY';
		case 16:
			return 'PRODUCT_SERVICE';
		case 17:
			return 'POLICY_HOLDER_CHANGE';
		case 18:
			return 'PRICE_INCREASE';
		default:
			return 'OTHER';
	}
};
var $author$project$New$Gql$Platform$InputObject$encodeCustomerDeclineRenewalInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$NewScalarCodecs$codecs)(input____.kg))),
				_Utils_Tuple2(
				'requestedAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.N;
						},
						$author$project$NewScalarCodecs$codecs)(input____.h))),
				_Utils_Tuple2(
				'reason',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString, input____.im))),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$New$Gql$Platform$Mutation$customerDeclineRenewal = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'customerDeclineRenewal',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nm, $author$project$New$Gql$Platform$InputObject$encodeCustomerDeclineRenewalInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$New$Gql$Platform$InputObject$encodeCustomerTerminatePolicyInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$NewScalarCodecs$codecs)(input____.kg))),
				_Utils_Tuple2(
				'requestedAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.N;
						},
						$author$project$NewScalarCodecs$codecs)(input____.h))),
				_Utils_Tuple2(
				'interruptionAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.N;
						},
						$author$project$NewScalarCodecs$codecs)(input____.a1))),
				_Utils_Tuple2(
				'reason',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString, input____.im))),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$New$Gql$Platform$Mutation$customerTerminatePolicy = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'customerTerminatePolicy',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nm, $author$project$New$Gql$Platform$InputObject$encodeCustomerTerminatePolicyInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Page$PolicyDetails$Gql$customerTerminatePolicy = function (_v0) {
	var id = _v0.kg;
	var requestedAt = _v0.h;
	var interruptionAt = _v0.a1;
	var reason = _v0.im;
	var description = _v0.mN;
	return {
		nm: {
			mN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(description),
			kg: id,
			a1: interruptionAt,
			im: reason,
			h: requestedAt
		}
	};
};
var $author$project$New$Gql$Platform$Object$CustomerTerminatePolicyOutput$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$Page$PolicyDetails$Gql$customerTerminatePolicySelectionSet = $author$project$New$Gql$Platform$Object$CustomerTerminatePolicyOutput$policyId;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'COMPETITOR_OFFER';
		case 1:
			return 'VEHICLE_SOLD';
		case 2:
			return 'VEHICLE_NOT_PURCHASED';
		case 3:
			return 'VEHICLE_DEREGISTRATION';
		case 4:
			return 'NO_INSURANCE_WANTED';
		case 5:
			return 'DOES_NOT_KNOW';
		case 6:
			return 'WANTS_GREEN_CARD';
		case 7:
			return 'INCORRECT_EFFECTIVE_DATE';
		case 8:
			return 'INCORRECT_DATA_OTHER';
		case 9:
			return 'INCORRECT_PERSONAL_DATA';
		case 10:
			return 'PAYMENT_METHOD_OR_DATE';
		case 11:
			return 'DECEASED_POLICY_HOLDER';
		case 12:
			return 'COVERAGE_CHANGE';
		case 13:
			return 'DISSATISFACTION_SERVICE';
		case 14:
			return 'UNDERWRITING_RULES';
		case 15:
			return 'MOVING_TO_ANOTHER_COUNTRY';
		default:
			return 'OTHER';
	}
};
var $author$project$New$Gql$Platform$InputObject$encodeCustomerWithdrawPolicyInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$NewScalarCodecs$codecs)(input____.kg))),
				_Utils_Tuple2(
				'requestedAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.N;
						},
						$author$project$NewScalarCodecs$codecs)(input____.h))),
				_Utils_Tuple2(
				'reason',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$toString, input____.im))),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$New$Gql$Platform$Mutation$customerWithdrawPolicy = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'customerWithdrawPolicy',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nm, $author$project$New$Gql$Platform$InputObject$encodeCustomerWithdrawPolicyInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Page$PolicyDetails$Gql$declineRenewal = function (_v0) {
	var id = _v0.kg;
	var requestedAt = _v0.h;
	var reason = _v0.im;
	var additionalNotes = _v0.me;
	return {
		nm: {
			mN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(additionalNotes),
			kg: id,
			im: reason,
			h: requestedAt
		}
	};
};
var $author$project$New$Gql$Platform$Object$CustomerDeclineRenewalOutput$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$Page$PolicyDetails$Gql$declineRenewalSelectionSet = $author$project$New$Gql$Platform$Object$CustomerDeclineRenewalOutput$policyId;
var $author$project$New$Gql$Platform$InputObject$encodePotentialCustomerTermination = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'interruptionAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.N;
						},
						$author$project$NewScalarCodecs$codecs)(input____.a1))),
				_Utils_Tuple2(
				'reason',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString, input____.im)))
			]));
};
var $author$project$New$Gql$Platform$InputObject$encodePotentialPrimaTermination = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'interruptionAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.N;
						},
						$author$project$NewScalarCodecs$codecs)(input____.a1))),
				_Utils_Tuple2(
				'reason',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString, input____.im)))
			]));
};
var $author$project$New$Gql$Platform$InputObject$encodePotentialWithdrawal = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'interruptionAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.N;
						},
						$author$project$NewScalarCodecs$codecs)(input____.a1)))
			]));
};
var $author$project$New$Gql$Platform$InputObject$encodePotentialInterruptionDetails = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'withdrawal',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i7, $author$project$New$Gql$Platform$InputObject$encodePotentialWithdrawal)),
				_Utils_Tuple2(
				'customerTermination',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gj, $author$project$New$Gql$Platform$InputObject$encodePotentialCustomerTermination)),
				_Utils_Tuple2(
				'primaTermination',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ii, $author$project$New$Gql$Platform$InputObject$encodePotentialPrimaTermination))
			]));
};
var $author$project$New$Gql$Platform$InputObject$encodeCheckElegibilityInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$NewScalarCodecs$codecs)(input____.oQ))),
				_Utils_Tuple2(
				'interruptionDetails',
				$elm$core$Maybe$Just(
					$author$project$New$Gql$Platform$InputObject$encodePotentialInterruptionDetails(input____.no)))
			]));
};
var $author$project$New$Gql$Platform$Query$checkEligibility = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'checkEligibility',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nm, $author$project$New$Gql$Platform$InputObject$encodeCheckElegibilityInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$New$Gql$Platform$Query$CheckEligibilityRequiredArguments = function (input) {
	return {nm: input};
};
var $author$project$Common$Gql$PolicyCheckEligibility$customerTerminateInputRequiredFields = F2(
	function (interruptionAt, reason) {
		return {a1: interruptionAt, im: reason};
	});
var $author$project$Common$Gql$PolicyCheckEligibility$customerWithdrawInputRequiredFields = function (interruptionAt) {
	return {a1: interruptionAt};
};
var $author$project$Common$Gql$PolicyCheckEligibility$primaTerminateInputRequiredFields = F2(
	function (interruptionAt, reason) {
		return {a1: interruptionAt, im: reason};
	});
var $author$project$Common$Gql$PolicyCheckEligibility$backofficeInterruptionDetails = function (claimEligibilityArg) {
	switch (claimEligibilityArg.$) {
		case 0:
			var commonData = claimEligibilityArg.a;
			return {
				gj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				ii: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				i7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Common$Gql$PolicyCheckEligibility$customerWithdrawInputRequiredFields(commonData.a1))
			};
		case 1:
			var commonData = claimEligibilityArg.a;
			var reason = claimEligibilityArg.b;
			return {
				gj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					A2($author$project$Common$Gql$PolicyCheckEligibility$customerTerminateInputRequiredFields, commonData.a1, reason)),
				ii: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				i7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
			};
		default:
			var commonData = claimEligibilityArg.a;
			var reason = claimEligibilityArg.b;
			return {
				gj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				ii: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					A2($author$project$Common$Gql$PolicyCheckEligibility$primaTerminateInputRequiredFields, commonData.a1, reason)),
				i7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
			};
	}
};
var $author$project$Common$Gql$PolicyCheckEligibility$pickPolicyId = function (argument) {
	switch (argument.$) {
		case 0:
			var policyId = argument.a.oQ;
			return policyId;
		case 1:
			var policyId = argument.a.oQ;
			return policyId;
		default:
			var policyId = argument.a.oQ;
			return policyId;
	}
};
var $author$project$Common$Gql$PolicyCheckEligibility$checkEligibilityRequiredArguments = function (claimEligibilityArg) {
	return $author$project$New$Gql$Platform$Query$CheckEligibilityRequiredArguments(
		{
			no: $author$project$Common$Gql$PolicyCheckEligibility$backofficeInterruptionDetails(claimEligibilityArg),
			oQ: $author$project$Common$Gql$PolicyCheckEligibility$pickPolicyId(claimEligibilityArg)
		});
};
var $author$project$New$Gql$Platform$Object$CheckEligibilityOutput$eligibility = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'eligibility', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$ExpectedRefund$ExpectedRefund = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$ExpectedRefund$refund = function (price) {
	return $author$project$Common$ExpectedRefund$ExpectedRefund(price);
};
var $author$project$New$Gql$Platform$Object$Eligible$refund = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.GqlDecimal',
	'refund',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mz.A);
var $author$project$Common$Gql$PolicyCheckEligibility$decodeEligible = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$Eligible$refund),
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$ExpectedRefund$refund));
var $author$project$Common$ExpectedRefund$NoExpectedRefund = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$ExpectedRefund$noRefund = function (price) {
	return $author$project$Common$ExpectedRefund$NoExpectedRefund(price);
};
var $author$project$New$Gql$Platform$Object$Ineligible$refund = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.GqlDecimal',
	'refund',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mz.A);
var $author$project$Common$Gql$PolicyCheckEligibility$decodeIneligible = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$Ineligible$refund),
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$ExpectedRefund$noRefund));
var $author$project$New$Gql$Platform$Union$Eligibility$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Eligible', selections____.os),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Ineligible', selections____.ou)
			]));
};
var $author$project$Common$Gql$PolicyCheckEligibility$eligibilitySelectionSet = $author$project$New$Gql$Platform$Union$Eligibility$fragments(
	{os: $author$project$Common$Gql$PolicyCheckEligibility$decodeEligible, ou: $author$project$Common$Gql$PolicyCheckEligibility$decodeIneligible});
var $author$project$Common$Gql$PolicyCheckEligibility$checkEligibilitySelectionSet = $author$project$New$Gql$Platform$Object$CheckEligibilityOutput$eligibility($author$project$Common$Gql$PolicyCheckEligibility$eligibilitySelectionSet);
var $author$project$Common$Gql$PolicyCheckEligibility$checkEligibilityQuery = function (claimEligibilityArg) {
	return A2(
		$author$project$New$Gql$Platform$Query$checkEligibility,
		$author$project$Common$Gql$PolicyCheckEligibility$checkEligibilityRequiredArguments(claimEligibilityArg),
		$author$project$Common$Gql$PolicyCheckEligibility$checkEligibilitySelectionSet);
};
var $author$project$Page$PolicyDetails$Effect$executeCheckEligibilityQuery = F3(
	function (env, returnMsg, checkEligibilityArgument) {
		return A5(
			$author$project$Api$executeNewGraphqlOperation,
			env,
			'checkEligibility',
			$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
			$author$project$Common$Gql$PolicyCheckEligibility$checkEligibilityQuery(checkEligibilityArgument),
			A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, returnMsg));
	});
var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 1) {
			return ma;
		} else {
			return mb;
		}
	});
var $author$project$Common$AmendReason$toCustomerReason = function (reason) {
	if (reason.$ === 1) {
		var customerReason = reason.a;
		return $elm$core$Maybe$Just(customerReason);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Common$AmendReason$toPrimaReason = function (reason) {
	if (!reason.$) {
		var primaReason = reason.a;
		return $elm$core$Maybe$Just(primaReason);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$PolicyDetails$Effect$getExpectedRefundForAmendInterruption = F3(
	function (amendReason, policyId, interruptionAt) {
		return A2(
			$elm_community$maybe_extra$Maybe$Extra$orElse,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Common$AmendReason$companyReasonToGql,
					A2($author$project$Common$Gql$PolicyCheckEligibility$terminationByPrima, policyId, interruptionAt)),
				$author$project$Common$AmendReason$toPrimaReason(amendReason)),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Common$AmendReason$customerReasonToGql,
					A2($author$project$Common$Gql$PolicyCheckEligibility$terminationByCustomer, policyId, interruptionAt)),
				$author$project$Common$AmendReason$toCustomerReason(amendReason)));
	});
var $author$project$New$Gql$Platform$Query$GetRefundRequiredArguments = function (input) {
	return {nm: input};
};
var $author$project$New$Gql$Platform$InputObject$encodeGetRefundInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$NewScalarCodecs$codecs)(input____.oQ)))
			]));
};
var $author$project$New$Gql$Platform$Query$getRefund = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'getRefund',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nm, $author$project$New$Gql$Platform$InputObject$encodeGetRefundInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Common$Refund$Completed = 2;
var $author$project$Common$Refund$Failed = 3;
var $author$project$Common$Refund$NotRequired = 4;
var $author$project$Common$Refund$Pending = 0;
var $author$project$Common$Refund$ToBePaid = 1;
var $author$project$Common$Gql$GetRefund$decodeStatus = function (status) {
	switch (status) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		default:
			return 4;
	}
};
var $author$project$New$Gql$Platform$Object$GetRefundOutput$eligibility = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'eligibility', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$GetRefundOutput$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'id',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$Common$Refund$Refund = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Common$Refund$new = F3(
	function (id, expectedRefund, status) {
		return A2(
			$author$project$Common$Refund$Refund,
			{mY: expectedRefund, kg: id},
			status);
	});
var $author$project$New$Gql$Platform$Enum$RefundStatus$Completed = 2;
var $author$project$New$Gql$Platform$Enum$RefundStatus$Failed = 3;
var $author$project$New$Gql$Platform$Enum$RefundStatus$NotRequired = 4;
var $author$project$New$Gql$Platform$Enum$RefundStatus$Pending = 0;
var $author$project$New$Gql$Platform$Enum$RefundStatus$ToBePaid = 1;
var $author$project$New$Gql$Platform$Enum$RefundStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'PENDING':
				return $elm$json$Json$Decode$succeed(0);
			case 'TO_BE_PAID':
				return $elm$json$Json$Decode$succeed(1);
			case 'COMPLETED':
				return $elm$json$Json$Decode$succeed(2);
			case 'FAILED':
				return $elm$json$Json$Decode$succeed(3);
			case 'NOT_REQUIRED':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid RefundStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$GetRefundOutput$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.RefundStatus.RefundStatus', 'status', _List_Nil, $author$project$New$Gql$Platform$Enum$RefundStatus$decoder);
var $author$project$Common$Gql$GetRefund$getRefundSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$GetRefund$decodeStatus, $author$project$New$Gql$Platform$Object$GetRefundOutput$status),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$GetRefundOutput$eligibility($author$project$Common$Gql$PolicyCheckEligibility$eligibilitySelectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$GetRefundOutput$id,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Refund$new))));
var $author$project$Common$Gql$GetRefund$getRefundQuery = function (policyId) {
	return A2(
		$author$project$New$Gql$Platform$Query$getRefund,
		$author$project$New$Gql$Platform$Query$GetRefundRequiredArguments(
			{oQ: policyId}),
		$author$project$Common$Gql$GetRefund$getRefundSelectionSet);
};
var $author$project$New$Gql$Platform$Enum$IssueReason$toString = function (enum____) {
	return 'OTHER';
};
var $author$project$New$Gql$Platform$InputObject$encodeIssueRefundInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'refundId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$NewScalarCodecs$codecs)(input____.al))),
				_Utils_Tuple2(
				'reason',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$New$Gql$Platform$Enum$IssueReason$toString, input____.im)))
			]));
};
var $author$project$New$Gql$Platform$Mutation$issueRefund = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'issueRefund',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nm, $author$project$New$Gql$Platform$InputObject$encodeIssueRefundInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$New$Gql$Platform$Enum$IssueReason$Other = 0;
var $author$project$Page$PolicyDetails$Gql$issueRefund = function (refundId) {
	return {
		nm: {im: 0, al: refundId}
	};
};
var $author$project$New$Gql$Platform$Object$IssueRefundOutput$refundId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'refundId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$Page$PolicyDetails$Gql$issueRefundSelectionSet = $author$project$New$Gql$Platform$Object$IssueRefundOutput$refundId;
var $author$project$New$Gql$Platform$InputObject$encodePayRefundInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'refundId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$NewScalarCodecs$codecs)(input____.al)))
			]));
};
var $author$project$New$Gql$Platform$Mutation$payRefund = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'payRefund',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nm, $author$project$New$Gql$Platform$InputObject$encodePayRefundInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Page$PolicyDetails$Gql$payRefund = function (refundId) {
	return {
		nm: {al: refundId}
	};
};
var $author$project$New$Gql$Platform$Object$PayRefundOutput$refundId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'refundId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$Page$PolicyDetails$Gql$payRefundSelectionSet = $author$project$New$Gql$Platform$Object$PayRefundOutput$refundId;
var $author$project$Common$Refund$pickId = function (_v0) {
	var refundData = _v0.a;
	return refundData.kg;
};
var $author$project$Common$Gql$Policy$policyByIdRequiredArguments = function (id) {
	return {
		nm: {oQ: id}
	};
};
var $author$project$New$Gql$Platform$InputObject$encodePolicyDetailsInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$NewScalarCodecs$codecs)(input____.oQ)))
			]));
};
var $author$project$New$Gql$Platform$Query$policyDetails = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'policyDetails',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nm, $author$project$New$Gql$Platform$InputObject$encodePolicyDetailsInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$New$Gql$Platform$Object$Policy$additionalDriver = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'additionalDriver',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$New$Gql$Platform$Object$AdditionalDriver$dateOfBirth = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'dateOfBirth',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$AdditionalDriver$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$AdditionalDriver$firstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'firstName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$AdditionalDriver$lastName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Policy$additionalDriverPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$AdditionalDriver$dateOfBirth,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$AdditionalDriver$documentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$AdditionalDriver$lastName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$AdditionalDriver$firstName,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Policy$additionalDriverSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	$elm$core$Maybe$Nothing,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Common$Gql$Policy$additionalDriverPersonDataSelectionSet,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$AdditionalDriver)));
var $author$project$New$Gql$Platform$Object$Policy$applicationId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'applicationId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$New$Gql$Platform$Object$PolicyDetailsOutput$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$New$Gql$Platform$Object$PolicyDetailsOutput$claimsDeclaredWithFault = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'claimsDeclaredWithFault',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$New$Gql$Platform$Object$PolicyDetailsOutput$coverContinuityInfo = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'coverContinuityInfo', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$Policy$customerFacingId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'customerFacingId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$AmendTerminationType$Customer = 1;
var $author$project$Common$Policy$AmendTermination = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Policy$actionAmendTermination = F4(
	function (policyId, earliestSelectableDate, latestSelectableDate, kind) {
		return $author$project$Common$Policy$AmendTermination(
			{aZ: earliestSelectableDate, c_: kind, a4: latestSelectableDate, oQ: policyId});
	});
var $author$project$New$Gql$Platform$Object$AmendCustomerTermination$earliestSelectableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'earliestSelectableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$AmendCustomerTermination$latestSelectableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'latestSelectableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$AmendCustomerTermination$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$Common$Gql$Policy$decodeAmendCustomerTerminationAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	1,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$AmendCustomerTermination$latestSelectableDate,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$AmendCustomerTermination$earliestSelectableDate,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$AmendCustomerTermination$policyId,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$actionAmendTermination)))));
var $author$project$New$Gql$Platform$Object$AmendPrimaTermination$earliestSelectableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'earliestSelectableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$AmendPrimaTermination$latestSelectableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'latestSelectableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$AmendPrimaTermination$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$Common$Gql$Policy$decodeAmendPrimaTerminationAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	1,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$AmendPrimaTermination$latestSelectableDate,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$AmendPrimaTermination$earliestSelectableDate,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$AmendPrimaTermination$policyId,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$actionAmendTermination)))));
var $author$project$Common$Policy$CancelRenewal = function (a) {
	return {$: 4, a: a};
};
var $author$project$Common$Policy$actionCancelRenewal = function (policyId) {
	return $author$project$Common$Policy$CancelRenewal(
		{oQ: policyId});
};
var $author$project$New$Gql$Platform$Object$CancelRenewal$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$Common$Gql$Policy$decodeCancelRenewalAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$CancelRenewal$policyId,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$actionCancelRenewal));
var $author$project$Common$Policy$CustomerTerminate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Common$Policy$actionCustomerTerminate = F3(
	function (policyId, earliestSelectableDate, latestSelectableDate) {
		return $author$project$Common$Policy$CustomerTerminate(
			{aZ: earliestSelectableDate, a4: latestSelectableDate, oQ: policyId});
	});
var $author$project$New$Gql$Platform$Object$CustomerTerminate$earliestSelectableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'earliestSelectableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$CustomerTerminate$latestSelectableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'latestSelectableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$CustomerTerminate$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$Common$Gql$Policy$decodeCustomerTerminateAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$CustomerTerminate$latestSelectableDate,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$CustomerTerminate$earliestSelectableDate,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$CustomerTerminate$policyId,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$actionCustomerTerminate))));
var $author$project$Common$Policy$PrimaTerminate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Common$Policy$actionPrimaTerminate = F3(
	function (policyId, earliestSelectableDate, latestSelectableDate) {
		return $author$project$Common$Policy$PrimaTerminate(
			{aZ: earliestSelectableDate, a4: latestSelectableDate, oQ: policyId});
	});
var $author$project$New$Gql$Platform$Object$PrimaTerminate$earliestSelectableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'earliestSelectableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$PrimaTerminate$latestSelectableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'latestSelectableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$PrimaTerminate$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$Common$Gql$Policy$decodePrimaTerminateAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PrimaTerminate$latestSelectableDate,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$PrimaTerminate$earliestSelectableDate,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$PrimaTerminate$policyId,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$actionPrimaTerminate))));
var $author$project$Common$Policy$Withdraw = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$Policy$actionWithdraw = F2(
	function (policyId, latestRequestableDate) {
		return $author$project$Common$Policy$Withdraw(
			{ky: latestRequestableDate, oQ: policyId});
	});
var $author$project$New$Gql$Platform$Object$Withdraw$latestRequestableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'latestRequestableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$Withdraw$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$Common$Gql$Policy$decodeWithdrawAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$Withdraw$latestRequestableDate,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$Withdraw$policyId,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$actionWithdraw)));
var $author$project$New$Gql$Platform$Union$AvailablePolicyDetailsPageActions$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CustomerTerminate', selections____.or),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PrimaTerminate', selections____.oC),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Withdraw', selections____.oK),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CancelRenewal', selections____.ok),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'AmendCustomerTermination', selections____.n0),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'AmendPrimaTermination', selections____.n2)
			]));
};
var $author$project$Common$Gql$Policy$decodeAvailableActions = $author$project$New$Gql$Platform$Union$AvailablePolicyDetailsPageActions$fragments(
	{n0: $author$project$Common$Gql$Policy$decodeAmendCustomerTerminationAction, n2: $author$project$Common$Gql$Policy$decodeAmendPrimaTerminationAction, ok: $author$project$Common$Gql$Policy$decodeCancelRenewalAction, or: $author$project$Common$Gql$Policy$decodeCustomerTerminateAction, oC: $author$project$Common$Gql$Policy$decodePrimaTerminateAction, oK: $author$project$Common$Gql$Policy$decodeWithdrawAction});
var $author$project$Common$Gql$Source$decodeFromQuoteSource = function (source) {
	switch (source) {
		case 2:
			return 0;
		case 3:
			return 1;
		case 1:
			return 3;
		default:
			return 2;
	}
};
var $author$project$Common$PolicyStatus$Active = 1;
var $author$project$Common$PolicyStatus$Expired = 3;
var $author$project$Common$PolicyStatus$GracePeriod = 2;
var $author$project$Common$PolicyStatus$Issued = 0;
var $author$project$Common$PolicyStatus$NotRenewed = 4;
var $author$project$Common$PolicyStatus$TerminatedByCustomer = 6;
var $author$project$Common$PolicyStatus$TerminatedByPrima = 7;
var $author$project$Common$PolicyStatus$Withdrawn = 5;
var $author$project$Common$Gql$Policy$decodePolicyStatus = function (status) {
	switch (status) {
		case 1:
			return 1;
		case 3:
			return 3;
		case 0:
			return 0;
		case 6:
			return 6;
		case 7:
			return 7;
		case 5:
			return 5;
		case 2:
			return 2;
		default:
			return 4;
	}
};
var $author$project$Common$Person$emptyAdditionalDriverFixture = A2(
	$author$project$Common$Person$AdditionalDriver,
	{aq: $author$project$Common$Locale$defaultDate, ar: '', aD: '', aJ: ''},
	$elm$core$Maybe$Nothing);
var $author$project$New$Gql$Platform$Object$Policy$endDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'endDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$Policy$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'id',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$New$Gql$Platform$Object$Policy$interruption = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'interruption',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Common$Policy$Interruption = F4(
	function (at, kind, reason, description) {
		return {ml: at, mN: description, c_: kind, im: reason};
	});
var $author$project$New$Gql$Platform$Object$Interruption$at = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.DateTime',
	'at',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).N.A);
var $author$project$Common$InterruptionKind$TerminationByCustomer = 1;
var $author$project$Common$InterruptionKind$TerminationByPrima = 2;
var $author$project$Common$InterruptionKind$Withdrawal = 0;
var $author$project$Common$Gql$PolicyInterruption$decodePolicyInterruptionKind = function (kind) {
	switch (kind) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Common$InterruptionReason$Chargeback = 0;
var $author$project$Common$InterruptionReason$CompetitorOffer = 1;
var $author$project$Common$InterruptionReason$CoverageChange = 2;
var $author$project$Common$InterruptionReason$DeceasedPolicyHolder = 3;
var $author$project$Common$InterruptionReason$DissatisfactionDocsRequest = 4;
var $author$project$Common$InterruptionReason$DissatisfactionService = 5;
var $author$project$Common$InterruptionReason$DoesNotKnow = 6;
var $author$project$Common$InterruptionReason$Fraud = 7;
var $author$project$Common$InterruptionReason$IncorrectDataOther = 8;
var $author$project$Common$InterruptionReason$IncorrectEffectiveDate = 9;
var $author$project$Common$InterruptionReason$IncorrectPersonalData = 10;
var $author$project$Common$InterruptionReason$IncorrectVehicleInfo = 11;
var $author$project$Common$InterruptionReason$InexactDeclaration = 12;
var $author$project$Common$InterruptionReason$InexactDeclarationDni = 13;
var $author$project$Common$InterruptionReason$InexactDeclarationSinco = 14;
var $author$project$Common$InterruptionReason$MovingToAnotherCountry = 15;
var $author$project$Common$InterruptionReason$NoInsuranceWanted = 16;
var $author$project$Common$InterruptionReason$NoReason = 17;
var $author$project$Common$InterruptionReason$Other = 18;
var $author$project$Common$InterruptionReason$PaymentMethodOrDate = 19;
var $author$project$Common$InterruptionReason$PhotoVerificationNotProvided = 32;
var $author$project$Common$InterruptionReason$PolicyHolderChange = 20;
var $author$project$Common$InterruptionReason$PriceIncrease = 31;
var $author$project$Common$InterruptionReason$ProductService = 21;
var $author$project$Common$InterruptionReason$RenewalNotProvided = 22;
var $author$project$Common$InterruptionReason$RenewalRejected = 23;
var $author$project$Common$InterruptionReason$RiskAggravation = 24;
var $author$project$Common$InterruptionReason$SwitchToGreatLakes = 33;
var $author$project$Common$InterruptionReason$UnderwritingRules = 25;
var $author$project$Common$InterruptionReason$VehicleDeregistration = 26;
var $author$project$Common$InterruptionReason$VehicleNotPurchased = 27;
var $author$project$Common$InterruptionReason$VehicleScrapped = 28;
var $author$project$Common$InterruptionReason$VehicleSold = 29;
var $author$project$Common$InterruptionReason$WantsGreenCard = 30;
var $author$project$Common$Gql$PolicyInterruption$decodePolicyInterruptionReason = function (reasonKind) {
	switch (reasonKind) {
		case 0:
			return 17;
		case 1:
			return 9;
		case 2:
			return 1;
		case 3:
			return 11;
		case 4:
			return 30;
		case 5:
			return 10;
		case 6:
			return 4;
		case 7:
			return 29;
		case 8:
			return 28;
		case 9:
			return 3;
		case 10:
			return 15;
		case 11:
			return 5;
		case 12:
			return 16;
		case 13:
			return 7;
		case 14:
			return 24;
		case 15:
			return 12;
		case 16:
			return 18;
		case 17:
			return 27;
		case 18:
			return 26;
		case 19:
			return 6;
		case 21:
			return 19;
		case 22:
			return 2;
		case 23:
			return 25;
		case 24:
			return 14;
		case 25:
			return 0;
		case 26:
			return 13;
		case 20:
			return 8;
		case 28:
			return 22;
		case 27:
			return 23;
		case 30:
			return 20;
		case 31:
			return 21;
		case 32:
			return 31;
		case 29:
			return 32;
		default:
			return 33;
	}
};
var $author$project$New$Gql$Platform$Object$Interruption$description = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'description',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Enum$InterruptionKind$TerminatedByCustomer = 1;
var $author$project$New$Gql$Platform$Enum$InterruptionKind$TerminatedByPrima = 2;
var $author$project$New$Gql$Platform$Enum$InterruptionKind$Withdrawn = 0;
var $author$project$New$Gql$Platform$Enum$InterruptionKind$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'WITHDRAWN':
				return $elm$json$Json$Decode$succeed(0);
			case 'TERMINATED_BY_CUSTOMER':
				return $elm$json$Json$Decode$succeed(1);
			case 'TERMINATED_BY_PRIMA':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid InterruptionKind type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Interruption$kind = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.InterruptionKind.InterruptionKind', 'kind', _List_Nil, $author$project$New$Gql$Platform$Enum$InterruptionKind$decoder);
var $author$project$New$Gql$Platform$Enum$InterruptionReason$Chargeback = 25;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$CompetitorOffer = 2;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$CoverageChange = 22;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$DeceasedPolicyHolder = 9;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$DissatisfactionDocsRequest = 6;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$DissatisfactionService = 11;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$DoesNotKnow = 19;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$Fraud = 13;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$IncorrectDataOther = 20;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$IncorrectEffectiveDate = 1;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$IncorrectPersonalData = 5;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$IncorrectVehicleInfo = 3;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$InexactDeclaration = 15;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$InexactDeclarationDni = 26;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$InexactDeclarationSinco = 24;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$MovingToAnotherCountry = 10;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$NoInsuranceWanted = 12;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$NoReason = 0;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$Other = 16;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$PaymentMethodOrDate = 21;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$PhotoVerificationNotProvided = 29;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$PolicyHolderChange = 30;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$PriceIncrease = 32;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$ProductService = 31;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$RenewalNotProvided = 28;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$RenewalRejected = 27;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$RiskAggravation = 14;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$SwitchToGreatLakes = 33;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$UnderwritingRules = 23;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$VehicleDeregistration = 18;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$VehicleNotPurchased = 17;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$VehicleScrapped = 8;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$VehicleSold = 7;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$WantsGreenCard = 4;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'NO_REASON':
				return $elm$json$Json$Decode$succeed(0);
			case 'INCORRECT_EFFECTIVE_DATE':
				return $elm$json$Json$Decode$succeed(1);
			case 'COMPETITOR_OFFER':
				return $elm$json$Json$Decode$succeed(2);
			case 'INCORRECT_VEHICLE_INFO':
				return $elm$json$Json$Decode$succeed(3);
			case 'WANTS_GREEN_CARD':
				return $elm$json$Json$Decode$succeed(4);
			case 'INCORRECT_PERSONAL_DATA':
				return $elm$json$Json$Decode$succeed(5);
			case 'DISSATISFACTION_DOCS_REQUEST':
				return $elm$json$Json$Decode$succeed(6);
			case 'VEHICLE_SOLD':
				return $elm$json$Json$Decode$succeed(7);
			case 'VEHICLE_SCRAPPED':
				return $elm$json$Json$Decode$succeed(8);
			case 'DECEASED_POLICY_HOLDER':
				return $elm$json$Json$Decode$succeed(9);
			case 'MOVING_TO_ANOTHER_COUNTRY':
				return $elm$json$Json$Decode$succeed(10);
			case 'DISSATISFACTION_SERVICE':
				return $elm$json$Json$Decode$succeed(11);
			case 'NO_INSURANCE_WANTED':
				return $elm$json$Json$Decode$succeed(12);
			case 'FRAUD':
				return $elm$json$Json$Decode$succeed(13);
			case 'RISK_AGGRAVATION':
				return $elm$json$Json$Decode$succeed(14);
			case 'INEXACT_DECLARATION':
				return $elm$json$Json$Decode$succeed(15);
			case 'OTHER':
				return $elm$json$Json$Decode$succeed(16);
			case 'VEHICLE_NOT_PURCHASED':
				return $elm$json$Json$Decode$succeed(17);
			case 'VEHICLE_DEREGISTRATION':
				return $elm$json$Json$Decode$succeed(18);
			case 'DOES_NOT_KNOW':
				return $elm$json$Json$Decode$succeed(19);
			case 'INCORRECT_DATA_OTHER':
				return $elm$json$Json$Decode$succeed(20);
			case 'PAYMENT_METHOD_OR_DATE':
				return $elm$json$Json$Decode$succeed(21);
			case 'COVERAGE_CHANGE':
				return $elm$json$Json$Decode$succeed(22);
			case 'UNDERWRITING_RULES':
				return $elm$json$Json$Decode$succeed(23);
			case 'INEXACT_DECLARATION_SINCO':
				return $elm$json$Json$Decode$succeed(24);
			case 'CHARGEBACK':
				return $elm$json$Json$Decode$succeed(25);
			case 'INEXACT_DECLARATION_DNI':
				return $elm$json$Json$Decode$succeed(26);
			case 'RENEWAL_REJECTED':
				return $elm$json$Json$Decode$succeed(27);
			case 'RENEWAL_NOT_PROVIDED':
				return $elm$json$Json$Decode$succeed(28);
			case 'PHOTO_VERIFICATION_NOT_PROVIDED':
				return $elm$json$Json$Decode$succeed(29);
			case 'POLICY_HOLDER_CHANGE':
				return $elm$json$Json$Decode$succeed(30);
			case 'PRODUCT_SERVICE':
				return $elm$json$Json$Decode$succeed(31);
			case 'PRICE_INCREASE':
				return $elm$json$Json$Decode$succeed(32);
			case 'SWITCH_TO_GREAT_LAKES':
				return $elm$json$Json$Decode$succeed(33);
			default:
				return $elm$json$Json$Decode$fail('Invalid InterruptionReason type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Interruption$reason = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.InterruptionReason.InterruptionReason', 'reason', _List_Nil, $author$project$New$Gql$Platform$Enum$InterruptionReason$decoder);
var $author$project$Common$Gql$Policy$interruptionSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$Interruption$description,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$PolicyInterruption$decodePolicyInterruptionReason, $author$project$New$Gql$Platform$Object$Interruption$reason),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$PolicyInterruption$decodePolicyInterruptionKind, $author$project$New$Gql$Platform$Object$Interruption$kind),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$Interruption$at,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$Interruption)))));
var $author$project$New$Gql$Platform$Object$Policy$isARenewal = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isARenewal', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$New$Gql$Platform$Object$Policy$lastWithdrawableDay = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe NewScalarCodecs.Date)',
	'lastWithdrawableDay',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A));
var $author$project$New$Gql$Platform$Object$Policy$mainDriver = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'mainDriver', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$MainDriver$address = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'address', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$Address$postalCode = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'postalCode', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Address$province = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'province', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Address$streetName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'streetName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Object$Address$streetNumber = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'streetNumber',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$Policy$addressSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$Address$postalCode,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$Address$province,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$Address$streetNumber),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$Address$streetName),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Address$Address)))));
var $author$project$New$Gql$Platform$Object$MainDriver$dateOfBirth = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'dateOfBirth',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$MainDriver$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$MainDriver$firstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'firstName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$MainDriver$lastName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Policy$mainDriverPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$MainDriver$dateOfBirth,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$MainDriver$documentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$MainDriver$lastName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$MainDriver$firstName,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Policy$mainDriverSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	$elm$core$Maybe$Nothing,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
		'',
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$MainDriver$address($author$project$Common$Gql$Policy$addressSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$Policy$mainDriverPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Driver)))));
var $author$project$Common$Policy$Policy = $elm$core$Basics$identity;
var $author$project$Common$Policy$new = function (id) {
	return function (applicationId) {
		return function (quoteId) {
			return function (customerFacingId) {
				return function (startDate) {
					return function (endDate) {
						return function (purchaseDate) {
							return function (lastWithdrawableDay) {
								return function (status) {
									return function (interruption) {
										return function (product) {
											return function (mainDriver) {
												return function (policyHolder) {
													return function (vehicleOwner) {
														return function (additionalDriver) {
															return function (claimsDeclaredWithFault) {
																return function (vehicle) {
																	return function (coverContinuity) {
																		return function (isARenewal) {
																			return function (renewalPolicyId) {
																				return function (renewalCancellation) {
																					return function (source) {
																						return function (availableActions) {
																							return {jb: additionalDriver, fO: applicationId, aS: availableActions, f5: claimsDeclaredWithFault, jG: coverContinuity, mI: customerFacingId, et: endDate, kg: id, cV: interruption, gZ: isARenewal, c0: lastWithdrawableDay, eU: mainDriver, ib: policyHolder, av: product, ik: purchaseDate, o_: quoteId, iq: renewalCancellation, ir: renewalPolicyId, iA: source, lL: startDate, dx: status, i$: vehicle, l$: vehicleOwner};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$New$Gql$Platform$Union$ClaimsCount$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Exactly', selections____.ot),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Atleast', selections____.n5)
			]));
};
var $author$project$New$Gql$Platform$Object$Atleast$count = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'count', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Common$Gql$ClaimsCount$newAtLeastTotalClaimsDeclaredWithFaultSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Count$minimum, $author$project$New$Gql$Platform$Object$Atleast$count);
var $author$project$New$Gql$Platform$Object$Exactly$count = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'count', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Common$Gql$ClaimsCount$newCountTotalClaimsDeclaredWithFaultSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Count$exact, $author$project$New$Gql$Platform$Object$Exactly$count);
var $author$project$Common$Gql$ClaimsCount$newClaimsDeclaredWithFaultSelectionSet = $author$project$New$Gql$Platform$Union$ClaimsCount$fragments(
	{n5: $author$project$Common$Gql$ClaimsCount$newAtLeastTotalClaimsDeclaredWithFaultSelectionSet, ot: $author$project$Common$Gql$ClaimsCount$newCountTotalClaimsDeclaredWithFaultSelectionSet});
var $author$project$New$Gql$Platform$Union$CoverContinuityInfo$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NoPreviousCoverage', selections____.kV),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'TercerosBasicoSelected', selections____.k7),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoverageWithNoContinuityInformation', selections____.k_),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoveragePendingContinuityInformation', selections____.kZ),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoverageAndSelectedTercerosAmpliado', selections____.kW),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoverageAndSelectedTodoRiesgo', selections____.kX),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousPrimaBasicoCoverage', selections____.k0),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousPrimaAmpliadoCoverage', selections____.k$),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousPrimaTodoRiesgoCoverage', selections____.k1),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoverageGivenOnCheck24', selections____.kY)
			]));
};
var $author$project$Common$Gql$CoverContinuity$onNewNoPreviousCoverageSelectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newCoverContinuityWithNoPreviousPolicy);
var $author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTercerosAmpliado$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTercerosAmpliado$hadLunas = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadLunas', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoverageAndSelectedTercerosAmpliadoSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTercerosAmpliado$hadLunas,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTercerosAmpliado$companyName,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalCoverContinuityTercerosAmpliado)));
var $author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$hadDanosPropios = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadDanosPropios', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$hadLunas = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadLunas', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoverageAndSelectedTodoRiesgoSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$hadDanosPropios,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$hadLunas,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$companyName,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalCoverContinuityTodoRiesgo))));
var $author$project$New$Gql$Platform$Object$PreviousExternalCoverageGivenOnCheck24$bundleName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'bundleName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PreviousExternalCoverageGivenOnCheck24$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoverageGivenOnCheck24SelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PreviousExternalCoverageGivenOnCheck24$bundleName,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$PreviousExternalCoverageGivenOnCheck24$companyName,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalCoverageGivenOnCheck24)));
var $author$project$New$Gql$Platform$Object$PreviousExternalCoveragePendingContinuityInformation$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoveragePendingContinuityInformationSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PreviousExternalCoveragePendingContinuityInformation$companyName,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newCoverContinuityPendingInfo));
var $author$project$New$Gql$Platform$Object$PreviousExternalCoverageWithNoContinuityInformation$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoverageWithNoContinuityInformationSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PreviousExternalCoverageWithNoContinuityInformation$companyName,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalCoverageWithNoCoverContinuityInformation));
var $author$project$New$Gql$Platform$Object$PreviousPrimaAmpliadoCoverage$hadLunas = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadLunas', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$Gql$CoverContinuity$onNewPreviousPrimaAmpliadoCoverageSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PreviousPrimaAmpliadoCoverage$hadLunas,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPrimaCoverContinuityTercerosAmpliado));
var $author$project$Common$Gql$CoverContinuity$onNewPreviousPrimaBasicoCoverageSelectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPrimaTercerosBasicoSelected);
var $author$project$New$Gql$Platform$Object$PreviousPrimaTodoRiesgoCoverage$hadDanosPropios = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadDanosPropios', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$New$Gql$Platform$Object$PreviousPrimaTodoRiesgoCoverage$hadLunas = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadLunas', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$Gql$CoverContinuity$onNewPreviousPrimaTodoRiesgoCoverageSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PreviousPrimaTodoRiesgoCoverage$hadDanosPropios,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$PreviousPrimaTodoRiesgoCoverage$hadLunas,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPrimaCoverContinuityTodoRiesgo)));
var $author$project$New$Gql$Platform$Object$TercerosBasicoSelected$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$CoverContinuity$onNewTercerosBasicoSelectedSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$TercerosBasicoSelected$companyName,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalTercerosBasicoSelected));
var $author$project$Common$Gql$CoverContinuity$newCoverContinuitySelectionSet = $author$project$New$Gql$Platform$Union$CoverContinuityInfo$fragments(
	{kV: $author$project$Common$Gql$CoverContinuity$onNewNoPreviousCoverageSelectionSet, kW: $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoverageAndSelectedTercerosAmpliadoSelectionSet, kX: $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoverageAndSelectedTodoRiesgoSelectionSet, kY: $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoverageGivenOnCheck24SelectionSet, kZ: $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoveragePendingContinuityInformationSelectionSet, k_: $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoverageWithNoContinuityInformationSelectionSet, k$: $author$project$Common$Gql$CoverContinuity$onNewPreviousPrimaAmpliadoCoverageSelectionSet, k0: $author$project$Common$Gql$CoverContinuity$onNewPreviousPrimaBasicoCoverageSelectionSet, k1: $author$project$Common$Gql$CoverContinuity$onNewPreviousPrimaTodoRiesgoCoverageSelectionSet, k7: $author$project$Common$Gql$CoverContinuity$onNewTercerosBasicoSelectedSelectionSet});
var $author$project$New$Gql$Platform$Enum$VehicleModification$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'TINTED_WINDOWS';
		case 1:
			return 'XENON_HEADLIGHTS';
		case 2:
			return 'TOWBALL';
		case 3:
			return 'RIMS';
		case 4:
			return 'SKIRTS';
		case 5:
			return 'SPOILERS';
		case 6:
			return 'EXHAUST_PIPE';
		case 7:
			return 'ENGINE';
		default:
			return 'OTHER';
	}
};
var $author$project$Common$Gql$Vehicle$decodeModification = $author$project$New$Gql$Platform$Enum$VehicleModification$toString;
var $author$project$Common$Gql$Vehicle$decodeModifications = $elm$core$List$map($author$project$Common$Gql$Vehicle$decodeModification);
var $author$project$New$Gql$Platform$Enum$FuelType$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'DIESEL';
		case 1:
			return 'GASOLINE';
		case 2:
			return 'ELECTRIC';
		case 3:
			return 'LIQUID_GAS';
		case 4:
			return 'HYDROGEN';
		case 5:
			return 'HYBRID_ELECTRIC_GASOLINE';
		case 6:
			return 'HYBRID_ELECTRIC_DIESEL';
		case 7:
			return 'HYBRID_PLUGIN_ELECTRIC_GASOLINE';
		case 8:
			return 'HYBRID_PLUGIN_ELECTRIC_DIESEL';
		case 9:
			return 'BIO_ETHANOL';
		case 10:
			return 'ELECTRIC_WITH_GASOLINE_BATTERY';
		case 11:
			return 'ELECTRIC_WITH_HYDROGEN_FUEL_CELL';
		default:
			return 'MILD_HYBRID_ELECTRIC_GASOLINE';
	}
};
var $author$project$Common$Gql$Vehicle$decodeNewFuelType = function (fuelType) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$New$Gql$Platform$Enum$FuelType$toString, fuelType));
};
var $author$project$Common$Gql$Vehicle$decodeNewMileage = function (mileage) {
	if (!mileage.$) {
		switch (mileage.a) {
			case 0:
				var _v1 = mileage.a;
				return 'Up to 2000';
			case 1:
				var _v2 = mileage.a;
				return '2000 - 4000';
			case 2:
				var _v3 = mileage.a;
				return '4000 - 6000';
			case 3:
				var _v4 = mileage.a;
				return '6000 - 8000';
			case 4:
				var _v5 = mileage.a;
				return '8000 - 10000';
			case 5:
				var _v6 = mileage.a;
				return '10000 - 12000';
			case 6:
				var _v7 = mileage.a;
				return '12000 - 14000';
			case 7:
				var _v8 = mileage.a;
				return '14000 - 16000';
			case 8:
				var _v9 = mileage.a;
				return '16000 - 18000';
			case 9:
				var _v10 = mileage.a;
				return '18000 - 20000';
			case 10:
				var _v11 = mileage.a;
				return '20000 - 22000';
			case 11:
				var _v12 = mileage.a;
				return '22000 - 24000';
			case 12:
				var _v13 = mileage.a;
				return '24000 - 26000';
			case 13:
				var _v14 = mileage.a;
				return '26000 - 28000';
			case 14:
				var _v15 = mileage.a;
				return '28000 - 30000';
			case 15:
				var _v16 = mileage.a;
				return '30000 - 32000';
			case 16:
				var _v17 = mileage.a;
				return '32000 - 34000';
			case 17:
				var _v18 = mileage.a;
				return '34000 - 36000';
			case 18:
				var _v19 = mileage.a;
				return '36000 - 38000';
			case 19:
				var _v20 = mileage.a;
				return '38000 - 40000';
			case 20:
				var _v21 = mileage.a;
				return '40000 - 45000';
			case 21:
				var _v22 = mileage.a;
				return '45000 - 50000';
			case 22:
				var _v23 = mileage.a;
				return 'More than 50000';
			case 23:
				var _v24 = mileage.a;
				return 'Up to 6000';
			case 24:
				var _v25 = mileage.a;
				return '6000 - 10000';
			case 25:
				var _v26 = mileage.a;
				return '10000 - 14000';
			case 26:
				var _v27 = mileage.a;
				return '14000 - 20000';
			case 27:
				var _v28 = mileage.a;
				return '20000 - 30000';
			default:
				var _v29 = mileage.a;
				return '30000 - 50000';
		}
	} else {
		return '';
	}
};
var $author$project$New$Gql$Platform$Enum$VehicleUse$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'OCCASIONAL';
		case 1:
			return 'HABITUAL';
		case 2:
			return 'PROFESSIONAL_OCCASIONAL';
		default:
			return 'PROFESSIONAL_HABITUAL';
	}
};
var $author$project$Common$Gql$Vehicle$decodeNewUsage = function (usage) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$New$Gql$Platform$Enum$VehicleUse$toString, usage));
};
var $author$project$New$Gql$Platform$Object$Vehicle$enginePower = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Int)',
	'enginePower',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$New$Gql$Platform$Enum$Mileage$From10To12 = 5;
var $author$project$New$Gql$Platform$Enum$Mileage$From10To14 = 25;
var $author$project$New$Gql$Platform$Enum$Mileage$From12To14 = 6;
var $author$project$New$Gql$Platform$Enum$Mileage$From14To16 = 7;
var $author$project$New$Gql$Platform$Enum$Mileage$From14To20 = 26;
var $author$project$New$Gql$Platform$Enum$Mileage$From16To18 = 8;
var $author$project$New$Gql$Platform$Enum$Mileage$From18To20 = 9;
var $author$project$New$Gql$Platform$Enum$Mileage$From20To22 = 10;
var $author$project$New$Gql$Platform$Enum$Mileage$From20To30 = 27;
var $author$project$New$Gql$Platform$Enum$Mileage$From22To24 = 11;
var $author$project$New$Gql$Platform$Enum$Mileage$From24To26 = 12;
var $author$project$New$Gql$Platform$Enum$Mileage$From26To28 = 13;
var $author$project$New$Gql$Platform$Enum$Mileage$From28To30 = 14;
var $author$project$New$Gql$Platform$Enum$Mileage$From2To4 = 1;
var $author$project$New$Gql$Platform$Enum$Mileage$From30To32 = 15;
var $author$project$New$Gql$Platform$Enum$Mileage$From30To50 = 28;
var $author$project$New$Gql$Platform$Enum$Mileage$From32To34 = 16;
var $author$project$New$Gql$Platform$Enum$Mileage$From34To36 = 17;
var $author$project$New$Gql$Platform$Enum$Mileage$From36To38 = 18;
var $author$project$New$Gql$Platform$Enum$Mileage$From38To40 = 19;
var $author$project$New$Gql$Platform$Enum$Mileage$From40To45 = 20;
var $author$project$New$Gql$Platform$Enum$Mileage$From45To50 = 21;
var $author$project$New$Gql$Platform$Enum$Mileage$From4To6 = 2;
var $author$project$New$Gql$Platform$Enum$Mileage$From6To10 = 24;
var $author$project$New$Gql$Platform$Enum$Mileage$From6To8 = 3;
var $author$project$New$Gql$Platform$Enum$Mileage$From8To10 = 4;
var $author$project$New$Gql$Platform$Enum$Mileage$MoreThan50 = 22;
var $author$project$New$Gql$Platform$Enum$Mileage$UpTo2 = 0;
var $author$project$New$Gql$Platform$Enum$Mileage$UpTo6 = 23;
var $author$project$New$Gql$Platform$Enum$Mileage$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'UP_TO_2':
				return $elm$json$Json$Decode$succeed(0);
			case 'FROM_2_TO_4':
				return $elm$json$Json$Decode$succeed(1);
			case 'FROM_4_TO_6':
				return $elm$json$Json$Decode$succeed(2);
			case 'FROM_6_TO_8':
				return $elm$json$Json$Decode$succeed(3);
			case 'FROM_8_TO_10':
				return $elm$json$Json$Decode$succeed(4);
			case 'FROM_10_TO_12':
				return $elm$json$Json$Decode$succeed(5);
			case 'FROM_12_TO_14':
				return $elm$json$Json$Decode$succeed(6);
			case 'FROM_14_TO_16':
				return $elm$json$Json$Decode$succeed(7);
			case 'FROM_16_TO_18':
				return $elm$json$Json$Decode$succeed(8);
			case 'FROM_18_TO_20':
				return $elm$json$Json$Decode$succeed(9);
			case 'FROM_20_TO_22':
				return $elm$json$Json$Decode$succeed(10);
			case 'FROM_22_TO_24':
				return $elm$json$Json$Decode$succeed(11);
			case 'FROM_24_TO_26':
				return $elm$json$Json$Decode$succeed(12);
			case 'FROM_26_TO_28':
				return $elm$json$Json$Decode$succeed(13);
			case 'FROM_28_TO_30':
				return $elm$json$Json$Decode$succeed(14);
			case 'FROM_30_TO_32':
				return $elm$json$Json$Decode$succeed(15);
			case 'FROM_32_TO_34':
				return $elm$json$Json$Decode$succeed(16);
			case 'FROM_34_TO_36':
				return $elm$json$Json$Decode$succeed(17);
			case 'FROM_36_TO_38':
				return $elm$json$Json$Decode$succeed(18);
			case 'FROM_38_TO_40':
				return $elm$json$Json$Decode$succeed(19);
			case 'FROM_40_TO_45':
				return $elm$json$Json$Decode$succeed(20);
			case 'FROM_45_TO_50':
				return $elm$json$Json$Decode$succeed(21);
			case 'MORE_THAN_50':
				return $elm$json$Json$Decode$succeed(22);
			case 'UP_TO_6':
				return $elm$json$Json$Decode$succeed(23);
			case 'FROM_6_TO_10':
				return $elm$json$Json$Decode$succeed(24);
			case 'FROM_10_TO_14':
				return $elm$json$Json$Decode$succeed(25);
			case 'FROM_14_TO_20':
				return $elm$json$Json$Decode$succeed(26);
			case 'FROM_20_TO_30':
				return $elm$json$Json$Decode$succeed(27);
			case 'FROM_30_TO_50':
				return $elm$json$Json$Decode$succeed(28);
			default:
				return $elm$json$Json$Decode$fail('Invalid Mileage type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Vehicle$expectedMileage = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.Mileage.Mileage)',
	'expectedMileage',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$New$Gql$Platform$Enum$Mileage$decoder));
var $author$project$Common$Locale$formatDate = function (date) {
	return _Utils_eq(date, $author$project$Common$Locale$defaultDate) ? '' : A2($justinmimbs$date$Date$format, 'dd/MM/y', date);
};
var $author$project$New$Gql$Platform$Enum$FuelType$BioEthanol = 9;
var $author$project$New$Gql$Platform$Enum$FuelType$Diesel = 0;
var $author$project$New$Gql$Platform$Enum$FuelType$Electric = 2;
var $author$project$New$Gql$Platform$Enum$FuelType$ElectricWithGasolineBattery = 10;
var $author$project$New$Gql$Platform$Enum$FuelType$ElectricWithHydrogenFuelCell = 11;
var $author$project$New$Gql$Platform$Enum$FuelType$Gasoline = 1;
var $author$project$New$Gql$Platform$Enum$FuelType$HybridElectricDiesel = 6;
var $author$project$New$Gql$Platform$Enum$FuelType$HybridElectricGasoline = 5;
var $author$project$New$Gql$Platform$Enum$FuelType$HybridPluginElectricDiesel = 8;
var $author$project$New$Gql$Platform$Enum$FuelType$HybridPluginElectricGasoline = 7;
var $author$project$New$Gql$Platform$Enum$FuelType$Hydrogen = 4;
var $author$project$New$Gql$Platform$Enum$FuelType$LiquidGas = 3;
var $author$project$New$Gql$Platform$Enum$FuelType$MildHybridElectricGasoline = 12;
var $author$project$New$Gql$Platform$Enum$FuelType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'DIESEL':
				return $elm$json$Json$Decode$succeed(0);
			case 'GASOLINE':
				return $elm$json$Json$Decode$succeed(1);
			case 'ELECTRIC':
				return $elm$json$Json$Decode$succeed(2);
			case 'LIQUID_GAS':
				return $elm$json$Json$Decode$succeed(3);
			case 'HYDROGEN':
				return $elm$json$Json$Decode$succeed(4);
			case 'HYBRID_ELECTRIC_GASOLINE':
				return $elm$json$Json$Decode$succeed(5);
			case 'HYBRID_ELECTRIC_DIESEL':
				return $elm$json$Json$Decode$succeed(6);
			case 'HYBRID_PLUGIN_ELECTRIC_GASOLINE':
				return $elm$json$Json$Decode$succeed(7);
			case 'HYBRID_PLUGIN_ELECTRIC_DIESEL':
				return $elm$json$Json$Decode$succeed(8);
			case 'BIO_ETHANOL':
				return $elm$json$Json$Decode$succeed(9);
			case 'ELECTRIC_WITH_GASOLINE_BATTERY':
				return $elm$json$Json$Decode$succeed(10);
			case 'ELECTRIC_WITH_HYDROGEN_FUEL_CELL':
				return $elm$json$Json$Decode$succeed(11);
			case 'MILD_HYBRID_ELECTRIC_GASOLINE':
				return $elm$json$Json$Decode$succeed(12);
			default:
				return $elm$json$Json$Decode$fail('Invalid FuelType type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Vehicle$fuelType = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.FuelType.FuelType)',
	'fuelType',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$New$Gql$Platform$Enum$FuelType$decoder));
var $author$project$New$Gql$Platform$Object$Vehicle$maker = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'maker', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Vehicle$model = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'model', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Enum$VehicleModification$Engine = 7;
var $author$project$New$Gql$Platform$Enum$VehicleModification$ExhaustPipe = 6;
var $author$project$New$Gql$Platform$Enum$VehicleModification$Other = 8;
var $author$project$New$Gql$Platform$Enum$VehicleModification$Rims = 3;
var $author$project$New$Gql$Platform$Enum$VehicleModification$Skirts = 4;
var $author$project$New$Gql$Platform$Enum$VehicleModification$Spoilers = 5;
var $author$project$New$Gql$Platform$Enum$VehicleModification$TintedWindows = 0;
var $author$project$New$Gql$Platform$Enum$VehicleModification$Towball = 2;
var $author$project$New$Gql$Platform$Enum$VehicleModification$XenonHeadlights = 1;
var $author$project$New$Gql$Platform$Enum$VehicleModification$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'TINTED_WINDOWS':
				return $elm$json$Json$Decode$succeed(0);
			case 'XENON_HEADLIGHTS':
				return $elm$json$Json$Decode$succeed(1);
			case 'TOWBALL':
				return $elm$json$Json$Decode$succeed(2);
			case 'RIMS':
				return $elm$json$Json$Decode$succeed(3);
			case 'SKIRTS':
				return $elm$json$Json$Decode$succeed(4);
			case 'SPOILERS':
				return $elm$json$Json$Decode$succeed(5);
			case 'EXHAUST_PIPE':
				return $elm$json$Json$Decode$succeed(6);
			case 'ENGINE':
				return $elm$json$Json$Decode$succeed(7);
			case 'OTHER':
				return $elm$json$Json$Decode$succeed(8);
			default:
				return $elm$json$Json$Decode$fail('Invalid VehicleModification type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Vehicle$modifications = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List Enum.VehicleModification.VehicleModification)',
	'modifications',
	_List_Nil,
	$elm$json$Json$Decode$list($author$project$New$Gql$Platform$Enum$VehicleModification$decoder));
var $author$project$New$Gql$Platform$Object$Vehicle$plateNumber = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'plateNumber', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Vehicle$registrationDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe NewScalarCodecs.Date)',
	'registrationDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A));
var $author$project$New$Gql$Platform$Enum$VehicleUse$Habitual = 1;
var $author$project$New$Gql$Platform$Enum$VehicleUse$Occasional = 0;
var $author$project$New$Gql$Platform$Enum$VehicleUse$ProfessionalHabitual = 3;
var $author$project$New$Gql$Platform$Enum$VehicleUse$ProfessionalOccasional = 2;
var $author$project$New$Gql$Platform$Enum$VehicleUse$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'OCCASIONAL':
				return $elm$json$Json$Decode$succeed(0);
			case 'HABITUAL':
				return $elm$json$Json$Decode$succeed(1);
			case 'PROFESSIONAL_OCCASIONAL':
				return $elm$json$Json$Decode$succeed(2);
			case 'PROFESSIONAL_HABITUAL':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Invalid VehicleUse type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Vehicle$usage = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.VehicleUse.VehicleUse)',
	'usage',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$New$Gql$Platform$Enum$VehicleUse$decoder));
var $author$project$New$Gql$Platform$Object$Vehicle$version = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'version', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Vehicle$newVehicleSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeModifications, $author$project$New$Gql$Platform$Object$Vehicle$modifications),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$Vehicle$enginePower,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$Vehicle$version,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeNewFuelType, $author$project$New$Gql$Platform$Object$Vehicle$fuelType),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeNewUsage, $author$project$New$Gql$Platform$Object$Vehicle$usage),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
							'',
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
								$elm$core$Maybe$map($author$project$Common$Locale$formatDate),
								$author$project$New$Gql$Platform$Object$Vehicle$registrationDate)),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeNewMileage, $author$project$New$Gql$Platform$Object$Vehicle$expectedMileage),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$New$Gql$Platform$Object$Vehicle$plateNumber,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$New$Gql$Platform$Object$Vehicle$maker,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$New$Gql$Platform$Object$Vehicle$model,
										$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Vehicle$new)))))))))));
var $author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'policy', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$Policy$policyHolder = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'policyHolder', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$PolicyHolder$address = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'address',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Common$Gql$Policy$decodeDocumentKind = function (status) {
	if (!status) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$New$Gql$Platform$Enum$DocumentKind$Dni = 0;
var $author$project$New$Gql$Platform$Enum$DocumentKind$Nie = 1;
var $author$project$New$Gql$Platform$Enum$DocumentKind$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'DNI':
				return $elm$json$Json$Decode$succeed(0);
			case 'NIE':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid DocumentKind type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicyHolder$documentKind = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.DocumentKind.DocumentKind', 'documentKind', _List_Nil, $author$project$New$Gql$Platform$Enum$DocumentKind$decoder);
var $author$project$New$Gql$Platform$Object$PolicyHolder$email = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'email', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicyHolder$phoneNumber = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'phoneNumber', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Policy$policyHolderContactsSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PolicyHolder$phoneNumber,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$PolicyHolder$email,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Contacts)));
var $author$project$New$Gql$Platform$Object$PolicyHolder$dateOfBirth = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'dateOfBirth',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$PolicyHolder$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicyHolder$firstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'firstName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicyHolder$lastName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Policy$policyHolderPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PolicyHolder$dateOfBirth,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$PolicyHolder$documentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$PolicyHolder$lastName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$PolicyHolder$firstName,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Policy$policyHolderSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Policy$decodeDocumentKind, $author$project$New$Gql$Platform$Object$PolicyHolder$documentKind),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Common$Gql$Policy$policyHolderContactsSelectionSet,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
				$author$project$Common$Address$defaultAddress,
				$author$project$New$Gql$Platform$Object$PolicyHolder$address($author$project$Common$Gql$Policy$addressSelectionSet)),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$Policy$policyHolderPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PolicyHolder)))));
var $author$project$New$Gql$Platform$Object$Policy$product = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'product', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Product$PolicyProduct = F4(
	function (bundleSlug, annualPrice, issuingCompany, chosenExcess) {
		return {jd: annualPrice, mt: bundleSlug, f3: chosenExcess, a3: issuingCompany};
	});
var $author$project$New$Gql$Platform$Object$Product$bundleSlug = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BundleSlug.BundleSlug', 'bundleSlug', _List_Nil, $author$project$New$Gql$Platform$Enum$BundleSlug$decoder);
var $author$project$New$Gql$Platform$Object$Product$chosenExcess = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe NewScalarCodecs.Decimal)',
	'chosenExcess',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).my.A));
var $author$project$Common$IssuingCompany$GreatLakes = 1;
var $author$project$Common$IssuingCompany$Iptiq = 0;
var $author$project$Common$Gql$IssuingCompany$decodeIssuingCompany = function (issuingCompany) {
	if (!issuingCompany) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$New$Gql$Platform$Enum$IssuingCompany$GreatLakes = 1;
var $author$project$New$Gql$Platform$Enum$IssuingCompany$Iptiq = 0;
var $author$project$New$Gql$Platform$Enum$IssuingCompany$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'IPTIQ':
				return $elm$json$Json$Decode$succeed(0);
			case 'GREAT_LAKES':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid IssuingCompany type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Product$issuingCompany = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.IssuingCompany.IssuingCompany', 'issuingCompany', _List_Nil, $author$project$New$Gql$Platform$Enum$IssuingCompany$decoder);
var $author$project$New$Gql$Platform$Object$Product$priceBreakdown = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'priceBreakdown', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$gross = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'gross',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).my.A);
var $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$net = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'net',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).my.A);
var $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$taxIps = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'taxIps',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).my.A);
var $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$taxSurcharges = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'taxSurcharges',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).my.A);
var $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$taxes = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'taxes',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).my.A);
var $author$project$Common$Gql$PolicyProduct$priceBreakdownSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$taxSurcharges),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$taxIps),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$net),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$taxes),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$gross),
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Product$AnnualPrice))))));
var $author$project$Common$Gql$PolicyProduct$policyProductSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$Maybe$map($author$project$Common$Price$euro),
		$author$project$New$Gql$Platform$Object$Product$chosenExcess),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$IssuingCompany$decodeIssuingCompany, $author$project$New$Gql$Platform$Object$Product$issuingCompany),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$Product$priceBreakdown($author$project$Common$Gql$PolicyProduct$priceBreakdownSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$BundleSlug$decodeNewBundleSlug, $author$project$New$Gql$Platform$Object$Product$bundleSlug),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Product$PolicyProduct)))));
var $author$project$Common$Gql$Policy$productSelectionSet = $author$project$Common$Gql$PolicyProduct$policyProductSelectionSet;
var $author$project$New$Gql$Platform$Object$Policy$purchasedDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'purchasedDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$Policy$quoteId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe NewScalarCodecs.Uuid)',
	'quoteId',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A));
var $author$project$New$Gql$Platform$Object$Policy$renewalCancellation = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'renewalCancellation',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Common$Policy$RenewalCancellation = F2(
	function (reason, description) {
		return {mN: description, im: reason};
	});
var $author$project$New$Gql$Platform$Object$RenewalCancellation$description = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'description',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Object$RenewalCancellation$reason = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.InterruptionReason.InterruptionReason', 'reason', _List_Nil, $author$project$New$Gql$Platform$Enum$InterruptionReason$decoder);
var $author$project$Common$Gql$Policy$renewalCancellationSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$RenewalCancellation$description,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$PolicyInterruption$decodePolicyInterruptionReason, $author$project$New$Gql$Platform$Object$RenewalCancellation$reason),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$RenewalCancellation)));
var $author$project$New$Gql$Platform$Object$Policy$renewalPolicyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe NewScalarCodecs.Uuid)',
	'renewalPolicyId',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A));
var $author$project$New$Gql$Platform$Enum$QuoteSource$Acierto = 2;
var $author$project$New$Gql$Platform$Enum$QuoteSource$Check24 = 3;
var $author$project$New$Gql$Platform$Enum$QuoteSource$Dts = 0;
var $author$project$New$Gql$Platform$Enum$QuoteSource$Rastreator = 1;
var $author$project$New$Gql$Platform$Enum$QuoteSource$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'DTS':
				return $elm$json$Json$Decode$succeed(0);
			case 'RASTREATOR':
				return $elm$json$Json$Decode$succeed(1);
			case 'ACIERTO':
				return $elm$json$Json$Decode$succeed(2);
			case 'CHECK_24':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Invalid QuoteSource type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Policy$source = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.QuoteSource.QuoteSource', 'source', _List_Nil, $author$project$New$Gql$Platform$Enum$QuoteSource$decoder);
var $author$project$New$Gql$Platform$Object$Policy$startDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'startDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Enum$PolicyStatus$Active = 1;
var $author$project$New$Gql$Platform$Enum$PolicyStatus$Expired = 3;
var $author$project$New$Gql$Platform$Enum$PolicyStatus$GracePeriod = 2;
var $author$project$New$Gql$Platform$Enum$PolicyStatus$Issued = 0;
var $author$project$New$Gql$Platform$Enum$PolicyStatus$NotRenewed = 4;
var $author$project$New$Gql$Platform$Enum$PolicyStatus$TerminatedByCustomer = 6;
var $author$project$New$Gql$Platform$Enum$PolicyStatus$TerminatedByPrima = 7;
var $author$project$New$Gql$Platform$Enum$PolicyStatus$Withdrawn = 5;
var $author$project$New$Gql$Platform$Enum$PolicyStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'ISSUED':
				return $elm$json$Json$Decode$succeed(0);
			case 'ACTIVE':
				return $elm$json$Json$Decode$succeed(1);
			case 'GRACE_PERIOD':
				return $elm$json$Json$Decode$succeed(2);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(3);
			case 'NOT_RENEWED':
				return $elm$json$Json$Decode$succeed(4);
			case 'WITHDRAWN':
				return $elm$json$Json$Decode$succeed(5);
			case 'TERMINATED_BY_CUSTOMER':
				return $elm$json$Json$Decode$succeed(6);
			case 'TERMINATED_BY_PRIMA':
				return $elm$json$Json$Decode$succeed(7);
			default:
				return $elm$json$Json$Decode$fail('Invalid PolicyStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Policy$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.PolicyStatus.PolicyStatus', 'status', _List_Nil, $author$project$New$Gql$Platform$Enum$PolicyStatus$decoder);
var $author$project$New$Gql$Platform$Object$Policy$vehicle = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'vehicle', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$Policy$vehicleOwner = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'vehicleOwner', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Person$VehicleOwner = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$New$Gql$Platform$Object$VehicleOwner$address = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'address',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$New$Gql$Platform$Object$VehicleOwner$dateOfBirth = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'dateOfBirth',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$VehicleOwner$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$VehicleOwner$firstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'firstName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$VehicleOwner$lastName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Policy$vehicleOwnerPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$VehicleOwner$dateOfBirth,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$VehicleOwner$documentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$VehicleOwner$lastName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$VehicleOwner$firstName,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Policy$vehicleOwnerSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
		$author$project$Common$Address$defaultAddress,
		$author$project$New$Gql$Platform$Object$VehicleOwner$address($author$project$Common$Gql$Policy$addressSelectionSet)),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Common$Gql$Policy$vehicleOwnerPersonDataSelectionSet,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$VehicleOwner)));
var $author$project$Common$Gql$Policy$policySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$availableActions($author$project$Common$Gql$Policy$decodeAvailableActions),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			$author$project$Common$Gql$Source$decodeFromQuoteSource,
			$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$source)),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy(
				$author$project$New$Gql$Platform$Object$Policy$renewalCancellation($author$project$Common$Gql$Policy$renewalCancellationSelectionSet)),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$renewalPolicyId),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$isARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$coverContinuityInfo($author$project$Common$Gql$CoverContinuity$newCoverContinuitySelectionSet),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy(
								$author$project$New$Gql$Platform$Object$Policy$vehicle($author$project$Common$Gql$Vehicle$newVehicleSelectionSet)),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
									$author$project$Common$Count$default,
									$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$claimsDeclaredWithFault($author$project$Common$Gql$ClaimsCount$newClaimsDeclaredWithFaultSelectionSet)),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
										$author$project$Common$Person$emptyAdditionalDriverFixture,
										$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy(
											$author$project$New$Gql$Platform$Object$Policy$additionalDriver($author$project$Common$Gql$Policy$additionalDriverSelectionSet))),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy(
											$author$project$New$Gql$Platform$Object$Policy$vehicleOwner($author$project$Common$Gql$Policy$vehicleOwnerSelectionSet)),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy(
												$author$project$New$Gql$Platform$Object$Policy$policyHolder($author$project$Common$Gql$Policy$policyHolderSelectionSet)),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy(
													$author$project$New$Gql$Platform$Object$Policy$mainDriver($author$project$Common$Gql$Policy$mainDriverSelectionSet)),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy(
														$author$project$New$Gql$Platform$Object$Policy$product($author$project$Common$Gql$Policy$productSelectionSet)),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy(
															$author$project$New$Gql$Platform$Object$Policy$interruption($author$project$Common$Gql$Policy$interruptionSelectionSet)),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																$author$project$Common$Gql$Policy$decodePolicyStatus,
																$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$status)),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$lastWithdrawableDay),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$purchasedDate),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$endDate),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$startDate),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$customerFacingId),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																						$elm$core$Maybe$map($author$project$Common$QuoteId$new),
																						$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$quoteId)),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																							$author$project$Common$ApplicationId$new,
																							$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$applicationId)),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$id),
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$new))))))))))))))))))))))));
var $author$project$Common$Gql$ClaimHistory$pricingActionByPolicyIdRequiredArguments = function (policyId) {
	return $author$project$Gql$Platform$Query$PricingActionRequiredArguments(
		{
			F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			k: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				{
					oQ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(policyId)
				})
		});
};
var $author$project$Common$Gql$ClaimHistory$pricingActionByPolicyIdQuery = function (policyId) {
	return $author$project$Common$Gql$ClaimHistory$pricingActionQuery(
		$author$project$Common$Gql$ClaimHistory$pricingActionByPolicyIdRequiredArguments(policyId));
};
var $author$project$New$Gql$Platform$InputObject$encodePrimaTerminatePolicyInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$NewScalarCodecs$codecs)(input____.kg))),
				_Utils_Tuple2(
				'requestedAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.N;
						},
						$author$project$NewScalarCodecs$codecs)(input____.h))),
				_Utils_Tuple2(
				'interruptionAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.N;
						},
						$author$project$NewScalarCodecs$codecs)(input____.a1))),
				_Utils_Tuple2(
				'reason',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString, input____.im))),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$New$Gql$Platform$Mutation$primaTerminatePolicy = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'primaTerminatePolicy',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nm, $author$project$New$Gql$Platform$InputObject$encodePrimaTerminatePolicyInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Page$PolicyDetails$Gql$primaTerminatePolicy = function (_v0) {
	var id = _v0.kg;
	var requestedAt = _v0.h;
	var interruptionAt = _v0.a1;
	var reason = _v0.im;
	var description = _v0.mN;
	return {
		nm: {
			mN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(description),
			kg: id,
			a1: interruptionAt,
			im: reason,
			h: requestedAt
		}
	};
};
var $author$project$New$Gql$Platform$Object$PrimaTerminatePolicyOutput$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$Page$PolicyDetails$Gql$primaTerminatePolicySelectionSet = $author$project$New$Gql$Platform$Object$PrimaTerminatePolicyOutput$policyId;
var $author$project$Page$PolicyDetails$Ports$requestIssueRefundReleaseDate = _Platform_outgoingPort(
	'requestIssueRefundReleaseDate',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$New$Gql$Platform$InputObject$SendPolicyContractEmailInput = function (policyId) {
	return {oQ: policyId};
};
var $author$project$Page$PolicyDetails$Gql$sendPolicyContract = function (policyId) {
	return {
		nm: $author$project$New$Gql$Platform$InputObject$SendPolicyContractEmailInput(policyId)
	};
};
var $author$project$New$Gql$Platform$InputObject$encodeSendPolicyContractEmailInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$NewScalarCodecs$codecs)(input____.oQ)))
			]));
};
var $author$project$New$Gql$Platform$Mutation$sendPolicyContractEmail = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'sendPolicyContractEmail',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nm, $author$project$New$Gql$Platform$InputObject$encodeSendPolicyContractEmailInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$New$Gql$Platform$Object$SendPolicyContractEmailOutput$success = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'success', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Page$PolicyDetails$Gql$sendPolicyContractSelectionSet = $author$project$New$Gql$Platform$Object$SendPolicyContractEmailOutput$success;
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Gql$Platform$InputObject$BackofficeUpdatePolicyholderEmailInput = F2(
	function (policyCustomerFacingId, newEmailAddress) {
		return {c8: newEmailAddress, df: policyCustomerFacingId};
	});
var $author$project$Page$PolicyDetails$Gql$updateEmail = F2(
	function (policyCfid, email) {
		return {
			nm: A2($author$project$Gql$Platform$InputObject$BackofficeUpdatePolicyholderEmailInput, policyCfid, email)
		};
	});
var $author$project$New$Gql$Platform$Object$UpdatePolicyHolderEmailOutput$success = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'success', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Page$PolicyDetails$Gql$updateEmailSelectionSet = $author$project$New$Gql$Platform$Object$UpdatePolicyHolderEmailOutput$success;
var $author$project$New$Gql$Platform$InputObject$encodeUpdatePolicyHolderEmailInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyCustomerFacingId',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.df))),
				_Utils_Tuple2(
				'newEmailAddress',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.c8)))
			]));
};
var $author$project$New$Gql$Platform$Mutation$updatePolicyHolderEmail = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'updatePolicyHolderEmail',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nm, $author$project$New$Gql$Platform$InputObject$encodeUpdatePolicyHolderEmailInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Tracker$Policy = 1;
var $author$project$Tracker$userSendEmailPayloadForPolicy = function (emails) {
	return {gu: emails, gx: 1};
};
var $author$project$Page$PolicyDetails$Gql$withdrawPolicy = function (_v0) {
	var id = _v0.kg;
	var requestedAt = _v0.h;
	var reason = _v0.im;
	var description = _v0.mN;
	return {
		nm: {
			mN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(description),
			kg: id,
			im: reason,
			h: requestedAt
		}
	};
};
var $author$project$New$Gql$Platform$Object$CustomerWithdrawPolicyOutput$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$Page$PolicyDetails$Gql$withdrawPolicySelectionSet = $author$project$New$Gql$Platform$Object$CustomerWithdrawPolicyOutput$policyId;
var $author$project$Page$PolicyDetails$Effect$runEffect = F3(
	function (env, model, effect) {
		switch (effect.$) {
			case 31:
				return $elm$core$Platform$Cmd$none;
			case 7:
				var cmd = effect.a;
				return cmd;
			case 0:
				var id = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'policyDetails',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					A2(
						$author$project$New$Gql$Platform$Query$policyDetails,
						$author$project$Common$Gql$Policy$policyByIdRequiredArguments(id),
						$author$project$Common$Gql$Policy$policySelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$FetchedPolicy));
			case 1:
				var quoteId = effect.a;
				return A4(
					$author$project$Api$executeGraphqlOperation,
					env,
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					A2(
						$author$project$Gql$Platform$Query$claimsHistory,
						$author$project$Common$Gql$ClaimHistory$claimHistoryByQuoteIdRequiredArguments(
							$author$project$Common$QuoteId$toUuid(quoteId)),
						$author$project$Common$Gql$ClaimHistory$claimHistorySelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$FetchedClaimHistory));
			case 2:
				var offerId = effect.a;
				return A4(
					$author$project$Api$executeGraphqlOperation,
					env,
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$CustomerId$getCustomerId(
						$author$project$Common$Gql$CustomerId$PolicyId(offerId)),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$FetchedCustomerId));
			case 4:
				var policyId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'fetchCoverSelection',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$CoverSelection$getCoverSelection(
						$author$project$Common$Gql$CoverSelection$PolicyId(policyId)),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$FetchedCoverSelection));
			case 3:
				var policyId = effect.a;
				return A4(
					$author$project$Api$executeGraphqlOperation,
					env,
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$ClaimHistory$pricingActionByPolicyIdQuery(policyId),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$FetchedClaimHistoryPricingAction));
			case 11:
				var _arguments = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'customerWithdrawPolicy',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$customerWithdrawPolicy,
						$author$project$Page$PolicyDetails$Gql$withdrawPolicy(_arguments),
						$author$project$Page$PolicyDetails$Gql$withdrawPolicySelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$InterruptionResponseReceived));
			case 12:
				var _arguments = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'customerTerminatePolicy',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$customerTerminatePolicy,
						$author$project$Page$PolicyDetails$Gql$customerTerminatePolicy(_arguments),
						$author$project$Page$PolicyDetails$Gql$customerTerminatePolicySelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$InterruptionResponseReceived));
			case 13:
				var _arguments = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'primaTerminatePolicy',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$primaTerminatePolicy,
						$author$project$Page$PolicyDetails$Gql$primaTerminatePolicy(_arguments),
						$author$project$Page$PolicyDetails$Gql$primaTerminatePolicySelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$InterruptionResponseReceived));
			case 8:
				return A2($elm$core$Task$perform, $author$project$Page$PolicyDetails$Msg$GotCurrentTime, $elm$time$Time$now);
			case 9:
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						A2($author$project$Page$PolicyDetails$Effect$executeCheckEligibilityQuery, env, $author$project$Page$PolicyDetails$Msg$GotExpectedRefund),
						$author$project$Page$PolicyDetails$Effect$createCheckEligibilityArgument(model)));
			case 10:
				var policyId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'getRefund',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$GetRefund$getRefundQuery(policyId),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$GotRefund));
			case 30:
				var policyId = effect.a;
				return A2(
					$elm$core$Task$perform,
					$elm$core$Basics$always(
						$author$project$Page$PolicyDetails$Msg$WaitedBeforePollingRefundCompletion(policyId)),
					$elm$core$Process$sleep(500.0));
			case 29:
				var policyId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'getRefund',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$GetRefund$getRefundQuery(policyId),
					A2(
						$elm$core$Basics$composeR,
						$krisajenkins$remotedata$RemoteData$fromResult,
						$author$project$Page$PolicyDetails$Msg$PolledForRefundCompletion(policyId)));
			case 28:
				var originalRefund = effect.a;
				var policyId = effect.b;
				return A2(
					$elm$core$Task$perform,
					$elm$core$Basics$always(
						A2($author$project$Page$PolicyDetails$Msg$WaitedBeforePollingRefundUpdate, originalRefund, policyId)),
					$elm$core$Process$sleep(500.0));
			case 27:
				var originalRefund = effect.a;
				var policyId = effect.b;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'getRefund',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$GetRefund$getRefundQuery(policyId),
					A2(
						$elm$core$Basics$composeR,
						$krisajenkins$remotedata$RemoteData$fromResult,
						A2($author$project$Page$PolicyDetails$Msg$PolledForRefundUpdate, originalRefund, policyId)));
			case 14:
				var policyId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'createRefund',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$createRefund,
						$author$project$Page$PolicyDetails$Gql$createRefund(policyId),
						$author$project$Page$PolicyDetails$Gql$createRefundSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$CreateRefundResponseReceived));
			case 15:
				var refund = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'issueRefund',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$issueRefund,
						$author$project$Page$PolicyDetails$Gql$issueRefund(
							$author$project$Common$Refund$pickId(refund)),
						$author$project$Page$PolicyDetails$Gql$issueRefundSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$IssueRefundResponseReceived));
			case 16:
				var refund = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'payRefund',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$payRefund,
						$author$project$Page$PolicyDetails$Gql$payRefund(
							$author$project$Common$Refund$pickId(refund)),
						$author$project$Page$PolicyDetails$Gql$payRefundSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$IssueRefundResponseReceived));
			case 17:
				return $author$project$Page$PolicyDetails$Ports$requestIssueRefundReleaseDate(0);
			case 19:
				var policyId = effect.a;
				return A4(
					$author$project$Api$executeGraphqlOperation,
					env,
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$PaymentMethod$getPaymentMethod(
						$author$project$Common$Gql$PaymentMethod$PolicyId(policyId)),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$FetchedPaymentMethod));
			case 18:
				var _arguments = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'customerDeclineRenewal',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$customerDeclineRenewal,
						$author$project$Page$PolicyDetails$Gql$declineRenewal(_arguments),
						$author$project$Page$PolicyDetails$Gql$declineRenewalSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$RenewalCancellationResponseReceived));
			case 20:
				var policyId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'sendPolicyContractEmail',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$sendPolicyContractEmail,
						$author$project$Page$PolicyDetails$Gql$sendPolicyContract(policyId),
						$author$project$Page$PolicyDetails$Gql$sendPolicyContractSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$SendPolicyContractEmailResponseReceived));
			case 21:
				var email = effect.a;
				var policyCfid = effect.b;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'updatePolicyHolderEmail',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$updatePolicyHolderEmail,
						A2($author$project$Page$PolicyDetails$Gql$updateEmail, policyCfid, email),
						$author$project$Page$PolicyDetails$Gql$updateEmailSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$GotChangeEmailResponse));
			case 22:
				var emailOptions = effect.a;
				return $author$project$Tracker$publishUserEvent(
					$author$project$Tracker$userSendEmailEvent(
						$author$project$Tracker$userSendEmailPayloadForPolicy(emailOptions)));
			case 23:
				var args = effect.a;
				var hasInterruptionDateChanged = effect.b;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'amendTermination',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$amendTermination,
						$author$project$Page$PolicyDetails$Gql$amendCustomerInterruption(args),
						$author$project$Page$PolicyDetails$Gql$amendTerminationSelectionSet),
					A2(
						$elm$core$Basics$composeR,
						$krisajenkins$remotedata$RemoteData$fromResult,
						$author$project$Page$PolicyDetails$Msg$AmendInterruptionResponseReceived(hasInterruptionDateChanged)));
			case 24:
				var args = effect.a;
				var hasInterruptionDateChanged = effect.b;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'amendTermination',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$amendTermination,
						$author$project$Page$PolicyDetails$Gql$amendCompanyInterruption(args),
						$author$project$Page$PolicyDetails$Gql$amendTerminationSelectionSet),
					A2(
						$elm$core$Basics$composeR,
						$krisajenkins$remotedata$RemoteData$fromResult,
						$author$project$Page$PolicyDetails$Msg$AmendInterruptionResponseReceived(hasInterruptionDateChanged)));
			case 25:
				var reason = effect.a;
				var args = effect.b;
				var hasInterruptionDateChanged = effect.c;
				return A4(
					$author$project$Api$executeGraphqlOperation,
					env,
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2($author$project$Page$PolicyDetails$Effect$amendDateInterruptionArgs, reason, args),
					A2(
						$elm$core$Basics$composeR,
						$krisajenkins$remotedata$RemoteData$fromResult,
						$author$project$Page$PolicyDetails$Msg$AmendInterruptionResponseReceived(hasInterruptionDateChanged)));
			case 26:
				var reason = effect.a;
				var policyId = effect.b;
				var interruptionAt = effect.c;
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						A2($author$project$Page$PolicyDetails$Effect$executeCheckEligibilityQuery, env, $author$project$Page$PolicyDetails$Msg$GotAmendExpectedRefund),
						A3($author$project$Page$PolicyDetails$Effect$getExpectedRefundForAmendInterruption, reason, policyId, interruptionAt)));
			case 5:
				return $elm$core$Platform$Cmd$none;
			default:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						A2($author$project$Page$PolicyDetails$Effect$runEffect, env, model),
						effects));
		}
	});
var $author$project$Page$Search$Msg$GotCurrentDate = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Search$Msg$GotNewResults = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Search$Msg$GotResults = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Search$Msg$RewriteUrl = function (a) {
	return {$: 6, a: a};
};
var $primait$prima_elm_extra$PrimaCmd$fromMsg = A2(
	$elm$core$Basics$composeL,
	$elm$core$Task$perform($elm$core$Basics$identity),
	$elm$core$Task$succeed);
var $author$project$New$Gql$Platform$InputObject$encodeSearchInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyCustomerFacingId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.df, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'offerCustomerFacingId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bZ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'policyHolderEmail',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b4, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'plateNumber',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ia, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'policyHolderPhoneNumber',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b5, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'policyHolderDocumentId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'customerId',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.gi,
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$NewScalarCodecs$codecs)))
			]));
};
var $author$project$New$Gql$Platform$Query$search = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'search',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nm, $author$project$New$Gql$Platform$InputObject$encodeSearchInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Page$Search$SearchResult$SearchResult = F3(
	function (offers, policies, quotes) {
		return {kM: offers, lf: policies, o$: quotes};
	});
var $author$project$Gql$Platform$Query$QuoteRequiredArguments = function (identifier) {
	return {bM: identifier};
};
var $author$project$Common$Gql$Quote$findQuoteArguments = function (customerFacingId) {
	return $author$project$Gql$Platform$Query$QuoteRequiredArguments(
		{
			mI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(customerFacingId),
			o_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
		});
};
var $author$project$Common$Quote$Quote = F9(
	function (id, customerFacingId, creationDate, endDate, status, vehicle, source, funnelGuaranteeSelectionUrl, policyholderEmail) {
		return {gd: creationDate, mI: customerFacingId, et: endDate, m4: funnelGuaranteeSelectionUrl, kg: id, oR: policyholderEmail, iA: source, dx: status, i$: vehicle};
	});
var $author$project$Gql$Platform$Object$BackofficeQuote$customerFacingId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'customerFacingId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeQuote$applicationSource = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeApplicationSource.BackofficeApplicationSource', 'applicationSource', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeApplicationSource$decoder);
var $author$project$Common$Gql$Quote$decodeApplicationSource = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$ApplicationSource$decodeApplicationSource, $author$project$Gql$Platform$Object$BackofficeQuote$applicationSource);
var $author$project$Gql$Platform$Object$BackofficeQuote$vehicleData = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'vehicleData', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Quote$decodePartialVehicle = $author$project$Gql$Platform$Object$BackofficeQuote$vehicleData($author$project$Common$Gql$Vehicle$partialVehicleOwnerSelectionSet);
var $author$project$Common$Quote$Active = 0;
var $author$project$Common$Quote$Blocked = 2;
var $author$project$Common$Quote$Expired = 1;
var $author$project$Common$Gql$Quote$decodeQuoteStatus = function (status) {
	switch (status) {
		case 0:
			return 0;
		case 2:
			return 2;
		default:
			return 1;
	}
};
var $author$project$Gql$Platform$Object$BackofficeQuote$funnelGuaranteeSelectionUrl = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'funnelGuaranteeSelectionUrl', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeQuote$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'id',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).t.A);
var $author$project$Gql$Platform$Object$BackofficeQuote$policyholderEmail = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'policyholderEmail',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $justinmimbs$timezone_data$TimeZone$Specification$DateTime = F5(
	function (year, month, day, time, clock) {
		return {aB: clock, mJ: day, nM: month, iR: time, pG: year};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$Rules = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$WallClock = 2;
var $justinmimbs$timezone_data$TimeZone$Specification$Zone = F2(
	function (history, current) {
		return {ge: current, _: history};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$ZoneState = F2(
	function (standardOffset, zoneRules) {
		return {iC: standardOffset, i9: zoneRules};
	});
var $justinmimbs$timezone_data$TimeZone$maxYear = 2037;
var $justinmimbs$timezone_data$TimeZone$minYear = 1970;
var $justinmimbs$timezone_data$TimeZone$Specification$Universal = 0;
var $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch = function (_v0) {
	dropChangesBeforeEpoch:
	while (true) {
		var initial = _v0.a;
		var changes = _v0.b;
		if (changes.b) {
			var change = changes.a;
			var rest = changes.b;
			if (change.l <= 0) {
				var $temp$_v0 = _Utils_Tuple2(change.e, rest);
				_v0 = $temp$_v0;
				continue dropChangesBeforeEpoch;
			} else {
				return _Utils_Tuple2(initial, changes);
			}
		} else {
			return _Utils_Tuple2(initial, _List_Nil);
		}
	}
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $justinmimbs$timezone_data$RataDie$weekdayNumber = function (rd) {
	var _v0 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v0) {
		return 7;
	} else {
		var n = _v0;
		return n;
	}
};
var $justinmimbs$timezone_data$RataDie$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$timezone_data$RataDie$floorWeekday = F2(
	function (weekday, rd) {
		var daysSincePreviousWeekday = A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$timezone_data$RataDie$weekdayNumber(rd) + 7) - $justinmimbs$timezone_data$RataDie$weekdayToNumber(weekday));
		return rd - daysSincePreviousWeekday;
	});
var $justinmimbs$timezone_data$RataDie$ceilingWeekday = F2(
	function (weekday, rd) {
		var floored = A2($justinmimbs$timezone_data$RataDie$floorWeekday, weekday, rd);
		return _Utils_eq(rd, floored) ? rd : (floored + 7);
	});
var $justinmimbs$timezone_data$RataDie$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$timezone_data$RataDie$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$timezone_data$RataDie$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
	return (365 * y) + leapYears;
};
var $justinmimbs$timezone_data$RataDie$dayOfMonth = F3(
	function (y, m, d) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + d;
	});
var $justinmimbs$timezone_data$RataDie$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$timezone_data$RataDie$lastOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + A2($justinmimbs$timezone_data$RataDie$daysInMonth, y, m);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie = function (rd) {
	return (rd - 719163) * 1440;
};
var $elm$core$List$sortBy = _List_sortBy;
var $justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment = F2(
	function (clock, _v0) {
		var standard = _v0.aP;
		var save = _v0.J;
		switch (clock) {
			case 0:
				return 0;
			case 1:
				return 0 - standard;
			default:
				return 0 - (standard + save);
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime = function (_v0) {
	var year = _v0.pG;
	var month = _v0.nM;
	var day = _v0.mJ;
	var time = _v0.iR;
	return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
		A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, month, day)) + time;
};
var $justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime = F2(
	function (offset, datetime) {
		return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime(datetime) + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, datetime.aB, offset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges = F5(
	function (previousOffset, start, until, standardOffset, rules) {
		var transitions = A2(
			$elm$core$List$concatMap,
			function (year) {
				return A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.l;
					},
					A2(
						$elm$core$List$map,
						function (rule) {
							return {
								aB: rule.aB,
								J: rule.J,
								l: $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
									function () {
										var _v2 = rule.mJ;
										switch (_v2.$) {
											case 0:
												var day = _v2.a;
												return A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.nM, day);
											case 1:
												var weekday = _v2.a;
												var after = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$ceilingWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.nM, after));
											case 2:
												var weekday = _v2.a;
												var before = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.nM, before));
											default:
												var weekday = _v2.a;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A2($justinmimbs$timezone_data$RataDie$lastOfMonth, year, rule.nM));
										}
									}()) + rule.iR
							};
						},
						A2(
							$elm$core$List$filter,
							function (rule) {
								return (_Utils_cmp(rule.j3, year) < 1) && (_Utils_cmp(year, rule.lU) < 1);
							},
							rules)));
			},
			A2($elm$core$List$range, start.pG - 1, until.pG));
		var initialOffset = {J: 0, aP: standardOffset};
		var initialChange = {
			e: standardOffset,
			l: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
		};
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (transition, _v1) {
					var currentOffset = _v1.a;
					var changes = _v1.b;
					var newOffset = {J: transition.J, aP: standardOffset};
					if (_Utils_cmp(
						transition.l + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.aB, previousOffset),
						initialChange.l) < 1) {
						var updatedInitialChange = {e: standardOffset + transition.J, l: initialChange.l};
						return _Utils_Tuple2(
							newOffset,
							_List_fromArray(
								[updatedInitialChange]));
					} else {
						if (_Utils_cmp(
							transition.l + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.aB, currentOffset),
							A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, currentOffset, until)) < 0) {
							var change = {
								e: standardOffset + transition.J,
								l: transition.l + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.aB, currentOffset)
							};
							return _Utils_Tuple2(
								newOffset,
								A2($elm$core$List$cons, change, changes));
						} else {
							return _Utils_Tuple2(currentOffset, changes);
						}
					}
				}),
			_Utils_Tuple2(
				initialOffset,
				_List_fromArray(
					[initialChange])),
			transitions);
		var nextOffset = _v0.a;
		var descendingChanges = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(descendingChanges),
			nextOffset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges = F4(
	function (previousOffset, start, until, _v0) {
		var standardOffset = _v0.iC;
		var zoneRules = _v0.i9;
		if (!zoneRules.$) {
			var save = zoneRules.a;
			return _Utils_Tuple2(
				_List_fromArray(
					[
						{
						e: standardOffset + save,
						l: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
					}
					]),
				{J: save, aP: standardOffset});
		} else {
			var rules = zoneRules.a;
			return A5($justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges, previousOffset, start, until, standardOffset, rules);
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp = F4(
	function (f, a, rev, list) {
		stripDuplicatesByHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$List$reverse(rev);
			} else {
				var x = list.a;
				var xs = list.b;
				var b = f(x);
				var rev_ = (!_Utils_eq(a, b)) ? A2($elm$core$List$cons, x, rev) : rev;
				var $temp$f = f,
					$temp$a = b,
					$temp$rev = rev_,
					$temp$list = xs;
				f = $temp$f;
				a = $temp$a;
				rev = $temp$rev;
				list = $temp$list;
				continue stripDuplicatesByHelp;
			}
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges = F3(
	function (zoneStart, zoneUntil, zone) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, _v2) {
					var state = _v1.a;
					var nextStart = _v1.b;
					var start = _v2.a;
					var ranges = _v2.b;
					return _Utils_Tuple2(
						nextStart,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple3(start, state, nextStart),
							ranges));
				}),
			_Utils_Tuple2(zoneStart, _List_Nil),
			zone._);
		var currentStart = _v0.a;
		var historyRanges = _v0.b;
		return $elm$core$List$reverse(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple3(currentStart, zone.ge, zoneUntil),
				historyRanges));
	});
var $justinmimbs$timezone_data$TimeZone$Specification$toOffsets = F3(
	function (minYear, maxYear, zone) {
		var initialState = function () {
			var _v5 = zone._;
			if (_v5.b) {
				var _v6 = _v5.a;
				var earliest = _v6.a;
				return earliest;
			} else {
				return zone.ge;
			}
		}();
		var initialOffset = {
			J: function () {
				var _v4 = initialState.i9;
				if (!_v4.$) {
					var save = _v4.a;
					return save;
				} else {
					return 0;
				}
			}(),
			aP: initialState.iC
		};
		var ascendingChanges = A4(
			$justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp,
			function ($) {
				return $.e;
			},
			initialOffset.aP + initialOffset.J,
			_List_Nil,
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v1, _v2) {
						var start = _v1.a;
						var state = _v1.b;
						var until = _v1.c;
						var prevOffset = _v2.a;
						var prevChanges = _v2.b;
						var _v3 = A4($justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges, prevOffset, start, until, state);
						var nextChanges = _v3.a;
						var nextOffset = _v3.b;
						return _Utils_Tuple2(
							nextOffset,
							_Utils_ap(prevChanges, nextChanges));
					}),
				_Utils_Tuple2(initialOffset, _List_Nil),
				A3(
					$justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges,
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, minYear, 0, 1, 0, 0),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, maxYear + 1, 0, 1, 0, 0),
					zone)).b);
		var _v0 = $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch(
			_Utils_Tuple2(initialOffset.aP + initialOffset.J, ascendingChanges));
		var initial = _v0.a;
		var ascending = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(ascending),
			initial);
	});
var $justinmimbs$timezone_data$TimeZone$fromSpecification = function (zone) {
	var _v0 = A3($justinmimbs$timezone_data$TimeZone$Specification$toOffsets, $justinmimbs$timezone_data$TimeZone$minYear, $justinmimbs$timezone_data$TimeZone$maxYear, zone);
	var descending = _v0.a;
	var bottom = _v0.b;
	return A2($elm$time$Time$customZone, bottom, descending);
};
var $justinmimbs$timezone_data$TimeZone$Specification$Day = function (a) {
	return {$: 0, a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Last = function (a) {
	return {$: 3, a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Next = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$Rule = F7(
	function (from, to, month, day, time, clock, save) {
		return {aB: clock, mJ: day, j3: from, nM: month, J: save, iR: time, lU: to};
	});
var $justinmimbs$timezone_data$TimeZone$rules_EU = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$Specification$Standard = 1;
var $justinmimbs$timezone_data$TimeZone$rules_Spain = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 12),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__madrid = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Spain)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $author$project$Common$Locale$customerTimeZone = $justinmimbs$timezone_data$TimeZone$europe__madrid(0);
var $author$project$Common$Locale$posixToCustomerDate = function (time) {
	return A2($justinmimbs$date$Date$fromPosix, $author$project$Common$Locale$customerTimeZone, time);
};
var $author$project$Gql$Platform$Object$BackofficeQuote$quotedAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.DateTime',
	'quotedAt',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).N.A);
var $author$project$Gql$Platform$Enum$BackofficeQuoteStatus$Active = 0;
var $author$project$Gql$Platform$Enum$BackofficeQuoteStatus$Blocked = 2;
var $author$project$Gql$Platform$Enum$BackofficeQuoteStatus$Expired = 1;
var $author$project$Gql$Platform$Enum$BackofficeQuoteStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'ACTIVE':
				return $elm$json$Json$Decode$succeed(0);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(1);
			case 'BLOCKED':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeQuoteStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeQuote$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeQuoteStatus.BackofficeQuoteStatus', 'status', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeQuoteStatus$decoder);
var $author$project$Gql$Platform$Object$BackofficeQuote$validUntil = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.DateTime',
	'validUntil',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).N.A);
var $author$project$Common$Gql$Quote$findQuoteSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeQuote$policyholderEmail,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeQuote$funnelGuaranteeSelectionUrl,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Common$Gql$Quote$decodeApplicationSource,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$Quote$decodePartialVehicle,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Quote$decodeQuoteStatus, $author$project$Gql$Platform$Object$BackofficeQuote$status),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Locale$posixToCustomerDate, $author$project$Gql$Platform$Object$BackofficeQuote$validUntil),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Locale$posixToCustomerDate, $author$project$Gql$Platform$Object$BackofficeQuote$quotedAt),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Gql$Platform$Object$BackofficeQuote$customerFacingId,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficeQuote$id,
									$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Quote$Quote))))))))));
var $author$project$Gql$Platform$InputObject$encodeQuoteIdentifier = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'customerFacingId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mI, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'quoteId',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.o_,
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$ScalarCodecs$codecs)))
			]));
};
var $author$project$Gql$Platform$Query$quote = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'quote',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'identifier', requiredArgs____.bM, $author$project$Gql$Platform$InputObject$encodeQuoteIdentifier)
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Common$Gql$Quote$findQuoteQuery = function (findQuoteArg) {
	return A2(
		$author$project$Gql$Platform$Query$quote,
		$author$project$Common$Gql$Quote$findQuoteArguments(findQuoteArg),
		$author$project$Common$Gql$Quote$findQuoteSelectionSet);
};
var $author$project$Page$Search$Gql$offerRequiredArguments = function (cfid) {
	return $author$project$Gql$Platform$Query$OfferV2RequiredArguments(
		{
			mI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(cfid),
			n$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
		});
};
var $author$project$Gql$Platform$Query$offersByApplicationId = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'offersByApplicationId',
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
					'applicationId',
					requiredArgs____.fO,
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.t;
						},
						$author$project$ScalarCodecs$codecs))
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Gql$Platform$Query$OffersByApplicationIdRequiredArguments = function (applicationId) {
	return {fO: applicationId};
};
var $author$project$Page$Search$Gql$offersByApplicationId = $author$project$Gql$Platform$Query$OffersByApplicationIdRequiredArguments;
var $author$project$Gql$Platform$Query$OffersV2RequiredArguments = function (by) {
	return {d2: by};
};
var $author$project$Page$Search$Gql$offersByDocumentIdArgument = function (documentId) {
	return $author$project$Gql$Platform$Query$OffersV2RequiredArguments(
		{
			ar: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(documentId),
			eq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			h8: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			ia: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
		});
};
var $author$project$Page$Search$Gql$offersByEmailArgument = function (email) {
	return $author$project$Gql$Platform$Query$OffersV2RequiredArguments(
		{
			ar: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			eq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(email),
			h8: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			ia: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
		});
};
var $author$project$Page$Search$Gql$offersByPhoneNumberArgument = function (phone) {
	return $author$project$Gql$Platform$Query$OffersV2RequiredArguments(
		{
			ar: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			eq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			h8: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(phone),
			ia: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
		});
};
var $author$project$Page$Search$Gql$offersByPlateNumberArgument = function (plateNumber) {
	return $author$project$Gql$Platform$Query$OffersV2RequiredArguments(
		{
			ar: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			eq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			h8: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			ia: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(plateNumber)
		});
};
var $author$project$Gql$Platform$InputObject$encodeFindOfferCriteria = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'documentId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ar, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'email',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eq, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'phoneNumber',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h8, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'plateNumber',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ia, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$Gql$Platform$Query$offersV2 = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'offersV2',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'by', requiredArgs____.d2, $author$project$Gql$Platform$InputObject$encodeFindOfferCriteria)
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Page$Search$Gql$searchQuery = function (searchInputString) {
	var searchResult = $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Search$SearchResult$SearchResult);
	var noSearchQuery = A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
		_List_Nil,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
			_List_Nil,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded, _List_Nil, searchResult)));
	switch (searchInputString.$) {
		case 0:
			var documentId = searchInputString.a;
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
				_List_Nil,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
					_List_Nil,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2(
							$author$project$Gql$Platform$Query$offersV2,
							$author$project$Page$Search$Gql$offersByDocumentIdArgument(documentId),
							$author$project$Common$Gql$Offer$offerSelectionSet),
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Search$SearchResult$SearchResult))));
		case 1:
			switch (searchInputString.a.$) {
				case 0:
					return A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
						_List_Nil,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
							_List_Nil,
							A2($dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded, _List_Nil, searchResult)));
				case 1:
					var oId = searchInputString.a.a;
					return A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
						_List_Nil,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
							_List_Nil,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Maybe$map($elm$core$List$singleton),
										$elm$core$Maybe$withDefault(_List_Nil)),
									A2(
										$author$project$Gql$Platform$Query$offerV2,
										$author$project$Page$Search$Gql$offerRequiredArguments(oId),
										$author$project$Common$Gql$Offer$offerSelectionSet)),
								searchResult)));
				default:
					var qId = searchInputString.a.a;
					return A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map($elm$core$List$singleton),
								$elm$core$Maybe$withDefault(_List_Nil)),
							$author$project$Common$Gql$Quote$findQuoteQuery(qId)),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
							_List_Nil,
							A2($dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded, _List_Nil, searchResult)));
			}
		case 3:
			return noSearchQuery;
		case 2:
			var email = searchInputString.a;
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
				_List_Nil,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
					_List_Nil,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2(
							$author$project$Gql$Platform$Query$offersV2,
							$author$project$Page$Search$Gql$offersByEmailArgument(email),
							$author$project$Common$Gql$Offer$offerSelectionSet),
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Search$SearchResult$SearchResult))));
		case 4:
			var plateNumber = searchInputString.a;
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
				_List_Nil,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
					_List_Nil,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2(
							$author$project$Gql$Platform$Query$offersV2,
							$author$project$Page$Search$Gql$offersByPlateNumberArgument(plateNumber),
							$author$project$Common$Gql$Offer$offerSelectionSet),
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Search$SearchResult$SearchResult))));
		case 5:
			var phone = searchInputString.a;
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
				_List_Nil,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
					_List_Nil,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2(
							$author$project$Gql$Platform$Query$offersV2,
							$author$project$Page$Search$Gql$offersByPhoneNumberArgument(phone),
							$author$project$Common$Gql$Offer$offerSelectionSet),
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Search$SearchResult$SearchResult))));
		default:
			var customerId = searchInputString.a;
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
				_List_Nil,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
					_List_Nil,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2(
							$author$project$Gql$Platform$Query$offersByApplicationId,
							$author$project$Page$Search$Gql$offersByApplicationId(customerId),
							$author$project$Common$Gql$Offer$offerSelectionSet),
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Search$SearchResult$SearchResult))));
	}
};
var $author$project$Page$Search$NewGql$emptySearchArgs = {gi: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ia: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, df: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, b3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, b4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, b5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent};
var $author$project$Page$Search$NewGql$searchRequiredArg = function (searchInput) {
	switch (searchInput.$) {
		case 0:
			var documentId = searchInput.a;
			return {
				nm: _Utils_update(
					$author$project$Page$Search$NewGql$emptySearchArgs,
					{
						b3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(documentId)
					})
			};
		case 1:
			switch (searchInput.a.$) {
				case 0:
					var cfid = searchInput.a.a;
					return {
						nm: _Utils_update(
							$author$project$Page$Search$NewGql$emptySearchArgs,
							{
								df: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(cfid)
							})
					};
				case 1:
					var cfid = searchInput.a.a;
					return {
						nm: _Utils_update(
							$author$project$Page$Search$NewGql$emptySearchArgs,
							{
								bZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(cfid)
							})
					};
				default:
					return {nm: $author$project$Page$Search$NewGql$emptySearchArgs};
			}
		case 2:
			var email = searchInput.a;
			return {
				nm: _Utils_update(
					$author$project$Page$Search$NewGql$emptySearchArgs,
					{
						b4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(email)
					})
			};
		case 3:
			return {nm: $author$project$Page$Search$NewGql$emptySearchArgs};
		case 4:
			var plateNumber = searchInput.a;
			return {
				nm: _Utils_update(
					$author$project$Page$Search$NewGql$emptySearchArgs,
					{
						ia: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(plateNumber)
					})
			};
		case 5:
			var phoneNumber = searchInput.a;
			return {
				nm: _Utils_update(
					$author$project$Page$Search$NewGql$emptySearchArgs,
					{
						b5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(phoneNumber)
					})
			};
		default:
			var customerId = searchInput.a;
			return {
				nm: _Utils_update(
					$author$project$Page$Search$NewGql$emptySearchArgs,
					{
						gi: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(customerId)
					})
			};
	}
};
var $author$project$Page$Search$NewSearchResult$new = F2(
	function (offers, policies) {
		return {kM: offers, lf: policies};
	});
var $author$project$New$Gql$Platform$Object$OfferSearchResult$bundleSlug = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BundleSlug.BundleSlug', 'bundleSlug', _List_Nil, $author$project$New$Gql$Platform$Enum$BundleSlug$decoder);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$creationDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'creationDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$customerFacingId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'customerFacingId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Page$Search$NewGql$decodeGrossPrice = function (decimalPrice) {
	return $author$project$Common$Price$euro(decimalPrice);
};
var $author$project$Page$Search$NewGql$decodeOfferBy = function (source) {
	switch (source) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		default:
			return 2;
	}
};
var $author$project$Page$Search$NewGql$decodeOfferStatus = function (status) {
	switch (status) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		default:
			return 8;
	}
};
var $author$project$New$Gql$Platform$Object$OfferSearchResult$grossPrice = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'grossPrice',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).my.A);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'id',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$isAGreatLakesRenewal = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isAGreatLakesRenewal', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$isARenewal = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isARenewal', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$isCustomerInformationComplete = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isCustomerInformationComplete', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$mainDriverBirthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'mainDriverBirthDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$mainDriverProvince = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'mainDriverProvince', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$mainDriverRecentInsuranceCompanyName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'mainDriverRecentInsuranceCompanyName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Page$Search$OfferSearchResult$OfferSearchResult = $elm$core$Basics$identity;
var $author$project$Page$Search$OfferSearchResult$new = function (id) {
	return function (customerFacingId) {
		return function (status) {
			return function (grossPrice) {
				return function (vehiclePlateNumber) {
					return function (vehicleModel) {
						return function (vehicleMake) {
							return function (policyholderDni) {
								return function (mainDriverBirthDate) {
									return function (bundleSlug) {
										return function (offerBy) {
											return function (startDate) {
												return function (creationDate) {
													return function (mainDriverRecentInsuranceCompanyName) {
														return function (mainDriverProvince) {
															return function (isARenewal) {
																return function (isAGreatLakesRenewal) {
																	return function (isCustomerInformationComplete) {
																		return {mt: bundleSlug, gd: creationDate, mI: customerFacingId, cT: grossPrice, kg: id, gY: isAGreatLakesRenewal, gZ: isARenewal, g$: isCustomerInformationComplete, hd: mainDriverBirthDate, he: mainDriverProvince, hf: mainDriverRecentInsuranceCompanyName, hz: offerBy, id: policyholderDni, lL: startDate, dx: status, i0: vehicleMake, i2: vehicleModel, i3: vehiclePlateNumber};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$New$Gql$Platform$Enum$ApplicationSource$Acierto = 0;
var $author$project$New$Gql$Platform$Enum$ApplicationSource$Check24 = 1;
var $author$project$New$Gql$Platform$Enum$ApplicationSource$Prima = 2;
var $author$project$New$Gql$Platform$Enum$ApplicationSource$PrimaDts = 4;
var $author$project$New$Gql$Platform$Enum$ApplicationSource$Rastreator = 3;
var $author$project$New$Gql$Platform$Enum$ApplicationSource$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'ACIERTO':
				return $elm$json$Json$Decode$succeed(0);
			case 'CHECK_24':
				return $elm$json$Json$Decode$succeed(1);
			case 'PRIMA':
				return $elm$json$Json$Decode$succeed(2);
			case 'RASTREATOR':
				return $elm$json$Json$Decode$succeed(3);
			case 'PRIMA_DTS':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid ApplicationSource type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$offerBy = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ApplicationSource.ApplicationSource', 'offerBy', _List_Nil, $author$project$New$Gql$Platform$Enum$ApplicationSource$decoder);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$policyholderDni = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'policyholderDni', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$startDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'startDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$Available = 7;
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$Blocked = 4;
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$Expired = 3;
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$NewPrice = 0;
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$NewProduct = 1;
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$Purchased = 6;
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$Requoted = 5;
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$StartDateExpired = 2;
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'NEW_PRICE':
				return $elm$json$Json$Decode$succeed(0);
			case 'NEW_PRODUCT':
				return $elm$json$Json$Decode$succeed(1);
			case 'START_DATE_EXPIRED':
				return $elm$json$Json$Decode$succeed(2);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(3);
			case 'BLOCKED':
				return $elm$json$Json$Decode$succeed(4);
			case 'REQUOTED':
				return $elm$json$Json$Decode$succeed(5);
			case 'PURCHASED':
				return $elm$json$Json$Decode$succeed(6);
			case 'AVAILABLE':
				return $elm$json$Json$Decode$succeed(7);
			default:
				return $elm$json$Json$Decode$fail('Invalid OfferSearchResultStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.OfferSearchResultStatus.OfferSearchResultStatus', 'status', _List_Nil, $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$decoder);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$vehicleMake = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'vehicleMake', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$vehicleModel = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'vehicleModel', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$vehiclePlateNumber = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'vehiclePlateNumber',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Page$Search$NewGql$offerSearchResultSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$OfferSearchResult$isCustomerInformationComplete,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$OfferSearchResult$isAGreatLakesRenewal,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$OfferSearchResult$isARenewal,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$OfferSearchResult$mainDriverProvince,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$New$Gql$Platform$Object$OfferSearchResult$mainDriverRecentInsuranceCompanyName,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$New$Gql$Platform$Object$OfferSearchResult$creationDate,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$New$Gql$Platform$Object$OfferSearchResult$startDate,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Page$Search$NewGql$decodeOfferBy, $author$project$New$Gql$Platform$Object$OfferSearchResult$offerBy),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$BundleSlug$decodeNewBundleSlug, $author$project$New$Gql$Platform$Object$OfferSearchResult$bundleSlug),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$New$Gql$Platform$Object$OfferSearchResult$mainDriverBirthDate,
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$New$Gql$Platform$Object$OfferSearchResult$policyholderDni,
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$New$Gql$Platform$Object$OfferSearchResult$vehicleMake,
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$New$Gql$Platform$Object$OfferSearchResult$vehicleModel,
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$New$Gql$Platform$Object$OfferSearchResult$vehiclePlateNumber,
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Page$Search$NewGql$decodeGrossPrice, $author$project$New$Gql$Platform$Object$OfferSearchResult$grossPrice),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Page$Search$NewGql$decodeOfferStatus, $author$project$New$Gql$Platform$Object$OfferSearchResult$status),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	$author$project$New$Gql$Platform$Object$OfferSearchResult$customerFacingId,
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		$author$project$New$Gql$Platform$Object$OfferSearchResult$id,
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Search$OfferSearchResult$new)))))))))))))))))));
var $author$project$New$Gql$Platform$Object$SearchOutput$offers = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'offers',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$New$Gql$Platform$Object$SearchOutput$policies = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'policies',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$New$Gql$Platform$Object$PolicySearchResult$bundleSlug = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BundleSlug.BundleSlug', 'bundleSlug', _List_Nil, $author$project$New$Gql$Platform$Enum$BundleSlug$decoder);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$customerFacingId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'customerFacingId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Page$Search$NewGql$decodePolicySource = function (source) {
	switch (source) {
		case 2:
			return 0;
		case 3:
			return 1;
		case 1:
			return 3;
		default:
			return 2;
	}
};
var $author$project$Page$Search$NewGql$decodePolicyStatus = function (status) {
	switch (status) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 3:
			return 3;
		case 5:
			return 5;
		case 6:
			return 6;
		case 7:
			return 7;
		case 4:
			return 4;
		default:
			return 2;
	}
};
var $author$project$New$Gql$Platform$Object$PolicySearchResult$endDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'endDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$grossPrice = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'grossPrice',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).my.A);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'id',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).t.A);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$isARenewal = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isARenewal', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Page$Search$PolicySearchResult$PolicySearchResult = $elm$core$Basics$identity;
var $author$project$Page$Search$PolicySearchResult$new = function (id) {
	return function (customerFacingId) {
		return function (bundleSlug) {
			return function (grossPrice) {
				return function (source) {
					return function (startDate) {
						return function (endDate) {
							return function (vehiclePlateNumber) {
								return function (vehicleMaker) {
									return function (vehicleModel) {
										return function (policyholderDni) {
											return function (policyholderDateOfBirth) {
												return function (policyholderFirstName) {
													return function (policyholderLastName) {
														return function (status) {
															return function (isARenewal) {
																return {mt: bundleSlug, mI: customerFacingId, et: endDate, cT: grossPrice, kg: id, gZ: isARenewal, ic: policyholderDateOfBirth, id: policyholderDni, ie: policyholderFirstName, $8: policyholderLastName, iA: source, lL: startDate, dx: status, i1: vehicleMaker, i2: vehicleModel, i3: vehiclePlateNumber};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$New$Gql$Platform$Object$PolicySearchResult$policyHolderDateOfBirth = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'policyHolderDateOfBirth',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$policyHolderDocument = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'policyHolderDocument', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$policyHolderFirstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'policyHolderFirstName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$policyHolderLastName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'policyHolderLastName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$source = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.QuoteSource.QuoteSource', 'source', _List_Nil, $author$project$New$Gql$Platform$Enum$QuoteSource$decoder);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$startDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'startDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mx.A);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.PolicyStatus.PolicyStatus', 'status', _List_Nil, $author$project$New$Gql$Platform$Enum$PolicyStatus$decoder);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$vehicleMake = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'vehicleMake', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$vehicleModel = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'vehicleModel', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$vehiclePlateNumber = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'vehiclePlateNumber', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Page$Search$NewGql$policySearchResultSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PolicySearchResult$isARenewal,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Page$Search$NewGql$decodePolicyStatus, $author$project$New$Gql$Platform$Object$PolicySearchResult$status),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$PolicySearchResult$policyHolderLastName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$PolicySearchResult$policyHolderFirstName,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$New$Gql$Platform$Object$PolicySearchResult$policyHolderDateOfBirth,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$New$Gql$Platform$Object$PolicySearchResult$policyHolderDocument,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$New$Gql$Platform$Object$PolicySearchResult$vehicleModel,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$New$Gql$Platform$Object$PolicySearchResult$vehicleMake,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$New$Gql$Platform$Object$PolicySearchResult$vehiclePlateNumber,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$New$Gql$Platform$Object$PolicySearchResult$endDate,
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$New$Gql$Platform$Object$PolicySearchResult$startDate,
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Page$Search$NewGql$decodePolicySource, $author$project$New$Gql$Platform$Object$PolicySearchResult$source),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Page$Search$NewGql$decodeGrossPrice, $author$project$New$Gql$Platform$Object$PolicySearchResult$grossPrice),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$BundleSlug$decodeNewBundleSlug, $author$project$New$Gql$Platform$Object$PolicySearchResult$bundleSlug),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$New$Gql$Platform$Object$PolicySearchResult$customerFacingId,
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																$author$project$New$Gql$Platform$Object$PolicySearchResult$id,
																$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Search$PolicySearchResult$new)))))))))))))))));
var $author$project$Page$Search$NewGql$searchSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$SearchOutput$policies($author$project$Page$Search$NewGql$policySearchResultSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$SearchOutput$offers($author$project$Page$Search$NewGql$offerSearchResultSelectionSet),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Search$NewSearchResult$new)));
var $author$project$Tracker$UserSearch = function (a) {
	return {$: 0, a: a};
};
var $author$project$Tracker$userSearchEvent = $author$project$Tracker$UserSearch;
var $author$project$Tracker$UserSearchPayload = $elm$core$Basics$identity;
var $author$project$Tracker$userSearchPayload = function (searchType) {
	return {lx: searchType};
};
var $author$project$Page$Search$Effect$runEffect = F3(
	function (env, model, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 2:
				return $elm$core$Platform$Cmd$none;
			case 8:
				return $elm$core$Platform$Cmd$none;
			case 3:
				var cmd = effect.a;
				return cmd;
			case 4:
				var searchInputString = effect.a;
				return A4(
					$author$project$Api$executeGraphqlOperation,
					env,
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Page$Search$Gql$searchQuery(searchInputString),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$Search$Msg$GotResults));
			case 5:
				var searchInputString = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'search',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					A2(
						$author$project$New$Gql$Platform$Query$search,
						$author$project$Page$Search$NewGql$searchRequiredArg(searchInputString),
						$author$project$Page$Search$NewGql$searchSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$Search$Msg$GotNewResults));
			case 6:
				return A2(
					$elm$core$Task$perform,
					$author$project$Page$Search$Msg$GotCurrentDate,
					A2(
						$elm$core$Task$map,
						$justinmimbs$date$Date$fromPosix($elm$time$Time$utc),
						$elm$time$Time$now));
			case 7:
				var searchInputString = effect.a;
				return $primait$prima_elm_extra$PrimaCmd$fromMsg(
					$author$project$Page$Search$Msg$RewriteUrl(searchInputString));
			case 9:
				var searchType = effect.a;
				return $author$project$Tracker$publishUserEvent(
					$author$project$Tracker$userSearchEvent(
						$author$project$Tracker$userSearchPayload(searchType)));
			default:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						A2($author$project$Page$Search$Effect$runEffect, env, model),
						effects));
		}
	});
var $author$project$Page$Search$SearchQueryParam$pickCustomerFacingId = function (customerFId) {
	switch (customerFId.$) {
		case 0:
			var policyId = customerFId.a;
			return policyId;
		case 1:
			var offerId = customerFId.a;
			return offerId;
		default:
			var quoteId = customerFId.a;
			return quoteId;
	}
};
var $author$project$Referer$toString = function (_v0) {
	return 'payment-page';
};
var $author$project$Route$routeToPieces = function (page) {
	switch (page.$) {
		case 0:
			return _List_fromArray(
				['not-found']);
		case 1:
			return _List_fromArray(
				['not-authorized']);
		case 2:
			return _List_fromArray(
				['login']);
		case 4:
			var offerId = page.a;
			return _List_fromArray(
				[
					'payment',
					$danyx23$elm_uuid$Uuid$toString(offerId)
				]);
		case 3:
			var tabIndex = page.a;
			var searchQuery = page.b;
			if (!searchQuery.$) {
				switch (searchQuery.a.$) {
					case 0:
						var documentId = searchQuery.a.a;
						return _List_fromArray(
							['#search=' + documentId]);
					case 1:
						var cfid = searchQuery.a.a;
						return _List_fromArray(
							[
								'#search=' + $author$project$Page$Search$SearchQueryParam$pickCustomerFacingId(cfid)
							]);
					case 4:
						var plateNumber = searchQuery.a.a;
						return _List_fromArray(
							['#search=' + plateNumber]);
					case 2:
						var email = searchQuery.a.a;
						return _List_fromArray(
							[
								'?tabIndex=' + ($elm$core$String$fromInt(tabIndex) + ('#search=' + email))
							]);
					case 5:
						var phoneNumber = searchQuery.a.a;
						return _List_fromArray(
							['#search=' + phoneNumber]);
					case 6:
						var customerId = searchQuery.a.a;
						return _List_fromArray(
							[
								'#search=' + $danyx23$elm_uuid$Uuid$toString(customerId)
							]);
					default:
						var _v2 = searchQuery.a;
						return _List_Nil;
				}
			} else {
				return _List_Nil;
			}
		case 5:
			if (!page.b.$) {
				var policyId = page.a;
				var referer = page.b.a;
				return _List_fromArray(
					[
						'policy-details',
						$danyx23$elm_uuid$Uuid$toString(policyId),
						'?referer=' + $author$project$Referer$toString(referer)
					]);
			} else {
				var policyId = page.a;
				var _v3 = page.b;
				return _List_fromArray(
					[
						'policy-details',
						$danyx23$elm_uuid$Uuid$toString(policyId)
					]);
			}
		default:
			var cfid = page.a;
			return _List_fromArray(
				['offer-details', cfid]);
	}
};
var $author$project$Route$toString = function (page) {
	return '/' + A2(
		$elm$core$String$join,
		'/',
		$author$project$Route$routeToPieces(page));
};
var $author$project$Translations$languageToString = function (lang) {
	if (!lang) {
		return 'en';
	} else {
		return 'es';
	}
};
var $author$project$Route$toStringWithLanguageOverride = F2(
	function (language, page) {
		return '/' + ($author$project$Translations$languageToString(language) + ('/' + A2(
			$elm$core$String$join,
			'/',
			$author$project$Route$routeToPieces(page))));
	});
var $author$project$Effect$runEffect = F3(
	function (env, model, effect) {
		var _v0 = _Utils_Tuple2(model.oO, effect);
		_v0$15:
		while (true) {
			_v0$16:
			while (true) {
				_v0$17:
				while (true) {
					_v0$18:
					while (true) {
						_v0$19:
						while (true) {
							_v0$20:
							while (true) {
								_v0$21:
								while (true) {
									switch (_v0.b.$) {
										case 0:
											var _v1 = _v0.b;
											return $elm$core$Platform$Cmd$none;
										case 1:
											var effects = _v0.b.a;
											return $elm$core$Platform$Cmd$batch(
												A2(
													$elm$core$List$map,
													A2($author$project$Effect$runEffect, env, model),
													effects));
										case 2:
											var cmd = _v0.b.a;
											return cmd;
										case 3:
											var route = _v0.b.a;
											var fullRoute = function () {
												var _v2 = $author$project$Env$languageOverride(model.mU);
												if (!_v2.$) {
													var languageOverride = _v2.a;
													return A2($author$project$Route$toStringWithLanguageOverride, languageOverride, route);
												} else {
													return $author$project$Route$toString(route);
												}
											}();
											return A2($elm$browser$Browser$Navigation$pushUrl, model.hp, fullRoute);
										case 4:
											var pageNumber = _v0.b.a;
											return A2($elm$browser$Browser$Navigation$back, model.hp, pageNumber);
										case 6:
											var queryParams = _v0.b.a;
											return A2($elm$browser$Browser$Navigation$replaceUrl, model.hp, queryParams);
										case 5:
											var address = _v0.b.a;
											return $elm$browser$Browser$Navigation$load(address);
										case 10:
											var _v3 = _v0.b;
											return A3($author$project$Utils$executeLogout, env, $author$project$Env$newApiUrl, $author$project$Msg$GotLogoutResult);
										case 9:
											switch (_v0.a.$) {
												case 2:
													var subModel = _v0.a.a;
													var subEffect = _v0.b.a;
													return A2(
														$elm$core$Platform$Cmd$map,
														$author$project$Msg$Login,
														A3($author$project$Page$Login$Effect$runEffect, env, subModel, subEffect));
												case 0:
													break _v0$16;
												case 1:
													break _v0$17;
												case 3:
													break _v0$18;
												case 4:
													break _v0$19;
												case 5:
													break _v0$20;
												default:
													break _v0$21;
											}
										case 7:
											switch (_v0.a.$) {
												case 2:
													break _v0$15;
												case 0:
													var subModel = _v0.a.a;
													var subEffect = _v0.b.a;
													return A2(
														$elm$core$Platform$Cmd$map,
														$author$project$Msg$NotFound,
														A3($author$project$Page$NotFound$Effect$runEffect, env, subModel, subEffect));
												case 1:
													break _v0$17;
												case 3:
													break _v0$18;
												case 4:
													break _v0$19;
												case 5:
													break _v0$20;
												default:
													break _v0$21;
											}
										case 8:
											switch (_v0.a.$) {
												case 2:
													break _v0$15;
												case 0:
													break _v0$16;
												case 1:
													var subModel = _v0.a.a;
													var subEffect = _v0.b.a;
													return A2(
														$elm$core$Platform$Cmd$map,
														$author$project$Msg$NotAuthorized,
														A3($author$project$Page$NotAuthorized$Effect$runEffect, env, subModel, subEffect));
												case 3:
													break _v0$18;
												case 4:
													break _v0$19;
												case 5:
													break _v0$20;
												default:
													break _v0$21;
											}
										case 11:
											switch (_v0.a.$) {
												case 2:
													break _v0$15;
												case 0:
													break _v0$16;
												case 1:
													break _v0$17;
												case 3:
													var subModel = _v0.a.a;
													var subEffect = _v0.b.a;
													return A2(
														$elm$core$Platform$Cmd$map,
														$author$project$Msg$Search,
														A3($author$project$Page$Search$Effect$runEffect, env, subModel, subEffect));
												case 4:
													break _v0$19;
												case 5:
													break _v0$20;
												default:
													break _v0$21;
											}
										case 12:
											switch (_v0.a.$) {
												case 2:
													break _v0$15;
												case 0:
													break _v0$16;
												case 1:
													break _v0$17;
												case 3:
													break _v0$18;
												case 4:
													var subModel = _v0.a.a;
													var subEffect = _v0.b.a;
													return A2(
														$elm$core$Platform$Cmd$map,
														$author$project$Msg$Payment,
														A3($author$project$Page$Payment$Effect$runEffect, env, subModel, subEffect));
												case 5:
													break _v0$20;
												default:
													break _v0$21;
											}
										case 13:
											switch (_v0.a.$) {
												case 2:
													break _v0$15;
												case 0:
													break _v0$16;
												case 1:
													break _v0$17;
												case 3:
													break _v0$18;
												case 4:
													break _v0$19;
												case 5:
													var subModel = _v0.a.a;
													var subEffect = _v0.b.a;
													return A2(
														$elm$core$Platform$Cmd$map,
														$author$project$Msg$PolicyDetails,
														A3($author$project$Page$PolicyDetails$Effect$runEffect, env, subModel, subEffect));
												default:
													break _v0$21;
											}
										default:
											switch (_v0.a.$) {
												case 2:
													break _v0$15;
												case 0:
													break _v0$16;
												case 1:
													break _v0$17;
												case 3:
													break _v0$18;
												case 4:
													break _v0$19;
												case 5:
													break _v0$20;
												default:
													var subModel = _v0.a.a;
													var subEffect = _v0.b.a;
													return A2(
														$elm$core$Platform$Cmd$map,
														$author$project$Msg$OfferDetails,
														A3($author$project$Page$OfferDetails$Effect$runEffect, env, subModel, subEffect));
											}
									}
								}
								return $elm$core$Platform$Cmd$none;
							}
							return $elm$core$Platform$Cmd$none;
						}
						return $elm$core$Platform$Cmd$none;
					}
					return $elm$core$Platform$Cmd$none;
				}
				return $elm$core$Platform$Cmd$none;
			}
			return $elm$core$Platform$Cmd$none;
		}
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Common$User$Anonymous = {$: 0};
var $author$project$Common$User$Backoffice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Effect$ChangeRoute = function (a) {
	return {$: 3, a: a};
};
var $author$project$Effect$Effects = function (a) {
	return {$: 1, a: a};
};
var $author$project$Effect$GoBack = function (a) {
	return {$: 4, a: a};
};
var $author$project$Effect$LoadExternalPage = function (a) {
	return {$: 5, a: a};
};
var $author$project$Effect$Login = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$Login = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$Login = {$: 2};
var $author$project$Effect$Logout = {$: 10};
var $author$project$Effect$None = {$: 0};
var $author$project$Effect$NotAuthorized = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$NotAuthorized = function (a) {
	return {$: 1, a: a};
};
var $author$project$Effect$NotFound = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$NotFound = function (a) {
	return {$: 0, a: a};
};
var $author$project$Effect$OfferDetails = function (a) {
	return {$: 14, a: a};
};
var $author$project$Model$OfferDetails = function (a) {
	return {$: 6, a: a};
};
var $author$project$Effect$Payment = function (a) {
	return {$: 12, a: a};
};
var $author$project$Model$Payment = function (a) {
	return {$: 4, a: a};
};
var $author$project$Effect$PolicyDetails = function (a) {
	return {$: 13, a: a};
};
var $author$project$Model$PolicyDetails = function (a) {
	return {$: 5, a: a};
};
var $author$project$Effect$RewriteUrl = function (a) {
	return {$: 6, a: a};
};
var $author$project$Effect$Search = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$Search = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$NotFound = {$: 0};
var $author$project$Route$NotAuthorized = {$: 1};
var $author$project$Route$OfferDetails = function (a) {
	return {$: 6, a: a};
};
var $author$project$Route$Payment = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$PolicyDetails = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Route$Search = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$url$Url$Parser$fragment = function (toFrag) {
	return function (_v0) {
		var visited = _v0.bm;
		var unvisited = _v0.aR;
		var params = _v0.bc;
		var frag = _v0.a$;
		var value = _v0.pB;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					toFrag(frag)))
			]);
	};
};
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.bm;
		var unvisited = _v0.aR;
		var params = _v0.bc;
		var frag = _v0.a$;
		var value = _v0.pB;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.bm;
			var unvisited = _v1.aR;
			var params = _v1.bc;
			var frag = _v1.a$;
			var value = _v1.pB;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $author$project$Referer$PaymentPage = 0;
var $author$project$Referer$fromString = function (str) {
	if (str === 'payment-page') {
		return $elm$core$Result$Ok(0);
	} else {
		return $elm$core$Result$Err(0);
	}
};
var $author$project$Route$parseRefererQueryParam = A2(
	$elm$url$Url$Parser$Query$custom,
	'referer',
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$head,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map(
				A2($elm$core$Basics$composeR, $author$project$Referer$fromString, $elm$core$Result$toMaybe)),
			$elm_community$maybe_extra$Maybe$Extra$join)));
var $author$project$Page$Search$SearchQueryParam$Empty = {$: 3};
var $author$project$Page$Search$SearchQueryParam$CustomerFacingId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Search$SearchQueryParam$OfferId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Search$SearchQueryParam$PolicyId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Search$SearchQueryParam$QuoteId = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Search$SearchQueryParam$attemptIdentifyCustomerFacingId = function (value) {
	var _v0 = A2($elm$core$String$left, 1, value);
	switch (_v0) {
		case 'F':
			return $elm$core$Result$Ok(
				$author$project$Page$Search$SearchQueryParam$OfferId(value));
		case 'P':
			return $elm$core$Result$Ok(
				$author$project$Page$Search$SearchQueryParam$PolicyId(value));
		case 'Q':
			return $elm$core$Result$Ok(
				$author$project$Page$Search$SearchQueryParam$QuoteId(value));
		default:
			return $elm$core$Result$Err(0);
	}
};
var $author$project$Page$Search$SearchQueryParam$fromStringToRegex = function (pattern) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString(pattern));
};
var $author$project$Page$Search$SearchQueryParam$NotRecognised = 0;
var $author$project$Page$Search$SearchQueryParam$inputRecogniser = F2(
	function (recognizer, value) {
		return A2(
			$elm$core$Result$mapError,
			$elm$core$Basics$always(0),
			recognizer(value));
	});
var $author$project$Page$Search$SearchQueryParam$cfIdRecogniser = function (value) {
	var pattern = '^[FPQ]\\d+$';
	var regex = $author$project$Page$Search$SearchQueryParam$fromStringToRegex(pattern);
	var recogniser = function (cfid) {
		return A2($elm$regex$Regex$contains, regex, cfid) ? A2(
			$elm$core$Result$map,
			$author$project$Page$Search$SearchQueryParam$CustomerFacingId,
			$author$project$Page$Search$SearchQueryParam$attemptIdentifyCustomerFacingId(cfid)) : $elm$core$Result$Err(0);
	};
	return A2($author$project$Page$Search$SearchQueryParam$inputRecogniser, recogniser, value);
};
var $author$project$Page$Search$SearchQueryParam$CustomerId = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Search$SearchQueryParam$customerIdRecogniser = function (value) {
	var recogniser = function (customerId) {
		return A2(
			$elm$core$Result$map,
			$author$project$Page$Search$SearchQueryParam$CustomerId,
			A2(
				$elm$core$Result$fromMaybe,
				0,
				$danyx23$elm_uuid$Uuid$fromString(customerId)));
	};
	return A2($author$project$Page$Search$SearchQueryParam$inputRecogniser, recogniser, value);
};
var $author$project$Page$Search$SearchQueryParam$PlateNumber = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Search$SearchQueryParam$defaultWhenNotRecognised = function (inputValue) {
	return $author$project$Page$Search$SearchQueryParam$PlateNumber(inputValue);
};
var $author$project$Page$Search$SearchQueryParam$DocumentId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Search$SearchQueryParam$dniRecogniser = function (value) {
	var regex = $author$project$Page$Search$SearchQueryParam$fromStringToRegex('^[X,x,Y,y, Z,z, 0-9]*[0-9][a-zA-Z]$');
	var recogniser = function (dni) {
		return A2($elm$regex$Regex$contains, regex, dni) ? $elm$core$Result$Ok(
			$author$project$Page$Search$SearchQueryParam$DocumentId(dni)) : $elm$core$Result$Err(0);
	};
	return A2($author$project$Page$Search$SearchQueryParam$inputRecogniser, recogniser, value);
};
var $author$project$Page$Search$SearchQueryParam$emptyStringRecogniser = function (value) {
	var recogniser = function (v) {
		return $elm$core$String$isEmpty(v) ? $elm$core$Result$Ok($author$project$Page$Search$SearchQueryParam$Empty) : $elm$core$Result$Err(0);
	};
	return A2($author$project$Page$Search$SearchQueryParam$inputRecogniser, recogniser, value);
};
var $author$project$Page$Search$SearchQueryParam$Email = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Search$SearchQueryParam$mailRecogniser = function (value) {
	var pattern = '^[a-z]?.*@';
	var regex = $author$project$Page$Search$SearchQueryParam$fromStringToRegex(pattern);
	var recogniser = function (mail) {
		return A2($elm$regex$Regex$contains, regex, mail) ? $elm$core$Result$Ok(
			$author$project$Page$Search$SearchQueryParam$Email(mail)) : $elm$core$Result$Err(0);
	};
	return A2($author$project$Page$Search$SearchQueryParam$inputRecogniser, recogniser, value);
};
var $elm_community$result_extra$Result$Extra$or = F2(
	function (ra, rb) {
		if (ra.$ === 1) {
			return rb;
		} else {
			return ra;
		}
	});
var $author$project$Page$Search$SearchQueryParam$PhoneNumber = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Search$SearchQueryParam$phoneNumberRecogniser = function (value) {
	var regex = $author$project$Page$Search$SearchQueryParam$fromStringToRegex('^[0-9]*[0-9]$');
	var recogniser = function (phone) {
		return A2($elm$regex$Regex$contains, regex, phone) ? $elm$core$Result$Ok(
			$author$project$Page$Search$SearchQueryParam$PhoneNumber(phone)) : $elm$core$Result$Err(0);
	};
	return A2($author$project$Page$Search$SearchQueryParam$inputRecogniser, recogniser, value);
};
var $elm_community$result_extra$Result$Extra$unwrap = F3(
	function (defaultValue, okFunc, result) {
		if (!result.$) {
			var ok = result.a;
			return okFunc(ok);
		} else {
			return defaultValue;
		}
	});
var $author$project$Page$Search$SearchQueryParam$fromUrlStringToSearchInput = function (inputValue) {
	return A3(
		$elm_community$result_extra$Result$Extra$unwrap,
		$author$project$Page$Search$SearchQueryParam$defaultWhenNotRecognised(inputValue),
		$elm$core$Basics$identity,
		A2(
			$elm_community$result_extra$Result$Extra$or,
			$author$project$Page$Search$SearchQueryParam$customerIdRecogniser(inputValue),
			A2(
				$elm_community$result_extra$Result$Extra$or,
				$author$project$Page$Search$SearchQueryParam$phoneNumberRecogniser(inputValue),
				A2(
					$elm_community$result_extra$Result$Extra$or,
					$author$project$Page$Search$SearchQueryParam$dniRecogniser(inputValue),
					A2(
						$elm_community$result_extra$Result$Extra$or,
						$author$project$Page$Search$SearchQueryParam$emptyStringRecogniser(inputValue),
						A2(
							$elm_community$result_extra$Result$Extra$or,
							$author$project$Page$Search$SearchQueryParam$cfIdRecogniser(inputValue),
							$author$project$Page$Search$SearchQueryParam$mailRecogniser(inputValue)))))));
};
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $elm_community$string_extra$String$Extra$firstResultHelp = F2(
	function (_default, list) {
		firstResultHelp:
		while (true) {
			if (!list.b) {
				return _default;
			} else {
				if (!list.a.$) {
					var a = list.a.a;
					return a;
				} else {
					var _v1 = list.a;
					var rest = list.b;
					var $temp$default = _default,
						$temp$list = rest;
					_default = $temp$default;
					list = $temp$list;
					continue firstResultHelp;
				}
			}
		}
	});
var $elm_community$string_extra$String$Extra$firstResult = function (list) {
	return A2($elm_community$string_extra$String$Extra$firstResultHelp, '', list);
};
var $elm_community$string_extra$String$Extra$regexFromString = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $elm_community$string_extra$String$Extra$regexEscape = A2(
	$elm$regex$Regex$replace,
	$elm_community$string_extra$String$Extra$regexFromString('[-/\\^$*+?.()|[\\]{}]'),
	function (_v0) {
		var match = _v0.c6;
		return '\\' + match;
	});
var $elm_community$string_extra$String$Extra$rightOf = F2(
	function (pattern, string) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.lQ;
					},
					$elm_community$string_extra$String$Extra$firstResult),
				A3(
					$elm$regex$Regex$findAtMost,
					1,
					$elm_community$string_extra$String$Extra$regexFromString(
						$elm_community$string_extra$String$Extra$regexEscape(pattern) + '(.*)$'),
					string)));
	});
var $author$project$Route$parseSearchFragment = function (fragment) {
	var searchString = A2(
		$elm_community$string_extra$String$Extra$rightOf,
		'search=',
		A2($elm$core$Maybe$withDefault, '', fragment));
	return $elm$core$String$isEmpty(searchString) ? $elm$core$Result$Ok($author$project$Page$Search$SearchQueryParam$Empty) : $elm$core$Result$Ok(
		$author$project$Page$Search$SearchQueryParam$fromUrlStringToSearchInput(searchString));
};
var $author$project$Page$Search$SearchQueryParam$defaultSearchContext = 0;
var $elm$url$Url$Parser$Query$int = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$String$toInt(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $elm$url$Url$Parser$Query$map = F2(
	function (func, _v0) {
		var a = _v0;
		return function (dict) {
			return func(
				a(dict));
		};
	});
var $author$project$Route$searchTabIndex = A2(
	$elm$url$Url$Parser$Query$map,
	$elm$core$Maybe$withDefault($author$project$Page$Search$SearchQueryParam$defaultSearchContext),
	$elm$url$Url$Parser$Query$int('tabIndex'));
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.bm;
			var unvisited = _v0.aR;
			var params = _v0.bc;
			var frag = _v0.a$;
			var value = _v0.pB;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Route$uuid = A2($elm$url$Url$Parser$custom, 'uuid', $danyx23$elm_uuid$Uuid$fromString);
var $author$project$Route$parser = function () {
	var routeParser = $elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Search,
				A2(
					$elm$url$Url$Parser$slash,
					A2($elm$url$Url$Parser$questionMark, $elm$url$Url$Parser$top, $author$project$Route$searchTabIndex),
					$elm$url$Url$Parser$fragment($author$project$Route$parseSearchFragment))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Payment,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('payment'),
					$author$project$Route$uuid)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Login,
				$elm$url$Url$Parser$s('login')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$NotAuthorized,
				$elm$url$Url$Parser$s('not-authorized')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$PolicyDetails,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('policy-details'),
					A2($elm$url$Url$Parser$questionMark, $author$project$Route$uuid, $author$project$Route$parseRefererQueryParam))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$OfferDetails,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('offer-details'),
					$elm$url$Url$Parser$string))
			]));
	var routeWithLanguage = A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$oneOf(
			_List_fromArray(
				[
					$elm$url$Url$Parser$s('es'),
					$elm$url$Url$Parser$s('en')
				])),
		routeParser);
	return $elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[routeParser, routeWithLanguage]));
}();
var $author$project$Route$fromUrl = function (url) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Route$NotFound,
		A2($elm$url$Url$Parser$parse, $author$project$Route$parser, url));
};
var $author$project$Common$User$hasAnyPermissions = function (user) {
	if (!user.$) {
		return false;
	} else {
		var permissions = user.a.de;
		return !$elm$core$List$isEmpty(permissions);
	}
};
var $author$project$Main$canAccess = F2(
	function (user, route) {
		switch (route.$) {
			case 2:
				return true;
			case 0:
				return true;
			case 1:
				return true;
			case 3:
				return $author$project$Common$User$hasAnyPermissions(user);
			case 4:
				return $author$project$Common$User$hasAnyPermissions(user);
			case 5:
				return $author$project$Common$User$hasAnyPermissions(user);
			default:
				return $author$project$Common$User$hasAnyPermissions(user);
		}
	});
var $author$project$Page$Login$Effect$CheckIfAuthed = {$: 1};
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $author$project$Page$Login$Model$init = F2(
	function (externalApiUrl, maybeTargetRoute) {
		var targetRoute = function () {
			if (maybeTargetRoute.$ === 1) {
				return A2(
					$author$project$Route$Search,
					$author$project$Page$Search$SearchQueryParam$defaultSearchContext,
					$elm$core$Result$Ok($author$project$Page$Search$SearchQueryParam$Empty));
			} else {
				if (maybeTargetRoute.a.$ === 2) {
					var _v1 = maybeTargetRoute.a;
					return A2(
						$author$project$Route$Search,
						$author$project$Page$Search$SearchQueryParam$defaultSearchContext,
						$elm$core$Result$Ok($author$project$Page$Search$SearchQueryParam$Empty));
				} else {
					var route = maybeTargetRoute.a;
					return route;
				}
			}
		}();
		return {mn: $krisajenkins$remotedata$RemoteData$Loading, cP: externalApiUrl, pr: targetRoute};
	});
var $author$project$Page$Login$init = F2(
	function (apiUrl, targetRoute) {
		return _Utils_Tuple2(
			A2($author$project$Page$Login$Model$init, apiUrl, targetRoute),
			$author$project$Page$Login$Effect$CheckIfAuthed);
	});
var $author$project$Page$NotAuthorized$Effect$None = 0;
var $author$project$Page$NotAuthorized$Model$init = {};
var $author$project$Page$NotAuthorized$init = _Utils_Tuple2($author$project$Page$NotAuthorized$Model$init, 0);
var $author$project$Page$NotFound$Effect$None = 0;
var $author$project$Page$NotFound$Model$init = {};
var $author$project$Page$NotFound$init = _Utils_Tuple2($author$project$Page$NotFound$Model$init, 0);
var $author$project$Page$OfferDetails$Effect$Effects = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$OfferDetails$Effect$FetchOffer = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$OfferDetails$Effect$GetCurrentDate = {$: 9};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $author$project$Page$OfferDetails$Msg$PortfolioMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$OfferDetails$Msg$ShowCoverPackagesModal = function (a) {
	return {$: 15, a: a};
};
var $author$project$Common$ComponentUI$Modal$CoverPackages$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Modal$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Modal$init = function (id) {
	return {gn: $elm$core$Maybe$Nothing, gv: $elm$core$Maybe$Nothing, kg: id, g2: false, fm: $elm$core$Maybe$Nothing};
};
var $author$project$Common$ComponentUI$Modal$CoverPackages$init = function (onClose) {
	return {
		bX: $author$project$Pyxis$Components$Modal$init('cover-packages-modal'),
		hK: onClose,
		ij: $elm$core$Maybe$Nothing
	};
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$Model = F4(
	function (popUp, isSendEmailSubmitted, sendEmailCheckBoxGroup, recipientEmail) {
		return {g4: isSendEmailSubmitted, ig: popUp, $9: recipientEmail, cd: sendEmailCheckBoxGroup};
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$FieldStatus$FieldStatus = F2(
	function (isBlurred, isDirty) {
		return {kp: isBlurred, nr: isDirty};
	});
var $author$project$Pyxis$Components$Field$FieldStatus$init = A2($author$project$Pyxis$Components$Field$FieldStatus$FieldStatus, false, false);
var $author$project$Pyxis$Components$Field$CheckboxGroup$init = {aA: _List_Nil, ev: $author$project$Pyxis$Components$Field$FieldStatus$init, hH: $elm$core$Maybe$Nothing, kN: $elm$core$Maybe$Nothing, hQ: $elm$core$Maybe$Nothing};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$init = A4(
	$author$project$Common$ComponentUI$Modal$SendOfferEmail$Model,
	$author$project$Pyxis$Components$Modal$init('send-offer-email-modal'),
	false,
	$author$project$Pyxis$Components$Field$CheckboxGroup$init,
	'');
var $author$project$Common$Portfolio$Portfolio = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Tabs$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Tabs$init = {
	M: 0,
	e5: $elm$core$Maybe$Nothing,
	h0: $elm$core$Maybe$Nothing,
	b0: A3($elm$core$Dict$insert, 0, 1, $elm$core$Dict$empty),
	$7: $elm$core$Maybe$Nothing
};
var $author$project$Common$Portfolio$init = F2(
	function (onShowIncludedCovers, tagger) {
		return {gr: $elm$core$Maybe$Nothing, gs: $elm$core$Maybe$Nothing, eE: $author$project$Pyxis$Components$Tabs$init, kP: $elm$core$Maybe$Nothing, k4: onShowIncludedCovers, b1: $author$project$Pyxis$Components$Tabs$init, iM: tagger};
	});
var $author$project$Pyxis$Components$Toasts$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Toasts$init = {ec: 0, s: $elm$core$Dict$empty};
var $author$project$Page$OfferDetails$Model$init = {
	mh: $krisajenkins$remotedata$RemoteData$NotAsked,
	cF: $krisajenkins$remotedata$RemoteData$NotAsked,
	eb: $author$project$Pyxis$Components$Modal$init('legal-recording-disclaimer-modal'),
	ed: $author$project$Common$ComponentUI$Modal$CoverPackages$init(
		$author$project$Page$OfferDetails$Msg$ShowCoverPackagesModal(false)),
	jI: $krisajenkins$remotedata$RemoteData$NotAsked,
	gf: $elm$core$Maybe$Nothing,
	gi: $krisajenkins$remotedata$RemoteData$NotAsked,
	bI: $author$project$Pyxis$Components$Modal$init('great-lakes-opt-in-consent-modal-landing'),
	bJ: $author$project$Pyxis$Components$Modal$init('great-lakes-opt-in-consent-modal-purchase'),
	F: $krisajenkins$remotedata$RemoteData$Loading,
	lc: $krisajenkins$remotedata$RemoteData$NotAsked,
	dn: A2($author$project$Common$Portfolio$init, $author$project$Page$OfferDetails$Msg$ShowCoverPackagesModal, $author$project$Page$OfferDetails$Msg$PortfolioMsg),
	dt: $krisajenkins$remotedata$RemoteData$NotAsked,
	B: $author$project$Common$ComponentUI$Modal$SendOfferEmail$init,
	dy: $author$project$Pyxis$Components$Modal$init('start-recording-disclaimer-modal'),
	s: $author$project$Pyxis$Components$Toasts$init
};
var $author$project$Page$OfferDetails$init = function (offerCFID) {
	return _Utils_Tuple2(
		$author$project$Page$OfferDetails$Model$init,
		$author$project$Page$OfferDetails$Effect$Effects(
			_List_fromArray(
				[
					$author$project$Page$OfferDetails$Effect$FetchOffer(offerCFID),
					$author$project$Page$OfferDetails$Effect$GetCurrentDate
				])));
};
var $author$project$Page$Payment$Effect$Effects = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Payment$Effect$FetchBraintreeToken = {$: 4};
var $author$project$Page$Payment$Effect$FetchProducts = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Payment$Model$Initializing = 0;
var $author$project$Page$Payment$Model$initCreditCardField = function (id) {
	return {kg: id, eH: false, eM: true, bQ: false};
};
var $author$project$Page$Payment$Model$initCreditCardFields = {
	cE: $author$project$Page$Payment$Model$initCreditCardField('credit-card-number'),
	cO: $author$project$Page$Payment$Model$initCreditCardField('credit-card-expiration-date')
};
var $author$project$Page$Payment$Model$init = function (offerId) {
	return {d4: $author$project$Page$Payment$Model$initCreditCardFields, gI: $krisajenkins$remotedata$RemoteData$NotAsked, gJ: $krisajenkins$remotedata$RemoteData$NotAsked, gK: $krisajenkins$remotedata$RemoteData$NotAsked, n$: offerId, h6: $elm$core$Maybe$Nothing, dx: 0};
};
var $author$project$Page$Payment$init = function (offerId) {
	return _Utils_Tuple2(
		$author$project$Page$Payment$Model$init(offerId),
		$author$project$Page$Payment$Effect$Effects(
			_List_fromArray(
				[
					$author$project$Page$Payment$Effect$FetchBraintreeToken,
					$author$project$Page$Payment$Effect$FetchProducts(offerId)
				])));
};
var $author$project$Page$PolicyDetails$Effect$Effects = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$PolicyDetails$Effect$FetchPolicy = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$PolicyDetails$Effect$GetCurrentTime = {$: 8};
var $author$project$Page$PolicyDetails$Effect$RequestIssueRefundReleaseData = {$: 17};
var $author$project$Page$PolicyDetails$Msg$ChangeEmailModalMsg = function (a) {
	return {$: 47, a: a};
};
var $author$project$Page$PolicyDetails$Msg$ChangeEmailSubmitted = function (a) {
	return {$: 48, a: a};
};
var $author$project$Page$PolicyDetails$Msg$PortfolioMsg = function (a) {
	return {$: 38, a: a};
};
var $author$project$Page$PolicyDetails$Msg$SendEmailConfirmed = function (a) {
	return {$: 43, a: a};
};
var $author$project$Page$PolicyDetails$Msg$SendEmailModalMsg = function (a) {
	return {$: 44, a: a};
};
var $author$project$Page$PolicyDetails$Msg$ShowCoverPackagesModal = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$Closed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$Model = $elm$core$Basics$identity;
var $author$project$Page$PolicyDetails$ChangeEmailModal$ResetSubmission = {$: 4};
var $author$project$Pyxis$Components$Field$Input$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Input$init = {ev: $author$project$Pyxis$Components$Field$FieldStatus$init, hH: $elm$core$Maybe$Nothing, hQ: $elm$core$Maybe$Nothing, hS: $elm$core$Maybe$Nothing, hW: $elm$core$Maybe$Nothing, pB: ''};
var $author$project$Pyxis$Components$Field$Input$setOnFocus = F2(
	function (msg, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				hQ: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$Page$PolicyDetails$ChangeEmailModal$init = F2(
	function (tagger, onConfirm) {
		return {
			a_: A2(
				$author$project$Pyxis$Components$Field$Input$setOnFocus,
				tagger($author$project$Page$PolicyDetails$ChangeEmailModal$ResetSubmission),
				$author$project$Pyxis$Components$Field$Input$init),
			cY: false,
			kO: onConfirm,
			iM: tagger,
			cq: $author$project$Page$PolicyDetails$ChangeEmailModal$Closed(
				$author$project$Pyxis$Components$Modal$init(''))
		};
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$DateInput$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$DateInput$init = {ev: $author$project$Pyxis$Components$Field$FieldStatus$init, hH: $elm$core$Maybe$Nothing, hQ: $elm$core$Maybe$Nothing, hS: $elm$core$Maybe$Nothing, pB: ''};
var $author$project$Pyxis$Components$Field$Textarea$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Textarea$init = {ev: $author$project$Pyxis$Components$Field$FieldStatus$init, hH: $elm$core$Maybe$Nothing, hQ: $elm$core$Maybe$Nothing, hS: $elm$core$Maybe$Nothing, pB: ''};
var $author$project$Page$PolicyDetails$Msg$InterruptionReasonConfirmed = {$: 14};
var $author$project$Page$PolicyDetails$Msg$InterruptionReasonReset = {$: 15};
var $author$project$Pyxis$Components$Field$Autocomplete$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Commons$Basics$ternaryOperator = F3(
	function (condition, functionOnTrue, functionOnFalse) {
		return condition ? functionOnTrue : functionOnFalse;
	});
var $author$project$Pyxis$Components$Field$Autocomplete$getFilterFunction = F4(
	function (isCaseSensitive, isStartWith, filteringValue, value) {
		var filterFunction = A3($author$project$Pyxis$Commons$Basics$ternaryOperator, isStartWith, $elm$core$String$startsWith, $elm$core$String$contains);
		var convertForCaseSensitive = A3($author$project$Pyxis$Commons$Basics$ternaryOperator, isCaseSensitive, $elm$core$Basics$identity, $elm$core$String$toLower);
		return A2(
			filterFunction,
			convertForCaseSensitive(filteringValue),
			convertForCaseSensitive(value));
	});
var $author$project$Pyxis$Components$Field$Autocomplete$init = {
	H: $elm$core$Maybe$Nothing,
	ev: $author$project$Pyxis$Components$Field$FieldStatus$init,
	bH: A2($author$project$Pyxis$Components$Field$Autocomplete$getFilterFunction, false, true),
	E: '',
	eA: false,
	a2: false,
	bO: false,
	hH: $elm$core$Maybe$Nothing,
	hQ: $elm$core$Maybe$Nothing,
	hR: $elm$core$Maybe$Nothing,
	hS: $elm$core$Maybe$Nothing,
	h$: $elm$core$Maybe$Nothing,
	e4: $elm$core$Maybe$Nothing,
	fj: $elm$core$Maybe$Nothing,
	pB: $elm$core$Maybe$Nothing,
	aw: $krisajenkins$remotedata$RemoteData$NotAsked
};
var $author$project$Pyxis$Components$Field$Autocomplete$setFilterStrategyContains = F2(
	function (isCaseSensitive, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{
				bH: A2($author$project$Pyxis$Components$Field$Autocomplete$getFilterFunction, isCaseSensitive, false)
			});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$setOnReset = F2(
	function (msg, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				h$: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$setOnSelect = F2(
	function (msg, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				e4: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$initReasonInput = A2(
	$author$project$Pyxis$Components$Field$Autocomplete$setOnReset,
	$author$project$Page$PolicyDetails$Msg$InterruptionReasonReset,
	A2(
		$author$project$Pyxis$Components$Field$Autocomplete$setOnSelect,
		$author$project$Page$PolicyDetails$Msg$InterruptionReasonConfirmed,
		A2($author$project$Pyxis$Components$Field$Autocomplete$setFilterStrategyContains, false, $author$project$Pyxis$Components$Field$Autocomplete$init)));
var $author$project$Page$PolicyDetails$InterruptionModal$Model$init = {
	aC: $author$project$Pyxis$Components$Field$Textarea$init,
	mY: $krisajenkins$remotedata$RemoteData$NotAsked,
	aI: $author$project$Pyxis$Components$Field$DateInput$init,
	at: $elm$core$Maybe$Nothing,
	hy: $elm$core$Maybe$Nothing,
	k: $elm$core$Maybe$Nothing,
	aN: $author$project$Page$PolicyDetails$InterruptionModal$Model$initReasonInput,
	cq: $author$project$Pyxis$Components$Modal$init('policy-interruption-modal')
};
var $author$project$Page$PolicyDetails$RefundIssuingModal$Model = $elm$core$Basics$identity;
var $author$project$Page$PolicyDetails$RefundIssuingModal$init = {
	o4: $elm$core$Maybe$Nothing,
	cq: $author$project$Pyxis$Components$Modal$init('policy-refund-modal')
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$Model = $elm$core$Basics$identity;
var $author$project$Common$ReasonDescriptionStatus$NotSet = 3;
var $author$project$Page$PolicyDetails$RenewalCancellationModal$initReasonInput = A2($author$project$Pyxis$Components$Field$Autocomplete$setFilterStrategyContains, false, $author$project$Pyxis$Components$Field$Autocomplete$init);
var $author$project$Page$PolicyDetails$RenewalCancellationModal$init = {
	me: $elm$core$Maybe$Nothing,
	aC: $author$project$Pyxis$Components$Field$Textarea$init,
	bD: 3,
	k: $elm$core$Maybe$Nothing,
	aN: $author$project$Page$PolicyDetails$RenewalCancellationModal$initReasonInput,
	fk: $elm$core$Maybe$Nothing,
	cq: $author$project$Pyxis$Components$Modal$init('renewal-cancellation-modal')
};
var $author$project$Page$PolicyDetails$SendEmailModal$Model = $elm$core$Basics$identity;
var $author$project$Page$PolicyDetails$SendEmailModal$OptionChecked = {$: 3};
var $author$project$Pyxis$Components$Field$CheckboxGroup$setOnCheck = F2(
	function (msg, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				kN: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$Page$PolicyDetails$SendEmailModal$init = F3(
	function (policyId, confirmMsg, tagger) {
		return {
			aW: A2(
				$author$project$Pyxis$Components$Field$CheckboxGroup$setOnCheck,
				tagger($author$project$Page$PolicyDetails$SendEmailModal$OptionChecked),
				$author$project$Pyxis$Components$Field$CheckboxGroup$init),
			jB: confirmMsg(policyId),
			gt: $elm$core$Maybe$Nothing,
			cY: false,
			oQ: policyId,
			iM: tagger,
			cq: $author$project$Pyxis$Components$Modal$init('policy-email-send-modal')
		};
	});
var $author$project$Page$PolicyDetails$Model$init = F2(
	function (referer, policyId) {
		return {
			U: $elm$core$Maybe$Nothing,
			bx: A2($author$project$Page$PolicyDetails$ChangeEmailModal$init, $author$project$Page$PolicyDetails$Msg$ChangeEmailModalMsg, $author$project$Page$PolicyDetails$Msg$ChangeEmailSubmitted),
			cF: $krisajenkins$remotedata$RemoteData$NotAsked,
			ed: $author$project$Common$ComponentUI$Modal$CoverPackages$init(
				$author$project$Page$PolicyDetails$Msg$ShowCoverPackagesModal(false)),
			jI: $krisajenkins$remotedata$RemoteData$NotAsked,
			jJ: $krisajenkins$remotedata$RemoteData$NotAsked,
			gg: $elm$core$Maybe$Nothing,
			gi: $krisajenkins$remotedata$RemoteData$NotAsked,
			p: $author$project$Page$PolicyDetails$InterruptionModal$Model$init,
			ns: $elm$core$Maybe$Nothing,
			lc: $krisajenkins$remotedata$RemoteData$NotAsked,
			ld: $author$project$Pyxis$Components$Tabs$init,
			k: $krisajenkins$remotedata$RemoteData$Loading,
			oQ: policyId,
			dn: A2($author$project$Common$Portfolio$init, $author$project$Page$PolicyDetails$Msg$ShowCoverPackagesModal, $author$project$Page$PolicyDetails$Msg$PortfolioMsg),
			o2: referer,
			o4: $krisajenkins$remotedata$RemoteData$NotAsked,
			b9: $author$project$Page$PolicyDetails$RefundIssuingModal$init,
			am: $author$project$Page$PolicyDetails$RenewalCancellationModal$init,
			ce: A3($author$project$Page$PolicyDetails$SendEmailModal$init, policyId, $author$project$Page$PolicyDetails$Msg$SendEmailConfirmed, $author$project$Page$PolicyDetails$Msg$SendEmailModalMsg),
			fl: $krisajenkins$remotedata$RemoteData$NotAsked,
			s: $author$project$Pyxis$Components$Toasts$init
		};
	});
var $author$project$Page$PolicyDetails$init = F2(
	function (referer, policyId) {
		return _Utils_Tuple2(
			A2($author$project$Page$PolicyDetails$Model$init, referer, policyId),
			$author$project$Page$PolicyDetails$Effect$Effects(
				_List_fromArray(
					[
						$author$project$Page$PolicyDetails$Effect$FetchPolicy(policyId),
						$author$project$Page$PolicyDetails$Effect$GetCurrentTime,
						$author$project$Page$PolicyDetails$Effect$RequestIssueRefundReleaseData
					])));
	});
var $author$project$Page$Search$Effect$Effects = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Search$Effect$FetchNewResults = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Search$Effect$FetchResults = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Search$Effect$GetCurrentDate = {$: 6};
var $author$project$Page$Search$Msg$NoOp = {$: 14};
var $author$project$Page$Search$Effect$None = {$: 0};
var $author$project$Page$Search$Effect$WithCmd = function (a) {
	return {$: 3, a: a};
};
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Page$Search$Model$init = function (newSearchApiEnabled) {
	return {
		fL: $author$project$Pyxis$Components$Tabs$init,
		eb: $author$project$Pyxis$Components$Modal$init('legal-recording-disclaimer-modal'),
		gf: $elm$core$Maybe$Nothing,
		gL: $author$project$Pyxis$Components$Modal$init('great-lakes-opt-in-consent-modal'),
		g3: false,
		eO: false,
		kx: $krisajenkins$remotedata$RemoteData$NotAsked,
		c9: newSearchApiEnabled,
		kJ: $krisajenkins$remotedata$RemoteData$NotAsked,
		h7: $author$project$Pyxis$Components$Field$Input$init,
		lb: 'payment-disputes',
		dt: $krisajenkins$remotedata$RemoteData$NotAsked,
		du: $author$project$Pyxis$Components$Field$Input$init,
		lv: 'personal-id-number',
		bi: $elm$core$Result$Ok($author$project$Page$Search$SearchQueryParam$Empty),
		lw: $krisajenkins$remotedata$RemoteData$NotAsked,
		lE: $elm$core$Maybe$Nothing,
		dy: $author$project$Pyxis$Components$Modal$init('stop-recording-disclaimer-modal'),
		s: $author$project$Pyxis$Components$Toasts$init
	};
};
var $author$project$Page$Search$SearchQueryParam$inputIsQuoteCfid = function (input) {
	if ((input.$ === 1) && (input.a.$ === 2)) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Components$Tabs$setActiveTabIndex = F2(
	function (index, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{
				M: index,
				b0: A3(
					$elm$core$Dict$insert,
					index,
					1 + A2(
						$elm$core$Maybe$withDefault,
						0,
						A2($elm$core$Dict$get, index, modelData.b0)),
					modelData.b0),
				$7: $elm$core$Maybe$Just(modelData.M)
			});
	});
var $author$project$Page$Search$Model$setAdminSearchBarTab = F2(
	function (tabIndex, model) {
		return _Utils_update(
			model,
			{
				fL: A2($author$project$Pyxis$Components$Tabs$setActiveTabIndex, tabIndex, model.fL)
			});
	});
var $author$project$Page$Search$Model$setAdminSearchBarToDisputes = $author$project$Page$Search$Model$setAdminSearchBarTab(1);
var $author$project$Page$Search$Model$setAdminSearchBarToInquiries = $author$project$Page$Search$Model$setAdminSearchBarTab(0);
var $author$project$Pyxis$Components$Field$Input$setValue = F2(
	function (value, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{pB: value});
	});
var $author$project$Page$Search$Model$setPaymentDisputeSearch = F2(
	function (searchTerm, model) {
		return _Utils_update(
			model,
			{
				h7: A2($author$project$Pyxis$Components$Field$Input$setValue, searchTerm, $author$project$Pyxis$Components$Field$Input$init)
			});
	});
var $author$project$Page$Search$Model$setRemoteDataLoading = F2(
	function (useNewSearchApi, model) {
		return useNewSearchApi ? _Utils_update(
			model,
			{kJ: $krisajenkins$remotedata$RemoteData$Loading}) : _Utils_update(
			model,
			{lw: $krisajenkins$remotedata$RemoteData$Loading});
	});
var $author$project$Page$Search$Model$setSearchInputField = F2(
	function (searchTerm, model) {
		return _Utils_update(
			model,
			{
				du: A2($author$project$Pyxis$Components$Field$Input$setValue, searchTerm, $author$project$Pyxis$Components$Field$Input$init)
			});
	});
var $author$project$Page$Search$init = F3(
	function (tabIndex, newSearchApiEnabled, searchQuery) {
		var useNewSearchApi = function () {
			if (!searchQuery.$) {
				var input = searchQuery.a;
				return newSearchApiEnabled && (!$author$project$Page$Search$SearchQueryParam$inputIsQuoteCfid(input));
			} else {
				return false;
			}
		}();
		var initialModel = $author$project$Page$Search$Model$init(newSearchApiEnabled);
		var searchModel = function () {
			if (!searchQuery.$) {
				switch (searchQuery.a.$) {
					case 3:
						var _v3 = searchQuery.a;
						return initialModel;
					case 0:
						var documentId = searchQuery.a.a;
						return A2(
							$author$project$Page$Search$Model$setRemoteDataLoading,
							useNewSearchApi,
							$author$project$Page$Search$Model$setAdminSearchBarToInquiries(
								A2(
									$author$project$Page$Search$Model$setSearchInputField,
									documentId,
									_Utils_update(
										initialModel,
										{bi: searchQuery}))));
					case 1:
						var customerFacingId = searchQuery.a.a;
						return A2(
							$author$project$Page$Search$Model$setRemoteDataLoading,
							useNewSearchApi,
							$author$project$Page$Search$Model$setAdminSearchBarToInquiries(
								A2(
									$author$project$Page$Search$Model$setSearchInputField,
									$author$project$Page$Search$SearchQueryParam$pickCustomerFacingId(customerFacingId),
									_Utils_update(
										initialModel,
										{bi: searchQuery}))));
					case 2:
						var email = searchQuery.a.a;
						return A2(
							$author$project$Page$Search$Model$setRemoteDataLoading,
							useNewSearchApi,
							A2(
								$author$project$Page$Search$Model$setAdminSearchBarTab,
								tabIndex,
								A2(
									$author$project$Page$Search$Model$setPaymentDisputeSearch,
									email,
									A2(
										$author$project$Page$Search$Model$setSearchInputField,
										email,
										_Utils_update(
											initialModel,
											{bi: searchQuery})))));
					case 4:
						var plateNumber = searchQuery.a.a;
						return A2(
							$author$project$Page$Search$Model$setRemoteDataLoading,
							useNewSearchApi,
							$author$project$Page$Search$Model$setAdminSearchBarToInquiries(
								A2(
									$author$project$Page$Search$Model$setSearchInputField,
									plateNumber,
									_Utils_update(
										initialModel,
										{bi: searchQuery}))));
					case 5:
						var phoneNumber = searchQuery.a.a;
						return A2(
							$author$project$Page$Search$Model$setRemoteDataLoading,
							useNewSearchApi,
							$author$project$Page$Search$Model$setAdminSearchBarToInquiries(
								A2(
									$author$project$Page$Search$Model$setSearchInputField,
									phoneNumber,
									_Utils_update(
										initialModel,
										{bi: searchQuery}))));
					default:
						var id = searchQuery.a.a;
						return A2(
							$author$project$Page$Search$Model$setRemoteDataLoading,
							useNewSearchApi,
							$author$project$Page$Search$Model$setAdminSearchBarToDisputes(
								A2(
									$author$project$Page$Search$Model$setPaymentDisputeSearch,
									$danyx23$elm_uuid$Uuid$toString(id),
									_Utils_update(
										initialModel,
										{bi: searchQuery}))));
				}
			} else {
				return _Utils_update(
					initialModel,
					{bi: searchQuery});
			}
		}();
		var additionalEffect = function () {
			if (!searchQuery.$) {
				if (searchQuery.a.$ === 3) {
					var _v1 = searchQuery.a;
					return $author$project$Page$Search$Effect$WithCmd(
						A2(
							$elm$core$Task$attempt,
							$elm$core$Basics$always($author$project$Page$Search$Msg$NoOp),
							$elm$browser$Browser$Dom$focus(initialModel.lv)));
				} else {
					var searchInputString = searchQuery.a;
					return useNewSearchApi ? $author$project$Page$Search$Effect$FetchNewResults(searchInputString) : $author$project$Page$Search$Effect$FetchResults(searchInputString);
				}
			} else {
				return $author$project$Page$Search$Effect$None;
			}
		}();
		return _Utils_Tuple2(
			searchModel,
			$author$project$Page$Search$Effect$Effects(
				_List_fromArray(
					[additionalEffect, $author$project$Page$Search$Effect$GetCurrentDate])));
	});
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$Env$newSearchApiEnabled = function (_v0) {
	var environment = _v0;
	return environment.c9;
};
var $author$project$Main$initPage = F2(
	function (env, route) {
		switch (route.$) {
			case 0:
				return A3($elm$core$Tuple$mapBoth, $author$project$Model$NotFound, $author$project$Effect$NotFound, $author$project$Page$NotFound$init);
			case 1:
				return A3($elm$core$Tuple$mapBoth, $author$project$Model$NotAuthorized, $author$project$Effect$NotAuthorized, $author$project$Page$NotAuthorized$init);
			case 2:
				return A3(
					$elm$core$Tuple$mapBoth,
					$author$project$Model$Login,
					$author$project$Effect$Login,
					A2(
						$author$project$Page$Login$init,
						$author$project$Env$newApiUrl(env),
						$elm$core$Maybe$Nothing));
			case 3:
				var tabIndex = route.a;
				var searchQuery = route.b;
				return A3(
					$elm$core$Tuple$mapBoth,
					$author$project$Model$Search,
					$author$project$Effect$Search,
					A3(
						$author$project$Page$Search$init,
						tabIndex,
						$author$project$Env$newSearchApiEnabled(env),
						searchQuery));
			case 4:
				var offerId = route.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					$author$project$Model$Payment,
					$author$project$Effect$Payment,
					$author$project$Page$Payment$init(offerId));
			case 5:
				var policyId = route.a;
				var referer = route.b;
				return A3(
					$elm$core$Tuple$mapBoth,
					$author$project$Model$PolicyDetails,
					$author$project$Effect$PolicyDetails,
					A2($author$project$Page$PolicyDetails$init, referer, policyId));
			default:
				var cfid = route.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					$author$project$Model$OfferDetails,
					$author$project$Effect$OfferDetails,
					$author$project$Page$OfferDetails$init(cfid));
		}
	});
var $author$project$Common$User$isBackoffice = function (user) {
	if (!user.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Main$onRouteChange = F2(
	function (model, route) {
		if (A2($author$project$Main$canAccess, model.fB, route)) {
			var _v0 = A2($author$project$Main$initPage, model.mU, route);
			var pageModel = _v0.a;
			var effect = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{oO: pageModel}),
				effect);
		} else {
			return _Utils_Tuple2(
				model,
				$author$project$Common$User$isBackoffice(model.fB) ? $author$project$Effect$ChangeRoute($author$project$Route$NotAuthorized) : $author$project$Effect$ChangeRoute($author$project$Route$Login));
		}
	});
var $author$project$Page$Login$Effect$None = {$: 0};
var $author$project$Page$Login$Effect$TryRouteUserTo = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Login$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var result = msg.a;
			switch (result.$) {
				case 3:
					var user = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Page$Login$Effect$TryRouteUserTo(
							_Utils_Tuple2(user, model.pr)));
				case 2:
					var failure = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								mn: $krisajenkins$remotedata$RemoteData$Failure(failure)
							}),
						$author$project$Page$Login$Effect$None);
				default:
					return _Utils_Tuple2(model, $author$project$Page$Login$Effect$None);
			}
		} else {
			return _Utils_Tuple2(model, $author$project$Page$Login$Effect$None);
		}
	});
var $author$project$Page$NotAuthorized$update = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, 0);
	});
var $author$project$Page$NotFound$update = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, 0);
	});
var $author$project$Page$OfferDetails$Effect$AmendOfferCoverageEffectiveDate = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Page$OfferDetails$Effect$ChangeRoute = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$OfferDetails$Effect$FetchPaymentMethod = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$OfferDetails$Effect$FetchPricingActionClaimHistory = function (a) {
	return {$: 4, a: a};
};
var $author$project$ExternalUrl$FunnelOffer = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Page$OfferDetails$Effect$None = {$: 14};
var $author$project$Page$OfferDetails$Effect$SaveGreatLakesOptInConsent = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Page$OfferDetails$Effect$SendOfferEmail = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$OfferDetails$Effect$TrackSendEmail = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$OfferDetails$Effect$WithCmd = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pyxis$Components$Toasts$Add = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$deletingTimed = function (timed) {
	switch (timed.$) {
		case 0:
			var wrappedEl = timed.b;
			return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting(wrappedEl);
		case 1:
			var wrappedEl = timed.a;
			return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting(wrappedEl);
		case 2:
			var wrappedEl = timed.a;
			return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting(wrappedEl);
		default:
			var wrappedEl = timed.b;
			return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting(wrappedEl);
	}
};
var $author$project$Pyxis$Components$Toasts$updateModelDeletingToast = F2(
	function (toastUUID, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				s: A3(
					$elm$core$Dict$update,
					toastUUID,
					$elm$core$Maybe$map($author$project$Pyxis$Components$Toasts$ToastsHelpers$deletingTimed),
					model.s)
			});
	});
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$Idle = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$Paused = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$deltaIntervalInMilliseconds = 500;
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$pausingTimed = function (timed) {
	switch (timed.$) {
		case 0:
			var visibilityTime = timed.a;
			var wrappedEl = timed.b;
			return A2($author$project$Pyxis$Components$Toasts$ToastsHelpers$Paused, visibilityTime, wrappedEl);
		case 1:
			var wrappedEl = timed.a;
			return A2($author$project$Pyxis$Components$Toasts$ToastsHelpers$Paused, $author$project$Pyxis$Components$Toasts$ToastsHelpers$deltaIntervalInMilliseconds, wrappedEl);
		case 2:
			var wrappedEl = timed.a;
			return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Idle(wrappedEl);
		default:
			var visibilityTime = timed.a;
			var wrappedEl = timed.b;
			return A2($author$project$Pyxis$Components$Toasts$ToastsHelpers$Paused, visibilityTime, wrappedEl);
	}
};
var $author$project$Pyxis$Components$Toasts$updateModelPausedToast = F2(
	function (toastUUID, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				s: A3(
					$elm$core$Dict$update,
					toastUUID,
					$elm$core$Maybe$map($author$project$Pyxis$Components$Toasts$ToastsHelpers$pausingTimed),
					model.s)
			});
	});
var $author$project$Pyxis$Components$Toasts$updateModelRemoveToast = F2(
	function (toastUUID, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				s: A2($elm$core$Dict$remove, toastUUID, model.s)
			});
	});
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$Running = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$resumingTimed = function (timed) {
	switch (timed.$) {
		case 3:
			var visibilityTime = timed.a;
			var wrappedEl = timed.b;
			return _Utils_eq(visibilityTime, $author$project$Pyxis$Components$Toasts$ToastsHelpers$deltaIntervalInMilliseconds) ? $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting(wrappedEl) : A2($author$project$Pyxis$Components$Toasts$ToastsHelpers$Running, visibilityTime, wrappedEl);
		case 1:
			var wrappedEl = timed.a;
			return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting(wrappedEl);
		case 2:
			var wrappedEl = timed.a;
			return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Idle(wrappedEl);
		default:
			var visibilityTime = timed.a;
			var wrappedEl = timed.b;
			return A2($author$project$Pyxis$Components$Toasts$ToastsHelpers$Running, visibilityTime, wrappedEl);
	}
};
var $author$project$Pyxis$Components$Toasts$updateModelResumeToast = F2(
	function (toastUUID, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				s: A3(
					$elm$core$Dict$update,
					toastUUID,
					$elm$core$Maybe$map($author$project$Pyxis$Components$Toasts$ToastsHelpers$resumingTimed),
					model.s)
			});
	});
var $author$project$Pyxis$Components$Toasts$updateModelWithIncreasedCounter = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{ec: model.ec + 1});
};
var $primait$prima_elm_extra$PrimaFunction$flip = F3(
	function (mapper, b, a) {
		return A2(mapper, a, b);
	});
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 0:
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 1:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i16, mb, offset, n, !e);
			case 2:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i32, mb, offset, n, !e);
			case 3:
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 4:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u16, mb, offset, n, !e);
			case 5:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u32, mb, offset, n, !e);
			case 6:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f32, mb, offset, n, !e);
			case 7:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f64, mb, offset, n, !e);
			case 8:
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 9:
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $TSFoster$elm_uuid$UUID$UUID = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$bytes$Bytes$Encode$Bytes = function (a) {
	return {$: 10, a: a};
};
var $elm$bytes$Bytes$Encode$bytes = $elm$bytes$Bytes$Encode$Bytes;
var $elm$bytes$Bytes$BE = 1;
var $elm$bytes$Bytes$Encode$Seq = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$getWidths = F2(
	function (width, builders) {
		getWidths:
		while (true) {
			if (!builders.b) {
				return width;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b),
					$temp$builders = bs;
				width = $temp$width;
				builders = $temp$builders;
				continue getWidths;
			}
		}
	});
var $elm$bytes$Bytes$Encode$sequence = function (builders) {
	return A2(
		$elm$bytes$Bytes$Encode$Seq,
		A2($elm$bytes$Bytes$Encode$getWidths, 0, builders),
		builders);
};
var $elm$bytes$Bytes$Encode$U32 = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$unsignedInt32 = $elm$bytes$Bytes$Encode$U32;
var $TSFoster$elm_uuid$UUID$encoder = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	var c = _v0.c;
	var d = _v0.d;
	return $elm$bytes$Bytes$Encode$sequence(
		_List_fromArray(
			[
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, a),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, b),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, c),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, d)
			]));
};
var $elm$bytes$Bytes$Decode$decode = F2(
	function (_v0, bs) {
		var decoder = _v0;
		return A2(_Bytes_decode, decoder, bs);
	});
var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Decode$loopHelp = F4(
	function (state, callback, bites, offset) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var decoder = _v0;
			var _v1 = A2(decoder, bites, offset);
			var newOffset = _v1.a;
			var step = _v1.b;
			if (!step.$) {
				var newState = step.a;
				var $temp$state = newState,
					$temp$callback = callback,
					$temp$bites = bites,
					$temp$offset = newOffset;
				state = $temp$state;
				callback = $temp$callback;
				bites = $temp$bites;
				offset = $temp$offset;
				continue loopHelp;
			} else {
				var result = step.a;
				return _Utils_Tuple2(newOffset, result);
			}
		}
	});
var $elm$bytes$Bytes$Decode$loop = F2(
	function (state, callback) {
		return A2($elm$bytes$Bytes$Decode$loopHelp, state, callback);
	});
var $elm$bytes$Bytes$Decode$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$bytes$Bytes$Decode$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$bytes$Bytes$Decode$map = F2(
	function (func, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var aOffset = _v1.a;
				var a = _v1.b;
				return _Utils_Tuple2(
					aOffset,
					func(a));
			});
	});
var $elm$bytes$Bytes$Decode$succeed = function (a) {
	return F2(
		function (_v0, offset) {
			return _Utils_Tuple2(offset, a);
		});
};
var $TSFoster$elm_sha1$SHA1$loopHelp = F2(
	function (step, _v0) {
		var n = _v0.a;
		var state = _v0.b;
		return (n > 0) ? A2(
			$elm$bytes$Bytes$Decode$map,
			function (_new) {
				return $elm$bytes$Bytes$Decode$Loop(
					_Utils_Tuple2(n - 1, _new));
			},
			step(state)) : $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(state));
	});
var $TSFoster$elm_sha1$SHA1$iterate = F3(
	function (n, step, initial) {
		return A2(
			$elm$bytes$Bytes$Decode$loop,
			_Utils_Tuple2(n, initial),
			$TSFoster$elm_sha1$SHA1$loopHelp(step));
	});
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $elm$bytes$Bytes$Encode$U8 = function (a) {
	return {$: 3, a: a};
};
var $elm$bytes$Bytes$Encode$unsignedInt8 = $elm$bytes$Bytes$Encode$U8;
var $elm$bytes$Bytes$width = _Bytes_width;
var $TSFoster$elm_sha1$SHA1$padBuffer = function (bytes) {
	var byteCount = $elm$bytes$Bytes$width(bytes);
	var paddingSize = 4 + A2(
		$elm$core$Basics$modBy,
		64,
		56 - A2($elm$core$Basics$modBy, 64, byteCount + 1));
	var message = $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$bytes(bytes),
					$elm$bytes$Bytes$Encode$unsignedInt8(128),
					$elm$bytes$Bytes$Encode$sequence(
					A2(
						$elm$core$List$repeat,
						paddingSize,
						$elm$bytes$Bytes$Encode$unsignedInt8(0))),
					A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, byteCount << 3)
				])));
	return message;
};
var $elm$bytes$Bytes$Decode$map4 = F5(
	function (func, _v0, _v1, _v2, _v3) {
		var decodeA = _v0;
		var decodeB = _v1;
		var decodeC = _v2;
		var decodeD = _v3;
		return F2(
			function (bites, offset) {
				var _v4 = A2(decodeA, bites, offset);
				var aOffset = _v4.a;
				var a = _v4.b;
				var _v5 = A2(decodeB, bites, aOffset);
				var bOffset = _v5.a;
				var b = _v5.b;
				var _v6 = A2(decodeC, bites, bOffset);
				var cOffset = _v6.a;
				var c = _v6.b;
				var _v7 = A2(decodeD, bites, cOffset);
				var dOffset = _v7.a;
				var d = _v7.b;
				return _Utils_Tuple2(
					dOffset,
					A4(func, a, b, c, d));
			});
	});
var $elm$bytes$Bytes$Decode$map5 = F6(
	function (func, _v0, _v1, _v2, _v3, _v4) {
		var decodeA = _v0;
		var decodeB = _v1;
		var decodeC = _v2;
		var decodeD = _v3;
		var decodeE = _v4;
		return F2(
			function (bites, offset) {
				var _v5 = A2(decodeA, bites, offset);
				var aOffset = _v5.a;
				var a = _v5.b;
				var _v6 = A2(decodeB, bites, aOffset);
				var bOffset = _v6.a;
				var b = _v6.b;
				var _v7 = A2(decodeC, bites, bOffset);
				var cOffset = _v7.a;
				var c = _v7.b;
				var _v8 = A2(decodeD, bites, cOffset);
				var dOffset = _v8.a;
				var d = _v8.b;
				var _v9 = A2(decodeE, bites, dOffset);
				var eOffset = _v9.a;
				var e = _v9.b;
				return _Utils_Tuple2(
					eOffset,
					A5(func, a, b, c, d, e));
			});
	});
var $TSFoster$elm_sha1$SHA1$map16 = function (f) {
	return function (b1) {
		return function (b2) {
			return function (b3) {
				return function (b4) {
					return function (b5) {
						return function (b6) {
							return function (b7) {
								return function (b8) {
									return function (b9) {
										return function (b10) {
											return function (b11) {
												return function (b12) {
													return function (b13) {
														return function (b14) {
															return function (b15) {
																return function (b16) {
																	var d1 = A5(
																		$elm$bytes$Bytes$Decode$map4,
																		F4(
																			function (a, b, c, d) {
																				return A4(f, a, b, c, d);
																			}),
																		b1,
																		b2,
																		b3,
																		b4);
																	var d2 = A6(
																		$elm$bytes$Bytes$Decode$map5,
																		F5(
																			function (h, a, b, c, d) {
																				return A4(h, a, b, c, d);
																			}),
																		d1,
																		b5,
																		b6,
																		b7,
																		b8);
																	var d3 = A6(
																		$elm$bytes$Bytes$Decode$map5,
																		F5(
																			function (h, a, b, c, d) {
																				return A4(h, a, b, c, d);
																			}),
																		d2,
																		b9,
																		b10,
																		b11,
																		b12);
																	var d4 = A6(
																		$elm$bytes$Bytes$Decode$map5,
																		F5(
																			function (h, a, b, c, d) {
																				return A4(h, a, b, c, d);
																			}),
																		d3,
																		b13,
																		b14,
																		b15,
																		b16);
																	return d4;
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $TSFoster$elm_sha1$SHA1$DeltaState = $elm$core$Basics$identity;
var $TSFoster$elm_sha1$SHA1$State = $elm$core$Basics$identity;
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $TSFoster$elm_sha1$SHA1$rotateLeftBy = F2(
	function (amount, i) {
		return ((i >>> (32 - amount)) | (i << amount)) >>> 0;
	});
var $TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk = F3(
	function (index, _int, _v0) {
		var a = _v0.dS;
		var b = _v0.mo;
		var c = _v0.d3;
		var d = _v0.ei;
		var e = _v0.O;
		var shiftedA = (a >>> (32 - 5)) | (a << 5);
		var f = function () {
			var _v1 = (index / 20) | 0;
			switch (_v1) {
				case 0:
					return ((b & c) | ((~b) & d)) + 1518500249;
				case 1:
					return (b ^ (c ^ d)) + 1859775393;
				case 2:
					return ((b & (c | d)) | (c & d)) + 2400959708;
				default:
					return (b ^ (c ^ d)) + 3395469782;
			}
		}();
		var newA = (((shiftedA + f) + e) + _int) >>> 0;
		return {
			dS: newA,
			mo: a,
			d3: A2($TSFoster$elm_sha1$SHA1$rotateLeftBy, 30, b),
			ei: c,
			O: d
		};
	});
var $TSFoster$elm_sha1$SHA1$calculateDigestDeltas = function (remaining) {
	return function (index) {
		return function (a) {
			return function (b) {
				return function (c) {
					return function (d) {
						return function (e) {
							return function (v1) {
								return function (v2) {
									return function (v3) {
										return function (v4) {
											return function (v5) {
												return function (v6) {
													return function (v7) {
														return function (v8) {
															calculateDigestDeltas:
															while (true) {
																if (!remaining) {
																	return {dS: a, mo: b, d3: c, ei: d, O: e};
																} else {
																	var shiftedA = (a >>> (32 - 5)) | (a << 5);
																	var _int = v1;
																	var f = function () {
																		var _v0 = (index / 20) | 0;
																		switch (_v0) {
																			case 0:
																				return ((b & c) | ((~b) & d)) + 1518500249;
																			case 1:
																				return (b ^ (c ^ d)) + 1859775393;
																			case 2:
																				return ((b & (c | d)) | (c & d)) + 2400959708;
																			default:
																				return (b ^ (c ^ d)) + 3395469782;
																		}
																	}();
																	var newA = (((shiftedA + f) + e) + _int) >>> 0;
																	var $temp$remaining = remaining - 1,
																		$temp$index = index + 1,
																		$temp$a = newA,
																		$temp$b = a,
																		$temp$c = A2($TSFoster$elm_sha1$SHA1$rotateLeftBy, 30, b),
																		$temp$d = c,
																		$temp$e = d,
																		$temp$v1 = v2,
																		$temp$v2 = v3,
																		$temp$v3 = v4,
																		$temp$v4 = v5,
																		$temp$v5 = v6,
																		$temp$v6 = v7,
																		$temp$v7 = v8,
																		$temp$v8 = 0;
																	remaining = $temp$remaining;
																	index = $temp$index;
																	a = $temp$a;
																	b = $temp$b;
																	c = $temp$c;
																	d = $temp$d;
																	e = $temp$e;
																	v1 = $temp$v1;
																	v2 = $temp$v2;
																	v3 = $temp$v3;
																	v4 = $temp$v4;
																	v5 = $temp$v5;
																	v6 = $temp$v6;
																	v7 = $temp$v7;
																	v8 = $temp$v8;
																	continue calculateDigestDeltas;
																}
															}
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $TSFoster$elm_sha1$SHA1$rotateLeftBy1 = function (i) {
	return (i >>> 31) | (i << 1);
};
var $TSFoster$elm_sha1$SHA1$reduceWords = function (i) {
	return function (deltaState) {
		return function (b16) {
			return function (b15) {
				return function (b14) {
					return function (b13) {
						return function (b12) {
							return function (b11) {
								return function (b10) {
									return function (b9) {
										return function (b8) {
											return function (b7) {
												return function (b6) {
													return function (b5) {
														return function (b4) {
															return function (b3) {
																return function (b2) {
																	return function (b1) {
																		reduceWords:
																		while (true) {
																			var a = deltaState.dS;
																			var b = deltaState.mo;
																			var c = deltaState.d3;
																			var d = deltaState.ei;
																			var e = deltaState.O;
																			if (i !== 64) {
																				var value3 = $TSFoster$elm_sha1$SHA1$rotateLeftBy1(b14 ^ (b12 ^ (b6 ^ b1)));
																				var value6 = $TSFoster$elm_sha1$SHA1$rotateLeftBy1(b11 ^ (b9 ^ (b3 ^ value3)));
																				var value2 = $TSFoster$elm_sha1$SHA1$rotateLeftBy1(b15 ^ (b13 ^ (b7 ^ b2)));
																				var value5 = $TSFoster$elm_sha1$SHA1$rotateLeftBy1(b12 ^ (b10 ^ (b4 ^ value2)));
																				var value8 = $TSFoster$elm_sha1$SHA1$rotateLeftBy1(b9 ^ (b7 ^ (b1 ^ value5)));
																				var value1 = $TSFoster$elm_sha1$SHA1$rotateLeftBy1(b16 ^ (b14 ^ (b8 ^ b3)));
																				var value4 = $TSFoster$elm_sha1$SHA1$rotateLeftBy1(b13 ^ (b11 ^ (b5 ^ value1)));
																				var value7 = $TSFoster$elm_sha1$SHA1$rotateLeftBy1(b10 ^ (b8 ^ (b2 ^ value4)));
																				var newState = $TSFoster$elm_sha1$SHA1$calculateDigestDeltas(8)(i + 16)(a)(b)(c)(d)(e)(value1)(value2)(value3)(value4)(value5)(value6)(value7)(value8);
																				var $temp$i = i + 8,
																					$temp$deltaState = newState,
																					$temp$b16 = b8,
																					$temp$b15 = b7,
																					$temp$b14 = b6,
																					$temp$b13 = b5,
																					$temp$b12 = b4,
																					$temp$b11 = b3,
																					$temp$b10 = b2,
																					$temp$b9 = b1,
																					$temp$b8 = value1,
																					$temp$b7 = value2,
																					$temp$b6 = value3,
																					$temp$b5 = value4,
																					$temp$b4 = value5,
																					$temp$b3 = value6,
																					$temp$b2 = value7,
																					$temp$b1 = value8;
																				i = $temp$i;
																				deltaState = $temp$deltaState;
																				b16 = $temp$b16;
																				b15 = $temp$b15;
																				b14 = $temp$b14;
																				b13 = $temp$b13;
																				b12 = $temp$b12;
																				b11 = $temp$b11;
																				b10 = $temp$b10;
																				b9 = $temp$b9;
																				b8 = $temp$b8;
																				b7 = $temp$b7;
																				b6 = $temp$b6;
																				b5 = $temp$b5;
																				b4 = $temp$b4;
																				b3 = $temp$b3;
																				b2 = $temp$b2;
																				b1 = $temp$b1;
																				continue reduceWords;
																			} else {
																				return deltaState;
																			}
																		}
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $TSFoster$elm_sha1$SHA1$reduceChunkHelp = function (_v0) {
	return function (b1) {
		return function (b2) {
			return function (b3) {
				return function (b4) {
					return function (b5) {
						return function (b6) {
							return function (b7) {
								return function (b8) {
									return function (b9) {
										return function (b10) {
											return function (b11) {
												return function (b12) {
													return function (b13) {
														return function (b14) {
															return function (b15) {
																return function (b16) {
																	var initial = _v0;
																	var initialDeltaState = A3(
																		$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																		15,
																		b16,
																		A3(
																			$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																			14,
																			b15,
																			A3(
																				$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																				13,
																				b14,
																				A3(
																					$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																					12,
																					b13,
																					A3(
																						$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																						11,
																						b12,
																						A3(
																							$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																							10,
																							b11,
																							A3(
																								$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																								9,
																								b10,
																								A3(
																									$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																									8,
																									b9,
																									A3(
																										$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																										7,
																										b8,
																										A3(
																											$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																											6,
																											b7,
																											A3(
																												$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																												5,
																												b6,
																												A3(
																													$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																													4,
																													b5,
																													A3(
																														$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																														3,
																														b4,
																														A3(
																															$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																															2,
																															b3,
																															A3(
																																$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																																1,
																																b2,
																																A3($TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk, 0, b1, initial))))))))))))))));
																	var _v1 = $TSFoster$elm_sha1$SHA1$reduceWords(0)(initialDeltaState)(b1)(b2)(b3)(b4)(b5)(b6)(b7)(b8)(b9)(b10)(b11)(b12)(b13)(b14)(b15)(b16);
																	var a = _v1.dS;
																	var b = _v1.mo;
																	var c = _v1.d3;
																	var d = _v1.ei;
																	var e = _v1.O;
																	return {dS: initial.dS + a, mo: initial.mo + b, d3: initial.d3 + c, ei: initial.ei + d, O: initial.O + e};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$bytes$Bytes$Decode$unsignedInt32 = function (endianness) {
	return _Bytes_read_u32(!endianness);
};
var $TSFoster$elm_sha1$SHA1$u32 = $elm$bytes$Bytes$Decode$unsignedInt32(1);
var $TSFoster$elm_sha1$SHA1$reduceChunk = function (state) {
	return $TSFoster$elm_sha1$SHA1$map16(
		$TSFoster$elm_sha1$SHA1$reduceChunkHelp(state))($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32);
};
var $TSFoster$elm_sha1$SHA1$Digest = $elm$core$Basics$identity;
var $TSFoster$elm_sha1$SHA1$stateToDigest = function (_v0) {
	var a = _v0.dS;
	var b = _v0.mo;
	var c = _v0.d3;
	var d = _v0.ei;
	var e = _v0.O;
	return {dS: a >>> 0, mo: b >>> 0, d3: c >>> 0, ei: d >>> 0, O: e >>> 0};
};
var $TSFoster$elm_sha1$SHA1$hashBytes = F2(
	function (state, bytes) {
		var message = $TSFoster$elm_sha1$SHA1$padBuffer(bytes);
		var numberOfChunks = ($elm$bytes$Bytes$width(message) / 64) | 0;
		var hashState = A3($TSFoster$elm_sha1$SHA1$iterate, numberOfChunks, $TSFoster$elm_sha1$SHA1$reduceChunk, state);
		return $TSFoster$elm_sha1$SHA1$stateToDigest(
			A2(
				$elm$core$Maybe$withDefault,
				state,
				A2($elm$bytes$Bytes$Decode$decode, hashState, message)));
	});
var $TSFoster$elm_sha1$SHA1$Tuple5 = F5(
	function (a, b, c, d, e) {
		return {dS: a, mo: b, d3: c, ei: d, O: e};
	});
var $TSFoster$elm_sha1$SHA1$initialState = A5($TSFoster$elm_sha1$SHA1$Tuple5, 1732584193, 4023233417, 2562383102, 271733878, 3285377520);
var $TSFoster$elm_sha1$SHA1$fromBytes = $TSFoster$elm_sha1$SHA1$hashBytes($TSFoster$elm_sha1$SHA1$initialState);
var $TSFoster$elm_sha1$SHA1$toInt32s = function (_v0) {
	var digest = _v0;
	return digest;
};
var $TSFoster$elm_uuid$UUID$forceUnsigned = $elm$core$Bitwise$shiftRightZfBy(0);
var $TSFoster$elm_uuid$UUID$toVariant1 = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	var c = _v0.c;
	var d = _v0.d;
	return A4(
		$TSFoster$elm_uuid$UUID$UUID,
		a,
		b,
		$TSFoster$elm_uuid$UUID$forceUnsigned(2147483648 | (1073741823 & c)),
		d);
};
var $TSFoster$elm_uuid$UUID$toVersion = F2(
	function (v, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		var d = _v0.d;
		return A4(
			$TSFoster$elm_uuid$UUID$UUID,
			a,
			$TSFoster$elm_uuid$UUID$forceUnsigned((v << 12) | (4294905855 & b)),
			c,
			d);
	});
var $TSFoster$elm_uuid$UUID$forBytes = F2(
	function (bytes, namespace) {
		return $TSFoster$elm_uuid$UUID$toVariant1(
			A2(
				$TSFoster$elm_uuid$UUID$toVersion,
				5,
				function (_v0) {
					var a = _v0.dS;
					var b = _v0.mo;
					var c = _v0.d3;
					var d = _v0.ei;
					return A4($TSFoster$elm_uuid$UUID$UUID, a, b, c, d);
				}(
					$TSFoster$elm_sha1$SHA1$toInt32s(
						$TSFoster$elm_sha1$SHA1$fromBytes(
							$elm$bytes$Bytes$Encode$encode(
								$elm$bytes$Bytes$Encode$sequence(
									_List_fromArray(
										[
											$TSFoster$elm_uuid$UUID$encoder(namespace),
											$elm$bytes$Bytes$Encode$bytes(bytes)
										]))))))));
	});
var $elm$bytes$Bytes$Encode$Utf8 = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$string = function (str) {
	return A2(
		$elm$bytes$Bytes$Encode$Utf8,
		_Bytes_getStringWidth(str),
		str);
};
var $TSFoster$elm_uuid$UUID$forName = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$Basics$composeL, $TSFoster$elm_uuid$UUID$forBytes, $elm$bytes$Bytes$Encode$encode),
	$elm$bytes$Bytes$Encode$string);
var $TSFoster$elm_uuid$UUID$toHex = F2(
	function (acc, _int) {
		toHex:
		while (true) {
			if (!_int) {
				return $elm$core$String$fromList(acc);
			} else {
				var _char = function () {
					var _v0 = 15 & _int;
					switch (_v0) {
						case 0:
							return '0';
						case 1:
							return '1';
						case 2:
							return '2';
						case 3:
							return '3';
						case 4:
							return '4';
						case 5:
							return '5';
						case 6:
							return '6';
						case 7:
							return '7';
						case 8:
							return '8';
						case 9:
							return '9';
						case 10:
							return 'a';
						case 11:
							return 'b';
						case 12:
							return 'c';
						case 13:
							return 'd';
						case 14:
							return 'e';
						default:
							return 'f';
					}
				}();
				var $temp$acc = A2($elm$core$List$cons, _char, acc),
					$temp$int = _int >>> 4;
				acc = $temp$acc;
				_int = $temp$int;
				continue toHex;
			}
		}
	});
var $TSFoster$elm_uuid$UUID$toStringWith = F2(
	function (sep, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		var d = _v0.d;
		return _Utils_ap(
			A3(
				$elm$core$String$padLeft,
				8,
				'0',
				A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, a)),
			_Utils_ap(
				sep,
				_Utils_ap(
					A3(
						$elm$core$String$padLeft,
						4,
						'0',
						A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, b >>> 16)),
					_Utils_ap(
						sep,
						_Utils_ap(
							A3(
								$elm$core$String$padLeft,
								4,
								'0',
								A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, 65535 & b)),
							_Utils_ap(
								sep,
								_Utils_ap(
									A3(
										$elm$core$String$padLeft,
										4,
										'0',
										A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, c >>> 16)),
									_Utils_ap(
										sep,
										_Utils_ap(
											A3(
												$elm$core$String$padLeft,
												4,
												'0',
												A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, 65535 & c)),
											A3(
												$elm$core$String$padLeft,
												8,
												'0',
												A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, d)))))))))));
	});
var $TSFoster$elm_uuid$UUID$toString = $TSFoster$elm_uuid$UUID$toStringWith('-');
var $TSFoster$elm_uuid$UUID$urlNamespace = A4($TSFoster$elm_uuid$UUID$UUID, 1806153745, 2645365201, 2159280320, 1339306184);
var $author$project$Pyxis$Components$Toasts$counterToUUID = function (counter) {
	return $TSFoster$elm_uuid$UUID$toString(
		A3(
			$primait$prima_elm_extra$PrimaFunction$flip,
			$TSFoster$elm_uuid$UUID$forName,
			$TSFoster$elm_uuid$UUID$urlNamespace,
			$elm$core$String$fromInt(counter)));
};
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$idle = $author$project$Pyxis$Components$Toasts$ToastsHelpers$Idle;
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$running = function (duration) {
	return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Running(duration);
};
var $author$project$Pyxis$Components$Toasts$Toast = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Toasts$withInternalId = F2(
	function (internalId, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{kg: internalId});
	});
var $author$project$Pyxis$Components$Toasts$updateModelWithNewToast = F2(
	function (toastToAdd, _v0) {
		var duration = toastToAdd.eo;
		var isSticky = toastToAdd.eQ;
		var model = _v0;
		var internalId = $author$project$Pyxis$Components$Toasts$counterToUUID(model.ec);
		var toastToAddWithId = A2($author$project$Pyxis$Components$Toasts$withInternalId, internalId, toastToAdd);
		var timedToast = isSticky ? $author$project$Pyxis$Components$Toasts$ToastsHelpers$idle(toastToAddWithId) : A2($author$project$Pyxis$Components$Toasts$ToastsHelpers$running, duration, toastToAddWithId);
		return _Utils_update(
			model,
			{
				s: A3($elm$core$Dict$insert, internalId, timedToast, model.s)
			});
	});
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$isDeleting = function (timed) {
	if (timed.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $elm$core$Basics$truncate = _Basics_truncate;
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$tickDownVisibilityTimeForToastsDict = F3(
	function (tick, _v0, timedToast) {
		var deltaInTimeAsInt = tick | 0;
		switch (timedToast.$) {
			case 0:
				var visibilityTime = timedToast.a;
				var wrappedToast = timedToast.b;
				return _Utils_eq(visibilityTime - deltaInTimeAsInt, $author$project$Pyxis$Components$Toasts$ToastsHelpers$deltaIntervalInMilliseconds) ? $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting(wrappedToast) : A2($author$project$Pyxis$Components$Toasts$ToastsHelpers$Running, visibilityTime - deltaInTimeAsInt, wrappedToast);
			case 1:
				var wrappedToast = timedToast.a;
				return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting(wrappedToast);
			case 2:
				var wrappedToast = timedToast.a;
				return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Idle(wrappedToast);
			default:
				var visibilityTime = timedToast.a;
				var wrappedToast = timedToast.b;
				return A2($author$project$Pyxis$Components$Toasts$ToastsHelpers$Paused, visibilityTime, wrappedToast);
		}
	});
var $author$project$Pyxis$Components$Toasts$updateModelWithTickDown = F2(
	function (deltaTime, _v0) {
		var model = _v0;
		var isNotDeleting = F2(
			function (_v1, timed) {
				return !$author$project$Pyxis$Components$Toasts$ToastsHelpers$isDeleting(timed);
			});
		return _Utils_update(
			model,
			{
				s: A2(
					$elm$core$Dict$map,
					$author$project$Pyxis$Components$Toasts$ToastsHelpers$tickDownVisibilityTimeForToastsDict(deltaTime),
					A2($elm$core$Dict$filter, isNotDeleting, model.s))
			});
	});
var $primait$prima_elm_extra$PrimaUpdate$withoutCmds = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Pyxis$Components$Toasts$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var delta = msg.a;
				return $primait$prima_elm_extra$PrimaUpdate$withoutCmds(
					A2($author$project$Pyxis$Components$Toasts$updateModelWithTickDown, delta, model));
			case 0:
				var toastToAdd = msg.a;
				return $primait$prima_elm_extra$PrimaUpdate$withoutCmds(
					A2(
						$author$project$Pyxis$Components$Toasts$updateModelWithNewToast,
						toastToAdd,
						$author$project$Pyxis$Components$Toasts$updateModelWithIncreasedCounter(model)));
			case 2:
				var toastUUID = msg.a;
				return $primait$prima_elm_extra$PrimaUpdate$withoutCmds(
					A2($author$project$Pyxis$Components$Toasts$updateModelDeletingToast, toastUUID, model));
			case 3:
				var toastUUID = msg.a;
				return $primait$prima_elm_extra$PrimaUpdate$withoutCmds(
					A2($author$project$Pyxis$Components$Toasts$updateModelRemoveToast, toastUUID, model));
			case 4:
				var toastUUID = msg.a;
				return $primait$prima_elm_extra$PrimaUpdate$withoutCmds(
					A2($author$project$Pyxis$Components$Toasts$updateModelPausedToast, toastUUID, model));
			default:
				var toastUUID = msg.a;
				return $primait$prima_elm_extra$PrimaUpdate$withoutCmds(
					A2($author$project$Pyxis$Components$Toasts$updateModelResumeToast, toastUUID, model));
		}
	});
var $author$project$Pyxis$Components$Toasts$addNewToast = function (toastToAdd) {
	return $author$project$Pyxis$Components$Toasts$update(
		$author$project$Pyxis$Components$Toasts$Add(toastToAdd));
};
var $author$project$Page$OfferDetails$Effect$FetchClaimHistory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$Offer$pickQuoteIdForClaimsHistory = function (_v0) {
	var offer = _v0;
	return offer.il;
};
var $author$project$Page$OfferDetails$chooseEffectForClaimHistory = function (maybeOffer) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Page$OfferDetails$Effect$None,
		A2(
			$elm$core$Maybe$map,
			$author$project$Page$OfferDetails$Effect$FetchClaimHistory,
			A2($elm$core$Maybe$andThen, $author$project$Common$Offer$pickQuoteIdForClaimsHistory, maybeOffer)));
};
var $author$project$Page$OfferDetails$Effect$FetchCoverSelection = function (a) {
	return {$: 5, a: a};
};
var $author$project$Common$Offer$pickId = function (_v0) {
	var offer = _v0;
	return offer.kg;
};
var $author$project$Page$OfferDetails$chooseEffectForCoverSelection = A2(
	$elm_community$maybe_extra$Maybe$Extra$unwrap,
	$author$project$Page$OfferDetails$Effect$None,
	A2($elm$core$Basics$composeR, $author$project$Common$Offer$pickId, $author$project$Page$OfferDetails$Effect$FetchCoverSelection));
var $author$project$Page$OfferDetails$Effect$FetchCustomerId = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$OfferDetails$chooseEffectForCustomerId = function (maybeOffer) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Page$OfferDetails$Effect$None,
		A2(
			$elm$core$Maybe$map,
			$author$project$Page$OfferDetails$Effect$FetchCustomerId,
			A2($elm$core$Maybe$map, $author$project$Common$Offer$pickId, maybeOffer)));
};
var $author$project$Common$Offer$pickIsRenewal = function (_v0) {
	var offer = _v0;
	return offer.eN;
};
var $author$project$Page$OfferDetails$choseEffectForRenewal = function (offer) {
	return $author$project$Common$Offer$pickIsRenewal(offer) ? $author$project$Page$OfferDetails$Effect$FetchPaymentMethod(
		$author$project$Common$Offer$pickId(offer)) : $author$project$Page$OfferDetails$Effect$None;
};
var $author$project$Page$OfferDetails$chooseEffectForPaymentMethod = function (maybeOffer) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Page$OfferDetails$Effect$None,
		A2($elm$core$Maybe$map, $author$project$Page$OfferDetails$choseEffectForRenewal, maybeOffer));
};
var $author$project$Pyxis$Components$Modal$Close = 1;
var $author$project$Pyxis$Commons$Basics$forwardValue = F2(
	function (value, _function) {
		return _function(value);
	});
var $author$project$Pyxis$Commons$Basics$maybeForwardValue = function (value) {
	return $elm$core$Maybe$map(
		$author$project$Pyxis$Commons$Basics$forwardValue(value));
};
var $author$project$Pyxis$Components$Modal$updateIsOpen = F2(
	function (isOpen, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{g2: isOpen});
	});
var $primait$prima_elm_extra$PrimaUpdate$withCmd = F2(
	function (cmd, model) {
		return _Utils_Tuple2(model, cmd);
	});
var $author$project$Pyxis$Components$Modal$update = F2(
	function (msg, model) {
		var enableFocusTrap = model.gv;
		var disableFocusTrap = model.gn;
		var id = model.kg;
		var startingElementId = model.fm;
		if (!msg) {
			return A2(
				$primait$prima_elm_extra$PrimaUpdate$withCmd,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$author$project$Pyxis$Commons$Basics$maybeForwardValue,
						{fm: startingElementId, pF: id},
						enableFocusTrap)),
				A2($author$project$Pyxis$Components$Modal$updateIsOpen, true, model));
		} else {
			return A2(
				$primait$prima_elm_extra$PrimaUpdate$withCmd,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2($author$project$Pyxis$Commons$Basics$maybeForwardValue, 0, disableFocusTrap)),
				A2($author$project$Pyxis$Components$Modal$updateIsOpen, false, model));
		}
	});
var $author$project$Pyxis$Components$Modal$close = $author$project$Pyxis$Components$Modal$update(1);
var $author$project$Common$ComponentUI$Modal$CoverPackages$close = function (_v0) {
	var modelData = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$close(modelData.bX);
	var newModalModel = _v1.a;
	var cmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			modelData,
			{bX: newModalModel}),
		cmd);
};
var $author$project$Page$OfferDetails$closeConsentModelWithOrigin = F2(
	function (model, modalOrigin) {
		if (!modalOrigin) {
			return $author$project$Pyxis$Components$Modal$close(model.bI);
		} else {
			return $author$project$Pyxis$Components$Modal$close(model.bJ);
		}
	});
var $author$project$Translations$detailsToastAmendDateErrorMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The start date has not been correctly updated. Please try again later.';
	} else {
		return 'La fecha de inicio no se ha actualizado correctamente. Por favor, inténtelo de nuevo más tarde.';
	}
};
var $author$project$Translations$detailsToastAmendDateSuccessMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The start date has been correctly updated.';
	} else {
		return 'La fecha de inicio se ha actualizado correctamente.';
	}
};
var $author$project$Pyxis$Components$Toasts$Error = 4;
var $author$project$Pyxis$Components$Toasts$SimpleContent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$IconSet$CheckCircle = 187;
var $author$project$Pyxis$Components$IconSet$checkCircle = 187;
var $author$project$Pyxis$Components$IconSet$ExclamationCircle = 144;
var $author$project$Pyxis$Components$IconSet$exclamationCircle = 144;
var $author$project$Pyxis$Components$IconSet$ExclamationTriangle = 143;
var $author$project$Pyxis$Components$IconSet$exclamationTriangle = 143;
var $author$project$Pyxis$Components$IconSet$InfoCircle = 103;
var $author$project$Pyxis$Components$IconSet$infoCircle = 103;
var $author$project$Pyxis$Components$IconSet$ThumbUp = 36;
var $author$project$Pyxis$Components$IconSet$thumbUp = 36;
var $author$project$Pyxis$Components$Toasts$variantToDefaultIcon = function (variant) {
	switch (variant) {
		case 0:
			return $author$project$Pyxis$Components$IconSet$infoCircle;
		case 1:
			return $author$project$Pyxis$Components$IconSet$thumbUp;
		case 2:
			return $author$project$Pyxis$Components$IconSet$exclamationTriangle;
		case 3:
			return $author$project$Pyxis$Components$IconSet$checkCircle;
		case 4:
			return $author$project$Pyxis$Components$IconSet$exclamationCircle;
		default:
			return $author$project$Pyxis$Components$IconSet$infoCircle;
	}
};
var $author$project$Pyxis$Components$Toasts$toast = function (variant) {
	return {
		T: $elm$core$Maybe$Nothing,
		f6: _List_Nil,
		f7: 'Close',
		ej: _List_Nil,
		eo: 20000,
		kf: $elm$core$Maybe$Just(
			$author$project$Pyxis$Components$Toasts$variantToDefaultIcon(variant)),
		kg: '',
		eQ: false,
		hG: $elm$core$Maybe$Nothing,
		fv: $elm$core$Maybe$Nothing,
		pu: $author$project$Pyxis$Components$Toasts$SimpleContent(''),
		i_: variant
	};
};
var $author$project$Pyxis$Components$Toasts$errorToast = $author$project$Pyxis$Components$Toasts$toast(4);
var $author$project$Page$OfferDetails$fromMaybeOfferIdToString = function (maybeUuid) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		'',
		function (uuid) {
			return uuid;
		},
		maybeUuid);
};
var $author$project$Translations$greatLakesOptInConsentModalErrorToastMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Error saving consent';
	} else {
		return 'Error al guardar el consentimiento';
	}
};
var $author$project$Translations$greatLakesOptInConsentModalSuccessToastMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Consent saved successfully';
	} else {
		return 'Consentimiento guardado correctamente';
	}
};
var $author$project$Common$Offer$filterActionValue = F2(
	function (filterFunc, _v0) {
		var offer = _v0;
		return $elm$core$List$head(
			A2($elm$core$List$filterMap, filterFunc, offer.aS));
	});
var $author$project$Common$Offer$pickEditCoverAction = function (action) {
	if (action.$ === 4) {
		var url = action.a;
		return $elm$core$Maybe$Just(url);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Common$Offer$mayEditCover = $author$project$Common$Offer$filterActionValue($author$project$Common$Offer$pickEditCoverAction);
var $author$project$Common$Portfolio$setEditCoverageUrl = F2(
	function (coverageUrl, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				gr: $elm$core$Maybe$Just(coverageUrl)
			});
	});
var $author$project$Page$OfferDetails$Model$maybeAddSetEditCoverUrlToPortfolio = F2(
	function (maybeOffer, model) {
		var updatePortfolioEditCoverUrl = function (link) {
			return _Utils_update(
				model,
				{
					dn: A2($author$project$Common$Portfolio$setEditCoverageUrl, link, model.dn)
				});
		};
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				updatePortfolioEditCoverUrl,
				$elm_community$maybe_extra$Maybe$Extra$join(
					A2($elm$core$Maybe$map, $author$project$Common$Offer$mayEditCover, maybeOffer))));
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $author$project$Common$Offer$isEditAction = function (action) {
	if (action.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Common$Offer$mayBeEdited = function (_v0) {
	var offer = _v0;
	return A2($elm$core$List$any, $author$project$Common$Offer$isEditAction, offer.aS);
};
var $author$project$Common$Portfolio$setEditRedirectUrl = F2(
	function (redirectUrl, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				gs: $elm$core$Maybe$Just(redirectUrl)
			});
	});
var $author$project$Page$OfferDetails$Model$maybeAddSetOnEditToPortfolio = F3(
	function (maybeFunnelUrl, maybeOffer, model) {
		var isEditable = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Common$Offer$mayBeEdited, maybeOffer));
		var _v0 = _Utils_Tuple2(isEditable, maybeFunnelUrl);
		if (_v0.a && (!_v0.b.$)) {
			var funnelUrl = _v0.b.a;
			return _Utils_update(
				model,
				{
					dn: A2($author$project$Common$Portfolio$setEditRedirectUrl, funnelUrl, model.dn)
				});
		} else {
			return model;
		}
	});
var $author$project$Page$OfferDetails$maybeSetCoverSelectionAsLoading = F2(
	function (maybeOffer, model) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			model,
			function (_v0) {
				return _Utils_update(
					model,
					{jI: $krisajenkins$remotedata$RemoteData$Loading});
			},
			maybeOffer);
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$updateEmailAddress = F2(
	function (email, sendEmailModalModel) {
		return _Utils_update(
			sendEmailModalModel,
			{$9: email});
	});
var $author$project$Page$OfferDetails$setPolicyHolderEmailAddress = F2(
	function (email, model) {
		return _Utils_update(
			model,
			{
				B: A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$updateEmailAddress, email, model.B)
			});
	});
var $author$project$Page$OfferDetails$maybeSetPolicyHolderEmailAddress = F2(
	function (email, model) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			model,
			A2($primait$prima_elm_extra$PrimaFunction$flip, $author$project$Page$OfferDetails$setPolicyHolderEmailAddress, model),
			email);
	});
var $author$project$Page$OfferDetails$Model$setPaymentMethod = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{lc: result});
	});
var $author$project$Page$OfferDetails$updatePaymentMethodIfRenewal = F2(
	function (model, offer) {
		return $author$project$Common$Offer$pickIsRenewal(offer) ? A2($author$project$Page$OfferDetails$Model$setPaymentMethod, $krisajenkins$remotedata$RemoteData$Loading, model) : model;
	});
var $author$project$Page$OfferDetails$maybeUpdatePaymentMethodIfRenewal = F2(
	function (maybeOffer, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				$author$project$Page$OfferDetails$updatePaymentMethodIfRenewal(model),
				maybeOffer));
	});
var $author$project$Pyxis$Components$Modal$Open = 0;
var $author$project$Pyxis$Components$Modal$open = $author$project$Pyxis$Components$Modal$update(0);
var $author$project$Common$ComponentUI$Modal$CoverPackages$open = function (_v0) {
	var modelData = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$open(modelData.bX);
	var newModalModel = _v1.a;
	var cmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			modelData,
			{bX: newModalModel}),
		cmd);
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$optionToString = function (_v0) {
	return 'new business offer';
};
var $author$project$Common$Person$pickContacts = function (person) {
	switch (person.$) {
		case 1:
			return $elm$core$Maybe$Nothing;
		case 0:
			return $elm$core$Maybe$Nothing;
		case 2:
			var contacts = person.c;
			return $elm$core$Maybe$Just(contacts);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $krisajenkins$remotedata$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var value = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					f(value));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				var error = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(error);
		}
	});
var $author$project$Common$Offer$pickCustomerFacingId = function (_v0) {
	var offer = _v0;
	return offer.mI;
};
var $krisajenkins$remotedata$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 3) {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var $author$project$Page$OfferDetails$Model$pickCustomerFacingId = function (model) {
	return A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		$elm$core$Maybe$Nothing,
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			$elm$core$Maybe$map($author$project$Common$Offer$pickCustomerFacingId),
			model.F));
};
var $author$project$Page$OfferDetails$Model$pickOfferId = function (model) {
	return A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		$elm$core$Maybe$Nothing,
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			$elm$core$Maybe$map($author$project$Common$Offer$pickId),
			model.F));
};
var $author$project$Common$Offer$pickPolicyHolder = function (_v0) {
	var offer = _v0;
	return offer.ib;
};
var $author$project$Common$ComponentUI$Modal$CoverPackages$ProductV1 = 0;
var $author$project$Common$ComponentUI$Modal$CoverPackages$ProductV2 = 1;
var $author$project$Common$ComponentUI$Modal$CoverPackages$productVersionFromCoverSelection = function (coverSelection) {
	var _v0 = coverSelection.mi;
	if (!_v0.$) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Common$Offer$requiresGreatLakesOptInConsent = function (_v0) {
	var offer = _v0;
	return offer.it;
};
var $author$project$Pyxis$Components$Field$CheckboxGroup$resetValue = function (_v0) {
	var modelData = _v0;
	return _Utils_update(
		modelData,
		{aA: _List_Nil});
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$resetCheckBoxGropup = function (sendEmailModalModel) {
	return _Utils_update(
		sendEmailModalModel,
		{
			cd: $author$project$Pyxis$Components$Field$CheckboxGroup$resetValue(sendEmailModalModel.cd)
		});
};
var $author$project$Translations$sendOfferEmailsBlockedOffer = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The offer is not available for recruitment, so it is not possible to send emails.';
	} else {
		return 'La oferta no está disponible para contratación, por lo que no es posible enviar emails.';
	}
};
var $author$project$Translations$sendOfferEmailsMissingEmailAddress = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'There is no email address associated with this offer, please complete it to be able to send emails.';
	} else {
		return 'No hay una dirección de correo electrónico asociada a esta oferta, complétala para poder enviar emails.';
	}
};
var $author$project$Translations$sendOfferEmailsOfferExpired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The offer has expired, so it is not possible to send emails.';
	} else {
		return 'La oferta ha caducado, por lo que no es posible enviar emails.';
	}
};
var $author$project$Translations$sendOfferEmailsOfferIsRenewal = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'This offer is a renewal, so it is not possible to send email';
	} else {
		return 'Esta oferta es una renovación, por lo que no es posible enviar emails';
	}
};
var $author$project$Translations$sendOfferEmailsOfferPurchased = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The offer has been contracted, so it is not possible to send emails.';
	} else {
		return 'La oferta ha sido contratada, por lo que no es posible enviar emails.';
	}
};
var $author$project$Translations$sendOfferEmailsOfferRequoted = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The offer has been re-quoted, so it is not possible to send emails.';
	} else {
		return 'La oferta ha sido cotizada nuevamente, por lo que no es posible enviar emails.';
	}
};
var $author$project$Translations$sendOfferEmailsStartDateExpired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'You need to change the start date to be able to send emails.';
	} else {
		return 'Necesitas cambiar la fecha de inicio para poder enviar emails.';
	}
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$sendEmailError = F2(
	function (i18n, error) {
		switch (error) {
			case 0:
				return $author$project$Translations$sendOfferEmailsOfferExpired(i18n);
			case 1:
				return $author$project$Translations$sendOfferEmailsStartDateExpired(i18n);
			case 2:
				return $author$project$Translations$sendOfferEmailsOfferPurchased(i18n);
			case 3:
				return $author$project$Translations$sendOfferEmailsBlockedOffer(i18n);
			case 4:
				return $author$project$Translations$sendOfferEmailsOfferRequoted(i18n);
			case 5:
				return $author$project$Translations$sendOfferEmailsMissingEmailAddress(i18n);
			default:
				return $author$project$Translations$sendOfferEmailsOfferIsRenewal(i18n);
		}
	});
var $author$project$Translations$sendOfferEmailsGenericErrorMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'It was not possible to send the email. Please refresh the page to try again.';
	} else {
		return 'No ha sido posible enviar el email. Actualiza la página para intentarlo nuevamente.';
	}
};
var $author$project$Translations$sendOfferEmailsSuccessMessage = F2(
	function (email, _v0) {
		var lang = _v0;
		if (!lang) {
			return 'Email successfully sent to ' + email;
		} else {
			return 'Envío realizado a ' + email;
		}
	});
var $author$project$Common$PricingAction$new = function (pricingAction) {
	return $author$project$Common$PricingAction$PricingAction(pricingAction);
};
var $author$project$Common$PricingAction$Unknown = {$: 1};
var $author$project$Common$PricingAction$unknown = $author$project$Common$PricingAction$Unknown;
var $author$project$Page$OfferDetails$Model$pickPricingAction = function (response) {
	return A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		$author$project$Common$PricingAction$unknown,
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($author$project$Common$PricingAction$new),
				$elm$core$Maybe$withDefault($author$project$Common$PricingAction$default)),
			response));
};
var $author$project$Common$ClaimHistory$default = A6($author$project$Common$ClaimHistory$ClaimHistory, '', '', '', $author$project$Common$Count$default, $elm$core$Maybe$Nothing, $author$project$Common$PricingAction$default);
var $elm_community$maybe_extra$Maybe$Extra$orElseLazy = F2(
	function (fma, mb) {
		if (mb.$ === 1) {
			return fma(0);
		} else {
			return mb;
		}
	});
var $author$project$Common$ClaimHistory$setActionNeeded = F2(
	function (actionNeeded, claimHistory) {
		return _Utils_update(
			claimHistory,
			{fI: actionNeeded});
	});
var $author$project$Common$ClaimHistory$setPricingActionToClaimHistoryOrDefault = F2(
	function (action, maybeClaimHistory) {
		return A2(
			$elm_community$maybe_extra$Maybe$Extra$orElseLazy,
			function (_v0) {
				return $elm$core$Maybe$Just(
					A2($author$project$Common$ClaimHistory$setActionNeeded, action, $author$project$Common$ClaimHistory$default));
			},
			A2(
				$elm$core$Maybe$map,
				$author$project$Common$ClaimHistory$setActionNeeded(action),
				maybeClaimHistory));
	});
var $author$project$Page$OfferDetails$Model$setPricingActionToClaimHistoryResponse = F2(
	function (model, action) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			$author$project$Common$ClaimHistory$setPricingActionToClaimHistoryOrDefault(action),
			model.cF);
	});
var $author$project$Page$OfferDetails$Model$setClaimHistoryPricingActionResult = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{
				cF: A2(
					$author$project$Page$OfferDetails$Model$setPricingActionToClaimHistoryResponse,
					model,
					$author$project$Page$OfferDetails$Model$pickPricingAction(result))
			});
	});
var $author$project$Common$Offer$pickClaimsDeclaredWithFault = function (_v0) {
	var offer = _v0;
	return offer.f5;
};
var $krisajenkins$remotedata$RemoteData$toMaybe = A2(
	$elm$core$Basics$composeR,
	$krisajenkins$remotedata$RemoteData$map($elm$core$Maybe$Just),
	$krisajenkins$remotedata$RemoteData$withDefault($elm$core$Maybe$Nothing));
var $author$project$Page$OfferDetails$Model$pickClaimsDeclaredWithFaultByCustomer = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.F;
	},
	A2(
		$elm$core$Basics$composeR,
		$krisajenkins$remotedata$RemoteData$toMaybe,
		A2(
			$elm$core$Basics$composeR,
			$elm_community$maybe_extra$Maybe$Extra$join,
			A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Common$Count$default, $author$project$Common$Offer$pickClaimsDeclaredWithFault))));
var $author$project$Common$ClaimHistory$setClaimDeclaredWithFaultByCustomer = F2(
	function (claims, claimHistory) {
		return _Utils_update(
			claimHistory,
			{f4: claims});
	});
var $author$project$Page$OfferDetails$Model$setClaimDeclaredToClaimHistory = function (model) {
	return $author$project$Common$ClaimHistory$setClaimDeclaredWithFaultByCustomer(
		$author$project$Page$OfferDetails$Model$pickClaimsDeclaredWithFaultByCustomer(model));
};
var $author$project$Page$OfferDetails$Model$setClaimsDeclaredToResponse = function (model) {
	return $krisajenkins$remotedata$RemoteData$map(
		$elm$core$Maybe$map(
			$author$project$Page$OfferDetails$Model$setClaimDeclaredToClaimHistory(model)));
};
var $author$project$Page$OfferDetails$Model$setClaimHistoryResult = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{
				cF: A2($author$project$Page$OfferDetails$Model$setClaimsDeclaredToResponse, model, result)
			});
	});
var $author$project$Page$OfferDetails$Model$setConsentModalModelWithOrigin = F3(
	function (origin, modalModel, model) {
		if (!origin) {
			return _Utils_update(
				model,
				{bI: modalModel});
		} else {
			return _Utils_update(
				model,
				{bJ: modalModel});
		}
	});
var $author$project$Page$OfferDetails$Model$setCustomerId = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{gi: result});
	});
var $author$project$Page$OfferDetails$Model$setGreatLakesOptInConsentModalForLanding = F2(
	function (modalModel, model) {
		return _Utils_update(
			model,
			{bI: modalModel});
	});
var $author$project$Page$OfferDetails$Model$setOfferResult = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{F: result});
	});
var $author$project$Pyxis$Components$Toasts$Success = 3;
var $author$project$Pyxis$Components$Toasts$successToast = $author$project$Pyxis$Components$Toasts$toast(3);
var $author$project$Env$funnelUrl = function (_v0) {
	var environment = _v0;
	return environment.cR;
};
var $author$project$ExternalUrl$toString = function (link) {
	var env = link.a;
	var offerId = link.b;
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$author$project$Env$funnelUrl(env),
				'/offer/',
				$danyx23$elm_uuid$Uuid$toString(offerId)
			]));
};
var $author$project$Commands$dispatch = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$always(msg),
		$elm$core$Task$succeed(
			$elm$core$Basics$always(msg)));
};
var $author$project$Commands$dispatchFromMaybe = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($author$project$Commands$dispatch),
	$elm$core$Maybe$withDefault($elm$core$Platform$Cmd$none));
var $author$project$Pyxis$Commons$Commands$dispatch = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$always(msg),
		$elm$core$Task$succeed(
			$elm$core$Basics$always(msg)));
};
var $author$project$Pyxis$Commons$Commands$dispatchFromMaybe = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($author$project$Pyxis$Commons$Commands$dispatch),
	$elm$core$Maybe$withDefault($elm$core$Platform$Cmd$none));
var $author$project$Pyxis$Components$Tabs$dispatchOnTabActivation = function (_v0) {
	var activeIndex = _v0.M;
	var onTabActivation = _v0.e5;
	return $author$project$Pyxis$Commons$Commands$dispatchFromMaybe(
		A2(
			$elm$core$Maybe$map,
			function (theMsg) {
				return theMsg(activeIndex);
			},
			onTabActivation));
};
var $author$project$Pyxis$Components$Tabs$dispatchOnTabFirstActivation = function (_v0) {
	var activeIndex = _v0.M;
	var onTabFirstActivation = _v0.h0;
	return $author$project$Pyxis$Commons$Commands$dispatchFromMaybe(
		A2(
			$elm$core$Maybe$map,
			function (theMsg) {
				return theMsg(activeIndex);
			},
			onTabFirstActivation));
};
var $primait$prima_elm_extra$PrimaCmd$ifThenCmd = F2(
	function (condition, cmd) {
		return condition ? cmd : $elm$core$Platform$Cmd$none;
	});
var $primait$prima_elm_extra$PrimaCmd$ifThenCmdMap = F3(
	function (condition, cmd, a) {
		return A2(
			$primait$prima_elm_extra$PrimaCmd$ifThenCmd,
			condition(a),
			cmd(a));
	});
var $author$project$Pyxis$Components$Tabs$isCurrentTabFirstActivation = function (_v0) {
	var activeIndex = _v0.M;
	var openedTabs = _v0.b0;
	return 1 === A2(
		$elm$core$Maybe$withDefault,
		1,
		A2($elm$core$Dict$get, activeIndex, openedTabs));
};
var $primait$prima_elm_extra$PrimaCmd$fromMaybeMap = F2(
	function (command, maybe) {
		if (!maybe.$) {
			var a = maybe.a;
			return command(a);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Pyxis$Components$Tabs$getTabId = function (id) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$String$fromInt,
		$elm$core$Basics$append(id + '-tab-'));
};
var $author$project$Pyxis$Components$Tabs$attemptTabFocus = F2(
	function (id, _v0) {
		var modelData = _v0;
		return A2(
			$primait$prima_elm_extra$PrimaCmd$fromMaybeMap,
			function (msg) {
				return A2(
					$elm$core$Task$attempt,
					$elm$core$Basics$always(msg),
					$elm$browser$Browser$Dom$focus(
						A2($author$project$Pyxis$Components$Tabs$getTabId, id, modelData.M)));
			},
			A2(
				$elm$core$Maybe$map,
				function (msg) {
					return msg(modelData.M);
				},
				modelData.e5));
	});
var $author$project$Pyxis$Commons$Events$Keyboard$matchKeyCode = F2(
	function (match, _v0) {
		var keyCode = _v0.ku;
		return _Utils_eq(keyCode, match);
	});
var $author$project$Pyxis$Commons$Events$Keyboard$isArrowLeft = $author$project$Pyxis$Commons$Events$Keyboard$matchKeyCode(37);
var $author$project$Pyxis$Commons$Events$Keyboard$isArrowRight = $author$project$Pyxis$Commons$Events$Keyboard$matchKeyCode(39);
var $author$project$Pyxis$Commons$Events$Keyboard$isEnd = $author$project$Pyxis$Commons$Events$Keyboard$matchKeyCode(35);
var $author$project$Pyxis$Commons$Events$Keyboard$isHome = $author$project$Pyxis$Commons$Events$Keyboard$matchKeyCode(36);
var $author$project$Pyxis$Components$Tabs$updateIndexToPrevious = F2(
	function (numberOfTabs, model) {
		var activeIndex = model.M;
		return ((activeIndex - 1) >= 0) ? A2($author$project$Pyxis$Components$Tabs$setActiveTabIndex, activeIndex - 1, model) : A2($author$project$Pyxis$Components$Tabs$setActiveTabIndex, numberOfTabs - 1, model);
	});
var $author$project$Pyxis$Components$Tabs$updateToNextIndex = F2(
	function (numberOfTabs, model) {
		var activeIndex = model.M;
		return (_Utils_cmp(activeIndex + 1, numberOfTabs - 1) < 1) ? A2($author$project$Pyxis$Components$Tabs$setActiveTabIndex, activeIndex + 1, model) : A2($author$project$Pyxis$Components$Tabs$setActiveTabIndex, 0, model);
	});
var $primait$prima_elm_extra$PrimaUpdate$withCmdsMap = F2(
	function (cmdFunctions, model) {
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$map,
					function (f) {
						return f(model);
					},
					cmdFunctions)));
	});
var $author$project$Pyxis$Components$Tabs$updateOnKeyEvent = F3(
	function (id, numberOfTabs, event) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Pyxis$Commons$Events$Keyboard$isArrowLeft(event) ? $author$project$Pyxis$Components$Tabs$updateIndexToPrevious(numberOfTabs) : ($author$project$Pyxis$Commons$Events$Keyboard$isArrowRight(event) ? $author$project$Pyxis$Components$Tabs$updateToNextIndex(numberOfTabs) : ($author$project$Pyxis$Commons$Events$Keyboard$isHome(event) ? $author$project$Pyxis$Components$Tabs$setActiveTabIndex(0) : ($author$project$Pyxis$Commons$Events$Keyboard$isEnd(event) ? $author$project$Pyxis$Components$Tabs$setActiveTabIndex(numberOfTabs - 1) : $elm$core$Basics$identity))),
			$primait$prima_elm_extra$PrimaUpdate$withCmdsMap(
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Tabs$attemptTabFocus(id),
						$author$project$Pyxis$Components$Tabs$dispatchOnTabActivation,
						A2($primait$prima_elm_extra$PrimaCmd$ifThenCmdMap, $author$project$Pyxis$Components$Tabs$isCurrentTabFirstActivation, $author$project$Pyxis$Components$Tabs$dispatchOnTabFirstActivation)
					])));
	});
var $author$project$Pyxis$Components$Tabs$update = F2(
	function (msg, model) {
		var model_ = model;
		switch (msg.$) {
			case 0:
				var index = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmdsMap,
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Tabs$dispatchOnTabActivation,
							A2($primait$prima_elm_extra$PrimaCmd$ifThenCmdMap, $author$project$Pyxis$Components$Tabs$isCurrentTabFirstActivation, $author$project$Pyxis$Components$Tabs$dispatchOnTabFirstActivation)
						]),
					A2($author$project$Pyxis$Components$Tabs$setActiveTabIndex, index, model));
			case 1:
				var numberOfTabs = msg.a;
				var id = msg.b;
				var event = msg.c;
				return A4($author$project$Pyxis$Components$Tabs$updateOnKeyEvent, id, numberOfTabs, event, model);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model_,
						{$7: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Common$Portfolio$updateInnerTabsModel = F2(
	function (newTabModel, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{eE: newTabModel});
	});
var $author$project$Common$Portfolio$updateOuterTabsModel = F2(
	function (newTabModel, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{b1: newTabModel});
	});
var $author$project$Common$Portfolio$update = F2(
	function (msg, portfolio) {
		var model = portfolio;
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Pyxis$Components$Tabs$update, subMsg, model.b1);
				var newTabModel = _v1.a;
				var tabCmd = _v1.b;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmd,
					tabCmd,
					A2($author$project$Common$Portfolio$updateOuterTabsModel, newTabModel, portfolio));
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Pyxis$Components$Tabs$update, subMsg, model.eE);
				var newTabModel = _v2.a;
				var tabCmd = _v2.b;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmd,
					tabCmd,
					A2($author$project$Common$Portfolio$updateInnerTabsModel, newTabModel, portfolio));
			case 2:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmd,
					$author$project$Commands$dispatchFromMaybe(model.kP),
					portfolio);
			default:
				return $primait$prima_elm_extra$PrimaUpdate$withoutCmds(portfolio);
		}
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$mapCheckedValues = F2(
	function (mapper, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{
				aA: mapper(modelData.aA)
			});
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$checkValue = function (value) {
	return $author$project$Pyxis$Components$Field$CheckboxGroup$mapCheckedValues(
		$elm$core$List$cons(value));
};
var $primait$prima_elm_extra$PrimaFunction$ifThenElseMap = F4(
	function (condition, mapper1, mapper2, m) {
		return condition(m) ? mapper1(m) : mapper2(m);
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$mapFieldStatus = F2(
	function (mapper, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				ev: mapper(model.ev)
			});
	});
var $author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred = F2(
	function (isBlurred, fieldStatus) {
		return _Utils_update(
			fieldStatus,
			{kp: isBlurred});
	});
var $author$project$Pyxis$Components$Field$FieldStatus$setIsDirty = F2(
	function (isDirty, fieldStatus) {
		return _Utils_update(
			fieldStatus,
			{nr: isDirty});
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$uncheckValue = function (value) {
	return $author$project$Pyxis$Components$Field$CheckboxGroup$mapCheckedValues(
		$elm$core$List$filter(
			$elm$core$Basics$neq(value)));
};
var $primait$prima_elm_extra$PrimaUpdate$withCmds = F2(
	function (cmds, model) {
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(cmds));
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$update = F2(
	function (msg, model) {
		var modelData = model;
		switch (msg.$) {
			case 2:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hH)
						]),
					A2(
						$author$project$Pyxis$Components$Field$CheckboxGroup$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(true),
						model));
			case 1:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hQ)
						]),
					A2(
						$author$project$Pyxis$Components$Field$CheckboxGroup$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(false),
						model));
			default:
				var value = msg.a;
				var check = msg.b;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.kN)
						]),
					A2(
						$author$project$Pyxis$Components$Field$CheckboxGroup$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsDirty(true),
						A4(
							$primait$prima_elm_extra$PrimaFunction$ifThenElseMap,
							$elm$core$Basics$always(check),
							$author$project$Pyxis$Components$Field$CheckboxGroup$checkValue(value),
							$author$project$Pyxis$Components$Field$CheckboxGroup$uncheckValue(value),
							model)));
		}
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$updateCheckBoxGroup = F2(
	function (newCheckBoxModel, sendEmailModalModel) {
		return _Utils_update(
			sendEmailModalModel,
			{cd: newCheckBoxModel});
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$updateIsSentEmailSubmitted = F2(
	function (isSubmitted, sendEmailModalModel) {
		return _Utils_update(
			sendEmailModalModel,
			{g4: isSubmitted});
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$updateModalModel = F2(
	function (newSendEmailModel, sendEmailModalModel) {
		return _Utils_update(
			sendEmailModalModel,
			{ig: newSendEmailModel});
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$withProductVersion = F2(
	function (productVersion, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{
				ij: $elm$core$Maybe$Just(productVersion)
			});
	});
var $author$project$Pyxis$Components$Toasts$withToastText = F2(
	function (text, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				pu: $author$project$Pyxis$Components$Toasts$SimpleContent(text)
			});
	});
var $author$project$Page$OfferDetails$update = F4(
	function (i18n, env, msg, model) {
		switch (msg.$) {
			case 0:
				var remoteData = msg.a;
				var maybeOffer = $elm_community$maybe_extra$Maybe$Extra$join(
					$krisajenkins$remotedata$RemoteData$toMaybe(remoteData));
				var policyHolderEmailAddress = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.eq;
					},
					A2(
						$elm$core$Maybe$andThen,
						A2($elm$core$Basics$composeR, $author$project$Common$Offer$pickPolicyHolder, $author$project$Common$Person$pickContacts),
						maybeOffer));
				var maybeFunneUrl = A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Common$Offer$pickId,
						A2(
							$elm$core$Basics$composeR,
							$author$project$ExternalUrl$FunnelOffer(env),
							$author$project$ExternalUrl$toString)),
					maybeOffer);
				var _v1 = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, false, $author$project$Common$Offer$requiresGreatLakesOptInConsent, maybeOffer) ? $author$project$Pyxis$Components$Modal$open(model.bI) : _Utils_Tuple2(model.bI, $elm$core$Platform$Cmd$none);
				var newConsentModalModel = _v1.a;
				var consentModalCmd = _v1.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$OfferDetails$maybeSetCoverSelectionAsLoading,
						maybeOffer,
						A2(
							$author$project$Page$OfferDetails$maybeSetPolicyHolderEmailAddress,
							policyHolderEmailAddress,
							A2(
								$author$project$Page$OfferDetails$maybeUpdatePaymentMethodIfRenewal,
								maybeOffer,
								A2(
									$author$project$Page$OfferDetails$Model$maybeAddSetEditCoverUrlToPortfolio,
									maybeOffer,
									A3(
										$author$project$Page$OfferDetails$Model$maybeAddSetOnEditToPortfolio,
										maybeFunneUrl,
										maybeOffer,
										A2(
											$author$project$Page$OfferDetails$Model$setGreatLakesOptInConsentModalForLanding,
											newConsentModalModel,
											A2(
												$author$project$Page$OfferDetails$Model$setOfferResult,
												remoteData,
												_Utils_update(
													model,
													{bI: newConsentModalModel})))))))),
					$author$project$Page$OfferDetails$Effect$Effects(
						_List_fromArray(
							[
								$author$project$Page$OfferDetails$chooseEffectForCustomerId(maybeOffer),
								$author$project$Page$OfferDetails$chooseEffectForClaimHistory(maybeOffer),
								$author$project$Page$OfferDetails$chooseEffectForPaymentMethod(maybeOffer),
								$author$project$Page$OfferDetails$chooseEffectForCoverSelection(maybeOffer),
								$author$project$Page$OfferDetails$Effect$WithCmd(consentModalCmd)
							])));
			case 1:
				if (msg.a.$ === 3) {
					var remoteData = msg.a;
					return _Utils_Tuple2(
						A2($author$project$Page$OfferDetails$Model$setClaimHistoryResult, remoteData, model),
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Page$OfferDetails$Effect$None,
							A2(
								$elm$core$Maybe$map,
								$author$project$Page$OfferDetails$Effect$FetchPricingActionClaimHistory,
								$author$project$Page$OfferDetails$Model$pickOfferId(model))));
				} else {
					var remoteData = msg.a;
					return _Utils_Tuple2(
						A2($author$project$Page$OfferDetails$Model$setClaimHistoryResult, remoteData, model),
						$author$project$Page$OfferDetails$Effect$None);
				}
			case 2:
				var remoteData = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$OfferDetails$Model$setClaimHistoryPricingActionResult, remoteData, model),
					$author$project$Page$OfferDetails$Effect$None);
			case 3:
				var remotedata = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$OfferDetails$Model$setCustomerId, remotedata, model),
					$author$project$Page$OfferDetails$Effect$None);
			case 4:
				if (msg.a.$ === 3) {
					var coverSelectionResult = msg.a;
					var coverSelection = coverSelectionResult.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ed: A2(
									$author$project$Common$ComponentUI$Modal$CoverPackages$withProductVersion,
									$author$project$Common$ComponentUI$Modal$CoverPackages$productVersionFromCoverSelection(coverSelection),
									model.ed),
								jI: coverSelectionResult
							}),
						$author$project$Page$OfferDetails$Effect$None);
				} else {
					var coverSelection = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{jI: coverSelection}),
						$author$project$Page$OfferDetails$Effect$None);
				}
			case 14:
				return _Utils_Tuple2(model, $author$project$Page$OfferDetails$Effect$None);
			case 5:
				var offer = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$OfferDetails$Effect$ChangeRoute(
						$author$project$Route$Payment(
							$author$project$Common$Offer$pickId(offer))));
			case 6:
				var searchQuery = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$OfferDetails$Effect$ChangeRoute(
						A2($author$project$Route$Search, $author$project$Page$Search$SearchQueryParam$defaultSearchContext, searchQuery)));
			case 20:
				if (msg.a) {
					var _v2 = $author$project$Pyxis$Components$Modal$open(model.B.ig);
					var newModalState = _v2.a;
					var cmd = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								B: A2(
									$author$project$Common$ComponentUI$Modal$SendOfferEmail$updateIsSentEmailSubmitted,
									false,
									A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$updateModalModel, newModalState, model.B))
							}),
						$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
				} else {
					var _v3 = $author$project$Pyxis$Components$Modal$close(model.B.ig);
					var newModalState = _v3.a;
					var cmd = _v3.b;
					var newSendOfferEmailModel = $author$project$Common$ComponentUI$Modal$SendOfferEmail$resetCheckBoxGropup(
						A2(
							$author$project$Common$ComponentUI$Modal$SendOfferEmail$updateIsSentEmailSubmitted,
							false,
							A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$updateModalModel, newModalState, model.B)));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{B: newSendOfferEmailModel}),
						$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
				}
			case 15:
				if (msg.a) {
					var _v4 = $author$project$Common$ComponentUI$Modal$CoverPackages$open(model.ed);
					var newModalModel = _v4.a;
					var cmd = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ed: newModalModel}),
						$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
				} else {
					var _v5 = $author$project$Common$ComponentUI$Modal$CoverPackages$close(model.ed);
					var newModalModel = _v5.a;
					var cmd = _v5.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ed: newModalModel}),
						$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
				}
			case 21:
				var value = msg.a;
				var _v6 = A2($author$project$Pyxis$Components$Field$CheckboxGroup$update, value, model.B.cd);
				var newModel = _v6.a;
				var cmd = _v6.b;
				var newSendOfferEmailModel = A2(
					$author$project$Common$ComponentUI$Modal$SendOfferEmail$updateIsSentEmailSubmitted,
					false,
					A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$updateCheckBoxGroup, newModel, model.B));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{B: newSendOfferEmailModel}),
					$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
			case 22:
				var options = msg.a;
				var trackEmails = $author$project$Page$OfferDetails$Effect$TrackSendEmail(
					A2($elm$core$List$map, $author$project$Common$ComponentUI$Modal$SendOfferEmail$optionToString, options));
				var sendEmailEffects = A2($elm$core$List$map, $author$project$Page$OfferDetails$Effect$SendOfferEmail, options);
				var _v7 = function () {
					if (!options.b) {
						return _Utils_Tuple2(model.B.ig, $elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Pyxis$Components$Modal$close(model.B.ig);
					}
				}();
				var newModalState = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							B: $author$project$Common$ComponentUI$Modal$SendOfferEmail$resetCheckBoxGropup(
								A2(
									$author$project$Common$ComponentUI$Modal$SendOfferEmail$updateIsSentEmailSubmitted,
									true,
									A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$updateModalModel, newModalState, model.B)))
						}),
					$author$project$Page$OfferDetails$Effect$Effects(
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Page$OfferDetails$Effect$WithCmd(cmd),
									trackEmails
								]),
							sendEmailEffects)));
			case 11:
				var offer = msg.a;
				if ($author$project$Common$Offer$requiresGreatLakesOptInConsent(offer)) {
					var _v9 = $author$project$Pyxis$Components$Modal$open(model.bJ);
					var newModalModel = _v9.a;
					var cmd = _v9.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bJ: newModalModel}),
						$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
				} else {
					var _v10 = $author$project$Pyxis$Components$Modal$open(model.dy);
					var newModalState = _v10.a;
					var cmd = _v10.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dy: newModalState}),
						$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
				}
			case 12:
				var _v11 = $author$project$Pyxis$Components$Modal$close(model.dy);
				var newModalState = _v11.a;
				var cmd = _v11.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dy: newModalState}),
					$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
			case 7:
				var offer = msg.a;
				var newCoverageEffectiveDate = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mh: $krisajenkins$remotedata$RemoteData$Loading}),
					A2(
						$author$project$Page$OfferDetails$Effect$AmendOfferCoverageEffectiveDate,
						$author$project$Common$Offer$pickId(offer),
						newCoverageEffectiveDate));
			case 8:
				if ((msg.a.$ === 3) && (!msg.a.a.$)) {
					var _v12 = msg.a.a;
					var offerId = $author$project$Page$OfferDetails$fromMaybeOfferIdToString(
						$author$project$Page$OfferDetails$Model$pickCustomerFacingId(model));
					var _v13 = A2(
						$author$project$Pyxis$Components$Toasts$addNewToast,
						A2(
							$author$project$Pyxis$Components$Toasts$withToastText,
							$author$project$Translations$detailsToastAmendDateSuccessMessage(i18n),
							$author$project$Pyxis$Components$Toasts$successToast),
						model.s);
					var newToastsModel = _v13.a;
					var toastCmd = _v13.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{s: newToastsModel}),
						$author$project$Page$OfferDetails$Effect$Effects(
							_List_fromArray(
								[
									$author$project$Page$OfferDetails$Effect$WithCmd(toastCmd),
									$author$project$Page$OfferDetails$Effect$FetchOffer(offerId)
								])));
				} else {
					var _v14 = A2(
						$author$project$Pyxis$Components$Toasts$addNewToast,
						A2(
							$author$project$Pyxis$Components$Toasts$withToastText,
							$author$project$Translations$detailsToastAmendDateErrorMessage(i18n),
							$author$project$Pyxis$Components$Toasts$errorToast),
						model.s);
					var newToastsModel = _v14.a;
					var toastCmd = _v14.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{s: newToastsModel}),
						$author$project$Page$OfferDetails$Effect$WithCmd(toastCmd));
				}
			case 9:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gf: $elm$core$Maybe$Just(date)
						}),
					$author$project$Page$OfferDetails$Effect$None);
			case 10:
				if (msg.a) {
					var _v15 = $author$project$Pyxis$Components$Modal$open(model.eb);
					var newModalModel = _v15.a;
					var cmd = _v15.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{eb: newModalModel}),
						$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
				} else {
					var _v16 = $author$project$Pyxis$Components$Modal$close(model.eb);
					var newModalModel = _v16.a;
					var cmd = _v16.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{eb: newModalModel}),
						$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
				}
			case 13:
				var portfolioSubMsg = msg.a;
				var _v17 = A2($author$project$Common$Portfolio$update, portfolioSubMsg, model.dn);
				var newPortFolioModel = _v17.a;
				var cmd = _v17.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dn: newPortFolioModel}),
					$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
			case 18:
				var offerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{lc: $krisajenkins$remotedata$RemoteData$Loading}),
					$author$project$Page$OfferDetails$Effect$FetchPaymentMethod(offerId));
			case 19:
				var response = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{lc: response}),
					$author$project$Page$OfferDetails$Effect$None);
			case 16:
				var toastCounterSubMsg = msg.a;
				var _v18 = A2($author$project$Pyxis$Components$Toasts$update, toastCounterSubMsg, model.s);
				var newToastsModel = _v18.a;
				var cmd = _v18.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{s: newToastsModel}),
					$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
			case 17:
				switch (msg.a.$) {
					case 2:
						var _v19 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$sendOfferEmailsGenericErrorMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.s);
						var newToastsModel = _v19.a;
						var toastCmd = _v19.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{s: newToastsModel}),
							$author$project$Page$OfferDetails$Effect$WithCmd(toastCmd));
					case 3:
						if (!msg.a.a.$) {
							var _v20 = msg.a.a;
							var _v21 = A2(
								$author$project$Pyxis$Components$Toasts$addNewToast,
								A2(
									$author$project$Pyxis$Components$Toasts$withToastText,
									A2($author$project$Translations$sendOfferEmailsSuccessMessage, model.B.$9, i18n),
									$author$project$Pyxis$Components$Toasts$successToast),
								model.s);
							var newToastsModel = _v21.a;
							var toastCmd = _v21.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{s: newToastsModel}),
								$author$project$Page$OfferDetails$Effect$Effects(
									_List_fromArray(
										[
											$author$project$Page$OfferDetails$Effect$WithCmd(toastCmd)
										])));
						} else {
							var reason = msg.a.a.a;
							var _v22 = A2(
								$author$project$Pyxis$Components$Toasts$addNewToast,
								A2(
									$author$project$Pyxis$Components$Toasts$withToastText,
									A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$sendEmailError, i18n, reason),
									$author$project$Pyxis$Components$Toasts$errorToast),
								model.s);
							var newToastsModel = _v22.a;
							var toastCmd = _v22.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{s: newToastsModel}),
								$author$project$Page$OfferDetails$Effect$WithCmd(toastCmd));
						}
					default:
						return _Utils_Tuple2(model, $author$project$Page$OfferDetails$Effect$None);
				}
			case 23:
				var origin = msg.a;
				var offerId = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dt: $krisajenkins$remotedata$RemoteData$Loading}),
					A2($author$project$Page$OfferDetails$Effect$SaveGreatLakesOptInConsent, offerId, origin));
			case 25:
				switch (msg.b.$) {
					case 3:
						if (!msg.a) {
							var _v23 = msg.a;
							var response = msg.b;
							var offerCfid = $author$project$Page$OfferDetails$fromMaybeOfferIdToString(
								$author$project$Page$OfferDetails$Model$pickCustomerFacingId(model));
							var _v24 = A2(
								$author$project$Pyxis$Components$Toasts$addNewToast,
								A2(
									$author$project$Pyxis$Components$Toasts$withToastText,
									$author$project$Translations$greatLakesOptInConsentModalSuccessToastMessage(i18n),
									$author$project$Pyxis$Components$Toasts$successToast),
								model.s);
							var newToastsModel = _v24.a;
							var toastsCmd = _v24.b;
							var _v25 = $author$project$Pyxis$Components$Modal$close(model.bI);
							var newModalModel = _v25.a;
							var modalCmd = _v25.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{bI: newModalModel, dt: response, s: newToastsModel}),
								$author$project$Page$OfferDetails$Effect$Effects(
									_List_fromArray(
										[
											$author$project$Page$OfferDetails$Effect$WithCmd(modalCmd),
											$author$project$Page$OfferDetails$Effect$WithCmd(toastsCmd),
											$author$project$Page$OfferDetails$Effect$FetchOffer(offerCfid)
										])));
						} else {
							var _v26 = msg.a;
							var response = msg.b;
							var _v27 = A2(
								$author$project$Pyxis$Components$Toasts$addNewToast,
								A2(
									$author$project$Pyxis$Components$Toasts$withToastText,
									$author$project$Translations$greatLakesOptInConsentModalSuccessToastMessage(i18n),
									$author$project$Pyxis$Components$Toasts$successToast),
								model.s);
							var newToastsModel = _v27.a;
							var toastsCmd = _v27.b;
							var _v28 = $author$project$Pyxis$Components$Modal$open(model.bJ);
							var newDisclaimerModalModel = _v28.a;
							var disclaimerModalCmd = _v28.b;
							var _v29 = $author$project$Pyxis$Components$Modal$close(model.bJ);
							var newConsentModalModel = _v29.a;
							var consentModalCmd = _v29.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{bJ: newConsentModalModel, dt: response, dy: newDisclaimerModalModel, s: newToastsModel}),
								$author$project$Page$OfferDetails$Effect$Effects(
									_List_fromArray(
										[
											$author$project$Page$OfferDetails$Effect$WithCmd(consentModalCmd),
											$author$project$Page$OfferDetails$Effect$WithCmd(toastsCmd),
											$author$project$Page$OfferDetails$Effect$WithCmd(disclaimerModalCmd)
										])));
						}
					case 2:
						var origin = msg.a;
						var response = msg.b;
						var _v30 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$greatLakesOptInConsentModalErrorToastMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.s);
						var newToastsModel = _v30.a;
						var toastsCmd = _v30.b;
						var _v31 = A2($author$project$Page$OfferDetails$closeConsentModelWithOrigin, model, origin);
						var newModalModel = _v31.a;
						var cmd = _v31.b;
						return _Utils_Tuple2(
							A3(
								$author$project$Page$OfferDetails$Model$setConsentModalModelWithOrigin,
								origin,
								newModalModel,
								_Utils_update(
									model,
									{dt: response, s: newToastsModel})),
							$author$project$Page$OfferDetails$Effect$Effects(
								_List_fromArray(
									[
										$author$project$Page$OfferDetails$Effect$WithCmd(cmd),
										$author$project$Page$OfferDetails$Effect$WithCmd(toastsCmd)
									])));
					default:
						var response = msg.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{dt: response}),
							$author$project$Page$OfferDetails$Effect$None);
				}
			default:
				var origin = msg.a;
				var _v32 = A2($author$project$Page$OfferDetails$closeConsentModelWithOrigin, model, origin);
				var newModalModel = _v32.a;
				var cmd = _v32.b;
				return _Utils_Tuple2(
					A3($author$project$Page$OfferDetails$Model$setConsentModalModelWithOrigin, origin, newModalModel, model),
					$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
		}
	});
var $author$project$Page$Payment$Effect$ChangeRoute = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Payment$Effect$GoBack = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Payment$Effect$None = {$: 8};
var $author$project$Page$Payment$Effect$PayWithCreditCard = {$: 5};
var $author$project$Page$Payment$Effect$SetupBraintreeClient = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Payment$Effect$Purchase = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Payment$Model$ClientSideError = $elm$core$Basics$identity;
var $author$project$Page$Payment$Model$setPaymentClientError = F2(
	function (error, model) {
		return _Utils_update(
			model,
			{
				h6: $elm$core$Maybe$Just(error)
			});
	});
var $author$project$Page$Payment$Model$setClientError = F2(
	function (_v0, model) {
		var error = _v0.jS;
		var clientSideError = error;
		return A2($author$project$Page$Payment$Model$setPaymentClientError, clientSideError, model);
	});
var $author$project$Page$Payment$Model$setCreditCardFields = F2(
	function (fieldsValidation, model) {
		var cardFields = model.d4;
		var updateField = F2(
			function (field, _v1) {
				var id = _v1.kg;
				var isValid = _v1.bQ;
				var isPristine = _v1.eM;
				var isFocused = _v1.eH;
				return _Utils_update(
					field,
					{kg: id, eH: isFocused, eM: isPristine, bQ: isValid});
			});
		var updatedFields = A3(
			$elm$core$List$foldl,
			F2(
				function (field, current) {
					var _v0 = field.kg;
					switch (_v0) {
						case 'credit-card-number':
							return _Utils_update(
								current,
								{
									cE: A2(updateField, current.cE, field)
								});
						case 'credit-card-expiration-date':
							return _Utils_update(
								current,
								{
									cO: A2(updateField, current.cO, field)
								});
						default:
							return current;
					}
				}),
			cardFields,
			fieldsValidation);
		return _Utils_update(
			model,
			{d4: updatedFields});
	});
var $author$project$Page$Payment$Model$PaymentNotReady = 2;
var $author$project$Page$Payment$Model$PaymentReady = 1;
var $author$project$Page$Payment$Model$setStatusCreditCardReady = F2(
	function (isReady, model) {
		var newStatus = isReady ? 1 : 2;
		return _Utils_update(
			model,
			{dx: newStatus});
	});
var $author$project$Page$Payment$handlePaymentEvent = F2(
	function (paymentMsg, model) {
		switch (paymentMsg.$) {
			case 0:
				var creditCardFieldValidations = paymentMsg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$Payment$Model$setCreditCardFields, creditCardFieldValidations, model),
					$author$project$Page$Payment$Effect$None);
			case 1:
				var clientErrorEvent = paymentMsg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$Payment$Model$setClientError, clientErrorEvent, model),
					$author$project$Page$Payment$Effect$None);
			case 2:
				var isReady = paymentMsg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$Payment$Model$setStatusCreditCardReady, isReady, model),
					$author$project$Page$Payment$Effect$None);
			default:
				var nonce = paymentMsg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$Payment$Effect$Purchase(nonce));
		}
	});
var $author$project$Referer$paymentPage = 0;
var $author$project$Page$Payment$Model$setGotBraintreeTokenResult = F2(
	function (remoteData, model) {
		return _Utils_update(
			model,
			{gI: remoteData});
	});
var $author$project$Page$Payment$Model$setGotOfferProductResult = F2(
	function (remoteData, model) {
		return _Utils_update(
			model,
			{gJ: remoteData});
	});
var $author$project$Page$Payment$Model$setGotPolicyResult = F2(
	function (remoteData, model) {
		return _Utils_update(
			model,
			{gK: remoteData});
	});
var $author$project$Page$Payment$Model$PayingWithCreditCard = 3;
var $author$project$Page$Payment$Model$setStatusPayingWithCreditCard = function (model) {
	return _Utils_update(
		model,
		{dx: 3});
};
var $author$project$Page$Payment$Model$PaymentFailed = 4;
var $author$project$Page$Payment$Model$PaymentSuccess = 5;
var $author$project$Page$Payment$Model$setStatusPayment = F2(
	function (remoteData, model) {
		switch (remoteData.$) {
			case 2:
				return _Utils_update(
					model,
					{dx: 4});
			case 3:
				return _Utils_update(
					model,
					{dx: 5});
			default:
				return model;
		}
	});
var $krisajenkins$remotedata$RemoteData$unwrap = F3(
	function (_default, _function, remoteData) {
		if (remoteData.$ === 3) {
			var data = remoteData.a;
			return _function(data);
		} else {
			return _default;
		}
	});
var $author$project$Page$Payment$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 3:
				var remoteData = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$Payment$Model$setGotBraintreeTokenResult, remoteData, model),
					A3($krisajenkins$remotedata$RemoteData$unwrap, $author$project$Page$Payment$Effect$None, $author$project$Page$Payment$Effect$SetupBraintreeClient, remoteData));
			case 4:
				var remoteData = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$Payment$Model$setGotOfferProductResult, remoteData, model),
					$author$project$Page$Payment$Effect$None);
			case 5:
				var remoteData = msg.a;
				var updatedModel = A2(
					$author$project$Page$Payment$Model$setStatusPayment,
					remoteData,
					A2($author$project$Page$Payment$Model$setGotPolicyResult, remoteData, model));
				var newEffect = A3(
					$krisajenkins$remotedata$RemoteData$unwrap,
					$author$project$Page$Payment$Effect$None,
					function (policyId) {
						return $author$project$Page$Payment$Effect$ChangeRoute(
							A2(
								$author$project$Route$PolicyDetails,
								policyId,
								$elm$core$Maybe$Just($author$project$Referer$paymentPage)));
					},
					remoteData);
				return _Utils_Tuple2(updatedModel, newEffect);
			case 1:
				var paymentMsg = msg.a;
				return A2($author$project$Page$Payment$handlePaymentEvent, paymentMsg, model);
			case 6:
				return _Utils_Tuple2(
					$author$project$Page$Payment$Model$setStatusPayingWithCreditCard(model),
					$author$project$Page$Payment$Effect$PayWithCreditCard);
			case 0:
				return _Utils_Tuple2(model, $author$project$Page$Payment$Effect$None);
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Page$Payment$Effect$GoBack(1));
		}
	});
var $author$project$Page$PolicyDetails$Effect$ChangeRoute = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$PolicyDetails$Effect$CreateRefund = function (a) {
	return {$: 14, a: a};
};
var $author$project$Page$PolicyDetails$Effect$CustomerTerminatePolicy = function (a) {
	return {$: 12, a: a};
};
var $author$project$Page$PolicyDetails$Effect$FetchCoverSelection = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$PolicyDetails$Effect$FetchCustomerId = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$PolicyDetails$Effect$FetchPaymentMethod = function (a) {
	return {$: 19, a: a};
};
var $author$project$Page$PolicyDetails$Effect$FetchPricingActionClaimHistory = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$PolicyDetails$Effect$GetExpectedRefund = {$: 9};
var $author$project$Page$PolicyDetails$Effect$IssueRefund = function (a) {
	return {$: 15, a: a};
};
var $author$project$Page$PolicyDetails$Effect$None = {$: 31};
var $author$project$Page$PolicyDetails$Effect$PayRefund = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$PolicyDetails$Effect$PollForRefundUpdate = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $author$project$Page$PolicyDetails$Effect$PollRefundForCompletion = function (a) {
	return {$: 29, a: a};
};
var $author$project$Page$PolicyDetails$Effect$PrimaTerminatePolicy = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$PolicyDetails$Effect$RenewalCancellation = function (a) {
	return {$: 18, a: a};
};
var $author$project$Page$PolicyDetails$Effect$SendPolicyContractEmail = function (a) {
	return {$: 20, a: a};
};
var $author$project$Page$PolicyDetails$Effect$TrackSendEmail = function (a) {
	return {$: 22, a: a};
};
var $author$project$Page$PolicyDetails$Effect$UpdateEmail = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Page$PolicyDetails$Effect$WaitBeforePollingRefundUpdate = F2(
	function (a, b) {
		return {$: 28, a: a, b: b};
	});
var $author$project$Page$PolicyDetails$Effect$WithCmd = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$PolicyDetails$Effect$WithdrawPolicy = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$isDifferent = F2(
	function (modelA, modelB) {
		return !_Utils_eq(modelA, modelB);
	});
var $author$project$Page$PolicyDetails$applyIfInterruptionModelChanged = F3(
	function (model, interruptionModal, effect) {
		return A2($author$project$Page$PolicyDetails$InterruptionModal$Model$isDifferent, interruptionModal, model.p) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{p: interruptionModal}),
			effect) : _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
	});
var $author$project$Translations$changeEmailModalErrorToastMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'It was not possible to change the email address. Please refresh the page to try again.';
	} else {
		return 'No ha sido posible cambiar el dirección de email. Actualiza la página para intentarlo nuevamente.';
	}
};
var $author$project$Translations$changeEmailModalSuccessToastMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The email address was changed successfully.';
	} else {
		return 'El dirección de email ha cambiado correctamente.';
	}
};
var $author$project$Page$PolicyDetails$Effect$FetchClaimHistory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$Policy$pickQuoteId = function (_v0) {
	var policy = _v0;
	return policy.o_;
};
var $author$project$Page$PolicyDetails$chooseClaimHistoryEffectByFetchedPolicy = function (policy) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Page$PolicyDetails$Effect$None,
		A2(
			$elm$core$Maybe$map,
			$author$project$Page$PolicyDetails$Effect$FetchClaimHistory,
			$author$project$Common$Policy$pickQuoteId(policy)));
};
var $author$project$Page$PolicyDetails$Effect$GetRefund = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$PolicyDetails$chooseEffectForInterruptedPolicy = F3(
	function (policyId, issueRefundReleaseDate, interruption) {
		return (_Utils_cmp(
			$elm$time$Time$posixToMillis(issueRefundReleaseDate),
			$elm$time$Time$posixToMillis(interruption.ml)) < 0) ? $author$project$Page$PolicyDetails$Effect$GetRefund(policyId) : $author$project$Page$PolicyDetails$Effect$None;
	});
var $krisajenkins$remotedata$RemoteData$isLoading = function (data) {
	if (data.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Common$Policy$pickInterruption = function (_v0) {
	var policy = _v0;
	return policy.cV;
};
var $author$project$Page$PolicyDetails$chooseGetRefundEffectByFetchedPolicy = F3(
	function (model, issueRefundReleaseDate, policy) {
		return (!$krisajenkins$remotedata$RemoteData$isLoading(model.o4)) ? A2(
			$elm$core$Maybe$withDefault,
			$author$project$Page$PolicyDetails$Effect$None,
			A2(
				$elm$core$Maybe$map,
				A2(
					$author$project$Page$PolicyDetails$chooseEffectForInterruptedPolicy,
					$author$project$Common$Policy$pickId(policy),
					issueRefundReleaseDate),
				$author$project$Common$Policy$pickInterruption(policy))) : $author$project$Page$PolicyDetails$Effect$None;
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$Model = $elm$core$Basics$identity;
var $author$project$Page$PolicyDetails$AmendInterruptionModal$closeModal = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$close(model.cq);
	var visibilityModel = _v1.a;
	var visibilityCmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{cq: visibilityModel}),
		visibilityCmd);
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$Dismiss = {$: 0};
var $author$project$Page$PolicyDetails$ChangeEmailModal$Opened = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pyxis$Components$Field$Input$getValue = function (_v0) {
	var value = _v0.pB;
	return value;
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$emailRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('[^@\\s]+@[^@\\s]+'));
var $author$project$Page$PolicyDetails$ChangeEmailModal$isInputValid = function (emailInput) {
	return (!$elm$core$String$isEmpty(emailInput)) && A2($elm$regex$Regex$contains, $author$project$Page$PolicyDetails$ChangeEmailModal$emailRegex, emailInput);
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$modalVisibility = function (_v0) {
	var visibility = _v0.cq;
	if (!visibility.$) {
		var visibilityStatus = visibility.a;
		return visibilityStatus;
	} else {
		var visibilityStatus = visibility.a;
		return visibilityStatus;
	}
};
var $author$project$Pyxis$Components$Field$Input$mapFieldStatus = F2(
	function (mapper, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				ev: mapper(model.ev)
			});
	});
var $author$project$Pyxis$Components$Field$Input$update = F2(
	function (msg, model) {
		var modelData = model;
		switch (msg.$) {
			case 2:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hH)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Input$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(true),
						model));
			case 1:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hQ)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Input$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(false),
						model));
			case 0:
				var value = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hS)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Input$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsDirty(true),
						_Utils_update(
							modelData,
							{pB: value})));
			default:
				var event = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(
							A2($author$project$Pyxis$Commons$Basics$maybeForwardValue, event, modelData.hW))
						]),
					model);
		}
	});
var $author$project$Page$PolicyDetails$ChangeEmailModal$update = F2(
	function (msg, model) {
		var modelData = model;
		switch (msg.$) {
			case 0:
				var _v1 = $author$project$Pyxis$Components$Modal$close(
					$author$project$Page$PolicyDetails$ChangeEmailModal$modalVisibility(model));
				var visibility = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						modelData,
						{
							cq: $author$project$Page$PolicyDetails$ChangeEmailModal$Closed(visibility)
						}),
					cmd);
			case 1:
				var email = msg.a;
				var newInputModel = A2($author$project$Pyxis$Components$Field$Input$setValue, email, modelData.a_);
				var _v2 = $author$project$Pyxis$Components$Modal$open(
					$author$project$Page$PolicyDetails$ChangeEmailModal$modalVisibility(model));
				var visibility = _v2.a;
				var cmd = _v2.b;
				var newModalVisibility = A2($author$project$Page$PolicyDetails$ChangeEmailModal$Opened, visibility, email);
				return _Utils_Tuple2(
					_Utils_update(
						modelData,
						{a_: newInputModel, cq: newModalVisibility}),
					cmd);
			case 2:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Pyxis$Components$Field$Input$update, subMsg, modelData.a_);
				var newInputModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						modelData,
						{a_: newInputModel}),
					cmd);
			case 3:
				var inputValue = $author$project$Pyxis$Components$Field$Input$getValue(modelData.a_);
				return $author$project$Page$PolicyDetails$ChangeEmailModal$isInputValid(inputValue) ? _Utils_Tuple2(
					_Utils_update(
						modelData,
						{cY: true}),
					$author$project$Pyxis$Commons$Commands$dispatch(
						modelData.kO(inputValue))) : _Utils_Tuple2(
					_Utils_update(
						modelData,
						{cY: true}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						modelData,
						{cY: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$PolicyDetails$ChangeEmailModal$closeModal = $author$project$Page$PolicyDetails$ChangeEmailModal$update($author$project$Page$PolicyDetails$ChangeEmailModal$Dismiss);
var $author$project$Page$PolicyDetails$InterruptionModal$Model$closeModal = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$close(model.cq);
	var visibilityModel = _v1.a;
	var visibilityCmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{cq: visibilityModel}),
		visibilityCmd);
};
var $author$project$Page$PolicyDetails$RefundIssuingModal$closeModal = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$close(model.cq);
	var newVisibility = _v1.a;
	var cmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{cq: newVisibility}),
		cmd);
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$closeModal = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$close(model.cq);
	var visibilityModel = _v1.a;
	var visibilityCmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{cq: visibilityModel}),
		visibilityCmd);
};
var $author$project$Page$PolicyDetails$SendEmailModal$closeModal = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$close(model.cq);
	var newVisibility = _v1.a;
	var cmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{cq: newVisibility}),
		cmd);
};
var $author$project$Page$PolicyDetails$Effect$WaitBeforePollingRefundCompletion = function (a) {
	return {$: 30, a: a};
};
var $author$project$Page$PolicyDetails$Model$setRefundResult = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{o4: result});
	});
var $author$project$Page$PolicyDetails$continuePolling = F2(
	function (model, policyId) {
		return _Utils_Tuple2(
			A2($author$project$Page$PolicyDetails$Model$setRefundResult, $krisajenkins$remotedata$RemoteData$Loading, model),
			$author$project$Page$PolicyDetails$Effect$WaitBeforePollingRefundCompletion(policyId));
	});
var $author$project$Page$PolicyDetails$SendEmailModal$emailOptionToString = 'policy contract';
var $author$project$Common$Refund$isPendingOrNotRequired = function (_v0) {
	var status = _v0.b;
	return (!status) || (status === 4);
};
var $author$project$Common$Refund$isToBePaid = function (_v0) {
	var status = _v0.b;
	return status === 1;
};
var $author$project$Page$PolicyDetails$Effect$GetExpectedRefundForAmendInterruption = F3(
	function (a, b, c) {
		return {$: 26, a: a, b: b, c: c};
	});
var $elm$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					return $elm$core$Maybe$Just(
						A3(func, a, b, c));
				}
			}
		}
	});
var $author$project$Pyxis$Components$Field$DateInput$getValue = function (_v0) {
	var value = _v0.pB;
	return value;
};
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var year = _v0.pG;
		var month = _v0.nM;
		var day = _v0.mJ;
		var hour = _v0.nh;
		var minute = _v0.nK;
		var second = _v0.pg;
		var millisecond = _v0.nI;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $author$project$Common$Locale$midnightAtCustomerDate = function (date) {
	return A2(
		$justinmimbs$time_extra$Time$Extra$partsToPosix,
		$author$project$Common$Locale$customerTimeZone,
		{
			mJ: $justinmimbs$date$Date$day(date),
			nh: 0,
			nI: 0,
			nK: 0,
			nM: $justinmimbs$date$Date$month(date),
			pg: 0,
			pG: $justinmimbs$date$Date$year(date)
		});
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$pickDateValue = function (_v0) {
	var interruptionDateInput = _v0.aI;
	return A2(
		$elm$core$Maybe$map,
		$author$project$Common$Locale$midnightAtCustomerDate,
		$elm$core$Result$toMaybe(
			$justinmimbs$date$Date$fromIsoString(
				$author$project$Pyxis$Components$Field$DateInput$getValue(interruptionDateInput))));
};
var $author$project$Pyxis$Components$Field$Autocomplete$getValue = function (_v0) {
	var value = _v0.pB;
	return value;
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$pickReasonValue = function (_v0) {
	var reasonInput = _v0.aN;
	return $author$project$Pyxis$Components$Field$Autocomplete$getValue(reasonInput);
};
var $author$project$Page$PolicyDetails$maybeGetExpectedRefundForAmendInterruption = function (oldState) {
	var model = oldState.a;
	var effect = oldState.b;
	var updateModelAndEffect = F3(
		function (reason, policyId, interruptionAt) {
			return A2(
				$elm$core$Tuple$pair,
				model,
				$author$project$Page$PolicyDetails$Effect$Effects(
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[effect]),
						$elm$core$List$singleton(
							A3($author$project$Page$PolicyDetails$Effect$GetExpectedRefundForAmendInterruption, reason, policyId, interruptionAt)))));
		});
	var maybeReason = A2($elm$core$Maybe$andThen, $author$project$Page$PolicyDetails$AmendInterruptionModal$pickReasonValue, model.U);
	var maybePolicyId = A2(
		$elm$core$Maybe$map,
		$author$project$Common$Policy$pickId,
		$krisajenkins$remotedata$RemoteData$toMaybe(model.k));
	var maybeInterruptionAt = A2($elm$core$Maybe$andThen, $author$project$Page$PolicyDetails$AmendInterruptionModal$pickDateValue, model.U);
	return A2(
		$elm$core$Maybe$withDefault,
		oldState,
		A4($elm$core$Maybe$map3, updateModelAndEffect, maybeReason, maybePolicyId, maybeInterruptionAt));
};
var $author$project$Page$PolicyDetails$Msg$AmendInterruptionDateSelected = {$: 57};
var $author$project$Page$PolicyDetails$Msg$AmendInterruptionModalSubmitErrored = {$: 60};
var $author$project$Page$PolicyDetails$Msg$AmendInterruptionReasonChanged = function (a) {
	return {$: 53, a: a};
};
var $author$project$Page$PolicyDetails$Msg$AmendInterruptionReasonSelected = {$: 54};
var $author$project$Page$PolicyDetails$Msg$ChangeAmendInterruptionDate = function (a) {
	return {$: 56, a: a};
};
var $author$project$Page$PolicyDetails$Msg$ChangeAmendInterruptionDescription = function (a) {
	return {$: 55, a: a};
};
var $author$project$Page$PolicyDetails$Msg$DismissAmendModal = {$: 51};
var $author$project$Page$PolicyDetails$Msg$SubmitAmendInterruptionModal = F4(
	function (a, b, c, d) {
		return {$: 52, a: a, b: b, c: c, d: d};
	});
var $author$project$Translations$interruptionCompetitorOffer = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Competitor offer';
	} else {
		return 'Competencia';
	}
};
var $author$project$Translations$interruptionCoverageChange = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Coverage change';
	} else {
		return 'Cambio cobertura';
	}
};
var $author$project$Translations$interruptionDeceasedPolicyHolder = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Deceased policy holder';
	} else {
		return 'Fallecimiento';
	}
};
var $author$project$Translations$interruptionDissatisfactionService = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Unsatisfied';
	} else {
		return 'Insatisfacción';
	}
};
var $author$project$Translations$interruptionDoesNotKnow = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Doesn\'t know / doesn\'t reply';
	} else {
		return 'NS/NC';
	}
};
var $author$project$Translations$interruptionIncorrectDataOther = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Incorrect data - Other';
	} else {
		return 'Datos incorrectos - Otro';
	}
};
var $author$project$Translations$interruptionIncorrectEffectiveDate = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Incorrect start date';
	} else {
		return 'Fecha de inicio incorrecta';
	}
};
var $author$project$Translations$interruptionIncorrectPersonalData = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Incorrect personal data';
	} else {
		return 'Datos personales incorrectos';
	}
};
var $author$project$Translations$interruptionMovingToAnotherCountry = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Moving To another country';
	} else {
		return 'Mudanza al extranjero';
	}
};
var $author$project$Translations$interruptionNoInsuranceWanted = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Leaves vehicle uninsured';
	} else {
		return 'Deja sin seguro';
	}
};
var $author$project$Translations$interruptionOther = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Other';
	} else {
		return 'Otro';
	}
};
var $author$project$Translations$interruptionPaymentMethodOrDate = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Payment method / date';
	} else {
		return 'Fecha de pago';
	}
};
var $author$project$Translations$interruptionPolicyHolderChange = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy holder change';
	} else {
		return 'Cambio de titular';
	}
};
var $author$project$Translations$interruptionProductService = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Product service';
	} else {
		return 'Producto/servicio';
	}
};
var $author$project$Translations$interruptionSwitchToGreatLakes = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Switch to Great Lakes';
	} else {
		return 'Cambio a Great Lakes';
	}
};
var $author$project$Translations$interruptionUnderwritingRules = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Underwriting rules';
	} else {
		return 'Normas de suscripción';
	}
};
var $author$project$Translations$interruptionVehicleDeregistration = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Vehicle deregistration';
	} else {
		return 'Baja del vehículo';
	}
};
var $author$project$Translations$interruptionVehicleNotPurchased = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Vehicle not purchased';
	} else {
		return 'No compra vehículo';
	}
};
var $author$project$Translations$interruptionVehicleSold = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Vehicle sold';
	} else {
		return 'Venta';
	}
};
var $author$project$Translations$interruptionWantsGreenCard = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Needs Carta Verde';
	} else {
		return 'Necesidad de Carta Verde';
	}
};
var $author$project$Common$AmendReason$customerReasonLabel = F2(
	function (i18n, customerReason) {
		switch (customerReason) {
			case 0:
				return $author$project$Translations$interruptionCompetitorOffer(i18n);
			case 1:
				return $author$project$Translations$interruptionVehicleSold(i18n);
			case 2:
				return $author$project$Translations$interruptionVehicleNotPurchased(i18n);
			case 3:
				return $author$project$Translations$interruptionVehicleDeregistration(i18n);
			case 4:
				return $author$project$Translations$interruptionNoInsuranceWanted(i18n);
			case 5:
				return $author$project$Translations$interruptionDoesNotKnow(i18n);
			case 6:
				return $author$project$Translations$interruptionWantsGreenCard(i18n);
			case 7:
				return $author$project$Translations$interruptionIncorrectEffectiveDate(i18n);
			case 8:
				return $author$project$Translations$interruptionIncorrectPersonalData(i18n);
			case 9:
				return $author$project$Translations$interruptionIncorrectDataOther(i18n);
			case 10:
				return $author$project$Translations$interruptionPaymentMethodOrDate(i18n);
			case 11:
				return $author$project$Translations$interruptionDeceasedPolicyHolder(i18n);
			case 12:
				return $author$project$Translations$interruptionCoverageChange(i18n);
			case 13:
				return $author$project$Translations$interruptionDissatisfactionService(i18n);
			case 14:
				return $author$project$Translations$interruptionUnderwritingRules(i18n);
			case 15:
				return $author$project$Translations$interruptionMovingToAnotherCountry(i18n);
			case 16:
				return $author$project$Translations$interruptionProductService(i18n);
			case 17:
				return $author$project$Translations$interruptionPolicyHolderChange(i18n);
			case 18:
				return $author$project$Translations$interruptionSwitchToGreatLakes(i18n);
			default:
				return $author$project$Translations$interruptionOther(i18n);
		}
	});
var $author$project$Translations$interruptionChargeback = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Chargeback';
	} else {
		return 'Impago';
	}
};
var $author$project$Translations$interruptionFraud = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Fraud';
	} else {
		return 'Fraude';
	}
};
var $author$project$Translations$interruptionInexactDeclarationDni = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Inexact declaration - DNI';
	} else {
		return 'Declaración inexacta - DNI';
	}
};
var $author$project$Translations$interruptionInexactDeclarationSinco = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Inexact declaration - SINCO';
	} else {
		return 'Declaración inexacta - SINCO';
	}
};
var $author$project$Translations$interruptionPhotoVericiationNotProvided = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Photo verification not provided';
	} else {
		return 'Fotoverificación no enviada';
	}
};
var $author$project$Translations$interruptionRiskAggravation = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Risk aggravation';
	} else {
		return 'Agravación del riesgo';
	}
};
var $author$project$Common$AmendReason$primaReasonLabel = F2(
	function (i18n, primaReason) {
		switch (primaReason) {
			case 0:
				return $author$project$Translations$interruptionInexactDeclarationSinco(i18n);
			case 1:
				return $author$project$Translations$interruptionFraud(i18n);
			case 2:
				return $author$project$Translations$interruptionChargeback(i18n);
			case 3:
				return $author$project$Translations$interruptionInexactDeclarationDni(i18n);
			case 4:
				return $author$project$Translations$interruptionRiskAggravation(i18n);
			default:
				return $author$project$Translations$interruptionPhotoVericiationNotProvided(i18n);
		}
	});
var $author$project$Common$AmendReason$amendReasonLabel = F2(
	function (i18n, reason) {
		if (!reason.$) {
			var primaReason = reason.a;
			return A2($author$project$Common$AmendReason$primaReasonLabel, i18n, primaReason);
		} else {
			var customerReason = reason.a;
			return A2($author$project$Common$AmendReason$customerReasonLabel, i18n, customerReason);
		}
	});
var $author$project$Common$AmendReason$Company = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$AmendReason$CompetitorOffer = 0;
var $author$project$Common$AmendReason$Customer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$AmendReason$InexactDeclarationSinco = 0;
var $author$project$Common$AmendReason$defaultFromAmendType = function (amendKind) {
	if (!amendKind) {
		return $author$project$Common$AmendReason$Company(0);
	} else {
		return $author$project$Common$AmendReason$Customer(0);
	}
};
var $author$project$Common$AmendReason$Chargeback = 2;
var $author$project$Common$AmendReason$Fraud = 1;
var $author$project$Common$AmendReason$InexactDeclarationDni = 3;
var $author$project$Common$AmendReason$PhotoVerificationNotProvided = 5;
var $author$project$Common$AmendReason$RiskAggravation = 4;
var $author$project$Common$AmendReason$nextCompany = function (list) {
	var _v0 = $elm$core$List$head(list);
	if (_v0.$ === 1) {
		return $author$project$Common$AmendReason$nextCompany(
			A2($elm$core$List$cons, 0, list));
	} else {
		switch (_v0.a) {
			case 0:
				var _v1 = _v0.a;
				return $author$project$Common$AmendReason$nextCompany(
					A2($elm$core$List$cons, 1, list));
			case 1:
				var _v2 = _v0.a;
				return $author$project$Common$AmendReason$nextCompany(
					A2($elm$core$List$cons, 2, list));
			case 2:
				var _v3 = _v0.a;
				return $author$project$Common$AmendReason$nextCompany(
					A2($elm$core$List$cons, 3, list));
			case 3:
				var _v4 = _v0.a;
				return $author$project$Common$AmendReason$nextCompany(
					A2($elm$core$List$cons, 4, list));
			case 4:
				var _v5 = _v0.a;
				return $author$project$Common$AmendReason$nextCompany(
					A2($elm$core$List$cons, 5, list));
			default:
				var _v6 = _v0.a;
				return list;
		}
	}
};
var $author$project$Common$AmendReason$allCompanyReason = $elm$core$List$reverse(
	$author$project$Common$AmendReason$nextCompany(_List_Nil));
var $author$project$Common$AmendReason$CoverageChange = 12;
var $author$project$Common$AmendReason$DeceasedPolicyHolder = 11;
var $author$project$Common$AmendReason$DissatisfactionService = 13;
var $author$project$Common$AmendReason$DoesNotKnow = 5;
var $author$project$Common$AmendReason$IncorrectDataOther = 9;
var $author$project$Common$AmendReason$IncorrectEffectiveDate = 7;
var $author$project$Common$AmendReason$IncorrectPersonalData = 8;
var $author$project$Common$AmendReason$MovingToAnotherCountry = 15;
var $author$project$Common$AmendReason$NoInsuranceWanted = 4;
var $author$project$Common$AmendReason$Other = 19;
var $author$project$Common$AmendReason$PaymentMethodOrDate = 10;
var $author$project$Common$AmendReason$PolicyHolderChange = 17;
var $author$project$Common$AmendReason$ProductService = 16;
var $author$project$Common$AmendReason$SwitchToGreatLakes = 18;
var $author$project$Common$AmendReason$UnderwritingRules = 14;
var $author$project$Common$AmendReason$VehicleDeregistration = 3;
var $author$project$Common$AmendReason$VehicleNotPurchased = 2;
var $author$project$Common$AmendReason$VehicleSold = 1;
var $author$project$Common$AmendReason$WantsGreenCard = 6;
var $author$project$Common$AmendReason$nextCustomer = function (list) {
	var _v0 = $elm$core$List$head(list);
	if (_v0.$ === 1) {
		return $author$project$Common$AmendReason$nextCustomer(
			A2($elm$core$List$cons, 0, list));
	} else {
		switch (_v0.a) {
			case 0:
				var _v1 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 1, list));
			case 1:
				var _v2 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 2, list));
			case 2:
				var _v3 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 3, list));
			case 3:
				var _v4 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 4, list));
			case 4:
				var _v5 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 5, list));
			case 5:
				var _v6 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 6, list));
			case 6:
				var _v7 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 7, list));
			case 7:
				var _v8 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 8, list));
			case 8:
				var _v9 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 9, list));
			case 9:
				var _v10 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 10, list));
			case 10:
				var _v11 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 11, list));
			case 11:
				var _v12 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 12, list));
			case 12:
				var _v13 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 13, list));
			case 13:
				var _v14 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 14, list));
			case 14:
				var _v15 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 15, list));
			case 15:
				var _v16 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 16, list));
			case 16:
				var _v17 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 17, list));
			case 17:
				var _v18 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 18, list));
			case 18:
				var _v19 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 19, list));
			default:
				var _v20 = _v0.a;
				return list;
		}
	}
};
var $author$project$Common$AmendReason$allCustomerReason = $elm$core$List$reverse(
	$author$project$Common$AmendReason$nextCustomer(_List_Nil));
var $author$project$Common$AmendReason$amendReasons = _Utils_ap(
	A2($elm$core$List$map, $author$project$Common$AmendReason$Company, $author$project$Common$AmendReason$allCompanyReason),
	A2($elm$core$List$map, $author$project$Common$AmendReason$Customer, $author$project$Common$AmendReason$allCustomerReason));
var $author$project$Common$AmendReason$isCompanyReason = function (reason) {
	if (!reason.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Common$AmendReason$companyReasons = A2($elm$core$List$filter, $author$project$Common$AmendReason$isCompanyReason, $author$project$Common$AmendReason$amendReasons);
var $author$project$Common$AmendReason$customerReasons = A2($elm$core$List$filter, $author$project$Common$AmendReason$isCustomerReason, $author$project$Common$AmendReason$amendReasons);
var $author$project$Common$AmendReason$fromAmendInterruptionType = function (amendKind) {
	if (!amendKind) {
		return $author$project$Common$AmendReason$companyReasons;
	} else {
		return $author$project$Common$AmendReason$customerReasons;
	}
};
var $author$project$Common$AmendReason$fromInterruptionReason = function (intReason) {
	switch (intReason) {
		case 0:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Company(2));
		case 1:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(0));
		case 2:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(12));
		case 3:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(11));
		case 4:
			return $elm$core$Maybe$Nothing;
		case 5:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(13));
		case 6:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(5));
		case 7:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Company(1));
		case 8:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(9));
		case 9:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(7));
		case 10:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(8));
		case 11:
			return $elm$core$Maybe$Nothing;
		case 12:
			return $elm$core$Maybe$Nothing;
		case 13:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Company(3));
		case 14:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Company(0));
		case 15:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(15));
		case 16:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(4));
		case 17:
			return $elm$core$Maybe$Nothing;
		case 18:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(19));
		case 19:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(10));
		case 20:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(17));
		case 21:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(16));
		case 22:
			return $elm$core$Maybe$Nothing;
		case 23:
			return $elm$core$Maybe$Nothing;
		case 24:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Company(4));
		case 25:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(14));
		case 26:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(3));
		case 27:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(2));
		case 28:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(3));
		case 29:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(1));
		case 30:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(6));
		case 32:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Company(5));
		case 33:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(18));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$Pristine = 0;
var $author$project$Pyxis$Components$Field$Autocomplete$Option = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Autocomplete$option = function (_v0) {
	var value = _v0.pB;
	var label = _v0.eR;
	return {kg: 'id-' + label, eR: label, pB: value};
};
var $author$project$Pyxis$Components$Field$DateInput$setOnInput = F2(
	function (msg, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				hS: $elm$core$Maybe$Just(msg)
			});
	});
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Pyxis$Components$Field$Autocomplete$getOptionData = function (_v0) {
	var optionData = _v0;
	return optionData;
};
var $author$project$Pyxis$Components$Field$Autocomplete$getOptions = function (_v0) {
	var modelData = _v0;
	return A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.eR;
				},
				modelData.bH(modelData.E))),
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$krisajenkins$remotedata$RemoteData$toMaybe(modelData.aw)));
};
var $author$project$Pyxis$Components$Field$Autocomplete$setActiveOption = F2(
	function (option_, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{H: option_});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$initializeActiveOption = function (model) {
	var value = model.pB;
	if (!value.$) {
		var currentValue = value.a;
		return A3(
			$primait$prima_elm_extra$PrimaFunction$flip,
			$author$project$Pyxis$Components$Field$Autocomplete$setActiveOption,
			model,
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pB;
						},
						$elm$core$Basics$eq(currentValue))),
				$author$project$Pyxis$Components$Field$Autocomplete$getOptions(model)));
	} else {
		return A3(
			$primait$prima_elm_extra$PrimaFunction$flip,
			$author$project$Pyxis$Components$Field$Autocomplete$setActiveOption,
			model,
			$elm$core$List$head(
				$author$project$Pyxis$Components$Field$Autocomplete$getOptions(model)));
	}
};
var $krisajenkins$remotedata$RemoteData$isSuccess = function (data) {
	if (data.$ === 3) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var $krisajenkins$remotedata$RemoteData$mapError = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var x = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(x);
			case 2:
				var e = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(
					f(e));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			default:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
		}
	});
var $author$project$Pyxis$Components$Field$Autocomplete$setOptions = F2(
	function (optionsRemoteData, _v0) {
		var modelData = _v0;
		var values = A2(
			$krisajenkins$remotedata$RemoteData$mapError,
			$elm$core$Basics$always(0),
			optionsRemoteData);
		return $author$project$Pyxis$Components$Field$Autocomplete$initializeActiveOption(
			_Utils_update(
				modelData,
				{
					a2: $krisajenkins$remotedata$RemoteData$isSuccess(optionsRemoteData),
					aw: values
				}));
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$init = function (onDismiss) {
	return function (onSubmit) {
		return function (onSubmitError) {
			return function (onReasonChanged) {
				return function (onReasonSelected) {
					return function (onDescriptionChanges) {
						return function (onInterruptionDateChanges) {
							return function (onInterruptionDateSelected) {
								return function (policyStartDate) {
									return function (earliestSelectableDate) {
										return function (latestSelectableDate) {
											return function (reasons) {
												return function (descriptionStatusMapper) {
													return function (defaultReason) {
														var reasonsOptions = A2(
															$elm$core$List$map,
															$author$project$Pyxis$Components$Field$Autocomplete$option,
															A2(
																$elm$core$List$sortBy,
																function ($) {
																	return $.eR;
																},
																reasons));
														return {
															mM: defaultReason,
															aC: $author$project$Pyxis$Components$Field$Textarea$init,
															bD: 3,
															gm: descriptionStatusMapper,
															aZ: earliestSelectableDate,
															mY: $krisajenkins$remotedata$RemoteData$NotAsked,
															aE: 0,
															gW: $elm$core$Maybe$Nothing,
															aI: A2($author$project$Pyxis$Components$Field$DateInput$setOnInput, onInterruptionDateSelected, $author$project$Pyxis$Components$Field$DateInput$init),
															a4: latestSelectableDate,
															kR: onDescriptionChanges,
															hP: onDismiss,
															kT: onInterruptionDateChanges,
															k2: onReasonChanged,
															k5: onSubmit,
															k6: onSubmitError,
															lg: policyStartDate,
															aN: A2(
																$author$project$Pyxis$Components$Field$Autocomplete$setOnSelect,
																onReasonSelected,
																A2(
																	$author$project$Pyxis$Components$Field$Autocomplete$setOptions,
																	$krisajenkins$remotedata$RemoteData$Success(reasonsOptions),
																	$author$project$Pyxis$Components$Field$Autocomplete$init)),
															cq: $author$project$Pyxis$Components$Modal$init('edit-policy-interruption-modal')
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$Dirty = 1;
var $author$project$Pyxis$Components$Field$Autocomplete$setDropdownClosed = function (_v0) {
	var modelData = _v0;
	return _Utils_update(
		modelData,
		{H: $elm$core$Maybe$Nothing, eA: false, a2: false, bO: false});
};
var $author$project$Pyxis$Components$Field$Autocomplete$setSelectedOption = F2(
	function (value, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{
				fj: A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.pB;
							},
							$elm$core$Basics$eq(value))),
					$author$project$Pyxis$Components$Field$Autocomplete$getOptions(modelData))
			});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$getLabelByValue = F2(
	function (model, value) {
		return A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
				function ($) {
					return $.eR;
				}),
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pB;
						},
						$elm$core$Basics$eq(value))),
				$author$project$Pyxis$Components$Field$Autocomplete$getOptions(model)));
	});
var $author$project$Pyxis$Components$Field$Autocomplete$updateFilteringValue = function (model) {
	var modelData = model;
	var filteringValue = A2(
		$elm$core$Maybe$withDefault,
		modelData.E,
		A2(
			$elm$core$Maybe$andThen,
			$author$project$Pyxis$Components$Field$Autocomplete$getLabelByValue(model),
			modelData.pB));
	return _Utils_update(
		modelData,
		{E: filteringValue});
};
var $author$project$Pyxis$Components$Field$Autocomplete$updateSelectedValue = F2(
	function (value, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{
				pB: $elm$core$Maybe$Just(value)
			});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$setValue = F2(
	function (value, model) {
		return $author$project$Pyxis$Components$Field$Autocomplete$setDropdownClosed(
			$author$project$Pyxis$Components$Field$Autocomplete$updateFilteringValue(
				A2(
					$author$project$Pyxis$Components$Field$Autocomplete$setSelectedOption,
					value,
					A2($author$project$Pyxis$Components$Field$Autocomplete$updateSelectedValue, value, model))));
	});
var $author$project$Pyxis$Components$Field$DateInput$setValue = F2(
	function (value, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{pB: value});
	});
var $author$project$Pyxis$Components$Field$Textarea$setValue = F2(
	function (value, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{pB: value});
	});
var $author$project$Common$Locale$toIsoString = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$fromPosix($author$project$Common$Locale$customerTimeZone),
	$justinmimbs$date$Date$toIsoString);
var $author$project$Page$PolicyDetails$AmendInterruptionModal$setInitialValues = F2(
	function (initialValues, _v0) {
		var modelData = _v0;
		var stringDate = $author$project$Common$Locale$toIsoString(initialValues.gX);
		var newReasonModel = A2(
			$elm$core$Maybe$withDefault,
			modelData.aN,
			A2(
				$elm$core$Maybe$map,
				function (value) {
					return A2($author$project$Pyxis$Components$Field$Autocomplete$setValue, value, modelData.aN);
				},
				initialValues.im));
		var newDescriptionStatus = A2(
			$elm$core$Maybe$withDefault,
			3,
			A2($elm$core$Maybe$map, modelData.gm, initialValues.im));
		var newDescriptionModel = A2(
			$elm$core$Maybe$withDefault,
			modelData.aC,
			A2(
				$elm$core$Maybe$map,
				function (value) {
					return A2($author$project$Pyxis$Components$Field$Textarea$setValue, value, modelData.aC);
				},
				initialValues.mN));
		return _Utils_update(
			modelData,
			{
				aC: newDescriptionModel,
				bD: newDescriptionStatus,
				aE: 1,
				gW: $elm$core$Maybe$Just(initialValues),
				aI: A2($author$project$Pyxis$Components$Field$DateInput$setValue, stringDate, modelData.aI),
				aN: newReasonModel
			});
	});
var $author$project$Common$Policy$startDateTime = function (_v0) {
	var policy = _v0;
	return $author$project$Common$Locale$midnightAtCustomerDate(policy.lL);
};
var $author$project$Common$ReasonDescriptionStatus$Mandatory = 0;
var $author$project$Common$ReasonDescriptionStatus$NotRequired = 2;
var $author$project$Common$ReasonDescriptionStatus$Optional = 1;
var $author$project$Common$AmendReason$customerReasonToDescriptionStatus = function (reason) {
	switch (reason) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 2;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 2;
		case 6:
			return 2;
		case 7:
			return 2;
		case 8:
			return 1;
		case 9:
			return 1;
		case 10:
			return 2;
		case 11:
			return 2;
		case 12:
			return 1;
		case 13:
			return 1;
		case 14:
			return 2;
		case 15:
			return 2;
		case 16:
			return 1;
		case 17:
			return 1;
		case 18:
			return 1;
		default:
			return 0;
	}
};
var $author$project$Common$AmendReason$primaReasonToDescriptionStatus = function (reason) {
	switch (reason) {
		case 2:
			return 2;
		case 0:
			return 2;
		case 1:
			return 1;
		case 3:
			return 2;
		case 4:
			return 1;
		default:
			return 1;
	}
};
var $author$project$Common$AmendReason$toDescriptionStatus = function (reason) {
	if (!reason.$) {
		var primaReason = reason.a;
		return $author$project$Common$AmendReason$primaReasonToDescriptionStatus(primaReason);
	} else {
		var customerReason = reason.a;
		return $author$project$Common$AmendReason$customerReasonToDescriptionStatus(customerReason);
	}
};
var $author$project$Page$PolicyDetails$Model$initAmendModal = F4(
	function (i18n, policy, model, _v0) {
		var earliestSelectableDate = _v0.aZ;
		var latestSelectableDate = _v0.a4;
		var kind = _v0.c_;
		var setInitialValues = F2(
			function (initialModel, interruption) {
				return A2(
					$author$project$Page$PolicyDetails$AmendInterruptionModal$setInitialValues,
					{
						mN: interruption.mN,
						gX: interruption.ml,
						im: $author$project$Common$AmendReason$fromInterruptionReason(interruption.im)
					},
					initialModel);
			});
		var reasons = A2(
			$elm$core$List$map,
			function (reason) {
				return {
					eR: A2($author$project$Common$AmendReason$amendReasonLabel, i18n, reason),
					pB: reason
				};
			},
			$author$project$Common$AmendReason$fromAmendInterruptionType(kind));
		var initModel = $author$project$Page$PolicyDetails$AmendInterruptionModal$init($author$project$Page$PolicyDetails$Msg$DismissAmendModal)($author$project$Page$PolicyDetails$Msg$SubmitAmendInterruptionModal)($author$project$Page$PolicyDetails$Msg$AmendInterruptionModalSubmitErrored)($author$project$Page$PolicyDetails$Msg$AmendInterruptionReasonChanged)($author$project$Page$PolicyDetails$Msg$AmendInterruptionReasonSelected)($author$project$Page$PolicyDetails$Msg$ChangeAmendInterruptionDescription)($author$project$Page$PolicyDetails$Msg$ChangeAmendInterruptionDate)($author$project$Page$PolicyDetails$Msg$AmendInterruptionDateSelected)(
			$author$project$Common$Policy$startDateTime(policy))(earliestSelectableDate)(latestSelectableDate)(reasons)($author$project$Common$AmendReason$toDescriptionStatus)(
			$author$project$Common$AmendReason$defaultFromAmendType(kind));
		var maybeWithInitialValues = A2(
			$elm$core$Maybe$withDefault,
			initModel,
			A2(
				$elm$core$Maybe$map,
				setInitialValues(initModel),
				$author$project$Common$Policy$pickInterruption(policy)));
		return _Utils_update(
			model,
			{
				U: $elm$core$Maybe$Just(maybeWithInitialValues)
			});
	});
var $author$project$Common$Policy$mapActionAmendInterruption = F2(
	function (f, _v0) {
		var policyId = _v0.oQ;
		var earliestSelectableDate = _v0.aZ;
		var latestSelectableDate = _v0.a4;
		var kind = _v0.c_;
		return f(
			{aZ: earliestSelectableDate, c_: kind, a4: latestSelectableDate, oQ: policyId});
	});
var $author$project$Common$Policy$pickAmendTerminationAction = function (_v0) {
	var policy = _v0;
	return $elm$core$List$head(
		A2(
			$elm$core$List$filterMap,
			function (action) {
				if (!action.$) {
					var params = action.a;
					return $elm$core$Maybe$Just(params);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			policy.aS));
};
var $author$project$Page$PolicyDetails$Model$maybeInitAmendModal = F3(
	function (i18n, policy, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				$author$project$Common$Policy$mapActionAmendInterruption(
					A3($author$project$Page$PolicyDetails$Model$initAmendModal, i18n, policy, model)),
				$author$project$Common$Policy$pickAmendTerminationAction(policy)));
	});
var $author$project$Referer$isPaymentPage = function (_v0) {
	return true;
};
var $author$project$Translations$paymentAfterPurchaseText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Thank you! The policy has been successfully purchased';
	} else {
		return 'Gracias! La contratación de la póliza se ha completado.';
	}
};
var $author$project$Page$PolicyDetails$showToastIfRefererIsPaymentPage = F3(
	function (i18n, model, referer) {
		if ($author$project$Referer$isPaymentPage(referer)) {
			var _v0 = A2(
				$author$project$Pyxis$Components$Toasts$addNewToast,
				A2(
					$author$project$Pyxis$Components$Toasts$withToastText,
					$author$project$Translations$paymentAfterPurchaseText(i18n),
					$author$project$Pyxis$Components$Toasts$successToast),
				model.s);
			var newToastModel = _v0.a;
			var newCmd = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{s: newToastModel}),
				$author$project$Page$PolicyDetails$Effect$WithCmd(newCmd));
		} else {
			return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
		}
	});
var $author$project$Page$PolicyDetails$maybeUpdateModelIfRefererIsPaymentPage = F2(
	function (i18n, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Page$PolicyDetails$showToastIfRefererIsPaymentPage, i18n, model),
				model.o2));
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$openModal = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$open(model.cq);
	var visibilityModel = _v1.a;
	var visibilityCmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{cq: visibilityModel}),
		visibilityCmd);
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$setActualTime = F2(
	function (now, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				hy: $elm$core$Maybe$Just(now)
			});
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Data$CustomerTerminationInput = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$PolicyDetails$InterruptionModal$Data$initCustomerTermination = F2(
	function (now, interruptionAt) {
		return $author$project$Page$PolicyDetails$InterruptionModal$Data$CustomerTerminationInput(
			{mN: $elm$core$Maybe$Nothing, bD: 3, a1: interruptionAt, kC: $elm$core$Maybe$Nothing, o6: now});
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Data$PrimaTerminationInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$PolicyDetails$InterruptionModal$Data$initPrimaTermination = F2(
	function (now, interruptionAt) {
		return $author$project$Page$PolicyDetails$InterruptionModal$Data$PrimaTerminationInput(
			{mN: $elm$core$Maybe$Nothing, bD: 3, a1: interruptionAt, kC: $elm$core$Maybe$Nothing, o6: now});
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Data$WithdrawalInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$PolicyDetails$InterruptionModal$Data$initWithdrawal = function (now) {
	return $author$project$Page$PolicyDetails$InterruptionModal$Data$WithdrawalInput(
		{mN: $elm$core$Maybe$Nothing, bD: 3, kC: $elm$core$Maybe$Nothing, o6: now});
};
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$date$Date$Months = 1;
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.pG - 1)) + ($justinmimbs$date$Date$monthToNumber(date.nM) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.mJ,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $author$project$Common$Locale$maxPosix = F2(
	function (l, r) {
		var rMillis = $elm$time$Time$posixToMillis(r);
		var lMillis = $elm$time$Time$posixToMillis(l);
		return $elm$time$Time$millisToPosix(
			A2($elm$core$Basics$max, lMillis, rMillis));
	});
var $author$project$Common$Policy$earliestCustomerTerminationDate = function (_v0) {
	var policy = _v0;
	var startAt = $author$project$Common$Locale$midnightAtCustomerDate(policy.lL);
	return A2(
		$elm$core$Maybe$withDefault,
		startAt,
		A2(
			$elm$core$Maybe$map,
			$author$project$Common$Locale$maxPosix(startAt),
			A2(
				$elm$core$Maybe$map,
				$author$project$Common$Locale$midnightAtCustomerDate,
				A2(
					$elm$core$Maybe$map,
					A2($justinmimbs$date$Date$add, 3, 1),
					policy.c0))));
};
var $author$project$Common$Policy$earliestPrimaTerminationDate = function (_v0) {
	var policy = _v0;
	return $author$project$Common$Locale$midnightAtCustomerDate(policy.lL);
};
var $author$project$Common$Locale$nextCustomerMidnight = function (now) {
	return $author$project$Common$Locale$midnightAtCustomerDate(
		A3(
			$justinmimbs$date$Date$add,
			3,
			1,
			$author$project$Common$Locale$posixToCustomerDate(now)));
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$initialInterruptionAt = F3(
	function (time, policy, kind) {
		switch (kind) {
			case 0:
				return time;
			case 1:
				return (_Utils_cmp(
					$elm$time$Time$posixToMillis(time),
					$elm$time$Time$posixToMillis(
						$author$project$Common$Policy$earliestCustomerTerminationDate(policy))) < 0) ? $author$project$Common$Policy$earliestCustomerTerminationDate(policy) : $author$project$Common$Locale$nextCustomerMidnight(time);
			default:
				return (_Utils_cmp(
					$elm$time$Time$posixToMillis(time),
					$elm$time$Time$posixToMillis(
						$author$project$Common$Policy$earliestPrimaTerminationDate(policy))) < 0) ? $author$project$Common$Policy$earliestPrimaTerminationDate(policy) : $author$project$Common$Locale$nextCustomerMidnight(time);
		}
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$kindDataFromInterruptionKind = F3(
	function (time, policy, kind) {
		switch (kind) {
			case 0:
				return $author$project$Page$PolicyDetails$InterruptionModal$Data$initWithdrawal(time);
			case 1:
				return A2(
					$author$project$Page$PolicyDetails$InterruptionModal$Data$initCustomerTermination,
					time,
					A3($author$project$Page$PolicyDetails$InterruptionModal$Model$initialInterruptionAt, time, policy, kind));
			default:
				return A2(
					$author$project$Page$PolicyDetails$InterruptionModal$Data$initPrimaTermination,
					time,
					A3($author$project$Page$PolicyDetails$InterruptionModal$Model$initialInterruptionAt, time, policy, kind));
		}
	});
var $author$project$Page$PolicyDetails$TerminationReasonList$initCustomerCancellationReasonOptionList = function (i18n) {
	return A2(
		$elm$core$List$map,
		$author$project$Pyxis$Components$Field$Autocomplete$option,
		A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.eR;
			},
			_List_fromArray(
				[
					{
					eR: $author$project$Translations$interruptionCompetitorOffer(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(0)
				},
					{
					eR: $author$project$Translations$interruptionCoverageChange(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(12)
				},
					{
					eR: $author$project$Translations$interruptionDeceasedPolicyHolder(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(11)
				},
					{
					eR: $author$project$Translations$interruptionDissatisfactionService(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(13)
				},
					{
					eR: $author$project$Translations$interruptionDoesNotKnow(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(5)
				},
					{
					eR: $author$project$Translations$interruptionIncorrectDataOther(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(9)
				},
					{
					eR: $author$project$Translations$interruptionIncorrectEffectiveDate(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(7)
				},
					{
					eR: $author$project$Translations$interruptionIncorrectPersonalData(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(8)
				},
					{
					eR: $author$project$Translations$interruptionMovingToAnotherCountry(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(15)
				},
					{
					eR: $author$project$Translations$interruptionNoInsuranceWanted(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(4)
				},
					{
					eR: $author$project$Translations$interruptionOther(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(19)
				},
					{
					eR: $author$project$Translations$interruptionPaymentMethodOrDate(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(10)
				},
					{
					eR: $author$project$Translations$interruptionUnderwritingRules(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(14)
				},
					{
					eR: $author$project$Translations$interruptionVehicleDeregistration(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(3)
				},
					{
					eR: $author$project$Translations$interruptionVehicleNotPurchased(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(2)
				},
					{
					eR: $author$project$Translations$interruptionVehicleSold(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(1)
				},
					{
					eR: $author$project$Translations$interruptionWantsGreenCard(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(6)
				},
					{
					eR: $author$project$Translations$interruptionProductService(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(16)
				},
					{
					eR: $author$project$Translations$interruptionPolicyHolderChange(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(17)
				},
					{
					eR: $author$project$Translations$interruptionSwitchToGreatLakes(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(18)
				}
				])));
};
var $author$project$Page$PolicyDetails$TerminationReasonList$updateAutoCompleteModel = F2(
	function (autoCompleteModel, optionList) {
		return A2(
			$author$project$Pyxis$Components$Field$Autocomplete$setOptions,
			$krisajenkins$remotedata$RemoteData$Success(optionList),
			autoCompleteModel);
	});
var $author$project$Page$PolicyDetails$TerminationReasonList$updateModelWithCustomerTerminationReasonList = F2(
	function (i18n, autoCompleteModel) {
		return A2(
			$author$project$Page$PolicyDetails$TerminationReasonList$updateAutoCompleteModel,
			autoCompleteModel,
			$author$project$Page$PolicyDetails$TerminationReasonList$initCustomerCancellationReasonOptionList(i18n));
	});
var $author$project$Page$PolicyDetails$TerminationReasonList$initPrimaTerminateReasonOptionList = function (i18n) {
	return A2(
		$elm$core$List$map,
		$author$project$Pyxis$Components$Field$Autocomplete$option,
		A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.eR;
			},
			_List_fromArray(
				[
					{
					eR: $author$project$Translations$interruptionInexactDeclarationSinco(i18n),
					pB: $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString(0)
				},
					{
					eR: $author$project$Translations$interruptionFraud(i18n),
					pB: $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString(1)
				},
					{
					eR: $author$project$Translations$interruptionChargeback(i18n),
					pB: $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString(2)
				},
					{
					eR: $author$project$Translations$interruptionInexactDeclarationDni(i18n),
					pB: $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString(3)
				},
					{
					eR: $author$project$Translations$interruptionRiskAggravation(i18n),
					pB: $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString(4)
				},
					{
					eR: $author$project$Translations$interruptionPhotoVericiationNotProvided(i18n),
					pB: $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString(5)
				}
				])));
};
var $author$project$Page$PolicyDetails$TerminationReasonList$updateModelWithPrimaTerminationReasonList = F2(
	function (i18n, autoCompleteModel) {
		return A2(
			$author$project$Page$PolicyDetails$TerminationReasonList$updateAutoCompleteModel,
			autoCompleteModel,
			$author$project$Page$PolicyDetails$TerminationReasonList$initPrimaTerminateReasonOptionList(i18n));
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$updateReasonInputOptionsWhenKindIsSet = function (kind) {
	switch (kind) {
		case 0:
			return $author$project$Page$PolicyDetails$TerminationReasonList$updateModelWithCustomerTerminationReasonList;
		case 1:
			return $author$project$Page$PolicyDetails$TerminationReasonList$updateModelWithCustomerTerminationReasonList;
		default:
			return $author$project$Page$PolicyDetails$TerminationReasonList$updateModelWithPrimaTerminationReasonList;
	}
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$setInterruptionKind = F3(
	function (i18n, kind, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				at: A4(
					$elm$core$Maybe$map3,
					$author$project$Page$PolicyDetails$InterruptionModal$Model$kindDataFromInterruptionKind,
					model.hy,
					model.k,
					$elm$core$Maybe$Just(kind)),
				aN: A3($author$project$Page$PolicyDetails$InterruptionModal$Model$updateReasonInputOptionsWhenKindIsSet, kind, i18n, model.aN)
			});
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$setPolicy = F2(
	function (policy, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				k: $elm$core$Maybe$Just(policy)
			});
	});
var $author$project$Page$PolicyDetails$openAndInitInterruptionModal = F5(
	function (i18n, kind, model, policy, time) {
		var _v0 = $author$project$Page$PolicyDetails$InterruptionModal$Model$openModal(
			A3(
				$author$project$Page$PolicyDetails$InterruptionModal$Model$setInterruptionKind,
				i18n,
				kind,
				A2(
					$author$project$Page$PolicyDetails$InterruptionModal$Model$setPolicy,
					policy,
					A2($author$project$Page$PolicyDetails$InterruptionModal$Model$setActualTime, time, model.p))));
		var interruptionModelModal = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{p: interruptionModelModal}),
			$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
	});
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$CompetitorOffer = 0;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$CoverageChange = 12;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$DeceasedPolicyHolder = 11;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$DissatisfactionService = 13;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$DoesNotKnow = 5;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$IncorrectDataOther = 9;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$IncorrectEffectiveDate = 7;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$IncorrectPersonalData = 8;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$MovingToAnotherCountry = 15;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$NoInsuranceWanted = 4;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$Other = 19;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$PaymentMethodOrDate = 10;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$PolicyHolderChange = 17;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$PriceIncrease = 18;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$ProductService = 16;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$UnderwritingRules = 14;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$VehicleDeregistration = 3;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$VehicleNotPurchased = 2;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$VehicleSold = 1;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$WantsGreenCard = 6;
var $author$project$Translations$interruptionPriceIncrease = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Price increased';
	} else {
		return 'Aumento de precio';
	}
};
var $author$project$Page$PolicyDetails$TerminationReasonList$initCustomerDeclineRenewalOptionList = function (i18n) {
	return A2(
		$elm$core$List$map,
		$author$project$Pyxis$Components$Field$Autocomplete$option,
		A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.eR;
			},
			_List_fromArray(
				[
					{
					eR: $author$project$Translations$interruptionCompetitorOffer(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(0)
				},
					{
					eR: $author$project$Translations$interruptionCoverageChange(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(12)
				},
					{
					eR: $author$project$Translations$interruptionDeceasedPolicyHolder(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(11)
				},
					{
					eR: $author$project$Translations$interruptionDissatisfactionService(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(13)
				},
					{
					eR: $author$project$Translations$interruptionDoesNotKnow(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(5)
				},
					{
					eR: $author$project$Translations$interruptionIncorrectDataOther(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(9)
				},
					{
					eR: $author$project$Translations$interruptionIncorrectEffectiveDate(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(7)
				},
					{
					eR: $author$project$Translations$interruptionIncorrectPersonalData(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(8)
				},
					{
					eR: $author$project$Translations$interruptionMovingToAnotherCountry(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(15)
				},
					{
					eR: $author$project$Translations$interruptionNoInsuranceWanted(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(4)
				},
					{
					eR: $author$project$Translations$interruptionOther(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(19)
				},
					{
					eR: $author$project$Translations$interruptionPaymentMethodOrDate(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(10)
				},
					{
					eR: $author$project$Translations$interruptionUnderwritingRules(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(14)
				},
					{
					eR: $author$project$Translations$interruptionVehicleDeregistration(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(3)
				},
					{
					eR: $author$project$Translations$interruptionVehicleNotPurchased(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(2)
				},
					{
					eR: $author$project$Translations$interruptionVehicleSold(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(1)
				},
					{
					eR: $author$project$Translations$interruptionWantsGreenCard(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(6)
				},
					{
					eR: $author$project$Translations$interruptionProductService(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(16)
				},
					{
					eR: $author$project$Translations$interruptionPolicyHolderChange(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(17)
				},
					{
					eR: $author$project$Translations$interruptionPriceIncrease(i18n),
					pB: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(18)
				}
				])));
};
var $author$project$Page$PolicyDetails$TerminationReasonList$updateModelWithCustomerDeclineRenewalList = F2(
	function (i18n, autoCompleteModel) {
		return A2(
			$author$project$Page$PolicyDetails$TerminationReasonList$updateAutoCompleteModel,
			autoCompleteModel,
			$author$project$Page$PolicyDetails$TerminationReasonList$initCustomerDeclineRenewalOptionList(i18n));
	});
var $author$project$Page$PolicyDetails$RenewalCancellationModal$openModal = F2(
	function (i18n, _v0) {
		var model = _v0;
		var _v1 = $author$project$Pyxis$Components$Modal$open(model.cq);
		var visibilityModel = _v1.a;
		var visibilityCmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					aN: A2($author$project$Page$PolicyDetails$TerminationReasonList$updateModelWithCustomerDeclineRenewalList, i18n, model.aN),
					cq: visibilityModel
				}),
			visibilityCmd);
	});
var $author$project$Page$PolicyDetails$RenewalCancellationModal$setPolicy = F2(
	function (policy, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				k: $elm$core$Maybe$Just(policy)
			});
	});
var $author$project$Page$PolicyDetails$openAndInitRenewalCancellationModal = F3(
	function (i18n, model, policy) {
		var _v0 = A2(
			$author$project$Page$PolicyDetails$RenewalCancellationModal$openModal,
			i18n,
			A2($author$project$Page$PolicyDetails$RenewalCancellationModal$setPolicy, policy, model.am));
		var renewalCancellationModal = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{am: renewalCancellationModal}),
			$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$openModal = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$open(model.cq);
	var visibilityModel = _v1.a;
	var visibilityCmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{cq: visibilityModel}),
		visibilityCmd);
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$openModal = A2($elm$core$Basics$composeL, $author$project$Page$PolicyDetails$ChangeEmailModal$update, $author$project$Page$PolicyDetails$ChangeEmailModal$Open);
var $author$project$Page$PolicyDetails$RefundIssuingModal$openModal = F2(
	function (refund, _v0) {
		var model = _v0;
		var _v1 = $author$project$Pyxis$Components$Modal$open(model.cq);
		var newVisibility = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					o4: $elm$core$Maybe$Just(refund),
					cq: newVisibility
				}),
			cmd);
	});
var $author$project$Page$PolicyDetails$SendEmailModal$openModal = F3(
	function (policyId, emailRecipient, _v0) {
		var model = _v0;
		var _v1 = $author$project$Pyxis$Components$Modal$open(model.cq);
		var newVisibility = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					aW: $author$project$Pyxis$Components$Field$CheckboxGroup$resetValue(model.aW),
					gt: emailRecipient,
					cY: false,
					oQ: policyId,
					cq: newVisibility
				}),
			cmd);
	});
var $author$project$Page$PolicyDetails$openSendEmailModal = F2(
	function (newModalModel, model) {
		return _Utils_update(
			model,
			{ce: newModalModel});
	});
var $author$project$Common$Policy$pickCustomerFacingId = function (_v0) {
	var policy = _v0;
	return policy.mI;
};
var $author$project$Common$Person$pickEmail = function (person) {
	switch (person.$) {
		case 1:
			return $elm$core$Maybe$Nothing;
		case 0:
			return $elm$core$Maybe$Nothing;
		case 2:
			var email = person.c.eq;
			return $elm$core$Maybe$Just(email);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Common$Policy$pickPolicyHolder = function (_v0) {
	var policy = _v0;
	return policy.ib;
};
var $author$project$Page$PolicyDetails$Model$pickEmailRecipient = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.k;
	},
	A2(
		$elm$core$Basics$composeR,
		$krisajenkins$remotedata$RemoteData$toMaybe,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($author$project$Common$Policy$pickPolicyHolder),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($author$project$Common$Person$pickEmail),
				$elm_community$maybe_extra$Maybe$Extra$join))));
var $author$project$Fixtures$epoch = $elm$time$Time$millisToPosix(0);
var $author$project$Page$PolicyDetails$Model$pickIssueRefundReleaseDate = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.ns;
	},
	$elm$core$Maybe$withDefault($author$project$Fixtures$epoch));
var $author$project$Page$PolicyDetails$Model$pickPolicyId = function (model) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Common$Policy$pickId,
		$krisajenkins$remotedata$RemoteData$toMaybe(model.k));
};
var $author$project$Page$PolicyDetails$Model$pickRefund = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.o4;
	},
	$krisajenkins$remotedata$RemoteData$toMaybe);
var $author$project$Common$Refund$pickStatus = function (_v0) {
	var status = _v0.b;
	return status;
};
var $author$project$Translations$policyAmendInterruptionSuccessMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Interruption has been correctly amended';
	} else {
		return 'La interrupción se ha modificado correctamente';
	}
};
var $author$project$Translations$policyCreateRefundSuccessMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Refund has been correctly created.';
	} else {
		return 'Reembolso creado correctamente.';
	}
};
var $author$project$Translations$policyGeneralErrorMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'An error has occurred, please contact the development team.';
	} else {
		return 'Se ha detectado un error, contacta con el equipo de desarrollo.';
	}
};
var $author$project$Translations$policyInterruptionSuccessMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy has been correctly interrupted.';
	} else {
		return 'Póliza interrumpida correctamente.';
	}
};
var $author$project$Translations$policyIssueRefundErrorMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The refund could not be processed. Please wait a few minutes and refresh the page to try again.';
	} else {
		return 'No se pudo procesar el reembolso. Espera unos minutos y actualiza la página para intentarlo nuevamente.';
	}
};
var $author$project$Translations$policyRenewalCancellationErrorMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'We were unable to cancel the renewal. Please refresh the page to try again.';
	} else {
		return 'No pudimos cancelar la renovación. Actualiza la página para intentarlo nuevamente.';
	}
};
var $author$project$Translations$policyRenewalCancellationSuccessMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Renewal has been correctly cancelled.';
	} else {
		return 'La renovación se ha cancelado correctamente.';
	}
};
var $author$project$Translations$policySendEmailFailureMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'It was not possible to send the email. Please refresh the page to try again.';
	} else {
		return 'No ha sido posible enviar el email. Actualiza la página para intentarlo nuevamente.';
	}
};
var $author$project$Translations$policySendEmailSuccessMessage = F2(
	function (email, _v0) {
		var lang = _v0;
		if (!lang) {
			return 'The email has been sent to ' + email;
		} else {
			return 'El email se ha enviado a ' + email;
		}
	});
var $author$project$Page$PolicyDetails$Effect$AmendCompanyInterruption = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Page$PolicyDetails$Effect$AmendCustomerInterruption = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Page$PolicyDetails$amendInterruptionEffect = F6(
	function (description, interruptionAt, amendReason, policyId, requestedAt, hasInterruptionDateChanged) {
		var createCustomerAmendEffect = function (customerReason) {
			return A2(
				$author$project$Page$PolicyDetails$Effect$AmendCustomerInterruption,
				{
					mN: $elm$core$Maybe$Just(description),
					kg: policyId,
					a1: interruptionAt,
					im: customerReason,
					h: requestedAt
				},
				hasInterruptionDateChanged);
		};
		var createCompanyAmendEffect = function (primaReason) {
			return A2(
				$author$project$Page$PolicyDetails$Effect$AmendCompanyInterruption,
				{
					mN: $elm$core$Maybe$Just(description),
					kg: policyId,
					a1: interruptionAt,
					im: primaReason,
					h: requestedAt
				},
				hasInterruptionDateChanged);
		};
		var maybeCreateAmendWithReasonEffect = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Page$PolicyDetails$Effect$None,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$orElse,
				A2(
					$elm$core$Maybe$map,
					createCompanyAmendEffect,
					$author$project$Common$AmendReason$toPrimaReason(amendReason)),
				A2(
					$elm$core$Maybe$map,
					createCustomerAmendEffect,
					$author$project$Common$AmendReason$toCustomerReason(amendReason))));
		return maybeCreateAmendWithReasonEffect;
	});
var $author$project$Page$PolicyDetails$requestAmendInterruption = F5(
	function (desctiption, interruptionAt, reason, hasInterruptionDateChanged, _v0) {
		var model = _v0.a;
		var effect = _v0.b;
		var updateModelAndEffect = F3(
			function (amendReason, policyId, requestedAt) {
				return _Utils_Tuple2(
					model,
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								effect,
								A6($author$project$Page$PolicyDetails$amendInterruptionEffect, desctiption, interruptionAt, amendReason, policyId, requestedAt, hasInterruptionDateChanged)
							])));
			});
		var maybeRequestedAt = model.gg;
		var maybePolicyId = A2(
			$elm$core$Maybe$map,
			$author$project$Common$Policy$pickId,
			$krisajenkins$remotedata$RemoteData$toMaybe(model.k));
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(model, effect),
			A3(
				$elm$core$Maybe$map2,
				updateModelAndEffect(reason),
				maybePolicyId,
				maybeRequestedAt));
	});
var $author$project$Page$PolicyDetails$resetSendEmailResult = function (model) {
	return _Utils_update(
		model,
		{fl: $krisajenkins$remotedata$RemoteData$NotAsked});
};
var $author$project$Page$PolicyDetails$Model$pickPricingAction = function (response) {
	return A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		$author$project$Common$PricingAction$unknown,
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($author$project$Common$PricingAction$new),
				$elm$core$Maybe$withDefault($author$project$Common$PricingAction$default)),
			response));
};
var $author$project$Page$PolicyDetails$Model$setPricingActionToClaimHistoryResponse = F2(
	function (model, action) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			$author$project$Common$ClaimHistory$setPricingActionToClaimHistoryOrDefault(action),
			model.cF);
	});
var $author$project$Page$PolicyDetails$Model$setClaimHistoryPricingActionResult = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{
				cF: A2(
					$author$project$Page$PolicyDetails$Model$setPricingActionToClaimHistoryResponse,
					model,
					$author$project$Page$PolicyDetails$Model$pickPricingAction(result))
			});
	});
var $author$project$Common$Policy$pickClaimsDeclaredWithFault = function (_v0) {
	var policy = _v0;
	return policy.f5;
};
var $author$project$Page$PolicyDetails$Model$pickClaimsDeclaredWithFaultByCustomer = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.k;
	},
	A2(
		$elm$core$Basics$composeR,
		$krisajenkins$remotedata$RemoteData$toMaybe,
		A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Common$Count$default, $author$project$Common$Policy$pickClaimsDeclaredWithFault)));
var $author$project$Page$PolicyDetails$Model$setClaimDeclaredToClaimHistory = function (model) {
	return $author$project$Common$ClaimHistory$setClaimDeclaredWithFaultByCustomer(
		$author$project$Page$PolicyDetails$Model$pickClaimsDeclaredWithFaultByCustomer(model));
};
var $author$project$Page$PolicyDetails$Model$setClaimsDeclaredToResponse = function (model) {
	return $krisajenkins$remotedata$RemoteData$map(
		$elm$core$Maybe$map(
			$author$project$Page$PolicyDetails$Model$setClaimDeclaredToClaimHistory(model)));
};
var $author$project$Page$PolicyDetails$Model$setClaimHistoryResult = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{
				cF: A2($author$project$Page$PolicyDetails$Model$setClaimsDeclaredToResponse, model, result)
			});
	});
var $author$project$Page$PolicyDetails$Model$setCustomerId = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{gi: result});
	});
var $author$project$Page$PolicyDetails$Model$setPaymentMethod = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{lc: result});
	});
var $author$project$Page$PolicyDetails$Model$setPolicyResult = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{k: result});
	});
var $author$project$Page$PolicyDetails$showRefundFailure = F3(
	function (i18n, model, result) {
		var _v0 = A2(
			$author$project$Pyxis$Components$Toasts$addNewToast,
			A2(
				$author$project$Pyxis$Components$Toasts$withToastText,
				$author$project$Translations$policyIssueRefundErrorMessage(i18n),
				$author$project$Pyxis$Components$Toasts$errorToast),
			model.s);
		var newToastsState = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Page$PolicyDetails$Model$setRefundResult,
				result,
				_Utils_update(
					model,
					{s: newToastsState})),
			$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
	});
var $author$project$Common$ExpectedRefund$pickPrice = function (expectedRefund) {
	if (!expectedRefund.$) {
		var price = expectedRefund.a;
		return price;
	} else {
		var price = expectedRefund.a;
		return price;
	}
};
var $author$project$Common$Refund$pickPrice = function (_v0) {
	var refundData = _v0.a;
	return $author$project$Common$ExpectedRefund$pickPrice(refundData.mY);
};
var $author$project$Translations$policyIssueRefundSuccessMessage = F2(
	function (refundAmount, _v0) {
		var lang = _v0;
		if (!lang) {
			return 'The refund was issued successfully. The customer will receive ' + (refundAmount + '.');
		} else {
			return 'El reembolso ha sido efectuado correctamente. El cliente recibirá ' + (refundAmount + '.');
		}
	});
var $author$project$Common$Price$pickSign = function (_v0) {
	return '€';
};
var $cuducos$elm_format_number$FormatNumber$Locales$Exact = function (a) {
	return {$: 2, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Min = function (a) {
	return {$: 0, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Western = 0;
var $cuducos$elm_format_number$FormatNumber$Locales$base = {
	mK: '.',
	mL: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	hs: '−',
	ht: '',
	lh: '',
	li: '',
	fr: 0,
	aQ: '',
	l6: '',
	l7: ''
};
var $author$project$Translations$currentLanguage = function (_v0) {
	var lang = _v0;
	return lang;
};
var $author$project$Common$Price$decimalSeparator = function (i18n) {
	var _v0 = $author$project$Translations$currentLanguage(i18n);
	if (!_v0) {
		return '.';
	} else {
		return ',';
	}
};
var $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {mL: decimals, km: integers, k8: original, e9: prefix, fp: suffix};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$Negative = 2;
var $cuducos$elm_format_number$FormatNumber$Parser$Positive = 0;
var $cuducos$elm_format_number$FormatNumber$Parser$Zero = 1;
var $cuducos$elm_format_number$FormatNumber$Parser$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.km,
				$elm$core$List$singleton(formatted.mL))));
	return onlyZeros ? 1 : ((formatted.k8 < 0) ? 2 : 0);
};
var $elm$core$String$filter = _String_filter;
var $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit = F2(
	function (desiredLength, value) {
		var length = $elm$core$String$length(value);
		var missing = (_Utils_cmp(length, desiredLength) < 0) ? $elm$core$Basics$abs(desiredLength - length) : 0;
		return _Utils_ap(
			value,
			A2($elm$core$String$repeat, missing, '0'));
	});
var $cuducos$elm_format_number$FormatNumber$Parser$removeZeros = function (decimals) {
	return (A2($elm$core$String$right, 1, decimals) !== '0') ? decimals : $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(
		A2($elm$core$String$dropRight, 1, decimals));
};
var $cuducos$elm_format_number$FormatNumber$Parser$getDecimals = F2(
	function (locale, digits) {
		var _v0 = locale.mL;
		switch (_v0.$) {
			case 1:
				return $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(digits);
			case 2:
				return digits;
			default:
				var min = _v0.a;
				return A2($cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit, min, digits);
		}
	});
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $elm$core$Char$fromCode = _Char_fromCode;
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitInParts = F2(
	function (locale, value) {
		var toString = function () {
			var _v1 = locale.mL;
			switch (_v1.$) {
				case 1:
					var max = _v1.a;
					return $myrho$elm_round$Round$round(max);
				case 0:
					return $elm$core$String$fromFloat;
				default:
					var exact = _v1.a;
					return $myrho$elm_round$Round$round(exact);
			}
		}();
		var asList = A2(
			$elm$core$String$split,
			'.',
			toString(value));
		var decimals = function () {
			var _v0 = $elm$core$List$tail(asList);
			if (!_v0.$) {
				var values = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(values));
			} else {
				return '';
			}
		}();
		var integers = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(asList));
		return _Utils_Tuple2(integers, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian = function (integers) {
	var thousand = ($elm$core$String$length(integers) > 3) ? A2($elm$core$String$right, 3, integers) : integers;
	var reversedSplitHundreds = function (value) {
		return ($elm$core$String$length(value) > 2) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 2, value),
			reversedSplitHundreds(
				A2($elm$core$String$dropRight, 2, value))) : ((!$elm$core$String$length(value)) ? _List_Nil : _List_fromArray(
			[value]));
	};
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$cons,
			thousand,
			reversedSplitHundreds(
				A2($elm$core$String$dropRight, 3, integers))));
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitIntegers = F2(
	function (system, integers) {
		if (!system) {
			return $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, integers));
		} else {
			return $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, integers));
		}
	});
var $cuducos$elm_format_number$FormatNumber$Parser$parse = F2(
	function (locale, original) {
		var parts = A2($cuducos$elm_format_number$FormatNumber$Parser$splitInParts, locale, original);
		var integers = A2(
			$cuducos$elm_format_number$FormatNumber$Parser$splitIntegers,
			locale.fr,
			A2($elm$core$String$filter, $elm$core$Char$isDigit, parts.a));
		var decimals = A2($cuducos$elm_format_number$FormatNumber$Parser$getDecimals, locale, parts.b);
		var partial = A5($cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $cuducos$elm_format_number$FormatNumber$Parser$classify(partial);
		switch (_v0) {
			case 2:
				return _Utils_update(
					partial,
					{e9: locale.hs, fp: locale.ht});
			case 0:
				return _Utils_update(
					partial,
					{e9: locale.lh, fp: locale.li});
			default:
				return _Utils_update(
					partial,
					{e9: locale.l6, fp: locale.l7});
		}
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals = F2(
	function (locale, decimals) {
		return (decimals === '') ? '' : _Utils_ap(locale.mK, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy = F2(
	function (locale, formatted) {
		var stringfyDecimals = $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals(locale);
		var integers = A2($elm$core$String$join, locale.aQ, formatted.km);
		var decimals = stringfyDecimals(formatted.mL);
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.e9, integers, decimals, formatted.fp]));
	});
var $cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A2(
			$cuducos$elm_format_number$FormatNumber$Stringfy$stringfy,
			locale,
			A2($cuducos$elm_format_number$FormatNumber$Parser$parse, locale, number_));
	});
var $prikhi$decimal$Decimal$toFloat = function (d) {
	var _v0 = $elm$core$String$toFloat(
		$prikhi$decimal$Decimal$toString(d));
	if (!_v0.$) {
		var a = _v0.a;
		return a;
	} else {
		return 42.0;
	}
};
var $author$project$Common$Price$toAmountString = F2(
	function (i18n, amount) {
		var base = $cuducos$elm_format_number$FormatNumber$Locales$base;
		return A2(
			$cuducos$elm_format_number$FormatNumber$format,
			_Utils_update(
				base,
				{
					mK: $author$project$Common$Price$decimalSeparator(i18n),
					mL: $cuducos$elm_format_number$FormatNumber$Locales$Exact(2)
				}),
			$prikhi$decimal$Decimal$toFloat(amount));
	});
var $author$project$Common$Price$toStringSignFirst = F2(
	function (i18n, _v0) {
		var amount = _v0.a;
		var currency = _v0.b;
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					$author$project$Common$Price$pickSign(currency),
					A2($author$project$Common$Price$toAmountString, i18n, amount)
				]));
	});
var $author$project$Page$PolicyDetails$showRefundSuccess = F4(
	function (i18n, model, refund, result) {
		var successMessage = A3(
			$primait$prima_elm_extra$PrimaFunction$flip,
			$author$project$Translations$policyIssueRefundSuccessMessage,
			i18n,
			A2(
				$author$project$Common$Price$toStringSignFirst,
				i18n,
				$author$project$Common$Refund$pickPrice(refund)));
		var _v0 = A2(
			$author$project$Pyxis$Components$Toasts$addNewToast,
			A2($author$project$Pyxis$Components$Toasts$withToastText, successMessage, $author$project$Pyxis$Components$Toasts$successToast),
			model.s);
		var newToastModel = _v0.a;
		var toastCmd = _v0.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Page$PolicyDetails$Model$setRefundResult,
				result,
				_Utils_update(
					model,
					{s: newToastModel})),
			$author$project$Page$PolicyDetails$Effect$Effects(
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$author$project$Page$PolicyDetails$Effect$None,
						A2(
							$elm$core$Maybe$map,
							$author$project$Page$PolicyDetails$Effect$FetchPolicy,
							$author$project$Page$PolicyDetails$Model$pickPolicyId(model))),
						$author$project$Page$PolicyDetails$Effect$WithCmd(toastCmd)
					])));
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$getValue = function (_v0) {
	var modelData = _v0;
	return modelData.aA;
};
var $author$project$Page$PolicyDetails$SendEmailModal$updateCheckboxGroup = F2(
	function (checkboxMsg, _v0) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$CheckboxGroup$update, checkboxMsg, model.aW);
		var newCheckboxModel = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{aW: newCheckboxModel}),
			cmd);
	});
var $author$project$Page$PolicyDetails$SendEmailModal$update = F2(
	function (modalMsg, model) {
		var innerModel = model;
		switch (modalMsg.$) {
			case 0:
				var checkboxMsg = modalMsg.a;
				return A2($author$project$Page$PolicyDetails$SendEmailModal$updateCheckboxGroup, checkboxMsg, model);
			case 1:
				return $author$project$Page$PolicyDetails$SendEmailModal$closeModal(model);
			case 2:
				return $elm$core$List$isEmpty(
					$author$project$Pyxis$Components$Field$CheckboxGroup$getValue(innerModel.aW)) ? _Utils_Tuple2(
					_Utils_update(
						innerModel,
						{cY: true}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					model,
					$author$project$Pyxis$Commons$Commands$dispatch(innerModel.jB));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						innerModel,
						{cY: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$PolicyDetails$updateAmendModalState = F2(
	function (model, _v0) {
		var amendInterruptionModel = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					U: $elm$core$Maybe$Just(amendInterruptionModel)
				}),
			$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$updateExpectedRefundAmount = F2(
	function (amount, _v0) {
		var model = _v0;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{mY: amount}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$updateExpectedRefundAmount = F2(
	function (_v0, amount) {
		var model = _v0;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{mY: amount}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pyxis$Components$Field$DateInput$mapFieldStatus = F2(
	function (mapper, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				ev: mapper(model.ev)
			});
	});
var $author$project$Pyxis$Components$Field$DateInput$update = F2(
	function (msg, model) {
		var modelData = model;
		switch (msg.$) {
			case 2:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hH)
						]),
					A2(
						$author$project$Pyxis$Components$Field$DateInput$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(true),
						model));
			case 1:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hQ)
						]),
					A2(
						$author$project$Pyxis$Components$Field$DateInput$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(false),
						model));
			default:
				var value = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hS)
						]),
					A2(
						$author$project$Pyxis$Components$Field$DateInput$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsDirty(true),
						_Utils_update(
							modelData,
							{pB: value})));
		}
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$updateInterruptionDate = F2(
	function (msg, _v0) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$DateInput$update, msg, model.aI);
		var dateInputModel = _v1.a;
		var dateInputCmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{aI: dateInputModel}),
			dateInputCmd);
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Data$setInterruptionDate = F2(
	function (dateInput, data) {
		var maybeDate = $elm$core$Result$toMaybe(
			$justinmimbs$date$Date$fromIsoString(dateInput));
		if (!maybeDate.$) {
			var selectedDate = maybeDate.a;
			var interruptionAt = $author$project$Common$Locale$midnightAtCustomerDate(selectedDate);
			switch (data.$) {
				case 1:
					var customerTerminateData = data.a;
					return $author$project$Page$PolicyDetails$InterruptionModal$Data$CustomerTerminationInput(
						_Utils_update(
							customerTerminateData,
							{a1: interruptionAt}));
				case 2:
					var primaTerminateData = data.a;
					return $author$project$Page$PolicyDetails$InterruptionModal$Data$PrimaTerminationInput(
						_Utils_update(
							primaTerminateData,
							{a1: interruptionAt}));
				default:
					return data;
			}
		} else {
			return data;
		}
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$updateInterruptionDateInput = F2(
	function (_v0, inputMsg) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$DateInput$update, inputMsg, model.aI);
		var newInterruptionDateModel = _v1.a;
		var selectCmd = _v1.b;
		var date = $author$project$Pyxis$Components$Field$DateInput$getValue(newInterruptionDateModel);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					aI: newInterruptionDateModel,
					at: A2(
						$elm$core$Maybe$map,
						$author$project$Page$PolicyDetails$InterruptionModal$Data$setInterruptionDate(date),
						model.at)
				}),
			selectCmd);
	});
var $author$project$Pyxis$Components$Field$Textarea$mapFieldStatus = F2(
	function (mapper, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				ev: mapper(model.ev)
			});
	});
var $author$project$Pyxis$Components$Field$Textarea$update = F2(
	function (msg, model) {
		var modelData = model;
		switch (msg.$) {
			case 2:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hH)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Textarea$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(true),
						model));
			case 1:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hQ)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Textarea$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(false),
						model));
			default:
				var value = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hS)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Textarea$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsDirty(true),
						_Utils_update(
							modelData,
							{pB: value})));
		}
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$updateInterruptionDescription = F2(
	function (msg, _v0) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$Textarea$update, msg, model.aC);
		var descriptionInputModel = _v1.a;
		var descriptionInputCmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{aC: descriptionInputModel}),
			descriptionInputCmd);
	});
var $author$project$Pyxis$Commons$Events$Keyboard$isEnter = $author$project$Pyxis$Commons$Events$Keyboard$matchKeyCode(13);
var $author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus = F2(
	function (mapper, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{
				ev: mapper(modelData.ev)
			});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$maybeDispatchOnHoveredOptionChange = F2(
	function (_v0, _v1) {
		var oldModelData = _v0;
		var newModelData = _v1;
		return (!_Utils_eq(oldModelData.H, newModelData.H)) ? A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (_v2, onHoveredOptionChange) {
						var id = _v2.kg;
						return $author$project$Pyxis$Commons$Commands$dispatch(
							onHoveredOptionChange(id));
					}),
				newModelData.H,
				newModelData.hR)) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Pyxis$Components$Field$Autocomplete$getSelectedOption = function (_v0) {
	var modelData = _v0;
	return modelData.fj;
};
var $author$project$Pyxis$Components$Field$Autocomplete$setFilteringValueToSelectedValueLabel = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Components$Field$Autocomplete$getSelectedOption,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
				function ($) {
					return $.eR;
				})),
		$elm$core$Maybe$withDefault('')));
var $author$project$Pyxis$Components$Field$Autocomplete$setFilteringValueOnBlur = function (_v0) {
	var modelData = _v0;
	return _Utils_eq(
		$author$project$Pyxis$Components$Field$Autocomplete$getSelectedOption(modelData),
		$elm$core$Maybe$Nothing) ? modelData : _Utils_update(
		modelData,
		{
			E: $author$project$Pyxis$Components$Field$Autocomplete$setFilteringValueToSelectedValueLabel(modelData)
		});
};
var $author$project$Pyxis$Components$Field$Autocomplete$setHasFocus = F2(
	function (hasFocus, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{eA: hasFocus});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$setIsDropdownOpen = F2(
	function (isOpen, _v0) {
		var modelData = _v0;
		return A4(
			$author$project$Pyxis$Commons$Basics$ternaryOperator,
			isOpen,
			$author$project$Pyxis$Components$Field$Autocomplete$initializeActiveOption,
			$elm$core$Basics$identity,
			_Utils_update(
				modelData,
				{a2: isOpen}));
	});
var $author$project$Pyxis$Components$Field$Autocomplete$handleOnSelect = function (value) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Pyxis$Components$Field$Autocomplete$setValue(value),
		$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus(
			$author$project$Pyxis$Components$Field$FieldStatus$setIsDirty(true)));
};
var $author$project$Pyxis$Commons$Events$Keyboard$isArrowDown = $author$project$Pyxis$Commons$Events$Keyboard$matchKeyCode(40);
var $author$project$Pyxis$Commons$Events$Keyboard$isArrowUp = $author$project$Pyxis$Commons$Events$Keyboard$matchKeyCode(38);
var $author$project$Pyxis$Commons$Events$Keyboard$isEsc = $author$project$Pyxis$Commons$Events$Keyboard$matchKeyCode(27);
var $elm$core$Array$toIndexedList = function (array) {
	var len = array.a;
	var helper = F2(
		function (entry, _v0) {
			var index = _v0.a;
			var list = _v0.b;
			return _Utils_Tuple2(
				index - 1,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(index, entry),
					list));
		});
	return A3(
		$elm$core$Array$foldr,
		helper,
		_Utils_Tuple2(len - 1, _List_Nil),
		array).b;
};
var $author$project$Pyxis$Components$Field$Autocomplete$getActiveOptionWithIndex = function (model) {
	var modelData = model;
	var findOption = function (_v0) {
		var value = _v0.b.pB;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pB;
						},
						$elm$core$Basics$eq(value))),
				modelData.H));
	};
	return A2(
		$elm_community$list_extra$List$Extra$find,
		findOption,
		$elm$core$Array$toIndexedList(
			$elm$core$Array$fromList(
				$author$project$Pyxis$Components$Field$Autocomplete$getOptions(model))));
};
var $author$project$Pyxis$Components$Field$Autocomplete$getValuesLength = function (_v0) {
	var modelData = _v0;
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.eR;
					},
					modelData.bH(modelData.E))),
			A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, modelData.aw)));
};
var $author$project$Pyxis$Components$Field$Autocomplete$updateActiveOption = F2(
	function (moveByPositions, model) {
		var modelData = model;
		var newActiveOptionIndex = moveByPositions + A2(
			$elm$core$Maybe$withDefault,
			-1,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$first,
				$author$project$Pyxis$Components$Field$Autocomplete$getActiveOptionWithIndex(model)));
		return _Utils_update(
			modelData,
			{
				H: ((newActiveOptionIndex < 0) || (_Utils_cmp(
					newActiveOptionIndex,
					$author$project$Pyxis$Components$Field$Autocomplete$getValuesLength(model)) > -1)) ? modelData.H : A2(
					$elm$core$Array$get,
					newActiveOptionIndex,
					$elm$core$Array$fromList(
						$author$project$Pyxis$Components$Field$Autocomplete$getOptions(model)))
			});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$updateOnKeyEvent = F2(
	function (event, model) {
		var modelData = model;
		return $author$project$Pyxis$Commons$Events$Keyboard$isArrowDown(event) ? A2($author$project$Pyxis$Components$Field$Autocomplete$updateActiveOption, 1, model) : ($author$project$Pyxis$Commons$Events$Keyboard$isArrowUp(event) ? A2($author$project$Pyxis$Components$Field$Autocomplete$updateActiveOption, -1, model) : ($author$project$Pyxis$Commons$Events$Keyboard$isEsc(event) ? $author$project$Pyxis$Components$Field$Autocomplete$setDropdownClosed(model) : ($author$project$Pyxis$Commons$Events$Keyboard$isEnter(event) ? A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pB;
						},
						A2($primait$prima_elm_extra$PrimaFunction$flip, $author$project$Pyxis$Components$Field$Autocomplete$handleOnSelect, model))),
				modelData.H)) : model)));
	});
var $author$project$Pyxis$Components$Field$Autocomplete$update = F2(
	function (msg, model) {
		var modelData = model;
		switch (msg.$) {
			case 0:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hH)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(true),
						$author$project$Pyxis$Components$Field$Autocomplete$setFilteringValueOnBlur(
							A2(
								$author$project$Pyxis$Components$Field$Autocomplete$setHasFocus,
								false,
								A2($author$project$Pyxis$Components$Field$Autocomplete$setIsDropdownOpen, false, model)))));
			case 1:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hQ)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$setHasFocus,
						true,
						A2(
							$author$project$Pyxis$Components$Field$Autocomplete$setIsDropdownOpen,
							true,
							A2(
								$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus,
								$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(false),
								model))));
			case 3:
				var value = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmdsMap,
					_List_fromArray(
						[
							$elm$core$Basics$always(
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hS)),
							$author$project$Pyxis$Components$Field$Autocomplete$maybeDispatchOnHoveredOptionChange(model)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsDirty(true),
						A2(
							$author$project$Pyxis$Components$Field$Autocomplete$setHasFocus,
							true,
							A2(
								$author$project$Pyxis$Components$Field$Autocomplete$setIsDropdownOpen,
								$krisajenkins$remotedata$RemoteData$isSuccess(modelData.aw),
								_Utils_update(
									modelData,
									{E: value, bO: true})))));
			case 4:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.h$)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(false),
						A2(
							$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus,
							$author$project$Pyxis$Components$Field$FieldStatus$setIsDirty(false),
							_Utils_update(
								modelData,
								{H: $elm$core$Maybe$Nothing, E: '', bO: false, fj: $elm$core$Maybe$Nothing, pB: $elm$core$Maybe$Nothing}))));
			case 5:
				var value = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.e4)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsDirty(true),
						A2(
							$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus,
							$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(false),
							A2($author$project$Pyxis$Components$Field$Autocomplete$setValue, value, model))));
			case 6:
				var event = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmdsMap,
					_List_fromArray(
						[
							$elm$core$Basics$always(
							A3(
								$author$project$Pyxis$Commons$Basics$ternaryOperator,
								$author$project$Pyxis$Commons$Events$Keyboard$isEnter(event) && (!_Utils_eq(modelData.H, $elm$core$Maybe$Nothing)),
								$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.e4),
								$elm$core$Platform$Cmd$none)),
							$author$project$Pyxis$Components$Field$Autocomplete$maybeDispatchOnHoveredOptionChange(model)
						]),
					A2($author$project$Pyxis$Components$Field$Autocomplete$updateOnKeyEvent, event, model));
			case 2:
				var option_ = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmdsMap,
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Field$Autocomplete$maybeDispatchOnHoveredOptionChange(model)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$setActiveOption,
						$elm$core$Maybe$Just(option_),
						model));
			case 7:
				return $primait$prima_elm_extra$PrimaUpdate$withoutCmds(model);
			default:
				return modelData.a2 ? $primait$prima_elm_extra$PrimaUpdate$withoutCmds(
					$author$project$Pyxis$Components$Field$Autocomplete$setDropdownClosed(model)) : $primait$prima_elm_extra$PrimaUpdate$withoutCmds(
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$setIsDropdownOpen,
						true,
						A2(
							$author$project$Pyxis$Components$Field$Autocomplete$setHasFocus,
							true,
							A2(
								$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus,
								$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(false),
								model))));
		}
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$updateInterruptionReason = F2(
	function (msg, _v0) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$Autocomplete$update, msg, model.aN);
		var reasonInputModel = _v1.a;
		var reasonInputCmd = _v1.b;
		var descriptionStatus = A2(
			$elm$core$Maybe$withDefault,
			3,
			A2(
				$elm$core$Maybe$map,
				model.gm,
				$author$project$Pyxis$Components$Field$Autocomplete$getValue(reasonInputModel)));
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bD: descriptionStatus, aN: reasonInputModel}),
			reasonInputCmd);
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$Loading = 3;
var $author$project$Page$PolicyDetails$AmendInterruptionModal$updateOnSubmit = function (_v0) {
	var model = _v0;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{aE: 3}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$Submitted = 2;
var $author$project$Page$PolicyDetails$AmendInterruptionModal$updateOnSubmitError = function (_v0) {
	var model = _v0;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{aE: 2}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pyxis$Components$Field$Textarea$getValue = function (_v0) {
	var value = _v0.pB;
	return value;
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$updateReasonAdditionalNotes = F2(
	function (_v0, textareaMsg) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$Textarea$update, textareaMsg, model.aC);
		var newDescriptionModel = _v1.a;
		var textareaCmd = _v1.b;
		var description = $author$project$Pyxis$Components$Field$Textarea$getValue(newDescriptionModel);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					me: $elm$core$Maybe$Just(description),
					aC: newDescriptionModel
				}),
			textareaCmd);
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Data$setDescription = F2(
	function (description, data) {
		switch (data.$) {
			case 0:
				var withdrawalData = data.a;
				return $author$project$Page$PolicyDetails$InterruptionModal$Data$WithdrawalInput(
					_Utils_update(
						withdrawalData,
						{mN: description}));
			case 1:
				var customerTerminationData = data.a;
				return $author$project$Page$PolicyDetails$InterruptionModal$Data$CustomerTerminationInput(
					_Utils_update(
						customerTerminationData,
						{mN: description}));
			default:
				var primaTerminationData = data.a;
				return $author$project$Page$PolicyDetails$InterruptionModal$Data$PrimaTerminationInput(
					_Utils_update(
						primaTerminationData,
						{mN: description}));
		}
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$updateReasonDescription = F2(
	function (_v0, textareaMsg) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$Textarea$update, textareaMsg, model.aC);
		var newDescriptionModel = _v1.a;
		var textareaCmd = _v1.b;
		var description = $author$project$Pyxis$Components$Field$Textarea$getValue(newDescriptionModel);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					aC: newDescriptionModel,
					at: A2(
						$elm$core$Maybe$map,
						$author$project$Page$PolicyDetails$InterruptionModal$Data$setDescription(
							$elm$core$Maybe$Just(description)),
						model.at)
				}),
			textareaCmd);
	});
var $author$project$Common$ReasonDescriptionStatus$fromCustomerTerminationReason = function (reason) {
	switch (reason) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 2;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 2;
		case 6:
			return 2;
		case 8:
			return 1;
		case 9:
			return 1;
		case 7:
			return 2;
		case 10:
			return 2;
		case 11:
			return 2;
		case 12:
			return 1;
		case 13:
			return 1;
		case 14:
			return 2;
		case 15:
			return 2;
		case 19:
			return 0;
		case 16:
			return 1;
		case 17:
			return 1;
		default:
			return 1;
	}
};
var $author$project$Common$ReasonDescriptionStatus$fromCustomerWithdrawReason = function (reason) {
	switch (reason) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 2;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 2;
		case 6:
			return 2;
		case 7:
			return 2;
		case 10:
			return 2;
		case 11:
			return 2;
		case 12:
			return 1;
		case 13:
			return 1;
		case 14:
			return 2;
		case 15:
			return 2;
		case 16:
			return 0;
		case 9:
			return 1;
		default:
			return 1;
	}
};
var $author$project$Common$ReasonDescriptionStatus$fromPrimaTerminationReason = function (reason) {
	switch (reason) {
		case 2:
			return 2;
		case 0:
			return 2;
		case 1:
			return 1;
		case 3:
			return 2;
		case 4:
			return 1;
		default:
			return 1;
	}
};
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$fromString = function (enumString____) {
	switch (enumString____) {
		case 'COMPETITOR_OFFER':
			return $elm$core$Maybe$Just(0);
		case 'VEHICLE_SOLD':
			return $elm$core$Maybe$Just(1);
		case 'VEHICLE_NOT_PURCHASED':
			return $elm$core$Maybe$Just(2);
		case 'VEHICLE_DEREGISTRATION':
			return $elm$core$Maybe$Just(3);
		case 'NO_INSURANCE_WANTED':
			return $elm$core$Maybe$Just(4);
		case 'DOES_NOT_KNOW':
			return $elm$core$Maybe$Just(5);
		case 'WANTS_GREEN_CARD':
			return $elm$core$Maybe$Just(6);
		case 'INCORRECT_EFFECTIVE_DATE':
			return $elm$core$Maybe$Just(7);
		case 'INCORRECT_PERSONAL_DATA':
			return $elm$core$Maybe$Just(8);
		case 'INCORRECT_DATA_OTHER':
			return $elm$core$Maybe$Just(9);
		case 'PAYMENT_METHOD_OR_DATE':
			return $elm$core$Maybe$Just(10);
		case 'DECEASED_POLICY_HOLDER':
			return $elm$core$Maybe$Just(11);
		case 'COVERAGE_CHANGE':
			return $elm$core$Maybe$Just(12);
		case 'DISSATISFACTION_SERVICE':
			return $elm$core$Maybe$Just(13);
		case 'UNDERWRITING_RULES':
			return $elm$core$Maybe$Just(14);
		case 'MOVING_TO_ANOTHER_COUNTRY':
			return $elm$core$Maybe$Just(15);
		case 'PRODUCT_SERVICE':
			return $elm$core$Maybe$Just(16);
		case 'POLICY_HOLDER_CHANGE':
			return $elm$core$Maybe$Just(17);
		case 'SWITCH_TO_GREAT_LAKES':
			return $elm$core$Maybe$Just(18);
		case 'OTHER':
			return $elm$core$Maybe$Just(19);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$CompetitorOffer = 0;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$CoverageChange = 12;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$DeceasedPolicyHolder = 11;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$DissatisfactionService = 13;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$DoesNotKnow = 5;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$IncorrectDataOther = 8;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$IncorrectEffectiveDate = 7;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$IncorrectPersonalData = 9;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$MovingToAnotherCountry = 15;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$NoInsuranceWanted = 4;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$Other = 16;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$PaymentMethodOrDate = 10;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$UnderwritingRules = 14;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$VehicleDeregistration = 3;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$VehicleNotPurchased = 2;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$VehicleSold = 1;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$WantsGreenCard = 6;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$fromString = function (enumString____) {
	switch (enumString____) {
		case 'COMPETITOR_OFFER':
			return $elm$core$Maybe$Just(0);
		case 'VEHICLE_SOLD':
			return $elm$core$Maybe$Just(1);
		case 'VEHICLE_NOT_PURCHASED':
			return $elm$core$Maybe$Just(2);
		case 'VEHICLE_DEREGISTRATION':
			return $elm$core$Maybe$Just(3);
		case 'NO_INSURANCE_WANTED':
			return $elm$core$Maybe$Just(4);
		case 'DOES_NOT_KNOW':
			return $elm$core$Maybe$Just(5);
		case 'WANTS_GREEN_CARD':
			return $elm$core$Maybe$Just(6);
		case 'INCORRECT_EFFECTIVE_DATE':
			return $elm$core$Maybe$Just(7);
		case 'INCORRECT_DATA_OTHER':
			return $elm$core$Maybe$Just(8);
		case 'INCORRECT_PERSONAL_DATA':
			return $elm$core$Maybe$Just(9);
		case 'PAYMENT_METHOD_OR_DATE':
			return $elm$core$Maybe$Just(10);
		case 'DECEASED_POLICY_HOLDER':
			return $elm$core$Maybe$Just(11);
		case 'COVERAGE_CHANGE':
			return $elm$core$Maybe$Just(12);
		case 'DISSATISFACTION_SERVICE':
			return $elm$core$Maybe$Just(13);
		case 'UNDERWRITING_RULES':
			return $elm$core$Maybe$Just(14);
		case 'MOVING_TO_ANOTHER_COUNTRY':
			return $elm$core$Maybe$Just(15);
		case 'OTHER':
			return $elm$core$Maybe$Just(16);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$fromString = function (enumString____) {
	switch (enumString____) {
		case 'INEXACT_DECLARATION_SINCO':
			return $elm$core$Maybe$Just(0);
		case 'FRAUD':
			return $elm$core$Maybe$Just(1);
		case 'CHARGEBACK':
			return $elm$core$Maybe$Just(2);
		case 'INEXACT_DECLARATION_DNI':
			return $elm$core$Maybe$Just(3);
		case 'RISK_AGGRAVATION':
			return $elm$core$Maybe$Just(4);
		case 'PHOTO_VERIFICATION_NOT_PROVIDED':
			return $elm$core$Maybe$Just(5);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$PolicyDetails$InterruptionModal$Data$setReason = F2(
	function (maybeReason, data) {
		switch (data.$) {
			case 0:
				var withdrawalData = data.a;
				return $author$project$Page$PolicyDetails$InterruptionModal$Data$WithdrawalInput(
					_Utils_update(
						withdrawalData,
						{
							bD: A2(
								$elm$core$Maybe$withDefault,
								3,
								A2(
									$elm$core$Maybe$map,
									$author$project$Common$ReasonDescriptionStatus$fromCustomerWithdrawReason,
									A2($elm$core$Maybe$andThen, $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$fromString, maybeReason))),
							kC: A2($elm$core$Maybe$andThen, $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$fromString, maybeReason)
						}));
			case 1:
				var customerTerminationData = data.a;
				return $author$project$Page$PolicyDetails$InterruptionModal$Data$CustomerTerminationInput(
					_Utils_update(
						customerTerminationData,
						{
							bD: A2(
								$elm$core$Maybe$withDefault,
								3,
								A2(
									$elm$core$Maybe$map,
									$author$project$Common$ReasonDescriptionStatus$fromCustomerTerminationReason,
									A2($elm$core$Maybe$andThen, $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$fromString, maybeReason))),
							kC: A2($elm$core$Maybe$andThen, $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$fromString, maybeReason)
						}));
			default:
				var primaTerminationData = data.a;
				return $author$project$Page$PolicyDetails$InterruptionModal$Data$PrimaTerminationInput(
					_Utils_update(
						primaTerminationData,
						{
							bD: A2(
								$elm$core$Maybe$withDefault,
								3,
								A2(
									$elm$core$Maybe$map,
									$author$project$Common$ReasonDescriptionStatus$fromPrimaTerminationReason,
									A2($elm$core$Maybe$andThen, $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$fromString, maybeReason))),
							kC: A2($elm$core$Maybe$andThen, $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$fromString, maybeReason)
						}));
		}
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$updateReasonKindInput = F2(
	function (_v0, autoCompleteMessage) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$Autocomplete$update, autoCompleteMessage, model.aN);
		var autoCompleteReasonModel = _v1.a;
		var selectCmd = _v1.b;
		var reason = $author$project$Pyxis$Components$Field$Autocomplete$getValue(autoCompleteReasonModel);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					at: A2(
						$elm$core$Maybe$map,
						$author$project$Page$PolicyDetails$InterruptionModal$Data$setReason(reason),
						model.at),
					aN: autoCompleteReasonModel
				}),
			selectCmd);
	});
var $author$project$Common$ReasonDescriptionStatus$fromCustomerDeclineRenewalReason = function (reason) {
	switch (reason) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 2;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 2;
		case 6:
			return 2;
		case 8:
			return 1;
		case 9:
			return 1;
		case 7:
			return 2;
		case 10:
			return 2;
		case 11:
			return 2;
		case 12:
			return 1;
		case 13:
			return 1;
		case 14:
			return 2;
		case 15:
			return 2;
		case 19:
			return 0;
		case 16:
			return 1;
		case 17:
			return 1;
		default:
			return 1;
	}
};
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$fromString = function (enumString____) {
	switch (enumString____) {
		case 'COMPETITOR_OFFER':
			return $elm$core$Maybe$Just(0);
		case 'VEHICLE_SOLD':
			return $elm$core$Maybe$Just(1);
		case 'VEHICLE_NOT_PURCHASED':
			return $elm$core$Maybe$Just(2);
		case 'VEHICLE_DEREGISTRATION':
			return $elm$core$Maybe$Just(3);
		case 'NO_INSURANCE_WANTED':
			return $elm$core$Maybe$Just(4);
		case 'DOES_NOT_KNOW':
			return $elm$core$Maybe$Just(5);
		case 'WANTS_GREEN_CARD':
			return $elm$core$Maybe$Just(6);
		case 'INCORRECT_EFFECTIVE_DATE':
			return $elm$core$Maybe$Just(7);
		case 'INCORRECT_PERSONAL_DATA':
			return $elm$core$Maybe$Just(8);
		case 'INCORRECT_DATA_OTHER':
			return $elm$core$Maybe$Just(9);
		case 'PAYMENT_METHOD_OR_DATE':
			return $elm$core$Maybe$Just(10);
		case 'DECEASED_POLICY_HOLDER':
			return $elm$core$Maybe$Just(11);
		case 'COVERAGE_CHANGE':
			return $elm$core$Maybe$Just(12);
		case 'DISSATISFACTION_SERVICE':
			return $elm$core$Maybe$Just(13);
		case 'UNDERWRITING_RULES':
			return $elm$core$Maybe$Just(14);
		case 'MOVING_TO_ANOTHER_COUNTRY':
			return $elm$core$Maybe$Just(15);
		case 'PRODUCT_SERVICE':
			return $elm$core$Maybe$Just(16);
		case 'POLICY_HOLDER_CHANGE':
			return $elm$core$Maybe$Just(17);
		case 'PRICE_INCREASE':
			return $elm$core$Maybe$Just(18);
		case 'OTHER':
			return $elm$core$Maybe$Just(19);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$updateReasonKindInput = F2(
	function (_v0, autoCompleteMessage) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$Autocomplete$update, autoCompleteMessage, model.aN);
		var autoCompleteReasonModel = _v1.a;
		var selectCmd = _v1.b;
		var maybeReason = $author$project$Pyxis$Components$Field$Autocomplete$getValue(autoCompleteReasonModel);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					me: $elm$core$Maybe$Nothing,
					bD: A2(
						$elm$core$Maybe$withDefault,
						3,
						A2(
							$elm$core$Maybe$map,
							$author$project$Common$ReasonDescriptionStatus$fromCustomerDeclineRenewalReason,
							A2($elm$core$Maybe$andThen, $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$fromString, maybeReason))),
					aN: autoCompleteReasonModel,
					fk: A2($elm$core$Maybe$andThen, $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$fromString, maybeReason)
				}),
			selectCmd);
	});
var $author$project$Page$PolicyDetails$updateToastState = F2(
	function (_v0, _v1) {
		var toastModel = _v0.a;
		var toastCmd = _v0.b;
		var model = _v1.a;
		var effect = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{s: toastModel}),
			$author$project$Page$PolicyDetails$Effect$Effects(
				_List_fromArray(
					[
						effect,
						$author$project$Page$PolicyDetails$Effect$WithCmd(toastCmd)
					])));
	});
var $author$project$Page$PolicyDetails$update = F3(
	function (i18n, msg, model) {
		switch (msg.$) {
			case 0:
				if (msg.a.$ === 3) {
					var policy = msg.a.a;
					var _v1 = A2($author$project$Page$PolicyDetails$maybeUpdateModelIfRefererIsPaymentPage, i18n, model);
					var updatedModel = _v1.a;
					var toastEffect = _v1.b;
					return _Utils_Tuple2(
						A3(
							$author$project$Page$PolicyDetails$Model$maybeInitAmendModal,
							i18n,
							policy,
							A2(
								$author$project$Page$PolicyDetails$Model$setPaymentMethod,
								$krisajenkins$remotedata$RemoteData$Loading,
								A2(
									$author$project$Page$PolicyDetails$Model$setPolicyResult,
									$krisajenkins$remotedata$RemoteData$Success(policy),
									updatedModel))),
						$author$project$Page$PolicyDetails$Effect$Effects(
							_List_fromArray(
								[
									$author$project$Page$PolicyDetails$Effect$FetchCustomerId(
									$author$project$Common$Policy$pickId(policy)),
									$author$project$Page$PolicyDetails$chooseClaimHistoryEffectByFetchedPolicy(policy),
									A3(
									$author$project$Page$PolicyDetails$chooseGetRefundEffectByFetchedPolicy,
									model,
									$author$project$Page$PolicyDetails$Model$pickIssueRefundReleaseDate(model),
									policy),
									$author$project$Page$PolicyDetails$Effect$FetchPaymentMethod(
									$author$project$Common$Policy$pickId(policy)),
									$author$project$Page$PolicyDetails$Effect$FetchCoverSelection(
									$author$project$Common$Policy$pickId(policy)),
									toastEffect
								])));
				} else {
					var remoteData = msg.a;
					return _Utils_Tuple2(
						A2($author$project$Page$PolicyDetails$Model$setPolicyResult, remoteData, model),
						$author$project$Page$PolicyDetails$Effect$None);
				}
			case 1:
				if (msg.a.$ === 3) {
					var remoteData = msg.a;
					return _Utils_Tuple2(
						A2($author$project$Page$PolicyDetails$Model$setClaimHistoryResult, remoteData, model),
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Page$PolicyDetails$Effect$None,
							A2(
								$elm$core$Maybe$map,
								$author$project$Page$PolicyDetails$Effect$FetchPricingActionClaimHistory,
								$author$project$Page$PolicyDetails$Model$pickPolicyId(model))));
				} else {
					var remoteData = msg.a;
					return _Utils_Tuple2(
						A2($author$project$Page$PolicyDetails$Model$setClaimHistoryResult, remoteData, model),
						$author$project$Page$PolicyDetails$Effect$None);
				}
			case 2:
				var remoteData = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$PolicyDetails$Model$setClaimHistoryPricingActionResult, remoteData, model),
					$author$project$Page$PolicyDetails$Effect$None);
			case 3:
				var remotedata = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$PolicyDetails$Model$setCustomerId, remotedata, model),
					$author$project$Page$PolicyDetails$Effect$None);
			case 4:
				if (msg.a.$ === 3) {
					var coverSelectionResult = msg.a;
					var coverSelection = coverSelectionResult.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ed: A2(
									$author$project$Common$ComponentUI$Modal$CoverPackages$withProductVersion,
									$author$project$Common$ComponentUI$Modal$CoverPackages$productVersionFromCoverSelection(coverSelection),
									model.ed),
								jI: coverSelectionResult
							}),
						$author$project$Page$PolicyDetails$Effect$None);
				} else {
					var coverSelection = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{jI: coverSelection}),
						$author$project$Page$PolicyDetails$Effect$None);
				}
			case 5:
				var searchTerm = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$PolicyDetails$Effect$ChangeRoute(
						A2(
							$author$project$Route$Search,
							$author$project$Page$Search$SearchQueryParam$defaultSearchContext,
							$elm$core$Result$Ok(searchTerm))));
			case 9:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gg: $elm$core$Maybe$Just(time)
						}),
					$author$project$Page$PolicyDetails$Effect$None);
			case 6:
				return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
			case 7:
				if (msg.a) {
					var _v2 = $author$project$Common$ComponentUI$Modal$CoverPackages$open(model.ed);
					var newModalModel = _v2.a;
					var cmd = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ed: newModalModel}),
						$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
				} else {
					var _v3 = $author$project$Common$ComponentUI$Modal$CoverPackages$close(model.ed);
					var newModalModel = _v3.a;
					var cmd = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ed: newModalModel}),
						$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
				}
			case 8:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Pyxis$Components$Tabs$update, subMsg, model.ld);
				var newModel = _v4.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ld: newModel}),
					$author$project$Page$PolicyDetails$Effect$None);
			case 12:
				var inputMsg = msg.a;
				var _v5 = A2($author$project$Page$PolicyDetails$InterruptionModal$Model$updateInterruptionDateInput, model.p, inputMsg);
				var modalModel = _v5.a;
				var subCmd = _v5.b;
				return A3(
					$author$project$Page$PolicyDetails$applyIfInterruptionModelChanged,
					model,
					modalModel,
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								$author$project$Page$PolicyDetails$Effect$WithCmd(subCmd),
								$author$project$Page$PolicyDetails$Effect$GetExpectedRefund
							])));
			case 13:
				var selectMsg = msg.a;
				var _v6 = A2($author$project$Page$PolicyDetails$InterruptionModal$Model$updateReasonKindInput, model.p, selectMsg);
				var modalModel = _v6.a;
				var subCmd = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p: modalModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(subCmd));
			case 15:
				var _v7 = A2($author$project$Page$PolicyDetails$InterruptionModal$Model$updateExpectedRefundAmount, model.p, $krisajenkins$remotedata$RemoteData$NotAsked);
				var newModalState = _v7.a;
				var subCmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p: newModalState}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(subCmd));
			case 14:
				var _v8 = A2($author$project$Page$PolicyDetails$InterruptionModal$Model$updateExpectedRefundAmount, model.p, $krisajenkins$remotedata$RemoteData$Loading);
				var newModalState = _v8.a;
				return A3($author$project$Page$PolicyDetails$applyIfInterruptionModelChanged, model, newModalState, $author$project$Page$PolicyDetails$Effect$GetExpectedRefund);
			case 16:
				var textareaMsg = msg.a;
				var _v9 = A2($author$project$Page$PolicyDetails$InterruptionModal$Model$updateReasonDescription, model.p, textareaMsg);
				var modalModel = _v9.a;
				var subCmd = _v9.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p: modalModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(subCmd));
			case 17:
				var kind = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A3(
						$elm$core$Maybe$map2,
						A3($author$project$Page$PolicyDetails$openAndInitInterruptionModal, i18n, kind, model),
						$krisajenkins$remotedata$RemoteData$toMaybe(model.k),
						model.gg));
			case 18:
				var _v10 = $author$project$Page$PolicyDetails$InterruptionModal$Model$closeModal(model.p);
				var newInterruptionDateModel = _v10.a;
				var cmd = _v10.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p: newInterruptionDateModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 22:
				switch (msg.a.$) {
					case 3:
						var _v11 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyInterruptionSuccessMessage(i18n),
								$author$project$Pyxis$Components$Toasts$successToast),
							model.s);
						var newToastsState = _v11.a;
						var cmd = _v11.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{s: newToastsState}),
							$author$project$Page$PolicyDetails$Effect$Effects(
								_List_fromArray(
									[
										$author$project$Page$PolicyDetails$Effect$FetchPolicy(model.oQ),
										$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
									])));
					case 2:
						var _v12 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyGeneralErrorMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.s);
						var newToastsState = _v12.a;
						var cmd = _v12.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{s: newToastsState}),
							$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
					default:
						return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
				}
			case 19:
				var _arguments = msg.a;
				var _v13 = $author$project$Page$PolicyDetails$InterruptionModal$Model$closeModal(model.p);
				var newInterruptionDateModel = _v13.a;
				var cmd = _v13.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p: newInterruptionDateModel, k: $krisajenkins$remotedata$RemoteData$Loading}),
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								$author$project$Page$PolicyDetails$Effect$WithdrawPolicy(_arguments),
								$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
							])));
			case 20:
				var _arguments = msg.a;
				var _v14 = $author$project$Page$PolicyDetails$InterruptionModal$Model$closeModal(model.p);
				var newInterruptionDateModel = _v14.a;
				var cmd = _v14.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p: newInterruptionDateModel, k: $krisajenkins$remotedata$RemoteData$Loading}),
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								$author$project$Page$PolicyDetails$Effect$CustomerTerminatePolicy(_arguments),
								$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
							])));
			case 21:
				var _arguments = msg.a;
				var _v15 = $author$project$Page$PolicyDetails$InterruptionModal$Model$closeModal(model.p);
				var newInterruptionDateModel = _v15.a;
				var cmd = _v15.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p: newInterruptionDateModel, k: $krisajenkins$remotedata$RemoteData$Loading}),
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								$author$project$Page$PolicyDetails$Effect$PrimaTerminatePolicy(_arguments),
								$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
							])));
			case 10:
				var amount = msg.a;
				var _v16 = A2($author$project$Page$PolicyDetails$InterruptionModal$Model$updateExpectedRefundAmount, model.p, amount);
				var newModalState = _v16.a;
				var subCmd = _v16.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p: newModalState}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(subCmd));
			case 11:
				var result = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$PolicyDetails$Model$setRefundResult, result, model),
					$author$project$Page$PolicyDetails$Effect$None);
			case 63:
				if (msg.b.$ === 3) {
					var policyId = msg.a;
					var result = msg.b;
					var refund = result.a;
					var _v17 = $author$project$Common$Refund$pickStatus(refund);
					switch (_v17) {
						case 2:
							return A4($author$project$Page$PolicyDetails$showRefundSuccess, i18n, model, refund, result);
						case 3:
							return A3($author$project$Page$PolicyDetails$showRefundFailure, i18n, model, result);
						case 1:
							return _Utils_Tuple2(
								A2($author$project$Page$PolicyDetails$Model$setRefundResult, result, model),
								$author$project$Page$PolicyDetails$Effect$None);
						case 0:
							return A2($author$project$Page$PolicyDetails$continuePolling, model, policyId);
						default:
							return _Utils_Tuple2(
								A2($author$project$Page$PolicyDetails$Model$setRefundResult, result, model),
								$author$project$Page$PolicyDetails$Effect$None);
					}
				} else {
					var policyId = msg.a;
					return A2($author$project$Page$PolicyDetails$continuePolling, model, policyId);
				}
			case 64:
				var policyId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$PolicyDetails$Effect$PollRefundForCompletion(policyId));
			case 23:
				var policyId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$PolicyDetails$Effect$CreateRefund(policyId));
			case 24:
				var refund = msg.a;
				var _v18 = A2($author$project$Page$PolicyDetails$RefundIssuingModal$openModal, refund, model.b9);
				var newRefundModalState = _v18.a;
				var cmd = _v18.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b9: newRefundModalState}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 25:
				var _v19 = $author$project$Page$PolicyDetails$RefundIssuingModal$closeModal(model.b9);
				var newRefundModalState = _v19.a;
				var cmd = _v19.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b9: newRefundModalState}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 26:
				var refund = msg.a;
				var refundEffect = $author$project$Common$Refund$isToBePaid(refund) ? $author$project$Page$PolicyDetails$Effect$PayRefund(refund) : $author$project$Page$PolicyDetails$Effect$IssueRefund(refund);
				var _v20 = $author$project$Page$PolicyDetails$RefundIssuingModal$closeModal(model.b9);
				var newRefundModalState = _v20.a;
				var cmd = _v20.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b9: newRefundModalState}),
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								refundEffect,
								$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
							])));
			case 27:
				switch (msg.a.$) {
					case 3:
						var _v21 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyCreateRefundSuccessMessage(i18n),
								$author$project$Pyxis$Components$Toasts$successToast),
							model.s);
						var newToastsState = _v21.a;
						var cmd = _v21.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{s: newToastsState}),
							$author$project$Page$PolicyDetails$Effect$Effects(
								_List_fromArray(
									[
										$author$project$Page$PolicyDetails$Effect$FetchPolicy(model.oQ),
										$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
									])));
					case 2:
						var _v22 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyGeneralErrorMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.s);
						var newToastsState = _v22.a;
						var cmd = _v22.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{s: newToastsState}),
							$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
					default:
						return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
				}
			case 28:
				switch (msg.a.$) {
					case 3:
						return _Utils_Tuple2(
							A2($author$project$Page$PolicyDetails$Model$setRefundResult, $krisajenkins$remotedata$RemoteData$Loading, model),
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$Page$PolicyDetails$Effect$None,
								A2(
									$elm$core$Maybe$map,
									$author$project$Page$PolicyDetails$Effect$PollRefundForCompletion,
									$author$project$Page$PolicyDetails$Model$pickPolicyId(model))));
					case 2:
						var _v23 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyIssueRefundErrorMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.s);
						var newToastsState = _v23.a;
						var cmd = _v23.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{s: newToastsState}),
							$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
					default:
						return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
				}
			case 29:
				var timestampMillis = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ns: $elm$core$Maybe$Just(
								$elm$time$Time$millisToPosix(timestampMillis))
						}),
					$author$project$Page$PolicyDetails$Effect$None);
			case 30:
				return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
			case 31:
				var policy = msg.a;
				return A3($author$project$Page$PolicyDetails$openAndInitRenewalCancellationModal, i18n, model, policy);
			case 32:
				var _v24 = $author$project$Page$PolicyDetails$RenewalCancellationModal$closeModal(model.am);
				var newRenewalCancellationModel = _v24.a;
				var cmd = _v24.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{am: newRenewalCancellationModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 33:
				var selectMsg = msg.a;
				var _v25 = A2($author$project$Page$PolicyDetails$RenewalCancellationModal$updateReasonKindInput, model.am, selectMsg);
				var modalModel = _v25.a;
				var subCmd = _v25.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{am: modalModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(subCmd));
			case 34:
				var textareaMsg = msg.a;
				var _v26 = A2($author$project$Page$PolicyDetails$RenewalCancellationModal$updateReasonAdditionalNotes, model.am, textareaMsg);
				var modalModel = _v26.a;
				var subCmd = _v26.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{am: modalModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(subCmd));
			case 35:
				var args = msg.a;
				var _v27 = $author$project$Page$PolicyDetails$RenewalCancellationModal$closeModal(model.am);
				var newRenewalCancellationModal = _v27.a;
				var cmd = _v27.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: $krisajenkins$remotedata$RemoteData$Loading, am: newRenewalCancellationModal}),
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								$author$project$Page$PolicyDetails$Effect$RenewalCancellation(args),
								$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
							])));
			case 36:
				switch (msg.a.$) {
					case 3:
						var _v28 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyRenewalCancellationSuccessMessage(i18n),
								$author$project$Pyxis$Components$Toasts$successToast),
							model.s);
						var newToastsModel = _v28.a;
						var toastCmd = _v28.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{s: newToastsModel}),
							$author$project$Page$PolicyDetails$Effect$Effects(
								_List_fromArray(
									[
										$author$project$Page$PolicyDetails$Effect$FetchPolicy(model.oQ),
										$author$project$Page$PolicyDetails$Effect$WithCmd(toastCmd)
									])));
					case 2:
						var _v29 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyRenewalCancellationErrorMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.s);
						var newToastsModel = _v29.a;
						var toastCmd = _v29.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{s: newToastsModel}),
							$author$project$Page$PolicyDetails$Effect$WithCmd(toastCmd));
					default:
						return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
				}
			case 41:
				switch (msg.a.$) {
					case 3:
						var result = msg.a;
						var _v30 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								A2(
									$author$project$Translations$policySendEmailSuccessMessage,
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Page$PolicyDetails$Model$pickEmailRecipient(model)),
									i18n),
								$author$project$Pyxis$Components$Toasts$successToast),
							model.s);
						var newToastsModel = _v30.a;
						var toastCmd = _v30.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{fl: result, s: newToastsModel}),
							$author$project$Page$PolicyDetails$Effect$WithCmd(toastCmd));
					case 2:
						var result = msg.a;
						var _v31 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policySendEmailFailureMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.s);
						var newToastsModel = _v31.a;
						var toastCmd = _v31.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{fl: result, s: newToastsModel}),
							$author$project$Page$PolicyDetails$Effect$WithCmd(toastCmd));
					default:
						var result = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{fl: result}),
							$author$project$Page$PolicyDetails$Effect$None);
				}
			case 37:
				var renewalPolicyId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$PolicyDetails$Effect$ChangeRoute(
						A2(
							$author$project$Route$PolicyDetails,
							renewalPolicyId,
							$elm$core$Maybe$Just($author$project$Referer$paymentPage))));
			case 38:
				var message = msg.a;
				var _v32 = A2($author$project$Common$Portfolio$update, message, model.dn);
				var newModel = _v32.a;
				var cmd = _v32.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dn: newModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 39:
				var response = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{lc: response}),
					$author$project$Page$PolicyDetails$Effect$None);
			case 40:
				var policyId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{lc: $krisajenkins$remotedata$RemoteData$Loading}),
					$author$project$Page$PolicyDetails$Effect$FetchPaymentMethod(policyId));
			case 42:
				var policyId = msg.a;
				var email = msg.b;
				var _v33 = A3($author$project$Page$PolicyDetails$SendEmailModal$openModal, policyId, email, model.ce);
				var newModalModel = _v33.a;
				var cmd = _v33.b;
				return _Utils_Tuple2(
					$author$project$Page$PolicyDetails$resetSendEmailResult(
						A2($author$project$Page$PolicyDetails$openSendEmailModal, newModalModel, model)),
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
							])));
			case 44:
				var sendEmailMsg = msg.a;
				var _v34 = A2($author$project$Page$PolicyDetails$SendEmailModal$update, sendEmailMsg, model.ce);
				var newModalModel = _v34.a;
				var cmd = _v34.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ce: newModalModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 43:
				var id = msg.a;
				var trackSendingEmail = $author$project$Page$PolicyDetails$Effect$TrackSendEmail(
					$elm$core$List$singleton($author$project$Page$PolicyDetails$SendEmailModal$emailOptionToString));
				var _v35 = $author$project$Page$PolicyDetails$SendEmailModal$closeModal(model.ce);
				var newModalModel = _v35.a;
				var cmd = _v35.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ce: newModalModel}),
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								$author$project$Page$PolicyDetails$Effect$SendPolicyContractEmail(id),
								$author$project$Page$PolicyDetails$Effect$WithCmd(cmd),
								trackSendingEmail
							])));
			case 45:
				var toastCounterSubMsg = msg.a;
				var _v36 = A2($author$project$Pyxis$Components$Toasts$update, toastCounterSubMsg, model.s);
				var newToastsModel = _v36.a;
				var cmd = _v36.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{s: newToastsModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 46:
				var originalEmail = msg.a;
				var _v37 = A2($author$project$Page$PolicyDetails$ChangeEmailModal$openModal, originalEmail, model.bx);
				var newModalModel = _v37.a;
				var cmd = _v37.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bx: newModalModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 47:
				var subMsg = msg.a;
				var _v38 = A2($author$project$Page$PolicyDetails$ChangeEmailModal$update, subMsg, model.bx);
				var newModalModel = _v38.a;
				var cmd = _v38.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bx: newModalModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 48:
				var newEmail = msg.a;
				var _v39 = $author$project$Page$PolicyDetails$ChangeEmailModal$closeModal(model.bx);
				var newModalModel = _v39.a;
				var cmd = _v39.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bx: newModalModel}),
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								$author$project$Page$PolicyDetails$Effect$None,
								A2(
									$elm$core$Maybe$map,
									$author$project$Page$PolicyDetails$Effect$UpdateEmail(newEmail),
									A2(
										$elm$core$Maybe$map,
										$author$project$Common$Policy$pickCustomerFacingId,
										$krisajenkins$remotedata$RemoteData$toMaybe(model.k)))),
								$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
							])));
			case 49:
				switch (msg.a.$) {
					case 2:
						var _v40 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$changeEmailModalErrorToastMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.s);
						var newToastModel = _v40.a;
						var cmd = _v40.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{s: newToastModel}),
							$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
					case 3:
						var _v41 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$changeEmailModalSuccessToastMessage(i18n),
								$author$project$Pyxis$Components$Toasts$successToast),
							model.s);
						var newToastModel = _v41.a;
						var cmd = _v41.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{s: newToastModel}),
							$author$project$Page$PolicyDetails$Effect$Effects(
								_List_fromArray(
									[
										$author$project$Page$PolicyDetails$Effect$FetchPolicy(model.oQ),
										$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
									])));
					default:
						return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
				}
			case 50:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$openModal,
							$author$project$Page$PolicyDetails$updateAmendModalState(model)),
						model.U));
			case 51:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$closeModal,
							$author$project$Page$PolicyDetails$updateAmendModalState(model)),
						model.U));
			case 52:
				var description = msg.a;
				var interruptionAt = msg.b;
				var reason = msg.c;
				var hasInterruptionDateChanged = msg.d;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A2(
						$elm$core$Maybe$map,
						A4($author$project$Page$PolicyDetails$requestAmendInterruption, description, interruptionAt, reason, hasInterruptionDateChanged),
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Page$PolicyDetails$AmendInterruptionModal$updateOnSubmit,
								$author$project$Page$PolicyDetails$updateAmendModalState(model)),
							model.U)));
			case 60:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$updateOnSubmitError,
							$author$project$Page$PolicyDetails$updateAmendModalState(model)),
						model.U));
			case 59:
				switch (msg.b.$) {
					case 3:
						var hasInterruptionDateChanged = msg.a;
						var pollRefundEffect = A2(
							$elm$core$Maybe$withDefault,
							$author$project$Page$PolicyDetails$Effect$None,
							A3(
								$elm$core$Maybe$map2,
								$author$project$Page$PolicyDetails$Effect$PollForRefundUpdate,
								$author$project$Page$PolicyDetails$Model$pickRefund(model),
								$author$project$Page$PolicyDetails$Model$pickPolicyId(model)));
						var canBePolled = A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								$author$project$Common$Refund$isPendingOrNotRequired,
								$author$project$Page$PolicyDetails$Model$pickRefund(model)));
						var _v42 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyAmendInterruptionSuccessMessage(i18n),
								$author$project$Pyxis$Components$Toasts$successToast),
							model.s);
						var newToastsModel = _v42.a;
						var cmd = _v42.b;
						return (hasInterruptionDateChanged && canBePolled) ? _Utils_Tuple2(
							A2(
								$author$project$Page$PolicyDetails$Model$setRefundResult,
								$krisajenkins$remotedata$RemoteData$Loading,
								_Utils_update(
									model,
									{s: newToastsModel})),
							$author$project$Page$PolicyDetails$Effect$Effects(
								_List_fromArray(
									[
										$author$project$Page$PolicyDetails$Effect$FetchPolicy(model.oQ),
										pollRefundEffect,
										$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
									]))) : _Utils_Tuple2(
							_Utils_update(
								model,
								{s: newToastsModel}),
							$author$project$Page$PolicyDetails$Effect$Effects(
								_List_fromArray(
									[
										$author$project$Page$PolicyDetails$Effect$FetchPolicy(model.oQ),
										$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
									])));
					case 2:
						var updatedToastStatus = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyGeneralErrorMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.s);
						return A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
							A2(
								$elm$core$Maybe$map,
								$author$project$Page$PolicyDetails$updateToastState(updatedToastStatus),
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Page$PolicyDetails$AmendInterruptionModal$updateOnSubmitError,
										$author$project$Page$PolicyDetails$updateAmendModalState(model)),
									model.U)));
					default:
						return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
				}
			case 57:
				return $author$project$Page$PolicyDetails$maybeGetExpectedRefundForAmendInterruption(
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None));
			case 54:
				return $author$project$Page$PolicyDetails$maybeGetExpectedRefundForAmendInterruption(
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None));
			case 58:
				var result = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$updateExpectedRefundAmount(result),
							$author$project$Page$PolicyDetails$updateAmendModalState(model)),
						model.U));
			case 56:
				var subMsg = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$updateInterruptionDate(subMsg),
							$author$project$Page$PolicyDetails$updateAmendModalState(model)),
						model.U));
			case 53:
				var subMsg = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$updateInterruptionReason(subMsg),
							$author$project$Page$PolicyDetails$updateAmendModalState(model)),
						model.U));
			case 55:
				var subMsg = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$updateInterruptionDescription(subMsg),
							$author$project$Page$PolicyDetails$updateAmendModalState(model)),
						model.U));
			case 61:
				if (msg.c.$ === 3) {
					var originalRefund = msg.a;
					var policyId = msg.b;
					var result = msg.c;
					var refund = result.a;
					return _Utils_eq(refund, originalRefund) ? _Utils_Tuple2(
						model,
						A2($author$project$Page$PolicyDetails$Effect$WaitBeforePollingRefundUpdate, originalRefund, policyId)) : _Utils_Tuple2(
						A2($author$project$Page$PolicyDetails$Model$setRefundResult, result, model),
						$author$project$Page$PolicyDetails$Effect$None);
				} else {
					var originalRefund = msg.a;
					var policyId = msg.b;
					return _Utils_Tuple2(
						model,
						A2($author$project$Page$PolicyDetails$Effect$WaitBeforePollingRefundUpdate, originalRefund, policyId));
				}
			default:
				var originalRefund = msg.a;
				var policyId = msg.b;
				return _Utils_Tuple2(
					model,
					A2($author$project$Page$PolicyDetails$Effect$PollForRefundUpdate, originalRefund, policyId));
		}
	});
var $author$project$Page$Search$Effect$ChangeRoute = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Search$Effect$RewriteUrlRequest = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Search$Effect$RewrittenUrl = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Search$Effect$TrackUserSearch = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Search$SearchQueryParam$fromStringInputToPaymentDispute = function (inputValue) {
	return A2(
		$elm_community$result_extra$Result$Extra$or,
		$author$project$Page$Search$SearchQueryParam$customerIdRecogniser(inputValue),
		$author$project$Page$Search$SearchQueryParam$mailRecogniser(inputValue));
};
var $author$project$Page$Search$SearchQueryParam$fromStringInputToSearchInput = function (inputValue) {
	return A3(
		$elm_community$result_extra$Result$Extra$unwrap,
		$author$project$Page$Search$SearchQueryParam$defaultWhenNotRecognised(inputValue),
		$elm$core$Basics$identity,
		A2(
			$elm_community$result_extra$Result$Extra$or,
			$author$project$Page$Search$SearchQueryParam$phoneNumberRecogniser(inputValue),
			A2(
				$elm_community$result_extra$Result$Extra$or,
				$author$project$Page$Search$SearchQueryParam$dniRecogniser(inputValue),
				A2(
					$elm_community$result_extra$Result$Extra$or,
					$author$project$Page$Search$SearchQueryParam$emptyStringRecogniser(inputValue),
					A2(
						$elm_community$result_extra$Result$Extra$or,
						$author$project$Page$Search$SearchQueryParam$cfIdRecogniser(inputValue),
						$author$project$Page$Search$SearchQueryParam$mailRecogniser(inputValue))))));
};
var $author$project$Pyxis$Components$Tabs$getActiveTabIndex = function (_v0) {
	var activeIndex = _v0.M;
	return activeIndex;
};
var $author$project$Pyxis$Components$Field$Input$resetValue = function (_v0) {
	var modelData = _v0;
	return _Utils_update(
		modelData,
		{pB: ''});
};
var $author$project$Page$Search$SearchQueryParam$searchInputToString = function (searchInput) {
	switch (searchInput.$) {
		case 0:
			return 'documentId';
		case 1:
			switch (searchInput.a.$) {
				case 1:
					return 'offerId';
				case 0:
					return 'policyId';
				default:
					return 'quoteId';
			}
		case 2:
			return 'email';
		case 3:
			return 'empty';
		case 6:
			return 'customerId';
		case 4:
			return 'plateNumber';
		default:
			return 'phoneNumber';
	}
};
var $author$project$Translations$searchResultsToastErrorMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'An unexpected error occurred. Please try again later.';
	} else {
		return 'Se ha producido un error inesperado. Vuelve a intentarlo más tarde.';
	}
};
var $author$project$Page$Search$SearchQueryParam$UnexpectedError = function (a) {
	return {$: 10, a: a};
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Page$Search$SearchQueryParam$EmailError = {$: 4};
var $author$project$Page$Search$SearchQueryParam$isValidEmail = function (email) {
	var emailPattern = '^[a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$';
	var regex = $author$project$Page$Search$SearchQueryParam$fromStringToRegex(emailPattern);
	return A2($elm$regex$Regex$contains, regex, email) ? $elm$core$Result$Ok(
		$author$project$Page$Search$SearchQueryParam$Email(email)) : $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$EmailError);
};
var $author$project$Page$Search$SearchQueryParam$validatePaymentDisputes = function () {
	var genericError = $author$project$Page$Search$SearchQueryParam$UnexpectedError('');
	var validate = function (okResult) {
		switch (okResult.$) {
			case 6:
				var id = okResult.a;
				return $elm$core$Result$Ok(
					$author$project$Page$Search$SearchQueryParam$CustomerId(id));
			case 2:
				var email = okResult.a;
				return $author$project$Page$Search$SearchQueryParam$isValidEmail(email);
			default:
				return $elm$core$Result$Err(genericError);
		}
	};
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Result$mapError(
			$elm$core$Basics$always(genericError)),
		$elm$core$Result$andThen(validate));
}();
var $author$project$Page$Search$SearchQueryParam$EmptyError = {$: 9};
var $author$project$Page$Search$SearchQueryParam$CustomerFacingIdError = {$: 0};
var $author$project$Page$Search$SearchQueryParam$OfferError = {$: 2};
var $author$project$Page$Search$SearchQueryParam$isValidOfferId = function (offerId) {
	return A2(
		$elm$regex$Regex$contains,
		$author$project$Page$Search$SearchQueryParam$fromStringToRegex('^F\\d{9}$'),
		offerId) ? $elm$core$Result$Ok(
		$author$project$Page$Search$SearchQueryParam$CustomerFacingId(
			$author$project$Page$Search$SearchQueryParam$OfferId(offerId))) : $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$OfferError);
};
var $author$project$Page$Search$SearchQueryParam$PolicyError = {$: 1};
var $author$project$Page$Search$SearchQueryParam$isValidPolicyId = function (policyId) {
	return A2(
		$elm$regex$Regex$contains,
		$author$project$Page$Search$SearchQueryParam$fromStringToRegex('^P\\d{9}$'),
		policyId) ? $elm$core$Result$Ok(
		$author$project$Page$Search$SearchQueryParam$CustomerFacingId(
			$author$project$Page$Search$SearchQueryParam$PolicyId(policyId))) : $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$PolicyError);
};
var $author$project$Page$Search$SearchQueryParam$QuoteError = {$: 3};
var $author$project$Page$Search$SearchQueryParam$isValidQuoteId = function (quoteId) {
	return A2(
		$elm$regex$Regex$contains,
		$author$project$Page$Search$SearchQueryParam$fromStringToRegex('^Q\\d{8}$'),
		quoteId) ? $elm$core$Result$Ok(
		$author$project$Page$Search$SearchQueryParam$CustomerFacingId(
			$author$project$Page$Search$SearchQueryParam$QuoteId(quoteId))) : $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$QuoteError);
};
var $author$project$Page$Search$SearchQueryParam$isValidCustomerFacingId = function (cfid) {
	var _v0 = $author$project$Page$Search$SearchQueryParam$attemptIdentifyCustomerFacingId(cfid);
	if (!_v0.$) {
		switch (_v0.a.$) {
			case 0:
				var value = _v0.a.a;
				return $author$project$Page$Search$SearchQueryParam$isValidPolicyId(value);
			case 1:
				var value = _v0.a.a;
				return $author$project$Page$Search$SearchQueryParam$isValidOfferId(value);
			default:
				var value = _v0.a.a;
				return $author$project$Page$Search$SearchQueryParam$isValidQuoteId(value);
		}
	} else {
		return $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$CustomerFacingIdError);
	}
};
var $author$project$Page$Search$SearchQueryParam$DocumentIdError = {$: 5};
var $author$project$Page$Search$SearchQueryParam$isValidDocumentId = function (value) {
	var controlLetters = 'TRWAGMYFPDXBNJZSQVHLCKEtrwagmyfpdxbnjzsqvhlcke';
	var dniPattern = '\\d{8}[' + (controlLetters + ']');
	var niePattern = '[KLMXYZklmxyz]\\d{7,8}[' + (controlLetters + ']');
	var documentIdPattern = A2(
		$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
		'^({0}|{1})$',
		_List_fromArray(
			[dniPattern, niePattern]));
	var regex = $author$project$Page$Search$SearchQueryParam$fromStringToRegex(documentIdPattern);
	return A2($elm$regex$Regex$contains, regex, value) ? $elm$core$Result$Ok(
		$author$project$Page$Search$SearchQueryParam$DocumentId(value)) : $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$DocumentIdError);
};
var $author$project$Page$Search$SearchQueryParam$PhoneNumberError = {$: 7};
var $author$project$Page$Search$SearchQueryParam$isValidPhoneNumber = function (phoneNumber) {
	var regex = $author$project$Page$Search$SearchQueryParam$fromStringToRegex('^(\\d{9}|\\d{10})$');
	return A2($elm$regex$Regex$contains, regex, phoneNumber) ? $elm$core$Result$Ok(
		$author$project$Page$Search$SearchQueryParam$PhoneNumber(phoneNumber)) : $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$PhoneNumberError);
};
var $author$project$Page$Search$SearchQueryParam$PlateNumberError = {$: 6};
var $author$project$Page$Search$SearchQueryParam$isValidPlateNumber = function (value) {
	var oldProvincialCodes = '(A|ALB|AB|AL|AOE|AV|B|BA|BI|BU|C|CA|CAC|CC|CAS|CS|CE|CO|CR|CU|FP|GC|GE|GI|GR|GU|H|HU|I|IF|PM|IB|J|L|LE|LO|LR|LU|M|MA|ME|ML|MU|O|OR|OU|P|PA|NA|PO|RM|S|SA|SE|SEG|SG|SH|SO|SS|T|TE|TER|TE|TEG|TF|TG|TO|V|VA|VI|Z|ZA)';
	var previousPlateNumberPattern = oldProvincialCodes + '\\d{4}[A-Z]{1,2}';
	var oldPlateNumberPattern = oldProvincialCodes + '\\d{1,6}';
	var currentPlateNumberPattern = '\\d{4}[BCDFGHJKLMNPRSTVWXYZ]{3}';
	var regex = $author$project$Page$Search$SearchQueryParam$fromStringToRegex(
		A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'^({0}|{1}|{2})$',
			_List_fromArray(
				[currentPlateNumberPattern, previousPlateNumberPattern, oldPlateNumberPattern])));
	return A2($elm$regex$Regex$contains, regex, value) ? $elm$core$Result$Ok(
		$author$project$Page$Search$SearchQueryParam$PlateNumber(value)) : $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$PlateNumberError);
};
var $author$project$Page$Search$SearchQueryParam$validateSearchInput = function (searchInput) {
	switch (searchInput.$) {
		case 0:
			var docId = searchInput.a;
			return $author$project$Page$Search$SearchQueryParam$isValidDocumentId(docId);
		case 1:
			var cfid = searchInput.a;
			return $author$project$Page$Search$SearchQueryParam$isValidCustomerFacingId(
				$author$project$Page$Search$SearchQueryParam$pickCustomerFacingId(cfid));
		case 2:
			var email = searchInput.a;
			return $author$project$Page$Search$SearchQueryParam$isValidEmail(email);
		case 4:
			var plateNumber = searchInput.a;
			return $author$project$Page$Search$SearchQueryParam$isValidPlateNumber(plateNumber);
		case 5:
			var phone = searchInput.a;
			return $author$project$Page$Search$SearchQueryParam$isValidPhoneNumber(phone);
		case 6:
			var id = searchInput.a;
			return $elm$core$Result$Ok(
				$author$project$Page$Search$SearchQueryParam$CustomerId(id));
		default:
			return $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$EmptyError);
	}
};
var $author$project$Page$Search$update = F3(
	function (i18n, msg, model) {
		switch (msg.$) {
			case 0:
				var inputValue = $author$project$Page$Search$SearchQueryParam$validateSearchInput(
					$author$project$Page$Search$SearchQueryParam$fromStringInputToSearchInput(
						$author$project$Pyxis$Components$Field$Input$getValue(model.du)));
				if (!inputValue.$) {
					var value = inputValue.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{eO: true}),
						$author$project$Page$Search$Effect$Effects(
							_List_fromArray(
								[
									$author$project$Page$Search$Effect$RewriteUrlRequest(value),
									$author$project$Page$Search$Effect$TrackUserSearch(
									$author$project$Page$Search$SearchQueryParam$searchInputToString(value))
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{eO: true}),
						$author$project$Page$Search$Effect$None);
				}
			case 1:
				var id = msg.a;
				var _v2 = A2($author$project$Pyxis$Components$Field$Input$update, id, model.du);
				var newFieldModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eO: false, du: newFieldModel}),
					$author$project$Page$Search$Effect$WithCmd(subCmd));
			case 2:
				if (msg.a.$ === 2) {
					var result = msg.a;
					var _v3 = A2(
						$author$project$Pyxis$Components$Toasts$addNewToast,
						A2(
							$author$project$Pyxis$Components$Toasts$withToastText,
							$author$project$Translations$searchResultsToastErrorMessage(i18n),
							$author$project$Pyxis$Components$Toasts$errorToast),
						model.s);
					var newToastsModel = _v3.a;
					var toastsCmd = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{lw: result, s: newToastsModel}),
						$author$project$Page$Search$Effect$WithCmd(toastsCmd));
				} else {
					var result = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{lw: result}),
						$author$project$Page$Search$Effect$None);
				}
			case 3:
				if (msg.a.$ === 2) {
					var result = msg.a;
					var _v4 = A2(
						$author$project$Pyxis$Components$Toasts$addNewToast,
						A2(
							$author$project$Pyxis$Components$Toasts$withToastText,
							$author$project$Translations$searchResultsToastErrorMessage(i18n),
							$author$project$Pyxis$Components$Toasts$errorToast),
						model.s);
					var newToastsModel = _v4.a;
					var toastsCmd = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{kJ: result, s: newToastsModel}),
						$author$project$Page$Search$Effect$WithCmd(toastsCmd));
				} else {
					var results = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{kJ: results}),
						$author$project$Page$Search$Effect$None);
				}
			case 4:
				var offer = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$Search$Effect$ChangeRoute(
						$author$project$Route$Payment(
							$author$project$Common$Offer$pickId(offer))));
			case 5:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gf: $elm$core$Maybe$Just(date)
						}),
					$author$project$Page$Search$Effect$None);
			case 6:
				var searchTerm = msg.a;
				var actualTabIndex = $author$project$Pyxis$Components$Tabs$getActiveTabIndex(model.fL);
				var queryParams = $author$project$Route$toString(
					A2(
						$author$project$Route$Search,
						actualTabIndex,
						$elm$core$Result$Ok(searchTerm)));
				return _Utils_Tuple2(
					model,
					$author$project$Page$Search$Effect$RewrittenUrl(queryParams));
			case 7:
				var customerFacingId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$Search$Effect$ChangeRoute(
						A2($author$project$Route$PolicyDetails, customerFacingId, $elm$core$Maybe$Nothing)));
			case 8:
				var offerCfid = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$Search$Effect$ChangeRoute(
						$author$project$Route$OfferDetails(offerCfid)));
			case 9:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Pyxis$Components$Toasts$update, subMsg, model.s);
				var newToastsModel = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{s: newToastsModel}),
					$author$project$Page$Search$Effect$WithCmd(cmd));
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eO: false,
							du: $author$project$Pyxis$Components$Field$Input$resetValue(model.du)
						}),
					$author$project$Page$Search$Effect$WithCmd(
						A2(
							$elm$core$Task$attempt,
							$elm$core$Basics$always($author$project$Page$Search$Msg$NoOp),
							$elm$browser$Browser$Dom$focus(model.lv))));
			case 11:
				var subMsg = msg.a;
				var _v6 = A2($author$project$Pyxis$Components$Tabs$update, subMsg, model.fL);
				var newModel = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fL: newModel}),
					$author$project$Page$Search$Effect$WithCmd(cmd));
			case 12:
				var subMsg = msg.a;
				var _v7 = A2($author$project$Pyxis$Components$Field$Input$update, subMsg, model.h7);
				var newModel = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{g3: false, h7: newModel}),
					$author$project$Page$Search$Effect$WithCmd(cmd));
			case 13:
				var inputValue = $author$project$Page$Search$SearchQueryParam$validatePaymentDisputes(
					$author$project$Page$Search$SearchQueryParam$fromStringInputToPaymentDispute(
						$author$project$Pyxis$Components$Field$Input$getValue(model.h7)));
				if (!inputValue.$) {
					var value = inputValue.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{g3: true}),
						$author$project$Page$Search$Effect$RewriteUrlRequest(value));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{g3: true}),
						$author$project$Page$Search$Effect$None);
				}
			default:
				return _Utils_Tuple2(model, $author$project$Page$Search$Effect$None);
		}
	});
var $author$project$Main$update = F2(
	function (model, msg) {
		var _v0 = _Utils_Tuple2(msg, model.oO);
		_v0$0:
		while (true) {
			_v0$1:
			while (true) {
				_v0$2:
				while (true) {
					_v0$10:
					while (true) {
						_v0$11:
						while (true) {
							switch (_v0.b.$) {
								case 0:
									switch (_v0.a.$) {
										case 1:
											break _v0$0;
										case 2:
											break _v0$1;
										case 12:
											break _v0$2;
										case 3:
											var subMsg = _v0.a.a;
											var subModel = _v0.b.a;
											var _v5 = A2($author$project$Page$NotFound$update, subMsg, subModel);
											var newSubModel = _v5.a;
											var subEffect = _v5.b;
											return _Utils_Tuple2(
												_Utils_update(
													model,
													{
														oO: $author$project$Model$NotFound(newSubModel)
													}),
												$author$project$Effect$NotFound(subEffect));
										case 6:
											break _v0$10;
										case 7:
											break _v0$11;
										default:
											return _Utils_Tuple2(model, $author$project$Effect$None);
									}
								case 1:
									switch (_v0.a.$) {
										case 1:
											break _v0$0;
										case 2:
											break _v0$1;
										case 12:
											break _v0$2;
										case 4:
											var subMsg = _v0.a.a;
											var subModel = _v0.b.a;
											var _v6 = A2($author$project$Page$NotAuthorized$update, subMsg, subModel);
											var newSubModel = _v6.a;
											var subEffect = _v6.b;
											return _Utils_Tuple2(
												_Utils_update(
													model,
													{
														oO: $author$project$Model$NotAuthorized(newSubModel)
													}),
												$author$project$Effect$NotAuthorized(subEffect));
										case 6:
											break _v0$10;
										case 7:
											break _v0$11;
										default:
											return _Utils_Tuple2(model, $author$project$Effect$None);
									}
								case 2:
									switch (_v0.a.$) {
										case 1:
											break _v0$0;
										case 2:
											break _v0$1;
										case 12:
											break _v0$2;
										case 5:
											var subMsg = _v0.a.a;
											var subModel = _v0.b.a;
											var _v2 = A2($author$project$Page$Login$update, subMsg, subModel);
											var newSubModel = _v2.a;
											var subEffect = _v2.b;
											if (subEffect.$ === 2) {
												var _v4 = subEffect.a;
												var user = _v4.a;
												var route = _v4.b;
												return _Utils_Tuple2(
													_Utils_update(
														model,
														{
															oO: $author$project$Model$Login(newSubModel),
															fB: $author$project$Common$User$Backoffice(user)
														}),
													$author$project$Effect$ChangeRoute(route));
											} else {
												return _Utils_Tuple2(
													_Utils_update(
														model,
														{
															oO: $author$project$Model$Login(newSubModel)
														}),
													$author$project$Effect$Login(subEffect));
											}
										case 6:
											break _v0$10;
										case 7:
											break _v0$11;
										default:
											return _Utils_Tuple2(model, $author$project$Effect$None);
									}
								case 3:
									switch (_v0.a.$) {
										case 1:
											break _v0$0;
										case 2:
											break _v0$1;
										case 12:
											break _v0$2;
										case 8:
											var subMsg = _v0.a.a;
											var subModel = _v0.b.a;
											var _v7 = A3($author$project$Page$Search$update, model.ni, subMsg, subModel);
											var newSubModel = _v7.a;
											var subEffect = _v7.b;
											var subEffectToMainEffect = function () {
												switch (subEffect.$) {
													case 2:
														var route = subEffect.a;
														return $author$project$Effect$ChangeRoute(route);
													case 8:
														var queryParams = subEffect.a;
														return $author$project$Effect$RewriteUrl(queryParams);
													default:
														return $author$project$Effect$Search(subEffect);
												}
											}();
											return _Utils_Tuple2(
												_Utils_update(
													model,
													{
														oO: $author$project$Model$Search(newSubModel)
													}),
												subEffectToMainEffect);
										case 6:
											break _v0$10;
										case 7:
											break _v0$11;
										default:
											return _Utils_Tuple2(model, $author$project$Effect$None);
									}
								case 4:
									switch (_v0.a.$) {
										case 1:
											break _v0$0;
										case 2:
											break _v0$1;
										case 12:
											break _v0$2;
										case 9:
											var subMsg = _v0.a.a;
											var subModel = _v0.b.a;
											var _v9 = A2($author$project$Page$Payment$update, subMsg, subModel);
											var newSubModel = _v9.a;
											var subEffect = _v9.b;
											var subEffectToMainEffect = function () {
												switch (subEffect.$) {
													case 1:
														var route = subEffect.a;
														return $author$project$Effect$ChangeRoute(route);
													case 2:
														var pageNumber = subEffect.a;
														return $author$project$Effect$GoBack(pageNumber);
													default:
														return $author$project$Effect$Payment(subEffect);
												}
											}();
											return _Utils_Tuple2(
												_Utils_update(
													model,
													{
														oO: $author$project$Model$Payment(newSubModel)
													}),
												subEffectToMainEffect);
										case 6:
											break _v0$10;
										case 7:
											break _v0$11;
										default:
											return _Utils_Tuple2(model, $author$project$Effect$None);
									}
								case 5:
									switch (_v0.a.$) {
										case 1:
											break _v0$0;
										case 2:
											break _v0$1;
										case 12:
											break _v0$2;
										case 10:
											var subMsg = _v0.a.a;
											var subModel = _v0.b.a;
											var _v11 = A3($author$project$Page$PolicyDetails$update, model.ni, subMsg, subModel);
											var newSubModel = _v11.a;
											var subEffect = _v11.b;
											var subEffectToMainEffect = function () {
												if (subEffect.$ === 5) {
													var route = subEffect.a;
													return $author$project$Effect$ChangeRoute(route);
												} else {
													return $author$project$Effect$PolicyDetails(subEffect);
												}
											}();
											return _Utils_Tuple2(
												_Utils_update(
													model,
													{
														oO: $author$project$Model$PolicyDetails(newSubModel)
													}),
												subEffectToMainEffect);
										case 6:
											break _v0$10;
										case 7:
											break _v0$11;
										default:
											return _Utils_Tuple2(model, $author$project$Effect$None);
									}
								default:
									switch (_v0.a.$) {
										case 1:
											break _v0$0;
										case 2:
											break _v0$1;
										case 12:
											break _v0$2;
										case 11:
											var subMsg = _v0.a.a;
											var subModel = _v0.b.a;
											var _v13 = A4($author$project$Page$OfferDetails$update, model.ni, model.mU, subMsg, subModel);
											var newSubModel = _v13.a;
											var subEffect = _v13.b;
											var subEffectToMainEffect = function () {
												if (subEffect.$ === 7) {
													var route = subEffect.a;
													return $author$project$Effect$ChangeRoute(route);
												} else {
													return $author$project$Effect$OfferDetails(subEffect);
												}
											}();
											return _Utils_Tuple2(
												_Utils_update(
													model,
													{
														oO: $author$project$Model$OfferDetails(newSubModel)
													}),
												subEffectToMainEffect);
										case 6:
											break _v0$10;
										case 7:
											break _v0$11;
										default:
											return _Utils_Tuple2(model, $author$project$Effect$None);
									}
							}
						}
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{fB: $author$project$Common$User$Anonymous}),
							$author$project$Effect$ChangeRoute($author$project$Route$Login));
					}
					var _v15 = _v0.a;
					return _Utils_Tuple2(model, $author$project$Effect$Logout);
				}
				return _Utils_Tuple2(model, $author$project$Effect$None);
			}
			var url = _v0.a.a;
			return A2(
				$author$project$Main$onRouteChange,
				model,
				$author$project$Route$fromUrl(url));
		}
		var urlRequest = _v0.a.a;
		if (!urlRequest.$) {
			var url = urlRequest.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				function (effect) {
					return $author$project$Effect$Effects(
						_List_fromArray(
							[
								effect,
								$author$project$Effect$ChangeRoute(
								$author$project$Route$fromUrl(url))
							]));
				},
				A2(
					$author$project$Main$onRouteChange,
					model,
					$author$project$Route$fromUrl(url)));
		} else {
			var address = urlRequest.a;
			return _Utils_Tuple2(
				model,
				$author$project$Effect$LoadExternalPage(address));
		}
	});
var $author$project$Main$handle = F2(
	function (msg, model) {
		var _v0 = A2($author$project$Main$update, model, msg);
		var newModel = _v0.a;
		var effect = _v0.b;
		return _Utils_Tuple2(
			newModel,
			A3($author$project$Effect$runEffect, model.mU, newModel, effect));
	});
var $author$project$Translations$Es = 1;
var $author$project$Env$Env = $elm$core$Basics$identity;
var $author$project$Env$env = {cy: '', cP: '', cR: '', c$: $elm$core$Maybe$Nothing, c3: $author$project$Common$Locale$customerTimeZone, c4: '', c5: '', c7: '', c9: false};
var $author$project$Translations$En = 0;
var $author$project$Translations$languages = _List_fromArray(
	[0, 1]);
var $author$project$Translations$languageFromString = function (lang) {
	var helper = function (langs) {
		helper:
		while (true) {
			if (!langs.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var l = langs.a;
				var ls = langs.b;
				if (A2(
					$elm$core$String$startsWith,
					$author$project$Translations$languageToString(l),
					lang)) {
					return $elm$core$Maybe$Just(l);
				} else {
					var $temp$langs = ls;
					langs = $temp$langs;
					continue helper;
				}
			}
		}
	};
	return helper(
		$elm$core$List$reverse($author$project$Translations$languages));
};
var $author$project$Main$extractPreferredLanguage = function (languages) {
	return $elm$core$List$head(
		A2($elm$core$List$filterMap, $author$project$Translations$languageFromString, languages));
};
var $author$project$Translations$I18n = $elm$core$Basics$identity;
var $author$project$Translations$init = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$NavigationSidebar$Collapsed = 1;
var $author$project$Pyxis$Components$NavigationSidebar$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$NavigationSidebar$initCollapsed = {cs: '', cN: 1, aG: $elm$core$Set$empty, e2: $elm$core$Maybe$Nothing};
var $author$project$Model$init = F4(
	function (key, env, pageModel, language) {
		return {
			mU: env,
			ni: $author$project$Translations$init(language),
			hp: key,
			nR: $author$project$Pyxis$Components$NavigationSidebar$initCollapsed,
			oO: pageModel,
			fB: $author$project$Common$User$Anonymous
		};
	});
var $author$project$Main$languageFromUrl = function (url) {
	return $elm_community$maybe_extra$Maybe$Extra$join(
		A2(
			$elm$core$Maybe$map,
			$author$project$Translations$languageFromString,
			A2(
				$elm$core$Array$get,
				1,
				$elm$core$Array$fromList(
					A2($elm$core$String$split, '/', url.oP)))));
};
var $elm_community$maybe_extra$Maybe$Extra$or = F2(
	function (ma, mb) {
		if (ma.$ === 1) {
			return mb;
		} else {
			return ma;
		}
	});
var $author$project$Env$withApiUrl = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{cy: value});
	});
var $author$project$Env$withExternalApiUrl = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{cP: value});
	});
var $author$project$Env$withFunnelUrl = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{cR: value});
	});
var $author$project$Env$withLanguageOverride = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{
				c$: $elm$core$Maybe$Just(value)
			});
	});
var $author$project$Env$withLocalTimeZone = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{c3: value});
	});
var $author$project$Env$withLoginPath = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{c4: value});
	});
var $author$project$Env$withLogoutPath = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{c5: value});
	});
var $author$project$Env$withNewApiUrl = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{c7: value});
	});
var $author$project$Env$withNewSearchApiEnabled = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{c9: value});
	});
var $justinmimbs$timezone_data$TimeZone$Specification$Save = function (a) {
	return {$: 0, a: a};
};
var $justinmimbs$timezone_data$TimeZone$africa__abidjan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Algeria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1380,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1380,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__algiers = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 9, 21, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 26, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 4, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__bissau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Egypt = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1959,
		1981,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1994,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1988,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1994,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2010,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 3, 1),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__cairo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Egypt))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Morocco = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2013,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2018,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2018,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2021,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2021,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		2023,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		2023,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2025,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2025,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2026,
		2026,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2026,
		2026,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2027,
		2027,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2027,
		2027,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2028,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2028,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2030,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2030,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2031,
		2031,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2031,
		2031,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2032,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2032,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2034,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2034,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2035,
		2035,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2035,
		2035,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2036,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2036,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2037,
		2037,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2037,
		2037,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__casablanca = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 2, 16, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 28, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
};
var $justinmimbs$timezone_data$TimeZone$rules_SpainAfrica = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__ceuta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SpainAfrica)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 2, 16, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$africa__el_aaiun = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 3, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 28, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
};
var $justinmimbs$timezone_data$TimeZone$africa__johannesburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Sudan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__juba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 0, 15, 720, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2021, 1, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__khartoum = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 0, 15, 720, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2017, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__lagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__maputo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__monrovia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-45,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 0, 7, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__nairobi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__ndjamena = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 2, 8, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__sao_tome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 0, 1, 60, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 0, 1, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Libya = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1989,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__tripoli = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 4, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 9, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 10, 10, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 9, 25, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Tunisia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2008,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2008,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__tunis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tunisia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Namibia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		2017,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2017,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		-60)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__windhoek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 21, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Namibia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_US = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1973,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__adak = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__anchorage = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Brazil = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1995,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 11),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1995,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2006,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2017,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2011,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2014,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2019,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__araguaina = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 8, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 8, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 9, 21, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 8, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Arg = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1968,
		1969,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1993,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1992,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 9, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 6, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 4, 7, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 9, 18, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 23, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 8, 26, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__salta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 4, 7, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 31, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 6, 25, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_SanLuis = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2008,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 31, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 6, 25, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 0, 21, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SanLuis)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 11, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 13, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Para = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1978,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1991,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1995,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1995,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2001,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		2001,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2004,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2003,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2009,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2009,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2024,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2012,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2024,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__asuncion = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Para)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2024, 9, 15, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__bahia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 8, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 9, 16, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 9, 21, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mexico = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2000,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2000,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2022,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2022,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__bahia_banderas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 3, 4, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Barb = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__barbados = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Barb))));
};
var $justinmimbs$timezone_data$TimeZone$america__belem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Belize = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__belize = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Belize))));
};
var $justinmimbs$timezone_data$TimeZone$america__boa_vista = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 15, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_CO = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		1440,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__bogota = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CO))));
};
var $justinmimbs$timezone_data$TimeZone$america__boise = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 1, 3, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Canada = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_NT_YK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__cambridge_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 10, 5, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 3, 1, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__campo_grande = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$america__cancun = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 11, 26, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 0, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 9, 26, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 7, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 1, 1, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__caracas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 11, 9, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-270,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 4, 1, 150, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__cayenne = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__chicago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__chihuahua = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 3, 5, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 9, 30, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__ciudad_juarez = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 3, 5, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_CR = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		5,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__costa_rica = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CR))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Chile = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1972,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1986,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1987,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1996,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1997,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2010,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2007,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		7,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		7,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2021,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		240,
		0,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__coyhaique = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2025, 2, 20, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__cuiaba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 8, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$america__danmarkshavn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__dawson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 9, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Vanc = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1946,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__dawson_creek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 7, 30, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__denver = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__detroit = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 3, 27, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Edm = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__edmonton = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Edm)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__eirunepe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 8, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 5, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 10, 10, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Salv = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__el_salvador = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Salv))));
};
var $justinmimbs$timezone_data$TimeZone$america__fort_nelson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 2, 8, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__fortaleza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Halifax = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		1973,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		1973,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__glace_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_StJohns = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1951,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1960,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		1,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		120),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2011,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2010,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__goose_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__grand_turk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 2, 8, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 2, 11, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Guat = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__guatemala = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guat))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Ecuador = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__guayaquil = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
};
var $justinmimbs$timezone_data$TimeZone$america__guyana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-225,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 7, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 60, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__halifax = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cuba = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1977,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1971,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1974,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1990,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1985,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 14),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1997,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1995,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1999,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		2003,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2003,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2010,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2010,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__havana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cuba))));
};
var $justinmimbs$timezone_data$TimeZone$america__hermosillo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__knox = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 27, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__marengo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 10, 4, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__vevay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 10, 4, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__winamac = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 2, 11, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__inuvik = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 3, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__iqaluit = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__jamaica = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__juneau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 27, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 9, 26, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__la_paz = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Peru = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__lima = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Peru))));
};
var $justinmimbs$timezone_data$TimeZone$america__los_angeles = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__maceio = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 9, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 8, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Nic = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		5,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 0, 23),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__managua = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 1, 16, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 240, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic))));
};
var $justinmimbs$timezone_data$TimeZone$america__manaus = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 8, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 22, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__martinique = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 8, 28, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__matamoros = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__mazatlan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__menominee = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 3, 29, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__merida = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 11, 26, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 10, 2, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__metlakatla = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 10, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 10, 4, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 0, 20, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__mexico_city = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 1, 20, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__miquelon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Moncton = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1946,
		1972,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1957,
		1972,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		1,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__moncton = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__monterrey = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Uruguay = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		2,
		90),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1991,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 21),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2015,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2014,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__montevideo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 2, 10, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 11, 22, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay))));
};
var $justinmimbs$timezone_data$TimeZone$america__new_york = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__nome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__noronha = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 10, 7, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__center = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 9, 25, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 9, 26, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__nuuk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2023, 2, 26, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2023, 9, 29, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$america__ojinaga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 3, 5, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__panama = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__paramaribo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-210,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__phoenix = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Haiti = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1987,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1987,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1997,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1997,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2015,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2015,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__port_au_prince = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Haiti))));
};
var $justinmimbs$timezone_data$TimeZone$america__porto_velho = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__puerto_rico = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__punta_arenas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 11, 4, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__rankin_inlet = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 3, 1, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__recife = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__regina = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__resolute = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 3, 1, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 2, 11, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__rio_branco = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 5, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 10, 10, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__santarem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 5, 24, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__santiago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
};
var $justinmimbs$timezone_data$TimeZone$rules_DR = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1973,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1974,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__santo_domingo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_DR)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 11, 3, 60, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__sao_paulo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$rules_C_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__scoresbysund = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 2, 29, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2024, 2, 31, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$america__sitka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__st_johns = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-210,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-210,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__swift_current = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 3, 30, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Hond = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		7,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 0, 1),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__tegucigalpa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hond))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Thule = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__thule = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Thule))));
};
var $justinmimbs$timezone_data$TimeZone$america__tijuana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 1, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Toronto = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1946,
		1973,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1957,
		1973,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__toronto = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Toronto)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__vancouver = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__whitehorse = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Winn = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2005,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__winnipeg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Winn)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__yakutat = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__casey = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 18, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 5, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 9, 28, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 1, 21, 1020, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 9, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 2, 11, 240, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 7, 240, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 2, 17, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 9, 4, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 2, 8, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 9, 4, 1, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2021, 2, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2021, 9, 3, 1, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 2, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 9, 2, 1, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2023, 2, 9, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__davis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 18, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 10, 1200, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 9, 28, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 1, 21, 1200, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AT = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1968,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1971,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1981,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1986,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1990,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1999,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$antarctica__macquarie = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__mawson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 18, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__palmer = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 11, 4, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__rothera = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 11, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Troll = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		120),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$antarctica__troll = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, 1, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Troll))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__vostok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 1, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 10, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2023, 11, 18, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_RussiaAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2010,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2010,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__almaty = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2024, 2, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Jordan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1988,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1998,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1998,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2002,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2012,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2011,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2021,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2022,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__amman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 9, 28, 0, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Russia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2010,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2010,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__anadyr = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						780,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aqtau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 25, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aqtobe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ashgabat = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__atyrau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Iraq = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1984,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1990,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2007,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__baghdad = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 4, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iraq))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Azer = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2015,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		240,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2015,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		300,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_EUAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__baku = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Azer))));
};
var $justinmimbs$timezone_data$TimeZone$asia__bangkok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__barnaul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 4, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Lebanon = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1987,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1991,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1992,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1998,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__beirut = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Lebanon))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Kyrgyz = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1996,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 7),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1996,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		150,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2004,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		150,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__bishkek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 7, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Kyrgyz)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, 7, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__chita = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__colombo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 4, 25, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						390,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 9, 26, 30, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 15, 30, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				330,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Syria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1976,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1978,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1996,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(0),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2006,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2011,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2022,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2022,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__damascus = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Syria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 9, 28, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Dhaka = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__dhaka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Dhaka))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dili = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 4, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 8, 17, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dubai = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dushanbe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 9, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cyprus = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1997,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__famagusta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 8, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 8, 8, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2017, 9, 29, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
};
var $justinmimbs$timezone_data$TimeZone$Specification$Prev = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $justinmimbs$timezone_data$TimeZone$rules_Palestine = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2005,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2003,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2007,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, 5, 30),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, 5, 30),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, 5, 30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2021,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, 5, 30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2021,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2035,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, 5, 30),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		2023,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2025,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2026,
		2054,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, 5, 30),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2036,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2037,
		2037,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Zion = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1440,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1440,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1995,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2012,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, 4, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 23),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__gaza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 7, 29, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 8, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 27, 1, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 7, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
};
var $justinmimbs$timezone_data$TimeZone$asia__hebron = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 5, 13, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_HK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1976,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1976,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		210,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__hong_kong = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_HK))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mongol = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1998,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2006,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2006,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2016,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2016,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__hovd = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__irkutsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__jakarta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__jayapura = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__jerusalem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kabul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				270,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kamchatka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Pakistan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__karachi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 2, 26, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Pakistan))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kathmandu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				345,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__khandyga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 8, 13, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kolkata = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				330,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kuching = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Macau = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1973,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1976,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1976,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__macau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Macau))));
};
var $justinmimbs$timezone_data$TimeZone$asia__magadan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 3, 24, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__makassar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Phil = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		1440,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__manila = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Phil))));
};
var $justinmimbs$timezone_data$TimeZone$asia__nicosia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 8, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
};
var $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__novosibirsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 4, 23, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 6, 24, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__omsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__oral = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__pontianak = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__pyongyang = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 7, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						510,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 4, 4, 1410, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qatar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 5, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qostanay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2024, 2, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qyzylorda = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 11, 21, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__riyadh = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__sakhalin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 2, 30, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__samarkand = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_ROK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		180,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__seoul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_ROK))));
};
var $justinmimbs$timezone_data$TimeZone$rules_PRC = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1991,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 11),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1991,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 11),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__shanghai = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_PRC))));
};
var $justinmimbs$timezone_data$TimeZone$asia__singapore = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						450,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 11, 31, 960, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Taiwan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__taipei = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Taiwan))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tashkent = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_E_EurAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__tbilisi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 25, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 9, 27, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 2, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 27, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, 2, 27, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Iran = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1995,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1999,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1999,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2003,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2003,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2011,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2011,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2015,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2015,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2019,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2019,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2022,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2022,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__tehran = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						210,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 9, 20, 1440, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 10, 10, 1440, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				210,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran))));
};
var $justinmimbs$timezone_data$TimeZone$asia__thimphu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tokyo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tomsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 4, 1, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 4, 29, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__urumqi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ust_nera = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 8, 13, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__vladivostok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yakutsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yangon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				390,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Armenia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__yerevan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 8, 24, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Armenia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Port = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1986,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1985,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$atlantic__azores = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 2, 28, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 11, 27, 60, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 5, 17, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__bermuda = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 3, 28, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__canary = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 8, 28, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 10, 25, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__faroe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__madeira = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 6, 31, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Falk = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2000,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		2000,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2010,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2010,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$atlantic__stanley = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, 8, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 8, 5, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AS = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1985,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__adelaide = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AQ = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1991,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1992,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__brisbane = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AN = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1981,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1985,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__broken_hill = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
};
var $justinmimbs$timezone_data$TimeZone$australia__darwin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AW = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2009,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2008,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__eucla = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				525,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
};
var $justinmimbs$timezone_data$TimeZone$australia__hobart = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Holiday = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1994,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__lindeman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 6, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Holiday))));
};
var $justinmimbs$timezone_data$TimeZone$rules_LH = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1985,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		30)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__lord_howe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						630,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, 6, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				630,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AV = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1985,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1994,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__melbourne = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AV))));
};
var $justinmimbs$timezone_data$TimeZone$australia__perth = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
};
var $justinmimbs$timezone_data$TimeZone$australia__sydney = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
};
var $justinmimbs$timezone_data$TimeZone$europe__andorra = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, 2, 31, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__astrakhan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Greece = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		240,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		540,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__athens = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Greece)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__belgrade = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 10, 27, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__berlin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__brussels = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_E_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Romania = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1993,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__bucharest = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Hungary = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__budapest = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hungary)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Moldova = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__chisinau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 4, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moldova))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Eire = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		0,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		120,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		120,
		0,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		60,
		0,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		60,
		0,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		-60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__dublin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Eire))));
};
var $justinmimbs$timezone_data$TimeZone$europe__gibraltar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Finland = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__helsinki = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Finland)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Turkey = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1976,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 31),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2006,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__istanbul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 5, 29, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 10, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 28, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 2, 30, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 2, 31, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 9, 25, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 10, 8, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 8, 7, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__kaliningrad = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__kirov = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__kyiv = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 6, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 4, 13, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__lisbon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 8, 26, 60, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 27, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 2, 31, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_GB_Eire = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1995,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		60,
		0,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__london = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 9, 31, 120, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_GB_Eire)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Italy = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1969,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1972,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1979,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Malta = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1979,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1980,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__malta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 2, 31, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Malta)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__minsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__moscow = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_France = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		60,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__paris = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_France)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__prague = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Latvia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1996,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1996,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__riga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 8, 24, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Latvia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 21, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 1, 29, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 0, 2, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__rome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__samara = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__saratov = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 11, 4, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__simferopol = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 6, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 2, 31, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 9, 27, 180, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 2, 30, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 2, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Bulg = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1982,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 1),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__sofia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 2, 31, 1380, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Bulg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 8, 26, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__tallinn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 8, 24, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 8, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 240, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 1, 21, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Albania = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__tirane = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Albania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 6, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Austria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__vienna = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Austria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__vilnius = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 2, 29, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__volgograd = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 11, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_W_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__warsaw = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__zurich = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$indian__chagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__maldives = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mauritius = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$indian__mauritius = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mauritius))));
};
var $justinmimbs$timezone_data$TimeZone$rules_WS = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 1),
		240,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		180,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2021,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		240,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2020,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__apia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 11, 29, 1440, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS))));
};
var $justinmimbs$timezone_data$TimeZone$rules_NZ = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2006,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2007,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__auckland = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NZ))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__bougainville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 11, 28, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Chatham = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		165,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		165,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2006,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2007,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		165,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		165,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__chatham = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				765,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chatham))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__easter = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 2, 14, 180, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Vanuatu = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		720,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		720,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1991,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1991,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22),
		1440,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__efate = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanuatu))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__fakaofo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 11, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Fiji = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1999,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2000,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2013,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 21),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2013,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 18),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 18),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2018,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2021,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 12),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__fiji = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Fiji))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__galapagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__gambier = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Guam = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1971,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1971,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		121,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__guam = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guam)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 11, 23, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__honolulu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kanton = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 11, 31, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kiritimati = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-640,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 11, 31, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				840,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kosrae = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kwajalein = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 7, 20, 1440, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__marquesas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-570,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__nauru = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 1, 10, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__niue = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__norfolk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 2, 2, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 9, 4, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 6, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
};
var $justinmimbs$timezone_data$TimeZone$rules_NC = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		11,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__noumea = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NC))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pago_pago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__palau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pitcairn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-510,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 3, 27, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__port_moresby = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cook = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1991,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1990,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		30)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__rarotonga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-630,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 10, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cook))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__tahiti = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__tarawa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Tonga = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2002,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		180,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__tongatapu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						780,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tonga))));
};
var $justinmimbs$timezone_data$TimeZone$zones = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Africa/Abidjan', $justinmimbs$timezone_data$TimeZone$africa__abidjan),
			_Utils_Tuple2('Africa/Algiers', $justinmimbs$timezone_data$TimeZone$africa__algiers),
			_Utils_Tuple2('Africa/Bissau', $justinmimbs$timezone_data$TimeZone$africa__bissau),
			_Utils_Tuple2('Africa/Cairo', $justinmimbs$timezone_data$TimeZone$africa__cairo),
			_Utils_Tuple2('Africa/Casablanca', $justinmimbs$timezone_data$TimeZone$africa__casablanca),
			_Utils_Tuple2('Africa/Ceuta', $justinmimbs$timezone_data$TimeZone$africa__ceuta),
			_Utils_Tuple2('Africa/El_Aaiun', $justinmimbs$timezone_data$TimeZone$africa__el_aaiun),
			_Utils_Tuple2('Africa/Johannesburg', $justinmimbs$timezone_data$TimeZone$africa__johannesburg),
			_Utils_Tuple2('Africa/Juba', $justinmimbs$timezone_data$TimeZone$africa__juba),
			_Utils_Tuple2('Africa/Khartoum', $justinmimbs$timezone_data$TimeZone$africa__khartoum),
			_Utils_Tuple2('Africa/Lagos', $justinmimbs$timezone_data$TimeZone$africa__lagos),
			_Utils_Tuple2('Africa/Maputo', $justinmimbs$timezone_data$TimeZone$africa__maputo),
			_Utils_Tuple2('Africa/Monrovia', $justinmimbs$timezone_data$TimeZone$africa__monrovia),
			_Utils_Tuple2('Africa/Nairobi', $justinmimbs$timezone_data$TimeZone$africa__nairobi),
			_Utils_Tuple2('Africa/Ndjamena', $justinmimbs$timezone_data$TimeZone$africa__ndjamena),
			_Utils_Tuple2('Africa/Sao_Tome', $justinmimbs$timezone_data$TimeZone$africa__sao_tome),
			_Utils_Tuple2('Africa/Tripoli', $justinmimbs$timezone_data$TimeZone$africa__tripoli),
			_Utils_Tuple2('Africa/Tunis', $justinmimbs$timezone_data$TimeZone$africa__tunis),
			_Utils_Tuple2('Africa/Windhoek', $justinmimbs$timezone_data$TimeZone$africa__windhoek),
			_Utils_Tuple2('America/Adak', $justinmimbs$timezone_data$TimeZone$america__adak),
			_Utils_Tuple2('America/Anchorage', $justinmimbs$timezone_data$TimeZone$america__anchorage),
			_Utils_Tuple2('America/Araguaina', $justinmimbs$timezone_data$TimeZone$america__araguaina),
			_Utils_Tuple2('America/Argentina/Buenos_Aires', $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires),
			_Utils_Tuple2('America/Argentina/Catamarca', $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca),
			_Utils_Tuple2('America/Argentina/Cordoba', $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba),
			_Utils_Tuple2('America/Argentina/Jujuy', $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy),
			_Utils_Tuple2('America/Argentina/La_Rioja', $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja),
			_Utils_Tuple2('America/Argentina/Mendoza', $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza),
			_Utils_Tuple2('America/Argentina/Rio_Gallegos', $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos),
			_Utils_Tuple2('America/Argentina/Salta', $justinmimbs$timezone_data$TimeZone$america__argentina__salta),
			_Utils_Tuple2('America/Argentina/San_Juan', $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan),
			_Utils_Tuple2('America/Argentina/San_Luis', $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis),
			_Utils_Tuple2('America/Argentina/Tucuman', $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman),
			_Utils_Tuple2('America/Argentina/Ushuaia', $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia),
			_Utils_Tuple2('America/Asuncion', $justinmimbs$timezone_data$TimeZone$america__asuncion),
			_Utils_Tuple2('America/Bahia', $justinmimbs$timezone_data$TimeZone$america__bahia),
			_Utils_Tuple2('America/Bahia_Banderas', $justinmimbs$timezone_data$TimeZone$america__bahia_banderas),
			_Utils_Tuple2('America/Barbados', $justinmimbs$timezone_data$TimeZone$america__barbados),
			_Utils_Tuple2('America/Belem', $justinmimbs$timezone_data$TimeZone$america__belem),
			_Utils_Tuple2('America/Belize', $justinmimbs$timezone_data$TimeZone$america__belize),
			_Utils_Tuple2('America/Boa_Vista', $justinmimbs$timezone_data$TimeZone$america__boa_vista),
			_Utils_Tuple2('America/Bogota', $justinmimbs$timezone_data$TimeZone$america__bogota),
			_Utils_Tuple2('America/Boise', $justinmimbs$timezone_data$TimeZone$america__boise),
			_Utils_Tuple2('America/Cambridge_Bay', $justinmimbs$timezone_data$TimeZone$america__cambridge_bay),
			_Utils_Tuple2('America/Campo_Grande', $justinmimbs$timezone_data$TimeZone$america__campo_grande),
			_Utils_Tuple2('America/Cancun', $justinmimbs$timezone_data$TimeZone$america__cancun),
			_Utils_Tuple2('America/Caracas', $justinmimbs$timezone_data$TimeZone$america__caracas),
			_Utils_Tuple2('America/Cayenne', $justinmimbs$timezone_data$TimeZone$america__cayenne),
			_Utils_Tuple2('America/Chicago', $justinmimbs$timezone_data$TimeZone$america__chicago),
			_Utils_Tuple2('America/Chihuahua', $justinmimbs$timezone_data$TimeZone$america__chihuahua),
			_Utils_Tuple2('America/Ciudad_Juarez', $justinmimbs$timezone_data$TimeZone$america__ciudad_juarez),
			_Utils_Tuple2('America/Costa_Rica', $justinmimbs$timezone_data$TimeZone$america__costa_rica),
			_Utils_Tuple2('America/Coyhaique', $justinmimbs$timezone_data$TimeZone$america__coyhaique),
			_Utils_Tuple2('America/Cuiaba', $justinmimbs$timezone_data$TimeZone$america__cuiaba),
			_Utils_Tuple2('America/Danmarkshavn', $justinmimbs$timezone_data$TimeZone$america__danmarkshavn),
			_Utils_Tuple2('America/Dawson', $justinmimbs$timezone_data$TimeZone$america__dawson),
			_Utils_Tuple2('America/Dawson_Creek', $justinmimbs$timezone_data$TimeZone$america__dawson_creek),
			_Utils_Tuple2('America/Denver', $justinmimbs$timezone_data$TimeZone$america__denver),
			_Utils_Tuple2('America/Detroit', $justinmimbs$timezone_data$TimeZone$america__detroit),
			_Utils_Tuple2('America/Edmonton', $justinmimbs$timezone_data$TimeZone$america__edmonton),
			_Utils_Tuple2('America/Eirunepe', $justinmimbs$timezone_data$TimeZone$america__eirunepe),
			_Utils_Tuple2('America/El_Salvador', $justinmimbs$timezone_data$TimeZone$america__el_salvador),
			_Utils_Tuple2('America/Fort_Nelson', $justinmimbs$timezone_data$TimeZone$america__fort_nelson),
			_Utils_Tuple2('America/Fortaleza', $justinmimbs$timezone_data$TimeZone$america__fortaleza),
			_Utils_Tuple2('America/Glace_Bay', $justinmimbs$timezone_data$TimeZone$america__glace_bay),
			_Utils_Tuple2('America/Goose_Bay', $justinmimbs$timezone_data$TimeZone$america__goose_bay),
			_Utils_Tuple2('America/Grand_Turk', $justinmimbs$timezone_data$TimeZone$america__grand_turk),
			_Utils_Tuple2('America/Guatemala', $justinmimbs$timezone_data$TimeZone$america__guatemala),
			_Utils_Tuple2('America/Guayaquil', $justinmimbs$timezone_data$TimeZone$america__guayaquil),
			_Utils_Tuple2('America/Guyana', $justinmimbs$timezone_data$TimeZone$america__guyana),
			_Utils_Tuple2('America/Halifax', $justinmimbs$timezone_data$TimeZone$america__halifax),
			_Utils_Tuple2('America/Havana', $justinmimbs$timezone_data$TimeZone$america__havana),
			_Utils_Tuple2('America/Hermosillo', $justinmimbs$timezone_data$TimeZone$america__hermosillo),
			_Utils_Tuple2('America/Indiana/Indianapolis', $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis),
			_Utils_Tuple2('America/Indiana/Knox', $justinmimbs$timezone_data$TimeZone$america__indiana__knox),
			_Utils_Tuple2('America/Indiana/Marengo', $justinmimbs$timezone_data$TimeZone$america__indiana__marengo),
			_Utils_Tuple2('America/Indiana/Petersburg', $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg),
			_Utils_Tuple2('America/Indiana/Tell_City', $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city),
			_Utils_Tuple2('America/Indiana/Vevay', $justinmimbs$timezone_data$TimeZone$america__indiana__vevay),
			_Utils_Tuple2('America/Indiana/Vincennes', $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes),
			_Utils_Tuple2('America/Indiana/Winamac', $justinmimbs$timezone_data$TimeZone$america__indiana__winamac),
			_Utils_Tuple2('America/Inuvik', $justinmimbs$timezone_data$TimeZone$america__inuvik),
			_Utils_Tuple2('America/Iqaluit', $justinmimbs$timezone_data$TimeZone$america__iqaluit),
			_Utils_Tuple2('America/Jamaica', $justinmimbs$timezone_data$TimeZone$america__jamaica),
			_Utils_Tuple2('America/Juneau', $justinmimbs$timezone_data$TimeZone$america__juneau),
			_Utils_Tuple2('America/Kentucky/Louisville', $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville),
			_Utils_Tuple2('America/Kentucky/Monticello', $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello),
			_Utils_Tuple2('America/La_Paz', $justinmimbs$timezone_data$TimeZone$america__la_paz),
			_Utils_Tuple2('America/Lima', $justinmimbs$timezone_data$TimeZone$america__lima),
			_Utils_Tuple2('America/Los_Angeles', $justinmimbs$timezone_data$TimeZone$america__los_angeles),
			_Utils_Tuple2('America/Maceio', $justinmimbs$timezone_data$TimeZone$america__maceio),
			_Utils_Tuple2('America/Managua', $justinmimbs$timezone_data$TimeZone$america__managua),
			_Utils_Tuple2('America/Manaus', $justinmimbs$timezone_data$TimeZone$america__manaus),
			_Utils_Tuple2('America/Martinique', $justinmimbs$timezone_data$TimeZone$america__martinique),
			_Utils_Tuple2('America/Matamoros', $justinmimbs$timezone_data$TimeZone$america__matamoros),
			_Utils_Tuple2('America/Mazatlan', $justinmimbs$timezone_data$TimeZone$america__mazatlan),
			_Utils_Tuple2('America/Menominee', $justinmimbs$timezone_data$TimeZone$america__menominee),
			_Utils_Tuple2('America/Merida', $justinmimbs$timezone_data$TimeZone$america__merida),
			_Utils_Tuple2('America/Metlakatla', $justinmimbs$timezone_data$TimeZone$america__metlakatla),
			_Utils_Tuple2('America/Mexico_City', $justinmimbs$timezone_data$TimeZone$america__mexico_city),
			_Utils_Tuple2('America/Miquelon', $justinmimbs$timezone_data$TimeZone$america__miquelon),
			_Utils_Tuple2('America/Moncton', $justinmimbs$timezone_data$TimeZone$america__moncton),
			_Utils_Tuple2('America/Monterrey', $justinmimbs$timezone_data$TimeZone$america__monterrey),
			_Utils_Tuple2('America/Montevideo', $justinmimbs$timezone_data$TimeZone$america__montevideo),
			_Utils_Tuple2('America/New_York', $justinmimbs$timezone_data$TimeZone$america__new_york),
			_Utils_Tuple2('America/Nome', $justinmimbs$timezone_data$TimeZone$america__nome),
			_Utils_Tuple2('America/Noronha', $justinmimbs$timezone_data$TimeZone$america__noronha),
			_Utils_Tuple2('America/North_Dakota/Beulah', $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah),
			_Utils_Tuple2('America/North_Dakota/Center', $justinmimbs$timezone_data$TimeZone$america__north_dakota__center),
			_Utils_Tuple2('America/North_Dakota/New_Salem', $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem),
			_Utils_Tuple2('America/Nuuk', $justinmimbs$timezone_data$TimeZone$america__nuuk),
			_Utils_Tuple2('America/Ojinaga', $justinmimbs$timezone_data$TimeZone$america__ojinaga),
			_Utils_Tuple2('America/Panama', $justinmimbs$timezone_data$TimeZone$america__panama),
			_Utils_Tuple2('America/Paramaribo', $justinmimbs$timezone_data$TimeZone$america__paramaribo),
			_Utils_Tuple2('America/Phoenix', $justinmimbs$timezone_data$TimeZone$america__phoenix),
			_Utils_Tuple2('America/Port-au-Prince', $justinmimbs$timezone_data$TimeZone$america__port_au_prince),
			_Utils_Tuple2('America/Porto_Velho', $justinmimbs$timezone_data$TimeZone$america__porto_velho),
			_Utils_Tuple2('America/Puerto_Rico', $justinmimbs$timezone_data$TimeZone$america__puerto_rico),
			_Utils_Tuple2('America/Punta_Arenas', $justinmimbs$timezone_data$TimeZone$america__punta_arenas),
			_Utils_Tuple2('America/Rankin_Inlet', $justinmimbs$timezone_data$TimeZone$america__rankin_inlet),
			_Utils_Tuple2('America/Recife', $justinmimbs$timezone_data$TimeZone$america__recife),
			_Utils_Tuple2('America/Regina', $justinmimbs$timezone_data$TimeZone$america__regina),
			_Utils_Tuple2('America/Resolute', $justinmimbs$timezone_data$TimeZone$america__resolute),
			_Utils_Tuple2('America/Rio_Branco', $justinmimbs$timezone_data$TimeZone$america__rio_branco),
			_Utils_Tuple2('America/Santarem', $justinmimbs$timezone_data$TimeZone$america__santarem),
			_Utils_Tuple2('America/Santiago', $justinmimbs$timezone_data$TimeZone$america__santiago),
			_Utils_Tuple2('America/Santo_Domingo', $justinmimbs$timezone_data$TimeZone$america__santo_domingo),
			_Utils_Tuple2('America/Sao_Paulo', $justinmimbs$timezone_data$TimeZone$america__sao_paulo),
			_Utils_Tuple2('America/Scoresbysund', $justinmimbs$timezone_data$TimeZone$america__scoresbysund),
			_Utils_Tuple2('America/Sitka', $justinmimbs$timezone_data$TimeZone$america__sitka),
			_Utils_Tuple2('America/St_Johns', $justinmimbs$timezone_data$TimeZone$america__st_johns),
			_Utils_Tuple2('America/Swift_Current', $justinmimbs$timezone_data$TimeZone$america__swift_current),
			_Utils_Tuple2('America/Tegucigalpa', $justinmimbs$timezone_data$TimeZone$america__tegucigalpa),
			_Utils_Tuple2('America/Thule', $justinmimbs$timezone_data$TimeZone$america__thule),
			_Utils_Tuple2('America/Tijuana', $justinmimbs$timezone_data$TimeZone$america__tijuana),
			_Utils_Tuple2('America/Toronto', $justinmimbs$timezone_data$TimeZone$america__toronto),
			_Utils_Tuple2('America/Vancouver', $justinmimbs$timezone_data$TimeZone$america__vancouver),
			_Utils_Tuple2('America/Whitehorse', $justinmimbs$timezone_data$TimeZone$america__whitehorse),
			_Utils_Tuple2('America/Winnipeg', $justinmimbs$timezone_data$TimeZone$america__winnipeg),
			_Utils_Tuple2('America/Yakutat', $justinmimbs$timezone_data$TimeZone$america__yakutat),
			_Utils_Tuple2('Antarctica/Casey', $justinmimbs$timezone_data$TimeZone$antarctica__casey),
			_Utils_Tuple2('Antarctica/Davis', $justinmimbs$timezone_data$TimeZone$antarctica__davis),
			_Utils_Tuple2('Antarctica/Macquarie', $justinmimbs$timezone_data$TimeZone$antarctica__macquarie),
			_Utils_Tuple2('Antarctica/Mawson', $justinmimbs$timezone_data$TimeZone$antarctica__mawson),
			_Utils_Tuple2('Antarctica/Palmer', $justinmimbs$timezone_data$TimeZone$antarctica__palmer),
			_Utils_Tuple2('Antarctica/Rothera', $justinmimbs$timezone_data$TimeZone$antarctica__rothera),
			_Utils_Tuple2('Antarctica/Troll', $justinmimbs$timezone_data$TimeZone$antarctica__troll),
			_Utils_Tuple2('Antarctica/Vostok', $justinmimbs$timezone_data$TimeZone$antarctica__vostok),
			_Utils_Tuple2('Asia/Almaty', $justinmimbs$timezone_data$TimeZone$asia__almaty),
			_Utils_Tuple2('Asia/Amman', $justinmimbs$timezone_data$TimeZone$asia__amman),
			_Utils_Tuple2('Asia/Anadyr', $justinmimbs$timezone_data$TimeZone$asia__anadyr),
			_Utils_Tuple2('Asia/Aqtau', $justinmimbs$timezone_data$TimeZone$asia__aqtau),
			_Utils_Tuple2('Asia/Aqtobe', $justinmimbs$timezone_data$TimeZone$asia__aqtobe),
			_Utils_Tuple2('Asia/Ashgabat', $justinmimbs$timezone_data$TimeZone$asia__ashgabat),
			_Utils_Tuple2('Asia/Atyrau', $justinmimbs$timezone_data$TimeZone$asia__atyrau),
			_Utils_Tuple2('Asia/Baghdad', $justinmimbs$timezone_data$TimeZone$asia__baghdad),
			_Utils_Tuple2('Asia/Baku', $justinmimbs$timezone_data$TimeZone$asia__baku),
			_Utils_Tuple2('Asia/Bangkok', $justinmimbs$timezone_data$TimeZone$asia__bangkok),
			_Utils_Tuple2('Asia/Barnaul', $justinmimbs$timezone_data$TimeZone$asia__barnaul),
			_Utils_Tuple2('Asia/Beirut', $justinmimbs$timezone_data$TimeZone$asia__beirut),
			_Utils_Tuple2('Asia/Bishkek', $justinmimbs$timezone_data$TimeZone$asia__bishkek),
			_Utils_Tuple2('Asia/Chita', $justinmimbs$timezone_data$TimeZone$asia__chita),
			_Utils_Tuple2('Asia/Colombo', $justinmimbs$timezone_data$TimeZone$asia__colombo),
			_Utils_Tuple2('Asia/Damascus', $justinmimbs$timezone_data$TimeZone$asia__damascus),
			_Utils_Tuple2('Asia/Dhaka', $justinmimbs$timezone_data$TimeZone$asia__dhaka),
			_Utils_Tuple2('Asia/Dili', $justinmimbs$timezone_data$TimeZone$asia__dili),
			_Utils_Tuple2('Asia/Dubai', $justinmimbs$timezone_data$TimeZone$asia__dubai),
			_Utils_Tuple2('Asia/Dushanbe', $justinmimbs$timezone_data$TimeZone$asia__dushanbe),
			_Utils_Tuple2('Asia/Famagusta', $justinmimbs$timezone_data$TimeZone$asia__famagusta),
			_Utils_Tuple2('Asia/Gaza', $justinmimbs$timezone_data$TimeZone$asia__gaza),
			_Utils_Tuple2('Asia/Hebron', $justinmimbs$timezone_data$TimeZone$asia__hebron),
			_Utils_Tuple2('Asia/Ho_Chi_Minh', $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh),
			_Utils_Tuple2('Asia/Hong_Kong', $justinmimbs$timezone_data$TimeZone$asia__hong_kong),
			_Utils_Tuple2('Asia/Hovd', $justinmimbs$timezone_data$TimeZone$asia__hovd),
			_Utils_Tuple2('Asia/Irkutsk', $justinmimbs$timezone_data$TimeZone$asia__irkutsk),
			_Utils_Tuple2('Asia/Jakarta', $justinmimbs$timezone_data$TimeZone$asia__jakarta),
			_Utils_Tuple2('Asia/Jayapura', $justinmimbs$timezone_data$TimeZone$asia__jayapura),
			_Utils_Tuple2('Asia/Jerusalem', $justinmimbs$timezone_data$TimeZone$asia__jerusalem),
			_Utils_Tuple2('Asia/Kabul', $justinmimbs$timezone_data$TimeZone$asia__kabul),
			_Utils_Tuple2('Asia/Kamchatka', $justinmimbs$timezone_data$TimeZone$asia__kamchatka),
			_Utils_Tuple2('Asia/Karachi', $justinmimbs$timezone_data$TimeZone$asia__karachi),
			_Utils_Tuple2('Asia/Kathmandu', $justinmimbs$timezone_data$TimeZone$asia__kathmandu),
			_Utils_Tuple2('Asia/Khandyga', $justinmimbs$timezone_data$TimeZone$asia__khandyga),
			_Utils_Tuple2('Asia/Kolkata', $justinmimbs$timezone_data$TimeZone$asia__kolkata),
			_Utils_Tuple2('Asia/Krasnoyarsk', $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk),
			_Utils_Tuple2('Asia/Kuching', $justinmimbs$timezone_data$TimeZone$asia__kuching),
			_Utils_Tuple2('Asia/Macau', $justinmimbs$timezone_data$TimeZone$asia__macau),
			_Utils_Tuple2('Asia/Magadan', $justinmimbs$timezone_data$TimeZone$asia__magadan),
			_Utils_Tuple2('Asia/Makassar', $justinmimbs$timezone_data$TimeZone$asia__makassar),
			_Utils_Tuple2('Asia/Manila', $justinmimbs$timezone_data$TimeZone$asia__manila),
			_Utils_Tuple2('Asia/Nicosia', $justinmimbs$timezone_data$TimeZone$asia__nicosia),
			_Utils_Tuple2('Asia/Novokuznetsk', $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk),
			_Utils_Tuple2('Asia/Novosibirsk', $justinmimbs$timezone_data$TimeZone$asia__novosibirsk),
			_Utils_Tuple2('Asia/Omsk', $justinmimbs$timezone_data$TimeZone$asia__omsk),
			_Utils_Tuple2('Asia/Oral', $justinmimbs$timezone_data$TimeZone$asia__oral),
			_Utils_Tuple2('Asia/Pontianak', $justinmimbs$timezone_data$TimeZone$asia__pontianak),
			_Utils_Tuple2('Asia/Pyongyang', $justinmimbs$timezone_data$TimeZone$asia__pyongyang),
			_Utils_Tuple2('Asia/Qatar', $justinmimbs$timezone_data$TimeZone$asia__qatar),
			_Utils_Tuple2('Asia/Qostanay', $justinmimbs$timezone_data$TimeZone$asia__qostanay),
			_Utils_Tuple2('Asia/Qyzylorda', $justinmimbs$timezone_data$TimeZone$asia__qyzylorda),
			_Utils_Tuple2('Asia/Riyadh', $justinmimbs$timezone_data$TimeZone$asia__riyadh),
			_Utils_Tuple2('Asia/Sakhalin', $justinmimbs$timezone_data$TimeZone$asia__sakhalin),
			_Utils_Tuple2('Asia/Samarkand', $justinmimbs$timezone_data$TimeZone$asia__samarkand),
			_Utils_Tuple2('Asia/Seoul', $justinmimbs$timezone_data$TimeZone$asia__seoul),
			_Utils_Tuple2('Asia/Shanghai', $justinmimbs$timezone_data$TimeZone$asia__shanghai),
			_Utils_Tuple2('Asia/Singapore', $justinmimbs$timezone_data$TimeZone$asia__singapore),
			_Utils_Tuple2('Asia/Srednekolymsk', $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk),
			_Utils_Tuple2('Asia/Taipei', $justinmimbs$timezone_data$TimeZone$asia__taipei),
			_Utils_Tuple2('Asia/Tashkent', $justinmimbs$timezone_data$TimeZone$asia__tashkent),
			_Utils_Tuple2('Asia/Tbilisi', $justinmimbs$timezone_data$TimeZone$asia__tbilisi),
			_Utils_Tuple2('Asia/Tehran', $justinmimbs$timezone_data$TimeZone$asia__tehran),
			_Utils_Tuple2('Asia/Thimphu', $justinmimbs$timezone_data$TimeZone$asia__thimphu),
			_Utils_Tuple2('Asia/Tokyo', $justinmimbs$timezone_data$TimeZone$asia__tokyo),
			_Utils_Tuple2('Asia/Tomsk', $justinmimbs$timezone_data$TimeZone$asia__tomsk),
			_Utils_Tuple2('Asia/Ulaanbaatar', $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar),
			_Utils_Tuple2('Asia/Urumqi', $justinmimbs$timezone_data$TimeZone$asia__urumqi),
			_Utils_Tuple2('Asia/Ust-Nera', $justinmimbs$timezone_data$TimeZone$asia__ust_nera),
			_Utils_Tuple2('Asia/Vladivostok', $justinmimbs$timezone_data$TimeZone$asia__vladivostok),
			_Utils_Tuple2('Asia/Yakutsk', $justinmimbs$timezone_data$TimeZone$asia__yakutsk),
			_Utils_Tuple2('Asia/Yangon', $justinmimbs$timezone_data$TimeZone$asia__yangon),
			_Utils_Tuple2('Asia/Yekaterinburg', $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg),
			_Utils_Tuple2('Asia/Yerevan', $justinmimbs$timezone_data$TimeZone$asia__yerevan),
			_Utils_Tuple2('Atlantic/Azores', $justinmimbs$timezone_data$TimeZone$atlantic__azores),
			_Utils_Tuple2('Atlantic/Bermuda', $justinmimbs$timezone_data$TimeZone$atlantic__bermuda),
			_Utils_Tuple2('Atlantic/Canary', $justinmimbs$timezone_data$TimeZone$atlantic__canary),
			_Utils_Tuple2('Atlantic/Cape_Verde', $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde),
			_Utils_Tuple2('Atlantic/Faroe', $justinmimbs$timezone_data$TimeZone$atlantic__faroe),
			_Utils_Tuple2('Atlantic/Madeira', $justinmimbs$timezone_data$TimeZone$atlantic__madeira),
			_Utils_Tuple2('Atlantic/South_Georgia', $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia),
			_Utils_Tuple2('Atlantic/Stanley', $justinmimbs$timezone_data$TimeZone$atlantic__stanley),
			_Utils_Tuple2('Australia/Adelaide', $justinmimbs$timezone_data$TimeZone$australia__adelaide),
			_Utils_Tuple2('Australia/Brisbane', $justinmimbs$timezone_data$TimeZone$australia__brisbane),
			_Utils_Tuple2('Australia/Broken_Hill', $justinmimbs$timezone_data$TimeZone$australia__broken_hill),
			_Utils_Tuple2('Australia/Darwin', $justinmimbs$timezone_data$TimeZone$australia__darwin),
			_Utils_Tuple2('Australia/Eucla', $justinmimbs$timezone_data$TimeZone$australia__eucla),
			_Utils_Tuple2('Australia/Hobart', $justinmimbs$timezone_data$TimeZone$australia__hobart),
			_Utils_Tuple2('Australia/Lindeman', $justinmimbs$timezone_data$TimeZone$australia__lindeman),
			_Utils_Tuple2('Australia/Lord_Howe', $justinmimbs$timezone_data$TimeZone$australia__lord_howe),
			_Utils_Tuple2('Australia/Melbourne', $justinmimbs$timezone_data$TimeZone$australia__melbourne),
			_Utils_Tuple2('Australia/Perth', $justinmimbs$timezone_data$TimeZone$australia__perth),
			_Utils_Tuple2('Australia/Sydney', $justinmimbs$timezone_data$TimeZone$australia__sydney),
			_Utils_Tuple2('Europe/Andorra', $justinmimbs$timezone_data$TimeZone$europe__andorra),
			_Utils_Tuple2('Europe/Astrakhan', $justinmimbs$timezone_data$TimeZone$europe__astrakhan),
			_Utils_Tuple2('Europe/Athens', $justinmimbs$timezone_data$TimeZone$europe__athens),
			_Utils_Tuple2('Europe/Belgrade', $justinmimbs$timezone_data$TimeZone$europe__belgrade),
			_Utils_Tuple2('Europe/Berlin', $justinmimbs$timezone_data$TimeZone$europe__berlin),
			_Utils_Tuple2('Europe/Brussels', $justinmimbs$timezone_data$TimeZone$europe__brussels),
			_Utils_Tuple2('Europe/Bucharest', $justinmimbs$timezone_data$TimeZone$europe__bucharest),
			_Utils_Tuple2('Europe/Budapest', $justinmimbs$timezone_data$TimeZone$europe__budapest),
			_Utils_Tuple2('Europe/Chisinau', $justinmimbs$timezone_data$TimeZone$europe__chisinau),
			_Utils_Tuple2('Europe/Dublin', $justinmimbs$timezone_data$TimeZone$europe__dublin),
			_Utils_Tuple2('Europe/Gibraltar', $justinmimbs$timezone_data$TimeZone$europe__gibraltar),
			_Utils_Tuple2('Europe/Helsinki', $justinmimbs$timezone_data$TimeZone$europe__helsinki),
			_Utils_Tuple2('Europe/Istanbul', $justinmimbs$timezone_data$TimeZone$europe__istanbul),
			_Utils_Tuple2('Europe/Kaliningrad', $justinmimbs$timezone_data$TimeZone$europe__kaliningrad),
			_Utils_Tuple2('Europe/Kirov', $justinmimbs$timezone_data$TimeZone$europe__kirov),
			_Utils_Tuple2('Europe/Kyiv', $justinmimbs$timezone_data$TimeZone$europe__kyiv),
			_Utils_Tuple2('Europe/Lisbon', $justinmimbs$timezone_data$TimeZone$europe__lisbon),
			_Utils_Tuple2('Europe/London', $justinmimbs$timezone_data$TimeZone$europe__london),
			_Utils_Tuple2('Europe/Madrid', $justinmimbs$timezone_data$TimeZone$europe__madrid),
			_Utils_Tuple2('Europe/Malta', $justinmimbs$timezone_data$TimeZone$europe__malta),
			_Utils_Tuple2('Europe/Minsk', $justinmimbs$timezone_data$TimeZone$europe__minsk),
			_Utils_Tuple2('Europe/Moscow', $justinmimbs$timezone_data$TimeZone$europe__moscow),
			_Utils_Tuple2('Europe/Paris', $justinmimbs$timezone_data$TimeZone$europe__paris),
			_Utils_Tuple2('Europe/Prague', $justinmimbs$timezone_data$TimeZone$europe__prague),
			_Utils_Tuple2('Europe/Riga', $justinmimbs$timezone_data$TimeZone$europe__riga),
			_Utils_Tuple2('Europe/Rome', $justinmimbs$timezone_data$TimeZone$europe__rome),
			_Utils_Tuple2('Europe/Samara', $justinmimbs$timezone_data$TimeZone$europe__samara),
			_Utils_Tuple2('Europe/Saratov', $justinmimbs$timezone_data$TimeZone$europe__saratov),
			_Utils_Tuple2('Europe/Simferopol', $justinmimbs$timezone_data$TimeZone$europe__simferopol),
			_Utils_Tuple2('Europe/Sofia', $justinmimbs$timezone_data$TimeZone$europe__sofia),
			_Utils_Tuple2('Europe/Tallinn', $justinmimbs$timezone_data$TimeZone$europe__tallinn),
			_Utils_Tuple2('Europe/Tirane', $justinmimbs$timezone_data$TimeZone$europe__tirane),
			_Utils_Tuple2('Europe/Ulyanovsk', $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk),
			_Utils_Tuple2('Europe/Vienna', $justinmimbs$timezone_data$TimeZone$europe__vienna),
			_Utils_Tuple2('Europe/Vilnius', $justinmimbs$timezone_data$TimeZone$europe__vilnius),
			_Utils_Tuple2('Europe/Volgograd', $justinmimbs$timezone_data$TimeZone$europe__volgograd),
			_Utils_Tuple2('Europe/Warsaw', $justinmimbs$timezone_data$TimeZone$europe__warsaw),
			_Utils_Tuple2('Europe/Zurich', $justinmimbs$timezone_data$TimeZone$europe__zurich),
			_Utils_Tuple2('Indian/Chagos', $justinmimbs$timezone_data$TimeZone$indian__chagos),
			_Utils_Tuple2('Indian/Maldives', $justinmimbs$timezone_data$TimeZone$indian__maldives),
			_Utils_Tuple2('Indian/Mauritius', $justinmimbs$timezone_data$TimeZone$indian__mauritius),
			_Utils_Tuple2('Pacific/Apia', $justinmimbs$timezone_data$TimeZone$pacific__apia),
			_Utils_Tuple2('Pacific/Auckland', $justinmimbs$timezone_data$TimeZone$pacific__auckland),
			_Utils_Tuple2('Pacific/Bougainville', $justinmimbs$timezone_data$TimeZone$pacific__bougainville),
			_Utils_Tuple2('Pacific/Chatham', $justinmimbs$timezone_data$TimeZone$pacific__chatham),
			_Utils_Tuple2('Pacific/Easter', $justinmimbs$timezone_data$TimeZone$pacific__easter),
			_Utils_Tuple2('Pacific/Efate', $justinmimbs$timezone_data$TimeZone$pacific__efate),
			_Utils_Tuple2('Pacific/Fakaofo', $justinmimbs$timezone_data$TimeZone$pacific__fakaofo),
			_Utils_Tuple2('Pacific/Fiji', $justinmimbs$timezone_data$TimeZone$pacific__fiji),
			_Utils_Tuple2('Pacific/Galapagos', $justinmimbs$timezone_data$TimeZone$pacific__galapagos),
			_Utils_Tuple2('Pacific/Gambier', $justinmimbs$timezone_data$TimeZone$pacific__gambier),
			_Utils_Tuple2('Pacific/Guadalcanal', $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal),
			_Utils_Tuple2('Pacific/Guam', $justinmimbs$timezone_data$TimeZone$pacific__guam),
			_Utils_Tuple2('Pacific/Honolulu', $justinmimbs$timezone_data$TimeZone$pacific__honolulu),
			_Utils_Tuple2('Pacific/Kanton', $justinmimbs$timezone_data$TimeZone$pacific__kanton),
			_Utils_Tuple2('Pacific/Kiritimati', $justinmimbs$timezone_data$TimeZone$pacific__kiritimati),
			_Utils_Tuple2('Pacific/Kosrae', $justinmimbs$timezone_data$TimeZone$pacific__kosrae),
			_Utils_Tuple2('Pacific/Kwajalein', $justinmimbs$timezone_data$TimeZone$pacific__kwajalein),
			_Utils_Tuple2('Pacific/Marquesas', $justinmimbs$timezone_data$TimeZone$pacific__marquesas),
			_Utils_Tuple2('Pacific/Nauru', $justinmimbs$timezone_data$TimeZone$pacific__nauru),
			_Utils_Tuple2('Pacific/Niue', $justinmimbs$timezone_data$TimeZone$pacific__niue),
			_Utils_Tuple2('Pacific/Norfolk', $justinmimbs$timezone_data$TimeZone$pacific__norfolk),
			_Utils_Tuple2('Pacific/Noumea', $justinmimbs$timezone_data$TimeZone$pacific__noumea),
			_Utils_Tuple2('Pacific/Pago_Pago', $justinmimbs$timezone_data$TimeZone$pacific__pago_pago),
			_Utils_Tuple2('Pacific/Palau', $justinmimbs$timezone_data$TimeZone$pacific__palau),
			_Utils_Tuple2('Pacific/Pitcairn', $justinmimbs$timezone_data$TimeZone$pacific__pitcairn),
			_Utils_Tuple2('Pacific/Port_Moresby', $justinmimbs$timezone_data$TimeZone$pacific__port_moresby),
			_Utils_Tuple2('Pacific/Rarotonga', $justinmimbs$timezone_data$TimeZone$pacific__rarotonga),
			_Utils_Tuple2('Pacific/Tahiti', $justinmimbs$timezone_data$TimeZone$pacific__tahiti),
			_Utils_Tuple2('Pacific/Tarawa', $justinmimbs$timezone_data$TimeZone$pacific__tarawa),
			_Utils_Tuple2('Pacific/Tongatapu', $justinmimbs$timezone_data$TimeZone$pacific__tongatapu)
		]));
var $author$project$Main$init = F3(
	function (flags, url, key) {
		var route = $author$project$Route$fromUrl(url);
		var localTimeZone = A2(
			$elm$core$Maybe$withDefault,
			$elm$time$Time$utc,
			A2(
				$elm$core$Maybe$map,
				function (f) {
					return f(0);
				},
				A2($elm$core$Dict$get, flags.c3, $justinmimbs$timezone_data$TimeZone$zones)));
		var languageOverride = $author$project$Main$languageFromUrl(url);
		var language = A2(
			$elm$core$Maybe$withDefault,
			1,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$or,
				languageOverride,
				$author$project$Main$extractPreferredLanguage(flags.g8)));
		var env = A2(
			$author$project$Env$withLogoutPath,
			flags.c5,
			A2(
				$author$project$Env$withNewSearchApiEnabled,
				flags.c9,
				A2(
					$author$project$Env$withLoginPath,
					flags.c4,
					A2(
						$author$project$Env$withLanguageOverride,
						language,
						A2(
							$author$project$Env$withLocalTimeZone,
							localTimeZone,
							A2(
								$author$project$Env$withFunnelUrl,
								flags.cR,
								A2(
									$author$project$Env$withExternalApiUrl,
									flags.cP,
									A2(
										$author$project$Env$withNewApiUrl,
										flags.c7,
										A2($author$project$Env$withApiUrl, flags.cy + '/graphql', $author$project$Env$env)))))))));
		var _v0 = A3(
			$elm$core$Tuple$mapBoth,
			$author$project$Model$Login,
			$author$project$Effect$Login,
			A2(
				$author$project$Page$Login$init,
				$author$project$Env$newApiUrl(env),
				$elm$core$Maybe$Just(route)));
		var pageModel = _v0.a;
		var checkAuthEffect = _v0.b;
		var model = A4($author$project$Model$init, key, env, pageModel, language);
		return _Utils_Tuple2(
			model,
			A3($author$project$Effect$runEffect, env, model, checkAuthEffect));
	});
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Page$Search$Msg$ToastMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pyxis$Components$Toasts$Tick = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {lk: processes, lS: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.lk;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.lS);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$isTimeBlocked = function (timedEl) {
	switch (timedEl.$) {
		case 2:
			return true;
		case 0:
			return false;
		case 1:
			return false;
		default:
			return true;
	}
};
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$haveAllStopped = function (listTimed) {
	if (!listTimed.b) {
		return true;
	} else {
		var nonEmptylist = listTimed;
		return A2($elm$core$List$all, $author$project$Pyxis$Components$Toasts$ToastsHelpers$isTimeBlocked, nonEmptylist);
	}
};
var $author$project$Pyxis$Components$Toasts$subscription = function (_v0) {
	var model = _v0;
	var listOfTimedToast = A2(
		$elm$core$List$map,
		$elm$core$Tuple$second,
		$elm$core$Dict$toList(model.s));
	var deltaTickAsFloat = $author$project$Pyxis$Components$Toasts$ToastsHelpers$deltaIntervalInMilliseconds;
	return $author$project$Pyxis$Components$Toasts$ToastsHelpers$haveAllStopped(listOfTimedToast) ? $elm$core$Platform$Sub$none : A2(
		$elm$time$Time$every,
		deltaTickAsFloat,
		$elm$core$Basics$always(
			$author$project$Pyxis$Components$Toasts$Tick(deltaTickAsFloat)));
};
var $author$project$Page$Search$subscription = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Page$Search$Msg$ToastMsg,
		$author$project$Pyxis$Components$Toasts$subscription(model.s));
};
var $author$project$Page$OfferDetails$Msg$ToastMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$OfferDetails$toastCounterSubscription = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Page$OfferDetails$Msg$ToastMsg,
		$author$project$Pyxis$Components$Toasts$subscription(model.s));
};
var $author$project$Page$PolicyDetails$Msg$ToastMsg = function (a) {
	return {$: 45, a: a};
};
var $author$project$Page$PolicyDetails$toastCounterSubscription = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Page$PolicyDetails$Msg$ToastMsg,
		$author$project$Pyxis$Components$Toasts$subscription(model.s));
};
var $author$project$Main$subscribeToToastCounter = function (model) {
	var _v0 = model.oO;
	switch (_v0.$) {
		case 3:
			var searchModel = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$Search,
				$author$project$Page$Search$subscription(searchModel));
		case 6:
			var offerDetailModel = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$OfferDetails,
				$author$project$Page$OfferDetails$toastCounterSubscription(offerDetailModel));
		case 5:
			var policyDetailsModel = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$PolicyDetails,
				$author$project$Page$PolicyDetails$toastCounterSubscription(policyDetailsModel));
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Page$Payment$Msg$CreditCardReady = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Payment$Msg$NonceReceive = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Payment$Msg$NotifyErrorEvent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Payment$Msg$PaymentEvent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Payment$Msg$ValidateCreditCardFields = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Payment$Ports$creditCardReady = _Platform_incomingPort('creditCardReady', $elm$json$Json$Decode$bool);
var $author$project$Page$Payment$Ports$nonceReceived = _Platform_incomingPort('nonceReceived', $elm$json$Json$Decode$string);
var $author$project$Page$Payment$Ports$notifyErrorEvent = _Platform_incomingPort(
	'notifyErrorEvent',
	A2(
		$elm$json$Json$Decode$andThen,
		function (error) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (context) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (code) {
							return $elm$json$Json$Decode$succeed(
								{js: code, mB: context, jS: error});
						},
						A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'context', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string)));
var $author$project$Page$Payment$Ports$validateCreditCardFields = _Platform_incomingPort(
	'validateCreditCardFields',
	$elm$json$Json$Decode$list(
		A2(
			$elm$json$Json$Decode$andThen,
			function (isValid) {
				return A2(
					$elm$json$Json$Decode$andThen,
					function (isPristine) {
						return A2(
							$elm$json$Json$Decode$andThen,
							function (isFocused) {
								return A2(
									$elm$json$Json$Decode$andThen,
									function (id) {
										return $elm$json$Json$Decode$succeed(
											{kg: id, eH: isFocused, eM: isPristine, bQ: isValid});
									},
									A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
							},
							A2($elm$json$Json$Decode$field, 'isFocused', $elm$json$Json$Decode$bool));
					},
					A2($elm$json$Json$Decode$field, 'isPristine', $elm$json$Json$Decode$bool));
			},
			A2($elm$json$Json$Decode$field, 'isValid', $elm$json$Json$Decode$bool))));
var $author$project$Page$Payment$Subscriptions$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Page$Payment$Ports$creditCardReady(
			A2($elm$core$Basics$composeR, $author$project$Page$Payment$Msg$CreditCardReady, $author$project$Page$Payment$Msg$PaymentEvent)),
			$author$project$Page$Payment$Ports$notifyErrorEvent(
			A2($elm$core$Basics$composeR, $author$project$Page$Payment$Msg$NotifyErrorEvent, $author$project$Page$Payment$Msg$PaymentEvent)),
			$author$project$Page$Payment$Ports$validateCreditCardFields(
			A2($elm$core$Basics$composeR, $author$project$Page$Payment$Msg$ValidateCreditCardFields, $author$project$Page$Payment$Msg$PaymentEvent)),
			$author$project$Page$Payment$Ports$nonceReceived(
			A2($elm$core$Basics$composeR, $author$project$Page$Payment$Msg$NonceReceive, $author$project$Page$Payment$Msg$PaymentEvent))
		]));
var $author$project$Page$PolicyDetails$Msg$ReceivedIssueRefundReleaseDate = function (a) {
	return {$: 29, a: a};
};
var $author$project$Page$PolicyDetails$Ports$receiveManualRefundCutoff = _Platform_incomingPort('receiveManualRefundCutoff', $elm$json$Json$Decode$int);
var $author$project$Page$PolicyDetails$subscriptions = $author$project$Page$PolicyDetails$Ports$receiveManualRefundCutoff($author$project$Page$PolicyDetails$Msg$ReceivedIssueRefundReleaseDate);
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$core$Platform$Sub$map, $author$project$Msg$PolicyDetails, $author$project$Page$PolicyDetails$subscriptions),
				A2($elm$core$Platform$Sub$map, $author$project$Msg$Payment, $author$project$Page$Payment$Subscriptions$subscriptions),
				$author$project$Main$subscribeToToastCounter(model)
			]));
};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $author$project$Msg$Logout = {$: 6};
var $author$project$Msg$NavigationSidebarMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pyxis$Components$NavigationSidebar$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$NavigationSidebar$Content = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$NavigationSidebar$content = {f6: _List_Nil, ej: _List_Nil, kg: $elm$core$Maybe$Nothing, hq: $elm$core$Maybe$Nothing, hr: 'Navigation', iy: $elm$core$Maybe$Nothing, iz: $elm$core$Maybe$Nothing, fv: $elm$core$Maybe$Nothing};
var $author$project$Pyxis$Components$NavigationSidebar$Header = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$NavigationSidebar$header = {f6: _List_Nil, ej: _List_Nil, kg: $elm$core$Maybe$Nothing, hc: $elm$core$Maybe$Nothing, fv: $elm$core$Maybe$Nothing};
var $author$project$Pyxis$Components$NavigationSidebar$config = {fZ: $elm$core$Maybe$Nothing, f6: _List_Nil, gc: $author$project$Pyxis$Components$NavigationSidebar$content, ej: _List_Nil, gD: $elm$core$Maybe$Nothing, gO: $author$project$Pyxis$Components$NavigationSidebar$header, kg: $elm$core$Maybe$Nothing, fv: $elm$core$Maybe$Nothing};
var $author$project$Pyxis$Components$NavigationSidebar$Default = {$: 0};
var $author$project$Pyxis$Components$NavigationSidebar$Footer = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$NavigationSidebar$UserInfo = F2(
	function (email, name) {
		return {eq: email, kF: name};
	});
var $author$project$Pyxis$Components$NavigationSidebar$footer = F3(
	function (email, name, onLogout) {
		return {
			ay: $elm$core$Maybe$Nothing,
			f6: _List_Nil,
			ej: _List_Nil,
			kg: $elm$core$Maybe$Nothing,
			kU: onLogout,
			fv: $elm$core$Maybe$Nothing,
			iX: $author$project$Pyxis$Components$NavigationSidebar$Default,
			l_: A2($author$project$Pyxis$Components$NavigationSidebar$UserInfo, email, name)
		};
	});
var $author$project$Pyxis$Components$NavigationSidebar$Prima = {$: 0};
var $author$project$Pyxis$Components$NavigationSidebar$primaLogo = $author$project$Pyxis$Components$NavigationSidebar$Prima;
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$Pyxis$Commons$Attributes$dataAttribute = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return A2($elm$html$Html$Attributes$attribute, 'data-' + key, value);
};
var $author$project$Pyxis$Commons$Attributes$appendDataAttrList = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map($author$project$Pyxis$Commons$Attributes$dataAttribute),
	$elm$core$List$append);
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$html$Html$header = _VirtualDom_node('header');
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Pyxis$Components$NavigationSidebar$Expanded = 0;
var $author$project$Pyxis$Components$NavigationSidebar$isExpanded = function (_v0) {
	var expandState = _v0.cN;
	return !expandState;
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $author$project$Pyxis$Commons$Attributes$none = A2($elm$html$Html$Attributes$property, 'none@pyxis-elm', $elm$json$Json$Encode$null);
var $author$project$Pyxis$Commons$Attributes$maybe = function (f) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(f),
		$elm$core$Maybe$withDefault($author$project$Pyxis$Commons$Attributes$none));
};
var $author$project$Pyxis$Components$NavigationSidebar$Collapse = {$: 2};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Pyxis$Components$NavigationSidebar$overlay = function (tagger) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('side-panel__overlay'),
				$elm$html$Html$Events$onClick(
				tagger($author$project$Pyxis$Components$NavigationSidebar$Collapse))
			]),
		_List_Nil);
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Pyxis$Commons$Render$empty = $elm$html$Html$text('');
var $author$project$Pyxis$Commons$Render$renderMaybe = $elm$core$Maybe$withDefault($author$project$Pyxis$Commons$Render$empty);
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $author$project$Pyxis$Components$NavigationSidebar$elementIndexToKey = function (index) {
	return $TSFoster$elm_uuid$UUID$toString(
		A3(
			$primait$prima_elm_extra$PrimaFunction$flip,
			$TSFoster$elm_uuid$UUID$forName,
			$TSFoster$elm_uuid$UUID$urlNamespace,
			$elm$core$String$fromInt(index)));
};
var $author$project$Pyxis$Components$NavigationSidebar$ToggleGroupExpand = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pyxis$Components$IconSet$ChevronDown = 180;
var $author$project$Pyxis$Components$IconSet$chevronDown = 180;
var $author$project$Pyxis$Components$Icon$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Icon$Default = {$: 0};
var $author$project$Pyxis$Components$Icon$M = 1;
var $author$project$Pyxis$Components$Icon$config = function (icon) {
	return {fV: $elm$core$Maybe$Nothing, fX: $elm$core$Maybe$Nothing, f6: _List_Nil, ea: $elm$core$Maybe$Nothing, ej: _List_Nil, kf: icon, aO: 1, dA: $author$project$Pyxis$Components$Icon$Default};
};
var $author$project$Pyxis$Components$NavigationSidebar$isGroupExpanded = F2(
	function (groupId, _v0) {
		var model = _v0;
		return A2($elm$core$Set$member, groupId, model.aG);
	});
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$Pyxis$Commons$Render$maybeMapRender = function (renderFn) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(renderFn),
		$author$project$Pyxis$Commons$Render$renderMaybe);
};
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Pyxis$Commons$NonEmptyList$toList = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	return A2($elm$core$List$cons, head, tail);
};
var $author$project$Pyxis$Components$NavigationSidebar$pickNavItemGroupLinkHref = function (groupItemList_) {
	return A2(
		$elm$core$List$filterMap,
		function (navItemGroupLink) {
			if (!navItemGroupLink.$) {
				var c = navItemGroupLink.a;
				return $elm$core$Maybe$Just(c.cU);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		$author$project$Pyxis$Commons$NonEmptyList$toList(groupItemList_));
};
var $author$project$Pyxis$Commons$String$fromBool = function (bool) {
	return bool ? 'true' : 'false';
};
var $author$project$Pyxis$Commons$Attributes$ariaHidden = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Commons$String$fromBool,
	$elm$html$Html$Attributes$attribute('aria-hidden'));
var $author$project$Pyxis$Commons$Attributes$ariaLabel = $elm$html$Html$Attributes$attribute('aria-label');
var $author$project$Pyxis$Commons$Attributes$ariaLabelledBy = $elm$html$Html$Attributes$attribute('aria-labelledby');
var $author$project$Pyxis$Tokens$TypographyColor$toString = function (typographyColor) {
	switch (typographyColor) {
		case 0:
			return 'action';
		case 1:
			return 'alert';
		case 2:
			return 'brand';
		case 3:
			return 'content';
		case 4:
			return 'content-on-action';
		case 5:
			return 'content-on-action-surface';
		case 6:
			return 'content-on-alert';
		case 7:
			return 'content-on-alert-surface';
		case 8:
			return 'content-on-brand';
		case 9:
			return 'content-on-brand-surface';
		case 10:
			return 'content-on-error';
		case 11:
			return 'content-on-error-surface';
		case 12:
			return 'content-on-informative';
		case 13:
			return 'content-on-informative-surface';
		case 14:
			return 'content-on-inverse';
		case 15:
			return 'content-on-success';
		case 16:
			return 'content-on-success-surface';
		case 17:
			return 'content-weak';
		case 18:
			return 'error';
		case 19:
			return 'informative';
		default:
			return 'success';
	}
};
var $author$project$Pyxis$Components$Icon$getColorClass = function (maybeColor) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (color) {
				return 'c-' + $author$project$Pyxis$Tokens$TypographyColor$toString(color);
			},
			maybeColor));
};
var $author$project$Pyxis$Components$Icon$getEmphasisClass = function (style) {
	if (!style.$) {
		return '';
	} else {
		var emphasis = style.b;
		if (!emphasis) {
			return '';
		} else {
			return 'icon--strong';
		}
	}
};
var $author$project$Pyxis$Components$Icon$getSizeClass = function (size) {
	switch (size) {
		case 2:
			return 'icon--size-l';
		case 1:
			return 'icon--size-m';
		default:
			return 'icon--size-s';
	}
};
var $author$project$Pyxis$Components$Icon$getVariantClass = function (variant) {
	switch (variant) {
		case 0:
			return 'icon--boxed';
		case 1:
			return 'icon--boxed icon--brand';
		case 2:
			return 'icon--boxed icon--success';
		case 3:
			return 'icon--boxed icon--alert';
		case 4:
			return 'icon--boxed icon--error';
		default:
			return 'icon--boxed icon--informative';
	}
};
var $author$project$Pyxis$Components$Icon$getStyleClass = function (style) {
	if (!style.$) {
		return '';
	} else {
		var variant = style.a;
		return $author$project$Pyxis$Components$Icon$getVariantClass(variant);
	}
};
var $author$project$Pyxis$Components$Icon$getClassList = function (_v0) {
	var style = _v0.dA;
	var size = _v0.aO;
	var color = _v0.ea;
	var classList = _v0.f6;
	return A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$first,
			A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2('icon', true),
					_Utils_Tuple2(
					$author$project$Pyxis$Components$Icon$getSizeClass(size),
					true),
					_Utils_Tuple2(
					$author$project$Pyxis$Components$Icon$getStyleClass(style),
					true),
					_Utils_Tuple2(
					$author$project$Pyxis$Components$Icon$getEmphasisClass(style),
					true),
					_Utils_Tuple2(
					$author$project$Pyxis$Components$Icon$getColorClass(color),
					true)
				]),
			classList));
};
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $elm$svg$Svg$node = $elm$virtual_dom$VirtualDom$nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$Attributes$xlinkHref = function (value) {
	return A3(
		_VirtualDom_attributeNS,
		'http://www.w3.org/1999/xlink',
		'xlink:href',
		_VirtualDom_noJavaScriptUri(value));
};
var $Garados007$elm_svg_parser$SvgParser$toAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return (name === 'xlink:href') ? $elm$svg$Svg$Attributes$xlinkHref(value) : A2($elm$virtual_dom$VirtualDom$attribute, name, value);
};
var $Garados007$elm_svg_parser$SvgParser$elementToSvg = function (element) {
	return A3(
		$elm$svg$Svg$node,
		element.kF,
		A2($elm$core$List$map, $Garados007$elm_svg_parser$SvgParser$toAttribute, element.mm),
		A2($elm$core$List$map, $Garados007$elm_svg_parser$SvgParser$nodeToSvg, element.ae));
};
var $Garados007$elm_svg_parser$SvgParser$nodeToSvg = function (svgNode) {
	switch (svgNode.$) {
		case 0:
			var element = svgNode.a;
			return $Garados007$elm_svg_parser$SvgParser$elementToSvg(element);
		case 1:
			var content = svgNode.a;
			return $elm$svg$Svg$text(content);
		default:
			var content = svgNode.a;
			return $elm$svg$Svg$text('');
	}
};
var $andre_dietrich$parser_combinators$Combine$Parser = $elm$core$Basics$identity;
var $andre_dietrich$parser_combinators$Combine$app = function (_v0) {
	var inner = _v0;
	return inner;
};
var $andre_dietrich$parser_combinators$Combine$andThen = F2(
	function (f, p) {
		return F2(
			function (state, stream) {
				var _v0 = A3($andre_dietrich$parser_combinators$Combine$app, p, state, stream);
				if (!_v0.c.$) {
					var rstate = _v0.a;
					var rstream = _v0.b;
					var res = _v0.c.a;
					return A3(
						$andre_dietrich$parser_combinators$Combine$app,
						f(res),
						rstate,
						rstream);
				} else {
					var estate = _v0.a;
					var estream = _v0.b;
					var ms = _v0.c.a;
					return _Utils_Tuple3(
						estate,
						estream,
						$elm$core$Result$Err(ms));
				}
			});
	});
var $pilatch$flip$Flip$flip = F3(
	function (_function, argB, argA) {
		return A2(_function, argA, argB);
	});
var $andre_dietrich$parser_combinators$Combine$bimap = F3(
	function (fok, ferr, p) {
		return F2(
			function (state, stream) {
				var _v0 = A3($andre_dietrich$parser_combinators$Combine$app, p, state, stream);
				if (!_v0.c.$) {
					var rstate = _v0.a;
					var rstream = _v0.b;
					var res = _v0.c.a;
					return _Utils_Tuple3(
						rstate,
						rstream,
						$elm$core$Result$Ok(
							fok(res)));
				} else {
					var estate = _v0.a;
					var estream = _v0.b;
					var ms = _v0.c.a;
					return _Utils_Tuple3(
						estate,
						estream,
						$elm$core$Result$Err(
							ferr(ms)));
				}
			});
	});
var $andre_dietrich$parser_combinators$Combine$map = F2(
	function (f, p) {
		return A3($andre_dietrich$parser_combinators$Combine$bimap, f, $elm$core$Basics$identity, p);
	});
var $andre_dietrich$parser_combinators$Combine$andMap = F2(
	function (rp, lp) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$andThen,
			A2($pilatch$flip$Flip$flip, $andre_dietrich$parser_combinators$Combine$map, rp),
			lp);
	});
var $Garados007$elm_svg_parser$SvgParser$flip = F3(
	function (func, b, a) {
		return A2(func, a, b);
	});
var $Garados007$elm_svg_parser$SvgParser$andMapRight = F2(
	function (lp, rp) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$andMap,
			rp,
			A2(
				$andre_dietrich$parser_combinators$Combine$map,
				$Garados007$elm_svg_parser$SvgParser$flip($elm$core$Basics$always),
				lp));
	});
var $andre_dietrich$parser_combinators$Combine$many = function (p) {
	var accumulate = F3(
		function (acc, state, stream) {
			accumulate:
			while (true) {
				var _v0 = A3($andre_dietrich$parser_combinators$Combine$app, p, state, stream);
				if (!_v0.c.$) {
					var rstate = _v0.a;
					var rstream = _v0.b;
					var res = _v0.c.a;
					if (_Utils_eq(stream, rstream)) {
						return _Utils_Tuple3(
							rstate,
							rstream,
							$elm$core$List$reverse(acc));
					} else {
						var $temp$acc = A2($elm$core$List$cons, res, acc),
							$temp$state = rstate,
							$temp$stream = rstream;
						acc = $temp$acc;
						state = $temp$state;
						stream = $temp$stream;
						continue accumulate;
					}
				} else {
					return _Utils_Tuple3(
						state,
						stream,
						$elm$core$List$reverse(acc));
				}
			}
		});
	return F2(
		function (state, stream) {
			var _v1 = A3(accumulate, _List_Nil, state, stream);
			var rstate = _v1.a;
			var rstream = _v1.b;
			var res = _v1.c;
			return _Utils_Tuple3(
				rstate,
				rstream,
				$elm$core$Result$Ok(res));
		});
};
var $Garados007$elm_svg_parser$SvgParser$SvgElement = function (a) {
	return {$: 0, a: a};
};
var $Garados007$elm_svg_parser$SvgParser$andMapLeft = F2(
	function (lp, rp) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$andMap,
			rp,
			A2($andre_dietrich$parser_combinators$Combine$map, $elm$core$Basics$always, lp));
	});
var $andre_dietrich$parser_combinators$Combine$emptyErr = F2(
	function (state, stream) {
		return _Utils_Tuple3(
			state,
			stream,
			$elm$core$Result$Err(_List_Nil));
	});
var $andre_dietrich$parser_combinators$Combine$or = F2(
	function (lp, rp) {
		return F2(
			function (state, stream) {
				var _v0 = A3($andre_dietrich$parser_combinators$Combine$app, lp, state, stream);
				if (!_v0.c.$) {
					var res = _v0;
					return res;
				} else {
					var lms = _v0.c.a;
					var _v1 = A3($andre_dietrich$parser_combinators$Combine$app, rp, state, stream);
					if (!_v1.c.$) {
						var res = _v1;
						return res;
					} else {
						var rms = _v1.c.a;
						return _Utils_Tuple3(
							state,
							stream,
							$elm$core$Result$Err(
								_Utils_ap(lms, rms)));
					}
				}
			});
	});
var $andre_dietrich$parser_combinators$Combine$choice = function (xs) {
	return A3($elm$core$List$foldr, $andre_dietrich$parser_combinators$Combine$or, $andre_dietrich$parser_combinators$Combine$emptyErr, xs);
};
var $Garados007$elm_svg_parser$SvgParser$SvgComment = function (a) {
	return {$: 2, a: a};
};
var $andre_dietrich$parser_combinators$Combine$mapError = $andre_dietrich$parser_combinators$Combine$bimap($elm$core$Basics$identity);
var $andre_dietrich$parser_combinators$Combine$onerror = F2(
	function (m, p) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$mapError,
			$elm$core$Basics$always(
				_List_fromArray(
					[m])),
			p);
	});
var $andre_dietrich$parser_combinators$Combine$primitive = $elm$core$Basics$identity;
var $andre_dietrich$parser_combinators$Combine$Char$satisfy = function (pred) {
	return $andre_dietrich$parser_combinators$Combine$primitive(
		F2(
			function (state, stream) {
				var message = 'could not satisfy predicate';
				var _v0 = $elm$core$String$uncons(stream.nm);
				if (!_v0.$) {
					var _v1 = _v0.a;
					var h = _v1.a;
					var rest = _v1.b;
					return pred(h) ? _Utils_Tuple3(
						state,
						_Utils_update(
							stream,
							{nm: rest, e8: stream.e8 + 1}),
						$elm$core$Result$Ok(h)) : _Utils_Tuple3(
						state,
						stream,
						$elm$core$Result$Err(
							_List_fromArray(
								[message])));
				} else {
					return _Utils_Tuple3(
						state,
						stream,
						$elm$core$Result$Err(
							_List_fromArray(
								[message])));
				}
			}));
};
var $andre_dietrich$parser_combinators$Combine$Char$anyChar = A2(
	$andre_dietrich$parser_combinators$Combine$onerror,
	'expected any character',
	$andre_dietrich$parser_combinators$Combine$Char$satisfy(
		$elm$core$Basics$always(true)));
var $andre_dietrich$parser_combinators$Combine$succeed = function (res) {
	return F2(
		function (state, stream) {
			return _Utils_Tuple3(
				state,
				stream,
				$elm$core$Result$Ok(res));
		});
};
var $andre_dietrich$parser_combinators$Combine$lazy = function (t) {
	return A2(
		$andre_dietrich$parser_combinators$Combine$andThen,
		t,
		$andre_dietrich$parser_combinators$Combine$succeed(0));
};
var $andre_dietrich$parser_combinators$Combine$manyTill = F2(
	function (p, end_) {
		var accumulate = F3(
			function (acc, state, stream) {
				accumulate:
				while (true) {
					var _v0 = A3($andre_dietrich$parser_combinators$Combine$app, end_, state, stream);
					if (!_v0.c.$) {
						var rstate = _v0.a;
						var rstream = _v0.b;
						return _Utils_Tuple3(
							rstate,
							rstream,
							$elm$core$Result$Ok(
								$elm$core$List$reverse(acc)));
					} else {
						var estate = _v0.a;
						var estream = _v0.b;
						var ms = _v0.c.a;
						var _v1 = A3($andre_dietrich$parser_combinators$Combine$app, p, state, stream);
						if (!_v1.c.$) {
							var rstate = _v1.a;
							var rstream = _v1.b;
							var res = _v1.c.a;
							var $temp$acc = A2($elm$core$List$cons, res, acc),
								$temp$state = rstate,
								$temp$stream = rstream;
							acc = $temp$acc;
							state = $temp$state;
							stream = $temp$stream;
							continue accumulate;
						} else {
							return _Utils_Tuple3(
								estate,
								estream,
								$elm$core$Result$Err(ms));
						}
					}
				}
			});
		return accumulate(_List_Nil);
	});
var $andre_dietrich$parser_combinators$Combine$string = function (s) {
	return F2(
		function (state, stream) {
			if (A2($elm$core$String$startsWith, s, stream.nm)) {
				var len = $elm$core$String$length(s);
				var pos = stream.e8 + len;
				var rem = A2($elm$core$String$dropLeft, len, stream.nm);
				return _Utils_Tuple3(
					state,
					_Utils_update(
						stream,
						{nm: rem, e8: pos}),
					$elm$core$Result$Ok(s));
			} else {
				return _Utils_Tuple3(
					state,
					stream,
					$elm$core$Result$Err(
						_List_fromArray(
							['expected \"' + (s + '\"')])));
			}
		});
};
var $andre_dietrich$parser_combinators$Combine$regexer = F5(
	function (input, output, pat, state, stream) {
		var pattern = A2($elm$core$String$startsWith, '^', pat) ? pat : ('^' + pat);
		var _v0 = A3(
			$elm$regex$Regex$findAtMost,
			1,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				input(pattern)),
			stream.nm);
		if (_v0.b && (!_v0.b.b)) {
			var match = _v0.a;
			var len = $elm$core$String$length(match.c6);
			var pos = stream.e8 + len;
			var rem = A2($elm$core$String$dropLeft, len, stream.nm);
			return _Utils_Tuple3(
				state,
				_Utils_update(
					stream,
					{nm: rem, e8: pos}),
				$elm$core$Result$Ok(
					output(match)));
		} else {
			return _Utils_Tuple3(
				state,
				stream,
				$elm$core$Result$Err(
					_List_fromArray(
						['expected input matching Regexp /' + (pattern + '/')])));
		}
	});
var $andre_dietrich$parser_combinators$Combine$regex = A2(
	$elm$core$Basics$composeR,
	A2(
		$andre_dietrich$parser_combinators$Combine$regexer,
		$elm$regex$Regex$fromString,
		function ($) {
			return $.c6;
		}),
	$elm$core$Basics$identity);
var $andre_dietrich$parser_combinators$Combine$whitespace = A2(
	$andre_dietrich$parser_combinators$Combine$onerror,
	'optional whitespace',
	$andre_dietrich$parser_combinators$Combine$regex('\\s*'));
var $Garados007$elm_svg_parser$SvgParser$commentParser = $andre_dietrich$parser_combinators$Combine$lazy(
	function (_v0) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$map,
			A2($elm$core$Basics$composeL, $Garados007$elm_svg_parser$SvgParser$SvgComment, $elm$core$String$fromList),
			A2(
				$Garados007$elm_svg_parser$SvgParser$andMapRight,
				A2(
					$Garados007$elm_svg_parser$SvgParser$andMapRight,
					$andre_dietrich$parser_combinators$Combine$whitespace,
					$andre_dietrich$parser_combinators$Combine$string('<!--')),
				A2(
					$andre_dietrich$parser_combinators$Combine$manyTill,
					$andre_dietrich$parser_combinators$Combine$Char$anyChar,
					$andre_dietrich$parser_combinators$Combine$string('-->'))));
	});
var $Garados007$elm_svg_parser$SvgParser$Element = F3(
	function (name, attributes, children) {
		return {mm: attributes, ae: children, kF: name};
	});
var $andre_dietrich$parser_combinators$Combine$optional = F2(
	function (res, p) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$or,
			p,
			$andre_dietrich$parser_combinators$Combine$succeed(res));
	});
var $Garados007$elm_svg_parser$SvgParser$attributeParser = A2(
	$andre_dietrich$parser_combinators$Combine$andMap,
	A2(
		$andre_dietrich$parser_combinators$Combine$optional,
		'',
		A2(
			$Garados007$elm_svg_parser$SvgParser$andMapLeft,
			A2(
				$Garados007$elm_svg_parser$SvgParser$andMapRight,
				$andre_dietrich$parser_combinators$Combine$string('=\"'),
				$andre_dietrich$parser_combinators$Combine$regex('[^\"]*')),
			$andre_dietrich$parser_combinators$Combine$string('\"'))),
	A2(
		$andre_dietrich$parser_combinators$Combine$map,
		$elm$core$Tuple$pair,
		$andre_dietrich$parser_combinators$Combine$regex('[^=>/]+')));
var $andre_dietrich$parser_combinators$Combine$keep = F2(
	function (p1, p2) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$andMap,
			p1,
			A2(
				$andre_dietrich$parser_combinators$Combine$map,
				$pilatch$flip$Flip$flip($elm$core$Basics$always),
				p2));
	});
var $andre_dietrich$parser_combinators$Combine$sepBy1 = F2(
	function (sep, p) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$andMap,
			$andre_dietrich$parser_combinators$Combine$many(
				A2($andre_dietrich$parser_combinators$Combine$keep, p, sep)),
			A2($andre_dietrich$parser_combinators$Combine$map, $elm$core$List$cons, p));
	});
var $andre_dietrich$parser_combinators$Combine$sepBy = F2(
	function (sep, p) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$or,
			A2($andre_dietrich$parser_combinators$Combine$sepBy1, sep, p),
			$andre_dietrich$parser_combinators$Combine$succeed(_List_Nil));
	});
var $Garados007$elm_svg_parser$SvgParser$openingParser = A3(
	$Garados007$elm_svg_parser$SvgParser$flip,
	$andre_dietrich$parser_combinators$Combine$andMap,
	A2(
		$andre_dietrich$parser_combinators$Combine$andMap,
		$andre_dietrich$parser_combinators$Combine$regex('[^/>\\s]+'),
		A2(
			$andre_dietrich$parser_combinators$Combine$map,
			F3(
				function (_v0, tagName, attributes) {
					return A3($Garados007$elm_svg_parser$SvgParser$Element, tagName, attributes, _List_Nil);
				}),
			$andre_dietrich$parser_combinators$Combine$string('<'))),
	A2(
		$Garados007$elm_svg_parser$SvgParser$andMapLeft,
		A2(
			$Garados007$elm_svg_parser$SvgParser$andMapRight,
			$andre_dietrich$parser_combinators$Combine$whitespace,
			A2($andre_dietrich$parser_combinators$Combine$sepBy, $andre_dietrich$parser_combinators$Combine$whitespace, $Garados007$elm_svg_parser$SvgParser$attributeParser)),
		$andre_dietrich$parser_combinators$Combine$whitespace));
var $Garados007$elm_svg_parser$SvgParser$SvgText = function (a) {
	return {$: 1, a: a};
};
var $Garados007$elm_svg_parser$SvgParser$textParser = $andre_dietrich$parser_combinators$Combine$lazy(
	function (_v0) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$map,
			$Garados007$elm_svg_parser$SvgParser$SvgText,
			A2(
				$Garados007$elm_svg_parser$SvgParser$andMapRight,
				$andre_dietrich$parser_combinators$Combine$whitespace,
				$andre_dietrich$parser_combinators$Combine$regex('[^<]+')));
	});
var $Garados007$elm_svg_parser$SvgParser$closingOrChildrenParser = function (element) {
	var childrenParser = A2(
		$andre_dietrich$parser_combinators$Combine$map,
		function (children) {
			return _Utils_update(
				element,
				{ae: children});
		},
		A2(
			$Garados007$elm_svg_parser$SvgParser$andMapLeft,
			A2(
				$Garados007$elm_svg_parser$SvgParser$andMapLeft,
				A2(
					$Garados007$elm_svg_parser$SvgParser$andMapRight,
					A2(
						$Garados007$elm_svg_parser$SvgParser$andMapRight,
						$andre_dietrich$parser_combinators$Combine$whitespace,
						$andre_dietrich$parser_combinators$Combine$string('>')),
					$andre_dietrich$parser_combinators$Combine$many(
						$Garados007$elm_svg_parser$SvgParser$cyclic$nodeParser())),
				$andre_dietrich$parser_combinators$Combine$whitespace),
			$andre_dietrich$parser_combinators$Combine$string('</' + (element.kF + '>'))));
	return $andre_dietrich$parser_combinators$Combine$lazy(
		function (_v2) {
			return $andre_dietrich$parser_combinators$Combine$choice(
				_List_fromArray(
					[
						A2(
						$Garados007$elm_svg_parser$SvgParser$andMapRight,
						A2(
							$Garados007$elm_svg_parser$SvgParser$andMapRight,
							$andre_dietrich$parser_combinators$Combine$whitespace,
							$andre_dietrich$parser_combinators$Combine$string('/>')),
						$andre_dietrich$parser_combinators$Combine$succeed(element)),
						childrenParser
					]));
		});
};
function $Garados007$elm_svg_parser$SvgParser$cyclic$elementParser() {
	return $andre_dietrich$parser_combinators$Combine$lazy(
		function (_v1) {
			return A2(
				$andre_dietrich$parser_combinators$Combine$map,
				$Garados007$elm_svg_parser$SvgParser$SvgElement,
				A2(
					$andre_dietrich$parser_combinators$Combine$andThen,
					$Garados007$elm_svg_parser$SvgParser$closingOrChildrenParser,
					A2(
						$andre_dietrich$parser_combinators$Combine$andMap,
						$Garados007$elm_svg_parser$SvgParser$openingParser,
						A2(
							$andre_dietrich$parser_combinators$Combine$map,
							$Garados007$elm_svg_parser$SvgParser$flip($elm$core$Basics$always),
							$andre_dietrich$parser_combinators$Combine$whitespace))));
		});
}
function $Garados007$elm_svg_parser$SvgParser$cyclic$nodeParser() {
	return $andre_dietrich$parser_combinators$Combine$lazy(
		function (_v0) {
			return $andre_dietrich$parser_combinators$Combine$choice(
				_List_fromArray(
					[
						$Garados007$elm_svg_parser$SvgParser$textParser,
						$Garados007$elm_svg_parser$SvgParser$commentParser,
						$Garados007$elm_svg_parser$SvgParser$cyclic$elementParser()
					]));
		});
}
var $Garados007$elm_svg_parser$SvgParser$elementParser = $Garados007$elm_svg_parser$SvgParser$cyclic$elementParser();
$Garados007$elm_svg_parser$SvgParser$cyclic$elementParser = function () {
	return $Garados007$elm_svg_parser$SvgParser$elementParser;
};
var $Garados007$elm_svg_parser$SvgParser$nodeParser = $Garados007$elm_svg_parser$SvgParser$cyclic$nodeParser();
$Garados007$elm_svg_parser$SvgParser$cyclic$nodeParser = function () {
	return $Garados007$elm_svg_parser$SvgParser$nodeParser;
};
var $andre_dietrich$parser_combinators$Combine$InputStream = F3(
	function (data, input, position) {
		return {jM: data, nm: input, e8: position};
	});
var $andre_dietrich$parser_combinators$Combine$initStream = function (s) {
	return A3($andre_dietrich$parser_combinators$Combine$InputStream, s, s, 0);
};
var $andre_dietrich$parser_combinators$Combine$runParser = F3(
	function (p, st, s) {
		var _v0 = A3(
			$andre_dietrich$parser_combinators$Combine$app,
			p,
			st,
			$andre_dietrich$parser_combinators$Combine$initStream(s));
		if (!_v0.c.$) {
			var state = _v0.a;
			var stream = _v0.b;
			var res = _v0.c.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple3(state, stream, res));
		} else {
			var state = _v0.a;
			var stream = _v0.b;
			var ms = _v0.c.a;
			return $elm$core$Result$Err(
				_Utils_Tuple3(state, stream, ms));
		}
	});
var $Garados007$elm_svg_parser$SvgParser$xmlDeclarationParser = A2(
	$andre_dietrich$parser_combinators$Combine$map,
	$elm$core$String$fromList,
	A2(
		$Garados007$elm_svg_parser$SvgParser$andMapRight,
		A2(
			$Garados007$elm_svg_parser$SvgParser$andMapRight,
			$andre_dietrich$parser_combinators$Combine$whitespace,
			$andre_dietrich$parser_combinators$Combine$string('<?xml')),
		A2(
			$andre_dietrich$parser_combinators$Combine$manyTill,
			$andre_dietrich$parser_combinators$Combine$Char$anyChar,
			$andre_dietrich$parser_combinators$Combine$string('?>'))));
var $Garados007$elm_svg_parser$SvgParser$parseToNodes = function (input) {
	var _v0 = A3(
		$andre_dietrich$parser_combinators$Combine$runParser,
		A2(
			$Garados007$elm_svg_parser$SvgParser$andMapRight,
			A2($andre_dietrich$parser_combinators$Combine$optional, '', $Garados007$elm_svg_parser$SvgParser$xmlDeclarationParser),
			$andre_dietrich$parser_combinators$Combine$many($Garados007$elm_svg_parser$SvgParser$nodeParser)),
		_List_Nil,
		input);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var svgNodes = _v1.c;
		return $elm$core$Result$Ok(svgNodes);
	} else {
		var _v2 = _v0.a;
		var errors = _v2.c;
		return $elm$core$Result$Err(
			A2($elm$core$String$join, ' or ', errors));
	}
};
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $Garados007$elm_svg_parser$SvgParser$parse = function (input) {
	var toHtml = function (svgNodes) {
		toHtml:
		while (true) {
			if (svgNodes.b) {
				if (!svgNodes.a.$) {
					var element = svgNodes.a.a;
					var tl = svgNodes.b;
					if (element.kF === 'svg') {
						return $elm$core$Result$Ok(
							A2(
								$elm$svg$Svg$svg,
								A2($elm$core$List$map, $Garados007$elm_svg_parser$SvgParser$toAttribute, element.mm),
								A2($elm$core$List$map, $Garados007$elm_svg_parser$SvgParser$nodeToSvg, element.ae)));
					} else {
						var $temp$svgNodes = tl;
						svgNodes = $temp$svgNodes;
						continue toHtml;
					}
				} else {
					var tl = svgNodes.b;
					var $temp$svgNodes = tl;
					svgNodes = $temp$svgNodes;
					continue toHtml;
				}
			} else {
				return $elm$core$Result$Err('No svg found');
			}
		}
	};
	return A2(
		$elm$core$Result$andThen,
		toHtml,
		$Garados007$elm_svg_parser$SvgParser$parseToNodes(input));
};
var $author$project$Pyxis$Commons$Attributes$renderIf = F2(
	function (bool, attr) {
		return bool ? attr : $author$project$Pyxis$Commons$Attributes$none;
	});
var $author$project$Pyxis$Commons$Attributes$role = $elm$html$Html$Attributes$attribute('role');
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Pyxis$Components$IconSet$toLabel = function (icon) {
	switch (icon) {
		case 0:
			return 'youtube';
		case 1:
			return 'x';
		case 2:
			return 'wrench';
		case 3:
			return 'whatsapp';
		case 4:
			return 'wallet';
		case 5:
			return 'video';
		case 6:
			return 'vehicle-vandalism';
		case 7:
			return 'vehicle-theft-fire';
		case 8:
			return 'vehicle-secured-bonus';
		case 9:
			return 'vehicle-roadside-assistance';
		case 10:
			return 'vehicle-ricourse-waiver';
		case 11:
			return 'vehicle-natural-events';
		case 12:
			return 'vehicle-legal-protection';
		case 13:
			return 'vehicle-glasses';
		case 14:
			return 'vehicle-glasses-filled';
		case 15:
			return 'vehicle-full-kasko';
		case 16:
			return 'vehicle-driver-injuries';
		case 17:
			return 'vehicle-collision-kasko';
		case 18:
			return 'van';
		case 19:
			return 'users';
		case 20:
			return 'user';
		case 21:
			return 'user-plus';
		case 22:
			return 'user-minus';
		case 23:
			return 'user-cross';
		case 24:
			return 'user-circle';
		case 25:
			return 'user-circle-filled';
		case 26:
			return 'user-check';
		case 27:
			return 'upload';
		case 28:
			return 'umbrella';
		case 29:
			return 'twitter';
		case 30:
			return 'tshirt-sport';
		case 31:
			return 'trend-up';
		case 32:
			return 'trend-up-chart';
		case 33:
			return 'trend-down';
		case 34:
			return 'trend-down-chart';
		case 35:
			return 'trash-bin';
		case 36:
			return 'thumb-up';
		case 37:
			return 'thumb-down';
		case 38:
			return 'tablet';
		case 39:
			return 'switch';
		case 40:
			return 'steering-wheel';
		case 41:
			return 'star';
		case 42:
			return 'star-filled';
		case 43:
			return 'smartphone';
		case 44:
			return 'ski';
		case 45:
			return 'shield-check';
		case 46:
			return 'share';
		case 47:
			return 'share-android';
		case 48:
			return 'scan';
		case 49:
			return 'replay';
		case 50:
			return 'reload';
		case 51:
			return 'refund';
		case 52:
			return 'question-circle';
		case 53:
			return 'prima';
		case 54:
			return 'pound';
		case 55:
			return 'pos';
		case 56:
			return 'plus';
		case 57:
			return 'plus-square';
		case 58:
			return 'plus-circle';
		case 59:
			return 'plate';
		case 60:
			return 'picture';
		case 61:
			return 'phone';
		case 62:
			return 'phone-filled';
		case 63:
			return 'phone-24';
		case 64:
			return 'pen';
		case 65:
			return 'pen-form';
		case 66:
			return 'pec';
		case 67:
			return 'paperclip';
		case 68:
			return 'paper-plane';
		case 69:
			return 'odometer';
		case 70:
			return 'motorcycle';
		case 71:
			return 'more-vertical';
		case 72:
			return 'more-horizontal';
		case 73:
			return 'more-horizontal-circle';
		case 74:
			return 'moped';
		case 75:
			return 'minus';
		case 76:
			return 'minus-square';
		case 77:
			return 'minus-circle';
		case 78:
			return 'megaphone';
		case 79:
			return 'medal';
		case 80:
			return 'map-marker';
		case 81:
			return 'mail';
		case 82:
			return 'magnifying-glass';
		case 83:
			return 'magnifying-glass-plus';
		case 84:
			return 'magnifying-glass-minus';
		case 85:
			return 'magic-wand';
		case 86:
			return 'logout';
		case 87:
			return 'lock';
		case 88:
			return 'lock-open';
		case 89:
			return 'location';
		case 90:
			return 'location-filled';
		case 91:
			return 'location-disabled';
		case 92:
			return 'local-protection';
		case 93:
			return 'loader';
		case 94:
			return 'list';
		case 95:
			return 'list-circle';
		case 96:
			return 'linkedin';
		case 97:
			return 'link';
		case 98:
			return 'keyhole';
		case 99:
			return 'key';
		case 100:
			return 'jobs';
		case 101:
			return 'insurance-home';
		case 102:
			return 'instagram';
		case 103:
			return 'info-circle';
		case 104:
			return 'id-card';
		case 105:
			return 'hourglass';
		case 106:
			return 'hourglass-cross';
		case 107:
			return 'home';
		case 108:
			return 'home-theft-valuable';
		case 109:
			return 'home-telephone-legal-advice';
		case 110:
			return 'home-robberies-outside';
		case 111:
			return 'home-natural-events';
		case 112:
			return 'home-legal-protection';
		case 113:
			return 'home-insurance-home';
		case 114:
			return 'home-injuries-freetime';
		case 115:
			return 'home-injuries-family';
		case 116:
			return 'home-furniture-content';
		case 117:
			return 'home-fire-explosion';
		case 118:
			return 'home-emergencies-repairs';
		case 119:
			return 'home-domestic-thefts';
		case 120:
			return 'home-damage-third-parties';
		case 121:
			return 'home-damage-pets';
		case 122:
			return 'home-damage-family';
		case 123:
			return 'home-damage-ebike';
		case 124:
			return 'home-and-family';
		case 125:
			return 'heart';
		case 126:
			return 'heart-filled';
		case 127:
			return 'headset';
		case 128:
			return 'grid';
		case 129:
			return 'graduation-hat';
		case 130:
			return 'gps-enabled';
		case 131:
			return 'gps-disabled';
		case 132:
			return 'gift';
		case 133:
			return 'gear';
		case 134:
			return 'folder';
		case 135:
			return 'floppy-disk';
		case 136:
			return 'fax';
		case 137:
			return 'family-rc';
		case 138:
			return 'facebook';
		case 139:
			return 'eye';
		case 140:
			return 'eye-slashed';
		case 141:
			return 'external-link';
		case 142:
			return 'expand';
		case 143:
			return 'exclamation-triangle';
		case 144:
			return 'exclamation-circle';
		case 145:
			return 'exclamation-circle-filled';
		case 146:
			return 'euro';
		case 147:
			return 'download';
		case 148:
			return 'document';
		case 149:
			return 'document-signed';
		case 150:
			return 'document-plus';
		case 151:
			return 'document-pdf';
		case 152:
			return 'document-cross';
		case 153:
			return 'document-clock';
		case 154:
			return 'document-check';
		case 155:
			return 'document-alert';
		case 156:
			return 'direction';
		case 157:
			return 'diamond';
		case 158:
			return 'devices';
		case 159:
			return 'dashboard';
		case 160:
			return 'dashboard-filled';
		case 161:
			return 'damage-third-parties';
		case 162:
			return 'cross';
		case 163:
			return 'cross-square';
		case 164:
			return 'cross-circle';
		case 165:
			return 'cross-circle-filled';
		case 166:
			return 'credit-card';
		case 167:
			return 'cookie';
		case 168:
			return 'contactless';
		case 169:
			return 'computer';
		case 170:
			return 'collapse';
		case 171:
			return 'code';
		case 172:
			return 'clock';
		case 173:
			return 'clock-24';
		case 174:
			return 'circle-stop';
		case 175:
			return 'circle-play';
		case 176:
			return 'circle-pause';
		case 177:
			return 'chevron-up';
		case 178:
			return 'chevron-right';
		case 179:
			return 'chevron-left';
		case 180:
			return 'chevron-down';
		case 181:
			return 'chevron-circle-up';
		case 182:
			return 'chevron-circle-right';
		case 183:
			return 'chevron-circle-left';
		case 184:
			return 'chevron-circle-down';
		case 185:
			return 'check';
		case 186:
			return 'check-square';
		case 187:
			return 'check-circle';
		case 188:
			return 'check-circle-filled';
		case 189:
			return 'chat';
		case 190:
			return 'chart';
		case 191:
			return 'cart';
		case 192:
			return 'cards-overlap';
		case 193:
			return 'car';
		case 194:
			return 'camera';
		case 195:
			return 'calendar';
		case 196:
			return 'calendar-mail';
		case 197:
			return 'calendar-down';
		case 198:
			return 'calendar-clock';
		case 199:
			return 'calculator';
		case 200:
			return 'burger';
		case 201:
			return 'buildings';
		case 202:
			return 'book';
		case 203:
			return 'bell';
		case 204:
			return 'bank';
		case 205:
			return 'baloon';
		case 206:
			return 'arrow-up';
		case 207:
			return 'arrow-right';
		case 208:
			return 'arrow-left';
		case 209:
			return 'arrow-down';
		case 210:
			return 'arrow-diagonal-up-right';
		case 211:
			return 'arrow-diagonal-up-left';
		case 212:
			return 'arrow-diagonal-down-right';
		case 213:
			return 'arrow-diagonal-down-left';
		case 214:
			return 'apple';
		case 215:
			return 'android';
		case 216:
			return 'alarm';
		case 217:
			return 'affiliated-repairshops';
		case 218:
			return 'adjustments-horizontal';
		default:
			return 'activity';
	}
};
var $author$project$Pyxis$Components$IconSet$svgActivity = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M22 7H12c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h10c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1zm-7 7h-3c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h3c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1zm4 7h-7c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h7c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1z\"/><circle cx=\"4.25\" cy=\"13\" r=\"1.25\"/><circle cx=\"4.25\" cy=\"20\" r=\"1.25\"/><path d=\"M4 8c-.27 0-.53-.11-.72-.3l-2-2.05C.9 5.24.91 4.61 1.3 4.23c.4-.38 1.03-.38 1.41.02L4 5.57l3.28-3.36c.39-.39 1.02-.4 1.41-.02.4.39.4 1.02.02 1.41l-4 4.09c-.18.2-.44.31-.71.31z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgAdjustmentsHorizontal = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path fill-rule=\"evenodd\" d=\"M11.879 3.879a3 3 0 0 1 4.243 0A3 3 0 0 1 16.828 5H20a1 1 0 1 1 0 2h-3.172A3 3 0 0 1 14 9a3 3 0 0 1-2.828-2H4a1 1 0 1 1 0-2h7.172a3 3 0 0 1 .707-1.121zM15 6a1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1zM5.879 9.879a3 3 0 0 1 4.243 0A3 3 0 0 1 10.828 11H20a1 1 0 1 1 0 2h-9.172A3 3 0 0 1 8 15a3 3 0 0 1-2.828-2H4a1 1 0 1 1 0-2h1.172a3 3 0 0 1 .707-1.121zm2.828 1.414a1 1 0 0 1 0 1.414 1 1 0 0 1-1.414 0 1 1 0 0 1 0-1.414 1 1 0 0 1 1.414 0zM17 15a3 3 0 0 0-2.828 2H4a1 1 0 1 0 0 2h10.172A3 3 0 0 0 17 21a3 3 0 0 0 2.828-2H20a1 1 0 1 0 0-2h-.172A3 3 0 0 0 17 15zm1 3a1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgAffiliatedRepairshops = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><g clip-path=\"url(#A)\"><path d=\"M21.78 7l-4.1-1.1-1.1-1.9c-.54-.93-1.53-1.5-2.6-1.5H5.84c-.8 0-1.56.32-2.12.88l-2.5 2.5C.46 6.64.17 7.74.44 8.78l.67 2.5c.26.98.99 1.74 1.92 2.06L3 13.01c0 1.66 1.34 3 3 3s3-1.34 3-3c0 .17-.02.34-.05.5h7.1c-.03-.16-.05-.33-.05-.5 0 1.66 1.34 3 3 3s3-1.34 3-3c0 .11-.02.22-.03.33 1.18-.4 2.03-1.51 2.03-2.83v-.6a3 3 0 0 0-2.22-2.9V7zM6 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm13 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3-3.5c0 .37-.21.67-.5.85 0 .01.01.03.02.04C20.99 10.56 20.06 10 19 10s-2.06.61-2.58 1.5H8.59c-.52-.89-1.48-1.5-2.58-1.5s-1.99.55-2.52 1.39c0-.01.02-.03.02-.05a1.01 1.01 0 0 1-.45-.58l-.67-2.5c-.09-.34 0-.71.26-.97l2.5-2.5a.99.99 0 0 1 .71-.29H14c.36 0 .69.19.87.5l1.1 1.9c.27.46.7.79 1.21.93l4.1 1.1c.44.12.74.51.74.97v.6H22zm-8.8-5H8.4c-.55 0-1 .45-1 1s.45 1 1 1h4.8c.55 0 1-.45 1-1s-.45-1-1-1zM21 18H3c-.55 0-1 .45-1 1s.45 1 1 1h2v1c0 .55.45 1 1 1s1-.45 1-1v-1h10v1c0 .55.45 1 1 1s1-.45 1-1v-1h2c.55 0 1-.45 1-1s-.45-1-1-1z\" /></g><defs><clipPath id=\"A\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs></svg>';
var $author$project$Pyxis$Components$IconSet$svgAlarm = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20.99 19.22l-2.08-7.78C18.2 8.82 15.82 7 13.11 7h-2.22a5.99 5.99 0 0 0-5.79 4.45l-2.08 7.78A2.99 2.99 0 0 0 5.91 23h12.18c1.97 0 3.41-1.87 2.9-3.78zM7.03 11.96C7.5 10.22 9.08 9 10.89 9h2.22c1.81 0 3.4 1.22 3.86 2.96L18.32 17H5.68l1.35-5.04zm11.85 8.65c-.11.14-.36.39-.79.39H5.91c-.43 0-.68-.25-.79-.39-.12-.15-.29-.45-.18-.87l.2-.74h13.72l.2.74c.11.42-.06.72-.18.87zM5.64 6.05a.98.98 0 0 0 .71.29c.26 0 .51-.1.71-.29.39-.39.39-1.02 0-1.41L5.64 3.22c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41l1.41 1.42zM12 4c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1zm5.66 2.34c.26 0 .51-.1.71-.29l1.41-1.41c.39-.39.39-1.02 0-1.41s-1.02-.39-1.41 0l-1.41 1.41c-.39.39-.39 1.02 0 1.41.18.2.44.29.7.29z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgAndroid = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M17.06 15.06a.92.92 0 1 1 0-1.84.92.92 0 1 1 0 1.84m-10.12 0a.92.92 0 0 1 0-1.84.92.92 0 0 1 .92.92.93.93 0 0 1-.92.92m10.45-5.52l1.83-3.17c.1-.18.04-.42-.14-.52s-.42-.04-.52.14L16.71 9.2c-1.42-.64-3.01-1-4.71-1s-3.29.36-4.71 1.01L5.44 5.99a.39.39 0 0 0-.52-.14c-.18.11-.25.34-.14.52l1.83 3.17c-3.15 1.71-5.3 4.9-5.61 8.66h22c-.31-3.76-2.47-6.95-5.61-8.66\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgApple = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M18 12.7a4.98 4.98 0 0 1 2.38-4.19c-.93-1.32-2.42-2.13-4.03-2.18-1.7-.18-3.34 1.02-4.21 1.02-.88 0-2.21-1-3.65-.97-1.88.05-3.59 1.1-4.51 2.75-1.95 3.38-.5 8.35 1.38 11.09.94 1.34 2.03 2.83 3.46 2.78 1.4-.06 1.92-.89 3.62-.89 1.68 0 2.17.89 3.63.86 1.5-.02 2.45-1.34 3.35-2.7.67-.95 1.19-2.01 1.53-3.12-1.79-.76-2.95-2.51-2.95-4.45zm-2.76-8.17A4.96 4.96 0 0 0 16.37 1a4.99 4.99 0 0 0-3.24 1.68 4.7 4.7 0 0 0-1.16 3.4c1.27.01 2.47-.56 3.27-1.55z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgArrowDiagonalDownLeft = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M6 8a1 1 0 1 1 2 0v6.586l8.293-8.293a1 1 0 1 1 1.414 1.414L9.414 16H16a1 1 0 1 1 0 2H7l-.102-.005A1 1 0 0 1 6 17z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgArrowDiagonalDownRight = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M18 8a1 1 0 1 0-2 0v6.586L7.707 6.293a1 1 0 1 0-1.414 1.414L14.586 16H8a1 1 0 1 0 0 2h9l.102-.005A1 1 0 0 0 18 17z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgArrowDiagonalUpLeft = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M6 16a1 1 0 1 0 2 0V9.414l8.293 8.293a1 1 0 1 0 1.414-1.414L9.414 8H16a1 1 0 1 0 0-2H7l-.102.005A1 1 0 0 0 6 7z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgArrowDiagonalUpRight = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M18 16a1 1 0 1 1-2 0V9.414l-8.293 8.293a1 1 0 1 1-1.414-1.414L14.586 8H8a1 1 0 0 1 0-2h9l.102.005A1 1 0 0 1 18 7z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgArrowDown = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M11 5a1 1 0 1 1 2 0v11.586l4.293-4.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6-.068-.076a1 1 0 0 1 1.406-1.406l.076.068L11 16.586z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgArrowLeft = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M19 11a1 1 0 1 1 0 2H7.414l4.293 4.293a1 1 0 1 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6 .076-.069a1 1 0 0 1 1.406 1.407l-.068.076L7.414 11z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgArrowRight = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M5 11a1 1 0 1 0 0 2h11.586l-4.293 4.293a1 1 0 1 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6-.076-.069a1 1 0 0 0-1.406 1.407l.068.076L16.586 11z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgArrowUp = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M11 19a1 1 0 1 0 2 0V7.414l4.293 4.293a1 1 0 1 0 1.414-1.414l-6-6a1 1 0 0 0-1.414 0l-6 6-.068.076a1 1 0 0 0 1.406 1.406l.076-.068L11 7.414z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgBaloon = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M16 12H8c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h8c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1zm-4-4H8c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h4c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1zm8.25-5c.41 0 .75.34.75.75v11c0 .41-.34.75-.75.75H7.33c-1.07 0-2.07.42-2.83 1.17L3 18.17V3.75c0-.41.34-.75.75-.75h16.5m0-2H3.75A2.75 2.75 0 0 0 1 3.75v16.84c0 .6.49 1 1.01 1 .25 0 .5-.09.7-.29l3.21-3.21c.38-.38.88-.59 1.41-.59h12.92A2.75 2.75 0 0 0 23 14.75v-11A2.75 2.75 0 0 0 20.25 1h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgBank = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M22 10V8.57c0-1.07-.57-2.06-1.5-2.6L14 2.22c-1.23-.71-2.77-.71-4 0L3.5 5.97C2.57 6.51 2 7.5 2 8.57V10c0 .74.41 1.37 1 1.72V20c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1v-8.28c.59-.35 1-.98 1-1.72zM4 8.57c0-.36.19-.69.5-.87L11 3.95c.31-.18.65-.27 1-.27s.69.09 1 .27l6.5 3.75c.31.18.5.51.5.87V10H4V8.57zM11 12v8H9v-8h2zm2 0h2v8h-2v-8zm-8 0h2v8H5v-8zm12 8v-8h2v8h-2z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgBell = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M22.13 19l-1.73-3c-.26-.46-.4-.97-.4-1.5V10c0-3.74-2.56-6.86-6.03-7.74.02-.09.03-.17.03-.26 0-1.1-.9-2-2-2s-2 .9-2 2c0 .09.01.17.03.26C6.56 3.14 4 6.26 4 10v4.5c0 .53-.14 1.04-.4 1.5l-1.73 3c-.38.67.1 1.5.87 1.5h5.32A3.97 3.97 0 0 0 12 24c2.04 0 3.7-1.53 3.95-3.5h5.32c.77 0 1.25-.83.86-1.5zM12 22c-.93 0-1.71-.64-1.93-1.5h3.86c-.22.86-1 1.5-1.93 1.5zm3.7-3.5h-2.39-2.62H8.3 4.46l.87-1.5A4.98 4.98 0 0 0 6 14.5V10c0-3.31 2.69-6 6-6s6 2.69 6 6v4.5a4.98 4.98 0 0 0 .67 2.5l.87 1.5H15.7z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgBook = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M22 2.39a1.86 1.86 0 0 0-.52.07L12 5 2.52 2.46A1.91 1.91 0 0 0 2 2.39c-1.07 0-2 .87-2 2v12.09a3 3 0 0 0 2.22 2.9L12 22l9.78-2.62a3 3 0 0 0 2.22-2.9V4.39c0-1.13-.93-2-2-2zM2 16.48V4.39l9 2.41v12.86l-8.26-2.21c-.44-.12-.74-.52-.74-.97zm20 0c0 .45-.3.85-.74.97L13 19.66V6.8l9-2.41v12.09zM16 10c.09 0 .17-.01.26-.03l3-.8c.53-.14.85-.69.71-1.22s-.69-.85-1.22-.71l-3 .8c-.53.14-.85.69-.71 1.22.11.45.52.74.96.74zm2.74 1.23l-3 .8c-.53.14-.85.69-.71 1.22A1 1 0 0 0 16 14c.09 0 .17-.01.26-.03l3-.8c.53-.14.85-.69.71-1.22s-.69-.86-1.23-.72z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgBuildings = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M5 21c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v3.38c.6-.35 1.28-.55 2-.55V4c0-1.66-1.34-3-3-3H5C3.34 1 2 2.34 2 4v16c0 1.66 1.34 3 3 3h3.56c-.35-.59-.56-1.27-.56-2H5zM7 8c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1zm0 5c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1zm4-5c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1zm10.12 5.12l-3.71-3.71c-.39-.39-.9-.59-1.41-.59s-1.02.2-1.41.59l-3.71 3.71c-.56.56-.88 1.33-.88 2.12V21c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-5.76c0-.79-.32-1.56-.88-2.12zM20 21h-3v-2c0-.55-.45-1-1-1s-1 .45-1 1v2h-3v-5.76a.99.99 0 0 1 .29-.71l3.71-3.7h0l3.71 3.71c.19.18.29.44.29.7V21z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgBurger = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><use xlink:href=\"#B\"/><use xlink:href=\"#B\" y=\"8\"/><use xlink:href=\"#B\" y=\"16\"/><defs ><path id=\"B\" d=\"M21 5H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1z\"/></defs></svg>';
var $author$project$Pyxis$Components$IconSet$svgCalculator = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><g ><path d=\"M17 3a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h10zm0-2H7C3.69 1 1 3.69 1 7v10c0 3.31 2.69 6 6 6h10c3.31 0 6-2.69 6-6V7c0-3.31-2.69-6-6-6zm-7 6H9V6c0-.55-.45-1-1-1s-1 .45-1 1v1H6c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1V9h1c.55 0 1-.45 1-1s-.45-1-1-1z\"/><use href=\"#B\"/><use href=\"#B\" y=\"-3\"/><path d=\"M10.12 13.88c-.39-.39-1.02-.39-1.41 0l-.71.71-.71-.71c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41l.71.71-.71.71c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0l.71-.71.71.71c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L9.41 16l.71-.71c.39-.39.39-1.02 0-1.41z\"/><use href=\"#B\" y=\"-9.5\"/></g><defs ><path id=\"B\" d=\"M18 16.5h-4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z\"/></defs></svg>';
var $author$project$Pyxis$Components$IconSet$svgCalendar = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1H7V2c0-.55-.45-1-1-1s-1 .45-1 1v1H4C2.34 3 1 4.34 1 6v14c0 1.66 1.34 3 3 3h16c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3zM4 5h1v1c0 .55.45 1 1 1s1-.45 1-1V5h10v1c0 .55.45 1 1 1s1-.45 1-1V5h1c.55 0 1 .45 1 1v2H3V6c0-.55.45-1 1-1zm16 16H4c-.55 0-1-.45-1-1V10h18v10c0 .55-.45 1-1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgCalendarClock = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1H7V2c0-.55-.45-1-1-1s-1 .45-1 1v1H4C2.34 3 1 4.34 1 6v14c0 1.66 1.34 3 3 3h6.36c-.71-.57-1.33-1.24-1.83-2H4c-.55 0-1-.45-1-1V10h6.31c.73-.81 1.6-1.49 2.58-2H3V6c0-.55.45-1 1-1h1v1c0 .55.45 1 1 1s1-.45 1-1V5h10v1c0 .55.45 1 1 1s1-.45 1-1V5h1c.55 0 1 .45 1 1v2.52c.76.51 1.43 1.13 2 1.83V6c0-1.66-1.34-3-3-3zm-4 6c-3.87 0-7 3.13-7 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm1-5.41v-2.67c0-.55-.45-1-1-1s-1 .45-1 1v3.5l1.63 1.63a.98.98 0 0 0 .71.29c.26 0 .51-.1.71-.29.39-.39.39-1.02 0-1.41L17 15.59z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgCalendarDown = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"m19 15c0.5522 1e-4 1 0.4478 1 1v3.5859l1.293-1.2929c0.3905-0.3905 1.0235-0.3905 1.414 0 0.3904 0.3905 0.3904 1.0236 0 1.414l-3 3c-0.0868 0.0869-0.1865 0.153-0.292 0.2012-0.0527 0.0242-0.1077 0.0438-0.165 0.0586-0.011 0.0028-0.0221 0.0054-0.0332 0.0078-0.0177 0.0039-0.0356 0.0068-0.0537 0.0098-0.0131 0.0021-0.0259 0.0052-0.0391 0.0068-0.0165 0.0021-0.033 0.0037-0.0498 0.0049-0.0179 0.0013-0.0357 0.0026-0.0537 0.0029-0.0068 2e-4 -0.0136 1e-3 -0.0205 1e-3 -0.0068 0-0.0138-8e-4 -0.0205-1e-3 -0.016-3e-4 -0.0319-0.0018-0.0478-0.0029-0.0181-0.0012-0.036-0.0027-0.0538-0.0049-0.0156-0.0019-0.0312-0.0042-0.0468-0.0068-0.0141-0.0024-0.0281-0.0049-0.042-0.0078-0.0142-0.0031-0.028-0.0071-0.042-0.0108-0.1744-0.0455-0.3305-0.1352-0.4541-0.2588l-3-3-0.0684-0.0761c-0.3203-0.3928-0.2977-0.9718 0.0684-1.3379s0.9451-0.3887 1.3379-0.0684l0.0761 0.0684 1.293 1.2929v-3.5859c0-0.5523 0.4477-1 1-1z\"/><path d=\"m18 1c0.55 0 1 0.45 1 1v1h1c1.66 0 3 1.34 3 3v7c0 0.5523-0.4477 1-1 1s-1-0.4477-1-1v-3h-18v10c0 0.55 0.45 1 1 1h9c0.5523 0 1 0.4477 1 1s-0.4477 1-1 1h-9c-1.66 0-3-1.34-3-3v-14c0-1.66 1.34-3 3-3h1v-1c0-0.55 0.45-1 1-1s1 0.45 1 1v1h10v-1c0-0.55 0.45-1 1-1zm-14 4c-0.55 0-1 0.45-1 1v2h18v-2c0-0.55-0.45-1-1-1h-1v1c0 0.55-0.45 1-1 1s-1-0.45-1-1v-1h-10v1c0 0.55-0.45 1-1 1s-1-0.45-1-1v-1h-1z\"/></svg>\n';
var $author$project$Pyxis$Components$IconSet$svgCalendarMail = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1H7V2c0-.55-.45-1-1-1s-1 .45-1 1v1H4C2.34 3 1 4.34 1 6v14c0 1.66 1.34 3 3 3h2.97c-.36-.59-.58-1.27-.62-2H4c-.55 0-1-.45-1-1V10h18v.02c.73.04 1.41.25 2 .62V6c0-1.66-1.34-3-3-3zM3 8V6c0-.55.45-1 1-1h1v1c0 .55.45 1 1 1s1-.45 1-1V5h10v1c0 .55.45 1 1 1s1-.45 1-1V5h1c.55 0 1 .45 1 1v2H3zm17.8 4H10.53c-1.22 0-2.2.98-2.2 2.2v6.6c0 1.22.98 2.2 2.2 2.2H20.8c1.22 0 2.2-.98 2.2-2.2v-6.6c0-1.22-.98-2.2-2.2-2.2zm-.01 2l-5.12 2.96L10.55 14h10.24zm.01 7H10.53a.2.2 0 0 1-.2-.2v-4.61l4.83 2.79c.15.09.33.13.5.13s.35-.04.5-.13L21 16.19v4.61a.2.2 0 0 1-.2.2z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgCamera = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M13.76 5a.99.99 0 0 1 .71.29l1.83 1.83c.56.57 1.31.88 2.11.88H20c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h1.59a2.97 2.97 0 0 0 2.12-.88l1.83-1.83c.18-.19.44-.29.7-.29h3.52m0-2h-3.51c-.8 0-1.56.32-2.12.88L6.29 5.71a1.01 1.01 0 0 1-.7.29H4C2.34 6 1 7.34 1 9v10c0 1.66 1.34 3 3 3h16c1.66 0 3-1.34 3-3V9c0-1.66-1.34-3-3-3h-1.59c-.27 0-.52-.11-.71-.29l-1.83-1.83c-.55-.56-1.32-.88-2.11-.88h0zM12 10a3.01 3.01 0 0 1 3 3 3.01 3.01 0 0 1-3 3 3.01 3.01 0 0 1-3-3 3.01 3.01 0 0 1 3-3m0-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgCar = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21.78 10l-4.1-1.1-1.1-1.9c-.54-.93-1.53-1.5-2.6-1.5H5.84c-.8 0-1.56.32-2.12.88l-2.5 2.5c-.76.76-1.05 1.86-.78 2.9l.67 2.5c.26.98.99 1.74 1.92 2.06L3 16c0 1.66 1.34 3 3 3s3-1.34 3-3c0 .17-.02.34-.05.5h7.1c-.03-.16-.05-.33-.05-.5 0 1.66 1.34 3 3 3s3-1.34 3-3c0 .11-.02.22-.03.33 1.18-.4 2.03-1.51 2.03-2.83v-.6a3 3 0 0 0-2.22-2.9zM6 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm13 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3-3.5c0 .37-.21.67-.5.85.01.01.01.03.02.04A2.97 2.97 0 0 0 19 13c-1.11 0-2.06.61-2.58 1.5H8.58C8.06 13.61 7.11 13 6 13a2.97 2.97 0 0 0-2.52 1.39c.01-.01.02-.03.02-.05a1.01 1.01 0 0 1-.45-.58l-.67-2.5a1.03 1.03 0 0 1 .26-.97l2.5-2.5c.18-.19.44-.29.7-.29h8.14c.36 0 .69.19.87.5l1.1 1.9c.27.46.7.79 1.21.93l4.1 1.1c.44.12.74.52.74.97v.6zm-8.8-5H8.4c-.55 0-1 .45-1 1s.45 1 1 1h4.8c.55 0 1-.45 1-1s-.45-1-1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgCardsOverlap = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M18.5 7c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1h-9c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h9m0-2h-9c-1.66 0-3 1.34-3 3v12c0 1.66 1.34 3 3 3h9c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3h0zm-14 9.82V4c0-.55.45-1 1-1H13h1.5 2.82c-.42-1.16-1.52-2-2.82-2h-9c-1.66 0-3 1.34-3 3v12c0 1.3.84 2.4 2 2.82V16v-1.18z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgCart = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M18.47 18h-7.93a3 3 0 0 1-2.9-2.22l-2.3-8.56C4.99 5.91 3.81 5 2.45 5H2c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h.45c2.26 0 4.24 1.52 4.83 3.71L7.62 8h13.22c.63 0 1.2.29 1.59.78a2.01 2.01 0 0 1 .35 1.74l-1.41 5.26c-.36 1.31-1.55 2.22-2.9 2.22zM8.16 10l1.41 5.26c.12.44.51.74.96.74h7.93c.45 0 .85-.3.97-.74L20.84 10H8.16zM10 19a1.5 1.5 0 1 0 0 3 1.5 1.5 0 1 0 0-3h0zm9 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 1 0 0-3h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgChart = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20 3c.55 0 1 .45 1 1v16c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h16m0-2H4C2.34 1 1 2.34 1 4v16c0 1.66 1.34 3 3 3h16c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3h0zM7 18h0c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1zm5 0h0c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1zm5 0h0c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v7c0 .55-.45 1-1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgChat = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M7.5 12c1.29 0 2.52.55 3.37 1.52.87.98 1.25 2.25 1.09 3.56a4.56 4.56 0 0 1-3.68 3.85c-.26.05-.52.07-.78.07a4.53 4.53 0 0 1-2.24-.6l-.72-.41-.71.19.19-.71-.42-.73a4.47 4.47 0 0 1-.54-3.02c.32-1.9 1.94-3.45 3.85-3.68A3.99 3.99 0 0 1 7.5 12m0-2a7.86 7.86 0 0 0-.83.05c-2.79.35-5.11 2.56-5.58 5.33a6.5 6.5 0 0 0 .78 4.36l-.42 1.58c-.18.65.33 1.26.96 1.26.09 0 .17-.01.26-.04l1.58-.42A6.43 6.43 0 0 0 7.5 23a7.02 7.02 0 0 0 1.11-.09 6.52 6.52 0 0 0 5.33-5.58c.5-3.96-2.58-7.33-6.44-7.33h0zm14.39 3.37c.9-1.56 1.32-3.44 1-5.43-.57-3.63-3.61-6.51-7.26-6.89a8.65 8.65 0 0 0-.88-.05C10.6 1 7.18 4.07 6.6 8.06A6.69 6.69 0 0 1 7.5 8c.38 0 .75.03 1.11.08.21-1.11.71-2.15 1.49-3.01A6.26 6.26 0 0 1 14.75 3c.22 0 .45.01.68.04 2.75.29 5.06 2.48 5.49 5.21a6.22 6.22 0 0 1-.76 4.12l-.41.72.21.8.21.79-.79-.21-.8-.21-.72.41a6.51 6.51 0 0 1-1.96.72c.09.67.11 1.35.03 2.03 1.05-.15 2.04-.5 2.92-1.01l2.46.66c.09.02.18.04.26.04.63 0 1.14-.61.96-1.26l-.64-2.48z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgCheck = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M10 18c-.26 0-.51-.1-.71-.29L4 12.41c-.39-.39-.39-1.02 0-1.41h0c.39-.39 1.02-.39 1.41 0L10 15.59 19.59 6c.39-.39 1.02-.39 1.41 0h0c.39.39.39 1.02 0 1.41l-10.29 10.3c-.2.19-.45.29-.71.29z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgCheckCircle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0zm-1 16c-.26 0-.51-.1-.71-.29L7 12.41c-.39-.39-.39-1.02 0-1.41h0c.39-.39 1.02-.39 1.41 0L11 13.59 16.59 8c.39-.39 1.02-.39 1.41 0h0c.39.39.39 1.02 0 1.41l-6.29 6.29c-.2.2-.45.3-.71.3z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgCheckCircleFilled = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 0.000488281C18.6298 0.000751951 24 5.37069 24 12.0005C23.9997 18.6301 18.6296 24.0005 12 24.0005C5.3702 24.0005 0 18.6303 0 12.0005C0 5.37049 5.37 0.000488281 12 0.000488281ZM18 8.00049C17.61 7.61049 16.9798 7.61049 16.5898 8.00049L11 13.5903L8.4092 11.0005C8.0192 10.6105 7.39 10.6105 7 11.0005C6.61 11.3905 6.61 12.0197 7 12.4097L10.2891 15.7104C10.4891 15.9004 10.74 16.0005 11 16.0005C11.2598 16.0004 11.5101 15.8996 11.7099 15.6997L18 9.40969C18.3894 9.01981 18.3894 8.39039 18 8.00049Z\"/></svg>\n';
var $author$project$Pyxis$Components$IconSet$svgCheckSquare = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M17 3a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h10m0-2H7C3.69 1 1 3.69 1 7v10c0 3.31 2.69 6 6 6h10c3.31 0 6-2.69 6-6V7c0-3.31-2.69-6-6-6h0zm-6 15c-.26 0-.51-.1-.71-.29L7 12.41c-.39-.39-.39-1.02 0-1.41h0c.39-.39 1.02-.39 1.41 0L11 13.59 16.59 8c.39-.39 1.02-.39 1.41 0h0c.39.39.39 1.02 0 1.41l-6.29 6.29c-.2.2-.45.3-.71.3z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgChevronCircleDown = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0zm0 16c-.26 0-.51-.1-.71-.29L7 11.41c-.39-.39-.39-1.02 0-1.41h0c.39-.39 1.02-.39 1.41 0L12 13.59 15.59 10c.39-.39 1.02-.39 1.41 0h0c.39.39.39 1.02 0 1.41l-4.29 4.29c-.2.2-.45.3-.71.3z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgChevronCircleLeft = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2h0a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0zm.59 17L8.3 12.71c-.39-.39-.39-1.02 0-1.41L12.59 7c.39-.39 1.02-.39 1.41 0h0c.39.39.39 1.02 0 1.41L10.41 12 14 15.59c.39.39.39 1.02 0 1.41h0c-.39.39-1.02.39-1.41 0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgChevronCircleRight = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2h0a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0zm-2 17h0c-.39-.39-.39-1.02 0-1.41L13.59 12 10 8.41c-.39-.39-.39-1.02 0-1.41h0c.39-.39 1.02-.39 1.41 0l4.29 4.29c.39.39.39 1.02 0 1.41L11.41 17c-.39.39-1.02.39-1.41 0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgChevronCircleUp = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2h0a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0zm3.59 14L12 10.41 8.41 14c-.39.39-1.02.39-1.41 0h0c-.39-.39-.39-1.02 0-1.41l4.29-4.29c.39-.39 1.02-.39 1.41 0l4.3 4.29c.39.39.39 1.02 0 1.41h0c-.39.39-1.02.39-1.41 0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgChevronDown = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 17c-.26 0-.51-.1-.71-.29L5 10.41c-.39-.39-.39-1.02 0-1.41h0c.39-.39 1.02-.39 1.41 0L12 14.59 17.59 9c.39-.39 1.02-.39 1.41 0h0c.39.39.39 1.02 0 1.41l-6.29 6.29c-.2.2-.45.3-.71.3z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgChevronLeft = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M13.59 19L7.3 12.71c-.39-.39-.39-1.02 0-1.41L13.59 5c.39-.39 1.02-.39 1.41 0h0c.39.39.39 1.02 0 1.41L9.41 12 15 17.59c.39.39.39 1.02 0 1.41h0c-.39.39-1.02.39-1.41 0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgChevronRight = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M9 19h0c-.39-.39-.39-1.02 0-1.41L14.59 12 9 6.41C8.61 6.02 8.61 5.39 9 5h0c.39-.39 1.02-.39 1.41 0l6.29 6.29c.39.39.39 1.02 0 1.41L10.41 19c-.39.39-1.02.39-1.41 0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgChevronUp = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M17.59 15L12 9.41 6.41 15c-.39.39-1.02.39-1.41 0h0c-.39-.39-.39-1.02 0-1.41l6.29-6.29c.39-.39 1.02-.39 1.41 0l6.3 6.29c.39.39.39 1.02 0 1.41h0c-.39.39-1.02.39-1.41 0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgCirclePause = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><g clip-path=\"url(#circle_pause_icon_A)\" ><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2zm0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24z\"/><g fill-rule=\"evenodd\"><use href=\"#circle_pause_icon_B\"/><path d=\"M14.5 16.5a1 1 0 0 1-1-1v-7a1 1 0 1 1 2 0v7a1 1 0 0 1-1 1z\"/></g></g><defs><clipPath id=\"circle_pause_icon_A\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath><path id=\"circle_pause_icon_B\" d=\"M9.5 16.5a1 1 0 0 1-1-1v-7a1 1 0 1 1 2 0v7a1 1 0 0 1-1 1z\"/></defs></svg>';
var $author$project$Pyxis$Components$IconSet$svgCirclePlay = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><g clip-path=\"url(#A)\"><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2zm0-2A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm4.16 11.13L10.5 7.86c-.67-.38-1.5.1-1.5.87v6.54c0 .77.83 1.25 1.5.87l5.66-3.27a1 1 0 0 0 .498-.865 1 1 0 0 0-.498-.865v-.01z\" /></g><defs><clipPath id=\"A\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs></svg>';
var $author$project$Pyxis$Components$IconSet$svgCircleStop = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><g clip-path=\"url(#A)\" ><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2zm0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24zm3 8H9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z\"/></g><defs><clipPath id=\"A\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs></svg>';
var $author$project$Pyxis$Components$IconSet$svgClock = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 0a12 12 0 1 0 0 24 12 12 0 1 0 0-24zm0 22A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10zm1-10.41V5c0-.55-.45-1-1-1s-1 .45-1 1v7.41l4.29 4.29c.2.2.45.3.71.3s.51-.1.71-.29c.39-.39.39-1.02 0-1.41L13 11.59z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgClock24 = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M13.69 4.43c-.03-.09-.05-.26-.05-.42 0-1.06.78-2.01 2.27-2.01 1.44 0 2.26.9 2.26 1.98 0 .71-.34 1.3-1.1 1.72l-.99.56c-.15.08-.33.26-.36.38h2.45V8h-4.55v-.1c0-1.11.33-1.97 1.41-2.6l.93-.55c.43-.24.59-.44.59-.78 0-.31-.24-.58-.66-.58-.47 0-.71.34-.71.72a1.17 1.17 0 0 0 .04.32h-1.53zm5.17.85l2.4-3.16h1.89v3.34H24V6.8h-.85V8h-1.62V6.8h-2.66V5.28zm2.67-1.46L20.3 5.46h1.22V3.82zM14 18c-.26 0-.51-.1-.71-.29L10 14.41V8c0-.55.45-1 1-1s1 .45 1 1v5.59l2.71 2.71c.39.39.39 1.02 0 1.41-.2.19-.45.29-.71.29zm5.47-8c.33.94.53 1.95.53 3 0 4.96-4.04 9-9 9s-9-4.04-9-9 4.04-9 9-9c.21 0 .42.02.62.03v-2c-.2-.01-.41-.03-.62-.03C4.92 2 0 6.92 0 13s4.92 11 11 11 11-4.92 11-11a10.98 10.98 0 0 0-.42-3h-2.11z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgCode = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><g clip-path=\"url(#A)\"><path d=\"M10.19 19.76c-.09 0-.17-.01-.26-.03-.53-.14-.85-.69-.71-1.22l3.62-13.52c.14-.53.69-.85 1.22-.71s.85.69.71 1.22l-3.62 13.52c-.12.45-.52.74-.97.74h.01zm-4.95-2.52c-.26 0-.51-.1-.71-.29L.29 12.71a.99.99 0 0 1-.217-.326A.99.99 0 0 1 0 12c0-.27.11-.52.29-.71l4.24-4.24c.39-.39 1.02-.39 1.41 0s.39 1.02 0 1.41L2.4 12l3.54 3.54c.39.39.39 1.02 0 1.41a.98.98 0 0 1-.71.29h.01zm13.52 0c-.26 0-.51-.1-.71-.29-.39-.39-.39-1.02 0-1.41L21.59 12l-3.54-3.54c-.39-.39-.39-1.02 0-1.41s1.02-.39 1.41 0l4.24 4.24a.99.99 0 0 1 .29.71c0 .27-.11.52-.29.71l-4.24 4.24a.98.98 0 0 1-.71.29h.01z\" /></g><defs><clipPath id=\"A\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs></svg>';
var $author$project$Pyxis$Components$IconSet$svgCollapse = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M19 11h-5c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v4h4c.55 0 1 .45 1 1s-.45 1-1 1zm-9 9c-.55 0-1-.45-1-1v-4H5c-.55 0-1-.45-1-1s.45-1 1-1h5c.55 0 1 .45 1 1v5c0 .55-.45 1-1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgComputer = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20 2H4C2.34 2 1 3.34 1 5v11c0 1.66 1.34 3 3 3h6v1H8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1h-2v-1h6c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3zm1 14c0 .55-.45 1-1 1h-6-4-6c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v11z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgContactless = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\">\n<path d=\"M12 2C17.51 2 22 6.49 22 12C22 17.51 17.51 22 12 22C6.49 22 2 17.51 2 12C2 6.49 6.49 2 12 2ZM12 0C5.37 0 0 5.37 0 12C0 18.63 5.37 24 12 24C18.63 24 24 18.63 24 12C24 5.37 18.63 0 12 0Z\"/>\n<path d=\"M14.971 12C14.971 10.1919 14.5542 8.4098 13.7542 6.792L13.5882 6.47071L13.5453 6.37793C13.3531 5.9089 13.5435 5.36083 14.0003 5.11723C14.4572 4.87365 15.0187 5.02062 15.3011 5.44145L15.3539 5.52934L15.5462 5.90532C16.4825 7.79872 16.971 9.88402 16.971 12.0001C16.971 14.257 16.4159 16.4794 15.3539 18.4708C15.094 18.958 14.4876 19.1427 14.0003 18.8829C13.5131 18.623 13.3284 18.0166 13.5882 17.5294C14.4958 15.8276 14.971 13.9286 14.971 12Z\"/>\n<path d=\"M11.002 12C11.002 10.7525 10.7141 9.5226 10.1622 8.4063L10.0479 8.18462L10.0049 8.09185C9.81279 7.62281 10.0031 7.07475 10.46 6.83115C10.9169 6.58756 11.4783 6.73454 11.7608 7.15537L11.8135 7.24326L11.9551 7.51962C12.6433 8.91132 13.002 10.4447 13.002 12C13.0019 13.6588 12.5941 15.2923 11.8135 16.7559C11.5536 17.2432 10.9473 17.4279 10.46 17.168C9.9727 16.9081 9.788 16.3018 10.0479 15.8145C10.674 14.6405 11.0019 13.3306 11.002 12Z\"/>\n<path d=\"M8.2152 15.24C7.89522 15.6899 7.27073 15.7951 6.8207 15.4753C6.37072 15.1553 6.26458 14.5309 6.58437 14.0808L8.2152 15.24ZM7.25719 12.0886C7.25716 11.5008 7.08892 10.9042 6.74352 10.3376L6.58434 10.0964L6.52965 10.0105C6.27922 9.56987 6.39874 9.0019 6.82067 8.7019C7.2426 8.40224 7.8179 8.47601 8.15167 8.85717L8.21515 8.93823L8.33722 9.11694C8.93198 10.0194 9.25711 11.0368 9.25714 12.0886C9.25714 13.2106 8.88784 14.2941 8.2152 15.24L6.58437 14.0808C7.03726 13.4439 7.25719 12.7604 7.25719 12.0886Z\"/>\n</svg>\n';
var $author$project$Pyxis$Components$IconSet$svgCookie = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><g clip-path=\"url(#A)\" ><path d=\"M12 24C5.38 24 0 18.62 0 12S5.38 0 12 0h.11c.47.03.89.39.96.86C13.49 3.79 16.04 6 19 6a6.29 6.29 0 0 0 1.01-.09c.34-.05.68.06.91.32a.98.98 0 0 1 .21.94c-.09.32-.13.58-.13.83 0 1.36.92 2.54 2.25 2.89.43.11.74.5.75.95V12a12.01 12.01 0 0 1-11.99 12H12zm-.73-21.98A10.02 10.02 0 0 0 2 12c0 5.28 4.49 10 10 10s9.69-4.18 9.98-9.44C20.19 11.77 19 9.99 19 8c-3.65 0-6.82-2.51-7.73-5.98z\"/><use href=\"#B\"/><path d=\"M16.5 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 1 0 0 3zM11 18a1 1 0 1 0 0-2 1 1 0 1 0 0 2z\"/></g><defs><clipPath id=\"A\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath><path id=\"B\" d=\"M7.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 1 0 0 3z\"/></defs></svg>';
var $author$project$Pyxis$Components$IconSet$svgCreditCard = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21 2.5H3c-1.66 0-3 1.34-3 3v13c0 1.66 1.34 3 3 3h18c1.66 0 3-1.34 3-3v-13c0-1.66-1.34-3-3-3zm-18 2h18c.55 0 1 .45 1 1v2H2v-2c0-.55.45-1 1-1zm18 15H3c-.55 0-1-.45-1-1v-7h20v7c0 .55-.45 1-1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgCross = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20.0098 3.99001C19.6198 3.60001 18.9898 3.60001 18.5998 3.99001L11.9998 10.59L5.39977 3.99001C5.00977 3.60001 4.37977 3.60001 3.98977 3.99001C3.59977 4.38001 3.59977 5.01001 3.98977 5.40001L10.5898 12L3.98977 18.6C3.59977 18.99 3.59977 19.62 3.98977 20.01C4.37977 20.4 5.00977 20.4 5.39977 20.01L11.9998 13.41L18.5998 20.01C18.9898 20.4 19.6198 20.4 20.0098 20.01C20.3998 19.62 20.3998 18.99 20.0098 18.6L13.4098 12L20.0098 5.40001C20.3998 5.01001 20.3998 4.38001 20.0098 3.99001V3.99001Z\"/></svg>\n';
var $author$project$Pyxis$Components$IconSet$svgCrossCircle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0zm1.41 12l2.48-2.48c.39-.39.39-1.02 0-1.41s-1.02-.39-1.41 0L12 10.59 9.52 8.11c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41L10.59 12l-2.48 2.48c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0L12 13.41l2.48 2.48c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L13.41 12z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgCrossCircleFilled = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"m12 0c6.63 0 12 5.37 12 12s-5.37 12-12 12-12-5.37-12-12 5.37-12 12-12zm3.8896 8.1104c-0.3899-0.38998-1.0191-0.38994-1.4091 0l-2.4805 2.4794-2.4805-2.4794c-0.39-0.38994-1.0192-0.38998-1.4092 0s-0.38994 1.0192 0 1.4092l2.4794 2.4805-2.4794 2.4805c-0.38994 0.39-0.38998 1.0192 0 1.4091 0.38998 0.39 1.0192 0.39 1.4092 0l2.4805-2.4794 2.4805 2.4794c0.39 0.39 1.0192 0.39 1.4091 0 0.39-0.3899 0.39-1.0191 0-1.4091l-2.4794-2.4805 2.4794-2.4805c0.39-0.39 0.39-1.0192 0-1.4092z\"/></svg>\n';
var $author$project$Pyxis$Components$IconSet$svgCrossSquare = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M17 3a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h10m0-2H7C3.69 1 1 3.69 1 7v10c0 3.31 2.69 6 6 6h10c3.31 0 6-2.69 6-6V7c0-3.31-2.69-6-6-6h0zm-1.11 7.11h0c-.39-.39-1.02-.39-1.41 0L12 10.59 9.52 8.11c-.39-.39-1.02-.39-1.41 0h0c-.39.39-.39 1.02 0 1.41L10.59 12l-2.48 2.48c-.39.39-.39 1.02 0 1.41h0c.39.39 1.02.39 1.41 0L12 13.41l2.48 2.48c.39.39 1.02.39 1.41 0h0c.39-.39.39-1.02 0-1.41L13.41 12l2.48-2.48c.39-.39.39-1.02 0-1.41z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgDamageThirdParties = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M15.3 18H14c-1.1 0-2-.9-2-2v-1c0-.55-.45-1-1-1v-1.09c2.88-.5 5-3.15 5-6.16V2.41c0-.6-.49-1-1.01-1-.25 0-.5.09-.7.29l-.59.59a.98.98 0 0 1-.71.29c-.26 0-.51-.1-.71-.29L10.69.7a.98.98 0 0 0-.71-.29c-.26 0-.51.1-.71.29L7.71 2.29c-.2.2-.45.3-.71.3s-.51-.1-.71-.29l-.58-.59c-.2-.2-.45-.29-.7-.29-.51 0-1.01.4-1.01 1V7c0 2.97 2.16 5.43 5 5.91V14H4.93C3.61 14 2.65 15.25 3 16.52l1.41 5.26C4.76 23.09 5.94 24 7.3 24h5.4a3 3 0 0 0 2.9-2.22l.67-2.52A1 1 0 0 0 15.3 18zM6 7V4.42c.32.11.65.17 1 .17a2.97 2.97 0 0 0 2.12-.88l.88-.88.88.88c.57.56 1.32.88 2.12.88.35 0 .68-.06 1-.17v2.33c0 2.28-1.74 4.19-3.88 4.25H10a4 4 0 0 1-4-4zm7.66 14.26c-.11.44-.51.74-.96.74H7.3c-.45 0-.85-.3-.97-.74L4.93 16H10a4 4 0 0 0 4 4h0l-.34 1.26zM19 20.8a1.97 1.97 0 0 0-1.73 1l-.4.7c-.38.67.1 1.5.87 1.5h2.54c.77 0 1.25-.83.87-1.5l-.4-.7c-.4-.66-1.08-1-1.75-1h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgDashboard = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M9 3v8H3V3h6m0-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2h0zm0 16v4H3v-4h6m0-2H3c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2h0zm12-2v8h-6v-8h6m0-2h-6c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2h0zm0-8v4h-6V3h6m0-2h-6c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgDashboardFilled = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"m9 1h-6c-1.1 0-2 0.9-2 2v8c0 1.1 0.9 2 2 2h6c1.1 0 2-0.9 2-2v-8c0-1.1-0.9-2-2-2zm0 14h-6c-1.1 0-2 0.9-2 2v4c0 1.1 0.9 2 2 2h6c1.1 0 2-0.9 2-2v-4c0-1.1-0.9-2-2-2zm12-4h-6c-1.1 0-2 0.9-2 2v8c0 1.1 0.9 2 2 2h6c1.1 0 2-0.9 2-2v-8c0-1.1-0.9-2-2-2zm0-10h-6c-1.1 0-2 0.9-2 2v4c0 1.1 0.9 2 2 2h6c1.1 0 2-0.9 2-2v-4c0-1.1-0.9-2-2-2z\"/></svg>\n';
var $author$project$Pyxis$Components$IconSet$svgDevices = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20 8c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h3m0-2h-3c-1.66 0-3 1.34-3 3v10c0 1.66 1.34 3 3 3h3c1.66 0 3-1.34 3-3V9c0-1.66-1.34-3-3-3h0zm-8 11h-2-6c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h13 1.3H20h2.82C22.4 2.84 21.3 2 20 2H4C2.34 2 1 3.34 1 5v11c0 1.66 1.34 3 3 3h6v1H8c-.55 0-1 .45-1 1s.45 1 1 1h5.03c-.64-.84-1.03-1.87-1.03-3v-2z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgDiamond = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M22.95 7.84L19.58 2c-.36-.62-1.02-1-1.73-1H6.15c-.71 0-1.37.38-1.73 1L1.05 7.84a1.98 1.98 0 0 0 .15 2.22l9.22 11.9a1.98 1.98 0 0 0 3.16 0l9.22-11.9a2.02 2.02 0 0 0 .15-2.22zM14.81 10L12 17.98 9.2 10h5.61zM9.55 8L12 3.94 14.45 8h-4.9zm4.22-5h3.5l-1.29 3.66L13.77 3zM8.02 6.66L6.74 3h3.49L8.02 6.66zm1.87 11.35L3.69 10h3.39l2.81 8.01zM16.93 10h3.39l-6.2 8.01L16.93 10zm3.8-2h-3.1l1.17-3.34L20.73 8zM5.2 4.66L6.37 8h-3.1L5.2 4.66z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgDirection = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2.24c.15 0 .45.04.71.29l8.76 8.76c.39.39.39 1.02 0 1.41l-8.76 8.76c-.25.25-.55.29-.71.29s-.45-.04-.71-.29l-8.75-8.75c-.39-.39-.39-1.02 0-1.41l8.75-8.76c.25-.25.55-.29.71-.29m0-2.01c-.77 0-1.54.29-2.12.88L1.12 9.88a3 3 0 0 0 0 4.24l8.76 8.76c.59.59 1.35.88 2.12.88s1.54-.29 2.12-.88l8.76-8.76a3 3 0 0 0 0-4.24l-8.76-8.76C13.53.53 12.77.24 12 .24h0zm4.71 11.05l-3-3c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41l1.29 1.29H8c-.55 0-1 .45-1 1s.45 1 1 1h5.59l-1.29 1.29c-.39.39-.39 1.02 0 1.41a.98.98 0 0 0 .71.29c.26 0 .51-.1.71-.29l3-3c.39-.39.39-1.02 0-1.41z\"/></svg>\n';
var $author$project$Pyxis$Components$IconSet$svgDocument = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20.12 7.12L13.88.88C13.32.32 12.55 0 11.76 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V9.24c0-.79-.32-1.56-.88-2.12zM14 3.83L17.17 7H14V3.83zM19 21c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h5.76c.08 0 .16.03.24.05V7c0 1.1.9 2 2 2h4.95c.02.08.05.16.05.24V21z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgDocumentAlert = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21.12 7.12L14.88.88C14.32.32 13.55 0 12.76 0H7a3.01 3.01 0 0 0-3 3v6.52c.62-.41 1.29-.74 2-1V3c0-.55.45-1 1-1h5.76c.08 0 .16.03.24.05V7c0 1.1.9 2 2 2h4.95c.02.08.05.16.05.24V21c0 .55-.45 1-1 1h-2.52c-.51.76-1.13 1.43-1.83 2H19a3.01 3.01 0 0 0 3-3V9.24c0-.79-.32-1.56-.88-2.12zM15 3.83L18.17 7H15V3.83zM9 12c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5m0-2c-3.87 0-7 3.13-7 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7h0zm0 8c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1z\"/><circle cx=\"9\" cy=\"20\" r=\"1\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgDocumentCheck = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"m19.12 7.12-6.24-6.24c-0.57-0.57-1.32-0.88-2.12-0.88h-5.76c-1.65 0-3 1.35-3 3v18c0 1.65 1.35 3 3 3h7c0.55 0 1-0.45 1-1s-0.45-1-1-1h-7c-0.55 0-1-0.45-1-1v-18c0-0.55 0.45-1 1-1h5.76c0.08 0 0.16 0.03 0.24 0.05v4.95c0 1.1 0.9 2 2 2h4.95c0.02 0.08 0.05 0.16 0.05 0.24v3.76c0 0.55 0.45 1 1 1s1-0.45 1-1v-3.76c0-0.8-0.31-1.55-0.88-2.12zm-6.12-3.29 3.17 3.17h-3.17v-3.17z\"/><path d=\"m17.002 21.9c-0.2703 0-0.5306-0.1084-0.7208-0.2956l-2.0021-2.0201c-0.3804-0.404-0.3704-1.0248 0.02-1.3993 0.4004-0.3744 1.0311-0.3744 1.4115 0.0198l1.2914 1.3007 3.2835-3.311c0.3904-0.3843 1.0211-0.3941 1.4115-0.0197 0.4005 0.3843 0.4005 1.0051 0.02 1.3894l-4.0043 4.0303c-0.1801 0.1971-0.4404 0.3055-0.7107 0.3055z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgDocumentClock = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21.12 7.12L14.88.88C14.32.32 13.55 0 12.76 0H7a3.01 3.01 0 0 0-3 3v6.52c.62-.41 1.29-.74 2-1V3c0-.55.45-1 1-1h5.76c.08 0 .16.03.24.05V7c0 1.1.9 2 2 2h4.95c.02.08.05.16.05.24V21c0 .55-.45 1-1 1h-2.52c-.51.76-1.13 1.43-1.83 2h4.36a3.01 3.01 0 0 0 3-3V9.24c0-.79-.32-1.56-.88-2.12h-.01zM15 3.83L18.17 7H15V3.83zM9 12c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5zm0-2c-3.87 0-7 3.13-7 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm1.33 9.33c-.26 0-.51-.1-.71-.29l-1.63-1.63v-3.5c0-.55.45-1 1-1s1 .45 1 1v2.67l1.04 1.04c.39.39.39 1.02 0 1.41a.98.98 0 0 1-.71.29l.01.01z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgDocumentCross = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"m19.12 7.12-6.24-6.24c-0.57-0.57-1.32-0.88-2.12-0.88h-5.76c-1.65 0-3 1.35-3 3v18c0 1.65 1.35 3 3 3h7c0.55 0 1-0.45 1-1s-0.45-1-1-1h-7c-0.55 0-1-0.45-1-1v-18c0-0.55 0.45-1 1-1h5.76c0.08 0 0.16 0.03 0.24 0.05v4.95c0 1.1 0.9 2 2 2h4.95c0.02 0.08 0.05 0.16 0.05 0.24v3.76c0 0.55 0.45 1 1 1s1-0.45 1-1v-3.76c0-0.8-0.31-1.55-0.88-2.12zm-6.12-3.29 3.17 3.17h-3.17v-3.17z\"/><path d=\"m21.822 22.572c0.39-0.39 0.39-1.02 0-1.41l-1.48-1.48 1.48-1.48c0.39-0.39 0.39-1.02 0-1.41s-1.02-0.39-1.41 0l-1.48 1.48-1.48-1.48c-0.39-0.39-1.02-0.39-1.41 0s-0.39 1.02 0 1.41l1.48 1.48-1.48 1.48c-0.39 0.39-0.39 1.02 0 1.41s1.02 0.39 1.41 0l1.48-1.48 1.48 1.48c0.39 0.39 1.02 0.39 1.41 0z\"/></svg>\n';
var $author$project$Pyxis$Components$IconSet$svgDocumentPdf = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20.12 7.12L13.88.88A2.97 2.97 0 0 0 11.76 0H6a3.01 3.01 0 0 0-3 3v9.5c0 .602.5 1 1 1s1-.402 1-1V3c0-.55.45-1 1-1h5.76c.08 0 .16.03.24.05V7c0 1.1.9 2 2 2h4.95c.02.08.05.16.05.24v3.26c0 .55.45 1 1 1s1-.45 1-1V9.24a2.97 2.97 0 0 0-.88-2.12zM14 3.83L17.17 7H14V3.83zm5.18 20.168h-1.908V15.49h5.484v1.8h-3.588v1.8h3.156v1.728H19.18v3.18zm-8.825-1.788h1.104c1.308 0 2.376-.756 2.376-2.46s-1.068-2.472-2.376-2.472h-1.104v4.932zm1.176 1.788H8.459V15.49h3.084c2.556 0 4.272 1.632 4.272 4.26s-1.716 4.248-4.284 4.248zm-8.523-4.692h1.104c.72 0 1.212-.42 1.212-1.08 0-.684-.492-1.092-1.212-1.092H3.008v2.172zm1.296 1.632H2.996v3.06H1.1V15.49h3.204c1.728 0 2.916 1.14 2.916 2.724 0 1.608-1.188 2.724-2.916 2.724z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgDocumentPlus = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M19.12 7.12L12.88.88A2.97 2.97 0 0 0 10.76 0H5a3.01 3.01 0 0 0-3 3v18a3.01 3.01 0 0 0 3 3h7c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h5.76c.08 0 .16.03.24.05V7c0 1.1.9 2 2 2h4.95c.02.08.05.16.05.24V13c0 .55.45 1 1 1s1-.45 1-1V9.24a2.97 2.97 0 0 0-.88-2.12zM13 3.83L16.17 7H13V3.83zM21 19h-2v-2c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgDocumentSigned = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20.12 7.12L13.88.88C13.32.32 12.55 0 11.76 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V9.24c0-.79-.32-1.56-.88-2.12zM14 3.83L17.17 7H14V3.83zM19 21c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h5.76c.08 0 .16.03.24.05V7c0 1.1.9 2 2 2h4.95c.02.08.05.16.05.24V21zm-3-3h-6c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm0-3h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgDownload = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M18 23H6a4.02 4.02 0 0 1-3.8-2.74c-.2-.62.29-1.26.95-1.26h0c.42 0 .82.24.95.63.27.8 1.02 1.37 1.9 1.37h12c.88 0 1.63-.57 1.9-1.37.13-.39.54-.63.95-.63h0c.66 0 1.15.64.95 1.26A4.02 4.02 0 0 1 18 23zm-2-12c-.39-.39-1.02-.39-1.41 0L13 12.59V2c0-.55-.45-1-1-1s-1 .45-1 1v10.59L9.41 11c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41l3.29 3.29c.2.2.45.3.71.3s.51-.1.71-.29l3.29-3.3c.39-.39.39-1.02 0-1.41z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgEuro = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M14 20c-3.35 0-6.22-2.07-7.41-5H13v-2H6.07c-.04-.33-.07-.66-.07-1s.03-.67.07-1H15V9H6.59C7.78 6.07 10.65 4 14 4a7.95 7.95 0 0 1 5.66 2.34l1.41-1.41A9.93 9.93 0 0 0 14 2C9.53 2 5.74 4.95 4.46 9H3v2h1.05c-.03.33-.05.66-.05 1s.02.67.05 1H3v2h1.46c1.28 4.05 5.07 7 9.54 7a9.93 9.93 0 0 0 7.07-2.93l-1.41-1.41A7.95 7.95 0 0 1 14 20z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgExclamationCircle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0zm0 14.37h0c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v7c0 .56-.45 1-1 1z\"/><circle cx=\"12\" cy=\"17.38\" r=\"1.25\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgExclamationCircleFilled = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 0a12 12 0 1 0 0 24 12 12 0 1 0 0-24zm-1.5 5.88a1.5 1.5 0 1 1 3 0v7a1.5 1.5 0 1 1-3 0v-7zM12 19.63a1.76 1.76 0 0 1-1.75-1.75A1.76 1.76 0 0 1 12 16.13a1.76 1.76 0 0 1 1.75 1.75A1.76 1.76 0 0 1 12 19.63z\"/></svg>\n';
var $author$project$Pyxis$Components$IconSet$svgExclamationTriangle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2.77c.18 0 .62.05.88.52l8.85 16.23a.97.97 0 0 1-.02.99c-.09.15-.34.49-.86.49H3.15c-.51 0-.77-.34-.86-.49s-.26-.54-.02-.99l8.85-16.23c.26-.47.7-.52.88-.52m0-2c-1.03 0-2.07.52-2.63 1.56L.51 18.56C-.58 20.56.87 23 3.14 23h17.7c2.28 0 3.72-2.44 2.63-4.44L14.63 2.33C14.07 1.29 13.03.77 12 .77h0zM12 15h0c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1z\"/><circle cx=\"12\" cy=\"18\" r=\"1.25\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgExpand = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M18 12c-.55 0-1-.45-1-1V7h-4c-.55 0-1-.45-1-1s.45-1 1-1h5c.55 0 1 .45 1 1v5c0 .55-.45 1-1 1zm-7 7H6c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v4h4c.55 0 1 .45 1 1s-.45 1-1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgExternalLink = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M17 22H7c-2.76 0-5-2.24-5-5V7c0-2.76 2.24-5 5-5h3c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1H7C5.34 4 4 5.34 4 7v10c0 1.66 1.34 3 3 3h10c1.66 0 3-1.34 3-3v-3c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v3c0 2.76-2.24 5-5 5zm5-21h-7c-.55 0-1 .45-1 1h0c0 .55.45 1 1 1h4.59L12 10.59c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0L21 4.41V9c0 .55.45 1 1 1h0c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgEye = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 6c4.69 0 7.82 3.39 9.27 5.4.26.36.26.83 0 1.19C19.82 14.61 16.69 18 12 18s-7.82-3.39-9.27-5.4c-.26-.36-.26-.83 0-1.19C4.18 9.39 7.31 6 12 6m0-2C6.43 4 2.8 7.88 1.1 10.24c-.76 1.06-.76 2.47 0 3.52C2.8 16.12 6.43 20 12 20s9.2-3.88 10.9-6.24c.76-1.06.76-2.47 0-3.52C21.2 7.88 17.57 4 12 4h0zm0 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2a4 4 0 1 0 0 8 4 4 0 1 0 0-8h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgEyeSlashed = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M22.9 10.24C21.2 7.88 17.57 4 12 4c-2.03 0-3.79.52-5.3 1.28l1.5 1.51C9.33 6.31 10.59 6 12 6c4.69 0 7.82 3.39 9.27 5.4.26.36.26.83 0 1.19-.76 1.06-1.98 2.49-3.65 3.61l1.44 1.44c1.73-1.24 3.01-2.74 3.83-3.89.76-1.05.76-2.45.01-3.51zM12 10c1.1 0 2 .9 2 2 0 .18-.03.35-.07.51l1.51 1.51A3.95 3.95 0 0 0 16 12a4 4 0 0 0-4-4c-.74 0-1.43.22-2.02.57l1.51 1.51A1.7 1.7 0 0 1 12 10zm7.71 10.29l-1.87-1.87-1.48-1.48-1.85-1.85-1.42-1.42-2.76-2.76-1.42-1.42-2.03-2.02-1.45-1.45-1.72-1.73c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41l1.53 1.53a18.18 18.18 0 0 0-2.72 3c-.76 1.06-.76 2.47 0 3.52C2.8 16.12 6.43 20 12 20a11.57 11.57 0 0 0 3.91-.68l2.39 2.39c.19.19.44.29.7.29s.51-.1.71-.29a1.01 1.01 0 0 0 0-1.42zM12 18c-4.69 0-7.82-3.39-9.27-5.4-.26-.36-.26-.83 0-1.19.57-.8 1.42-1.81 2.51-2.75l2.81 2.81c-.02.17-.05.35-.05.53a4 4 0 0 0 4 4c.18 0 .36-.03.53-.05l1.77 1.77A9.99 9.99 0 0 1 12 18z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgFacebook = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M24 12.07C24 5.27 18.41-.22 11.6 0 5.56.2.47 5.11.03 11.18-.43 17.6 4.11 23.05 10.12 24v-8.44H7.08v-3.49h3.05V9.41c0-3.03 1.79-4.7 4.53-4.7 1.31 0 2.69.24 2.69.24v2.97h-1.51c-1.49 0-1.96.93-1.96 1.89v2.26h3.33l-.53 3.49h-2.8V24C19.61 23.09 24 18.1 24 12.07z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgFamilyRc = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M16 9c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm3 5h-5.78c-.55-.61-1.34-1-2.22-1H5c-1.66 0-3 1.34-3 3v3c0 .55.45 1 1 1h6.18c-.11-.31-.18-.65-.18-1s.07-.69.18-1H4v-2c0-.55.45-1 1-1h5.79c-.43.48-.71 1.08-.77 1.76.53-.47 1.22-.76 1.98-.76.21 0 .42.03.61.07a2.98 2.98 0 0 1 1.39.71V12h5c.55 0 1 .45 1 1v2h-5c0 .77-.3 1.47-.78 2H21c.55 0 1-.45 1-1v-3c0-1.66-1.34-3-3-3zM8 8c1.66 0 3-1.34 3-3S9.66 2 8 2 5 3.34 5 5s1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 13a2 2 0 1 0 0-4 2 2 0 1 0 0 4zm2 1h-4c-1.1 0-2 .9-2 2v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1c0-1.1-.9-2-2-2z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgFax = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M5.62 10.2V15H3.64v-4.8H2.61V8.54h1.03v-.56c0-1.48.9-2.5 2.47-2.5.4 0 .75.05.94.14v1.61c-.1-.03-.27-.06-.59-.06-.35 0-.84.16-.84.87v.49h1.4v1.66h-1.4zm4.03.89l1.52-.23c.35-.05.47-.22.47-.44 0-.38-.33-.7-.95-.7-.69 0-1.07.47-1.1.95l-1.72-.35c.07-.94.93-2.16 2.83-2.16 2.09 0 2.86 1.17 2.86 2.5v3.16c0 .51.06.94.08 1h-1.78c-.01-.05-.06-.29-.06-.73-.35.55-.97.91-1.83.91-1.42 0-2.24-.94-2.24-1.96.01-1.15.85-1.8 1.92-1.95zm1.99 1.19V12l-1.22.2c-.42.06-.73.26-.73.71 0 .34.22.66.77.66.58 0 1.18-.29 1.18-1.29zm5.11-.5l-2.26-3.24h2.33l1.16 1.77 1.13-1.77h2.21l-2.24 3.16 2.31 3.3h-2.31l-1.2-1.82L16.7 15h-2.17l2.22-3.22z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgFloppyDisk = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M22.12 7.12L18 3h0l-1.12-1.12c-.56-.56-1.33-.88-2.12-.88H6 4C2.34 1 1 2.34 1 4v16c0 1.66 1.34 3 3 3h16c1.66 0 3-1.34 3-3V9.24c0-.79-.32-1.56-.88-2.12zM14.76 3a.99.99 0 0 1 .71.29l.53.54V9c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1V3h6.76zM21 20c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h2v6c0 1.66 1.34 3 3 3h6c1.66 0 3-1.34 3-3V5.83l2.71 2.71c.19.18.29.44.29.7V20z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgFolder = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M8.76 5a.99.99 0 0 1 .71.29l1.83 1.83c.56.57 1.31.88 2.11.88H20c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h4.76m0-2H4C2.34 3 1 4.34 1 6v12c0 1.66 1.34 3 3 3h16c1.66 0 3-1.34 3-3V9c0-1.66-1.34-3-3-3h-6.59c-.27 0-.52-.11-.71-.29l-1.83-1.83C10.32 3.32 9.55 3 8.76 3h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgGear = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M14 3v.95a2 2 0 0 0 1.11 1.79c.3.15.55.29.76.43.33.22.72.34 1.11.34.34 0 .69-.09 1-.27l.81-.47 2 3.46-.82.47c-.66.38-1.04 1.1-1 1.86l.01.15.02.29-.01.29-.01.15c-.05.76.34 1.48 1 1.86l.82.47-2 3.46-.81-.47c-.31-.18-.66-.27-1-.27a1.96 1.96 0 0 0-1.11.34c-.21.14-.46.28-.76.43A1.99 1.99 0 0 0 14 20.05V21h-4v-.95a2 2 0 0 0-1.11-1.79c-.3-.15-.55-.29-.76-.43-.33-.22-.72-.34-1.11-.34-.34 0-.69.09-1 .27l-.81.47-2-3.46.82-.47c.66-.38 1.04-1.1 1-1.86l-.01-.15L5 12l.01-.29.01-.15c.05-.76-.34-1.48-1-1.86l-.81-.47 2-3.46.81.47c.31.18.66.27 1 .27a1.96 1.96 0 0 0 1.11-.34c.21-.14.46-.28.76-.43A2 2 0 0 0 10 3.95V3h4m0-2h-4c-1.1 0-2 .9-2 2v.95c-.34.16-.67.35-.98.56l-.81-.47c-.31-.18-.66-.27-1-.27-.69 0-1.36.36-1.73 1l-2 3.46c-.55.96-.22 2.18.73 2.73l.82.47L3 12c0 .19.02.37.03.56l-.82.47c-.96.55-1.28 1.78-.73 2.73l2 3.46c.37.64 1.04 1 1.73 1a2.03 2.03 0 0 0 1-.27l.81-.47a7.36 7.36 0 0 0 .98.57V21c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-.95c.34-.17.67-.35.98-.56l.81.47c.31.18.66.27 1 .27.69 0 1.36-.36 1.73-1l2-3.46c.55-.96.22-2.18-.73-2.73l-.82-.47L21 12c0-.19-.02-.37-.03-.56l.82-.47c.96-.55 1.28-1.78.73-2.73l-2-3.46c-.37-.64-1.04-1-1.73-1a2.03 2.03 0 0 0-1 .27l-.81.47a6.41 6.41 0 0 0-.98-.57V3c0-1.1-.9-2-2-2h0zm-2 8a3.01 3.01 0 0 1 3 3 3.01 3.01 0 0 1-3 3 3.01 3.01 0 0 1-3-3 3.01 3.01 0 0 1 3-3m0-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgGift = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M19 7h-4c1.66 0 3-1.34 3-3h0c0-1.66-1.34-3-3-3s-3 1.34-3 3c0-1.66-1.34-3-3-3S6 2.34 6 4h0c0 1.66 1.34 3 3 3H5c-1.66 0-3 1.34-3 3v10c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3V10c0-1.66-1.34-3-3-3zm0 2c.55 0 1 .45 1 1v4h-7V9h6zm-5-5c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1h-1V4zM8 4c0-.55.45-1 1-1s1 .45 1 1v1H9c-.55 0-1-.45-1-1zM5 9h6v5H4v-4c0-.55.45-1 1-1zM4 20v-4h7v5H5c-.55 0-1-.45-1-1zm15 1h-6v-5h7v4c0 .55-.45 1-1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgGpsDisabled = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M22 11h-1.06c-.46-4.17-3.77-7.48-7.94-7.94V2c0-.55-.45-1-1-1s-1 .45-1 1v1.06C6.83 3.52 3.52 6.83 3.06 11H2c-.55 0-1 .45-1 1s.45 1 1 1h1.06c.46 4.17 3.77 7.48 7.94 7.94V22c0 .55.45 1 1 1s1-.45 1-1v-1.06c4.17-.46 7.48-3.77 7.94-7.94H22c.55 0 1-.45 1-1s-.45-1-1-1zm-9 7.92V18c0-.55-.45-1-1-1s-1 .45-1 1v.92A7 7 0 0 1 5.08 13H6c.55 0 1-.45 1-1s-.45-1-1-1h-.92A7 7 0 0 1 11 5.08V6c0 .55.45 1 1 1s1-.45 1-1v-.92A7 7 0 0 1 18.92 11H18c-.55 0-1 .45-1 1s.45 1 1 1h.92A7 7 0 0 1 13 18.92z\"/></svg>\n';
var $author$project$Pyxis$Components$IconSet$svgGpsEnabled = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M22,11h-1.06c-.46-4.17-3.77-7.48-7.94-7.94v-1.06c0-.55-.45-1-1-1s-1,.45-1,1v1.06c-4.17.46-7.48,3.77-7.94,7.94h-1.06c-.55,0-1,.45-1,1s.45,1,1,1h1.06c.46,4.17,3.77,7.48,7.94,7.94v1.06c0,.55.45,1,1,1s1-.45,1-1v-1.06c4.17-.46,7.48-3.77,7.94-7.94h1.06c.55,0,1-.45,1-1s-.45-1-1-1ZM12,19c-3.86,0-7-3.14-7-7s3.14-7,7-7,7,3.14,7,7-3.14,7-7,7Z\"/><circle cx=\"12\" cy=\"12\" r=\"3\"/></svg>\n';
var $author$project$Pyxis$Components$IconSet$svgGraduationHat = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M23.5 10a1.52 1.52 0 0 0-.75-1.3L13 3.07c-.62-.36-1.38-.36-2 0L1.25 8.7C.79 8.97.5 9.46.5 10s.29 1.03.75 1.3L5 13.46v3.49a1.99 1.99 0 0 0 1 1.73l5 2.89c.31.18.65.27 1 .27s.69-.09 1-.27l5-2.89c.62-.36 1-1.02 1-1.73v-3.49l2-1.15V15c0 .55.45 1 1 1s1-.45 1-1v-3.89a1.5 1.5 0 0 0 .5-1.11zM12 4.8l9 5.2-9 5.2L3 10l9-5.2zm5 12.16l-5 2.89-5-2.89v-2.34l4 2.31c.31.18.65.27 1 .27s.69-.09 1-.27l4-2.31v2.34z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgGrid = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M9 3v6H3V3h6m0-2H3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2h0zm12 2v6h-6V3h6m0-2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2h0zM9 15v6H3v-6h6m0-2H3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2h0zm12 2v6h-6v-6h6m0-2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHeadset = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path fill-rule=\"evenodd\" d=\"M12.73 1.02c-3.2-.2-6.24.93-8.51 3.2C2.08 6.36 1 9.34 1 12.36V17c0 .55.45 1 1 1s1-.45 1-1h2c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1H3.27c.38-1.64 1.16-3.16 2.36-4.36 1.86-1.86 4.35-2.8 6.97-2.62 3.94.26 7.15 3.16 8.1 6.98H19c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h2v1c0 1.66-1.34 3-3 3h-4c0-1.1-.9-2-2-2s-2 .9-2 2v1c0 .55.45 1 1 1h7c2.76 0 5-2.24 5-5v-5.66c0-5.97-4.51-10.95-10.27-11.32z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgHeart = '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n    <path d=\"M12.4971 21.8682C12.1893 22.0444 11.8107 22.0444 11.5029 21.8682L12 21L12.4971 21.8682ZM21 8.52246C20.9999 7.304 20.5444 6.14678 19.751 5.30273C18.9593 4.46071 17.8988 4 16.8076 4C15.0415 4.00003 13.5572 5.01154 12.9336 6.63184C12.785 7.01793 12.4137 7.27246 12 7.27246C11.5863 7.27246 11.215 7.01793 11.0664 6.63184C10.4428 5.01154 8.95853 4.00003 7.19238 4C6.10111 4 5.04066 4.46071 4.24902 5.30273C3.45562 6.14677 3.00006 7.30398 3 8.52246C3 11.4382 5.19755 14.2996 7.67285 16.5527C8.87961 17.6512 10.0913 18.5501 11.0029 19.1748C11.4037 19.4494 11.7452 19.6692 12 19.8291C12.2548 19.6692 12.5963 19.4494 12.9971 19.1748C13.9087 18.5501 15.1204 17.6512 16.3271 16.5527C18.8025 14.2996 21 11.4382 21 8.52246ZM23 8.52246C23 12.3566 20.1974 15.7343 17.6729 18.0322C16.3798 19.2092 15.0912 20.1641 14.1279 20.8242C13.6453 21.1549 13.2416 21.4131 12.957 21.5898C12.8149 21.6781 12.7023 21.7464 12.624 21.793C12.5852 21.8161 12.5545 21.8342 12.5332 21.8467C12.5226 21.8528 12.5138 21.8579 12.5078 21.8613C12.5051 21.8629 12.5027 21.8642 12.501 21.8652C12.5001 21.8657 12.4986 21.8668 12.498 21.8672H12.4971C12.494 21.8625 12.4583 21.8003 12 21C11.5414 21.8008 11.5059 21.8626 11.5029 21.8672H11.502C11.5014 21.8668 11.4999 21.8657 11.499 21.8652C11.4973 21.8642 11.4949 21.8629 11.4922 21.8613C11.4862 21.8579 11.4774 21.8528 11.4668 21.8467C11.4455 21.8342 11.4148 21.8161 11.376 21.793C11.2977 21.7464 11.1851 21.6781 11.043 21.5898C10.7584 21.4131 10.3547 21.1549 9.87207 20.8242C8.90877 20.1641 7.62019 19.2092 6.32715 18.0322C3.80258 15.7343 1 12.3566 1 8.52246C1.00006 6.81192 1.63825 5.15985 2.79199 3.93262C3.94784 2.7032 5.52948 2 7.19238 2C9.1213 2.00002 10.8592 2.84336 12 4.27637C13.1408 2.84336 14.8787 2.00002 16.8076 2C18.4705 2 20.0522 2.7032 21.208 3.93262C22.3617 5.15984 22.9999 6.81192 23 8.52246Z\"/>\n</svg>\n';
var $author$project$Pyxis$Components$IconSet$svgHeartFilled = '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n    <path d=\"M23 8.45984C23 15.7532 12.8064 21.6567 12.3722 21.9004C12.2578 21.9658 12.1299 22 12 22C11.8701 22 11.7422 21.9658 11.6278 21.9004C11.1936 21.6567 1 15.7532 1 8.45984C1.00182 6.74717 1.64395 5.10521 2.78552 3.89418C3.92709 2.68314 5.47486 2.00193 7.08929 2C9.11741 2 10.8931 2.92522 12 4.48913C13.1069 2.92522 14.8826 2 16.9107 2C18.5251 2.00193 20.073 2.68314 21.2144 3.89418C22.356 5.10521 22.9982 6.74717 23 8.45984Z\"/>\n</svg>\n';
var $author$project$Pyxis$Components$IconSet$svgHome = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 3.24c.15 0 .45.04.71.29l6.71 6.71c.38.38.59.88.59 1.41V20c0 .55-.45 1-1 1h-3v-5a3.01 3.01 0 0 0-3-3h-2a3.01 3.01 0 0 0-3 3v5H5c-.55 0-1-.45-1-1v-8.34c0-.53.21-1.04.59-1.41l6.71-6.71c.25-.26.55-.3.7-.3m0-2c-.77 0-1.54.29-2.12.88L3.17 8.83C2.42 9.58 2 10.6 2 11.66V20c0 1.66 1.34 3 3 3h3c1.1 0 2-.9 2-2v-5c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v5c0 1.1.9 2 2 2h3c1.66 0 3-1.34 3-3v-8.34c0-1.06-.42-2.08-1.17-2.83l-6.71-6.71A3 3 0 0 0 12 1.24h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHomeAndFamily = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 3.24c.15 0 .45.04.71.29l6.71 6.71c.38.38.59.88.59 1.41v8.34c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1v-8.34c0-.53.21-1.04.59-1.41l6.71-6.71c.25-.25.55-.29.71-.29m-.01-2c-.77 0-1.54.29-2.12.88L3.17 8.83C2.42 9.58 2 10.6 2 11.66V20c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3v-8.34c0-1.06-.42-2.08-1.17-2.83l-6.71-6.71c-.59-.59-1.35-.88-2.12-.88zM12 14a2 2 0 1 0 0-4 2 2 0 1 0 0 4zm2 1h-4c-1.1 0-2 .9-2 2v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1c0-1.1-.9-2-2-2z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHomeDamageEbike = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M19 13c-.1 0-.2.02-.3.03l-.82-3.07C17.41 8.22 15.83 7 14.02 7H13c-.55 0-1 .45-1 1s.45 1 1 1h1.02c.9 0 1.7.61 1.93 1.48l.01.03-4.46 2.57-1.16-1.16A.96.96 0 0 0 11 11c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1h1.59l2.13 2.13-.99.57C7.81 13.66 6.49 13 5 13c-2.76 0-5 2.24-5 5s2.24 5 5 5a5 5 0 0 0 4.9-4h4.2a5 5 0 0 0 4.9 4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-2.5-.48l.28 1.03c-1.35.68-2.36 1.93-2.67 3.45H9.9c-.04-.2-.11-.38-.18-.57l6.78-3.91zM5 21a3.01 3.01 0 0 1-3-3 3.01 3.01 0 0 1 3-3c1.3 0 2.4.84 2.82 2H5c-.55 0-1 .45-1 1s.45 1 1 1h2.82C7.4 20.16 6.3 21 5 21zm14 0a3.01 3.01 0 0 1-3-3c0-1.02.52-1.93 1.3-2.47l.73 2.73c.12.45.53.74.97.74.09 0 .17-.01.26-.03.53-.14.85-.69.71-1.22l-.73-2.72c1.54.12 2.76 1.4 2.76 2.97a3.01 3.01 0 0 1-3 3zM8 2v3H3l7 3V5h5L8 2z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHomeDamageFamily = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M16.37 9.52a8.01 8.01 0 0 0 0 8.96A6.99 6.99 0 0 0 18 14a6.99 6.99 0 0 0-1.63-4.48zM7.12 8.17A6.96 6.96 0 0 1 11 7a6.96 6.96 0 0 1 3.88 1.17C13.7 9.81 13 11.82 13 14s.7 4.19 1.88 5.83A6.96 6.96 0 0 1 11 21a6.96 6.96 0 0 1-3.88-1.17C8.3 18.19 9 16.18 9 14s-.7-4.19-1.88-5.83zm10.59 11.82a8.71 8.71 0 0 1-1.5 1.34C14.74 22.38 12.95 23 11 23s-3.74-.62-5.21-1.67a8.71 8.71 0 0 1-1.5-1.34 8.97 8.97 0 0 1 0-11.98 8.71 8.71 0 0 1 1.5-1.34C7.26 5.62 9.05 5 11 5s3.74.62 5.21 1.67a8.71 8.71 0 0 1 1.5 1.34 8.97 8.97 0 0 1 0 11.98zM5.62 9.53C4.61 10.74 4 12.3 4 14s.61 3.26 1.62 4.47C6.49 17.2 7 15.65 7 14s-.51-3.2-1.38-4.47z\" fill-rule=\"evenodd\"/><path d=\"M19.07 5.93c-.26 0-.51-.1-.71-.29-.39-.39-.39-1.02 0-1.41l1.41-1.41c.39-.39 1.02-.39 1.41 0s.39 1.02 0 1.41l-1.41 1.41c-.19.19-.44.29-.7.29zM20.66 8c-.35 0-.68-.18-.87-.5-.28-.48-.11-1.09.37-1.37l1.73-1c.48-.28 1.09-.11 1.37.37s.11 1.09-.37 1.37l-1.73 1a1.01 1.01 0 0 1-.5.13zM17 4.34a1.01 1.01 0 0 1-.5-.13 1.01 1.01 0 0 1-.37-1.37l1-1.73A1.01 1.01 0 0 1 18.5.74a1.01 1.01 0 0 1 .37 1.37l-1 1.73a1.02 1.02 0 0 1-.87.5z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHomeDamagePets = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M4 9c.15 0 .45.04.71.29.39.39.39 1.02 0 1.41-.26.26-.56.3-.71.3s-.45-.04-.71-.29c-.39-.39-.39-1.02 0-1.41.26-.26.56-.3.71-.3m0-2c-.77 0-1.54.29-2.12.88a3 3 0 0 0 0 4.24c.58.59 1.35.88 2.12.88s1.54-.29 2.12-.88a3 3 0 0 0 0-4.24C5.54 7.29 4.77 7 4 7h0zm4.5-3c.15 0 .45.04.71.29.25.26.29.56.29.71s-.04.45-.29.71c-.26.25-.56.29-.71.29s-.45-.04-.71-.29c-.39-.39-.39-1.02 0-1.41.26-.26.56-.3.71-.3m0-2c-.77 0-1.54.29-2.12.88a3 3 0 0 0 0 4.24c.58.59 1.35.88 2.12.88s1.54-.29 2.12-.88a3 3 0 0 0 0-4.24C10.04 2.29 9.27 2 8.5 2h0zm7 2c.15 0 .45.04.71.29.25.26.29.56.29.71s-.04.45-.29.71c-.26.25-.56.29-.71.29s-.45-.04-.71-.29c-.39-.39-.39-1.02 0-1.41.26-.26.56-.3.71-.3m0-2c-.77 0-1.54.29-2.12.88a3 3 0 0 0 0 4.24c.58.59 1.35.88 2.12.88s1.54-.29 2.12-.88a3 3 0 0 0 0-4.24C17.04 2.29 16.27 2 15.5 2h0zM20 9c.15 0 .45.04.71.29.25.26.29.56.29.71s-.04.45-.29.71c-.26.25-.56.29-.71.29s-.45-.04-.71-.29c-.39-.39-.39-1.02 0-1.41.26-.26.56-.3.71-.3m0-2c-.77 0-1.54.29-2.12.88a3 3 0 0 0 0 4.24c.58.59 1.35.88 2.12.88s1.54-.29 2.12-.88a3 3 0 0 0 0-4.24C21.54 7.29 20.77 7 20 7h0zm-8 5.49c1.07 0 2.07.42 2.83 1.17l1.96 1.96c.97.97 1.11 2.49.31 3.47a2.46 2.46 0 0 1-1.93.91c-.35 0-.69-.07-1.01-.21-.69-.31-1.42-.46-2.16-.46s-1.47.16-2.16.46c-.32.14-.66.21-1.01.21-.74 0-1.45-.33-1.93-.91-.8-.97-.67-2.49.31-3.47l1.96-1.96A3.96 3.96 0 0 1 12 12.49m0-2c-1.54 0-3.07.59-4.24 1.76L5.8 14.21c-1.66 1.66-1.92 4.35-.43 6.15C6.26 21.45 7.55 22 8.83 22c.62 0 1.24-.13 1.82-.38a3.38 3.38 0 0 1 1.35-.29c.46 0 .92.1 1.35.29.58.26 1.2.38 1.82.38a4.49 4.49 0 0 0 3.47-1.64c1.49-1.81 1.22-4.5-.43-6.15l-1.96-1.96A5.97 5.97 0 0 0 12 10.49h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHomeDamageThirdParties = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20 18h-.23L16.08 4.22C15.73 2.91 14.53 2 13.18 2h-2.36a3 3 0 0 0-2.9 2.22L4.23 18H4c-1.1 0-2 .9-2 2v1c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-1c0-1.1-.9-2-2-2zM10.82 4h2.36c.45 0 .85.3.97.74L15.02 8H8.98l.87-3.26c.12-.44.52-.74.97-.74zm-2.37 6h7.11l.8 3H7.64l.81-3zm-1.34 5h9.79l.8 3H6.3l.81-3zM20 21H4v-1h16v1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHomeDomesticThefts = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21.83 9.9L8.43 2.17a2.89 2.89 0 0 0-1.49-.41c-1.04 0-2.05.54-2.6 1.5l-2 3.47C1.51 8.16 2 10 3.43 10.83L8 13.46V15c0 1.1-.9 2-2 2h-.11c-.38-1.87-1.8-3.37-3.64-3.84a1.07 1.07 0 0 0-.25-.03c-.54 0-1 .44-1 1.01v7.74a1.01 1.01 0 0 0 1 1.01 1.07 1.07 0 0 0 .25-.03c1.84-.47 3.26-1.97 3.64-3.84H6a4 4 0 0 0 4-4v-.38l1.83 1.06a2.96 2.96 0 0 0 1.5.4c.36 0 .73-.07 1.08-.2.23.22.49.42.78.59.63.36 1.32.54 2 .54a4.02 4.02 0 0 0 3.47-2 4 4 0 0 0 .42-2.93l.75-.44c.66-.41.66-1.38 0-1.76zM3 20.24v-4.48a3.01 3.01 0 0 1 0 4.48zM18.92 14c-.35.61-1.02 1-1.73 1-.3 0-.59-.07-.86-.2l2.85-1.64a1.96 1.96 0 0 1-.26.84zm-.61-2.65l-3.11 1.8-1.37.79c-.16.09-.32.13-.49.13h-.01c-.18 0-.35-.04-.5-.13l-8.4-4.85c-.47-.27-.64-.88-.36-1.36l2-3.47a.99.99 0 0 1 .87-.5c.17 0 .34.05.49.14l8.99 5.18 2.91 1.68-1.02.59z\" fill-rule=\"evenodd\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHomeEmergenciesRepairs = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M23 5h-3.18C19.4 3.84 18.3 3 17 3c0-1.1-.9-2-2-2H5C2.24 1 0 3.24 0 6a5 5 0 0 0 4 4.9V20c0 1.66 1.34 3 3 3h.7a3 3 0 0 0 2.9-2.22L13.22 11H15c1.1 0 2-.9 2-2 1.3 0 2.4-.84 2.82-2H23c.55 0 1-.45 1-1s-.45-1-1-1zM8.66 20.26c-.11.44-.51.74-.96.74H7c-.55 0-1-.45-1-1v-9h5.14l-2.48 9.26zM15 9h-1.25H5a3.01 3.01 0 0 1-3-3 3.01 3.01 0 0 1 3-3h10v6zm2-2V5c.55 0 1 .45 1 1s-.45 1-1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHomeFireExplosion = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M10.78 3.16c4.68.85 8.22 5 8.22 9.84v.69c0 3.85-2.87 7.06-6.53 7.29-.16.01-.31.02-.47.02a7.01 7.01 0 0 1-7-7c0-2.13.95-4.11 2.6-5.45 1.63-1.32 2.74-3.2 3.18-5.39m-.86-2.12c-.49 0-.92.36-.97.85-.2 2.04-1.11 3.9-2.61 5.1C4.3 8.64 3 11.17 3 14c0 4.97 4.03 9 9 9 .2 0 .4-.01.6-.02 4.78-.31 8.4-4.5 8.4-9.29V13c0-6.29-4.84-11.45-11-11.96h-.08 0zm3.91 11.09c.67 1.03.74 2.38.1 3.49l-.14.24c-.4.69-1.14 1.14-1.89 1.14a1.7 1.7 0 0 1-.74-.16c-.53-.24-.91-.67-1.09-1.22-.17-.54-.11-1.12.17-1.61a1.99 1.99 0 0 1 1.42-.98c.77-.11 1.51-.43 2.17-.9m.12-2.42c-.28 0-.56.13-.77.35-.5.53-1.13.9-1.83 1-1.15.18-2.22.86-2.84 1.95-1.17 2.03-.37 4.65 1.81 5.64.51.23 1.05.34 1.58.34 1.45 0 2.86-.81 3.62-2.14l.14-.24a5.34 5.34 0 0 0-1.14-6.71 1 1 0 0 0-.57-.19h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHomeFurnitureContent = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20 10.18V7c0-.55-.45-1-1-1h-1a3.01 3.01 0 0 1-3-3V2c0-.55-.45-1-1-1H8a4 4 0 0 0-4 4v5.18C2.84 10.6 2 11.7 2 13v6c0 1.1.9 2 2 2 0 1.1.9 2 2 2s2-.9 2-2H6h12-2c0 1.1.9 2 2 2s2-.9 2-2c1.1 0 2-.9 2-2v-6c0-1.3-.84-2.4-2-2.82zM8 16h8v3H8v-3zm-4-3c0-.55.45-1 1-1s1 .45 1 1v6h0 0-2v-6zm12 0v1H8v-1c0-1.3-.84-2.4-2-2.82V5c0-1.1.9-2 2-2h5c0 2.76 2.24 5 5 5v2.18c-1.16.42-2 1.52-2 2.82zm4 6h-2v-6c0-.55.45-1 1-1s1 .45 1 1v6z\" fill-rule=\"evenodd\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHomeInjuriesFamily = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M15 3v4 2h2 4v6h-4-2v2 4H9v-4-2H7 3V9h4 2V7 3h6m0-2H9c-1.1 0-2 .9-2 2v4H3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h4v4c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-4h4c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2h-4V3c0-1.1-.9-2-2-2h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHomeInjuriesFreetime = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20.49 3.51h0a5.99 5.99 0 0 0-4.24-1.76c-1.53 0-3.08.59-4.25 1.76L3.51 12c-2.34 2.34-2.34 6.14 0 8.49a5.99 5.99 0 0 0 8.48 0l8.5-8.49c2.34-2.34 2.34-6.14 0-8.49zm-9.9 15.56a3.96 3.96 0 0 1-2.83 1.17c-1.07 0-2.07-.42-2.83-1.17a3.96 3.96 0 0 1-1.17-2.83c0-1.07.42-2.07 1.17-2.83l3.54-3.54 5.66 5.66-3.54 3.54zm8.48-8.48l-3.54 3.54-5.65-5.67 3.54-3.54a3.96 3.96 0 0 1 2.83-1.17c1.07 0 2.07.42 2.83 1.17a4.03 4.03 0 0 1-.01 5.67z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHomeInsuranceHome = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 3.24c.15 0 .45.04.71.29l6.71 6.71c.38.38.59.88.59 1.41V20c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1v-8.34c0-.53.21-1.04.59-1.41l6.71-6.71c.25-.26.55-.3.7-.3m0-2c-.77 0-1.54.29-2.12.88L3.17 8.83C2.42 9.58 2 10.6 2 11.66V20c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3v-8.34c0-1.06-.42-2.08-1.17-2.83l-6.71-6.71A3 3 0 0 0 12 1.24h0zm3 10.83V10.5a3.01 3.01 0 0 0-3-3 3.01 3.01 0 0 0-3 3v1.57c-.86.22-1.5 1-1.5 1.93v3c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-3c0-.93-.64-1.71-1.5-1.93zM12 9.5c.55 0 1 .45 1 1V12h-2v-1.5c0-.55.45-1 1-1zm2.5 7.5h-5v-3h5v3z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHomeLegalProtection = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12.65 21.72c-.21.07-.42.11-.65.11-.22 0-.44-.04-.65-.11C4.98 19.5 5 13.3 5 13.05V13l-.03-7.1C8.5 5.52 10.74 4.14 12 3.04c1.26 1.1 3.5 2.48 7 2.85v6.81l1.96 1.13c.05-.51.04-.83.04-.83V5.89c0-1.01-.75-1.87-1.75-1.98-2.98-.32-4.86-1.44-5.95-2.39-.37-.33-.83-.49-1.3-.49a1.97 1.97 0 0 0-1.3.49c-1.09.95-2.96 2.07-5.94 2.39C3.75 4.02 3 4.88 3 5.89V13s-.2 7.85 7.69 10.61c.42.15.86.22 1.31.22s.89-.07 1.31-.22c2.68-.94 4.41-2.46 5.55-4.07l-1.75-1.01c-.94 1.27-2.34 2.45-4.46 3.19zm8.95-5.21l-5.63-3.25.5-.87a3 3 0 0 0-1.1-4.1l-.87-.5c-.47-.27-.99-.4-1.5-.4-1.04 0-2.05.54-2.6 1.5l-2 3.46a3 3 0 0 0 1.1 4.1l.87.5c.47.27.99.4 1.5.4 1.04 0 2.05-.54 2.6-1.5l.5-.87 5.63 3.25a1.01 1.01 0 0 0 .5.13c.35 0 .68-.18.87-.5.27-.46.1-1.07-.37-1.35zm-8.87-1.65c-.18.31-.51.5-.87.5-.18 0-.34-.05-.5-.13l-.87-.5c-.31-.18-.43-.46-.47-.61a1 1 0 0 1 .1-.76l2-3.46c.18-.31.51-.5.87-.5.18 0 .34.05.5.13l.87.5c.31.18.43.46.47.61a1 1 0 0 1-.1.76l-2 3.46z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHomeNaturalEvents = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12.11 23a1.01 1.01 0 0 1-.5-.13 1.01 1.01 0 0 1-.37-1.37l2.02-3.5H10c-.36 0-.69-.19-.87-.5s-.18-.69 0-1l2.89-5a1.01 1.01 0 0 1 1.37-.37 1.01 1.01 0 0 1 .37 1.37L11.73 16H15c.36 0 .69.19.87.5s.18.69 0 1l-2.89 5c-.19.32-.52.5-.87.5zm6.88-15.86c0-.05.01-.09.01-.14 0-3.31-2.69-6-6-6-2.62 0-4.85 1.69-5.66 4.03C7.22 5.03 7.12 5 7 5c-2.76 0-5 2.24-5 5s2.24 5 5 5h.69l1.15-2H7a3.01 3.01 0 0 1-3-3 3.01 3.01 0 0 1 2.93-3l.27.03 1.52.1.5-1.44C9.78 4.08 11.3 3 13 3c2.19 0 3.98 1.77 4 3.96 0 .04-.01.09-.01.13l-.04 1.59 1.54.4C19.38 9.3 20 10.1 20 11c0 1.1-.9 2-2 2h-2.29c-.06.17-.13.34-.22.5l-.87 1.5H18a4 4 0 0 0 4-4 3.99 3.99 0 0 0-3.01-3.86z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHomeRobberiesOutside = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M19.3 10.31c-.54-2.33-2.16-4.25-4.31-5.18 0-.05.01-.09.01-.13 0-1.66-1.34-3-3-3S9 3.34 9 5c0 .04.01.08.01.12-2.15.94-3.77 2.86-4.31 5.19-1 .48-1.7 1.5-1.7 2.69 0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3 0-1.19-.7-2.21-1.7-2.69zm-8.19-5.75c.17-.33.5-.56.89-.56s.72.23.89.56c-.3-.04-.59-.06-.89-.06s-.59.02-.89.06zM18 14H6c-.55 0-1-.45-1-1a1 1 0 0 1 .57-.89l.86-.42.22-.93C7.23 8.25 9.43 6.5 12 6.5s4.77 1.75 5.35 4.26l.22.93.86.42c.28.13.57.44.57.89 0 .55-.45 1-1 1zm1.87 4h-7.74c-.05 0-.09.01-.13.02-.04-.01-.09-.02-.13-.02H4.13c-.65 0-1.14.62-.97 1.25A4.99 4.99 0 0 0 8 23c1.64 0 3.09-.8 4-2.02.91 1.22 2.36 2.02 4 2.02a4.99 4.99 0 0 0 4.84-3.75c.17-.63-.32-1.25-.97-1.25zM8 21a3.01 3.01 0 0 1-2.24-1h4.48A3.01 3.01 0 0 1 8 21zm8 0a3.01 3.01 0 0 1-2.24-1h4.48A3.01 3.01 0 0 1 16 21z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHomeTelephoneLegalAdvice = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M17 2.67c.71.46 1.7.91 3 1.15v2.92c0 .03-.03 3.14-3 4.17-2.86-.99-2.99-3.86-3-4.17V3.82c1.3-.23 2.29-.69 3-1.15m0-2.24c-.22 0-.44.07-.61.22-.61.5-1.7 1.14-3.48 1.31a1 1 0 0 0-.91.99v3.8s0 4.61 4.43 6.09a1.79 1.79 0 0 0 .57.09c.19 0 .38-.03.57-.09C22 11.36 22 6.75 22 6.75v-3.8a1 1 0 0 0-.9-.99c-1.78-.17-2.88-.8-3.48-1.31A.96.96 0 0 0 17 .43h0zm-.98 22.25a4 4 0 0 1-.84-.09C8.3 21.11 2.89 15.7 1.41 8.81A3.88 3.88 0 0 1 2.2 5.5C2.97 4.55 4.11 4 5.33 4h1.03A3 3 0 0 1 9.3 6.41l.47 2.34c.2.99-.11 2-.82 2.71.94 1.42 2.13 2.65 3.5 3.67l.08-.08c.71-.71 1.73-1.02 2.71-.82l2.34.47c1.4.28 2.41 1.52 2.41 2.94v1.03c0 1.22-.55 2.36-1.5 3.13a3.87 3.87 0 0 1-2.47.88zM5.33 6a1.98 1.98 0 0 0-1.57.75 1.95 1.95 0 0 0-.4 1.64 16.01 16.01 0 0 0 12.25 12.25 1.98 1.98 0 0 0 1.64-.39 2.01 2.01 0 0 0 .75-1.57v-1.03c0-.47-.34-.89-.8-.98l-2.34-.47c-.33-.06-.67.04-.9.27l-.08.08c-.7.7-1.81.79-2.59.21-1.55-1.15-2.9-2.54-4.01-4.11-.56-.79-.46-1.86.24-2.55.27-.27.37-.61.31-.94L7.34 6.8a1 1 0 0 0-.98-.8H5.33z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHomeTheftValuable = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M15.73 7.93l1.5-2.6a2 2 0 0 0-.32-2.41l-1.33-1.33c-.37-.38-.88-.59-1.41-.59H9.83c-.53 0-1.04.21-1.42.59L7.09 2.91a2 2 0 0 0-.32 2.42l1.5 2.6C5.73 9.27 4 11.93 4 15a8 8 0 1 0 16 0c0-3.07-1.73-5.73-4.27-7.07zM8.5 4.33L9.83 3h4.34 0l1.33 1.33-1.67 2.89C13.24 7.08 12.63 7 12 7s-1.24.08-1.83.22L8.5 4.33zM12 21c-3.31 0-6-2.69-6-6 0-2.32 1.33-4.34 3.27-5.34a5.98 5.98 0 0 1 5.46 0c1.94 1 3.27 3.01 3.27 5.34 0 3.31-2.69 6-6 6z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHourglass = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M17.83 8.59C18.57 7.84 19 6.81 19 5.76V4a3.01 3.01 0 0 0-3-3H8a3.01 3.01 0 0 0-3 3v1.76c0 1.05.43 2.08 1.17 2.83l2.71 2.71a.99.99 0 0 1 .29.71.99.99 0 0 1-.29.71l-2.71 2.71C5.42 16.17 5 17.17 5 18.24V20a3.01 3.01 0 0 0 3 3h8a3.01 3.01 0 0 0 3-3v-1.76c0-1.07-.42-2.07-1.17-2.83l-2.71-2.71a.99.99 0 0 1-.29-.71.99.99 0 0 1 .29-.71l2.71-2.69zM17 20c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-1h10v1zm-3.29-5.88l2.71 2.71c.05.05.09.11.14.17H7.45l.14-.17 2.71-2.71a2.97 2.97 0 0 0 .88-2.12 2.97 2.97 0 0 0-.88-2.12L7.59 7.17C7.21 6.8 7 6.28 7 5.76V4c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v1.76c0 .53-.21 1.04-.59 1.41L13.7 9.88a2.97 2.97 0 0 0-.88 2.12c.01.8.32 1.55.89 2.12z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgHourglassCross = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><g ><use href=\"#B\"/><path d=\"M17.41 16l1.06-1.06c.39-.39.39-1.02 0-1.41s-1.02-.39-1.41 0L16 14.59l-1.06-1.06c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41L14.59 16l-1.06 1.06c-.39.39-.39 1.02 0 1.41a.98.98 0 0 0 .71.29c.26 0 .51-.1.71-.29l1.06-1.06 1.06 1.06a.98.98 0 0 0 .71.29c.26 0 .51-.1.71-.29.39-.39.39-1.02 0-1.41L17.43 16h-.02z\"/><use href=\"#B\"/><path d=\"M8.52 21H4c-.55 0-1-.45-1-1v-1h4.53c-.23-.64-.39-1.31-.47-2H3.45l.14-.17 2.71-2.71a3 3 0 0 0 0-4.24L3.59 7.17C3.21 6.79 3 6.29 3 5.76V4c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v1.76c0 .53-.21 1.04-.59 1.41l-1.25 1.25c1.07-.68 2.29-1.15 3.6-1.33.15-.43.24-.87.24-1.34V3.99a3.01 3.01 0 0 0-3-3H4a3.01 3.01 0 0 0-3 3v1.76c0 1.07.42 2.07 1.17 2.83l2.71 2.71c.39.39.39 1.02 0 1.42l-2.71 2.71C1.41 16.17 1 17.18 1 18.25v1.76a3.01 3.01 0 0 0 3 3h6.36c-.71-.57-1.33-1.24-1.83-2L8.52 21z\"/></g><defs ><path id=\"B\" d=\"M16 11c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5zm0-2c-3.87 0-7 3.13-7 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7z\"/></defs></svg>';
var $author$project$Pyxis$Components$IconSet$svgIdCard = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21 2.5H3c-1.66 0-3 1.34-3 3v13c0 1.66 1.34 3 3 3h3 12 3c1.66 0 3-1.34 3-3v-13c0-1.66-1.34-3-3-3zm-13 17v-2c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v2H8zm14-1c0 .55-.45 1-1 1h-3v-2c0-1.66-1.34-3-3-3H9c-1.66 0-3 1.34-3 3v2H3c-.55 0-1-.45-1-1v-13c0-.55.45-1 1-1h18c.55 0 1 .45 1 1v13zm-10-12c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 1 1 0 3z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgInfoCircle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0zm0 18.62h0c-.55 0-1-.45-1-1v-6h0c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v7c0 .56-.45 1-1 1z\"/><circle cx=\"12\" cy=\"6.63\" r=\"1.25\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgInstagram = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2.98l4.44.06c1.07.05 1.65.23 2.04.38.51.2.88.44 1.26.82s.62.75.82 1.26c.15.39.33.97.38 2.04l.06 4.44-.06 4.44c-.05 1.07-.23 1.65-.38 2.04-.2.51-.44.88-.82 1.26s-.75.62-1.26.82c-.39.15-.97.33-2.04.38l-4.44.06c-2.93 0-3.29-.01-4.44-.06-1.07-.05-1.65-.23-2.04-.38-.51-.2-.88-.44-1.26-.82-.4-.35-.64-.72-.84-1.23-.15-.39-.33-.97-.38-2.04L2.98 12l.06-4.44c.06-1.08.23-1.66.38-2.05a3.34 3.34 0 0 1 .83-1.26 3.34 3.34 0 0 1 1.26-.83c.39-.15.97-.32 2.05-.37L12 2.98M12 1l-4.54.07c-1.17.05-1.97.24-2.67.51-.72.28-1.33.65-1.94 1.27-.62.61-.99 1.22-1.27 1.94-.27.7-.46 1.5-.51 2.67L1 12l.07 4.54c.05 1.17.24 1.97.51 2.67a5.42 5.42 0 0 0 1.27 1.95c.61.61 1.22.99 1.95 1.27.7.27 1.5.46 2.67.51L12 23l4.54-.07c1.17-.05 1.97-.24 2.67-.51a5.42 5.42 0 0 0 1.95-1.27c.61-.61.99-1.22 1.27-1.95.27-.7.46-1.5.51-2.67L23 12l-.07-4.54c-.05-1.17-.24-1.97-.51-2.67a5.42 5.42 0 0 0-1.27-1.95c-.61-.61-1.22-.99-1.95-1.27-.7-.27-1.5-.46-2.67-.51L12 1h0zm0 5.35a5.65 5.65 0 0 0 0 11.3 5.65 5.65 0 0 0 0-11.3zm0 9.32c-2.03 0-3.67-1.64-3.67-3.67S9.97 8.33 12 8.33s3.67 1.64 3.67 3.67-1.64 3.67-3.67 3.67z\"/><circle cx=\"17.87\" cy=\"6.13\" r=\"1.32\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgInsuranceHome = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 3.24c.15 0 .45.04.71.29l6.71 6.71c.38.38.59.88.59 1.41V20c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1v-8.34c0-.53.21-1.04.59-1.41l6.71-6.71c.25-.26.55-.3.7-.3m0-2c-.77 0-1.54.29-2.12.88L3.17 8.83C2.42 9.58 2 10.6 2 11.66V20c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3v-8.34c0-1.06-.42-2.08-1.17-2.83l-6.71-6.71A3 3 0 0 0 12 1.24h0zm3 10.83V10.5a3.01 3.01 0 0 0-3-3 3.01 3.01 0 0 0-3 3v1.57c-.86.22-1.5 1-1.5 1.93v3c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-3c0-.93-.64-1.71-1.5-1.93zM12 9.5c.55 0 1 .45 1 1V12h-2v-1.5c0-.55.45-1 1-1zm2.5 7.5h-5v-3h5v3z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgJobs = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20 6h-3a4 4 0 0 0-4-4h-2a4 4 0 0 0-4 4H4C2.34 6 1 7.34 1 9v4 7c0 1.66 1.34 3 3 3h16c1.66 0 3-1.34 3-3V9c0-1.66-1.34-3-3-3zM9 6c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2H9zM4 8h16c.55 0 1 .45 1 1v3h-7c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1H3V9c0-.55.45-1 1-1zm16 13H4c-.55 0-1-.45-1-1v-6h7v1c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1h7v6c0 .55-.45 1-1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgKey = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M8 19a3.01 3.01 0 0 1-3-3 3.01 3.01 0 0 1 3-3 3.01 3.01 0 0 1 3 3 3.01 3.01 0 0 1-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 8a7.01 7.01 0 0 1-7-7 7.01 7.01 0 0 1 7-7c.76 0 1.5.12 2.22.36l8.07-8.07c.19-.18.44-.29.71-.29h3c.55 0 1 .45 1 1v3c0 .27-.11.52-.29.71l-1 1c-.19.18-.44.29-.71.29h-1v1c0 .27-.11.52-.29.71l-1 1c-.19.18-.44.29-.71.29h-1v1c0 .27-.11.52-.29.71l-2.07 2.07c.24.72.36 1.46.36 2.22a7.01 7.01 0 0 1-7 7zm0-12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5c0-.71-.15-1.4-.45-2.05a1.01 1.01 0 0 1 .2-1.12L15 10.59V9c0-.55.45-1 1-1h1.59l.41-.41V6c0-.55.45-1 1-1h1.59l.41-.41V3h-1.59l-8.24 8.24a.99.99 0 0 1-1.12.2C9.4 11.15 8.71 11 8 11z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgKeyhole = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 3c2.76 0 5 2.24 5 5a4.99 4.99 0 0 1-1.84 3.87l-1 .82.33 1.25 1.9 7.06H7.61l1.89-7.07.33-1.25-1-.82C7.71 10.95 7.04 9.58 7 8.13c-.03-1.31.47-2.58 1.42-3.57.94-.98 2.19-1.54 3.49-1.56H12m0-2h-.12C8.06 1.06 4.9 4.36 5 8.18c.05 2.11 1.04 3.99 2.57 5.24l-1.89 7.07C5.33 21.75 6.29 23 7.61 23h8.79a2 2 0 0 0 1.93-2.52l-1.89-7.07C18 12.13 19 10.18 19 8c0-3.87-3.13-7-7-7h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgLink = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M17 13H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1zm-8 6H7a7.01 7.01 0 0 1-7-7 7.01 7.01 0 0 1 7-7h2c.55 0 1 .45 1 1s-.45 1-1 1H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h2c.55 0 1 .45 1 1s-.45 1-1 1zm8 0h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c2.76 0 5-2.24 5-5s-2.24-5-5-5h-2c-.55 0-1-.45-1-1s.45-1 1-1h2a7.01 7.01 0 0 1 7 7 7.01 7.01 0 0 1-7 7z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgLinkedin = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path fill-rule=\"evenodd\" d=\"M21.41 1H2.66C1.76 1 1 1.71 1 2.58v18.83c0 .88.76 1.59 1.66 1.59h18.75c.9 0 1.59-.71 1.59-1.58V2.58A1.58 1.58 0 0 0 21.41 1zM9.71 9.25h2.98v1.5c.43-.86 1.53-1.63 3.18-1.63 3.17 0 3.92 1.71 3.92 4.86v5.82h-3.21v-5.11c0-1.79-.43-2.8-1.52-2.8-1.51 0-2.14 1.09-2.14 2.8v5.11H9.71V9.25zm-5.5 10.54h3.21V9.25H4.21v10.54zM7.87 5.81c0 1.14-.92 2.06-2.06 2.06s-2.06-.92-2.06-2.06.92-2.06 2.06-2.06 2.06.92 2.06 2.06z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgList = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M22 6H8c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h14c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1zm-7 7H8c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h7c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1zm4 7H8c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h11c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1z\"/><circle cx=\"2.25\" cy=\"5\" r=\"1.25\"/><circle cx=\"2.25\" cy=\"12\" r=\"1.25\"/><circle cx=\"2.25\" cy=\"19\" r=\"1.25\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgListCircle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0zm6 9h-7c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h7c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1zm-5 4h-2c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h2c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1zm3 4h-5c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h5c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1z\"/><circle cx=\"7\" cy=\"12\" r=\"1\"/><circle cx=\"7\" cy=\"8\" r=\"1\"/><circle cx=\"7\" cy=\"16\" r=\"1\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgLoader = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12,24C5.38,24,0,18.62,0,12S5.38,0,12,0c0.55,0,1,0.45,1,1s-0.45,1-1,1C6.49,2,2,6.49,2,12s4.49,10,10,10s10-4.49,10-10   c0-0.55,0.45-1,1-1s1,0.45,1,1C24,18.62,18.62,24,12,24z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgLocalProtection = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 3.04c1.26 1.1 3.5 2.48 7 2.85v7.15c0 .26.02 6.46-6.35 8.68-.21.07-.42.11-.65.11-.22 0-.44-.04-.65-.11C4.98 19.5 5 13.3 5 13.05V13l-.03-7.1C8.5 5.52 10.74 4.14 12 3.04m0-2.01a1.97 1.97 0 0 0-1.3.49c-1.09.95-2.96 2.07-5.95 2.39-1 .11-1.75.97-1.75 1.98V13s-.2 7.85 7.69 10.61c.42.15.86.22 1.31.22s.89-.07 1.31-.22C21.2 20.85 21 13 21 13V5.89c0-1.01-.75-1.87-1.75-1.98-2.98-.32-4.86-1.44-5.95-2.39a1.97 1.97 0 0 0-1.3-.49h0zM12 8c1.1 0 2 .9 2 2 0 .61-.28 1.05-.51 1.31a2.94 2.94 0 0 0-.62 2.74l.52 1.95H10.6l.52-1.93c.27-.99.03-2.03-.62-2.77-.26-.29-.66-.92-.44-1.82.17-.69.75-1.26 1.44-1.42A2.2 2.2 0 0 1 12 8m0-2c-.31 0-.62.03-.94.11A3.98 3.98 0 0 0 8.12 9c-.34 1.4.06 2.7.88 3.63.22.25.28.61.19.93l-.85 3.19c-.17.63.31 1.25.96 1.25h5.39a1 1 0 0 0 .97-1.26l-.86-3.21c-.08-.31-.03-.65.18-.89A3.93 3.93 0 0 0 16 10a4 4 0 0 0-4-4h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgLocation = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"m21.707 2.2929c0.2741 0.27416 0.3651 0.68208 0.2334 1.0468l-6.5 18c-0.0094 0.026-0.0199 0.0517-0.0314 0.0769-0.1237 0.2698-0.3222 0.4985-0.572 0.6588s-0.5403 0.2455-0.8371 0.2455-0.5874-0.0852-0.8372-0.2455c-0.2438-0.1565-0.4387-0.378-0.5629-0.6395l-3.3453-6.6905-6.6905-3.3453c-0.26143-0.1241-0.48301-0.3191-0.63948-0.5629-0.1603-0.2498-0.24551-0.5404-0.24551-0.8372 0-0.29677 0.08521-0.58733 0.24551-0.83712 0.1603-0.24978 0.38895-0.4483 0.65876-0.57194 0.02521-0.01155 0.05088-0.02205 0.07696-0.03147l18-6.5c0.3647-0.13168 0.7726-0.04071 1.0468 0.23345zm-17.335 7.775 6.0755 3.0377c0.1935 0.0968 0.3504 0.2537 0.4472 0.4472l3.0377 6.0755 5.4037-14.964-14.964 5.4037z\" /></svg>\n';
var $author$project$Pyxis$Components$IconSet$svgLocationDisabled = '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\"><path d=\"M21.94 3.34a1 1 0 0 0-1.28-1.28L10.38 5.77a1 1 0 0 0 .68 1.882l8.276-2.989-3 8.31a1 1 0 0 0 1.88.679zM5.957 7.37 2.293 3.707a1 1 0 0 1 1.414-1.414l18 18a1 1 0 0 1-1.414 1.414l-3.662-3.662-1.19 3.295q-.014.038-.032.077a1.55 1.55 0 0 1-2.809.019l-3.345-6.69-6.69-3.346a1.55 1.55 0 0 1 .095-2.84zm9.113 9.113-7.551-7.55-3.146 1.135 6.075 3.038a1 1 0 0 1 .448.447l3.037 6.075z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgLocationFilled = '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\"><path d=\"M20.89 2.006 20.998 2l.13.008.09.016.123.035.107.046.1.057.09.067.082.075.052.059.082.116.052.096q.07.15.09.316l.005.106q0 .113-.024.22l-.035.123-6.532 18.077a1.55 1.55 0 0 1-2.172.705 1.55 1.55 0 0 1-.566-.549l-.065-.127-3.352-6.702-6.67-3.336a1.55 1.55 0 0 1-.898-1.259L1.68 10c0-.56.3-1.072.84-1.37l.14-.07 18.018-6.506.106-.03z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgLock = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M18 10V7c0-3.31-2.69-6-6-6S6 3.69 6 7v3c-1.66 0-3 1.34-3 3v7c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3v-7c0-1.66-1.34-3-3-3zM8 7a4 4 0 1 1 8 0v3H8V7zm11 13c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v7z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgLockOpen = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M18 10h0V7.21c0-3.05-2.19-5.77-5.21-6.16C9.54.63 6.7 2.84 6.11 5.84c-.12.6.38 1.16 1 1.16.48 0 .88-.34.98-.81.4-1.94 2.22-3.37 4.32-3.17 2.08.2 3.6 2.07 3.6 4.16V10H6c-1.66 0-3 1.34-3 3v7c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3v-7c0-1.66-1.34-3-3-3zm1 10c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v7z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgLogout = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21.71 11.29L18.41 8c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41L18.59 11H12c-.55 0-1 .45-1 1h0c0 .55.45 1 1 1h6.59L17 14.59c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0l3.29-3.29a1 1 0 0 0 .01-1.42zM15 23H7a4 4 0 0 1-4-4V5a4 4 0 0 1 4-4h8a4.02 4.02 0 0 1 3.8 2.74c.2.62-.29 1.26-.95 1.26h0c-.42 0-.82-.24-.95-.63C16.63 3.57 15.88 3 15 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c.88 0 1.63-.57 1.9-1.37.13-.39.54-.63.95-.63h0c.66 0 1.15.64.95 1.26A4.02 4.02 0 0 1 15 23z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgMagicWand = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M19 6.59L17.41 5c-.78-.78-2.05-.78-2.83 0L2 17.59c-.78.78-.78 2.05 0 2.83L3.59 22c.39.39.9.58 1.41.58s1.02-.2 1.41-.58L19 9.41a1.99 1.99 0 0 0 0-2.82zm-3-.18L17.59 8 16.5 9.09 14.91 7.5 16 6.41zM5 20.59L3.41 19 13.5 8.91l1.59 1.59L5 20.59zM8 1l-.61 1.82a3 3 0 0 1-1.5 1.74L5 5l.89.44a3 3 0 0 1 1.5 1.74L8 9l.61-1.82a2.98 2.98 0 0 1 1.5-1.73L11 5l-.89-.44a3 3 0 0 1-1.5-1.74L8 1h0zm11 12l-.61 1.82a2.98 2.98 0 0 1-1.5 1.73L16 17l.89.44a3.01 3.01 0 0 1 1.5 1.73L19 21l.61-1.82a2.98 2.98 0 0 1 1.5-1.73L22 17l-.89-.44a3.01 3.01 0 0 1-1.5-1.73L19 13h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgMagnifyingGlass = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M23 21.59l-6.83-6.83C17.31 13.31 18 11.49 18 9.5A8.51 8.51 0 0 0 9.5 1 8.51 8.51 0 0 0 1 9.5 8.51 8.51 0 0 0 9.5 18c1.99 0 3.81-.69 5.26-1.83L21.59 23c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41zM9.5 16C5.92 16 3 13.08 3 9.5S5.92 3 9.5 3 16 5.92 16 9.5 13.08 16 9.5 16z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgMagnifyingGlassMinus = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path fill-rule=\"evenodd\" d=\"M16.17 14.76L22 20.59c.39.39.39 1.02 0 1.41s-1.02.39-1.41 0l-5.83-5.83C13.31 17.31 11.49 18 9.5 18A8.51 8.51 0 0 1 1 9.5 8.51 8.51 0 0 1 9.5 1 8.51 8.51 0 0 1 18 9.5c0 1.99-.69 3.81-1.83 5.26zM3 9.5C3 13.08 5.92 16 9.5 16S16 13.08 16 9.5 13.08 3 9.5 3 3 5.92 3 9.5zm3.5-1a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgMagnifyingGlassPlus = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path fill-rule=\"evenodd\" d=\"M16.17 14.76L22 20.59c.39.39.39 1.02 0 1.41s-1.02.39-1.41 0l-5.83-5.83C13.31 17.31 11.49 18 9.5 18A8.51 8.51 0 0 1 1 9.5 8.51 8.51 0 0 1 9.5 1 8.51 8.51 0 0 1 18 9.5c0 1.99-.69 3.81-1.83 5.26zM3 9.5C3 13.08 5.92 16 9.5 16S16 13.08 16 9.5 13.08 3 9.5 3 3 5.92 3 9.5zm7.5-1h2c.55 0 1 .45 1 1s-.45 1-1 1h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2h-2c-.55 0-1-.45-1-1s.45-1 1-1h2v-2c0-.55.45-1 1-1s1 .45 1 1v2z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgMail = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21 3H3C1.34 3 0 4.34 0 6v12c0 1.66 1.34 3 3 3h18c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3zM3 5h18c.55 0 1 .45 1 1v.07l-10 5.77L2 6.07V6c0-.55.45-1 1-1zm18 14H3c-.55 0-1-.45-1-1V8.38l9.5 5.48c.15.09.33.14.5.14s.35-.04.5-.13L22 8.38V18c0 .55-.45 1-1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgMapMarker = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 3c3.58 0 6.5 2.92 6.5 6.5 0 .66-.1 1.32-.3 1.95-.1.31-.22.62-.39.95l-.45.78-4.09 7.08A1.46 1.46 0 0 1 12 21c-.52 0-1.01-.28-1.27-.73l-4.09-7.09-.45-.78a5.3 5.3 0 0 1-.39-.95c-.27-.86-.36-1.77-.26-2.68.35-3.15 3.11-5.68 6.29-5.77H12m0-2h-.23c-4.18.11-7.76 3.39-8.22 7.55-.13 1.23-.01 2.41.34 3.5.14.45.33.89.54 1.31l.48.83L9 21.27c.62 1.07 1.76 1.73 3 1.73h0c1.24 0 2.38-.66 3-1.73l4.09-7.08.48-.83c.21-.42.4-.85.54-1.31.25-.8.39-1.66.39-2.55A8.51 8.51 0 0 0 12 1h0zm0 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2a4 4 0 1 0 0 8 4 4 0 1 0 0-8h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgMedal = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 11.13l2.28 1.37-.6-2.59 2.01-1.74-2.65-.22L12 5.5l-1.04 2.44-2.64.23 2.01 1.74-.6 2.59L12 11.13zM21 9c0-4.97-4.03-9-9-9S3 4.03 3 9a8.94 8.94 0 0 0 2 5.65v6.74c0 1.13.93 2 2 2a1.86 1.86 0 0 0 .52-.07l3.71-.99a2.93 2.93 0 0 1 .78-.1 2.98 2.98 0 0 1 .78.1l3.71.99a1.91 1.91 0 0 0 .52.07c1.07 0 2-.87 2-2v-6.74A9.04 9.04 0 0 0 21 9zm-9-7a7.01 7.01 0 0 1 7 7 7.01 7.01 0 0 1-7 7 7.01 7.01 0 0 1-7-7 7.01 7.01 0 0 1 7-7zM5.87 15.57c.05.04.1.09.15.13a.64.64 0 0 1-.15-.13zm7.42 4.83c-.42-.11-.86-.17-1.29-.17-.44 0-.87.06-1.29.17L7 21.39v-4.91A8.94 8.94 0 0 0 12 18a8.94 8.94 0 0 0 5-1.52v4.91l-3.71-.99zm4.7-4.69c.05-.04.1-.09.15-.13-.05.04-.1.08-.15.13z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgMegaphone = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M16 1.27c-.17 0-.34.04-.5.14l-4.27 2.46c-.15.09-.32.13-.5.13H5a4 4 0 0 0-4 4v2a4 4 0 0 0 4 4v7c0 1.1.9 2 2 2h.23c.9 0 1.7-.61 1.93-1.48l1.99-7.42.08.03 4.27 2.46c.16.09.33.14.5.14.52 0 1-.42 1-1V2.27c0-.58-.48-1-1-1zM7.23 21H7v-7h2.11l-1.88 7zM15 14l-2.77-1.6c-.46-.26-.97-.4-1.5-.4H5c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h5.73c.53 0 1.04-.14 1.5-.4L15 4v10zm7-6h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm-1.771 4.298a1 1 0 0 0-.518 1.932l1.932.518a1 1 0 1 0 .518-1.932l-1.932-.518zm1.404-9.043l-1.932.518a1 1 0 1 0 .518 1.932l1.932-.518a1 1 0 1 0-.518-1.932z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgMinus = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M19 13H5c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h14c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgMinusCircle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0zm4 13H8c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h8c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgMinusSquare = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M17 3a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h10m0-2H7C3.69 1 1 3.69 1 7v10c0 3.31 2.69 6 6 6h10c3.31 0 6-2.69 6-6V7c0-3.31-2.69-6-6-6h0zm-1 12H8c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h8c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgMoped = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M19 15c.55 0 1 .45 1 1s-.45 1-1 1c-.56 0-1-.45-1-1s.44-1 1-1zm-15.6-.5h-.79l.62-1.24A4.98 4.98 0 0 1 7.7 10.5h2.91l-.69 2.05c-.21.65-.2 1.33.02 1.95H8.6 3.4zm3.46 2c-.17.3-.49.5-.86.5s-.7-.2-.86-.5h1.72zm9.17-.11C16.22 17.86 17.47 19 19 19a3.01 3.01 0 0 0 3-3c0-1.41-.97-2.58-2.27-2.9.18-.5.27-1.04.27-1.6v-.17a4.02 4.02 0 0 0-.57-2.06L17.76 6.5H18c.55 0 1-.45 1-1 0-.56-.45-1-1-1h-2-1a.99.99 0 0 0-1 1c0 .55.44 1 1 1h.43l2.28 3.8a1.98 1.98 0 0 1 .29 1.03v.17a3.01 3.01 0 0 1-3 3h-2.23c-.33 0-.62-.16-.81-.42s-.24-.59-.14-.9l.69-2.05c.2-.61.1-1.28-.28-1.8-.37-.52-.98-.83-1.62-.83H7.7a6.97 6.97 0 0 0-6.26 3.87L.82 13.6a2.02 2.02 0 0 0 .09 1.95 2.01 2.01 0 0 0 1.7.95h.44A2.98 2.98 0 0 0 6 19a2.99 2.99 0 0 0 2.95-2.5H15a5 5 0 0 0 1.03-.11z\" fill-rule=\"evenodd\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgMoreHorizontal = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><circle cx=\"12\" cy=\"12\" r=\"2\"/><circle cx=\"5\" cy=\"12\" r=\"2\"/><circle cx=\"19\" cy=\"12\" r=\"2\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgMoreHorizontalCircle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0z\"/><circle cx=\"12\" cy=\"12\" r=\"1.25\"/><circle cx=\"7.75\" cy=\"12\" r=\"1.25\"/><circle cx=\"16.25\" cy=\"12\" r=\"1.25\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgMoreVertical = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><circle cx=\"12\" cy=\"12\" r=\"2\"/><circle cx=\"12\" cy=\"5\" r=\"2\"/><circle cx=\"12\" cy=\"19\" r=\"2\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgMotorcycle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20 11c-.37 0-.72.07-1.06.16L16.25 6.5c-.54-.93-1.53-1.5-2.6-1.5H12c-.55 0-1 .45-1 1s.45 1 1 1h1.65c.36 0 .69.19.87.5l.28.5h-3.01a6.92 6.92 0 0 0-1.81.24L6.21 9.25c-.54-.75-1.29-1.3-2.19-1.54l-2.76-.74c-.53-.14-1.08.18-1.23.71-.14.53.17 1.08.71 1.22l2.76.74a1.96 1.96 0 0 1 1.21.93l.34.58C4.71 11.07 4.37 11 4 11a4 4 0 1 0 0 8c1.89 0 3.46-1.31 3.88-3.08.57.67 1.39 1.08 2.27 1.08h1.69c1.07 0 2.06-.58 2.6-1.5l2.35-4.06.41.71c-.74.72-1.2 1.73-1.2 2.85a4 4 0 1 0 8 0 4 4 0 0 0-4-4zM4 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm8.71-2.5c-.18.31-.51.5-.87.5h-1.69c-.36 0-.69-.19-.87-.5l-2-3.47 3.21-.86c.42-.11.86-.17 1.29-.17h3.52l-2.59 4.5zM20 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgOdometer = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M22.42 17.91c1-1.75 1.58-3.76 1.58-5.91a12.03 12.03 0 0 0-1.59-5.96c-.01-.01-.01-.03-.02-.04-.01-.02-.03-.02-.04-.04-1.04-1.79-2.53-3.27-4.32-4.32-.01-.01-.01-.02-.03-.03-.01-.01-.03-.01-.04-.01C16.2.59 14.17 0 12 0h0 0l-.48.01C9.58.08 7.75.64 6.14 1.56c-.05.02-.1.02-.14.05-.06.03-.1.09-.16.13a12.3 12.3 0 0 0-4.1 4.11c-.05.05-.1.09-.13.15-.03.04-.03.08-.04.12C.66 7.71.11 9.52.02 11.43c-.01.16.01.31.01.47-.01.04-.03.07-.03.1 0 .04.02.07.02.11a11.92 11.92 0 0 0 1.56 5.81c.01.02.01.05.03.08.01.02.03.04.05.06a11.85 11.85 0 0 0 2.8 3.26c.53.44 1.21.68 1.9.68h11.28c.7 0 1.37-.24 1.91-.68 1.11-.9 2.04-2 2.77-3.23.02-.03.05-.06.07-.09s.02-.06.03-.09zm-4.13 1.86a1.01 1.01 0 0 1-.65.23H6.36a1.01 1.01 0 0 1-.65-.23c-.7-.57-1.31-1.23-1.82-1.93l.81-.47A1.01 1.01 0 0 0 5.07 16a1.01 1.01 0 0 0-1.37-.37l-.83.48c-.43-.97-.7-2.02-.81-3.11H3c.55 0 1-.45 1-1s-.45-1-1-1h-.94a9.94 9.94 0 0 1 .83-3.11l.82.47c.15.1.33.14.49.14.35 0 .68-.18.87-.5.28-.48.11-1.09-.37-1.37l-.8-.46c.63-.87 1.4-1.64 2.27-2.27l.46.8c.19.32.52.5.87.5a1.01 1.01 0 0 0 .5-.13 1.01 1.01 0 0 0 .37-1.37l-.47-.81c.96-.44 2.01-.72 3.1-.83V3c0 .55.45 1 1 1s1-.45 1-1v-.95a9.75 9.75 0 0 1 3.1.84l-.47.82A1 1 0 0 0 16 5.07a1.01 1.01 0 0 0 .5.13c.35 0 .68-.18.87-.5l.47-.81c.87.63 1.64 1.4 2.27 2.27l-.81.47c-.48.28-.65.89-.37 1.37.19.32.52.5.87.5a1.01 1.01 0 0 0 .5-.13l.81-.47a9.82 9.82 0 0 1 .84 3.1H21c-.55 0-1 .45-1 1s.45 1 1 1h.94a9.95 9.95 0 0 1-.83 3.1l-.82-.47c-.48-.28-1.09-.11-1.37.37s-.11 1.09.37 1.37l.81.47c-.51.7-1.11 1.36-1.81 1.93zM13 9.14V7c0-.55-.45-1-1-1s-1 .45-1 1v2.14c-1.72.45-3 2-3 3.86a4 4 0 1 0 8 0c0-1.86-1.28-3.41-3-3.86zM12 15c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgPaperPlane = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20.5 11.13L4.09 1.66c-.16-.09-.33-.14-.5-.14-.61 0-1.15.58-.97 1.26l2.4 8.96a.92.92 0 0 1 0 .52l-2.4 8.96c-.18.68.35 1.26.97 1.26.17 0 .34-.04.5-.14l16.41-9.47c.67-.39.67-1.35 0-1.74zM16.27 11H6.9L5.18 4.6 16.27 11zM6.9 13h9.37L5.18 19.4 6.9 13z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgPaperclip = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12,24c-3.86,0-7-3.14-7-7V5c0-2.76,2.24-5,5-5s5,2.24,5,5v12c0,1.65-1.35,3-3,3s-3-1.35-3-3V6c0-0.55,0.45-1,1-1   s1,0.45,1,1v11c0,0.55,0.45,1,1,1s1-0.45,1-1V5c0-1.65-1.35-3-3-3S7,3.35,7,5v12c0,2.76,2.24,5,5,5s5-2.24,5-5V6c0-0.55,0.45-1,1-1   s1,0.45,1,1v11C19,20.86,15.86,24,12,24z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgPec = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M1.14 17.27V8.34h1.91V9c.27-.42.98-.82 1.9-.82 1.87 0 3 1.43 3 3.37 0 1.98-1.27 3.39-3.08 3.39-.83 0-1.46-.29-1.75-.65v2.98H1.14zm3.4-7.3c-.77 0-1.46.52-1.46 1.6 0 1.07.69 1.61 1.46 1.61.78 0 1.47-.53 1.47-1.61s-.69-1.6-1.47-1.6zm10.7 2.97C14.93 14.06 13.9 15 12.27 15c-1.78 0-3.37-1.27-3.37-3.45 0-2.08 1.55-3.41 3.22-3.41 2 0 3.24 1.24 3.24 3.32a4.59 4.59 0 0 1-.04.61h-4.5c.04.73.7 1.25 1.47 1.25.71 0 1.12-.34 1.3-.84l1.65.46zm-1.79-2.14c-.03-.49-.36-1.09-1.3-1.09-.83 0-1.25.61-1.29 1.09h2.59zm4.82.78c0 1.03.69 1.6 1.51 1.6.77 0 1.2-.48 1.34-.96l1.74.53c-.28 1.13-1.35 2.25-3.08 2.25-1.92 0-3.47-1.42-3.47-3.42 0-2.01 1.51-3.43 3.41-3.43 1.78 0 2.82 1.09 3.11 2.25l-1.77.53c-.14-.49-.53-.96-1.3-.96-.82 0-1.49.57-1.49 1.61z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgPen = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M22.22 3.5L20.5 1.78a3 3 0 0 0-4.24 0L1.88 16.16c-.57.56-.88 1.32-.88 2.12V22c0 .55.45 1 1 1h3.72a2.97 2.97 0 0 0 2.12-.88L22.22 7.74a2.97 2.97 0 0 0 .88-2.12c0-.8-.32-1.55-.88-2.12zM6.43 20.71a1.05 1.05 0 0 1-.71.29H3v-2.72a1.05 1.05 0 0 1 .29-.71L14.74 6.13l3.13 3.13L6.43 20.71zM20.8 6.33l-1.52 1.52-3.13-3.13 1.52-1.52c.39-.39 1.02-.39 1.41 0l1.72 1.72a.99.99 0 0 1 .29.71c.01.26-.1.51-.29.7z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgPenForm = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M23 2.59L21.41 1c-.78-.78-2.05-.78-2.83 0l-9.29 9.29c-.18.19-.29.44-.29.71v3c0 .55.45 1 1 1h3c.27 0 .52-.11.71-.29L23 5.41a1.99 1.99 0 0 0 0-2.82zM12.59 13H11v-1.59l6-6L18.59 7l-6 6zM20 5.59L18.41 4 20 2.41 21.59 4 20 5.59zM17 20c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h5.76l2-2H4C2.34 5 1 6.34 1 8v12c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3v-7.76l-2 2V20zM6 19h8c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgPhone = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M17.02 21.68c-.28 0-.56-.03-.83-.09A17.98 17.98 0 0 1 2.41 7.81 3.88 3.88 0 0 1 3.2 4.5C3.97 3.55 5.11 3 6.33 3h1.03c1.42 0 2.66 1.01 2.94 2.41l.47 2.34c.2.99-.11 2-.82 2.71.94 1.42 2.14 2.65 3.52 3.68l-.01-.02.08-.08c.71-.71 1.72-1.01 2.71-.82l2.34.47c1.4.28 2.41 1.52 2.41 2.94v1.03c0 1.22-.55 2.36-1.5 3.13a3.87 3.87 0 0 1-2.48.89zM6.33 5a1.98 1.98 0 0 0-1.57.75 1.95 1.95 0 0 0-.4 1.64 16.01 16.01 0 0 0 12.25 12.25c.58.13 1.17-.02 1.64-.4a2.01 2.01 0 0 0 .75-1.57v-1.03a1 1 0 0 0-.8-.98l-2.34-.47a.99.99 0 0 0-.9.27l-.08.08c-.7.7-1.81.79-2.59.21-1.55-1.15-2.9-2.54-4.01-4.11-.57-.79-.47-1.87.22-2.56.27-.27.37-.61.31-.94L8.34 5.8a1 1 0 0 0-.98-.8H6.33z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgPhone24 = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M16.02 21.68c-.28 0-.56-.03-.83-.09A17.98 17.98 0 0 1 1.41 7.81 3.88 3.88 0 0 1 2.2 4.5C2.97 3.55 4.11 3 5.33 3h1.03A3 3 0 0 1 9.3 5.41l.47 2.34c.2.99-.11 2-.82 2.71.94 1.42 2.14 2.65 3.52 3.68l-.01-.02.08-.08c.71-.71 1.72-1.02 2.71-.82l2.34.47c1.4.28 2.41 1.52 2.41 2.94v1.03c0 1.22-.55 2.36-1.5 3.13a3.87 3.87 0 0 1-2.48.89zM5.33 5a1.98 1.98 0 0 0-1.57.75 1.95 1.95 0 0 0-.4 1.64 16.01 16.01 0 0 0 12.25 12.25c.58.13 1.17-.02 1.64-.4a2.01 2.01 0 0 0 .75-1.57v-1.03a1 1 0 0 0-.8-.98l-2.34-.47c-.33-.06-.67.04-.9.27l-.08.08c-.7.7-1.81.79-2.59.21-1.55-1.15-2.9-2.54-4.01-4.11-.57-.79-.47-1.87.22-2.56.27-.27.37-.61.31-.94L7.34 5.8a1 1 0 0 0-.98-.8H5.33zm6.36-.57c-.03-.09-.05-.26-.05-.42 0-1.06.78-2.01 2.27-2.01 1.44 0 2.26.9 2.26 1.98 0 .71-.34 1.3-1.1 1.72l-.99.56c-.15.08-.33.26-.36.38h2.45V8h-4.55v-.1c0-1.11.33-1.97 1.41-2.6l.93-.55c.43-.24.59-.44.59-.78 0-.31-.24-.58-.66-.58-.47 0-.71.34-.71.72a1.17 1.17 0 0 0 .04.32h-1.53zm5.17.85l2.4-3.16h1.89v3.34H22V6.8h-.85V8h-1.62V6.8h-2.66V5.28zm2.67-1.46L18.3 5.46h1.22V3.82z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgPhoneFilled = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"m17.02 21.68c-0.28 0-0.56-0.03-0.83-0.09-6.89-1.48-12.3-6.89-13.78-13.78-0.26-1.17 0.03-2.38 0.79-3.31 0.77-0.95 1.91-1.5 3.13-1.5h1.03c1.42 0 2.66 1.01 2.94 2.41l0.47 2.34c0.2 0.99-0.11 2-0.81996 2.71 0.93996 1.42 2.14 2.65 3.52 3.68l-0.01-0.02 0.08-0.08c0.71-0.71 1.72-1.01 2.71-0.82l2.34 0.47c1.4 0.28 2.41 1.52 2.41 2.94v1.03c0 1.22-0.55 2.36-1.5 3.13-0.71 0.59-1.59 0.89-2.48 0.89z\"/></svg>\n';
var $author$project$Pyxis$Components$IconSet$svgPicture = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M17 1H7C3.69 1 1 3.69 1 7v10c0 3.31 2.69 6 6 6h10c3.31 0 6-2.69 6-6V7c0-3.31-2.69-6-6-6zm4 16a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-.59l4.59-4.59c.76-.76 2.07-.76 2.83 0l5.88 5.88a.98.98 0 0 0 .71.29c.26 0 .51-.1.71-.29.39-.39.39-1.02 0-1.41L15.43 14l.88-.88c.38-.38 1.04-.38 1.41 0l3.29 3.29V17zm0-3.41l-1.88-1.88a3.08 3.08 0 0 0-4.24 0l-.88.88-2.17-2.17c-1.51-1.51-4.15-1.51-5.66 0L3 13.59V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v6.59z\"/><circle cx=\"15\" cy=\"7\" r=\"1.5\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgPlate = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21 5c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h18m0-2H3C1.34 3 0 4.34 0 6v12c0 1.66 1.34 3 3 3h18c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3h0zM3.98 9.95c.98-.02 1.49-.49 1.63-1.19h1.53v6.49H5.3v-4.04H3.98V9.95zm4.29 0c.98-.02 1.49-.49 1.63-1.19h1.53v6.49H9.59v-4.04H8.27V9.95zm4.33 3.18v-1.59h3.09v1.59H12.6zm4.27-3.18c.98-.02 1.49-.49 1.63-1.19h1.53v6.49h-1.84v-4.04h-1.32V9.95z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgPlus = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M19 11h-6V5c0-.55-.45-1-1-1s-1 .45-1 1v6H5c-.55 0-1 .45-1 1s.45 1 1 1h6v6c0 .55.45 1 1 1s1-.45 1-1v-6h6c.55 0 1-.45 1-1s-.45-1-1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgPlusCircle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0zm4 11h-3V8c0-.55-.45-1-1-1s-1 .45-1 1v3H8c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgPlusSquare = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M17 3a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h10m0-2H7C3.69 1 1 3.69 1 7v10c0 3.31 2.69 6 6 6h10c3.31 0 6-2.69 6-6V7c0-3.31-2.69-6-6-6h0zm-1 10h-3V8c0-.55-.45-1-1-1h0c-.55 0-1 .45-1 1v3H8c-.55 0-1 .45-1 1h0c0 .55.45 1 1 1h3v3c0 .55.45 1 1 1h0c.55 0 1-.45 1-1v-3h3c.55 0 1-.45 1-1h0c0-.55-.45-1-1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgPos = '<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg data-name=\"Livello 4\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"m17.5 2c0.55 0 1 0.45 1 1v18c0 0.55-0.45 1-1 1h-11c-0.55 0-1-0.45-1-1v-18c0-0.55 0.45-1 1-1h11m0-2h-11c-1.66 0-3 1.34-3 3v18c0 1.66 1.34 3 3 3h11c1.66 0 3-1.34 3-3v-18c0-1.66-1.34-3-3-3z\"/>\n<circle cx=\"8\" cy=\"15.25\" r=\"1.25\"/>\n<circle cx=\"12\" cy=\"15.25\" r=\"1.25\"/>\n<circle cx=\"16\" cy=\"15.25\" r=\"1.25\"/>\n<circle cx=\"8\" cy=\"19.25\" r=\"1.25\"/>\n<circle cx=\"12\" cy=\"19.25\" r=\"1.25\"/>\n<circle cx=\"16\" cy=\"19.25\" r=\"1.25\"/>\n<path d=\"m16,10.31h-8c-.55,0-1-.45-1-1v-4.75c0-.55.45-1,1-1h8c.55,0,1,.45,1,1v4.75c0,.55-.45,1-1,1Zm-7-2h6v-2.75h-6v2.75Z\"/>\n</svg>\n';
var $author$project$Pyxis$Components$IconSet$svgPound = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M7.41 20l1.06-1.06A6.97 6.97 0 0 0 10.5 14H14v-2h-3.78c-.15-.52-.35-1.03-.63-1.51l-.95-1.65c-.56-.97-.56-2.16.01-3.03C9.4 4.68 10.65 4 12 4c1.59 0 3.03.94 3.67 2.4l1.83-.8C16.54 3.41 14.39 2 12 2 9.97 2 8.09 3.01 6.98 4.71 6 6.21 5.97 8.22 6.91 9.84l.95 1.65c.1.17.17.34.24.51H6v2h2.52c0 1.29-.49 2.56-1.45 3.52L6 18.59a2 2 0 0 0-.43 2.18A1.98 1.98 0 0 0 7.41 22H18v-2H7.41z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgPrima = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0zm5.08 8.76c-.21-1.44-1.37-2.53-2.81-2.66-.72-.13-1.45-.13-2.15.02-.37.04-.65.36-.65.74.02.41.37.75.78.76.06 0 .13 0 .19-.02.47-.11.94-.12 1.42-.05 1 .09 1.77.98 1.7 2 .06.84.04 1.69-.07 2.54a1.76 1.76 0 0 1-1.82 1.6c-.82.07-1.64-.07-2.4-.42-.16-.04-.27-.2-.25-.37v-1.53-.76-.62-1.24-1.1c-.02-.44-.39-.79-.84-.8-.13.01-.25.03-.37.08L7.05 8.31c-.3.17-.5.39-.56.63-.05.2-.01.41.11.61.26.42.72.5 1.25.21L9.35 9v9.24a.8.8 0 0 0 .79.76h.04a.81.81 0 0 0 .81-.77v-3.38l.64.12 1.44.24a3.49 3.49 0 0 0 2.62-.6 1.56 1.56 0 0 0 .2-.16c.15-.13.29-.27.42-.42s.24-.31.34-.48.19-.35.26-.53c.04-.09.07-.19.09-.28l.08-.33c.04-.24.06-.48.08-.72l.04-.73v-.74l-.04-.74-.08-.72z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgQuestionCircle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0z\"/><circle cx=\"12\" cy=\"17.37\" r=\"1.25\"/><path d=\"M13 14.37h-2v-.1c0-1.3.73-2.47 1.95-3.14.77-.42 1.16-1.25 1.02-2.12a2.03 2.03 0 0 0-1.59-1.61c-.61-.11-1.2.04-1.66.43a1.93 1.93 0 0 0-.59.85c-.15.4-.48.69-.9.69h-.15a.93.93 0 0 1-.89-1.21c.22-.71.65-1.36 1.24-1.85 1.23-1.03 3-1.25 4.53-.45a3.64 3.64 0 0 1 1.5 1.46c1.16 2.09.37 4.53-1.55 5.57-.57.31-.91.83-.91 1.38v.1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgRefund = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><circle cx=\"17.5\" cy=\"12.5\" r=\"1.5\"/><path d=\"M21 4.18v-.86A2.99 2.99 0 0 0 19.83.94c-.75-.57-1.69-.76-2.6-.52L3.79 4.02C2.23 4.13 1 5.42 1 7v11a3.01 3.01 0 0 0 3 3c.55 0 1-.45 1-1s-.45-1-1-1-1-.45-1-1V7c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v6c0 .55.45 1 1 1s1-.45 1-1V7c0-1.3-.84-2.4-2-2.82zm-3.26-1.83c.3-.08.62-.02.87.17a1.02 1.02 0 0 1 .39.8V4h-7.4l6.14-1.65zM22 16c-.55 0-1 .45-1 1v1c0 .55-.45 1-1 1h-9.59l1.29-1.29c.39-.39.39-1.02 0-1.41s-1.02-.39-1.41 0l-3 3c-.09.09-.17.2-.22.33a1 1 0 0 0 0 .76c.05.12.12.23.22.33l3 3A1.06 1.06 0 0 0 11 24c.26 0 .51-.1.71-.29.39-.39.39-1.02 0-1.41l-1.3-1.3H20a3.01 3.01 0 0 0 3-3v-1c0-.55-.45-1-1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgReload = '<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M22 0C21.45 0 21 0.45 21 1V3.08C16.29 -1.15 9.03 -1.01 4.51 3.52C-0.17 8.2 -0.17 15.81 4.51 20.49C6.85 22.83 9.92 24 13 24C16.08 24 19.15 22.83 21.49 20.49C21.88 20.1 21.88 19.47 21.49 19.08C21.1 18.69 20.47 18.69 20.08 19.08C16.18 22.98 9.83 22.98 5.93 19.08C2.03 15.18 2.03 8.83 5.93 4.93C9.83 1.03 16.18 1.03 20.08 4.93C20.1 4.96 20.14 4.97 20.18 5H17C16.45 5 16 5.45 16 6C16 6.55 16.45 7 17 7H22C22.55 7 23 6.55 23 6V1C23 0.45 22.55 0 22 0Z\"/>\n</svg>\n';
var $author$project$Pyxis$Components$IconSet$svgReplay = '<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M2 0C2.55 0 3 0.45 3 1V3.08C7.71 -1.15 14.97 -1.01 19.49 3.52C24.17 8.2 24.17 15.81 19.49 20.49C17.15 22.83 14.08 24 11 24C7.92 24 4.85 22.83 2.51 20.49C2.12 20.1 2.12 19.47 2.51 19.08C2.9 18.69 3.53 18.69 3.92 19.08C7.82 22.98 14.17 22.98 18.07 19.08C21.97 15.18 21.97 8.83 18.07 4.93C14.17 1.03 7.82 1.03 3.92 4.93C3.9 4.96 3.86 4.97 3.82 5H7C7.55 5 8 5.45 8 6C8 6.55 7.55 7 7 7H2C1.45 7 1 6.55 1 6V1C1 0.45 1.45 0 2 0Z\"/>\n</svg>\n';
var $author$project$Pyxis$Components$IconSet$svgScan = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M22 7c-.55 0-1-.45-1-1V5c0-1.1-.9-2-2-2h-1c-.55 0-1-.45-1-1s.45-1 1-1h1a4 4 0 0 1 4 4v1c0 .55-.45 1-1 1zM2 7c-.55 0-1-.45-1-1V5a4 4 0 0 1 4-4h1c.55 0 1 .45 1 1s-.45 1-1 1H5c-1.1 0-2 .9-2 2v1c0 .55-.45 1-1 1zm17 16h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c1.1 0 2-.9 2-2v-1c0-.55.45-1 1-1s1 .45 1 1v1a4 4 0 0 1-4 4zM6 23H5a4 4 0 0 1-4-4v-1c0-.55.45-1 1-1s1 .45 1 1v1c0 1.1.9 2 2 2h1c.55 0 1 .45 1 1s-.45 1-1 1zm14-10H4c-.55 0-1-.45-1-1s.45-1 1-1h16c.55 0 1 .45 1 1s-.45 1-1 1z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgShare = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path fill-rule=\"evenodd\" d=\"M16 5.583l-3.29-3.29c-.39-.39-1.02-.39-1.41 0l-3.29 3.29c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0l1.59-1.59v8.59c0 .55.45 1 1 1s1-.45 1-1v-8.59l1.59 1.59c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41H16zM7 8a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3h-1a1 1 0 1 0 0 2h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h1a1 1 0 1 0 0-2H7z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgShareAndroid = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M18 15c-1.16 0-2.19.5-2.93 1.29l-6.2-3.34c.07-.31.13-.62.13-.95s-.05-.64-.13-.95l6.2-3.34C15.8 8.5 16.84 9 18 9a4 4 0 0 0 4-4 4 4 0 0 0-4-4 4 4 0 0 0-4 4c0 .33.05.64.13.95l-6.2 3.34C7.2 8.5 6.16 8 5 8a4 4 0 0 0-4 4 4 4 0 0 0 4 4c1.16 0 2.19-.5 2.93-1.29l6.2 3.34c-.07.31-.13.62-.13.95a4 4 0 0 0 4 4 4 4 0 0 0 4-4 4 4 0 0 0-4-4zm0-12c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM5 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm13 7c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgShieldCheck = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 3.04c1.26 1.1 3.5 2.48 7 2.85V13v.05c0 .06.09 6.42-6.35 8.67-.21.07-.42.11-.65.11s-.44-.04-.65-.11C4.98 19.5 5 13.3 5 13.05V13l-.03-7.1C8.5 5.52 10.74 4.14 12 3.04m0-2.01a1.97 1.97 0 0 0-1.3.49c-1.09.95-2.96 2.07-5.95 2.39-1 .11-1.75.97-1.75 1.98V13s-.2 7.85 7.69 10.61c.42.15.86.22 1.31.22s.89-.07 1.31-.22C21.2 20.85 21 13 21 13V5.89c0-1.01-.75-1.87-1.75-1.98-2.98-.32-4.86-1.44-5.95-2.39a1.97 1.97 0 0 0-1.3-.49h0zM11.5 16c-.26 0-.51-.1-.71-.29l-2.29-2.3c-.39-.39-.39-1.02 0-1.41h0c.39-.39 1.02-.39 1.41 0l1.59 1.59L15.09 10c.39-.39 1.02-.39 1.41 0h0c.39.39.39 1.02 0 1.41l-4.29 4.29c-.2.2-.45.3-.71.3z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgSki = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M22.71 18.29c-.39-.39-1.02-.39-1.41 0l-.55.55c-1.26 1.26-3.11 1.75-4.83 1.29l-3.85-1.03 1.75-1.75a2.97 2.97 0 0 0 .78-2.9c-.28-1.05-1.07-1.84-2.12-2.12l-.86-.23c-.5-.13-.66-.54-.71-.71-.04-.17-.11-.6.26-.96l.32-.32 3.02 1.75A.87.87 0 0 0 15 12c.35 0 .68-.18.87-.5.28-.48.11-1.09-.37-1.37l-2.56-1.48 1.89-1.89c.36.16.76.24 1.17.24 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .51.14.98.36 1.4l-2.22 2.22-6.41-3.7c-.47-.28-1.08-.11-1.36.37-.27.48-.11 1.09.37 1.36l5.95 3.44c-.72.76-1 1.81-.73 2.83.28 1.05 1.07 1.84 2.12 2.12l.86.23c.5.13.66.54.71.71.04.17.11.6-.26.97l-2.56 2.56-7.58-2.03c-.53-.14-1.08.17-1.22.71-.14.53.17 1.08.71 1.22l13.65 3.66c.59.16 1.2.24 1.8.24 1.83 0 3.63-.72 4.96-2.05l.55-.55a1 1 0 0 0 .01-1.42zM16 3c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgSmartphone = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M16 2c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h8m0-2H8C6.34 0 5 1.34 5 3v18c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3h0zm-4 18.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 1 0 0-2.5h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgStar = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 4.93l1.67 4 .47 1.12 1.21.1 4.32.35-3.29 2.82-.92.79.28 1.19 1 4.22-3.7-2.25-1.04-.64-1.04.63-3.7 2.25 1-4.22.28-1.19-.92-.79-3.29-2.81 4.32-.35 1.21-.1.47-1.12 1.67-4m0-3.6a.98.98 0 0 0-.92.62L8.49 8.16l-6.71.54c-.89.07-1.24 1.18-.57 1.76l5.11 4.38-1.56 6.55c-.16.67.37 1.23.97 1.23.17 0 .35-.05.52-.15l5.75-3.5 5.75 3.5c.17.1.35.15.52.15.6 0 1.13-.56.97-1.23l-1.56-6.55 5.11-4.38c.67-.58.32-1.68-.57-1.76l-6.71-.54-2.59-6.21a.98.98 0 0 0-.92-.62h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgStarFilled = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12.92 1.95l2.59 6.21 6.71.54c.89.07 1.24 1.18.57 1.76l-5.11 4.38 1.56 6.55c.21.86-.73 1.55-1.49 1.08L12 18.97l-5.75 3.5c-.76.46-1.7-.22-1.49-1.08l1.56-6.55-5.11-4.38c-.68-.58-.32-1.69.57-1.76l6.71-.54 2.59-6.21a1 1 0 0 1 1.84 0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgSteeringWheel = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 0a12 12 0 1 0 0 24 12 12 0 1 0 0-24zm0 2c3.69 0 6.91 2.02 8.65 5H3.35C5.09 4.02 8.31 2 12 2zM2.2 14h2.52a3 3 0 0 1 2.94 2.41l1 5C5.4 20.25 2.91 17.45 2.2 14zm8.6 7.92l-1.18-5.9C9.16 13.69 7.1 12 4.72 12H2a9.91 9.91 0 0 1 .46-3h19.08a9.91 9.91 0 0 1 .46 3h-2.72c-2.38 0-4.44 1.69-4.9 4.02l-1.18 5.9c-.4.05-.79.08-1.2.08s-.8-.03-1.2-.08zm4.54-.5l1-5c.28-1.4 1.52-2.41 2.94-2.41h2.52c-.71 3.44-3.2 6.24-6.46 7.41z\"/><circle cx=\"12\" cy=\"12\" r=\"1.25\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgSwitch = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M9 22c-.39.39-1.02.39-1.41 0L1.3 15.71c-.29-.29-.37-.72-.22-1.09S1.6 14 2 14h20c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1H4.41L9 20.59c.39.39.39 1.02 0 1.41h0zm13-12H2c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h17.59L15 3.41c-.39-.39-.39-1.02 0-1.41h0c.39-.39 1.02-.39 1.41 0l6.29 6.29c.29.29.37.72.22 1.09S22.4 10 22 10z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgTablet = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M18 2c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h12m0-2H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3h0zm-6 18.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 1 0 0-2.5h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgThumbDown = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M3.9 12.91l2.96.79c.44.12.74.51.74.97V20c0 1.66 1.34 3 3 3h.03c.71 0 1.37-.38 1.73-1l4.85-8.4c.18-.31.51-.5.87-.5H20c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3H6.29a3 3 0 0 0-2.9 2.22L1.78 9.24a2.99 2.99 0 0 0 .297 2.275A2.99 2.99 0 0 0 3.9 12.91zM21 4v6.1c0 .55-.45 1-1 1h-1.5V3H20c.55 0 1 .45 1 1zM3.71 9.76l1.61-6.02c.12-.44.51-.74.97-.74H16.5v8.56c-.41.26-.77.6-1.02 1.04L10.63 21h-.03c-.55 0-1-.45-1-1v-5.33a3 3 0 0 0-2.22-2.9l-2.96-.79c-.53-.14-.85-.69-.71-1.22z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgThumbUp = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20.1 11.09l-2.96-.79c-.44-.12-.74-.51-.74-.97V4c0-1.66-1.34-3-3-3h-.03c-.71 0-1.37.38-1.73 1l-4.85 8.4c-.18.31-.51.5-.87.5H4c-1.66 0-3 1.34-3 3V20c0 1.66 1.34 3 3 3h2.5 11.21a3 3 0 0 0 2.9-2.22l1.61-6.02c.43-1.6-.52-3.24-2.12-3.67zM3 20v-6.1c0-.55.45-1 1-1h1.5V21H4c-.55 0-1-.45-1-1zm17.29-5.76l-1.61 6.02c-.12.44-.51.74-.97.74H7.5v-8.56c.41-.26.77-.6 1.02-1.04L13.37 3h.03c.55 0 1 .45 1 1v5.33a3 3 0 0 0 2.22 2.9l2.96.79c.54.14.85.69.71 1.22z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgTrashBin = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M14 1h-4c-1.1 0-2 .9-2 2h8c0-1.1-.9-2-2-2zm7 3H3c-.55 0-1 .45-1 1s.45 1 1 1h.54v12c0 2.76 2.24 5 5 5h7c2.76 0 5-2.24 5-5V6H21c.55 0 1-.45 1-1s-.45-1-1-1zm-2.46 14a3.01 3.01 0 0 1-3 3h-7a3.01 3.01 0 0 1-3-3V6h13v12zM9 19c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v9c0 .55.45 1 1 1zm6 0c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v9c0 .55.45 1 1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgTrendDown = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M22.92 17.38a1.02 1.02 0 0 1-.54.54c-.12.05-.25.08-.38.08h-6c-.55 0-1-.45-1-1s.45-1 1-1h3.59L13 9.41 8.71 13.7c-.39.39-1.02.39-1.41 0L1.29 7.71C.9 7.32.9 6.69 1.29 6.3A.98.98 0 0 1 2 6.01c.26 0 .51.1.71.29L8 11.59l4.29-4.29c.39-.39 1.02-.39 1.41 0l7.29 7.29V11c0-.55.45-1 1-1s1 .45 1 1v6c0 .13-.03.26-.08.38h.01z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgTrendDownChart = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path fill-rule=\"evenodd\" d=\"M22.38 14.91a1.02 1.02 0 0 0 .54-.54h-.01c.05-.12.08-.25.08-.38v-6c0-.55-.45-1-1-1s-1 .45-1 1v3.59L13.7 4.29c-.39-.39-1.02-.39-1.41 0L8 8.58 2.71 3.29C2.51 3.1 2.26 3 2 3a.98.98 0 0 0-.71.29c-.39.39-.39 1.02 0 1.41l6.01 5.99c.39.39 1.02.39 1.41 0L13 6.4l6.59 6.59H16c-.55 0-1 .45-1 1s.45 1 1 1h6c.13 0 .26-.03.38-.08zM22 22H2c-.55 0-1-.45-1-1s.45-1 1-1h20c.55 0 1 .45 1 1s-.45 1-1 1z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgTrendUp = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M22.92 6.62a1.02 1.02 0 0 0-.54-.54C22.26 6.03 22.13 6 22 6h-6c-.55 0-1 .45-1 1s.45 1 1 1h3.59L13 14.59 8.71 10.3c-.39-.39-1.02-.39-1.41 0l-6 6c-.39.39-.39 1.02 0 1.41a.98.98 0 0 0 .71.29c.26 0 .51-.1.71-.29l5.29-5.29 4.29 4.29c.39.39 1.02.39 1.41 0L21 9.42v3.59c0 .55.45 1 1 1s1-.45 1-1v-6c0-.13-.03-.26-.08-.38v-.01z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgTrendUpChart = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21.92 3.62c-.1-.25-.3-.44-.54-.54-.12-.05-.25-.08-.38-.08h-6c-.55 0-1 .45-1 1s.45 1 1 1h3.59L13 10.59 9.71 7.3c-.39-.39-1.02-.39-1.41 0l-6 6c-.39.39-.39 1.02 0 1.41a.98.98 0 0 0 .71.29c.26 0 .51-.1.71-.29l5.29-5.29 3.29 3.29c.39.39 1.02.39 1.41 0L20 6.42v3.59c0 .55.45 1 1 1s1-.45 1-1V4c0-.13-.03-.26-.08-.38zM22 22H2c-.55 0-1-.45-1-1s.45-1 1-1h20c.55 0 1 .45 1 1s-.45 1-1 1z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgTshirtSport = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M7.4 3.73l1.06 1.06c.94.94 2.2 1.46 3.54 1.46s2.59-.52 3.54-1.46l1.06-1.06 3.4.91V8.5h-1-2v2 10H7v-10-2H5 4V4.64l3.4-.91M16 1.5l-1.88 1.88a3 3 0 0 1-2.12.88c-.77 0-1.54-.29-2.12-.88L8 1.5 3.48 2.71C2.61 2.94 2 3.74 2 4.64V8.5c0 1.1.9 2 2 2h1v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-10h1c1.1 0 2-.9 2-2V4.64c0-.91-.61-1.7-1.48-1.93L16 1.5h0zm-5 16v-6H9v-1.29c1.33-.01 2.15-.76 2.33-1.71H13v9h-2z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgTwitter = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21.54 7.1l.01.64c0 6.51-4.95 14.01-14.01 14.01h0c-2.68 0-5.3-.76-7.55-2.21.39.05.78.07 1.17.07 2.22 0 4.37-.74 6.12-2.11-2.11-.04-3.95-1.41-4.6-3.42A5.04 5.04 0 0 0 4.9 14C2.6 13.54.95 11.52.95 9.17v-.06a4.92 4.92 0 0 0 2.25.61C1.03 8.28.36 5.4 1.67 3.15c2.5 3.08 6.19 4.95 10.15 5.14a4.93 4.93 0 0 1 1.42-4.7 4.94 4.94 0 0 1 6.97.21 9.86 9.86 0 0 0 3.13-1.2c-.37 1.14-1.14 2.11-2.16 2.72A9.61 9.61 0 0 0 24 4.55a9.78 9.78 0 0 1-2.46 2.55z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgUmbrella = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 1h-.21C5.74 1.11 1 6.31 1 12.36v.02c0 .58.48 1 1 1 .15 0 .3-.03.45-.11l.76-.38a4.02 4.02 0 0 1 3.58 0l1.69.85c.14.07.29.11.45.11a.99.99 0 0 0 .55-.17l.3-.2a4.03 4.03 0 0 1 1.22-.54V20c0 .55-.45 1-1 1s-1-.45-1-1-.45-1-1-1-1 .45-1 1a3.01 3.01 0 0 0 3 3 3.01 3.01 0 0 0 3-3v-7.06a3.8 3.8 0 0 1 1.22.54l.3.2c.17.11.36.17.55.17.15 0 .31-.03.45-.11l1.69-.85a4.02 4.02 0 0 1 3.58 0l.76.38c.15.07.3.11.45.11.52 0 1-.42 1-1V12c0-6.08-4.92-11-11-11zm7 9.47c-.93 0-1.85.22-2.68.63l-1.18.59c-.95-.58-2.03-.89-3.14-.89s-2.19.31-3.14.89l-1.18-.59c-.83-.41-1.75-.63-2.68-.63a5.95 5.95 0 0 0-1.87.3c.73-4.33 4.35-7.69 8.7-7.77H12c4.55 0 8.32 3.4 8.92 7.79-.62-.21-1.27-.32-1.92-.32z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgUpload = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M18 23H6a4.02 4.02 0 0 1-3.8-2.74c-.2-.62.29-1.26.95-1.26h0c.42 0 .82.24.95.63.27.8 1.02 1.37 1.9 1.37h12c.88 0 1.63-.57 1.9-1.37.13-.39.54-.63.95-.63h0c.66 0 1.15.64.95 1.26A4.02 4.02 0 0 1 18 23zM16 5.59L12.71 2.3c-.2-.2-.45-.3-.71-.3s-.51.1-.71.29L8 5.59c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0L11 5.41V16c0 .55.45 1 1 1s1-.45 1-1V5.41L14.59 7c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgUser = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 3a3.01 3.01 0 0 1 3 3 3.01 3.01 0 0 1-3 3 3.01 3.01 0 0 1-3-3 3.01 3.01 0 0 1 3-3m0-2C9.24 1 7 3.24 7 6s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5h0zm5 14c1.1 0 2 .9 2 2v4H5v-4c0-1.1.9-2 2-2h10m0-2H7a4 4 0 0 0-4 4v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4a4 4 0 0 0-4-4h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgUserCheck = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M11 3a3.01 3.01 0 0 1 3 3 3.01 3.01 0 0 1-3 3 3.01 3.01 0 0 1-3-3 3.01 3.01 0 0 1 3-3m0-2C8.24 1 6 3.24 6 6s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5h0zm6 16c-.26 0-.51-.1-.71-.29L14 14.41c-.39-.39-.39-1.02 0-1.41h0c.39-.39 1.02-.39 1.41 0L17 14.59 20.59 11c.39-.39 1.02-.39 1.41 0h0c.39.39.39 1.02 0 1.41l-4.29 4.29c-.2.2-.45.3-.71.3zm2 3c-.55 0-1 .45-1 1H4v-4c0-1.1.9-2 2-2h5c.55 0 1-.45 1-1h0c0-.55-.45-1-1-1H6a4 4 0 0 0-4 4v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2 0-.55-.45-1-1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgUserCircle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 7c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2a4 4 0 1 0 0 8 4 4 0 1 0 0-8h0z\"/><path d=\"M17 20.65A9.9 9.9 0 0 1 12 22c-1.82 0-3.53-.49-5-1.34V18a.99.99 0 0 1 1-1h8c.55 0 1 .44 1 1v2.65zM5 19.14C3.15 17.32 2 14.79 2 12 2 6.48 6.48 2 12 2c5.51 0 10 4.48 10 10 0 2.79-1.15 5.32-3 7.14V18c0-1.66-1.35-3-3-3H8c-1.66 0-3 1.34-3 3v1.14zm0 2.6c.62.46 1.29.85 2 1.17 1.52.7 3.22 1.09 5 1.09s3.48-.39 5-1.09a11.13 11.13 0 0 0 2-1.17c3.03-2.18 5-5.73 5-9.74 0-6.63-5.38-12-12-12A12 12 0 0 0 0 12c0 4.01 1.97 7.56 5 9.74z\" fill-rule=\"evenodd\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgUserCircleFilled = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 0C18.63 0 24 5.37 24 12C24 18.63 18.63 24 12 24C5.37 24 0 18.63 0 12C0 5.37 5.37 0 12 0ZM8 15C6.34 15 5 16.34 5 18V18.707C5 18.9754 5.10656 19.2352 5.30566 19.415C7.13726 21.0695 9.51986 21.9951 12 22C14.4802 21.9951 16.8627 21.0695 18.6943 19.415C18.8934 19.2352 19 18.9754 19 18.707V18C19 16.34 17.65 15 16 15H8ZM12 5C9.79 5 8 6.79 8 9C8 11.21 9.79 13 12 13C14.21 13 16 11.21 16 9C16 6.79 14.21 5 12 5Z\"/></svg>\n';
var $author$project$Pyxis$Components$IconSet$svgUserCross = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M11 3a3.01 3.01 0 0 1 3 3 3.01 3.01 0 0 1-3 3 3.01 3.01 0 0 1-3-3 3.01 3.01 0 0 1 3-3m0-2C8.24 1 6 3.24 6 6s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5h0zm9.89 15.89h0c.39-.39.39-1.02 0-1.41L19.41 14l1.48-1.48c.39-.39.39-1.02 0-1.41h0c-.39-.39-1.02-.39-1.41 0L18 12.59l-1.48-1.48c-.39-.39-1.02-.39-1.41 0h0c-.39.39-.39 1.02 0 1.41L16.59 14l-1.48 1.48c-.39.39-.39 1.02 0 1.41h0c.39.39 1.02.39 1.41 0L18 15.41l1.48 1.48c.39.39 1.02.39 1.41 0zM19 20c-.55 0-1 .45-1 1H4v-4c0-1.1.9-2 2-2h5c.55 0 1-.45 1-1h0c0-.55-.45-1-1-1H6a4 4 0 0 0-4 4v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2 0-.55-.45-1-1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgUserMinus = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M11 3a3.01 3.01 0 0 1 3 3 3.01 3.01 0 0 1-3 3 3.01 3.01 0 0 1-3-3 3.01 3.01 0 0 1 3-3m0-2C8.24 1 6 3.24 6 6s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5h0zm8 19c-.55 0-1 .45-1 1H4v-4c0-1.1.9-2 2-2h5c.55 0 1-.45 1-1h0c0-.55-.45-1-1-1H6a4 4 0 0 0-4 4v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2 0-.55-.45-1-1-1zm2-4h-6c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h6c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgUserPlus = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M11 3a3.01 3.01 0 0 1 3 3 3.01 3.01 0 0 1-3 3 3.01 3.01 0 0 1-3-3 3.01 3.01 0 0 1 3-3m0-2C8.24 1 6 3.24 6 6s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5h0zm7 17.09h0c.55 0 1-.45 1-1V15h2.09c.55 0 1-.45 1-1h0c0-.55-.45-1-1-1H19v-2.09c0-.55-.45-1-1-1h0c-.55 0-1 .45-1 1V13h-2.09c-.55 0-1 .45-1 1h0c0 .55.45 1 1 1H17v2.09c0 .55.45 1 1 1zM19 20c-.55 0-1 .45-1 1H4v-4c0-1.1.9-2 2-2h5c.55 0 1-.45 1-1h0c0-.55-.45-1-1-1H6a4 4 0 0 0-4 4v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2 0-.55-.45-1-1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgUsers = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M10 11c.98 0 1.88-.29 2.65-.77-.21.13-.42.25-.65.35a4.94 4.94 0 0 0 2 .42c2.76 0 5-2.24 5-5s-2.24-5-5-5a4.94 4.94 0 0 0-2 .42c.23.1.44.22.65.35C11.88 1.29 10.98 1 10 1 7.24 1 5 3.24 5 6s2.24 5 5 5zm2.99-1.01l.26-.21-.26.21zM14 3a3.01 3.01 0 0 1 3 3 3.01 3.01 0 0 1-3 3c.61-.84 1-1.87 1-3s-.39-2.16-1.02-3zm-.76-.78l-.26-.21.26.21zM10 3a3.01 3.01 0 0 1 3 3 3.01 3.01 0 0 1-3 3 3.01 3.01 0 0 1-3-3 3.01 3.01 0 0 1 3-3zm9 10h-4c.24 0 .48.03.71.07-.23-.04-.47-.07-.71-.07H5a4 4 0 0 0-4 4v4c0 1.1.9 2 2 2h14c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-4c0-.73-.21-1.41-.55-2H19c1.1 0 2 .9 2 2v4h-2c0 .55-.22 1.05-.59 1.41-.36.37-.86.59-1.41.59h4c1.1 0 2-.9 2-2v-4a4 4 0 0 0-4-4zm-2 8H3v-4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v4zm-1.09-7.89a3.74 3.74 0 0 1 .54.17c-.18-.07-.36-.12-.54-.17zm.79.28c.13.06.26.13.38.21l-.38-.21zm.69.42l.16.13-.16-.13z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgVan = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M23.6 11.8L21.98 9c-.54-.93-1.53-1.5-2.6-1.5H18v-1c0-1.66-1.34-3-3-3H3c-1.66 0-3 1.34-3 3v9c0 1.1.9 2 2 2h.05a2.99 2.99 0 0 0 5.9 0h7.1a2.99 2.99 0 0 0 5.9 0H22c1.1 0 2-.9 2-2v-2.2c0-.52-.14-1.04-.4-1.5zM2 6.5c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v1 7.28a2.87 2.87 0 0 0-.58.72H7.58C7.06 14.61 6.11 14 5 14s-2.06.61-2.58 1.5H2v-9zM5 18c-.37 0-.67-.21-.85-.5-.09-.15-.15-.31-.15-.5 0-.55.45-1 1-1s1 .45 1 1c0 .19-.06.35-.15.5-.18.29-.48.5-.85.5zm13 0c-.37 0-.67-.21-.85-.5-.09-.15-.15-.31-.15-.5 0-.55.45-1 1-1s1 .45 1 1c0 .19-.06.35-.15.5-.18.29-.48.5-.85.5zm4-2.5h-1.42c-.52-.89-1.47-1.5-2.58-1.5V9.5h1.38c.36 0 .69.19.87.5l1.62 2.8c.09.15.13.32.13.5v2.2z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgVehicleCollisionKasko = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M17 7c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1zm4 0a1.01 1.01 0 0 1-.5-.13 1.01 1.01 0 0 1-.37-1.37l1.5-2.6A1.01 1.01 0 0 1 23 2.53a1.01 1.01 0 0 1 .37 1.37l-1.5 2.6A1.02 1.02 0 0 1 21 7zm-8 0c-.35 0-.68-.18-.87-.5l-1.5-2.6c-.27-.48-.11-1.09.37-1.36.48-.28 1.09-.11 1.37.37l1.5 2.6c.28.48.11 1.09-.37 1.37-.16.08-.33.12-.5.12zm8.77 6l-2.4-.64 1.43-.83c.61-.35 1.3-.53 2-.53h.2c.55 0 1-.45 1-1 0-.56-.45-1-1-1h-.2c-1.05 0-2.09.27-3 .8l-2.5 1.45-.72-1.25c-.54-.93-1.53-1.5-2.6-1.5H5.84c-.8 0-1.56.31-2.12.88l-2.5 2.49c-.76.76-1.05 1.87-.78 2.9l.67 2.5c.27.98 1 1.75 1.92 2.07a2.99 2.99 0 0 0 5.92.16h7.1A2.98 2.98 0 0 0 19 22c1.54 0 2.81-1.17 2.98-2.67A3 3 0 0 0 24 16.5v-.61c0-1.35-.92-2.54-2.23-2.89zM6.86 19.5c-.17.3-.49.5-.86.5s-.7-.2-.86-.5c-.09-.15-.14-.32-.14-.5 0-.55.44-1 1-1 .55 0 1 .45 1 1 0 .18-.05.35-.14.5zm13 0c-.17.3-.49.5-.86.5s-.7-.2-.86-.5c-.09-.15-.14-.32-.14-.5 0-.55.44-1 1-1 .55 0 1 .45 1 1 0 .18-.05.35-.14.5zm2.14-3c0 .36-.2.68-.49.86C20.97 16.54 20.05 16 19 16c-1.11 0-2.08.6-2.6 1.5H8.6C8.08 16.6 7.11 16 6 16c-1.05 0-1.97.54-2.51 1.35-.21-.13-.38-.34-.44-.59l-.67-2.51c-.1-.34 0-.71.25-.96l2.5-2.5a.99.99 0 0 1 .71-.29h8.14c.35 0 .69.19.86.5l1.1 1.9a2.01 2.01 0 0 0 1.22.93l4.09 1.1c.44.12.75.51.75.96v.61zm-8.8-5H8.4a.99.99 0 0 0-1 1c0 .55.44 1 1 1h4.8c.55 0 1-.45 1-1 0-.56-.45-1-1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgVehicleDriverInjuries = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M19.07 12l1.41-1.41c1.56-1.56 1.56-4.09 0-5.66l-1.41-1.41a3.98 3.98 0 0 0-2.83-1.17 3.98 3.98 0 0 0-2.83 1.17L12 4.93l-1.41-1.41c-.79-.79-1.81-1.18-2.83-1.18a4 4 0 0 0-2.83 1.17L3.51 4.93c-1.56 1.56-1.56 4.09 0 5.66L4.93 12l-1.41 1.41c-1.56 1.56-1.56 4.09 0 5.66l1.41 1.41a3.98 3.98 0 0 0 2.83 1.17 3.98 3.98 0 0 0 2.83-1.17l7.07-7.07 1.41 1.41c.78.78.78 2.05 0 2.83l-1.41 1.41c-.38.38-.88.59-1.41.59s-1.04-.21-1.41-.59l-1.41-1.41L12 19.07l1.41 1.41a3.98 3.98 0 0 0 2.83 1.17 3.98 3.98 0 0 0 2.83-1.17l1.41-1.41c1.56-1.56 1.56-4.09 0-5.66L19.07 12zM4.93 9.17c-.38-.38-.59-.88-.59-1.41s.21-1.04.59-1.41l1.41-1.41c.38-.38.88-.59 1.41-.59s1.04.21 1.41.59l1.41 1.41-4.24 4.24-1.4-1.42zm4.24 9.9c-.38.38-.88.59-1.41.59s-1.04-.21-1.41-.59l-1.41-1.41c-.78-.78-.78-2.05 0-2.83l9.9-9.9c.38-.38.88-.59 1.41-.59s1.04.21 1.41.59l1.41 1.41c.38.38.59.88.59 1.41s-.21 1.04-.59 1.41l-9.9 9.91zm3.54-10.19c-.26 0-.51.1-.71.29L9.17 12c-.39.39-.39 1.02 0 1.41l1.41 1.41a.98.98 0 0 0 .71.29c.26 0 .51-.1.71-.29L14.83 12c.39-.39.39-1.02 0-1.41l-1.41-1.41a1.01 1.01 0 0 0-.71-.3h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgVehicleFullKasko = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><g clip-path=\"url(#icon_A)\"><path d=\"M21.78 13l-4.1-1.1-1.1-1.9c-.54-.93-1.53-1.5-2.6-1.5H5.84c-.8 0-1.56.32-2.12.88l-2.5 2.5c-.76.76-1.05 1.86-.78 2.9l.67 2.5c.26.98.99 1.74 1.92 2.06L3 19.01c0 1.66 1.34 3 3 3s3-1.34 3-3c0 .17-.02.34-.05.5h7.1c-.03-.16-.05-.33-.05-.5 0 1.66 1.34 3 3 3s3-1.34 3-3c0 .11-.02.22-.03.33 1.18-.4 2.03-1.51 2.03-2.83v-.6a3 3 0 0 0-2.22-2.9V13zM6 20c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm13 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3-3.5c0 .37-.21.67-.5.85 0 .01.01.03.02.04C20.99 16.56 20.06 16 19 16s-2.06.61-2.58 1.5H8.59c-.52-.89-1.48-1.5-2.58-1.5s-1.99.55-2.52 1.39c0-.01.02-.03.02-.05a1.01 1.01 0 0 1-.45-.58l-.67-2.5c-.09-.34 0-.71.26-.97l2.5-2.5a.99.99 0 0 1 .71-.29H14c.36 0 .69.19.87.5l1.1 1.9c.27.46.7.79 1.21.93l4.1 1.1c.44.12.74.51.74.97v.6H22zm-8.8-5H8.4c-.55 0-1 .45-1 1s.45 1 1 1h4.8c.55 0 1-.45 1-1s-.45-1-1-1zM6 1l-.36 1.07a2.98 2.98 0 0 1-1.5 1.73l-.39.19.39.19a3.01 3.01 0 0 1 1.5 1.73L6 6.98l.36-1.07a2.98 2.98 0 0 1 1.5-1.73l.39-.19-.39-.19a3.01 3.01 0 0 1-1.5-1.73L6 1zm13 1l-.61 1.82a2.98 2.98 0 0 1-1.5 1.73l-.89.44.89.44a3.01 3.01 0 0 1 1.5 1.73L19 9.98l.61-1.82a2.98 2.98 0 0 1 1.5-1.73l.89-.44-.89-.44a3.01 3.01 0 0 1-1.5-1.73L19 2z\" /></g><defs><clipPath id=\"A\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs></svg>';
var $author$project$Pyxis$Components$IconSet$svgVehicleGlasses = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21 4c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1h-9.65l1.25-4.68c.28-1.03.13-2.11-.4-3.04l-2.06-3.57L11.41 4H21m0-2H10.64c-.45 0-.85.3-.97.74L8.21 8.2c-.14.51-.07 1.06.2 1.52l2.06 3.57c.27.46.34 1.01.2 1.52l-1.59 5.94c-.17.63.31 1.25.97 1.25H21c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3h0zM5.27 4l-.99 3.68c-.28 1.03-.13 2.11.4 3.04l2.06 3.57L5.21 20H3c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2.27m1.3-2H3C1.34 2 0 3.34 0 5v14c0 1.66 1.34 3 3 3h2.98c.45 0 .85-.3.97-.74l1.73-6.46c.14-.51.07-1.06-.2-1.52L6.41 9.72c-.26-.46-.33-1.01-.2-1.52l1.32-4.94A.99.99 0 0 0 6.57 2h0zM15 12c-.26 0-.51-.1-.71-.29-.39-.39-.39-1.02 0-1.41l4-4c.39-.39 1.02-.39 1.41 0s.39 1.02 0 1.41l-4 4c-.19.19-.44.29-.7.29zm2 3c-.26 0-.51-.1-.71-.29-.39-.39-.39-1.02 0-1.41l2-2c.39-.39 1.02-.39 1.41 0s.39 1.02 0 1.41l-2 2c-.19.19-.44.29-.7.29z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgVehicleGlassesFilled = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M6.57 2H3C1.34 2 0 3.34 0 5V19C0 20.66 1.34 22 3 22H5.98C6.43 22 6.83 21.7 6.95 21.26L8.68 14.8C8.82 14.29 8.75 13.74 8.48 13.28L6.41 9.72C6.15 9.26 6.08 8.71 6.21 8.2L7.53 3.26C7.71 2.62 7.23 2 6.57 2Z\"/><path d=\"m21 2c1.6599 2e-5 3 1.34 3 3v14c0 1.66-1.3401 3-3 3h-10.95c-0.65995-1e-4 -1.1398-0.6201-0.96977-1.25l1.5899-5.9404c0.1398-0.5099 0.0697-1.0597-0.2002-1.5196l-2.0596-3.5703c-0.26991-0.45992-0.34011-1.0096-0.20019-1.5195l1.46-5.46c0.11997-0.43989 0.51982-0.74009 0.96972-0.74023h10.36zm-1.3008 9.2998c-0.39-0.3898-1.0203-0.3899-1.4102 0l-2 2c-0.3898 0.3899-0.3897 1.0202 0 1.4102 0.2 0.19 0.451 0.29 0.711 0.29 0.2597-1e-4 0.5093-0.1003 0.6992-0.29l2-2c0.39-0.39 0.39-1.0202 0-1.4102zm0-5c-0.39-0.38977-1.0203-0.38992-1.4102 0l-4 4c-0.3898 0.3899-0.3897 1.0202 0 1.4102 0.2 0.19 0.451 0.29 0.711 0.29 0.2597-1e-4 0.5093-0.1003 0.6992-0.29l4-4c0.39-0.39 0.39-1.0202 0-1.4102z\"/></svg>\n';
var $author$project$Pyxis$Components$IconSet$svgVehicleLegalProtection = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12.65 21.72c-.21.07-.42.11-.65.11-.22 0-.44-.04-.65-.11C4.98 19.5 5 13.3 5 13.05V13l-.03-7.1C8.5 5.52 10.74 4.14 12 3.04c1.26 1.1 3.5 2.48 7 2.85v6.81l1.96 1.13c.05-.51.04-.83.04-.83V5.89c0-1.01-.75-1.87-1.75-1.98-2.98-.32-4.86-1.44-5.95-2.39-.37-.33-.83-.49-1.3-.49a1.97 1.97 0 0 0-1.3.49c-1.09.95-2.96 2.07-5.94 2.39C3.75 4.02 3 4.88 3 5.89V13s-.2 7.85 7.69 10.61c.42.15.86.22 1.31.22.44 0 .89-.07 1.31-.22 2.68-.94 4.41-2.46 5.55-4.07l-1.75-1.01c-.94 1.27-2.34 2.45-4.46 3.19zm8.95-5.21l-5.63-3.25.5-.87a3 3 0 0 0-1.1-4.1l-.87-.5c-.47-.27-.99-.4-1.5-.4-1.04 0-2.05.54-2.6 1.5l-2 3.46a3 3 0 0 0 1.1 4.1l.87.5c.47.27.99.4 1.5.4 1.04 0 2.05-.54 2.6-1.5l.5-.87 5.63 3.25a1.01 1.01 0 0 0 .5.13c.35 0 .68-.18.87-.5.27-.46.1-1.07-.37-1.35zm-8.87-1.65c-.18.31-.51.5-.87.5-.18 0-.34-.05-.5-.13l-.87-.5c-.31-.18-.43-.46-.47-.61a1 1 0 0 1 .1-.76l2-3.46c.18-.31.51-.5.87-.5.18 0 .34.05.5.13l.87.5c.31.18.43.46.47.61a1 1 0 0 1-.1.76l-2 3.46z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgVehicleNaturalEvents = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12.11 23a1.01 1.01 0 0 1-.5-.13 1.01 1.01 0 0 1-.37-1.37l2.02-3.5H10c-.36 0-.69-.19-.87-.5s-.18-.69 0-1l2.89-5a1.01 1.01 0 0 1 1.37-.37 1.01 1.01 0 0 1 .37 1.37L11.73 16H15c.36 0 .69.19.87.5s.18.69 0 1l-2.89 5c-.19.32-.52.5-.87.5zm6.88-15.86c0-.05.01-.09.01-.14 0-3.31-2.69-6-6-6-2.62 0-4.85 1.69-5.66 4.03C7.22 5.03 7.12 5 7 5c-2.76 0-5 2.24-5 5s2.24 5 5 5h.69l1.15-2H7a3.01 3.01 0 0 1-3-3 3.01 3.01 0 0 1 2.93-3l.27.03 1.52.1.5-1.44C9.78 4.08 11.3 3 13 3c2.19 0 3.98 1.77 4 3.96 0 .04-.01.09-.01.13l-.04 1.59 1.54.4C19.38 9.3 20 10.1 20 11c0 1.1-.9 2-2 2h-2.29c-.06.17-.13.34-.22.5l-.87 1.5H18a4 4 0 0 0 4-4 3.99 3.99 0 0 0-3.01-3.86z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgVehicleRicourseWaiver = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21.12 7.12L14.88.88C14.32.32 13.55 0 12.76 0H7C5.34 0 4 1.34 4 3v2.18c.31-.11.65-.18 1-.18h1V3c0-.55.45-1 1-1h5.76c.08 0 .16.03.24.05V7c0 1.1.9 2 2 2h4.95c.02.08.05.16.05.24V21c0 .55-.45 1-1 1h-8.35c-.26.75-.67 1.42-1.19 2H19c1.66 0 3-1.34 3-3V9.24c0-.79-.32-1.56-.88-2.12zM15 7V3.83L18.17 7H15zm-9 9.14V13h1c.55 0 1-.45 1-1s-.45-1-1-1H6V9h2c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1v8.14c-1.72.45-3 2-3 3.86a4 4 0 1 0 8 0c0-1.86-1.28-3.41-3-3.86zM5 22c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgVehicleRoadsideAssistance = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M23.59 11.8l-2.48-4.3c-.54-.93-1.53-1.5-2.6-1.5H15c-1.11 0-2 .89-2 2v2.59l-7.29-7.3c-.29-.28-.72-.37-1.09-.21C4.24 3.23 4 3.6 4 4v4.28c-.6.34-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V6.41l6.09 6.09H2c-1.11 0-2 .89-2 2v2a2 2 0 0 0 2 2h.05A2.98 2.98 0 0 0 5 21a2.99 2.99 0 0 0 2.95-2.5H13h2 .05A2.98 2.98 0 0 0 18 21a2.99 2.99 0 0 0 2.95-2.5H22c1.1 0 2-.9 2-2v-3.2a2.94 2.94 0 0 0-.41-1.5zM5.86 18.5c-.17.3-.49.5-.86.5s-.7-.2-.86-.5c-.09-.15-.14-.32-.14-.5 0-.55.44-1 1-1 .55 0 1 .45 1 1 0 .18-.05.35-.14.5zm7.14-2H7.6C7.08 15.6 6.11 15 5 15s-2.08.6-2.6 1.5H2v-2h11v2zm5.86 2c-.17.3-.49.5-.86.5s-.7-.2-.86-.5c-.09-.15-.14-.32-.14-.5 0-.55.44-1 1-1 .55 0 1 .45 1 1 0 .18-.05.35-.14.5zm3.14-2h-1.4c-.52-.9-1.49-1.5-2.6-1.5s-2.08.6-2.6 1.5H15v-4V8h3.51c.36 0 .69.19.87.5l2.48 4.3c.09.15.14.33.14.5v3.2z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgVehicleSecuredBonus = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 3.04c1.26 1.1 3.5 2.48 7 2.85V13v.05c0 .06.09 6.42-6.35 8.67-.21.07-.42.11-.65.11s-.44-.04-.65-.11C4.98 19.5 5 13.3 5 13.05V13l-.03-7.1C8.5 5.52 10.74 4.14 12 3.04m0-2.01a1.97 1.97 0 0 0-1.3.49c-1.09.95-2.96 2.07-5.95 2.39-1 .11-1.75.97-1.75 1.98V13s-.2 7.85 7.69 10.61c.42.15.86.22 1.31.22s.89-.07 1.31-.22C21.2 20.85 21 13 21 13V5.89c0-1.01-.75-1.87-1.75-1.98-2.98-.32-4.86-1.44-5.95-2.39a1.97 1.97 0 0 0-1.3-.49h0zm0 13.4L14.6 16l-.69-2.96 2.3-1.99-3.03-.26L12 8l-1.18 2.79-3.03.26 2.3 1.99L9.4 16l2.6-1.57z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgVehicleTheftFire = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M19 4h-3.09l2.88-1.66a1.01 1.01 0 0 0 .37-1.37A1.01 1.01 0 0 0 17.79.6L14 2.78C13.48 2.3 12.78 2 12 2c-1.33 0-2.44.87-2.84 2.07C6.25 4.47 4 6.98 4 10v8c0 .55.45 1 1 1s1-.45 1-1v-8c0-1.94 1.38-3.55 3.21-3.92.08.21.18.42.31.6C8.02 7.55 7 9.15 7 11v11c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V11c0-1.85-1.02-3.45-2.52-4.32a2.85 2.85 0 0 0 .33-.68H19c.55 0 1-.45 1-1s-.45-1-1-1zm-4 18H9V11a3.01 3.01 0 0 1 3-3 3.01 3.01 0 0 1 3 3v11zM11 5c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgVehicleVandalism = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M18.06 1.22a4.61 4.61 0 0 0-3.63 1.79l-9.97 13c-.27.35-.65.6-1.07.71l-.69.19c-.7.19-1.23.72-1.41 1.41a1.97 1.97 0 0 0 .52 1.93l1.79 1.79c.38.38.88.59 1.41.59a1.98 1.98 0 0 0 .53-.07c.7-.19 1.23-.72 1.41-1.41l.18-.69c.11-.42.37-.8.71-1.07l13-9.97c1.12-.86 1.79-2.21 1.79-3.63 0-2.52-2.05-4.57-4.57-4.57zM5.2 19.94l-.18.69-1.79-1.79.69-.18c.33-.09.64-.23.93-.4l.75.75c-.17.3-.31.6-.4.93zM19.63 7.83L6.96 17.55l-.66-.66 9.72-12.67c.48-.63 1.25-1 2.04-1a2.57 2.57 0 0 1 2.57 2.57c0 .79-.37 1.56-1 2.04zM5 4h6c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1zM3 7h6c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgVideo = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path fill-rule=\"evenodd\" d=\"M3.391 6.391c.25-.25.589-.391.943-.391h9.333c.354 0 .693.14.943.391s.39.589.39.943v2.384 4.565 2.384c0 .354-.14.693-.39.943s-.589.39-.943.39H4.333c-.354 0-.693-.14-.943-.39S3 17.02 3 16.667V7.333c0-.354.14-.693.391-.943zM17 16.004v.663c0 .884-.351 1.732-.976 2.357S14.551 20 13.667 20H4.333c-.884 0-1.732-.351-2.357-.976S1 17.551 1 16.667V7.333c0-.884.351-1.732.976-2.357S3.449 4 4.333 4h9.333c.884 0 1.732.351 2.357.976S17 6.449 17 7.333v.663l3.058-1.744c.313-.179.672-.268 1.039-.249s.713.144 1.006.351a2.09 2.09 0 0 1 .67.793A2.27 2.27 0 0 1 23 8.14v7.719a2.27 2.27 0 0 1-.228.995 2.09 2.09 0 0 1-.67.793c-.293.206-.639.332-1.006.351s-.725-.07-1.039-.249L17 16.004zm0-2.303l3.977 2.269c.013-.029.023-.067.023-.111V8.141c0-.044-.01-.083-.023-.111L17 10.299v3.403z\" /></svg>';
var $author$project$Pyxis$Components$IconSet$svgWallet = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21 6.18v-.86a2.99 2.99 0 0 0-1.17-2.38 3 3 0 0 0-2.6-.52L3.79 6.02C2.23 6.13 1 7.42 1 9v11c0 1.66 1.34 3 3 3h16c1.66 0 3-1.34 3-3V9c0-1.3-.84-2.4-2-2.82zm-3.26-1.83c.3-.08.62-.02.87.17a1.02 1.02 0 0 1 .39.8V6h-7.41l6.15-1.65zM21 20c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v11z\"/><circle cx=\"17.5\" cy=\"14.5\" r=\"1.5\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgWhatsapp = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20.5 3.49C18.25 1.24 15.25 0 12.05 0 5.46 0 .1 5.33.1 11.89a11.82 11.82 0 0 0 1.6 5.95L0 24l6.33-1.65a11.96 11.96 0 0 0 5.71 1.45h0C18.64 23.79 24 18.46 24 11.9c0-3.18-1.24-6.16-3.5-8.41zm-8.45 18.3h0c-1.79 0-3.53-.48-5.06-1.38l-.36-.21-3.76.98 1-3.65-.24-.37c-.99-1.57-1.52-3.39-1.52-5.26 0-5.45 4.46-9.88 9.94-9.88a9.87 9.87 0 0 1 7.02 2.9c1.88 1.87 2.91 4.35 2.91 6.99 0 5.44-4.46 9.88-9.93 9.88zm5.45-7.41c-.3-.15-1.77-.87-2.04-.97s-.47-.15-.67.15-.77.97-.95 1.17c-.17.2-.35.22-.65.07s-1.26-.46-2.4-1.47c-.89-.79-1.49-1.76-1.66-2.06s-.02-.46.13-.61c.13-.13.3-.35.45-.52s.2-.3.3-.5.05-.37-.02-.52-.68-1.6-.93-2.2c-.24-.58-.49-.5-.67-.51-.17-.01-.37-.01-.57-.01a1.1 1.1 0 0 0-.8.37c-.28.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.07c.15.2 2.11 3.2 5.1 4.49.71.31 1.27.49 1.7.63.72.23 1.37.19 1.88.12.57-.09 1.77-.72 2.02-1.41s.25-1.29.17-1.41c-.07-.13-.27-.21-.57-.36z\" fill-rule=\"evenodd\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgWrench = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M14.35 3.99l.33.01-2.44 2.44a2.97 2.97 0 0 0-.88 2.12 2.97 2.97 0 0 0 .88 2.12l1.41 1.41a2.97 2.97 0 0 0 2.12.88 2.97 2.97 0 0 0 2.12-.88l2.45-2.45c.09 1.68-.52 3.35-1.74 4.57a5.96 5.96 0 0 1-4.24 1.75c-.22 0-.44-.01-.66-.04l-.95-.1-.68.68-3.37 3.37a.96.96 0 0 1-.7.3c-.15 0-.45-.04-.71-.29l-2.83-2.83c-.39-.39-.39-1.02 0-1.41l3.37-3.37.68-.68-.1-.95c-.23-2.09.62-4.11 2.29-5.41 1.02-.8 2.32-1.24 3.65-1.24m7.3 4.36h0 0m-7.3-6.36c-1.74 0-3.47.55-4.89 1.66-2.33 1.82-3.34 4.57-3.05 7.2l-3.37 3.37a3 3 0 0 0 0 4.24l2.83 2.83c.59.59 1.35.88 2.12.88s1.54-.29 2.12-.88l3.37-3.37.88.05c2.05 0 4.09-.78 5.65-2.34 2.27-2.27 2.88-5.55 1.86-8.38-.15-.41-.53-.62-.92-.62-.26 0-.52.1-.72.3l-3.75 3.75a.98.98 0 0 1-.71.29c-.26 0-.51-.1-.71-.29l-1.41-1.41c-.39-.39-.39-1.02 0-1.41l3.75-3.75c.53-.53.31-1.42-.4-1.66-.84-.31-1.74-.46-2.65-.46h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$svgX = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M13.86 10.47L21.15 2h-1.73l-6.33 7.35L8.04 2H2.22l7.64 11.12L2.22 22h1.73l6.68-7.77L15.97 22h5.83l-7.92-11.53h0zm-2.36 2.75l-.77-1.11L4.56 3.3h2.65l4.97 7.11.77 1.11 6.46 9.24h-2.65l-5.27-7.54h0z\"/></svg>\n';
var $author$project$Pyxis$Components$IconSet$svgYoutube = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M23.5 6.22c-.28-1.03-1.09-1.85-2.12-2.12-1.87-.5-9.38-.5-9.38-.5s-7.51 0-9.38.5C1.59 4.38.78 5.19.5 6.22 0 8.09 0 12 0 12s0 3.91.5 5.78c.28 1.03 1.09 1.85 2.12 2.12 1.87.5 9.38.5 9.38.5s7.51 0 9.38-.5c1.03-.28 1.85-1.09 2.12-2.12.5-1.87.5-5.78.5-5.78s0-3.91-.5-5.78z\"/><path d=\"M9.6 15.6l6.24-3.6L9.6 8.4z\" fill=\"#fff\"/></svg>';
var $author$project$Pyxis$Components$IconSet$toString = function (icon) {
	switch (icon) {
		case 0:
			return $author$project$Pyxis$Components$IconSet$svgYoutube;
		case 1:
			return $author$project$Pyxis$Components$IconSet$svgX;
		case 2:
			return $author$project$Pyxis$Components$IconSet$svgWrench;
		case 3:
			return $author$project$Pyxis$Components$IconSet$svgWhatsapp;
		case 4:
			return $author$project$Pyxis$Components$IconSet$svgWallet;
		case 5:
			return $author$project$Pyxis$Components$IconSet$svgVideo;
		case 6:
			return $author$project$Pyxis$Components$IconSet$svgVehicleVandalism;
		case 7:
			return $author$project$Pyxis$Components$IconSet$svgVehicleTheftFire;
		case 8:
			return $author$project$Pyxis$Components$IconSet$svgVehicleSecuredBonus;
		case 9:
			return $author$project$Pyxis$Components$IconSet$svgVehicleRoadsideAssistance;
		case 10:
			return $author$project$Pyxis$Components$IconSet$svgVehicleRicourseWaiver;
		case 11:
			return $author$project$Pyxis$Components$IconSet$svgVehicleNaturalEvents;
		case 12:
			return $author$project$Pyxis$Components$IconSet$svgVehicleLegalProtection;
		case 13:
			return $author$project$Pyxis$Components$IconSet$svgVehicleGlasses;
		case 14:
			return $author$project$Pyxis$Components$IconSet$svgVehicleGlassesFilled;
		case 15:
			return $author$project$Pyxis$Components$IconSet$svgVehicleFullKasko;
		case 16:
			return $author$project$Pyxis$Components$IconSet$svgVehicleDriverInjuries;
		case 17:
			return $author$project$Pyxis$Components$IconSet$svgVehicleCollisionKasko;
		case 18:
			return $author$project$Pyxis$Components$IconSet$svgVan;
		case 19:
			return $author$project$Pyxis$Components$IconSet$svgUsers;
		case 20:
			return $author$project$Pyxis$Components$IconSet$svgUser;
		case 21:
			return $author$project$Pyxis$Components$IconSet$svgUserPlus;
		case 22:
			return $author$project$Pyxis$Components$IconSet$svgUserMinus;
		case 23:
			return $author$project$Pyxis$Components$IconSet$svgUserCross;
		case 24:
			return $author$project$Pyxis$Components$IconSet$svgUserCircle;
		case 25:
			return $author$project$Pyxis$Components$IconSet$svgUserCircleFilled;
		case 26:
			return $author$project$Pyxis$Components$IconSet$svgUserCheck;
		case 27:
			return $author$project$Pyxis$Components$IconSet$svgUpload;
		case 28:
			return $author$project$Pyxis$Components$IconSet$svgUmbrella;
		case 29:
			return $author$project$Pyxis$Components$IconSet$svgTwitter;
		case 30:
			return $author$project$Pyxis$Components$IconSet$svgTshirtSport;
		case 31:
			return $author$project$Pyxis$Components$IconSet$svgTrendUp;
		case 32:
			return $author$project$Pyxis$Components$IconSet$svgTrendUpChart;
		case 33:
			return $author$project$Pyxis$Components$IconSet$svgTrendDown;
		case 34:
			return $author$project$Pyxis$Components$IconSet$svgTrendDownChart;
		case 35:
			return $author$project$Pyxis$Components$IconSet$svgTrashBin;
		case 36:
			return $author$project$Pyxis$Components$IconSet$svgThumbUp;
		case 37:
			return $author$project$Pyxis$Components$IconSet$svgThumbDown;
		case 38:
			return $author$project$Pyxis$Components$IconSet$svgTablet;
		case 39:
			return $author$project$Pyxis$Components$IconSet$svgSwitch;
		case 40:
			return $author$project$Pyxis$Components$IconSet$svgSteeringWheel;
		case 41:
			return $author$project$Pyxis$Components$IconSet$svgStar;
		case 42:
			return $author$project$Pyxis$Components$IconSet$svgStarFilled;
		case 43:
			return $author$project$Pyxis$Components$IconSet$svgSmartphone;
		case 44:
			return $author$project$Pyxis$Components$IconSet$svgSki;
		case 45:
			return $author$project$Pyxis$Components$IconSet$svgShieldCheck;
		case 46:
			return $author$project$Pyxis$Components$IconSet$svgShare;
		case 47:
			return $author$project$Pyxis$Components$IconSet$svgShareAndroid;
		case 48:
			return $author$project$Pyxis$Components$IconSet$svgScan;
		case 49:
			return $author$project$Pyxis$Components$IconSet$svgReplay;
		case 50:
			return $author$project$Pyxis$Components$IconSet$svgReload;
		case 51:
			return $author$project$Pyxis$Components$IconSet$svgRefund;
		case 52:
			return $author$project$Pyxis$Components$IconSet$svgQuestionCircle;
		case 53:
			return $author$project$Pyxis$Components$IconSet$svgPrima;
		case 54:
			return $author$project$Pyxis$Components$IconSet$svgPound;
		case 55:
			return $author$project$Pyxis$Components$IconSet$svgPos;
		case 56:
			return $author$project$Pyxis$Components$IconSet$svgPlus;
		case 57:
			return $author$project$Pyxis$Components$IconSet$svgPlusSquare;
		case 58:
			return $author$project$Pyxis$Components$IconSet$svgPlusCircle;
		case 59:
			return $author$project$Pyxis$Components$IconSet$svgPlate;
		case 60:
			return $author$project$Pyxis$Components$IconSet$svgPicture;
		case 61:
			return $author$project$Pyxis$Components$IconSet$svgPhone;
		case 62:
			return $author$project$Pyxis$Components$IconSet$svgPhoneFilled;
		case 63:
			return $author$project$Pyxis$Components$IconSet$svgPhone24;
		case 64:
			return $author$project$Pyxis$Components$IconSet$svgPen;
		case 65:
			return $author$project$Pyxis$Components$IconSet$svgPenForm;
		case 66:
			return $author$project$Pyxis$Components$IconSet$svgPec;
		case 67:
			return $author$project$Pyxis$Components$IconSet$svgPaperclip;
		case 68:
			return $author$project$Pyxis$Components$IconSet$svgPaperPlane;
		case 69:
			return $author$project$Pyxis$Components$IconSet$svgOdometer;
		case 70:
			return $author$project$Pyxis$Components$IconSet$svgMotorcycle;
		case 71:
			return $author$project$Pyxis$Components$IconSet$svgMoreVertical;
		case 72:
			return $author$project$Pyxis$Components$IconSet$svgMoreHorizontal;
		case 73:
			return $author$project$Pyxis$Components$IconSet$svgMoreHorizontalCircle;
		case 74:
			return $author$project$Pyxis$Components$IconSet$svgMoped;
		case 75:
			return $author$project$Pyxis$Components$IconSet$svgMinus;
		case 76:
			return $author$project$Pyxis$Components$IconSet$svgMinusSquare;
		case 77:
			return $author$project$Pyxis$Components$IconSet$svgMinusCircle;
		case 78:
			return $author$project$Pyxis$Components$IconSet$svgMegaphone;
		case 79:
			return $author$project$Pyxis$Components$IconSet$svgMedal;
		case 80:
			return $author$project$Pyxis$Components$IconSet$svgMapMarker;
		case 81:
			return $author$project$Pyxis$Components$IconSet$svgMail;
		case 82:
			return $author$project$Pyxis$Components$IconSet$svgMagnifyingGlass;
		case 83:
			return $author$project$Pyxis$Components$IconSet$svgMagnifyingGlassPlus;
		case 84:
			return $author$project$Pyxis$Components$IconSet$svgMagnifyingGlassMinus;
		case 85:
			return $author$project$Pyxis$Components$IconSet$svgMagicWand;
		case 86:
			return $author$project$Pyxis$Components$IconSet$svgLogout;
		case 87:
			return $author$project$Pyxis$Components$IconSet$svgLock;
		case 88:
			return $author$project$Pyxis$Components$IconSet$svgLockOpen;
		case 89:
			return $author$project$Pyxis$Components$IconSet$svgLocation;
		case 90:
			return $author$project$Pyxis$Components$IconSet$svgLocationFilled;
		case 91:
			return $author$project$Pyxis$Components$IconSet$svgLocationDisabled;
		case 92:
			return $author$project$Pyxis$Components$IconSet$svgLocalProtection;
		case 93:
			return $author$project$Pyxis$Components$IconSet$svgLoader;
		case 94:
			return $author$project$Pyxis$Components$IconSet$svgList;
		case 95:
			return $author$project$Pyxis$Components$IconSet$svgListCircle;
		case 96:
			return $author$project$Pyxis$Components$IconSet$svgLinkedin;
		case 97:
			return $author$project$Pyxis$Components$IconSet$svgLink;
		case 98:
			return $author$project$Pyxis$Components$IconSet$svgKeyhole;
		case 99:
			return $author$project$Pyxis$Components$IconSet$svgKey;
		case 100:
			return $author$project$Pyxis$Components$IconSet$svgJobs;
		case 101:
			return $author$project$Pyxis$Components$IconSet$svgInsuranceHome;
		case 102:
			return $author$project$Pyxis$Components$IconSet$svgInstagram;
		case 103:
			return $author$project$Pyxis$Components$IconSet$svgInfoCircle;
		case 104:
			return $author$project$Pyxis$Components$IconSet$svgIdCard;
		case 105:
			return $author$project$Pyxis$Components$IconSet$svgHourglass;
		case 106:
			return $author$project$Pyxis$Components$IconSet$svgHourglassCross;
		case 107:
			return $author$project$Pyxis$Components$IconSet$svgHome;
		case 108:
			return $author$project$Pyxis$Components$IconSet$svgHomeTheftValuable;
		case 109:
			return $author$project$Pyxis$Components$IconSet$svgHomeTelephoneLegalAdvice;
		case 110:
			return $author$project$Pyxis$Components$IconSet$svgHomeRobberiesOutside;
		case 111:
			return $author$project$Pyxis$Components$IconSet$svgHomeNaturalEvents;
		case 112:
			return $author$project$Pyxis$Components$IconSet$svgHomeLegalProtection;
		case 113:
			return $author$project$Pyxis$Components$IconSet$svgHomeInsuranceHome;
		case 114:
			return $author$project$Pyxis$Components$IconSet$svgHomeInjuriesFreetime;
		case 115:
			return $author$project$Pyxis$Components$IconSet$svgHomeInjuriesFamily;
		case 116:
			return $author$project$Pyxis$Components$IconSet$svgHomeFurnitureContent;
		case 117:
			return $author$project$Pyxis$Components$IconSet$svgHomeFireExplosion;
		case 118:
			return $author$project$Pyxis$Components$IconSet$svgHomeEmergenciesRepairs;
		case 119:
			return $author$project$Pyxis$Components$IconSet$svgHomeDomesticThefts;
		case 120:
			return $author$project$Pyxis$Components$IconSet$svgHomeDamageThirdParties;
		case 121:
			return $author$project$Pyxis$Components$IconSet$svgHomeDamagePets;
		case 122:
			return $author$project$Pyxis$Components$IconSet$svgHomeDamageFamily;
		case 123:
			return $author$project$Pyxis$Components$IconSet$svgHomeDamageEbike;
		case 124:
			return $author$project$Pyxis$Components$IconSet$svgHomeAndFamily;
		case 125:
			return $author$project$Pyxis$Components$IconSet$svgHeart;
		case 126:
			return $author$project$Pyxis$Components$IconSet$svgHeartFilled;
		case 127:
			return $author$project$Pyxis$Components$IconSet$svgHeadset;
		case 128:
			return $author$project$Pyxis$Components$IconSet$svgGrid;
		case 129:
			return $author$project$Pyxis$Components$IconSet$svgGraduationHat;
		case 130:
			return $author$project$Pyxis$Components$IconSet$svgGpsEnabled;
		case 131:
			return $author$project$Pyxis$Components$IconSet$svgGpsDisabled;
		case 132:
			return $author$project$Pyxis$Components$IconSet$svgGift;
		case 133:
			return $author$project$Pyxis$Components$IconSet$svgGear;
		case 134:
			return $author$project$Pyxis$Components$IconSet$svgFolder;
		case 135:
			return $author$project$Pyxis$Components$IconSet$svgFloppyDisk;
		case 136:
			return $author$project$Pyxis$Components$IconSet$svgFax;
		case 137:
			return $author$project$Pyxis$Components$IconSet$svgFamilyRc;
		case 138:
			return $author$project$Pyxis$Components$IconSet$svgFacebook;
		case 139:
			return $author$project$Pyxis$Components$IconSet$svgEye;
		case 140:
			return $author$project$Pyxis$Components$IconSet$svgEyeSlashed;
		case 141:
			return $author$project$Pyxis$Components$IconSet$svgExternalLink;
		case 142:
			return $author$project$Pyxis$Components$IconSet$svgExpand;
		case 143:
			return $author$project$Pyxis$Components$IconSet$svgExclamationTriangle;
		case 144:
			return $author$project$Pyxis$Components$IconSet$svgExclamationCircle;
		case 145:
			return $author$project$Pyxis$Components$IconSet$svgExclamationCircleFilled;
		case 146:
			return $author$project$Pyxis$Components$IconSet$svgEuro;
		case 147:
			return $author$project$Pyxis$Components$IconSet$svgDownload;
		case 148:
			return $author$project$Pyxis$Components$IconSet$svgDocument;
		case 149:
			return $author$project$Pyxis$Components$IconSet$svgDocumentSigned;
		case 150:
			return $author$project$Pyxis$Components$IconSet$svgDocumentPlus;
		case 151:
			return $author$project$Pyxis$Components$IconSet$svgDocumentPdf;
		case 152:
			return $author$project$Pyxis$Components$IconSet$svgDocumentCross;
		case 153:
			return $author$project$Pyxis$Components$IconSet$svgDocumentClock;
		case 154:
			return $author$project$Pyxis$Components$IconSet$svgDocumentCheck;
		case 155:
			return $author$project$Pyxis$Components$IconSet$svgDocumentAlert;
		case 156:
			return $author$project$Pyxis$Components$IconSet$svgDirection;
		case 157:
			return $author$project$Pyxis$Components$IconSet$svgDiamond;
		case 158:
			return $author$project$Pyxis$Components$IconSet$svgDevices;
		case 159:
			return $author$project$Pyxis$Components$IconSet$svgDashboard;
		case 160:
			return $author$project$Pyxis$Components$IconSet$svgDashboardFilled;
		case 161:
			return $author$project$Pyxis$Components$IconSet$svgDamageThirdParties;
		case 162:
			return $author$project$Pyxis$Components$IconSet$svgCross;
		case 163:
			return $author$project$Pyxis$Components$IconSet$svgCrossSquare;
		case 164:
			return $author$project$Pyxis$Components$IconSet$svgCrossCircle;
		case 165:
			return $author$project$Pyxis$Components$IconSet$svgCrossCircleFilled;
		case 166:
			return $author$project$Pyxis$Components$IconSet$svgCreditCard;
		case 167:
			return $author$project$Pyxis$Components$IconSet$svgCookie;
		case 168:
			return $author$project$Pyxis$Components$IconSet$svgContactless;
		case 169:
			return $author$project$Pyxis$Components$IconSet$svgComputer;
		case 170:
			return $author$project$Pyxis$Components$IconSet$svgCollapse;
		case 171:
			return $author$project$Pyxis$Components$IconSet$svgCode;
		case 172:
			return $author$project$Pyxis$Components$IconSet$svgClock;
		case 173:
			return $author$project$Pyxis$Components$IconSet$svgClock24;
		case 174:
			return $author$project$Pyxis$Components$IconSet$svgCircleStop;
		case 175:
			return $author$project$Pyxis$Components$IconSet$svgCirclePlay;
		case 176:
			return $author$project$Pyxis$Components$IconSet$svgCirclePause;
		case 177:
			return $author$project$Pyxis$Components$IconSet$svgChevronUp;
		case 178:
			return $author$project$Pyxis$Components$IconSet$svgChevronRight;
		case 179:
			return $author$project$Pyxis$Components$IconSet$svgChevronLeft;
		case 180:
			return $author$project$Pyxis$Components$IconSet$svgChevronDown;
		case 181:
			return $author$project$Pyxis$Components$IconSet$svgChevronCircleUp;
		case 182:
			return $author$project$Pyxis$Components$IconSet$svgChevronCircleRight;
		case 183:
			return $author$project$Pyxis$Components$IconSet$svgChevronCircleLeft;
		case 184:
			return $author$project$Pyxis$Components$IconSet$svgChevronCircleDown;
		case 185:
			return $author$project$Pyxis$Components$IconSet$svgCheck;
		case 186:
			return $author$project$Pyxis$Components$IconSet$svgCheckSquare;
		case 187:
			return $author$project$Pyxis$Components$IconSet$svgCheckCircle;
		case 188:
			return $author$project$Pyxis$Components$IconSet$svgCheckCircleFilled;
		case 189:
			return $author$project$Pyxis$Components$IconSet$svgChat;
		case 190:
			return $author$project$Pyxis$Components$IconSet$svgChart;
		case 191:
			return $author$project$Pyxis$Components$IconSet$svgCart;
		case 192:
			return $author$project$Pyxis$Components$IconSet$svgCardsOverlap;
		case 193:
			return $author$project$Pyxis$Components$IconSet$svgCar;
		case 194:
			return $author$project$Pyxis$Components$IconSet$svgCamera;
		case 195:
			return $author$project$Pyxis$Components$IconSet$svgCalendar;
		case 196:
			return $author$project$Pyxis$Components$IconSet$svgCalendarMail;
		case 197:
			return $author$project$Pyxis$Components$IconSet$svgCalendarDown;
		case 198:
			return $author$project$Pyxis$Components$IconSet$svgCalendarClock;
		case 199:
			return $author$project$Pyxis$Components$IconSet$svgCalculator;
		case 200:
			return $author$project$Pyxis$Components$IconSet$svgBurger;
		case 201:
			return $author$project$Pyxis$Components$IconSet$svgBuildings;
		case 202:
			return $author$project$Pyxis$Components$IconSet$svgBook;
		case 203:
			return $author$project$Pyxis$Components$IconSet$svgBell;
		case 204:
			return $author$project$Pyxis$Components$IconSet$svgBank;
		case 205:
			return $author$project$Pyxis$Components$IconSet$svgBaloon;
		case 206:
			return $author$project$Pyxis$Components$IconSet$svgArrowUp;
		case 207:
			return $author$project$Pyxis$Components$IconSet$svgArrowRight;
		case 208:
			return $author$project$Pyxis$Components$IconSet$svgArrowLeft;
		case 209:
			return $author$project$Pyxis$Components$IconSet$svgArrowDown;
		case 210:
			return $author$project$Pyxis$Components$IconSet$svgArrowDiagonalUpRight;
		case 211:
			return $author$project$Pyxis$Components$IconSet$svgArrowDiagonalUpLeft;
		case 212:
			return $author$project$Pyxis$Components$IconSet$svgArrowDiagonalDownRight;
		case 213:
			return $author$project$Pyxis$Components$IconSet$svgArrowDiagonalDownLeft;
		case 214:
			return $author$project$Pyxis$Components$IconSet$svgApple;
		case 215:
			return $author$project$Pyxis$Components$IconSet$svgAndroid;
		case 216:
			return $author$project$Pyxis$Components$IconSet$svgAlarm;
		case 217:
			return $author$project$Pyxis$Components$IconSet$svgAffiliatedRepairshops;
		case 218:
			return $author$project$Pyxis$Components$IconSet$svgAdjustmentsHorizontal;
		default:
			return $author$project$Pyxis$Components$IconSet$svgActivity;
	}
};
var $author$project$Pyxis$Components$Icon$render = function (configuration) {
	var ariaLabel = configuration.fV;
	var ariaLabelledby = configuration.fX;
	var icon = configuration.kf;
	var color = configuration.ea;
	var dataAttrList = configuration.ej;
	return A2(
		$elm$html$Html$span,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					$author$project$Pyxis$Components$Icon$getClassList(configuration)),
					$author$project$Pyxis$Commons$Attributes$ariaHidden(
					$elm_community$maybe_extra$Maybe$Extra$isNothing(ariaLabel) && $elm_community$maybe_extra$Maybe$Extra$isNothing(ariaLabelledby)),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaLabel, ariaLabel),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaLabelledBy, ariaLabelledby),
					A2(
					$author$project$Pyxis$Commons$Attributes$renderIf,
					$elm_community$maybe_extra$Maybe$Extra$isJust(ariaLabel) || $elm_community$maybe_extra$Maybe$Extra$isJust(ariaLabelledby),
					$author$project$Pyxis$Commons$Attributes$role('img')),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-name',
					$author$project$Pyxis$Components$IconSet$toLabel(icon))
				])),
		_List_fromArray(
			[
				$author$project$Pyxis$Commons$Render$renderMaybe(
				$elm$core$Result$toMaybe(
					$Garados007$elm_svg_parser$SvgParser$parse(
						$author$project$Pyxis$Components$IconSet$toString(icon))))
			]));
};
var $author$project$Pyxis$Components$Badge$Brand = 1;
var $author$project$Pyxis$Components$Badge$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Badge$Default = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Badge$Weak = 0;
var $author$project$Pyxis$Components$Badge$config = function (variant) {
	return {
		dU: $elm$core$Maybe$Nothing,
		f6: _List_Nil,
		ej: _List_Nil,
		er: 0,
		kg: $elm$core$Maybe$Nothing,
		fv: $elm$core$Maybe$Nothing,
		pu: '',
		bk: $author$project$Pyxis$Components$Badge$Default($elm$core$Maybe$Nothing),
		i_: variant
	};
};
var $author$project$Pyxis$Components$Badge$brand = $author$project$Pyxis$Components$Badge$config(1);
var $author$project$Pyxis$Components$NavigationSidebar$getBadgeAccessibilityLabel = F3(
	function (badgeAccessibilityLabel, badgeText, itemLabel) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_ap(badgeText, itemLabel),
			A2(
				$elm$core$Maybe$map,
				function (badgeFn) {
					return A2(badgeFn, badgeText, itemLabel);
				},
				badgeAccessibilityLabel));
	});
var $author$project$Pyxis$Components$Badge$Notification = {$: 2};
var $author$project$Pyxis$Components$Badge$notification = $author$project$Pyxis$Components$Badge$Notification;
var $author$project$Pyxis$Components$Badge$Strong = 1;
var $author$project$Pyxis$Components$Badge$getBadgeTypeClass = F2(
	function (type_, emphasis) {
		switch (type_.$) {
			case 0:
				var icon = type_.a;
				return A3(
					$author$project$Pyxis$Commons$Basics$ternaryOperator,
					$elm_community$maybe_extra$Maybe$Extra$isJust(icon),
					'badge--with-icon',
					'');
			case 1:
				var icon = type_.a;
				return A3(
					$author$project$Pyxis$Commons$Basics$ternaryOperator,
					$elm_community$maybe_extra$Maybe$Extra$isJust(icon),
					'badge--ribbon badge--with-icon',
					'badge--ribbon');
			default:
				return A3($author$project$Pyxis$Commons$Basics$ternaryOperator, emphasis === 1, 'badge--notification', '');
		}
	});
var $author$project$Pyxis$Components$Badge$getBadgeVariantClass = function (variant) {
	switch (variant) {
		case 2:
			return 'badge--action';
		case 5:
			return 'badge--alert';
		case 1:
			return 'badge--brand';
		case 3:
			return 'badge--error';
		case 0:
			return '';
		case 4:
			return 'badge--success';
		default:
			return 'badge--informative';
	}
};
var $author$project$Pyxis$Commons$Attributes$ariaLivePolite = A2($elm$html$Html$Attributes$attribute, 'aria-live', 'polite');
var $author$project$Pyxis$Components$Badge$renderAccessibilityLabel = function (accessibilityLabel) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sr-only'),
				$author$project$Pyxis$Commons$Attributes$ariaLivePolite,
				$author$project$Pyxis$Commons$Attributes$role('status')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(accessibilityLabel)
			]));
};
var $author$project$Pyxis$Components$Badge$renderIcon = function (type_) {
	var maybeIcon = function () {
		switch (type_.$) {
			case 0:
				var icon = type_.a;
				return icon;
			case 1:
				var icon = type_.a;
				return icon;
			default:
				return $elm$core$Maybe$Nothing;
		}
	}();
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$html$Html$text(''),
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Pyxis$Components$Icon$config, $author$project$Pyxis$Components$Icon$render),
			maybeIcon));
};
var $author$project$Pyxis$Commons$Attributes$testId = $elm$html$Html$Attributes$attribute('data-test-id');
var $author$project$Pyxis$Components$Badge$render = function (_v0) {
	var accessibilityLabel = _v0.dU;
	var classList = _v0.f6;
	var dataAttrList = _v0.ej;
	var id = _v0.kg;
	var emphasis = _v0.er;
	var testId = _v0.fv;
	var text = _v0.pu;
	var type_ = _v0.bk;
	var variant = _v0.i_;
	return A2(
		$elm$html$Html$span,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('badge', true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Badge$getBadgeVariantClass(variant),
							true),
							_Utils_Tuple2('badge--strong', emphasis === 1),
							_Utils_Tuple2(
							A2($author$project$Pyxis$Components$Badge$getBadgeTypeClass, type_, emphasis),
							true)
						])),
					$elm$html$Html$Attributes$classList(classList),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
				])),
		_List_fromArray(
			[
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Badge$renderAccessibilityLabel, accessibilityLabel)),
				$author$project$Pyxis$Components$Badge$renderIcon(type_),
				$elm$html$Html$text(text)
			]));
};
var $author$project$Pyxis$Components$Badge$strong = 1;
var $author$project$Pyxis$Components$Badge$withAccessibilityLabel = F2(
	function (accessibilityLabel, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				dU: $elm$core$Maybe$Just(accessibilityLabel)
			});
	});
var $author$project$Pyxis$Components$Badge$withEmphasis = F2(
	function (emphasis, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{er: emphasis});
	});
var $author$project$Pyxis$Components$Badge$withText = F2(
	function (text, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{pu: text});
	});
var $author$project$Pyxis$Components$Badge$withType = F2(
	function (type_, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{bk: type_});
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderBadge = F3(
	function (accessibilityLabelFn, itemLabel, badge) {
		return $author$project$Pyxis$Components$Badge$render(
			A2(
				$author$project$Pyxis$Components$Badge$withType,
				$author$project$Pyxis$Components$Badge$notification,
				A2(
					$author$project$Pyxis$Components$Badge$withEmphasis,
					$author$project$Pyxis$Components$Badge$strong,
					A2(
						$author$project$Pyxis$Components$Badge$withAccessibilityLabel,
						A3($author$project$Pyxis$Components$NavigationSidebar$getBadgeAccessibilityLabel, accessibilityLabelFn, badge, itemLabel),
						A2($author$project$Pyxis$Components$Badge$withText, badge, $author$project$Pyxis$Components$Badge$brand)))));
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $author$project$Pyxis$Components$IconSet$ExternalLink = 141;
var $author$project$Pyxis$Components$IconSet$externalLink = 141;
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Pyxis$Commons$Attributes$LinkTarget$toString = function (linkTarget) {
	switch (linkTarget) {
		case 0:
			return '_blank';
		case 1:
			return '_self';
		case 2:
			return '_parent';
		case 3:
			return '_top';
		default:
			return 'framename';
	}
};
var $author$project$Pyxis$Commons$Attributes$target = A2($elm$core$Basics$composeR, $author$project$Pyxis$Commons$Attributes$LinkTarget$toString, $elm$html$Html$Attributes$target);
var $author$project$Pyxis$Components$Icon$withClassList = F2(
	function (a, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{f6: a});
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderGroupExternalLinkItem = F4(
	function (tabIndexValue, badgeAccessibilityLabel, _v0, target) {
		var href = _v0.cU;
		var label = _v0.eR;
		var danger = _v0.aY;
		var testId = _v0.fv;
		var dataAttrList = _v0.ej;
		var badge = _v0.bu;
		return A2(
			$elm$html$Html$a,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-nav-item side-nav-item--with-icon'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('side-nav-item--danger', danger)
							])),
						$elm$html$Html$Attributes$href(href),
						$elm$html$Html$Attributes$tabindex(tabIndexValue),
						$author$project$Pyxis$Commons$Attributes$target(target),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					])),
			_List_fromArray(
				[
					$elm$html$Html$text(label),
					$author$project$Pyxis$Components$Icon$render(
					A2(
						$author$project$Pyxis$Components$Icon$withClassList,
						_List_fromArray(
							[
								_Utils_Tuple2('side-nav-item__external-link-icon', true)
							]),
						$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$externalLink))),
					A2(
					$author$project$Pyxis$Commons$Render$maybeMapRender,
					A2($author$project$Pyxis$Components$NavigationSidebar$renderBadge, badgeAccessibilityLabel, label),
					badge)
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$isActiveRoute = F2(
	function (href, activeRoute) {
		return _Utils_eq(href, activeRoute);
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderGroupInternalLinkItem = F4(
	function (activeRoute, badgeAccessibilityLabel, tabIndexValue, _v0) {
		var href = _v0.cU;
		var label = _v0.eR;
		var danger = _v0.aY;
		var testId = _v0.fv;
		var dataAttrList = _v0.ej;
		var badge = _v0.bu;
		return A2(
			$elm$html$Html$a,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-nav-item'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('side-nav-item--danger', danger),
								_Utils_Tuple2(
								'side-nav-item--selected',
								A2($author$project$Pyxis$Components$NavigationSidebar$isActiveRoute, href, activeRoute))
							])),
						$elm$html$Html$Attributes$href(href),
						$elm$html$Html$Attributes$tabindex(tabIndexValue),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					])),
			_List_fromArray(
				[
					$elm$html$Html$text(label),
					A2(
					$author$project$Pyxis$Commons$Render$maybeMapRender,
					A2($author$project$Pyxis$Components$NavigationSidebar$renderBadge, badgeAccessibilityLabel, label),
					badge)
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderGroupItemLink = F4(
	function (activeRoute, badgeAccessibilityLabel, tabIndexValue, groupLink) {
		if (!groupLink.$) {
			var configuration = groupLink.a;
			return A4($author$project$Pyxis$Components$NavigationSidebar$renderGroupInternalLinkItem, activeRoute, badgeAccessibilityLabel, tabIndexValue, configuration);
		} else {
			var configuration = groupLink.a;
			var target = groupLink.b;
			return A4($author$project$Pyxis$Components$NavigationSidebar$renderGroupExternalLinkItem, tabIndexValue, badgeAccessibilityLabel, configuration, target);
		}
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderGroupItemAsDropdown = F3(
	function (activeRoute, badgeAccessibilityLabel, groupLink) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-panel__dropdown__list__item')
				]),
			_List_fromArray(
				[
					A4($author$project$Pyxis$Components$NavigationSidebar$renderGroupItemLink, activeRoute, badgeAccessibilityLabel, 0, groupLink)
				]));
	});
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Pyxis$Components$NavigationSidebar$renderGroupAsDropdown = F4(
	function (activeRoute, badgeAccessibilityLabel, label, groupItemList) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-panel__dropdown-wrapper'),
					A2($elm$html$Html$Attributes$attribute, 'data-style', 'default')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('side-panel__dropdown__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('side-panel__dropdown__list')
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Pyxis$Components$NavigationSidebar$renderGroupItemAsDropdown, activeRoute, badgeAccessibilityLabel),
						$author$project$Pyxis$Commons$NonEmptyList$toList(groupItemList)))
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderGroupItemAsList = F4(
	function (activeRoute, badgeAccessibilityLabel, groupExpanded, groupLink) {
		var tabIndexValue = groupExpanded ? 0 : (-1);
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-panel__group__list__item')
				]),
			_List_fromArray(
				[
					A4($author$project$Pyxis$Components$NavigationSidebar$renderGroupItemLink, activeRoute, badgeAccessibilityLabel, tabIndexValue, groupLink)
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderGroupAsList = F4(
	function (activeRoute, badgeAccessibilityLabel, groupItemList, groupExpanded) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-panel__group-wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('side-panel__group__list')
						]),
					A2(
						$elm$core$List$map,
						A3($author$project$Pyxis$Components$NavigationSidebar$renderGroupItemAsList, activeRoute, badgeAccessibilityLabel, groupExpanded),
						$author$project$Pyxis$Commons$NonEmptyList$toList(groupItemList)))
				]));
	});
var $author$project$Pyxis$Commons$Render$renderIfElse = F3(
	function (condition, falseHtml, trueHtml) {
		return condition ? trueHtml : falseHtml;
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderGroup = F6(
	function (key, badgeAccessibilityLabel, _v0, groupItemList, tagger, model) {
		var label = _v0.eR;
		var icon = _v0.kf;
		var badge = _v0.bu;
		var activeRoute = model.cs;
		var groupIsSelected = A2(
			$elm$core$List$member,
			activeRoute,
			$author$project$Pyxis$Components$NavigationSidebar$pickNavItemGroupLinkHref(groupItemList));
		var groupExpanded = A2($author$project$Pyxis$Components$NavigationSidebar$isGroupExpanded, key, model);
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-nav__list__item side-nav__list__item--with-sub-item'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('side-nav__list__item--expanded', groupExpanded)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('side-nav-item side-nav-item--button side-nav-item--with-icon'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('side-nav-item--selected', groupIsSelected && (!groupExpanded))
								])),
							A2($elm$html$Html$Attributes$attribute, 'aria-controls', 'group-item'),
							A2($elm$html$Html$Attributes$attribute, 'data-group-key', key),
							$elm$html$Html$Events$onClick(
							tagger(
								$author$project$Pyxis$Components$NavigationSidebar$ToggleGroupExpand(key)))
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Icon$render(
							$author$project$Pyxis$Components$Icon$config(icon)),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-nav-item__text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-nav-item__right-section')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Pyxis$Commons$Render$maybeMapRender,
									A2($author$project$Pyxis$Components$NavigationSidebar$renderBadge, badgeAccessibilityLabel, label),
									badge),
									$author$project$Pyxis$Components$Icon$render(
									A2(
										$author$project$Pyxis$Components$Icon$withClassList,
										_List_fromArray(
											[
												_Utils_Tuple2('side-nav-item__toggle-icon', true)
											]),
										$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$chevronDown)))
								]))
						])),
					A3(
					$author$project$Pyxis$Commons$Render$renderIfElse,
					$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model),
					A4($author$project$Pyxis$Components$NavigationSidebar$renderGroupAsDropdown, activeRoute, badgeAccessibilityLabel, label, groupItemList),
					A4($author$project$Pyxis$Components$NavigationSidebar$renderGroupAsList, activeRoute, badgeAccessibilityLabel, groupItemList, groupExpanded))
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderKeyedGroup = F6(
	function (badgeAccessibilityLabel, key, groupConfig, groupItemList, tagger, model) {
		return _Utils_Tuple2(
			key,
			A6($author$project$Pyxis$Components$NavigationSidebar$renderGroup, key, badgeAccessibilityLabel, groupConfig, groupItemList, tagger, model));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderNavigationItemText = function (label) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('side-nav-item__text')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Pyxis$Components$NavigationSidebar$renderNavigationItemToolTip = function (label) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('side-nav-item__tooltip'),
				A2($elm$html$Html$Attributes$attribute, 'data-style', 'default')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Pyxis$Components$NavigationSidebar$renderExternalLink = F4(
	function (badgeAccessibilityLabel, model, _v0, target) {
		var href = _v0.cU;
		var divider = _v0.gq;
		var label = _v0.eR;
		var icon = _v0.kf;
		var testId = _v0.fv;
		var dataAttrList = _v0.ej;
		var badge = _v0.bu;
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('side-nav__list__item', true),
							_Utils_Tuple2('side-nav__list__item--with-divider', divider)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					A2(
						$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
						dataAttrList,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('side-nav-item side-nav-item--with-icon'),
								$elm$html$Html$Attributes$href(href),
								$author$project$Pyxis$Commons$Attributes$target(target),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
							])),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Icon$render(
							$author$project$Pyxis$Components$Icon$config(icon)),
							A3(
							$author$project$Pyxis$Commons$Render$renderIfElse,
							$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model),
							$author$project$Pyxis$Components$NavigationSidebar$renderNavigationItemToolTip(label),
							$author$project$Pyxis$Components$NavigationSidebar$renderNavigationItemText(label)),
							$author$project$Pyxis$Components$Icon$render(
							A2(
								$author$project$Pyxis$Components$Icon$withClassList,
								_List_fromArray(
									[
										_Utils_Tuple2('side-nav-item__external-link-icon', true)
									]),
								$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$externalLink))),
							A2(
							$author$project$Pyxis$Commons$Render$maybeMapRender,
							A2($author$project$Pyxis$Components$NavigationSidebar$renderBadge, badgeAccessibilityLabel, label),
							badge)
						]))
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderInternalLink = F3(
	function (badgeAccessibilityLabel, model, _v0) {
		var activeRoute = model.cs;
		var href = _v0.cU;
		var divider = _v0.gq;
		var label = _v0.eR;
		var icon = _v0.kf;
		var testId = _v0.fv;
		var dataAttrList = _v0.ej;
		var badge = _v0.bu;
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('side-nav__list__item', true),
							_Utils_Tuple2('side-nav__list__item--with-divider', divider)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					A2(
						$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
						dataAttrList,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('side-nav-item'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('side-nav-item', true),
										_Utils_Tuple2(
										'side-nav-item--selected',
										A2($author$project$Pyxis$Components$NavigationSidebar$isActiveRoute, href, activeRoute))
									])),
								$elm$html$Html$Attributes$href(href),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
							])),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Icon$render(
							$author$project$Pyxis$Components$Icon$config(icon)),
							A3(
							$author$project$Pyxis$Commons$Render$renderIfElse,
							$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model),
							$author$project$Pyxis$Components$NavigationSidebar$renderNavigationItemToolTip(label),
							$author$project$Pyxis$Components$NavigationSidebar$renderNavigationItemText(label)),
							A2(
							$author$project$Pyxis$Commons$Render$maybeMapRender,
							A2($author$project$Pyxis$Components$NavigationSidebar$renderBadge, badgeAccessibilityLabel, label),
							badge)
						]))
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderLink = F3(
	function (badgeAccessibilityLabel, model, navItemLink) {
		if (!navItemLink.$) {
			var navigationItemLinkConfig = navItemLink.a;
			return A3($author$project$Pyxis$Components$NavigationSidebar$renderInternalLink, badgeAccessibilityLabel, model, navigationItemLinkConfig);
		} else {
			var navigationItemLinkConfig = navItemLink.a;
			var target = navItemLink.b;
			return A4($author$project$Pyxis$Components$NavigationSidebar$renderExternalLink, badgeAccessibilityLabel, model, navigationItemLinkConfig, target);
		}
	});
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$Pyxis$Components$NavigationSidebar$renderSectionTitle = function (title) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('side-nav__list__item')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-nav__list__item__title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					]))
			]));
};
var $author$project$Pyxis$Components$NavigationSidebar$renderNavItem = F5(
	function (tagger, badgeAccessibilityLabel, model, elementIndex, navItem) {
		switch (navItem.$) {
			case 0:
				var navItemLink = navItem.a;
				return _Utils_Tuple2(
					$author$project$Pyxis$Components$NavigationSidebar$elementIndexToKey(elementIndex),
					A3($author$project$Pyxis$Components$NavigationSidebar$renderLink, badgeAccessibilityLabel, model, navItemLink));
			case 1:
				var title = navItem.a;
				return _Utils_Tuple2(
					$author$project$Pyxis$Components$NavigationSidebar$elementIndexToKey(elementIndex),
					$author$project$Pyxis$Components$NavigationSidebar$renderSectionTitle(title));
			default:
				if (navItem.a.b.$ === 1) {
					var _v1 = navItem.a;
					var _v2 = _v1.b;
					return _Utils_Tuple2(
						$author$project$Pyxis$Components$NavigationSidebar$elementIndexToKey(elementIndex),
						$author$project$Pyxis$Commons$Render$empty);
				} else {
					var _v3 = navItem.a;
					var groupConfiguration = _v3.a;
					var items = _v3.b.a;
					return $author$project$Pyxis$Components$NavigationSidebar$isExpanded(model) ? A6(
						$author$project$Pyxis$Components$NavigationSidebar$renderKeyedGroup,
						badgeAccessibilityLabel,
						'with-list-' + $author$project$Pyxis$Components$NavigationSidebar$elementIndexToKey(elementIndex),
						groupConfiguration,
						items,
						tagger,
						model) : A6(
						$author$project$Pyxis$Components$NavigationSidebar$renderKeyedGroup,
						badgeAccessibilityLabel,
						'with-dropdown-' + $author$project$Pyxis$Components$NavigationSidebar$elementIndexToKey(elementIndex),
						groupConfiguration,
						items,
						tagger,
						model);
				}
		}
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$Keyed$ul = $elm$html$Html$Keyed$node('ul');
var $author$project$Pyxis$Components$NavigationSidebar$renderNavigationList = F5(
	function (tagger, badgeAccessibilityLabel, model, ariaLabel, navigation) {
		return A2(
			$elm$html$Html$nav,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-nav'),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', ariaLabel)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Keyed$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('side-nav__list')
						]),
					A2(
						$elm$core$List$indexedMap,
						A3($author$project$Pyxis$Components$NavigationSidebar$renderNavItem, tagger, badgeAccessibilityLabel, model),
						$author$project$Pyxis$Commons$NonEmptyList$toList(navigation)))
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderSlotBottom = F2(
	function (model, customContent) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('side-panel__slot-bottom', true),
							_Utils_Tuple2(
							'side-panel__slot-bottom--opened',
							$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model)),
							_Utils_Tuple2(
							'side-panel__slot-bottom--collapsed',
							!$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model))
						]))
				]),
			_List_fromArray(
				[customContent]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderSlotTop = F2(
	function (model, customContent) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('side-panel__slot-top', true),
							_Utils_Tuple2(
							'side-panel__slot-top--opened',
							$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model)),
							_Utils_Tuple2(
							'side-panel__slot-top--collapsed',
							!$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model))
						]))
				]),
			_List_fromArray(
				[customContent]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderContent = F4(
	function (tagger, badgeAccessibilityLabel, model, _v0) {
		var slotBottom = _v0.iy;
		var slotTop = _v0.iz;
		var navigation = _v0.hq;
		var id = _v0.kg;
		var classList = _v0.f6;
		var testId = _v0.fv;
		var navigationAriaLabel = _v0.hr;
		var dataAttrList = _v0.ej;
		return A2(
			$elm$html$Html$div,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-panel__content-wrapper'),
						$elm$html$Html$Attributes$classList(classList),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					])),
			_List_fromArray(
				[
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2(
						$elm$core$Maybe$map,
						$author$project$Pyxis$Components$NavigationSidebar$renderSlotTop(model),
						slotTop)),
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2(
						$elm$core$Maybe$map,
						A4($author$project$Pyxis$Components$NavigationSidebar$renderNavigationList, tagger, badgeAccessibilityLabel, model, navigationAriaLabel),
						navigation)),
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2(
						$elm$core$Maybe$map,
						$author$project$Pyxis$Components$NavigationSidebar$renderSlotBottom(model),
						slotBottom))
				]));
	});
var $author$project$Pyxis$Components$Button$Ghost = 5;
var $author$project$Pyxis$Components$Button$Button = {$: 0};
var $author$project$Pyxis$Components$Button$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Button$Inherit = 2;
var $author$project$Pyxis$Components$Button$M = 2;
var $author$project$Pyxis$Components$Button$None = {$: 3};
var $author$project$Pyxis$Components$Button$config = function (variant) {
	return {fP: $elm$core$Maybe$Nothing, fQ: $elm$core$Maybe$Nothing, fR: $elm$core$Maybe$Nothing, fS: $elm$core$Maybe$Nothing, fT: $elm$core$Maybe$Nothing, fU: $elm$core$Maybe$Nothing, fV: $elm$core$Maybe$Nothing, fW: $elm$core$Maybe$Nothing, f6: _List_Nil, ej: _List_Nil, go: false, gE: $elm$core$Maybe$Nothing, kf: $author$project$Pyxis$Components$Button$None, kg: $elm$core$Maybe$Nothing, bR: false, hb: 'Loading...', hJ: $elm$core$Maybe$Nothing, hX: $elm$core$Maybe$Nothing, aO: 2, iF: $elm$core$Maybe$Nothing, fv: $elm$core$Maybe$Nothing, pu: '', bk: $author$project$Pyxis$Components$Button$Button, i_: variant, dR: 2};
};
var $author$project$Pyxis$Components$Button$ghost = $author$project$Pyxis$Components$Button$config(5);
var $author$project$Pyxis$Components$IconSet$MoreVertical = 71;
var $author$project$Pyxis$Components$IconSet$moreVertical = 71;
var $author$project$Pyxis$Commons$Attributes$ariaControls = $elm$html$Html$Attributes$attribute('aria-controls');
var $author$project$Pyxis$Commons$Attributes$ariaCurrent = $elm$html$Html$Attributes$attribute('aria-current');
var $author$project$Pyxis$Commons$Attributes$ariaDescribedBy = $elm$html$Html$Attributes$attribute('aria-describedby');
var $author$project$Pyxis$Commons$Attributes$ariaDisabled = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Commons$String$fromBool,
	$elm$html$Html$Attributes$attribute('aria-disabled'));
var $primait$prima_elm_extra$PrimaFunction$ifThenElse = F3(
	function (condition, a, b) {
		return condition ? a : b;
	});
var $author$project$Pyxis$Commons$Attributes$ariaExpanded = function (isExpanded) {
	return A2(
		$elm$html$Html$Attributes$attribute,
		'aria-expanded',
		A3($primait$prima_elm_extra$PrimaFunction$ifThenElse, isExpanded, 'true', 'false'));
};
var $author$project$Pyxis$Commons$Attributes$ariaHasPopup = $elm$html$Html$Attributes$attribute('aria-haspopup');
var $author$project$Pyxis$Components$AriaLive$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$AriaLive$config = function (text) {
	return text;
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$Attributes$form = _VirtualDom_attribute('form');
var $author$project$Pyxis$Commons$Attributes$getAriaDisabledState = F2(
	function (maybeDisabled, loading) {
		var _v0 = _Utils_Tuple2(maybeDisabled, loading);
		if (!_v0.b) {
			if (!_v0.a.$) {
				var disabled = _v0.a.a;
				return $elm$core$Maybe$Just(disabled);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Just(true);
		}
	});
var $author$project$Pyxis$Components$Button$getButtonIconClass = function (icon) {
	switch (icon.$) {
		case 0:
			return 'button--append-icon';
		case 1:
			return 'button--prepend-icon';
		case 2:
			return 'button--icon-only';
		default:
			return '';
	}
};
var $author$project$Pyxis$Components$Button$getButtonSizeClass = function (size) {
	switch (size) {
		case 0:
			return 'button--xl';
		case 1:
			return 'button--l';
		case 2:
			return 'button--m';
		default:
			return 'button--s';
	}
};
var $author$project$Pyxis$Components$Button$getButtonVariantClass = function (variant) {
	switch (variant) {
		case 0:
			return 'button--primary';
		case 1:
			return 'button--secondary';
		case 2:
			return 'button--tertiary';
		case 3:
			return 'button--brand';
		case 5:
			return 'button--ghost';
		default:
			return 'button--danger';
	}
};
var $author$project$Pyxis$Components$Button$getButtonWidthClass = function (width) {
	switch (width) {
		case 2:
			return '';
		case 0:
			return 'button--min-width';
		default:
			return 'button--full-width';
	}
};
var $author$project$Pyxis$Components$Button$isAppend = function (buttonIcon) {
	if (!buttonIcon.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Components$Button$isGhost = function (buttonVariant) {
	if (buttonVariant === 5) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Components$Button$isPrepend = function (buttonIcon) {
	if (buttonIcon.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Components$Button$isStandalone = function (buttonIcon) {
	if (buttonIcon.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Commons$Attributes$TabIndex$Negative = 0;
var $author$project$Pyxis$Commons$Attributes$TabIndex$negative = 0;
var $author$project$Pyxis$Components$AriaLive$render = function (_v0) {
	var text = _v0;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sr-only'),
				$author$project$Pyxis$Commons$Attributes$role('status'),
				$author$project$Pyxis$Commons$Attributes$ariaLivePolite
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(text)
			]));
};
var $author$project$Pyxis$Components$Icon$L = 2;
var $author$project$Pyxis$Components$Icon$sizeL = 2;
var $author$project$Pyxis$Components$Icon$sizeM = 1;
var $author$project$Pyxis$Components$Icon$S = 0;
var $author$project$Pyxis$Components$Icon$sizeS = 0;
var $author$project$Pyxis$Components$Icon$withSize = F2(
	function (a, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aO: a});
	});
var $author$project$Pyxis$Components$Button$applyIconSize = F3(
	function (size, ghostButton, iconOnlyButton) {
		var _v0 = _Utils_Tuple3(size, ghostButton, iconOnlyButton);
		_v0$8:
		while (true) {
			_v0$9:
			while (true) {
				_v0$10:
				while (true) {
					_v0$11:
					while (true) {
						switch (_v0.a) {
							case 0:
								if (!_v0.b) {
									if (_v0.c) {
										var _v1 = _v0.a;
										return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeL);
									} else {
										break _v0$8;
									}
								} else {
									if (_v0.c) {
										var _v5 = _v0.a;
										return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeL);
									} else {
										break _v0$8;
									}
								}
							case 1:
								if (!_v0.b) {
									if (_v0.c) {
										var _v2 = _v0.a;
										return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeL);
									} else {
										break _v0$9;
									}
								} else {
									if (_v0.c) {
										var _v6 = _v0.a;
										return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeL);
									} else {
										break _v0$9;
									}
								}
							case 2:
								if (!_v0.b) {
									if (_v0.c) {
										var _v3 = _v0.a;
										return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeS);
									} else {
										break _v0$10;
									}
								} else {
									if (_v0.c) {
										var _v7 = _v0.a;
										return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeL);
									} else {
										break _v0$10;
									}
								}
							default:
								if (!_v0.b) {
									if (_v0.c) {
										var _v4 = _v0.a;
										return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeS);
									} else {
										break _v0$11;
									}
								} else {
									if (_v0.c) {
										var _v8 = _v0.a;
										return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeM);
									} else {
										break _v0$11;
									}
								}
						}
					}
					var _v12 = _v0.a;
					return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeS);
				}
				var _v11 = _v0.a;
				return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeS);
			}
			var _v10 = _v0.a;
			return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeM);
		}
		var _v9 = _v0.a;
		return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeM);
	});
var $author$project$Pyxis$Components$Button$pickIcon = function (buttonIcon) {
	switch (buttonIcon.$) {
		case 0:
			var icon = buttonIcon.a;
			return $elm$core$Maybe$Just(icon);
		case 1:
			var icon = buttonIcon.a;
			return $elm$core$Maybe$Just(icon);
		case 2:
			var icon = buttonIcon.a;
			return $elm$core$Maybe$Just(icon);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pyxis$Components$Button$renderIcon = F4(
	function (size, ghostButton, iconOnlyButton, icon) {
		return $author$project$Pyxis$Commons$Render$renderMaybe(
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Icon$config,
					A2(
						$elm$core$Basics$composeR,
						A3($author$project$Pyxis$Components$Button$applyIconSize, size, ghostButton, iconOnlyButton),
						$author$project$Pyxis$Components$Icon$render)),
				$author$project$Pyxis$Components$Button$pickIcon(icon)));
	});
var $author$project$Pyxis$Commons$Render$renderIf = function (condition) {
	return A2($author$project$Pyxis$Commons$Render$renderIfElse, condition, $author$project$Pyxis$Commons$Render$empty);
};
var $author$project$Pyxis$Components$Button$renderTag = function (_v0) {
	var configData = _v0;
	var _v1 = configData.bk;
	if (_v1.$ === 3) {
		return $elm$html$Html$a;
	} else {
		return $elm$html$Html$button;
	}
};
var $author$project$Pyxis$Commons$Render$renderUnless = function (condition) {
	return $author$project$Pyxis$Commons$Render$renderIf(!condition);
};
var $author$project$Pyxis$Commons$Attributes$TabIndex$toInt = function (index) {
	if (!index) {
		return -1;
	} else {
		return 0;
	}
};
var $author$project$Pyxis$Commons$Attributes$TabIndex$tabIndex = A2($elm$core$Basics$composeR, $author$project$Pyxis$Commons$Attributes$TabIndex$toInt, $elm$html$Html$Attributes$tabindex);
var $elm$html$Html$Attributes$download = function (fileName) {
	return A2($elm$html$Html$Attributes$stringProperty, 'download', fileName);
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$Pyxis$Components$Button$typeToAttribute = function (type_) {
	switch (type_.$) {
		case 1:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('submit')
				]);
		case 2:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('reset')
				]);
		case 0:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button')
				]);
		default:
			if (type_.c === 1) {
				var href = type_.a;
				var _v1 = type_.c;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$href(href),
						$elm$html$Html$Attributes$download('')
					]);
			} else {
				var href = type_.a;
				var target = type_.b;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$href(href),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$target, target)
					]);
			}
	}
};
var $author$project$Pyxis$Components$Button$render = function (configuration) {
	var configData = configuration;
	return A3(
		$author$project$Pyxis$Components$Button$renderTag,
		configuration,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			configData.ej,
			A2(
				$elm$core$List$append,
				$author$project$Pyxis$Components$Button$typeToAttribute(configData.bk),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_Utils_ap(
							_List_fromArray(
								[
									_Utils_Tuple2('button', true),
									_Utils_Tuple2('button--loading', configData.bR),
									_Utils_Tuple2(
									$author$project$Pyxis$Components$Button$getButtonIconClass(configData.kf),
									true),
									_Utils_Tuple2(
									$author$project$Pyxis$Components$Button$getButtonVariantClass(configData.i_),
									true),
									_Utils_Tuple2(
									$author$project$Pyxis$Components$Button$getButtonWidthClass(configData.dR),
									true),
									_Utils_Tuple2(
									$author$project$Pyxis$Components$Button$getButtonSizeClass(configData.aO),
									true)
								]),
							configData.f6)),
						$elm$html$Html$Attributes$disabled(configData.go),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Events$onClick, configData.hJ),
						A2(
						$author$project$Pyxis$Commons$Attributes$maybe,
						A2(
							$elm$core$Basics$composeR,
							$elm$json$Json$Decode$succeed,
							$elm$html$Html$Events$on('mousedown')),
						configData.hX),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, configData.kg),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, configData.fv),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaLabelledBy, configData.fW),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaDescribedBy, configData.fR),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaLabel, configData.fV),
						A2(
						$author$project$Pyxis$Commons$Attributes$maybe,
						$author$project$Pyxis$Commons$Attributes$ariaDisabled,
						A2($author$project$Pyxis$Commons$Attributes$getAriaDisabledState, configData.fS, configData.bR)),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaControls, configData.fP),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaCurrent, configData.fQ),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaExpanded, configData.fT),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaHasPopup, configData.fU),
						A2(
						$author$project$Pyxis$Commons$Attributes$maybe,
						$author$project$Pyxis$Commons$Attributes$TabIndex$tabIndex,
						A3(
							$primait$prima_elm_extra$PrimaFunction$ifThenElse,
							configData.bR,
							$elm$core$Maybe$Just($author$project$Pyxis$Commons$Attributes$TabIndex$negative),
							configData.iF)),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$form, configData.gE)
					]))),
		_List_fromArray(
			[
				A2(
				$author$project$Pyxis$Commons$Render$renderIf,
				configData.bR,
				$author$project$Pyxis$Components$AriaLive$render(
					$author$project$Pyxis$Components$AriaLive$config(configData.hb))),
				A2(
				$author$project$Pyxis$Commons$Render$renderIf,
				$author$project$Pyxis$Components$Button$isPrepend(configData.kf) || $author$project$Pyxis$Components$Button$isStandalone(configData.kf),
				A4(
					$author$project$Pyxis$Components$Button$renderIcon,
					configData.aO,
					$author$project$Pyxis$Components$Button$isGhost(configData.i_),
					$author$project$Pyxis$Components$Button$isStandalone(configData.kf),
					configData.kf)),
				A2(
				$author$project$Pyxis$Commons$Render$renderUnless,
				$author$project$Pyxis$Components$Button$isStandalone(configData.kf),
				$elm$html$Html$text(configData.pu)),
				A2(
				$author$project$Pyxis$Commons$Render$renderIf,
				$author$project$Pyxis$Components$Button$isAppend(configData.kf),
				A4(
					$author$project$Pyxis$Components$Button$renderIcon,
					configData.aO,
					$author$project$Pyxis$Components$Button$isGhost(configData.i_),
					$author$project$Pyxis$Components$Button$isStandalone(configData.kf),
					configData.kf))
			]));
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Pyxis$Components$IconSet$User = 20;
var $author$project$Pyxis$Components$IconSet$user = 20;
var $author$project$Pyxis$Components$NavigationSidebar$renderUserAvatar = function (userAvatar) {
	if (!userAvatar.$) {
		return $author$project$Pyxis$Components$Icon$render(
			$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$user));
	} else {
		var imageReference = userAvatar.a;
		return A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src(imageReference)
				]),
			_List_Nil);
	}
};
var $author$project$Pyxis$Components$Button$sizeM = function (_v0) {
	var configuration = _v0;
	return _Utils_update(
		configuration,
		{aO: 2});
};
var $author$project$Pyxis$Components$Button$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{f6: classList});
	});
var $author$project$Pyxis$Components$Button$Standalone = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pyxis$Components$Button$withIconOnly = F2(
	function (icon, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				kf: $author$project$Pyxis$Components$Button$Standalone(icon)
			});
	});
var $author$project$Pyxis$Components$Button$withSize = function (setSize) {
	return setSize;
};
var $author$project$Pyxis$Components$NavigationSidebar$renderDropdownTrigger = F2(
	function (isSidebarExpanded, userAvatar) {
		return isSidebarExpanded ? $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withSize,
				$author$project$Pyxis$Components$Button$sizeM,
				A2(
					$author$project$Pyxis$Components$Button$withClassList,
					_List_fromArray(
						[
							_Utils_Tuple2('side-panel__footer__show-more-button', true)
						]),
					A2($author$project$Pyxis$Components$Button$withIconOnly, $author$project$Pyxis$Components$IconSet$moreVertical, $author$project$Pyxis$Components$Button$ghost)))) : A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-panel__footer__show-more-button-collapsed'),
					A2($elm$html$Html$Attributes$attribute, 'aria-expanded', 'true')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$NavigationSidebar$renderUserAvatar(userAvatar)
				]));
	});
var $author$project$Pyxis$Commons$NonEmptyList$map = function (mapper) {
	return A2(
		$elm$core$Tuple$mapBoth,
		mapper,
		$elm$core$List$map(mapper));
};
var $author$project$Pyxis$Components$NavigationSidebar$renderFooterAction = function (_v0) {
	var label = _v0.a;
	var theMsg = _v0.b;
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('side-panel__footer-dropdown__list__item'),
				$elm$html$Html$Events$onClick(theMsg)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-nav-item')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]))
			]));
};
var $author$project$Pyxis$Components$IconSet$Logout = 86;
var $author$project$Pyxis$Components$IconSet$logout = 86;
var $author$project$Pyxis$Components$NavigationSidebar$renderLogoutIcon = $author$project$Pyxis$Components$Icon$render(
	$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$logout));
var $author$project$Pyxis$Components$NavigationSidebar$renderLogoutAction = function (onLogoutAction) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('side-panel__footer-dropdown__list__item side-panel__footer-dropdown__list__item--logout'),
				$elm$html$Html$Events$onClick(onLogoutAction)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-nav-item')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Logout'),
						$author$project$Pyxis$Components$NavigationSidebar$renderLogoutIcon
					]))
			]));
};
var $author$project$Pyxis$Components$NavigationSidebar$renderFooterDropdown = F3(
	function (userInfo, onLogoutAction, actions) {
		var actionList = A2(
			$elm$core$List$append,
			$author$project$Pyxis$Commons$NonEmptyList$toList(
				A2($author$project$Pyxis$Commons$NonEmptyList$map, $author$project$Pyxis$Components$NavigationSidebar$renderFooterAction, actions)),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$NavigationSidebar$renderLogoutAction(onLogoutAction)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-panel__footer-dropdown'),
					A2($elm$html$Html$Attributes$attribute, 'data-style', 'default')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('side-panel__footer-dropdown__title')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-panel__footer__user__name text-m-bold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(userInfo.kF)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-panel__footer__user__email text-s-book')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(userInfo.eq)
								]))
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('side-panel__footer-dropdown__list')
						]),
					actionList)
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderLogoutActionButton = function (onLogout) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('side-panel__footer__logout-button'),
				$elm$html$Html$Events$onClick(onLogout)
			]),
		_List_fromArray(
			[$author$project$Pyxis$Components$NavigationSidebar$renderLogoutIcon]));
};
var $author$project$Pyxis$Components$NavigationSidebar$renderActionsOrLogout = F5(
	function (actions, userInfo, userAvatar, onLogout, isSidebarExpanded) {
		if (!actions.$) {
			var actions_ = actions.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-panel__footer__actions-wrapper')
					]),
				_List_fromArray(
					[
						A2($author$project$Pyxis$Components$NavigationSidebar$renderDropdownTrigger, isSidebarExpanded, userAvatar),
						A3($author$project$Pyxis$Components$NavigationSidebar$renderFooterDropdown, userInfo, onLogout, actions_)
					]));
		} else {
			return $author$project$Pyxis$Components$NavigationSidebar$renderLogoutActionButton(onLogout);
		}
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderFooter = F2(
	function (isSidebarExpanded, _v0) {
		var actions = _v0.ay;
		var userAvatar = _v0.iX;
		var userInfo = _v0.l_;
		var onLogout = _v0.kU;
		var id = _v0.kg;
		var classList = _v0.f6;
		var testId = _v0.fv;
		var dataAttrList = _v0.ej;
		return A2(
			$elm$html$Html$div,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-panel__footer-wrapper'),
						$elm$html$Html$Attributes$classList(classList),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('side-panel__footer')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('avatar side-panel__footer__avatar')
								]),
							_List_fromArray(
								[
									$author$project$Pyxis$Components$NavigationSidebar$renderUserAvatar(userAvatar)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-panel__footer__user')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('side-panel__footer__user__name text-m-bold')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(userInfo.kF)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('side-panel__footer__user__email text-s-book')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(userInfo.eq)
										]))
								])),
							A5($author$project$Pyxis$Components$NavigationSidebar$renderActionsOrLogout, actions, userInfo, userAvatar, onLogout, isSidebarExpanded)
						]))
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$ToggleExpand = {$: 0};
var $author$project$Pyxis$Components$Logos$PrimaLogo$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Logos$PrimaLogo$Default = 0;
var $author$project$Pyxis$Components$Logos$PrimaLogo$Logotype = 0;
var $author$project$Pyxis$Components$Logos$PrimaLogo$config = {dU: $elm$core$Maybe$Nothing, f6: _List_Nil, ea: 0, ej: _List_Nil, kg: $elm$core$Maybe$Nothing, fv: $elm$core$Maybe$Nothing, i_: 0, dR: $elm$core$Maybe$Nothing};
var $author$project$Pyxis$Components$Logos$PrimaLogo$Monogram = 1;
var $author$project$Pyxis$Components$Logos$PrimaLogo$monogramVariant = 1;
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $author$project$Pyxis$Components$Logos$SvgBuilder$fromClassListToString = function (classList) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			A2(
				$elm$core$List$filter,
				$elm$core$Tuple$second,
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
					classList))));
};
var $elm$svg$Svg$title = $elm$svg$Svg$trustedNode('title');
var $author$project$Pyxis$Components$Logos$SvgBuilder$svgTitle = F2(
	function (accessibilityLabel, id) {
		return A2(
			$elm$svg$Svg$title,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(id)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(accessibilityLabel)
				]));
	});
var $author$project$Pyxis$Components$Logos$SvgBuilder$getSvgTitle = F2(
	function (accessibilityLabel, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Pyxis$Commons$Render$empty,
			A3($elm$core$Maybe$map2, $author$project$Pyxis$Components$Logos$SvgBuilder$svgTitle, accessibilityLabel, id));
	});
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $author$project$Pyxis$Components$Logos$SvgBuilder$getViewBox = function (nodes) {
	if (nodes.b && (!nodes.a.$)) {
		var attributes = nodes.a.a.mm;
		return A2(
			$elm$core$List$filterMap,
			function (attr) {
				return (attr.a === 'viewBox') ? $elm$core$Maybe$Just(
					$elm$svg$Svg$Attributes$viewBox(attr.b)) : $elm$core$Maybe$Nothing;
			},
			attributes);
	} else {
		return _List_Nil;
	}
};
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $author$project$Pyxis$Components$Logos$SvgBuilder$buildSvg = F3(
	function (_v0, svgAttr, nodes) {
		var dataAttrList = _v0.ej;
		var accessibilityLabel = _v0.dU;
		var id = _v0.kg;
		var testId = _v0.fv;
		var classList = _v0.f6;
		var titleId = A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append('title-'),
			id);
		var titleElement = A2($author$project$Pyxis$Components$Logos$SvgBuilder$getSvgTitle, accessibilityLabel, titleId);
		if (nodes.b && (!nodes.a.$)) {
			var payload = nodes.a.a;
			return A2(
				$elm$svg$Svg$svg,
				A2(
					$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
					dataAttrList,
					A2(
						$elm$core$List$append,
						$author$project$Pyxis$Components$Logos$SvgBuilder$getViewBox(nodes),
						A2(
							$elm$core$List$append,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class(
									$author$project$Pyxis$Components$Logos$SvgBuilder$fromClassListToString(classList)),
									A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$svg$Svg$Attributes$id, id),
									A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
									$author$project$Pyxis$Commons$Attributes$ariaHidden(
									$elm_community$maybe_extra$Maybe$Extra$isNothing(accessibilityLabel)),
									A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaLabelledBy, titleId),
									A2(
									$author$project$Pyxis$Commons$Attributes$renderIf,
									$elm_community$maybe_extra$Maybe$Extra$isJust(accessibilityLabel) && $elm_community$maybe_extra$Maybe$Extra$isJust(id),
									$author$project$Pyxis$Commons$Attributes$role('img'))
								]),
							svgAttr))),
				A2(
					$elm$core$List$cons,
					titleElement,
					A2($elm$core$List$map, $Garados007$elm_svg_parser$SvgParser$nodeToSvg, payload.ae)));
		} else {
			return $author$project$Pyxis$Commons$Render$empty;
		}
	});
var $author$project$Pyxis$Components$Logos$PrimaLogo$Pride = 1;
var $author$project$Pyxis$Components$Logos$PrimaLogo$getClassList = function (_v0) {
	var classList = _v0.f6;
	var color = _v0.ea;
	var variant = _v0.i_;
	return _Utils_ap(
		_List_fromArray(
			[
				_Utils_Tuple2('logo--pride', color === 1),
				_Utils_Tuple2('logo-prima--monogram', variant === 1),
				_Utils_Tuple2('logo-prima--logotype', !variant)
			]),
		classList);
};
var $author$project$Pyxis$Components$Logos$PrimaLogo$getSizeAttributesSingleton = function (attribute) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(attribute),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault($author$project$Pyxis$Commons$Attributes$none),
			$elm$core$List$singleton));
};
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $author$project$Pyxis$Components$Logos$SvgBuilder$svgSizeFormatter = function (size) {
	return (!_Utils_eq(
		$elm$core$String$toFloat(size),
		$elm$core$Maybe$Nothing)) ? ('--logo-size: ' + (size + 'px')) : ('--logo-size: ' + size);
};
var $author$project$Pyxis$Components$Logos$PrimaLogo$buildSvg = F2(
	function (configuration, nodes) {
		var width = configuration.dR;
		var id = configuration.kg;
		var dataAttrList = configuration.ej;
		var testId = configuration.fv;
		var accessibilityLabel = configuration.dU;
		var sizeAttributes = A2(
			$author$project$Pyxis$Components$Logos$PrimaLogo$getSizeAttributesSingleton,
			$elm$svg$Svg$Attributes$style,
			A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Logos$SvgBuilder$svgSizeFormatter, width));
		return A3(
			$author$project$Pyxis$Components$Logos$SvgBuilder$buildSvg,
			{
				dU: accessibilityLabel,
				f6: $author$project$Pyxis$Components$Logos$PrimaLogo$getClassList(configuration),
				ej: dataAttrList,
				kg: id,
				fv: testId
			},
			sizeAttributes,
			nodes);
	});
var $author$project$Pyxis$Components$Logos$LogoSet$Prima = 5;
var $author$project$Pyxis$Components$Logos$LogoSet$prima = 5;
var $author$project$Pyxis$Components$Logos$LogoSet$PrimaMonogram = 6;
var $author$project$Pyxis$Components$Logos$LogoSet$primaMonogram = 6;
var $author$project$Pyxis$Components$Logos$LogoSet$svgAmericanExpress = '<svg width=\"70\" height=\"48\" viewBox=\"0 0 70 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_1807_15268)\">\n<rect width=\"70\" height=\"48\" rx=\"8\" fill=\"#0071CE\"/>\n<rect x=\"33\" y=\"7\" width=\"40\" height=\"35\" fill=\"white\"/>\n<path d=\"M64.314 41.05L61.2969 37.6848L58.1638 41.05H52.0137H38.785V25.3845H32.6348L40.2935 7.86232H47.7201L50.3891 13.8964V7.86232H59.6724L61.2969 12.3879L62.9215 7.86232H70V5.19338C70 3.56881 68.7235 2.29236 67.099 2.29236H4.90105C3.27648 2.29236 2.00003 3.56881 2.00003 5.19338V42.9067C2.00003 44.5312 3.27648 45.8077 4.90105 45.8077H67.099C68.7235 45.8077 70 44.5312 70 42.9067V41.05H64.314Z\" fill=\"#0071CE\"/>\n<path d=\"M65.1263 39.1934H70L63.6177 32.3469L70 25.6166H65.2423L61.1809 30.0261L57.2355 25.6166H52.3618L58.8601 32.463L52.3618 39.1934H57.1195L61.1809 34.7838L65.1263 39.1934Z\" fill=\"#0071CE\"/>\n<path d=\"M44.587 36.0603V33.9715H52.2457V30.8384H44.587V28.7497H52.3618V25.6166H40.8737V39.1934H52.3618V36.0603H44.587Z\" fill=\"#0071CE\"/>\n<path d=\"M66.4027 23.6439H69.8839V9.95105L64.314 10.0671L61.2969 18.5381L58.1638 10.0671H52.3618V23.6439H56.0751V14.1285L59.5563 23.6439H62.8055L66.4027 14.1285V23.6439Z\" fill=\"#0071CE\"/>\n<path d=\"M46.4437 10.067H41.686L35.6519 23.6438H39.7133L40.8737 20.9749H47.1399L48.3003 23.6438H52.4778L46.4437 10.067ZM42.1502 17.8418L44.0068 13.4322L45.8635 17.8418H42.1502Z\" fill=\"#0071CE\"/>\n<path d=\"M66.6348 31.9988L70 35.7121V28.2855L66.6348 31.9988Z\" fill=\"#0071CE\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_1807_15268\">\n<rect width=\"70\" height=\"48\" rx=\"8\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>\n';
var $author$project$Pyxis$Components$Logos$LogoSet$svgApplePay = '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"70\" height=\"48\" viewBox=\"0 0 70 48\" fill=\"none\">\n  <rect x=\"0.5\" y=\"0.5\" width=\"69\" height=\"47\" rx=\"7.5\" fill=\"white\" stroke=\"#DDDEE1\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.6924 17.8659C17.6325 17.9452 18.5726 17.3901 19.1601 16.6863C19.7379 15.9627 20.1198 14.9913 20.0219 14C19.1895 14.0397 18.1613 14.5551 17.5737 15.2787C17.0352 15.9032 16.5749 16.9143 16.6924 17.8659ZM27.8755 30.6333V15.1796H33.6041C36.5615 15.1796 38.6277 17.2414 38.6277 20.2548C38.6277 23.2683 36.5223 25.3499 33.5258 25.3499H30.2453V30.6333H27.8755ZM20.012 18.0542C19.1838 18.006 18.4281 18.3064 17.8177 18.549C17.4249 18.7051 17.0923 18.8373 16.8392 18.8373C16.5552 18.8373 16.2089 18.6981 15.82 18.5417L15.82 18.5417L15.82 18.5417L15.82 18.5417C15.3104 18.3368 14.7278 18.1025 14.1169 18.1137C12.7166 18.1335 11.4142 18.9365 10.6993 20.2152C9.23044 22.7726 10.3174 26.5593 11.7373 28.6409C12.4326 29.6718 13.265 30.8018 14.3617 30.7622C14.8442 30.7438 15.1913 30.5947 15.5505 30.4404C15.9641 30.2628 16.3937 30.0782 17.0645 30.0782C17.712 30.0782 18.1228 30.2579 18.5172 30.4305C18.8921 30.5945 19.2522 30.752 19.7868 30.7424C20.9227 30.7225 21.6376 29.7115 22.3328 28.6806C23.0831 27.5741 23.4129 26.4943 23.4629 26.3304L23.4688 26.3114C23.4676 26.3102 23.4583 26.3059 23.4419 26.2984C23.1911 26.1821 21.274 25.2937 21.2557 22.9114C21.2372 20.9118 22.7762 19.8987 23.0185 19.7392C23.0332 19.7295 23.0432 19.723 23.0477 19.7196C22.0684 18.2525 20.5408 18.0939 20.012 18.0542ZM42.9561 30.7523C44.4445 30.7523 45.8253 29.989 46.452 28.7797H46.501V30.6333H48.6945V22.9412C48.6945 20.7108 46.9318 19.2735 44.2193 19.2735C41.7026 19.2735 39.842 20.7307 39.7735 22.733H41.9083C42.0845 21.7814 42.9561 21.1569 44.1508 21.1569C45.6 21.1569 46.4128 21.8409 46.4128 23.0998V23.9522L43.4555 24.1307C40.7038 24.2992 39.2153 25.4391 39.2153 27.4217C39.2153 29.424 40.7527 30.7523 42.9561 30.7523ZM43.5924 28.9185C42.3292 28.9185 41.5262 28.3039 41.5262 27.3622C41.5262 26.3908 42.2998 25.8257 43.7785 25.7365L46.4127 25.568V26.4403C46.4127 27.8876 45.1984 28.9185 43.5924 28.9185ZM55.9702 31.238C55.0204 33.9442 53.9334 34.8363 51.6224 34.8363C51.4461 34.8363 50.8585 34.8165 50.7214 34.7768V32.9232C50.8683 32.943 51.2307 32.9628 51.4167 32.9628C52.4645 32.9628 53.0521 32.5167 53.4144 31.357L53.6298 30.673L49.6149 19.4222H52.0924L54.8833 28.5517H54.9322L57.7231 19.4222H60.1321L55.9702 31.238ZM30.2451 17.2018H32.9772C35.0336 17.2018 36.2087 18.312 36.2087 20.2648C36.2087 22.2175 35.0336 23.3377 32.9674 23.3377H30.2451V17.2018Z\" fill=\"black\"/>\n</svg>';
var $author$project$Pyxis$Components$Logos$LogoSet$svgGooglePay = '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"70\" height=\"48\" viewBox=\"0 0 70 48\" fill=\"none\">\n  <rect x=\"0.5\" y=\"0.5\" width=\"69\" height=\"47\" rx=\"7.5\" fill=\"white\" stroke=\"#DDDEE1\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M33.0603 31.5161V25.4741H36.1786C37.4564 25.4741 38.535 25.046 39.4142 24.2015L39.6252 23.9875C41.2313 22.2391 41.1258 19.5155 39.4142 17.898C38.5584 17.0416 37.3861 16.5778 36.1786 16.6016H31.1728V31.5161H33.0603ZM33.0605 23.6425V18.4332H36.2262C36.9063 18.4332 37.5511 18.6948 38.0319 19.1706C39.0519 20.1696 39.0754 21.8347 38.0905 22.8694C37.6098 23.3809 36.9297 23.6663 36.2262 23.6425H33.0605ZM48.4293 22.1083C47.6204 21.359 46.5184 20.9784 45.1234 20.9784C43.3298 20.9784 41.9816 21.6444 41.0906 22.9646L42.7553 24.0231C43.3649 23.1192 44.1973 22.6673 45.2523 22.6673C45.9206 22.6673 46.5653 22.9171 47.0694 23.369C47.5618 23.7972 47.8431 24.4156 47.8431 25.0698V25.5098C47.1163 25.1055 46.2019 24.8914 45.0765 24.8914C43.7635 24.8914 42.7084 25.2006 41.923 25.831C41.1375 26.4613 40.7389 27.2939 40.7389 28.3524C40.7155 29.3158 41.1258 30.2316 41.8526 30.85C42.5912 31.5161 43.529 31.8491 44.631 31.8491C45.9323 31.8491 46.9639 31.2663 47.7494 30.1007H47.8314V31.5161H49.6368V25.2244C49.6368 23.9042 49.2382 22.8576 48.4293 22.1083ZM43.3066 29.6369C42.9197 29.3514 42.6852 28.8876 42.6852 28.3881C42.6852 27.8291 42.9432 27.3652 43.4473 26.9965C43.9632 26.6278 44.6081 26.4375 45.3702 26.4375C46.4255 26.4256 47.2462 26.6635 47.8325 27.1392C47.8325 27.948 47.5159 28.6497 46.8945 29.2444C46.3317 29.8153 45.5696 30.1364 44.7723 30.1364C44.2446 30.1483 43.7287 29.9699 43.3066 29.6369ZM53.693 35.9999L60.0001 21.3114H57.9485L55.0295 28.6378H54.9943L52.0049 21.3114H49.9533L54.0916 30.8619L51.747 35.9999H53.693Z\" fill=\"#3C4043\"/>\n  <path d=\"M26.5442 24.1659C26.5442 23.5831 26.4973 23.0003 26.4035 22.4294H18.4435V25.7239H23.0038C22.8162 26.7825 22.2066 27.734 21.3157 28.3286V30.4695H24.0355C25.6298 28.9828 26.5442 26.7825 26.5442 24.1659Z\" fill=\"#4285F4\"/>\n  <path d=\"M18.4439 32.539C20.7182 32.539 22.6408 31.7778 24.0358 30.4695L21.3161 28.3287C20.5541 28.852 19.581 29.1493 18.4439 29.1493C16.2399 29.1493 14.376 27.6388 13.7078 25.6169H10.9059V27.8291C12.3361 30.7193 15.2552 32.539 18.4439 32.539Z\" fill=\"#34A853\"/>\n  <path d=\"M13.7081 25.6169C13.3563 24.5584 13.3563 23.4048 13.7081 22.3343V20.134H10.9058C9.69811 22.5484 9.69811 25.4029 10.9058 27.8172L13.7081 25.6169Z\" fill=\"#FBBC04\"/>\n  <path d=\"M18.4439 18.8019C19.6514 18.7781 20.812 19.242 21.6795 20.0864L24.0944 17.6363C22.5587 16.1853 20.5423 15.3885 18.4439 15.4123C15.2552 15.4123 12.3361 17.2439 10.9059 20.134L13.7078 22.3462C14.376 20.3124 16.2399 18.8019 18.4439 18.8019Z\" fill=\"#EA4335\"/>\n</svg>';
var $author$project$Pyxis$Components$Logos$LogoSet$svgMaestro = '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"70\" height=\"48\" viewBox=\"0 0 70 48\" fill=\"none\">\n  <rect x=\"0.5\" y=\"0.5\" width=\"69\" height=\"47\" rx=\"7.5\" fill=\"white\" stroke=\"#DDDEE1\"/>\n  <path d=\"M40.976 13.1295H28.8967V34.8365H40.976V13.1295Z\" fill=\"#7375CF\"/>\n  <path d=\"M29.6635 23.983C29.6616 21.8924 30.1353 19.8289 31.0488 17.9485C31.9623 16.0681 33.2917 14.4202 34.9362 13.1295C32.8997 11.5287 30.4539 10.5333 27.8783 10.2568C25.3028 9.98039 22.7014 10.4341 20.3716 11.5663C18.0418 12.6984 16.0774 14.4631 14.7032 16.6589C13.3289 18.8546 12.6001 21.3926 12.6001 23.983C12.6001 26.5733 13.3289 29.1114 14.7032 31.3071C16.0774 33.5028 18.0418 35.2676 20.3716 36.3997C22.7014 37.5318 25.3028 37.9856 27.8783 37.7091C30.4539 37.4327 32.8997 36.4372 34.9362 34.8365C33.2917 33.5458 31.9623 31.8979 31.0488 30.0175C30.1353 28.1371 29.6616 26.0735 29.6635 23.983Z\" fill=\"#EB001B\"/>\n  <path d=\"M57.2718 23.983C57.2719 26.5733 56.5432 29.1113 55.169 31.3071C53.7948 33.5028 51.8305 35.2675 49.5007 36.3997C47.1709 37.5318 44.5696 37.9856 41.9941 37.7091C39.4186 37.4327 36.9728 36.4372 34.9364 34.8365C36.5795 33.5445 37.9078 31.8963 38.8211 30.0162C39.7345 28.1361 40.2091 26.0732 40.2091 23.983C40.2091 21.8928 39.7345 19.8298 38.8211 17.9497C37.9078 16.0697 36.5795 14.4215 34.9364 13.1295C36.9728 11.5287 39.4186 10.5333 41.9941 10.2568C44.5696 9.98039 47.1709 10.4342 49.5007 11.5663C51.8305 12.6984 53.7948 14.4632 55.169 16.6589C56.5432 18.8546 57.2719 21.3927 57.2718 23.983Z\" fill=\"#00A2E5\"/>\n</svg>';
var $author$project$Pyxis$Components$Logos$LogoSet$svgMastercard = '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"70\" height=\"48\" viewBox=\"0 0 70 48\" fill=\"none\">\n<rect x=\"0.5\" y=\"0.5\" width=\"69\" height=\"47\" rx=\"7.5\" fill=\"white\" stroke=\"#DDDEE1\"/>\n<path d=\"M40.9746 12.9546H28.9008V34.6491H40.9746V12.9546Z\" fill=\"#FF5F00\"/>\n<path d=\"M29.6673 23.8018C29.6673 19.5856 31.6221 15.561 34.9185 12.9546C28.9391 8.24003 20.2383 9.27493 15.5238 15.2927C10.8476 21.2721 11.8825 29.9345 17.9002 34.649C22.9213 38.597 29.9356 38.597 34.9568 34.649C31.6221 32.0426 29.6673 28.018 29.6673 23.8018Z\" fill=\"#EB001B\"/>\n<path d=\"M57.2646 23.8018C57.2646 31.4294 51.0935 37.6004 43.466 37.6004C40.3613 37.6004 37.3716 36.5655 34.9568 34.649C40.9362 29.9345 41.9711 21.2721 37.2566 15.2543C36.5667 14.4111 35.8001 13.6062 34.9568 12.9546C40.9362 8.24003 49.637 9.27493 54.3132 15.2927C56.2297 17.7074 57.2646 20.6971 57.2646 23.8018Z\" fill=\"#F79E1B\"/>\n</svg>';
var $author$project$Pyxis$Components$Logos$LogoSet$svgPaypal = '<svg width=\"70\" height=\"48\" viewBox=\"0 0 70 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect x=\"0.5\" y=\"0.5\" width=\"69\" height=\"47\" rx=\"7.5\" fill=\"white\" stroke=\"#DDDEE1\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.8 30.4819H16.6888C16.4759 30.4819 16.2948 30.6367 16.2616 30.8468L15.0033 38.8249C14.9783 38.9824 15.1002 39.1243 15.2599 39.1243H16.7452C16.9581 39.1243 17.1392 38.9695 17.1724 38.759L17.5118 36.6072C17.5445 36.3965 17.726 36.2419 17.9385 36.2419H18.9234C20.9729 36.2419 22.1556 35.2502 22.4647 33.2849C22.6038 32.4251 22.4705 31.7495 22.0678 31.2762C21.6257 30.7569 20.8413 30.4819 19.8 30.4819ZM20.159 33.3958C19.9889 34.5123 19.1358 34.5123 18.3111 34.5123H17.8416L18.1709 32.4272C18.1905 32.3013 18.2997 32.2085 18.4271 32.2085H18.6422C19.2041 32.2085 19.7341 32.2085 20.008 32.5287C20.1712 32.7198 20.2213 33.0036 20.159 33.3958ZM29.1002 33.36H27.6103C27.4834 33.36 27.3737 33.4529 27.3541 33.579L27.2882 33.9956L27.184 33.8447C26.8615 33.3765 26.1423 33.22 25.4244 33.22C23.7779 33.22 22.3718 34.467 22.0979 36.2163C21.9556 37.0887 22.1579 37.923 22.6529 38.5049C23.107 39.0398 23.7567 39.2628 24.5295 39.2628C25.856 39.2628 26.5918 38.4097 26.5918 38.4097L26.5253 38.8238C26.5002 38.9822 26.6221 39.1241 26.7809 39.1241H28.123C28.3365 39.1241 28.5165 38.9693 28.5501 38.7588L29.3554 33.6594C29.3809 33.5026 29.2594 33.36 29.1002 33.36ZM27.0234 36.2598C26.8796 37.111 26.204 37.6824 25.3426 37.6824C24.9099 37.6824 24.564 37.5436 24.3421 37.2807C24.1219 37.0196 24.0381 36.6478 24.1082 36.2339C24.2425 35.3899 24.9295 34.8 25.7779 34.8C26.2009 34.8 26.5449 34.9405 26.7714 35.2057C26.9983 35.4737 27.0885 35.8476 27.0234 36.2598ZM35.5379 33.3598H37.0352C37.2449 33.3598 37.3672 33.595 37.2481 33.767L32.2685 40.9548C32.1878 41.0712 32.055 41.1405 31.9131 41.1405H30.4177C30.2072 41.1405 30.0842 40.9034 30.2061 40.731L31.7567 38.5424L30.1076 33.7028C30.0506 33.5346 30.1748 33.3598 30.3537 33.3598H31.8249C32.016 33.3598 32.1847 33.4853 32.2398 33.6683L33.115 36.5912L35.1801 33.5495C35.2609 33.4308 35.3952 33.3598 35.5379 33.3598Z\" fill=\"#253B80\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M51.7709 38.8248L53.0478 30.7008C53.0673 30.5747 53.1766 30.4819 53.3035 30.4814H54.741C54.8998 30.4814 55.0217 30.6238 54.9966 30.7812L53.7374 38.7589C53.7046 38.9695 53.5235 39.1242 53.3103 39.1242H52.0265C51.8677 39.1242 51.7459 38.9823 51.7709 38.8248ZM41.9921 30.4819H38.8803C38.6679 30.4819 38.4869 30.6366 38.4536 30.8467L37.1953 38.8248C37.1702 38.9823 37.2921 39.1242 37.4511 39.1242H39.0477C39.1961 39.1242 39.3231 39.016 39.3462 38.8686L39.7033 36.6071C39.7361 36.3964 39.9176 36.2419 40.13 36.2419H41.1145C43.1644 36.2419 44.3469 35.2501 44.6562 33.2848C44.7957 32.425 44.6616 31.7494 44.2591 31.2762C43.8172 30.7568 43.0334 30.4819 41.9921 30.4819ZM42.3511 33.3958C42.1814 34.5122 41.3284 34.5122 40.5031 34.5122H40.034L40.3639 32.4271C40.3835 32.3012 40.4917 32.2084 40.6195 32.2084H40.8347C41.3961 32.2084 41.9267 32.2084 42.2004 32.5286C42.3637 32.7198 42.4134 33.0036 42.3511 33.3958ZM51.2915 33.36H49.8027C49.6747 33.36 49.5661 33.4528 49.5469 33.5789L49.481 33.9956L49.3764 33.8446C49.0538 33.3764 48.3351 33.22 47.6172 33.22C45.9707 33.22 44.565 34.4669 44.2911 36.2162C44.1492 37.0886 44.3507 37.9229 44.8456 38.5048C45.3006 39.0398 45.9494 39.2627 46.7223 39.2627C48.0488 39.2627 48.7844 38.4097 48.7844 38.4097L48.7181 38.8238C48.693 38.9821 48.8149 39.124 48.9747 39.124H50.3162C50.5286 39.124 50.7096 38.9693 50.7429 38.7587L51.5486 33.6593C51.5732 33.5025 51.4513 33.36 51.2915 33.36ZM49.2149 36.2598C49.072 37.1109 48.3955 37.6823 47.5338 37.6823C47.1021 37.6823 46.7555 37.5436 46.5334 37.2806C46.3132 37.0196 46.2305 36.6478 46.2997 36.2339C46.4347 35.3899 47.1208 34.8 47.9692 34.8C48.3924 34.8 48.7362 34.9404 48.9629 35.2057C49.1907 35.4737 49.2808 35.8476 49.2149 36.2598Z\" fill=\"#179BD7\"/>\n<path d=\"M31.314 27.6277L31.6966 25.1983L30.8446 25.1785H26.7761L29.6035 7.25081C29.6121 7.19668 29.6408 7.14622 29.6824 7.11039C29.7241 7.07456 29.7776 7.05481 29.8332 7.05481H36.6932C38.9707 7.05481 40.5423 7.52873 41.3629 8.46412C41.7475 8.90294 41.9926 9.36149 42.1111 9.86612C42.2353 10.3956 42.2376 11.0282 42.1162 11.7998L42.1073 11.8561V12.3505L42.4922 12.5685C42.8162 12.7403 43.0734 12.9371 43.2709 13.1623C43.6002 13.5375 43.813 14.0144 43.9029 14.5797C43.9957 15.1611 43.965 15.853 43.813 16.6363C43.6374 17.5373 43.3536 18.322 42.9705 18.9642C42.6178 19.5558 42.1688 20.0465 41.6357 20.4269C41.1267 20.7881 40.5218 21.0625 39.838 21.238C39.1753 21.4105 38.4199 21.4976 37.5913 21.4976H37.0574C36.6757 21.4976 36.3048 21.6351 36.0138 21.8816C35.722 22.1332 35.5288 22.4768 35.4696 22.8528L35.4294 23.0715L34.7536 27.3534L34.7229 27.5107C34.7149 27.5606 34.701 27.5854 34.6806 27.6023C34.6622 27.6174 34.6359 27.6277 34.6102 27.6277H31.314Z\" fill=\"#253B80\"/>\n<path d=\"M42.8564 11.9135C42.836 12.0444 42.8126 12.1782 42.7863 12.3157C41.8814 16.9605 38.7865 18.5651 34.8334 18.5651H32.8208C32.3374 18.5651 31.93 18.9161 31.8547 19.393L30.8241 25.9284L30.5323 27.7809C30.4833 28.0939 30.7248 28.3762 31.0406 28.3762H34.6105C35.0332 28.3762 35.3922 28.0691 35.4587 27.6522L35.4938 27.4707L36.166 23.2055L36.2092 22.9716C36.2749 22.5533 36.6347 22.2461 37.0574 22.2461H37.5913C41.0498 22.2461 43.7574 20.8419 44.5488 16.7784C44.8793 15.0809 44.7082 13.6636 43.8334 12.6667C43.5688 12.3661 43.2404 12.1168 42.8564 11.9135Z\" fill=\"#179BD7\"/>\n<path d=\"M41.9096 11.5364C41.7715 11.4962 41.6288 11.4596 41.4825 11.4267C41.3355 11.3945 41.1848 11.366 41.0298 11.3411C40.4871 11.2534 39.8926 11.2117 39.2555 11.2117H33.8787C33.7463 11.2117 33.6206 11.2416 33.5079 11.2958C33.2599 11.415 33.0757 11.6498 33.0311 11.9372L31.8871 19.182L31.8542 19.3933C31.9296 18.9165 32.337 18.5654 32.8204 18.5654H34.833C38.7861 18.5654 41.8812 16.9601 42.7859 12.316C42.8128 12.1785 42.8355 12.0447 42.856 11.9138C42.6271 11.7924 42.3791 11.6885 42.1122 11.6C42.0465 11.5781 41.9785 11.5569 41.9096 11.5364Z\" fill=\"#222D65\"/>\n<path d=\"M33.0311 11.937C33.0758 11.6495 33.2602 11.4148 33.508 11.2963C33.6215 11.2422 33.7465 11.2122 33.8787 11.2122H39.2558C39.8928 11.2122 40.4874 11.2539 41.0299 11.3416C41.185 11.3665 41.3358 11.395 41.4827 11.4272C41.629 11.4601 41.7716 11.4967 41.9099 11.5369C41.9785 11.5574 42.0465 11.5786 42.1131 11.5998C42.38 11.6883 42.628 11.7929 42.8568 11.9136C43.1261 10.1971 42.8547 9.02837 41.9267 7.97009C40.9036 6.80505 39.0568 6.30627 36.6939 6.30627H29.8337C29.3509 6.30627 28.9393 6.65731 28.8646 7.13489L26.0073 25.2468C25.9509 25.6052 26.2273 25.9285 26.5886 25.9285H30.824L31.8873 19.1817L33.0311 11.937Z\" fill=\"#253B80\"/>\n</svg>\n';
var $author$project$Pyxis$Components$Logos$LogoSet$svgPostepay = '<svg width=\"70\" height=\"48\" viewBox=\"0 0 70 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_425_552)\">\n<rect x=\"0.0645142\" width=\"70\" height=\"48\" rx=\"8\" fill=\"#FBE200\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.72988 19.8972C9.72858 19.8976 9.72729 19.8981 9.72599 19.8987V20.67C9.53342 20.724 9.33708 20.8344 9.14456 20.9448C8.78019 21.1938 8.47397 21.5502 8.25301 21.9948C8.00106 22.4354 7.80723 22.9605 7.66769 23.5391C7.52813 24.1447 7.50101 24.616 7.52813 25.0031C7.55528 25.4438 7.72196 25.7772 8.00106 26.0531C8.28014 26.3022 8.64452 26.4402 9.09029 26.4402C9.31217 26.4402 9.53029 26.414 9.72599 26.3581V27.4597H9.4818C8.95075 27.4597 8.53211 27.3485 8.1406 27.1568C7.77623 26.9652 7.44286 26.6587 7.16377 26.2754L6.27222 30.1116H4.7876V30.1077L6.71412 21.7456C6.74126 21.5809 6.76936 21.4219 6.79747 21.2629C6.82557 21.1038 6.85367 20.9448 6.8808 20.7799C6.90793 20.4504 6.93507 20.1438 6.96607 19.8142H8.30728L8.19487 20.9448C8.61351 20.5309 9.03214 20.2013 9.4508 20.0059C9.52746 19.9576 9.62295 19.928 9.70342 19.9029C9.71244 19.9001 9.72129 19.8975 9.72988 19.8947V19.8972ZM9.73377 27.459V26.356C9.73118 26.3567 9.72858 26.3574 9.72599 26.3581V26.3561C9.9198 26.3024 10.1175 26.2182 10.2842 26.1338C10.6486 25.9116 10.9548 25.5819 11.2067 25.1413C11.4587 24.7006 11.6525 24.2291 11.7921 23.7079C11.9316 23.183 11.9587 22.6886 11.9316 22.2173C11.8773 21.719 11.7068 21.3358 11.4277 21.0292C11.1215 20.7265 10.73 20.5885 10.2842 20.5885C10.0904 20.5885 9.89268 20.6153 9.72599 20.6728V20.67C9.72729 20.6695 9.72859 20.6692 9.72988 20.6689V19.8972C10.0624 19.7603 10.4523 19.707 10.8152 19.707C11.5401 19.707 12.1564 19.9294 12.6022 20.3701C13.0751 20.8107 13.3271 21.447 13.4124 22.2173C13.4666 22.7691 13.4124 23.3745 13.2457 24.0108C13.1061 24.6469 12.8813 25.1987 12.5751 25.6663C12.2417 26.2449 11.7921 26.6856 11.2339 26.9922C10.7902 27.2669 10.2889 27.4048 9.73377 27.459ZM9.73377 27.459L9.72757 27.4597C9.72963 27.4593 9.73169 27.4592 9.73377 27.459Z\" fill=\"#004A99\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M45.1236 21.0468C45.2643 21.0236 45.3894 21.0031 45.5353 21.0031C45.8996 21.0031 46.1788 21.1141 46.3959 21.3287C46.5936 21.5243 46.7331 21.827 46.7602 22.2409C46.7873 22.5973 46.7602 23.0112 46.6478 23.5093C46.5393 24.0076 46.3688 24.4751 46.1749 24.8889C45.9772 25.276 45.7833 25.552 45.5314 25.7435C45.3919 25.8547 45.2251 25.9391 45.0585 25.9658V25.9747C44.9512 26.0012 44.8401 26.0273 44.729 26.0273C44.3375 26.0273 44.0313 25.8894 43.8065 25.6402C43.5544 25.3912 43.442 25.0309 43.3878 24.5635C43.3064 23.6513 43.4731 22.8236 43.9189 22.0802C44.225 21.559 44.6166 21.1987 45.0624 21.0607V19.9877C44.729 20.1794 44.4189 20.4284 44.0855 20.7312L44.1399 19.8191H42.0466C41.9924 20.3173 41.8528 21.0914 41.6279 22.1108L39.8409 30.1126H42.159L43.0506 26.1653C43.2754 26.5792 43.5817 26.9125 43.9731 27.1042C44.2794 27.269 44.6437 27.3801 45.0624 27.4069V27.3992C45.1041 27.3995 45.1511 27.406 45.1981 27.4125C45.2465 27.4192 45.295 27.426 45.3376 27.426C46.5083 27.426 47.4579 26.9048 48.1556 25.8547C48.8806 24.8354 49.1596 23.5668 49.0201 22.0761C48.9659 21.2752 48.7138 20.6696 48.2953 20.2557C47.8766 19.8418 47.2913 19.6196 46.5664 19.6196C46.0935 19.6196 45.6477 19.7039 45.2563 19.8956C45.2019 19.9262 45.1477 19.953 45.0624 19.9798V21.0567C45.0832 21.0534 45.1036 21.05 45.1236 21.0468ZM45.0624 27.3992V25.9737C45.0612 25.9741 45.0598 25.9744 45.0585 25.9747V27.399C45.0598 27.399 45.061 27.3992 45.0624 27.3992Z\" fill=\"#004A99\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M54.2416 23.7349C54.1874 23.7079 54.1291 23.7079 54.075 23.7079H53.8229C53.4585 23.7079 53.1252 23.7349 52.8462 23.8191V22.6042C53.1523 22.5774 53.5168 22.5774 53.8772 22.5774H54.2687H54.5207C54.5368 22.4952 54.5534 22.4206 54.5686 22.3518C54.6044 22.1896 54.6331 22.0597 54.6331 21.9414C54.6602 21.8034 54.6602 21.6922 54.6602 21.581C54.6332 21.3589 54.5478 21.1939 54.3811 21.0829C54.2416 20.9718 54.0167 20.918 53.7377 20.918C53.4043 20.918 53.1523 21.0024 52.9857 21.1404C52.9717 21.1542 52.9576 21.1662 52.9439 21.1783C52.9036 21.213 52.8663 21.2452 52.8462 21.3051V19.7608C53.1252 19.707 53.4314 19.707 53.7377 19.707C54.7144 19.707 55.4394 19.845 55.9705 20.1746C56.4743 20.5041 56.7534 20.9756 56.8077 21.6078C56.8348 21.7995 56.8348 21.9949 56.8077 22.2134C56.7853 22.3715 56.7417 22.5689 56.6967 22.773L56.6682 22.9032L56.0829 25.4401C56.0216 25.6578 55.9903 25.8755 55.9573 26.1045C55.9445 26.194 55.9315 26.2854 55.9161 26.379C55.889 26.7087 55.889 27.0153 55.889 27.3448H53.7687V26.8197C53.7687 26.7215 53.7755 26.6311 53.7823 26.5411C53.7891 26.452 53.7958 26.3632 53.7958 26.2679C53.5168 26.655 53.1834 26.9577 52.8462 27.1226V25.9651C53.071 25.854 53.2919 25.6892 53.5168 25.4401C53.8811 25.0033 54.133 24.4247 54.2416 23.7349ZM52.8462 23.8191C52.54 23.9033 52.2878 24.0108 52.063 24.1794C51.5901 24.4823 51.3925 24.8692 51.4506 25.31C51.4506 25.559 51.5359 25.7507 51.7025 25.8887C51.8422 26.0266 52.0359 26.0802 52.2878 26.0802C52.4817 26.0802 52.6794 26.0534 52.846 25.969V27.1264L52.7918 27.1532C52.4275 27.3449 52.0398 27.4559 51.563 27.4559C50.8924 27.4559 50.3613 27.2644 49.9428 26.9041C49.5241 26.5439 49.2993 26.0765 49.2449 25.4709C49.1598 24.532 49.5241 23.8154 50.3071 23.3171C50.9195 22.9302 51.7569 22.681 52.846 22.6005L52.8462 23.8191ZM52.8462 21.3051V19.7608C52.2609 19.8451 51.7878 20.0097 51.3653 20.255C50.8071 20.6421 50.4698 21.1672 50.4157 21.857H52.6212C52.6794 21.6346 52.7337 21.4431 52.8462 21.3051Z\" fill=\"#004A99\"/>\n<path d=\"M57.2029 30.082L59.0442 27.3228L57.703 19.7617H59.9939L60.6335 24.9505L63.5911 19.7617H65.7696L61.0249 27.6255L59.6566 30.082H57.2029Z\" fill=\"#004A99\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.2421 20.6171C17.4327 20.5612 17.6013 20.5352 17.7925 20.5352C18.3236 20.5352 18.7152 20.6732 18.9904 20.9528C19.2694 21.202 19.44 21.6159 19.4942 22.1945C19.5215 22.6353 19.4671 23.1334 19.3276 23.739C19.1881 24.3176 18.9942 24.8427 18.7152 25.3102C18.4631 25.724 18.1841 26.0306 17.8507 26.2223C17.6851 26.3327 17.4657 26.4168 17.2421 26.4704V26.4676C17.0755 26.4944 16.9048 26.5213 16.7111 26.5213C16.2072 26.5213 15.8157 26.3833 15.5094 26.1074C15.2303 25.8315 15.0326 25.4751 15.0055 24.9768C14.9784 24.5361 15.0055 24.0111 15.145 23.4056C15.2846 22.8001 15.4784 22.3019 15.7304 21.8881C15.9784 21.4474 16.2886 21.1177 16.6219 20.8686C16.8158 20.7576 17.0406 20.6732 17.2343 20.6196H17.2421V20.6171ZM17.2421 19.6528V20.6171C17.2396 20.6179 17.237 20.6188 17.2343 20.6196V19.6537C17.237 19.6534 17.2396 19.6531 17.2421 19.6528ZM17.2421 19.6528V19.65C16.7963 19.7036 16.3506 19.8148 15.9862 19.9527C15.428 20.2019 14.9822 20.5352 14.6179 21.0028C14.2264 21.524 13.9473 22.1333 13.7534 22.8499C13.5286 23.5665 13.4744 24.2295 13.5286 24.8926C13.5868 25.6935 13.893 26.3296 14.4512 26.7703C14.9784 27.2379 15.7071 27.4601 16.5987 27.4601C16.7153 27.4601 16.8318 27.453 16.944 27.446C17.0468 27.4396 17.1461 27.4335 17.2382 27.4333V27.437C17.7964 27.3796 18.2694 27.2684 18.6609 27.0769C19.2191 26.8277 19.6648 26.4138 20.0563 25.8352C20.3896 25.3369 20.6417 24.7315 20.8083 24.0417C21.0022 23.3519 21.0564 22.6889 21.0022 22.0835C20.9169 21.3131 20.6378 20.7039 20.0796 20.263C19.5486 19.8491 18.8508 19.627 17.9593 19.627C17.7102 19.627 17.4649 19.627 17.2421 19.6528ZM17.2382 27.4333V26.4713C17.2396 26.471 17.2408 26.4707 17.2421 26.4704V27.4333C17.2408 27.4333 17.2396 27.4333 17.2382 27.4333Z\" fill=\"#004A99\"/>\n<path d=\"M22.5371 24.8656C22.4829 25.0036 22.452 25.1147 22.452 25.2259C22.4247 25.3369 22.4247 25.4175 22.452 25.5018C22.4791 25.8046 22.5915 26.0267 22.8163 26.1647C23.0411 26.3296 23.3474 26.3871 23.793 26.3871C24.3785 26.3871 24.8243 26.2759 25.1615 26.0574C25.4949 25.8084 25.6344 25.5056 25.6073 25.1454C25.6073 24.9231 25.4949 24.7315 25.301 24.5668C25.1071 24.4019 24.7157 24.1797 24.0993 23.9038C23.3163 23.5434 22.7581 23.2139 22.452 22.9112C22.1186 22.6353 21.948 22.275 21.9209 21.8918C21.8665 21.2288 22.1147 20.7039 22.6457 20.263C23.2039 19.8491 23.9559 19.627 24.9055 19.627C25.77 19.627 26.4135 19.7649 26.8322 20.014C27.2778 20.263 27.5027 20.6195 27.557 21.1445C27.557 21.2288 27.557 21.3093 27.557 21.4204C27.557 21.5047 27.557 21.6426 27.5299 21.8343H26.1616C26.1616 21.7499 26.1616 21.6696 26.1616 21.612C26.1616 21.5545 26.1616 21.474 26.1616 21.4204C26.1343 21.1445 26.0219 20.9222 25.7971 20.7842C25.6034 20.6463 25.2933 20.562 24.8746 20.562C24.4017 20.562 24.0374 20.6732 23.7853 20.8647C23.5063 21.0564 23.3939 21.3323 23.4209 21.6657C23.448 21.8572 23.5334 22.0528 23.7272 22.1908C23.8938 22.3555 24.3125 22.5777 24.956 22.8806C25.8476 23.2945 26.4638 23.6546 26.7158 23.9305C26.9678 24.2065 27.1344 24.5668 27.1615 24.9807C27.2159 25.6705 26.9367 26.2759 26.2701 26.7472C25.6266 27.2148 24.7622 27.464 23.704 27.464C22.8666 27.464 22.2233 27.2991 21.7231 27.0231C21.2503 26.7204 20.9983 26.3065 20.9401 25.7547C20.913 25.6435 20.913 25.5056 20.9401 25.3408C20.9672 25.2028 20.9945 25.0381 21.0254 24.8734H22.5371V24.8656Z\" fill=\"#004A99\"/>\n<path d=\"M31.7201 27.3489C31.4409 27.3758 31.189 27.4026 30.9681 27.4333C30.7432 27.4333 30.5223 27.4601 30.3246 27.4601C29.7664 27.4601 29.3477 27.3758 29.0958 27.1841C28.8167 27.0194 28.6772 26.7167 28.65 26.3028C28.6229 26.1648 28.65 25.9157 28.6772 25.613C28.7043 25.2833 28.7896 24.95 28.8438 24.5935L29.7083 20.8418H28.3127L28.5648 19.8761H29.9331L30.3246 18.1668L31.8053 17.8066L31.3595 19.8761H33.007L32.7822 20.8418H31.1347L30.2975 24.7583C30.2122 25.0611 30.158 25.2833 30.158 25.4213C30.1307 25.586 30.1036 25.6972 30.1307 25.7816C30.1307 26.0038 30.216 26.1418 30.3555 26.2223C30.4952 26.3335 30.7471 26.387 31.0805 26.387C31.1929 26.387 31.3595 26.3602 31.5263 26.3335C31.6658 26.3335 31.8325 26.2797 31.972 26.2491L31.7201 27.3489Z\" fill=\"#004A99\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M36.55 22.7155H38.4493C38.4559 22.6558 38.4624 22.5991 38.4685 22.5458C38.488 22.3775 38.5036 22.2417 38.5036 22.1369C38.5307 21.9989 38.5307 21.8878 38.5036 21.7767C38.4765 21.3629 38.3097 21.06 38.0307 20.8378C37.7245 20.6155 37.333 20.4775 36.829 20.4775C36.7864 20.4775 36.738 20.4843 36.6895 20.491C36.641 20.4976 36.5926 20.5044 36.55 20.5044V19.5962V19.5923H36.8561C37.833 19.5923 38.5851 19.784 39.0889 20.1441C39.5618 20.5044 39.8719 21.0831 39.9263 21.8841C39.9534 22.16 39.9534 22.4627 39.9263 22.7654C39.9263 23.0681 39.8719 23.4016 39.7866 23.7311H36.55V22.7155ZM36.55 26.2774C36.3532 26.3604 36.1338 26.3869 35.9104 26.3869C35.3793 26.3869 34.9878 26.249 34.6816 26C34.4025 25.7508 34.2319 25.3905 34.1777 24.9231C34.1777 24.7583 34.1777 24.5628 34.2048 24.3712C34.2319 24.1489 34.259 23.9573 34.3443 23.735H36.55V23.7311V22.7155L34.5962 22.7157C34.7359 21.9684 35.0149 21.4166 35.4065 21.0602C35.7126 20.7305 36.1042 20.5619 36.55 20.5083V20.5044V19.5962C35.9647 19.6499 35.4607 19.7611 35.0149 20.01C34.4879 20.2553 34.0382 20.6692 33.7048 21.1675C33.3986 21.6925 33.1194 22.3286 32.9528 23.0452C32.7589 23.7887 32.7047 24.4517 32.7589 25.0304C32.8133 25.8044 33.1194 26.41 33.6234 26.8239C34.1545 27.2378 34.8522 27.46 35.7438 27.46C36.0228 27.46 36.302 27.4332 36.5539 27.4064C37.1647 27.3217 37.6944 27.1298 38.1393 26.8277C38.7826 26.4139 39.2013 25.8314 39.3952 25.0878H37.7477C37.6082 25.5017 37.3562 25.8314 37.0229 26.0535C36.8834 26.1379 36.7166 26.2237 36.55 26.2774ZM36.55 26.2774C36.5512 26.277 36.5525 26.2764 36.5539 26.2759V27.4064C36.5525 27.4065 36.5512 27.4062 36.55 27.4064V26.2774Z\" fill=\"#004A99\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_425_552\">\n<rect width=\"70\" height=\"48\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>\n';
var $author$project$Pyxis$Components$Logos$LogoSet$svgPrima = '<svg viewBox=\"0 0 120 46\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g class=\"logo__content\" clip-path=\"url(#clip0_1777_801)\">\n<path d=\"M65.9781 14.5636C65.061 14.8848 64.6853 15.4165 64.6964 16.4245C64.7627 21.5642 64.7295 26.7039 64.7295 31.8325C64.7295 32.2313 64.7406 32.619 64.7185 33.0178C64.6522 34.3581 63.9229 35.1778 62.8179 35.1888C61.6356 35.1999 60.7737 34.3359 60.7627 32.9845C60.7406 26.7925 60.7295 20.6005 60.7958 14.4085C60.8069 13.7993 61.2267 12.9685 61.735 12.6473C65.9892 9.92237 70.5748 9.32422 75.3814 11.1298C76.2875 11.4731 77.0389 12.2042 77.9781 12.8356C80.1881 11.0411 82.7295 10.1218 85.6798 10.1328C91.503 10.155 94.6964 12.8024 94.9505 18.363C95.1825 23.2701 95.0389 28.1993 95.0168 33.1174C95.0057 34.4134 94.1439 35.211 93.0057 35.1888C91.9671 35.1667 91.1052 34.3581 91.0831 33.1618C91.0278 29.5618 91.0499 25.9618 91.0389 22.3618C91.0389 21.3094 91.072 20.2571 91.0057 19.2048C90.7295 14.8184 87.8566 12.8356 83.3925 13.9876C82.5638 14.1981 81.7903 14.6411 81.0499 15.0731C80.1881 15.5827 79.8124 16.3138 79.8234 17.3771C79.8897 22.6054 79.8676 27.8227 79.8455 33.051C79.8455 34.3581 79.0389 35.1888 77.9339 35.1888C76.7847 35.1888 76.0002 34.3691 75.9339 33.1064C75.9118 32.7519 75.9229 32.4085 75.9229 32.0541C75.9229 28.0553 75.9229 24.0676 75.9229 20.0688C75.9229 19.5814 75.9339 19.1051 75.8897 18.6178C75.5582 15.3501 73.5803 13.6221 70.1218 13.7439C70.1328 13.7439 68.2875 13.755 65.9781 14.5636Z\"/>\n<path d=\"M34.2544 15.7599C34.5858 12.5254 36.8842 10.5205 40.2654 10.2214C42.1218 10.0552 44.0334 10.2657 45.8897 10.4983C47.3041 10.6756 47.9892 11.6171 47.7792 12.6362C47.5693 13.6552 46.5748 14.1869 45.1936 14.054C43.956 13.9432 42.7184 13.7439 41.4919 13.7992C39.3151 13.8989 38.1881 14.9623 38.1107 17.0337C38.0113 20.0577 38.0444 23.0817 38.0334 26.1168C38.0223 28.2657 38.0444 30.4922 38.0223 32.6411C38.0113 34.2694 37.3151 35.1666 36.0886 35.1999C34.7737 35.2442 33.9892 34.3137 33.9892 32.6633C33.9781 30.1156 33.9892 27.5014 33.9892 24.9537C34.0665 24.9537 33.945 18.7949 34.2544 15.7599Z\"/>\n<path d=\"M55.3925 22.7938C55.3925 26.1279 55.4035 29.4621 55.3925 32.7962C55.3814 34.3248 54.6743 35.1888 53.4809 35.1999C52.2102 35.211 51.4588 34.3027 51.4588 32.7408C51.4477 26.1611 51.4477 25.563 51.4588 18.9944C51.4588 17.3439 52.1218 16.491 53.3925 16.4799C54.7295 16.4578 55.3925 17.3107 55.4035 19.0498C55.3925 22.2842 55.3925 19.5482 55.3925 22.7938Z\"/>\n<path d=\"M53.3483 14.4085C52.2323 14.3975 51.2157 13.3895 51.2047 12.2928C51.1936 11.0744 52.1439 10.1439 53.3925 10.1439C54.6411 10.1439 55.6466 11.1187 55.6024 12.2707C55.5803 13.4448 54.5417 14.4196 53.3483 14.4085Z\"/>\n<path d=\"M29.0058 17.5655C28.3759 13.611 25.6135 11.1298 21.4035 10.3876C19.3483 10.0332 17.3704 10.0885 15.4588 10.4541C14.5969 10.5981 13.9781 11.2849 13.956 12.171C13.9339 13.1347 14.829 14.0209 15.8013 13.9987C15.945 13.9987 16.0776 13.9765 16.2102 13.9433C17.5251 13.6442 18.8732 13.5556 20.2875 13.8104C23.4477 14.3532 25.0389 16.0479 25.3704 19.7698C25.5803 22.1513 25.4809 24.5993 25.1936 26.9809C24.8511 29.9273 22.8732 31.5445 19.7682 31.8104C17.3814 32.0098 15.1052 31.5445 12.9284 30.603C12.2544 30.315 11.9781 29.9495 12.0002 29.2184C12.0555 27.0695 12.0223 24.9205 12.0223 22.7716C12.0223 21.0325 12.0002 19.2824 12.0334 17.5433V14.5082C12.0334 13.4781 11.1383 12.6141 10.0444 12.5919C9.71293 12.5809 9.40354 12.6473 9.1273 12.7581C6.85105 13.755 5.21569 14.6079 1.45879 16.5907C0.0444237 17.3661 -0.342317 18.4959 0.309617 19.5815C0.917352 20.6116 2.02232 20.7889 3.35934 20.0689C4.89525 19.2381 6.46431 18.4405 8.05547 17.6762C8.08862 25.8289 8.06652 36.219 8.07757 44.0947V44.1058C8.07757 44.1168 8.07757 44.1168 8.07757 44.1168C8.07757 44.139 8.07757 44.1501 8.07757 44.1722H8.08862C8.13282 45.1802 8.9947 45.9888 10.0555 45.9888C11.1162 45.9888 11.9892 45.1802 12.0223 44.1722H12.0334C12.0444 41.9015 12.0334 37.9581 12.0334 34.2584C14.2433 34.6682 16.2433 35.1999 18.2765 35.3772C23.9118 35.8645 28.398 32.8073 29.1715 27.5015C29.6356 24.2449 29.5251 20.8221 29.0058 17.5655Z\"/>\n<path d=\"M119.801 17.5877C119.691 14.0321 117.569 11.5287 114.111 10.6425C110.188 9.63451 106.343 10.1219 102.619 11.573C101.392 12.0493 100.939 13.0462 101.315 13.9988C101.669 14.8961 102.718 15.2284 104.033 14.8407C104.033 14.8407 107.492 13.6997 110.906 13.7219C113.812 13.7441 115.459 15.1508 115.857 17.7207C115.923 18.1748 115.934 18.6401 115.923 19.1274H115.934L115.967 24.1453V24.2007C115.967 24.2228 115.967 24.2561 115.967 24.2782V24.4001C115.967 26.2056 116.022 27.8561 115.923 29.4954C115.901 29.9496 115.514 30.6031 115.105 30.8025C112.232 32.2093 109.194 32.4308 106.133 31.4893C104.177 30.8801 103.227 29.4179 103.227 27.4573C103.227 25.6739 104.287 24.3004 106.243 23.6468C108.155 23.0154 110.022 23.0487 111.89 23.3367C111.978 23.3477 112.078 23.3588 112.177 23.3588C113.061 23.3588 113.768 22.6388 113.768 21.7637C113.768 20.9884 113.216 20.3459 112.475 20.2019C110.011 19.8364 107.547 19.7699 105.061 20.4677C101.392 21.4979 99.282 24.0345 99.2709 27.4351C99.2599 31.1459 101.293 33.9484 105.028 34.8677C109.834 36.0641 114.453 35.2887 118.729 32.9293C119.26 32.6413 119.79 31.8437 119.801 31.2788C119.89 26.7262 119.956 22.1514 119.801 17.5877Z\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_1777_801\">\n<rect width=\"120\" height=\"36\" fill=\"white\" transform=\"translate(0 10)\"/>\n <linearGradient\n          id=\"full-pride-gradient-default\"\n          x1=\"0.000488281\"\n          y1=\"20.3767\"\n          x2=\"120.676\"\n          y2=\"20.3767\"\n          gradientUnits=\"userSpaceOnUse\"\n        >\n          <stop stop-color=\"#DF1654\" />\n          <stop offset=\"0.033\" stop-color=\"#E43353\" />\n          <stop offset=\"0.098\" stop-color=\"#EE6552\" />\n          <stop offset=\"0.16\" stop-color=\"#F58E51\" />\n          <stop offset=\"0.216\" stop-color=\"#FBAA51\" />\n          <stop offset=\"0.264\" stop-color=\"#FEBC50\" />\n          <stop offset=\"0.3\" stop-color=\"#FFC250\" />\n          <stop offset=\"0.515\" stop-color=\"#A3CD50\" />\n          <stop offset=\"0.557\" stop-color=\"#9BC95A\" />\n          <stop offset=\"0.627\" stop-color=\"#84C073\" />\n          <stop offset=\"0.716\" stop-color=\"#5FB09D\" />\n          <stop offset=\"0.78\" stop-color=\"#41A3BF\" />\n          <stop offset=\"0.823\" stop-color=\"#4A93BF\" />\n          <stop offset=\"0.906\" stop-color=\"#636AC1\" />\n          <stop offset=\"1\" stop-color=\"#8334C2\" />\n        </linearGradient>\n\n        <linearGradient\n          id=\"full-pride-gradient-negative\"\n          x1=\"0\"\n          y1=\"20.3767\"\n          x2=\"120.675\"\n          y2=\"20.3767\"\n          gradientUnits=\"userSpaceOnUse\"\n        >\n          <stop stop-color=\"#DF1654\" />\n          <stop offset=\"0.257\" stop-color=\"#FF9110\" />\n          <stop offset=\"0.26\" stop-color=\"#FF9211\" />\n          <stop offset=\"0.325\" stop-color=\"#FFB22C\" />\n          <stop offset=\"0.389\" stop-color=\"#FFC940\" />\n          <stop offset=\"0.448\" stop-color=\"#FFD74C\" />\n          <stop offset=\"0.5\" stop-color=\"#FFDC50\" />\n          <stop offset=\"0.756\" stop-color=\"#A3CD50\" />\n          <stop offset=\"0.781\" stop-color=\"#9ACC58\" />\n          <stop offset=\"0.822\" stop-color=\"#83CB6E\" />\n          <stop offset=\"0.872\" stop-color=\"#5DC892\" />\n          <stop offset=\"0.93\" stop-color=\"#29C5C3\" />\n          <stop offset=\"0.971\" stop-color=\"#00C2E9\" />\n        </linearGradient>\n</clipPath>\n</defs>\n</svg>\n';
var $author$project$Pyxis$Components$Logos$LogoSet$svgPrimaMonogram = '<svg fill=\"none\" viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_1638_800)\">\n<g>\n<path  class=\"logo__content\" d=\"M20 0C8.95 0 0 8.95 0 20C0 31.05 8.95 40 20 40C31.05 40 40 31.05 40 20C40 8.95 31.05 0 20 0ZM28.67 20.75C28.16 24.26 25.19 26.28 21.44 25.94C20.09 25.82 18.77 25.47 17.3 25.2V31.76C17.25 32.39 16.75 32.89 16.12 32.94C15.4 33.01 14.76 32.47 14.7 31.76V14.25C13.65 14.76 12.6 15.29 11.59 15.84C10.69 16.31 9.98 16.23 9.55 15.51C9.12 14.8 9.37 14.05 10.28 13.55C12.78 12.22 13.84 11.66 15.37 11C15.56 10.92 15.77 10.89 15.98 10.89C16.69 10.89 17.27 11.45 17.3 12.16V17.65C17.3 19.07 17.34 20.49 17.3 21.91C17.25 22.33 17.51 22.71 17.91 22.83C19.33 23.46 20.89 23.74 22.45 23.63C24.52 23.45 25.81 22.38 26.04 20.43C26.25 18.84 26.29 17.23 26.16 15.64C25.94 13.18 24.88 12.06 22.79 11.7C21.89 11.55 20.97 11.57 20.09 11.79C19.99 11.81 19.9 11.82 19.8 11.82C19.13 11.82 18.59 11.28 18.57 10.62C18.58 10.04 19.02 9.55 19.59 9.48C20.89 9.23 22.23 9.21 23.53 9.44C26.32 9.93 28.16 11.57 28.57 14.18C28.93 16.35 28.96 18.57 28.67 20.75Z\"/>\n</g>\n<path class=\"logo__text\"  d=\"M28.5705 14.1823C28.1639 11.5686 26.3179 9.92642 23.5313 9.43828C22.2261 9.21457 20.8909 9.22865 19.5905 9.47902C19.0161 9.55457 18.5839 10.039 18.5735 10.6179C18.5898 11.2846 19.1324 11.8179 19.7991 11.8231C19.8968 11.8235 19.9942 11.8116 20.0891 11.7875C20.9739 11.5749 21.8928 11.5457 22.7891 11.7012C24.8839 12.0572 25.9416 13.1809 26.1602 15.6368C26.2857 17.2349 26.2465 18.8416 26.0431 20.432C25.8142 22.3794 24.5176 23.4472 22.4479 23.6253C20.8935 23.7375 19.335 23.4631 17.9124 22.8272C17.5113 22.7131 17.2513 22.3261 17.2972 21.912C17.3379 20.4883 17.2972 19.0694 17.2972 17.6509C17.2972 16.4964 17.2972 15.3423 17.2972 14.1931V12.159C17.2698 11.4516 16.6883 10.8923 15.9802 10.8927C15.7713 10.8868 15.5631 10.9246 15.3698 11.0046C13.8442 11.6605 12.7765 12.2249 10.285 13.5472C9.37461 14.0505 9.12054 14.7979 9.55276 15.5149C9.98498 16.232 10.6868 16.3131 11.5868 15.8353C12.6039 15.2861 13.6461 14.7623 14.6987 14.2538C14.6987 19.6438 14.6987 26.5135 14.6987 31.7153V31.7561C14.7624 32.4749 15.3968 33.0061 16.1157 32.9427C16.7465 32.8868 17.2465 32.3868 17.3024 31.7561C17.3024 30.2305 17.3024 27.6475 17.3024 25.2016C18.7668 25.4712 20.0891 25.822 21.4365 25.939C25.1942 26.2798 28.1639 24.2561 28.6724 20.7472C28.9639 18.5661 28.9294 16.3535 28.5705 14.1823Z\"/>\n</g>\n\n<defs>\n<clipPath id=\"clip0_1638_800\">\n<rect width=\"40\" height=\"40\" fill=\"white\"/>\n</clipPath>\n\n  <linearGradient id=\"monogram-gradient-default\" x1=\"20\" y1=\"-0.365233\" x2=\"20\" y2=\"40.9458\" gradientUnits=\"userSpaceOnUse\">\n  <stop offset=\"0.00166442\" stop-color=\"var(--pyx-color-monogram-gradient-0)\"/>\n  <stop offset=\"1\" stop-color=\"var(--pyx-color-monogram-gradient-100)\"/>\n  </linearGradient>\n\n\n  <linearGradient id=\"monogram-gradient-negative\" x1=\"20\" y1=\"-0.365233\" x2=\"20\" y2=\"40.9458\" gradientUnits=\"userSpaceOnUse\">\n  <stop offset=\"0.00166442\" stop-color=\"var(--pyx-color-monogram-gradient-0-vibrant)\"/>\n  <stop offset=\"1\" stop-color=\"var(--pyx-color-monogram-gradient-100-vibrant)\"/>\n  </linearGradient>\n\n\n    <linearGradient id=\"monogram-pride-gradient-default\" x1=\"19.9996\" y1=\"6.33545\" x2=\"19.9996\" y2=\"33.6631\" gradientUnits=\"userSpaceOnUse\">\n      <stop stop-color=\"#DF1654\"/>\n      <stop offset=\"0.033\" stop-color=\"#E43353\"/>\n      <stop offset=\"0.098\" stop-color=\"#EE6552\"/>\n      <stop offset=\"0.16\" stop-color=\"#F58E51\"/>\n      <stop offset=\"0.216\" stop-color=\"#FBAA51\"/>\n      <stop offset=\"0.264\" stop-color=\"#FEBC50\"/>\n      <stop offset=\"0.3\" stop-color=\"#FFC250\"/>\n      <stop offset=\"0.515\" stop-color=\"#A3CD50\"/>\n      <stop offset=\"0.557\" stop-color=\"#9BC95A\"/>\n      <stop offset=\"0.627\" stop-color=\"#84C073\"/>\n      <stop offset=\"0.716\" stop-color=\"#5FB09D\"/>\n      <stop offset=\"0.78\" stop-color=\"#41A3BF\"/>\n      <stop offset=\"0.823\" stop-color=\"#4A93BF\"/>\n      <stop offset=\"0.906\" stop-color=\"#636AC1\"/>\n      <stop offset=\"1\" stop-color=\"#8334C2\"/>\n    </linearGradient>\n\n    <linearGradient id=\"monogram-pride-gradient-negative\" x1=\"19.1001\" y1=\"7.15681\" x2=\"19.1001\" y2=\"34.9925\" gradientUnits=\"userSpaceOnUse\">\n      <stop stop-color=\"#DF1654\"/>\n      <stop offset=\"0.257\" stop-color=\"#FF9110\"/>\n      <stop offset=\"0.26\" stop-color=\"#FF9211\"/>\n      <stop offset=\"0.325\" stop-color=\"#FFB22C\"/>\n      <stop offset=\"0.389\" stop-color=\"#FFC940\"/>\n      <stop offset=\"0.448\" stop-color=\"#FFD74C\"/>\n      <stop offset=\"0.5\" stop-color=\"#FFDC50\"/>\n      <stop offset=\"0.756\" stop-color=\"#A3CD50\"/>\n      <stop offset=\"0.781\" stop-color=\"#9ACC58\"/>\n      <stop offset=\"0.822\" stop-color=\"#83CB6E\"/>\n      <stop offset=\"0.872\" stop-color=\"#5DC892\"/>\n      <stop offset=\"0.93\" stop-color=\"#29C5C3\"/>\n      <stop offset=\"0.971\" stop-color=\"#00C2E9\"/>\n    </linearGradient>\n\n</defs>\n</svg>\n';
var $author$project$Pyxis$Components$Logos$LogoSet$svgTrustpilot = '<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg  viewBox=\"0 0 163 40\" xmlns=\"http://www.w3.org/2000/svg\">\n<path class=\"logo-trustpilot__text\" d=\"m152.1 20.318h2.428v-4.3385h3.201v4.3121h2.88v2.3544h-2.88v7.6719c0 0.3439 0.026 0.6084 0.053 0.873 0.026 0.238 0.106 0.4497 0.186 0.6084 0.107 0.1587 0.267 0.291 0.454 0.3704 0.213 0.0793 0.48 0.1322 0.853 0.1322 0.214 0 0.454 0 0.667-0.0264 0.214-0.0265 0.454-0.0529 0.667-0.1058v2.4603c-0.346 0.0529-0.693 0.0793-1.04 0.1058-0.347 0.0529-0.667 0.0529-1.04 0.0529-0.854 0-1.521-0.0794-2.028-0.2381-0.506-0.1587-0.906-0.3968-1.2-0.6878-0.293-0.3175-0.48-0.6878-0.587-1.1376-0.107-0.4497-0.16-1.0053-0.186-1.5873v-8.4654h-2.428v-2.4074 0.0529zm-8.269 12.249c0.694 0 1.334-0.1587 1.841-0.4497 0.533-0.291 0.933-0.6879 1.28-1.164 0.347-0.4762 0.587-1.0318 0.747-1.6138 0.16-0.6084 0.24-1.2169 0.24-1.8518 0-0.6084-0.08-1.2169-0.24-1.8254-0.16-0.6084-0.4-1.1375-0.747-1.6137s-0.773-0.8465-1.28-1.1375c-0.534-0.291-1.147-0.4498-1.841-0.4498-0.693 0-1.333 0.1588-1.84 0.4498-0.534 0.291-0.934 0.6878-1.28 1.1375-0.347 0.4762-0.587 1.0053-0.748 1.6137-0.16 0.6085-0.239 1.217-0.239 1.8254 0 0.6349 0.079 1.2434 0.239 1.8518 0.161 0.6085 0.401 1.1376 0.748 1.6138 0.346 0.4761 0.773 0.873 1.28 1.164 0.533 0.3174 1.147 0.4497 1.84 0.4497zm0 2.5128c-1.147 0-2.187-0.1851-3.094-0.582-0.907-0.3968-1.654-0.8994-2.293-1.5608-0.614-0.6613-1.094-1.4814-1.414-2.4074-0.32-0.9259-0.507-1.9576-0.507-3.0422 0-1.0847 0.16-2.0899 0.507-3.0159 0.32-0.9259 0.8-1.7195 1.414-2.4073 0.613-0.6614 1.386-1.1905 2.293-1.5608 0.907-0.3704 1.947-0.582 3.094-0.582 1.148 0 2.188 0.1851 3.095 0.582 0.907 0.3703 1.654 0.8994 2.294 1.5608 0.613 0.6613 1.094 1.4814 1.413 2.4073 0.32 0.926 0.507 1.9312 0.507 3.0159 0 1.1111-0.16 2.1163-0.507 3.0422-0.346 0.926-0.8 1.7196-1.413 2.4074-0.614 0.6614-1.387 1.1905-2.294 1.5608-0.907 0.3704-1.921 0.582-3.095 0.582zm-12.964-0.3968h3.201v-19.841h-3.201v19.841zm-6.054 5e-4h3.2v-14.365h-3.2v14.365zm0-16.852h3.2v-2.9893h-3.2v2.9893zm-5.629 9.6826c0-0.6349-0.08-1.2698-0.267-1.8782-0.16-0.6085-0.427-1.1376-0.774-1.6138-0.346-0.4761-0.773-0.8465-1.253-1.1375-0.507-0.291-1.094-0.4233-1.734-0.4233-1.334 0-2.348 0.4497-3.041 1.3757-0.667 0.9259-1.013 2.1692-1.013 3.7036 0 0.7407 0.08 1.4021 0.266 2.0105 0.187 0.6085 0.427 1.1376 0.801 1.5873 0.346 0.4497 0.773 0.7937 1.28 1.0582 0.506 0.2645 1.067 0.3968 1.734 0.3968 0.746 0 1.333-0.1587 1.84-0.4497s0.907-0.6878 1.254-1.1376c0.32-0.4761 0.56-1.0052 0.693-1.6137 0.134-0.6349 0.214-1.2433 0.214-1.8783zm-11.176-7.1958h3.014v1.9576h0.053c0.454-0.8465 1.067-1.4285 1.867-1.7989 0.801-0.3704 1.654-0.5555 2.614-0.5555 1.148 0 2.134 0.1851 2.988 0.6084 0.854 0.3968 1.547 0.9259 2.108 1.6402 0.559 0.6878 0.986 1.5079 1.253 2.4338s0.427 1.9312 0.427 2.9629c0 0.9789-0.134 1.9048-0.374 2.8042-0.266 0.8995-0.64 1.7196-1.147 2.4074-0.506 0.6878-1.147 1.2434-1.947 1.6666-0.8 0.4233-1.707 0.6349-2.774 0.6349-0.453 0-0.934-0.0529-1.387-0.1322-0.453-0.0794-0.907-0.2117-1.334-0.3969-0.427-0.1851-0.827-0.4232-1.173-0.7142-0.374-0.291-0.667-0.6349-0.907-1.0053h-0.053v7.1692h-3.201v-19.682h-0.027zm-10.75 1e-4h2.4274v-4.3385h3.2008v4.3121h2.881v2.3544h-2.881v7.6719c0 0.3439 0.027 0.6084 0.053 0.873 0.027 0.238 0.107 0.4497 0.187 0.6084 0.107 0.1587 0.267 0.291 0.454 0.3704 0.213 0.0793 0.48 0.1322 0.853 0.1322 0.214 0 0.454 0 0.667-0.0264 0.214-0.0265 0.454-0.0529 0.667-0.1058v2.4603c-0.347 0.0529-0.694 0.0793-1.04 0.1058-0.347 0.0529-0.667 0.0529-1.041 0.0529-0.853 0-1.52-0.0794-2.027-0.2381s-0.907-0.3968-1.2-0.6878c-0.293-0.3175-0.4801-0.6878-0.5871-1.1376-0.1064-0.4497-0.1598-1.0053-0.1867-1.5873v-8.4654h-2.4274v-2.4074 0.0529zm-10.537 9.7621c0.107 0.9259 0.4537 1.5609 1.067 1.9577 0.6135 0.3703 1.3604 0.5555 2.2139 0.5555 0.2937 0 0.6405-0.0264 1.0136-0.0793 0.3735-0.053 0.7472-0.1323 1.067-0.2646 0.347-0.1323 0.6138-0.3174 0.8272-0.582 0.2131-0.2645 0.3201-0.582 0.2931-0.9788-0.0264-0.3968-0.1597-0.7407-0.4534-1.0053-0.2934-0.2645-0.6399-0.4497-1.067-0.6349-0.4268-0.1587-0.9336-0.291-1.4938-0.3968-0.5598-0.1058-1.1203-0.2381-1.7071-0.3704-0.5866-0.1323-1.1734-0.291-1.7338-0.4762-0.5602-0.1851-1.0401-0.4232-1.4938-0.7671-0.4265-0.3175-0.8002-0.7143-1.0403-1.217-0.2667-0.5026-0.4001-1.0846-0.4001-1.8253 0-0.7937 0.1867-1.4286 0.5868-1.9577 0.3737-0.5291 0.8803-0.9523 1.4671-1.2698 0.5869-0.3174 1.2537-0.5555 1.9742-0.6878 0.7202-0.1323 1.4134-0.1852 2.0539-0.1852 0.7469 0 1.4671 0.0794 2.1339 0.2381 0.6669 0.1587 1.3068 0.3968 1.8403 0.7672 0.5604 0.3439 1.0136 0.8201 1.3606 1.3756 0.3732 0.5556 0.5866 1.2434 0.6933 2.037h-3.3343c-0.1598-0.7671-0.5068-1.2698-1.0403-1.5343-0.5601-0.2646-1.1734-0.3968-1.8938-0.3968-0.2132 0-0.5068 0.0264-0.8003 0.0529-0.3201 0.0529-0.5868 0.1058-0.8799 0.2116-0.2668 0.1058-0.5071 0.2645-0.6938 0.4497-0.1865 0.1852-0.2935 0.4498-0.2935 0.7672 0 0.3968 0.1334 0.6878 0.4002 0.9259 0.2667 0.2381 0.6135 0.4233 1.0669 0.6085 0.4268 0.1587 0.9336 0.291 1.4938 0.3968 0.5604 0.1058 1.1472 0.2381 1.7338 0.3704 0.5868 0.1322 1.1473 0.291 1.7072 0.4761 0.5601 0.1852 1.0669 0.4233 1.4937 0.7672 0.4271 0.3175 0.8002 0.7143 1.067 1.1905 0.2667 0.4762 0.4001 1.0846 0.4001 1.7724 0 0.8466-0.1865 1.5609-0.5866 2.1693-0.4001 0.582-0.9072 1.0846-1.5204 1.455-0.6135 0.3704-1.3337 0.6349-2.0806 0.8201-0.7738 0.1587-1.5204 0.2646-2.2673 0.2646-0.9072 0-1.7608-0.1059-2.5341-0.3175-0.7738-0.2116-1.467-0.5291-2.0275-0.9259-0.5599-0.4233-1.0136-0.9259-1.3337-1.5608-0.3201-0.6085-0.5065-1.3492-0.5335-2.2222h3.2279v0.0264h0.0264zm-5.4411 4.6031h-3.1476v-2.0105h-0.0533c-0.4001 0.7407-0.987 1.2963-1.7605 1.746-0.7736 0.4497-1.5738 0.6614-2.374 0.6614-1.8939 0-3.281-0.4498-4.1345-1.4021-0.8536-0.9259-1.2804-2.3545-1.2804-4.2328v-9.1268h3.2009v8.8094c0 1.2698 0.2403 2.1693 0.7469 2.6719 0.4801 0.5291 1.1737 0.7936 2.0539 0.7936 0.6669 0 1.227-0.1058 1.6805-0.3174 0.4534-0.2117 0.8272-0.4762 1.0939-0.8201 0.2931-0.3439 0.4799-0.7672 0.6132-1.2434 0.1334-0.4762 0.187-1.0053 0.187-1.5608v-8.3332h3.2009v14.365h-0.0269zm-23.153-14.365h2.9875v2.7777h0.0536c0.1065-0.3968 0.2932-0.7672 0.5599-1.1375 0.2668-0.3704 0.5869-0.7143 0.987-1.0053 0.3734-0.3175 0.8002-0.5556 1.2803-0.7407 0.4535-0.1852 0.9336-0.291 1.4138-0.291 0.3734 0 0.6402 0.0264 0.7735 0.0264 0.1334 0.0265 0.2935 0.0529 0.4268 0.0529v3.0423c-0.2134-0.0529-0.4534-0.0794-0.6935-0.1058-0.2401-0.0265-0.4535-0.0529-0.6935-0.0529-0.5335 0-1.0403 0.1058-1.5202 0.3174-0.4804 0.2117-0.8805 0.5291-1.254 0.9259-0.3465 0.4233-0.6401 0.9259-0.8535 1.5344s-0.3201 1.3227-0.3201 2.1164v6.8253h-3.2009l0.0533-14.286zm-15.498-5.476h16.191v2.9894h-6.3752v16.852h-3.4943v-16.852h-6.3485l0.027-2.9894z\" clip-rule=\"evenodd\" fill-rule=\"evenodd\"/>\n<path class=\"logo-trustpilot__star\" d=\"m24.112 14.177h14.896l-12.049 8.7563-7.4479 5.4062 8.4831-2.1998-1.0352-3.2064 4.601 14.162-12.049-8.7563-12.063 8.7563 4.6154-14.162-12.063-8.7706 14.896 0.0143 4.6153-14.177 4.601 14.177z\" clip-rule=\"evenodd\" fill=\"#00B67A\" fill-rule=\"evenodd\"/>\n<path class=\"logo-trustpilot__star-cut\" d=\"m27.994 26.14-1.0352-3.2064-7.4479 5.4062 8.4831-2.1998z\" fill=\"#005128\"/>\n</svg>\n';
var $author$project$Pyxis$Components$Logos$LogoSet$svgVisa = '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"70\" height=\"48\" viewBox=\"0 0 70 48\" fill=\"none\">\n<rect x=\"0.5\" y=\"0.5\" width=\"69\" height=\"47\" rx=\"7.5\" fill=\"white\" stroke=\"#DDDEE1\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.2505 32.5165H17.0099L13.8299 20.3847C13.679 19.8267 13.3585 19.3333 12.8871 19.1008C11.7106 18.5165 10.4142 18.0514 9 17.8169V17.3498H15.8313C16.7742 17.3498 17.4813 18.0514 17.5991 18.8663L19.2491 27.6173L23.4877 17.3498H27.6104L21.2505 32.5165ZM29.9675 32.5165H25.9626L29.2604 17.3498H33.2653L29.9675 32.5165ZM38.4467 21.5514C38.5646 20.7346 39.2717 20.2675 40.0967 20.2675C41.3931 20.1502 42.8052 20.3848 43.9838 20.9671L44.6909 17.7016C43.5123 17.2345 42.216 17 41.0395 17C37.1524 17 34.3239 19.1008 34.3239 22.0165C34.3239 24.2346 36.3274 25.3992 37.7417 26.1008C39.2717 26.8004 39.861 27.2675 39.7431 27.9671C39.7431 29.0165 38.5646 29.4836 37.3881 29.4836C35.9739 29.4836 34.5596 29.1338 33.2653 28.5494L32.5582 31.8169C33.9724 32.3992 35.5025 32.6338 36.9167 32.6338C41.2752 32.749 43.9838 30.6502 43.9838 27.5C43.9838 23.5329 38.4467 23.3004 38.4467 21.5514ZM58 32.5165L54.82 17.3498H51.4044C50.6972 17.3498 49.9901 17.8169 49.7544 18.5165L43.8659 32.5165H47.9887L48.8116 30.3004H53.8772L54.3486 32.5165H58ZM51.9936 21.4342L53.1701 27.1502H49.8723L51.9936 21.4342Z\" fill=\"#172B85\"/>\n</svg>';
var $author$project$Pyxis$Components$Logos$LogoSet$svgWireTransferEn = '<svg width=\"70\" height=\"48\" viewBox=\"0 0 70 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect x=\"0.5\" y=\"0.5\" width=\"69\" height=\"47\" rx=\"7.5\" fill=\"#F2EAF8\" stroke=\"#DDDEE1\"/>\n<path d=\"M30.7505 19.81L32.0305 14.91H33.4405L31.4805 22H30.0605L28.4405 16.95L26.8205 22H25.3805L23.4105 14.91H24.8705L26.1705 19.79L27.7405 14.91H29.1705L30.7505 19.81ZM35.6409 22H34.3109V17.08H35.6409V22ZM34.1509 15.47C34.1509 15.01 34.5209 14.64 34.9709 14.64C35.4309 14.64 35.7909 15.01 35.7909 15.47C35.7909 15.91 35.4309 16.28 34.9709 16.28C34.5209 16.28 34.1509 15.91 34.1509 15.47ZM39.9964 17.06V18.4C39.8464 18.37 39.7164 18.36 39.5964 18.36C38.9164 18.36 38.3264 18.69 38.3264 19.75V22H36.9964V17.08H38.2864V17.81C38.5864 17.16 39.2664 17.04 39.6864 17.04C39.7964 17.04 39.8964 17.05 39.9964 17.06ZM41.8648 18.98H44.0648C44.0448 18.49 43.7248 18.01 42.9648 18.01C42.2748 18.01 41.8948 18.53 41.8648 18.98ZM44.1948 20.26L45.3048 20.59C45.0548 21.44 44.2748 22.15 43.0648 22.15C41.7148 22.15 40.5248 21.18 40.5248 19.52C40.5248 17.95 41.6848 16.93 42.9448 16.93C44.4648 16.93 45.3748 17.9 45.3748 19.48C45.3748 19.67 45.3548 19.87 45.3548 19.89H41.8348C41.8648 20.54 42.4148 21.01 43.0748 21.01C43.6948 21.01 44.0348 20.7 44.1948 20.26ZM18.5555 27.61V29.08H19.5455V30.26H18.5555V32.32C18.5555 32.75 18.7555 32.89 19.1355 32.89C19.2955 32.89 19.4755 32.87 19.5455 32.85V33.95C19.4255 34 19.1855 34.07 18.7955 34.07C17.8355 34.07 17.2355 33.5 17.2355 32.55V30.26H16.3455V29.08H16.5955C17.1155 29.08 17.3555 28.74 17.3555 28.3V27.61H18.5555ZM23.6146 29.06V30.4C23.4646 30.37 23.3346 30.36 23.2146 30.36C22.5346 30.36 21.9446 30.69 21.9446 31.75V34H20.6146V29.08H21.9046V29.81C22.2046 29.16 22.8846 29.04 23.3046 29.04C23.4146 29.04 23.5146 29.05 23.6146 29.06ZM24.2015 32.66C24.2015 31.78 24.8515 31.29 25.6715 31.17L26.8815 30.99C27.1615 30.95 27.2515 30.81 27.2515 30.64C27.2515 30.29 26.9815 30 26.4215 30C25.8415 30 25.5215 30.37 25.4815 30.8L24.3015 30.55C24.3815 29.78 25.0915 28.93 26.4115 28.93C27.9715 28.93 28.5515 29.81 28.5515 30.8V33.22C28.5515 33.48 28.5815 33.83 28.6115 34H27.3915C27.3615 33.87 27.3415 33.6 27.3415 33.41C27.0915 33.8 26.6215 34.14 25.8915 34.14C24.8415 34.14 24.2015 33.43 24.2015 32.66ZM26.1715 33.15C26.7315 33.15 27.2515 32.88 27.2515 32.01V31.79L26.1415 31.96C25.8015 32.01 25.5315 32.2 25.5315 32.58C25.5315 32.87 25.7415 33.15 26.1715 33.15ZM31.2024 31.17V34H29.8724V29.08H31.1624V29.69C31.4624 29.18 32.0524 28.95 32.5824 28.95C33.8024 28.95 34.3624 29.82 34.3624 30.9V34H33.0324V31.13C33.0324 30.58 32.7624 30.15 32.1224 30.15C31.5424 30.15 31.2024 30.6 31.2024 31.17ZM35.3432 32.63L36.4832 32.38C36.5132 32.77 36.8032 33.13 37.3832 33.13C37.8232 33.13 38.0332 32.9 38.0332 32.64C38.0332 32.42 37.8832 32.24 37.5032 32.16L36.8532 32.01C35.9032 31.8 35.4732 31.23 35.4732 30.54C35.4732 29.66 36.2532 28.93 37.3132 28.93C38.7132 28.93 39.1832 29.82 39.2432 30.35L38.1332 30.6C38.0932 30.31 37.8832 29.94 37.3232 29.94C36.9732 29.94 36.6932 30.15 36.6932 30.43C36.6932 30.67 36.8732 30.82 37.1432 30.87L37.8432 31.02C38.8132 31.22 39.3032 31.81 39.3032 32.53C39.3032 33.33 38.6832 34.15 37.3932 34.15C35.9132 34.15 35.4032 33.19 35.3432 32.63ZM42.8111 27.86C42.5111 27.86 42.1211 27.99 42.1211 28.54V29.08H43.2311V30.22H42.1211V34H40.7811V30.22H39.9611V29.08H40.7811V28.52C40.7811 27.41 41.4811 26.69 42.5711 26.69C42.8511 26.69 43.1211 26.74 43.2311 26.79V27.91C43.1611 27.89 43.0311 27.86 42.8111 27.86ZM45.0728 30.98H47.2728C47.2528 30.49 46.9328 30.01 46.1728 30.01C45.4828 30.01 45.1028 30.53 45.0728 30.98ZM47.4028 32.26L48.5128 32.59C48.2628 33.44 47.4828 34.15 46.2728 34.15C44.9228 34.15 43.7328 33.18 43.7328 31.52C43.7328 29.95 44.8928 28.93 46.1528 28.93C47.6728 28.93 48.5828 29.9 48.5828 31.48C48.5828 31.67 48.5628 31.87 48.5628 31.89H45.0428C45.0728 32.54 45.6228 33.01 46.2828 33.01C46.9028 33.01 47.2428 32.7 47.4028 32.26ZM52.6575 29.06V30.4C52.5075 30.37 52.3775 30.36 52.2575 30.36C51.5775 30.36 50.9875 30.69 50.9875 31.75V34H49.6575V29.08H50.9475V29.81C51.2475 29.16 51.9275 29.04 52.3475 29.04C52.4575 29.04 52.5575 29.05 52.6575 29.06Z\" fill=\"#8334C2\"/>\n</svg>\n';
var $author$project$Pyxis$Components$Logos$LogoSet$svgWireTransferEs = '<svg width=\"70\" height=\"48\" viewBox=\"0 0 70 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect x=\"0.5\" y=\"0.5\" width=\"69\" height=\"47\" rx=\"7.5\" fill=\"#F2EAF8\" stroke=\"#DDDEE1\"/>\n<path d=\"M11.946 15.798H9.93004V21H8.67904V15.798H6.66304V14.619H11.946V15.798ZM14.665 16.554V17.76C14.53 17.733 14.413 17.724 14.305 17.724C13.693 17.724 13.162 18.021 13.162 18.975V21H11.965V16.572H13.126V17.229C13.396 16.644 14.008 16.536 14.386 16.536C14.485 16.536 14.575 16.545 14.665 16.554ZM15.1933 19.794C15.1933 19.002 15.7783 18.561 16.5163 18.453L17.6053 18.291C17.8573 18.255 17.9383 18.129 17.9383 17.976C17.9383 17.661 17.6953 17.4 17.1913 17.4C16.6693 17.4 16.3813 17.733 16.3453 18.12L15.2833 17.895C15.3553 17.202 15.9943 16.437 17.1823 16.437C18.5863 16.437 19.1083 17.229 19.1083 18.12V20.298C19.1083 20.532 19.1353 20.847 19.1623 21H18.0643C18.0373 20.883 18.0193 20.64 18.0193 20.469C17.7943 20.82 17.3713 21.126 16.7143 21.126C15.7693 21.126 15.1933 20.487 15.1933 19.794ZM16.9663 20.235C17.4703 20.235 17.9383 19.992 17.9383 19.209V19.011L16.9393 19.164C16.6333 19.209 16.3903 19.38 16.3903 19.722C16.3903 19.983 16.5793 20.235 16.9663 20.235ZM21.4941 18.453V21H20.2971V16.572H21.4581V17.121C21.7281 16.662 22.2591 16.455 22.7361 16.455C23.8341 16.455 24.3381 17.238 24.3381 18.21V21H23.1411V18.417C23.1411 17.922 22.8981 17.535 22.3221 17.535C21.8001 17.535 21.4941 17.94 21.4941 18.453ZM25.2208 19.767L26.2468 19.542C26.2738 19.893 26.5348 20.217 27.0568 20.217C27.4528 20.217 27.6418 20.01 27.6418 19.776C27.6418 19.578 27.5068 19.416 27.1648 19.344L26.5798 19.209C25.7248 19.02 25.3378 18.507 25.3378 17.886C25.3378 17.094 26.0398 16.437 26.9938 16.437C28.2538 16.437 28.6768 17.238 28.7308 17.715L27.7318 17.94C27.6958 17.679 27.5068 17.346 27.0028 17.346C26.6878 17.346 26.4358 17.535 26.4358 17.787C26.4358 18.003 26.5978 18.138 26.8408 18.183L27.4708 18.318C28.3438 18.498 28.7848 19.029 28.7848 19.677C28.7848 20.397 28.2268 21.135 27.0658 21.135C25.7338 21.135 25.2748 20.271 25.2208 19.767ZM31.9419 15.474C31.6719 15.474 31.3209 15.591 31.3209 16.086V16.572H32.3199V17.598H31.3209V21H30.1149V17.598H29.3769V16.572H30.1149V16.068C30.1149 15.069 30.7449 14.421 31.7259 14.421C31.9779 14.421 32.2209 14.466 32.3199 14.511V15.519C32.2569 15.501 32.1399 15.474 31.9419 15.474ZM33.9774 18.282H35.9574C35.9394 17.841 35.6514 17.409 34.9674 17.409C34.3464 17.409 34.0044 17.877 33.9774 18.282ZM36.0744 19.434L37.0734 19.731C36.8484 20.496 36.1464 21.135 35.0574 21.135C33.8424 21.135 32.7714 20.262 32.7714 18.768C32.7714 17.355 33.8154 16.437 34.9494 16.437C36.3174 16.437 37.1364 17.31 37.1364 18.732C37.1364 18.903 37.1184 19.083 37.1184 19.101H33.9504C33.9774 19.686 34.4724 20.109 35.0664 20.109C35.6244 20.109 35.9304 19.83 36.0744 19.434ZM40.8037 16.554V17.76C40.6687 17.733 40.5517 17.724 40.4437 17.724C39.8317 17.724 39.3007 18.021 39.3007 18.975V21H38.1037V16.572H39.2647V17.229C39.5347 16.644 40.1467 16.536 40.5247 16.536C40.6237 16.536 40.7137 16.545 40.8037 16.554ZM42.4852 18.282H44.4652C44.4472 17.841 44.1592 17.409 43.4752 17.409C42.8542 17.409 42.5122 17.877 42.4852 18.282ZM44.5822 19.434L45.5812 19.731C45.3562 20.496 44.6542 21.135 43.5652 21.135C42.3502 21.135 41.2792 20.262 41.2792 18.768C41.2792 17.355 42.3232 16.437 43.4572 16.437C44.8252 16.437 45.6442 17.31 45.6442 18.732C45.6442 18.903 45.6262 19.083 45.6262 19.101H42.4582C42.4852 19.686 42.9802 20.109 43.5742 20.109C44.1322 20.109 44.4382 19.83 44.5822 19.434ZM47.8085 18.453V21H46.6115V16.572H47.7725V17.121C48.0425 16.662 48.5735 16.455 49.0505 16.455C50.1485 16.455 50.6525 17.238 50.6525 18.21V21H49.4555V18.417C49.4555 17.922 49.2125 17.535 48.6365 17.535C48.1145 17.535 47.8085 17.94 47.8085 18.453ZM53.8842 17.544C53.2722 17.544 52.7592 17.985 52.7592 18.786C52.7592 19.587 53.2812 20.037 53.8932 20.037C54.5052 20.037 54.8112 19.632 54.9102 19.29L55.9632 19.641C55.7652 20.379 55.0722 21.135 53.8932 21.135C52.5882 21.135 51.5622 20.145 51.5622 18.786C51.5622 17.418 52.5702 16.437 53.8572 16.437C55.0632 16.437 55.7472 17.184 55.9362 17.931L54.8652 18.291C54.7572 17.922 54.4782 17.544 53.8842 17.544ZM58.0302 21H56.8332V16.572H58.0302V21ZM56.6892 15.123C56.6892 14.709 57.0222 14.376 57.4272 14.376C57.8412 14.376 58.1652 14.709 58.1652 15.123C58.1652 15.519 57.8412 15.852 57.4272 15.852C57.0222 15.852 56.6892 15.519 56.6892 15.123ZM58.9892 19.794C58.9892 19.002 59.5742 18.561 60.3122 18.453L61.4012 18.291C61.6532 18.255 61.7342 18.129 61.7342 17.976C61.7342 17.661 61.4912 17.4 60.9872 17.4C60.4652 17.4 60.1772 17.733 60.1412 18.12L59.0792 17.895C59.1512 17.202 59.7902 16.437 60.9782 16.437C62.3822 16.437 62.9042 17.229 62.9042 18.12V20.298C62.9042 20.532 62.9312 20.847 62.9582 21H61.8602C61.8332 20.883 61.8152 20.64 61.8152 20.469C61.5902 20.82 61.1672 21.126 60.5102 21.126C59.5652 21.126 58.9892 20.487 58.9892 19.794ZM60.7622 20.235C61.2662 20.235 61.7342 19.992 61.7342 19.209V19.011L60.7352 19.164C60.4292 19.209 60.1862 19.38 60.1862 19.722C60.1862 19.983 60.3752 20.235 60.7622 20.235ZM18.6807 33H17.5197V26.484H18.6987V29.058C18.8967 28.743 19.3827 28.455 20.0397 28.455C21.3357 28.455 22.0827 29.454 22.0827 30.768C22.0827 32.109 21.2547 33.108 19.9947 33.108C19.3827 33.108 18.9147 32.838 18.6807 32.46V33ZM20.8857 30.777C20.8857 29.967 20.3997 29.526 19.7877 29.526C19.1847 29.526 18.6807 29.967 18.6807 30.777C18.6807 31.578 19.1847 32.037 19.7877 32.037C20.3997 32.037 20.8857 31.587 20.8857 30.777ZM22.787 31.794C22.787 31.002 23.372 30.561 24.11 30.453L25.199 30.291C25.451 30.255 25.532 30.129 25.532 29.976C25.532 29.661 25.289 29.4 24.785 29.4C24.263 29.4 23.975 29.733 23.939 30.12L22.877 29.895C22.949 29.202 23.588 28.437 24.776 28.437C26.18 28.437 26.702 29.229 26.702 30.12V32.298C26.702 32.532 26.729 32.847 26.756 33H25.658C25.631 32.883 25.613 32.64 25.613 32.469C25.388 32.82 24.965 33.126 24.308 33.126C23.363 33.126 22.787 32.487 22.787 31.794ZM24.56 32.235C25.064 32.235 25.532 31.992 25.532 31.209V31.011L24.533 31.164C24.227 31.209 23.984 31.38 23.984 31.722C23.984 31.983 24.173 32.235 24.56 32.235ZM29.0878 30.453V33H27.8908V28.572H29.0518V29.121C29.3218 28.662 29.8528 28.455 30.3298 28.455C31.4278 28.455 31.9318 29.238 31.9318 30.21V33H30.7348V30.417C30.7348 29.922 30.4918 29.535 29.9158 29.535C29.3938 29.535 29.0878 29.94 29.0878 30.453ZM35.1635 29.544C34.5515 29.544 34.0385 29.985 34.0385 30.786C34.0385 31.587 34.5605 32.037 35.1725 32.037C35.7845 32.037 36.0905 31.632 36.1895 31.29L37.2425 31.641C37.0445 32.379 36.3515 33.135 35.1725 33.135C33.8675 33.135 32.8415 32.145 32.8415 30.786C32.8415 29.418 33.8495 28.437 35.1365 28.437C36.3425 28.437 37.0265 29.184 37.2155 29.931L36.1445 30.291C36.0365 29.922 35.7575 29.544 35.1635 29.544ZM37.8515 31.794C37.8515 31.002 38.4365 30.561 39.1745 30.453L40.2635 30.291C40.5155 30.255 40.5965 30.129 40.5965 29.976C40.5965 29.661 40.3535 29.4 39.8495 29.4C39.3275 29.4 39.0395 29.733 39.0035 30.12L37.9415 29.895C38.0135 29.202 38.6525 28.437 39.8405 28.437C41.2445 28.437 41.7665 29.229 41.7665 30.12V32.298C41.7665 32.532 41.7935 32.847 41.8205 33H40.7225C40.6955 32.883 40.6775 32.64 40.6775 32.469C40.4525 32.82 40.0295 33.126 39.3725 33.126C38.4275 33.126 37.8515 32.487 37.8515 31.794ZM39.6245 32.235C40.1285 32.235 40.5965 31.992 40.5965 31.209V31.011L39.5975 31.164C39.2915 31.209 39.0485 31.38 39.0485 31.722C39.0485 31.983 39.2375 32.235 39.6245 32.235ZM45.6553 28.554V29.76C45.5203 29.733 45.4033 29.724 45.2953 29.724C44.6833 29.724 44.1523 30.021 44.1523 30.975V33H42.9553V28.572H44.1163V29.229C44.3863 28.644 44.9983 28.536 45.3763 28.536C45.4753 28.536 45.5653 28.545 45.6553 28.554ZM47.6415 33H46.4445V28.572H47.6415V33ZM46.3005 27.123C46.3005 26.709 46.6335 26.376 47.0385 26.376C47.4525 26.376 47.7765 26.709 47.7765 27.123C47.7765 27.519 47.4525 27.852 47.0385 27.852C46.6335 27.852 46.3005 27.519 46.3005 27.123ZM48.6005 31.794C48.6005 31.002 49.1855 30.561 49.9235 30.453L51.0125 30.291C51.2645 30.255 51.3455 30.129 51.3455 29.976C51.3455 29.661 51.1025 29.4 50.5985 29.4C50.0765 29.4 49.7885 29.733 49.7525 30.12L48.6905 29.895C48.7625 29.202 49.4015 28.437 50.5895 28.437C51.9935 28.437 52.5155 29.229 52.5155 30.12V32.298C52.5155 32.532 52.5425 32.847 52.5695 33H51.4715C51.4445 32.883 51.4265 32.64 51.4265 32.469C51.2015 32.82 50.7785 33.126 50.1215 33.126C49.1765 33.126 48.6005 32.487 48.6005 31.794ZM50.3735 32.235C50.8775 32.235 51.3455 31.992 51.3455 31.209V31.011L50.3465 31.164C50.0405 31.209 49.7975 31.38 49.7975 31.722C49.7975 31.983 49.9865 32.235 50.3735 32.235Z\" fill=\"#8334C2\"/>\n</svg>\n';
var $author$project$Pyxis$Components$Logos$LogoSet$svgWireTransferIt = '<svg width=\"70\" height=\"48\" viewBox=\"0 0 70 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect x=\"0.5\" y=\"0.5\" width=\"69\" height=\"47\" rx=\"7.5\" fill=\"#F2EAF8\" stroke=\"#DDDEE1\"/>\n<path d=\"M16.0722 20.91H18.6222C20.0022 20.91 20.7822 21.72 20.7822 22.82C20.7822 23.55 20.3422 24.14 19.7522 24.34C20.4422 24.51 21.0022 25.14 21.0022 26.02C21.0022 27.17 20.1422 28 18.8122 28H16.0722V20.91ZM17.4322 23.84H18.4122C19.0422 23.84 19.4222 23.49 19.4222 22.95C19.4222 22.41 19.0722 22.07 18.4022 22.07H17.4322V23.84ZM17.4322 26.85H18.5522C19.2222 26.85 19.6222 26.5 19.6222 25.93C19.6222 25.37 19.2622 24.98 18.5722 24.98H17.4322V26.85ZM24.4034 26.94C25.0534 26.94 25.6534 26.47 25.6534 25.54C25.6534 24.61 25.0534 24.14 24.4034 24.14C23.7534 24.14 23.1534 24.61 23.1534 25.54C23.1534 26.46 23.7534 26.94 24.4034 26.94ZM24.4034 22.93C25.8734 22.93 26.9834 24.02 26.9834 25.54C26.9834 27.05 25.8734 28.15 24.4034 28.15C22.9334 28.15 21.8234 27.05 21.8234 25.54C21.8234 24.02 22.9334 22.93 24.4034 22.93ZM29.3713 25.17V28H28.0413V23.08H29.3313V23.69C29.6313 23.18 30.2213 22.95 30.7513 22.95C31.9713 22.95 32.5313 23.82 32.5313 24.9V28H31.2013V25.13C31.2013 24.58 30.9313 24.15 30.2913 24.15C29.7113 24.15 29.3713 24.6 29.3713 25.17ZM35.1721 28H33.8421V23.08H35.1721V28ZM33.6821 21.47C33.6821 21.01 34.0521 20.64 34.5021 20.64C34.9621 20.64 35.3221 21.01 35.3221 21.47C35.3221 21.91 34.9621 22.28 34.5021 22.28C34.0521 22.28 33.6821 21.91 33.6821 21.47ZM40.2777 24.22H38.3077V28H36.9677V24.22H36.1477V23.08H36.9677V22.52C36.9677 21.41 37.6677 20.69 38.7577 20.69C39.0377 20.69 39.3077 20.74 39.4177 20.79V21.91C39.3477 21.89 39.2177 21.86 38.9977 21.86C38.7077 21.86 38.3077 21.99 38.3077 22.54V23.08H41.5977V28H40.2777V24.22ZM40.1177 21.46C40.1177 21 40.4877 20.63 40.9377 20.63C41.3877 20.63 41.7577 21 41.7577 21.46C41.7577 21.91 41.3877 22.27 40.9377 22.27C40.4877 22.27 40.1177 21.91 40.1177 21.46ZM45.2432 24.16C44.5632 24.16 43.9932 24.65 43.9932 25.54C43.9932 26.43 44.5732 26.93 45.2532 26.93C45.9332 26.93 46.2732 26.48 46.3832 26.1L47.5532 26.49C47.3332 27.31 46.5632 28.15 45.2532 28.15C43.8032 28.15 42.6632 27.05 42.6632 25.54C42.6632 24.02 43.7832 22.93 45.2132 22.93C46.5532 22.93 47.3132 23.76 47.5232 24.59L46.3332 24.99C46.2132 24.58 45.9032 24.16 45.2432 24.16ZM50.7998 26.94C51.4498 26.94 52.0498 26.47 52.0498 25.54C52.0498 24.61 51.4498 24.14 50.7998 24.14C50.1498 24.14 49.5498 24.61 49.5498 25.54C49.5498 26.46 50.1498 26.94 50.7998 26.94ZM50.7998 22.93C52.2698 22.93 53.3798 24.02 53.3798 25.54C53.3798 27.05 52.2698 28.15 50.7998 28.15C49.3298 28.15 48.2198 27.05 48.2198 25.54C48.2198 24.02 49.3298 22.93 50.7998 22.93Z\" fill=\"#8334C2\"/>\n</svg>\n';
var $author$project$Pyxis$Components$Logos$LogoSet$toString = function (logo) {
	switch (logo) {
		case 0:
			return $author$project$Pyxis$Components$Logos$LogoSet$svgWireTransferIt;
		case 1:
			return $author$project$Pyxis$Components$Logos$LogoSet$svgWireTransferEs;
		case 2:
			return $author$project$Pyxis$Components$Logos$LogoSet$svgWireTransferEn;
		case 3:
			return $author$project$Pyxis$Components$Logos$LogoSet$svgVisa;
		case 4:
			return $author$project$Pyxis$Components$Logos$LogoSet$svgTrustpilot;
		case 5:
			return $author$project$Pyxis$Components$Logos$LogoSet$svgPrima;
		case 6:
			return $author$project$Pyxis$Components$Logos$LogoSet$svgPrimaMonogram;
		case 7:
			return $author$project$Pyxis$Components$Logos$LogoSet$svgPostepay;
		case 8:
			return $author$project$Pyxis$Components$Logos$LogoSet$svgPaypal;
		case 9:
			return $author$project$Pyxis$Components$Logos$LogoSet$svgMastercard;
		case 10:
			return $author$project$Pyxis$Components$Logos$LogoSet$svgMaestro;
		case 11:
			return $author$project$Pyxis$Components$Logos$LogoSet$svgGooglePay;
		case 12:
			return $author$project$Pyxis$Components$Logos$LogoSet$svgApplePay;
		default:
			return $author$project$Pyxis$Components$Logos$LogoSet$svgAmericanExpress;
	}
};
var $author$project$Pyxis$Components$Logos$PrimaLogo$getPrimaLogoSvg = function (variant) {
	if (!variant) {
		return $author$project$Pyxis$Components$Logos$LogoSet$toString($author$project$Pyxis$Components$Logos$LogoSet$prima);
	} else {
		return $author$project$Pyxis$Components$Logos$LogoSet$toString($author$project$Pyxis$Components$Logos$LogoSet$primaMonogram);
	}
};
var $author$project$Pyxis$Components$Logos$PrimaLogo$render = function (configuration) {
	var variant = configuration.i_;
	return $author$project$Pyxis$Commons$Render$renderMaybe(
		A2(
			$elm$core$Maybe$map,
			$author$project$Pyxis$Components$Logos$PrimaLogo$buildSvg(configuration),
			$elm$core$Result$toMaybe(
				$Garados007$elm_svg_parser$SvgParser$parseToNodes(
					$author$project$Pyxis$Components$Logos$PrimaLogo$getPrimaLogoSvg(variant)))));
};
var $author$project$Pyxis$Components$Logos$PrimaLogo$withVariant = F2(
	function (variant, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{i_: variant});
	});
var $author$project$Pyxis$Components$NavigationSidebar$defaultCollapsedLogo = $author$project$Pyxis$Components$Logos$PrimaLogo$render(
	A2($author$project$Pyxis$Components$Logos$PrimaLogo$withVariant, $author$project$Pyxis$Components$Logos$PrimaLogo$monogramVariant, $author$project$Pyxis$Components$Logos$PrimaLogo$config));
var $author$project$Pyxis$Components$NavigationSidebar$defaultExpandedLogo = $author$project$Pyxis$Components$Logos$PrimaLogo$render($author$project$Pyxis$Components$Logos$PrimaLogo$config);
var $author$project$Pyxis$Components$NavigationSidebar$pickLogosFromConfig = function (logoConfig) {
	if (!logoConfig.$) {
		return _Utils_Tuple2($author$project$Pyxis$Components$NavigationSidebar$defaultCollapsedLogo, $author$project$Pyxis$Components$NavigationSidebar$defaultExpandedLogo);
	} else {
		var collapsedLogo = logoConfig.a;
		var expandedLogo = logoConfig.b;
		return _Utils_Tuple2(collapsedLogo, expandedLogo);
	}
};
var $author$project$Pyxis$Components$NavigationSidebar$renderLogos = function (logoConfig) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('side-panel__logo-wrapper')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-panel__logo side-panel__logo--collapsed')
					]),
				_List_fromArray(
					[
						$author$project$Pyxis$Components$NavigationSidebar$pickLogosFromConfig(logoConfig).a
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-panel__logo side-panel__logo--expanded')
					]),
				_List_fromArray(
					[
						$author$project$Pyxis$Components$NavigationSidebar$pickLogosFromConfig(logoConfig).b
					]))
			]));
};
var $author$project$Pyxis$Components$NavigationSidebar$renderHeader = F3(
	function (tagger, model, _v0) {
		var logo = _v0.hc;
		var classList = _v0.f6;
		var id = _v0.kg;
		var testId = _v0.fv;
		var dataAttrList = _v0.ej;
		return A2(
			$elm$html$Html$div,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-panel__header-wrapper'),
						$elm$html$Html$Attributes$classList(classList),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('side-panel__toggle', true),
									_Utils_Tuple2(
									'side-panel__toggle--opened',
									$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model))
								])),
							$elm$html$Html$Events$onClick(
							tagger($author$project$Pyxis$Components$NavigationSidebar$ToggleExpand))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-panel__toggle__line')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-panel__toggle__line')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-panel__toggle__line')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sr-only')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close Sidebar')
								]))
						])),
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2($elm$core$Maybe$map, $author$project$Pyxis$Components$NavigationSidebar$renderLogos, logo))
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$render = F3(
	function (tagger, model, _v0) {
		var headerConfig = _v0.gO;
		var contentConfig = _v0.gc;
		var footerConfig = _v0.gD;
		var badgeAccessibilityLabel = _v0.fZ;
		var id = _v0.kg;
		var classList = _v0.f6;
		var testId = _v0.fv;
		var dataAttrList = _v0.ej;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-panel-scrollable-wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$header,
					A2(
						$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
						dataAttrList,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('side-panel', true),
										_Utils_Tuple2(
										'side-panel--opened',
										$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model)),
										_Utils_Tuple2(
										'side-panel--collapsed',
										!$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model))
									])),
								$elm$html$Html$Attributes$classList(classList),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
							])),
					_List_fromArray(
						[
							A3($author$project$Pyxis$Components$NavigationSidebar$renderHeader, tagger, model, headerConfig),
							A4($author$project$Pyxis$Components$NavigationSidebar$renderContent, tagger, badgeAccessibilityLabel, model, contentConfig),
							$author$project$Pyxis$Commons$Render$renderMaybe(
							A2(
								$elm$core$Maybe$map,
								$author$project$Pyxis$Components$NavigationSidebar$renderFooter(
									$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model)),
								footerConfig)),
							$author$project$Pyxis$Components$NavigationSidebar$overlay(tagger)
						]))
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{f6: classList});
	});
var $author$project$Pyxis$Components$NavigationSidebar$withFooter = F2(
	function (footerConfig, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				gD: $elm$core$Maybe$Just(footerConfig)
			});
	});
var $author$project$Pyxis$Components$NavigationSidebar$withHeader = F2(
	function (headerConfig, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{gO: headerConfig});
	});
var $author$project$Pyxis$Components$NavigationSidebar$withHeaderLogo = F2(
	function (logo, _v0) {
		var headerConfig = _v0;
		return _Utils_update(
			headerConfig,
			{
				hc: $elm$core$Maybe$Just(logo)
			});
	});
var $author$project$Main$navigationSidebar = function (model) {
	var headerConfiguration = A2($author$project$Pyxis$Components$NavigationSidebar$withHeaderLogo, $author$project$Pyxis$Components$NavigationSidebar$primaLogo, $author$project$Pyxis$Components$NavigationSidebar$header);
	var footerConfiguration = A3($author$project$Pyxis$Components$NavigationSidebar$footer, '', '', $author$project$Msg$Logout);
	return A3(
		$author$project$Pyxis$Components$NavigationSidebar$render,
		$author$project$Msg$NavigationSidebarMsg,
		model.nR,
		A2(
			$author$project$Pyxis$Components$NavigationSidebar$withFooter,
			footerConfiguration,
			A2(
				$author$project$Pyxis$Components$NavigationSidebar$withHeader,
				headerConfiguration,
				A2(
					$author$project$Pyxis$Components$NavigationSidebar$withClassList,
					_List_fromArray(
						[
							_Utils_Tuple2('main-header-navigation', true)
						]),
					$author$project$Pyxis$Components$NavigationSidebar$config))));
};
var $author$project$Main$addHeaderToBody = F2(
	function (model, _v0) {
		var title = _v0.iS;
		var body = _v0.f$;
		var container = _List_fromArray(
			[
				A2(
				$elm$html$Html$main_,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container--with-sidebar')
					]),
				body)
			]);
		return {
			f$: A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						$author$project$Main$navigationSidebar(model)
					]),
				container),
			iS: title
		};
	});
var $elm$browser$Browser$Document = F2(
	function (title, body) {
		return {f$: body, iS: title};
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Main$mapDocument = F2(
	function (msgMapper, _v0) {
		var title = _v0.iS;
		var body = _v0.f$;
		return A2(
			$elm$browser$Browser$Document,
			title,
			A2(
				$elm$core$List$map,
				$elm$html$Html$map(msgMapper),
				body));
	});
var $author$project$Translations$routeLogin = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Login';
	} else {
		return 'Ingresar';
	}
};
var $author$project$Pyxis$Components$Button$Full = 1;
var $author$project$Pyxis$Components$Button$full = function (_v0) {
	var configuration = _v0;
	return _Utils_update(
		configuration,
		{dR: 1});
};
var $author$project$Pyxis$Components$Button$Link = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Pyxis$Components$Button$NoOp = 2;
var $author$project$Pyxis$Components$Button$link = function (href) {
	return A3($author$project$Pyxis$Components$Button$Link, href, $elm$core$Maybe$Nothing, 2);
};
var $author$project$Translations$loginButtonText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Login';
	} else {
		return 'Iniciar sesión';
	}
};
var $author$project$Translations$loginErrorText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Something went wrong.';
	} else {
		return 'Algo salió mal';
	}
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Page$Login$View$encodeReturnUrl = F2(
	function (env, returnRoute) {
		var _v0 = $author$project$Env$languageOverride(env);
		if (!_v0.$) {
			var languageOverride = _v0.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				A2(
					$elm$core$List$cons,
					$author$project$Translations$languageToString(languageOverride),
					$author$project$Route$routeToPieces(returnRoute)),
				_List_Nil);
		} else {
			return A2(
				$elm$url$Url$Builder$absolute,
				$author$project$Route$routeToPieces(returnRoute),
				_List_Nil);
		}
	});
var $author$project$Env$loginPath = function (_v0) {
	var environment = _v0;
	return environment.c4;
};
var $author$project$Page$Login$View$loginLink = F2(
	function (env, returnRoute) {
		return _Utils_ap(
			$author$project$Env$newApiUrl(env),
			_Utils_ap(
				$author$project$Env$loginPath(env),
				A2($author$project$Page$Login$View$encodeReturnUrl, env, returnRoute)));
	});
var $elm$svg$Svg$clipPath = $elm$svg$Svg$trustedNode('clipPath');
var $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute('clip-path');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Common$ComponentUI$Illustrations$primaLogo = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('194'),
			$elm$svg$Svg$Attributes$height('80'),
			$elm$svg$Svg$Attributes$viewBox('0 0 194 80'),
			$elm$svg$Svg$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$clipPath('url(#clip0_38_4221)')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M105.516 7.15611C104.159 7.46915 103.26 8.7576 103.432 10.1396C103.54 18.3799 103.485 26.6126 103.485 34.8453C103.485 35.4847 103.504 36.1127 103.466 36.7464C103.357 38.8938 102.172 40.209 100.372 40.2262C99.4404 40.2434 98.5451 39.8692 97.9057 39.1935C97.2701 38.5235 96.9494 37.613 97.0276 36.693C96.9914 26.7653 96.9723 16.8357 97.083 6.90796C97.1593 5.7894 97.7167 4.75865 98.6119 4.08484C105.171 -0.316872 113.466 -1.22546 120.821 1.65302C122.323 2.41081 123.739 3.32704 125.049 4.38834C128.582 1.50604 133.02 -0.0286422 137.58 0.0515276C147.057 0.087795 152.255 4.33107 152.669 13.249C153.047 21.1171 152.813 29.0196 152.778 36.9068C152.843 37.7925 152.522 38.6629 151.898 39.2928C151.268 39.9284 150.4 40.2682 149.506 40.2262C148.655 40.2071 147.846 39.854 147.256 39.2412C146.67 38.6323 146.353 37.8134 146.378 36.9698C146.288 31.1956 146.323 25.4272 146.307 19.6531C146.307 17.9657 146.361 16.2802 146.252 14.5833C145.803 7.54932 141.119 4.37116 133.86 6.21888C132.516 6.62164 131.233 7.20764 130.048 7.95781C128.706 8.68124 127.922 10.1319 128.053 11.6513C128.162 20.0348 128.124 28.3992 128.088 36.7827C128.181 37.6569 127.895 38.5312 127.301 39.1802C126.704 39.8349 125.858 40.209 124.971 40.209C124.085 40.2185 123.236 39.8654 122.615 39.2317C122.001 38.6037 121.674 37.7486 121.716 36.8705C121.68 36.3017 121.697 35.7519 121.697 35.1831V15.9824C121.697 15.1998 121.716 14.4363 121.644 13.6575C121.105 8.41783 117.885 5.64624 112.258 5.84285C109.962 5.95738 107.692 6.39831 105.52 7.15611H105.516Z'),
							$elm$svg$Svg$Attributes$fill('#8334C2')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M57.2042 8.97137C57.7387 3.76987 61.4532 0.545899 66.9143 0.0648796C69.9493 -0.106913 72.9977 0.041974 76.0021 0.509632C78.287 0.794044 79.3921 2.30773 79.0543 3.94739C78.7164 5.58706 77.1073 6.4403 74.8683 6.22651C72.8869 5.95737 70.8865 5.81993 68.8861 5.81612C65.3701 5.97646 63.5472 7.68484 63.4269 11.0176C63.2666 15.8793 63.32 20.743 63.3009 25.6219C63.2818 29.0711 63.32 32.6559 63.2818 36.1127C63.2627 38.7297 62.1385 40.1746 60.159 40.2281C58.0345 40.2987 56.769 38.8041 56.769 36.1471C56.7499 32.0489 56.769 27.8476 56.769 23.7513C56.874 23.7513 56.6774 13.8484 57.2023 8.96947L57.2042 8.97137Z'),
							$elm$svg$Svg$Attributes$fill('#8334C2')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M90.3506 20.974C90.3506 26.1507 90.3697 31.3235 90.3506 36.5002C90.3315 38.8729 89.1232 40.2128 87.0732 40.23C84.899 40.2472 83.6029 38.8366 83.6029 36.4143C83.5839 26.2022 83.5839 25.2726 83.6029 15.0758C83.6029 12.5141 84.7387 11.1913 86.9128 11.1723C89.2015 11.1379 90.3372 12.4626 90.3563 15.1617C90.3506 20.1837 90.3506 15.9347 90.3506 20.974Z'),
							$elm$svg$Svg$Attributes$fill('#8334C2')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M86.8518 6.70181C85.0976 6.62355 83.6851 5.16713 83.5858 3.33277C83.6755 1.46977 85.1396 0.00571518 86.9224 -0.00382885C88.7052 -0.0133729 90.1827 1.43541 90.2915 3.29459C90.1941 5.20531 88.6823 6.70181 86.8518 6.6999V6.70181Z'),
							$elm$svg$Svg$Attributes$fill('#8334C2')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M47.0895 12.0286C46.0873 5.62077 41.6856 1.59319 34.98 0.388736C31.8457 -0.168635 28.6332 -0.132368 25.5123 0.497538C24.1399 0.715142 23.1282 1.89288 23.1206 3.28058C23.1416 4.89925 24.4396 6.20869 26.0582 6.24305C26.2777 6.23923 26.4972 6.20869 26.7091 6.15333C28.8355 5.63223 31.0478 5.55969 33.2029 5.93764C38.2364 6.8176 40.7713 9.56628 41.2981 15.6C41.5997 19.4978 41.5062 23.4147 41.0156 27.2934C40.4773 32.073 37.3221 34.6938 32.3745 35.1252C28.637 35.4077 24.8862 34.7358 21.4809 33.1687C20.5036 32.8862 19.8775 31.9337 20.0035 30.9239C20.0913 27.4461 20.0397 23.953 20.0397 20.4713C20.0397 17.652 20.0035 14.8136 20.0569 11.9924V7.05047C20.0111 5.32873 18.612 3.95439 16.8902 3.93912C16.3901 3.92003 15.8919 4.01165 15.43 4.20826C11.788 5.8422 9.18246 7.22417 3.19835 10.4329C0.944044 11.6889 0.327499 13.5194 1.3678 15.2793C2.33556 16.9495 4.09548 17.2359 6.22571 16.0696C8.6709 14.7277 11.1657 13.4335 13.7063 12.1909C13.7579 25.4113 13.7235 42.2603 13.7426 55.0321V55.1581H13.7598C13.8609 56.8875 15.346 58.2084 17.0773 58.1053C18.6654 58.0118 19.9309 56.7462 20.0245 55.1581H20.0417C20.0588 51.4779 20.0417 45.0892 20.0417 39.0821C23.5596 39.7464 26.7473 40.6092 29.9846 40.8955C38.9522 41.6858 46.1045 36.7286 47.3376 28.1237C48.0534 22.7771 47.9694 17.3523 47.0875 12.0286H47.0895Z'),
							$elm$svg$Svg$Attributes$fill('#8334C2')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M192.958 11.8689C192.957 6.48992 189.084 1.86488 183.71 0.818854C177.486 -0.654746 170.954 -0.137459 165.04 2.29818C164.214 2.48715 163.506 3.0178 163.095 3.76033C162.691 4.49522 162.626 5.37136 162.92 6.15779C163.494 7.58558 165.201 8.11432 167.337 7.49777C170.958 6.39257 174.716 5.79321 178.501 5.71685C183.224 5.75312 185.9 7.99024 186.554 12.0808C186.661 12.8214 186.698 13.5716 186.663 14.3179H186.682L186.736 22.3025V22.7091C186.736 25.5837 186.825 28.2083 186.665 30.8177C186.56 31.6766 186.072 32.4421 185.337 32.8983C180.796 35.1182 175.575 35.5095 170.753 33.9901C167.321 33.0376 165.309 29.4815 166.262 26.0495C166.886 23.8047 168.671 22.0677 170.937 21.5103C173.912 20.6208 177.058 20.4509 180.112 21.0159C180.267 21.0369 180.423 21.0484 180.578 21.0522C181.973 21.1095 183.153 20.0253 183.21 18.6299C183.264 17.3396 182.338 16.2172 181.063 16.0244C177.06 15.3201 172.956 15.4632 169.013 16.4463C163.051 18.084 159.621 22.1231 159.602 27.5326C159.293 33.2094 163.277 38.2468 168.957 39.3615C176.503 41.2054 184.466 40.1021 191.225 36.2769C192.17 35.708 192.812 34.7441 192.968 33.6503C193.119 26.4102 193.209 19.13 192.958 11.8689Z'),
							$elm$svg$Svg$Attributes$fill('#8334C2')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M54.3849 77.8373V61.9694C54.3849 61.3891 54.5624 60.9253 54.9194 60.5798C55.2744 60.2343 55.7516 60.0606 56.351 60.0606H62.5851C64.3641 60.0606 65.7404 60.5474 66.7139 61.5208C67.7064 62.5134 68.2027 63.7102 68.2027 65.1151C68.2027 67.4172 67.3228 68.8774 65.5629 69.4958V69.5531C66.5554 69.7974 67.3361 70.3204 67.9088 71.126C68.4795 71.9315 68.7658 72.9336 68.7658 74.1304C68.7658 75.9839 68.2409 77.383 67.193 78.3298C66.1431 79.2747 64.7115 79.748 62.8963 79.748H56.3529C55.7535 79.748 55.2763 79.5705 54.9213 79.2136C54.5643 78.8585 54.3868 78.3985 54.3868 77.8373H54.3849ZM56.6869 62.2786V68.4861H62.4439C64.7459 68.4861 65.8988 67.4572 65.8988 65.3976C65.8988 63.338 64.7478 62.2806 62.4439 62.2806H56.6869V62.2786ZM56.6869 70.6755V77.5281H62.5851C65.1315 77.5281 66.4046 76.3771 66.4046 74.0732C66.4046 73.0252 66.0859 72.1968 65.4502 71.5879C64.8127 70.979 63.9518 70.6755 62.8657 70.6755H56.6869Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M72.1902 75.2261C72.1902 73.8784 72.6904 72.7828 73.6925 71.941C74.6946 71.0992 76.0747 70.6774 77.8346 70.6774C78.9951 70.6774 80.3065 70.874 81.7667 71.2672V70.1162C81.7667 68.9919 81.4804 68.1749 80.9097 67.6596C80.3389 67.1442 79.4533 66.8865 78.2564 66.8865C77.3383 66.8865 76.2255 67.1308 74.9141 67.6176C74.7461 67.692 74.5495 67.7302 74.3243 67.7302C74.1372 67.7302 73.9502 67.6844 73.7631 67.5908C73.4443 67.3847 73.2859 67.1041 73.2859 66.7491C73.2859 66.2623 73.5283 65.9073 74.017 65.682C75.2711 65.0827 76.7599 64.783 78.4817 64.783C80.2034 64.783 81.6274 65.2182 82.5818 66.0886C83.5362 66.959 84.0134 68.2742 84.0134 70.0341V77.5052C84.0134 77.9175 83.855 78.2267 83.5362 78.4329C83.1048 78.7516 82.3279 79.1067 81.2055 79.4999C80.1767 79.8377 79.0429 80.0057 77.8079 80.0057C76.0289 80.0057 74.6488 79.5743 73.6658 78.7135C72.6827 77.8526 72.1922 76.692 72.1922 75.2318L72.1902 75.2261ZM74.4655 75.1688C74.4655 77.0222 75.6643 77.9499 78.0598 77.9499C79.8388 77.9499 81.0738 77.6044 81.7667 76.9115V73.2333C80.1939 72.821 78.8921 72.6148 77.8632 72.6148C76.8344 72.6148 76.0327 72.8439 75.4066 73.302C74.7786 73.7601 74.4655 74.3843 74.4655 75.1688Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M88.3387 74.327C88.2643 72.9794 88.2643 71.649 88.3387 70.3395C88.4132 68.7113 89.0412 67.3713 90.2208 66.3234C91.3814 65.2946 92.8512 64.7792 94.6302 64.7792C96.4092 64.7792 97.7568 65.2659 98.7875 66.2394C99.8355 67.1938 100.36 68.0833 100.36 68.9079C100.36 69.2458 100.257 69.5206 100.051 69.7363C99.845 69.952 99.5931 70.0589 99.2934 70.0589C98.7875 70.0589 98.423 69.8051 98.1977 69.3011C97.8789 68.5338 97.4075 67.944 96.7795 67.5317C96.1515 67.1194 95.4452 66.9132 94.6588 66.9132C93.4982 66.9132 92.5572 67.2358 91.8357 67.8829C91.1141 68.53 90.7076 69.3947 90.614 70.4808C90.5396 71.5287 90.5396 72.7656 90.614 74.1877C90.7076 75.2929 91.1141 76.1824 91.8357 76.8562C92.5572 77.53 93.4963 77.8679 94.6588 77.8679C95.4452 77.8679 96.161 77.6617 96.8081 77.2494C97.4533 76.8371 97.9362 76.2473 98.255 75.4799C98.4802 74.9741 98.8448 74.7221 99.3506 74.7221C99.6503 74.7221 99.9023 74.829 100.108 75.0447C100.315 75.2604 100.418 75.5353 100.418 75.8732C100.418 76.7149 99.8832 77.614 98.8162 78.5684C97.7663 79.5228 96.3729 80.0019 94.6321 80.0019C92.8912 80.0019 91.3642 79.4674 90.2227 78.4004C89.0431 77.2761 88.4151 75.919 88.3406 74.327H88.3387Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M104.516 78.6791V60.9577C104.516 60.639 104.623 60.3679 104.838 60.1427C105.054 59.9174 105.319 59.8048 105.638 59.8048C105.957 59.8048 106.228 59.9174 106.453 60.1427C106.679 60.3679 106.791 60.639 106.791 60.9577V71.0973H107.268C107.887 71.0973 108.41 70.8816 108.841 70.4521L114.092 65.285C114.318 65.0426 114.592 64.9204 114.921 64.9204C115.249 64.9204 115.514 65.033 115.721 65.2564C115.946 65.5179 116.058 65.7813 116.058 66.0428C116.058 66.3425 115.936 66.6135 115.694 66.8579L110.16 72.1662L115.778 77.8679C116.039 78.1675 116.171 78.4481 116.171 78.7096C116.171 78.9711 116.058 79.2441 115.833 79.5247C115.627 79.7499 115.36 79.8626 115.033 79.8626C114.707 79.8626 114.43 79.7404 114.205 79.498L108.841 73.993C108.393 73.5444 107.877 73.3192 107.297 73.3192H106.791V78.6829C106.791 79.0208 106.684 79.3014 106.469 79.5247C106.253 79.7499 105.978 79.8626 105.64 79.8626C105.34 79.8626 105.079 79.7461 104.854 79.5113C104.628 79.2766 104.516 79.0017 104.516 78.6829V78.6791Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M118.866 74.327C118.792 73.0176 118.792 71.6871 118.866 70.3395C118.941 68.7285 119.569 67.4 120.748 66.352C121.947 65.3041 123.407 64.7792 125.129 64.7792C126.851 64.7792 128.34 65.2946 129.483 66.3234C130.682 67.3713 131.317 68.7113 131.394 70.3395C131.506 71.6871 131.506 73.0176 131.394 74.327C131.319 75.9743 130.682 77.3315 129.483 78.4004C128.342 79.4674 126.889 80.0019 125.129 80.0019C123.369 80.0019 121.955 79.4674 120.777 78.4004C119.578 77.3334 118.943 75.9762 118.866 74.327ZM121.142 74.1877C121.235 75.2929 121.642 76.1824 122.363 76.8562C123.085 77.53 124.007 77.8679 125.129 77.8679C126.251 77.8679 127.175 77.53 127.895 76.8562C128.615 76.1824 129.023 75.2929 129.117 74.1877C129.191 72.9527 129.191 71.7253 129.117 70.5075C129.042 69.4214 128.649 68.551 127.937 67.8963C127.225 67.2415 126.29 66.9132 125.129 66.9132C123.969 66.9132 123.031 67.2415 122.321 67.8963C121.609 68.551 121.216 69.4214 121.142 70.5075C121.067 71.7253 121.067 72.9508 121.142 74.1877Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M135.578 65.4511H136.561V64.1588C136.561 62.7367 136.945 61.6182 137.712 60.8031C138.479 59.9881 139.565 59.5815 140.97 59.5815C141.944 59.5815 142.768 59.6846 143.442 59.8907C144.041 60.0587 144.341 60.4156 144.341 60.9577C144.341 61.2383 144.244 61.4769 144.047 61.6735C143.851 61.8701 143.583 61.9675 143.247 61.9675C143.154 61.9675 142.822 61.9255 142.251 61.8415C141.68 61.7575 141.272 61.7155 141.029 61.7155C139.569 61.7155 138.838 62.5859 138.838 64.3268V65.4511H142.77C143.219 65.4148 143.534 65.577 143.711 65.9435C143.889 66.3081 143.889 66.6746 143.711 67.0392C143.534 67.4038 143.219 67.5679 142.77 67.5297H138.838V78.6791C138.838 79.0169 138.729 79.2975 138.515 79.5209C138.3 79.7461 138.033 79.8587 137.716 79.8587C137.399 79.8587 137.126 79.7461 136.901 79.5209C136.675 79.2956 136.563 79.015 136.563 78.6791V67.5297H135.58C135.131 67.5679 134.816 67.4038 134.639 67.0392C134.461 66.6746 134.461 66.3081 134.639 65.9435C134.816 65.5789 135.131 65.4148 135.58 65.4511H135.578Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M146.586 65.4511H147.569V64.1588C147.569 62.7367 147.953 61.6182 148.72 60.8031C149.487 59.9881 150.573 59.5815 151.978 59.5815C152.952 59.5815 153.776 59.6846 154.45 59.8907C155.05 60.0587 155.349 60.4156 155.349 60.9577C155.349 61.2383 155.252 61.4769 155.055 61.6735C154.859 61.8701 154.592 61.9675 154.256 61.9675C154.162 61.9675 153.83 61.9255 153.259 61.8415C152.688 61.7575 152.28 61.7155 152.038 61.7155C150.577 61.7155 149.846 62.5859 149.846 64.3268V65.4511H153.778C154.227 65.4148 154.542 65.577 154.719 65.9435C154.897 66.3081 154.897 66.6746 154.719 67.0392C154.542 67.4038 154.227 67.5679 153.778 67.5297H149.846V78.6791C149.846 79.0169 149.737 79.2975 149.524 79.5209C149.308 79.7461 149.041 79.8587 148.724 79.8587C148.407 79.8587 148.134 79.7461 147.909 79.5209C147.684 79.2956 147.571 79.015 147.571 78.6791V67.5297H146.588C146.139 67.5679 145.824 67.4038 145.647 67.0392C145.469 66.6746 145.469 66.3081 145.647 65.9435C145.824 65.5789 146.139 65.4148 146.588 65.4511H146.586ZM159.28 62.7272C158.886 62.7272 158.558 62.5859 158.297 62.3053C158.035 62.0248 157.903 61.6869 157.903 61.2937C157.903 60.9005 158.033 60.5721 158.297 60.3106C158.558 60.03 158.886 59.8888 159.28 59.8888C159.673 59.8888 160.001 60.03 160.263 60.3106C160.543 60.5721 160.684 60.9005 160.684 61.2937C160.684 61.6869 160.543 62.0248 160.263 62.3053C160.001 62.5859 159.673 62.7272 159.28 62.7272ZM158.155 78.6791V66.1535C158.155 65.8347 158.262 65.5599 158.478 65.3251C158.694 65.0903 158.959 64.9739 159.278 64.9739C159.596 64.9739 159.867 65.0903 160.093 65.3251C160.318 65.5599 160.431 65.8347 160.431 66.1535V78.6791C160.431 79.0169 160.324 79.2975 160.108 79.5209C159.892 79.7442 159.617 79.8587 159.28 79.8587C158.98 79.8587 158.718 79.7461 158.493 79.5209C158.268 79.2956 158.155 79.015 158.155 78.6791Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M165.178 74.327C165.103 72.9794 165.103 71.649 165.178 70.3395C165.252 68.7113 165.88 67.3713 167.06 66.3234C168.22 65.2946 169.69 64.7792 171.469 64.7792C173.248 64.7792 174.596 65.2659 175.627 66.2394C176.674 67.1938 177.199 68.0833 177.199 68.9079C177.199 69.2458 177.096 69.5206 176.89 69.7363C176.684 69.952 176.432 70.0589 176.132 70.0589C175.627 70.0589 175.262 69.8051 175.037 69.3011C174.718 68.5338 174.246 67.944 173.618 67.5317C172.99 67.1194 172.284 66.9132 171.498 66.9132C170.337 66.9132 169.396 67.2358 168.675 67.8829C167.953 68.53 167.547 69.3947 167.453 70.4808C167.379 71.5287 167.379 72.7656 167.453 74.1877C167.547 75.2929 167.953 76.1824 168.675 76.8562C169.396 77.53 170.335 77.8679 171.498 77.8679C172.284 77.8679 173 77.6617 173.647 77.2494C174.292 76.8371 174.775 76.2473 175.094 75.4799C175.319 74.9741 175.684 74.7221 176.19 74.7221C176.489 74.7221 176.741 74.829 176.947 75.0447C177.154 75.2604 177.257 75.5353 177.257 75.8732C177.257 76.7149 176.722 77.614 175.655 78.5684C174.605 79.5228 173.212 80.0019 171.471 80.0019C169.73 80.0019 168.203 79.4674 167.062 78.4004C165.882 77.2761 165.254 75.919 165.18 74.327H165.178Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M180.822 73.9605C180.784 73.1741 180.767 72.6224 180.767 72.3037C180.767 71.668 180.796 71.0954 180.851 70.5915C181 68.7934 181.637 67.3751 182.76 66.3367C183.882 65.2984 185.316 64.7773 187.056 64.7773C188.891 64.7773 190.351 65.348 191.437 66.4895C192.542 67.6309 193.094 69.0931 193.094 70.8702V71.7119C193.094 72.7981 192.542 73.3402 191.437 73.3402H183.04V73.7887C183.04 75.0619 183.42 76.0678 184.178 76.8085C184.936 77.5491 185.951 77.9175 187.224 77.9175C188.104 77.9175 189.246 77.6731 190.651 77.1864C190.893 77.0929 191.09 77.0452 191.241 77.0452C191.408 77.0452 191.596 77.1024 191.802 77.2131C192.082 77.4193 192.241 77.7094 192.279 78.0835C192.279 78.5149 192.073 78.8509 191.66 79.0952C190.649 79.6946 189.16 79.9943 187.196 79.9943C185.232 79.9943 183.792 79.4522 182.66 78.3641C181.527 77.278 180.914 75.8082 180.82 73.9548L180.822 73.9605ZM183.04 71.208V71.4333H190.511C190.737 71.4333 190.857 71.3206 190.876 71.0954V70.7308C190.876 69.6256 190.567 68.7189 189.948 68.007C189.236 67.2205 188.282 66.8273 187.083 66.8273C185.755 66.8273 184.733 67.2396 184.021 68.0623C183.367 68.8678 183.038 69.9158 183.038 71.208H183.04Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('clip0_38_4221')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$rect,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$width('192.188'),
									$elm$svg$Svg$Attributes$height('80'),
									$elm$svg$Svg$Attributes$fill('white'),
									$elm$svg$Svg$Attributes$transform('translate(0.905884)')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$Pyxis$Components$Button$Primary = 0;
var $author$project$Pyxis$Components$Button$primary = $author$project$Pyxis$Components$Button$config(0);
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$Pyxis$Components$Button$XL = 0;
var $author$project$Pyxis$Components$Button$sizeXL = function (_v0) {
	var configuration = _v0;
	return _Utils_update(
		configuration,
		{aO: 0});
};
var $author$project$Pyxis$Components$Button$withText = F2(
	function (text, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{pu: text});
	});
var $author$project$Pyxis$Components$Button$withType = F2(
	function (type_, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{bk: type_});
	});
var $author$project$Pyxis$Components$Button$withWidth = function (setWidth) {
	return setWidth;
};
var $author$project$Page$Login$View$view = F3(
	function (i18n, env, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$main_,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container-responsive display-flex justify-content-center align-items-center login-container')
					]),
				function () {
					var _v0 = model.mn;
					switch (_v0.$) {
						case 0:
							return _List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$loginErrorText(i18n))
								]);
						case 1:
							return _List_fromArray(
								[
									$elm$html$Html$text('')
								]);
						case 3:
							return _List_fromArray(
								[
									$elm$html$Html$text('')
								]);
						default:
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$section,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('login-container__logo')
										]),
									_List_fromArray(
										[$author$project$Common$ComponentUI$Illustrations$primaLogo])),
									A2(
									$elm$html$Html$section,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('login-container__actions')
										]),
									_List_fromArray(
										[
											$author$project$Pyxis$Components$Button$render(
											A2(
												$author$project$Pyxis$Components$Button$withType,
												$author$project$Pyxis$Components$Button$link(
													A2($author$project$Page$Login$View$loginLink, env, model.pr)),
												A2(
													$author$project$Pyxis$Components$Button$withWidth,
													$author$project$Pyxis$Components$Button$full,
													A2(
														$author$project$Pyxis$Components$Button$withSize,
														$author$project$Pyxis$Components$Button$sizeXL,
														A2(
															$author$project$Pyxis$Components$Button$withText,
															$author$project$Translations$loginButtonText(i18n),
															$author$project$Pyxis$Components$Button$primary)))))
										]))
								]);
					}
				}())
			]);
	});
var $author$project$Page$Login$view = F3(
	function (i18n, env, model) {
		return {
			f$: A3($author$project$Page$Login$View$view, i18n, env, model),
			iS: $author$project$Translations$routeLogin(i18n)
		};
	});
var $author$project$Translations$routeNotAuthorized = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Not authorized';
	} else {
		return 'No Autorizado';
	}
};
var $author$project$Page$NotAuthorized$View$view = function (_v0) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container-responsive'),
					$elm$html$Html$Attributes$class('justify-content-center')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('You do not have the required permissions to perform this action. Please contact your supervisor if you need to acquire permissions.')
				]))
		]);
};
var $author$project$Page$NotAuthorized$view = F2(
	function (i18n, model) {
		return {
			f$: $author$project$Page$NotAuthorized$View$view(model),
			iS: $author$project$Translations$routeNotAuthorized(i18n)
		};
	});
var $author$project$Translations$routeNotFound = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Not found';
	} else {
		return 'Sin Resultados';
	}
};
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$Pyxis$Components$IconSet$Home = 107;
var $author$project$Pyxis$Components$IconSet$home = 107;
var $author$project$Pyxis$Components$Button$Prepend = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pyxis$Components$Button$withIconPrepend = F2(
	function (icon, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				kf: $author$project$Pyxis$Components$Button$Prepend(icon)
			});
	});
var $author$project$Page$NotFound$View$view = function (_v0) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Not found')
				])),
			$author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withType,
				$author$project$Pyxis$Components$Button$link(
					$author$project$Route$toString(
						A2(
							$author$project$Route$Search,
							$author$project$Page$Search$SearchQueryParam$defaultSearchContext,
							$elm$core$Result$Ok($author$project$Page$Search$SearchQueryParam$Empty)))),
				A2(
					$author$project$Pyxis$Components$Button$withText,
					'Go Home',
					A2($author$project$Pyxis$Components$Button$withIconPrepend, $author$project$Pyxis$Components$IconSet$home, $author$project$Pyxis$Components$Button$primary))))
		]);
};
var $author$project$Page$NotFound$view = F2(
	function (i18n, model) {
		return {
			f$: $author$project$Page$NotFound$View$view(model),
			iS: $author$project$Translations$routeNotFound(i18n)
		};
	});
var $author$project$Translations$routeOfferDetails = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Offer details';
	} else {
		return 'Detalles de Oferta';
	}
};
var $author$project$Page$OfferDetails$GreatLakesModalOrigin$AfterPressingPurchaseButton = 1;
var $author$project$Page$OfferDetails$Msg$GreatLakesOptInConsentDismissed = function (a) {
	return {$: 24, a: a};
};
var $author$project$Page$OfferDetails$Msg$GreatLakesOptInConsentGiven = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Page$OfferDetails$GreatLakesModalOrigin$LandingOnPage = 0;
var $author$project$Page$OfferDetails$Msg$RecordingDisclaimerDismissed = {$: 12};
var $author$project$Page$OfferDetails$Msg$RedirectToPayment = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$OfferDetails$Msg$ShowCompleteOfferLegalInformationModal = function (a) {
	return {$: 10, a: a};
};
var $prikhi$decimal$Decimal$fromIntWithExponent = F2(
	function (n, e) {
		return A2(
			$prikhi$decimal$Decimal$Decimal,
			$cmditch$elm_bigint$BigInt$fromInt(n),
			e);
	});
var $prikhi$decimal$Decimal$fromInt = function (n) {
	return A2($prikhi$decimal$Decimal$fromIntWithExponent, n, 0);
};
var $author$project$Common$CoverSelection$defaultExcess = $author$project$Common$Price$euro(
	$prikhi$decimal$Decimal$fromInt(200));
var $author$project$Common$ErrorContainer$CarCrashing = 0;
var $author$project$Pyxis$Components$Form$Legend$Center = 0;
var $author$project$Pyxis$Components$Form$Legend$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Form$Legend$config = {mf: $elm$core$Maybe$Nothing, dY: 0, f6: _List_Nil, ej: _List_Nil, mN: $elm$core$Maybe$Nothing, eC: $elm$core$Maybe$Nothing, kg: $elm$core$Maybe$Nothing, fv: $elm$core$Maybe$Nothing, iS: $elm$core$Maybe$Nothing};
var $author$project$Common$ErrorContainer$iconToImagePath = function (errorIcon) {
	return '/assets/' + function () {
		if (!errorIcon) {
			return 'car-crashing.svg';
		} else {
			return 'camera.svg';
		}
	}();
};
var $author$project$Pyxis$Components$Form$Legend$Left = 1;
var $author$project$Pyxis$Components$Form$Legend$isAlignedLeft = $elm$core$Basics$eq(1);
var $elm$html$Html$legend = _VirtualDom_node('legend');
var $author$project$Pyxis$Components$Icon$Boxed = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pyxis$Components$Icon$Brand = 1;
var $author$project$Pyxis$Components$Icon$Weak = 0;
var $author$project$Pyxis$Components$Icon$brand = A2($author$project$Pyxis$Components$Icon$Boxed, 1, 0);
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $author$project$Pyxis$Components$Icon$withStyle = F2(
	function (a, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{dA: a});
	});
var $author$project$Pyxis$Components$Form$Legend$renderAddonByType = function (type_) {
	if (!type_.$) {
		var icon = type_.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-legend__addon')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Icon$render(
					A2(
						$author$project$Pyxis$Components$Icon$withStyle,
						$author$project$Pyxis$Components$Icon$brand,
						$author$project$Pyxis$Components$Icon$config(icon)))
				]));
	} else {
		var url = type_.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-legend__addon')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(url),
							$elm$html$Html$Attributes$width(80)
						]),
					_List_Nil)
				]));
	}
};
var $author$project$Pyxis$Components$Form$Legend$renderDescription = function (str) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-legend__text')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $author$project$Pyxis$Components$Form$Legend$renderTag = function (maybeHeadingLevel) {
	if (!maybeHeadingLevel.$) {
		switch (maybeHeadingLevel.a) {
			case 0:
				var _v1 = maybeHeadingLevel.a;
				return $elm$html$Html$h1;
			case 1:
				var _v2 = maybeHeadingLevel.a;
				return $elm$html$Html$h2;
			case 2:
				var _v3 = maybeHeadingLevel.a;
				return $elm$html$Html$h3;
			case 3:
				var _v4 = maybeHeadingLevel.a;
				return $elm$html$Html$h4;
			case 4:
				var _v5 = maybeHeadingLevel.a;
				return $elm$html$Html$h5;
			default:
				var _v6 = maybeHeadingLevel.a;
				return $elm$html$Html$h6;
		}
	} else {
		return $elm$html$Html$span;
	}
};
var $author$project$Pyxis$Components$Form$Legend$renderTitle = F2(
	function (maybeHeadingLevel, str) {
		return A3(
			$author$project$Pyxis$Components$Form$Legend$renderTag,
			maybeHeadingLevel,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-legend__title')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(str)
				]));
	});
var $author$project$Pyxis$Components$Form$Legend$render = function (_v0) {
	var configuration = _v0;
	return A2(
		$elm$html$Html$legend,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			configuration.ej,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2('form-legend', true),
								_Utils_Tuple2(
								'form-legend--align-left',
								$author$project$Pyxis$Components$Form$Legend$isAlignedLeft(configuration.dY))
							]),
						configuration.f6)),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, configuration.kg),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, configuration.fv)
				])),
		_List_fromArray(
			[
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Form$Legend$renderAddonByType, configuration.mf)),
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2(
					$elm$core$Maybe$map,
					$author$project$Pyxis$Components$Form$Legend$renderTitle(configuration.eC),
					configuration.iS)),
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Form$Legend$renderDescription, configuration.mN))
			]));
};
var $author$project$Pyxis$Components$Form$Legend$withTitle = F2(
	function (text, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				iS: $elm$core$Maybe$Just(text)
			});
	});
var $author$project$Common$ErrorContainer$custom = F2(
	function (errorIcon, title) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('error-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('error-container__icon')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('space-v-xs'),
									$elm$html$Html$Attributes$src(
									$author$project$Common$ErrorContainer$iconToImagePath(errorIcon))
								]),
							_List_Nil)
						])),
					$author$project$Pyxis$Components$Form$Legend$render(
					A2($author$project$Pyxis$Components$Form$Legend$withTitle, title, $author$project$Pyxis$Components$Form$Legend$config))
				]));
	});
var $author$project$Common$ErrorContainer$generic = A2($author$project$Common$ErrorContainer$custom, 0, 'Oops! This is embarrassing... something has gone wrong.');
var $elm_community$html_extra$Html$Extra$nothing = $elm$html$Html$text('');
var $author$project$Common$Render$maybe = F2(
	function (content, maybeValue) {
		if (maybeValue.$ === 1) {
			return $elm_community$html_extra$Html$Extra$nothing;
		} else {
			var value = maybeValue.a;
			return content(value);
		}
	});
var $author$project$Common$ErrorContainer$Camera = 1;
var $author$project$Common$ErrorContainer$notFound = A2($author$project$Common$ErrorContainer$custom, 1, '404 - we can\'t find this page');
var $author$project$Common$CoverSelection$pickExcess = function (_v0) {
	var chosenExcess = _v0.f3;
	return A2($elm$core$Maybe$withDefault, $author$project$Common$CoverSelection$defaultExcess, chosenExcess);
};
var $author$project$Common$Offer$pickSelectedBundle = function (_v0) {
	var offer = _v0;
	return offer.iw;
};
var $author$project$Translations$completeOfferLegalInformationContent = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The customer has been previously informed about the Privacy Policy. If you have voluntarily mentioned that you do not agree to receive commercial emails, please make sure you tick the relevant boxes.';
	} else {
		return 'El cliente ha sido informado previamente sobre la Política de privacidad. Si ha mencionado voluntariamente no estar de acuerdo con recibir emails comerciales, asegúrate de seleccionar las casillas correspondientes.';
	}
};
var $author$project$Pyxis$Components$Modal$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Modal$M = 1;
var $author$project$Pyxis$Components$Modal$config = {dW: $elm$core$Maybe$Nothing, f6: _List_Nil, aX: _List_Nil, ej: _List_Nil, ew: $elm$core$Maybe$Nothing, eB: $elm$core$Maybe$Nothing, eG: false, e1: $elm$core$Maybe$Nothing, aO: 1, fv: $elm$core$Maybe$Nothing};
var $author$project$Translations$completeOfferLegalInformationButtonText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Continue';
	} else {
		return 'Continuar';
	}
};
var $author$project$Pyxis$Components$Modal$Footer$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Modal$Footer$Horizontal = 0;
var $author$project$Pyxis$Components$Modal$Footer$config = {d0: _List_Nil, d1: 0, f6: _List_Nil, eg: $elm$core$Maybe$Nothing, ej: _List_Nil, ey: false, eQ: false};
var $author$project$Pyxis$Components$Modal$Footer$withButtons = F2(
	function (buttons, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{d0: buttons});
	});
var $author$project$Pyxis$Components$Button$withId = F2(
	function (id, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				kg: $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Pyxis$Components$Button$withOnClick = F2(
	function (onClick, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				hJ: $elm$core$Maybe$Just(onClick)
			});
	});
var $author$project$Pyxis$Components$Button$withTestId = F2(
	function (id, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				fv: $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Common$ComponentUI$Modal$CompleteOfferLegalInformation$footer = F3(
	function (i18n, externalUrl, ctaMsg) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$target('_blank'),
							$elm$html$Html$Attributes$href(
							$author$project$ExternalUrl$toString(externalUrl))
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Button$render(
							A2(
								$author$project$Pyxis$Components$Button$withTestId,
								'legal-info-btn',
								A2(
									$author$project$Pyxis$Components$Button$withId,
									'legal-info-btn',
									A2(
										$author$project$Pyxis$Components$Button$withText,
										$author$project$Translations$completeOfferLegalInformationButtonText(i18n),
										A2($author$project$Pyxis$Components$Button$withOnClick, ctaMsg, $author$project$Pyxis$Components$Button$primary)))))
						]))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Translations$completeOfferLegalInformationTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Preference over commercial emails';
	} else {
		return 'Preferencia sobre emails comerciales';
	}
};
var $author$project$Pyxis$Components$Modal$Header$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Modal$Header$config = {bu: $elm$core$Maybe$Nothing, f6: _List_Nil, d8: $elm$core$Maybe$Nothing, eg: $elm$core$Maybe$Nothing, ej: _List_Nil, kf: $elm$core$Maybe$Nothing, eQ: false, iS: $elm$core$Maybe$Nothing};
var $author$project$Pyxis$Components$Modal$Header$withTitle = F2(
	function (title, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				iS: $elm$core$Maybe$Just(title)
			});
	});
var $author$project$Common$ComponentUI$Modal$CompleteOfferLegalInformation$header = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withTitle,
		$author$project$Translations$completeOfferLegalInformationTitle(i18n),
		$author$project$Pyxis$Components$Modal$Header$config);
};
var $author$project$Pyxis$Components$Modal$contentId = function (id) {
	return id + '-content';
};
var $author$project$Pyxis$Components$Modal$getModalSizeClass = function (size) {
	switch (size) {
		case 0:
			return 'modal--s';
		case 1:
			return 'modal--m';
		default:
			return 'modal--l';
	}
};
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $author$project$Pyxis$Components$Modal$Footer$Vertical = 1;
var $author$project$Pyxis$Components$Modal$Footer$renderButtons = F2(
	function (fullWidthButton, buttonsOrientation) {
		return $elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('modal__footer__buttons', true),
							_Utils_Tuple2('modal__footer__buttons--full-width', fullWidthButton),
							_Utils_Tuple2('modal__footer__buttons--vertical-orientation', buttonsOrientation === 1)
						]))
				]));
	});
var $author$project$Pyxis$Components$Modal$Footer$render = function (_v0) {
	var classList = _v0.f6;
	var dataAttrList = _v0.ej;
	var customContent = _v0.eg;
	var isSticky = _v0.eQ;
	var fullWidthButton = _v0.ey;
	var buttons = _v0.d0;
	var buttonsOrientation = _v0.d1;
	return A2(
		$elm$html$Html$footer,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('modal__footer', true),
							_Utils_Tuple2('modal__footer--sticky', isSticky),
							_Utils_Tuple2(
							'modal__footer--custom',
							$elm_community$maybe_extra$Maybe$Extra$isJust(customContent))
						])),
					$elm$html$Html$Attributes$classList(classList)
				])),
		A2(
			$elm$core$Maybe$withDefault,
			_List_fromArray(
				[
					A3($author$project$Pyxis$Components$Modal$Footer$renderButtons, fullWidthButton, buttonsOrientation, buttons)
				]),
			customContent));
};
var $author$project$Pyxis$Components$Modal$Header$renderBadge = function (badge) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal__header__badge')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Badge$render(badge)
			]));
};
var $author$project$Pyxis$Components$Button$button = $author$project$Pyxis$Components$Button$Button;
var $author$project$Pyxis$Components$IconSet$Cross = 162;
var $author$project$Pyxis$Components$IconSet$cross = 162;
var $author$project$Pyxis$Components$Button$S = 3;
var $author$project$Pyxis$Components$Button$sizeS = function (_v0) {
	var configuration = _v0;
	return _Utils_update(
		configuration,
		{aO: 3});
};
var $author$project$Pyxis$Components$Button$withAriaLabel = F2(
	function (ariaLabel, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				fV: $elm$core$Maybe$Just(ariaLabel)
			});
	});
var $author$project$Pyxis$Components$Modal$Header$renderCloseButton = function (_v0) {
	var msg = _v0.kD;
	var ariaLabel = _v0.fV;
	return $author$project$Pyxis$Components$Button$render(
		A2(
			$author$project$Pyxis$Components$Button$withIconOnly,
			$author$project$Pyxis$Components$IconSet$cross,
			A2(
				$author$project$Pyxis$Components$Button$withOnClick,
				msg,
				A2(
					$author$project$Pyxis$Components$Button$withType,
					$author$project$Pyxis$Components$Button$button,
					A2(
						$author$project$Pyxis$Components$Button$withAriaLabel,
						ariaLabel,
						A2($author$project$Pyxis$Components$Button$withSize, $author$project$Pyxis$Components$Button$sizeS, $author$project$Pyxis$Components$Button$ghost))))));
};
var $author$project$Pyxis$Components$Modal$Header$renderIcon = $author$project$Pyxis$Components$Icon$render;
var $author$project$Pyxis$Components$Modal$Header$renderTitle = F2(
	function (id, title) {
		return A2(
			$elm$html$Html$h2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal__header__title'),
					$elm$html$Html$Attributes$id(id)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(title)
				]));
	});
var $author$project$Pyxis$Components$Modal$Header$render = F2(
	function (titleId, _v0) {
		var classList = _v0.f6;
		var closeButton = _v0.d8;
		var customContent = _v0.eg;
		var dataAttrList = _v0.ej;
		var isSticky = _v0.eQ;
		var title = _v0.iS;
		var badge = _v0.bu;
		var icon = _v0.kf;
		return A2(
			$elm$html$Html$header,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal__header', true),
								_Utils_Tuple2('modal__header--sticky', isSticky)
							]))
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal__header__wrapper', true),
									_Utils_Tuple2(
									'modal__header__wrapper--custom',
									$elm_community$maybe_extra$Maybe$Extra$isJust(customContent))
								])),
							$elm$html$Html$Attributes$classList(classList)
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_fromArray(
							[
								$author$project$Pyxis$Commons$Render$renderMaybe(
								A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Modal$Header$renderBadge, badge)),
								$author$project$Pyxis$Commons$Render$renderMaybe(
								A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Modal$Header$renderIcon, icon)),
								$author$project$Pyxis$Commons$Render$renderMaybe(
								A2(
									$elm$core$Maybe$map,
									$author$project$Pyxis$Components$Modal$Header$renderTitle(titleId),
									title))
							]),
						customContent)),
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Modal$Header$renderCloseButton, closeButton))
				]));
	});
var $author$project$Pyxis$Components$Modal$screenReaderDescriptionId = function (id) {
	return id + '-sr-description';
};
var $author$project$Pyxis$Components$Modal$renderDescribedBy = F2(
	function (id, description) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sr-only'),
					$elm$html$Html$Attributes$id(
					$author$project$Pyxis$Components$Modal$screenReaderDescriptionId(id))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(description)
				]));
	});
var $author$project$Pyxis$Components$Modal$titleId = function (id) {
	return id + '-header-title';
};
var $author$project$Pyxis$Components$Modal$Header$withCloseButton = F2(
	function (onCloseData, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{d8: onCloseData});
	});
var $author$project$Pyxis$Components$Modal$render = F2(
	function (_v0, _v1) {
		var id = _v0.kg;
		var isOpen = _v0.g2;
		var classList = _v1.f6;
		var header = _v1.eB;
		var dataAttrList = _v1.ej;
		var content = _v1.aX;
		var footer = _v1.ew;
		var size = _v1.aO;
		var onCloseMsg = _v1.e1;
		var accessibleDescription = _v1.dW;
		var testId = _v1.fv;
		var isCentered = _v1.eG;
		return A2(
			$author$project$Pyxis$Commons$Render$renderIf,
			isOpen,
			A2(
				$elm$html$Html$div,
				A2(
					$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
					dataAttrList,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal-backdrop', true),
									_Utils_Tuple2('modal-backdrop--show', isOpen)
								])),
							$elm$html$Html$Attributes$classList(classList)
						])),
				_List_fromArray(
					[
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2(
							$elm$core$Maybe$map,
							$author$project$Pyxis$Components$Modal$renderDescribedBy(id),
							accessibleDescription)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-close'),
								A2(
								$author$project$Pyxis$Commons$Attributes$maybe,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.kD;
									},
									$elm$html$Html$Events$onClick),
								onCloseMsg)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$section,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('modal', true),
										_Utils_Tuple2(
										$author$project$Pyxis$Components$Modal$getModalSizeClass(size),
										true),
										_Utils_Tuple2('modal--center', isCentered)
									])),
								$elm$html$Html$Attributes$id(id),
								$author$project$Pyxis$Commons$Attributes$role('dialog'),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
								$author$project$Pyxis$Commons$Attributes$ariaLabelledBy(
								$author$project$Pyxis$Components$Modal$titleId(id)),
								$author$project$Pyxis$Commons$Attributes$ariaDescribedBy(
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Pyxis$Components$Modal$contentId(id),
									A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$always(
											$author$project$Pyxis$Components$Modal$screenReaderDescriptionId(id)),
										accessibleDescription))),
								A2($elm$html$Html$Attributes$attribute, 'aria-modal', 'true')
							]),
						_List_fromArray(
							[
								$author$project$Pyxis$Commons$Render$renderMaybe(
								A2(
									$elm$core$Maybe$map,
									$author$project$Pyxis$Components$Modal$Header$render(
										$author$project$Pyxis$Components$Modal$titleId(id)),
									A2(
										$elm$core$Maybe$map,
										$author$project$Pyxis$Components$Modal$Header$withCloseButton(onCloseMsg),
										header))),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal__content'),
										$elm$html$Html$Attributes$id(
										$author$project$Pyxis$Components$Modal$contentId(id))
									]),
								content),
								$author$project$Pyxis$Commons$Render$renderMaybe(
								A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Modal$Footer$render, footer))
							]))
					])));
	});
var $author$project$Pyxis$Components$Modal$S = 0;
var $author$project$Pyxis$Components$Modal$sizeS = 0;
var $author$project$Pyxis$Components$Modal$withCloseMsg = F3(
	function (msg, ariaLabel, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				e1: $elm$core$Maybe$Just(
					{fV: ariaLabel, kD: msg})
			});
	});
var $author$project$Pyxis$Components$Modal$withContent = F2(
	function (content, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{aX: content});
	});
var $author$project$Pyxis$Components$Modal$withFooter = F2(
	function (footer, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				ew: $elm$core$Maybe$Just(footer)
			});
	});
var $author$project$Pyxis$Components$Modal$withHeader = F2(
	function (header, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				eB: $elm$core$Maybe$Just(header)
			});
	});
var $author$project$Pyxis$Components$Modal$withSize = F2(
	function (size, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{aO: size});
	});
var $author$project$Common$ComponentUI$Modal$CompleteOfferLegalInformation$render = F5(
	function (offer, i18n, env, closeMsg, modelMessage) {
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			modelMessage,
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A3(
					$author$project$Common$ComponentUI$Modal$CompleteOfferLegalInformation$footer,
					i18n,
					env(
						$author$project$Common$Offer$pickId(offer)),
					closeMsg),
				A3(
					$author$project$Pyxis$Components$Modal$withCloseMsg,
					closeMsg,
					'',
					A2(
						$author$project$Pyxis$Components$Modal$withContent,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$completeOfferLegalInformationContent(i18n))
							]),
						A2(
							$author$project$Pyxis$Components$Modal$withHeader,
							$author$project$Common$ComponentUI$Modal$CompleteOfferLegalInformation$header(i18n),
							A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
	});
var $author$project$Pyxis$Components$List$Block = {$: 1};
var $author$project$Pyxis$Components$List$block = $author$project$Pyxis$Components$List$Block;
var $author$project$Pyxis$Components$List$Dl = 2;
var $author$project$Pyxis$Components$List$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$List$EmphasisOnTitle = 0;
var $author$project$Pyxis$Components$List$FullWidth = 1;
var $author$project$Pyxis$Components$List$H2 = 1;
var $author$project$Pyxis$Components$List$ItemBlock = 0;
var $author$project$Pyxis$Components$List$M = 1;
var $author$project$Pyxis$Components$List$config = function (tag) {
	return {f6: _List_Nil, ej: _List_Nil, gq: false, er: 0, kg: $elm$core$Maybe$Nothing, g5: 0, g6: 1, g7: _List_Nil, kB: tag, h3: $author$project$Pyxis$Components$List$Block, aO: 1, fv: $elm$core$Maybe$Nothing, iT: 1};
};
var $author$project$Pyxis$Components$List$dl = $author$project$Pyxis$Components$List$config(2);
var $author$project$Pyxis$Components$List$EmphasisOnText = 1;
var $author$project$Pyxis$Components$List$emphasisText = 1;
var $author$project$Pyxis$Components$List$ItemInline = 1;
var $author$project$Pyxis$Components$List$itemOrientationInline = 1;
var $author$project$Pyxis$Components$List$getItemOrientationClass = function (itemOrientation) {
	if (!itemOrientation) {
		return 'list--item-block';
	} else {
		return 'list--item-inline';
	}
};
var $author$project$Pyxis$Components$List$getItemSizeClass = function (itemSize) {
	switch (itemSize) {
		case 0:
			return 'list--s';
		case 1:
			return 'list--m';
		default:
			return 'list--l';
	}
};
var $author$project$Pyxis$Components$List$getItemWidthClass = F3(
	function (itemWidth, orientation, itemOrientation) {
		var itemWidthClass = function () {
			if (!itemWidth) {
				return 'list--item-width-content';
			} else {
				return 'list--item-width-full-width';
			}
		}();
		var isInlineItemOrientation = itemOrientation === 1;
		var isBlockOrientation = _Utils_eq(orientation, $author$project$Pyxis$Components$List$Block);
		return A3($author$project$Pyxis$Commons$Basics$ternaryOperator, isBlockOrientation && isInlineItemOrientation, itemWidthClass, '');
	});
var $author$project$Pyxis$Components$List$orientationClass = function (orientation) {
	switch (orientation.$) {
		case 0:
			return 'list--inline';
		case 1:
			return 'list--block';
		case 2:
			return 'list--columns';
		default:
			return 'list--columns-horizontal';
	}
};
var $elm$html$Html$dd = _VirtualDom_node('dd');
var $elm$html$Html$dt = _VirtualDom_node('dt');
var $author$project$Pyxis$Components$List$renderAction = function (_v0) {
	var icon = _v0.kf;
	var label = _v0.eR;
	var onClick = _v0.hJ;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list__item__action')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Button$render(
				A2(
					$author$project$Pyxis$Components$Button$withOnClick,
					onClick,
					A2(
						$author$project$Pyxis$Components$Button$withText,
						label,
						A2(
							$author$project$Pyxis$Components$Button$withSize,
							$author$project$Pyxis$Components$Button$sizeS,
							A2($author$project$Pyxis$Components$Button$withIconOnly, icon, $author$project$Pyxis$Components$Button$ghost)))))
			]));
};
var $author$project$Pyxis$Components$List$Ol = 1;
var $author$project$Pyxis$Components$List$Ul = 0;
var $author$project$Pyxis$Components$Illustration$getClassList = function (classList) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			A2(
				$elm$core$List$filter,
				$elm$core$Tuple$second,
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2('illustration', true),
						classList)))));
};
var $author$project$Pyxis$Components$Illustration$formatSize = function (size) {
	return (!_Utils_eq(
		$elm$core$String$toFloat(size),
		$elm$core$Maybe$Nothing)) ? ('--illustration-size: ' + (size + 'px')) : ('--illustration-size: ' + size);
};
var $author$project$Pyxis$Components$Illustration$getOptionalSizeStyleAttribute = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		function (size) {
			return $elm$svg$Svg$Attributes$style(
				$author$project$Pyxis$Components$Illustration$formatSize(size));
		}),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map($elm$core$List$singleton),
		$elm$core$Maybe$withDefault(_List_Nil)));
var $author$project$Pyxis$Components$IllustrationSet$toLabel = function (illustration) {
	switch (illustration) {
		case 0:
			return 'wallet';
		case 1:
			return 'vehicle-vandalism';
		case 2:
			return 'vehicle-theft-fire';
		case 3:
			return 'vehicle-secure-bonus';
		case 4:
			return 'vehicle-roadside-assistance';
		case 5:
			return 'vehicle-ricourse-waiver';
		case 6:
			return 'vehicle-natural-events';
		case 7:
			return 'vehicle-legal-protection';
		case 8:
			return 'vehicle-glasses';
		case 9:
			return 'vehicle-full-kasko';
		case 10:
			return 'vehicle-driver-injuries';
		case 11:
			return 'vehicle-collision-kasko';
		case 12:
			return 'van';
		case 13:
			return 'steering-wheel';
		case 14:
			return 'smartphone-gear';
		case 15:
			return 'motorcycle';
		case 16:
			return 'motorcycle-car';
		case 17:
			return 'moped';
		case 18:
			return 'home-theft-valuable';
		case 19:
			return 'home-telephone-legal';
		case 20:
			return 'home-robberies-outside';
		case 21:
			return 'home-natural-events';
		case 22:
			return 'home-legal-protection';
		case 23:
			return 'home-insurance-home';
		case 24:
			return 'home-insurance-family';
		case 25:
			return 'home-injuries-freetime';
		case 26:
			return 'home-injuries-family';
		case 27:
			return 'home-furniture-content';
		case 28:
			return 'home-fire-explosion';
		case 29:
			return 'home-emergencies-repairs';
		case 30:
			return 'home-domestic-thefts';
		case 31:
			return 'home-damage-third-parties';
		case 32:
			return 'home-damage-third-parties-property';
		case 33:
			return 'home-damage-repair';
		case 34:
			return 'home-damage-pets';
		case 35:
			return 'home-damage-family';
		case 36:
			return 'home-damage-ebike-scooter';
		case 37:
			return 'car';
		case 38:
			return 'car-shiny';
		default:
			return 'car-protected';
	}
};
var $author$project$Pyxis$Components$Illustration$buildSvg = F2(
	function (_v0, nodes) {
		var size = _v0.aO;
		var ariaLabel = _v0.fV;
		var ariaLabelledby = _v0.fX;
		var dataAttrList = _v0.ej;
		var illustration = _v0.gT;
		var classList = _v0.f6;
		if (nodes.b && (!nodes.a.$)) {
			var payload = nodes.a.a;
			return A2(
				$elm$svg$Svg$svg,
				A2(
					$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
					dataAttrList,
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$viewBox('0 0 100 100'),
								$elm$svg$Svg$Attributes$class(
								$author$project$Pyxis$Components$Illustration$getClassList(classList)),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaLabel, ariaLabel),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaLabelledBy, ariaLabelledby),
								$author$project$Pyxis$Commons$Attributes$ariaHidden(
								$elm_community$maybe_extra$Maybe$Extra$isNothing(ariaLabel) && $elm_community$maybe_extra$Maybe$Extra$isNothing(ariaLabelledby)),
								A2(
								$author$project$Pyxis$Commons$Attributes$renderIf,
								$elm_community$maybe_extra$Maybe$Extra$isJust(ariaLabel) || $elm_community$maybe_extra$Maybe$Extra$isJust(ariaLabelledby),
								$author$project$Pyxis$Commons$Attributes$role('img')),
								A2(
								$elm$html$Html$Attributes$attribute,
								'data-name',
								$author$project$Pyxis$Components$IllustrationSet$toLabel(illustration))
							]),
						$author$project$Pyxis$Components$Illustration$getOptionalSizeStyleAttribute(size))),
				A2($elm$core$List$map, $Garados007$elm_svg_parser$SvgParser$nodeToSvg, payload.ae));
		} else {
			return $author$project$Pyxis$Commons$Render$empty;
		}
	});
var $author$project$Pyxis$Components$Illustration$prefixIdAttribute = F2(
	function (name, array) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm_community$maybe_extra$Maybe$Extra$join(
				A2($elm$core$Array$get, 0, array))) + (name + ('_' + A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm_community$maybe_extra$Maybe$Extra$join(
				A2($elm$core$Array$get, 1, array)))));
	});
var $author$project$Pyxis$Components$Illustration$replace = F3(
	function (userRegex, replacer, string) {
		var _v0 = $elm$regex$Regex$fromString(userRegex);
		if (_v0.$ === 1) {
			return string;
		} else {
			var regex = _v0.a;
			return A3($elm$regex$Regex$replace, regex, replacer, string);
		}
	});
var $author$project$Pyxis$Components$Illustration$prefixIdsWithName = F2(
	function (name, string) {
		return A3(
			$author$project$Pyxis$Components$Illustration$replace,
			'(id="|xlink:href="#|fill="url\\(#)((?![^\\"]*\\/>)[^( |\\/|>)]*)',
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.lQ;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Array$fromList,
					$author$project$Pyxis$Components$Illustration$prefixIdAttribute(name))),
			string);
	});
var $author$project$Pyxis$Components$Illustration$addHrefAttribute = function (array) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm_community$maybe_extra$Maybe$Extra$join(
			A2($elm$core$Array$get, 0, array))) + (' href=' + A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm_community$maybe_extra$Maybe$Extra$join(
			A2($elm$core$Array$get, 1, array))));
};
var $author$project$Pyxis$Components$Illustration$replaceXlinkHref = function (string) {
	return A3(
		$author$project$Pyxis$Components$Illustration$replace,
		'(xlink:href=((?![^\\"]*\\/>)[^( |\\/|>)]*))',
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.lQ;
			},
			A2($elm$core$Basics$composeR, $elm$core$Array$fromList, $author$project$Pyxis$Components$Illustration$addHrefAttribute)),
		string);
};
var $author$project$Pyxis$Components$IllustrationSet$svgCar = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><path opacity=\".3\" d=\"M69.25 95.822l23.527-13.581c10.709-6.177 9.348-17.081-3.006-24.23L72.72 48.169c-12.369-7.134-31.245-7.927-41.954-1.735L7.223 60.015c-10.709 6.177-9.348 17.081 3.006 24.23l17.051 9.842c12.369 7.134 31.26 7.927 41.969 1.735z\" fill=\"#e3d4ff\"/><path d=\"M92.448 59.566l.523-4.308L66.767 70.32l.09.494-.583 3.874 26.175-15.121z\" fill=\"url(#A)\"/><path d=\"M63.372 29.099L43.987 40.077c-.344.194-.269.867-.165 1.256l4.173 15.884a.88.88 0 0 0 1.286.553l24.305-13.476c.464-.254.598-.853.299-1.271l-9.079-13.401c-.269-.374-1.032-.748-1.436-.523z\" fill=\"url(#B)\"/><path d=\"M15.479 39.524l-6.536 3.321 1.541 4.098 7.478-4.397-2.483-3.021z\" fill=\"url(#C)\"/><path d=\"M54.562 63.485l-6.536 3.201.718 5.1 7.478-4.158-1.66-4.143z\" fill=\"url(#D)\"/><path d=\"M22.943 53.838c0-3.201-2.258-7.119-5.1-8.78-1.062-.598-2.139-.838-2.962-.598-.239 0-2.962 1.541-2.962 1.66-.718.598-1.182 1.541-1.182 3.081 0 3.201 2.258 7.12 5.1 8.78 1.182.718 2.258.838 3.201.598.239-.12 2.842-1.421 3.32-2.139.344-.703.583-1.54.583-2.602z\" fill=\"url(#E)\"/><path d=\"M10.244 49.44c0 3.201 2.258 7.12 5.1 8.78s5.1.359 5.1-2.842-2.259-7.12-5.1-8.78-5.1-.479-5.1 2.842z\" fill=\"url(#F)\"/><use xlink:href=\"#N\" fill=\"#fff\"/><path d=\"M13.684 51.25c0 .942.718 2.258 1.541 2.737.838.479 1.541.12 1.541-.838s-.718-2.259-1.541-2.737c-.838-.598-1.541-.12-1.541.838z\" fill=\"url(#G)\"/><path d=\"M61.995 76.198c0-3.201-2.258-7.12-5.1-8.78-1.062-.598-2.139-.838-2.962-.598-.239 0-2.962 1.541-2.962 1.66-.718.598-1.182 1.54-1.182 3.081 0 3.201 2.258 7.12 5.1 8.78 1.182.718 2.258.838 3.201.598.239-.12 2.842-1.421 3.321-2.139.359-.703.583-1.526.583-2.603z\" fill=\"url(#H)\"/><path d=\"M49.297 71.816c0 3.201 2.259 7.12 5.1 8.78s5.1.359 5.1-2.842-2.258-7.119-5.1-8.78c-2.842-1.675-5.1-.479-5.1 2.842z\" fill=\"url(#I)\"/><use xlink:href=\"#N\" x=\"39.067\" y=\"22.375\" fill=\"#fff\"/><path d=\"M52.737 73.626c0 .942.718 2.258 1.541 2.737.838.479 1.541.12 1.541-.838s-.718-2.258-1.541-2.737c-.823-.598-1.541-.12-1.541.838z\" fill=\"url(#J)\"/><path d=\"M70.057 70.634c0-.838-.598-1.062-1.182-.718a2.59 2.59 0 0 0-1.301 2.139c0 .838.598 1.062 1.182.718.718-.359 1.182-1.301 1.301-2.139zm21.837-12.833c0-.718-.479-1.062-1.181-.598-.718.359-1.182 1.301-1.182 2.019s.479 1.062 1.182.598c.598-.344 1.181-1.182 1.181-2.019z\" fill=\"#fff\"/><path d=\"M66.782 71.292l.075-.494-.09-.494 26.205-15.062-18.248-11.801-10.26-15.48c-.03-.045-.075-.105-.135-.135L44.286 16.326a3.77 3.77 0 0 0-3.709-.015L21.208 27.154l-12.025 8.87-.763.523a2.89 2.89 0 0 0-1.077 1.451l-.12.389a4.28 4.28 0 0 0 .03 2.632l1.72 5.011 1.511.912c.838-2.139 2.528-3.051 5.025-1.63 3.201 1.9 5.818 6.417 5.818 10.096v.12l.239.718L48.4 71.681l.359.12v-.718c0-3.679 2.617-5.22 5.818-3.32 3.081 1.78 5.579 5.938 5.818 9.617l1.152.837c.613.449 1.301 1.137 1.914 1.137.224 0 .628-.165 1.152-.434a34 34 0 0 0 1.466-.838l2.722-1.585 3.321-1.914 3.62-2.094 3.65-2.109 3.395-1.959 2.857-1.66 2.049-1.182.957-.553c.015 0 .03-.015.03-.015.658-.374 1.197-.912 1.57-1.571l2.184-3.724c.015-.03.03-.075.045-.12L66.303 74.717l.479-3.425zm-19.07-15.495l-3.694-14.568c-.135-.538.105-1.107.583-1.376l18.337-10.44c.568-.329 1.286-.15 1.645.404l8.436 12.938a1.24 1.24 0 0 1-.449 1.765l-22.555 12.31c-.912.464-2.049-.03-2.303-1.032z\" fill=\"url(#K)\"/><path d=\"M15.868 37.041c.314-.808.164-1.6-.479-1.929-.643-.314-1.436 0-1.765.808-.314.808-.164 1.6.479 1.929.643.314 1.451-.015 1.765-.808z\" fill=\"url(#L)\"/><path d=\"M42.417 40.436l-15.735-9.094c-.643-.374-1.466-.284-2.004.209l-6.222 5.654a1.72 1.72 0 0 0 .329 2.782l.643.344 26.474 15.316.135-.374c.224-.613.254-1.271.105-1.9l-2.917-11.861c-.12-.449-.404-.838-.808-1.077z\" fill=\"#fff\"/><path d=\"M34.879 36.084L32.59 47.945l-.942-.538 2.274-11.876.957.553z\" fill=\"url(#M)\"/><defs><linearGradient id=\"A\" x1=\"-85.419\" y1=\"64.972\" x2=\"96.971\" y2=\"64.972\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"37.605\" y1=\"43.46\" x2=\"197.544\" y2=\"43.46\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"5.96\" y1=\"43.233\" x2=\"25.493\" y2=\"43.233\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"46.952\" y1=\"67.635\" x2=\"59.272\" y2=\"67.635\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"2.283\" y1=\"51.526\" x2=\"26.798\" y2=\"51.526\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"7.975\" y1=\"52.395\" x2=\"27.272\" y2=\"52.395\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"11.636\" y1=\"52.169\" x2=\"17.179\" y2=\"52.169\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"41.343\" y1=\"73.901\" x2=\"65.858\" y2=\"73.901\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"46.623\" y1=\"74.77\" x2=\"65.92\" y2=\"74.77\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"50.697\" y1=\"74.544\" x2=\"56.239\" y2=\"74.544\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"-8.097\" y1=\"47.596\" x2=\"101.503\" y2=\"47.596\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"9.127\" y1=\"36.473\" x2=\"23.21\" y2=\"36.473\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"21.419\" y1=\"41.736\" x2=\"55.51\" y2=\"41.736\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><path id=\"N\" d=\"M12.608 50.622c0 1.78 1.301 4.038 2.842 4.981s2.842.239 2.842-1.66c0-1.78-1.301-4.038-2.842-4.981s-2.842-.239-2.842 1.66z\"/><linearGradient id=\"O\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgCarProtected = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#T)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#dfd4fb\"/><path d=\"M92.45 59.58l.52-4.32-26.2 15.06.09.49-.59 3.88 26.18-15.11z\" fill=\"url(#A)\"/><path d=\"M63.37 29.1L43.98 40.09c-.35.2-.27.87-.17 1.26l4.17 15.88a.89.89 0 0 0 .511.59.89.89 0 0 0 .779-.039l24.3-13.47c.46-.25.6-.85.31-1.28l-9.08-13.4c-.26-.38-1.03-.75-1.43-.53z\" fill=\"url(#B)\"/><path d=\"M15.49 39.53l-6.53 3.32 1.54 4.1 7.48-4.39-2.49-3.03z\" fill=\"url(#C)\"/><path d=\"M54.56 63.49l-6.53 3.21.71 5.1 7.48-4.15-1.66-4.16z\" fill=\"url(#D)\"/><use xlink:href=\"#U\" fill=\"url(#E)\"/><path d=\"M10.24 49.44c0 3.21 2.26 7.12 5.1 8.78 2.85 1.66 5.1.36 5.1-2.85s-2.26-7.12-5.1-8.78-5.1-.47-5.1 2.85z\" fill=\"url(#F)\"/><path d=\"M12.61 50.63c0 1.78 1.31 4.04 2.85 4.99s2.85.24 2.85-1.66c0-1.78-1.31-4.04-2.85-4.99s-2.85-.24-2.85 1.66z\" fill=\"#fff\"/><path d=\"M13.68 51.25c0 .95.71 2.26 1.54 2.73s1.54.12 1.54-.83-.71-2.26-1.54-2.73c-.82-.59-1.54-.12-1.54.83z\" fill=\"url(#G)\"/><path d=\"M62 76.21c0-3.21-2.26-7.12-5.1-8.78-1.07-.59-2.14-.83-2.97-.59-.24 0-2.97 1.54-2.97 1.66-.71.59-1.19 1.54-1.19 3.09 0 3.21 2.26 7.12 5.1 8.78 1.19.71 2.26.83 3.21.59.24-.12 2.85-1.42 3.32-2.14.36-.71.6-1.54.6-2.61z\" fill=\"url(#H)\"/><path d=\"M49.3 71.82c0 3.21 2.26 7.12 5.1 8.78 2.85 1.66 5.1.36 5.1-2.85s-2.26-7.12-5.1-8.78-5.1-.48-5.1 2.85z\" fill=\"url(#I)\"/><path d=\"M51.67 73.01c0 1.78 1.31 4.04 2.85 4.99s2.85.24 2.85-1.66c0-1.78-1.31-4.04-2.85-4.99-1.54-.96-2.85-.24-2.85 1.66z\" fill=\"#fff\"/><path d=\"M52.74 73.63c0 .95.71 2.26 1.54 2.73s1.54.12 1.54-.83-.71-2.26-1.54-2.73c-.82-.6-1.54-.12-1.54.83z\" fill=\"url(#J)\"/><path d=\"M70.06 70.64c0-.83-.59-1.07-1.19-.71a2.63 2.63 0 0 0-1.31 2.14c0 .83.59 1.07 1.19.71.72-.36 1.19-1.31 1.31-2.14zM91.9 57.81c0-.71-.47-1.07-1.19-.59-.71.36-1.19 1.31-1.19 2.02s.47 1.07 1.19.59c.59-.35 1.19-1.19 1.19-2.02z\" fill=\"#fff\"/><path d=\"M66.78 71.3l.07-.49-.09-.49 26.2-15.06-18.23-11.8-10.26-15.48c-.04-.05-.07-.1-.13-.13L44.3 16.35a3.75 3.75 0 0 0-3.71-.02L21.2 27.16 9.18 36.03l-.76.52c-.51.35-.89.86-1.08 1.46l-.12.38c-.27.86-.26 1.78.04 2.63l1.72 5.01 1.51.91c.83-2.14 2.53-3.05 5.02-1.62 3.21 1.9 5.82 6.41 5.82 10.09v.12l.24.71L48.4 71.67l.36.12v-.71c0-3.68 2.61-5.22 5.82-3.32 3.09 1.78 5.58 5.94 5.82 9.62l1.15.84c.61.45 1.29 1.14 1.91 1.14.23 0 .63-.16 1.16-.44.48-.25 1.02-.57 1.47-.84l2.72-1.58 3.32-1.92 3.62-2.1 3.65-2.11 3.39-1.97 2.86-1.66 2.05-1.18.95-.55c.01-.01.02-.01.03-.02.65-.38 1.2-.92 1.58-1.57l2.18-3.72c.02-.04.02-.08.04-.11l-26.21 15.1.51-3.39zM47.71 55.8l-3.69-14.57a1.23 1.23 0 0 1 .59-1.38L62.94 29.4a1.24 1.24 0 0 1 1.65.4l8.43 12.93c.39.61.19 1.42-.44 1.76l-22.56 12.3c-.92.52-2.05.02-2.31-.99z\" fill=\"url(#K)\"/><path d=\"M15.87 37.04c.32-.8.16-1.6-.48-1.92s-1.44 0-1.76.8-.16 1.6.48 1.92 1.44 0 1.76-.8z\" fill=\"url(#L)\"/><path d=\"M42.41 40.45l-15.73-9.1c-.65-.37-1.46-.29-2.01.21l-6.23 5.65c-.88.79-.7 2.22.34 2.78l.64.35L45.9 55.65l.14-.37c.22-.61.26-1.27.1-1.9l-2.91-11.86c-.12-.45-.41-.84-.82-1.07z\" fill=\"#fff\"/><path d=\"M34.88 36.09l-2.3 11.86-.93-.54 2.27-11.88.96.56z\" fill=\"url(#M)\"/><path d=\"M36.45 21.58c0 .08.02.14.02.22v.12l.01.24.04.48c.04.32.1.64.19.95s.199.615.33.91.29.58.46.85.37.53.58.77l.19.21c.06.06.12.14.19.18.02.01.05.02.07.04.03.02.05.06.08.08.07.06.15.11.23.17l.32.2 2.82 1.51c.03-.03.03.03.03.03l.03-.03-.07-.07c-.17-.1-.34-.14-.48-.24-.09-.04-.16-.13-.24-.19l-.24-.24c-.222-.232-.422-.483-.6-.75s-.342-.541-.48-.83a7.54 7.54 0 0 1-.36-.89c-.1-.31-.17-.62-.22-.94l-.05-.48c-.01-.08-.01-.16-.01-.24 0-.04-.01-.08 0-.12.02-.1.01-.2.01-.3v-.21-.03l-.03-6.42 6.29-6.15 6.21-1.13-2.78-1.58-6.29 1.07-6.29 6.15.03 6.42v.03a1.04 1.04 0 0 1 .01.21z\" fill=\"url(#N)\"/><path d=\"M51.77 9.29v6.43c0 .34.27 6.33-6.19 13.55-3.52.14-5.1-1.61-5.78-3.32-.58-1.47-.51-2.91-.51-3.05l-.03-6.4 6.26-6.13 6.25-1.08z\" fill=\"#fff\"/><path d=\"M50.43 11.72v5.03c0 .24.24 5-4.89 10.71-5.13.21-4.93-4.76-4.93-5.03V17.4l4.89-4.83 4.93-.85z\" fill=\"url(#O)\"/><use xlink:href=\"#V\" fill=\"url(#P)\"/><path d=\"M19.34 27.47c2.28 1.05 2.62 4.06 2.62 4.06s.34-3.01 2.62-4.06c-2.28-1.05-2.62-4.06-2.62-4.06s-.34 3.01-2.62 4.06z\" fill=\"url(#Q)\"/><path d=\"M75.87 34.29c4.47 2.06 5.14 7.98 5.14 7.98s.67-5.92 5.14-7.98c-4.47-2.06-5.14-7.98-5.14-7.98s-.66 5.92-5.14 7.98z\" fill=\"url(#R)\"/><path d=\"M10.33 18.49c3.55 1.64 4.08 6.33 4.08 6.33s.53-4.7 4.08-6.33c-3.55-1.64-4.08-6.33-4.08-6.33s-.53 4.7-4.08 6.33z\" fill=\"url(#S)\"/></g><defs><linearGradient id=\"A\" x1=\"-85.417\" y1=\"64.977\" x2=\"96.97\" y2=\"64.977\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"37.605\" y1=\"43.466\" x2=\"197.542\" y2=\"43.466\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"5.961\" y1=\"43.239\" x2=\"25.493\" y2=\"43.239\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"46.952\" y1=\"67.641\" x2=\"59.272\" y2=\"67.641\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"2.283\" y1=\"51.532\" x2=\"26.798\" y2=\"51.532\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"7.976\" y1=\"52.401\" x2=\"27.272\" y2=\"52.401\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"11.637\" y1=\"52.175\" x2=\"17.179\" y2=\"52.175\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"41.343\" y1=\"73.906\" x2=\"65.858\" y2=\"73.906\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"46.623\" y1=\"74.775\" x2=\"65.919\" y2=\"74.775\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"50.697\" y1=\"74.549\" x2=\"56.239\" y2=\"74.549\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"-8.097\" y1=\"47.602\" x2=\"101.502\" y2=\"47.602\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"9.128\" y1=\"36.479\" x2=\"23.211\" y2=\"36.479\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"21.42\" y1=\"41.742\" x2=\"55.51\" y2=\"41.742\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"29.546\" y1=\"31.4\" x2=\"62.653\" y2=\"-1.706\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"31.32\" y1=\"19.592\" x2=\"63.555\" y2=\"19.592\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"34.073\" y1=\"69.584\" x2=\"69.654\" y2=\"69.584\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"14.55\" y1=\"27.473\" x2=\"56.799\" y2=\"27.473\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"R\" x1=\"71.513\" y1=\"34.289\" x2=\"114.116\" y2=\"34.289\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"S\" x1=\"6.124\" y1=\"18.491\" x2=\"54.489\" y2=\"18.491\" xlink:href=\"#W\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"T\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><path id=\"U\" d=\"M22.94 53.84c0-3.21-2.26-7.12-5.1-8.78-1.07-.59-2.14-.83-2.97-.59-.24 0-2.97 1.54-2.97 1.66-.71.59-1.19 1.54-1.19 3.09 0 3.21 2.26 7.12 5.1 8.78 1.19.71 2.26.83 3.21.59.24-.12 2.85-1.42 3.32-2.14.36-.71.6-1.54.6-2.61z\"/><path id=\"V\" d=\"M41.47 69.58c2.28 1.05 2.62 4.06 2.62 4.06s.34-3.01 2.62-4.06c-2.28-1.05-2.62-4.06-2.62-4.06s-.34 3.01-2.62 4.06z\"/><linearGradient id=\"W\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgCarShiny = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#R)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#dfd4fb\"/><path d=\"M92.45 59.58l.52-4.32-26.2 15.06.09.49-.59 3.88 26.18-15.11z\" fill=\"url(#A)\"/><path d=\"M63.37 29.1L43.98 40.09c-.35.2-.27.87-.17 1.26l4.17 15.88a.89.89 0 0 0 .511.59.89.89 0 0 0 .779-.039l24.3-13.47c.46-.25.6-.85.31-1.28l-9.08-13.4c-.26-.38-1.03-.75-1.43-.53z\" fill=\"url(#B)\"/><path d=\"M15.49 39.53l-6.53 3.32 1.54 4.1 7.48-4.39-2.49-3.03z\" fill=\"url(#C)\"/><path d=\"M54.56 63.49l-6.53 3.21.71 5.1 7.48-4.15-1.66-4.16z\" fill=\"url(#D)\"/><use xlink:href=\"#S\" fill=\"url(#E)\"/><path d=\"M10.24 49.44c0 3.21 2.26 7.12 5.1 8.78 2.85 1.66 5.1.36 5.1-2.85s-2.26-7.12-5.1-8.78-5.1-.47-5.1 2.85z\" fill=\"url(#F)\"/><path d=\"M12.61 50.63c0 1.78 1.31 4.04 2.85 4.99s2.85.24 2.85-1.66c0-1.78-1.31-4.04-2.85-4.99s-2.85-.24-2.85 1.66z\" fill=\"#fff\"/><path d=\"M13.68 51.25c0 .95.71 2.26 1.54 2.73s1.54.12 1.54-.83-.71-2.26-1.54-2.73c-.82-.59-1.54-.12-1.54.83z\" fill=\"url(#G)\"/><path d=\"M62 76.21c0-3.21-2.26-7.12-5.1-8.78-1.07-.59-2.14-.83-2.97-.59-.24 0-2.97 1.54-2.97 1.66-.71.59-1.19 1.54-1.19 3.09 0 3.21 2.26 7.12 5.1 8.78 1.19.71 2.26.83 3.21.59.24-.12 2.85-1.42 3.32-2.14.36-.71.6-1.54.6-2.61z\" fill=\"url(#H)\"/><path d=\"M49.3 71.82c0 3.21 2.26 7.12 5.1 8.78 2.85 1.66 5.1.36 5.1-2.85s-2.26-7.12-5.1-8.78-5.1-.48-5.1 2.85z\" fill=\"url(#I)\"/><path d=\"M51.67 73.01c0 1.78 1.31 4.04 2.85 4.99s2.85.24 2.85-1.66c0-1.78-1.31-4.04-2.85-4.99-1.54-.96-2.85-.24-2.85 1.66z\" fill=\"#fff\"/><path d=\"M52.74 73.63c0 .95.71 2.26 1.54 2.73s1.54.12 1.54-.83-.71-2.26-1.54-2.73c-.82-.6-1.54-.12-1.54.83z\" fill=\"url(#J)\"/><path d=\"M70.06 70.64c0-.83-.59-1.07-1.19-.71a2.63 2.63 0 0 0-1.31 2.14c0 .83.59 1.07 1.19.71.72-.36 1.19-1.31 1.31-2.14zM91.9 57.81c0-.71-.47-1.07-1.19-.59-.71.36-1.19 1.31-1.19 2.02s.47 1.07 1.19.59c.59-.35 1.19-1.19 1.19-2.02z\" fill=\"#fff\"/><path d=\"M66.78 71.3l.07-.49-.09-.49 26.2-15.06-18.23-11.8-10.26-15.48c-.04-.05-.07-.1-.13-.13L44.3 16.35a3.75 3.75 0 0 0-3.71-.02L21.2 27.16 9.18 36.03l-.76.52c-.51.35-.89.86-1.08 1.46l-.12.38c-.27.86-.26 1.78.04 2.63l1.72 5.01 1.51.91c.83-2.14 2.53-3.05 5.02-1.62 3.21 1.9 5.82 6.41 5.82 10.09v.12l.24.71L48.4 71.67l.36.12v-.71c0-3.68 2.61-5.22 5.82-3.32 3.09 1.78 5.58 5.94 5.82 9.62l1.15.84c.61.45 1.29 1.14 1.91 1.14.23 0 .63-.16 1.16-.44.48-.25 1.02-.57 1.47-.84l2.72-1.58 3.32-1.92 3.62-2.1 3.65-2.11 3.39-1.97 2.86-1.66 2.05-1.18.95-.55c.01-.01.02-.01.03-.02.65-.38 1.2-.92 1.58-1.57l2.18-3.72c.02-.04.02-.08.04-.11l-26.21 15.1.51-3.39zM47.71 55.8l-3.69-14.57a1.23 1.23 0 0 1 .59-1.38L62.94 29.4a1.24 1.24 0 0 1 1.65.4l8.43 12.93c.39.61.19 1.42-.44 1.76l-22.56 12.3c-.92.52-2.05.02-2.31-.99z\" fill=\"url(#K)\"/><path d=\"M15.87 37.04c.32-.8.16-1.6-.48-1.92s-1.44 0-1.76.8-.16 1.6.48 1.92 1.44 0 1.76-.8z\" fill=\"url(#L)\"/><path d=\"M42.41 40.45l-15.73-9.1c-.65-.37-1.46-.29-2.01.21l-6.23 5.65c-.88.79-.7 2.22.34 2.78l.64.35L45.9 55.65l.14-.37c.22-.61.26-1.27.1-1.9l-2.91-11.86c-.12-.45-.41-.84-.82-1.07z\" fill=\"#fff\"/><path d=\"M34.88 36.09l-2.3 11.86-.93-.54 2.27-11.88.96.56z\" fill=\"url(#M)\"/><use xlink:href=\"#T\" fill=\"url(#N)\"/><path d=\"M19.34 27.47c2.28 1.05 2.62 4.06 2.62 4.06s.34-3.01 2.62-4.06c-2.28-1.05-2.62-4.06-2.62-4.06s-.34 3.01-2.62 4.06z\" fill=\"url(#O)\"/><path d=\"M75.87 34.29c4.47 2.06 5.14 7.98 5.14 7.98s.67-5.92 5.14-7.98c-4.47-2.06-5.14-7.98-5.14-7.98s-.66 5.92-5.14 7.98z\" fill=\"url(#P)\"/><path d=\"M10.33 18.49c3.55 1.64 4.08 6.33 4.08 6.33s.53-4.7 4.08-6.33c-3.55-1.64-4.08-6.33-4.08-6.33s-.53 4.7-4.08 6.33z\" fill=\"url(#Q)\"/></g><defs><linearGradient id=\"A\" x1=\"-85.417\" y1=\"64.977\" x2=\"96.97\" y2=\"64.977\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"37.605\" y1=\"43.466\" x2=\"197.542\" y2=\"43.466\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"5.961\" y1=\"43.239\" x2=\"25.493\" y2=\"43.239\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"46.952\" y1=\"67.641\" x2=\"59.272\" y2=\"67.641\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"2.283\" y1=\"51.532\" x2=\"26.798\" y2=\"51.532\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"7.976\" y1=\"52.401\" x2=\"27.272\" y2=\"52.401\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"11.637\" y1=\"52.175\" x2=\"17.179\" y2=\"52.175\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"41.343\" y1=\"73.906\" x2=\"65.858\" y2=\"73.906\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"46.623\" y1=\"74.775\" x2=\"65.919\" y2=\"74.775\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"50.697\" y1=\"74.549\" x2=\"56.239\" y2=\"74.549\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"-8.097\" y1=\"47.602\" x2=\"101.502\" y2=\"47.602\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"9.128\" y1=\"36.479\" x2=\"23.211\" y2=\"36.479\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"21.42\" y1=\"41.742\" x2=\"55.51\" y2=\"41.742\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"34.073\" y1=\"69.584\" x2=\"69.654\" y2=\"69.584\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"14.55\" y1=\"27.473\" x2=\"56.799\" y2=\"27.473\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"71.513\" y1=\"34.289\" x2=\"114.116\" y2=\"34.289\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"6.124\" y1=\"18.491\" x2=\"54.489\" y2=\"18.491\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"R\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><path id=\"S\" d=\"M22.94 53.84c0-3.21-2.26-7.12-5.1-8.78-1.07-.59-2.14-.83-2.97-.59-.24 0-2.97 1.54-2.97 1.66-.71.59-1.19 1.54-1.19 3.09 0 3.21 2.26 7.12 5.1 8.78 1.19.71 2.26.83 3.21.59.24-.12 2.85-1.42 3.32-2.14.36-.71.6-1.54.6-2.61z\"/><path id=\"T\" d=\"M41.47 69.58c2.28 1.05 2.62 4.06 2.62 4.06s.34-3.01 2.62-4.06c-2.28-1.05-2.62-4.06-2.62-4.06s-.34 3.01-2.62 4.06z\"/><linearGradient id=\"U\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeDamageEbikeScooter = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#R)\"><g clip-path=\"url(#S)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M46.98 29.84c-.01.168-.03.335-.06.5-.02.14-.07.27-.1.41l-.14.48-.16.39-.23.5c-.06.12-.14.24-.21.35l-.37.56c-.08.11-.17.21-.26.32-.2.25-.43.49-.67.73l-.26.26c-.15.14-.32.27-.49.4l-.45.35-.57.38-.6.39c-.485.281-.986.535-1.5.76l-.46.19-1.25.47-.46.16-.82.24-.62.17-.88.19-.6.12-1.81.25-.56.05-1.08.07-.69.02h-.87c-.24 0-.49-.01-.73-.02l-.81-.04-.74-.06-.8-.09-.71-.1-.84-.15-.66-.13-.99-.24-.55-.15-1.71-.58-.81-.34-.41-.18-1.17-.61c-3.14-1.81-4.71-4.19-4.7-6.57l-.12 42.75c-.01 2.38 1.56 4.75 4.7 6.57l1.17.61.41.18.72.31.09.03c.55.22 1.13.41 1.71.58.05.01.09.03.14.05.13.04.27.06.41.1l.99.24c.09.02.17.05.26.06.13.03.27.04.4.07l.84.15.34.06c.12.02.25.03.37.04l.8.09.38.04.35.02.81.04.4.02h.33.87.43c.09 0 .17-.01.26-.02l1.08-.07.43-.03c.04 0 .09-.01.13-.02l1.81-.25c.03-.01.06-.01.09-.01l.51-.11.89-.19.62-.17.83-.24c.06-.02.12-.03.18-.05.1-.03.18-.07.28-.11l1.26-.48.45-.19c.52-.23 1.03-.48 1.5-.76l.19-.11.41-.27.58-.38c.16-.11.3-.23.45-.35l.49-.4c.03-.03.07-.05.1-.08l.17-.18.67-.73c.04-.05.1-.1.15-.16.04-.05.07-.11.11-.16.14-.18.26-.37.37-.55l.16-.23.06-.12c.09-.16.16-.33.23-.49.04-.1.1-.19.14-.29l.03-.1c.06-.16.09-.32.14-.47l.09-.32c.01-.03 0-.06.01-.09.03-.17.04-.33.06-.5l.04-.33v-.14l.12-42.75c-.05.13-.08.28-.09.44z\" fill=\"url(#A)\"/><path d=\"M42.31 22.79c6.24 3.6 6.29 9.45.08 13.05-6.2 3.61-16.3 3.61-22.54 0-6.24-3.6-6.27-9.45-.07-13.05s16.28-3.6 22.53 0z\" fill=\"url(#B)\"/><path d=\"M46.86 67.06c-.01.168-.03.335-.06.5-.02.14-.07.27-.1.41l-.14.48-.16.39-.23.5c-.06.12-.14.24-.21.35l-.37.56c-.08.11-.17.21-.26.32-.2.25-.43.49-.67.73l-.26.26c-.15.14-.32.27-.49.4l-.45.35-.57.38-.6.39c-.485.281-.986.535-1.5.76l-.46.19-1.25.47-.46.16-.82.24-.62.17-.88.19-.6.12-1.81.25-.56.05-1.08.07-.69.02h-.87c-.24 0-.49-.01-.73-.02l-.81-.04-.74-.06-.8-.09-.71-.1-.84-.15-.66-.13-.99-.24-.55-.15-1.71-.58-.81-.34-.41-.18-1.17-.61c-3.14-1.81-4.71-4.19-4.7-6.57v5.53c-.01 2.38 1.56 4.75 4.7 6.57l1.17.61.41.18.72.31.09.03c.55.22 1.13.41 1.71.58.05.01.09.03.14.05.13.04.27.06.41.1l.99.24c.09.02.17.05.26.06.13.03.27.04.4.07l.84.15.34.06c.12.02.25.03.37.04l.8.09.38.04.35.02.81.04.4.02h.33.87.43c.09 0 .17-.01.26-.02l1.08-.07.43-.03c.04 0 .09-.01.13-.02l1.81-.25c.03-.01.06-.01.09-.01l.51-.11.89-.19.62-.17.83-.24c.06-.02.12-.03.18-.05.1-.03.18-.07.28-.11l1.26-.48.45-.19c.52-.23 1.03-.48 1.5-.76l.19-.11.41-.27.58-.38c.16-.11.3-.23.45-.35l.49-.4c.03-.03.07-.05.1-.08l.17-.18.67-.73c.04-.05.1-.1.15-.16.04-.05.07-.11.11-.16.14-.18.26-.37.37-.55l.16-.23.06-.12c.09-.16.16-.33.23-.49.04-.1.1-.19.14-.29l.03-.1c.06-.16.09-.32.14-.47l.09-.32c.01-.03 0-.06.01-.09.03-.17.04-.33.06-.5l.04-.33v-.14-5.53c-.06.13-.08.28-.09.44z\" fill=\"url(#C)\"/><path d=\"M39.47 24.49c4.7 2.71 4.72 7.11.06 9.83-4.67 2.71-12.26 2.71-16.96 0s-4.72-7.11-.06-9.83c4.66-2.71 12.26-2.71 16.96 0z\" fill=\"url(#D)\"/><path d=\"M35.27 25.77c-.01.02-.01.03-.01.05-.05.14-.12.27-.2.4-.02.02-.03.05-.05.07a2.38 2.38 0 0 1-.34.38c-.09.08-.2.15-.3.22-.09.06-.16.13-.27.19-.26.15-.55.27-.85.37-.11.04-.22.07-.33.1l-.43.11c-.17.04-.35.07-.53.09-.04.01-.08.01-.12.02-.24.03-.48.04-.73.04H31c-.24 0-.48-.02-.72-.04-.04 0-.07-.01-.11-.01l-.69-.12-.13-.03c-.21-.05-.41-.11-.6-.18l-.1-.03c-.23-.09-.46-.19-.66-.31-.64-.37-1.04-.82-1.2-1.3a1.61 1.61 0 0 1-.08-.48l-.01 3.54c0 .64.42 1.29 1.28 1.78.2.11.41.21.63.3.01 0 .02.01.03.01l.1.03.39.13.21.05.13.03.12.03.43.07c.05.01.1.01.15.02.04 0 .07.01.11.01l.17.02.43.02h.13.11.2l.48-.03c.02 0 .03-.01.05-.01.041-.002.081-.008.12-.02l.38-.05c.05-.01.1-.03.15-.04l.43-.11c.08-.02.16-.03.23-.06.03-.01.06-.03.1-.04.3-.1.59-.22.85-.37.02-.01.04-.02.05-.03.08-.05.14-.11.22-.16l.3-.22c.01-.01.02-.01.03-.02.1-.09.19-.19.27-.29.02-.02.03-.05.05-.07s.03-.05.05-.07c.03-.04.06-.08.08-.12.05-.08.08-.16.12-.25 0-.01.01-.03.01-.04.01-.02.01-.03.01-.05.02-.05.03-.1.05-.16a1.07 1.07 0 0 0 .03-.25v-.04l.01-3.54-.12.46z\" fill=\"url(#E)\"/><path d=\"M34.06 23.54c1.7.98 1.71 2.57.03 3.54-1.69.98-4.42.97-6.11 0s-1.71-2.56-.02-3.54c1.68-.97 4.42-.97 6.1 0z\" fill=\"url(#F)\"/><path d=\"M44.92 51.26l-7.15 14.27 2.56-9.36-3.73 2.15 7.03-14.52-2.52 9.66 3.81-2.2z\" fill=\"#fff\"/><path d=\"M62.54 65.69a1.59 1.59 0 0 1-.75-.2c-4.3-2.51-7.34-7.49-8.33-13.67-.65-4.05-.44-8.16-.24-12.13l.15-3.36c.15-4.52.01-9.74-2.22-14.16-1.82-3.61-5.92-7.31-10.64-6.88-4.39.39-8.09 4.82-7.76 9.28a1.48 1.48 0 0 1-.354 1.08 1.48 1.48 0 0 1-.457.357c-.174.088-.364.14-.559.154a1.46 1.46 0 0 1-1.085-.348 1.46 1.46 0 0 1-.505-1.022c-.45-6.1 4.44-11.92 10.46-12.46 6.12-.55 11.22 3.88 13.56 8.5 2.53 5.02 2.7 10.7 2.54 15.6l-.15 3.41c-.2 3.99-.39 7.76.2 11.51.85 5.3 3.36 9.51 6.89 11.57.71.41.95 1.32.54 2.03a1.49 1.49 0 0 1-1.29.74z\" fill=\"url(#G)\"/><path d=\"M76.88 63.63c.92-.53 1.67-.11 1.68.96l.02 6.32c0 1.06-.74 2.36-1.67 2.9l-12.43 7.18c-.92.53-1.67.1-1.68-.97l-.02-6.32c0-1.06.74-2.35 1.67-2.89l12.43-7.18z\" fill=\"url(#H)\"/><path d=\"M77.52 63.4h.03c.09-.01.18 0 .27.01.1.02.18.05.25.09h-.01l-13.3-7.74c-.04-.03-.06-.04-.09-.05l-.09-.03c-.02-.01-.04-.01-.06-.01h-.03c-.03-.01-.07-.01-.1-.01h-.11-.04-.03c-.02 0-.04 0-.06.01l-.15.03c-.02.01-.04.02-.06.02-.02.01-.04.01-.06.02s-.05.01-.07.03c-.08.03-.16.07-.23.12l-12.43 7.18c-.204.119-.392.264-.56.43l-.08.08-.03.03-.08.08c-.05.05-.09.11-.14.17l-.11.15c-.03.05-.07.1-.1.14l-.09.14-.08.13c-.02.05-.05.09-.07.14s-.05.1-.07.14l-.06.15-.06.16-.03.09c0 .01 0 .01-.01.02-.01.02-.01.04-.02.06-.02.06-.03.13-.05.19-.02.08-.03.16-.04.23l-.02.33.02 6.32c0 .53.19.9.49 1.08l13.31 7.74c-.3-.18-.49-.55-.49-1.08l-.02-6.32a3.04 3.04 0 0 1 .13-.82c.08-.29.2-.57.35-.83s.32-.5.52-.71l.03-.03c.2-.21.41-.38.64-.52l12.43-7.18a1.67 1.67 0 0 1 .31-.14c.02-.01.04-.01.06-.02.11.01.2-.01.29-.02z\" fill=\"url(#I)\"/><path d=\"M76.48 69.01l6.21 3.61c-.01-.01-.02-.01-.04-.02l-6.21-3.61c.02.01.03.01.04.02z\" fill=\"url(#J)\"/><path d=\"M82.66 72.6l-6.22-3.61.01.01 6.21 3.61v-.01z\" fill=\"url(#K)\"/><path d=\"M82.66 72.61L76.45 69c.01 0 .02.01.03.01l6.21 3.61c-.01-.01-.02-.01-.03-.01z\" fill=\"url(#L)\"/><path d=\"M82.69 72.62l-6.21-3.61 6.21 3.61z\" fill=\"url(#M)\"/><path d=\"M81.17 72.04l1.48.57L76.44 69l-1.48-.57c-.01 0-.03-.01-.04-.01-.03-.01-.06-.02-.1-.02-.03-.01-.07-.01-.1-.01h-.11c-.04 0-.08.01-.12.01l-.13.03-.18.06-.21.1-5.72 3.3c-.17.1-.34.23-.5.39l-.02.02-.15.16c-.05.05-.09.11-.13.16l-.11.15-.06.09-1.48 2.28c0 .01-.01.01-.01.02-.01.01-.02.03-.03.04s-.02.03-.02.04c-.01.01-.01.03-.02.04s-.01.03-.02.04-.01.03-.02.04c0 .01-.01.02-.01.03-.01.03-.01.04-.02.06s-.01.04-.01.06c-.01.02-.01.05-.01.07v.03a.42.42 0 0 0 .01.16.17.17 0 0 0 .01.07c.02.07.06.12.12.15l6.21 3.61c-.06-.03-.09-.09-.12-.15-.01-.02-.01-.05-.01-.07a.42.42 0 0 1-.01-.16l.04-.22c.031-.095.075-.186.13-.27l1.48-2.28c.14-.21.3-.41.46-.57.155-.158.33-.296.52-.41l5.72-3.3c.18-.1.35-.17.52-.19.16-.01.32.01.46.06z\" fill=\"url(#N)\"/><path d=\"M80.18 72.19c.35-.2.7-.26.99-.16l1.48.57c.24.09.24.53 0 .9l-1.48 2.28c-.29.43-.63.78-.99.99l-5.72 3.3c-.35.2-.7.26-.99.16l-1.48-.57c-.25-.09-.25-.52 0-.9l1.48-2.28c.29-.43.63-.78.99-.99l5.72-3.3z\" fill=\"url(#O)\"/><path d=\"M79.2 80.31v-.04-.02-.05c0-.01 0-.02-.01-.03v-.02-.02l-.01-.05-.01-.02-.01-.02c0-.01-.01-.01-.01-.02V80l-.02-.05-.03-.05c-.01-.01-.01-.02-.02-.02-.01-.01-.01-.02-.02-.03l-.04-.04-.04-.04c-.01-.01-.02-.02-.04-.03l-.03-.03c-.01-.01-.03-.02-.05-.03l-2.02-1.17-2.01-1.17c-.01 0-.02-.01-.03-.01s-.02-.01-.03-.01-.02 0-.03-.01h-.03-.03-.04c-.01 0-.03.01-.04.01-.02.01-.04.01-.06.02l-.06.03c-.06.03-.12.08-.18.14l-.02.02-.04.04c-.01.02-.03.03-.04.05-.01.01-.02.03-.03.05-.01.01-.02.03-.03.04s-.01.02-.02.04-.02.04-.02.05c-.01.01-.01.03-.02.04s-.01.03-.02.04c-.01.02-.01.03-.02.05s-.01.03-.02.05c0 .03-.01.04-.01.05-.01.02-.01.04-.01.06-.01.02-.01.05-.01.07 0 .03-.01.06-.01.09 0 .08.01.15.04.21.01.02.03.03.04.04a.27.27 0 0 0 .07.08l2.01 1.17 2.01 1.17.05.03c.01.01.02.01.02.02l.04.02h.02l.04.01h.03.02.04.05.03.02.03.02.04.01.01l.04-.01.06-.01.02-.01h.01.01l.01-.01c.01 0 .02-.01.02-.01.01 0 .01 0 .02-.01l.03-.02c.01 0 .01-.01.02-.01l.02-.01.03-.02.03-.02.03-.03.03-.03.02-.03c.01-.01.02-.02.02-.03l.02-.03.02-.03c.01-.01.01-.02.02-.03v-.01l.01-.01.01-.01c0-.01.01-.02.01-.02l.01-.03c0-.01.01-.02.01-.03v-.01-.01-.01-.01l.01-.03.01-.04.01-.04v-.04-.04c.02.01.02.01.02 0z\" fill=\"url(#P)\"/><path d=\"M85 76.67v-.04-.02-.05c0-.01 0-.02-.01-.03v-.02-.02l-.01-.05-.01-.02-.01-.02c0-.01-.01-.01-.01-.02v-.02l-.02-.05-.03-.05c-.01-.01-.01-.02-.02-.02-.01-.01-.01-.02-.02-.03l-.04-.04-.04-.04c-.01-.01-.02-.02-.04-.03l-.03-.03c-.01-.01-.03-.02-.05-.03l-2.02-1.17-2.01-1.17c-.01 0-.02-.01-.03-.01s-.02-.01-.03-.01-.02 0-.03-.01h-.03-.03-.04c-.01 0-.03.01-.04.01-.02.01-.04.01-.06.02l-.06.03c-.06.03-.12.08-.18.14l-.02.02-.04.04c-.01.02-.03.03-.04.05-.01.01-.02.03-.03.05-.01.01-.02.03-.03.04s-.01.02-.02.04-.02.04-.02.05c-.01.01-.01.03-.02.04s-.01.03-.02.04c-.01.02-.01.03-.02.05s-.01.03-.02.05c0 .03-.01.04-.01.05-.01.02-.01.04-.01.06-.01.02-.01.05-.01.07 0 .03-.01.06-.01.09 0 .08.01.15.04.21.01.02.03.03.04.04.018.031.042.058.07.08l2.01 1.17 2.01 1.17.05.03c.01.01.02.01.02.02l.04.02h.02l.05.02h.03.02.04.05.03.02.03.02.04.01.01l.04-.01.06-.01.02-.01h.01.01l.01-.01c.01 0 .02-.01.02-.01.01 0 .01 0 .02-.01l.03-.02c.01 0 .01-.01.02-.01l.02-.01.03-.02.03-.02.03-.03.03-.02.02-.03c.01-.01.02-.02.02-.03l.02-.03.02-.03c.01-.01.01-.02.02-.03v-.01l.01-.01-.01-.01c0-.01.01-.02.01-.02l.01-.03c0-.01.01-.02.01-.03v-.01-.01-.01-.01l.01-.03.01-.04.01-.04v-.04-.04c.03-.01.03-.01.03-.02z\" fill=\"url(#Q)\"/></g></g><defs><linearGradient id=\"A\" x1=\"8.422\" y1=\"55.287\" x2=\"52.765\" y2=\"55.287\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"8.636\" y1=\"29.321\" x2=\"67.809\" y2=\"29.321\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"5.057\" y1=\"73.898\" x2=\"77.24\" y2=\"73.898\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"18.333\" y1=\"29.406\" x2=\"82.459\" y2=\"29.406\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"23.206\" y1=\"28.329\" x2=\"38.15\" y2=\"28.329\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"23.277\" y1=\"25.315\" x2=\"41.381\" y2=\"25.315\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"-37.396\" y1=\"38.99\" x2=\"98.126\" y2=\"38.99\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".126\" stop-color=\"#f4ebfa\"/><stop offset=\".383\" stop-color=\"#d6b9ec\"/><stop offset=\".745\" stop-color=\"#a768d6\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"49.884\" y1=\"72.3\" x2=\"81.091\" y2=\"72.3\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"54.37\" y1=\"80.612\" x2=\"71.919\" y2=\"50.217\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"76.444\" y1=\"70.807\" x2=\"82.692\" y2=\"70.807\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"76.444\" y1=\"70.8\" x2=\"82.664\" y2=\"70.8\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"76.452\" y1=\"70.808\" x2=\"82.689\" y2=\"70.808\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"76.477\" y1=\"70.815\" x2=\"82.692\" y2=\"70.815\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"70.163\" y1=\"80.904\" x2=\"79.52\" y2=\"64.698\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"66.106\" y1=\"76.127\" x2=\"85.054\" y2=\"76.127\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"59.413\" y1=\"79.172\" x2=\"84.958\" y2=\"79.172\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"65.205\" y1=\"75.532\" x2=\"90.75\" y2=\"75.532\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"R\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"S\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"T\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeDamageFamily = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#BL)\"><g clip-path=\"url(#BM)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M91.11 63.76c-.02.09-.32 1.88-4.46 3.49l-5.12-3.89 4.88.71.32-1.5 4.38 1.19z\" fill=\"url(#A)\"/><path d=\"M91.11 63.78c-.01.03-.02.1-.06.19-.041.107-.092.211-.15.31-.07.13-.16.27-.28.42-.14.17-.3.35-.5.53-.02.02-.05.04-.07.06l-.46.38c-.02.01-.03.03-.05.04-.18.14-.4.28-.63.42l-.15.09-.85.46c-.05.02-.1.05-.16.07l-1.12.48v1.21l1.12-.48c.05-.02.1-.05.15-.07l.85-.46c.02-.01.05-.03.07-.04l.08-.05.63-.42c.02-.01.03-.03.05-.04l.46-.38c.02-.01.04-.03.05-.04l.02-.02a5.59 5.59 0 0 0 .49-.52c.108-.132.205-.272.29-.42.057-.103.107-.21.15-.32.04-.1.05-.16.06-.19v-1.23c.01 0 .01.01.01.02z\" fill=\"url(#B)\"/><path d=\"M86.65 67.24v1.22l-5.12-3.89v-1.21l5.12 3.88z\" fill=\"url(#C)\"/><path d=\"M27.3 73.13v1.22l-.28 4.17V77.3l.28-4.17z\" fill=\"url(#D)\"/><path d=\"M23.71 68.05l1.76 6.15 1.83-1.07-.28 4.17c-6.78.53-11.55-1.77-13.21-2.73-.42-.24-.63-.39-.64-.4l3.31-3.49 1.17 1.38 6.06-4.01z\" fill=\"url(#E)\"/><path d=\"M24.76 77.37h-.25l-1.96-.12-.47-.05-1.47-.22-.4-.07-1.2-.28-.56-.14-1.38-.44-.33-.12-1.01-.4-.14-.06-.92-.43-.19-.09-.66-.36-.64-.4v1.21c.01.01.22.16.64.4l.66.36.18.09.92.43.14.06.59.24.42.15.33.12 1.33.43c.02 0 .04.01.05.01.17.05.37.09.55.13l1.07.26c.04.01.09.01.13.02.13.03.27.05.4.07l.96.17.51.06.47.05.43.05 1.42.08h.11.26l1.12-.01 1.14-.06V77.3c-.77.07-1.52.08-2.25.07z\" fill=\"url(#F)\"/><path d=\"M64.561 62.72l-1.25-.82-1.58.61.46 1.08 1.82-.65.55-.22z\" fill=\"url(#G)\"/><path d=\"M63.31 57.98l1.13.69-1.3 6.04-1.68-.85.89-4.43.96-1.45z\" fill=\"url(#H)\"/><path d=\"M60.77 54.25l1.09.54-2.69 4.64-1.54-1.78 1.59-2.4 1.55-1z\" fill=\"url(#I)\"/><path d=\"M56.23 44.92l1.22.56-5.91 12.89-1.68-1.27 5.44-11.62.93-.56z\" fill=\"url(#J)\"/><path d=\"M56.67 34.88l-3.9 12.84-1.89-.79 4.07-11.81 1.72-.24z\" fill=\"url(#K)\"/><path d=\"M62.79 34.63l-2.8-3.45-.67.95 3.47 2.5z\" fill=\"url(#L)\"/><path d=\"M48.63 71.96l-.31.02.31-.02z\" fill=\"url(#M)\"/><path d=\"M46.13 71.81c-.068-.011-.135-.028-.2-.05.06.01.13.03.2.05z\" fill=\"url(#N)\"/><path d=\"M47.41 71.97c-.08 0-.17-.01-.25-.01.09.01.17.01.25.01z\" fill=\"url(#O)\"/><path d=\"M38.16 72.39l.41.57-.41-.57z\" fill=\"url(#P)\"/><path d=\"M37.051 70.04l-.23-.63-.01-.01c.07.22.17.42.24.64z\" fill=\"url(#Q)\"/><path d=\"M45.04 71.48l-.14-.05.14.05z\" fill=\"url(#R)\"/><path d=\"M40.13 74.68c.17.15.36.27.55.4l-.55-.4z\" fill=\"url(#S)\"/><path d=\"M39.56 74.12l-.48-.49c.15.18.32.33.48.49z\" fill=\"url(#T)\"/><path d=\"M60.771 29.75l.65-.09c-.04 0-.08.01-.12.01l-.53.08z\" fill=\"url(#U)\"/><path d=\"M37.4 70.96c.1.23.23.43.34.65l-.34-.65z\" fill=\"url(#V)\"/><path d=\"M60.97 64.43l.48-.58-.48.58z\" fill=\"url(#W)\"/><path d=\"M59.46 66.05l.94-.99-.94.99z\" fill=\"url(#X)\"/><path d=\"M51.63 71.28l-.44.17a17.25 17.25 0 0 0 1.62-.62c-.02.01-.05.02-.07.03l-1.11.42z\" fill=\"url(#Y)\"/><path d=\"M58.29 67.16l-.82.7-.51.41-.92.68-.45.32-1.4.86c1.61-.9 3.16-2.08 4.62-3.44l-.52.47z\" fill=\"url(#Z)\"/><path d=\"M15.8 24.7l.97-1.1-.97 1.1z\" fill=\"url(#a)\"/><path d=\"M14.731 26.07l.54-.7-.54.7z\" fill=\"url(#b)\"/><path d=\"M17.09 23.25l.89-.88-.89.88z\" fill=\"url(#c)\"/><path d=\"M19.7 20.86c.63-.5 1.28-.94 1.94-1.34l-1.94 1.34z\" fill=\"url(#d)\"/><path d=\"M12.88 28.85l.15-.24-.15.24z\" fill=\"url(#e)\"/><path d=\"M24.8 18c.35-.12.7-.21 1.04-.29L24.8 18z\" fill=\"url(#f)\"/><path d=\"M8.99 43.76l-.05-.45.05.45z\" fill=\"url(#g)\"/><path d=\"M10.54 48.46l-.25-.4.25.4z\" fill=\"url(#h)\"/><path d=\"M9.99 47.5l-.21-.45.21.45z\" fill=\"url(#i)\"/><path d=\"M11.18 49.3l-.29-.35.29.35z\" fill=\"url(#j)\"/><path d=\"M11.91 50.01c-.11-.09-.22-.19-.32-.29l.32.29z\" fill=\"url(#k)\"/><path d=\"M11.87 30.71l.21-.42-.21.42z\" fill=\"url(#l)\"/><path d=\"M8.89 41.84l.11-1.8-.11 1.8z\" fill=\"url(#m)\"/><path d=\"M9.55 46.4l-.16-.49.16.49z\" fill=\"url(#n)\"/><path d=\"M11.11 32.33l.25-.56-.25.56z\" fill=\"url(#o)\"/><path d=\"M9.211 45.17l-.11-.5.11.5z\" fill=\"url(#p)\"/><path d=\"M9.42 37.51l.28-1.16-.28 1.16z\" fill=\"url(#q)\"/><path d=\"M14.141 26.9l-.37.54.37-.54z\" fill=\"url(#r)\"/><path d=\"M10.72 33.29l-.25.65.25-.65z\" fill=\"url(#s)\"/><path d=\"M10.17 34.8l-.26.81.26-.81z\" fill=\"url(#t)\"/><path d=\"M19.661 20.9l-1.39 1.2.08-.08 1.31-1.12z\" fill=\"url(#u)\"/><path d=\"M26.73 17.53l-.53.08.26-.04.27-.04z\" fill=\"url(#v)\"/><path d=\"M24 18.3l-.41.16.29-.12c.04 0 .08-.02.12-.04z\" fill=\"url(#w)\"/><path d=\"M27.75 17.44l-.35.01.23-.01h.12z\" fill=\"url(#x)\"/><path d=\"M9.28 38.2l-.23 1.5.03-.24.2-1.26z\" fill=\"url(#y)\"/><path d=\"M28.85 17.47l-.36-.04c.05.01.11.01.16.02l.2.02z\" fill=\"url(#z)\"/><path d=\"M22.14 57.98l2.52 1.96-.12-.09-2.4-1.87z\" fill=\"url(#AA)\"/><path d=\"M12.04 50.12l6.31 4.91 2.52 1.96-.14-.11-8.69-6.76z\" fill=\"url(#AB)\"/><path d=\"M20.88 57l1.26.98-.98-.76-.28-.22z\" fill=\"url(#AC)\"/><path d=\"M36.53 68.26l-.06-.25.06.25z\" fill=\"url(#AD)\"/><path d=\"M36.47 68.01l-.11-.47c.03.17.08.31.11.47z\" fill=\"url(#AE)\"/><path d=\"M36.19 66.22l-.07-.53c.01.18.05.35.07.53z\" fill=\"url(#AF)\"/><path d=\"M44.011 70.98l-.2-.12.2.12z\" fill=\"url(#AG)\"/><path d=\"M36.12 65.69c0-.04-.01-.07-.01-.11 0 .03.01.07.01.11z\" fill=\"url(#AH)\"/><path d=\"M59 30.13l.64-.17c-.02 0-.04.01-.06.01l-.58.16z\" fill=\"url(#AI)\"/><path d=\"M57.101 30.77c.09-.04.17-.07.26-.1-.01 0-.01 0-.02.01l-.24.09z\" fill=\"url(#AJ)\"/><path d=\"M62.79 34.63l-.3-.05c.01 0 .02 0 .03.01l.27.04z\" fill=\"url(#AK)\"/><path d=\"M61.67 34.45l-.34-.02c.04 0 .09.01.13.01.07.01.14.01.21.01z\" fill=\"url(#AL)\"/><path d=\"M60.47 34.43l-.38.02c.06-.01.13 0 .19-.01.07 0 .13 0 .19-.01z\" fill=\"url(#AM)\"/><path d=\"M59.221 34.57l-.49.09c.03-.01.06-.01.09-.02l.4-.07z\" fill=\"url(#AN)\"/><path d=\"M57.37 35.04c.17-.06.34-.1.51-.15l-.51.15z\" fill=\"url(#AO)\"/><path d=\"M46.21 38.99l.37-.41-.37.41z\" fill=\"url(#AP)\"/><path d=\"M47.92 37.16l.85-.83-.85.83z\" fill=\"url(#AQ)\"/><path d=\"M56.01 35.57c.15-.07.3-.12.45-.18l-.45.18z\" fill=\"url(#AR)\"/><path d=\"M51.63 33.92l.67-.49-.67.49z\" fill=\"url(#AS)\"/><path d=\"M44.69 40.84l.67-.84-.67.84z\" fill=\"url(#AT)\"/><path d=\"M46.021 39.21l.19-.21-.19.21z\" fill=\"url(#AU)\"/><path d=\"M43.53 42.42l.49-.69-.49.69z\" fill=\"url(#AV)\"/><path d=\"M44.51 41.07l.18-.23-.18.23z\" fill=\"url(#AW)\"/><path d=\"M42.54 43.89l.19-.3-.19.3z\" fill=\"url(#AX)\"/><path d=\"M43.481 42.49c.02-.02.03-.05.05-.07-.01.03-.03.05-.05.07z\" fill=\"url(#AY)\"/><path d=\"M41.78 45.1l.76-1.21-.76 1.21z\" fill=\"url(#AZ)\"/><path d=\"M41.21 46.08l.33-.6-.33.6z\" fill=\"url(#Aa)\"/><path d=\"M39.481 49.46l.53-1.1-.53 1.1z\" fill=\"url(#Ab)\"/><path d=\"M38.76 51.14l.48-1.15-.48 1.15z\" fill=\"url(#Ac)\"/><path d=\"M38.101 52.86l.2-.59c-.08.2-.14.4-.2.59z\" fill=\"url(#Ad)\"/><path d=\"M38.39 52.01l.36-.87-.36.87z\" fill=\"url(#Ae)\"/><path d=\"M37.42 54.9l.03-.1-.03.1z\" fill=\"url(#Af)\"/><path d=\"M37.68 54.06l.42-1.2-.42 1.2z\" fill=\"url(#Ag)\"/><path d=\"M37.08 56.14l.35-1.24-.35 1.24z\" fill=\"url(#Ah)\"/><path d=\"M36.351 59.75c0-.02.01-.05.01-.07 0 .02 0 .05-.01.07z\" fill=\"url(#Ai)\"/><path d=\"M36.62 58.2l.23-1.1-.23 1.1z\" fill=\"url(#Aj)\"/><path d=\"M31.35 60.71a27.52 27.52 0 0 1 .2-2.84l.02-.34c.02-.19.07-.38.1-.57l.25-1.48c.04-.18.05-.37.09-.55l.13-.55.23-.95.15-.59.23-.75.22-.74.12-.38.5-1.41.09-.26c.01-.02.01-.04.02-.06l.67-1.65.15-.32.24-.53.34-.75.42-.83.24-.48.13-.25.86-1.55c.02-.04.05-.08.08-.13l.23-.38.64-1.05.3-.45.41-.62.35-.52.54-.73.49-.66.2-.27.65-.79.66-.81.15-.19.4-.43 1.34-1.43.3-.32.55-.51.68-.63 1.02-.87.66-.54 1.16-.85.58-.42 1.78-1.1c.672-.373 1.363-.71 2.07-1.01.06-.02.12-.06.17-.08l.45-.16 1.29-.44-23.2-9.58c-.01 0-.02-.01-.03-.01-.02-.01-.05-.02-.07-.03-.17-.07-.34-.13-.52-.18l-.14-.03-.12-.03-.26-.06c-.03-.01-.06-.01-.08-.02l-.24-.06c-.06-.01-.12-.01-.18-.02l-.24-.02-.2-.02c-.05 0-.11-.01-.16-.02s-.09-.01-.14-.01c-.07 0-.14.01-.21 0l-.39.01h-.12l-.23.01h-.07l-.2.03c-.13.01-.26.04-.4.06l-.27.04-.26.04c-.02 0-.04 0-.06.01l-.14.04-.16.05-1.04.29c-.05.02-.09.02-.14.04l-.66.26c-.04.02-.08.03-.12.05l-.29.12-.09.03-1.19.6-.45.26-.23.16-1.94 1.34c-.01.01-.02.01-.03.02l-1.32 1.13-.08.08-.27.26-.9.89-.05.05c-.09.09-.17.2-.26.29l-.98 1.11-.15.17-.38.49-.54.7-.16.21-.43.62-.37.55c-.033.052-.07.102-.11.15l-.62 1-.15.24c-.01.01-.01.02-.02.04l-.72 1.29-.06.12-.21.42-.38.77-.13.29-.25.56-.23.52-.17.43-.25.65-.15.38-.16.49-.26.81-.11.34c-.04.13-.06.27-.1.4l-.28 1.16-.1.4-.05.29-.2 1.26-.03.24c.03.15.01.26 0 .38l-.11 1.8c-.01.51.01 1 .05 1.47l.05.45.12.91.11.5.18.74.16.49.24.65c.062.154.132.304.21.45l.3.57.25.4.35.49.29.35c.13.15.27.28.41.42l.32.29c.041.042.084.082.13.12l8.69 6.76.14.11c.08.07.19.15.28.22l.98.76.01.01 2.4 1.87.12.09.23.18 5.6 4.36.48.37.85.66c-.35-1.46-.52-3.06-.49-4.82z\" fill=\"url(#Ak)\"/><path d=\"M36.81 69.4c0-.02-.01-.04-.02-.06.01.02.02.04.02.06z\" fill=\"url(#Al)\"/><path d=\"M58.73 57.54l2.05-3.29-9.58 1.89 5.04-11.23-4.27.56 2.88-9.33-.24.12c-8.07 4.5-14.7 15.72-14.82 25.07-.06 4.61 1.49 7.9 4.03 9.51.07.04.13.08.2.12.286.17.584.32.89.45.04.02.09.03.14.05.29.11.58.2.88.28.07.02.13.04.2.05a8.66 8.66 0 0 0 1.04.15c.083.008.166.012.25.01a6.91 6.91 0 0 0 .91 0c.1 0 .21-.01.31-.02.38-.03.77-.08 1.16-.16.02 0 .04-.01.07-.01a12.07 12.07 0 0 0 1.34-.35c.14-.05.29-.12.44-.17.37-.13.73-.26 1.11-.43.02-.01.05-.02.07-.03a15.66 15.66 0 0 0 1.36-.68c.479-.275.95-.565 1.41-.87.15-.1.3-.21.45-.32a19.81 19.81 0 0 0 .92-.68c.17-.13.34-.28.51-.41.28-.23.55-.46.82-.7.17-.15.34-.31.51-.47l.66-.64c.32-.32.63-.65.94-.99l.57-.63.48-.57c.25-.3.49-.61.73-.92l1.12-4.95-4.58-.41z\" fill=\"url(#Am)\"/><path d=\"M37.68 54.07l.42-1.2-.42 1.2z\" fill=\"url(#An)\"/><path d=\"M37.42 54.9l.03-.1-.03.1z\" fill=\"url(#Ao)\"/><path d=\"M38.39 52.01l.36-.87-.36.87z\" fill=\"url(#Ap)\"/><path d=\"M38.76 51.14l.48-1.15-.48 1.15z\" fill=\"url(#Aq)\"/><path d=\"M39.47 49.46l.53-1.1-.53 1.1z\" fill=\"url(#Ar)\"/><path d=\"M37.08 56.15l.35-1.25-.35 1.25z\" fill=\"url(#As)\"/><path d=\"M41.21 46.08l.33-.6-.33.6z\" fill=\"url(#At)\"/><path d=\"M36.62 58.19l.23-1.1-.23 1.1z\" fill=\"url(#Au)\"/><path d=\"M36.53 68.25l-.06-.25-.11-.47.11.46.06.26z\" fill=\"url(#Av)\"/><path d=\"M37.05 70.04l-.23-.63c-.01-.02-.02-.04-.02-.06.01.02.01.04.02.06.06.21.16.41.23.63z\" fill=\"url(#Aw)\"/><path d=\"M36.19 66.22l-.07-.53c0-.04-.01-.07-.01-.11 0 .04.01.07.01.11.01.18.05.35.07.53z\" fill=\"url(#Ax)\"/><path d=\"M59 30.13l.64-.17c-.02 0-.04.01-.06.01l-.58.16z\" fill=\"url(#Ay)\"/><path d=\"M57.101 30.77c.09-.04.17-.07.26-.1-.01 0-.01 0-.02.01l-.24.09z\" fill=\"url(#Az)\"/><path d=\"M42.54 43.89l.19-.3-.19.3z\" fill=\"url(#BA)\"/><path d=\"M47.92 37.16l.57-.56-.57.56z\" fill=\"url(#BB)\"/><path d=\"M60.771 29.75l.65-.09c-.04 0-.08.01-.12.01l-.53.08z\" fill=\"url(#BC)\"/><path d=\"M43.53 42.42l.49-.69-.49.69z\" fill=\"url(#BD)\"/><path d=\"M44.51 41.07l.19-.23-.19.23z\" fill=\"url(#BE)\"/><path d=\"M44.69 40.84l.67-.84-.67.84z\" fill=\"url(#BF)\"/><path d=\"M46.021 39.21l.19-.21.36-.4-.36.4-.19.21z\" fill=\"url(#BG)\"/><path d=\"M40.13 74.68c-.2-.17-.38-.37-.57-.56l-.48-.49c-.18-.21-.34-.45-.5-.67l-.41-.57-.42-.79-.34-.65c-.13-.29-.23-.61-.35-.92l-.24-.64c-.01-.02-.01-.04-.02-.06l-.27-1.09-.06-.25c-.03-.16-.08-.3-.11-.46-.08-.42-.12-.88-.17-1.33l-.07-.53c0-.04-.01-.07-.01-.11l-.07-2.14c.01-1.21.14-2.44.32-3.68 0-.02.01-.05.01-.07l.25-1.48.23-1.09.23-.95.35-1.24.03-.1.22-.73.42-1.2.2-.59.09-.26.36-.87.48-1.15.24-.53.53-1.1 1.21-2.28.33-.6c.07-.13.15-.25.23-.37l.77-1.22.19-.3.75-1.1c.02-.02.03-.05.05-.07l.49-.69.48-.66.18-.23.67-.83.66-.8.19-.21.36-.4 1.34-1.43.57-.56c.1-.09.19-.19.28-.28.92-.87 1.88-1.67 2.86-2.41l.67-.49c.77-.55 1.56-1.06 2.36-1.51.83-.46 1.65-.83 2.45-1.16l.24-.09c.01 0 .01 0 .02-.01l1.64-.54.58-.15c.02 0 .04-.01.06-.01l1.13-.21.53-.07c.04 0 .08-.01.12-.01l-2.94-2.78-1.12-.01c-.07 0-.15.02-.22.02l-.54.05-.61.06c-.118.021-.235.047-.35.08l-.76.16-.49.1c-.11.03-.22.08-.33.11-.04.01-.09.03-.13.04l-1.29.44c-.15.06-.3.09-.45.16-.06.02-.12.06-.17.08l-2.07 1.01-1.78 1.1-.58.42-1.16.85-.66.54-1.02.87-.68.63-.55.51-.3.32-1.34 1.43-.4.43-.15.19-.66.81-.65.79-.2.27-.49.66-.54.73-.35.52-.41.62-.3.45-.64 1.05-.23.38c-.02.04-.05.08-.08.13l-.86 1.55-.13.25-.24.48-.42.83-.34.75-.24.53-.15.32-.67 1.65c-.01.02-.01.04-.02.06l-.09.26-.5 1.41-.12.38-.22.74-.23.75-.15.59-.23.95-.13.55c-.04.18-.06.37-.09.55l-.25 1.48-.1.57-.02.34-.2 2.84c-.02 1.76.15 3.36.48 4.81l.3 1.14c.35 1.15.82 2.17 1.39 3.07s1.24 1.66 1.99 2.29c.38.31.78.59 1.2.84l4.69 2.73c-.03-.02-.05-.04-.08-.05-.22-.13-.43-.29-.64-.45l-.57-.44z\" fill=\"url(#BH)\"/><path d=\"M62.19 62.94l-.73.92-.48.58-.57.63-.94.99-.66.64c-1.46 1.37-3.01 2.55-4.62 3.44-.47.27-.92.49-1.37.69a13.05 13.05 0 0 1-1.62.62l-1.34.35c-.02 0-.04.01-.07.01-.4.08-.78.13-1.16.16l-.31.02h-.91c-.08 0-.17-.01-.25-.01a8.7 8.7 0 0 1-1.04-.15 1.17 1.17 0 0 1-.2-.05 6.44 6.44 0 0 1-.88-.28c-.04-.02-.09-.03-.14-.05-.31-.13-.61-.28-.89-.45l-.2-.12c-2.54-1.62-4.09-4.9-4.03-9.51.11-9.35 6.75-20.58 14.82-25.07.48-.26.94-.5 1.41-.7.15-.07.3-.12.45-.18a13.19 13.19 0 0 1 .92-.35c.17-.06.34-.1.51-.15.28-.08.56-.16.84-.22.17-.04.33-.06.49-.09.292-.049.586-.089.88-.12a5.1 5.1 0 0 1 .38-.02c.283-.01.567-.01.85 0 .11.01.23.01.34.02.275.024.549.065.82.12.1.02.2.03.3.05l-2.84-2.57 1.47-2.39c-.21.02-.43.05-.65.09-.38.052-.757.122-1.13.21-.21.05-.42.11-.64.17a19.6 19.6 0 0 0-1.64.54c-.09.03-.17.06-.26.1-.8.32-1.62.69-2.45 1.16-.8.45-1.58.96-2.36 1.51l-.67.49c-.98.73-1.94 1.53-2.86 2.41-.1.09-.19.19-.28.28-.19.18-.38.37-.57.56-.456.461-.9.935-1.33 1.42l-.37.41c-.06.07-.13.14-.19.22l-.66.8-.67.84c-.06.08-.13.15-.19.23l-.48.66c-.17.23-.33.46-.49.69-.02.02-.03.05-.05.07l-.75 1.1c-.06.1-.12.2-.19.3l-.77 1.22c-.08.13-.15.25-.23.37-.12.2-.22.4-.33.6A41.45 41.45 0 0 0 40 48.43l-.53 1.1-.24.53c-.17.38-.32.77-.48 1.15l-.36.87-.09.26c-.07.19-.13.39-.2.59l-.42 1.2c-.08.24-.15.49-.22.73-.01.03-.02.07-.03.1l-.35 1.25-.23.95-.23 1.1a26.91 26.91 0 0 0-.25 1.48c0 .02-.01.05-.01.07-.18 1.24-.3 2.48-.32 3.68-.008.714.016 1.428.07 2.14 0 .04.01.07.01.11.02.18.05.35.07.53.05.45.1.9.17 1.33.03.16.08.31.11.47l.06.25c.08.37.16.74.27 1.09.01.02.02.04.02.06.07.22.16.42.23.63.11.31.22.63.35.92.1.23.23.43.34.65.14.27.27.54.42.79.13.2.27.38.41.57.16.23.32.47.5.67.15.18.32.32.48.49.19.19.37.39.57.56.17.15.36.27.55.4.21.15.42.31.64.45 3.27 1.95 7.79 1.76 12.82-1.04 4.02-2.24 7.74-5.81 10.79-10.03l-.36-1.73-2.37.14z\" fill=\"url(#BI)\"/><path d=\"M61.191 47.7c1.98.68 3.92 1.51 5.81 2.41 5.28 2.53 10.45 5.85 13.49 10.85 1.22 2.01 2.06 4.28 3.41 6.22 1.16 1.66 2.52 2.84 1.9 5.1-1.37 5-8.08 7.94-12.65 8.83-4.11.8-8.32.61-12.46.24-3.44-.31-7.17-.96-10.34-2.38-1.62-.72-3.12-1.81-4.05-3.32-.66-1.07-1-2.3-1.55-3.43-.96-1.97-2.95-2.22-3.86-4.08-.92-2.09-1.18-4.31-1.15-6.58.06-4.73 1.55-9.35 3.83-13.46l.89-1.63c.27-.48.62-.87.89-1.33.62-1.04 1.08-1.96 2.1-2.69a.56.56 0 0 1 .26-.12c.1-.01.21.03.3.08.9.4 1.79.73 2.71 1.05.89.31 1.61 1.11 2.48 1.51 2.58 1.16 5.33 1.82 7.99 2.73z\" fill=\"url(#BJ)\"/><path d=\"M58.14 57.6a.72.72 0 0 1-.34-.09.69.69 0 0 1-.26-.94c6.75-12.02 21.53-12.96 21.68-12.97.42-.04.7.27.72.65s-.27.7-.65.72c-.14.01-14.18.92-20.55 12.27a.68.68 0 0 1-.6.36z\" fill=\"#e3d4ff\"/><path d=\"M82.37 37.15l.27 1.43c.18.97.97 1.71 1.94 1.84l1.45.19c2.19.29 2.73 3.2.79 4.26l-1.28.7c-.87.47-1.33 1.45-1.15 2.42l.27 1.43c.4 2.17-2.2 3.59-3.81 2.07l-1.06-1c-.72-.68-1.79-.82-2.65-.35l-1.28.7c-1.94 1.05-4.09-.99-3.15-2.98l.63-1.32c.42-.89.23-1.95-.49-2.63l-1.06-1c-1.6-1.52-.33-4.2 1.86-3.91l1.45.19a2.27 2.27 0 0 0 2.35-1.28l.63-1.32c.95-1.99 3.89-1.61 4.29.56z\" fill=\"url(#BK)\"/><path d=\"M79.37 46.53a3.07 3.07 0 1 0 0-6.14 3.07 3.07 0 1 0 0 6.14z\" fill=\"#fff\"/></g></g><defs><linearGradient id=\"A\" x1=\"76.155\" y1=\"64.909\" x2=\"100.754\" y2=\"64.909\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"76.882\" y1=\"66.109\" x2=\"96.538\" y2=\"66.109\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"80.512\" y1=\"65.908\" x2=\"103.639\" y2=\"65.908\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"24.292\" y1=\"75.825\" x2=\"27.669\" y2=\"75.825\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"9.136\" y1=\"72.716\" x2=\"45.506\" y2=\"72.716\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"1.763\" y1=\"76.383\" x2=\"39.949\" y2=\"76.383\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"61.731\" y1=\"62.744\" x2=\"64.564\" y2=\"62.744\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"61.456\" y1=\"61.35\" x2=\"64.441\" y2=\"61.35\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"57.631\" y1=\"56.841\" x2=\"61.861\" y2=\"56.841\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"49.857\" y1=\"51.645\" x2=\"65.083\" y2=\"51.645\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"46.44\" y1=\"41.301\" x2=\"67.976\" y2=\"41.301\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"40.151\" y1=\"32.903\" x2=\"63.371\" y2=\"32.903\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"46.598\" y1=\"71.967\" x2=\"48.681\" y2=\"71.967\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"44.801\" y1=\"71.782\" x2=\"46.161\" y2=\"71.782\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"45.793\" y1=\"71.968\" x2=\"47.454\" y2=\"71.968\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"35.89\" y1=\"72.676\" x2=\"38.644\" y2=\"72.676\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"35.49\" y1=\"69.719\" x2=\"37.096\" y2=\"69.719\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"R\" x1=\"44.155\" y1=\"71.455\" x2=\"45.061\" y2=\"71.455\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"S\" x1=\"37.107\" y1=\"74.88\" x2=\"40.768\" y2=\"74.88\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"T\" x1=\"36.416\" y1=\"73.878\" x2=\"39.638\" y2=\"73.878\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"U\" x1=\"57.191\" y1=\"29.708\" x2=\"61.53\" y2=\"29.708\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"V\" x1=\"35.528\" y1=\"71.281\" x2=\"37.797\" y2=\"71.281\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"W\" x1=\"58.295\" y1=\"64.147\" x2=\"61.537\" y2=\"64.147\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"X\" x1=\"54.257\" y1=\"65.557\" x2=\"60.563\" y2=\"65.557\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Y\" x1=\"42.253\" y1=\"71.135\" x2=\"53.082\" y2=\"71.135\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Z\" x1=\"28.534\" y1=\"68.418\" x2=\"59.586\" y2=\"68.418\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"a\" x1=\"15.803\" y1=\"24.149\" x2=\"16.776\" y2=\"24.149\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"b\" x1=\"14.731\" y1=\"25.718\" x2=\"15.27\" y2=\"25.718\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"c\" x1=\"17.094\" y1=\"22.807\" x2=\"17.984\" y2=\"22.807\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"d\" x1=\"19.701\" y1=\"20.191\" x2=\"21.645\" y2=\"20.191\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"e\" x1=\"12.883\" y1=\"28.727\" x2=\"13.034\" y2=\"28.727\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"f\" x1=\"24.798\" y1=\"17.853\" x2=\"25.837\" y2=\"17.853\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"g\" x1=\"8.934\" y1=\"43.534\" x2=\"8.986\" y2=\"43.534\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"h\" x1=\"10.289\" y1=\"48.262\" x2=\"10.538\" y2=\"48.262\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"i\" x1=\"9.786\" y1=\"47.272\" x2=\"9.992\" y2=\"47.272\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"j\" x1=\"10.893\" y1=\"49.126\" x2=\"11.181\" y2=\"49.126\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"k\" x1=\"11.593\" y1=\"49.862\" x2=\"11.914\" y2=\"49.862\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"l\" x1=\"11.873\" y1=\"30.503\" x2=\"12.082\" y2=\"30.503\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"m\" x1=\"8.887\" y1=\"40.938\" x2=\"9\" y2=\"40.938\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"n\" x1=\"9.389\" y1=\"46.158\" x2=\"9.548\" y2=\"46.158\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"o\" x1=\"11.113\" y1=\"32.053\" x2=\"11.359\" y2=\"32.053\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"p\" x1=\"9.104\" y1=\"44.919\" x2=\"9.212\" y2=\"44.919\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"q\" x1=\"9.42\" y1=\"36.929\" x2=\"9.702\" y2=\"36.929\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"r\" x1=\"13.765\" y1=\"27.174\" x2=\"14.137\" y2=\"27.174\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"s\" x1=\"10.468\" y1=\"33.612\" x2=\"10.716\" y2=\"33.612\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"t\" x1=\"9.909\" y1=\"35.207\" x2=\"10.167\" y2=\"35.207\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"u\" x1=\"18.268\" y1=\"21.494\" x2=\"19.658\" y2=\"21.494\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"v\" x1=\"26.195\" y1=\"17.574\" x2=\"26.729\" y2=\"17.574\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"w\" x1=\"23.593\" y1=\"18.386\" x2=\"23.998\" y2=\"18.386\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"x\" x1=\"27.399\" y1=\"17.441\" x2=\"27.751\" y2=\"17.441\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"y\" x1=\"9.046\" y1=\"38.945\" x2=\"9.276\" y2=\"38.945\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"z\" x1=\"28.496\" y1=\"17.456\" x2=\"28.852\" y2=\"17.456\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AA\" x1=\"22.145\" y1=\"58.964\" x2=\"24.662\" y2=\"58.964\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AB\" x1=\"12.042\" y1=\"53.56\" x2=\"20.876\" y2=\"53.56\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AC\" x1=\"20.876\" y1=\"57.487\" x2=\"22.135\" y2=\"57.487\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AD\" x1=\"36.473\" y1=\"68.132\" x2=\"36.533\" y2=\"68.132\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AE\" x1=\"36.363\" y1=\"67.776\" x2=\"36.474\" y2=\"67.776\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AF\" x1=\"36.119\" y1=\"65.951\" x2=\"36.188\" y2=\"65.951\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AG\" x1=\"43.814\" y1=\"70.921\" x2=\"44.012\" y2=\"70.921\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AH\" x1=\"36.105\" y1=\"65.629\" x2=\"36.12\" y2=\"65.629\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AI\" x1=\"59.003\" y1=\"30.044\" x2=\"59.64\" y2=\"30.044\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AJ\" x1=\"57.105\" y1=\"30.721\" x2=\"57.367\" y2=\"30.721\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AK\" x1=\"62.487\" y1=\"34.601\" x2=\"62.788\" y2=\"34.601\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AL\" x1=\"61.329\" y1=\"34.443\" x2=\"61.666\" y2=\"34.443\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AM\" x1=\"60.092\" y1=\"34.444\" x2=\"60.474\" y2=\"34.444\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AN\" x1=\"58.726\" y1=\"34.619\" x2=\"59.217\" y2=\"34.619\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AO\" x1=\"57.373\" y1=\"34.96\" x2=\"57.888\" y2=\"34.96\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AP\" x1=\"46.213\" y1=\"38.788\" x2=\"46.581\" y2=\"38.788\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AQ\" x1=\"47.916\" y1=\"36.745\" x2=\"48.77\" y2=\"36.745\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AR\" x1=\"56.005\" y1=\"35.478\" x2=\"56.454\" y2=\"35.478\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AS\" x1=\"51.629\" y1=\"33.677\" x2=\"52.295\" y2=\"33.677\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AT\" x1=\"44.695\" y1=\"40.424\" x2=\"45.363\" y2=\"40.424\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AU\" x1=\"46.02\" y1=\"39.099\" x2=\"46.214\" y2=\"39.099\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AV\" x1=\"43.533\" y1=\"42.076\" x2=\"44.026\" y2=\"42.076\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AW\" x1=\"44.509\" y1=\"40.958\" x2=\"44.695\" y2=\"40.958\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AX\" x1=\"42.54\" y1=\"43.741\" x2=\"42.728\" y2=\"43.741\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AY\" x1=\"43.484\" y1=\"42.458\" x2=\"43.534\" y2=\"42.458\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"AZ\" x1=\"41.774\" y1=\"44.499\" x2=\"42.54\" y2=\"44.499\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Aa\" x1=\"41.215\" y1=\"45.781\" x2=\"41.546\" y2=\"45.781\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Ab\" x1=\"39.476\" y1=\"48.91\" x2=\"40.009\" y2=\"48.91\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Ac\" x1=\"38.755\" y1=\"50.564\" x2=\"39.233\" y2=\"50.564\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Ad\" x1=\"38.096\" y1=\"52.568\" x2=\"38.3\" y2=\"52.568\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Ae\" x1=\"38.393\" y1=\"51.576\" x2=\"38.755\" y2=\"51.576\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Af\" x1=\"37.425\" y1=\"54.849\" x2=\"37.454\" y2=\"54.849\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Ag\" x1=\"37.677\" y1=\"53.463\" x2=\"38.095\" y2=\"53.463\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Ah\" x1=\"37.077\" y1=\"55.523\" x2=\"37.425\" y2=\"55.523\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Ai\" x1=\"36.353\" y1=\"59.713\" x2=\"36.362\" y2=\"59.713\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Aj\" x1=\"36.615\" y1=\"57.648\" x2=\"36.843\" y2=\"57.648\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Ak\" x1=\"3.935\" y1=\"41.47\" x2=\"59.19\" y2=\"41.47\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Al\" x1=\"36.798\" y1=\"69.374\" x2=\"36.822\" y2=\"69.374\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Am\" x1=\"4.911\" y1=\"54.067\" x2=\"60.469\" y2=\"54.067\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"An\" x1=\"37.057\" y1=\"53.463\" x2=\"38.045\" y2=\"53.463\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Ao\" x1=\"37.381\" y1=\"54.849\" x2=\"37.45\" y2=\"54.849\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Ap\" x1=\"37.857\" y1=\"51.576\" x2=\"38.712\" y2=\"51.576\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Aq\" x1=\"38.047\" y1=\"50.564\" x2=\"39.176\" y2=\"50.564\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Ar\" x1=\"38.685\" y1=\"48.91\" x2=\"39.944\" y2=\"48.91\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"As\" x1=\"36.563\" y1=\"55.523\" x2=\"37.383\" y2=\"55.523\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"At\" x1=\"40.724\" y1=\"45.781\" x2=\"41.506\" y2=\"45.781\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Au\" x1=\"36.276\" y1=\"57.647\" x2=\"36.816\" y2=\"57.647\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Av\" x1=\"36.11\" y1=\"67.899\" x2=\"36.512\" y2=\"67.899\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Aw\" x1=\"36.418\" y1=\"69.689\" x2=\"37.024\" y2=\"69.689\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Ax\" x1=\"35.982\" y1=\"65.895\" x2=\"36.178\" y2=\"65.895\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Ay\" x1=\"58.057\" y1=\"30.044\" x2=\"59.563\" y2=\"30.044\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Az\" x1=\"56.715\" y1=\"30.721\" x2=\"57.335\" y2=\"30.721\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"BA\" x1=\"42.26\" y1=\"43.741\" x2=\"42.706\" y2=\"43.741\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"BB\" x1=\"47.071\" y1=\"36.883\" x2=\"48.416\" y2=\"36.883\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"BC\" x1=\"59.813\" y1=\"29.708\" x2=\"61.343\" y2=\"29.708\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"BD\" x1=\"42.804\" y1=\"42.076\" x2=\"43.966\" y2=\"42.076\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"BE\" x1=\"44.235\" y1=\"40.957\" x2=\"44.672\" y2=\"40.957\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"BF\" x1=\"43.705\" y1=\"40.424\" x2=\"45.282\" y2=\"40.424\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"BG\" x1=\"45.201\" y1=\"38.9\" x2=\"46.506\" y2=\"38.9\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"BH\" x1=\"23.363\" y1=\"51.223\" x2=\"75.675\" y2=\"51.223\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"BI\" x1=\"12.813\" y1=\"53.239\" x2=\"76.597\" y2=\"53.239\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"BJ\" x1=\"11.932\" y1=\"61.997\" x2=\"96.948\" y2=\"61.997\" xlink:href=\"#BN\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"BK\" x1=\"64.142\" y1=\"43.706\" x2=\"93.952\" y2=\"43.706\" xlink:href=\"#BN\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"BL\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"BM\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"BN\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeDamagePets = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#R)\"><g clip-path=\"url(#S)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M34.46 57.53a4.67 4.67 0 0 1-.55.27c-.35.15-.75.27-1.18.25-.6-.02-.95-.26-1.32-.5l-.23-.14-1.47-.92c-.27-.21-.53-.43-.72-.67-.24-.28-.14-.56.13-.82.15-.16.37-.29.58-.42.01-.01.02-.01.03-.02.32-.19.73-.26 1.18-.27.75.01 1.48.08 2.13.31.34.12.62.29.9.44.88.51 1.73.98 1.3 1.76-.12.27-.41.52-.78.73z\" fill=\"url(#A)\"/><path d=\"M23.43 59.48c-.01.01-.02.01-.04.02-.58.31-1.46.43-2.24.3l-.05-.01c-1.7-.3-2.48-1.64-2.06-2.57.09-.2.25-.36.47-.49.21-.12.48-.21.81-.26.34-.06.67-.12 1.03-.03.76.21 1.41.49 1.75.97.48.65 1.38 1.47.33 2.07z\" fill=\"url(#B)\"/><path d=\"M30.45 59.79c-.61.35-1.56.5-2.43.39-1.14-.15-1.62-.65-2.19-1.17-.17-.16-.33-.33-.43-.51-.05-.1-.04-.21.01-.31.17-.32.2-.65.24-.98.03-.19.16-.36.36-.47.25-.14.61-.22 1.03-.19.47.03.89.15 1.3.27.68.21 1.16.55 1.65.88l.37.23c.35.2.71.4.78.67.1.39-.12.82-.58 1.12-.02.02-.06.05-.11.07z\" fill=\"url(#C)\"/><use xlink:href=\"#T\" fill=\"url(#D)\"/><path d=\"M26.12 54.88a2.92 2.92 0 0 1-.64.28c-.83.28-1.8.34-2.75.37-2.53.07-5.6.01-7.79-.82-.83-.31-1.51-.8-1.6-1.37-.07-.51.34-.99.97-1.35a4.62 4.62 0 0 1 .9-.39c.89-.28 1.87-.37 2.85-.47.49-.04.97-.23 1.35-.45a3.33 3.33 0 0 0 .44-.3c.46-.38.47-.99.73-1.43a2.83 2.83 0 0 1 1.04-1.02c.12-.07.25-.13.38-.19.62-.25 1.39-.36 2.13-.29a4.41 4.41 0 0 1 2.23.85 2.75 2.75 0 0 1 .91 1.2c.24.67.18 1.37.1 2.05-.11 1.09.16 2.51-1.25 3.33z\" fill=\"url(#E)\"/><path d=\"M42.23 78.82c-.177.102-.361.192-.55.27-.35.15-.75.27-1.18.25-.6-.02-.95-.26-1.32-.5l-.23-.14-1.47-.92c-.27-.21-.53-.43-.72-.67-.24-.28-.14-.56.13-.82.15-.16.37-.29.58-.42.01-.01.02-.01.03-.02.32-.19.73-.26 1.18-.27.75.01 1.48.08 2.13.31.34.12.62.29.9.44.88.51 1.73.98 1.3 1.76-.13.27-.42.52-.78.73z\" fill=\"url(#F)\"/><path d=\"M31.2 80.77c-.01.01-.02.01-.04.02-.58.31-1.46.43-2.24.3l-.05-.01c-1.7-.3-2.48-1.64-2.06-2.57.09-.2.25-.36.47-.49.21-.12.48-.21.81-.26.34-.06.67-.12 1.03-.03.76.21 1.41.49 1.75.97.47.65 1.37 1.47.33 2.07z\" fill=\"url(#G)\"/><path d=\"M38.22 81.08c-.61.35-1.56.5-2.43.39-1.14-.15-1.62-.65-2.19-1.17-.17-.16-.33-.33-.43-.51-.05-.1-.04-.21.01-.31.17-.32.2-.65.24-.98.03-.19.16-.36.36-.47.25-.14.61-.22 1.03-.19.47.03.89.15 1.3.27.68.21 1.16.55 1.65.88l.37.23c.35.2.71.4.78.67.1.39-.12.82-.58 1.12-.02.02-.06.04-.11.07z\" fill=\"url(#H)\"/><path d=\"M41.99 74.59c-.99.57-2.76.23-3.84-.09-.38-.12-.74-.26-1.03-.44-.44-.28-.88-.58-1.1-.94-.16-.25-.07-.49.25-.7.02-.01.05-.03.07-.04.53-.31 1.19-.47 1.93-.53l1.15-.07c1.5-.05 2.78.63 3.14 1.44.2.46.05 1-.52 1.35-.02 0-.03.01-.05.02z\" fill=\"url(#I)\"/><path d=\"M33.89 76.16a2.93 2.93 0 0 1-.64.28c-.83.28-1.8.34-2.75.37-2.53.07-5.6.01-7.79-.82-.83-.31-1.51-.8-1.6-1.37-.07-.51.34-.99.97-1.35.285-.162.587-.292.9-.39.89-.28 1.87-.37 2.85-.47.49-.04.97-.23 1.35-.45.154-.088.302-.188.44-.3.46-.38.47-.99.73-1.43a2.83 2.83 0 0 1 1.04-1.02c.12-.07.25-.13.38-.19.62-.25 1.39-.36 2.13-.29a4.41 4.41 0 0 1 2.23.85 2.75 2.75 0 0 1 .91 1.2c.24.67.18 1.37.1 2.05-.11 1.09.16 2.52-1.25 3.33z\" fill=\"url(#J)\"/><path d=\"M76.33 73.64l-.04.37c-.02.1-.05.2-.08.3l-.1.35c-.03.1-.08.19-.12.29l-.17.36-.16.26c-.083.144-.176.281-.28.41l-.31.39c-.03.03-.05.06-.08.09l-.49.48-.36.3-.33.26c-.13.1-.28.19-.42.28l-.45.29-1.1.56-.33.14-.92.35-.34.12-.6.17-.46.12-.65.14-.44.09-1.33.19-.42.03-.79.05-.51.01h-.64c-.18 0-.36-.01-.54-.01l-.59-.03-.54-.05-.58-.07-.52-.07-.62-.11-.49-.1-.73-.18-.4-.11-1.26-.42-.59-.25-.3-.13-.86-.45c-1.44-.83-2.43-1.83-2.97-2.88-.32-.63-.48-1.29-.48-1.94v1.64c0 1.75 1.15 3.5 3.46 4.83l.86.45c.1.05.2.09.3.13l.53.23c.02.01.04.01.06.02l1.26.42.1.03.3.07.73.18c.07.01.13.03.19.05l.29.05.62.11.25.04.28.03.58.07.28.03a2.35 2.35 0 0 0 .26.01l.59.03c.1 0 .2.01.3.02h.24.64.32c.06 0 .13-.01.19-.01l.79-.05.32-.02c.03 0 .06-.01.1-.01l1.33-.19c.02 0 .04-.01.07-.01.13-.02.25-.06.38-.08l.65-.14.46-.12.6-.17c.04-.01.09-.02.13-.04.07-.02.14-.05.21-.08l.92-.35.33-.14 1.1-.56.14-.08c.11-.06.2-.14.3-.2l.42-.28c.12-.08.22-.17.33-.26l.36-.3c.02-.02.05-.04.07-.06l.42-.42c.03-.03.05-.06.08-.09l.23-.26c.03-.04.05-.08.08-.12.099-.13.189-.267.27-.41l.12-.17c.02-.03.03-.06.04-.09.07-.12.12-.24.17-.36l.1-.21c.01-.02.01-.05.02-.07l.1-.35.07-.24c0-.02 0-.04.01-.06.02-.12.03-.25.04-.37.01-.08.03-.16.03-.24v-.1-1.64c0 .08-.02.19-.03.31z\" fill=\"url(#K)\"/><path d=\"M72.9 68.46c4.59 2.65 4.61 6.94.05 9.59s-11.97 2.65-16.56 0-4.61-6.94-.05-9.59c4.56-2.64 11.98-2.64 16.56 0z\" fill=\"url(#L)\"/><path d=\"M66.36 46.03a.51.51 0 0 1-.03.17c0 .01 0 .01-.01.02-.02.05-.05.1-.08.15-.01.01-.01.02-.02.03l-.13.15c-.03.03-.08.06-.12.09-.03.02-.06.05-.1.07-.1.06-.21.1-.33.14-.04.01-.08.03-.13.04-.06.02-.11.03-.17.04-.07.01-.13.03-.2.03-.02 0-.03.01-.05.01l-.28.02h-.04c-.09 0-.19-.01-.28-.02h-.04c-.09-.01-.18-.03-.27-.05-.02 0-.03-.01-.05-.01-.08-.02-.16-.04-.23-.07-.01 0-.03-.01-.04-.01-.09-.03-.18-.07-.25-.12-.08-.05-.15-.1-.21-.15-.18-.16-.28-.35-.28-.53l-.08 27.36c0 .25.16.5.49.69l.24.12c.02.01.04.01.05.01.05.02.1.04.15.05.03.01.06.01.08.02.02 0 .03.01.05.01.01 0 .03.01.04.01l.17.03c.02 0 .04 0 .06.01h.04c.02 0 .04.01.06.01.05 0 .11.01.16.01h.05.04.07c.06 0 .12-.01.19-.01.04 0 .05 0 .07-.01.05-.01.1-.01.14-.02.02 0 .04-.01.06-.02.06-.01.11-.03.17-.04.03-.01.06-.01.09-.02.01 0 .02-.01.04-.02.113-.039.224-.086.33-.14.01 0 .01-.01.02-.01.03-.02.05-.04.08-.06l.12-.09.11-.12c.01-.01.01-.02.02-.03s.01-.02.02-.03.02-.03.03-.04c.02-.03.03-.06.04-.09 0-.03 0-.03.01-.04.01-.02.01-.04.02-.06.01-.03.01-.06.01-.1v-.01l.1-27.37z\" fill=\"url(#M)\"/><path d=\"M65.87 45.34c.66.38.66.99.01 1.37s-1.71.38-2.37 0c-.65-.38-.65-.99 0-1.37.64-.38 1.7-.38 2.36 0z\" fill=\"url(#N)\"/><path d=\"M83.92 51.7v-.04l.17-1.83.03-.29 1.57-17.41.04-.44.13-1.42c0-.04.01-.08.01-.12l.11-1.22c.16-1.77-.45-3.81-1.91-5.92l-.75-.98-.25-.29-.62-.68-.28-.29-.81-.78c-.046-.037-.089-.077-.13-.12l-1.02-.85-.3-.23-.81-.59-.36-.25-.92-.59-.25-.15-.08-.05-.57-.32-.71-.4-.66-.33-.74-.36c-.03-.01-.06-.03-.09-.04-.21-.1-.43-.18-.65-.27l-.67-.28-.76-.28-.68-.24-.08-.03c-.09-.03-.19-.05-.29-.08l-1.35-.39-.57-.13-1.19-.24-.35-.07c-.1-.02-.19-.02-.29-.04l-.51-.07-.87-.09-.5-.04-.91-.03c-.14 0-.28-.01-.42-.01l-1.29.06-.96.12-.29.05-.44.08c-.06.01-.11.03-.17.04l-.3.07-.55.15-.27.09-.57.21-.18.07-.65.31c-.01.01-.02.01-.03.02l-.77.47-.19.14-.49.4c-.03.03-.07.05-.1.08l-.29.3-1.56 1.68-.46.49-.47.51-1.68 1.81-.27.29-1.78 1.91-.43.46-.05.06-.26.28-1.39 1.49-.53.57-.39.42-.44.47c-.02.02-.04.05-.06.07l-1.62 1.75-2.2 2.37-1.51 1.62-.76.82-1.01 1.09c-.27.29-.73.6-.89.96.22-.24.47-.47.72-.69.05-.05.1-.09.16-.14.25-.21.52-.42.81-.61l.17-.11.83-.5.13-.07 1.06-.51.28-.11.88-.32.42-.13.85-.24.45-.11.94-.18.45-.08 1.47-.18 1.98-.09.65.01 1.39.05.76.06 1.33.14.78.1 1.9.33c.02 0 .04.01.06.01l1.96.47.45.12 1.93.58 1.05.37 1.16.42 1.03.43 1.13.49 1.14.55 1 .5 1.1.62.98.56.38.24 1.4.91.55.38 1.23.91.46.35 1.56 1.3c.07.06.13.13.2.19l1.24 1.19.42.44.95 1.05.38.44 1.15 1.51c2.25 3.24 3.18 6.36 2.94 9.08l.33-3.23z\" fill=\"url(#O)\"/><path d=\"M70.18 27.57l-.32-1.11-2.03 1.11.42-2.4-3.55 2.63.28-4.29-1.01.64-.19-2.17c-3.31.71-5.79 3.65-5.79 7.17a7.34 7.34 0 0 0 2.15 5.19 7.34 7.34 0 0 0 5.19 2.15 7.34 7.34 0 0 0 5.19-2.15 7.34 7.34 0 0 0 2.15-5.19c0-1-.2-1.95-.57-2.82l-1.92 1.24z\" fill=\"#fff\"/><path d=\"M83.34 58.29l.11-.24.26-.57.06-.14c.03-.07.04-.15.07-.22.07-.19.13-.39.18-.59l.06-.2.03-.18.12-.66.04-.25.03-.26.1-1.06.1-1.12.11-1.25.03-.34.11-1.16.11-1.18.14-1.59.07-.75.29-3.18.03-.38.36-4.02.03-.38.1-1.1v-.03l.15-1.69.02-.26c.01-.06.01-.14.02-.21l.06-.71.13-1.47.07-.79.07-.72.02-.25.05-.57.16-1.78c-.01.11-.03.22-.05.33-.02.15-.05.29-.08.43l-.06.25-.12.39-.09.24c-.05.13-.11.25-.17.38l-.1.21a6.13 6.13 0 0 1-.26.43c-.03.04-.05.09-.08.13l-.41.53-.11.12-.38.38-.18.16-.41.33-.2.15-.67.41-.06.03c-.02.01-.05.02-.07.03l-.52.25c-.07.03-.13.06-.2.08-.13.06-.27.11-.41.16l-.34.12-.38.12c-.12.04-.24.07-.37.1l-.37.09-.66.13-.3.05-1.01.12c-.53.05-1.07.06-1.61.06a16.5 16.5 0 0 1-1.21-.04l-1.7-.18-.36-.06-1.36-.25-.67-.16-.92-.24-.83-.25-.55-.18-1.14-.41c-.07-.03-.15-.05-.22-.08l-1.33-.57-.35-.16-.99-.49-.36-.19-1.24-.7c-.02-.01-.03-.02-.05-.03l-1.14-.73-.34-.23-.86-.63-.3-.23-1.06-.89c-.05-.04-.09-.09-.13-.13l-.86-.82-.38-.4-.55-.61-.49-.61-.53-.7-.43-.66-.13-.22-.25-.44-.14-.27-.19-.39-.12-.27-.16-.38-.1-.27a2.79 2.79 0 0 1-.12-.38l-.08-.26-.1-.39-.05-.23c-.03-.14-.05-.28-.07-.43l-.03-.18-.05-.59v-.1l.01-.48c0-.07.01-.13.02-.2l.04-.36.04-.22.07-.33.06-.22.1-.31c.02-.07.05-.14.08-.21l.13-.3c.03-.07.06-.14.1-.2l.16-.29.11-.18.21-.3.11-.15c.11-.15.23-.29.36-.43l-1.94 2.09c-.02.03-.05.05-.07.07l-3.72 4.01-.48.52-.38.41-.42.45c-.03.03-.06.07-.09.1l-.94 1.01-2.7 2.91-.8.86-1.78 1.91-1.78 1.91-.36.39-.51.55-.26.28-.23.24-1.3 1.4-.54.65c-.06.07-.11.15-.16.22l-.32.46c-.06.09-.11.18-.16.28l-.24.44-.14.31-.19.45-.12.32-.14.47-.09.33-.1.49-.06.33c-.03.18-.04.37-.06.55l-.03.3-.01.73v.14l.07.9.04.27.11.65c.02.12.05.24.08.36l.14.58.12.39.19.57.15.4.24.57.18.41.29.59.21.4c.03.05.05.1.08.15l.3.51.19.32.65 1 .34.47.89 1.14.18.22.33.4.63.67.57.61.17.18 1.13 1.06c.07.06.13.13.2.19l.03.03 1.37 1.16.21.16.46.35.72.55.57.4.51.35.34.24 1.38.88c.02.01.05.03.07.04l1.52.88.35.18.54.29.67.35.83.39.52.25.26.12 1.68.71c.02.01.05.02.07.03l.33.12 1.39.52.33.11.84.27.83.27.73.2.29.08 1.5.37.49.1.43.09 2.02.35.26.03 1.88.2.33.03c.07 0 .13.01.2.02l1.5.05h.29.36l1.98-.09 1.53-.19.46-.08 1-.2.25-.05.3-.08.56-.15.58-.18.52-.18.25-.09.37-.16.3-.13.78-.38c.03-.02.07-.03.11-.05.01 0 .01-.01.02-.01l.77-.46c.07-.04.13-.09.2-.13l.24-.16.41-.3c.02-.02.05-.04.07-.05l.5-.42.09-.09.57-.57.15-.15.03-.03.62-.8c.01-.01.01-.02.02-.02.04-.06.07-.12.1-.17l.39-.65c.05.01.07-.02.09-.04z\" fill=\"url(#P)\"/><path d=\"M86.19 30.79l.06-.14.17-.48c.01-.02.01-.04.02-.06l.11-.44.03-.17.05-.34c0-.02.01-.05.01-.07v-.07c.03-.28.04-.56.03-.85 0-.04 0-.07-.01-.11-.01-.29-.05-.59-.1-.9v-.04c0-.03-.01-.05-.02-.08l-.2-.83c-.08-.3-.19-.59-.3-.88l-.03-.09-.03-.06-.36-.78c-.03-.05-.06-.11-.08-.16l-.43-.76c-.01-.02-.02-.04-.03-.05 0-.01-.01-.01-.01-.02l-.39-.6-.86-1.13-.88-.98-.28-.29-.37-.37-.34-.3-.33-.3-.85-.71-.23-.19c-.02-.02-.04-.03-.06-.05l-1.1-.8-.3-.2-.71-.47-.21-.12-.53-.32-.78-.44-.57-.3-.41-.21-.33-.15-.86-.39-.68-.29-.89-.35-.45-.18-.28-.09-.46-.15-.97-.29-.46-.13-1.17-.28-.23-.05-1.39-.24-.39-.05-1-.11-.47-.03-.95-.03c-.14 0-.28-.01-.42 0l-1.32.06-.99.12-.2.03-.9.18c-.05.01-.1.02-.14.04l-.76.22c-.04.01-.09.03-.13.04l-.76.29c-.02.01-.05.02-.07.03-.04.02-.07.04-.11.05l-.41.2-.18.09-.47.28c-.02.01-.04.03-.06.04l-.49.35-.13.11-.32.27c-.02.02-.05.04-.07.06-.03.03-.06.06-.08.09l-.18.18c-.05.06-.11.11-.16.17-.06.06-.11.13-.16.19l-.14.18-.14.2-.12.19-.13.21c-.02.04-.05.08-.07.12-.01.02-.01.03-.02.05l-.3.68c-.01.04-.03.08-.04.12-.08.24-.15.48-.2.72 0 .01-.01.03-.01.04-.01.03-.01.05-.01.08l-.09.7v.04.75.08c0 .02.01.04.01.06l.09.72.03.14c.04.23.1.46.16.69.01.02.01.05.02.07 0 .01.01.02.01.03.07.25.16.5.26.76.02.06.05.11.07.17l.35.78c0 .01.01.01.01.02l.4.72c.04.06.07.13.11.19l.49.76c.03.05.06.09.1.14l.75.98.12.14.69.78.09.09.46.45.59.57.51.44.46.4.15.11.92.69.42.31 1.42.92 1.25.71.38.2.94.47.42.2 1.1.47.25.1.06.03 1.35.49c.11.04.22.07.33.1l1.1.33.52.13.92.22.56.11.88.15.57.08.88.09.54.04.94.03.45.01 1.36-.06.78-.09.24-.04.5-.09.27-.05.45-.1.25-.06.46-.13.2-.06.61-.23c.02-.01.03-.02.05-.02.18-.07.35-.15.52-.24l.18-.09.36-.2a1.86 1.86 0 0 1 .19-.11l.32-.21c.04-.02.07-.05.11-.07.02-.01.03-.03.05-.04l.53-.42c.03-.02.05-.05.08-.07l.41-.41c.03-.04.07-.07.1-.11a6.11 6.11 0 0 0 .39-.5l.06-.1.28-.46c.01-.03.03-.05.05-.08.01-.02.02-.04.03-.05.02-.07.07-.18.12-.28zm-29.26-6.48l-.16-.29-.35-.7-.14-.32c-.11-.26-.2-.52-.28-.78-.02-.06-.05-.12-.06-.18l-.22-.93-.03-.24-.06-.66v-.34c0-.19.01-.37.03-.56l.04-.33.11-.5.1-.36a4.78 4.78 0 0 1 .19-.48l.14-.32c.11-.22.24-.44.39-.65.02-.03.05-.06.07-.1.16-.21.33-.42.52-.61l.09-.09c.2-.2.41-.39.64-.56.04-.03.08-.05.11-.08l.67-.44.15-.09.83-.4.3-.12c.226-.092.456-.172.69-.24.12-.04.24-.07.37-.1l.77-.18.36-.07 1.21-.16 1.27-.06h.4l.92.03.45.03.96.1.37.05 1.33.23c.07.02.14.03.22.05l1.13.27.44.12.93.28.45.15.71.26.86.33.65.28.83.38.71.35.54.29.76.43.51.3.88.57.29.19 1.11.82.21.18.82.68.32.29.68.65.27.28.85.94.83 1.09.57.9.2.35.36.72.13.27.34.93c.01.02.02.04.02.06.1.32.17.64.22.96.03.15.03.3.05.45l.05.53-.01.43-.03.52c-.01.04-.01.09-.02.13a7.09 7.09 0 0 1-.17.8c0 .01 0 .01-.01.02a6.12 6.12 0 0 1-.29.75l-.05.11c-.121.244-.261.478-.42.7-.03.05-.07.09-.11.14-.13.18-.27.34-.43.51l-.19.19a4.8 4.8 0 0 1-.48.42l-.19.15c-.23.17-.47.32-.72.47l-.16.09a8.81 8.81 0 0 1-.87.42c-.01 0-.01 0-.02.01l-.96.33-.19.06-1.04.24-.21.04-1.19.16-1.31.06c-.14 0-.29-.01-.44-.01l-.91-.03-.52-.04-.85-.09-.55-.08-.85-.15-.54-.11-.89-.21-.49-.13-1.06-.32-.31-.1-1.36-.5c-.08-.03-.16-.07-.23-.1l-1.06-.45-.4-.19-.91-.45-.36-.19-1.2-.68-1.37-.89-.4-.29-.89-.67-.59-.49-.49-.42-.57-.55-.44-.43-.76-.84c-.04-.04-.08-.09-.11-.13l-.82-1.07c-.29-.33-.5-.66-.68-.99z\" fill=\"url(#Q)\"/><path d=\"M62.95 38.95c.02 2.4-.88 4.74-2.21 6.72-1.36 1.97-3.21 3.66-5.46 4.51l4.25-5.33c1.28-1.84 2.32-3.79 3.42-5.9zm4.43-1.84c.11 4.1-1.09 8.21-3.09 11.82-2.02 3.6-4.89 6.78-8.44 8.84 2.81-2.95 5.25-6.08 7.16-9.55 1.95-3.45 3.34-7.17 4.37-11.11zm3.11 7.22c.4 1.13.44 2.39.2 3.59-.22 1.21-.71 2.34-1.31 3.39-.64 1.02-1.35 2-2.24 2.79s-1.82 1.53-2.83 2.15c.59-1.06 1.26-1.99 1.96-2.88.69-.9 1.29-1.84 1.86-2.8 1.13-1.92 1.99-3.89 2.36-6.24z\" fill=\"#fff\"/></g></g><defs><linearGradient id=\"A\" x1=\"24.241\" y1=\"56.167\" x2=\"40.564\" y2=\"56.167\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"16.358\" y1=\"58.13\" x2=\"29.304\" y2=\"58.13\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"21.957\" y1=\"58.385\" x2=\"35.619\" y2=\"58.385\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"23.032\" y1=\"52.044\" x2=\"38.983\" y2=\"52.044\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"11.277\" y1=\"51.491\" x2=\"37.446\" y2=\"51.491\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"32.01\" y1=\"77.453\" x2=\"48.332\" y2=\"77.453\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"24.127\" y1=\"79.416\" x2=\"37.072\" y2=\"79.416\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"29.726\" y1=\"79.671\" x2=\"43.388\" y2=\"79.671\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"30.8\" y1=\"73.329\" x2=\"46.751\" y2=\"73.329\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"19.045\" y1=\"72.777\" x2=\"45.214\" y2=\"72.777\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"49.365\" y1=\"77.451\" x2=\"93.283\" y2=\"77.451\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"46.059\" y1=\"73.26\" x2=\"85.135\" y2=\"73.26\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"61.08\" y1=\"60.181\" x2=\"69.888\" y2=\"60.181\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"63.021\" y1=\"46.021\" x2=\"66.36\" y2=\"46.021\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"26.425\" y1=\"34.123\" x2=\"105.87\" y2=\"34.174\" xlink:href=\"#U\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"P\" x1=\"29.8\" y1=\"40.028\" x2=\"92.468\" y2=\"39.943\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"41.944\" y1=\"24.047\" x2=\"100.877\" y2=\"23.952\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"R\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"S\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><path id=\"T\" d=\"M34.22 53.3c-.99.57-2.76.23-3.84-.09-.38-.12-.74-.26-1.03-.44-.44-.28-.88-.58-1.1-.94-.16-.25-.07-.49.25-.7.02-.01.05-.03.07-.04.53-.31 1.19-.47 1.93-.53l1.15-.07c1.5-.05 2.78.63 3.14 1.44.2.46.05 1-.52 1.35-.02 0-.03.01-.05.02z\"/><linearGradient id=\"U\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeDamageRepair = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#V)\"><g clip-path=\"url(#W)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M67.8 43.38c-.01.01-.02.01-.04.02l-.15.11-.21.15c-.01 0-.01.01-.02.01l-.19.2c-.01.02-.02.03-.03.05s-.02.03-.03.05c-.02.03-.04.05-.05.08-.03.06-.06.11-.08.17 0 .01 0 .02-.01.03 0 .01-.01.02-.01.03l-.03.11-.02.17v.03l-.01 4.42c0-.1.02-.21.05-.31 0-.01.01-.02.01-.03a1.05 1.05 0 0 1 .14-.28c.01-.02.02-.03.03-.05.07-.09.15-.18.24-.26.06-.05.14-.1.21-.15.06-.05.12-.09.19-.14l9.69-5.63.01-4.42-9.69 5.64z\" fill=\"url(#A)\"/><path d=\"M56.73 51.3l.01-4.42c0 1.13.32 2.2.92 3.21l-.01 4.42c-.61-1.01-.93-2.09-.92-3.21z\" fill=\"url(#B)\"/><path d=\"M57.66 50.09l-.01 4.42c-.6-1.01-.92-2.09-.92-3.21l.01-4.42c0 1.12.31 2.2.92 3.21z\" fill=\"url(#B)\"/><path d=\"M89.52 48.02c-.02.11-.06.22-.08.33l-.16.56-.12.3-.26.55c-.05.1-.11.19-.17.29a6.77 6.77 0 0 1-.44.65l-.17.23c-.27.33-.57.65-.89.96-.08.08-.17.15-.26.23l-.62.51-.32.24-.78.52-.24.15c-.51.31-1.06.59-1.64.85l-.26.12-1.79.69-.28.09c-.947.302-1.912.543-2.89.72-.02 0-.03.01-.05.01l-1.78.25-.94.09-1.62.06h-.77c-.37 0-.75-.01-1.11-.03l-.7-.04-1.13-.11-.64-.07-1.64-.27-.01 4.42 1.45.25c.06.01.13.01.19.02l.64.07.79.09.34.02.7.04.61.03h.5.78.47l1.14-.06.72-.06.22-.03 1.79-.25c.03 0 .04 0 .05-.01.978-.177 1.943-.418 2.89-.72l.12-.03.16-.06 1.8-.69.25-.12 1.64-.86c.01-.01.03-.01.04-.02l.19-.12.79-.53.31-.24.62-.52.18-.15c.026-.024.05-.051.07-.08.33-.31.63-.63.89-.96.02-.02.04-.04.06-.07.04-.05.07-.11.11-.17a6.75 6.75 0 0 0 .44-.65c.03-.05.08-.1.11-.16l.06-.13c.1-.18.18-.37.26-.55l.1-.21c.01-.03.01-.06.02-.08.07-.19.12-.37.16-.56.02-.08.05-.15.07-.23.01-.03.01-.06.02-.09.06-.31.1-.62.11-.92v-.14l.01-4.42c0 .35-.03.71-.11 1.07z\" fill=\"url(#C)\"/><path d=\"M30.5 71.73c-.15-.09-.32-.17-.49-.24l-.41-.14-.2-.05c-.02 0-.03-.01-.05-.01l-.11-.03-.34-.06c-.11-.02-.22-.03-.33-.04l-.34-.02h-.13-.04-.17c-.13 0-.25.01-.38.03-.148.01-.295.03-.44.06-.07.01-.13.03-.19.05-.06.01-.11.03-.17.04l-.29.07c-.27.09-.53.2-.76.33-.01.01-.03.02-.04.02-.07.04-.11.08-.17.13-.08.06-.17.11-.24.18-.01.01-.02.01-.02.02-.08.07-.15.15-.21.23-.01.02-.02.04-.04.05-.01.02-.03.04-.04.06-.02.03-.05.06-.06.09-.038.059-.068.123-.09.19 0 .01-.01.02-.01.03s-.01.02-.01.04c-.01.04-.03.08-.04.13-.01.07-.02.13-.02.2v.03l-.01 4.42c0-.12.02-.23.06-.35 0-.01.01-.02.01-.04.04-.11.09-.21.16-.32.01-.02.02-.04.04-.06.07-.1.16-.2.27-.3.07-.06.16-.12.24-.18l.21-.15c.31-.18.67-.31 1.05-.41.06-.01.11-.03.17-.04.38-.08.78-.13 1.18-.13h.05a5.68 5.68 0 0 1 1.24.14c.02 0 .03.01.05.01.4.1.78.24 1.11.43.5.29.82.65.95 1.03.04.13.06.25.06.38l.01-4.42c-.01-.51-.34-1.02-1.02-1.4z\" fill=\"url(#D)\"/><path d=\"M33.14 76.05c-.43.25-.91.45-1.4.62-.17.06-.35.11-.54.16l-.71.18-.87.15-.21.03-1.2.07h-.19c-.398.002-.795-.022-1.19-.07-.06-.01-.12-.01-.18-.02l-1.15-.2-.2-.05a8.09 8.09 0 0 1-.99-.3l-.18-.06c-.38-.15-.75-.32-1.09-.51-1.39-.8-2.09-1.87-2.1-2.91v-.05l-.01 4.42v.05c.01 1.04.71 2.11 2.1 2.91.32.19.67.35 1.03.49.02.01.04.01.06.02l.18.06.63.21.36.09.2.05c.06.01.12.03.18.05l.71.12.26.03c.06.01.12.01.18.02l.26.03.7.04H28h.19.32l.79-.05c.03 0 .06-.01.09-.01l.21-.03.61-.08c.09-.02.17-.05.26-.06l.71-.18.38-.09c.06-.02.1-.05.16-.07.5-.17.98-.37 1.4-.62l34.63-20.12.01-4.42-34.62 20.1z\" fill=\"url(#E)\"/><path d=\"M89.52 48.02c-.78 4.28-6.76 7.82-14.14 8.35-2.68.19-5.26.02-7.61-.45L33.14 76.05c-2.78 1.61-7.29 1.61-10.08 0-1.39-.8-2.09-1.87-2.1-2.91-.02-1.07.7-2.12 2.07-2.93l34.63-20.12c-.81-1.36-1.11-2.85-.8-4.41.9-4.28 6.99-7.75 14.37-8.22a27.79 27.79 0 0 1 6.26.28l-9.69 5.63c-1.17.68-1.16 1.79 0 2.46l7.27 4.2c1.17.67 3.08.67 4.25-.01l9.69-5.63c.56 1.13.77 2.34.51 3.63zM25.68 74.53c1.34.77 3.5.77 4.83 0 1.34-.78 1.34-2.03 0-2.81s-3.5-.77-4.84.01-1.33 2.03.01 2.8z\" fill=\"url(#F)\"/><path d=\"M39.56 35.95c-.23-.13-.47-.25-.73-.35-.01-.01-.03-.01-.04-.01-.04-.02-.08-.03-.12-.04l-.45-.15-.25-.06c-.05-.01-.09-.02-.14-.04l-.13-.03-.5-.09c-.06-.01-.12-.01-.18-.02-.04 0-.08-.01-.12-.01a1.1 1.1 0 0 0-.18-.02l-.5-.03h-.16-.14-.22l-.56.04c-.02 0-.04.01-.06.01-.05.01-.1.01-.15.02l-.43.06a1.21 1.21 0 0 0-.18.05l-.5.13-.27.07c-.04.01-.07.04-.11.05a5.22 5.22 0 0 0-.99.44c-.02.01-.04.02-.06.04-.1.06-.16.12-.25.19l-.35.26c-.01.01-.02.02-.03.02-.12.11-.22.22-.31.33l-.05.08c-.02.03-.04.05-.06.08-.03.05-.07.09-.09.14a1.51 1.51 0 0 0-.13.29c-.01.01-.01.03-.01.04-.01.02-.01.04-.02.06-.02.06-.04.12-.05.18-.02.095-.03.193-.03.29v.04l-.02 7.35c0-.17.03-.34.09-.52.01-.02.01-.04.02-.06a2.62 2.62 0 0 1 .24-.47c.02-.03.04-.05.06-.08.117-.161.251-.308.4-.44.1-.09.23-.17.35-.26.1-.07.19-.15.31-.22.3-.18.64-.31.99-.44l.38-.12.5-.13.61-.11c.05-.01.1-.02.15-.02l.85-.05h.14c.277.001.555.018.83.05.04 0 .08.01.13.01.27.03.54.08.81.14.05.01.1.02.14.04l.7.21c.04.01.08.03.12.04a4.93 4.93 0 0 1 .77.36c.99.57 1.48 1.32 1.48 2.07l.02-7.35c-.04-.74-.53-1.49-1.52-2.06z\" fill=\"url(#G)\"/><path d=\"M46.14 36.44l-.02 7.34-2.69 5.87.02-7.35 2.69-5.86z\" fill=\"url(#H)\"/><path d=\"M46.14 36.44l-2.69 5.87-10.11 1.57-7.44-4.3 2.68-5.86 10.12-1.58 7.44 4.3zm-13.66 3.63c1.96 1.13 5.14 1.13 7.09 0 1.96-1.14 1.95-2.98-.01-4.11-1.97-1.14-5.15-1.14-7.11 0-1.95 1.13-1.94 2.97.03 4.11z\" fill=\"url(#I)\"/><path d=\"M43.45 42.3l-.02 7.35-10.11 1.57.02-7.35 10.11-1.57z\" fill=\"url(#J)\"/><path d=\"M33.34 43.87l-.02 7.35-7.44-4.3.02-7.34 7.44 4.29z\" fill=\"url(#K)\"/><path d=\"M24.05 44.56c-.23-.13-.47-.25-.73-.35-.01-.01-.03-.01-.04-.01-.04-.02-.08-.03-.12-.04l-.45-.15-.25-.06c-.05-.01-.09-.02-.14-.04l-.13-.03-.5-.09c-.06-.01-.12-.01-.18-.02-.04 0-.08-.01-.12-.01-.06-.01-.12-.02-.18-.02l-.5-.03h-.16-.14-.22l-.56.04c-.02 0-.04.01-.06.01-.05.01-.1.01-.15.02l-.43.06c-.06.01-.12.03-.18.05l-.5.13-.27.07c-.04.01-.07.04-.11.05-.344.112-.676.259-.99.44-.02.01-.04.02-.06.04-.1.06-.16.12-.25.19l-.35.26c-.01.01-.02.02-.03.02-.12.11-.22.22-.31.33l-.05.08c-.02.03-.04.05-.06.08-.03.05-.07.09-.09.14a1.51 1.51 0 0 0-.13.29c-.01.01-.01.03-.01.04-.01.02-.01.04-.02.06-.021.059-.038.119-.05.18-.02.095-.03.193-.03.29v.04l-.02 7.35c0-.17.03-.34.09-.52.01-.02.01-.04.02-.06.064-.164.144-.322.24-.47.02-.03.04-.05.06-.08a2.7 2.7 0 0 1 .4-.44c.1-.09.23-.17.35-.26.1-.07.19-.15.31-.22.3-.18.64-.31.99-.44l.38-.12.5-.13.61-.11c.05-.01.1-.02.15-.02l.85-.05h.14a7.55 7.55 0 0 1 .83.05c.04 0 .08.01.13.01.27.03.54.08.81.14.05.01.1.02.14.04l.7.21c.04.01.08.03.12.04.267.098.524.218.77.36.99.57 1.48 1.32 1.48 2.07l.02-7.35c-.04-.74-.53-1.49-1.52-2.06z\" fill=\"url(#L)\"/><path d=\"M30.62 45.05l-.02 7.34-2.68 5.87.02-7.35 2.68-5.86z\" fill=\"url(#M)\"/><path d=\"M30.62 45.05l-2.69 5.87-10.11 1.57-7.44-4.3 2.68-5.86 10.12-1.58 7.44 4.3zm-13.65 3.62c1.96 1.13 5.14 1.13 7.09 0 1.96-1.14 1.95-2.98-.01-4.11-1.97-1.14-5.15-1.14-7.11 0-1.95 1.13-1.94 2.98.03 4.11z\" fill=\"url(#N)\"/><path d=\"M27.94 50.91l-.02 7.35-10.11 1.57.02-7.35 10.11-1.57z\" fill=\"url(#O)\"/><path d=\"M17.83 52.48l-.02 7.35-7.44-4.3.02-7.34 7.44 4.29z\" fill=\"url(#P)\"/><path d=\"M31.74 32.34c-.23-.13-.47-.25-.73-.35-.01-.01-.03-.01-.04-.01-.04-.02-.08-.03-.12-.04l-.45-.15-.25-.06c-.05-.01-.09-.02-.14-.04l-.13-.03-.5-.09c-.06-.01-.12-.01-.18-.02-.04 0-.08-.01-.12-.01a1.1 1.1 0 0 0-.18-.02l-.5-.03h-.16-.14-.22l-.56.04c-.02 0-.04.01-.06.01-.05.01-.1.01-.15.02l-.43.06c-.061.012-.121.029-.18.05l-.5.13-.27.07c-.04.01-.07.04-.11.05a5.22 5.22 0 0 0-.99.44c-.02.01-.04.02-.06.04-.1.06-.16.12-.25.19l-.35.26c-.01.01-.02.02-.03.02-.12.11-.22.22-.31.33l-.05.08c-.02.03-.04.05-.06.08-.03.05-.07.09-.09.14a1.51 1.51 0 0 0-.13.29c-.01.01-.01.03-.01.04-.01.02-.01.04-.02.06-.021.059-.038.119-.05.18-.02.095-.03.193-.03.29v.04l-.02 7.35c0-.17.03-.34.09-.52.01-.02.01-.04.02-.06.064-.164.144-.322.24-.47.02-.03.04-.05.06-.08a2.7 2.7 0 0 1 .4-.44c.1-.09.23-.17.35-.26.1-.07.19-.15.31-.22.3-.18.64-.31.99-.44l.38-.12.5-.13.61-.11a.77.77 0 0 1 .15-.02l.85-.05h.14c.277.001.555.018.83.05.04 0 .08.01.13.01.27.03.54.08.81.14.05.01.1.02.14.04l.7.21c.04.01.08.03.12.04a4.92 4.92 0 0 1 .77.36c.99.57 1.48 1.32 1.48 2.07l.02-7.35c-.04-.74-.53-1.49-1.52-2.06z\" fill=\"url(#Q)\"/><path d=\"M38.32 32.83l-.02 7.34-2.69 5.87.02-7.35 2.69-5.86z\" fill=\"url(#R)\"/><path d=\"M38.32 32.83l-2.69 5.87-10.11 1.57-7.44-4.3 2.68-5.86 10.12-1.58 7.44 4.3zm-13.65 3.63c1.96 1.13 5.14 1.13 7.09 0 1.96-1.14 1.95-2.98-.01-4.11-1.97-1.14-5.15-1.14-7.11 0-1.95 1.13-1.94 2.97.03 4.11z\" fill=\"url(#S)\"/><path d=\"M35.63 38.69l-.02 7.35-10.11 1.57.02-7.35 10.11-1.57z\" fill=\"url(#T)\"/><path d=\"M25.52 40.26l-.02 7.35-7.44-4.3.02-7.34 7.44 4.29z\" fill=\"url(#U)\"/></g></g><defs><linearGradient id=\"A\" x1=\"27.236\" y1=\"43.383\" x2=\"80.46\" y2=\"43.383\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"55.892\" y1=\"50.693\" x2=\"59.827\" y2=\"50.693\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"15.849\" y1=\"53.91\" x2=\"91.309\" y2=\"53.91\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"21.518\" y1=\"74.352\" x2=\"37.266\" y2=\"74.352\" xlink:href=\"#X\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"E\" x1=\"2.921\" y1=\"68.804\" x2=\"82.995\" y2=\"68.804\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"16.929\" y1=\"57.329\" x2=\"96.122\" y2=\"57.329\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"32.029\" y1=\"40.234\" x2=\"56.061\" y2=\"40.234\" xlink:href=\"#X\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"H\" x1=\"19.06\" y1=\"43.043\" x2=\"47.416\" y2=\"43.043\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"18.051\" y1=\"38.008\" x2=\"61.731\" y2=\"38.008\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"20.845\" y1=\"46.761\" x2=\"50.338\" y2=\"46.761\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"24.077\" y1=\"45.398\" x2=\"52.098\" y2=\"45.398\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"11.777\" y1=\"48.842\" x2=\"34.039\" y2=\"48.842\" xlink:href=\"#X\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"M\" x1=\"3.549\" y1=\"51.651\" x2=\"31.904\" y2=\"51.651\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"2.54\" y1=\"46.615\" x2=\"46.22\" y2=\"46.615\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"5.334\" y1=\"55.369\" x2=\"34.827\" y2=\"55.369\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"8.566\" y1=\"54.006\" x2=\"36.587\" y2=\"54.006\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"18.322\" y1=\"36.624\" x2=\"49.973\" y2=\"36.624\" xlink:href=\"#X\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"R\" x1=\"11.243\" y1=\"39.433\" x2=\"39.598\" y2=\"39.433\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"S\" x1=\"10.233\" y1=\"34.398\" x2=\"53.914\" y2=\"34.398\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"T\" x1=\"13.028\" y1=\"43.151\" x2=\"42.52\" y2=\"43.151\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"U\" x1=\"16.26\" y1=\"41.789\" x2=\"44.28\" y2=\"41.789\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"V\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"W\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"X\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeDamageThirdParties = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#f)\"><g clip-path=\"url(#g)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M80.04 67.45c-.14.18-10.06 2.49-10.58 2.61l-5.86-2.83 4.19-5.09 12.25 5.31z\" fill=\"url(#A)\"/><path d=\"M80.04 67.45v.82c-.14.18-10.06 2.49-10.58 2.61v-.82l10.58-2.61z\" fill=\"url(#B)\"/><path d=\"M80.03 67.45s-.01.01-.03.02c-.01.01-.03.01-.06.02s-.07.02-.11.04c-1.4.44-9.9 2.42-10.39 2.53v.82l10.39-2.53c.04-.01.08-.03.11-.04.02-.01.04-.02.06-.02.01-.01.02-.01.03-.02v-.82z\" fill=\"url(#C)\"/><path d=\"M69.46 70.06l-.01.82-5.85-2.84v-.81l5.86 2.83z\" fill=\"url(#D)\"/><path d=\"M22.29 61.5l-.01.81-11.13.62.01-.81 11.13-.62z\" fill=\"url(#E)\"/><path d=\"M22.55 66.23l-.26-4.73-11.13.62 10.88-5.3 6.53-4.1 5.47 1.86.05 2.18-11.54 9.47z\" fill=\"url(#F)\"/><path d=\"M22.55 66.23l-.01.81-.26-4.73.01-.81.26 4.73z\" fill=\"url(#G)\"/><path d=\"M34.09 56.76l-.01.81-11.54 9.47.01-.81 11.54-9.47z\" fill=\"url(#H)\"/><path d=\"M38.67 75.82l-12.79 4.14.07-3.45 12.72-.69z\" fill=\"url(#I)\"/><path d=\"M38.67 75.82v.85l-12.8 4.14.01-.85 12.79-4.14z\" fill=\"url(#J)\"/><path d=\"M61.71 69.94v.81l-3.68 4.3v-.81l3.68-4.3z\" fill=\"url(#K)\"/><path d=\"M58.03 74.24v.81l-2.35-1.35v-.82l2.35 1.36z\" fill=\"url(#L)\"/><path d=\"M55.68 72.88v.82l-6.39 4.46v-.82l6.39-4.46z\" fill=\"url(#M)\"/><path d=\"M49.29 77.34v.82l-2.93-2.12.01-.82 2.92 2.12z\" fill=\"url(#N)\"/><path d=\"M38.43 80.86l8.76-16.05 14.52 5.13-3.68 4.3-2.35-1.36-6.39 4.46-2.92-2.12-7.94 5.64z\" fill=\"url(#O)\"/><path d=\"M46.37 75.22l-.01.82-7.93 5.64v-.82l7.94-5.64z\" fill=\"url(#P)\"/><path d=\"M40.3 68.94v.82l-.63 4.66v-.82l.63-4.66z\" fill=\"url(#Q)\"/><path d=\"M18.95 74.1l10.56-10.03 10.79 4.87-.63 4.66-20.72.5z\" fill=\"url(#R)\"/><path d=\"M39.67 73.6v.82l-20.73.49.01-.81 20.72-.5z\" fill=\"url(#S)\"/><path d=\"M71.91 80.15l-11.92-3.21 4.47-4.52 5.19-.15 2.26 7.88z\" fill=\"url(#T)\"/><path d=\"M71.91 80.15l-.01.81-11.92-3.21.01-.81 11.92 3.21z\" fill=\"url(#U)\"/><path d=\"M88.85 62.67v.82l-17.57-4.97v-.82l17.57 4.97z\" fill=\"url(#V)\"/><path d=\"M61.49 54.25l5.11-3.89 22.25 12.31-17.57-4.97 1.8 4.91-11.59-8.36z\" fill=\"url(#W)\"/><path d=\"M73.08 62.61l-.01.81-11.59-8.36.01-.81 11.59 8.36z\" fill=\"url(#X)\"/><path d=\"M48.89 68.57c14.116 0 25.56-11.444 25.56-25.56S63.007 17.45 48.89 17.45 23.33 28.894 23.33 43.01s11.444 25.56 25.56 25.56z\" fill=\"url(#Y)\"/><path d=\"M40.29 28.71l-6.75-3.44.09-.19 6.75 3.45-.09.18zm13.07-2.87l-.18-.09 3.11-5.99.18.09-3.11 5.99zm7.067 10.26l.055-.203 9.681 2.624-.055.203-9.681-2.624zm-8.381 10.374l.205-.047 2.675 11.616-.205.047-2.675-11.616zM64.84 59.65l-.15-.14c3.7-3.75 7.23-9.33 7.27-9.39l.17.11c-.02.06-3.57 5.66-7.29 9.42zm-18.99 4.88c-7.27-1.56-11.66-4.58-11.7-4.61l.12-.17c.04.03 4.4 3.03 11.63 4.58l-.05.2zM30.786 48.504l8.468-7.1.135.161-8.468 7.1-.135-.161zM24.26 43.97c-.4-5.71 1.6-11.44 1.62-11.5l.19.07c-.02.06-2.01 5.75-1.61 11.42l-.2.01z\" fill=\"#8334c2\"/><path d=\"M40.34 28.62s6.23-2.89 12.93-2.83c0 0 4.08 3.85 7.18 10.21 0 0-2.52 4.9-8.3 10.45l-12.83-4.97s-.04-8.71 1.02-12.86z\" fill=\"url(#Z)\"/><path d=\"M60.82 20.4c-2.16-1.14-4.5-1.98-6.96-2.47a14 14 0 0 1 2.52 1.87s1.79-.03 4.44.6z\" fill=\"url(#a)\"/><path d=\"M72.06 50.18l1.52-.63c.55-2.09.88-4.28.88-6.54 0-3.83-.87-7.45-2.37-10.71-.2 1.51-.73 3.58-1.95 6.33-.01 0 1.66 4.78 1.92 11.55z\" fill=\"url(#b)\"/><path d=\"M54.82 58.07s-3.97 3.49-8.95 6.35c0 0 1.52 2.04 3.83 4.11 4.67-.15 9.02-1.54 12.73-3.87l2.34-5.09-9.95-1.5z\" fill=\"url(#c)\"/><path d=\"M30.85 48.58c-4.66-2.44-6.49-4.62-6.49-4.62-.39 1.25-.42 3.14-.31 5a25.43 25.43 0 0 0 6.31 11.62c3.48-.33 3.85-.75 3.85-.75-1.72-3.43-3.36-11.25-3.36-11.25z\" fill=\"url(#d)\"/><path d=\"M33.59 25.17c.31-1.34 1.61-3.06 2.9-4.51-4.71 2.62-8.48 6.69-10.76 11.6l.25.24c4.34-6.75 7.61-7.33 7.61-7.33z\" fill=\"url(#e)\"/></g></g><defs><linearGradient id=\"A\" x1=\"50.358\" y1=\"66.099\" x2=\"96.726\" y2=\"66.099\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"69.453\" y1=\"69.163\" x2=\"80.035\" y2=\"69.163\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"41.574\" y1=\"69.163\" x2=\"88.739\" y2=\"69.163\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"57.291\" y1=\"69.05\" x2=\"80.145\" y2=\"69.05\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"9.622\" y1=\"62.215\" x2=\"33.478\" y2=\"62.215\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"10.207\" y1=\"59.474\" x2=\"62.373\" y2=\"59.474\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"22.142\" y1=\"64.269\" x2=\"27.823\" y2=\"64.269\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"11.572\" y1=\"61.9\" x2=\"42.211\" y2=\"61.9\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"22.989\" y1=\"77.885\" x2=\"63.015\" y2=\"77.885\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"20.323\" y1=\"78.312\" x2=\"49.769\" y2=\"78.312\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"49.302\" y1=\"72.494\" x2=\"63.432\" y2=\"72.494\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"49.316\" y1=\"73.968\" x2=\"66.146\" y2=\"73.968\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"41.057\" y1=\"75.52\" x2=\"60.888\" y2=\"75.52\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"42.03\" y1=\"76.687\" x2=\"53.694\" y2=\"76.687\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"28.405\" y1=\"72.84\" x2=\"88.694\" y2=\"72.84\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"32.138\" y1=\"78.45\" x2=\"56.418\" y2=\"78.45\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"36.483\" y1=\"71.68\" x2=\"40.585\" y2=\"71.68\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"R\" x1=\"16.001\" y1=\"69.085\" x2=\"75.864\" y2=\"69.085\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"S\" x1=\"14.07\" y1=\"74.259\" x2=\"54.532\" y2=\"74.259\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"T\" x1=\"48.912\" y1=\"76.209\" x2=\"94.884\" y2=\"76.209\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"U\" x1=\"25.317\" y1=\"78.948\" x2=\"79.155\" y2=\"78.948\" xlink:href=\"#h\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"V\" x1=\"62.799\" y1=\"60.594\" x2=\"110.01\" y2=\"60.594\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"W\" x1=\"39.049\" y1=\"56.516\" x2=\"101.81\" y2=\"56.516\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"X\" x1=\"49.038\" y1=\"58.836\" x2=\"83.484\" y2=\"58.836\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Y\" x1=\"17.737\" y1=\"43.008\" x2=\"89.635\" y2=\"43.008\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Z\" x1=\"10.938\" y1=\"36.123\" x2=\"62.028\" y2=\"36.123\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"a\" x1=\"23.591\" y1=\"19.17\" x2=\"65.664\" y2=\"19.17\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"b\" x1=\"23.647\" y1=\"41.239\" x2=\"76.027\" y2=\"41.239\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"c\" x1=\"9.843\" y1=\"63.302\" x2=\"68.258\" y2=\"63.302\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"d\" x1=\"6.868\" y1=\"52.271\" x2=\"55.781\" y2=\"52.271\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"e\" x1=\"12.771\" y1=\"26.584\" x2=\"53.262\" y2=\"26.584\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"f\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"g\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"h\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeDamageThirdPartiesProperty = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#W)\"><g clip-path=\"url(#X)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M78.79 38.29L58.34 50 22.75 29.15 43.2 17.44l35.59 20.85z\" fill=\"url(#A)\"/><path d=\"M78.79 38.29l-.16 18.16-20.45 11.71.16-18.16 20.45-11.71z\" fill=\"url(#B)\"/><path d=\"M58.34 50l-.16 18.16-35.6-20.85.17-18.16L58.34 50z\" fill=\"url(#C)\"/><path d=\"M43.18 43.67c-.02.55-.03 1.16.34 1.57.2.23.5.37.72.58.77.75.38 2.08.86 3.04.16.31.4.57.58.87.56.93.44 2.15.98 3.09.67 1.2 2.15 1.63 3.48 1.96.31.08.63.15.95.11.37-.05.71-.27 1.08-.26.66.02 1.07.71 1.29 1.33s.42 1.34 1.01 1.64c.43.22.97.14 1.42.33.54.23.84.78 1.14 1.25.16.24.32.47.54.67.09.08.55.66.68.59 1.45-.79 3.18-1.3 4.28-2.59.34-.39.62-.86 1.07-1.12.38-.22.84-.28 1.23-.49.84-.45 1.14-1.49 1.24-2.44.1-.94.08-1.95.55-2.77.21-.35.5-.65.68-1.02.29-.6.26-1.3.31-1.97a7.77 7.77 0 0 1 1.78-4.38c-1.48-1.65-3.04-3.35-5.1-4.18-.91-.36-1.88-.54-2.85-.72-1.15-.21-2.47-.7-3.59-.23-.42.18-.84.4-1.29.47-1.05.14-2.12-.28-3.05-.69-.29-.13-.7-.44-1.02-.28-.16.08-.28.23-.42.36a1.98 1.98 0 0 1-.77.47c-.73.22-1.5-.05-2.22-.32-1.38-.52-2.79-1.04-4.26-1.08-.38-.01-.78.01-1.13.16-.5.21-.86.69-.98 1.21-.06.26 0 .49-.01.74-.02.33-.2.62-.28.94-.01.05-.02.1-.01.15.02.04.05.08.08.11.35.34.42.77.57 1.2.15.53.13 1.15.12 1.7z\" fill=\"url(#D)\"/><path d=\"M64.43 68.21l8.88 6.48-.03 5.51-10.07-6.45 1.22-5.54z\" fill=\"url(#E)\"/><path d=\"M80.04 70.61l-6.73 4.08-.03 5.51 9.24-5.2-2.48-4.39z\" fill=\"url(#F)\"/><path d=\"M64.43 68.21l4.52-.61 1.54.23.38-.59 5.31-.66 3.86 4.03-6.73 4.08-8.88-6.48z\" fill=\"url(#G)\"/><path d=\"M60.71 73.01c-.01.03 1.67 1.19 1.67 1.19l1.24-.75-.74-.77-2.17.33z\" fill=\"url(#H)\"/><path d=\"M60.5 74.06l1.84 1.2.04-1.05-1.67-1.2-.21 1.05z\" fill=\"url(#I)\"/><path d=\"M63.62 73.46l.3.86-1.58.94.04-1.05 1.24-.75z\" fill=\"url(#J)\"/><path d=\"M68.37 75.91l4 .55 1.97-2.26-4.51-.35-1.46 2.06z\" fill=\"url(#K)\"/><path d=\"M73.54 81.68l-1.17-5.22 1.97-2.26 1.56 5.79-2.36 1.69z\" fill=\"url(#L)\"/><path d=\"M67.92 78.52l.45-2.61 4 .55 1.17 5.22-5.62-3.16z\" fill=\"url(#M)\"/><path d=\"M85.5 69.32l2.25 1.72 1.78-.84-1.12-1.26-2.91.38z\" fill=\"url(#N)\"/><path d=\"M87.79 72.49l-.04-1.45 1.78-.84.39 1.54-2.13.75z\" fill=\"url(#O)\"/><path d=\"M85.5 69.32l-.21 1.29 2.5 1.88-.04-1.45-2.25-1.72z\" fill=\"url(#P)\"/><path d=\"M45.85 69.92c0 .01 0 .01-.01.02-.02.05-.05.1-.08.16-.01.01-.01.02-.02.03l-.13.15c-.03.03-.08.06-.12.09-.03.02-.06.05-.1.07l-16.22 9.29c-.1.06-.21.1-.33.14-.04.01-.08.03-.13.04-.06.02-.11.03-.17.04-.07.01-.13.03-.2.03-.02 0-.03 0-.05.01a2.62 2.62 0 0 1-.28.01h-.05c-.09 0-.19-.01-.28-.02h-.04c-.09-.01-.18-.03-.27-.05-.02 0-.03-.01-.05-.01-.08-.02-.16-.04-.23-.07-.01 0-.03-.01-.04-.01l-.26-.12-16.21-9.49c-.16-.1-.29-.21-.37-.33a.65.65 0 0 1-.12-.37l-.01 1.35c0 .25.16.5.49.7l16.21 9.49.24.12c.02.01.04.01.05.01a.88.88 0 0 0 .15.05c.03.01.06.01.08.02.02 0 .03.01.05.01.01 0 .03.01.04.01l.17.03c.02 0 .04 0 .06.01h.04c.02 0 .04.01.06.01.05 0 .11.01.17.01h.05.05.08c.06 0 .12-.01.19-.01.04 0 .05 0 .07-.01.05-.01.1-.01.14-.02.02 0 .04-.01.06-.01.06-.01.11-.03.17-.04.03-.01.06-.01.09-.02.01 0 .02-.01.04-.02.113-.039.223-.085.33-.14l16.22-9.29c.01 0 .01-.01.02-.01.03-.02.05-.04.08-.06l.12-.09.11-.12c.01-.01.01-.02.02-.03s.01-.02.02-.03c.01-.02.02-.03.03-.05.02-.03.03-.06.05-.1 0-.02 0-.02.01-.03.01-.02.01-.04.02-.06.01-.03.01-.06.01-.1l.01-1.36c0 .05-.01.11-.03.17z\" fill=\"url(#Q)\"/><path d=\"M45.39 69.05c.66.38.65 1 0 1.37l-16.22 9.29a2.61 2.61 0 0 1-2.37-.01l-16.21-9.49c-.66-.38-.65-1 0-1.37l16.22-9.29a2.61 2.61 0 0 1 2.37.01l16.21 9.49z\" fill=\"url(#R)\"/><path d=\"M30.38 44.9c-1.38.79-3.62.77-5.01-.04-1.38-.81-1.38-2.1 0-2.89s3.62-.77 5.01.04 1.38 2.11 0 2.89z\" fill=\"url(#S)\"/><path d=\"M38.77 68.66a3.82 3.82 0 0 0-.48-1.83l-3.52-13.15-1.74-6.75c-.5-1.79-1.11-3.85-2.11-4.74-.25-.23.71 1.27.29 1.95-.4.63-1.07.83-1.39 1.02a1.76 1.76 0 0 1-1.06.26l-1.82-.02c-.34.04-1.85-.71-2.09-.93-1.18-1.06.37-2.51 0-2.31-1.03.57-1.99 4.1-2.48 5.88l-1.96 7.07-3.25 11.41-.1.37c-.95 2.1.01 4.45 2.88 6.13 4.31 2.52 11.29 2.58 15.6.13 2.16-1.22 3.24-2.85 3.23-4.49z\" fill=\"url(#T)\"/><path d=\"M34.75 54.88a.36.36 0 0 0-.1.07c-.04.02-.08.05-.12.07l-.64.33-.18.08-.61.26-.08.03-.58.2-.1.03-.49.14-.37.1-.53.11c-.1.02-.2.05-.31.06-.03 0-.05.01-.08.01-.05.01-.11.02-.16.02l-.66.09c-.06.01-.13.02-.19.02-.04 0-.08.01-.12.01l-.65.05c-.05 0-.1 0-.14.01l-.26.01h-.26-.52-.19c-.08 0-.16-.01-.24-.01l-.48-.03c-.07-.01-.14-.01-.21-.01l-.23-.03-.47-.06-.22-.03c-.07-.01-.13-.03-.2-.04l-.5-.09c-.08-.02-.16-.03-.24-.04l-.29-.07-.12-.03-.58-.15c-.05-.01-.09-.03-.13-.04l-.2-.06-.58-.2-.17-.06-.08-.03-.43-.19-.24-.11-.7-.37-.51-.32-.04.17-1.36 4.65c.46.6 1.11 1.17 1.96 1.67l.7.37.25.11.5.22.17.06.58.2.2.06.72.2.12.03.52.11.5.09.43.06.47.06.44.04.48.03.44.01h.52l.52-.01c.05 0 .1 0 .14-.01l.77-.06c.06-.01.13-.01.19-.02l.66-.09c.05-.01.11-.02.16-.02.13-.02.26-.05.38-.08l.53-.11.37-.1.49-.14.69-.23.08-.03.61-.26.18-.08.64-.33c.08-.04.15-.09.22-.13l.17-.11.15-.1c.05-.04.11-.07.16-.11.05-.03.1-.07.14-.11l.15-.12.13-.11.14-.12c.04-.03.07-.06.1-.1l.22-.21.07-.07.19-.21-1.33-4.8-.05-.19c-.04.03-.08.06-.12.08l-.19.11z\" fill=\"url(#U)\"/><path d=\"M36.25 59.9l-.07.07-.22.21c-.03.03-.07.06-.1.1a1.74 1.74 0 0 1-.14.12c-.04.04-.09.07-.13.11l-.15.12-.14.11c-.05.04-.11.07-.16.11l-.15.1-.17.11-.22.13-.64.33-.18.08-.61.26-.08.03-.69.23-.49.14-.37.1-.53.11-.38.08c-.05.01-.11.02-.16.02l-.66.09c-.06.01-.13.02-.19.02l-.77.06c-.05 0-.1 0-.14.01l-.52.01h-.52c-.15 0-.29-.01-.44-.01l-.48-.03-.44-.04-.47-.06-.43-.06-.5-.09-.52-.11-.12-.03-.72-.2-.2-.06-.58-.2-.17-.06-.5-.22-.25-.11-.7-.37c-.85-.5-1.5-1.07-1.96-1.67l-.94 3.21-.01.7c-.01 1.42.92 2.85 2.79 3.94l.7.37.24.11.43.19a.69.69 0 0 0 .08.03l.17.06.58.2.2.06c.05.01.09.03.13.04l.58.15.12.03.29.07c.08.02.16.03.24.04l.5.09c.07.01.13.03.2.04l.22.03.47.06.23.03c.07.01.14.01.21.01l.48.03.24.01h.19.52.26l.26-.01c.05 0 .1 0 .14-.01l.65-.05c.04 0 .08-.01.12-.01.06-.01.13-.01.19-.02l.66-.09c.05-.01.11-.02.16-.02.03 0 .05-.01.08-.01l.31-.06.53-.11.37-.1.49-.14.1-.03.58-.2.08-.03.61-.26.18-.08.64-.33c.04-.02.08-.05.12-.07a.36.36 0 0 0 .1-.07l.17-.11.15-.1c.05-.04.11-.07.16-.11.05-.03.1-.07.14-.11l.15-.12.13-.11.14-.12c.02-.02.04-.03.06-.05l.05-.05.22-.21.07-.07c.09-.09.17-.19.25-.29.03-.03.04-.05.06-.08l.14-.18c.02-.03.04-.07.07-.1l.11-.17c.01-.02.02-.03.03-.05s.02-.05.04-.07c.03-.05.05-.09.07-.14l.06-.12c.14-.3.29-.63.34-.95.01-.04.01-.08.02-.12.01-.05.01-.1.01-.14 0-.03.01-.06.01-.08v-.08l.01-.65-.88-3.17c-.09.06-.15.13-.21.21zm-15.18-4.97l.7.37.24.11.43.19c.02.01.05.02.08.03l.17.06.58.2.2.06c.05.01.09.03.13.04l.58.15.12.03.29.07c.08.02.16.03.24.04l.5.09c.07.01.13.03.2.04l.22.03.47.06.23.03c.07.01.14.01.21.01l.48.03.24.01h.19.52.26l.26-.01c.05 0 .1 0 .14-.01l.65-.05c.04 0 .08-.01.12-.01.06-.01.13-.01.19-.02l.66-.09c.05-.01.11-.02.16-.02.03 0 .05-.01.08-.01l.31-.06.53-.11.37-.1.49-.14.1-.03.58-.2.08-.03.61-.26.18-.08.64-.33c.04-.02.08-.05.12-.07a.36.36 0 0 0 .1-.07l.17-.11c.04-.03.08-.06.12-.08l-1.38-5.38-.44.18-.08.03-.69.23-.49.14-.37.1-.53.11-.38.08c-.05.01-.11.02-.16.02l-.66.09c-.06.01-.13.02-.19.02l-.77.06c-.05 0-.1 0-.14.01l-.52.01h-.52c-.15 0-.29-.01-.44-.01l-.48-.03-.44-.04-.47-.06-.43-.06-.5-.09-.52-.11-.12-.03-.72-.2-.2-.06-.58-.2-.17-.06-.5-.22c-.04-.02-.08-.03-.12-.05l-1.47 5.44.54.32z\" fill=\"#fff\"/><path d=\"M27.9 46.18c-.97-.01-1.93-.23-2.68-.67-.81-.47-1.25-1.12-1.24-1.83 0-.71.45-1.34 1.25-1.8 1.5-.85 3.85-.83 5.34.04.81.47 1.25 1.12 1.24 1.83 0 .7-.45 1.34-1.25 1.8-.74.43-1.7.64-2.66.63zm-.02-3.98c-.8-.01-1.59.16-2.18.5-.49.28-.77.63-.77.98s.28.72.77 1.01c1.19.7 3.21.72 4.4.04.49-.28.77-.63.77-.98s-.28-.72-.77-1.01c-.61-.35-1.42-.53-2.22-.54z\" fill=\"url(#V)\"/></g></g><defs><linearGradient id=\"A\" x1=\"-6.514\" y1=\"33.359\" x2=\"133.289\" y2=\"34.239\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"25.889\" y1=\"52.957\" x2=\"91.952\" y2=\"53.373\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"10.42\" y1=\"48.466\" x2=\"124.521\" y2=\"49.184\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"17.324\" y1=\"48.729\" x2=\"94.526\" y2=\"49.215\" xlink:href=\"#Y\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"E\" x1=\"58.6\" y1=\"74.145\" x2=\"92.641\" y2=\"74.359\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"59.437\" y1=\"75.298\" x2=\"85.223\" y2=\"75.461\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"57.697\" y1=\"70.529\" x2=\"87.886\" y2=\"70.719\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"58.375\" y1=\"73.424\" x2=\"66.287\" y2=\"73.474\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"59.719\" y1=\"74.125\" x2=\"65.957\" y2=\"74.164\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"58.498\" y1=\"74.331\" x2=\"65.249\" y2=\"74.374\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"65.86\" y1=\"75.123\" x2=\"77.366\" y2=\"75.195\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"62.082\" y1=\"77.866\" x2=\"77.873\" y2=\"77.965\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"65.172\" y1=\"78.762\" x2=\"81.792\" y2=\"78.867\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"82.97\" y1=\"70.045\" x2=\"90.988\" y2=\"69.963\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"82.736\" y1=\"71.31\" x2=\"90.468\" y2=\"71.358\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"84.223\" y1=\"70.892\" x2=\"90.999\" y2=\"70.935\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"-8.612\" y1=\"75.255\" x2=\"56.203\" y2=\"75.662\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"R\" x1=\"7.261\" y1=\"69.502\" x2=\"70.1\" y2=\"69.897\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"S\" x1=\"20.807\" y1=\"43.394\" x2=\"40.237\" y2=\"43.517\" xlink:href=\"#Y\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"T\" x1=\"10.427\" y1=\"58.45\" x2=\"42.443\" y2=\"58.651\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"U\" x1=\"14.187\" y1=\"58.679\" x2=\"39.263\" y2=\"58.679\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"V\" x1=\"22.382\" y1=\"43.683\" x2=\"44.097\" y2=\"43.82\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"W\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"X\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"Y\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeDomesticThefts = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#S)\"><g clip-path=\"url(#T)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M27.73 38.08c1.72-.99 3.11-.19 3.11 1.79l.04 15.34c.01 1.97-1.38 4.37-3.09 5.36l-13.35 7.71c-1.72.99-3.12.2-3.13-1.77l-.04-15.34c-.01-1.97 1.39-4.39 3.1-5.38l13.36-7.71z\" fill=\"url(#A)\"/><path d=\"M28.92 37.67h.05c.17-.01.34-.01.5.03.01 0 .02 0 .03.01.16.03.31.09.45.17l-.01-.01-3.5-2.03c-.01 0-.01-.01-.02-.01-.05-.03-.1-.05-.16-.08l-.16-.06-.11-.03c-.01 0-.02 0-.02-.01-.01 0-.03-.01-.04-.01-.06-.01-.12-.02-.19-.02h-.21c-.02 0-.04 0-.07.01h-.05c-.04 0-.08.01-.12.01-.092.01-.182.03-.27.06-.04.01-.08.03-.12.04s-.07.02-.11.04l-.14.05a2.91 2.91 0 0 0-.43.22l-13.35 7.71c-.204.121-.398.258-.58.41l-.18.16-.27.24-.12.13-.1.11-.12.12a3.75 3.75 0 0 0-.25.31l-.08.11c-.01.02-.03.04-.04.06l-.08.11-.18.27-.16.26c0 .01-.01.02-.01.02 0 .01-.01.01-.01.02l-.12.22c-.05.09-.09.18-.13.27l-.11.24c-.01.02-.01.02-.02.03l-.11.28-.11.29c-.02.05-.03.1-.04.14-.04.02-.05.04-.05.07l-.03.11-.09.36c-.02.07-.02.14-.04.21-.01.04-.01.08-.02.11s-.01.07-.02.1a4.26 4.26 0 0 0-.04.61l.04 15.34c0 .98.35 1.66.9 1.99l3.51 2.04c-.56-.32-.9-1.01-.9-1.99l-.04-15.34c0-.23.02-.47.06-.71.01-.04.01-.08.02-.11.04-.22.09-.45.16-.68.01-.02.01-.04.02-.07l.27-.73c0-.01 0-.01.01-.02.11-.25.23-.49.37-.73 0-.01.01-.01.01-.02.13-.23.28-.45.44-.67.01-.02.03-.04.04-.06.14-.19.3-.37.45-.55.03-.04.07-.07.1-.11l.39-.37.18-.16a5.55 5.55 0 0 1 .58-.41l13.35-7.71c.2-.11.39-.2.57-.26.04-.01.07-.03.11-.04l.52-.09z\" fill=\"url(#B)\"/><path d=\"M18.16 55.48l.27-1.15.03-.11c.13-.422.283-.836.46-1.24 0-.01.01-.02.01-.02.18-.42.39-.83.62-1.23.01-.01.01-.02.02-.03l.74-1.13.07-.1c.24-.33.5-.63.77-.93.06-.06.12-.12.17-.19.211-.22.435-.427.67-.62l.3-.27c.32-.26.65-.49.99-.69.33-.19.66-.33.97-.45l.18-.06c.3-.09.59-.16.86-.19.03 0 .05-.01.08-.01.3-.02.58-.01.85.04.01 0 .03.01.04.01.27.06.53.15.76.29l-2.34-1.36c-.01-.01-.02-.01-.03-.02l-.26-.13c-.09-.04-.18-.07-.28-.1-.06-.02-.12-.03-.19-.04-.01 0-.03-.01-.04-.01-.02 0-.04-.01-.06-.01-.1-.02-.21-.03-.32-.04s-.23-.01-.35 0c-.04 0-.08.01-.12.01-.03 0-.05.01-.08.01l-.2.02c-.15.02-.31.06-.46.1-.07.02-.14.05-.2.07l-.18.06-.23.08a5.66 5.66 0 0 0-.74.37c-.34.2-.67.43-.99.69-.1.08-.2.18-.3.27l-.47.41-.2.21c-.06.06-.12.12-.17.19l-.2.21-.43.52c-.05.06-.09.13-.14.19l-.07.1c-.05.06-.09.12-.14.19l-.31.46-.27.45c-.01.01-.01.03-.02.04s-.01.02-.02.03l-.21.37-.23.45-.19.41c0 .01-.01.02-.01.02 0 .01-.01.02-.01.02l-.19.47-.18.5c-.03.08-.05.17-.08.25l-.03.11a1.21 1.21 0 0 0-.05.18c-.06.2-.11.4-.15.61-.03.12-.04.24-.06.37l-.03.19-.03.18c-.048.341-.071.685-.07 1.03 0 1.66.59 2.82 1.54 3.37l2.34 1.36c-.95-.55-1.53-1.72-1.54-3.37.004-.405.038-.81.1-1.21l.03-.2z\" fill=\"url(#C)\"/><path d=\"M23.29 47.77c2.91-1.68 5.27-.33 5.28 3.02.01 3.34-2.33 7.41-5.25 9.09-2.91 1.68-5.28.33-5.29-3-.01-3.35 2.35-7.43 5.26-9.11z\" fill=\"url(#D)\"/><path d=\"M38.88 58.2h.05a1.58 1.58 0 0 1 .49.03c.01 0 .02 0 .03.01a1.3 1.3 0 0 1 .44.17l-.01-.01-14.02-8.15c-.01 0-.01-.01-.02-.01-.05-.03-.1-.05-.16-.08l-.16-.06-.11-.03c-.01 0-.02 0-.02-.01-.01 0-.03-.01-.04-.01-.06-.01-.12-.02-.19-.02h-.2c-.02 0-.04 0-.07.01h-.05c-.04 0-.08.01-.12.01a1.31 1.31 0 0 0-.27.06c-.04.01-.08.03-.12.04s-.07.02-.11.04l-.14.05-.43.21c-.2.12-.39.25-.58.4l-.18.16c-.09.08-.19.15-.27.24l-.12.13c-.03.04-.07.07-.1.11l-.12.13-.25.3c-.03.04-.06.08-.08.12-.01.02-.03.04-.04.06l-.08.11-.18.27-.16.26c0 .01-.01.02-.01.03s-.01.02-.01.02l-.12.21-.13.26-.11.25-.11.3-.1.29c-.02.05-.03.1-.05.15-.01.02-.01.04-.02.06l-.03.1-.09.36c-.02.07-.02.14-.04.22-.01.04-.01.08-.02.11 0 .03-.01.07-.02.1a4.26 4.26 0 0 0-.04.61c-.001.228.019.456.06.68.12.62.42 1.07.84 1.31l14.03 8.16c-.56-.32-.9-1.01-.9-1.99 0-.23.02-.47.06-.71.01-.04.01-.07.02-.11.04-.22.09-.45.16-.67.01-.02.01-.04.02-.06l.27-.73a7.08 7.08 0 0 1 .36-.73c0-.01.01-.02.01-.02a7.5 7.5 0 0 1 .43-.66c.01-.02.03-.04.04-.06a5.85 5.85 0 0 1 .45-.54c.03-.04.07-.07.1-.11l.39-.36.18-.16c.19-.15.38-.29.58-.4.182-.103.373-.19.57-.26.04-.01.07-.03.11-.04a1.18 1.18 0 0 1 .51-.15z\" fill=\"url(#E)\"/><path d=\"M37.7 58.6c1.71-.98 3.09-.19 3.09 1.77.01 1.96-1.37 4.35-3.07 5.34-1.72.99-3.1.19-3.1-1.77-.01-1.95 1.37-4.34 3.08-5.34z\" fill=\"url(#F)\"/><path d=\"M38.76 68.87a6.42 6.42 0 1 0 0-12.84 6.42 6.42 0 1 0 0 12.84z\" fill=\"url(#G)\"/><path d=\"M53.59 49.24l-8.68 12.73c-.23.33-.53.62-.91.84-1.69.98-4.27.3-5.76-1.51-1.15-1.41-1.32-3.1-.54-4.24l8.68-12.73c-.78 1.14-.62 2.83.54 4.24 1.49 1.82 4.06 2.5 5.76 1.51.38-.22.68-.5.91-.84z\" fill=\"url(#H)\"/><path d=\"M43.94 13.16l-1.2.32c-.01 0-.02 0-.03.01-.02.01-.05.01-.07.02l-.48.13c-.02 0-.04.01-.05.01s-.03.01-.05.01l-.22.06-.19.05-.3.08h-.01c-.05.01-.11.03-.15.04l-.31.08c-.9.24-1.86.65-2.84 1.24-.42.25-.83.54-1.24.84l-.36.28-.87.73-.34.31-1.08 1.07-.04.04-1.04 1.23c-.04.04-.07.08-.11.13l-.18.25-.71.98-.28.41-.83 1.35c-.01.02-.02.04-.04.06l-.76 1.46-.2.44-.47 1.11-.18.45-.5 1.49c0 .01-.01.02-.01.04l-.37 1.52-.08.45-.16 1.11-.05.44-.06 1.47c.007.452.04.902.1 1.35a10.35 10.35 0 0 0 .24 1.21l.81 3.06c-.24-.9-.37-1.91-.39-3.02-.01-.57.02-1.15.07-1.73.01-.17.04-.35.06-.52l.19-1.31.1-.52.44-1.79c0-.01.01-.03.01-.04l.59-1.76.21-.53.56-1.31.24-.51.89-1.72c.01-.02.03-.04.04-.06l.98-1.6.32-.48.84-1.17.34-.45 1.23-1.45c.01-.02.03-.03.04-.04l1.27-1.27c.13-.13.27-.24.41-.36l1.03-.86.42-.33 1.46-.99c.58-.35 1.15-.64 1.71-.88.523-.274 1.077-.486 1.65-.63z\" fill=\"url(#I)\"/><path d=\"M79.08 64.24l-3.24.6c-.51.18-1.01.31-1.49.41l3.46-.66a10.51 10.51 0 0 0 1.27-.35z\" fill=\"url(#J)\"/><path d=\"M84.07 38.74c.02 0 .03-.01.05-.01.5-.1.98-.15 1.44-.15h.08c.45.01.88.06 1.29.16.01 0 .03.01.04.01.409.106.802.264 1.17.47.02.01.03.02.05.03.36.2.69.46.99.75.01.01.03.03.05.04.3.3.56.64.8 1.02l.05.08c.24.4.44.83.61 1.31l-.06-.16-.06-.17-.03-.09-.07-.21c-.02-.07-.05-.14-.07-.2l-.07-.22-.08-.22c-.01-.02-.01-.04-.02-.06-.01-.04-.03-.09-.05-.14l-.09-.27-.09-.25-.03-.09-.1-.3c-.01-.04-.03-.08-.04-.12l-.09-.27-.03-.09c-.02-.05-.03-.1-.05-.14l-.11-.33-.06-.17-.26-.64c0-.01-.01-.01-.01-.02-.01-.03-.03-.05-.04-.07l-.25-.48-.08-.13-.11-.18-.12-.2-.22-.29-.09-.12c-.01-.02-.02-.03-.04-.05l-.36-.41c-.02-.02-.05-.04-.07-.06l-.12-.11c-.07-.06-.13-.13-.2-.19l-.23-.18-.12-.09c-.02-.02-.04-.03-.06-.05l-.43-.28c-.02-.01-.05-.02-.07-.04l-.13-.07-.26-.14c-.08-.04-.16-.07-.24-.1l-.15-.06c-.03-.01-.06-.03-.09-.04l-.53-.17c-.01 0-.03-.01-.04-.01l-.12-.03-.4-.09c-.06-.01-.12-.01-.18-.02l-.23-.03c-.07-.01-.13-.02-.2-.02-.11-.01-.23-.01-.34-.01-.08 0-.15-.01-.23-.01h-.09c-.2 0-.4.02-.6.04-.04 0-.08 0-.12.01-.29.03-.56.07-.83.13-.01 0-.02.01-.03.01l-.29.07-.55.14c-.02.01-.05.02-.07.02l-.28.09-.47.16c-.06.02-.11.05-.17.07l-.24.1c-.09.04-.19.07-.28.12l-.51.24c-.02.01-.05.02-.07.03-.01 0-.02.01-.03.01l-.43.23-.44.25c-.03.02-.06.03-.09.05l-.25.15-.31.2-.31.21-.27.19c-.02.01-.04.03-.06.04l-.02.02c-.06.04-.12.08-.17.13l-.25.19-.25.19-.25.2-.24.19c-.01 0-.02.01-.02.01l-.25.21-.27.23-.35.31-.25.23-.03.03-.06.06-.97.99c-.02.02-.03.04-.05.05l-.02.02-.48.54-.4.47-.13.16c-.01.01-.02.02-.02.03-.02.03-.04.05-.06.08l-.21.27-.21.27-.18.24-.16.21c-.05.06-.09.13-.14.19 0 .01-.01.01-.01.02l-.15.22-.15.22-.15.22-.14.21c-.05.07-.1.14-.14.22s-.09.14-.14.22c0 .01-.01.01-.01.02l-.12.2-.15.24-.15.25-.15.25-.15.25c-.04.06-.07.13-.11.19 0 .01-.01.01-.01.02-.01.02-.02.03-.03.05l-.18.32-.17.32-.17.32-.19.38c0 .01-.01.02-.01.02 0 .01-.01.01-.01.02l-.18.38-.2.42-.23.53c-.01.03-.03.06-.04.09-.01.02-.02.05-.03.07l-.16.39-.25.64-.12.34c-.02.05-.03.1-.05.14l-.07.19-.25.75-.11.38-.06.19-.06.21-.21.81-.06.27-.05.24-.07.34-.15.88c0 .03-.01.06-.01.09-.01.06-.01.12-.02.18l-.08.64-.04.52-.02.28c0 .06-.01.11-.01.17L66.2 57v.13l.05.99.13.94.03.21c.01.03.01.06.01.09.1.53.23 1.03.39 1.5.01.03.03.06.04.09.04.11.09.2.13.3.16.39.33.75.53 1.09l.25.39a6.48 6.48 0 0 0 .65.8l.27.28a5.86 5.86 0 0 0 1.07.8c.05.03.11.05.17.08.34.18.7.32 1.08.43l.42.1c.336.072.677.119 1.02.14l.44.02c.49 0 1-.04 1.53-.14l3.46-.66c-.45.09-.88.11-1.29.11-.13 0-.25-.01-.37-.02-.3-.02-.58-.06-.86-.12l-.35-.08a4.33 4.33 0 0 1-.92-.37l-.14-.06c-.33-.19-.63-.42-.91-.68-.08-.07-.15-.16-.22-.24a5.28 5.28 0 0 1-.55-.68c-.07-.11-.15-.21-.21-.33-.17-.28-.32-.59-.45-.92l-.11-.26c-.16-.44-.29-.91-.38-1.43-.01-.06-.01-.12-.02-.18-.08-.51-.14-1.06-.15-1.64-.01-.37.01-.75.03-1.13a1.94 1.94 0 0 1 .02-.24l.1-.97c.01-.05.01-.11.02-.16l.2-1.11c.01-.07.03-.13.04-.2l.28-1.1.05-.17.36-1.12c.01-.04.03-.08.04-.12l.45-1.15.03-.06.55-1.21.64-1.21c0-.01.01-.01.01-.02l.7-1.16.77-1.14.82-1.08.02-.02.87-1 .91-.93.03-.03.95-.85 1-.78.02-.02 1.03-.67c.522-.313 1.067-.587 1.63-.82.03-.01.07-.03.1-.04.46-.17.97-.33 1.46-.43z\" fill=\"url(#K)\"/><path d=\"M72.71 56.59c-.1-5.22 3.55-11.68 8.13-14.42 4.59-2.74 8.38-.73 8.48 4.5s-3.55 11.68-8.13 14.42c-4.59 2.74-8.39.72-8.48-4.5z\" fill=\"url(#L)\"/><path d=\"M66.24 55.31l.1-.91.2-1.14.08-.46.12-.5.24-.95.13-.42.32-.98.15-.43.41-1.05.12-.29.59-1.29.15-.3.54-1.02c.06-.12.13-.23.2-.35l.75-1.24.83-1.21.31-.42.57-.75.46-.56.5-.58.79-.85.39-.4 1.61-1.43.35-.27 1.76-1.22 1.14-.61c.11-.06.22-.1.34-.16l.69-.29.8-.27.53-.16.48-.1.65-.11.36-.04c.246-.022.493-.028.74-.02h.23a6.5 6.5 0 0 1 .9.11l.19.04a5 5 0 0 1 .69.2l.21.07c.28.11.55.23.8.38L49.33 13.66c-.02-.01-.04-.02-.06-.04-.19-.11-.4-.21-.6-.29-.04-.02-.09-.03-.13-.05-.07-.03-.14-.05-.2-.07-.1-.03-.2-.08-.3-.1-.13-.04-.26-.06-.4-.09l-.19-.04c-.03-.01-.06-.02-.09-.02-.24-.04-.48-.07-.72-.08h-.09-.23c-.16 0-.31-.01-.48 0-.09 0-.17.02-.26.03l-.36.04c-.09.01-.18.01-.27.03l-.38.08-.48.1c-.07.02-.13.02-.2.04-.11.03-.22.08-.33.11l-.8.28c-.09.03-.17.05-.25.09l-.43.2-.34.16-1.14.61c-.6.36-1.19.78-1.76 1.22l-.35.27c-.55.44-1.09.92-1.61 1.43-.03.03-.06.05-.09.08l-.29.31-.8.85a3.87 3.87 0 0 1-.2.21l-.3.37-.46.56-.2.25-.37.5-.31.42a2.22 2.22 0 0 1-.12.16l-.7 1.04-.62 1.01-.13.23-.2.35-.24.43-.3.59-.15.3c-.02.05-.05.09-.07.14l-.48 1.04c-.02.04-.03.08-.05.12l-.12.3-.27.66-.14.38-.15.43-.12.32-.2.66-.13.43c-.01.05-.03.09-.04.14l-.2.8-.13.51c-.01.02-.01.05-.02.07-.03.13-.04.25-.06.38l-.2 1.15-.03.16-.07.75-.04.45-.03 1.36c.07 3.66 1.39 6.23 3.5 7.45l37.32 21.69c-2.1-1.22-3.43-3.79-3.5-7.45l.03-1.36c0-.19.02-.34.04-.5z\" fill=\"url(#M)\"/><path d=\"M86.899 41.5l1.06.62c1.46.85 2.37 2.63 2.42 5.16.1 5.22-3.55 11.68-8.13 14.42-2.36 1.41-4.51 1.56-6.06.66l-1.06-.62c1.54.9 3.7.75 6.06-.66 4.59-2.74 8.23-9.2 8.13-14.42-.05-2.53-.97-4.31-2.42-5.16z\" fill=\"url(#N)\"/><path d=\"M33.48 30.6c-.45 1.58.81 2.94 1.82 2.42 1.13-.58 1.21-3-.22-3.41-.65-.2-1.34.23-1.6.99zm2.34-5.16c-.74 1.42.26 2.74 1.43 2.41 1.3-.37 2.01-2.45.77-3.17-.71-.42-1.72-.07-2.2.76zm3.32-4.62c-.96 1.19-.18 2.38 1.06 2.26 1.44-.14 2.64-1.84 1.52-2.68-.7-.51-1.93-.31-2.58.42z\" fill=\"#fff\"/><path d=\"M78.5 53.78l.2-.89.03-.08.35-.96c.14-.33.3-.65.48-.96.01-.01.01-.02.02-.03.17-.3.36-.59.57-.87.02-.03.04-.05.06-.08l.59-.72c.041-.049.084-.096.13-.14.16-.17.34-.33.51-.48l.23-.21a6.12 6.12 0 0 1 .76-.53c.26-.15.51-.26.75-.35.05-.02.1-.03.14-.05.219-.068.443-.118.67-.15.02 0 .04 0 .06-.01.217-.021.436-.011.65.03.01 0 .02.01.03.01.21.05.41.12.59.22l-1.17-.68c-.01 0-.01-.01-.02-.01-.07-.04-.13-.07-.2-.1l-.21-.08-.15-.03c-.01 0-.02-.01-.03-.01-.02 0-.03-.01-.05-.01l-.25-.03a1.22 1.22 0 0 0-.27 0c-.03 0-.06.01-.09.01-.02 0-.04 0-.06.01-.05.01-.1.01-.15.02-.12.02-.24.04-.36.08-.05.01-.1.04-.15.05-.05.02-.1.03-.14.05l-.18.06c-.19.08-.38.17-.57.28-.26.15-.52.33-.76.53-.08.06-.16.14-.23.21l-.36.31-.16.17c-.04.05-.09.09-.13.14-.05.06-.1.11-.15.16l-.33.4-.11.15c-.02.03-.04.05-.06.08-.03.05-.07.09-.1.14l-.23.35-.21.34c-.01.01-.01.03-.02.04s-.01.02-.02.03l-.15.27-.18.35-.15.33c-.01.01-.01.02-.01.02l-.15.37-.14.38-.06.2-.03.08c-.01.04-.03.09-.04.13l-.11.47-.05.29-.03.15c-.01.04-.02.09-.02.13-.04.27-.05.54-.05.8 0 1.29.46 2.19 1.19 2.62l1.17.68c-.73-.42-1.18-1.33-1.19-2.62 0-.3.03-.62.07-.93.01-.03.02-.08.03-.13z\" fill=\"url(#O)\"/><path d=\"M82.44 47.84c2.25-1.3 4.07-.25 4.08 2.33s-1.81 5.73-4.06 7.02c-2.25 1.3-4.06.25-4.07-2.33 0-2.58 1.8-5.72 4.05-7.02z\" fill=\"url(#P)\"/><path d=\"M71.92 58.32c-.12-6.39 4.34-14.29 9.95-17.64s10.25-.89 10.37 5.5-4.34 14.29-9.95 17.64-10.26.89-10.37-5.5zm1.85-1.11c.1 5.22 3.89 7.24 8.48 4.5s8.23-9.2 8.13-14.42-3.89-7.24-8.48-4.5c-4.58 2.74-8.22 9.19-8.13 14.42z\" fill=\"url(#Q)\"/><path d=\"M88.23 39.26c-.02-.01-.04-.02-.05-.03-.16-.09-.34-.18-.51-.25-.04-.02-.08-.03-.11-.04l-.17-.06-.25-.09-.34-.08-.16-.04c-.03 0-.05-.01-.07-.02l-.61-.07h-.07-.19c-.13 0-.27-.01-.41 0-.07 0-.15.02-.22.02l-.3.03-.23.02-.32.07-.41.09c-.06.01-.11.02-.17.04-.09.02-.18.07-.28.09l-.68.23c-.07.03-.14.04-.21.07-.06.02-.12.06-.18.09l-1.45.73c-.51.3-1 .66-1.49 1.03l-.3.23-1.37 1.21a.5.5 0 0 1-.08.07l-.24.26-.68.72-.17.18-.26.31-.39.48-.17.21-.31.42-.27.36c-.03.05-.07.09-.1.14l-.59.88-.52.86-.11.2-.17.3-.2.36-.25.5-.13.25-.06.12-.4.88c-.01.03-.03.07-.04.1-.04.08-.07.17-.1.25l-.23.56-.11.32-.13.37-.1.27-.17.55-.11.36c-.01.04-.03.08-.04.12l-.17.68-.1.43c0 .02-.01.04-.01.06l-.06.32-.17.97c-.01.04-.02.09-.02.13-.01.06 0 .11-.01.17-.08.68-.13 1.35-.12 2 .06 3.1 1.18 5.28 2.96 6.31l1.04.61c-1.78-1.04-2.9-3.21-2.96-6.31-.01-.65.04-1.32.11-2l.03-.31.17-.97.07-.39.1-.43.2-.8.11-.36.27-.83.13-.36.35-.89.1-.25.5-1.1.12-.24.46-.87c.05-.1.11-.2.17-.3l.64-1.06.69-1.02.26-.35.49-.64.39-.47.43-.49.68-.72.33-.33c.44-.43.9-.83 1.37-1.21l.3-.23 1.49-1.03c.49-.29.97-.53 1.45-.73l.39-.16.68-.23.45-.13.41-.09.55-.09.3-.03c.21-.02.42-.02.63-.02h.19c.26.01.52.04.76.09l.16.04c.2.04.4.1.59.17l.17.06c.233.092.46.199.68.32l-1.07-.59z\" fill=\"url(#R)\"/></g></g><defs><linearGradient id=\"A\" x1=\"-4.564\" y1=\"53.181\" x2=\"37.762\" y2=\"53.181\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"2.382\" y1=\"52.057\" x2=\"36.282\" y2=\"52.057\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"-11.474\" y1=\"52.968\" x2=\"35.995\" y2=\"52.968\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"-17.298\" y1=\"53.826\" x2=\"31.711\" y2=\"53.826\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"5.2\" y1=\"57.98\" x2=\"53.053\" y2=\"57.98\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"34.619\" y1=\"62.162\" x2=\"40.796\" y2=\"62.162\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\".837\" y1=\"62.447\" x2=\"49.247\" y2=\"62.447\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"29.369\" y1=\"53.793\" x2=\"58.215\" y2=\"53.793\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"20.809\" y1=\"25.813\" x2=\"53.874\" y2=\"25.813\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"74.356\" y1=\"64.739\" x2=\"79.085\" y2=\"64.739\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"19.654\" y1=\"49.957\" x2=\"99.274\" y2=\"49.957\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"47.262\" y1=\"51.628\" x2=\"100.961\" y2=\"51.628\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"15.419\" y1=\"38.719\" x2=\"113.725\" y2=\"38.719\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"60.064\" y1=\"52.217\" x2=\"101.128\" y2=\"52.217\" xlink:href=\"#U\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"O\" x1=\"71.269\" y1=\"52.036\" x2=\"99.265\" y2=\"52.036\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"67.825\" y1=\"52.513\" x2=\"96.599\" y2=\"52.513\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"64.281\" y1=\"52.246\" x2=\"120.321\" y2=\"52.246\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"R\" x1=\"56.557\" y1=\"51.602\" x2=\"100.995\" y2=\"51.602\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"S\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"T\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"U\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeEmergenciesRepairs = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#W)\"><g clip-path=\"url(#X)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M33.82 20.98a.58.58 0 0 1-.28-.07l-12.08-7.02c-.26-.15-.35-.49-.2-.75s.49-.35.75-.2l12.08 7.02c.26.15.35.49.2.75-.1.17-.28.27-.47.27z\" fill=\"#8334c2\"/><path d=\"M31.49 21.65c.03 1.46 1.09 2.03 2.37 1.26s2.3-2.58 2.28-4.04-1.09-2.03-2.37-1.26c-1.29.76-2.31 2.57-2.28 4.04z\" fill=\"url(#A)\"/><path d=\"M40.74 20.4c0-.01-.01-.01-.01-.02l-.03-.07-.03-.06c-.01-.03-.03-.07-.05-.1-.01-.01-.02-.03-.02-.05-.01-.03-.03-.07-.05-.1-.01-.03-.03-.07-.05-.1-.01-.01-.02-.03-.02-.05-.01-.03-.03-.07-.05-.1-.01-.02-.02-.05-.03-.07l-.02-.04c-.01-.01-.01-.02-.01-.03-.01-.01-.01-.03-.02-.04l-.03-.06c-.05-.11-.12-.21-.19-.31-.02-.03-.05-.05-.07-.08a2.65 2.65 0 0 0-.16-.17.55.55 0 0 0-.09-.07l-.19-.12c-.03-.02-.06-.03-.09-.05-.01-.01-.03-.02-.04-.02l-.11-.03c.01 0 .03 0 .04.01l-.31-.1-.31-.1-.31-.1-.32-.1-.21-.07c-.02-.01-.05-.01-.07-.02l-.56-.18-.31-.1-.31-.1-.31-.1-.52-.17-.48-.16-.15-.05c-.05-.02-.11-.03-.17-.04-.05-.01-.09-.01-.14-.02h-.13c-.04 0-.08 0-.11.01-.04 0-.07.01-.11.01h-.02c-.03 0-.06.01-.08.01l-.1.03-.1.03c-.03.01-.07.02-.1.04a.3.3 0 0 0-.1.04c-.03.01-.07.03-.1.05s-.07.03-.1.05l-.1.06c-.01 0-.01.01-.02.01-.03.02-.06.03-.08.05l-.1.07-.11.08-.11.09c-.02.01-.03.03-.05.04-.01 0-.01.01-.02.01-.02.01-.03.03-.05.04-.04.04-.08.07-.13.11s-.09.09-.14.13c-.03.04-.07.07-.1.11l-.02.02-.03.03-.19.22-.09.12-.14.2-.19.3-.12.21-.06.1c-.04.08-.09.17-.12.26-.01.03-.03.07-.04.1 0 .01-.01.02-.01.03-.01.02-.02.05-.03.07l-.07.18-.06.16c-.02.05-.03.1-.05.15-.01.05-.03.09-.04.14l-.03.14-.03.13c-.01.04-.02.08-.02.13 0 .01 0 .03-.01.04 0 .03-.01.06-.01.08-.01.04-.01.08-.01.12s-.01.08-.01.12v.12.12.12c0 .04.01.08.01.12s.01.08.01.12c0 .02.01.04.01.06 0 .03 0 .05.01.06l.03.12c.01.05.03.09.04.13.01.01.01.03.02.04 0 .01.01.02.01.03.01.02.02.05.03.07.03.06.05.11.09.16 0 .01.01.01.02.02.06.1.13.19.21.26l3.24 2.95c-.03-.02-.05-.06-.07-.09.02.02.03.04.04.05.04.03.07.07.11.1.06.05.13.09.2.13.04.02.08.05.13.07l.25.08.12.03c.132.022.266.029.4.02l1.08-.08c-.12.01-.23 0-.34-.01-.04-.01-.07-.02-.1-.02l-.21-.06-.11-.06c-.06-.03-.11-.07-.16-.11-.03-.03-.06-.05-.09-.08a1.73 1.73 0 0 1-.13-.15l-.09-.13c-.01-.02-.02-.04-.04-.06l-.12-.26c0-.01-.01-.02-.01-.03-.03-.1-.06-.21-.08-.33-.02-.15-.03-.28-.03-.42 0-.2.01-.4.04-.6.03-.21.08-.42.14-.63s.132-.419.22-.62l.3-.6a4.74 4.74 0 0 1 .36-.58c.13-.18.27-.35.42-.52.15-.16.3-.31.47-.45a3.31 3.31 0 0 1 .5-.36c.121-.073.248-.137.38-.19s.26-.09.37-.12c.12-.03.24-.04.34-.05h.02c.1 0 .2 0 .29.02h.03l.24.07c.13.05.25.13.35.23.02.02.04.04.06.07a1.53 1.53 0 0 1 .27.38c-.01-.05-.02-.09-.04-.12zM39 18.61h-.02.02zm-.45.03h-.02.02zm-3.9 6.11v.03-.03z\" fill=\"url(#B)\"/><path d=\"M35.74 24.51c0-.04 0-.09.01-.13 0-.04.01-.09.01-.13s.01-.09.01-.13c.01-.05.01-.09.02-.14.01-.04.01-.09.02-.13l.03-.15c.01-.05.02-.1.04-.15l.04-.16c.01-.02.01-.05.02-.07 0-.01 0-.01.01-.02.01-.02.01-.05.02-.07l.06-.18.08-.21c.02-.06.05-.12.08-.18 0-.01.01-.02.01-.03.01-.01.01-.02.01-.04l.15-.31.09-.15c.05-.1.11-.19.16-.28l.21-.32.19-.26.1-.14a2.88 2.88 0 0 1 .23-.26l.03-.03c.01-.01.02-.02.02-.03l.12-.12.15-.15a1.64 1.64 0 0 0 .14-.13c.03-.02.05-.04.08-.06.02-.02.03-.03.05-.04a1.06 1.06 0 0 0 .12-.1l.12-.09c.04-.03.08-.05.12-.08.04-.02.08-.05.12-.07.01-.01.02-.01.03-.02.03-.02.06-.03.09-.05l.11-.06c.04-.02.07-.04.11-.05l.11-.05c.04-.01.07-.03.11-.04.01 0 .01 0 .02-.01.04-.01.06-.02.09-.03l.11-.03c.04-.01.07-.02.11-.02.04-.01.08-.01.12-.02.03 0 .05-.01.08-.01h.04.13c.047-.002.094.002.14.01.05 0 .11.01.16.02a1.21 1.21 0 0 1 .18.05c.08.03.15.06.22.1l1.21.7c-.12-.07-.26-.12-.4-.15a1.4 1.4 0 0 0-.46-.02c-.17.01-.34.05-.51.11-.19.06-.37.14-.56.25s-.37.232-.54.37c-.18.15-.34.3-.5.47-.01.01-.02.02-.02.03-.13.13-.24.28-.36.43-.07.08-.13.17-.19.26-.07.11-.15.21-.21.33-.06.09-.11.19-.16.28l-.25.5c0 .01-.01.02-.01.03-.09.21-.17.43-.24.65 0 .01 0 .01-.01.02-.07.22-.12.45-.15.67a3.75 3.75 0 0 0-.05.66c0 .21.02.41.06.59.032.171.083.339.15.5a2.06 2.06 0 0 0 .2.33c.03.03.05.06.08.09.09.1.19.18.3.25l-1.21-.7c-.11-.06-.21-.15-.3-.25-.03-.03-.05-.06-.08-.09-.03-.04-.07-.08-.1-.12a1.14 1.14 0 0 1-.1-.19v-.02l-.06-.14-.05-.14-.04-.14c0-.02-.01-.04-.01-.06 0-.04-.01-.06-.01-.08-.01-.04-.01-.09-.02-.13s-.01-.09-.01-.13-.01-.08-.01-.13v-.13c-.01-.06-.01-.11-.01-.15z\" fill=\"url(#C)\"/><path d=\"M54.38 24.85c-.01-.01-.01-.02-.02-.04l-.07-.14c-.021-.038-.038-.078-.05-.12l-.09-.2c-.01-.03-.03-.07-.05-.1l-.09-.2-.09-.2c-.01-.03-.03-.07-.05-.1l-.09-.2-.07-.15-.04-.08-.03-.06c-.01-.03-.03-.06-.04-.09l-.05-.11c-.11-.23-.23-.43-.37-.61a1.08 1.08 0 0 0-.14-.16 2.58 2.58 0 0 0-.33-.33l-.18-.14c-.118-.09-.246-.167-.38-.23l-.19-.1c-.03-.01-.05-.03-.08-.04-.07-.03-.15-.04-.22-.07.02.01.05.01.08.01l-.63-.2-.64-.19-.62-.2-.63-.21-.41-.13-.14-.04-1.11-.36-.63-.2-.63-.21-.62-.2-1.04-.34-.96-.31-.3-.1-.34-.08c-.09-.02-.18-.03-.28-.03h-.02-.02c-.07 0-.14-.01-.21 0l-.23.01-.21.03c-.01 0-.03.01-.04.01h-.02l-.14.03-.2.05-.2.06c-.07.02-.13.05-.2.07-.01 0-.01 0-.02.01-.07.02-.12.05-.18.07l-.2.09c-.07.03-.13.07-.2.1l-.2.11c-.01.01-.03.02-.04.03-.06.03-.11.07-.17.1-.07.04-.14.09-.21.14l-.22.16c-.07.06-.15.11-.22.17a.9.9 0 0 0-.1.09l-.03.03c-.03.03-.07.05-.1.08-.09.07-.17.15-.25.23l-.27.26-.21.22c-.01.02-.03.03-.04.05l-.06.06-.38.45-.18.25-.29.4-.38.6-.25.42-.12.2-.25.52a1.18 1.18 0 0 0-.08.2c-.01.02-.02.05-.03.07l-.06.14-.14.35-.11.33-.09.31-.08.28-.07.27-.05.26c-.02.08-.03.17-.04.25 0 .03-.01.05-.01.08l-.02.17-.03.24-.02.24-.01.24v.23l.01.24c.001.077.008.154.02.23l.03.24c.01.04.01.08.02.12 0 .01 0 .02.01.04 0 .03.01.06.01.08l.06.24c.02.09.05.18.08.26l.03.08c.01.02.02.04.02.06l.06.14c.05.12.11.22.17.33.01.02.02.02.03.04.13.2.27.38.43.53l6.5 5.9c-.05-.05-.09-.12-.14-.17.03.03.06.07.09.1l.22.2a1.99 1.99 0 0 0 .39.25c.08.05.16.09.25.13.16.07.32.11.49.15.08.02.16.05.24.06.268.04.54.05.81.03l2.17-.17a2.53 2.53 0 0 1-.68-.03c-.07-.01-.13-.03-.2-.05-.14-.03-.28-.07-.41-.13-.07-.03-.14-.07-.21-.11-.11-.06-.22-.13-.33-.21-.07-.05-.13-.11-.19-.17-.1-.09-.18-.19-.27-.3-.06-.08-.13-.16-.18-.25-.029-.04-.053-.084-.07-.13a2.72 2.72 0 0 1-.23-.52c-.01-.02-.01-.04-.02-.06a4.24 4.24 0 0 1-.16-.66c0-.01 0-.02-.01-.04-.04-.25-.06-.52-.07-.8-.01-.39.02-.8.08-1.21.06-.42.15-.84.27-1.25.12-.43.27-.84.44-1.26.17-.41.37-.81.59-1.21l.73-1.14a10.97 10.97 0 0 1 .85-1.04c.3-.32.61-.62.93-.89a8.49 8.49 0 0 1 1.01-.72c.26-.16.52-.28.77-.39.01 0 .01-.01.02-.01.25-.1.49-.18.73-.24a4.24 4.24 0 0 1 .68-.09h.05c.2-.01.4.01.58.04.02 0 .04.01.06.01.17.03.33.09.48.15.26.11.5.26.71.45l.13.13c.21.21.39.46.53.76-.03-.1-.06-.18-.09-.24zm-3.48-3.59h.02-.06.02.02zm-.92.06c-.01 0-.02 0-.03.01.01-.01.02-.01.03-.01zm-1 .29s-.01.01-.02.01c.01-.01.02-.01.02-.01zm-6.81 11.94c0 .01.01.03.01.05 0-.02 0-.04-.01-.05z\" fill=\"url(#D)\"/><path d=\"M44.36 33.08l.01-.26.02-.27.03-.27.04-.28c.01-.1.03-.19.05-.28l.06-.3.07-.3.09-.32c.01-.05.03-.1.04-.15 0-.01.01-.03.01-.04.02-.05.03-.1.05-.15l.12-.36.16-.42.15-.36.03-.06c.01-.02.02-.05.03-.07l.3-.63c.05-.1.12-.2.18-.31l.33-.57.42-.65.38-.52.2-.27.45-.52c.02-.02.04-.05.07-.07l.05-.05.23-.24.31-.29c.09-.09.19-.17.28-.25l.15-.13c.01-.01.02-.02.03-.02.03-.02.05-.04.07-.06.08-.07.17-.13.25-.19l.24-.17.23-.15.23-.14c.02-.01.04-.02.05-.03.06-.03.12-.07.17-.1l.22-.12c.07-.04.15-.07.22-.1l.22-.09c.07-.03.15-.06.22-.08.01 0 .03-.01.04-.01s.01 0 .02-.01c.05-.02.11-.04.16-.05l.23-.06.22-.05c.08-.02.16-.03.24-.04.05-.01.1-.01.16-.02h.02c.02 0 .04 0 .06-.01.09-.01.17-.01.26-.01l.28.01c.11.01.21.03.31.05l.38.1a2.48 2.48 0 0 1 .44.2l2.42 1.41c-.25-.14-.52-.24-.8-.3-.3-.06-.6-.07-.93-.05h-.03c-.32.03-.66.1-1.01.22-.01 0-.01 0-.02.01a5.97 5.97 0 0 0-1.1.51c-.37.21-.73.47-1.08.75-.01.01-.02.02-.03.02-.34.28-.66.58-.98.91l-.05.05c-.25.27-.49.56-.72.86l-.38.52-.43.65-.33.56-.51 1.01c-.01.02-.02.04-.02.06-.19.43-.35.86-.48 1.3 0 .01-.01.03-.01.04-.13.45-.24.89-.31 1.34s-.11.89-.11 1.33c-.001.393.036.784.11 1.17 0 .01 0 .02.01.03.067.331.171.653.31.96.12.25.27.45.42.64l.15.19a2.8 2.8 0 0 0 .6.49l-2.42-1.41a2.8 2.8 0 0 1-.6-.49l-.15-.19c-.07-.08-.14-.15-.2-.24l-.21-.37c-.02-.01-.01-.02-.02-.02l-.12-.28-.1-.29c-.029-.092-.052-.185-.07-.28-.01-.04-.02-.08-.02-.12 0-.01 0-.02-.01-.03-.01-.04-.02-.08-.02-.12l-.04-.26-.03-.26-.02-.26-.01-.26v-.02c.07-.08.07-.16.07-.24z\" fill=\"url(#E)\"/><path d=\"M65.15 56.12c-.8-.46-2.11-.46-2.91 0l-9.55 5.55c-.8.46-.79 1.22.01 1.68l16.6 9.58c.8.46 2.11.46 2.91 0l9.55-5.55c.79-.46.79-1.22-.01-1.68l-16.6-9.58z\" fill=\"url(#F)\"/><path d=\"M65.14 53.33c-.8-.46-2.11-.46-2.91 0l-9.55 5.55c-.79.46-.79 1.22.01 1.68l16.6 9.58c.8.46 2.11.46 2.91 0l9.55-5.55c.79-.46.79-1.22-.01-1.68l-16.6-9.58z\" fill=\"url(#G)\"/><path d=\"M82.35 66.55l-.01-2.8c0 .3-.2.61-.59.84l-9.55 5.55a2.26 2.26 0 0 1-.66.25c-.01 0-.02 0-.03.01-.24.05-.49.08-.75.08s-.51-.03-.74-.08c-.03-.01-.06-.01-.09-.02a3.03 3.03 0 0 1-.64-.24l-16.6-9.58a1.35 1.35 0 0 1-.45-.39.75.75 0 0 1-.16-.45l-.01 2.8c-.002.043.001.087.01.13l-.02 8.26c-.002.044.001.087.01.13l.03.12a.61.61 0 0 0 .05.12c.01.03.03.05.05.08.02.02.02.03.03.04.03.05.08.09.12.13.07.07.15.13.24.18.02.01.04.03.07.04l16.6 9.58c.14.08.3.15.47.2.05.02.11.03.17.04.03.01.06.02.09.02l.11.03c.08.02.17.03.26.04l.23.02h.12.03.06c.07 0 .14 0 .2-.01l.2-.02.2-.03c.03-.01.05-.01.08-.02.01 0 .02 0 .03-.01l.11-.03c.09-.02.17-.05.25-.08.11-.04.21-.09.31-.15l9.55-5.55c.39-.23.59-.53.59-.84l.03-8.39z\" fill=\"url(#H)\"/><path d=\"M77.65 62.13l-.05-16.8-9.39 5.42L51.83 39.9c-.26 1.14 6.01 20.43 6.01 20.43.02.08.04.16.07.24.01.02.01.05.02.07s.01.04.02.06c.05.13.11.25.18.38.03.06.08.12.12.18.02.04.05.07.07.11.03.04.04.07.07.11.12.15.26.3.41.44.01.01.03.02.04.03.13.12.3.23.46.34.11.08.2.17.33.25.03.02.05.03.08.05l8.55 4.97 9.39-5.43z\" fill=\"url(#I)\"/><path d=\"M72.79 53.85c1.18.54 2.75.37 4.45-.65 3.57-2.13 6.4-7.16 6.33-11.22-.03-1.83-.65-3.15-1.64-3.86L61.38 23.43c.03.02.05.06.08.08-.65-.49-1.42-.78-2.29-.82l-3.12-.15c.04 0 .08.01.12.02-1.07-.08-2.31.23-3.63 1.02-3.91 2.34-7.02 7.85-6.94 12.3.02 1.35.34 2.44.87 3.25-.01-.02-.03-.03-.04-.05l1.68 2.64c.02.04.05.06.08.1a3.92 3.92 0 0 0 .44.55c.03.04.06.08.1.11.19.19.41.36.63.51a1.59 1.59 0 0 0 .18.1c.1.06.2.13.31.18l5.73 2.65a6.52 6.52 0 0 0 .26.12l1.67.77c.13.06.25.12.37.17l.57.26 1.85.85 1.02.47 2.22 1.03c.02.01.05.02.07.03.03.01.06.03.09.04l3.35 1.55.36.17c.27.13.54.25.78.36l1.15.53 1.15.53 1.15.53 1.15.52z\" fill=\"url(#J)\"/><path d=\"M82.3 40.59c.01.01.03.01.04.02l-.56-.32c-.94-.55-2.26-.46-3.7.41-2.8 1.67-5.03 5.62-4.97 8.81.03 1.55.59 2.64 1.48 3.15l.31.18c.15.08.29.17.45.23.26.1.53.18.8.22.28.03.56.03.84-.01.31-.04.62-.13.92-.24.33-.12.64-.28.94-.46 2.8-1.67 5.03-5.62 4.97-8.81-.02-1.58-.6-2.67-1.52-3.18z\" fill=\"url(#K)\"/><path d=\"M66.6 43.18l1.8.98c.67.41.63 1.31.08 1.42-.21.05-.39-.04-.48-.08l-1.81-.95c-.71-.41-.66-1.31-.08-1.45.16-.03.33 0 .49.08zm1.25-2.69l1.78 1.03c.68.44.44 1.23-.09 1.37-.27.07-.49-.04-.58-.08l-1.79-1.01c-.66-.42-.51-1.25.1-1.4.19-.04.39-.01.58.09zm1.72-2.43l1.74 1.08c.66.45.3 1.16-.28 1.25-.3.05-.51-.07-.6-.12l-1.76-1.06c-.62-.41-.39-1.13.22-1.26.13-.03.4-.05.68.11zm2.08-1.96l1.7 1.12c.59.42.25.93-.27 1.02a1.06 1.06 0 0 1-.77-.15L70.59 37c-.57-.4-.32-.97.28-1.06a1.14 1.14 0 0 1 .78.16z\" fill=\"#fff\"/><path d=\"M58.72 51.34h-.03c-.1-.01-.2 0-.29.01-.1.02-.19.05-.27.1h.01l.99-.58c.04-.03.07-.04.1-.05l.09-.03c.02-.01.04-.01.06-.01h.03c.03-.01.07-.01.11-.01h.12.04.03c.02 0 .04 0 .07.01l.16.03c.02.01.05.02.07.02.02.01.04.01.06.02l.08.03c.08.03.17.08.25.12a2.85 2.85 0 0 1 .59.46c.03.03.05.06.08.09l.03.03c.03.03.06.06.08.09l.14.18.12.16c.04.05.07.1.1.15l.09.15c.04.05.06.1.08.14.03.05.05.1.08.15.02.05.05.1.07.15s.04.11.07.16l.06.17.03.09c0 .01 0 .01.01.02.01.02.02.05.02.07l.05.2c.02.08.03.16.04.25.02.12.02.23.02.35 0 .56-.2.95-.52 1.13l-1 .58c.32-.19.52-.58.52-1.13 0-.28-.05-.57-.14-.87 0-.01 0-.01-.01-.02-.09-.29-.22-.58-.37-.86-.16-.27-.34-.52-.55-.74l-.03-.03c-.21-.22-.43-.41-.67-.54a2.42 2.42 0 0 0-.33-.15c-.02-.01-.04-.02-.06-.02a.96.96 0 0 0-.28-.07z\" fill=\"url(#L)\"/><path d=\"M59.4 51.58c-.98-.57-1.78-.11-1.78 1.01s.79 2.5 1.77 3.06c.97.56 1.78.1 1.78-1.01 0-1.13-.8-2.5-1.77-3.06z\" fill=\"#fff\"/><path d=\"M28.75 57.61c-.01-1.36.65-1.81 1.48-1s1.51 2.55 1.52 3.91-.65 1.81-1.48 1-1.51-2.56-1.52-3.91zm1.07 1.03c0 .39.2.89.44 1.12s.43.1.43-.29-.2-.89-.44-1.12-.43-.1-.43.29z\" fill=\"url(#M)\"/><path d=\"M33.1 59.05v-.02-.09l-.01-.13c0-.04-.01-.08-.01-.12l-.02-.11v-.01c-.01-.03-.01-.07-.02-.09l-.02-.1-.03-.1-.03-.09-.02-.07v-.01l-.01-.04-.01-.04-.01-.02c-.01-.03-.03-.06-.04-.09l-.04-.09c-.01-.03-.03-.07-.05-.09l-.05-.09-.06-.1-.06-.1c-.02-.04-.06-.08-.08-.12l-.08-.11-.04-.04-.03-.03c-.02-.02-.04-.05-.06-.07l-.11-.12-.19-.17-.15-.12c-.03-.03-.06-.04-.08-.05-.04-.02-.07-.05-.11-.07-.02-.02-.04-.03-.05-.04l.08.05-.12-.07-.04-.02-.02-.01c-.03-.01-.06-.03-.08-.04l-.05-.02-.24-.1-.1-.04-.17-.06c-.02-.01-.04-.01-.07-.02-.01 0-.01 0-.02-.01-.01 0-.02-.01-.03-.01l-.17-.04-.17-.03-.13-.02c-.05-.01-.1-.01-.13-.01l-.1-.01H30h-.04-.07c-.04 0-.07.01-.11.02l-.49.16c.06-.02.13-.03.2-.03a.63.63 0 0 1 .22.05c.09.03.17.07.25.13l.26.21.3.34.27.4c.01.01.01.02.02.03a3.9 3.9 0 0 1 .19.35c.142.27.263.551.36.84l.11.32.14.56.09.55.03.53c0 .19-.01.37-.04.52-.016.138-.053.273-.11.4 0 .01-.01.02-.01.03-.03.08-.08.14-.12.2-.02.03-.04.06-.06.08-.07.07-.14.12-.22.15l.48-.16c.064-.023.122-.061.17-.11-.01 0-.01.02-.01.02l.03-.03.05-.04c.024-.026.051-.049.08-.07l.09-.08c.03-.03.07-.08.11-.11l.1-.12.13-.16.11-.15.08-.12.04-.06c.01-.02.02-.02.02-.03l.02-.04.02-.04c0 .01-.01.02-.02.03l.07-.13.06-.13c.01-.02.02-.05.03-.07.01-.03.03-.06.04-.09l.07-.19c.01-.04.02-.09.04-.13 0-.02.01-.03.01-.05 0-.01 0-.01.01-.02l.03-.17c0 .01-.01.02-.01.03.02-.1.03-.19.04-.29 0-.03.01-.06.01-.1v-.17c.03-.03.03-.05.03-.06z\" fill=\"url(#N)\"/><path d=\"M30.31 56.07c.02 0 .05.01.08.01-.03 0-.06 0-.08-.01z\" fill=\"url(#O)\"/><path d=\"M30.68 59.48v-.02-.03-.03-.03-.03-.03-.03c0-.01 0-.02-.01-.03 0-.01 0-.02-.01-.04 0-.01 0-.02-.01-.03 0-.02-.01-.04-.01-.05 0-.02-.01-.03-.01-.05-.01-.02-.01-.04-.02-.06-.01-.03-.02-.05-.02-.08 0-.01-.01-.03-.02-.04-.02-.04-.03-.08-.05-.13-.02-.04-.03-.08-.05-.11-.01-.02-.02-.04-.04-.06 0-.01-.01-.01-.01-.02s-.01-.01-.01-.02c-.01-.01-.02-.03-.02-.04-.01-.01-.01-.02-.02-.03s-.01-.02-.02-.03-.01-.02-.02-.03l-.02-.02-.02-.02-.02-.02-.02-.02-.02-.02c-.01-.01-.01-.01-.02-.01s-.01-.01-.02-.01-.01-.01-.02-.01-.01-.01-.02-.01-.01-.01-.02-.01-.01-.01-.02-.01c-.02-.01-.02-.01-.03-.02h-.04c-.03 0-.04 0-.05.01L19.2 61.88l-1.78.6c-.02.01-.05.02-.07.04l-.4.44-.27.29c-.01.01-.02.03-.04.04l-.06.06-.15.17c-.03.03-.05.06-.08.08-.01.01-.02.02-.02.03l-.15.17 1.7.31c.03.01.06-.01.09-.02l-.01.01 12.56-4.21c.04-.01.08-.05.11-.1 0-.01.01-.01.01-.02.01-.02.02-.03.02-.04s.01-.02.01-.03 0-.02.01-.03v-.03-.03-.03-.03-.03-.04z\" fill=\"url(#P)\"/><path d=\"M25.17 68.27c-.05-1.33 1.21-2.65 2.81-2.94s2.93.55 2.97 1.88c.05 1.33-1.21 2.65-2.81 2.94s-2.93-.55-2.97-1.88zm2.06-.38c.01.38.39.62.85.54s.82-.46.8-.84-.39-.62-.85-.54-.81.46-.8.84z\" fill=\"url(#Q)\"/><path d=\"M30.63 66.17l-.05-.11c-.02-.04-.05-.08-.07-.12-.03-.04-.05-.08-.08-.12l-.09-.11c-.03-.04-.07-.07-.11-.11l-.02-.02a.73.73 0 0 0-.1-.09c-.03-.03-.07-.05-.11-.08-.02-.02-.03-.02-.03-.03-.03-.02-.06-.04-.09-.05-.02-.01-.03-.02-.05-.03s-.02-.02-.03-.02-.01-.01-.02-.01c-.04-.03-.09-.05-.13-.07-.01-.01-.02-.01-.03-.02.05.02.1.05.14.07l-.15-.08c-.01-.01-.02-.01-.03-.02s-.03-.02-.04-.02l-.14-.06c-.02-.01-.06-.02-.08-.03-.01 0-.01-.01-.02-.01-.04-.01-.07-.03-.11-.04-.01 0-.01 0-.02-.01-.01 0-.02-.01-.03-.01-.02-.01-.03-.01-.05-.02l-.18-.05-.16-.03c-.02 0-.04-.01-.06-.01l.07.01-.13-.02-.06-.01h-.01l-.19-.02c-.02 0-.05 0-.07-.01h-.04-.04.05-.07-.03-.02-.16c-.08 0-.13.01-.18.01h-.04-.02c-.3.03-.54.09-.71.17-.03.01-.07.03-.11.05l-.14.06-.09.04-.16.09-.16.1c-.05.03-.11.08-.16.12-.03.02-.05.05-.08.07-.03.03-.06.05-.09.08l-.12.11-.13.14-.02.02c-.01.01-.01.02-.02.02l-.1.13c-.02.03-.04.05-.05.08l-.07.1c-.05.07-.1.17-.14.25l-.09.18c-.01.02-.02.05-.03.08-.01.01-.01.03-.02.04-.02.03-.03.06-.04.08-.02.04-.04.09-.05.13l-.05.17c-.01.04-.02.07-.02.11 0 .01-.01.02-.01.03l-.05.29c0 .03-.01.08-.01.11l.04-.23c-.01.08-.04.16-.04.23 0-.05.03-.09.03-.13-.02.12-.04.25-.04.38a1.86 1.86 0 0 0 .17.72l.14.36a1.9 1.9 0 0 1-.17-.72c-.01-.22.03-.44.09-.65.02-.05.03-.11.05-.16.07-.2.16-.4.28-.58.01-.01.01-.02.02-.03 0-.01.01-.01.02-.02a3.21 3.21 0 0 1 .33-.4c.13-.14.27-.26.41-.37.01 0 .01-.01.02-.01.15-.11.31-.22.47-.31.17-.09.35-.17.53-.24.2-.07.39-.12.58-.15.24-.04.47-.04.7-.03.17 0 .33.02.48.05.18.03.37.06.53.13.01 0 .02 0 .02.01.24.1.45.24.63.4.19.18.34.38.44.6l-.13-.35z\" fill=\"url(#R)\"/><path d=\"M32.67 75.83v-.03-.04c0-.01 0-.02-.01-.04 0-.01-.01-.02-.01-.03s-.01-.02-.01-.03-.01-.02-.01-.03l-.01-.01-3.79-8.24c0-.01-.01-.02-.02-.03s-.01-.02-.02-.04c-.01-.01-.02-.02-.02-.03l-.03-.03-.03-.03-.03-.03c-.01-.01-.03-.02-.04-.03-.02-.01-.03-.02-.05-.03l-.06-.03-.1-.03c-.085-.02-.172-.03-.26-.03-.037-.002-.074.002-.11.01-.01 0-.02 0-.03.01-.02 0-.03.01-.05.01-.02.01-.04.01-.07.02-.02.01-.04.01-.06.02s-.04.01-.05.02c-.02.01-.03.01-.05.02s-.03.02-.05.02c-.01.01-.03.02-.04.02-.01.01-.03.02-.04.03s-.03.02-.04.03-.03.02-.04.03-.03.02-.04.04l-.04.04-.05.05c-.02.02-.04.05-.05.07-.01.01-.01.03-.01.04-.07.11-.12.24-.11.36 0 .07.02.14.05.21l3.79 8.24c-.03-.06-.05-.13-.05-.21.01.24.16.42.39.51l.89.33.33-.89c0-.01.01-.02.01-.03.01-.02.01-.04.02-.06 0-.02.01-.04.01-.05v-.05-.04l-.01-.01z\" fill=\"url(#S)\"/><path d=\"M39.72 64.23c-.02-1.35 1.29-2.39 2.94-2.33s3 1.21 3.03 2.56-1.29 2.39-2.94 2.33-3.01-1.21-3.03-2.56zm2.13.08c.01.39.39.71.87.73s.85-.28.84-.67-.39-.71-.87-.73-.85.28-.84.67z\" fill=\"url(#T)\"/><path d=\"M45.73 64.12c0-.05 0-.09-.01-.14 0-.05-.01-.09-.02-.13s-.01-.09-.02-.13c-.01-.03-.01-.05-.02-.08 0-.02 0-.03-.01-.04-.01-.04-.02-.08-.04-.12-.01-.04-.03-.08-.05-.12 0-.01-.01-.02-.01-.03s-.01-.02-.01-.03c-.01-.02-.02-.05-.03-.07-.01-.01-.01-.03-.02-.04 0-.01-.01-.02-.01-.02-.02-.03-.03-.04-.04-.06 0-.01-.01-.01-.01-.02-.01-.02-.02-.05-.03-.07l-.07-.12c-.05-.08-.13-.19-.19-.27l-.03-.03c-.02-.02-.04-.04-.05-.06l-.04-.04-.19-.2-.08-.07-.17-.14-.03-.03c-.02-.01-.04-.03-.05-.04l-.16-.11c.02.01.04.03.06.04-.02-.01-.05-.03-.07-.04l-.18-.11-.18-.09c-.04-.02-.09-.04-.14-.06-.01 0-.02-.01-.03-.01s-.01-.01-.02-.01h-.01l-.03-.01-.11-.04-.05-.01a1.34 1.34 0 0 0-.19-.05l-.15-.03h.02c-.02 0-.04-.01-.06-.01l-.2-.03-.21-.01h-.17-.02-.03-.08l-.2.02c-.03 0-.06.01-.1.02s-.08.01-.12.02l-.2.05-.14.04c-.01 0-.02.01-.04.01-.01 0-.02.01-.04.01l.03-.01-.05.02-.07.03-.03.01-.08.04c-.03.01-.06.03-.1.05-.02.01-.04.02-.07.03-.03.02-.06.03-.09.04l-.17.1c-.01.01-.03.02-.05.03l-.22.15-.14.11-.12.12-.08.08-.04.04-.04.04c-.02.03-.05.06-.08.09.01-.01.03-.02.04-.03-.09.1-.17.2-.23.31-.02.03-.03.06-.05.09-.11.21-.2.42-.23.66l-.05.33c.03-.24.12-.45.23-.66.02-.03.03-.06.05-.09.12-.19.27-.36.44-.52l.22-.19c.01 0 .01-.01.02-.02.12-.09.26-.16.4-.23.01 0 .02-.01.02-.01.144-.07.295-.123.45-.16.01 0 .01 0 .02-.01l.5-.1c.19-.02.37-.03.56-.02.2.01.39.03.58.07.02 0 .04.01.05.01l.5.14c.242.09.474.208.69.35l.26.18c.02.02.04.03.06.05.127.107.244.224.35.35.11.14.21.28.28.42 0 .01.01.01.01.02.08.14.13.3.18.45.04.17.07.33.07.5l-.02.33v-.01l.02-.14.03-.18.02-.17c.01-.07.02-.13.01-.18z\" fill=\"url(#U)\"/><path d=\"M43.55 64.33v-.04c0-.01 0-.02-.01-.04 0-.01-.01-.02-.01-.04 0-.01-.01-.02-.01-.04 0-.01-.01-.02-.01-.03s-.01-.02-.02-.03c0-.01-.01-.01-.01-.02s-.01-.01-.01-.02c-.01-.01-.01-.02-.02-.04-.01-.01-.02-.02-.03-.04-.01-.01-.02-.03-.03-.04s-.02-.03-.04-.04l-.05-.05c-.01-.01-.02-.01-.02-.02-.02-.02-.04-.03-.06-.05-.05-.04-.11-.06-.17-.09-.01-.01-.03-.02-.04-.02l-.11-.03c-.02-.01-.05-.01-.07-.02-.02 0-.04-.01-.06-.01h-.05-.03-.02-.05-.05-.04c-.01 0-.03 0-.04.01-.01 0-.03 0-.04.01-.01 0-.03.01-.04.01h-.02c-.01 0-.01 0-.02.01-.01 0-.03.01-.04.01-.01.01-.03.01-.04.02-.02.01-.03.01-.04.02-.02.01-.03.02-.05.02-.02.01-.03.02-.05.03s-.04.03-.05.04c-.03.03-.06.06-.08.1-.02.02-.04.04-.05.06-.04.069-.07.143-.09.22l-1.25 8.39c.01-.04.03-.07.04-.1-.02.06-.05.13-.04.2a.6.6 0 0 0 .17.41l.54.62.69-.44c.08-.05.14-.11.19-.18.01-.02.02-.03.03-.05.02-.03.03-.04.04-.06.01-.01.01-.03.02-.05 0-.01.01-.03.01-.04s.01-.03.01-.04l.03-.24 1.21-8.16v-.05-.04c-.02.01-.02 0-.02-.02z\" fill=\"url(#V)\"/></g></g><defs><linearGradient id=\"A\" x1=\"31.491\" y1=\"20.257\" x2=\"36.143\" y2=\"20.257\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"29.79\" y1=\"21.772\" x2=\"42.288\" y2=\"21.772\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"20.705\" y1=\"23.324\" x2=\"43.955\" y2=\"23.324\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"34.65\" y1=\"27.591\" x2=\"56.875\" y2=\"27.591\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"16.293\" y1=\"30.698\" x2=\"60.398\" y2=\"30.698\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"52.099\" y1=\"64.531\" x2=\"82.347\" y2=\"64.531\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"42.506\" y1=\"61.733\" x2=\"85.217\" y2=\"61.733\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"46.009\" y1=\"70.696\" x2=\"90.964\" y2=\"70.696\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"45.324\" y1=\"53.724\" x2=\"91.573\" y2=\"53.724\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"37.168\" y1=\"38.346\" x2=\"90.254\" y2=\"38.346\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"68.877\" y1=\"46.625\" x2=\"89.235\" y2=\"46.625\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"56.289\" y1=\"53.261\" x2=\"65.666\" y2=\"53.261\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"28.124\" y1=\"59.059\" x2=\"36.705\" y2=\"59.059\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"28.472\" y1=\"58.965\" x2=\"34.226\" y2=\"58.965\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"30.311\" y1=\"56.078\" x2=\"30.387\" y2=\"56.078\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"13.401\" y1=\"61.165\" x2=\"40.489\" y2=\"61.165\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"21.735\" y1=\"67.743\" x2=\"33.733\" y2=\"67.743\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"R\" x1=\"24.038\" y1=\"66.906\" x2=\"35.434\" y2=\"66.906\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"S\" x1=\"25.232\" y1=\"72.002\" x2=\"38.714\" y2=\"72.002\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"T\" x1=\"36.203\" y1=\"64.341\" x2=\"49.639\" y2=\"64.341\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"U\" x1=\"39.498\" y1=\"63.102\" x2=\"48.88\" y2=\"63.102\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"V\" x1=\"39.464\" y1=\"68.687\" x2=\"47.659\" y2=\"68.687\" xlink:href=\"#Y\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"W\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"X\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"Y\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeFireExplosion = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#m)\"><g clip-path=\"url(#n)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M57.54 52.94c-4.25-1.48-9.64-1.47-13.91.04.05-.02.13-.04.18-.06l.09-.03c.05-.02.13-.04.18-.06s.13-.04.18-.06l.09-.03c.05-.02.13-.04.18-.06s.13-.04.18-.06l.09-.03c.05-.02.13-.04.18-.06s.13-.04.18-.06l.09-.03c.05-.02.13-.04.18-.06 3.16-1.12 7.15-1.12 10.3-.03.608.182 1.212.378 1.81.59z\" fill=\"url(#A)\"/><path d=\"M57.54 52.94l-1.81-.63c-3.15-1.09-7.14-1.09-10.3.03l-1.8.64c4.27-1.51 9.66-1.51 13.91-.04z\" fill=\"url(#A)\"/><path d=\"M57.14 50.47c-3.48-2.08-9.22-2.14-12.84-.12 3.62-2.03 9.37-1.97 12.84.12z\" fill=\"url(#B)\"/><path d=\"M57.14 50.47c-3.48-2.08-9.22-2.14-12.84-.12 3.62-2.03 9.37-1.97 12.84.12z\" fill=\"url(#B)\"/><path d=\"M44.3 50.34c2.92-1.63 7.23-1.91 10.61-.85-.19-.05-.45-.13-.64-.18-3.51-.85-7.14-.47-9.97 1.03z\" fill=\"url(#C)\"/><path d=\"M44.3 50.34c-3.6 2.02-3.72 5.35-.26 7.44-3.48-2.09-3.36-5.43.26-7.44z\" fill=\"url(#D)\"/><path d=\"M44.3 50.34c-3.6 2.02-3.72 5.35-.26 7.44-3.48-2.09-3.36-5.43.26-7.44z\" fill=\"url(#D)\"/><path d=\"M44.3 50.34c-3.43 2-2.89 4.27-2.5 5.15-.81-1.79.03-3.78 2.5-5.15z\" fill=\"url(#E)\"/><path d=\"M64.03 59.92c0-.04.01-.08.01-.13v-.04c.01-.19 0-.38-.02-.57 0-.03-.01-.07-.02-.1l-.03-.19-.04-.26c-.02-.08-.04-.16-.07-.23-.02-.06-.03-.13-.05-.19l-.03-.12c-.06-.18-.13-.36-.22-.53 0-.01-.01-.02-.01-.03l-.27-.5c-.02-.04-.05-.08-.08-.12l-.13-.19-.14-.21-.21-.26-.14-.17c-.02-.03-.04-.06-.07-.08l-.51-.51c-.04-.04-.07-.06-.1-.08l-.5-.42c-.04-.03-.08-.06-.12-.08l-.28-.2c-.11-.07-.2-.15-.32-.23l-.39-.25-.46-.26-.68-.34-.24-.12c-.03-.01-.05-.03-.07-.04l-1.2-.48c-.04-.01-.07-.03-.11-.04l-1.81-.63a12 12 0 0 1 2.05.94 7.84 7.84 0 0 1 1.09.79c-4.85-2.2-11.68-2.19-16.56.06.02-.02.04-.05.07-.07.38-.32.82-.63 1.33-.92.553-.307 1.132-.564 1.73-.77-.05.02-.13.04-.18.06l-.09.03c-.05.02-.13.04-.18.06s-.13.04-.18.06l-.09.03c-.05.02-.13.04-.18.06-.04.01-.08.03-.12.04l-.52.18c-.027.008-.054.018-.08.03-.05.02-.13.04-.18.06-.807.279-1.587.63-2.33 1.05a11.22 11.22 0 0 0-.96.6c-.11.07-.2.15-.3.23-.19.14-.37.27-.54.42-.01.01-.03.02-.04.03-.09.08-.16.16-.25.24-.14.13-.29.27-.42.41-.09.1-.17.2-.26.3l-.33.4c-.08.11-.14.22-.21.33-.08.13-.17.27-.24.4a3.57 3.57 0 0 0-.16.34c-.06.14-.12.27-.17.41-.01.04-.03.07-.04.11-.02.07-.03.15-.05.23-.04.15-.08.3-.1.45-.02.11-.03.23-.04.34-.01.15-.02.3-.02.45 0 .06-.01.11-.01.17 0 .02.01.04.01.07-.12 2.03 1.11 4.07 3.73 5.65 5.14 3.09 13.65 3.18 19.01.19 2.85-1.6 4.22-3.74 4.12-5.86z\" fill=\"url(#F)\"/><path d=\"M56.88 57.91c3.6-2.02 3.72-5.35.26-7.44 3.48 2.09 3.36 5.42-.26 7.44z\" fill=\"url(#G)\"/><path d=\"M56.88 57.91c3.6-2.02 3.72-5.35.26-7.44 3.48 2.09 3.36 5.42-.26 7.44z\" fill=\"url(#G)\"/><path d=\"M56.88 57.91c3.58-2.17 2.97-4.4 2.28-5.55 1.14 1.88.37 4.07-2.28 5.55z\" fill=\"url(#H)\"/><path d=\"M56.88 57.91c.7-.42.86-.52 1.35-.95a7.49 7.49 0 0 1-1.35.95z\" fill=\"url(#I)\"/><path d=\"M44.03 57.78c3.48 2.08 9.22 2.14 12.84.12-3.61 2.03-9.36 1.97-12.84-.12z\" fill=\"url(#J)\"/><path d=\"M44.03 57.78c3.48 2.08 9.22 2.14 12.84.12-3.61 2.03-9.36 1.97-12.84-.12z\" fill=\"url(#J)\"/><path d=\"M56.88 57.91c-3.08 1.72-7.7 1.93-11.15.67l.6.2c2.78.82 7 1.02 10.55-.87z\" fill=\"url(#K)\"/><path d=\"M56.88 57.91c-1.23.69-2.71 1.13-4.26 1.34l.68-.11c1.17-.24 2.18-.48 3.58-1.23z\" fill=\"url(#L)\"/><path d=\"M57.54 52.95c-4.38-1.52-9.76-1.43-13.93.04l1.81-.64c3.09-1.09 7.07-1.16 10.31-.03l1.81.63z\" fill=\"url(#M)\"/><path d=\"M43.61 52.99l1.81-.64c-1.15.41-2.18.96-3 1.64l-2.86 1.22c1.11-.93 2.5-1.67 4.05-2.22z\" fill=\"url(#N)\"/><path d=\"M60.54 54.72c-.33-4.31-5.9-5.54-6.54-5.66-5.24-1.04-9.31.4-11.38 2.1-.19.16-.21.49-.21.52 3.14-2.62 9.34-3.28 13.85-1.47 2.68 1.07 4.16 2.77 4.28 4.51z\" fill=\"url(#O)\"/><path d=\"M55.77 49.79c-4.12-1.64-9.77-1.04-12.63 1.35 2.85-2.4 8.51-3 12.63-1.35z\" fill=\"url(#P)\"/><path d=\"M42.63 51.16c-.19.16-.21.49-.21.52-1.13.95-1.71 2.02-1.77 3.09.11-1.94 1.42-3.11 1.98-3.61z\" fill=\"url(#Q)\"/><path d=\"M58.05 57.11c2.85-2.39 1.83-5.66-2.29-7.31 4.13 1.64 5.15 4.92 2.29 7.31z\" fill=\"url(#R)\"/><path d=\"M43.13 51.13c-2.85 2.39-1.83 5.66 2.29 7.31-4.13-1.64-5.15-4.91-2.29-7.31z\" fill=\"url(#S)\"/><path d=\"M45.41 58.45c4.12 1.64 9.77 1.04 12.63-1.35-2.85 2.4-8.51 3-12.63 1.35z\" fill=\"url(#T)\"/><path d=\"M60.55 54.93c0 .07-.01.13-.02.2l.01-.41-.01-.09-.01-.1c-.01-.05-.01-.11-.02-.15l-.02-.15-.04-.21-.05-.19c-.02-.09-.06-.2-.09-.28l-.03-.09-.05-.14-.18-.4-.16-.28-.14-.2-.06-.09-.09-.13-.15-.2-.23-.26-.02-.02-.03-.04-.36-.35a1.79 1.79 0 0 1-.14-.13c-.09-.08-.18-.15-.29-.23l-.21-.16-.12-.09-.12-.07-.37-.24-.47-.26c-.05-.03-.1-.05-.14-.08l-.25-.12-.26-.12-.07-.03-.65-.26-.65-.22-.69-.19-.06-.01c-.01 0-.03-.01-.05-.01l-.58-.13-.71-.12-.22-.03-.37-.05-.13-.02-.34-.03-.27-.02c-.04 0-.08-.01-.11-.01l-.47-.02c-.17 0-.33-.01-.5-.01l-.49.01-.24.01h-.02l-.48.03c-.04 0-.09.01-.14.01l-.37.04-.21.02-.72.11-.57.11c-.03.01-.07.01-.1.02-.01 0-.03.01-.04.01l-.69.17-.69.21-.04.02-.53.2-.07.03c-.11.04-.23.1-.35.15l-.47.22-.42.22-.26.16c-.04.03-.09.05-.13.08-.229.14-.449.294-.66.46-.05.04-.1.07-.14.11l-.35.3-.36.36c-.01.01-.01.02-.02.03-.03.03-.05.06-.07.09l-.4.5-.22.33-.08.14c-.01.02-.03.05-.04.07l-.04.09c-.02.03-.03.06-.05.09l-.12.28-.07.17-.02.06c-.01.02-.01.03-.02.05l-.02.06-.02.06c0 .01 0 .02-.01.02l-.03.09c-.021.069-.038.139-.05.21l-.04.19v.03l-.01.08c0 .02-.01.04-.01.05v.01.01l-.02.12-.01.1c0 .03 0 .06-.01.09v.07c0 .03-.01.06-.01.09v.06-.01l.01 2.31c0 1.43.92 2.86 2.77 3.98.49.29 1.02.55 1.59.77.01.01.03.01.04.02l1.2.4c.1.03.2.05.29.07a3.25 3.25 0 0 0 .3.07l.45.11.98.17c.05.01.11.01.16.02.06.01.13.01.19.02l.61.07.97.05h.13.18l.7-.01 1.07-.07h.02l1.26-.18.29-.07.87-.21.61-.15c.08-.02.14-.07.21-.09.69-.23 1.35-.49 1.95-.83l.47-.28c.18-.12.31-.25.47-.37l.51-.4c.05-.04.12-.08.16-.13a5.17 5.17 0 0 0 .59-.66l.05-.08c.03-.04.05-.08.07-.11l.26-.4c.1-.19.19-.37.25-.56 0-.01.01-.03.01-.04.01-.02.01-.04.02-.06.05-.15.1-.3.12-.46.04-.19.05-.38.06-.57v-.07l.03-2.31zm-19.9.23c.01.14.03.27.05.41 0 .02 0 .04.01.06a4.01 4.01 0 0 1-.06-.47zm.68 1.93a3.97 3.97 0 0 1-.23-.39c0 .01.01.01.01.02.01.01.02.03.03.04l.19.33c.03.03.05.06.07.08a.57.57 0 0 1-.07-.08zm3.66 2.64c.26.1.54.17.81.26l-.81-.26zm1.84.56c.33.08.67.13 1.02.19l-1.02-.19zm5.44.35a17.29 17.29 0 0 1-1.77.08l1.77-.08zm.02-.01c.4-.04.78-.12 1.17-.19l-1.17.19zm7.46-3.44c-.02.02-.04.05-.06.07.02-.03.05-.06.07-.09 0 .01-.01.02-.01.02zm.61-1.17c-.01.02-.01.04-.02.06-.02.05-.05.1-.07.15.04-.07.07-.15.09-.21z\" fill=\"url(#U)\"/><path d=\"M64.05 59.6c0 1.54-.77 3.09-2.4 4.45-4.24 3.54-12.61 4.43-18.71 1.99-3.75-1.5-5.77-3.92-5.78-6.38v.54c.01 2.46 2.02 4.88 5.78 6.38 6.1 2.44 14.48 1.55 18.71-1.99 1.63-1.36 2.41-2.92 2.4-4.45v-.54z\" fill=\"url(#V)\"/><path d=\"M83.32 57.89L52.94 40.35c-.167-.095-.341-.179-.52-.25-.14-.06-.29-.11-.44-.15l-.21-.05c-.02 0-.03-.01-.05-.01l-.11-.03-.36-.06c-.12-.02-.23-.03-.35-.04l-.36-.02h-.13-.05-.19c-.13 0-.27.01-.4.03l-.46.06c-.07.01-.13.03-.2.05-.06.01-.11.03-.17.04l-.31.08c-.275.088-.54.205-.79.35L17.65 57.89c-.01.01-.03.02-.04.03-.07.04-.12.09-.18.13-.09.06-.18.12-.25.19-.01.01-.02.01-.02.02l-.22.24c-.01.02-.03.04-.04.06s-.03.04-.04.06l-.07.1c-.04.07-.07.14-.1.21 0 .01-.01.02-.01.03s-.01.03-.01.04c-.01.04-.03.09-.04.13l-.02.21v.03l-.01 1.83c0-.12.02-.25.06-.37 0-.01.01-.03.01-.04.044-.119.101-.233.17-.34.01-.02.03-.04.04-.06.085-.116.183-.224.29-.32.07-.07.17-.13.25-.19l.22-.16 30.19-17.54c.33-.19.71-.32 1.1-.43.06-.01.11-.03.17-.04.41-.093.829-.14 1.25-.14h.05a5.66 5.66 0 0 1 1.31.15c.02 0 .03.01.05.01.42.1.83.25 1.17.45l30.39 17.54c.53.31.87.69 1 1.09.04.13.07.27.07.4l.01-1.83c-.01-.54-.36-1.08-1.08-1.49z\" fill=\"url(#W)\"/><path d=\"M84.18 57.03c2.23 1.29 2.25 3.39.03 4.68L54.64 78.89c-2.22 1.29-5.84 1.29-8.07 0L16.81 61.71c-2.23-1.29-2.25-3.39-.03-4.68l29.56-17.18c2.22-1.29 5.84-1.29 8.07 0l29.77 17.18zM53.15 78.39l30.19-17.54c1.4-.82 1.4-2.14-.02-2.96L52.94 40.35c-1.41-.82-3.7-.82-5.1 0L17.65 57.89c-1.4.82-1.4 2.14.02 2.96l30.39 17.54c1.4.82 3.69.82 5.09 0z\" fill=\"url(#X)\"/><path d=\"M85.86 59.39c0 .2-.04.39-.1.59-.01.02-.01.04-.02.06a2.41 2.41 0 0 1-.27.53l-.06.09c-.12.17-.28.34-.45.5-.12.1-.26.2-.4.3l-.35.25-29.57 17.18c-.34.2-.72.36-1.12.49l-.43.13-.57.14-.69.12c-.06.01-.11.02-.17.02l-.96.05h-.15c-.32 0-.63-.02-.95-.05-.05-.01-.09-.01-.14-.02l-.92-.16-.16-.04-.79-.24-.14-.05a5.81 5.81 0 0 1-.87-.41L16.81 61.71c-1.12-.65-1.69-1.5-1.68-2.35l-.01 1.83c0 .85.56 1.7 1.68 2.35l29.76 17.18c.26.15.53.28.82.39.02.01.03.01.05.02.05.02.1.03.14.05l.5.17a2.49 2.49 0 0 0 .29.07l.16.04c.05.01.1.03.15.04l.57.1.2.02c.05.01.1.01.15.02l.21.02c.19.02.37.03.56.03h.18.15.25l.63-.04c.02 0 .05-.01.07-.01.06-.01.11-.02.17-.02l.49-.07c.07-.01.14-.04.2-.05l.57-.14c.1-.03.21-.04.3-.08.05-.01.08-.04.13-.06.4-.14.78-.29 1.12-.49L84.2 63.54c.02-.01.05-.03.07-.04.11-.07.19-.14.28-.21l.4-.3c.01-.01.03-.02.04-.03.127-.117.244-.244.35-.38l.06-.09.06-.09c.03-.05.07-.1.1-.16.056-.104.106-.211.15-.32a.09.09 0 0 0 .01-.05c.01-.02.01-.04.02-.06.02-.07.05-.14.06-.21.02-.11.03-.22.04-.33v-.05l.02-1.83z\" fill=\"url(#Y)\"/><path d=\"M40.2 59.55v1.37l-6.62 3.82a.71.71 0 0 0-.31.54l.01 4.63-1.15.66-.01-4.98a2.64 2.64 0 0 1 1.21-2.08l6.87-3.96z\" fill=\"url(#Z)\"/><path d=\"M32.22 64.99a2.51 2.51 0 0 1 .26-.58 3.07 3.07 0 0 1 .37-.5l.02-.02a1.97 1.97 0 0 1 .46-.37l6.87-3.96-1.05-.61-6.87 3.96c-.14.08-.28.19-.41.32-.02.02-.03.04-.05.06l-.02.02c-.02.02-.04.04-.06.07-.03.04-.07.08-.1.12l-.08.11-.07.1-.06.1c-.02.03-.04.06-.05.1-.02.03-.04.07-.05.1-.02.03-.03.07-.05.1-.02.04-.03.07-.04.11s-.03.08-.04.11c-.01.02-.01.04-.02.06-.01.03-.01.04-.02.06l-.03.14-.03.17-.02.24.01 4.98 1.05.61-.01-4.98c0-.19.03-.39.09-.59v-.03z\" fill=\"url(#a)\"/><path d=\"M67.65 44.22c0-.1-.03-.17-.09-.2l-1.05-.61c.05.03.09.1.09.2l.01 4.63 1.05.61-.01-4.63z\" fill=\"url(#b)\"/><path d=\"M60.71 46.49l6.87-3.96c.67-.39 1.21-.07 1.22.69l.01 4.97-1.15.66-.01-4.63c0-.2-.13-.27-.31-.17l-6.63 3.83v-1.39z\" fill=\"url(#c)\"/><path d=\"M59.66 45.88l1.05.61.01 1.38-1.06-.61v-1.38z\" fill=\"url(#d)\"/><path d=\"M68.06 42.37a.61.61 0 0 1 .38.08l-1.05-.61c-.03-.01-.05-.02-.07-.03s-.04-.02-.06-.02c-.02-.01-.05-.01-.07-.02-.02 0-.05-.01-.07-.01h-.08-.03c-.03 0-.04 0-.06.01-.03.01-.07.01-.11.02-.05.01-.09.03-.14.05-.06.02-.11.05-.17.08l-6.87 3.96 1.05.61 6.87-3.96a1.05 1.05 0 0 1 .48-.16z\" fill=\"url(#e)\"/><path d=\"M32.62 44.43a.12.12 0 0 0-.05.05c0 .01-.01.01-.01.02s-.01.01-.01.02 0 .01-.01.02v.02.02.02.02.02.02l-.01 4.63 1.05-.61.01-4.63a.26.26 0 0 1 .09-.21l-1.06.59z\" fill=\"url(#f)\"/><path d=\"M39.46 46.9v1.37l-6.63-3.83c-.17-.1-.31-.01-.31.19l-.01 4.63-1.15-.66.01-4.98c0-.77.55-1.07 1.22-.68l6.87 3.96z\" fill=\"url(#g)\"/><path d=\"M39.46 46.9l1.05-.61v1.37l-1.05.61V46.9z\" fill=\"url(#h)\"/><path d=\"M33.65 42.32c-.01-.01-.03-.01-.04-.02-.02-.01-.03-.02-.05-.03s-.03-.02-.05-.02c-.02-.01-.03-.01-.05-.02s-.03-.01-.05-.02-.03-.01-.05-.02-.03-.01-.05-.01-.03-.01-.05-.01-.04-.01-.05-.01h-.04-.02-.06-.06c-.02 0-.05.01-.07.01-.03.01-.06.01-.08.02-.03.01-.07.03-.1.05l-1.05.61c.11-.06.24-.09.39-.08s.31.07.48.16l6.87 3.96 1.05-.61-6.87-3.96z\" fill=\"url(#i)\"/><path d=\"M60.68 59.67l6.88 3.97c.67.39 1.2 1.31 1.2 2.08l-.01 4.98-1.14-.66.01-4.63c0-.2-.14-.44-.31-.54l-6.63-3.83v-1.37z\" fill=\"url(#j)\"/><path d=\"M69.81 65.05v-.06-.06c0-.02 0-.04-.01-.06 0-.02-.01-.04-.01-.06s-.01-.04-.01-.06-.01-.04-.01-.06-.01-.04-.01-.06c-.01-.02-.01-.04-.02-.06 0-.02-.01-.03-.01-.05-.01-.03-.01-.05-.02-.07s-.01-.04-.02-.06-.01-.04-.02-.06-.02-.04-.02-.06c-.01-.02-.02-.04-.02-.06l-.03-.06-.03-.06c-.01-.02-.02-.05-.04-.07-.01-.03-.03-.05-.05-.08 0-.02-.01-.02-.01-.03l-.09-.14c-.02-.04-.05-.07-.08-.11-.02-.02-.04-.05-.05-.07-.02-.02-.03-.04-.05-.06s-.03-.04-.05-.05l-.05-.05c-.02-.02-.03-.03-.04-.05l-.05-.05c-.02-.02-.04-.03-.05-.05-.02-.02-.04-.03-.05-.05-.02-.01-.04-.03-.05-.04-.02-.01-.04-.03-.05-.04-.02-.01-.04-.03-.05-.04-.02-.01-.03-.02-.05-.03s-.03-.02-.05-.03l-6.89-3.98-1.05.61 6.88 3.97c.174.104.332.232.47.38a3.22 3.22 0 0 1 .38.51c.104.187.188.385.25.59.06.2.09.4.09.59l-.01 4.98 1.05-.61.01-4.98c-.03-.03-.03-.04-.03-.06z\" fill=\"url(#k)\"/><path d=\"M60.41 28.06s-.23 4.15-1.72 5.01c0 0-2.19-17.94-14.1-20.21 0 0 5.48 7.65.31 13.08-1.018 1.016-2.005 2.064-2.96 3.14-.01.01-.02.03-.03.04-.36-1-.5-2.28-.03-3.81-.04.12-.51.35-.61.43-.55.42-1.07.9-1.55 1.39-1.74 1.78-3.1 3.92-4.11 6.19-.72 1.62-1.26 3.33-1.65 5.06-.47 2.14-.85 4.34-.91 6.53-.11 4.18.61 8.3 3.05 11.77.641.902 1.353 1.751 2.13 2.54 0 0 12.57 11.47 24.05 0 11.49-11.46-1.87-31.16-1.87-31.16z\" fill=\"url(#l)\"/><path d=\"M55.88 54.68s-5.59 5.1-10.7 0 .84-13.87.84-13.87.1 1.85.77 2.23c0 0 .98-7.98 6.27-8.99 0 0-2.44 3.4-.14 5.82 2.02 2.02 8.64 9.02 2.96 14.81z\" fill=\"#fff\"/></g></g><defs><linearGradient id=\"A\" x1=\"43.631\" y1=\"52.241\" x2=\"57.544\" y2=\"52.241\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"44.299\" y1=\"49.666\" x2=\"57.145\" y2=\"49.666\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"44.299\" y1=\"49.598\" x2=\"54.907\" y2=\"49.598\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"41.504\" y1=\"54.057\" x2=\"44.309\" y2=\"54.057\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"41.504\" y1=\"52.91\" x2=\"44.3\" y2=\"52.91\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"35.19\" y1=\"60.136\" x2=\"71.297\" y2=\"60.136\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"56.869\" y1=\"54.187\" x2=\"59.674\" y2=\"54.187\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"56.878\" y1=\"55.134\" x2=\"59.687\" y2=\"55.134\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"56.879\" y1=\"57.432\" x2=\"58.228\" y2=\"57.432\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"44.033\" y1=\"58.578\" x2=\"56.879\" y2=\"58.578\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"45.729\" y1=\"58.645\" x2=\"56.879\" y2=\"58.645\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"52.621\" y1=\"58.577\" x2=\"56.879\" y2=\"58.577\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"43.615\" y1=\"52.244\" x2=\"57.542\" y2=\"52.244\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"39.562\" y1=\"53.778\" x2=\"45.423\" y2=\"53.778\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"42.416\" y1=\"51.718\" x2=\"60.539\" y2=\"51.718\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"43.127\" y1=\"49.999\" x2=\"55.772\" y2=\"49.999\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"40.643\" y1=\"52.967\" x2=\"42.626\" y2=\"52.967\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"R\" x1=\"55.763\" y1=\"53.45\" x2=\"59.675\" y2=\"53.45\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"S\" x1=\"41.503\" y1=\"54.794\" x2=\"45.415\" y2=\"54.794\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"T\" x1=\"45.407\" y1=\"58.245\" x2=\"58.051\" y2=\"58.245\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"U\" x1=\"32.233\" y1=\"55.867\" x2=\"63.717\" y2=\"55.867\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"V\" x1=\"25.807\" y1=\"63.778\" x2=\"68.327\" y2=\"63.778\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"W\" x1=\"-15.851\" y1=\"50.475\" x2=\"105.902\" y2=\"50.475\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".123\" stop-color=\"#9548cd\"/><stop offset=\".556\" stop-color=\"#cdaae8\"/><stop offset=\".857\" stop-color=\"#f1e7f8\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"X\" x1=\"-16.947\" y1=\"59.371\" x2=\"129.261\" y2=\"59.371\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Y\" x1=\"-12.6\" y1=\"70.519\" x2=\"88.324\" y2=\"70.519\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Z\" x1=\"23.148\" y1=\"65.061\" x2=\"42.926\" y2=\"65.061\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"a\" x1=\"27.579\" y1=\"64.754\" x2=\"44.849\" y2=\"64.754\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"b\" x1=\"65.478\" y1=\"46.133\" x2=\"69.499\" y2=\"46.133\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"c\" x1=\"52.617\" y1=\"45.608\" x2=\"69.744\" y2=\"45.608\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"d\" x1=\"59.512\" y1=\"46.877\" x2=\"62.813\" y2=\"46.877\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"e\" x1=\"56.572\" y1=\"44.121\" x2=\"70.224\" y2=\"44.121\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"f\" x1=\"29.766\" y1=\"46.538\" x2=\"35.066\" y2=\"46.538\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"g\" x1=\"29.557\" y1=\"46.016\" x2=\"51.986\" y2=\"46.016\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"h\" x1=\"35.202\" y1=\"47.281\" x2=\"40.759\" y2=\"47.281\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"i\" x1=\"27.008\" y1=\"44.529\" x2=\"42.482\" y2=\"44.529\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"j\" x1=\"59.589\" y1=\"65.182\" x2=\"77.784\" y2=\"65.182\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"k\" x1=\"57.72\" y1=\"64.876\" x2=\"72.11\" y2=\"64.876\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"l\" x1=\"20.387\" y1=\"38.599\" x2=\"73.218\" y2=\"38.599\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"m\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"n\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"o\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeFurnitureContent = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#U)\"><g clip-path=\"url(#V)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><use xlink:href=\"#W\" fill=\"url(#A)\"/><path d=\"M52.18 70.94c-.01.02-.02.03-.03.04a2.09 2.09 0 0 1-.18.27 1.52 1.52 0 0 1-.12.13c-.05.06-.11.11-.17.17-.15.13-.31.25-.51.37-.212.115-.432.212-.66.29-.08.03-.16.05-.23.07l-.5.13-.41.07-.21.03-.63.03h-.12c-.18 0-.35-.02-.53-.03l-.17-.02c-.18-.02-.35-.06-.53-.1-.04-.01-.08-.01-.12-.02-.15-.04-.29-.09-.43-.14-.07-.02-.15-.04-.21-.07-.199-.081-.393-.175-.58-.28-.62-.37-.97-.84-1.05-1.32l1.67 10.04c.04.26.23.52.58.72.19.12.42.2.65.26h.02.02l.27.05.27.03c.07 0 .14.01.2.01h.03.04l.28-.01.32-.04c.02 0 .03-.01.05-.02.28-.06.54-.14.76-.26.112-.06.216-.134.31-.22.04-.03.06-.07.09-.1l.03-.03.03-.03c.04-.05.07-.1.09-.15a.87.87 0 0 0 .05-.15c0-.01.01-.03.01-.04l1.73-10.03c-.02.11-.06.23-.11.35z\" fill=\"url(#B)\"/><path d=\"M45.9 68.78c1.5-.84 3.89-.82 5.34.05s1.42 2.25-.08 3.09-3.89.82-5.34-.05-1.41-2.25.08-3.09z\" fill=\"url(#C)\"/><path d=\"M74.38 64.26c.82-.46 2.13-.45 2.92.03.8.48.78 1.23-.04 1.69s-2.13.45-2.92-.03c-.79-.47-.77-1.23.04-1.69z\" fill=\"url(#D)\"/><path d=\"M79.5 55.58c-.01.02-.02.03-.03.04a2.11 2.11 0 0 1-.18.27c-.037.046-.078.089-.12.13-.05.06-.11.11-.17.17-.15.13-.31.25-.51.37a4.39 4.39 0 0 1-.66.29c-.08.03-.16.05-.23.07l-.5.13-.41.07-.21.03-.63.03h-.12c-.18 0-.35-.02-.53-.03l-.17-.02c-.18-.02-.35-.06-.53-.1-.04-.01-.08-.01-.12-.02a5.41 5.41 0 0 1-.43-.14c-.07-.02-.15-.04-.21-.07-.199-.081-.393-.175-.58-.28-.62-.37-.97-.84-1.05-1.32l1.67 10.04c.04.26.23.52.58.72.19.12.42.2.65.26h.04l.27.05.27.03c.07 0 .14.01.2.01h.03.04l.28-.01.32-.04c.02 0 .03-.01.05-.02.28-.06.54-.14.76-.26.112-.06.216-.134.31-.22.04-.03.06-.07.09-.1l.03-.03.03-.03c.04-.05.07-.1.09-.15a.88.88 0 0 0 .05-.15c0-.01.01-.03.01-.04l1.73-10.03c-.02.11-.06.23-.11.35z\" fill=\"url(#E)\"/><path d=\"M73.22 53.42c1.5-.84 3.89-.82 5.34.05s1.42 2.25-.08 3.09-3.89.82-5.34-.05-1.41-2.25.08-3.09z\" fill=\"url(#F)\"/><path d=\"M23.24 66.64c.82-.46 2.13-.45 2.92.03.8.48.78 1.23-.04 1.69s-2.13.45-2.92-.03c-.8-.47-.78-1.23.04-1.69z\" fill=\"url(#G)\"/><path d=\"M28.35 57.96c-.01.02-.02.03-.03.04a2.12 2.12 0 0 1-.18.27c-.038.046-.078.089-.12.13-.05.06-.11.11-.17.17-.15.13-.31.25-.51.37a4.39 4.39 0 0 1-.66.29c-.08.03-.16.05-.23.07l-.5.13-.41.07-.21.03-.63.03h-.12c-.18 0-.35-.02-.53-.03l-.17-.02c-.18-.02-.35-.06-.53-.1-.04-.01-.08-.01-.12-.02-.15-.04-.29-.09-.43-.14-.07-.02-.15-.04-.21-.07-.199-.081-.393-.175-.58-.28-.62-.37-.97-.84-1.05-1.32l1.67 10.04c.04.26.23.52.58.72.19.12.42.2.65.26h.04l.27.05.27.03c.07 0 .14.01.2.01h.03.04l.28-.01.32-.04c.02 0 .03-.01.05-.02.28-.06.54-.14.76-.26.112-.06.216-.134.31-.22.04-.03.06-.07.09-.1l.03-.03.03-.03c.04-.05.07-.1.09-.15s.04-.1.05-.15c0-.01.01-.03.01-.04l1.73-10.03a1.01 1.01 0 0 1-.11.35z\" fill=\"url(#H)\"/><path d=\"M22.08 55.8c1.5-.84 3.89-.82 5.34.05s1.42 2.25-.08 3.09-3.89.82-5.34-.05-1.42-2.25.08-3.09z\" fill=\"url(#I)\"/><path d=\"M67.8 32.06c4.75 2.74 8.6 9.4 8.58 14.86l-.04 11.68-28.87-16.67.06-21.57 20.27 11.7z\" fill=\"url(#J)\"/><path d=\"M80.37 44.21l-.02-.42c0-.06-.01-.13-.02-.19 0-.03 0-.05-.01-.08 0-.05-.01-.1-.01-.15l-.05-.42-.06-.43v-.02l-.07-.42-.09-.45-.04-.16c-.01-.03-.01-.06-.02-.09l-.05-.2-.12-.46-.1-.34c-.01-.02-.01-.04-.02-.06s-.01-.04-.02-.06l-.14-.45-.15-.44-.03-.08c-.01-.02-.02-.04-.02-.06l-.1-.28-.17-.42-.13-.3c-.01-.02-.01-.03-.02-.05l-.03-.06-.19-.42-.22-.45c-.01-.02-.02-.05-.04-.07-.01-.03-.03-.06-.04-.08l-.19-.36-.25-.45-.12-.22c-.02-.03-.03-.06-.05-.09l-.24-.38-.34-.55-.06-.09-.54-.77-.39-.51-.32-.39c-.01-.01-.01-.01-.01-.02l-.33-.39-.33-.37-.06-.06-.06-.06-.24-.25-.36-.36c-.04-.04-.08-.07-.11-.11-.03-.03-.06-.05-.08-.08l-.18-.17-.38-.33-.17-.14a.57.57 0 0 1-.08-.07l-.13-.1-.38-.29-.28-.2c-.02-.01-.03-.02-.05-.04-.02-.01-.03-.02-.05-.03l-.37-.24-.36-.22c-.03-.02-.06-.03-.08-.05l-20.27-11.7-4 2.32 20.27 11.7.86.55c.02.01.03.02.05.04l.78.59c.03.02.06.05.09.07l.73.64c.03.03.06.05.09.08l.71.71.06.06.73.82.71.91.6.86.35.55.29.47.13.22.43.8c.02.03.03.06.05.09l.47 1c.01.02.01.03.02.05l.4.99c.01.02.02.04.02.07l.34 1.02c.01.02.01.04.02.06l.26.99c.01.03.02.06.02.1l.2 1.01v.02l.12 1.01a.22.22 0 0 0 .01.08l.04.99-.04 11.72 4-2.32.03-11.68c.01-.13 0-.26 0-.39z\" fill=\"url(#K)\"/><path d=\"M76.37 50.51L52.49 64.39 23.96 47.92l23.88-13.88 28.53 16.47z\" fill=\"url(#L)\"/><path d=\"M76.37 50.51l-.03 8.09-23.87 13.88.02-8.09 23.88-13.88z\" fill=\"url(#M)\"/><path d=\"M52.49 64.39l-.02 8.09-28.53-16.47.02-8.09 28.53 16.47z\" fill=\"url(#N)\"/><path d=\"M40.88 25.23c.79-.01 1.57-.21 2.35-.14.68.07 1.31.34 1.93.62l2.61 1.14c.69.3 1.39.61 1.98 1.08.82.65 1.38 1.62 1.56 2.65a38.48 38.48 0 0 1-7.72-.9c-1.36-.3-2.75-.69-3.8-1.59-.78-.67-1.42-1.77-1.33-2.82.05-.53.31-.72.81-.52.57.23.97.48 1.61.48z\" fill=\"url(#O)\"/><path d=\"M38.78 22.44c.14.25.25.6.06.81-.19.2-.52.14-.78.06-.96-.29-1.94-.59-2.76-1.17-.6-.43-1.1-1.04-1.31-1.75-.12-.42-.2-.6.21-.7.3-.07.79.08 1.08.14 1.45.35 2.76 1.3 3.5 2.61z\" fill=\"url(#P)\"/><path d=\"M27.27 20.04c.47-.79 1.22-1.46 2.04-1.93a5.88 5.88 0 0 1 4.57-.48c-1.51-2.27-4.49-4.57-7.32-4.76-2.6-.17-5.09 2.3-5.54 4.71-.03.14-.04.29-.06.44l-.03.23c-.012.049-.018.099-.02.15-.03.33-.04.66-.04 1.01.01.44.05.87.13 1.29l5.01 26.05 5.82 1.72-.29-1.48-3.1-16.14-1.34-6.99-.27-1.39c-.2-.87 0-1.7.44-2.43z\" fill=\"url(#Q)\"/><path d=\"M33.27 16.7a3.6 3.6 0 0 1 .66.79c.76 1.24.89 2.99 2.16 3.69.7.39 1.6.35 2.23.85 1.07.85.64 2.57 1.12 3.85.44 1.17 1.78 1.93 3.01 1.7.68-.13 1.3-.51 1.98-.53.57-.02 1.12.21 1.65.44l4.16 1.79c1.21.54 1.13 1.38 1.38 2.64l.93 4.84L31.9 48.7l-5.01-26.05c-.46-2.4-.28-5.77 2.41-6.77 1.33-.49 2.92-.12 3.97.82z\" fill=\"url(#R)\"/><path d=\"M42.49 26.54a.4.4 0 0 1-.23-.08c-.71-.55-1.15-1.45-1.15-2.34 0-.83.38-1.67 1-2.22a4.25 4.25 0 0 1 1.49-3.73c.16-.13.39-.11.52.05s.11.39-.05.52c-.8.66-1.26 1.68-1.25 2.71.5-.21 1.04-.23 1.49-.04.4.17.72.54.84.98.11.38.05.77-.17 1.06-.46.64-1.38.64-1.96.23-.35-.24-.57-.58-.7-.92a2.28 2.28 0 0 0-.48 1.37 2.28 2.28 0 0 0 .86 1.76c.16.12.19.36.07.52-.06.08-.17.13-.28.13zm.44-4.32c.08.29.24.64.53.85.27.19.74.21.94-.06.11-.15.08-.33.05-.43a.78.78 0 0 0-.42-.5c-.31-.13-.72-.07-1.1.14z\" fill=\"#8334c2\"/><path d=\"M48.79 58.66c.36.15.78.26.97.59.26.45.05 1.21.53 1.41.35.14.71-.18 1.08-.21.39-.02.72.28 1.01.54.3.26.7.5 1.06.35.31-.14.43-.51.47-.85s.04-.7.24-.98c.18-.26.5-.39.77-.55s.55-.42.53-.74c-.02-.36-.39-.59-.74-.7-.35-.1-.73-.16-.99-.41-.28-.28-.31-.72-.41-1.11s-.39-.81-.79-.77c-.36.04-.58.44-.93.52-.47.11-.85-.37-1.32-.5-1.41-.39-.84 1.1-1.06 1.66-.22.57-2.01 1.09-.42 1.75z\" fill=\"#fff\"/><path d=\"M52.54 60.41c.02-.48.02-.99-.36-1.31-.64-.56-1.84-.75-2.66-.77-.71-.01-1.42.12-2.13.06s-1.46-.36-1.79-.98c-.45-.84-.01-1.91-.29-2.82-.31-1.02-1.42-1.58-1.98-2.5s-.49-2.07-.61-3.15a8.24 8.24 0 0 0-2.68-5.13c-1.23-1.11-2.96-1.83-4.4-2.66l-11.97-6.91-4 2.32 11.17 6.45 4.37 2.52c.73.42 1.45.64 1.91 1.39.55.91.76 1.98.87 3.02.16 1.4.2 2.86.78 4.14.49 1.06 1.32 1.94 1.74 3.02.36.93.41 1.97.91 2.83.72 1.23 2.17 1.78 3.53 2.21 1.25.4 3.55.96 3.57 2.52l-.01 3.76-.02 6.3v.08l4-2.32v-1.47l.03-10.2.02-.4z\" fill=\"url(#S)\"/><path d=\"M39.17 48.51c.32 1.06.21 2.2.22 3.31 0 1.14.16 2.38.94 3.22.43.47 1.04.79 1.33 1.37.39.77.07 1.73.33 2.55.24.75.94 1.29 1.7 1.5s1.57.15 2.35.03c.62-.1 1.6-.3 2.11.21.5.49.39 1.76.38 2.43L48.5 74.8 19.63 58.13l.06-21.57 10.89 6.29 4.64 2.51 1.84 1.14c.85.62 1.73.86 2.08 1.91l.03.1z\" fill=\"url(#T)\"/><path d=\"M43.67 36.07c-.21.52-.26 1.1-.52 1.59-.18.34-.47.62-.65.95-.19.34-.26.79-.02 1.09.28.35.84.34 1.17.65.7.66-.12 2.19.73 2.64.29.15.65.07.97.15 1.07.27 1.02 1.94 1.92 2.58.5.35 1.21.29 1.75.01s.96-.75 1.37-1.21c.47-.53.96-1.13.92-1.83-.03-.42-.25-.83-.23-1.25.03-.59.52-1.04.93-1.47s.78-1.04.54-1.58c-.28-.63-1.22-.73-1.53-1.34-.34-.68.28-1.54-.05-2.23-.33-.68-1.29-.66-2.03-.53-1.73.3-4.44-.21-5.27 1.78z\" fill=\"#fff\"/><path d=\"M45.49 53.26c-.25 0-.51-.08-.75-.23-.42-.27-.71-.72-.76-1.19-.07-.59.16-1.23.63-1.76-.34-.09-.7-.09-1.04 0-.85.24-1.5 1.08-1.51 1.97 0 .2-.17.37-.37.37s-.37-.17-.37-.37c.01-1.2.89-2.35 2.05-2.67.62-.17 1.28-.1 1.87.15 1.39-.96 3.39-.92 4.71.16.16.13.18.36.05.52s-.36.18-.52.05c-.97-.79-2.45-.88-3.54-.3a2.63 2.63 0 0 1 .56.64c.28.45.39.95.33 1.39-.08.56-.46 1.03-.95 1.2-.13.05-.26.07-.39.07zm-.17-2.85c-.43.41-.66.91-.61 1.35a.92.92 0 0 0 .42.65c.1.06.3.16.51.09.23-.08.42-.32.46-.6s-.04-.6-.22-.9c-.14-.24-.33-.44-.56-.59z\" fill=\"#8334c2\"/></g></g><defs><linearGradient id=\"A\" x1=\"46.439\" y1=\"80.484\" x2=\"50.573\" y2=\"80.484\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"43.617\" y1=\"76.119\" x2=\"54.273\" y2=\"76.119\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"44.757\" y1=\"70.352\" x2=\"52.311\" y2=\"70.352\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"73.758\" y1=\"65.122\" x2=\"77.892\" y2=\"65.122\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"68.652\" y1=\"60.757\" x2=\"83.155\" y2=\"60.757\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"72.077\" y1=\"54.991\" x2=\"79.631\" y2=\"54.991\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"22.616\" y1=\"67.504\" x2=\"26.75\" y2=\"67.504\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"19.56\" y1=\"63.14\" x2=\"30.82\" y2=\"63.14\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"20.935\" y1=\"57.373\" x2=\"28.488\" y2=\"57.373\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"39.156\" y1=\"39.483\" x2=\"88.24\" y2=\"39.483\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"27.666\" y1=\"38.321\" x2=\"87.47\" y2=\"38.321\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"21.568\" y1=\"49.216\" x2=\"163.658\" y2=\"49.216\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"32.163\" y1=\"61.498\" x2=\"107.952\" y2=\"61.498\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"23.936\" y1=\"60.199\" x2=\"52.491\" y2=\"60.199\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"18.583\" y1=\"27.626\" x2=\"64.457\" y2=\"27.626\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"33.89\" y1=\"21.524\" x2=\"38.94\" y2=\"21.524\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"18.233\" y1=\"30.669\" x2=\"93.325\" y2=\"30.669\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"R\" x1=\".719\" y1=\"32.183\" x2=\"105.511\" y2=\"32.183\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"S\" x1=\"3.148\" y1=\"54.52\" x2=\"60.768\" y2=\"54.52\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"T\" x1=\"15.654\" y1=\"55.681\" x2=\"63.653\" y2=\"55.681\" xlink:href=\"#X\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"U\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"V\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><path id=\"W\" d=\"M47.06 79.62c.82-.46 2.13-.45 2.92.03.8.48.78 1.23-.04 1.69s-2.13.45-2.92-.03c-.79-.47-.77-1.23.04-1.69z\"/><linearGradient id=\"X\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeInjuriesFamily = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#I)\"><g clip-path=\"url(#J)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M69.8 62.22c.023-.12.06-.238.11-.35.03-.08.08-.13.12-.19.09-.12.19-.23.31-.3L59.4 67.73c-.12.07-.22.18-.31.3-.01.02-.03.02-.04.04-.03.04-.05.09-.08.14-.02.04-.03.08-.04.11l-.03.11-.03.1c0 .01-.01.03-.01.04 0 .02-.01.04-.01.05-.01.03-.01.06-.01.1 0 .03-.01.06-.01.1 0 .03 0 .06-.01.09v.1l-.03 11.26c0 .15-.01.3-.04.43-.03.14-.06.26-.11.36-.03.07-.08.12-.12.18-.09.12-.19.23-.31.3l10.94-6.36c.12-.07.22-.18.31-.3.01-.02.03-.02.04-.04.03-.04.05-.09.08-.14v-.02c.02-.03.03-.07.04-.1l.03-.1.03-.1c0-.01.01-.03.01-.04 0-.02.01-.04.01-.05.01-.03.01-.06.01-.09s.01-.06.01-.1c0-.03 0-.06.01-.09v-.1l.03-11.26c0-.16.01-.3.04-.43z\" fill=\"url(#A)\"/><path d=\"M50.11 26.92c-.11.02-.22.03-.34.02-.13-.01-.25-.04-.38-.08s-.26-.11-.4-.19l-9.79-5.65c-.02-.01-.04-.02-.06-.04-.03-.01-.05-.03-.08-.04s-.05-.03-.08-.04l-.08-.03-.08-.03c-.01 0-.01 0-.02-.01-.03-.01-.05-.01-.07-.02-.03-.01-.05-.02-.08-.02-.03-.01-.05-.01-.08-.02s-.06-.01-.09-.01c-.02 0-.04 0-.06-.01h-.03-.09-.1a.36.36 0 0 0-.11.02c-.05.01-.09.02-.13.04-.06.02-.11.04-.16.07l-10.94 6.36a1.02 1.02 0 0 1 .29-.11c.1-.02.22-.03.33-.02.13.01.25.04.38.08.14.04.27.11.41.18l9.79 5.65c.02.01.04.02.06.04.03.01.06.03.08.04.03.01.05.03.08.04l.08.03.08.03c.03.01.05.01.07.02.03.01.06.02.08.02.03.01.05.01.08.02s.06.01.09.01c.02 0 .04 0 .06.01h.03.09.1a.36.36 0 0 0 .11-.02c.05-.01.09-.02.13-.04.06-.02.11-.04.16-.07l10.94-6.36c-.07.07-.17.1-.27.13z\" fill=\"url(#B)\"/><path d=\"M83.6 48.86v-.1c0-.03 0-.06-.01-.1 0-.03-.01-.07-.01-.1s-.01-.07-.01-.1-.01-.06-.02-.09-.01-.07-.02-.1-.02-.07-.02-.1l-.03-.11c-.01-.026-.017-.053-.02-.08v-.03l-.03-.1c-.01-.03-.02-.07-.04-.1-.01-.03-.02-.07-.04-.1-.01-.03-.03-.07-.04-.1-.01-.02-.02-.05-.03-.07 0-.02 0-.02-.01-.03-.01-.03-.03-.07-.04-.1l-.05-.11-.06-.12c-.02-.04-.05-.08-.07-.12 0-.01-.01-.01-.01-.02-.01-.01-.01-.02-.02-.03l-.15-.24-.12-.17-.09-.12c-.03-.03-.05-.06-.08-.1-.03-.03-.05-.06-.08-.09s-.05-.06-.08-.09l-.02-.02c-.02-.02-.04-.05-.06-.07l-.08-.08c-.03-.03-.06-.05-.09-.08s-.06-.05-.09-.08c-.01-.01-.03-.02-.04-.03-.02-.02-.03-.03-.05-.04-.03-.02-.06-.04-.09-.07l-.09-.06c-.03-.02-.06-.04-.08-.06-.03-.02-.06-.03-.08-.05-.01 0-.01-.01-.02-.01l-9.79-5.65c-.14-.08-.27-.17-.4-.28a4.28 4.28 0 0 1-.38-.35c-.13-.13-.24-.27-.34-.41l-.29-.44c-.1-.16-.18-.32-.25-.48a4.88 4.88 0 0 1-.18-.49c-.05-.17-.09-.33-.11-.49a2.7 2.7 0 0 1-.04-.49l.03-11.25v-.09-.1c0-.03 0-.06-.01-.1 0-.03-.01-.07-.01-.1s-.01-.07-.01-.1c-.01-.03-.01-.07-.02-.1s-.01-.07-.02-.1-.02-.07-.02-.1l-.03-.11c-.01-.03-.02-.05-.02-.08 0-.02 0-.02-.01-.03l-.03-.1c-.01-.03-.02-.07-.04-.1-.01-.03-.02-.06-.04-.1-.01-.03-.03-.06-.04-.1-.01-.02-.02-.05-.03-.07 0-.02-.01-.02-.01-.03-.01-.03-.03-.06-.04-.1-.02-.03-.03-.07-.05-.1l-.06-.12c-.02-.04-.05-.08-.07-.13 0-.01-.01-.01-.01-.02-.01-.01-.01-.02-.02-.03l-.15-.23-.13-.18-.09-.11c-.03-.03-.05-.06-.08-.09s-.05-.06-.08-.09-.05-.06-.08-.09l-.02-.02-.07-.07-.08-.08c-.03-.03-.06-.06-.09-.08-.03-.03-.06-.05-.09-.08-.02-.01-.03-.03-.05-.04l-.04-.04c-.03-.02-.06-.05-.09-.07l-.09-.06-.09-.06c-.03-.02-.06-.04-.09-.05-.01 0-.01-.01-.02-.01L53 13.12c-.02-.01-.04-.02-.06-.04-.03-.01-.06-.03-.08-.04-.03-.01-.05-.03-.08-.04l-.08-.03-.08-.03c-.04-.01-.06-.01-.08-.02-.03-.01-.06-.02-.08-.02-.03-.01-.06-.01-.08-.02-.03-.01-.06-.01-.09-.01-.02 0-.04 0-.06-.01h-.03-.09-.1c-.04 0-.08.01-.12.02-.05.01-.09.02-.14.04-.06.02-.11.05-.16.07l-10.94 6.36c.09-.05.19-.09.3-.11a1.27 1.27 0 0 1 .34-.02c.13.01.25.04.38.08.14.04.28.11.41.19l14.86 8.58c.14.08.27.17.4.28a4.26 4.26 0 0 1 .38.35c.13.14.24.27.34.41l.29.44c0 .01.01.01.01.02.09.15.16.3.23.46l.18.5c.05.163.087.331.11.5.03.16.04.33.04.48l-.03 11.25v.09.1c0 .03 0 .06.01.1 0 .03.01.06.01.1 0 .03.01.07.01.1 0 .04.01.07.02.1s.01.07.02.1.02.07.02.1l.03.11.03.09.03.12c.01.03.02.07.04.1.011.034.024.068.04.1.01.03.03.06.04.1l.03.08c.01.04.03.07.04.11l.05.11.06.12c.02.05.05.09.08.14 0 .01.01.01.01.02s.01.01.01.02l.15.24.13.18c.03.05.06.08.08.12.03.03.05.06.08.1.03.03.05.06.08.09s.05.06.08.09l.02.02.07.07.08.08c.03.03.06.06.09.08.03.03.06.05.09.08.02.01.03.03.05.04l.04.04c.03.02.06.05.09.07l.09.06.09.06c.03.02.06.04.09.05.01 0 .01.01.02.01l9.79 5.65c.138.078.268.169.39.27.14.11.26.23.37.35.13.14.24.27.34.41l.29.44c0 .01.01.02.01.02a3.28 3.28 0 0 1 .23.46 4.82 4.82 0 0 1 .18.49c.05.163.087.331.11.5a2.7 2.7 0 0 1 .04.49l-.05 17.08c0 .15-.01.3-.04.43-.03.14-.06.26-.11.36-.03.08-.08.13-.12.19-.09.12-.19.23-.31.3l10.94-6.36c.12-.07.22-.18.31-.3.01-.02.03-.02.04-.04.03-.04.05-.09.07-.14v-.02c.02-.03.03-.07.04-.1l.03-.1.03-.1c0-.01.01-.03.01-.04 0-.02.01-.04.01-.05.01-.03.01-.06.01-.09s.01-.06.01-.1c0-.03 0-.06.01-.09v-.1l.05-17.09c.03-.05.03-.08.03-.11z\" fill=\"url(#C)\"/><path d=\"M56.94 28.08c1.1.64 1.99 2.17 1.98 3.44l-.03 11.25c0 1.27.89 2.81 1.99 3.44l9.79 5.65c1.09.63 1.99 2.18 1.98 3.45l-.05 17.08c0 1.27-.9 1.77-2 1.14l-9.79-5.65c-1.1-.64-2-.12-2.01 1.14l-.03 11.25c0 1.26-.89 1.78-2 1.14l-14.86-8.58c-1.1-.64-2-2.19-1.99-3.44l.03-11.25c0-1.27-.88-2.81-1.98-3.45l-9.79-5.65c-1.1-.64-1.99-2.17-1.98-3.44l.05-17.08c0-1.27.89-1.79 2-1.15l9.79 5.65c1.1.64 1.99.13 2-1.14l.03-11.25c0-1.27.9-1.77 2.01-1.13l14.86 8.58z\" fill=\"url(#D)\"/><path d=\"M39.89 71.19c.01-.07.03-.13.06-.19a.88.88 0 0 1 .06-.1c.05-.07.1-.12.17-.16l-5.9 3.43c-.07.04-.12.1-.17.16-.01.01-.02.01-.02.02-.01.02-.03.05-.04.07s-.02.04-.02.06c-.01.02-.01.04-.02.06s-.01.04-.01.05v.03c0 .04-.01.05-.01.07s0 .03-.01.05v.05.05l-.02 6.06c-.001.077-.008.154-.02.23s-.03.14-.06.2a.88.88 0 0 1-.06.1c-.05.07-.1.12-.17.16l5.9-3.43c.07-.04.12-.1.17-.16.01-.01.02-.01.02-.02.01-.02.03-.05.04-.07s.02-.04.02-.05c.01-.02.01-.04.02-.06s.01-.04.01-.05v-.03c0-.04.01-.05.01-.07s0-.03.01-.05v-.05-.05l.02-6.06a1.95 1.95 0 0 1 .02-.25z\" fill=\"url(#E)\"/><path d=\"M29.28 52.17c-.06.01-.12.01-.18.01l-.2-.04c-.07-.02-.14-.06-.22-.1l-5.28-3.05c-.01-.01-.02-.01-.03-.02s-.03-.02-.04-.02c-.01-.01-.03-.01-.04-.02s-.03-.01-.04-.02-.03-.01-.04-.02c-.02 0-.03-.01-.04-.01s-.03-.01-.04-.01-.03-.01-.04-.01c-.02 0-.03-.01-.05-.01h-.03-.06-.06c-.02 0-.04 0-.06.01s-.05.01-.07.02c-.03.01-.06.02-.09.04l-5.9 3.43a.44.44 0 0 1 .16-.06c.06-.01.12-.01.18-.01l.2.04c.07.02.14.06.22.1l5.28 3.05c.01.01.02.01.03.02s.03.02.04.02c.01.01.03.01.04.02s.03.01.04.02.03.01.04.02c.02 0 .03.01.04.01s.03.01.04.01.03.01.04.01c.02 0 .03.01.05.01h.03.06.06c.02 0 .04 0 .06-.01s.05-.01.07-.02c.03-.01.06-.02.09-.04l5.9-3.43a.44.44 0 0 1-.16.06z\" fill=\"url(#F)\"/><path d=\"M47.33 64v-.05-.05c0-.02 0-.04-.01-.05 0-.02 0-.04-.01-.05 0-.02-.01-.03-.01-.05s-.01-.04-.01-.06-.01-.04-.01-.06-.01-.04-.02-.06c0-.01-.01-.03-.01-.04-.01-.03-.01-.05-.02-.07s-.01-.04-.02-.06-.01-.04-.02-.05c-.01-.02-.01-.04-.02-.05s-.01-.03-.02-.04c-.01-.03-.02-.05-.02-.06l-.03-.06-.03-.06c-.01-.02-.02-.04-.04-.07-.01-.02-.02-.02-.02-.03-.03-.04-.05-.09-.08-.13-.02-.03-.04-.06-.07-.09-.02-.02-.03-.04-.05-.06-.01-.02-.03-.03-.04-.05s-.03-.03-.04-.05-.03-.03-.04-.05c-.02-.02-.03-.03-.04-.05s-.03-.03-.05-.04-.03-.03-.05-.04-.03-.03-.05-.04l-.02-.02c-.02-.01-.02-.01-.03-.02-.02-.01-.03-.02-.05-.04-.02-.01-.03-.02-.05-.03-.01-.01-.03-.02-.04-.03s-.03-.02-.04-.03l-5.29-3.06c-.076-.041-.147-.091-.21-.15l-.2-.18-.18-.22c-.06-.08-.11-.16-.16-.24l-.13-.26c-.04-.09-.07-.18-.1-.26-.029-.088-.05-.178-.06-.27l-.02-.26.02-6.06v-.05-.05-.05c0-.02 0-.04-.01-.05 0-.02 0-.04-.01-.05 0-.02-.01-.04-.01-.05 0-.02-.01-.04-.01-.06s-.01-.04-.01-.06-.01-.04-.01-.06c0-.01-.01-.03-.01-.04-.01-.03-.01-.05-.02-.07s-.01-.04-.02-.05c-.01-.02-.01-.03-.02-.05s-.01-.03-.02-.05c-.01-.01-.01-.03-.02-.04-.01-.03-.02-.04-.02-.06l-.03-.06-.03-.06c-.01-.02-.03-.05-.04-.07l-.02-.02c-.03-.04-.05-.09-.08-.13l-.07-.1c-.02-.02-.03-.04-.05-.06-.01-.02-.03-.03-.04-.05s-.03-.03-.04-.05-.03-.03-.04-.05l-.04-.04c-.01-.02-.03-.03-.05-.04s-.03-.03-.05-.04-.03-.03-.05-.04c-.01-.01-.02-.01-.03-.02-.02 0-.02-.01-.03-.01-.02-.01-.03-.02-.05-.04-.02-.01-.03-.02-.05-.03s-.03-.02-.05-.03-.03-.02-.05-.03l-8.02-4.63c-.01-.01-.02-.01-.03-.02s-.03-.02-.04-.02c-.01-.01-.03-.01-.04-.02s-.03-.01-.04-.02-.03-.01-.04-.02c-.02 0-.03-.01-.04-.01-.02 0-.03-.01-.04-.01s-.03-.01-.04-.01c-.02 0-.03-.01-.05-.01h-.03-.06-.06c-.02 0-.04 0-.06.01s-.05.01-.07.02c-.03.01-.06.02-.09.04l-5.9 3.43a.44.44 0 0 1 .16-.06c.06-.01.12-.01.18-.01l.21.04c.07.02.14.06.22.1l8.01 4.62c.076.041.147.091.21.15l.2.18.18.22c.06.08.11.16.16.24.06.09.1.17.14.26s.07.17.1.26c.03.1.05.19.06.27l.02.26-.02 6.06v.05.05.05c-.002.017.002.035.01.05 0 .02 0 .04.01.05 0 .02.01.03.01.05s.01.04.01.06.01.04.01.06.01.04.01.06.01.03.01.05c.01.03.01.05.02.07s.01.04.02.05c.01.02.01.03.02.05s.01.03.02.05c.01.01.01.03.02.04.01.03.02.04.02.06l.03.06.03.06c.01.03.03.05.04.07.03.06.05.11.08.15.02.03.04.07.07.1.01.02.03.04.04.06s.03.03.04.05.03.03.04.05.03.03.04.05l.04.04.05.05c.02.02.03.03.05.04s.03.03.05.04c.01.01.02.01.03.02.02 0 .02.01.03.01.02.01.03.02.05.04.02.01.03.02.05.03s.03.02.05.03.03.02.05.03l5.29 3.06c.07.04.14.09.21.15.08.06.14.12.21.18l.18.22c.06.08.11.15.15.24.06.09.1.18.14.26l.1.27a1.32 1.32 0 0 1 .06.27l.02.26-.03 9.2c-.001.077-.008.154-.02.23s-.03.14-.06.2a.87.87 0 0 1-.06.1c-.05.07-.1.12-.17.16l5.9-3.43c.07-.04.12-.1.17-.16.01-.01.02-.01.02-.02.01-.02.03-.05.04-.07s.02-.04.02-.05c.01-.02.01-.04.02-.06s.01-.04.01-.05v-.03c0-.04.01-.05.01-.07s0-.03.01-.05v-.05-.05l.03-9.2-.01-.1z\" fill=\"url(#G)\"/><path d=\"M32.96 52.79c.59.34 1.07 1.17 1.07 1.85l-.02 6.06c0 .68.48 1.51 1.07 1.86l5.28 3.05a2.37 2.37 0 0 1 1.07 1.86l-.03 9.2c0 .68-.49.95-1.08.61l-5.28-3.05c-.59-.34-1.08-.07-1.08.62l-.02 6.06c0 .68-.48.96-1.08.61l-8.01-4.62c-.59-.34-1.08-1.18-1.07-1.86l.02-6.06c0-.68-.47-1.51-1.07-1.86l-5.28-3.05c-.59-.34-1.07-1.17-1.07-1.85l.03-9.2c0-.68.48-.96 1.08-.62l5.28 3.05c.59.34 1.07.07 1.08-.61l.02-6.06c0-.68.49-.95 1.08-.61l8.01 4.62z\" fill=\"url(#H)\"/></g></g><defs><linearGradient id=\"A\" x1=\"33.325\" y1=\"71.461\" x2=\"79.442\" y2=\"71.461\" xlink:href=\"#K\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"17.161\" y1=\"27.018\" x2=\"73.858\" y2=\"27.018\" xlink:href=\"#K\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"-3.874\" y1=\"43.265\" x2=\"112.679\" y2=\"43.265\" xlink:href=\"#K\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"19.946\" y1=\"50.452\" x2=\"128.658\" y2=\"50.452\" xlink:href=\"#K\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"19.888\" y1=\"76.174\" x2=\"46.98\" y2=\"76.174\" xlink:href=\"#K\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"11.325\" y1=\"52.223\" x2=\"41.879\" y2=\"52.223\" xlink:href=\"#K\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\".315\" y1=\"60.978\" x2=\"60.829\" y2=\"60.978\" xlink:href=\"#K\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"11.615\" y1=\"64.852\" x2=\"76.887\" y2=\"64.852\" xlink:href=\"#K\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"I\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"J\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"K\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeInjuriesFreetime = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#Q)\"><g clip-path=\"url(#R)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M44.1 30.67l8.44 4.9L28.58 49.4l-8.44-4.9L44.1 30.67z\" fill=\"url(#A)\"/><path d=\"M44.08 24.35l8.44 4.91-23.94 13.82-8.44-4.9 23.94-13.83z\" fill=\"url(#B)\"/><path d=\"M52.54 35.57l-.02-6.31-23.94 13.82v6.32l.07 25.27 23.96-13.84-.07-25.26z\" fill=\"url(#C)\"/><path d=\"M28.58 49.4v-6.32l-8.44-4.9v6.32l.07 25.27 8.44 4.9-.07-25.27z\" fill=\"url(#D)\"/><g fill=\"#fff\"><path d=\"M28.54 49.46l-8.43-4.9.06-.12 8.44 4.91-.07.11z\"/><path d=\"M28.61 49.46l-.07-.11 23.97-13.84.06.12-23.96 13.83z\"/><path d=\"M28.58 74.67l-.07-25.27h.13l.07 25.27h-.13z\"/></g><path d=\"M43.27 54.25c.29-.17.53-.03.53.31l.01 3.17a1.2 1.2 0 0 1-.52.92l-5.17 2.99c-.3.17-.54.04-.54-.31l-.01-3.17c0-.34.24-.75.53-.92l5.17-2.99z\" fill=\"url(#E)\"/><path d=\"M46.92 51.21c1.49-.86 2.72-.17 2.73 1.56 0 1.72-1.22 3.82-2.71 4.69l-12.48 7.2c-1.5.87-2.72.17-2.73-1.54 0-1.73 1.21-3.83 2.71-4.7l12.48-7.21zm-3.11 6.53l-.01-3.17c0-.34-.24-.48-.53-.31l-5.17 2.99c-.3.17-.53.58-.53.92l.01 3.17c0 .34.24.48.54.31l5.17-2.99a1.2 1.2 0 0 0 .52-.92z\" fill=\"#fff\"/><path d=\"M42.12 39.52l.02 6.82-2.55 1.48-.02-6.83 2.55-1.47z\" fill=\"url(#F)\"/><path d=\"M39.59 47.82l-.33-.19-.02-6.83.33.19.02 6.83z\" fill=\"url(#G)\"/><path d=\"M39.57 40.99l-.33-.19 2.55-1.47.33.19-2.55 1.47z\" fill=\"url(#H)\"/><path d=\"M46.6 71.87l-.09-.92.02.45c.001.051.008.101.02.15v.02l.03.25.04.22-.02-.17z\" fill=\"url(#I)\"/><path d=\"M79.53 72.36l-.28.85c-.01.02-.02.03-.02.05-.03.06-.06.11-.08.17-.18.36-.37.71-.62 1.06-.14.19-.3.38-.46.56-.279.329-.58.64-.9.93l-.64.54c-.53.41-1.08.82-1.73 1.18-1.54.87-3.3 1.51-5.16 1.97l-.94.21-1.96.32-.93.11-1.51.08-2.12.01-.94-.05-.51-.03-2.08-.26-.64-.11-.54-.1-.27-.06-1.79-.49-.32-.09-.25-.08-.29-.09-.39-.13c-.06-.02-.13-.04-.19-.07-.96-.37-1.89-.78-2.73-1.28-2.93-1.73-4.49-3.94-4.71-6.19v.02l.02.16.04.27.05.28.08.39.1.36.17.53.02.05.09.24.06.15c.09.22.23.5.34.72l.29.51.21.3.25.35.28.4.48.56.7.67c.4.36.72.62 1.35 1.08l.82.52 1.03.56.28.13.31.16.36.15.02.01 1.08.42.2.07.18.06.42.13.26.09 1.12.3.21.05c.02 0 .03.01.05.01l.12.03c.02 0 .04.01.06.01l.68.15 1.16.19.21.02.95.11 1.18.09.26.01h.09l.83.02 1.18-.02.44-.03h.07l.67-.04 1.18-.13 1.16-.18 1.16-.23 1.11-.28.6-.18.38-.12c.04-.01.08-.03.12-.04.01 0 .02-.01.03-.01l1.05-.39.08-.04c1.84-.74 3.46-1.74 4.74-2.99l.05-.05c.35-.34.66-.71.96-1.09.02-.03.05-.06.07-.09l.1-.13.07-.11.18-.26.39-.64c.03-.05.05-.1.08-.15l.01-.02c0-.01.02-.05.03-.07s.03-.05.04-.07l.24-.52.07-.18.07-.18c.02-.05.04-.09.05-.13l.01-.03c0-.01.01-.01.01-.02v-.01c.02-.05.03-.1.05-.15l.01-.04.06-.2.01-.05.11-.42.08-.35.03-.17.04-.27c0 .01-.01.01-.01.02.01-.05.02-.1.02-.14l.01-.05c0-.05.01-.11.02-.16.01.36-.14.72-.24 1.07z\" fill=\"url(#J)\"/><path d=\"M79.81 64.22l-.03-11.06-.06-19.95v-.24.19c0-.36-.04-.82-.06-1.17l-.03-.2-.08-.57v-.01c-.01-.05-.01-.11-.02-.15V31l-.01-.05v-.02c-.01-.05-.03-.1-.04-.15l-.03-.13c-.01-.03-.01-.05-.02-.07l-.1-.43-.02-.09v-.01l-.13-.44-.01-.02-.32-.94c-.06-.16-.14-.3-.21-.45-.17-.37-.35-.74-.57-1.09-.12-.19-.26-.36-.39-.54-.02-.02-.03-.05-.05-.07l-.07-.11-.07-.09-.69-.84-.45-.46-.28-.29-.18-.15c-.04-.03-.08-.08-.11-.11a1.67 1.67 0 0 1-.14-.13c-2.91-2.6-7.03-3.9-11.32-4.05h-.02c-.22-.01-.41-.02-.61-.02h-.52c-.31 0-.7.01-.99.02l-1.07.07-1.05.11h.03l-.05.01-.63.1-.33.05-.09.01-1.07.22-.39.1c-.1.02-.19.05-.29.07l-.35.09-.53.17-.29.09c-.04.01-.07.02-.11.03l.18-.06-.32.11-.23.09-.27.09c-.06.03-.1.04-.16.07l-.33.13c-.74.31-.77.32-2.01.97-.32.18-.74.45-1.05.65l-.84.56c-.03.03-.07.07-.11.1-.05.04-.09.08-.14.12l-.72.62-.66.68c-.07.08-.13.16-.2.25l-.68.87-.15.23-.27.42-.11.17c-.12.22-.25.48-.37.75-.08.18-.17.36-.24.53-.03.06-.06.12-.08.18l-.32.96c-.23.84-.24.92-.42 2.3l-.04 1.12.11 37.56c.01 2.42 1.58 4.84 4.73 6.71.834.491 1.707.913 2.61 1.26.01 0 .01.01.02.01a21.52 21.52 0 0 0 2.01.67c.19.05.39.09.59.14l.51.12c.22.05.43.11.65.16.54.11 1.09.2 1.64.28.12.02.24.02.36.04s.25.03.37.04c.29.03.58.07.88.09.54.04 1.08.07 1.63.08h.31.37l1.01-.01c.61-.02 1.23-.07 1.83-.13.02 0 .04-.01.07-.01l.22-.03c.6-.07 1.2-.15 1.79-.25.19-.03.36-.1.55-.14a22.54 22.54 0 0 0 1.47-.36c.31-.08.65-.14.95-.23.24-.08.46-.17.7-.26l.66-.24c.82-.32 1.62-.67 2.36-1.09.24-.13.46-.27.68-.41.31-.2.54-.43.82-.64.3-.23.62-.44.88-.68.07-.06.17-.12.24-.19.37-.36.7-.72.99-1.1.04-.05.06-.11.1-.16.05-.07.09-.14.14-.21.14-.2.29-.41.4-.62.17-.31.31-.62.43-.94.01-.03.01-.05.02-.08l.03-.12c.08-.24.15-.49.2-.73.06-.32.09-.63.1-.95v-.11l-.04-6.55zm-9.72-32.87l-.06.03c-.38.21-.79.39-1.21.56-.45.18-.89.32-1.32.45-.76.22-1.54.39-2.35.49-.12.01-.23.04-.35.05-.44.05-.89.06-1.33.07-.28.01-.57.01-.86.01-2.46-.06-4.9-.63-6.75-1.73-1.82-1.08-2.74-2.47-2.82-3.86-.01-.23.01-.46.04-.69.02-.16.04-.33.09-.49.07-.24.18-.47.31-.7.08-.15.14-.3.24-.45.17-.25.39-.49.62-.72.11-.12.2-.24.33-.35a8.28 8.28 0 0 1 1.37-.97c.62-.35 1.32-.63 2.04-.87.2-.07.41-.12.61-.18a13.35 13.35 0 0 1 1.82-.39c.18-.03.35-.07.53-.09a17.02 17.02 0 0 1 2.37-.12c.17 0 .34.02.52.03.637.031 1.271.098 1.9.2.3.05.59.09.88.16.16.03.29.07.45.1 1.13.29 2.2.7 3.11 1.24.448.258.867.563 1.25.91.12.11.2.23.31.34 2.12 2.23 1.56 5.09-1.74 6.97zm9.43-.38c0-.01 0 .01.01.02l-.01-.02z\" fill=\"url(#K)\"/><path d=\"M73.1 22.23c0 .36-.06.72-.18 1.08-.01.02-.01.05-.02.07-.12.34-.29.67-.51.99-.03.04-.05.09-.08.13-.22.3-.49.59-.8.87-.16.14-.35.28-.53.41l-.91.63c-.61.35-1.3.62-2.01.86l-.81.24-.89.22-1.41.23c-.05.01-.09.01-.14.02a17.13 17.13 0 0 1-1.76.09h-.22l-1.7-.1-.23-.02-1.6-.28-.31-.07c-.55-.14-1.08-.3-1.58-.49-.56-.22-1.09-.47-1.58-.76-1.9-1.13-2.85-2.59-2.86-4.05l.01 4.94c0 1.46.95 2.93 2.86 4.05.49.29 1.02.54 1.58.76.4.16.81.3 1.23.41l.36.09c.1.03.2.05.31.07l.39.09.99.17c.07.01.15.01.22.02l.23.02.53.06.98.05h.19.22l.61-.01 1.11-.08c.01 0 .03 0 .04-.01.05 0 .09-.01.14-.02l1.08-.15c.11-.02.22-.06.33-.08l.89-.22.58-.14c.08-.03.15-.07.23-.1.71-.24 1.4-.51 2.01-.86l.41-.25c.19-.12.35-.23.51-.36l.51-.42c.04-.04.1-.09.15-.13.22-.21.42-.44.6-.66l.06-.1c.03-.04.05-.09.08-.13l.24-.37c.1-.19.19-.38.26-.57.01-.02.01-.03.01-.05.01-.02.01-.05.02-.07.05-.15.09-.29.12-.44.04-.187.06-.378.06-.57v-.07l-.02-4.94z\" fill=\"url(#L)\"/><path d=\"M56.01 18.1c3.98-2.25 10.35-2.22 14.22.08s3.8 5.99-.18 8.24-10.35 2.22-14.22-.08-3.79-5.98.18-8.24z\" fill=\"url(#M)\"/><path d=\"M74.11 20.72c-.01.04-.02.08-.04.12-.12.36-.31.71-.54 1.05l-.12.18c-.25.34-.54.67-.89.98-.23.21-.52.39-.79.59l-.7.5c-.68.39-1.43.7-2.22.98l-.85.26-1.13.28-1.36.23c-.11.01-.22.03-.33.05-.63.07-1.26.1-1.89.11h-.3l-1.87-.1-.28-.03c-.61-.07-1.22-.18-1.81-.31-.108-.021-.215-.047-.32-.08-.528-.128-1.049-.285-1.56-.47l-.28-.09a12.32 12.32 0 0 1-1.72-.81c-1.11-.64-1.94-1.38-2.5-2.17-.55-.79-.83-1.63-.83-2.47l-.01 4.9c0 1.68 1.1 3.36 3.32 4.64a12.92 12.92 0 0 0 1.63.78l.09.03c.09.04.19.06.28.09l1 .34.56.14.32.08.29.07 1.11.19c.13.02.27.03.4.04l.27.03.42.05 1.11.06v-.02.02h.35.29.51l1.25-.08c.05 0 .09-.01.14-.02.11-.01.22-.03.33-.05l.96-.13.41-.1 1.13-.28.6-.15c.09-.03.16-.08.25-.11.79-.27 1.54-.58 2.22-.98l.14-.08c.21-.13.37-.28.56-.41.27-.19.57-.38.79-.59.02-.02.05-.04.08-.06a6.1 6.1 0 0 0 .7-.75c.05-.06.08-.12.12-.18l.12-.19.21-.31c.12-.21.22-.42.3-.64l.03-.1.03-.12.12-.41c.04-.21.07-.43.07-.64v-.1l.01-4.9c.02.37-.06.76-.18 1.14z\" fill=\"url(#N)\"/><path d=\"M70.98 14.92c4.41 2.55 4.44 6.67.05 9.21s-11.5 2.55-15.91 0-4.44-6.67-.05-9.21 11.5-2.54 15.91 0z\" fill=\"url(#O)\"/><path d=\"M79.75 39.82c.01 2.51-1.66 5.03-5 6.93-6.57 3.75-17.12 3.72-23.56-.06-3.17-1.86-4.75-4.28-4.76-6.71l.11 24.45c.01 2.43 1.6 4.85 4.76 6.71 6.44 3.79 16.99 3.81 23.56.06 3.34-1.91 5.01-4.42 5-6.93l-.11-24.45z\" fill=\"#fff\"/><path d=\"M66.24 53.33c-1.94.23-3.93.25-5.88.07l-.02 5.89a27.72 27.72 0 0 1-3.44-.54l-1.64-.44-1.57-.55-.01 2.48-.01 2.48 1.57.55 1.64.44c1.12.25 2.27.44 3.44.54l-.01 2.95-.01 2.95c.981.09 1.965.13 2.95.12s1.97-.07 2.94-.19l.01-2.95.01-2.95 1.72-.26c1.7-.31 3.33-.79 4.81-1.44l.01-4.95c-1.98.86-4.21 1.42-6.54 1.7l.03-5.9z\" fill=\"url(#P)\"/></g></g><defs><linearGradient id=\"A\" x1=\"20.141\" y1=\"40.034\" x2=\"52.539\" y2=\"40.034\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"6.92\" y1=\"33.718\" x2=\"65.903\" y2=\"33.718\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"9.073\" y1=\"51.963\" x2=\"56.042\" y2=\"51.963\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"17.489\" y1=\"56.423\" x2=\"55.351\" y2=\"56.423\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"25.458\" y1=\"57.948\" x2=\"46.697\" y2=\"57.948\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"35.529\" y1=\"43.668\" x2=\"48.194\" y2=\"43.668\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"39.043\" y1=\"44.31\" x2=\"43.29\" y2=\"44.31\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"35.454\" y1=\"40.162\" x2=\"45.191\" y2=\"40.162\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"46.518\" y1=\"71.49\" x2=\"46.633\" y2=\"71.49\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"27.211\" y1=\"76.504\" x2=\"82.36\" y2=\"76.504\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"40.42\" y1=\"50.35\" x2=\"83.062\" y2=\"50.35\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"40.693\" y1=\"27.628\" x2=\"74.137\" y2=\"27.628\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"52.977\" y1=\"22.263\" x2=\"73.096\" y2=\"22.263\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"48.804\" y1=\"25.222\" x2=\"75.298\" y2=\"25.222\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"42.099\" y1=\"19.532\" x2=\"76.565\" y2=\"19.532\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"47.976\" y1=\"61.802\" x2=\"75.781\" y2=\"61.802\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"Q\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"R\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"S\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeInsuranceFamily = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#T)\"><g clip-path=\"url(#U)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M83.7 61.1l-.01.25-.01.21-.02.25-.02.21-.03.25-.03.21a2.24 2.24 0 0 1-.05.25l-.04.21-.05.25-.05.21-.07.25-.06.2c-.02.09-.05.17-.08.26l-.06.2-.09.26-.07.19-.15.39c-.01.02-.02.05-.03.07l-.2.45c-.02.05-.05.09-.07.14l-.15.31-.09.17-.15.27-.09.16-.18.31-.11.18-.18.29-.12.19-.2.28-.13.18-.22.29c-.04.05-.08.11-.13.16l-.41.5c-.02.03-.05.06-.07.08l-.37.41-.14.15-.36.37-.13.13-.5.48c-.06.06-.13.11-.19.17l-.25.22-.21.18-.26.22-.22.18-.26.21-.23.18-.27.21-.24.18-.28.2-.25.17-.29.2-.26.17-.3.19-.27.17-.3.19-.49.29-.74.42-.22.12-.59.31c-.07.03-.13.07-.2.1l-.78.38-.14.06-.67.3c-.08.04-.16.07-.24.1l-.66.28-.16.07-.82.32-.21.08-.66.24-.25.09-.8.27c-.02.01-.04.01-.06.02l-.73.23c-.05.02-.11.03-.16.05l-.57.17-.27.08-.47.13-.3.08-.45.12-.32.08-.43.1-.34.08-.43.1-.34.07-.43.09-.35.07-.42.08-.31.06-.72.12-.22.04-.93.14-.2.03-.75.1-.28.03-.78.09c-.06.01-.12.01-.18.02l-.85.08c-.05 0-.1.01-.14.01l-.71.05-.29.02-.56.03-.33.02-.53.02-.35.01-.45.01-.37.01-.45.01h-.36-.46-.36c-.16 0-.31-.01-.47-.01-.12 0-.23 0-.35-.01-.14 0-.29-.01-.43-.01-.12 0-.24-.01-.36-.01l-.44-.02-.36-.02-.45-.03-.34-.02-.47-.03-.33-.03-.49-.04-.3-.03-.55-.06-.23-.02-.78-.09c-.03 0-.06-.01-.09-.01l-.69-.09-.19-.03-.6-.09-.29-.05-.5-.08-.32-.06-.46-.08-.34-.07-.44-.09-.32-.07-.51-.11-.32-.07-.5-.12-.31-.08-.52-.13-.28-.07-.64-.18c-.05-.01-.1-.03-.15-.04l-.9-.27c-.08-.02-.16-.05-.24-.08l-.72-.23c-.07-.02-.13-.04-.2-.07l-.87-.31-.19-.07-.7-.27-.27-.11-.28-.12-.36-.15-.28-.12-.36-.16-.28-.12-.35-.16-.27-.13-.35-.17-.26-.13-.36-.19-.24-.12-.4-.21-.2-.11-.58-.33c-6.45-3.73-9.68-8.62-9.66-13.5l-.01 2.08c-.01 4.88 3.21 9.78 9.66 13.5l.58.33c.06.04.13.07.2.11l.4.21.24.12c.12.06.24.13.37.19.089.039.175.083.26.13.12.06.24.12.36.17.09.04.18.08.27.13.12.05.24.11.36.16l.28.12c.12.05.24.1.36.16l.28.12.36.15c.09.04.19.08.28.11.04.02.09.04.13.05.05.02.09.03.14.05l.7.27c.06.02.13.05.19.07l.87.31c.07.02.13.04.2.07l.72.23c.08.03.16.05.24.08l.9.27c.05.01.1.02.14.04l.64.18c.09.02.19.05.28.07l.52.13c.1.03.21.05.31.08l.5.12c.11.02.21.05.32.07.17.04.34.07.51.11.07.01.14.03.2.04.04.01.07.01.11.02l.44.09c.11.02.22.04.34.07.15.03.31.06.46.08l.32.06c.17.03.33.06.5.08.1.02.19.03.29.05l.6.09.18.03.7.09c.03 0 .06.01.09.01l.78.09.25.03.53.06.31.03c.16.01.32.03.48.04h.03a3.03 3.03 0 0 0 .31.02l.46.03c.12.01.23.01.35.02l.44.03c.12.01.24.01.36.02.14.01.29.01.43.02.12 0 .24.01.37.01.14 0 .29.01.43.01h.08.27c.16 0 .31.01.47.01h.36.46.36c.15 0 .3 0 .45-.01.12 0 .25 0 .37-.01.15 0 .3-.01.45-.01h.17c.06 0 .12-.01.18-.01.18-.01.35-.01.53-.02.11-.01.22-.01.33-.02l.56-.03c.1-.01.2-.01.29-.02l.71-.05c.05 0 .1-.01.14-.01.28-.02.56-.05.85-.08h.04c.05 0 .09-.01.14-.02l.78-.08.29-.03.75-.1.2-.03c.31-.04.62-.09.93-.14.08-.01.15-.02.23-.04l.72-.12.15-.03.16-.03c.14-.03.28-.05.42-.08.12-.02.23-.05.35-.07l.42-.09c.12-.02.23-.05.35-.07l.42-.09c.11-.03.23-.05.34-.08.14-.03.29-.07.43-.1.11-.03.22-.05.33-.08.15-.04.3-.08.44-.11.1-.03.21-.05.31-.08.16-.04.31-.09.47-.13.09-.03.19-.05.28-.08.19-.05.38-.11.57-.17.05-.02.11-.03.16-.05.24-.07.49-.15.73-.23.03-.01.04-.01.06-.02l.8-.27.25-.09.66-.24c.07-.03.14-.05.21-.08l.82-.32c.06-.02.11-.05.17-.07l.66-.28c.08-.03.16-.07.24-.1l.67-.3c.05-.02.09-.04.14-.06.26-.12.52-.25.78-.38.07-.03.13-.07.2-.1.2-.1.39-.2.59-.31.07-.04.15-.08.22-.12l.74-.42.4-.24.09-.06c.1-.06.2-.12.3-.19.09-.06.18-.11.27-.17.1-.06.2-.13.3-.19.09-.06.18-.11.26-.17l.29-.2c.08-.06.17-.12.25-.17.09-.07.19-.13.28-.2l.24-.18.27-.21c.08-.06.16-.12.23-.18.09-.07.17-.14.26-.21.07-.06.15-.12.22-.18.088-.068.171-.141.25-.22l.21-.18.25-.22c.06-.05.12-.1.17-.16l.02-.02.5-.48.13-.13.36-.37c.05-.05.09-.1.14-.15.13-.14.25-.28.37-.42.02-.03.05-.05.07-.08.14-.17.28-.33.41-.5.01-.01.02-.03.03-.04l.09-.12c.07-.1.15-.19.22-.29.04-.06.09-.12.13-.18.07-.09.13-.19.2-.28l.13-.19c.06-.1.12-.19.18-.29a1.75 1.75 0 0 0 .11-.18l.18-.31c.02-.04.05-.08.07-.12.01-.01.01-.02.02-.04l.15-.28c.03-.06.06-.12.09-.17l.15-.31c.02-.05.05-.09.07-.14.07-.15.14-.3.2-.45.01-.02.02-.05.03-.07.05-.13.11-.26.15-.39 0-.01 0-.01.01-.02.02-.06.04-.11.06-.17l.09-.26.06-.2c.03-.09.05-.17.08-.26l.06-.2c.02-.08.05-.17.07-.25.02-.07.03-.14.05-.21.02-.08.04-.16.05-.25 0-.01.01-.03.01-.04l.03-.16c.02-.08.03-.17.04-.25l.03-.21.03-.25c.012-.069.018-.14.02-.21.012-.083.019-.166.02-.25a1.57 1.57 0 0 0 .01-.22c0-.08.01-.16.01-.25v-.08-.29l.01-2.08a3.43 3.43 0 0 0-.03.42z\" fill=\"url(#A)\"/><path d=\"M74.04 47.23c12.83 7.4 12.89 19.41.15 26.82s-33.47 7.41-46.3 0S15 54.64 27.74 47.23c12.75-7.41 33.48-7.41 46.3 0z\" fill=\"url(#B)\"/><path d=\"M43.34 53.93c-.085.188-.196.363-.33.52-.22.27-.46.53-.73.77-.1.09-.21.19-.35.22-.15.04-.31.01-.47-.02l-.54-.13c-.05-.01-.1-.03-.12-.08s.02-.1.06-.14c.09-.11.19-.21.3-.31l.32-.29.33-.27.34-.26.34-.26.33-.27.32-.29.15-.15c.02-.02.09-.09.13-.06.02.02.01.07.01.09v.12.24a2.33 2.33 0 0 1-.07.46c.01.03 0 .07-.02.11z\" fill=\"url(#C)\"/><path d=\"M30.13 57.24l-.02.65c0 .14-.01.29.03.42.05.18.18.33.32.46.33.32.73.57 1.15.72.8.29 1.68.44 2.53.37 1.12-.09 2.26-.39 3.22-.97 1.27-.77 2.18-2.05 3.23-3.1.77-.76 1.62-1.43 2.48-2.1.33-.26.51-.65.59-1.06.07-.41.05-.83.02-1.25-2.43 1.09-4.36 3.06-6.16 5.02-.63.68-1.27 1.36-2.06 1.83-.8.47-1.78.69-2.65.38-.93-.33-1.7-1.23-2.68-1.37z\" fill=\"url(#D)\"/><path d=\"M36.34 38.59s.29 9.96-.72 11.82c-1 1.86-4.44 5.01-4.44 5.01s-1.79 1.71-.78 2.68 2.6 1.09 2.6 1.09 2.7.19 4.04-.79c1.33-.99 1.76-1.46 1.76-1.46s1.93-2.12 2.77-2.77l1.37-1.03s.67-.45.75-1.11c.07-.66.15-1.18-.06-2.35-.19-1.03-.73-2.08-.41-3.89s1.77-11.9 1.77-11.9.37-1.81-1.33-2.26-3.6-.52-5.1.3c-.59.32-1.06.72-1.42 1.09a3.18 3.18 0 0 0-.9 2.2l.02 1.13.08 2.24z\" fill=\"url(#E)\"/><path d=\"M40.35 35.73c1.01-.12 1.98-.46 2.87-.93.37-.2.74-.43 1.01-.76.26-.33.4-.79.25-1.19-.16-.45-.63-.72-1.09-.88-.86-.29-1.88-.38-2.78-.26-1.34.18-1.69.37-2.44.86-.32.21-.67.55-.93.83s-.44.64-.44 1.01c0 .24.09.48.25.66.08.09.18.15.28.22.03.03.07.05.1.07.06.03.13.05.19.08.276.101.561.178.85.23.29.06.59.09.88.1a6.61 6.61 0 0 0 .89-.03.41.41 0 0 0 .11-.01z\" fill=\"url(#F)\"/><path d=\"M51.55 52.15c-2.43 1.09-4.36 3.06-6.16 5.02-.63.68-1.27 1.36-2.06 1.83-.8.47-1.78.69-2.65.38-.93-.33-1.7-1.23-2.68-1.37l-.02.65c0 .14-.01.29.03.42.05.18.18.33.32.46.33.32.73.57 1.15.72.8.3 1.68.44 2.53.37 1.12-.09 2.26-.39 3.22-.97 1.27-.77 2.18-2.05 3.23-3.1.16-.16.34-.3.51-.46l.37.09c.15.03.32.06.47.02.13-.04.24-.13.35-.22a7.61 7.61 0 0 0 .73-.77c.134-.157.245-.332.33-.52.01-.04.03-.07.04-.11.05-.15.07-.3.07-.46v-.14c.1-.18.17-.39.21-.6.06-.4.03-.82.01-1.24z\" fill=\"url(#G)\"/><path d=\"M44.21 39.36s.29 9.96-.72 11.82-4.44 5.01-4.44 5.01-1.79 1.71-.78 2.68 2.6 1.09 2.6 1.09 2.7.19 4.04-.79 1.76-1.46 1.76-1.46 1.93-2.12 2.77-2.77l1.37-1.03s.67-.45.75-1.11c.07-.66.15-1.18-.06-2.35-.19-1.03-.73-2.08-.41-3.89s1.77-11.9 1.77-11.9.37-1.81-1.33-2.26-3.6-.52-5.1.3c-.59.32-1.06.72-1.42 1.09a3.18 3.18 0 0 0-.9 2.2l.02 1.13.08 2.24z\" fill=\"url(#H)\"/><path d=\"M50.78 48.05c.1-.09.21-.19.34-.17.1.02.17.11.22.2.15.27.16.6.18.91.01.18.01.37-.06.54-.08.17-.23.3-.38.41-.18.15-.37.29-.57.41s-.43.2-.66.21l.15-1.05c.02-.15.04-.31.02-.46-.02-.1-.05-.2-.11-.28-.01-.02-.03-.04-.05-.06-.01-.01-.04-.03-.04-.05-.01-.05.08-.06.11-.07.2-.08.39-.19.57-.31l.28-.23z\" fill=\"url(#I)\"/><path d=\"M48.21 36.51c1.01-.12 1.98-.46 2.87-.93.37-.2.74-.43 1.01-.76.26-.33.4-.79.25-1.19-.16-.45-.63-.72-1.09-.88-.86-.29-1.88-.38-2.78-.26-1.34.18-1.69.37-2.44.86-.32.21-.67.55-.93.83s-.44.64-.44 1.01c0 .24.09.48.25.66.08.09.18.15.28.22.03.03.07.05.1.07.06.03.13.05.19.08a5.09 5.09 0 0 0 .85.23c.29.06.59.09.88.1a6.61 6.61 0 0 0 .89-.03c.04-.01.08-.01.11-.01z\" fill=\"url(#J)\"/><path d=\"M50.32 49.23c-.04-.25-.14-.47-.3-.62a.87.87 0 0 0-.31-.2.83.83 0 0 0-.34-.06c-.1.01-.19.04-.26.07l-.02.01a1.51 1.51 0 0 0-.28.15c-.09.06-.18.14-.26.23a2.05 2.05 0 0 0-.41.73c-.09.27-.13.49-.11.71.02.3.16.57.37.74.17.13.38.2.6.2.11 0 .23-.02.34-.06.27-.09.51-.29.68-.56.13-.2.22-.45.27-.74.05-.23.06-.42.03-.6zm-1.17 1.31c-.12.04-.27.02-.35-.04s-.13-.17-.14-.3.01-.27.08-.46c.08-.22.17-.39.28-.52.05-.05.1-.1.15-.13s.1-.06.15-.08l.02-.01c.02-.01.06-.02.07-.03.01 0 .04 0 .08.02a.18.18 0 0 1 .09.06.52.52 0 0 1 .12.27 1.59 1.59 0 0 1-.54.26.3.3 0 0 0-.193.142.3.3 0 0 0-.027.238.31.31 0 0 0 .3.23c.03 0 .05 0 .08-.01.08-.02.17-.05.25-.08-.02.05-.05.1-.08.15-.08.14-.21.25-.34.29z\" fill=\"url(#K)\"/><path d=\"M42.17 65.78l-.03 1.45c0 .99 0 1 .3 1.4.43.58 1.08.92 1.76 1.16 1.31.47 2.7.49 4.1.48.68 0 1.37-.07 2.04-.23l.73-.21.7-.23 1.38-.53 1.34-.63 1.29-.73 1.24-.82 1.18-.9 1.03-.91c1.24-1.18 2.66-2.12 4.09-3.06.84-.55 1.72-1.06 2.44-1.76.41-.4.56-1.02.6-1.59s-.03-1.15-.1-1.72c-.02-.12-.07-.28-.19-.28-.14 0-.18.19-.17.33.04.99-.8 1.88-1.59 2.49s-1.73.98-2.65 1.36c-2.664 1.121-5.227 2.469-7.66 4.03-1.46.93-2.91 1.96-4.61 2.32-2.42.52-4.92-.49-7.22-1.42z\" fill=\"url(#L)\"/><path d=\"M54.97 55.74c1.49-.88 2.92-1.87 4.25-2.98.74-.62 1.5-1.3 2.45-1.51 1.05-.23 2.18.18 2.96.91s1.34 1.75 1.46 2.82l.19 2.38c-.01.39.04.73-.24 1.29-.56 1.13-2.26 1.8-3.36 2.41-1.91 1.06-3.66 2.52-5.35 3.9-3.47 2.82-8.23 4.12-12.62 3.29-.99-.19-1.97-.58-2.39-1.44-.34-.7-.16-1.39.31-2.01.46-.62 1.13-1.06 1.76-1.5a29.05 29.05 0 0 0 7.28-7.47c.36-.54.83-.78 1.47-.84.63-.05 1.34.32 1.83.75z\" fill=\"url(#M)\"/><path d=\"M57.64 59.29c-.38-1.27-1.17-2.42-2.22-3.23 1.33-.8 2.65-1.7 3.88-2.64.57-.43 1.12-.89 1.76-1.22.63-.33 1.36-.53 2.06-.42.53.08 1.03.51 1.28.98.29.53.2 1.21-.08 1.74-.28.54-.74.95-1.22 1.33-1.65 1.34-3.56 2.5-5.46 3.46z\" fill=\"url(#N)\"/><path d=\"M48.99 70.1l-.03 1.45c0 .99 0 1 .3 1.4.43.58 1.08.92 1.76 1.16 1.31.47 2.7.49 4.1.48.68 0 1.37-.07 2.04-.23l.73-.21.7-.23 1.38-.53 1.34-.63 1.29-.73 1.24-.82 1.18-.9 1.03-.91c1.24-1.18 2.66-2.12 4.09-3.06.84-.55 1.72-1.06 2.44-1.76.41-.4.56-1.02.6-1.59s-.03-1.15-.1-1.72c-.02-.12-.07-.28-.19-.28-.14 0-.18.19-.17.33.04.99-.8 1.88-1.59 2.49s-1.73.98-2.65 1.36c-2.66 1.12-5.22 2.48-7.65 4.03-1.46.93-2.91 1.96-4.61 2.32-2.42.51-4.93-.49-7.23-1.42z\" fill=\"url(#O)\"/><path d=\"M61.79 60.06c1.49-.88 2.92-1.87 4.25-2.98.74-.62 1.5-1.3 2.45-1.51 1.05-.23 2.18.18 2.96.91s1.34 1.75 1.46 2.82l.19 2.38c-.01.39.04.73-.24 1.29-.56 1.13-2.26 1.8-3.36 2.41-1.91 1.06-3.66 2.52-5.35 3.9-3.47 2.82-8.23 4.12-12.62 3.29-.99-.19-1.97-.58-2.39-1.44-.34-.7-.16-1.39.31-2.01.46-.62 1.13-1.06 1.76-1.5a29.05 29.05 0 0 0 7.28-7.47c.36-.54.83-.78 1.47-.84.63-.05 1.35.32 1.83.75z\" fill=\"url(#P)\"/><path d=\"M64.47 63.61c-.38-1.27-1.17-2.42-2.22-3.23 1.33-.8 2.65-1.7 3.88-2.64.57-.43 1.12-.89 1.76-1.22.63-.33 1.36-.53 2.06-.42.53.08 1.03.51 1.28.98.29.53.2 1.21-.08 1.74-.28.54-.74.95-1.22 1.33-1.65 1.34-3.57 2.49-5.46 3.46z\" fill=\"url(#Q)\"/><g fill=\"#fff\"><path d=\"M60.55 63.29c-.33 0-.65-.21-.82-.48-.11-.18-.19-.41-.22-.69-.01-.06-.01-.14-.01-.21-.1.01-.21.04-.32.06l-.52.11c-.53.08-.97 0-1.28-.24-.21-.16-.36-.44-.38-.71-.02-.23.05-.45.2-.6.24-.25.64-.32 1.1-.2.223.06.436.154.63.28.19.12.66.44.86.88.52-.04.97.1 1.24.4a.94.94 0 0 1 .21.78c-.04.24-.17.43-.36.53-.09.07-.21.09-.33.09zm-.68-1.44v.06c0 .06 0 .11.01.16.03.23.08.41.17.55.14.22.45.39.67.27.12-.07.16-.2.18-.27.03-.17-.02-.36-.13-.48-.25-.29-.69-.31-.9-.29zm-1.99-1.22c-.14 0-.3.03-.41.14-.1.1-.11.23-.1.32a.65.65 0 0 0 .24.45c.29.22.7.22 1 .17l.49-.1.31-.07c-.13-.22-.37-.45-.67-.63-.17-.11-.35-.18-.54-.24-.05-.01-.18-.04-.32-.04z\"/><path d=\"M59.47 64.07c-.09 0-.16-.06-.18-.15-.13-.68-.01-1.39.13-2.03a2.09 2.09 0 0 0-1.58 1.31c-.04.1-.14.14-.24.11-.09-.03-.14-.14-.11-.24.32-.89 1.21-1.53 2.15-1.58l.24-.01-.05.23c-.15.67-.31 1.43-.18 2.13.02.1-.05.19-.15.21-.01.02-.02.02-.03.02zm-5.83-5.3c-.19 0-.37-.07-.5-.23s-.15-.36-.16-.55l-.01-.42v-.1-.39-.15c-.06.02-.12.04-.19.05-.18.05-.36.11-.55.13-.44.06-.84-.06-1.06-.33-.14-.17-.2-.4-.18-.65a.96.96 0 0 1 .37-.65c.27-.2.65-.25 1-.14.37.12.6.41.74.62a1.36 1.36 0 0 1 .21.52c.36-.03.66.05.87.24.27.24.4.65.33 1.1-.05.36-.2.63-.42.8-.12.1-.28.15-.45.15zm-.31-1.92v.23.38.11l.01.41c0 .12.01.26.08.34.1.12.32.11.45.01.18-.13.25-.38.27-.56.05-.33-.03-.62-.21-.78-.16-.14-.4-.16-.6-.14zm-1.75-1.08c-.12.09-.2.24-.22.4-.02.14.02.27.09.37.14.17.42.25.72.2.17-.02.33-.07.5-.12l.28-.08c-.02-.13-.07-.25-.15-.38-.18-.27-.35-.41-.55-.48-.23-.07-.49-.04-.67.09z\"/><path d=\"M52.46 59.4c-.05 0-.1-.02-.14-.06-.07-.08-.06-.19.02-.26.35-.3.49-.74.55-1.05.06-.29.06-.6.06-.9a5.08 5.08 0 0 1-2.12 1.01c-.1.02-.2-.04-.22-.14s.04-.2.14-.22c.83-.17 1.62-.59 2.24-1.17l.3-.28.01.41c.02.46.03.92-.05 1.37-.07.37-.24.89-.67 1.26-.03.02-.08.03-.12.03z\"/></g><path d=\"M78.18 42.49l.3-.34c.04-.04.06-.07.08-.1l.2-.24c.03-.04.06-.07.08-.11l.18-.23.09-.12.16-.22c.02-.04.05-.07.07-.11l.18-.28c.01-.02.02-.03.03-.05l.18-.31c.02-.03.03-.06.05-.09.04-.07.08-.15.11-.22l.05-.11.09-.2c.01-.03.03-.07.04-.1l.08-.23c.01-.02.02-.04.02-.07l.08-.29c.01-.02.01-.05.02-.07.02-.07.03-.14.04-.21.01-.03.01-.06.01-.1.01-.06.02-.12.02-.19 0-.03.01-.06.01-.1 0-.07.01-.13.01-.2v-.07c0-.09-.01-.17-.02-.26 0-.02 0-.03-.01-.05l-.04-.21c-.01-.03-.01-.06-.02-.08-.01-.06-.03-.11-.05-.17 0-.02-.01-.03-.01-.05l-1.05-2.74-1.15-2.37-1.46-2.47c-.01-.01-.02-.03-.03-.04l-1.04-1.48-.43-.58-1.85-2.18c-.94-1.02-2.01-2.03-3.15-2.98-.01-.01-.02-.02-.04-.03l-.81-.65-2.01-1.44-2.6-1.55c-.9-.52-2.16-1.1-3.14-1.47l-2.14-.78-2.31-.67c-1.92-.44-2.99-.66-5.19-.85l-.34-.03-.24-.02-1.89-.07c-.48-.01-1.12 0-1.59.02l-2.36.18-1.97.29-.42.08-1.97.43-.73.19-.7.2-.69.22-1.36.48-.7.27c-.01 0-.66.26-1.46.63-.66.3-1.97.94-3.34 1.78l-2.18 1.45c-.34.23-.77.56-1.09.82l-1.31 1.09-1.36 1.27-.05.05-1.28 1.33-.21.24-1.29 1.56-.44.56c-.82 1.07-1.76 2.61-2.44 3.78-.5.876-.948 1.781-1.34 2.71l-1.03 2.64-.71 2.36-.14.57-.06.25-.39 1.92c-.24 1.5-.39 3.52-.46 5.04-.04.85.02 1.99.09 2.84L16.7 53l1.23 4.99.03.11c.01.02.01.04.02.06s.02.04.02.06c.01.02.01.04.02.06a1.01 1.01 0 0 0 .07.15c.01.01.01.02.01.03l.1.18c.01.02.02.03.03.05l.06.1c.01.01.02.02.02.04.01.02.03.04.04.06.03.04.06.09.1.13.01.01.02.03.03.04l.14.16.04.04.13.12c.02.02.04.03.05.05.04.04.09.08.13.11.02.01.03.03.05.04l.19.15c.01.01.02.01.03.02l.18.12c.02.01.05.03.07.04l.16.1c.02.01.05.03.07.04l.24.12.27.12.08.03c.07.03.13.06.2.08a.35.35 0 0 1 .09.04l.25.09c.02.01.03.01.05.02l.31.1.09.03.24.07.11.03.27.07c.03.01.05.01.08.02l.36.08c.03.01.06.01.09.02l.29.06c.04.01.08.02.13.02l.29.05c.04.01.07.01.11.02l.41.06c.02 0 .04.01.07.01a4.36 4.36 0 0 0 .36.04c.046.008.093.012.14.01l.32.03c.05 0 .09.01.14.01l.46.04c3.71.25 8.37-.2 13.42-1.18 5.06-.98 10.51-2.5 15.8-4.39 5.29-1.9 10.41-4.17 14.82-6.67l.69-.4.21-.12a7.04 7.04 0 0 0 .46-.28c.08-.05.16-.09.23-.14l.44-.27c.07-.04.14-.09.21-.13.18-.11.35-.22.52-.33.03-.02.07-.04.1-.06l.59-.39.17-.11c.14-.09.28-.19.41-.28l.2-.14c.12-.09.25-.17.37-.26.06-.04.12-.09.19-.13l.4-.29.12-.09c.17-.13.34-.25.5-.38l.12-.09c.12-.1.24-.19.36-.28l.16-.13c.1-.08.2-.17.3-.25.05-.04.1-.09.16-.13.101-.09.204-.176.31-.26.04-.03.08-.07.12-.1.14-.12.27-.24.4-.36.02-.02.04-.04.07-.06.11-.1.21-.2.31-.3l.12-.12.24-.24c.042-.041.082-.084.12-.13.08-.08.15-.16.23-.24.07-.02.11-.06.14-.1z\" fill=\"url(#R)\"/><path d=\"M38.24 18a2.57 2.57 0 1 0 0-5.14 2.57 2.57 0 1 0 0 5.14z\" fill=\"url(#S)\"/></g></g><defs><linearGradient id=\"A\" x1=\"12.172\" y1=\"71.112\" x2=\"150.366\" y2=\"71.112\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"-34\" y1=\"60.636\" x2=\"278.443\" y2=\"60.636\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"40.809\" y1=\"54.183\" x2=\"43.458\" y2=\"54.183\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"9.573\" y1=\"55.627\" x2=\"47.978\" y2=\"55.627\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"16.292\" y1=\"45.245\" x2=\"50.66\" y2=\"45.245\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"35.199\" y1=\"33.712\" x2=\"67.952\" y2=\"33.712\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"21.468\" y1=\"56.4\" x2=\"57.309\" y2=\"56.4\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"24.843\" y1=\"46.018\" x2=\"61.769\" y2=\"46.018\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"36.797\" y1=\"49.218\" x2=\"53.569\" y2=\"49.218\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"42.378\" y1=\"34.485\" x2=\"77.526\" y2=\"34.485\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"46.703\" y1=\"49.768\" x2=\"56.101\" y2=\"49.768\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"15.344\" y1=\"63.466\" x2=\"82.134\" y2=\"63.466\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"34.18\" y1=\"59.854\" x2=\"78.984\" y2=\"59.854\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"49.55\" y1=\"55.522\" x2=\"94.183\" y2=\"55.522\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"19.714\" y1=\"67.781\" x2=\"96.115\" y2=\"67.781\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"38.911\" y1=\"64.169\" x2=\"90.656\" y2=\"64.169\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"57.377\" y1=\"59.838\" x2=\"97.41\" y2=\"59.838\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"R\" x1=\"-13.567\" y1=\"38.166\" x2=\"131.451\" y2=\"38.166\" xlink:href=\"#V\"><stop stop-color=\"#fff\" stop-opacity=\"0\"/><stop offset=\".22\" stop-color=\"#e3cef2\" stop-opacity=\".22\"/><stop offset=\".761\" stop-color=\"#9f5ad2\" stop-opacity=\".761\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"S\" x1=\"21.823\" y1=\"15.433\" x2=\"44.253\" y2=\"15.433\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"T\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"U\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"V\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeInsuranceHome = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#N)\"><g clip-path=\"url(#O)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M88.17 65.15L62.45 80.09 27.62 59.93l26.21-15.2 34.34 20.42z\" fill=\"url(#A)\"/><path d=\"M88.17 65.15l-.01 1.57-25.72 14.94.01-1.57 25.72-14.94z\" fill=\"url(#B)\"/><path d=\"M62.45 80.09l-.01 1.57L27.61 61.5l.01-1.57 34.83 20.16z\" fill=\"url(#C)\"/><path d=\"M54.77 45.48l-25.48-9.43v3 21.3l33.04 19.08V58.12 54.8l-7.56-9.32z\" fill=\"url(#D)\"/><path d=\"M57.78 76.8l-6.19-3.58V59.37l6.19 3.57V76.8zM46.27 56.3v8.28l-12.39-7.15v-8.29l12.39 7.16z\" fill=\"#fff\"/><path d=\"M87.09 65.09L62.33 79.43l-.03-25.67 24.76-14.34.03 25.67z\" fill=\"url(#E)\"/><path d=\"M54.8 43.1l9.59 11.87-.01 2.49-9.59-11.88-27.54-10.17.01-2.48L54.8 43.1z\" fill=\"url(#F)\"/><path d=\"M64.39 54.97l26.64-15.48v2.49L64.38 57.46l.01-2.49z\" fill=\"url(#G)\"/><path d=\"M68.93 60.37v8.29l12.39-7.16v-8.28l-12.39 7.15z\" fill=\"url(#H)\"/><path d=\"M27.26 32.93L53.9 17.44l27.54 10.17L54.8 43.1 27.26 32.93z\" fill=\"url(#I)\"/><path d=\"M54.8 43.1l26.64-15.49 9.59 11.88-26.64 15.48L54.8 43.1z\" fill=\"url(#J)\"/><path d=\"M36.34 67.89c0 .14-.04.26-.04.39v.22l-.01.43-.07.86c-.07.57-.18 1.14-.34 1.7a11.76 11.76 0 0 1-.59 1.63c-.24.53-.51 1.04-.82 1.52-.31.49-.66.95-1.04 1.38l-.34.37c-.11.11-.21.24-.34.32-.04.02-.08.04-.12.07-.06.04-.1.1-.15.14-.13.11-.27.2-.41.3l-.58.36-5.03 2.7c-.06-.06-.06.06-.06.06l-.06-.06.12-.12c.31-.18.61-.25.86-.43.16-.08.29-.22.42-.35l.43-.43c.39-.42.75-.86 1.08-1.33a13.67 13.67 0 0 0 .87-1.48c.25-.52.46-1.05.63-1.6a12.24 12.24 0 0 0 .39-1.67l.1-.85.02-.43c0-.07.01-.14 0-.21-.03-.18-.01-.36-.01-.54v-.37-.06l.06-11.48-11.24-10.98-11.1-2.01 4.97-2.84L25.17 45 36.4 55.99l-.06 11.48v.06.36z\" fill=\"url(#K)\"/><path d=\"M8.97 45.93v11.5c0 .61-.49 11.31 11.07 24.22 6.3.24 9.11-2.87 10.33-5.93 1.04-2.63.92-5.2.92-5.44l.06-11.44-11.19-10.95-11.19-1.96z\" fill=\"url(#L)\"/><path d=\"M11.35 50.27v8.99c0 .43-.43 8.93 8.74 19.14 9.17.37 8.81-8.5 8.81-8.99v-8.99l-8.74-8.62-8.81-1.53z\" fill=\"url(#M)\"/></g></g><defs><linearGradient id=\"A\" x1=\"24.835\" y1=\"62.409\" x2=\"164.223\" y2=\"62.409\" xlink:href=\"#P\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"17.635\" y1=\"73.402\" x2=\"119.764\" y2=\"73.402\" xlink:href=\"#P\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"20.4\" y1=\"70.794\" x2=\"134.111\" y2=\"70.794\" xlink:href=\"#P\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"18.333\" y1=\"57.739\" x2=\"145.291\" y2=\"57.739\" xlink:href=\"#P\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"4.825\" y1=\"59.427\" x2=\"117.143\" y2=\"59.427\" xlink:href=\"#P\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"20.248\" y1=\"45.194\" x2=\"100.792\" y2=\"45.194\" xlink:href=\"#P\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"-51.087\" y1=\"48.474\" x2=\"112.46\" y2=\"48.474\" xlink:href=\"#P\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"50.234\" y1=\"60.939\" x2=\"102.667\" y2=\"60.939\" xlink:href=\"#P\"><stop stop-color=\"#fff\"/><stop offset=\".101\" stop-color=\"#fbf8fd\"/><stop offset=\".245\" stop-color=\"#f0e6f8\"/><stop offset=\".414\" stop-color=\"#dec7f0\"/><stop offset=\".603\" stop-color=\"#c69ce4\"/><stop offset=\".806\" stop-color=\"#a666d5\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"-6.16\" y1=\"30.271\" x2=\"128.136\" y2=\"30.271\" xlink:href=\"#P\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"-17.353\" y1=\"41.293\" x2=\"121.87\" y2=\"41.293\" xlink:href=\"#P\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"-3.013\" y1=\"61.724\" x2=\"51.847\" y2=\"61.724\" xlink:href=\"#P\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"-2.658\" y1=\"63.795\" x2=\"167.58\" y2=\"63.795\" xlink:href=\"#P\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"3.978\" y1=\"64.344\" x2=\"35.685\" y2=\"64.344\" xlink:href=\"#P\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"N\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"O\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"P\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeLegalProtection = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#S)\"><g clip-path=\"url(#T)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M60.26 52.83l-.09.82c-.04.22-.11.44-.17.66l-.22.78-.27.63-.38.81c-.1.19-.23.38-.35.58l-.61.9c-.13.18-.28.35-.42.52-.33.4-.7.79-1.1 1.18l-.43.42-.79.66-.73.57-.93.62-.98.63c-.78.45-1.6.85-2.44 1.24l-.74.31-2.04.77-.75.26-1.33.38-1.02.27-1.43.31-.98.2-2.94.41-.91.08-1.76.12-1.12.03-1.42.01-1.18-.03-1.32-.07-1.2-.1-1.29-.14-1.16-.16-1.37-.24-1.08-.22-1.61-.4-.88-.24-2.78-.94-.37-.16c-1.23-.5-2.42-1.05-3.52-1.69-2.55-1.48-4.47-3.18-5.75-5s-1.91-3.75-1.9-5.68l-.01 3.8c-.01 3.86 2.54 7.73 7.65 10.68 1.1.64 2.29 1.19 3.52 1.69.08.03.15.08.23.11.05.02.1.03.14.05.9.35 1.83.66 2.78.94.08.02.15.05.23.08.22.06.44.1.66.16.53.14 1.06.27 1.61.39.15.03.29.08.43.11.21.04.43.07.64.11.46.09.91.17 1.37.24.19.03.37.07.56.1.2.03.4.04.6.07l1.29.14c.21.02.41.05.62.07.19.02.38.02.57.03.44.03.88.05 1.32.07.22.01.44.03.66.04h.52c.47.01.95 0 1.42-.01h.71c.14 0 .27-.02.41-.03a52.28 52.28 0 0 0 1.76-.12c.23-.02.47-.02.71-.05l.21-.03c.99-.1 1.97-.24 2.94-.41.05-.01.1-.01.15-.02.28-.05.56-.12.84-.18l1.42-.3c.35-.08.69-.18 1.03-.28.44-.12.89-.24 1.32-.38.1-.03.2-.05.29-.08.16-.05.3-.12.46-.17.69-.24 1.37-.49 2.03-.77.249-.101.496-.207.74-.32.84-.38 1.67-.78 2.44-1.24.109-.06.215-.123.32-.19.24-.14.44-.3.67-.45.32-.21.64-.41.93-.62.26-.19.49-.38.72-.57.27-.22.55-.43.8-.66l.16-.13c.1-.09.17-.19.27-.29.4-.39.77-.78 1.1-1.18.07-.09.17-.17.24-.26s.11-.18.18-.27c.214-.293.417-.593.61-.9.08-.13.18-.25.26-.38.04-.07.06-.13.09-.2.14-.27.26-.54.38-.8.07-.16.16-.31.22-.47.02-.05.03-.11.05-.16.09-.26.15-.51.22-.77.05-.18.12-.35.15-.53.01-.05.01-.09.02-.14a7.44 7.44 0 0 0 .09-.81c.02-.18.06-.35.06-.53v-.23l.01-3.8c.01.24-.03.49-.06.75z\" fill=\"url(#A)\"/><path d=\"M52.68 41.38c10.15 5.86 10.21 15.37.12 21.23s-26.5 5.85-36.65-.01-10.21-15.35-.12-21.22 26.49-5.87 36.65 0z\" fill=\"#fff\"/><path d=\"M55.18 48.36c-.02.22-.03.44-.08.66-.03.18-.09.35-.13.53l-.18.62c-.06.17-.14.34-.21.51l-.3.65c-.08.16-.18.31-.28.46l-.49.73-.34.42-.88.95-.35.34-.64.53-.58.46-.75.5-.79.51c-.62.36-1.28.69-1.96.99l-.59.25-1.64.62-.6.21-1.07.31-.82.22-1.15.25-.79.16-2.37.33-.73.06-1.41.09-.9.02-1.14.01a15.05 15.05 0 0 1-.95-.03L32 59.66l-.96-.08-1.04-.12-.93-.13-1.1-.19-.86-.18-1.3-.32-.71-.19-2.24-.76-.3-.13c-.99-.4-1.94-.84-2.83-1.35-2.05-1.19-3.59-2.56-4.62-4.02-1.02-1.46-1.54-3.02-1.53-4.57l-.01 3.05c-.01 3.1 2.04 6.21 6.15 8.58.88.51 1.84.95 2.83 1.35l.18.09c.04.01.08.02.11.04.735.284 1.482.535 2.24.75l.18.06c.17.05.36.08.53.13l1.29.32.35.09c.17.04.34.06.52.09.37.07.73.13 1.1.19.15.02.3.06.45.08.16.02.32.03.48.05l1.04.12.5.06c.15.01.31.01.46.02l1.06.06.53.03h.42c.38.01.76 0 1.14-.01h.57c.11 0 .22-.02.33-.02.471-.02.941-.05 1.41-.09.19-.02.38-.02.57-.04.06-.01.11-.02.17-.02.8-.08 1.59-.19 2.37-.33.04-.01.08-.01.12-.02.23-.04.45-.1.67-.14l1.14-.24.83-.22 1.06-.3c.08-.02.16-.04.23-.07.13-.04.24-.1.37-.14.56-.19 1.1-.4 1.63-.62l.6-.25c.68-.31 1.34-.63 1.96-.99.09-.05.17-.1.25-.15.19-.11.35-.24.54-.36l.75-.5c.21-.15.39-.31.58-.46.22-.18.44-.35.64-.53.04-.04.09-.07.13-.11.08-.07.14-.16.22-.23.32-.31.62-.63.88-.95.06-.07.14-.14.19-.21.06-.07.09-.14.14-.21a8.48 8.48 0 0 0 .49-.73c.06-.1.15-.2.21-.31.03-.05.05-.11.07-.16.12-.21.21-.43.3-.65.06-.13.13-.25.18-.38.02-.04.02-.09.04-.13.07-.21.12-.41.18-.62.04-.14.09-.28.12-.42a.45.45 0 0 0 .01-.11c.038-.215.061-.432.07-.65.01-.14.04-.29.05-.43v-.18l.01-3.05c.02.21-.01.41-.03.61z\" fill=\"url(#B)\"/><path d=\"M49.09 39.16c8.16 4.71 8.2 12.35.1 17.06s-21.29 4.7-29.45-.01-8.2-12.34-.1-17.05 21.29-4.71 29.45 0z\" fill=\"#fff\"/><path d=\"M58.97 35.17c-.11 5.92-4.41 8.2-9.6 5.1s-9.32-10.42-9.21-16.34 4.41-8.2 9.6-5.1 9.31 10.42 9.21 16.34z\" fill=\"url(#C)\"/><path d=\"M58.96 34.55l-.02-.45-.04-.46-.05-.46-.04-.26c0-.02 0-.03-.01-.05-.01-.05-.01-.11-.02-.16l-.08-.48-.1-.49-.12-.49-.13-.5-.05-.17c-.01-.02-.01-.04-.02-.05l-.08-.27-.16-.49-.17-.47-.18-.47-.18-.45-.06-.13c-.01-.01-.01-.03-.02-.04l-.12-.27-.21-.47-.23-.47-.3-.58-.2-.36c-.03-.06-.07-.12-.1-.17l-.19-.34-.69-1.1-.38-.54-.09-.12-.11-.15-.41-.53-.37-.46-.36-.42-.29-.32-.03-.03c-.02-.02-.04-.04-.05-.06l-.38-.4-.4-.39-.41-.38-.42-.36c-.02-.02-.04-.03-.06-.05-.01-.01-.02-.02-.03-.02l-.33-.27-.41-.31-.41-.29-.4-.26-.32-.2a.3.3 0 0 0-.08-.04l-.39-.22-.39-.2-.11-.05c-.02-.01-.05-.02-.07-.03-.07-.03-.13-.07-.2-.1l-.38-.16-.33-.12c-.01 0-.02-.01-.03-.01s-.01-.01-.02-.01l-.38-.12-.39-.11c-.03-.01-.07-.01-.1-.02s-.05-.01-.08-.02l-.21-.05-.4-.07c-.06-.01-.12-.01-.18-.02-.03 0-.07-.01-.1-.01-.05 0-.1-.01-.15-.01l-.44-.01c-.05 0-.1.01-.15.01s-.09 0-.14.01c-.06 0-.13 0-.19.01l-.51.07h-.02c-.23.04-.45.1-.66.18-.01 0-.03.01-.04.02a3.74 3.74 0 0 0-.73.34l-1.57.91c.231-.137.476-.251.73-.34a5.16 5.16 0 0 1 .7-.2h.02c.23-.04.47-.07.71-.08.05 0 .09-.01.14-.01.24-.01.48 0 .73.02.03 0 .07.01.1.01l.8.13c.03.01.05.01.08.02l.89.26c.01 0 .02.01.03.01l.91.38c.02.01.04.02.07.03.32.15.64.32.96.52.659.399 1.288.847 1.88 1.34.01.01.02.02.03.02.6.5 1.18 1.06 1.73 1.66l.03.03c.54.59 1.05 1.22 1.53 1.88l.09.13c.456.636.877 1.297 1.26 1.98.03.06.07.12.1.17l1.07 2.16c.01.01.01.02.02.04.319.75.593 1.518.82 2.3 0 .02.01.03.01.05.22.77.39 1.54.5 2.3 0 .01 0 .03.01.04.11.77.16 1.52.15 2.25a9.87 9.87 0 0 1-.22 1.96c0 .01-.01.03-.01.04-.13.6-.31 1.14-.55 1.63 0 .01-.01.01-.01.02-.19.39-.43.72-.69 1.04l-.26.32c-.31.32-.64.61-1.01.83l1.57-.91c.37-.22.71-.51 1.01-.83.092-.106.179-.216.26-.33l.36-.44a5.76 5.76 0 0 0 .33-.6c0-.01.01-.01.01-.02l.24-.56.16-.49c.05-.15.09-.31.12-.47.01-.03.01-.07.02-.1 0-.01.01-.03.01-.04l.07-.33.07-.44.05-.45.03-.45.01-.29v-.16-.54z\" fill=\"url(#D)\"/><path d=\"M57.37 34.96l-.07-.77a3.06 3.06 0 0 0-.05-.32l-.02-.13-.05-.34-.16-.82-.21-.85-.06-.2c-.01-.05-.03-.09-.04-.14l-.16-.54-.31-.9-.31-.77-.03-.08-.03-.08-.48-1.05-.39-.7-.37-.67-.21-.38-.59-.91-.25-.33-.47-.63-.49-.66-.78-.9-.74-.76-.72-.67-.24-.2c-.04-.04-.09-.07-.13-.11l-.34-.28-.69-.51-.68-.44c-.04-.02-.08-.05-.11-.07l-.55-.31-.64-.32c-.21-.1-.42-.18-.63-.26-.01 0-.02 0-.02-.01-.01 0-.02-.01-.02-.01l-.58-.19-.64-.16-.44-.07c-.03 0-.06-.01-.1-.01s-.08-.01-.12-.02l-.7-.03c-.24 0-.48.02-.7.06h-.04-.02a4.57 4.57 0 0 0-.9.23c-.08.03-.13.09-.21.12-.27.11-.51.27-.76.43-.18.12-.36.22-.52.37-.23.21-.42.46-.62.72-.13.17-.27.31-.38.5-.19.32-.32.69-.46 1.07l-.22.55c-.17.61-.28 1.27-.32 2.01l-.22 4.09a6.51 6.51 0 0 1 .21-1.32c.04-.13.1-.24.14-.36.09-.25.18-.5.3-.71.07-.12.16-.22.25-.33.13-.17.26-.34.41-.47.1-.09.22-.16.34-.24.16-.11.32-.21.5-.28.23-.1.48-.19.74-.23h.03c.31-.04.65-.05 1 0 .02 0 .04.01.06.01.35.05.71.14 1.09.27h.02c.39.15.8.34 1.21.59.42.249.818.534 1.19.85.03.02.06.05.09.07a12.25 12.25 0 0 1 1.11 1.06c.29.32.57.67.84 1.03l.31.41.68 1.07.24.44.59 1.2c.01.02.02.04.02.06.2.48.37.96.51 1.44l.03.09c.14.49.24.97.32 1.45 0 .03.01.06.01.09a9 9 0 0 1 .1 1.45c-.009.423-.056.845-.14 1.26 0 .02-.01.03-.01.04a5.47 5.47 0 0 1-.32.99c-.02.04-.05.08-.07.13-.12.24-.26.45-.41.64-.04.05-.08.11-.13.16-.19.21-.39.39-.62.53a.61.61 0 0 1-.14.07c-.2.11-.41.2-.63.27l-.2.06a3.44 3.44 0 0 1-.86.09c-.04 0-.08-.01-.11-.01-.27-.01-.56-.06-.85-.13l-.26-.07c-.355-.102-.7-.236-1.03-.4l3.67 1.83c.54.27 1.06.46 1.57.61l.4.11c.45.11.88.18 1.29.2.06 0 .11.02.17.02a5.11 5.11 0 0 0 1.31-.14c.11-.02.21-.06.31-.09.335-.099.657-.237.96-.41l.2-.11c.35-.22.66-.5.94-.81l.19-.24.32-.41c.11-.18.21-.38.31-.58.03-.07.07-.12.1-.19.02-.04.04-.06.05-.1a8.09 8.09 0 0 0 .29-.79 6.25 6.25 0 0 0 .15-.62c.01-.02.01-.05.02-.07 0-.02.01-.04.01-.06l.12-.73.06-.74c.01-.13.01-.26.01-.39v-.36c.01-.24 0-.49-.02-.75z\" fill=\"url(#E)\"/><path d=\"M50.7 36.15c-.07 3.88-2.89 5.38-6.3 3.34s-6.11-6.83-6.04-10.71 2.89-5.38 6.3-3.34 6.11 6.83 6.04 10.71z\" fill=\"url(#F)\"/><path d=\"M53.17 37.69l-.02-.43-.03-.43-.05-.44-.06-.45-.07-.45-.09-.46-.11-.47-.12-.47-.11-.37c0-.01-.01-.02-.01-.03-.01-.03-.01-.05-.02-.07l-.15-.46-.16-.45-.16-.44-.17-.43-.14-.33c0-.01-.01-.02-.01-.02-.01-.02-.02-.05-.03-.07l-.2-.43-.23-.47-.28-.53-.32-.56-.06-.1c-.02-.04-.04-.08-.07-.12l-.66-1.05-.56-.8-.4-.52-.34-.42-.34-.4-.35-.38-.07-.07-.03-.03-.27-.28c-.12-.13-.25-.25-.38-.37l-.39-.36-.4-.35-.2-.16c-.01-.01-.03-.02-.04-.04l-.15-.12-.39-.3-.39-.28-.38-.25-.38-.23c-.03-.02-.06-.03-.09-.05l-.28-.16c-.12-.07-.24-.13-.37-.19l-.36-.17-.36-.15-.36-.14c-.02-.01-.05-.01-.07-.02-.01 0-.02-.01-.03-.01l-.26-.09c-.12-.04-.25-.07-.37-.1l-.37-.08c-.128-.03-.259-.05-.39-.06l-.26-.03h-.04c-.03 0-.06-.01-.1-.01l-.42-.01-.46.02-.51.07h-.03c-.2.04-.4.1-.59.16-.25.09-.49.2-.72.33l-2.46 1.43c.4-.23.84-.4 1.31-.5h.02c.47-.1.97-.12 1.5-.08h.04a7.43 7.43 0 0 1 1.65.36c.01 0 .02.01.03.01.58.2 1.18.47 1.8.83.61.35 1.2.77 1.77 1.23.01.01.03.02.04.03.579.47 1.124.982 1.63 1.53l.03.03c1.05 1.12 1.99 2.4 2.79 3.78.02.03.04.07.05.1.39.67.74 1.37 1.05 2.07 0 .01.01.02.01.02a23 23 0 0 1 .81 2.18c0 .01.01.02.01.03a17.47 17.47 0 0 1 .51 2.2c.12.74.18 1.47.17 2.17 0 .69-.07 1.33-.18 1.91 0 .02-.01.04-.01.05-.12.58-.29 1.1-.51 1.57 0 .01-.01.02-.01.02-.18.39-.42.72-.67 1.04l-.25.31c-.29.31-.61.59-.97.8l2.46-1.43c.36-.21.68-.49.97-.8.09-.09.17-.2.25-.31.11-.13.23-.25.32-.4.12-.19.23-.39.34-.61 0-.01.01-.02.01-.03s.01-.02.01-.02l.19-.46c.06-.15.11-.31.16-.47l.12-.45.04-.19c0-.02.01-.04.01-.05l.04-.19.06-.42.04-.43.03-.42.01-.43v-.03c.02-.13.02-.27.01-.4z\" fill=\"url(#G)\"/><use xlink:href=\"#U\" fill=\"url(#H)\"/><path d=\"M25.53 32.96c5.23 3.02 9.44 10.31 9.42 16.31-.02 6.01-4.25 8.43-9.49 5.41-5.22-3.01-9.43-10.3-9.41-16.31.03-6.01 4.26-8.43 9.48-5.41z\" fill=\"url(#I)\"/><path d=\"M51.36 39.3l-.02-.46-.04-.46-.05-.46-.07-.47-.08-.48-.1-.49-.12-.49-.13-.5-.11-.39c0-.01-.01-.02-.01-.03-.01-.03-.01-.05-.02-.08l-.16-.49-.17-.48-.17-.46-.18-.46-.15-.35c0-.01-.01-.02-.01-.03-.01-.02-.02-.05-.03-.07l-.21-.46-.24-.5-.29-.57-.34-.6-.06-.1c-.02-.04-.04-.08-.07-.12l-.7-1.12-.6-.85-.41-.54-.36-.45-.37-.43-.37-.41-.08-.08c-.01-.01-.02-.02-.03-.04l-.27-.29-.4-.39-.42-.39-.42-.37-.22-.18c-.02-.01-.03-.03-.05-.04l-.15-.13-.42-.32-.41-.29-.4-.27-.4-.25c-.03-.02-.06-.04-.09-.05l-.3-.17-.39-.2-.38-.18-.38-.16-.38-.14c-.02-.01-.05-.02-.07-.02-.01 0-.02-.01-.03-.01l-.28-.09-.39-.11-.39-.09-.41-.07-.27-.03h-.04c-.03 0-.07-.01-.1-.01l-.44-.01-.49.02-.54.08c-.02 0-.02 0-.03.01-.214.04-.425.097-.63.17-.27.09-.52.21-.76.35L18.81 32.3c.43-.25.89-.42 1.39-.53.52-.1 1.05-.13 1.61-.08h.04c.56.05 1.14.18 1.75.38.01 0 .02.01.03.01a10.33 10.33 0 0 1 1.9.88 13.62 13.62 0 0 1 1.89 1.31c.02.01.03.03.05.04a17.5 17.5 0 0 1 1.73 1.62l.03.03c.56.6 1.09 1.23 1.59 1.91.49.67.95 1.37 1.37 2.09l.06.1c.41.71.78 1.45 1.11 2.2 0 .01.01.02.01.03.33.755.614 1.53.85 2.32 0 .01.01.02.01.03.23.78.42 1.56.54 2.33.12.79.19 1.56.19 2.31.002.684-.062 1.368-.19 2.04 0 .02-.01.04-.01.06-.12.61-.3 1.17-.53 1.67 0 .01-.01.02-.01.03-.2.42-.45.77-.71 1.1l-.26.32c-.31.33-.65.63-1.03.85l16.41-9.54c.38-.22.72-.52 1.03-.85.09-.1.17-.21.26-.32.11-.14.24-.26.34-.42a5.77 5.77 0 0 0 .36-.65c.01-.01.01-.02.01-.04 0-.01.01-.02.01-.03l.2-.47.17-.5.13-.48c.02-.07.03-.14.04-.21 0-.02.01-.04.01-.06l.04-.19.07-.45.05-.46.03-.45.01-.46v-.03c-.02-.16-.03-.3-.03-.44z\" fill=\"url(#J)\"/><path d=\"M33.53 49.14l-.02-.43-.03-.43-.05-.44-.06-.45-.07-.45-.09-.46-.11-.47-.12-.47-.11-.37c0-.01-.01-.02-.01-.03-.01-.03-.01-.05-.02-.07l-.15-.46-.16-.45-.16-.44-.17-.43-.14-.33c0-.01-.01-.02-.01-.02-.01-.02-.02-.05-.03-.07l-.2-.43-.23-.47-.28-.53-.32-.56-.06-.1c-.02-.04-.04-.08-.07-.12l-.66-1.05-.56-.8-.4-.52-.34-.42-.34-.4-.35-.38-.07-.07-.03-.03-.27-.28c-.12-.13-.25-.25-.38-.37l-.39-.36-.4-.35-.2-.16c-.01-.01-.03-.02-.04-.04l-.15-.12-.39-.3-.39-.28-.38-.25-.38-.23c-.03-.02-.06-.03-.09-.05l-.28-.16c-.12-.07-.24-.13-.37-.19l-.36-.17-.36-.15-.36-.14c-.02-.01-.05-.01-.07-.02-.01 0-.02-.01-.03-.01l-.26-.09c-.12-.04-.25-.07-.37-.1l-.37-.08a2.63 2.63 0 0 0-.39-.06l-.26-.03h-.04c-.03 0-.06-.01-.1-.01l-.42-.01-.46.02-.51.07h-.03c-.2.04-.4.1-.59.16-.25.09-.49.2-.72.33l-2.46 1.43c.4-.23.84-.4 1.31-.5.49-.1.99-.12 1.52-.08h.04a7.43 7.43 0 0 1 1.65.36c.01 0 .02.01.03.01.58.2 1.18.47 1.8.83.61.35 1.2.77 1.77 1.23.01.01.03.02.04.03.579.47 1.124.982 1.63 1.53l.03.03c1.05 1.12 1.99 2.4 2.79 3.78.02.03.04.07.05.1.39.67.74 1.37 1.05 2.07 0 .01.01.02.01.02a22.97 22.97 0 0 1 .81 2.18c0 .01.01.02.01.03a17.45 17.45 0 0 1 .51 2.2c.12.74.18 1.47.17 2.17 0 .69-.07 1.33-.18 1.91 0 .02-.01.04-.01.05-.12.58-.29 1.1-.51 1.57 0 .01-.01.02-.01.02-.18.39-.42.72-.67 1.04l-.25.31c-.29.31-.61.59-.97.8l2.46-1.43c.36-.21.68-.49.97-.8.09-.09.17-.2.25-.31.11-.13.23-.25.32-.4.12-.19.23-.39.34-.61 0-.01.01-.02.01-.03s.01-.02.01-.02l.19-.46c.06-.15.11-.31.16-.47l.12-.45.04-.19c0-.02.01-.04.01-.05l.04-.19.06-.42.04-.43.03-.42.01-.43v-.03c.019-.133.022-.267.01-.4z\" fill=\"url(#K)\"/><path d=\"M22.2 35.6c4.92 2.84 8.89 9.72 8.88 15.37-.02 5.64-4.01 7.93-8.93 5.09s-8.89-9.74-8.88-15.37c.01-5.65 4.01-7.93 8.93-5.09z\" fill=\"url(#L)\"/><path d=\"M14.73 43.12c-.05-3.96 2.68-5.62 6.1-3.72s6.22 6.66 6.27 10.61-2.68 5.62-6.1 3.72-6.22-6.65-6.27-10.61z\" fill=\"url(#M)\"/><path d=\"M27.08 49.59l-.06-.64-.06-.38c-.01-.04-.01-.08-.02-.13s-.01-.1-.02-.15l-.16-.7-.16-.55c-.01-.04-.02-.09-.04-.13l-.03-.1c-.1-.32-.22-.63-.35-.94-.03-.08-.08-.15-.11-.23l-.32-.67-.25-.53c-.03-.06-.08-.11-.11-.17-.36-.64-.75-1.25-1.19-1.82-.02-.03-.03-.06-.06-.08-.18-.23-.38-.43-.57-.65l-.39-.44c-.02-.02-.03-.04-.05-.06l-.7-.65c-.09-.08-.19-.15-.29-.23l-.15-.12c-.06-.04-.11-.09-.17-.14l-.56-.39c-.15-.1-.3-.19-.46-.27-.03-.02-.06-.03-.09-.05l-.2-.11-3.64-1.84.44.23c.62.34 1.22.76 1.8 1.21l.22.18c.54.44 1.07.92 1.58 1.44l.59.67 1 1.18.33.46.97 1.45.36.61.66 1.28.48 1.02.74 1.94.06.21c.22.71.4 1.43.52 2.14l.03.19c.12.74.2 1.48.21 2.2l-.01.77.21-4.07.01-.29v-.21c.03-.16.02-.3.01-.44z\" fill=\"url(#N)\"/><path d=\"M6.47 44.23c-.07-6.03 4.09-8.57 9.29-5.67s9.48 10.14 9.56 16.18c.07 6.03-4.09 8.57-9.29 5.67S6.54 50.27 6.47 44.23z\" fill=\"url(#O)\"/><path d=\"M26.9 53.82v-.23l-.02-.46-.04-.46-.05-.46-.07-.47-.03-.2c0-.02-.01-.03-.01-.05l-.04-.23-.1-.49-.12-.5-.13-.5-.15-.5-.03-.1c0-.01-.01-.02-.01-.04l-.11-.35-.17-.48-.17-.46-.18-.45-.19-.45-.05-.11c0-.01-.01-.02-.02-.03l-.14-.31-.24-.5-.27-.52-.45-.81c-.01-.02-.02-.04-.04-.06-.02-.04-.05-.08-.08-.12l-.65-1.03-.58-.82-.11-.14c-.02-.02-.03-.04-.05-.06l-.26-.34-.36-.44-.36-.43-.37-.41-.21-.22-.04-.04-.13-.14-.4-.4-.41-.38-.42-.37-.39-.32c-.02-.01-.02-.02-.03-.02l-.42-.32-.4-.29-.4-.27-.39-.24-.26-.15-.13-.07-.39-.2-.38-.18-.38-.16-.38-.14-.19-.06c-.01 0-.03-.01-.04-.01-.05-.02-.1-.04-.16-.05l-.39-.11-.39-.09-.41-.07c-.12-.02-.24-.03-.36-.04h-.05l-.45-.02-.48.02-.54.08c-.01 0-.02.01-.04.01s-.03.01-.05.01c-.2.04-.39.09-.57.16-.27.09-.52.21-.76.35L9.22 38c.41-.24.86-.4 1.33-.51.02 0 .04-.01.05-.02a5.61 5.61 0 0 1 1.55-.09c.56.04 1.13.16 1.73.35.01 0 .03.01.04.01.6.2 1.21.46 1.85.82.65.36 1.28.79 1.9 1.28.622.497 1.21 1.034 1.76 1.61l.04.04c.55.57 1.07 1.19 1.56 1.84.02.02.03.04.05.06.48.64.92 1.31 1.33 2 .02.04.05.08.08.12.42.72.81 1.45 1.14 2.21 0 .01.01.02.02.03.34.76.63 1.53.88 2.3 0 .01.01.02.01.04a18.02 18.02 0 0 1 .56 2.31c0 .02.01.03.01.05a15.03 15.03 0 0 1 .22 2.29c.01.76-.05 1.46-.17 2.11 0 .01-.01.03-.01.04-.12.63-.3 1.19-.52 1.7l-.03.06c-.2.43-.45.79-.72 1.14l-.26.32c-.32.34-.66.64-1.05.87l1.58-.92c.39-.23.73-.53 1.04-.87.09-.1.17-.21.26-.32.11-.13.23-.25.32-.4.13-.2.25-.42.36-.64.01-.03.03-.06.04-.09.01-.02.02-.04.03-.07l.16-.38.17-.5.13-.49.07-.33c0-.01.01-.03.01-.04.01-.03.01-.06.02-.08l.07-.46.05-.45.03-.45.01-.45c-.02-.07-.02-.15-.02-.22z\" fill=\"url(#P)\"/><path d=\"M92.2 67.72v-.01l.09.06-.09-.05z\" fill=\"url(#Q)\"/><path d=\"M93.53 71.79v-.1c0 .02-.01.03-.01.04 0-.19-.01-.37-.03-.51v-.03l-.06-.33c.01.03 0 .06.01.09-.01-.03-.01-.06-.02-.08l-.02-.14-.1-.32c-.01-.02-.02-.06-.04-.08l-.06-.14c-.01-.03-.02-.07-.04-.11l.03.09-.03-.06-.05-.11-.12-.27-.09-.15c-.02-.04-.05-.08-.07-.12l-.03-.05-.32-.45-.03-.03c-.03-.04-.07-.08-.1-.12l-.11-.13-.06-.06-.08-.08-.13-.12-.03-.03-.02-.02-.24-.21-.27-.21-.22-.15-.17-.11-.04-.02-.16-.09-.05-.03c-.01 0-.02-.01-.03-.02l-46-26.04a.27.27 0 0 0-.11-.05l-.1-.03a.36.36 0 0 0-.11-.02c-.04-.01-.08-.01-.12-.01h-.13c-.02 0-.04 0-.06.01-.03 0-.05 0-.08.01-.06.01-.11.02-.17.04-.07.02-.15.05-.22.08-.1.04-.21.1-.32.16-.22.13-.43.29-.62.48-.05.04-.09.09-.13.14l-.03.03-.05.05-.16.19-.13.17c-.04.05-.08.11-.12.17-.04.05-.07.11-.11.16l-.05.08c-.02.03-.04.05-.05.08l-.09.16c-.03.05-.06.11-.08.17l-.08.17c-.03.06-.05.12-.07.18l-.07.19-.06.22-.06.27c-.03.16-.04.31-.04.46-.01.56.18.97.48 1.17l43.9 29.49.01.01.11.08c.05.04.13.08.18.12l.2.12c.08.05.2.11.29.16l.07.03.22.1.4.16.34.11.12.03c.01 0 .03.01.04.01l.39.08.37.04c.19.01.26.02.43.01.08 0 .18-.01.33-.02l.36-.05.58-.15c.18-.06.35-.13.61-.25l.28-.16.26-.17.06-.04.21-.16.17-.14.19-.18.18-.18.16-.18c.01-.01.01-.02.02-.02.12-.14.22-.28.32-.42.03-.04.06-.08.08-.12l.12-.2.1-.18.02-.02.11-.21c.01-.02.02-.05.04-.08l.12-.28.03-.09.01-.02c.01-.02.01-.03.02-.05l.02-.07.03-.1.01-.02.01-.02.06-.21.06-.27.05-.27.03-.32.01-.3v-.03zm-3.23-4.38c.05.01.08.03.13.05-.05-.02-.11-.04-.17-.05h.04zm-3.31 1.61l-.15.19.15-.19zm-1.79 3.06c0-.01.01-.03.02-.04l-.03.09c0-.01 0-.03.01-.05zm-.21.84v-.03c-.05.28-.08.56-.08.83.01-.25.03-.52.08-.8zm.23 2.2c-.03-.06-.07-.11-.1-.18.03.07.07.12.1.18zm-.21-.55c-.02-.06-.04-.12-.05-.19.01.07.04.13.05.19zm.36.81c.04.06.09.1.14.15-.04-.05-.1-.09-.14-.15zm.51-4.83c.02-.03.03-.06.05-.09.01-.02.02-.03.03-.05 0-.01.01-.01.01-.02-.04.06-.06.11-.09.16zm.39-.62l.17-.25-.17.25zm.22-.31c.03-.04.08-.09.12-.15l-.12.15zm.57-.67l.03-.03c.09-.1.19-.18.29-.27l-.32.3zm.67-.61l.14-.12-.14.12zm1.08-.67c.07-.03.14-.07.2-.1.04-.01.07-.02.11-.04.05-.02.1-.02.14-.04-.153.051-.304.111-.45.18zm.81-.26c.02 0 .04-.01.06-.01s.03 0 .05-.01h.03c-.01 0-.01 0-.02.01-.04 0-.08 0-.12.01z\" fill=\"url(#R)\"/></g></g><defs><linearGradient id=\"A\" x1=\"-11.899\" y1=\"61.353\" x2=\"68.329\" y2=\"61.353\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".156\" stop-color=\"#fdfbfe\"/><stop offset=\".295\" stop-color=\"#f7f1fb\"/><stop offset=\".428\" stop-color=\"#ecdef6\"/><stop offset=\".557\" stop-color=\"#ddc5ef\"/><stop offset=\".683\" stop-color=\"#caa4e6\"/><stop offset=\".807\" stop-color=\"#b27bdb\"/><stop offset=\".927\" stop-color=\"#974cce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"-3.71\" y1=\"55.214\" x2=\"61.349\" y2=\"55.214\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".156\" stop-color=\"#fdfbfe\"/><stop offset=\".295\" stop-color=\"#f7f1fb\"/><stop offset=\".428\" stop-color=\"#ecdef6\"/><stop offset=\".557\" stop-color=\"#ddc5ef\"/><stop offset=\".683\" stop-color=\"#caa4e6\"/><stop offset=\".807\" stop-color=\"#b27bdb\"/><stop offset=\".927\" stop-color=\"#974cce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"40.146\" y1=\"29.548\" x2=\"58.967\" y2=\"29.548\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"26.468\" y1=\"29.686\" x2=\"64.972\" y2=\"29.686\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"34.41\" y1=\"30.456\" x2=\"64.159\" y2=\"30.456\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"38.365\" y1=\"32.467\" x2=\"50.705\" y2=\"32.467\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"13.705\" y1=\"33.364\" x2=\"64.256\" y2=\"33.364\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"32.909\" y1=\"34.38\" x2=\"50.719\" y2=\"34.38\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"13.572\" y1=\"43.816\" x2=\"50.621\" y2=\"43.816\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\".021\" y1=\"38.729\" x2=\"62.244\" y2=\"38.729\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"5.356\" y1=\"44.818\" x2=\"37.722\" y2=\"44.818\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"12.154\" y1=\"45.834\" x2=\"36.604\" y2=\"45.834\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"14.731\" y1=\"46.566\" x2=\"27.1\" y2=\"46.566\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"2.121\" y1=\"45.999\" x2=\"29.805\" y2=\"45.999\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"5.309\" y1=\"49.485\" x2=\"34.103\" y2=\"49.485\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"2.022\" y1=\"48.707\" x2=\"32.313\" y2=\"48.707\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"92.195\" y1=\"67.742\" x2=\"92.287\" y2=\"67.742\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"R\" x1=\"-2.199\" y1=\"59.074\" x2=\"103.573\" y2=\"59.074\" xlink:href=\"#V\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"S\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"T\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><path id=\"U\" d=\"M41.84 24.15c4.92 2.84 8.89 9.72 8.88 15.37-.02 5.64-4.01 7.93-8.93 5.09s-8.89-9.74-8.88-15.37c.01-5.65 4.01-7.93 8.93-5.09z\"/><linearGradient id=\"V\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeNaturalEvents = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#P)\"><g clip-path=\"url(#Q)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M64.34 68.54l-25.97-15.1-.04-12.77 25.98 15.09.03 12.78z\" fill=\"url(#A)\"/><path d=\"M63.55 68.08l-9.93 5.74V57.28l9.93-5.78v16.58z\" fill=\"url(#B)\"/><path d=\"M69.2 42.31l-13.89-.46-13.84 16.46v23.36l.07.03 15.9-9.17-.04-12.78 6.91-3.99.03 12.78 4.92-2.84-.06-23.39z\" fill=\"url(#C)\"/><path d=\"M15.5 43.22l.06 23.39 25.91 15.06V58.31L15.5 43.22z\" fill=\"url(#D)\"/><path d=\"M43.22 27.21l-13.89-.46L15.5 43.22l25.97 15.09 13.84-16.46 13.89.46-25.98-15.1z\" fill=\"url(#E)\"/><path d=\"M52.31 62.66l.02 5.49-3.62 2.09-.01-5.5 3.61-2.08z\" fill=\"url(#F)\"/><path d=\"M52.31 62.66l.02 5.49-3.62 2.09-.01-5.5 3.61-2.08z\" fill=\"#fff\"/><path d=\"M57.6 45.55l.02 5.49L54 53.13l-.01-5.49 3.61-2.09z\" fill=\"url(#G)\"/><path d=\"M57.6 45.55l.02 5.49L54 53.13l-.01-5.49 3.61-2.09z\" fill=\"#fff\"/><path d=\"M24.27 57.6l-.01 5.5-3.62-2.09.02-5.49 3.61 2.08z\" fill=\"url(#H)\"/><path d=\"M24.27 57.6l-.01 5.5-3.62-2.09.02-5.49 3.61 2.08z\" fill=\"#fff\"/><path d=\"M28.97 60.4l-.01 5.49-3.62-2.08.02-5.5 3.61 2.09z\" fill=\"url(#I)\"/><path d=\"M28.97 60.4l-.01 5.49-3.62-2.08.02-5.5 3.61 2.09z\" fill=\"#fff\"/><path d=\"M47.54 25.41l14.32-7.86 1.58 2.66-14.33 7.85L45 53.02l-1.59-2.66 4.13-24.95z\" fill=\"url(#J)\"/><path d=\"M45 53.02l-37.56.32-1.59-2.66 37.56-.32L45 53.02z\" fill=\"url(#K)\"/><path d=\"M24.3 17.87L9.98 25.73 5.85 50.68l37.56-.32 4.13-24.95 14.32-7.86-37.56.32z\" fill=\"url(#L)\"/><path d=\"M12.71 27.23l3.93-.05-1.91 3.44-3.94.04 1.92-3.43z\" fill=\"url(#M)\"/><path d=\"M16.64 27.18l-1.91 3.44-3.94.04 4.24 7.21 3.94-.05.85-5.23-3.18-5.41z\" fill=\"url(#N)\"/><path d=\"M55.03 36.83c-.98 0-1.98-.35-2.82-1-1.11-.86-1.8-2.1-1.9-3.41-.19-2.5 1.73-4.96 4.27-5.49.58-.12 1.16.25 1.28.84s-.25 1.16-.84 1.28c-1.49.31-2.66 1.78-2.56 3.21.05.69.45 1.39 1.07 1.86.56.44 1.23.62 1.83.52 2.09-.38 4.23-2.64 5.8-4.3l.21-.22 1.12-1.2c1.42-1.54 2.89-3.13 4.62-4.43.48-.36 1.16-.26 1.52.22s.26 1.16-.22 1.52c-1.58 1.19-2.91 2.63-4.33 4.17l-1.14 1.22-.21.22c-1.77 1.87-4.19 4.44-6.99 4.94l-.71.05zM72 35.35c-.24 0-.49-.08-.69-.25a1.08 1.08 0 0 1-.14-1.52c1.55-1.86 3.8-2.8 5.78-3.53l.58-.21c1.76-.64 3.43-1.25 4.73-2.35a1.09 1.09 0 0 1 1.53.14 1.09 1.09 0 0 1-.14 1.53c-1.6 1.34-3.52 2.04-5.38 2.72l-.57.21c-1.72.64-3.66 1.44-4.87 2.89-.21.24-.52.37-.83.37zm-6.12 20.89c-2.58 0-5.43-1.47-6.23-4.23-.42-1.44-.2-2.92.11-4.3.23-1.04.54-2.22 1.32-3.21.98-1.23 2.51-1.77 3.83-1.34a1.08 1.08 0 0 1 .671 1.351 1.08 1.08 0 0 1-1.332.709c-.44-.14-1.07.13-1.47.63-.5.62-.72 1.53-.9 2.32-.28 1.27-.41 2.31-.14 3.24.56 1.91 2.85 2.87 4.67 2.64 1.87-.23 3.77-1.44 5.37-3.42 1.04-1.29 1.86-2.74 2.73-4.26l1.08-1.86c1.391-2.3 3.002-4.46 4.81-6.45a1.09 1.09 0 0 1 1.53-.07 1.09 1.09 0 0 1 .07 1.53c-1.71 1.88-3.25 3.94-4.56 6.11l-1.05 1.81c-.87 1.53-1.77 3.12-2.93 4.55-1.95 2.42-4.36 3.92-6.79 4.21l-.79.04zm14.93-7.37a1.09 1.09 0 0 1-.907-.505 1.09 1.09 0 0 1-.073-1.035c1.51-3.21 3.85-5.95 6.78-7.95.44-.3.89-.58 1.34-.86.76-.47 1.48-.92 2.13-1.45.75-.62 1.7-1.61 1.92-2.83a1.08 1.08 0 0 1 .443-.699 1.08 1.08 0 0 1 .807-.181c.59.1.98.67.88 1.25-.26 1.49-1.19 2.92-2.68 4.13-.75.62-1.56 1.12-2.35 1.61l-1.27.81c-2.61 1.78-4.7 4.23-6.04 7.08-.18.4-.57.63-.98.63zm11.41 24.9c-.38 0-.7-.3-.72-.68-.27-5.03-1.61-8.19-3.98-9.38-3.56-1.79-8.45 1.41-8.5 1.44-.33.22-.78.13-1-.2s-.13-.78.2-1c.23-.15 5.63-3.7 9.95-1.53 2.87 1.44 4.48 5 4.78 10.59.02.4-.28.74-.68.76h-.05z\" fill=\"#e3d4ff\"/><path d=\"M71.6 60.5c-1.16.15-2.33.69-2.96 1.68-.27.42-.43.92-.77 1.29-.6.66-1.6.76-2.49.66s-1.76-.37-2.65-.28c-1.23.12-2.37.96-2.83 2.11-.31.77-.42 1.6-.16 2.4.08.25.2.5.16.76-.11.73-1.51.7-2.06.87-.85.27-1.67.66-2.33 1.27-1.31 1.21-1.65 3.64-.19 4.68.55.4 1.31.57 1.66 1.15.37.61.12 1.4.18 2.11.13 1.5 1.74 2.53 3.25 2.51s2.88-.85 4.06-1.78c.6-.47 1.27-1.01 2.03-.93.76.07 1.32.72 2.01 1.05 1.28.61 2.88-.01 3.82-1.07.71-.8.87-1.85 1.85-2.46.62-.39 1.47-.48 2.08-.07.59.39.95 1.21 1.66 1.26.67.04 1.12-.65 1.38-1.26.44-1.04.53-2.21.96-3.23l1.16-2.84c.61-2.04.88-4.35-.09-6.32-1.48-3-6.81-3.93-9.73-3.56z\" fill=\"url(#O)\"/></g></g><defs><linearGradient id=\"A\" x1=\"33.059\" y1=\"54.603\" x2=\"65.027\" y2=\"54.603\" xlink:href=\"#R\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"51.834\" y1=\"62.658\" x2=\"67.336\" y2=\"62.658\" xlink:href=\"#R\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"-4.028\" y1=\"61.776\" x2=\"71.527\" y2=\"61.776\" xlink:href=\"#R\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"1.955\" y1=\"62.442\" x2=\"77.509\" y2=\"62.442\" xlink:href=\"#R\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"-24.196\" y1=\"42.533\" x2=\"70.97\" y2=\"42.533\" xlink:href=\"#R\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"48.696\" y1=\"66.448\" x2=\"52.326\" y2=\"66.448\" xlink:href=\"#R\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"53.985\" y1=\"49.34\" x2=\"57.616\" y2=\"49.34\" xlink:href=\"#R\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"20.642\" y1=\"59.306\" x2=\"24.272\" y2=\"59.306\" xlink:href=\"#R\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"25.342\" y1=\"62.105\" x2=\"28.972\" y2=\"62.105\" xlink:href=\"#R\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"-3.163\" y1=\"35.284\" x2=\"73.02\" y2=\"35.284\" xlink:href=\"#R\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"-13.859\" y1=\"51.847\" x2=\"69.207\" y2=\"51.847\" xlink:href=\"#R\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\".4\" y1=\"34.115\" x2=\"83.968\" y2=\"34.115\" xlink:href=\"#R\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"8.608\" y1=\"28.923\" x2=\"20.161\" y2=\"28.923\" xlink:href=\"#R\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"7.652\" y1=\"32.526\" x2=\"27.683\" y2=\"32.526\" xlink:href=\"#R\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"50.045\" y1=\"71.065\" x2=\"87.638\" y2=\"71.065\" xlink:href=\"#R\"><stop stop-color=\"#fff\"/><stop offset=\".143\" stop-color=\"#f1e7f8\"/><stop offset=\".444\" stop-color=\"#cdaae8\"/><stop offset=\".877\" stop-color=\"#9548cd\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"P\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"Q\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"R\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeRobberiesOutside = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#K)\"><g clip-path=\"url(#L)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M64.34 36.02c12.5 7.22 12.57 18.92.15 26.14s-32.63 7.22-45.13 0-12.58-18.92-.16-26.14 32.63-7.21 45.14 0z\" fill=\"url(#A)\"/><path d=\"M20.78 49.5s.49 5.59 18.25 8.22 23.18-6.82 23.18-6.82-2.96-25.4-7.97-30.01c-3.05-2.8-6.97-3.41-9.58-3.46-1.28-.02-2.56.13-3.81.41-1.57.35-4.96.97-9.73 1.13 0 0-2.32-.05-3.13 1.47-.79 1.51-6.41 13.19-7.21 29.06z\" fill=\"url(#B)\"/><path d=\"M51.01 23.81c.36.24.72.49 1 .83s.47.76.43 1.2c-.04.48-.37.91-.78 1.17s-.88.39-1.36.48c-2.98.55-6.06-.24-8.89-1.32-3.03-1.15-6.02-2.71-8.07-5.22-.32-.39-.62-.92-.39-1.37.2-.37.68-.47 1.11-.52 1.25-.14 2.52-.19 3.78-.14l1.9.14c.54.06 1.12.09 1.64.27l1.34.47 1.66.6c1.097.421 2.172.899 3.22 1.43 1.048.526 2.066 1.111 3.05 1.75l.36.23z\" fill=\"url(#C)\"/><path d=\"M43.19 73.04l-.03.1c-.11.31-.27.61-.46.9-.04.05-.07.11-.11.16-.21.29-.47.58-.77.85-.2.18-.45.34-.69.51l-.59.42c-.58.34-1.24.61-1.92.84l-.73.22-.97.24-1.18.2-.29.04a14.82 14.82 0 0 1-1.63.09h-.26c-.54 0-1.08-.03-1.61-.09l-.24-.03c-.53-.06-1.05-.15-1.56-.27l-.28-.07a11.75 11.75 0 0 1-1.35-.41l-.23-.08c-.52-.2-1.02-.43-1.48-.7-1.44-.83-2.34-1.85-2.69-2.92-.12-.36-.18-.72-.18-1.08l-.01 2.26c0 1.45.95 2.9 2.87 4 .44.25.91.48 1.41.67.02.01.05.02.08.03l.24.08.87.29.48.12.28.07.25.06.96.17c.11.02.23.02.34.04l.24.03.36.04.95.05h.3.26.43l1.07-.07a.5.5 0 0 0 .12-.02l.29-.04.82-.11c.12-.02.23-.06.35-.09l.97-.24c.17-.05.35-.07.51-.13.08-.03.14-.07.22-.1.68-.23 1.33-.5 1.92-.84.04-.02.08-.05.12-.07.18-.11.31-.24.48-.35l.69-.51c.02-.02.05-.03.07-.05.23-.21.43-.43.6-.65.04-.05.07-.1.1-.15.04-.05.07-.11.11-.16l.18-.27c.1-.18.19-.37.26-.55.01-.03.01-.06.02-.08l.03-.11c.04-.12.08-.24.1-.36.04-.18.06-.37.06-.56v-.08l.01-2.26c.01.36-.06.69-.16 1.02z\" fill=\"url(#D)\"/><path d=\"M40.49 68.04c3.81 2.2 3.83 5.75.04 7.95-3.78 2.2-9.92 2.2-13.73 0s-3.83-5.75-.04-7.95c3.78-2.2 9.92-2.2 13.73 0z\" fill=\"url(#E)\"/><path d=\"M41.69 69.57l-.03.1c-.11.31-.27.61-.46.9-.04.05-.07.11-.11.16-.21.29-.47.58-.77.85-.2.18-.45.34-.69.51l-.59.42c-.58.34-1.24.61-1.92.84l-.73.22-.97.24-1.18.2-.29.04a14.87 14.87 0 0 1-1.63.09h-.26c-.54 0-1.08-.03-1.61-.09l-.24-.03c-.53-.06-1.05-.15-1.56-.27l-.28-.07a11.75 11.75 0 0 1-1.35-.41l-.23-.08c-.52-.2-1.02-.43-1.48-.7-1.44-.83-2.34-1.85-2.69-2.92-.12-.36-.18-.72-.18-1.08l-.01 2.26c0 1.45.95 2.9 2.87 4 .44.25.91.48 1.41.67a.69.69 0 0 0 .08.03l.24.08.87.29.48.12.28.07.25.06.96.17c.11.02.23.02.34.04l.24.03.36.04.95.05h.3.26.43l1.07-.07c.04 0 .08-.01.12-.02l.29-.04.82-.11c.12-.02.23-.06.35-.09l.97-.24c.17-.05.35-.07.51-.13.08-.03.14-.07.22-.1.68-.23 1.33-.5 1.92-.84.04-.02.08-.05.12-.07.18-.11.31-.24.48-.35l.69-.51c.02-.02.05-.03.07-.05.23-.21.43-.43.6-.65.04-.05.07-.1.1-.15.04-.05.07-.11.11-.16l.18-.27c.1-.18.19-.37.26-.55.01-.03.01-.06.02-.08l.03-.11c.04-.12.08-.24.1-.36.04-.18.06-.37.06-.56v-.09l.01-2.26c.01.36-.05.7-.16 1.03z\" fill=\"url(#F)\"/><path d=\"M38.99 64.57c3.81 2.2 3.83 5.75.04 7.95-3.78 2.2-9.92 2.2-13.73 0s-3.83-5.75-.04-7.95 9.92-2.2 13.73 0z\" fill=\"url(#G)\"/><path d=\"M44.36 68.32l-.03.1c-.11.31-.27.61-.46.9-.04.05-.07.11-.11.16-.21.29-.47.58-.77.85-.2.18-.45.34-.69.51l-.59.42c-.58.34-1.24.61-1.92.84l-.73.22-.97.24-1.18.2-.29.04a14.87 14.87 0 0 1-1.63.09h-.26c-.54 0-1.08-.03-1.61-.09l-.24-.03c-.53-.06-1.05-.15-1.56-.27l-.28-.07a11.75 11.75 0 0 1-1.35-.41l-.23-.08c-.52-.2-1.02-.43-1.48-.7-1.44-.83-2.34-1.85-2.69-2.92-.12-.36-.18-.72-.18-1.08l-.01 2.26c0 1.45.95 2.9 2.87 4 .44.25.91.48 1.41.67a.69.69 0 0 0 .08.03l.24.08.87.29.48.12.28.07.25.06.96.17c.11.02.23.02.34.04l.24.03.36.04.95.05h.3.26.43l1.07-.07c.04 0 .08-.01.12-.02l.29-.04.82-.11c.12-.02.23-.06.35-.09l.97-.24c.17-.05.35-.07.51-.13.08-.03.14-.07.22-.1.68-.23 1.33-.5 1.92-.84.04-.02.08-.05.12-.07.18-.11.31-.24.48-.35l.69-.51c.02-.02.05-.03.07-.05.23-.21.43-.43.6-.65.04-.05.07-.1.1-.15.04-.05.07-.11.11-.16l.18-.27c.1-.18.19-.37.26-.55.01-.03.01-.06.02-.08l.03-.11c.04-.12.08-.24.1-.36.04-.18.06-.37.06-.56v-.08l.01-2.26c0 .36-.06.69-.16 1.02z\" fill=\"url(#H)\"/><path d=\"M41.65 63.32c3.81 2.2 3.83 5.75.04 7.95-3.78 2.2-9.92 2.2-13.73 0s-3.83-5.75-.04-7.95 9.93-2.2 13.73 0z\" fill=\"url(#I)\"/><path d=\"M38.43 67.52l1.94.13c.03.29-.07.61-.32.94s-.61.63-1.09.89c-.81.46-1.66.69-2.56.71-.89.03-1.84-.15-2.8-.54l-.87.49-.64-.73.45-.25-.1-.05-.09-.06-.2-.12-.27-.16-.22-.16-.74.41-.63-.76.56-.31c-.59-.6-.8-1.18-.64-1.72.15-.56.67-1.08 1.54-1.56.12-.07.27-.14.44-.22l.56-.23c.18-.07.36-.15.53-.19.17-.05.31-.09.43-.1l.87 1.08c-.18.02-.4.08-.66.16-.26.09-.51.21-.76.35-.37.21-.62.43-.73.68-.11.24-.07.51.12.82l2.53-1.42.64.76-2.43 1.37.22.15.23.14.22.13.1.06.12.06 2.18-1.22.63.73-1.72.96c.46.15.89.21 1.3.2a2.5 2.5 0 0 0 1.17-.32c.3-.17.5-.35.6-.53.1-.2.13-.39.09-.57z\" fill=\"#fff\"/><path d=\"M81.06 59.11c1.48-.86 4.06-1.62 6.93.71 4.51 3.65.66 8.5-1.86 10.3-.19.13-.39.26-.6.38-2.58 1.49-6.43 1.89-7.86 1.83-1.49-.07-2.65.59-2.71.63 0 0-1.2.68-1.08 1.56.11.83-.6 3.06-3.18 4.55-.21.12-.43.24-.66.34-3.12 1.45-11.5 3.66-17.79 1.04-4.01-1.67-2.69-3.16-1.21-4.01.84-.49 1.69-.75 1.74-.77.35-.15 7.06-2.95 14.45-7.22 7.4-4.27 12.25-8.14 12.5-8.34.02-.02.48-.51 1.33-1zm-12.3 14.87c-.91-.74-3.76-.47-6.38.6a12.63 12.63 0 0 0-1.47.71c-1.63.94-2.35 1.98-1.65 2.56.89.75 3.76.48 6.37-.59.56-.23 1.06-.47 1.5-.72 1.62-.94 2.33-1.98 1.63-2.56zm13.66-6.42c1.86-1.51 2.33-3.17 1.04-3.69-1-.41-2.8 0-4.43.94-.435.25-.85.534-1.24.85-1.85 1.52-2.33 3.17-1.05 3.7 1 .41 2.8 0 4.42-.93.446-.251.868-.542 1.26-.87z\" fill=\"url(#J)\"/></g></g><defs><linearGradient id=\"A\" x1=\"-2.389\" y1=\"49.095\" x2=\"98.224\" y2=\"49.095\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"16.117\" y1=\"37.801\" x2=\"73.934\" y2=\"37.801\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"9.656\" y1=\"23.43\" x2=\"62.428\" y2=\"23.202\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"19.908\" y1=\"75.942\" x2=\"55.757\" y2=\"75.942\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"15.022\" y1=\"72.016\" x2=\"51.869\" y2=\"72.016\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"18.411\" y1=\"72.468\" x2=\"54.26\" y2=\"72.468\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"13.525\" y1=\"68.542\" x2=\"50.372\" y2=\"68.542\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"21.075\" y1=\"71.22\" x2=\"56.925\" y2=\"71.22\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"16.19\" y1=\"67.294\" x2=\"53.037\" y2=\"67.294\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"44.292\" y1=\"69.974\" x2=\"99.072\" y2=\"69.974\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"K\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"L\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"M\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeTelephoneLegal = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#X)\"><g clip-path=\"url(#Y)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M43.98 61.94c-.36-.21-.54-.48-.54-.76l.13-46.53c0 .27.18.55.54.76l-.13 46.53z\" fill=\"url(#A)\"/><path d=\"M44.12 15.41l-.13 46.53c-.36-.21-.54-.48-.54-.76l.13-46.53c-.01.28.17.55.54.76z\" fill=\"url(#A)\"/><path d=\"M42.19 61.18l.13-46.53c0 .46.3.92.91 1.27l-.13 46.54c-.61-.35-.91-.82-.91-1.28z\" fill=\"url(#B)\"/><path d=\"M76.22 30.94l-.13 46.54-29.51-17.04.13-46.54 29.51 17.04z\" fill=\"url(#C)\"/><path d=\"M77.11 30.43l-.13 46.53-.89.52.13-46.54.89-.51z\" fill=\"url(#D)\"/><path d=\"M75.07 30.28l-2.59 1.51-28.36-16.38c-.72-.41-.72-1.09 0-1.51.71-.41 1.88-.41 2.59 0l28.36 16.38z\" fill=\"url(#E)\"/><path d=\"M72.48 31.78l-.13 46.54-28.37-16.38.14-46.53 28.36 16.37z\" fill=\"url(#F)\"/><path d=\"M75.07 30.28l-.13 46.53-2.59 1.51.13-46.54 2.59-1.5z\" fill=\"url(#G)\"/><path d=\"M77.11 30.43l-.88.51L46.71 13.9c-.72-.41-1.88-.41-2.59 0-.72.42-.72 1.09 0 1.51l24.83 19.3-.98.44-24.74-19.23c-1.21-.7-1.21-1.83-.01-2.53s3.16-.7 4.37 0l29.52 17.04z\" fill=\"url(#H)\"/><path d=\"M68.94 34.71l-.13 46.53-.98.44.14-46.53.97-.44z\" fill=\"url(#I)\"/><path d=\"M43.23 15.92c-.61-.35-.91-.81-.91-1.27l-.13 46.53c0 .46.3.92.91 1.27l24.73 19.22.13-46.53-24.73-19.22z\" fill=\"url(#J)\"/><path d=\"M47.97 31.84c.41-.16.7-.15.72-.15.04 0 .9-.09 1.46.45.55.52.69 1.11.69 1.14l2 6.64c.01.03.17.67-.28.84l-.09.03-1.66.34s-.02 0-.06.02c-.15.06-.5.29-.33 1.2.21 1.11 1 3.74 2.41 6.86 1.4 3.11 2.86 5.47 3.58 6.4.57.74 1 .66 1.14.6.04-.01.05-.03.06-.03l1.42-.87c.03-.02.06-.03.08-.04.44-.17.82.37.84.4l3.7 5.97c.02.03.38.53.4 1.27.01.73-.65 1.24-.68 1.27-.01.01-.21.21-.62.37-1.02.4-3.26.47-6.54-3.89-2.96-3.94-5.75-10.14-5.9-10.47s-2.97-6.53-3.92-11.26c-1.06-5.24.56-6.69 1.58-7.09z\" fill=\"url(#K)\"/><path d=\"M33.94 28.45l1.07-.11-9.34 31.47-1.07.11 9.34-31.47z\" fill=\"url(#L)\"/><path d=\"M31.15 37.89l1.06-.11-1.66 5.62-1.07.11 1.67-5.62z\" fill=\"url(#M)\"/><path d=\"M25.16 61.61l1.06-.11 11.52 6.65-1.06.12-11.52-6.66z\" fill=\"url(#N)\"/><path d=\"M42.55 32.07l1.07-.12-11.41 5.83-1.06.11 11.4-5.82z\" fill=\"url(#O)\"/><path d=\"M46.93 34.6l1.07-.12-17.45 8.92-1.07.11 17.45-8.91z\" fill=\"url(#P)\"/><path d=\"M47.27 36.15c.16-.55 0-1.18-.37-1.53l-17.42 8.9 1.66-5.62 11.41-5.83 4.16 2.4-11.52-6.67c-.5-.29-1.06 0-1.25.65L24.6 59.92c-.19.65.06 1.41.55 1.69l11.52 6.65c.01 0 .02.01.02.01.01.01.03.01.04.02s.03.01.04.02.03.01.04.02c.015.008.033.012.05.01.01 0 .02.01.04.01.03 0 .04.01.06.01s.04 0 .06.01h.02.03.06l1.07-.11a.87.87 0 0 1-.23-.01c-.08-.02-.16-.05-.24-.09l-.19.02c.16-.13.3-.31.37-.56l9.36-31.47z\" fill=\"#fff\"/><path d=\"M42.55 32.07l1.07-.12 4.16 2.41-1.07.11-4.16-2.4z\" fill=\"url(#Q)\"/><path d=\"M35.19 27.8l1.07-.11 11.52 6.67-1.07.11-11.52-6.67z\" fill=\"url(#R)\"/><path d=\"M46.93 34.6l-17.45 8.91 1.67-5.62 11.4-5.82 4.16 2.4.22.13z\" fill=\"url(#S)\"/><path d=\"M46.71 34.47l1.07-.11.22.12-1.07.12-.22-.13z\" fill=\"url(#T)\"/><path d=\"M47.27 36.15l1.07-.12-9.35 31.47-1.06.11 9.34-31.46z\" fill=\"url(#U)\"/><path d=\"M46.97 33.74c.8.46 1.21 1.66.9 2.68L37.49 71.45c-.3 1.02-1.2 1.47-2 1.01l-11.61-6.7c-.8-.46-1.19-1.65-.89-2.67l10.38-35.03c.3-1.02 1.19-1.47 1.98-1.01l11.62 6.69zm-9.04 33.87l9.34-31.47c.16-.55 0-1.18-.37-1.53l-.19-.14-11.52-6.67c-.5-.29-1.06 0-1.25.65L24.6 59.92c-.19.65.06 1.41.55 1.69l11.52 6.65c.5.29 1.06.01 1.26-.65z\" fill=\"url(#V)\"/><path d=\"M49.04 35.53c0-.05 0-.09-.01-.13a.78.78 0 0 0-.02-.15c-.008-.068-.021-.135-.04-.2-.01-.05-.04-.1-.06-.15l-.1-.29c-.03-.07-.04-.14-.07-.21-.03-.06-.07-.12-.11-.18-.03-.04-.06-.08-.08-.12-.02-.03-.05-.06-.08-.09-.02-.03-.05-.05-.07-.08l-.07-.07c-.02-.02-.05-.04-.07-.06s-.04-.04-.07-.05c-.02-.02-.04-.03-.07-.05-.02-.02-.04-.03-.07-.04-.01-.01-.02-.01-.03-.02l-11.61-6.7c-.01-.01-.03-.01-.04-.02-.02-.01-.05-.02-.07-.04-.02-.01-.05-.02-.07-.03s-.05-.02-.07-.03-.05-.02-.07-.02c-.02-.01-.04-.01-.06-.01h-.02c-.03-.01-.05-.01-.08-.01s-.06-.01-.09-.01h-.1c-.03 0-.06 0-.1.01l-1.07.11a1.23 1.23 0 0 1 .38.02c.137.031.268.081.39.15l11.61 6.7c.35.2.61.57.79.98.039.094.073.191.1.29.06.2.11.41.11.63.01.26-.02.53-.1.78L37.49 71.45c-.05.17-.12.33-.2.46-.09.14-.18.26-.29.36-.07.07-.15.11-.23.16-.04.03-.08.06-.12.08-.12.06-.26.1-.39.11l1.07-.11a1.03 1.03 0 0 0 .39-.11c.04-.02.08-.06.12-.08l.23-.16c.05-.04.08-.07.12-.11.03-.03.05-.06.08-.1l.06-.09c.01-.01.02-.03.02-.04.02-.02.03-.03.03-.05.02-.03.03-.06.04-.08.01-.03.03-.06.04-.08l.03-.08.03-.08.03-.09 10.38-35.04c.01-.03.02-.05.02-.08.01-.03.01-.06.02-.09s.01-.06.02-.09.01-.06.01-.09.01-.06.01-.1c0-.03.01-.07.01-.1v-.11c.03-.05.02-.09.02-.13z\" fill=\"url(#W)\"/><path d=\"M30.65 65.85c.54.31.8 1.11.6 1.8-.2.67-.79.97-1.33.67-.52-.3-.79-1.1-.59-1.78.21-.69.8-.99 1.32-.69z\" fill=\"#fff\"/><g fill=\"#e3d4ff\"><use xlink:href=\"#Z\"/><path d=\"M35.64 57.24c.33.19.49.68.36 1.09l-.19.64c-.12.42-.49.6-.81.41l-.47-.27c-.33-.19-.49-.68-.36-1.09l.19-.64c.12-.42.49-.6.81-.41l.47.27z\"/><path d=\"M36.34 54.88c.33.19.49.68.36 1.09l-.19.64c-.12.42-.49.6-.81.41l-.47-.27c-.33-.19-.49-.68-.36-1.09l.19-.64c.12-.42.49-.6.81-.41l.47.27zm-5.09 2.6c.33.19.49.68.36 1.09l-.19.64c-.12.42-.49.6-.81.41l-.47-.27c-.33-.19-.49-.68-.36-1.09l.19-.64c.12-.42.49-.6.81-.41l.47.27zm1.15 3.43c.33.19.49.68.36 1.09l-.19.64c-.12.42-.49.6-.81.41l-.47-.27c-.33-.19-.49-.68-.36-1.09l.19-.64c.12-.42.49-.6.81-.41l.47.27z\"/><path d=\"M31.95 55.11c.33.19.49.68.36 1.09l-.19.64c-.12.42-.49.6-.81.41l-.47-.27c-.33-.19-.49-.68-.36-1.09l.19-.64c.12-.42.49-.6.81-.41l.47.27zm1.85 1.07c.33.19.49.68.36 1.09l-.19.64c-.12.42-.49.6-.81.41l-.47-.27c-.33-.19-.49-.68-.36-1.09l.19-.64c.12-.42.49-.6.81-.41l.47.27zm1.14 3.43c.33.19.49.68.36 1.09l-.19.64c-.12.42-.49.6-.81.41l-.47-.27c-.33-.19-.49-.68-.36-1.09l.19-.64c.12-.42.49-.6.81-.41l.47.27z\"/><path d=\"M34.5 53.81c.33.19.49.68.36 1.09l-.19.64c-.12.42-.49.6-.81.41l-.47-.27c-.33-.19-.49-.68-.36-1.09l.19-.64c.12-.42.49-.6.81-.41l.47.27zm-1.85-1.06c.33.19.49.68.36 1.09l-.19.64c-.12.42-.49.6-.81.41l-.47-.27c-.33-.19-.49-.68-.36-1.09l.19-.64c.12-.42.49-.6.81-.41l.47.27z\"/></g></g></g><defs><linearGradient id=\"A\" x1=\"43.443\" y1=\"38.297\" x2=\"44.116\" y2=\"38.297\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"42.19\" y1=\"38.552\" x2=\"43.231\" y2=\"38.552\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"63.387\" y1=\"45.69\" x2=\"176.156\" y2=\"45.69\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"64.966\" y1=\"53.954\" x2=\"77.453\" y2=\"53.954\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"28.529\" y1=\"22.686\" x2=\"173.817\" y2=\"22.686\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"-9.569\" y1=\"46.862\" x2=\"82.693\" y2=\"46.862\" xlink:href=\"#a\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"G\" x1=\"68.979\" y1=\"54.297\" x2=\"91.478\" y2=\"54.297\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"50.13\" y1=\"30.304\" x2=\"70.421\" y2=\"13.278\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"55.279\" y1=\"58.196\" x2=\"69.825\" y2=\"58.196\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"34.329\" y1=\"48.165\" x2=\"74.868\" y2=\"48.165\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"42.538\" y1=\"48.205\" x2=\"87.07\" y2=\"48.205\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"24.601\" y1=\"44.13\" x2=\"35.011\" y2=\"44.13\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"29.48\" y1=\"40.646\" x2=\"32.213\" y2=\"40.646\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"25.156\" y1=\"64.883\" x2=\"37.744\" y2=\"64.883\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"31.146\" y1=\"34.924\" x2=\"43.619\" y2=\"34.924\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"29.48\" y1=\"38.998\" x2=\"48\" y2=\"38.998\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"42.552\" y1=\"33.212\" x2=\"47.777\" y2=\"33.212\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"R\" x1=\"35.194\" y1=\"31.078\" x2=\"47.777\" y2=\"31.078\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"S\" x1=\"24.481\" y1=\"37.79\" x2=\"114.954\" y2=\"37.79\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"T\" x1=\"46.71\" y1=\"34.477\" x2=\"48\" y2=\"34.477\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"U\" x1=\"37.927\" y1=\"51.824\" x2=\"48.336\" y2=\"51.824\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"V\" x1=\"7.493\" y1=\"49.745\" x2=\"67.745\" y2=\"49.745\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"W\" x1=\"20.41\" y1=\"49.684\" x2=\"49.989\" y2=\"49.684\" xlink:href=\"#a\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"X\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"Y\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><path id=\"Z\" d=\"M33.1 58.54c.33.19.49.68.36 1.09l-.19.64c-.12.42-.49.6-.81.41l-.47-.27c-.33-.19-.49-.68-.36-1.09l.19-.64c.12-.42.49-.6.81-.41l.47.27z\"/><linearGradient id=\"a\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgHomeTheftValuable = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#Q)\"><g clip-path=\"url(#R)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M51.69 56.29c1.67-.96 4.56-1.82 7.8.8 5.07 4.11.74 9.56-2.09 11.59-.21.15-.44.29-.67.43-2.9 1.67-7.24 2.13-8.85 2.05-1.67-.08-2.98.67-3.05.7 0 0-1.35.76-1.22 1.76.12.93-.68 3.44-3.58 5.12-.23.14-.48.26-.74.39-3.51 1.63-12.94 4.12-20.02 1.17-4.51-1.88-3.03-3.55-1.36-4.51.95-.55 1.9-.85 1.95-.87.4-.17 7.94-3.32 16.25-8.12 8.33-4.81 13.78-9.16 14.07-9.39.04-.02.56-.57 1.51-1.12zM37.85 73.01c-1.02-.83-4.23-.53-7.18.67-.62.25-1.17.52-1.65.8-1.83 1.06-2.65 2.23-1.85 2.88 1.01.84 4.23.54 7.17-.66.63-.26 1.19-.53 1.69-.81 1.81-1.05 2.62-2.21 1.82-2.88zm15.37-7.21c2.09-1.7 2.62-3.56 1.17-4.15-1.13-.46-3.15 0-4.98 1.06-.48.28-.96.6-1.39.96-2.08 1.71-2.62 3.56-1.18 4.16 1.13.47 3.15 0 4.97-1.05.49-.29.97-.62 1.41-.98z\" fill=\"url(#A)\"/><path d=\"M43.8 41.25c.01-.02.01-.04.01-.05l-.01.05z\" fill=\"url(#B)\"/><path d=\"M43.481 42.38l.06-.2c0-.02.01-.03.01-.05l-.04.13a1.03 1.03 0 0 0-.03.12z\" fill=\"url(#C)\"/><path d=\"M72.88 75.06h-.03c-.02 0-.05-.01-.07-.01-.23-.02-.48-.07-.71-.1l-.62-.09c-.03-.01-.06-.01-.09-.02-.26-.05-.53-.14-.8-.21l-.64-.18c-.02-.01-.03-.01-.05-.02-.31-.1-.63-.24-.95-.36l-.52-.2c-.01 0-.01-.01-.02-.01l-1.56-.78-1.46-.9-1.4-1.01-.3-.22-1.6-1.37-1.32-1.29c-.05-.05-.09-.1-.14-.14l-.66-.73-.71-.8-1.15-1.44-.16-.21-.62-.87-1.33-2.03-.18-.28-1.25-2.23-.76-1.56c-.04-.1-.09-.19-.14-.29l-.77-1.84c-.02-.04-.03-.08-.05-.13-.04-.09-.06-.19-.1-.28l-.9-2.82-.2-.73-.43-2.07-.25-1.86-.1-1.91.06-1.84v-.02l.07-.55.16-1.16c0-.02.01-.04.01-.07l.13-.53.24-.95.03-.1c.05-.16.12-.3.17-.46l.33-.84c.01-.02.02-.04.02-.06.07-.16.16-.29.24-.44l.29-.54c.01-.02.03-.05.04-.08-.1 0-.2-.01-.29 0-.01 0-.03 0-.04.01h-.08c-.16.01-.31.05-.47.07l-.69.1c-.1.02-.18.06-.28.08-.05.01-.09.03-.14.04s-.09.03-.14.04c-.02.01-.04.01-.06.02l-.58.18c-.18.07-.35.16-.52.25-.06.03-.13.06-.19.1-.13.07-.27.12-.39.2-.17.1-.32.22-.48.34-.02.02-.05.03-.07.05l-.38.28-.18.16c-.05.04-.09.09-.13.13-.09.08-.17.17-.26.26l-.31.32-.04.04c-.03.03-.06.07-.09.1-.12.14-.22.3-.33.44l-.13.18-.28.39c-.03.05-.05.1-.08.15-.05.07-.08.16-.13.23l-.42.8c-.03.06-.05.13-.08.19-.01.03-.03.06-.04.1l-.23.62-.18.49c-.01.02-.02.05-.02.07s-.01.03-.02.05c-.04.12-.06.26-.09.39l-.25 1.04v.02c0 .02-.01.03-.01.05 0 .01-.01.03-.01.04-.06.32-.09.66-.13 1l-.08.63v.05l-.02.54-.04 1.24c0 .03.01.07.01.1l.09 1.64c.01.06 0 .11.01.17.01.14.04.27.05.4l.19 1.39c0 .03.01.05.01.08l.03.16.29 1.38.09.44c.01.03.01.06.02.09l.53 1.89c.01.04.03.09.04.13l.49 1.4.14.41c.02.04.03.08.05.13l.24.57.53 1.27.06.12.84 1.73c.03.07.07.13.1.2L49 65.3l1.2 1.92 1.14 1.6c.06.07.11.15.17.22l1.15 1.44.13.15L54.03 72c.05.05.09.1.14.14l1.32 1.29.12.11 1.44 1.23c.01.01.03.02.04.03l.78.57.43.31.31.23c.04.02.07.05.11.07l1.49.92c.02.01.04.02.05.03.35.2.7.35 1.04.52l.54.27c.01.01.03.01.04.02.01 0 .02.01.03.01l.56.21.88.34.08.03c.01 0 .03.01.04.01.34.11.66.18.99.26l.42.11c.01 0 .03.01.04.01.14.03.27.03.41.06l.77.1c.08.01.16.03.23.03h.04c.17.01.32 0 .49 0h.72.11.07c.13-.01.25-.04.38-.06l.72-.11h.03l.32-.09c.05-.01.09-.03.13-.04l.11-.03.57-.18c.01 0 .02-.01.03-.01l.57-.26.21-.1c.13-.07.27-.12.39-.2l.12-.08c.04-.02.07-.05.11-.08.11-.07.2-.15.31-.22l.47-.35c.05-.05.1-.09.16-.14l.03-.03c.11-.1.2-.2.3-.31l.42-.42c.03-.03.05-.06.08-.09l.35-.48.36-.49.03-.06c-.15.01-.31 0-.46 0-.22-.02-.42-.01-.62-.02z\" fill=\"url(#D)\"/><path d=\"M83.72 65.46c-.73-16.99-14.31-32.17-26.01-33.58-.07-.01-.13-.02-.2-.02-.06-.01-.11-.01-.17-.01-1.45-.1-3.09-.01-4.8.47-1.25.35-3.11 1.14-4.92 2.8-.05.05-.11.08-.16.13l-.27.27c-.07.07-.13.13-.19.2-.68.71-1.2 1.43-1.62 2.11-.01.01-.02.03-.03.04-.06.1-.12.2-.17.3-.08.15-.17.29-.24.43l-.06.12-.03.06-.41.84a1.96 1.96 0 0 1-.06.14c0 .01-.01.02-.01.03-.037.075-.071.152-.1.23-.13.33-.27.66-.38 1.01l-.04.12-.01.03c0 .02-.01.04-.01.06-.01.05-.03.11-.04.16-.01.02-.01.04-.02.06-.01.03-.02.05-.02.08-.03.1-.07.2-.1.31 0 .01-.01.02-.01.03-.01.02-.01.04-.01.06-.02.07-.03.13-.05.2 0 .02-.01.03-.01.05l-.13.52c-.01.03-.02.06-.02.09-.01.02-.01.05-.02.07-.01.05-.03.1-.04.15l-.03.14-.02.09-.06.32c0 .03-.01.05-.01.08l-.12.67-.02.14v.02c-.03.21-.05.45-.07.69 0 .02-.01.04-.01.07s-.01.07-.01.1c0 .02 0 .04-.01.05 0 .03 0 .05-.01.08v.02c-.01.16-.03.32-.04.48v.04c-.01.07-.01.13-.02.2 0 .02 0 .04-.01.07-.01.06-.01.13-.02.19v.19c-.01.17-.01.34-.01.51v.07.04.36c0 .12-.01.24 0 .36v.03c-.002.044.002.087.01.13v.06l.04.91v.04l.03.65c-.002.037.002.074.01.11 0 .03 0 .06.01.09v.03l.07.72c.01.14.03.27.04.41l.06.42.01.12c.01.05.02.11.03.15.028.208.061.414.1.62l.13.72c.01.05.01.08.02.12.01.07.02.13.04.2v.03c0 .02.01.04.01.06l.01.06.01.02c0 .02.01.05.02.07.01.04.02.09.03.13.09.45.23.89.34 1.34.13.51.24 1.02.39 1.54.01.03.02.07.03.1 0 .01.01.03.01.04.05.15.09.3.14.45 0 .01.01.01.01.02.04.11.09.23.12.34.17.52.37 1.03.56 1.54.1.26.18.53.29.79.03.07.04.14.07.2.01.03.02.07.04.1.05.11.1.24.14.34.038.075.071.152.1.23.02.05.05.1.07.15l.06.12c.04.09.09.18.13.28.304.688.624 1.368.96 2.04.02.02.02.03.02.04.05.1.09.21.15.31.03.05.06.11.08.16l.06.09c.03.06.07.12.1.18a2.29 2.29 0 0 1 .09.16c.21.38.44.75.66 1.12.19.32.36.64.56.95.11.17.2.35.31.53.04.07.08.14.12.2l.06.09c.02.03.04.07.06.1l.15.21.81 1.19.09.13.02.03.2.27.59.79c.09.11.17.23.26.34.01.02.02.03.04.05.02.03.04.05.06.08l.06.07.03.04c.074.093.15.182.23.27l.86 1.03c.01.02.02.03.04.05.01.01.02.02.03.04.01.01.01.02.02.02l.02.02c.03.03.06.07.09.1.27.31.58.64.87.95.08.09.17.18.24.26l.03.03.02.02.03.03c.18.19.37.37.56.56l.09.09.1.1c.07.07.14.13.21.2l.29.28.07.07c.06.06.13.11.2.17.434.404.881.794 1.34 1.17.28.23.56.44.84.66l.78.59.12.09c.22.16.44.31.66.45.33.22.65.42.98.62.04.02.07.05.11.07.09.05.17.1.26.15.14.08.27.17.41.24.044.018.088.038.13.06.09.05.18.09.26.14l.68.36c.12.06.23.13.35.18.05.03.11.06.16.08.16.07.3.15.45.21.22.1.44.19.66.28.34.14.63.24.83.31l.28.09.36.12.47.15V81l.21.07c.04.01.1.02.15.03.02.01.04.01.06.01.298.079.598.15.9.21.13.03.28.05.41.08.17.03.34.07.52.1.05.01.1.01.14.02.03 0 .05.01.08.01l.21.02c.31.04.62.07.95.1h.03c.43.02.84.03 1.23.02.2 0 .38-.02.57-.03h.04c.28-.02.55-.03.84-.07.04-.01.08 0 .13-.01h.04c.03-.01.07-.01.1-.02.07-.01.14-.03.21-.04.06-.01.12-.03.19-.04.25-.05.5-.09.75-.15.02 0 .04-.01.05-.01.07-.02.15-.03.22-.05l.09-.03h.01c.08-.02.16-.05.24-.07l.61-.19c.04-.02.1-.04.14-.06.03-.01.06-.02.08-.03l.29-.12c.08-.03.14-.05.21-.08.03-.01.05-.02.08-.03.16-.06.31-.13.43-.18l.86-.45c.04-.03.07-.04.1-.07.07-.05.14-.09.2-.13.05-.03.11-.07.16-.1.13-.09.28-.18.44-.29.01-.01.02-.01.03-.02.13-.1.25-.18.36-.27.04-.03.07-.06.1-.08.05-.04.09-.08.14-.11.06-.05.13-.1.19-.15s.13-.1.19-.16c.036-.027.069-.057.1-.09l.01-.01.14-.14.01-.01.19-.18c.25-.24.49-.49.72-.75.04-.05.09-.09.13-.13.09-.1.18-.22.3-.38a.55.55 0 0 0 .07-.09c.02-.03.05-.06.07-.1.18-.24.36-.49.53-.75.04-.05.08-.1.11-.16.02-.03.03-.05.05-.08l.2-.32c.032-.043.059-.09.08-.14.02-.04.04-.07.06-.1l.01-.01c.133-.236.26-.477.38-.72.01-.03.03-.06.04-.09.06-.12.12-.26.17-.39.06-.14.13-.28.19-.43.02-.04.05-.1.06-.14l.09-.25.05-.12c.03-.07.05-.14.08-.22l.12-.31.07-.2c0-.01.01-.03.01-.05l.02-.06c-.01.02-.01.03-.02.05.02-.05.03-.11.05-.17 0-.01.01-.03.01-.04.14-.46.28-.95.4-1.51.01-.04.02-.09.03-.14v-.02c0-.01 0-.02.01-.02.04-.2.06-.36.09-.54.01-.03.01-.06.02-.09l.06-.32c.02-.12.04-.23.05-.32.02-.11.02-.22.03-.33.05-.41.09-.81.12-1.2a2.45 2.45 0 0 0 .02-.28c.01-.08.01-.17.02-.24l.01-.42.01-.3c.02-.31.02-.6.03-.86zm-8.04 3.76v.05c-.02.19-.05.37-.07.56-.04.36-.08.73-.14 1.07 0 .02-.01.04-.01.06-.04.21-.1.41-.15.61-.07.29-.12.59-.21.86-.01.02-.01.04-.02.07-.06.21-.15.4-.22.6-.07.19-.13.38-.21.56-.03.07-.06.16-.09.23a9.54 9.54 0 0 1-.29.55l-.16.31c-.06.1-.1.21-.16.31-.01.02-.03.04-.04.06-.11.18-.24.33-.36.49-.11.16-.22.32-.34.47-.04.04-.06.07-.09.1-.13.15-.28.28-.42.42-.1.1-.2.21-.3.31l-.03.03a1.07 1.07 0 0 1-.16.14c-.15.13-.32.23-.47.35-.1.07-.2.16-.31.22-.04.02-.07.05-.11.08-.04.02-.08.05-.11.07-.14.08-.27.14-.4.21-.07.03-.13.07-.2.1-.19.09-.38.19-.57.26-.01 0-.02.01-.03.01-.19.07-.38.12-.57.18-.04.01-.07.02-.11.03-.15.04-.3.09-.45.13h-.03c-.23.05-.48.08-.72.11-.13.02-.25.05-.38.06-.06 0-.11.01-.17.01-.25.01-.49 0-.73 0-.16 0-.32.01-.49 0h-.04l-.23-.03c-.25-.02-.51-.06-.77-.1-.14-.02-.27-.03-.41-.06-.01 0-.03-.01-.04-.01-.14-.03-.28-.08-.42-.11-.33-.08-.66-.15-.99-.26-.04-.01-.08-.03-.13-.04-.29-.09-.59-.22-.88-.34-.19-.07-.37-.13-.56-.21-.03-.01-.05-.02-.08-.03-.18-.08-.36-.18-.54-.27-.35-.17-.69-.32-1.04-.52-.02-.01-.04-.02-.05-.03-.5-.28-1-.59-1.49-.92-.04-.02-.07-.05-.11-.07-.1-.07-.2-.15-.31-.23l-.43-.31c-.26-.19-.52-.37-.77-.57-.01-.01-.03-.02-.04-.03a27.46 27.46 0 0 1-1.44-1.23c-.04-.04-.08-.07-.12-.11-.455-.415-.895-.845-1.32-1.29-.05-.05-.09-.1-.14-.15-.42-.44-.83-.9-1.24-1.37-.04-.05-.09-.1-.13-.15-.394-.471-.778-.951-1.15-1.44-.06-.07-.11-.15-.17-.22-.39-.52-.77-1.05-1.14-1.6a38.31 38.31 0 0 1-1.2-1.92c-.33-.56-.64-1.12-.94-1.69-.03-.07-.07-.13-.1-.2-.29-.572-.57-1.148-.84-1.73l-.06-.12c-.19-.42-.36-.85-.53-1.27l-.24-.57c-.02-.04-.03-.09-.05-.13l-.14-.41-.49-1.4c-.01-.04-.03-.09-.04-.13-.2-.63-.37-1.26-.53-1.89-.01-.04-.02-.07-.02-.1-.04-.15-.06-.29-.09-.44-.1-.46-.21-.92-.29-1.38l-.03-.16c0-.03-.01-.05-.01-.08a23.13 23.13 0 0 1-.19-1.39c-.01-.13-.04-.26-.05-.39-.01-.07 0-.12-.01-.18-.05-.55-.08-1.1-.09-1.64 0-.03-.01-.07-.01-.1-.01-.43.02-.84.04-1.24.01-.18 0-.37.02-.54v-.05c.02-.22.06-.42.08-.63.04-.34.07-.68.13-1 .01-.03.01-.06.02-.08 0-.01 0-.02.01-.02.07-.36.16-.7.25-1.04l.09-.39c.01-.04.03-.08.04-.12.05-.17.12-.33.18-.49.07-.21.14-.42.23-.62l.12-.29c.128-.273.268-.54.42-.8l.21-.38c.09-.14.19-.26.28-.39.04-.06.09-.12.13-.18.14-.19.27-.38.42-.55l.04-.04c.1-.11.21-.21.31-.32.09-.09.17-.18.26-.26a8.1 8.1 0 0 1 .32-.28c.12-.1.25-.19.38-.28.02-.02.05-.03.07-.05.16-.11.31-.23.48-.33.13-.07.26-.13.39-.2.06-.03.13-.06.19-.1.17-.08.34-.18.52-.25.19-.07.38-.12.58-.18.02-.01.04-.01.06-.02.05-.01.09-.03.14-.04.14-.04.27-.09.41-.12.22-.05.46-.07.69-.1.16-.02.31-.06.47-.07.04 0 .08-.01.11-.01.09-.01.19 0 .28 0 .16-.01.31 0 .47 0 .18 0 .35-.01.53 0h.04.04c.26.02.54.07.8.11.19.03.38.04.58.08.01 0 .03.01.04.01.3.06.6.15.9.23.18.05.35.08.52.14.03.01.05.02.08.02.34.11.69.26 1.04.4.15.06.3.11.45.17.02.01.04.02.06.02.52.23 1.06.5 1.6.8.529.296 1.046.613 1.55.95.04.02.07.05.11.07.516.352 1.02.722 1.51 1.11.01.01.03.02.04.03a27.59 27.59 0 0 1 1.44 1.23c.04.04.08.08.12.11.45.41.89.84 1.32 1.28.05.05.09.1.14.15.42.44.83.9 1.24 1.37.04.05.09.1.13.15.394.471.778.951 1.15 1.44.06.07.11.14.17.22.39.52.77 1.06 1.14 1.6a38.4 38.4 0 0 1 1.2 1.92c.33.56.64 1.12.94 1.7.03.06.07.13.1.19.29.572.57 1.148.84 1.73l.06.12c.27.61.53 1.22.76 1.84.02.04.03.09.05.13.23.6.44 1.21.63 1.81.01.04.03.08.04.13.2.63.37 1.26.53 1.89.01.03.01.06.02.09.15.61.27 1.22.38 1.82l.03.16c.11.63.19 1.25.25 1.86.06.65.1 1.29.1 1.91a17.58 17.58 0 0 1-.06 1.81z\" fill=\"url(#E)\"/><path d=\"M59.77 34.55c0 .01.01.03.01.04a1.24 1.24 0 0 0 .18.34c.01.02.03.04.04.06a2.16 2.16 0 0 0 .29.32c.08.07.17.13.26.19.08.05.14.11.23.16.22.13.47.23.73.32l.28.09.37.09.45.08c.04 0 .07.01.11.02l.62.03h.1l.62-.03c.03 0 .06-.01.09-.01.2-.02.4-.06.6-.1l.11-.03c.18-.04.35-.1.51-.16l.09-.03c.2-.08.39-.17.57-.27.73-.42 1.09-.97 1.09-1.53l.01 2.1c0 .55-.36 1.11-1.09 1.53-.174.099-.354.186-.54.26-.01 0-.02.01-.03.01l-.09.03-.33.11c-.06.02-.12.03-.18.04l-.11.03c-.03.01-.06.02-.1.02-.121.031-.245.051-.37.06a.57.57 0 0 1-.13.01c-.03 0-.06.01-.09.01-.05 0-.09.01-.14.02l-.36.02h-.11-.1-.17a2.83 2.83 0 0 1-.41-.03c-.02 0-.03 0-.05-.01-.04 0-.07-.01-.11-.02l-.31-.04-.13-.03-.37-.09c-.06-.02-.13-.03-.2-.05-.03-.01-.05-.03-.08-.04-.26-.09-.51-.19-.73-.32-.02-.01-.03-.02-.05-.03-.07-.04-.12-.09-.18-.13l-.26-.19c-.01-.01-.02-.01-.03-.02-.09-.08-.16-.16-.23-.25-.01-.02-.02-.04-.04-.06-.01-.02-.03-.04-.04-.06l-.07-.1c-.04-.07-.07-.14-.1-.21 0-.01-.01-.02-.01-.03s-.01-.03-.01-.04c-.01-.05-.03-.09-.04-.14l-.02-.21v-.03l-.01-2.1a1.08 1.08 0 0 0 .06.4z\" fill=\"url(#F)\"/><path d=\"M60.8 32.64c-1.45.84-1.46 2.19-.02 3.03s3.78.84 5.23 0c1.44-.83 1.46-2.19.02-3.03s-3.79-.83-5.23 0z\" fill=\"url(#G)\"/><path d=\"M55.24 16.31l2.17 4.73 8.16 1.27 6-3.47-2.16-4.73-8.17-1.27-6 3.47z\" fill=\"url(#H)\"/><path d=\"M69.41 14.11l2.09 2.55 2.91 6.37-2.84-4.19-2.16-4.73z\" fill=\"url(#I)\"/><path d=\"M71.57 18.84l-6 3.47.75 5.39 8.09-4.67-2.84-4.19z\" fill=\"url(#J)\"/><path d=\"M65.57 22.31l-8.16-1.27-2.08 4.95 10.99 1.71-.75-5.39z\" fill=\"url(#K)\"/><path d=\"M57.41 21.04l-2.17-4.73-2.84 3.3 2.93 6.38 2.08-4.95z\" fill=\"url(#L)\"/><path d=\"M74.41 23.03l-11 11.46 2.91-6.79 8.09-4.67z\" fill=\"url(#M)\"/><path d=\"M66.32 27.7l-2.91 6.79-8.08-8.5 10.99 1.71z\" fill=\"url(#N)\"/><path d=\"M41.06 12.84c.01 3.75 2.67 5.26 5.93 3.37-3.26 1.88-5.91 6.46-5.9 10.21-.01-3.75-2.66-5.27-5.93-3.39 3.28-1.88 5.91-6.44 5.9-10.19z\" fill=\"url(#O)\"/><path d=\"M74.72 34.35c.01 3 2.14 4.2 4.75 2.7-2.61 1.51-4.72 5.17-4.72 8.17-.01-3-2.13-4.22-4.74-2.71 2.62-1.52 4.72-5.17 4.71-8.16z\" fill=\"url(#P)\"/></g></g><defs><linearGradient id=\"A\" x1=\"9.159\" y1=\"68.512\" x2=\"71.831\" y2=\"68.512\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"43.801\" y1=\"41.217\" x2=\"43.819\" y2=\"41.217\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"43.481\" y1=\"42.251\" x2=\"43.55\" y2=\"42.251\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"24.97\" y1=\"58.66\" x2=\"86.999\" y2=\"58.66\" xlink:href=\"#S\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"E\" x1=\"34.802\" y1=\"56.743\" x2=\"92.783\" y2=\"56.743\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"56.378\" y1=\"36.27\" x2=\"79.372\" y2=\"36.27\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"58.941\" y1=\"34.157\" x2=\"88.453\" y2=\"34.157\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"54.115\" y1=\"17.574\" x2=\"95.963\" y2=\"17.574\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"53.504\" y1=\"18.573\" x2=\"75.844\" y2=\"18.573\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"46.762\" y1=\"23.272\" x2=\"80.003\" y2=\"23.272\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"44.17\" y1=\"24.371\" x2=\"83.457\" y2=\"24.371\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"51.627\" y1=\"21.15\" x2=\"78.792\" y2=\"21.15\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"34.221\" y1=\"28.76\" x2=\"79.161\" y2=\"28.76\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"43.504\" y1=\"30.242\" x2=\"76.967\" y2=\"30.242\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"32.479\" y1=\"19.634\" x2=\"48.442\" y2=\"19.634\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"67.857\" y1=\"39.778\" x2=\"80.626\" y2=\"39.778\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"Q\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"R\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"S\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgMoped = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#i)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M20.62 26.83c0-.04.01-.07.01-.11.01-.04.01-.08.02-.12.01-.03.01-.05.02-.08s.01-.05.02-.08l.03-.11c.01-.02.01-.04.02-.06.01-.04.03-.08.04-.12.01-.02.01-.03.02-.05.02-.06.04-.11.07-.16 0-.01.01-.01.01-.02a1.01 1.01 0 0 1 .07-.15c.01-.02.02-.03.02-.05.02-.05.05-.09.07-.13 0-.01.01-.02.01-.03l.09-.15c.01-.01.02-.03.03-.04.02-.04.05-.07.07-.11.01-.02.03-.04.04-.06.02-.032.044-.062.07-.09.02-.02.04-.05.06-.07l.06-.06c.03-.04.07-.07.1-.11l.06-.06.05-.05a.56.56 0 0 1 .09-.07c.02-.01.03-.03.05-.04.03-.02.06-.05.09-.07.02-.01.03-.02.05-.03l.14-.09c.05-.03.09-.05.14-.07.01-.01.02-.01.04-.02.03-.01.05-.02.07-.03.04-.01.07-.03.11-.04.02-.01.04-.01.07-.02.02-.01.04-.01.06-.01.03-.01.05-.01.08-.01h.05.1c.06 0 .1.01.13.01.01 0 .02 0 .03.01.03.01.06.01.08.02.01 0 .02.01.03.01.03.01.07.03.1.05l-.59-.34c-.03-.01-.06-.03-.09-.04-.02-.01-.03-.02-.04-.02s-.03-.01-.04-.01-.03-.01-.04-.01-.02 0-.03-.01c-.04-.01-.07-.01-.1-.01h-.03-.07-.07-.04c-.01 0-.03.01-.04.01-.02 0-.04.01-.06.01-.01 0-.02 0-.03.01-.01 0-.02.01-.03.01-.03.01-.07.02-.11.04-.01 0-.02.01-.04.01-.01.01-.02.01-.04.02-.01.01-.02.01-.04.02-.05.02-.09.04-.14.07l-.14.09c-.02.01-.03.02-.05.03-.03.02-.06.05-.09.07-.02.01-.03.03-.05.04a.57.57 0 0 0-.08.07l-.05.05-.03.03-.03.03-.1.11-.03.03-.03.03c-.02.02-.04.05-.06.07-.01.02-.03.03-.04.05-.01.01-.02.03-.03.04-.01.02-.03.04-.04.06-.01.01-.02.03-.03.04-.02.02-.03.05-.05.07-.01.01-.02.03-.03.04 0 .01-.01.01-.01.02-.03.04-.05.08-.08.13-.01.02-.01.03-.01.04-.02.03-.03.06-.05.09-.01.01-.01.03-.02.04-.01.02-.02.03-.02.05-.01.01-.01.03-.02.04l-.05.11c0 .01-.01.01-.01.02l-.06.14c0 .01-.01.02-.01.02-.01.02-.01.03-.02.05s-.02.04-.02.07c-.01.02-.01.04-.02.05-.01.02-.01.04-.02.06 0 .01-.01.03-.01.04-.01.02-.01.05-.02.07-.01.03-.01.05-.02.08 0 .01 0 .02-.01.03 0 .02-.01.04-.01.06-.01.04-.01.08-.02.12 0 .01 0 .02-.01.03 0 .03 0 .05-.01.07 0 .02 0 .04-.01.05 0 .06-.01.11-.01.17 0 .36.1.63.26.81.05.06.11.11.18.15l.59.34c-.27-.16-.44-.49-.44-.96 0-.05 0-.11.01-.17 0-.02.01-.04.01-.06z\" fill=\"#8334c2\"/><path d=\"M22.1 24.45c.83-.48 1.5-.09 1.51.86 0 .95-.67 2.12-1.5 2.59s-1.5.09-1.51-.86c0-.94.67-2.11 1.5-2.59z\" fill=\"url(#A)\"/><path d=\"M29.87 21.26c0-.04.01-.07.01-.11.01-.04.01-.08.02-.12.01-.03.01-.05.02-.08s.01-.05.02-.08l.03-.11c.01-.02.01-.04.02-.06.01-.04.03-.08.04-.12.01-.02.01-.03.02-.05.02-.06.04-.11.07-.16 0-.01.01-.01.01-.02a1.01 1.01 0 0 1 .07-.15c.01-.02.02-.03.02-.05.02-.05.05-.09.07-.13 0-.01.01-.02.01-.03l.09-.15c.01-.01.02-.03.03-.04.02-.04.05-.07.07-.11.01-.02.03-.04.04-.06a.55.55 0 0 1 .07-.09c.02-.02.04-.05.06-.07l.06-.06c.03-.04.07-.07.1-.11l.06-.06.05-.05a.55.55 0 0 1 .09-.07c.02-.01.03-.03.05-.04.03-.02.06-.05.09-.07.02-.01.03-.02.05-.03l.14-.09c.05-.03.09-.05.14-.07.01-.01.02-.01.04-.02.03-.01.05-.02.07-.03.04-.01.07-.03.11-.04.02-.01.04-.01.07-.02.02-.01.04-.01.06-.01.03-.01.05-.01.08-.01h.05.1.02c.04 0 .08.01.11.01.01 0 .02 0 .03.01.03.01.06.01.08.02.01 0 .02.01.03.01.03.01.07.03.1.05l-.59-.34c-.03-.01-.06-.03-.09-.04-.02-.01-.03-.02-.04-.02s-.03-.01-.04-.01-.03-.01-.04-.01-.02 0-.03-.01c-.04-.01-.07-.01-.1-.01h-.03-.07-.07-.04c-.01 0-.03.01-.04.01-.02 0-.04.01-.06.01-.01 0-.02 0-.03.01-.01 0-.02.01-.03.01-.03.01-.07.02-.11.04-.01 0-.02.01-.04.01-.01.01-.02.01-.04.02-.01.01-.02.01-.04.02-.05.02-.09.04-.14.07l-.14.09c-.02.01-.03.02-.05.03-.03.02-.06.05-.09.07-.02.01-.03.03-.05.04a.57.57 0 0 0-.08.07l-.05.05-.03.03-.03.03-.1.11-.03.03-.03.03c-.02.02-.04.05-.06.07-.01.02-.03.03-.04.05-.01.01-.02.03-.03.04-.01.02-.03.04-.04.06-.01.01-.02.03-.03.04-.02.02-.03.05-.05.07-.01.01-.02.03-.03.04 0 .01-.01.01-.01.02-.03.04-.05.08-.08.13-.01.02-.01.03-.01.04-.02.03-.03.06-.05.09-.01.01-.01.03-.02.04-.01.02-.02.03-.02.05-.01.01-.01.03-.02.04l-.05.11c0 .01-.01.01-.01.02l-.06.14c0 .01-.01.02-.01.02-.01.02-.01.03-.02.05s-.02.04-.02.07c-.01.02-.01.04-.02.05-.01.02-.01.04-.02.06 0 .01-.01.03-.01.04-.01.02-.01.05-.02.07-.01.03-.01.05-.02.08 0 .01 0 .02-.01.03 0 .02-.01.04-.01.06-.01.04-.01.08-.02.12 0 .01 0 .02-.01.03 0 .03 0 .05-.01.07 0 .02 0 .04-.01.05 0 .06-.01.11-.01.17 0 .36.1.63.26.81.05.06.11.11.18.15l.59.34c-.27-.16-.44-.49-.44-.96 0-.05 0-.11.01-.17.01-.02.01-.04.01-.06z\" fill=\"#8334c2\"/><path d=\"M31.36 18.89c.83-.48 1.5-.09 1.51.86 0 .95-.67 2.12-1.5 2.59-.83.48-1.5.09-1.51-.86 0-.95.67-2.11 1.5-2.59z\" fill=\"url(#B)\"/><path d=\"M37.39 43.08a1.72 1.72 0 0 1-.31.14 2.17 2.17 0 0 1-.24.07c-.02 0-.04.01-.06.02-.1.02-.2.03-.3.04h-.06c-.1 0-.2 0-.31-.01h-.04c-.11-.01-.22-.03-.33-.05-.01 0-.02-.01-.03-.01l-.35-.1c-.01 0-.02-.01-.03-.01-.13-.04-.25-.09-.38-.15-.01 0-.02-.01-.03-.01-.13-.06-.26-.13-.4-.21a3.41 3.41 0 0 1-.4-.26c-.01-.01-.02-.01-.02-.02l-.36-.27c-.01-.01-.03-.02-.04-.03l-.34-.3c-.01-.01-.03-.02-.04-.04l-.33-.33-.03-.03c-.121-.123-.235-.253-.34-.39l-.34-.43c-.01-.01-.01-.02-.02-.02L32 40.3l-.17-.27-.13-.21-.06-.11-.2-.37c-.01-.01-.01-.03-.02-.04-.08-.15-.15-.31-.22-.47 0-.01-.01-.02-.01-.02l-.19-.46c0-.01-.01-.02-.01-.03l-.16-.48c0-.01-.01-.02-.01-.03-.05-.15-.09-.31-.12-.46 0-.01-.01-.03-.01-.04a4.29 4.29 0 0 1-.09-.47c-.03-.17-.04-.33-.06-.48v-.04l-.02-.47.02-.44v-.04a4.13 4.13 0 0 1 .05-.37c0-.02.01-.03.01-.05.018-.113.048-.224.09-.33.01-.02.01-.04.02-.06.031-.099.067-.196.11-.29 0-.01.01-.02.01-.03l.16-.29c.01-.01.02-.02.03-.04l.15-.2c.02-.02.04-.05.06-.07l.15-.15c.02-.02.04-.04.07-.06.07-.06.15-.11.23-.16l-4.47 2.6-.23.16c-.02.02-.04.04-.07.06-.05.05-.1.09-.15.15-.02.02-.04.04-.06.07-.05.06-.11.13-.15.2-.01.01-.02.02-.03.04-.07.1-.12.19-.16.29 0 .02-.01.03-.01.04-.031.061-.058.125-.08.19l-.03.1c-.01.02-.01.04-.02.06s-.01.04-.02.05c-.02.07-.04.13-.05.21-.01.02-.01.05-.01.07s-.01.03-.01.05c0 .03-.01.05-.01.07l-.03.19c0 .04-.01.07-.01.11v.04.05c-.01.06-.01.12-.01.19v.19.19c-.002.063.002.127.01.19 0 .03 0 .06.01.09v.04c0 .02 0 .04.01.07l.02.2.03.2.03.21.04.21c.01.03.01.05.02.08 0 .01.01.03.01.04.01.03.01.06.02.09l.06.21c.01.05.03.11.05.16 0 .01.01.02.01.03s0 .02.01.03l.07.21.07.21c0 .01.01.03.02.04 0 .01.01.02.01.03.02.04.03.08.05.13l.08.2.06.14c0 .01.01.02.01.02 0 .01.01.02.01.03l.09.2.1.21c.01.01.01.02.02.03s.01.03.02.04l.09.17.12.21.06.11c.01.01.02.03.02.04.03.06.07.11.11.17l.17.27c.01.01.02.03.03.04l.24.34c0 .01.01.01.01.02l.18.23.15.18.17.19c.05.06.1.12.16.17.01.01.02.02.02.03l.03.03.11.12.17.17.05.05c.01.01.03.02.04.04.03.03.06.05.09.08l.18.16c.03.02.05.04.08.06.01.01.03.02.04.03.02.02.04.03.06.05.06.05.12.09.18.13l.13.09c.01.01.02.01.02.02.01.01.02.01.02.02.06.04.11.08.17.11.06.04.11.07.17.1.01.01.03.02.04.02l.13.07.16.09.11.05c.01 0 .02.01.03.01s.02.01.03.01l.16.07.16.06c.01 0 .02.01.03.01s.02.01.03.01l.11.03.17.05c.03.01.05.01.08.02.01 0 .02.01.03.01.02 0 .03.01.05.01l.18.03c.04 0 .07.01.11.01h.04.03c.06 0 .13.01.19.01h.08.06.06l.23-.03c.03 0 .05-.01.06-.02l.22-.06c.01 0 .01-.01.02-.01.11-.04.21-.09.31-.14l4.4-2.64z\" fill=\"url(#C)\"/><path d=\"M41.46 41.86c0-.11-.01-.22-.02-.33 0-.05-.01-.1-.01-.16 0-.02 0-.04-.01-.07 0-.04-.01-.08-.01-.11l-.04-.34c-.01-.12-.03-.23-.05-.35v-.03l-.05-.32-.07-.36-.03-.13c-.01-.03-.01-.05-.02-.08-.01-.05-.02-.1-.04-.15l-.1-.37-.08-.28c0-.02-.01-.03-.01-.05 0-.01-.01-.03-.01-.04l-.11-.36-.12-.35c-.01-.02-.02-.05-.03-.07s-.01-.04-.02-.05l-.08-.21-.14-.34c-.032-.085-.069-.169-.11-.25-.01-.01-.01-.03-.02-.04s-.01-.03-.02-.04l-.15-.34-.18-.36-.03-.06c-.01-.02-.03-.05-.04-.07l-.15-.28-.2-.36-.1-.18c-.01-.02-.03-.05-.04-.07l-.19-.3-.28-.45c-.02-.02-.03-.05-.04-.07l-.43-.61s-.01-.01-.01-.02l-.31-.41-.25-.31-.02-.02-.27-.31-.27-.3c-.01-.02-.03-.03-.04-.04l-.05-.05a1.88 1.88 0 0 0-.2-.2l-.29-.29c-.03-.03-.06-.05-.09-.08-.02-.02-.05-.04-.07-.06l-.15-.14-.31-.27c-.04-.04-.09-.07-.13-.11-.02-.02-.05-.04-.07-.06-.03-.03-.07-.06-.1-.09l-.3-.23-.22-.16c-.01-.01-.03-.02-.04-.03s-.03-.02-.04-.03l-.29-.19-.29-.18c-.02-.01-.05-.03-.07-.04l-.22-.12-.28-.15-.19-.09c-.01-.01-.03-.01-.04-.02-.02-.01-.03-.02-.05-.02l-.28-.12c-.09-.04-.19-.07-.28-.1-.02-.01-.03-.01-.05-.02-.01 0-.03-.01-.04-.01l-.18-.06-.29-.08-.14-.03c-.02 0-.04-.01-.06-.01-.03-.01-.06-.01-.08-.02l-.3-.05c-.06-.01-.13-.01-.19-.02-.02 0-.04 0-.06-.01-.02 0-.04 0-.06-.01-.11-.01-.22-.01-.33-.01-.05 0-.1 0-.14.01-.04 0-.07 0-.11.01a.41.41 0 0 0-.11.01c-.135.009-.268.03-.4.06l-.11.03c-.13.03-.26.06-.38.11-.02.01-.03.01-.04.02l-.06.03c-.16.06-.31.13-.45.22l-4.47 2.6c.14-.08.3-.15.45-.22l.06-.03c.14-.05.284-.091.43-.12l.1-.03.52-.07c.04 0 .07 0 .11-.01.17-.01.35 0 .53.01.02 0 .04 0 .06.01l.58.09c.02 0 .04.01.06.01a5.11 5.11 0 0 1 .61.17c.01 0 .03.01.04.01.22.07.44.16.66.26.01.01.03.01.04.02.23.1.45.22.69.36l.69.44c.01.01.03.02.04.03l.63.47c.02.02.05.04.07.06l.59.51c.02.02.05.04.07.06.2.18.39.38.58.58l.05.05.59.66.57.73s.01.01.01.02l.47.68.28.45.23.37c.037.058.071.118.1.18l.35.64c.01.02.03.05.04.07l.38.8c.01.01.01.03.02.04.12.26.22.53.32.8.01.02.01.04.02.06l.28.83c0 .02.01.03.01.05l.21.8c.01.03.01.05.02.08l.16.81v.02l.1.81c0 .02 0 .04.01.07l.03.8c.002.254-.011.508-.04.76 0 .02 0 .04-.01.07-.02.22-.05.44-.09.64-.01.03-.01.06-.02.08-.04.2-.09.39-.15.57l-.03.1-.2.5c-.01.02-.01.03-.02.05-.08.18-.18.35-.28.5-.01.02-.03.04-.05.07a2.96 2.96 0 0 1-.27.35 1.19 1.19 0 0 1-.11.12c-.08.09-.17.17-.26.25-.04.03-.07.07-.11.1l-.4.28 4.47-2.6c.14-.08.27-.18.4-.28.04-.03.07-.06.11-.1l.26-.25.11-.12.27-.35c.02-.02.03-.04.05-.07 0-.01.01-.01.01-.02l.26-.47c.02-.03.02-.04.03-.06l.14-.33.06-.17.03-.1.03-.09.09-.35.03-.13c.01-.03.01-.05.02-.08l.03-.13.05-.33c.01-.06.01-.12.02-.19 0-.02 0-.04.01-.07 0-.03.01-.05.01-.08l.02-.33.01-.33v-.02a1.17 1.17 0 0 1-.04-.32z\" fill=\"url(#D)\"/><path d=\"M30.09 32.81c3.82 2.21 6.92 7.57 6.91 11.96s-3.13 6.17-6.95 3.96-6.92-7.57-6.91-11.97c.01-4.38 3.13-6.16 6.95-3.95zm-.04 12.59c2.22 1.28 4.04.25 4.04-2.3.01-2.55-1.8-5.67-4.02-6.96-2.22-1.28-4.04-.25-4.04 2.3 0 2.56 1.8 5.68 4.02 6.96z\" fill=\"url(#E)\"/><path d=\"M85.12 73.66a1.74 1.74 0 0 1-.31.14 2.18 2.18 0 0 1-.24.07c-.02 0-.04.01-.06.02-.1.02-.2.03-.3.04h-.06c-.1 0-.2 0-.31-.01h-.04c-.11-.01-.22-.03-.33-.05-.01 0-.02-.01-.03-.01l-.35-.1c-.01 0-.02-.01-.03-.01-.13-.04-.25-.09-.38-.15-.01 0-.02-.01-.03-.01-.13-.06-.26-.13-.4-.21s-.273-.164-.4-.26c-.01-.01-.02-.01-.02-.02l-.36-.27c-.01-.01-.03-.02-.04-.03l-.34-.3c-.01-.01-.03-.02-.04-.04l-.33-.33-.03-.03a4.3 4.3 0 0 1-.34-.39l-.34-.43c-.01-.01-.01-.02-.02-.02l-.26-.38-.17-.27-.13-.21-.06-.11-.2-.37c-.01-.01-.01-.03-.02-.04-.08-.15-.15-.31-.22-.47 0-.01-.01-.02-.01-.02l-.19-.46c0-.01-.01-.02-.01-.03l-.16-.48c0-.01-.01-.02-.01-.03-.05-.15-.09-.31-.12-.46 0-.01-.01-.03-.01-.04a4.29 4.29 0 0 1-.09-.47c-.03-.17-.04-.33-.06-.48v-.04l-.02-.47.02-.44v-.04c.01-.13.03-.25.05-.37 0-.02.01-.03.01-.05.018-.113.048-.224.09-.33.01-.02.01-.04.02-.06a2.48 2.48 0 0 1 .11-.29c0-.01.01-.02.01-.03l.16-.29c.01-.01.02-.02.03-.04l.15-.2c.02-.02.04-.05.06-.07l.15-.15c.02-.02.04-.04.07-.06.07-.06.15-.11.23-.16l-4.47 2.6-.23.16c-.02.02-.04.04-.07.06-.05.05-.1.09-.15.15-.02.02-.04.04-.06.07-.05.06-.11.13-.15.2-.01.01-.02.02-.03.04-.07.1-.12.19-.16.29 0 .02-.01.03-.01.04-.031.062-.058.125-.08.19l-.03.1c-.01.02-.01.04-.02.06s-.01.04-.02.05c-.02.07-.04.13-.05.21-.01.02-.01.05-.01.07s-.01.03-.01.05c0 .03-.01.05-.01.07l-.03.19c0 .04-.01.07-.01.11v.04.05c-.01.06-.01.12-.01.19v.19.19c-.002.064.002.127.01.19 0 .03 0 .06.01.09v.04c0 .02 0 .04.01.07l.02.2.03.2v.02l.03.19.04.21c.01.03.01.05.02.08 0 .01.01.03.01.04.01.03.01.06.02.09l.06.21c.01.05.03.11.05.16 0 .01.01.02.01.03s0 .02.01.03l.07.21.07.21c0 .01.01.03.02.04 0 .01.01.02.01.03.02.04.03.08.05.13l.08.2.06.14c0 .01.01.02.01.02 0 .01.01.02.01.03l.09.2.1.21c.01.01.01.02.02.03s.01.03.02.04l.09.17.12.21.06.11c.01.01.02.03.02.04.03.06.07.11.11.17l.17.27c.01.01.02.03.03.04l.24.34c0 .01.01.01.01.02l.18.23.15.18.17.19c.05.06.1.12.16.17.01.01.02.02.02.03l.03.03.11.12.17.17.05.05c.01.01.03.02.04.04.03.03.06.05.09.08l.18.16c.03.02.05.04.08.06.01.01.03.02.04.03.02.02.04.03.06.05.06.05.12.09.18.13l.13.09c.01.01.02.01.02.02.01.01.02.01.02.02.06.04.11.08.17.11.06.04.11.07.17.1.01.01.03.02.04.02l.13.07.16.09.11.05c.01 0 .02.01.03.01s.02.01.03.01l.16.07.16.06c.01 0 .02.01.03.01s.02.01.03.01l.11.03.17.05c.03.01.05.01.08.02.01 0 .02.01.03.01.02 0 .03.01.05.01l.18.03c.04 0 .07.01.11.01h.04.03c.06 0 .13.01.19.01h.08.06.06l.23-.03c.03 0 .05-.01.06-.02l.22-.06c.01 0 .01-.01.02-.01.11-.04.21-.09.31-.14l4.4-2.64z\" fill=\"url(#F)\"/><path d=\"M89.19 72.44c0-.11-.01-.22-.02-.33 0-.05-.01-.1-.01-.16 0-.02 0-.04-.01-.07 0-.04-.01-.08-.01-.11l-.04-.34c-.01-.12-.03-.23-.05-.35v-.03l-.05-.32-.07-.36-.03-.13c-.01-.03-.01-.05-.02-.08-.01-.05-.02-.1-.04-.15l-.1-.37-.08-.28c0-.02-.01-.03-.01-.05 0-.01-.01-.03-.01-.04l-.11-.36-.12-.35c-.01-.02-.02-.05-.03-.07s-.01-.04-.02-.05l-.08-.21-.14-.34c-.032-.085-.069-.169-.11-.25-.01-.01-.01-.03-.02-.04 0-.01-.01-.02-.01-.04l-.15-.34-.18-.36-.03-.06c-.01-.02-.03-.05-.04-.07l-.15-.28-.2-.36-.1-.18c-.01-.02-.03-.05-.04-.07l-.19-.3-.28-.45c-.02-.02-.03-.05-.04-.07l-.43-.61s-.01-.01-.01-.02l-.31-.41-.25-.31-.02-.02-.27-.31-.27-.3c-.01-.02-.03-.03-.04-.04l-.05-.05a1.88 1.88 0 0 0-.2-.2l-.29-.29c-.03-.03-.06-.05-.09-.08-.02-.02-.05-.04-.07-.06l-.15-.14-.31-.27c-.04-.04-.09-.07-.13-.11-.02-.02-.05-.04-.07-.06-.03-.03-.07-.06-.1-.09l-.3-.23-.22-.16c-.01-.01-.03-.02-.04-.03s-.03-.02-.04-.03l-.29-.19-.29-.18c-.02-.01-.05-.03-.07-.04l-.22-.12-.28-.15-.19-.09c-.01-.01-.03-.01-.04-.02-.02-.01-.03-.02-.05-.02l-.28-.12c-.09-.04-.19-.07-.28-.1-.02-.01-.03-.01-.05-.02-.01 0-.03-.01-.04-.01l-.18-.06-.29-.08-.14-.03c-.02 0-.04-.01-.06-.01-.03-.01-.06-.01-.08-.02l-.3-.05c-.06-.01-.13-.01-.19-.02-.02 0-.04 0-.06-.01-.02 0-.04 0-.06-.01-.11-.01-.22-.01-.33-.01-.05 0-.1 0-.14.01-.04 0-.07 0-.11.01-.04 0-.07 0-.11.01a2.56 2.56 0 0 0-.4.06l-.11.03c-.13.03-.26.06-.38.11-.02.01-.03.01-.04.02l-.06.03c-.16.06-.31.13-.45.22l-4.47 2.6c.14-.08.3-.15.45-.22l.06-.03a3.01 3.01 0 0 1 .43-.12l.1-.03.52-.07c.04 0 .07 0 .11-.01a4.73 4.73 0 0 1 .53.01c.02 0 .04 0 .06.01l.58.09c.02 0 .04.01.06.01.207.044.41.101.61.17.01 0 .03.01.04.01.22.07.44.16.66.26.01.01.03.01.04.02.23.1.45.22.69.36l.69.44c.01.01.03.02.04.03l.63.47c.02.02.05.04.07.06l.59.51c.02.02.05.04.07.06.2.18.39.38.58.58l.05.05.59.66.57.73s.01.01.01.02l.47.68.28.45.23.37c.04.06.07.12.1.18l.35.64c.01.02.03.05.04.07l.38.8c.01.01.01.03.02.04l.32.8c.01.02.01.04.02.06l.28.83c0 .02.01.03.01.05l.21.8c.01.03.01.05.02.08l.16.81.1.83c0 .02 0 .04.01.07l.03.8c.002.254-.011.508-.04.76 0 .02 0 .04-.01.07-.02.22-.05.44-.09.64-.01.03-.01.06-.02.08-.04.2-.09.39-.15.57l-.03.1-.2.5c-.01.02-.01.03-.02.05-.08.18-.18.35-.28.5-.01.02-.03.04-.05.07a2.97 2.97 0 0 1-.27.35c-.03.04-.07.08-.11.12-.082.088-.168.172-.26.25-.04.03-.07.07-.11.1l-.4.28 4.47-2.6c.14-.08.27-.18.4-.28.04-.03.07-.06.11-.1l.26-.25.11-.12.27-.35c.02-.02.03-.04.05-.07 0-.01.01-.01.01-.02l.26-.47c.02-.03.02-.04.03-.06l.14-.33.06-.17.03-.1.03-.09.09-.35.03-.13c.01-.03.01-.05.02-.08l.03-.13.05-.33c.01-.06.01-.12.02-.19 0-.02 0-.04.01-.07 0-.03.01-.05.01-.08l.02-.33.01-.33c-.04-.13-.05-.23-.05-.34z\" fill=\"url(#G)\"/><path d=\"M77.82 63.39c3.82 2.21 6.92 7.57 6.91 11.96s-3.13 6.17-6.95 3.96-6.92-7.57-6.91-11.97c.01-4.38 3.13-6.16 6.95-3.95z\" fill=\"url(#H)\"/><path d=\"M69.21 59.64l8.51-4.94c.02-.01.04-.02.05-.03l-8.51 4.94c-.01.01-.03.02-.05.03z\" fill=\"url(#I)\"/><path d=\"M69.21 59.64l8.51-4.94c.02-.01.04-.02.05-.03l-8.51 4.94c-.01.01-.03.02-.05.03z\" fill=\"url(#I)\"/><path d=\"M78.53 57.19c-5.38-3.53-23.73-8.31-21.1-14.98 0 0-1.33-3.57-2.65-12.39-1.49-9.91-23.93-8.29-23.93-8.29s-9.64 2.63-11.99 9.49c-2.35 6.87 19.53 17.59 19.53 17.59L40 52.35h.01c1.93 4.12 5.77 6.74 9.5 8.97 4.36 2.61 8.7 4.62 11.75 6.55 1.01 1.79 16.75-8.77 19.67-10.24-.81.24-1.68-.03-2.4-.44z\" fill=\"url(#J)\"/><path d=\"M81.32 57.46c-.07.01-.21.07-.4.17.03-.01.06-.01.09-.02l.31-.15z\" fill=\"url(#K)\"/><path d=\"M48.82 41.36s-7.89 4.99-5.81 15.21c0 0 .31.99 1.71 1.8s14.53 9.05 16.05 9.5c1.51.46 2 .59 2.74.2.74-.38 16.92-12.83 16.92-12.83l-18.13-7.7c-4.21-1.7-4.1-2.73-4.42-3.75-.56-1.8-.73-2.93-1.79-6.75l-7.27 4.32z\" fill=\"url(#L)\"/><path d=\"M48.45 53.06c-1.8 1.04-1.81 2.72-.02 3.76l12.44 7.23c1.79 1.04 4.69 1.04 6.49 0l6.85-3.95c1.8-1.04 1.81-2.72.02-3.76L61.79 49.1c-1.79-1.04-4.69-1.04-6.49 0l-6.85 3.96z\" fill=\"url(#M)\"/><path d=\"M75.55 58.2c0 .68-.45 1.37-1.35 1.89l-6.85 3.95c-.195.113-.399.21-.61.29-.02.01-.04.02-.07.03l-.49.17a.76.76 0 0 1-.16.04l-.29.07-.19.04c-.08.02-.16.03-.24.04l-.21.03-.23.03-.21.02c-.08.01-.15.01-.23.01l-.21.01h-.25c-.07 0-.13 0-.2-.01-.1 0-.21-.01-.31-.02-.05 0-.11-.01-.16-.01l-.52-.07c-.06-.01-.12-.02-.17-.04l-.25-.05a1.21 1.21 0 0 1-.18-.05l-.24-.07c-.04-.01-.09-.03-.13-.05l-.36-.14-.13-.06-.43-.22-12.43-7.23-.17-.11-.17-.11c-.05-.03-.09-.07-.13-.1l-.14-.12c-.03-.02-.05-.05-.08-.08l-.19-.21c-.03-.03-.05-.06-.07-.09-.04-.05-.07-.11-.11-.16l-.06-.1c-.03-.05-.05-.09-.07-.14l-.05-.11c-.02-.05-.03-.09-.04-.14l-.03-.12c-.01-.05-.01-.1-.02-.14 0-.04-.01-.09-.01-.14v.69.04c0 .03.01.06.01.09.001.047.008.094.02.14v.02l.03.09c.01.05.02.09.04.14 0 .01 0 .02.01.03.01.03.03.06.04.08.02.05.04.1.07.14.01.01.01.02.02.03.01.02.03.04.05.07.03.05.07.11.11.16.01.02.02.03.03.05s.03.03.04.05l.19.21.05.05c.01.01.02.02.03.02a1.74 1.74 0 0 0 .14.12c.04.03.08.07.13.1.05.04.11.07.17.11.04.03.08.05.12.08l.06.03L60.9 64.7l.43.22.13.06.36.14.08.03c.015.008.033.012.05.01l.24.07c.06.02.12.03.18.05l.25.05.15.03h.03l.52.07c.01 0 .03 0 .04.01.04 0 .08 0 .12.01l.31.02h.07.12.25.09c.04 0 .08 0 .12-.01l.23-.01c.03 0 .07 0 .1-.01.04 0 .07-.01.11-.01l.23-.03c.04 0 .07-.01.11-.01.03 0 .06-.01.1-.02l.24-.04c.04-.01.08-.01.12-.02.03-.01.05-.01.08-.02l.28-.07.12-.03c.01 0 .03-.01.04-.01l.49-.17c.01 0 .02-.01.03-.01.01-.01.03-.01.04-.02l.61-.29h.01l6.84-3.95c.91-.52 1.36-1.21 1.35-1.89l-.02-.65z\" fill=\"url(#N)\"/><path d=\"M83.81 51.4c-.11-7.59-6.77-15.34-3.01-22.76-3.13.92-5.5 1.35-8.46 2.81-5.45 2.69-6.19 4.06-8.51 7.08-1.56 3.35-1.7 6.54-.74 9.99.59 3.47 3.73 11.59 2.57 15.06-.46 1.07-.76 4.05-1.99 4.63l17.87-10.39c.26-.16.49-.37.66-.62.72-1.47 1.48-4.16 1.61-5.8z\" fill=\"url(#O)\"/><path d=\"M80.97 28.44l.13-.04-.28-.28c-3.71 1.24-9.18 3.37-13.14 5.96-4.26 2.79-6.34 7.94-5.23 12.91a49.73 49.73 0 0 0 .35 1.47l2.48 9.98c.45 1.83.48 3.52.08 4.88l-.93 3.17c-.48 1.65-2.04 2.09-3.78 1.09L46.4 59.34c-2.44-1.41-4.77-3.96-6.4-7 1.73 3.62 3.86 5.89 6.39 7.35l14.26 8.24c1.87 1.08 3.54.6 4.07-1.17l.93-3.17c.42-1.42.39-3.18-.09-5.09l-2.48-9.98-.31-1.28c-1.13-4.98.98-10.13 5.25-12.93 3.94-2.57 9.28-4.63 12.95-5.87z\" fill=\"url(#P)\"/><path d=\"M78.09 54.51l-.32.16-8.51 4.94.32-.16 8.51-4.94z\" fill=\"url(#Q)\"/><path d=\"M93.49 65.1v-.03-.06-.06c0-.02 0-.04-.01-.06 0-.02-.01-.04-.01-.06v-.03c0-.01 0-.03-.01-.04 0-.02-.01-.04-.01-.06s-.01-.04-.02-.07c-.01-.02-.01-.04-.02-.07-.01-.02-.01-.04-.02-.06-.01-.03-.01-.04-.02-.06s-.01-.04-.02-.06-.01-.04-.02-.06-.02-.04-.02-.06l-.03-.06c0-.01-.01-.02-.01-.03 0-.02-.01-.03-.01-.04-.01-.02-.02-.04-.03-.07-.01-.02-.02-.05-.04-.07-.02-.04-.04-.08-.07-.12-.01-.01-.01-.02-.02-.03l-.17-.27-.68-1.05-.06-.09c-.01-.02-.03-.04-.04-.05l-.6-.84c-.02-.02-.03-.05-.05-.07l-.14-.18-.27-.35c-.03-.04-.06-.07-.08-.11l-.15-.18-.22-.28-.09-.11c-.05-.07-.11-.13-.17-.19l-.21-.25c-.03-.03-.05-.06-.08-.09l-.19-.21-.22-.24c-.02-.02-.04-.05-.06-.07l-.2-.21-.23-.24-.06-.06-.2-.19-.26-.25-.06-.06-.19-.18-.27-.25-.06-.06c-.06-.06-.13-.11-.19-.17l-.28-.24c-.02-.02-.05-.04-.07-.06l-.19-.16-.27-.22c-.02-.02-.05-.04-.07-.06l-.21-.16-.25-.19c-.02-.02-.04-.03-.07-.05l-.23-.16-.23-.17c-.02-.01-.04-.03-.05-.04l-.28-.18-.19-.13c-.01-.01-.02-.01-.03-.02l-.49-.3-.1-.07-.31-.17c-.03-.02-.06-.03-.09-.05l-.17-.09c-.05-.02-.09-.05-.14-.07l-.14-.06-.17-.08c-.03-.01-.06-.03-.1-.04-.06-.03-.13-.05-.19-.08l-.16-.07c-.02-.01-.04-.02-.05-.02a2.95 2.95 0 0 0-.27-.1c-.04-.01-.08-.03-.11-.04-.01 0-.01 0-.02-.01-.13-.05-.27-.09-.4-.13-.05-.01-.08-.02-.11-.03l-.29-.08c-.01 0-.02 0-.03-.01-.06-.01-.12-.03-.17-.04l-.21-.05c-.02 0-.03 0-.05-.01l-.21-.03-.18-.03h-.05l-.24-.02a.25.25 0 0 0-.13-.03h-.04c-.11-.01-.22-.01-.32-.01h-.11l-.47.02h-.03c-.02 0-.05.01-.07.01a2.82 2.82 0 0 0-.42.06c-.03 0-.05.01-.08.01-.02 0-.03.01-.05.01-.2.04-.4.1-.59.16-.01 0-.03.01-.04.01l-.06.03c-.18.06-.35.13-.52.22l-8.51 4.94.52-.22c.04-.01.07-.03.11-.04.192-.069.389-.122.59-.16.04-.01.08-.02.12-.02.14-.03.28-.05.42-.06.03 0 .06-.01.1-.01l.46-.02h.12l.32.01c.07 0 .13.01.2.02l.23.02.23.03.2.03c.08.02.17.04.26.05.06.01.12.02.17.04l.33.09.1.03.43.14c.04.01.08.03.11.04l.32.12c.05.02.1.04.15.07l.28.12.17.08.28.14.17.09.4.22.1.06.52.32.19.13.33.22c.081.051.158.108.23.17l.29.21.25.19.28.21.27.22.26.22.28.24.25.22.27.25.25.24.26.25c.088.082.172.169.25.26l.23.24.26.28.22.24.26.3.21.25.25.3c.08.09.15.18.22.28l.23.29.27.35.19.25.6.84.1.15.68 1.05.17.27.17.32.12.33a1.73 1.73 0 0 1 .07.31c.019.099.029.199.03.3a2.14 2.14 0 0 1-.02.27c-.01.08-.04.16-.06.22l-.1.17c-.01.01-.02.03-.03.04-.04.05-.09.09-.14.12l8.51-4.94c.05-.03.1-.07.14-.12.01-.01.02-.03.03-.04.01-.02.03-.03.04-.04l.05-.08c0-.01.01-.02.01-.03.01-.02.02-.03.02-.04.01-.02.02-.04.02-.07.01-.02.01-.04.02-.06 0-.02.01-.04.01-.06s.01-.04.01-.06 0-.04.01-.06v-.06-.06c.03-.01.03-.01.03-.02z\" fill=\"url(#R)\"/><path d=\"M76.4 60.28l.1.06c2.94 1.73 5.76 4.64 7.92 8.18l.17.27c.56.92.52 1.94-.09 2.12-.22.07-.48.02-.75-.14a1.94 1.94 0 0 1-.29-.21l-3.65-3.13c-.71-.61-1.43-1.12-2.15-1.54-1.93-1.11-3.83-1.5-5.42-1.07l-.28.07c-.37.1-.82.01-1.26-.25-.36-.21-.73-.53-1.06-.94-1.22-1.52-1.41-3.57-.38-4.09l.32-.16c1.85-.93 4.29-.64 6.82.83z\" fill=\"url(#S)\"/><path d=\"M60.24 32.84v-.02-.02c0-.04 0-.08-.01-.12 0-.04-.01-.09-.01-.13 0-.02 0-.04-.01-.06v-.02c0-.02 0-.03-.01-.05-.01-.05-.01-.1-.02-.15l-.03-.15-.03-.17c-.01-.06-.03-.11-.04-.17 0-.01-.01-.03-.01-.04s-.01-.02-.01-.04l-.03-.1a1.22 1.22 0 0 1-.05-.18c-.01-.02-.01-.04-.02-.06 0-.01-.01-.03-.01-.04l-.03-.08c-.02-.06-.04-.13-.07-.19l-.03-.08c-.01-.02-.01-.03-.02-.05s-.02-.05-.03-.07l-.08-.2c-.009-.028-.023-.055-.04-.08-.01-.02-.01-.03-.02-.05s-.02-.05-.03-.07l-.09-.21c-.01-.02-.02-.05-.03-.07l-.03-.06c-.02-.03-.03-.06-.05-.1l-.13-.26c-.03-.07-.07-.13-.1-.19l-.11-.2c-.11-.2-.23-.38-.35-.56-.01-.02-.03-.04-.04-.06s-.03-.04-.04-.06l-.14-.19c-.03-.04-.05-.08-.08-.12-.02-.02-.03-.04-.05-.06-.02-.03-.04-.05-.06-.08s-.05-.06-.07-.09l-.15-.19-.15-.17c-.04-.05-.08-.09-.12-.13l-.03-.03-.14-.15-.15-.14c-.02-.02-.04-.04-.07-.06l-.03-.03c-.02-.02-.04-.03-.05-.05-.05-.05-.1-.09-.15-.13l-.16-.13-.02-.02-.14-.11-.18-.13c-.02-.01-.04-.02-.06-.04-.02-.01-.03-.02-.05-.03l-.09-.06-.23-.14-.06-.03c-.08-.05-.16-.09-.24-.13l-.2-.11-.27-.14c-.03-.01-.05-.03-.08-.04l-.38-.19-.43-.2c-.02-.01-.04-.02-.06-.02l-.41-.18c-.03-.01-.07-.03-.11-.04-.01 0-.01 0-.02-.01-.09-.03-.17-.07-.25-.1l-.21-.08-.28-.1-.29-.11-.27-.1c-.07-.02-.13-.05-.2-.08s-.15-.05-.22-.08l-.15-.06-.27-.12c-.03-.01-.06-.03-.09-.04l-.38-.19-.4-.22a6.13 6.13 0 0 1-.43-.26l-.08-.05-.32-.21-.18-.13-.22-.16-.23-.18c-.06-.04-.11-.09-.17-.13l-.39-.32-.02-.02-.41-.36c-.04-.03-.07-.06-.11-.1l-.33-.31-.09-.09c-.02-.02-.04-.04-.06-.05l-.46-.43c-.01-.01-.03-.02-.04-.04l-.12-.11-.28-.25-.14-.11-.15-.13c-.05-.04-.09-.08-.14-.11l-.34-.26c-.02-.01-.04-.03-.06-.04-.01 0-.01-.01-.02-.01l-.4-.28-.19-.12-.48-.32c-.01 0-.01-.01-.02-.01l-.46-.31c-.04-.03-.08-.05-.12-.08l-.4-.26c-.02-.02-.05-.03-.07-.05l-.46-.31-.09-.06-.45-.3c-.02-.01-.04-.03-.06-.04l-.38-.26c-.03-.02-.05-.04-.08-.05l-.37-.25-.09-.06-.33-.22-.24-.17c-.02-.01-.04-.03-.06-.04l-.17-.12-1.86-1.31c-.02-.01-.03-.01-.04-.02s-.02-.01-.03-.02c-.02 0-.03-.01-.03-.01-.01-.01-.02-.01-.03-.02s-.02-.01-.03-.01-.02-.01-.03-.01-.02-.01-.03-.01c-.02 0-.03-.01-.03-.01-.01 0-.02-.01-.03-.01s-.02 0-.03-.01c-.01 0-.02 0-.03-.01h-.02-.05-.04c-.01 0-.03 0-.04.01-.02 0-.03.01-.05.01l-.06.03-9.91 5.76c.03-.02.07-.03.11-.04s.08-.01.13-.01c.04 0 .09.01.14.03a1.01 1.01 0 0 1 .15.07c.03.01.05.03.08.05l1.86 1.31.17.12c.02.01.04.03.05.04l.23.16.34.22.09.06.38.26c.01.01.03.02.04.03l.44.29c.01 0 .01.01.02.01l.47.31.09.06.96.64.08.05.48.32c.01 0 .01.01.02.01l.48.32.6.42c.02.01.04.03.06.04l.48.37.15.13.42.36.12.11.56.52.05.05c.01.01.03.03.05.04l.33.31.06.06c.01.01.03.02.04.04l.41.36c.01 0 .01.01.02.01l.39.32c.01.01.02.02.04.03l.13.1.23.18c.02.01.03.03.05.04.05.04.11.08.17.12l.18.13c.02.01.03.02.04.03l.27.18.08.05.35.22c.025.017.051.031.08.04l.25.14c.05.03.1.06.16.08.05.03.11.05.16.08l.22.11c.03.01.06.03.09.04.01 0 .02.01.03.01.08.04.16.07.24.1l.15.06c.08.04.15.06.22.09l.19.07.28.1.28.1.28.1.21.08.25.1c.04.02.09.04.13.05l.41.17.49.23.46.23.27.14.44.24.38.24c.02.01.03.02.05.03.13.08.25.17.37.27l.39.33.03.03c.13.12.26.25.38.39.09.09.17.19.26.3.09.1.16.2.23.29.02.03.04.05.06.08l.13.18.13.19c.03.04.05.08.08.12l.35.55.14.24.09.16.19.36c.01.02.02.04.03.07l.16.34c.01.02.01.03.02.05l.14.35c.01.02.01.03.02.05l.12.35c0 .02.01.03.01.05l.1.35c0 .01.01.03.01.04l.08.36.05.36v.02l.02.33v.02l-.01.32c-.01.12-.02.22-.05.32a1.7 1.7 0 0 1-.1.32c0 .01-.01.02-.01.03l-.13.27c0 .01-.01.02-.01.02-.04.06-.09.11-.13.17a.55.55 0 0 1-.07.09c-.07.08-.16.14-.24.19l9.91-5.76c.09-.05.17-.12.24-.19a.55.55 0 0 0 .07-.09c.04-.05.09-.1.13-.16 0-.02.01-.02.01-.03l.09-.16c.02-.03.03-.07.04-.1 0-.01.01-.02.01-.03s.01-.02.01-.03l.05-.14.03-.13c0-.01 0-.02.01-.02.01-.03.01-.06.02-.09.01-.04.01-.08.02-.11 0-.03.01-.07.01-.1 0-.06.01-.1.01-.14v-.12c.03-.04.02-.07.02-.1z\" fill=\"url(#T)\"/><path d=\"M57.55 32.59s13.36-4.83 18.09-9.28l4.38-4.21s1.5.14 1.24 1.42c0 0-3.21 1.97-2.21 5.75s-3.47 9.9-3.47 9.9l-.32.53s-6.6-3.24-10.4-3.32-6.83.68-6.83.68l-.48-1.47z\" fill=\"url(#U)\"/><path d=\"M84.85 16.12c.01.35-.12.64-.32.73-.06.15-.13.29-.33.38-.06.15-.13.29-.33.38-.06.15-.13.29-.33.38-.06.15-.13.29-.33.38-.06.15-.13.29-.33.38-.06.15-.13.29-.33.38-.06.15-.13.29-.33.38-.06.15-.13.29-.33.38-.06.15-.13.29-.33.38-.06.15-.13.29-.33.38-.13.29-.33.38-.74.2-.55-.24-.91-.91-.99-1.47-.01-.35.12-.64.32-.73.06-.15.13-.29.33-.38.06-.15.13-.29.33-.38.06-.15.13-.29.33-.38.06-.15.13-.29.33-.38.06-.15.13-.29.33-.38.06-.15.13-.29.33-.38.06-.15.13-.29.33-.38.06-.15.13-.29.33-.38.06-.15.13-.29.33-.38.06-.15.13-.29.33-.38.13-.29.33-.38.74-.2.48.39.9.92.99 1.47z\" fill=\"url(#V)\"/><path d=\"M59.05 33.68s5.14-1.9 10.51-1.14c5.37.77 7.62 2.64 7.62 2.64l-2.56 1.33-1.73-.89-2.7-1.04s-3.62-1.29-5.72-1.22l-5.42.32z\" fill=\"url(#W)\"/><path d=\"M74.86 35.24l.04-.29c.02-.11.03-.22.06-.32l.04-.22.05-.21c.02-.1.05-.19.08-.29l.05-.17c.03-.11.07-.22.11-.32.02-.04.03-.09.05-.13l.18-.45c.01-.02.02-.03.02-.05l.18-.39.06-.12.2-.36c.01-.02.03-.05.04-.07l.26-.42c.03-.04.05-.08.08-.12l.2-.29.11-.15.18-.23.16-.19.15-.18.27-.29.17-.17c.05-.04.09-.09.14-.13l.23-.2c.05-.04.09-.08.14-.11.08-.07.17-.13.26-.19l.12-.09.39-.25.37-.19a.3.3 0 0 1 .1-.04l.2-.08.29-.1c.06-.02.12-.04.18-.05s.11-.03.17-.04l.21-.03c.04 0 .08-.01.12-.01.09-.01.18-.01.26-.01h.06l.3.04c.02 0 .05.01.07.02l.22.06c.02.01.05.02.07.02l.27.13-1.6-.93c-.01 0-.01-.01-.02-.01-.07-.04-.13-.07-.2-.1-.01-.01-.03-.01-.04-.01-.02-.01-.05-.02-.07-.02-.04-.01-.07-.03-.11-.04l-.12-.03c-.02-.01-.05-.01-.07-.02-.01 0-.03-.01-.04-.01l-.25-.03h-.08-.19c-.02 0-.04.01-.07.01-.04 0-.08.01-.12.01s-.07.01-.11.01c-.03.01-.07.02-.1.02-.05.01-.11.02-.17.04-.03.01-.06.01-.09.02l-.09.03-.29.1-.1.03c-.03.01-.07.03-.1.05-.03.01-.06.03-.1.04l-.37.19-.39.25-.12.09-.26.19c-.05.04-.09.08-.14.11-.08.06-.15.13-.23.2-.05.04-.09.08-.14.13-.03.03-.06.05-.09.08l-.09.09-.27.29-.09.09c-.02.03-.05.06-.07.08l-.16.19c-.03.04-.07.08-.1.13l-.08.11-.11.15c-.03.04-.05.07-.08.1l-.12.18c-.03.04-.05.08-.08.12-.01.02-.02.03-.03.05l-.21.34c0 .01-.01.02-.01.02-.01.02-.03.05-.04.07l-.14.25-.06.12-.06.12c-.02.04-.04.07-.05.11-.049.094-.093.191-.13.29-.01.02-.02.03-.02.05l-.16.37c-.01.02-.02.04-.02.07-.02.04-.03.09-.05.13l-.07.18c-.02.05-.03.09-.04.14l-.05.17-.03.1c-.02.06-.03.12-.05.19l-.05.21c-.01.02-.01.05-.02.07l-.03.15-.06.32c0 .03-.01.06-.02.09l-.02.2c0 .05-.01.1-.01.14l-.02.45c0 .96.26 1.7.69 2.2.14.16.31.3.49.41l1.6.93c-.73-.42-1.18-1.32-1.18-2.6l.02-.45a.23.23 0 0 0 .04-.14z\" fill=\"url(#X)\"/><path d=\"M78.87 28.83c2.24-1.29 4.06-.25 4.07 2.32s-1.8 5.71-4.04 7-4.06.25-4.07-2.32 1.8-5.7 4.04-7z\" fill=\"url(#Y)\"/><path d=\"M81.349 34.99c1.337-2.283 1.355-4.758.039-5.528s-3.466.456-4.803 2.738-1.355 4.758-.039 5.528 3.465-.456 4.802-2.738z\" fill=\"#f7f7f7\"/><path d=\"M58.99 32c-.33-.13-.64-.11-.79.05-.16.01-.32.02-.47.18-.16.01-.32.02-.47.18-.16.01-.32.02-.47.18-.16.01-.32.02-.47.18-.16.01-.32.02-.47.18-.16.01-.32.02-.47.18-.16.01-.32.02-.47.18-.16.01-.32.02-.47.18-.16.01-.32.02-.47.18-.16.01-.32.02-.47.18-.32.02-.47.18-.44.63.04.6.56 1.16 1.05 1.43.33.13.64.11.79-.05.16-.01.32-.02.47-.18.16-.01.32-.02.47-.18.16-.01.32-.02.47-.18.16-.01.32-.02.47-.18.16-.01.32-.02.47-.18.16-.01.32-.02.47-.18.16-.01.32-.02.47-.18.16-.01.32-.02.47-.18.16-.01.32-.02.47-.18.16-.01.32-.02.47-.18.32-.02.47-.18.44-.63-.2-.59-.56-1.16-1.05-1.43z\" fill=\"url(#Z)\"/><path d=\"M44.81 44.6v-.06-.16-.11l-.01-.23v-.03l-.02-.33v-.04-.04l-.03-.29v-.04c-.01-.11-.03-.22-.05-.34v-.02c0-.03-.01-.06-.01-.09l-.04-.23c0-.02-.01-.03-.01-.05-.01-.03-.01-.07-.02-.1l-.04-.2c0-.02-.01-.04-.01-.06l-.03-.12c-.01-.06-.03-.12-.04-.18-.01-.02-.01-.04-.02-.07-.01-.05-.02-.09-.04-.14l-.04-.16c-.01-.02-.01-.04-.01-.06l-.06-.2-.03-.11c0-.01-.01-.02-.01-.03-.03-.11-.07-.22-.11-.33 0-.01-.01-.01-.01-.02-.01-.02-.02-.05-.02-.07-.03-.07-.05-.15-.08-.22-.01-.03-.03-.07-.04-.1s-.03-.07-.04-.1-.02-.06-.04-.09l-.12-.29c0-.02-.01-.03-.01-.03l-.11-.25-.06-.14a.3.3 0 0 0-.04-.08l-.03-.06-.14-.3c-.01-.03-.03-.05-.04-.08l-.14-.27c-.03-.06-.06-.11-.1-.17l-.12-.21-.06-.1c-.02-.04-.05-.08-.07-.12l-.3-.48c-.02-.04-.05-.08-.07-.11-.02-.02-.03-.05-.05-.07l-.17-.25-.12-.17c-.02-.03-.04-.06-.06-.08l-.09-.12-.1-.13a1.64 1.64 0 0 0-.17-.2c-.02-.02-.04-.04-.05-.07-.01-.01-.02-.02-.02-.03l-.25-.29c-.02-.02-.03-.04-.05-.06-.03-.03-.06-.07-.09-.1a1.81 1.81 0 0 0-.13-.14l-.12-.13-.12-.12c-.02-.02-.04-.05-.06-.07l-.16-.16-.14-.14-.04-.04-.14-.13-.21-.2-.04-.04-.11-.09-.29-.26c-.02-.02-.05-.04-.07-.06s-.05-.04-.07-.06l-.5-.41c-.01 0-.01-.01-.02-.01l-.88-.67c-.01-.01-.02-.01-.02-.02l-.09-.06-.54-.39-.5-.35-.41-.27-.19-.13-.1-.06-.69-.42-.16-.09-.53-.3c-.04-.02-.09-.04-.13-.07-.1-.06-.21-.11-.31-.16l-.25-.13c-.05-.03-.1-.05-.16-.07l-.33-.16-.21-.1c-.06-.02-.11-.05-.16-.07l-.36-.15a1.56 1.56 0 0 0-.19-.08l-.15-.06-.4-.15-.19-.07c-.04-.01-.07-.02-.11-.04l-.48-.16-.18-.06c-.02-.01-.04-.01-.06-.02l-.74-.2c-.01 0-.02 0-.03-.01-.03-.01-.05-.01-.08-.02l-.7-.16c-.03-.01-.07-.02-.1-.02s-.05-.01-.07-.01l-.84-.14c-.02 0-.04-.01-.06-.01-.04-.01-.09-.01-.13-.02-.12-.02-.25-.03-.36-.04l-.2-.02-.36-.03c-.04 0-.08-.01-.11-.01h-.04l-.58-.03h-.13l-.49-.01h-.37-.14l-.29.01c-.12 0-.25.01-.37.02l-.31.02c-.06 0-.12.01-.18.01-.06.01-.13.02-.19.02l-.4.05-.37.05-.42.07-.21.03-.16.04-.49.11-.36.09-.5.15-.25.08-.08.03-.89.36c-.01 0-.01.01-.02.01l-3.43 1.99c.01 0 .01-.01.02-.01-.04.02-.06.04-.09.07-.04.05-.05.18-.05.35.02.82.38 1.6.95 2.18 5.86 5.91 10.8 10.26 14.17 13.06 1 .83 2.06 1.69 3.02 2.24.6.34 3.82 1.6 4.71 1.28.11-.04.22-.1.32-.15 0 .01-.01.01-.01.02l3.43-1.99c.093-.054.18-.118.26-.19.02-.02.05-.04.07-.06.06-.05.12-.11.17-.17.02-.02.04-.05.06-.07.07-.08.13-.17.19-.26 0-.01 0-.02.01-.02a3.73 3.73 0 0 0 .19-.34c0-.01.01-.01.01-.02.03-.05.05-.11.07-.16.02-.06.05-.11.07-.17 0-.01.01-.01.01-.02a5.05 5.05 0 0 0 .06-.2c.02-.05.03-.1.05-.14 0-.01 0-.01.01-.02.02-.07.03-.13.05-.2.01-.05.03-.1.04-.16l.03-.17c.01-.07.03-.14.04-.21v-.02c.01-.04.01-.08.02-.12.01-.08.03-.17.04-.25v-.03c0-.03.01-.07.01-.1l.03-.27c0-.02 0-.03.01-.05v-.08c.01-.1.01-.19.02-.28v-.06-.04c0-.13.01-.25.01-.36v-.02c-.06-.07-.06-.11-.06-.15z\" fill=\"url(#a)\"/><path d=\"M29.45 21.27c.03.01.05.03.08.05l1.86 1.31 4.33 2.91c.81.54 1.61 1.2 2.39 1.94.72.7 1.78 1.62 2.98 2.3l.4.22c1.24.64 2.1.75 3.64 1.5l1.18.61a6.55 6.55 0 0 1 1.61 1.28c1.43 1.55 2.72 4.24 2.37 5.84-.16.75-.71 1.41-1.5 1.17-.11-.03-.21-.08-.32-.14-.56-.32-1.06-1-1.64-1.73-1.48-1.86-2.77-3.1-5.35-5.58-.89-.86-2.07-1.99-3.67-3.1l-1.49-.95-1.43-.78-1.54-.84-2.11-1.34-1.68-1.22c-.82-1.08-.91-2.3-.85-3.09.01-.43.34-.59.74-.36z\" fill=\"url(#b)\"/><path d=\"M25.24 72.76s.87.17.73 3.61c-.09 2.18.89 3.08 1.62 3.44a2.59 2.59 0 0 0 1.16.26c.88 0 3.03-.18 4.55-1.65 1.96-1.89 2.42-3.9 2.42-3.9s.59-2.66-.1-3.45l-10.38 1.69z\" fill=\"url(#c)\"/><path d=\"M17.1 70.07s.17 2.27 0 3.34.68 1.1.68 1.1 1.95.25 2.44-2.38l-3.12-2.06z\" fill=\"url(#d)\"/><path d=\"M17.6 65.34s1.99-5.21 7.52-6.32 8.87 3.55 8.87 3.55 2.65 3.49 2.13 8.96c-.51 5.47-4.15 7.12-4.15 7.12s-4.24 2.19-4.48-.18c-.14-1.43-.08-2.34-.01-2.85.09-.61.14-1.21.12-1.83-.02-.53-.07-1.13-.2-1.59l-1.35-1.22-8.27-4.03-.18-1.61z\" fill=\"url(#e)\"/><path d=\"M17.9 64.56s.11 2.42 3.82 3.7c3.53 1.22 6.34 1.19 6.34 1.19s1.67-.02 1.58 1.29c-.07 1.12-1.47 1.88-2.14 2.18-.22.1-.44.17-.67.22-1.08.24-4.63.79-7.94-1.15-3.96-2.32-2.89-4.51-2.89-4.51s.63-1.79 1.9-2.92z\" fill=\"url(#f)\"/><path d=\"M19.18 67.86c-.16.38-.52.59-.81.47s-.4-.53-.24-.9.52-.59.81-.47c.29.11.4.52.24.9z\" fill=\"url(#g)\"/><path d=\"M27.89 70.89l-1.13-.08c-.18-.01-.31-.17-.3-.35v-.03c.01-.18.17-.31.35-.3l1.13.08c.18.01.31.17.3.35v.03c-.01.17-.17.31-.35.3z\" fill=\"#8334c2\"/><path d=\"M26.08 71.21a.82.82 0 1 0 0-1.64.82.82 0 1 0 0 1.64z\" fill=\"url(#h)\"/><path d=\"M75.1 69.73c0 1.66 1.24 3.94 2.69 4.77s2.69.21 2.69-1.66c0-1.66-1.24-3.94-2.69-4.77-1.44-.62-2.69.01-2.69 1.66z\" fill=\"#f7f7f7\"/></g><defs><linearGradient id=\"A\" x1=\"18.04\" y1=\"26.181\" x2=\"25.89\" y2=\"26.181\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"26.583\" y1=\"20.6\" x2=\"36.148\" y2=\"20.629\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"26.035\" y1=\"39.608\" x2=\"37.388\" y2=\"39.608\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"25.158\" y1=\"39.238\" x2=\"41.465\" y2=\"39.238\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"-1.201\" y1=\"40.771\" x2=\"42.094\" y2=\"40.771\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"73.504\" y1=\"70.188\" x2=\"96.255\" y2=\"70.188\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"41.985\" y1=\"69.818\" x2=\"90.499\" y2=\"69.818\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"58.416\" y1=\"71.35\" x2=\"91.241\" y2=\"71.35\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"69.209\" y1=\"57.156\" x2=\"77.771\" y2=\"57.156\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"-.517\" y1=\"44.747\" x2=\"93.175\" y2=\"44.747\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"80.771\" y1=\"57.908\" x2=\"81.327\" y2=\"57.324\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"25.774\" y1=\"52.676\" x2=\"93.482\" y2=\"52.676\" xlink:href=\"#j\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"M\" x1=\"27.665\" y1=\"56.572\" x2=\"91.894\" y2=\"56.572\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"39.935\" y1=\"60.229\" x2=\"90.837\" y2=\"60.229\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"31.859\" y1=\"48.42\" x2=\"92.043\" y2=\"48.42\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"33.795\" y1=\"48.303\" x2=\"132.411\" y2=\"48.303\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"64.931\" y1=\"66.25\" x2=\"78.76\" y2=\"51.717\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"R\" x1=\"54.475\" y1=\"62.416\" x2=\"105.314\" y2=\"62.416\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"S\" x1=\"58.683\" y1=\"64.93\" x2=\"114.829\" y2=\"64.93\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"T\" x1=\"17.913\" y1=\"27.867\" x2=\"71.652\" y2=\"27.867\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"U\" x1=\"46.307\" y1=\"27.897\" x2=\"91.83\" y2=\"27.897\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"V\" x1=\"72.181\" y1=\"17.745\" x2=\"91.26\" y2=\"17.745\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"W\" x1=\"53.909\" y1=\"34.439\" x2=\"99.37\" y2=\"34.439\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"X\" x1=\"65.583\" y1=\"32.893\" x2=\"88.853\" y2=\"32.893\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Y\" x1=\"63.62\" y1=\"33.494\" x2=\"85.775\" y2=\"33.494\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Z\" x1=\"47.557\" y1=\"33.96\" x2=\"74.86\" y2=\"33.96\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"a\" x1=\"3.787\" y1=\"39.992\" x2=\"59.076\" y2=\"39.992\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"b\" x1=\"22.874\" y1=\"30.812\" x2=\"87.031\" y2=\"30.812\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"c\" x1=\"14.016\" y1=\"75.565\" x2=\"36.734\" y2=\"75.565\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"d\" x1=\"12.701\" y1=\"72.289\" x2=\"22.455\" y2=\"72.289\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"e\" x1=\"14.081\" y1=\"69.208\" x2=\"45.714\" y2=\"69.208\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"f\" x1=\"8.076\" y1=\"68.984\" x2=\"33.399\" y2=\"68.984\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"g\" x1=\"17.514\" y1=\"67.637\" x2=\"22.789\" y2=\"67.637\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"h\" x1=\"23.718\" y1=\"70.389\" x2=\"29.798\" y2=\"70.389\" xlink:href=\"#j\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"i\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"j\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgMotorcycle = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#S)\"><g clip-path=\"url(#T)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M79.04 65.15l-5.96-15.24-.5.16-3.32-8.59-1.03.66 3.2 8.4h-.17l5.96 15.08c.17.31.5.62.83.62.66.16 1.15-.47.99-1.09z\" fill=\"url(#A)\"/><path d=\"M48.43 28.76v1.47l-5.1 3.52-.84-.48.1-1.53 5.84-2.98z\" fill=\"url(#B)\"/><path d=\"M28.57 29.23c-6.45-3.58-11.75-.78-11.75 6.22s5.29 15.4 11.75 18.97 11.75.78 11.75-6.22-5.29-15.39-11.75-18.97zm.33 21.62c-4.63-2.49-8.44-8.55-8.44-13.53s3.81-7 8.44-4.51 8.44 8.55 8.44 13.53c0 4.97-3.64 6.99-8.44 4.51z\" fill=\"url(#C)\"/><path d=\"M39 48.82c-.33-7-5.63-15.4-12.08-18.97-4.06-2.18-7.62-1.97-9.66.32-1.32 1.33-2.1 3.38-2.1 6.06 0 7 5.29 15.4 11.75 18.97 5.08 2.81 9.43 1.67 11.05-2.35l.04.02c.51-1.09 1-2.49 1-4.05zm-12.41 3.42c-4.63-2.49-8.44-8.55-8.44-13.53s3.81-7 8.44-4.51c4.62 2.48 8.42 8.53 8.44 13.5a8.25 8.25 0 0 1-.65 3.14h.01c-1.29 2.59-4.31 3.28-7.8 1.4z\" fill=\"url(#D)\"/><path d=\"M74.07 53.8c-6.45-3.58-11.75-.78-11.75 6.22s5.3 15.4 11.75 18.97 11.75.78 11.75-6.22-5.29-15.39-11.75-18.97zm.33 21.62c-4.63-2.49-8.44-8.55-8.44-13.53s3.81-7 8.44-4.51 8.44 8.55 8.44 13.53-3.64 7-8.44 4.51z\" fill=\"url(#E)\"/><path d=\"M84.5 73.4c-.33-7-5.63-15.4-12.08-18.98-4.06-2.18-7.62-1.97-9.66.32-1.32 1.33-2.1 3.38-2.1 6.06 0 7 5.3 15.4 11.75 18.98 5.08 2.82 9.43 1.67 11.06-2.35l.04.02c.5-1.1.99-2.5.99-4.05zm-12.41 3.42c-4.63-2.49-8.44-8.55-8.44-13.53s3.81-7 8.44-4.51c4.62 2.48 8.42 8.53 8.44 13.5a8.25 8.25 0 0 1-.65 3.14h.01c-1.29 2.59-4.31 3.27-7.8 1.4z\" fill=\"url(#F)\"/><path d=\"M65.3 39.49l-2.15-4.35c-2.65-5.29-11.42-6.53-13.24-5.91s-4.63 1.71-6.29 3.27l.08.04c-.27.28-.41.66-.41 1.05.17.62 0 3.89 3.81 5.91l9.27 4.98h.17c.08.02.16.02.24.04 1.3.54 3.03.36 4.23-.35l.33-1.87-.67-1.17 2.99 1.63 1.64-3.27z\" fill=\"url(#G)\"/><path d=\"M42.97 32.18l5.46-3.42-7.94-4.98-7.78-7.46c-.5-.47-1.32-.62-1.82-.31L24 19.86l10.7 7.03 8.27 5.29z\" fill=\"url(#H)\"/><path d=\"M66.79 36.54l-2.81-1.09-4.99 2.57-8.74-4.75-2.32-.31-4.41.28-.51-.44-.05-.62-6.78-4.35-2.48-2.02-6.45-6.06c-.66-.62-1.65-.78-2.48-.31l-.33.16c-1.16.62-1.99 1.87-1.82 3.27l.17.78c0 .5.32.99.71 1.41l-.21 2.16 11.39 9.02.46 1.68-.93.81.6 1.3-2.91 2.74c-.33.31-.5.78-.33 1.24 0 .47.33.78.83 1.09l5.13 2.8a1.08 1.08 0 0 0 .99 0c.18-.08.3-.26.36-.46l.65-.37 1.43 4.19c.39 1.14.56 2.61 1.37 3.53.74.84 1.84 1.29 2.88 1.65 2.7.94 5.49 1.63 8.26 2.32.66.16 1.34.33 2.01.25.76-.08 1.45-.46 2.11-.82 1.15-.63 2.33-1.28 3.21-2.27.98-1.1 1.53-2.54 2.3-3.78l3.51-5.62.11-.18 3.07-1.72-3-8.08z\" fill=\"url(#I)\"/><path d=\"M77.88 65.62c0-.32-.13-.64-.33-.92v-.01h-.01a2.42 2.42 0 0 0-.65-.63c-.18-.11-.34-.14-.5-.13v-.02l-.05.03c-.12.02-.23.07-.3.16l-3.12 1.68v2.02l1.16-.62v.78l3.29-1.76c.28-.05.51-.27.51-.58z\" fill=\"url(#J)\"/><path d=\"M32.04 46.71v-.06c0-.05-.01-.1-.01-.15l-.04-.47c-.01-.08-.01-.15-.03-.23-.39-2.54-2.21-5.23-4.55-6.46-2.48-1.24-4.63-.16-4.63 2.49 0 2.8 1.99 6.06 4.63 7.46 2.48 1.4 4.63.31 4.63-2.49.01-.03 0-.06 0-.09z\" fill=\"url(#K)\"/><path d=\"M67.16 46.88c-3.53.78-6.34 2.87-7.32 6.29l1.49.47 3.64-1.71c.61-1.94 2.19-2.93 3.95-3.41 2.25-.38 4.62-.35 6.64-.16l3.31-1.71v-.93c-3.57-.8-8.13-.33-11.71 1.16z\" fill=\"url(#L)\"/><path d=\"M41.15 50.85c-.161-.112-.336-.202-.52-.27l-11.26-6 3.34-4.77 2.98-4.67-2.24-1.65-13.81-9.7c-.83-.62-2.15-.78-3.14-.16l-.83.47c-.99.47-1.49 1.4-1.49 2.33l.06.03c.04.46.25.95.77 1.37l4.47 4.2 6.29.47 5.46 3.58-4.72 6.52c-.26-.01-.5.06-.69.21-.45.07-.71.51-.71 1.2 0 1.09.83 2.33 1.65 2.8.7.33 1.22.26 1.48-.18.1-.05.2-.11.27-.2l11.82 6.45.01-.04c.59.23 1.23.25 1.48-.11.32-.49.15-1.26-.67-1.88z\" fill=\"url(#M)\"/><path d=\"M66.96 65.31c0 2.8 1.99 6.06 4.63 7.46 2.48 1.4 4.63.31 4.63-2.49s-1.99-6.06-4.63-7.46-4.63-.31-4.63 2.49z\" fill=\"url(#N)\"/><path d=\"M69.5 26.11l4.9-2.17v-.78l-.66.29v-.75l-5.6 2.5-.02-.01-.02.03-22.98 10.23v1.4l.5-.22v.07l5.52-2.44 6.26 1.23.76 1.98-.46.17 1.82 5.44.69-.24 4.32 11.3-.71.28.5 1.09.33-.16 3.93 10.35c-.07.2-.13.43-.13.69 0 1.4.99 3.11 2.32 3.89 1.32.78 2.32.16 2.32-1.24s-.99-3.11-2.32-3.89c-.14-.1-.29-.17-.43-.23l-3.87-10.19.17-.16-.5-1.09-.41.16-3.22-8.51 2.22-1.12.25.14 4.8-1.56-1.35-4.13.19-.06-1.99-5.44-.61.14-.61-1.57 4.09-5.42zm-10.6 9.53l-.54-1.43-4.73-1.06 12.84-5.69-2.65 3.64.66 1.4.08.19.05.14-5.71 2.81z\" fill=\"url(#O)\"/><path d=\"M68.74 37.05l.01-.01c-2.32-1.4-4.47-.47-5.29.78-.76 1.15-.52 3.08 1.33 4.35.44.56 1.25.69 2.14.16 1.32-.78 2.48-2.49 2.48-3.89 0-.67-.26-1.14-.67-1.39z\" fill=\"url(#P)\"/><path d=\"M69.08 38.46c0-1.24-.83-1.71-1.99-1.09s-1.99 2.02-1.99 3.27.83 1.71 1.99 1.09c1.17-.47 1.99-2.03 1.99-3.27z\" fill=\"#fff\"/><path d=\"M49.95 32.94c-.34-.13-.67-.11-.83.06-.17.01-.33.02-.48.19-.17.01-.33.02-.48.19-.17.01-.33.02-.48.19-.17.01-.33.02-.48.19-.17.01-.33.02-.48.19-.17.01-.33.02-.48.19-.17.01-.33.02-.48.19-.17.01-.33.02-.48.19-.17.01-.33.02-.48.19-.17.01-.33.02-.48.19-.33.02-.48.19-.45.65.04.62.58 1.21 1.09 1.49.34.13.67.11.83-.06.17-.01.33-.02.48-.19.17-.01.33-.02.48-.19.17-.01.33-.02.48-.19.17-.01.33-.02.48-.19.17-.01.33-.02.48-.19.17-.01.33-.02.48-.19.17-.01.33-.02.48-.19.17-.01.33-.02.48-.19.17-.01.33-.02.48-.19.17-.01.33-.02.48-.19.33-.02.48-.19.45-.65-.2-.61-.57-1.21-1.09-1.49z\" fill=\"url(#Q)\"/><path d=\"M74.99 22.28c-.34-.14-.67-.13-.83.03-.17.01-.33.01-.49.18-.17.01-.33.01-.49.18-.17.01-.33.01-.49.18-.17.01-.33.01-.49.18-.17.01-.33.01-.49.18-.17.01-.33.01-.49.18-.17.01-.33.01-.49.18-.17.01-.33.01-.49.18-.17.01-.33.01-.49.18-.17.01-.33.01-.49.18-.33.01-.49.18-.47.64.03.62.55 1.22 1.06 1.51.34.14.67.13.83-.03.17-.01.33-.01.49-.18.17-.01.33-.01.49-.18.17-.01.33-.01.49-.18.17-.01.33-.01.49-.18.17-.01.33-.01.49-.18.17-.01.33-.01.49-.18.17-.01.33-.01.49-.18.17-.01.33-.01.49-.18.17-.01.33-.01.49-.18.17-.01.33-.01.49-.18.33-.01.49-.18.47-.64a1.71 1.71 0 0 0-1.06-1.51z\" fill=\"url(#R)\"/></g></g><defs><linearGradient id=\"A\" x1=\"51.259\" y1=\"53.871\" x2=\"91.371\" y2=\"53.871\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"30.679\" y1=\"31.256\" x2=\"49.616\" y2=\"31.256\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"-1.057\" y1=\"41.901\" x2=\"95.071\" y2=\"41.657\" xlink:href=\"#U\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"D\" x1=\"12.236\" y1=\"42.54\" x2=\"63.919\" y2=\"42.54\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"44.438\" y1=\"66.474\" x2=\"140.58\" y2=\"66.23\" xlink:href=\"#U\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"F\" x1=\"49.183\" y1=\"67.113\" x2=\"121.705\" y2=\"67.113\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"29.923\" y1=\"36.951\" x2=\"105.611\" y2=\"36.951\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"10.642\" y1=\"24.017\" x2=\"65.118\" y2=\"24.017\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"13.259\" y1=\"39.09\" x2=\"73.412\" y2=\"39.09\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"65.39\" y1=\"65.93\" x2=\"85.597\" y2=\"65.93\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"16.019\" y1=\"44.362\" x2=\"59.039\" y2=\"44.362\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"39.604\" y1=\"49.488\" x2=\"84.961\" y2=\"49.488\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"-15.792\" y1=\"38.114\" x2=\"79.47\" y2=\"38.114\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"62.443\" y1=\"67.838\" x2=\"95.904\" y2=\"67.682\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"11.595\" y1=\"46.66\" x2=\"90.395\" y2=\"46.66\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"59.256\" y1=\"39.493\" x2=\"71.685\" y2=\"39.493\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".907\" stop-color=\"#903fca\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"39.721\" y1=\"34.983\" x2=\"66.014\" y2=\"34.983\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"R\" x1=\"60.187\" y1=\"24.253\" x2=\"89.955\" y2=\"24.253\" xlink:href=\"#U\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"S\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"T\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"U\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgMotorcycleCar = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#f)\"><g clip-path=\"url(#g)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M97.11 54.43l.46-3.8-23.12 13.28.08.44-.52 3.42 23.1-13.34z\" fill=\"url(#A)\"/><path d=\"M71.45 27.55l-17.11 9.69c-.31.18-.24.77-.15 1.11l3.68 14.02c.13.5.69.74 1.14.49l21.44-11.89a.79.79 0 0 0 .383-.506.79.79 0 0 0-.113-.624l-8.01-11.82c-.22-.34-.9-.68-1.26-.47z\" fill=\"url(#B)\"/><path d=\"M29.2 36.74l-5.76 2.93 1.36 3.61 6.6-3.88-2.2-2.66z\" fill=\"url(#C)\"/><path d=\"M63.68 57.88l-5.76 2.83.63 4.5 6.6-3.67-1.47-3.66z\" fill=\"url(#D)\"/><path d=\"M35.78 49.37c0-2.83-1.99-6.28-4.5-7.75-.94-.52-1.89-.73-2.62-.52-.21 0-2.62 1.36-2.62 1.47-.63.52-1.05 1.36-1.05 2.72 0 2.83 1.99 6.28 4.5 7.75 1.05.63 1.99.73 2.83.52.21-.1 2.51-1.26 2.93-1.89.32-.63.53-1.36.53-2.3z\" fill=\"url(#E)\"/><path d=\"M24.57 45.49c0 2.83 1.99 6.28 4.5 7.75s4.5.31 4.5-2.51c0-2.83-1.99-6.28-4.5-7.75s-4.5-.42-4.5 2.51z\" fill=\"url(#F)\"/><path d=\"M26.67 46.54c0 1.57 1.15 3.56 2.51 4.4s2.51.21 2.51-1.47c0-1.57-1.15-3.56-2.51-4.4-1.36-.83-2.51-.21-2.51 1.47z\" fill=\"#fff\"/><path d=\"M27.61 47.09c0 .84.63 1.99 1.36 2.41s1.36.1 1.36-.73c0-.84-.63-1.99-1.36-2.41-.73-.53-1.36-.11-1.36.73z\" fill=\"url(#G)\"/><path d=\"M70.25 69.11c0-2.83-1.99-6.28-4.5-7.75-.94-.52-1.89-.73-2.62-.52-.21 0-2.62 1.36-2.62 1.47-.63.52-1.05 1.36-1.05 2.72 0 2.83 1.99 6.28 4.5 7.75 1.05.63 1.99.73 2.83.52.21-.1 2.51-1.26 2.93-1.89.32-.62.53-1.36.53-2.3z\" fill=\"url(#H)\"/><path d=\"M59.04 65.24c0 2.83 1.99 6.28 4.5 7.75s4.5.31 4.5-2.51-1.99-6.28-4.5-7.75-4.5-.43-4.5 2.51z\" fill=\"url(#I)\"/><path d=\"M61.13 66.28c0 1.57 1.15 3.56 2.51 4.4s2.51.21 2.51-1.47c0-1.57-1.15-3.56-2.51-4.4-1.35-.83-2.51-.2-2.51 1.47z\" fill=\"#fff\"/><path d=\"M62.08 66.83c0 .84.63 1.99 1.36 2.41s1.36.1 1.36-.73-.63-1.99-1.36-2.41c-.74-.53-1.36-.11-1.36.73z\" fill=\"url(#J)\"/><path d=\"M77.36 64.2c0-.73-.52-.94-1.05-.63-.63.31-1.15 1.15-1.15 1.89 0 .73.52.94 1.05.63.62-.32 1.04-1.16 1.15-1.89zm19.26-11.32c0-.63-.42-.94-1.05-.52-.63.31-1.05 1.15-1.05 1.78s.42.94 1.05.52c.53-.32 1.05-1.05 1.05-1.78z\" fill=\"#fff\"/><path d=\"M74.46 64.78l.07-.43-.08-.44 23.12-13.29-16.1-10.42-9.05-13.66c-.03-.04-.06-.09-.12-.12L54.63 16.29c-1.01-.58-2.25-.59-3.27-.02l-17.11 9.56-10.61 7.83-.67.46c-.45.31-.78.76-.95 1.28l-.11.33a3.68 3.68 0 0 0 .03 2.32l1.52 4.42 1.33.8c.73-1.89 2.23-2.69 4.43-1.43 2.83 1.68 5.13 5.66 5.13 8.9v.1l.21.63 23.67 13.62.31.1v-.63c0-3.25 2.3-4.61 5.13-2.93 2.72 1.57 4.92 5.24 5.13 8.48l1.01.74c.54.39 1.14 1 1.69 1 .2 0 .56-.14 1.02-.38.43-.22.9-.51 1.29-.74.79-.48 1.6-.93 2.4-1.4l2.93-1.7 3.2-1.85 3.22-1.86 2.99-1.73 2.52-1.46 1.81-1.05.84-.49c.01-.01.02-.01.03-.02a3.71 3.71 0 0 0 1.39-1.39l1.92-3.28c.02-.03.02-.07.04-.1L74 67.74l.46-2.96zM57.64 51.1l-3.26-12.85c-.12-.48.09-.97.52-1.22l16.18-9.22a1.1 1.1 0 0 1 1.46.35l7.44 11.41c.35.53.17 1.25-.39 1.56L59.67 51.99c-.81.44-1.81 0-2.03-.89z\" fill=\"url(#K)\"/><path d=\"M29.54 34.55c.28-.71.14-1.41-.42-1.7-.57-.28-1.27 0-1.56.71-.28.71-.14 1.41.42 1.7.57.28 1.28 0 1.56-.71z\" fill=\"url(#L)\"/><path d=\"M52.96 37.55l-13.88-8.03a1.51 1.51 0 0 0-1.77.19l-5.49 4.98c-.77.7-.62 1.96.3 2.45l.57.31 23.36 13.51.12-.33c.2-.54.23-1.12.09-1.67L53.67 38.5c-.09-.4-.35-.74-.71-.95z\" fill=\"#fff\"/><path d=\"M46.31 33.71l-2.02 10.46-.82-.47 2-10.48.84.49z\" fill=\"url(#M)\"/><path d=\"M45.44 70.6l-3.95-10.11-.33.1-2.2-5.7-.68.44 2.12 5.57h-.11l3.95 10c.11.21.33.41.55.41.43.11.76-.3.65-.71z\" fill=\"url(#N)\"/><path d=\"M25.14 46.46v.98l-3.38 2.33-.56-.32.07-1.01 3.87-1.98z\" fill=\"url(#O)\"/><path d=\"M11.97 46.77c-4.28-2.37-7.79-.52-7.79 4.13s3.51 10.21 7.79 12.58 7.79.52 7.79-4.13-3.51-10.2-7.79-12.58zm.22 14.34c-3.07-1.65-5.6-5.67-5.6-8.97s2.52-4.64 5.6-2.99c3.07 1.65 5.6 5.67 5.6 8.97s-2.42 4.64-5.6 2.99z\" fill=\"url(#P)\"/><path d=\"M18.89 59.77c-.22-4.64-3.73-10.21-8.01-12.58-2.7-1.45-5.05-1.31-6.41.21-.87.88-1.39 2.24-1.39 4.02 0 4.64 3.51 10.21 7.79 12.58 3.37 1.87 6.25 1.11 7.33-1.56l.02.01c.34-.72.67-1.65.67-2.68zm-8.23 2.27c-3.07-1.65-5.6-5.67-5.6-8.97s2.52-4.64 5.6-2.99c3.07 1.65 5.59 5.66 5.6 8.95-.01.89-.22 1.58-.43 2.08-.86 1.72-2.86 2.17-5.17.93z\" fill=\"url(#Q)\"/><path d=\"M42.15 63.07c-4.28-2.37-7.79-.52-7.79 4.13s3.51 10.21 7.79 12.58 7.79.52 7.79-4.13c0-4.64-3.51-10.21-7.79-12.58zm.22 14.34c-3.07-1.65-5.6-5.67-5.6-8.97s2.52-4.64 5.6-2.99c3.07 1.65 5.6 5.67 5.6 8.97s-2.42 4.64-5.6 2.99z\" fill=\"url(#R)\"/><path d=\"M49.07 76.07c-.22-4.64-3.73-10.21-8.01-12.58-2.7-1.45-5.05-1.31-6.41.21-.87.88-1.39 2.24-1.39 4.02 0 4.64 3.51 10.21 7.79 12.58 3.37 1.87 6.25 1.11 7.33-1.56l.02.01c.34-.72.67-1.65.67-2.68zm-8.24 2.27c-3.07-1.65-5.6-5.67-5.6-8.97s2.52-4.64 5.6-2.99c3.07 1.65 5.59 5.66 5.6 8.95-.01.89-.22 1.58-.43 2.08-.85 1.71-2.85 2.17-5.17.93z\" fill=\"url(#S)\"/><path d=\"M36.33 53.58l-1.43-2.89c-1.76-3.51-7.57-4.33-8.78-3.92s-3.07 1.13-4.17 2.17l.06.03c-.18.18-.27.44-.27.7.11.41 0 2.58 2.52 3.92l6.15 3.3h.11c.05.01.1.02.16.02.86.36 2.01.24 2.81-.23l.22-1.24-.45-.77 1.98 1.08 1.09-2.17z\" fill=\"url(#T)\"/><path d=\"M21.52 48.73l3.62-2.27-5.27-3.3-5.16-4.95c-.33-.31-.88-.41-1.21-.21l-4.57 2.56 7.09 4.66 5.5 3.51z\" fill=\"url(#U)\"/><path d=\"M37.32 51.62l-1.87-.72-3.31 1.7-5.8-3.15-1.54-.21-2.92.18-.34-.29-.03-.41-4.5-2.89-1.65-1.34-4.28-4.02c-.44-.41-1.1-.52-1.65-.21l-.22.1c-.77.41-1.32 1.24-1.21 2.17l.11.52c0 .33.21.66.47.94l-.14 1.43L16 51.4l.31 1.12-.62.54.4.86-1.93 1.82c-.22.21-.33.52-.22.83 0 .31.22.52.55.72l3.4 1.86c.22.1.44.1.66 0 .12-.06.2-.17.24-.3l.43-.25.95 2.78c.26.75.37 1.73.91 2.34.49.56 1.22.86 1.91 1.09 1.79.62 3.64 1.08 5.48 1.54.44.11.89.22 1.33.17.5-.05.96-.3 1.4-.55.76-.42 1.55-.85 2.13-1.5.65-.73 1.01-1.69 1.52-2.51l2.33-3.73c.02-.04.05-.08.07-.12l2.04-1.14-1.97-5.35z\" fill=\"url(#V)\"/><path d=\"M44.67 70.91c0-.21-.09-.42-.22-.61v-.01h-.01c-.12-.17-.28-.32-.43-.42-.12-.07-.23-.09-.33-.09v-.01l-.03.02c-.08.01-.15.04-.2.11l-2.07 1.11v1.34l.77-.41v.52l2.18-1.17c.19-.03.34-.18.34-.38z\" fill=\"url(#W)\"/><path d=\"M14.27 58.36v-.04c0-.03-.01-.07-.01-.1l-.03-.31c-.01-.05-.01-.1-.02-.15-.26-1.68-1.47-3.47-3.02-4.29-1.65-.83-3.07-.1-3.07 1.65 0 1.86 1.32 4.02 3.07 4.95 1.65.93 3.07.21 3.07-1.65.02-.01.01-.03.01-.06z\" fill=\"url(#X)\"/><path d=\"M37.57 58.48c-2.34.52-4.2 1.91-4.85 4.17l.99.31 2.41-1.13c.4-1.28 1.45-1.94 2.62-2.26 1.49-.25 3.06-.23 4.4-.11l2.19-1.13v-.62c-2.36-.53-5.39-.21-7.76.77z\" fill=\"url(#Y)\"/><path d=\"M20.31 61.11a1.83 1.83 0 0 0-.34-.18l-7.47-3.98 2.22-3.16 1.98-3.09-1.48-1.09-9.16-6.43c-.55-.41-1.43-.52-2.09-.1l-.55.31a1.69 1.69 0 0 0-.99 1.55l.04.02c.02.31.16.63.51.91l2.96 2.78 4.17.31 3.62 2.37-3.13 4.32a.64.64 0 0 0-.45.14c-.3.05-.47.34-.47.79 0 .72.55 1.55 1.1 1.86.46.22.81.17.98-.12.07-.03.13-.07.18-.13l7.84 4.28v-.03c.39.16.82.16.98-.07.21-.33.1-.85-.45-1.26z\" fill=\"url(#Z)\"/><path d=\"M37.43 70.7c0 1.86 1.32 4.02 3.07 4.95 1.65.93 3.07.21 3.07-1.65s-1.32-4.02-3.07-4.95-3.07-.2-3.07 1.65z\" fill=\"url(#a)\"/><path d=\"M39.12 44.71l3.25-1.44v-.52l-.44.19v-.5l-3.72 1.66-.01-.01-.01.02-15.24 6.79v.93l.33-.15v.05l3.66-1.62 4.15.81.5 1.31-.3.11 1.21 3.61.46-.16 2.86 7.5-.47.19.33.72.22-.1 2.61 6.86a1.3 1.3 0 0 0-.08.46c0 .93.66 2.06 1.54 2.58s1.54.1 1.54-.83-.66-2.06-1.54-2.58l-.28-.15-2.57-6.76.11-.1-.33-.72-.27.11-2.14-5.64 1.47-.75.17.09 3.18-1.03-.91-2.74.13-.04-1.32-3.61-.4.09-.4-1.04 2.71-3.59zm-7.03 6.32l-.36-.95-3.14-.7 8.51-3.77-1.76 2.41.44.93.05.12.04.09-3.78 1.87z\" fill=\"url(#b)\"/><path d=\"M38.61 51.96c-1.53-.94-2.96-.32-3.51.51-.51.76-.34 2.04.88 2.88.29.37.83.46 1.42.11.88-.52 1.65-1.65 1.65-2.58.01-.44-.16-.76-.44-.92z\" fill=\"url(#c)\"/><path d=\"M38.84 52.89c0-.83-.55-1.13-1.32-.72s-1.32 1.34-1.32 2.17.55 1.13 1.32.72c.77-.31 1.32-1.34 1.32-2.17z\" fill=\"#fff\"/><path d=\"M26.15 49.24c-.23-.09-.44-.07-.55.04-.11.01-.22.01-.32.12-.11.01-.22.01-.32.12-.11.01-.22.01-.32.12-.11.01-.22.01-.32.12-.11.01-.22.01-.32.12-.11.01-.22.01-.32.12-.11.01-.22.01-.32.12-.11.01-.22.01-.32.12-.11.01-.22.01-.32.12-.11.01-.22.01-.32.12-.22.01-.32.12-.3.43.03.41.38.8.73.99.23.09.44.07.55-.04.11-.01.22-.01.32-.12.11-.01.22-.01.32-.12.11-.01.22-.01.32-.12.11-.01.22-.01.32-.12.11-.01.22-.01.32-.12.11-.01.22-.01.32-.12.11-.01.22-.01.32-.12.11-.01.22-.01.32-.12.11-.01.22-.01.32-.12.11-.01.22-.01.32-.12.22-.01.32-.12.3-.43-.14-.41-.39-.81-.73-.99z\" fill=\"url(#d)\"/><path d=\"M42.76 42.16c-.22-.09-.44-.08-.55.02-.11 0-.22.01-.32.12-.11 0-.22.01-.32.12-.11 0-.22.01-.32.12-.11 0-.22.01-.32.12-.11 0-.22.01-.32.12-.11 0-.22.01-.32.12-.11 0-.22.01-.32.12-.11 0-.22.01-.32.12-.11 0-.22.01-.32.12-.11 0-.22.01-.32.12-.22.01-.32.12-.31.43.02.41.36.81.7 1 .22.09.44.08.55-.02.11 0 .22-.01.32-.12.11 0 .22-.01.32-.12.11 0 .22-.01.32-.12.11 0 .22-.01.32-.12.11 0 .22-.01.32-.12.11 0 .22-.01.32-.12.11 0 .22-.01.32-.12.11 0 .22-.01.32-.12.11 0 .22-.01.32-.12.11 0 .22-.01.32-.12.22-.01.32-.12.31-.43-.02-.41-.26-.81-.7-1z\" fill=\"url(#e)\"/></g></g><defs><linearGradient id=\"A\" x1=\"-59.834\" y1=\"59.199\" x2=\"101.101\" y2=\"59.199\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"48.719\" y1=\"40.218\" x2=\"189.844\" y2=\"40.218\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"20.796\" y1=\"40.017\" x2=\"38.031\" y2=\"40.017\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"56.966\" y1=\"61.549\" x2=\"67.837\" y2=\"61.549\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"17.551\" y1=\"47.335\" x2=\"39.183\" y2=\"47.335\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"22.574\" y1=\"48.102\" x2=\"39.601\" y2=\"48.102\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"25.805\" y1=\"47.902\" x2=\"30.695\" y2=\"47.902\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"52.017\" y1=\"67.078\" x2=\"73.649\" y2=\"67.078\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"56.676\" y1=\"67.845\" x2=\"73.703\" y2=\"67.845\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"60.271\" y1=\"67.645\" x2=\"65.161\" y2=\"67.645\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"8.392\" y1=\"43.868\" x2=\"105.1\" y2=\"43.868\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"23.591\" y1=\"34.053\" x2=\"36.017\" y2=\"34.053\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"34.437\" y1=\"38.696\" x2=\"64.518\" y2=\"38.696\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"27.019\" y1=\"63.117\" x2=\"53.622\" y2=\"63.117\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"13.369\" y1=\"48.118\" x2=\"25.929\" y2=\"48.118\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"-7.679\" y1=\"55.178\" x2=\"56.077\" y2=\"55.017\" xlink:href=\"#h\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"Q\" x1=\"1.137\" y1=\"55.602\" x2=\"35.415\" y2=\"55.602\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"R\" x1=\"22.495\" y1=\"71.476\" x2=\"86.26\" y2=\"71.314\" xlink:href=\"#h\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"S\" x1=\"25.642\" y1=\"71.9\" x2=\"73.741\" y2=\"71.9\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"T\" x1=\"12.868\" y1=\"51.895\" x2=\"63.067\" y2=\"51.895\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"U\" x1=\".08\" y1=\"43.317\" x2=\"36.21\" y2=\"43.317\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"V\" x1=\"1.815\" y1=\"53.314\" x2=\"41.711\" y2=\"53.314\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"W\" x1=\"36.391\" y1=\"71.115\" x2=\"49.793\" y2=\"71.115\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"X\" x1=\"3.646\" y1=\"56.81\" x2=\"32.179\" y2=\"56.81\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Y\" x1=\"19.289\" y1=\"60.21\" x2=\"49.371\" y2=\"60.21\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Z\" x1=\"-17.452\" y1=\"52.666\" x2=\"45.729\" y2=\"52.666\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"a\" x1=\"34.436\" y1=\"72.381\" x2=\"56.629\" y2=\"72.277\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"b\" x1=\".712\" y1=\"58.335\" x2=\"52.975\" y2=\"58.335\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"c\" x1=\"32.322\" y1=\"53.581\" x2=\"40.566\" y2=\"53.581\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".907\" stop-color=\"#903fca\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"d\" x1=\"19.366\" y1=\"50.59\" x2=\"36.805\" y2=\"50.59\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"e\" x1=\"32.94\" y1=\"43.473\" x2=\"52.683\" y2=\"43.473\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"f\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"g\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"h\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgSmartphoneGear = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#Y)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M65.983 33.721c.001-.381-.535-.691-1.198-.693s-1.201.306-1.202.687.535.692 1.198.693 1.201-.306 1.202-.687z\" fill=\"#fff\"/><path d=\"M88.41 44.57c1.51.87 1.52 2.29.02 3.16L38.24 76.9c-1.5.87-3.95.87-5.46 0l-20.9-12.07c-1.51-.87-1.52-2.29-.02-3.16l50.18-29.16c1.5-.87 3.95-.87 5.46 0l20.91 12.06zM63.94 34.21c.47.27 1.23.27 1.69 0 .47-.27.46-.71-.01-.98s-1.23-.27-1.69 0-.46.71.01.98z\" fill=\"url(#A)\"/><path d=\"M91.43 46.27c0 .03 0 .06-.01.09 0 .03-.01.05-.01.08s-.01.06-.01.09-.01.05-.02.08-.01.06-.02.08c-.01.03-.01.05-.02.08l-.03.08c-.01.02-.02.05-.03.07-.01.03-.02.06-.04.09-.01.02-.02.05-.03.07-.01.03-.03.06-.04.09-.01.02-.03.05-.04.07l-.06.1c-.01.02-.03.04-.04.06l-.08.11c-.01.02-.03.03-.04.05-.01.01-.01.02-.02.02l-.09.11-.03.03-.12.12-.02.02c-.03.03-.07.06-.1.09-.03.02-.05.05-.08.07a.5.5 0 0 0-.08.07c-.03.02-.06.05-.09.07l-.09.06c-.03.02-.06.05-.1.07l-.09.06c-.03.02-.07.04-.1.07-.04.03-.09.05-.13.08L39.58 77.67l-.26.14c-.03.01-.05.03-.08.04l-.21.1c-.02.01-.05.02-.07.03l-.29.12c-.02.01-.03.01-.05.02l-.25.09-.1.03c-.05.01-.09.03-.14.04l-.12.03c-.05.01-.1.03-.14.04l-.12.03-.15.03-.12.03-.15.03c-.04.01-.08.01-.12.02l-.33.05c-.02 0-.03 0-.05.01l-.29.03c-.04 0-.07.01-.11.01-.06.01-.12.01-.18.02-.04 0-.08.01-.12.01-.06 0-.13.01-.19.01h-.11-.17-.12-.18-.11c-.05 0-.11 0-.16-.01-.04 0-.08 0-.12-.01-.06 0-.12-.01-.18-.01-.03 0-.07 0-.1-.01l-.21-.02c-.02 0-.04 0-.07-.01l-.27-.03c-.02 0-.03-.01-.05-.01l-.23-.04c-.03-.01-.06-.01-.1-.02l-.18-.03c-.03-.01-.06-.01-.09-.02-.07-.01-.13-.03-.19-.04l-.11-.03-.17-.05-.1-.03-.27-.08c-.02-.01-.03-.01-.05-.02-.1-.03-.2-.07-.3-.11-.04-.02-.08-.03-.12-.05-.03-.01-.06-.03-.1-.04l-.13-.06c-.03-.01-.06-.03-.09-.04-.05-.02-.1-.05-.14-.07-.02-.01-.05-.02-.07-.04l-.21-.11-20.9-12.06c-.42-.25-.77-.52-1.04-.81-.086-.095-.166-.195-.24-.3-.04-.05-.07-.1-.1-.15-.06-.1-.11-.21-.16-.31l-.11-.32c-.04-.16-.06-.32-.06-.48l-.01 2.68c0 .86.56 1.72 1.7 2.37l20.9 12.07.21.11c.02.01.05.02.07.04.05.02.09.05.14.07.03.01.06.03.09.04l.13.06c.03.01.06.03.1.04.03.01.06.03.09.04.01 0 .02.01.03.01l.3.11c.02.01.03.01.05.02l.27.08c.02 0 .03.01.05.01.02.01.04.01.05.01l.17.05.11.03c.06.02.13.03.19.04.02.01.05.01.07.02h.02l.18.03c.03.01.06.01.1.02l.24.04c.01 0 .03 0 .04.01l.27.03c.02 0 .04 0 .07.01l.21.02a.41.41 0 0 1 .11.01c.06 0 .12.01.18.01.04 0 .08 0 .11.01.05 0 .11.01.16.01h.1.18.12.17.03.08c.06 0 .13-.01.19-.01.04 0 .08-.01.12-.01.06 0 .12-.01.18-.02.02 0 .04 0 .07-.01.02 0 .03 0 .04-.01l.29-.03c.02 0 .03 0 .05-.01l.33-.05c.01 0 .02 0 .03-.01.03-.01.06-.01.09-.02l.15-.03.12-.03.15-.03.12-.03c.05-.01.1-.03.14-.04l.12-.03c.05-.01.09-.03.14-.04.02-.01.04-.01.06-.02.01-.01.03-.01.04-.02l.25-.09c.02-.01.03-.01.05-.02l.29-.12c.02-.01.05-.02.07-.03l.21-.1c.03-.01.05-.03.08-.04l.26-.14 50.18-29.16c.02-.01.05-.03.07-.04s.04-.03.06-.04a.36.36 0 0 0 .1-.07l.09-.06.1-.07.09-.06c.03-.02.06-.05.09-.07s.05-.04.08-.07a.57.57 0 0 0 .08-.07l.03-.03c.02-.02.04-.04.07-.06.01-.01.02-.01.02-.02l.12-.12.03-.03.09-.11c.01-.01.01-.02.02-.02.02-.02.03-.04.04-.05.03-.04.06-.07.08-.11.01-.02.03-.04.04-.06l.06-.1c.01-.01.01-.02.02-.03s.01-.03.02-.04c.02-.03.03-.06.04-.09.01-.02.02-.05.03-.07.01-.03.03-.06.04-.09.01-.01.01-.03.02-.04 0-.01.01-.02.01-.04l.03-.08c.01-.03.02-.05.02-.08.01-.03.01-.06.02-.08 0-.02.01-.03.01-.05 0-.01 0-.02.01-.03.01-.03.01-.06.01-.09s.01-.05.01-.08 0-.06.01-.09v-.05-.05l.01-2.68c.04.07.03.1.03.13z\" fill=\"url(#B)\"/><path d=\"M89.74 43.8c2.25 1.3 2.26 3.41.03 4.71L39.58 77.67c-2.24 1.3-5.88 1.3-8.13 0L10.55 65.6c-2.25-1.3-2.26-3.41-.03-4.71L60.7 31.73c2.24-1.3 5.88-1.3 8.13 0L89.74 43.8zm-51.5 33.1l50.18-29.16c1.5-.87 1.49-2.29-.02-3.16L67.5 32.51c-1.51-.87-3.96-.87-5.46 0L11.87 61.67c-1.5.87-1.49 2.29.02 3.16l20.9 12.07c1.5.87 3.95.87 5.45 0z\" fill=\"url(#C)\"/><path d=\"M22.53 73.36c.29.17.52.57.52.91 0 .33-.24.47-.53.3l-2.64-1.52c-.29-.17-.52-.57-.52-.91 0-.33.24-.47.53-.3l2.64 1.52z\" fill=\"#8334c2\"/><path d=\"M74.87 58.76c.01 0 .02-.01.03-.01h.04.03.03.03c.02 0 .02 0 .03.01.02 0 .03.01.03.01l-.37-.22c-.01 0-.01-.01-.02-.01h-.02-.02-.03-.03-.02-.03-.02c-.01 0-.02.01-.03.01h-.02c-.02.01-.03.01-.05.02l-2.66 1.53c-.02.01-.05.03-.07.05l-.02.02-.03.03-.02.02c0 .01-.01.01-.01.02-.01.01-.02.02-.03.04l-.02.02c-.02.02-.02.03-.03.04s-.01.02-.02.03-.01.02-.01.03c-.01.01-.01.02-.02.03 0 .01-.01.02-.01.03-.01.01-.01.02-.01.03s-.01.02-.01.03 0 .01-.01.02c0 .03-.01.05-.01.06v.03c0 .04-.01.07 0 .09 0 .09.02.15.06.2l.04.04.37.22c-.07-.04-.11-.12-.11-.23 0-.03 0-.06.01-.08 0-.04.01-.06.02-.09l.03-.1c.01-.03.03-.06.04-.09l.05-.08c.03-.03.04-.05.06-.07a.22.22 0 0 1 .06-.05l.02-.02c.02-.02.05-.03.07-.05l2.66-1.53c.02-.01.03-.02.05-.02v-.01z\" fill=\"url(#D)\"/><path d=\"M74.81 58.79c.2-.12.37-.02.37.21s-.16.52-.37.63l-2.66 1.53c-.2.12-.37.02-.37-.21s.16-.52.37-.63l2.66-1.53z\" fill=\"url(#E)\"/><path d=\"M83.42 53.82c.01 0 .02-.01.03-.01h.04.03.03.03c.02 0 .02 0 .03.01.02 0 .03.01.03.01l-.37-.22c-.01 0-.01-.01-.02-.01h-.02-.02-.03-.03-.02-.03-.02c-.01 0-.02.01-.03.01h-.02c-.02.01-.03.01-.05.02l-3.02 1.74-3.02 1.74c-.02.01-.05.03-.07.05l-.02.02-.03.03-.02.02c0 .01-.01.01-.01.02-.01.01-.02.02-.03.04l-.02.02c-.02.02-.02.03-.03.04s-.01.02-.02.03-.01.02-.01.03c-.01.01-.01.02-.02.03 0 .01-.01.02-.01.03-.01.01-.01.02-.01.03s-.01.02-.01.03 0 .01-.01.02c0 .03-.01.05-.01.06v.03c0 .04-.01.07 0 .09 0 .12.04.2.11.23l.37.22c-.07-.04-.11-.12-.11-.23 0-.03 0-.06.01-.08 0-.04.01-.06.02-.09l.03-.1c.01-.03.03-.06.04-.09l.05-.08c.03-.03.04-.05.06-.07a.22.22 0 0 1 .06-.05l.02-.02c.02-.02.05-.03.07-.05l3.02-1.74 3.02-1.74c.02-.01.03-.02.05-.02h-.01z\" fill=\"url(#F)\"/><path d=\"M83.36 53.85c.2-.12.37-.02.37.21s-.16.52-.37.63l-3.02 1.74-3.02 1.74c-.2.12-.37.02-.37-.21s.16-.52.37-.63l3.02-1.74 3.02-1.74z\" fill=\"url(#G)\"/><path d=\"M36.95 26.39c-.05 0-.09.01-.13.02-.05.01-.1.02-.15.04-.06.02-.12.05-.17.08l-4.23 2.46c.13-.08.28-.12.45-.14l.88-.08 4.23-2.46-.88.08z\" fill=\"url(#H)\"/><path d=\"M47.4 45.93v1.16c0 .17-.02.32-.04.46a1.99 1.99 0 0 1-.12.39.69.69 0 0 1-.13.2c-.09.13-.2.24-.33.32L51 46a1.25 1.25 0 0 0 .33-.32c.01-.02.03-.02.04-.04.03-.05.06-.09.08-.15l.05-.13c.01-.04.03-.07.04-.11l.03-.11c0-.02.01-.03.01-.05 0-.03.01-.04.01-.05.01-.03.01-.07.02-.1 0-.03.01-.07.01-.1s0-.07.01-.1v-.1-1.17l-4.23 2.46z\" fill=\"url(#I)\"/><path d=\"M51.17 37.64c-.13.077-.267.141-.41.19-.11.04-.22.07-.33.09-.02 0-.04.01-.06.02-.13.03-.26.04-.4.05h-.08c-.13 0-.27 0-.4-.01-.02 0-.03 0-.05-.01-.14-.01-.29-.04-.44-.07-.02 0-.03-.01-.05-.01-.15-.03-.31-.08-.47-.13-.01 0-.02-.01-.03-.01l-.51-.2c-.01-.01-.02-.01-.04-.02l-.53-.27c-.36-.21-.72-.46-1.06-.74-.01-.01-.02-.01-.03-.02-.34-.28-.66-.58-.98-.91l-.02-.02c-.32-.34-.62-.7-.9-1.08s-.54-.78-.78-1.19c-.01-.02-.02-.03-.03-.05L42.94 32c-.194-.428-.358-.869-.49-1.32-.13-.46-.24-.9-.3-1.34-.07-.44-.11-.87-.1-1.3 0-.2.01-.4.03-.58 0-.02 0-.03.01-.05l.07-.5c0-.02.01-.04.01-.06l.11-.44.03-.08a2.5 2.5 0 0 1 .15-.38c.01-.01.01-.03.02-.04.06-.14.14-.26.21-.38.107-.166.231-.32.37-.46l.1-.1a2.42 2.42 0 0 1 .45-.34l-4.23 2.46a2.42 2.42 0 0 0-.45.34c-.03.03-.07.06-.1.1-.13.14-.26.29-.37.46-.078.119-.148.243-.21.37-.02.02-.02.04-.03.05-.039.081-.073.164-.1.25-.02.04-.03.09-.04.13l-.03.08c-.01.02-.02.05-.02.07-.03.09-.05.18-.07.27-.01.03-.01.07-.02.1 0 .02-.01.04-.01.06-.01.03-.01.06-.02.1l-.04.25c-.01.05-.01.1-.02.14 0 .02 0 .03-.01.05 0 .02 0 .04-.01.06l-.02.25-.01.26v.26l.01.26.02.26.03.26.04.27v.02l.04.25.06.28.06.28.07.28.07.22c0 .01 0 .01.01.02 0 .01.01.03.01.04l.09.28.09.27.1.26.1.26.09.2c.02.02.02.04.03.05l.12.26.14.28.16.32c.06.12.13.24.2.35.01.02.02.03.03.05s.02.04.03.05l.41.65.34.48.23.31.21.25.21.24.21.23c.01.02.03.03.04.05l.02.02a1.21 1.21 0 0 0 .16.16c.07.08.15.15.22.22l.23.22.24.21c.04.03.08.07.12.1.01.01.02.01.03.02.03.02.06.05.09.07l.23.18.23.16.23.15c.07.05.15.09.23.14.02.01.03.02.05.03l.17.09c.07.04.15.08.22.11.05.02.09.04.14.07.01.01.02.01.03.02s.03.01.04.02l.21.09c.07.03.14.06.22.08.01 0 .02.01.04.01.01 0 .02.01.03.01.05.02.1.03.15.05l.22.06c.03.01.07.02.1.02.02 0 .03.01.05.01s.05.01.07.02c.08.02.16.03.23.04.046.008.093.012.14.01h.05c.017-.002.035.002.05.01a2.11 2.11 0 0 0 .25.01c.04 0 .07 0 .11-.01h.08.09l.31-.04c.02 0 .04-.01.06-.02.1-.02.21-.05.3-.08.01 0 .01-.01.02-.01.143-.049.28-.113.41-.19l4.25-2.44z\" fill=\"url(#J)\"/><path d=\"M41.24 17.82c-.02-.02-.04-.04-.05-.07-.03-.03-.05-.06-.08-.09s-.06-.06-.08-.09l-.09-.09-.09-.09-.09-.09c-.01-.01-.02-.02-.03-.02-.03-.03-.05-.04-.07-.06-.03-.03-.06-.05-.09-.08-.03-.02-.06-.05-.09-.07l-.09-.06-.09-.06c-.03-.02-.06-.04-.09-.05-.01 0-.01-.01-.02-.01-.02-.01-.04-.03-.07-.04-.03-.02-.06-.03-.09-.04s-.06-.03-.09-.04-.06-.03-.09-.04l-.09-.03c-.04-.01-.06-.02-.09-.03s-.06-.02-.09-.02c-.03-.01-.06-.01-.09-.02s-.06-.01-.09-.02h-.04-.05-.1c-.04 0-.07 0-.11.01-.04 0-.07.01-.11.02a.71.71 0 0 0-.17.04c-.06.02-.12.05-.18.08l-4.23 2.46c.1-.06.21-.1.33-.12.13-.02.25-.03.37-.01.14.01.27.04.4.09.14.05.28.11.42.19.18.1.36.23.54.39a5.53 5.53 0 0 1 .53.55l.87 1.08 4.23-2.46-.86-1.11z\" fill=\"url(#K)\"/><path d=\"M43.16 18.82h-.11l-.27.01c-.06 0-.12 0-.18.01h-.03a3.39 3.39 0 0 0-.46.06l-4.23 2.46.49-.07c.06-.01.12-.01.18-.01.12-.01.25-.01.38-.01l4.23-2.45z\" fill=\"url(#L)\"/><path d=\"M58.89 41.09v-.08c0-.05 0-.09-.01-.12 0-.03-.01-.07-.01-.11s-.01-.07-.02-.11-.01-.07-.02-.11c0-.02-.01-.04-.01-.05 0-.03-.01-.04-.01-.06l-.03-.11-.03-.11-.03-.11c-.01-.04-.02-.07-.04-.11 0-.01 0-.01-.01-.02l-.03-.1c-.01-.03-.03-.07-.04-.1s-.03-.07-.04-.1-.03-.07-.04-.1c-.02-.03-.03-.07-.05-.1 0-.01-.01-.02-.01-.02-.01-.04-.03-.06-.04-.09l-.06-.12-.1-.19-.06-.09c-.01-.02-.03-.05-.04-.07-.02-.04-.04-.07-.07-.11l-.13-.18-.09-.12c-.01-.02-.03-.03-.04-.05l-.87-1.09-4.23 2.46.87 1.09c.12.15.23.3.33.46.02.02.03.05.04.07a5.65 5.65 0 0 1 .26.48l.21.53c.059.17.106.343.14.52l.07.5c.01.17.01.32-.01.47s-.05.29-.09.42c-.04.14-.1.25-.18.36l-2.14 3.01c-.09.13-.21.24-.33.31l4.23-2.46c.13-.07.24-.18.33-.31l2.14-3.01c.01-.02.02-.03.03-.05.03-.05.06-.1.08-.15.02-.04.04-.08.05-.13 0-.01.01-.02.01-.03.01-.04.02-.06.03-.09a1.64 1.64 0 0 0 .03-.11c.01-.03.01-.07.02-.1s.01-.07.02-.1v-.02c0-.04.01-.06.01-.09s0-.07.01-.1v-.1-.1z\" fill=\"url(#M)\"/><path d=\"M56.98 36.52l-.03-.54-4.23 2.46.03.71-.03.66 4.23-2.46.03-.48v-.18c.01-.06.01-.12 0-.17z\" fill=\"url(#N)\"/><path d=\"M52.71 25.02l-.33-.43-.34-.42-.35-.42-4.23 2.46 1.05 1.29 4.23-2.46c-.02-.01-.02-.02-.03-.02z\" fill=\"url(#O)\"/><path d=\"M51.69 22.49v-.1c0-.03 0-.07-.01-.1 0-.03-.01-.07-.01-.1 0-.04-.01-.07-.02-.11-.01-.03-.01-.07-.02-.1-.01-.04-.01-.07-.02-.11l-.03-.11-.03-.11-.03-.09v-.03c-.01-.04-.02-.07-.04-.11-.01-.04-.02-.07-.04-.11-.01-.03-.03-.07-.04-.1s-.03-.07-.04-.1l-.03-.08c0-.02 0-.02-.01-.03-.02-.03-.03-.07-.05-.1-.02-.04-.04-.07-.05-.11l-.07-.13-.08-.14c0-.01-.01-.01-.01-.02s-.01-.01-.01-.02l-.16-.26-.13-.19-.09-.12c-.03-.03-.05-.07-.08-.1s-.05-.06-.08-.1c-.03-.03-.05-.06-.08-.09l-.02-.02-.07-.07-.09-.09-.09-.09c-.03-.03-.06-.06-.1-.08-.02-.01-.03-.03-.05-.04l-.04-.04c-.03-.02-.06-.05-.09-.07s-.062-.044-.09-.07l-.09-.06-.09-.06c-.01 0-.01-.01-.02-.01l-4.26-2.46c-.02-.01-.05-.03-.07-.04-.03-.02-.06-.03-.09-.05-.03-.01-.06-.03-.09-.04s-.06-.03-.09-.04l-.09-.03c-.01 0-.01 0-.02-.01-.03-.01-.05-.01-.07-.02-.03-.01-.06-.02-.09-.02-.03-.01-.06-.01-.09-.02s-.06-.01-.09-.02c-.02 0-.04 0-.06-.01h-.03-.1c-.04 0-.07 0-.11.01a.5.5 0 0 0-.12.02c-.05.01-.1.02-.14.04-.06.02-.12.05-.17.08l-4.23 2.46c.1-.06.2-.1.32-.12s.24-.029.36-.02c.14.01.27.04.4.09.15.05.29.11.44.2l4.26 2.46a2.94 2.94 0 0 1 .43.29c.15.12.28.24.4.37.14.14.26.29.37.44a7.63 7.63 0 0 1 .31.47c0 .01.01.01.01.02l.25.5c.077.168.14.342.19.52l.12.54c.03.18.04.35.04.52v1.16l4.23-2.46v-1.16c-.02-.04-.02-.07-.02-.1z\" fill=\"url(#P)\"/><path d=\"M58.91 34.34v-.04-.1c0-.03 0-.07-.01-.1 0-.03-.01-.07-.01-.1 0-.02-.01-.04-.01-.07v-.04c-.01-.04-.01-.07-.02-.11s-.01-.07-.02-.11l-.03-.11c-.01-.03-.01-.05-.02-.08 0-.02 0-.03-.01-.04l-.03-.11c-.01-.04-.02-.07-.04-.11-.01-.04-.02-.07-.04-.11-.01-.03-.03-.07-.04-.1l-2.12-5.48c-.01-.04-.03-.08-.04-.11s-.03-.07-.04-.1c-.02-.03-.03-.07-.05-.1l-.05-.11-.06-.12c-.03-.06-.06-.11-.1-.17v-.02l-.18-.28-.12-.17-.09-.12c-.02-.02-.03-.04-.05-.06l-.04-.04c-.03-.03-.05-.06-.08-.1-.03-.03-.06-.06-.08-.09l-.09-.09-.09-.09a.89.89 0 0 0-.1-.09l-.03-.03c-.03-.03-.05-.04-.07-.06-.03-.03-.06-.05-.1-.08-.03-.02-.06-.05-.09-.07s-.06-.04-.09-.07l-.09-.06c-.03-.02-.06-.04-.09-.05-.01 0-.01-.01-.02-.01-.02-.01-.04-.03-.07-.04-.03-.02-.06-.03-.09-.04s-.06-.03-.09-.04-.06-.02-.08-.04l-.08-.03-.09-.03c-.01 0-.03-.01-.04-.01-.02 0-.03-.01-.05-.01-.03-.01-.06-.01-.09-.02s-.06-.01-.09-.02c-.03 0-.06-.01-.09-.01h-.1-.11l-.87.08-4.23 2.46.87-.08c.17-.01.34 0 .52.05a2.38 2.38 0 0 1 .55.23c.18.11.36.24.54.39.18.16.35.34.51.53.17.2.31.42.45.64.14.24.26.48.36.73l2.12 5.48.15.46.09.44c.02.15.03.28.03.41 0 .14 0 .26-.02.38-.015.115-.039.228-.07.34 0 .01 0 .01-.01.02-.031.089-.067.176-.11.26-.01.01-.01.03-.02.04-.01.03-.03.04-.05.07-.09.14-.2.25-.34.33l4.23-2.46c.14-.08.25-.2.34-.33l.03-.03c.01-.01.01-.03.02-.04s.01-.02.02-.04.03-.04.04-.07c.02-.04.04-.08.05-.13.01-.02.02-.05.02-.07 0-.01 0-.01.01-.02 0-.01.01-.02.01-.03l.03-.11a.36.36 0 0 0 .02-.11c0-.03.01-.06.01-.09 0-.05.01-.09.01-.12s0-.07.01-.1v-.1c-.01.02-.01 0-.01-.02z\" fill=\"url(#Q)\"/><path d=\"M53.6 40.9c1.02 1.26 1.37 2.96.78 3.8l-2.14 3.01c-.4.56-1.11.58-1.85.16-.36-.21-.73-.53-1.06-.94l-.87-1.07c-.33.06-.68.08-1.05.08v1.16c0 1.35-.96 1.9-2.14 1.22L41 45.85c-1.18-.68-2.13-2.33-2.13-3.68v-1.16l-1.05-1.29-.87.07c-.34.03-.7-.08-1.06-.28-.73-.42-1.45-1.27-1.84-2.29l-2.11-5.47c-.59-1.52-.24-2.81.79-2.9l.88-.08-.03-.7.03-.67-.87-1.08c-1.02-1.26-1.37-2.97-.77-3.8l2.14-3.02c.4-.55 1.12-.58 1.86-.15.36.21.72.52 1.06.94l.87 1.08c.33-.07.68-.09 1.05-.09v-1.16c0-1.35.96-1.89 2.14-1.21l4.26 2.46c1.18.68 2.13 2.32 2.13 3.67v1.16l1.05 1.29.87-.08c.33-.03.7.08 1.06.28.74.43 1.46 1.28 1.85 2.29l2.12 5.48c.58 1.51.23 2.81-.79 2.89l-.88.07.03.71-.03.66.84 1.11zm-10.45-1.17c2.94 1.7 5.33.34 5.34-3.04s-2.36-7.5-5.31-9.2c-2.94-1.7-5.34-.33-5.35 3.05 0 3.37 2.38 7.49 5.32 9.19z\" fill=\"url(#R)\"/><path d=\"M81.88 65.2a.38.38 0 0 0-.06.05c-.03.02-.05.04-.07.05l-.08.08c0 .01-.01.01-.01.02s-.01.01-.01.02c-.01.01-.01.02-.02.03l-.03.06v.02c0 .01-.01.03-.01.04 0 .02-.01.04-.01.06v1.57c0-.04.01-.07.02-.11a.37.37 0 0 1 .05-.11c0-.01.01-.01.01-.02.02-.03.05-.06.08-.09.02-.02.05-.04.07-.05.02-.02.04-.03.07-.05l3.43-1.99v-1.56l-3.43 1.98z\" fill=\"url(#S)\"/><path d=\"M77.97 68.01v-1.56c0 .4.11.78.32 1.14v1.56c-.21-.37-.33-.75-.32-1.14z\" fill=\"url(#T)\"/><path d=\"M78.29 67.58v1.56c-.21-.36-.33-.74-.32-1.14v-1.56c0 .4.11.78.32 1.14z\" fill=\"url(#T)\"/><path d=\"M89.57 66.85l-.03.12c-.02.07-.03.13-.06.2-.01.04-.03.07-.04.11l-.09.19-.06.1-.15.23c-.02.03-.04.05-.06.08-.09.12-.2.23-.32.34-.03.03-.06.05-.09.08l-.22.18-.11.09-.28.18c-.03.02-.05.04-.08.05-.18.11-.38.21-.58.3-.03.01-.06.03-.09.04-.2.09-.41.17-.63.24l-.1.03c-.32.1-.66.19-1.02.25l-.65.09-.33.03-.57.02h-.27c-.13 0-.26 0-.39-.01-.08 0-.16-.01-.25-.01l-.4-.04-.22-.03-.58-.09v1.56l.51.09a.17.17 0 0 1 .07.01l.22.03.28.03c.04 0 .08 0 .12.01.083.009.166.012.25.01l.22.01h.18.28.17c.13 0 .27-.01.4-.02l.25-.02c.03 0 .05-.01.08-.01l.63-.09h.02l1.02-.25c.01 0 .03-.01.04-.01.02-.01.04-.02.06-.02.22-.07.43-.15.64-.24.03-.01.06-.03.09-.04.2-.09.4-.19.58-.3 0 0 .01-.01.02-.01.02-.01.04-.03.07-.04a2.75 2.75 0 0 0 .28-.19c.04-.03.07-.06.11-.08l.22-.18c.02-.02.04-.04.06-.05l.03-.03c.12-.11.22-.22.32-.34l.02-.02c.01-.02.03-.04.04-.06.06-.08.11-.15.15-.23.01-.02.03-.04.04-.06s.01-.03.02-.05l.09-.19c.01-.03.03-.05.04-.08 0-.01.01-.02.01-.03l.06-.2c.01-.03.02-.05.02-.08 0-.01 0-.02.01-.03.02-.11.03-.22.04-.33v-.05-1.56c-.06.11-.07.24-.09.37z\" fill=\"url(#U)\"/><path d=\"M68.69 75.23c-.05-.03-.11-.06-.17-.08a.88.88 0 0 0-.15-.05c-.02-.01-.05-.01-.07-.02-.03 0-.04-.01-.06-.01-.04-.01-.08-.02-.12-.02-.04-.01-.08-.01-.12-.01s-.08-.01-.12-.01h-.05-.08c-.04 0-.09 0-.13.01-.05.01-.1.01-.15.02-.02 0-.04.01-.07.02-.02 0-.04.01-.06.01l-.1.03c-.1.03-.19.07-.27.12-.03.02-.05.04-.07.05-.03.02-.06.04-.08.06-.04.04-.06.06-.08.09 0 .01-.01.01-.01.02s-.01.01-.01.02c-.01.01-.02.02-.02.03-.01.02-.02.05-.03.07v.02c0 .01-.01.03-.01.04 0 .02-.01.05-.01.07v1.57a.5.5 0 0 1 .02-.12c.01-.05.03-.09.06-.12 0-.01.01-.01.01-.02.03-.04.06-.07.1-.11.02-.02.06-.04.08-.06.03-.02.05-.04.08-.05a1.49 1.49 0 0 1 .37-.14c.02 0 .04-.01.06-.01a1.93 1.93 0 0 1 .42-.05c.155 0 .309.017.46.05.16.03.3.08.41.15.18.1.29.23.33.36.01.04.02.09.02.13v-1.56c-.02-.18-.14-.36-.38-.5z\" fill=\"url(#V)\"/><path d=\"M69.62 76.76c-.15.09-.32.16-.5.22l-.18.06c-.08.02-.17.05-.25.06l-.31.05c-.03 0-.05.01-.07.01-.14.02-.28.02-.42.02h-.07c-.14 0-.28-.01-.42-.02-.02 0-.04 0-.06-.01l-.41-.07c-.02-.01-.05-.01-.07-.02-.118-.031-.235-.067-.35-.11-.02-.01-.04-.01-.06-.02-.14-.05-.26-.11-.38-.18-.49-.28-.74-.66-.74-1.03v1.54c0 .39.25.77.74 1.05.11.07.24.12.36.17.01 0 .01 0 .02.01.02.01.04.01.06.02.07.03.15.05.22.08l.13.03c.02.01.05.01.07.02.02 0 .04.01.07.02.08.02.17.03.25.04.03 0 .06.01.09.01.02 0 .04 0 .06.01.03 0 .06.01.09.01a2.11 2.11 0 0 0 .25.01h.08.07.11c.09 0 .19-.01.28-.02h.03c.03 0 .05-.01.07-.01l.22-.03c.03-.01.06-.02.09-.02l.25-.06.13-.03c.02-.01.04-.02.06-.02.18-.06.35-.13.5-.22l12.25-7.12v-1.56l-12.26 7.11z\" fill=\"url(#W)\"/><path d=\"M89.57 66.85c-.28 1.51-2.39 2.77-5 2.95-.9.07-1.805.016-2.69-.16l-12.25 7.12c-.98.57-2.58.57-3.57 0-.49-.28-.74-.66-.74-1.03-.01-.38.25-.75.73-1.04l12.25-7.12c-.29-.48-.39-1.01-.28-1.56.32-1.51 2.47-2.74 5.08-2.91.79-.05 1.53-.01 2.22.1l-3.43 1.99c-.41.24-.41.63 0 .87l2.57 1.49c.41.24 1.09.24 1.5 0l3.43-1.99c.19.4.27.83.18 1.29zm-22.59 9.37a1.91 1.91 0 0 0 1.71 0c.47-.28.47-.72 0-.99a1.91 1.91 0 0 0-1.71 0c-.47.28-.47.72 0 .99z\" fill=\"url(#X)\"/></g><defs><linearGradient id=\"A\" x1=\"-10.53\" y1=\"54.704\" x2=\"254.163\" y2=\"54.704\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"-90.875\" y1=\"63.751\" x2=\"105.926\" y2=\"63.751\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"-34.512\" y1=\"54.703\" x2=\"156.783\" y2=\"54.703\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"70.034\" y1=\"59.854\" x2=\"80.862\" y2=\"59.854\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"63.533\" y1=\"59.974\" x2=\"83.642\" y2=\"59.974\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"71.191\" y1=\"55.895\" x2=\"105.618\" y2=\"55.895\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"69.031\" y1=\"56.016\" x2=\"92.806\" y2=\"56.016\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"28.965\" y1=\"27.65\" x2=\"39.684\" y2=\"27.65\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"37.543\" y1=\"45.962\" x2=\"55.071\" y2=\"45.962\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".172\" stop-color=\"#ede0f7\"/><stop offset=\".549\" stop-color=\"#bf91e1\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"14.222\" y1=\"32.556\" x2=\"56.855\" y2=\"32.556\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"26.501\" y1=\"18.978\" x2=\"48.702\" y2=\"18.978\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"28.866\" y1=\"20.092\" x2=\"44.207\" y2=\"20.092\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"32.923\" y1=\"42.685\" x2=\"62.651\" y2=\"42.685\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".172\" stop-color=\"#ede0f7\"/><stop offset=\".549\" stop-color=\"#bf91e1\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"27.149\" y1=\"37.894\" x2=\"60.467\" y2=\"37.894\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".172\" stop-color=\"#ede0f7\"/><stop offset=\".549\" stop-color=\"#bf91e1\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"29.892\" y1=\"25.618\" x2=\"56.357\" y2=\"25.618\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".172\" stop-color=\"#ede0f7\"/><stop offset=\".549\" stop-color=\"#bf91e1\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"26.468\" y1=\"21.177\" x2=\"59.348\" y2=\"21.177\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".172\" stop-color=\"#ede0f7\"/><stop offset=\".549\" stop-color=\"#bf91e1\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"30.892\" y1=\"31.588\" x2=\"62.222\" y2=\"31.588\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".172\" stop-color=\"#ede0f7\"/><stop offset=\".549\" stop-color=\"#bf91e1\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"R\" x1=\"19.019\" y1=\"33.606\" x2=\"72.812\" y2=\"33.606\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".14\" stop-color=\"#f2e8f9\"/><stop offset=\".435\" stop-color=\"#cface8\"/><stop offset=\".858\" stop-color=\"#984dce\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"S\" x1=\"67.534\" y1=\"65.206\" x2=\"86.361\" y2=\"65.206\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"T\" x1=\"77.671\" y1=\"67.791\" x2=\"79.062\" y2=\"67.791\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"U\" x1=\"63.506\" y1=\"68.929\" x2=\"90.199\" y2=\"68.929\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"V\" x1=\"65.511\" y1=\"76.16\" x2=\"71.082\" y2=\"76.16\" xlink:href=\"#Z\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"W\" x1=\"58.933\" y1=\"74.198\" x2=\"87.258\" y2=\"74.198\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"X\" x1=\"63.888\" y1=\"70.139\" x2=\"91.901\" y2=\"70.139\" xlink:href=\"#Z\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"Y\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"Z\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgSteeringWheel = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#M)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#dfd4fb\"/><path d=\"M66.93 31.15c-.078-.752-.194-1.5-.35-2.24-.48-2.6-1.35-4.98-2.62-7.04-1.56-2.61-3.69-4.59-6.31-5.8-.02-.01-.03-.01-.05-.02l-.63-.29c-.02-.01-.05-.02-.07-.03-3.16-1.37-6.64-1.56-10.18-.79a21.66 21.66 0 0 0-2.04.52c-.09.03-.17.05-.26.08l-.44.14c-.16.05-.31.11-.46.16l.13-.05-.52.19-.11.04c-.16.06-.33.12-.49.19l-.06.02c-.01.01-.03.01-.04.02l-.65.27a2.99 2.99 0 0 0-.36.16c-.38.16-.81.36-1.24.57-6.45 3.05-11.84 8.12-15.96 14.09-2.58 3.52-4.86 7.5-6.66 11.84 0 .01-.01.01-.01.02l-.49 1.19c-2.3 5.59-3.61 11.51-3.44 17.27l.04 1.09c0 .03 0 .07.01.1-.002.047.002.094.01.14v.08c.037.739.107 1.477.21 2.21.81 7.14 4.13 12.7 10.05 14.83.05.02.1.04.16.06.402.164.813.308 1.23.43.21.07.43.13.62.17.85.22 1.56.33 2.06.38.05.01.1.01.16.02l.26.03c.16.02.32.03.47.04.48.03.94.04 1.37.03.478.001.955-.026 1.43-.08l-.43.03c.17-.01.35-.03.51-.04.02 0 .05 0 .07-.01-.05.01-.1.01-.15.02.15-.01.29-.03.43-.04.1-.01.21-.02.31-.04.05-.01.09-.01.14-.02s.1-.01.15-.02l.61-.1c.04-.01.09-.01.13-.02.11-.02.22-.05.34-.07l.34-.06.89-.21c.31-.08.6-.16.89-.25.55-.16 1.13-.34 1.61-.52.2-.07.41-.15.63-.24l.53-.21c.31-.12.63-.27.97-.42.68-.31 1.44-.69 2.14-1.09.03-.02.06-.03.09-.05a29.95 29.95 0 0 0 1.75-1.04c1.49-.95 2.93-2.02 3.88-2.82.64-.52 1.24-1.04 1.75-1.51l.02-.01.02-.02c.01-.01.02-.02.04-.03.02-.02.05-.04.07-.06a37.21 37.21 0 0 0 .97-.91c.01-.01.01-.01.02-.01.42-.4.66-.65.67-.66l.04-.04.08-.08.02-.02.03-.03.08-.08c.03-.03.06-.07.1-.1l.03-.03c.9-.91 1.75-1.85 2.55-2.79.08-.1.17-.2.25-.29.23-.27.45-.55.68-.83l.59-.74c.07-.09.14-.17.2-.26.15-.19.29-.38.42-.56.94-1.26 1.9-2.65 2.85-4.18l.32-.52c.02-.02.88-1.39 2-3.56.01-.01.01-.02.02-.03.02-.04.04-.09.07-.13.04-.08.09-.17.13-.26l.06-.12c.05-.09.09-.18.14-.28.02-.04.04-.07.05-.11.04-.08.08-.16.12-.23.01-.02.02-.04.03-.05.01-.03.02-.05.03-.08l.45-.95a1.99 1.99 0 0 1 .1-.21c.01-.01.01-.02.02-.04.06-.14.12-.27.19-.41.13-.28.25-.55.35-.8 0-.01.01-.01.01-.02s.01-.02.01-.03c.03-.07.06-.15.1-.23.3-.71.6-1.45.89-2.22l.12-.3c.29-.76.61-1.71.83-2.45 0-.01.01-.03.01-.04.01-.03.02-.05.02-.08.01-.02.01-.05.02-.07a51.2 51.2 0 0 0 .65-2.3c.17-.61.34-1.36.48-2.04.05-.23.1-.47.14-.7v-.02a26.93 26.93 0 0 0 .28-1.58c.03-.18.06-.35.08-.53l.14-1.02c.04-.29.07-.58.1-.86a27.75 27.75 0 0 0 .15-2v-.1c.06-2.13-.03-3.87-.19-5.21zM30.47 81.26h.08.07c-.04-.01-.09 0-.15 0zm31.17-45.94v.05c0 .07 0 .13-.01.2l-.08 1.54-.06.68a25.61 25.61 0 0 1-.11 1l-.16 1.1-.16.92c-.01.03-.01.06-.02.09 0-.02.01-.05.01-.07l-.05.31-.23 1.09-.26 1.15c0 .02-.01.04-.01.06.18-.79.38-1.71.54-2.55-.99 4.94-2.89 10.14-5.58 15.02l-.45.79-.57.95-.16.25-.55.86-.83 1.23-1.6 2.19-.83 1.07c-.03.03-.05.06-.08.09l-1.27 1.49c-.08.09-.15.18-.22.26s-.15.16-.23.24l-1.36 1.44-.02.02-.48.46c-.8.75-1.75 1.61-2.56 2.31l-.85.68-.16.12c-1.58 1.21-3.17 2.24-4.74 3.06-1.03.52-2.07.98-3.11 1.35-.58.2-1.19.38-1.7.53-.49.11-1.12.23-1.67.32l-1.55.16h-.06-.32c-.284-.002-.567-.008-.85-.02h-.03c-.25-.02-.52-.05-.78-.08-.02 0-.05-.01-.08-.01-.1-.01-.19-.03-.29-.04-.01 0-.03 0-.04-.01l-.53-.11c-.81-.21-1.64-.53-2.53-.98-.01-.01-.03-.01-.04-.02l-.51-.33c-.22-.23-.44-.42-.7-.56-1.24-1.11-2.22-2.43-2.96-3.92l-.34-.78-.23-.6c-.4-1.21-.69-2.46-.88-3.75l-.02-.16c-.02-.14-.03-.28-.05-.41-.16-1.64-.18-3.3-.08-4.96.01-.1.01-.2.02-.31 0-.06.01-.11.01-.17l.02-.24.1-1c0-.01 0-.03.01-.05v-.02l.03-.26.16-1.1.22-1.26.22-1.03.25-1.11c.531-2.122 1.202-4.207 2.01-6.24l.11-.27c.21-.52.43-1.04.66-1.56l.58-1.27.33-.68.93-1.81c.03-.05.05-.1.08-.15l.49-.85 1.1-1.84.77-1.21.31-.47 1.1-1.56.09-.12c.08-.1.14-.19.21-.28l1.84-2.31.8-.93c.08-.09.15-.18.22-.26s.151-.163.23-.24l1.09-1.16.62-.63.93-.89.37-.35c.12-.1.24-.21.37-.32l.54-.46c2.16-1.81 4.53-3.4 7.1-4.69.65-.31 1.31-.58 1.96-.83 1.47-.51 2.96-.87 4.47-1.05 2.34-.16 4.47.24 6.29 1.16.01.01.02.01.03.02.04.03.08.05.13.08.01.01.02.01.03.02l.09.06a14.95 14.95 0 0 1 .64.44l.37.29c.04.03.08.07.12.1l.49.45.53.57c.05.06.11.14.18.23.24.31.5.67.72 1 .09.13.17.27.26.41.18.32.37.68.54 1.02l.39.9.26.69.09.29c.1.32.2.67.29.99l.24 1.06.12.57.12.87.02.17c.02.14.03.28.05.42a26.34 26.34 0 0 1 .14 3.45z\" fill=\"url(#A)\"/><path d=\"M62.13 46.52v-.15-.08-.04c0-.02-.01-.05-.01-.07 0-.01-.01-.03-.01-.04 0-.02-.01-.04-.02-.06 0-.01-.01-.03-.01-.04l-.03-.06c-.01-.01-.01-.02-.02-.03-.01-.02-.03-.04-.04-.05s-.01-.02-.02-.03c-.02-.02-.05-.04-.08-.06l-2.26-1.31c.03.02.06.04.08.06.01.01.01.02.02.03.01.02.03.03.04.05.01.01.01.02.02.03l.03.06c0 .01.01.03.01.04.01.02.01.04.02.06 0 .01.01.03.01.04 0 .02.01.05.01.07v.04.08.04c0 .04 0 .08-.01.11 0 .04-.01.08-.01.11v.03c0 .03-.01.05-.01.08 0 .01 0 .03-.01.04 0 .02-.01.04-.01.06 0 .01-.01.03-.01.04v.02c-.01.02-.01.04-.01.06 0 .03-.01.04-.01.05 0 .02-.01.03-.01.04 0 .02 0 .03-.01.03 0 .06-.05.15-.06.21l-.63 1.99c-.01.04-.03.08-.02.12.01.05.05.08.08.12a2.3 2.3 0 0 0 .54.33c.57.26 1.2.42 1.83.45.18-.43.32-.87.44-1.32.06-.37.16-.76.18-1.15z\" fill=\"url(#B)\"/><path d=\"M50.36 63.98l-.34-.13c-.02-.01-.05-.02-.07-.01-.03.01-.05.03-.07.05l-.45.48-.13.13-.06.06-.12.12c-.02.02-.04.03-.05.05l-.17.15-.16.13c-.02.01-.03.03-.05.04-.04.03-.07.05-.1.08-.02.01-.03.03-.05.04l-.1.07c-.01.01-.03.02-.04.03-.05.03-.09.06-.14.08l-.17.09c-.02.01-.03.02-.05.02a.61.61 0 0 1-.12.05c-.01 0-.02.01-.03.01-.05.02-.09.03-.13.04-.02 0-.04.01-.06.01-.03.01-.06.01-.09.02h-.05-.09-.03c-.04 0-.07-.01-.11-.01h-.02c-.03-.01-.06-.01-.08-.02-.01 0-.01 0-.02-.01-.03-.01-.06-.03-.09-.04l2.26 1.31c.03.01.06.03.08.04.02 0 .02.01.03.01s.02.01.04.01.03.01.05.01h.02c.04 0 .07.01.09.01h.04.05.04.05.03c.02 0 .04-.01.06-.01.44-.09.84-.3 1.2-.57.162-.12.312-.254.45-.4l.2-.21.28-.21c.05-.04.1-.08.14-.13a.27.27 0 0 0 .01-.32c-.04-.06-.09-.1-.14-.14-.52-.42-1.13-.69-1.74-.93z\" fill=\"url(#C)\"/><path d=\"M35.03 73.45c0-.04.01-.08.01-.12v-.04c0-.04.01-.08.01-.12v-.12-.03-.07-.09-.05-.04c-.48-4.61-1.5-6.66-2.65-8.71-.16-.28-.35-.48-.58-.61l-2.26-1.31a1.63 1.63 0 0 1 .58.61c1.14 2.05 2.17 4.1 2.65 8.71v.03.05.08.09.03.11c0 .05 0 .09-.01.13v.04c0 .04-.01.08-.01.12v.03c-.01.05-.01.1-.02.16v.03l-.03.18a1.09 1.09 0 0 1-.04.22c0 .01-.01.03-.01.04l-.06.27c0 .01-.01.03-.01.04l-.06.21c0 .01-.01.02-.01.04-.02.05-.03.1-.05.14-.01.02-.02.05-.03.07-.01.03-.02.06-.04.09l-.03.08c-.01.02-.02.05-.03.07-.01.03-.03.06-.04.09l-.03.06c-.02.03-.03.07-.05.1-.01.01-.02.03-.03.04l-.09.14c-.04.05-.07.1-.1.14-.01.02-.02.03-.04.05a.55.55 0 0 1-.07.09c-.02.03-.04.05-.06.08-.02.02-.04.04-.05.06a1.21 1.21 0 0 1-.16.16c-.024.026-.051.049-.08.07l-.06.06c-.03.02-.06.05-.09.07-.02.02-.04.03-.06.05-.03.03-.07.05-.11.08-.02.01-.03.03-.05.04-.05.04-.11.07-.17.11l-.16.09-.06.03c-.04.02-.08.04-.12.05-.02.01-.05.02-.07.03-.04.01-.07.03-.11.04-.44.16-.97.2-1.44.22.02 0 .1.1.12.12a1.74 1.74 0 0 1 .12.14l.23.3c.14.21.25.42.35.64.03.08.08.15.16.19.07.03.15.03.22.02l.49-.05c.15-.02.28-.01.43-.02.33-.01.66-.05.99-.11.04-.01.08-.01.11-.02s.06-.01.09-.02l.11-.03c.01 0 .02-.01.04-.01s.03-.01.05-.01c.04-.01.08-.02.12-.04l.08-.03c.04-.01.08-.03.11-.04.02-.01.03-.01.05-.02.01 0 .02-.01.02-.01.04-.02.08-.04.12-.05l.06-.03.16-.09c.06-.031.117-.068.17-.11.02-.01.04-.03.05-.04.04-.02.07-.05.11-.08.02-.02.04-.03.06-.05.03-.02.06-.05.09-.07l.06-.06c.02-.02.05-.04.07-.06l.17-.17c.02-.03.04-.04.05-.06.02-.03.04-.05.06-.08l.02-.02c.02-.02.03-.05.05-.07.01-.02.02-.03.04-.05.04-.05.06-.09.09-.13.04-.05.06-.09.09-.14.02-.03.03-.04.04-.06s.03-.05.04-.07c0-.01.01-.02.01-.03l.03-.06c.01-.02.02-.03.03-.05.01-.01.01-.02.02-.03.01-.02.02-.05.03-.07.01-.01.01-.03.02-.04 0-.01.01-.02.01-.03.01-.03.02-.06.04-.09.01-.01.01-.03.02-.04 0-.01.01-.02.01-.03l.05-.14c0-.01.01-.02.01-.03l.06-.22c0-.01 0-.01.01-.02 0-.01 0-.01.01-.02.02-.09.05-.18.06-.27v-.04c.01-.07.03-.14.04-.2l.03-.2v-.03c.01-.05.01-.11.02-.16-.02-.01-.02-.01-.02-.02z\" fill=\"url(#D)\"/><path d=\"M62.57 29.7v-.1-.12-.1-.12c0-.03 0-.07-.01-.1 0-.04-.01-.08-.01-.12 0-.03-.01-.07-.01-.1 0-.04-.01-.08-.02-.12 0-.03-.01-.07-.01-.1-.01-.04-.01-.08-.02-.12-.01-.03-.01-.07-.02-.1l-.03-.12c-.01-.03-.01-.06-.02-.09l-.03-.12c-.01-.03-.02-.06-.02-.09-.01-.04-.02-.08-.04-.12l-.03-.09c-.01-.04-.03-.08-.04-.12l-.03-.08-.05-.14c-.01-.02-.01-.04-.02-.06-.02-.07-.05-.13-.08-.19-.1-.24-.12-.52-.22-.76l-.16-.33c-.04-.1-.05-.21-.08-.31-.07-.22-.17-.43-.28-.64 0-.03-.05-.09-.07-.12-.02-.04-.05-.08-.07-.12l-.15-.23c-.05-.09-.11-.17-.17-.26-.03-.05-.03-.14-.09-.16-.03-.02-.07-.01-.1 0-.03 0-.06.01-.09.01-.41.06-.82.06-1.23 0-.1-.01-.2-.03-.3-.06-.03-.01-.12-.05-.15-.03-.03.03.02.07.04.1l.31.5c.01.02.03.04.04.07.02.03.03.06.05.08.01.02.03.05.04.07.02.03.03.06.05.09.01.02.03.05.04.07.02.03.03.06.05.1.01.02.02.05.04.07.02.03.03.07.05.11.01.02.02.05.03.07.021.038.038.078.05.12l.03.06c.03.06.05.12.08.19.03.06.05.13.08.19.01.02.02.04.02.07.02.04.03.09.05.13l.03.08c.01.04.03.08.04.12l.03.09.03.12c.01.03.02.06.02.09l.03.12c.01.03.01.06.02.09l.03.12c.01.03.01.07.02.1.01.04.01.08.02.12a.34.34 0 0 1 .01.1c.01.04.01.08.02.12 0 .03.01.07.01.1 0 .04.01.08.01.12a.34.34 0 0 0 .01.1v.12.1.12.1c0 .04-.01.08-.01.12 0 .03-.01.07-.01.1s-.01.06-.01.09l-.03.18-.03.15-.06.23-.03.1c-.02.05-.03.11-.05.16-.01.02-.02.05-.03.07l-.09.21-.09.21c-.01.02-.02.03-.03.05l-.09.17c0 .01-.01.01-.01.02a.99.99 0 0 1-.11.17c-.01.02-.02.03-.04.05-.03.04-.05.08-.08.11-.02.02-.03.04-.05.07a.27.27 0 0 1-.07.08c-.03.03-.05.06-.08.09s-.05.06-.08.09c-.01.01-.02.03-.04.04l-.12.13c-.06.06-.12.12-.19.17-.02.01-.03.03-.05.04l-.18.14a.94.94 0 0 1-.18.12c-.01.01-.03.02-.04.03-.06.04-.11.07-.17.1l-.13.07c-.01.01-.03.01-.04.02-.03.01-.05.03-.08.04-.02.01-.03.01-.04.02l-.06.03c-.01.01-.03.01-.04.02-.02.01-.03.01-.05.02s-.04.01-.05.02c-.01 0-.02.01-.03.01-.01.01-.03.01-.04.01s-.02.01-.03.01-.02.01-.03.01h-.03l-.65.22c-.07.02-.13.05-.2.07l-.47.16c-.06.02-.13.04-.19.07l-.62.22-.61.22-.18.06-.44.16-.18.06-.59.21-.58.21-.17.06-.41.15-.17.06-.53.2c-.01 0-.01.01-.02.01l-.53.2-.16.06-.38.15-.15.06-.49.19c-.01 0-.01 0-.02.01l-.49.2-.14.06-.36.14-.14.06-.44.18c-.01 0-.02.01-.02.01l-.45.19c-.02.01-.03.01-.05.02l-.08.03-.32.13-.13.06-.41.17c-.01 0-.01 0-.02.01l-.41.17c-.038.021-.078.038-.12.05l-.29.12c-.04.02-.08.03-.12.05l-.37.16-.38.16c-.04.02-.07.03-.1.05l-.27.12c-.03.02-.07.03-.1.05l-.33.15-.34.16c-.03.02-.07.03-.1.04l-.23.11c-.03.01-.06.03-.09.04l-.29.13c-.01 0-.01 0-.02.01l-.29.13c-.03.01-.06.03-.09.04l-.21.1c-.03.01-.05.03-.08.04l-.25.12-.26.13c-.03.01-.05.02-.07.04l-.17.08c-.02.01-.04.02-.07.03l-.21.1c-.01 0-.02.01-.03.01-.07.03-.13.07-.2.1-.02.01-.05.02-.07.03-.05.02-.09.05-.14.07l-.06.03-.17.09c-.01 0-.01.01-.02.01l-.16.08c-.02.01-.03.02-.05.03l-.11.06c-.02.01-.03.02-.05.02-.05.02-.09.05-.13.07-.01 0-.01.01-.02.01l-.12.06c-.01.01-.03.01-.04.02-.03.02-.06.03-.09.05-.01.01-.02.01-.03.02-.07.04-.14.07-.2.1-.01.01-.02.01-.03.02-.02.01-.03.02-.05.03-.01 0-.02.01-.03.01l-.06.03c-.03.01-.04.02-.06.03-.02.02-.03.02-.04.03-.02.01-.03.02-.03.02-.31.19-6.28 3.77-18.03 13.34-.02.01-.33.28-.78.54-.07.04-.15.09-.23.13-.01 0-.01.01-.02.01-.08.04-.15.07-.23.11-.01 0-.02.01-.03.01l-.15.06c-.049.017-.099.03-.15.04-.01 0-.02.01-.03.01-.06.02-.12.03-.19.04h-.03c-.04.01-.08.01-.12.01h-.03-.12c-.05 0-.08-.01-.11-.01-.02 0-.04-.01-.06-.01-.01 0-.03-.01-.04-.01-.03-.01-.06-.02-.1-.03s-.07-.03-.1-.04l2.26 1.31c.04.02.06.04.09.05.04.01.07.02.11.03.01 0 .03.01.04.01.02 0 .04.01.05.01.03 0 .06.01.09.01h.14.03c.04 0 .08-.01.12-.01h.03c.06-.01.12-.02.19-.04.02 0 .02 0 .03-.01.05-.01.09-.03.14-.04.054-.018.107-.038.16-.06.01 0 .01 0 .02-.01a2.67 2.67 0 0 0 .24-.12c.01 0 .01-.01.02-.01a1.71 1.71 0 0 0 .23-.13c.45-.26.76-.52.78-.54 11.75-9.56 17.71-13.15 18.03-13.34.01 0 .01-.01.02-.01.02-.01.03-.02.04-.03.02-.02.04-.03.06-.04.03-.01.05-.02.07-.03.01 0 .02-.01.03-.01.02-.01.03-.02.05-.03.01-.01.02-.01.03-.02.06-.03.12-.07.2-.1.01-.01.02-.01.03-.02.03-.01.06-.03.09-.05.01-.01.02-.01.04-.02l.12-.06c.01 0 .01-.01.02-.01.04-.02.09-.05.13-.07.01-.01.03-.01.04-.02l.12-.06c.02-.01.03-.02.05-.03.06-.03.11-.06.17-.09l.18-.09.06-.03c.05-.02.09-.05.14-.07.02-.01.04-.02.07-.03.07-.03.13-.07.2-.1.08-.04.15-.08.22-.11.02-.01.05-.02.07-.03l.18-.09c.02-.01.05-.02.07-.03.08-.04.17-.08.25-.12s.17-.08.26-.12c.03-.01.06-.03.08-.04.07-.03.13-.06.2-.1.03-.01.06-.03.08-.04.09-.04.19-.09.29-.13.01 0 .01 0 .02-.01.09-.04.19-.09.29-.13.03-.01.06-.03.09-.04.08-.04.15-.07.23-.11.03-.01.07-.03.1-.04l.33-.15c.112-.055.226-.109.34-.16.03-.01.07-.03.1-.04l.27-.12c.04-.02.07-.03.11-.05l.37-.16c.12-.05.25-.11.38-.16.04-.02.08-.03.12-.05.099-.039.195-.083.29-.13.04-.02.08-.03.12-.05.14-.06.27-.12.41-.17.01 0 .01 0 .02-.01.13-.06.27-.11.41-.17.04-.02.09-.04.13-.06.11-.04.21-.09.32-.13.04-.02.09-.04.13-.05.15-.06.3-.12.45-.19.01 0 .02-.01.02-.01l.44-.18c.05-.02.09-.04.14-.06.12-.05.24-.1.36-.14.05-.02.09-.04.14-.06.16-.06.33-.13.49-.2.01 0 .01 0 .02-.01l.49-.19.15-.06.38-.15a2.85 2.85 0 0 1 .16-.06c.18-.07.35-.14.53-.2.19-.08.36-.14.54-.21.05-.02.11-.04.17-.06.14-.05.28-.1.42-.16.05-.02.11-.04.16-.06l1.16-.43.18-.06c.15-.05.3-.11.45-.16l.18-.06.61-.22.62-.22c.06-.02.13-.04.19-.07.16-.05.31-.11.47-.16.07-.02.13-.05.2-.07.22-.07.43-.15.66-.23h.02c.02 0 .03-.01.04-.01s.02-.01.03-.01.03-.01.04-.01.02-.01.04-.01c.02-.01.03-.01.05-.02.01 0 .01-.01.02-.01s.02-.01.03-.01c.01-.01.03-.01.04-.02.02-.01.04-.02.07-.03.01-.01.03-.01.04-.02.03-.01.05-.03.08-.04.01-.01.03-.01.04-.02.04-.02.09-.05.13-.07.05-.03.11-.07.17-.1.01-.01.03-.02.04-.03l.18-.12c.06-.04.12-.09.18-.14.02-.01.03-.03.05-.04.06-.05.12-.11.19-.17.042-.041.082-.084.12-.13.01-.01.02-.03.03-.04.02-.02.03-.04.05-.05l.03-.03c.03-.03.05-.06.08-.09.01-.02.03-.03.04-.05.01-.01.02-.03.03-.04.02-.02.03-.04.05-.07.01-.02.02-.03.04-.05.01-.02.03-.04.04-.06s.02-.03.04-.05c.01-.01.01-.02.02-.03.03-.05.06-.09.09-.14 0-.02.01-.02.01-.03.02-.04.05-.08.07-.12.01-.02.02-.03.03-.05s.02-.03.03-.05.02-.03.02-.05c.02-.05.05-.1.07-.15.02-.07.05-.12.07-.18.01-.01.01-.03.01-.04.01-.02.02-.05.03-.07.01-.03.02-.05.03-.08.01-.02.02-.05.02-.08.01-.03.02-.07.03-.1.01-.02.01-.04.02-.06.02-.06.03-.12.05-.17.01-.03.02-.07.02-.1 0-.02.01-.03.01-.05l.03-.18c0-.02.01-.04.01-.06v-.04c0-.03.01-.07.01-.1.03 0 .03-.04.03-.08z\" fill=\"url(#E)\"/><path d=\"M64.28 22.35l.64 1.18a27.41 27.41 0 0 1 1.25 3.42c.74 2.56 1.11 5.22 1.13 7.88.02 2.49-.26 4.98-.77 7.41l-.93 3.6-.38 1.34-.44 1.34c-.03.07-.05.15-.11.2-.07.07-.16.09-.25.12-.67.16-1.36.18-2.05.18h-.46c-.04 0-.47-.02-.47-.03.02-.09.07-.16.1-.24l.14-.44.35-1.23c.03-.09.52-1.71-.76-1.27s-5.15 2.32-5.35 2.42c-.01 0-.22.1-.58.3-1.02.59-3.11 2.06-3.95 4.55-1.13 3.36-2.14 6.59-2.59 11.73-.01.15-.17 2.91 1.71 1.83.3-.17.57-.39.83-.63.32-.29.68-.61.89-.99.41.37.81.76 1.1 1.24.39.65.53 1.54.05 2.18-.11.15-.24.27-.35.42-.15.19-.33.36-.5.54-1.1 1.12-2.17 2.24-3.35 3.27-1.78 1.57-3.67 3.02-5.68 4.27-3.63 2.26-7.85 3.95-12.14 4.28l-1.59.1c-.05 0-.12 0-.15-.03-.06-.06-.02-.16.02-.23.67-1.2.8-2.69.34-3.98 1.11-.02 2.3.1 3.3-.48 1.9-1.1 1.79-3.7 1.78-3.84-.48-4.61-1.5-6.66-2.65-8.71-.85-1.52-2.94-.57-3.96.02-.35.2-.57.36-.58.36-.2.14-4.07 2.72-5.35 3.76-.66.54-.97 1.36-.96 2.2 0 .32.16.63.28.92.05.12.08.24.15.35.06.09.14.19.14.31 0 .08-.04.15-.09.21-.01.02-.03.04-.04.06-.32.49-.73.93-1.14 1.35s-.854.816-1.32 1.18c-.32.25-.66.49-1.03.66-.26.12-.69.34-.91.1-.54-.58-.95-1.41-1.33-2.11-.6-1.1-1.1-2.26-1.49-3.46-.38-1.19-.59-2.38-.78-3.6-.333-2.16-.477-4.345-.43-6.53.05-2.34.31-4.68.8-6.98a36.41 36.41 0 0 1 .67-2.69l.33-1.1.38-1.22.19-.61c.07-.21.14-.42.22-.62 0-.01.01-.03.02-.03s.03 0 .04.01l.24.15c.14.08.27.16.41.23a7.1 7.1 0 0 0 2.93.9 5.24 5.24 0 0 0 .97-.01c.3-.03.6-.08.9-.13-.35 1.08-.6 2.2-.84 3.3-.23 1.09-.35 2.26.01 3.33.37 1.09 1.44.72 2.18.29.45-.26.76-.52.78-.54 11.75-9.56 17.71-13.15 18.03-13.34.96-.57 2-1.04 3.01-1.51 2.74-1.3 5.54-2.47 8.37-3.56l5.05-1.88a5.81 5.81 0 0 0 3.3-3.08c.45-1.03.58-2.2.38-3.31s-.62-2.18-1.24-3.12c.01.02.45-.18.48-.2.18-.08.35-.16.52-.26.34-.19.66-.4.96-.65.31-.25.66-.54.89-.87.04-.06.39-.5.37-.54.15.22.24.35.36.56z\" fill=\"url(#F)\"/><path d=\"M41.62 43.33c3.6-2.08 6.86-3.47 8.27-3.9 1.42-.43 1.68.9 1.7.97.85 4.86-.53 8.62-1.66 11.33s-3.51 9.79-3.64 10.17c-.02.1-.41 2.07-2.12 3.38-.93.71-2.41 1.57-2.49 1.61-.07.04-1.45.84-2.49 1.26-1.71.7-2.11-.85-2.13-.93-.13-.23-2.54-4.55-3.68-5.94s-2.54-3.56-1.72-9.38c.01-.09.27-1.71 1.69-2.92 1.41-1.2 4.67-3.57 8.27-5.65z\" fill=\"url(#G)\"/><g fill=\"#fff\"><path d=\"M27.62 58.45c.69-.4 1.29-.14 1.36.63.08.82-.47 1.9-1.22 2.42l-1.42.98-.14.09c-.69.4-1.29.14-1.36-.63-.08-.82.47-1.9 1.22-2.42l1.42-.98c.05-.04.1-.07.14-.09zM55.17 42.4c.05-.03.11-.06.16-.08l1.42-.62c.75-.33 1.29.14 1.2 1.05-.08.84-.67 1.77-1.35 2.16-.05.03-.11.06-.16.08l-1.42.62c-.75.33-1.29-.14-1.2-1.05.08-.84.66-1.76 1.35-2.16zM27.35 54.65c.61-.35 1.1-.07 1.1.63s-.49 1.54-1.09 1.89c-.61.35-1.1.07-1.1-.63s.49-1.54 1.09-1.89zm-2.83 1.88c.61-.35 1.1-.07 1.1.63s-.49 1.54-1.09 1.89c-.61.35-1.1.07-1.1-.63 0-.69.49-1.54 1.09-1.89zm-2.83 1.79c.61-.35 1.1-.07 1.1.63s-.49 1.54-1.09 1.89c-.61.35-1.1.07-1.1-.63 0-.69.49-1.54 1.09-1.89zm39.43-22.85a.72.72 0 0 1 .2-.09c.6-.22 1 .2.89.95-.09.67-.55 1.36-1.08 1.66a.72.72 0 0 1-.2.09c-.6.22-1-.2-.89-.95.1-.66.56-1.36 1.08-1.66z\"/><use xlink:href=\"#N\"/><path d=\"M54.9 38.09a.72.72 0 0 1 .2-.09c.6-.22 1 .2.89.95-.09.67-.56 1.36-1.08 1.66a.82.82 0 0 1-.19.09c-.6.22-1-.2-.89-.95.09-.66.55-1.36 1.07-1.66z\"/></g><path d=\"M68.71 68.36c1.64.94 4.25.99 5.97.09l8.35-4.35c1.85-.96 1.92-2.63.15-3.65l-3.95-2.28c-1.77-1.02-4.64-.97-6.3.1l-7.49 4.85c-1.53 1-1.45 2.51.18 3.46l3.09 1.78z\" fill=\"url(#H)\"/><path d=\"M64.34 68.35v-.03l.01-3.54c0 .04.01.08.01.13 0 .04.01.09.01.13l.03.12.03.13c.01.04.03.07.05.11.02.05.04.09.06.13l.06.09.1.15a.27.27 0 0 0 .07.08l.17.19.09.09c.04.03.07.06.11.1s.09.07.14.11l.13.09c.073.052.15.099.23.14l3.09 1.78c.138.08.282.15.43.21.04.02.08.03.11.05.14.06.29.12.44.16.01 0 .02.01.02.01l.32.09c.02 0 .04.01.06.02l.39.08.49.07c.05.01.11.01.16.02l.28.02c.06 0 .12.01.17.01h.24.18l.23-.01c.06 0 .12-.01.18-.01l.23-.02c.06-.01.12-.01.18-.02.09-.01.18-.03.27-.05l.14-.03.42-.1c.02-.01.04-.01.06-.02l.41-.14c.04-.01.08-.03.12-.05l.44-.2 8.35-4.35c.95-.5 1.43-1.18 1.43-1.86l-.01 3.54c0 .68-.48 1.36-1.43 1.86l-8.35 4.35-.44.2c-.02.01-.03.02-.05.02-.02.01-.05.01-.07.02l-.41.14c-.02 0-.03.01-.05.02l-.44.1-.14.02c-.09.02-.18.03-.26.04-.01 0-.02 0-.04.01-.05.01-.09.01-.14.02l-.23.02c-.02 0-.03 0-.05.01-.04 0-.09 0-.14.01l-.23.01h-.06-.12-.24-.08c-.03 0-.06-.01-.1-.01-.09 0-.19-.01-.28-.02-.03 0-.06 0-.1-.01-.02 0-.04-.01-.06-.01l-.47-.07-.41-.08c-.02 0-.04-.01-.06-.02l-.32-.09c-.02 0-.02 0-.03-.01l-.44-.16c-.04-.02-.08-.03-.11-.05l-.43-.21-3.09-1.78-.15-.09c-.03-.02-.05-.04-.08-.05l-.13-.09a.69.69 0 0 1-.13-.11c-.04-.03-.08-.06-.11-.1-.02-.01-.03-.03-.05-.04-.02-.02-.03-.03-.04-.05-.06-.06-.12-.12-.17-.19-.01-.02-.03-.03-.05-.05-.01-.01-.01-.02-.02-.03-.04-.05-.07-.1-.1-.15-.01-.02-.03-.05-.05-.07 0-.01-.01-.01-.01-.02l-.06-.14c-.01-.03-.03-.06-.04-.09l-.03-.15-.03-.1c-.01-.06-.01-.11-.01-.15v-.08z\" fill=\"url(#I)\"/><path d=\"M67.56 68.31L56.15 74.9c-.28.16-.51.56-.51.89v.99c0 .33.23.46.52.29l11.41-6.59-.01-2.17z\" fill=\"url(#J)\"/><path d=\"M54.87 75.33v-.04-.03-.03c0-.03 0-.04.01-.05 0-.01 0-.02.01-.03 0-.01 0-.02.01-.03 0-.01 0-.01.01-.02 0-.01.01-.02.01-.03s.01-.02.01-.03.01-.02.01-.03.01-.02.01-.03.01-.01.01-.02.01-.02.01-.02c0-.01.01-.02.01-.03.01-.01.02-.02.02-.03.01-.01.01-.02.02-.03v-.02c.01-.02.03-.04.04-.06s.02-.03.03-.05c.01-.01.02-.02.02-.03.01-.01.01-.02.02-.02.01-.01.01-.02.02-.02l.02-.02.02-.02.02-.02.02-.02c.01-.01.02-.01.02-.02.01-.01.02-.01.02-.02l.02-.02.02-.02c.01 0 .01-.01.02-.01s.01-.01.02-.01l11.42-6.59.76.44-11.38 6.58a.36.36 0 0 0-.1.07l-.09.09c-.03.03-.06.07-.09.1-.03.04-.05.07-.07.11l-.06.13c-.02.04-.03.08-.05.13l-.03.13c-.01.04-.01.08-.01.12v.99c0 .04 0 .08.01.11l.03.09c.01.02.02.03.03.05.02.03.05.06.08.08l-.76-.44c-.03-.02-.06-.05-.08-.08-.02-.02-.02-.03-.03-.05 0-.01-.01-.02-.01-.03s-.01-.02-.01-.03 0-.02-.01-.03v-.02-.04-.04-.99c-.03-.01-.03-.02-.03-.02z\" fill=\"url(#K)\"/><path d=\"M70.61 66.93c.01.04.03.07.05.1 0 .01.01.01.01.02.02.03.05.06.08.09.02.02.04.03.07.05.02.01.04.03.06.04l.19.09c.02.01.05.02.07.02.03.01.06.02.1.02.039.011.079.018.12.02h.03c.05.01.11.01.17.01h.03c.05 0 .11 0 .16-.01l.18-.03c.01 0 .02 0 .03-.01.05-.01.09-.03.14-.04.01 0 .02-.01.02-.01a1.01 1.01 0 0 0 .15-.07c.19-.11.29-.26.29-.4v.59c0 .15-.1.29-.29.4-.04.03-.09.05-.14.07-.02 0-.03.01-.03.01l-.09.03c-.02 0-.03.01-.05.01-.01 0-.02 0-.03.01-.01 0-.02 0-.03.01-.03.01-.06.01-.1.02h-.03-.06c-.03 0-.06 0-.1.01h-.03-.03-.04c-.04 0-.07 0-.11-.01h-.04c-.03 0-.06-.01-.08-.01-.01 0-.02-.01-.04-.01-.03-.01-.07-.02-.1-.02-.02 0-.04-.01-.05-.01s-.01-.01-.02-.01c-.07-.02-.13-.05-.19-.09-.03-.02-.04-.03-.06-.05s-.05-.03-.07-.05c-.03-.02-.05-.04-.07-.07 0-.01-.01-.01-.01-.02s-.01-.01-.01-.02c-.01-.01-.01-.02-.02-.03l-.03-.06v-.02c0-.01-.01-.02-.01-.04s-.01-.04-.01-.06v-.6l.02.13z\" fill=\"url(#L)\"/><path d=\"M70.89 66.42c-.39.22-.39.58-.01.8a1.55 1.55 0 0 0 1.39 0c.38-.22.39-.58 0-.8a1.53 1.53 0 0 0-1.38 0z\" fill=\"#fff\"/></g><defs><linearGradient id=\"A\" x1=\"-10.231\" y1=\"47.878\" x2=\"159.705\" y2=\"47.878\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"42.921\" y1=\"46.745\" x2=\"67.776\" y2=\"46.745\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"40.257\" y1=\"65.369\" x2=\"80.381\" y2=\"65.369\" xlink:href=\"#O\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"D\" x1=\"9.069\" y1=\"69.646\" x2=\"39.845\" y2=\"69.646\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"-49.423\" y1=\"39.673\" x2=\"173.052\" y2=\"39.673\" xlink:href=\"#O\"><stop stop-color=\"#842bc5\"/><stop offset=\".099\" stop-color=\"#8832c7\"/><stop offset=\".246\" stop-color=\"#9446cc\"/><stop offset=\".422\" stop-color=\"#a767d5\"/><stop offset=\".622\" stop-color=\"#c295e2\"/><stop offset=\".839\" stop-color=\"#e3cff2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"F\" x1=\"-92.035\" y1=\"51.571\" x2=\"139.013\" y2=\"51.571\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".102\" stop-color=\"#f8f3fc\"/><stop offset=\".287\" stop-color=\"#e5d3f3\"/><stop offset=\".533\" stop-color=\"#c79fe5\"/><stop offset=\".829\" stop-color=\"#9e58d1\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"-4.113\" y1=\"53.841\" x2=\"64.615\" y2=\"53.841\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"49.609\" y1=\"63.264\" x2=\"115.847\" y2=\"63.264\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"53.543\" y1=\"67.435\" x2=\"95.815\" y2=\"67.435\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"48.464\" y1=\"72.73\" x2=\"81.123\" y2=\"72.73\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"51.066\" y1=\"72.491\" x2=\"83.171\" y2=\"72.491\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"69.089\" y1=\"67.4\" x2=\"82.819\" y2=\"67.4\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".179\" stop-color=\"#ecdef6\"/><stop offset=\".574\" stop-color=\"#bc8bdf\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"M\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><path id=\"N\" d=\"M58 36.83a.72.72 0 0 1 .2-.09c.6-.22 1 .2.89.95-.09.67-.56 1.36-1.08 1.66a.82.82 0 0 1-.19.09c-.6.22-1-.2-.89-.95.09-.66.55-1.36 1.07-1.66z\"/><linearGradient id=\"O\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgVan = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#Q)\"><g clip-path=\"url(#R)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M47.49 73.69c.18-.1 14.37-7.58 14.37-7.58v-2.67L47 68.41v4.13l.49 1.15z\" fill=\"url(#A)\"/><path d=\"M15.22 53.2l14.03-7.77v-2.67l-13.79 7.03-.63 2.14.39 1.27z\" fill=\"url(#B)\"/><path d=\"M21.12 58.7l4.57-2.66a.72.72 0 0 1-.2.09c-.05.02-.1.03-.15.04-.01 0-.02.01-.04.01-.06.01-.13.02-.19.02h-.04-.2l-.23-.03-.25-.06c-.01 0-.01 0-.02-.01l-.24-.1-.26-.13-.26-.16c-.01 0-.01-.01-.02-.01-.081-.051-.158-.108-.23-.17-.01-.01-.02-.01-.03-.02l-.22-.19c-.01-.01-.02-.02-.03-.02l-.21-.21-.02-.02-.22-.25-.21-.27-.18-.25-.11-.17c-.03-.04-.06-.09-.08-.13-.01-.02-.03-.05-.04-.07l-.13-.24c0-.01-.01-.02-.01-.03l-.14-.3-.13-.31c0-.01-.01-.01-.01-.02-.039-.101-.073-.205-.1-.31v-.02l-.08-.3c0-.01 0-.02-.01-.03l-.06-.3-.04-.31v-.02c-.01-.1-.01-.2-.01-.3l.01-.28v-.02l.04-.24c0-.01 0-.02.01-.03.02-.07.03-.15.06-.21 0-.01.01-.03.01-.04l.07-.19c0-.01 0-.01.01-.02.03-.07.07-.13.1-.18a1.24 1.24 0 0 1 .18-.22l.05-.05a1.85 1.85 0 0 1 .22-.17l-4.57 2.66a1.18 1.18 0 0 0-.22.17l-.05.05c-.06.07-.13.14-.18.22-.039.057-.073.117-.1.18 0 .02 0 .02-.01.03-.02.04-.04.08-.05.12-.01.02-.01.04-.02.06 0 .01-.01.02-.01.04 0 .01-.01.02-.01.04l-.03.13c0 .02-.01.03-.01.05 0 .01 0 .02-.01.03 0 .02-.01.03-.01.05-.01.04-.01.08-.02.12 0 .02 0 .05-.01.07v.02.03c0 .04-.01.08-.01.12v.12.13c0 .04 0 .08.01.12v.06.02.04c0 .04.01.08.01.13.01.04.01.09.02.13l.02.14.03.13c0 .02.01.03.01.05 0 .01 0 .02.01.03 0 .02.01.04.01.06.01.05.02.09.04.14l.03.1c0 .01 0 .01.01.02v.02c.01.04.03.09.04.13s.03.09.05.13c0 .01.01.02.01.03s0 .01.01.02l.03.08c.02.04.03.08.05.13.01.03.03.06.04.09 0 .01 0 .01.01.02 0 .01 0 .01.01.02l.06.12c.02.05.04.09.07.14 0 .01.01.01.01.02s.01.02.01.03c.02.04.04.07.05.11l.07.13c.01.02.02.05.04.07.01.01.01.02.01.03.02.04.05.07.07.11.03.06.07.11.11.17.01.01.01.02.02.03l.15.22c.05.06.09.11.12.16l.09.12c.03.04.07.08.1.12s.07.07.1.11l.02.02.02.02c.02.03.05.05.07.08l.11.11.03.03c.01.01.02.02.03.02.02.02.04.03.05.05.04.03.08.07.11.1.02.01.03.03.05.04.01.01.02.01.03.02s.03.02.04.03l.11.09c.03.02.05.04.08.06.01 0 .01.01.02.01.05.03.08.06.12.08s.07.04.11.07c.01 0 .02.01.03.01l.08.05c.04.02.07.04.1.05.02.01.05.02.07.03.01 0 .01.01.02.01s.01.01.02.01c.03.02.07.03.1.04s.07.03.1.04c.01 0 .01 0 .02.01.01 0 .01 0 .02.01.02.01.05.02.07.02l.11.03c.02 0 .03.01.05.01.03 0 .04 0 .05.01.04.01.08.01.11.02a.17.17 0 0 1 .07.01h.04.12.05.04.04c.05-.002.101-.008.15-.02.01 0 .02-.01.04-.01.05-.01.1-.02.14-.04.09-.12.16-.14.22-.18z\" fill=\"#fff\"/><path d=\"M27.68 54.94c0-.06 0-.12-.01-.18 0-.03 0-.06-.01-.09v-.04c0-.02 0-.04-.01-.06-.01-.06-.01-.12-.02-.19l-.03-.19-.03-.2c-.01-.07-.03-.13-.04-.2-.01-.02-.01-.05-.02-.07 0-.01-.01-.03-.01-.04-.01-.03-.01-.06-.02-.08l-.05-.2c-.01-.05-.03-.1-.04-.15 0-.01 0-.02-.01-.03 0-.01 0-.02-.01-.02l-.06-.2c-.02-.06-.04-.13-.07-.19 0-.01-.01-.03-.01-.04s-.01-.02-.01-.03c-.01-.04-.03-.08-.04-.12l-.07-.19-.06-.13c0-.01-.01-.02-.01-.02 0-.01-.01-.02-.01-.02l-.08-.18c-.03-.07-.06-.13-.1-.2-.01-.01-.01-.02-.02-.03s-.01-.03-.02-.04c-.03-.05-.05-.11-.08-.16l-.11-.2-.06-.1c-.01-.01-.01-.03-.02-.04-.03-.06-.07-.11-.1-.16l-.16-.25c-.01-.01-.02-.03-.03-.04a3.69 3.69 0 0 0-.23-.32c0-.01-.01-.01-.01-.02l-.17-.22-.14-.17c-.045-.064-.095-.124-.15-.18s-.1-.11-.15-.16l-.02-.02c-.01-.01-.02-.02-.02-.03-.04-.04-.07-.08-.11-.11l-.16-.16-.05-.05c-.01-.01-.02-.02-.04-.03l-.08-.08-.17-.15c-.02-.02-.05-.04-.07-.06-.01-.01-.03-.02-.04-.03-.02-.02-.04-.03-.06-.05-.06-.04-.11-.09-.17-.13l-.12-.09c-.01-.01-.02-.01-.02-.02l-.02-.02c-.05-.04-.11-.07-.16-.11l-.16-.1c-.01-.01-.02-.01-.04-.02-.04-.02-.08-.05-.12-.07-.05-.03-.1-.06-.16-.08-.03-.02-.07-.03-.1-.05-.01 0-.02-.01-.02-.01-.01 0-.02-.01-.03-.01l-.15-.06-.15-.06c-.01 0-.02-.01-.03-.01s-.02-.01-.02-.01l-.1-.03c-.05-.02-.11-.03-.16-.04-.03-.01-.05-.01-.08-.02-.01 0-.02 0-.03-.01-.02 0-.03-.01-.05-.01l-.17-.03c-.03 0-.07-.01-.1-.01h-.03-.03c-.06 0-.12-.01-.18-.01h-.08-.06-.06l-.22.03c-.02 0-.03.01-.05.01-.07.02-.14.03-.21.06-.01 0-.01.01-.02.01-.101.037-.198.083-.29.14l-4.57 2.66c.094-.053.191-.099.29-.14.07-.03.15-.05.23-.07.02 0 .03-.01.05-.01.09-.02.19-.03.28-.04h.06l.29.01h.03c.1.01.21.03.32.05.01 0 .02 0 .03.01.11.02.22.06.33.09.01 0 .02.01.02.01l.36.14c.01 0 .02.01.02.01l.38.2c.13.07.26.16.38.24.01.01.02.01.02.02l.34.26c.01.01.03.02.04.03l.32.28c.01.01.03.02.04.03l.32.32.03.03.32.37.31.4c0 .01.01.01.01.02l.25.37.16.25.12.2.06.1.19.36c.01.01.01.03.02.04l.21.44c0 .01.01.01.01.02l.18.44c0 .01.01.02.01.03.06.15.11.3.15.45 0 .01 0 .02.01.03l.12.44c0 .01.01.03.01.04l.09.45.05.46v.04l.02.44-.02.42v.04c-.01.12-.03.24-.05.35 0 .02-.01.03-.01.04-.021.108-.047.215-.08.32-.01.02-.01.04-.02.06-.03.1-.07.19-.11.27 0 .01-.01.02-.01.03l-.15.28c-.01.01-.02.02-.03.04-.05.07-.09.13-.15.19l-.06.06c-.05.05-.09.1-.14.14-.02.02-.04.04-.06.05-.067.059-.141.109-.22.15l4.57-2.66c.08-.04.15-.1.22-.15.02-.02.04-.04.06-.05.05-.04.1-.09.14-.14l.06-.06.15-.19c.01-.01.02-.02.03-.04a1.81 1.81 0 0 0 .15-.27c0-.02.01-.03.01-.04l.08-.18.03-.09c.01-.02.01-.04.02-.06s.01-.03.02-.05c.021-.062.038-.126.05-.19.01-.02.01-.05.01-.07s.01-.03.01-.05.01-.05.01-.07l.03-.18c0-.03.01-.07.01-.1v-.04-.04c0-.06.01-.12.01-.18v-.18c.03-.08.02-.14.02-.2z\" fill=\"url(#C)\"/><path d=\"M19.32 51.19c2.1 1.21 3.81 4.16 3.8 6.58-.01 2.41-1.72 3.39-3.82 2.18s-3.81-4.16-3.8-6.58c0-2.41 1.72-3.39 3.82-2.18zm-.02 7.33c1.42.82 2.57.16 2.58-1.47s-1.14-3.62-2.56-4.43c-1.42-.82-2.57-.16-2.58 1.47s1.14 3.61 2.56 4.43z\" fill=\"url(#D)\"/><path d=\"M17.83 54.78c0 .91.68 2.16 1.48 2.61.79.45 1.48.11 1.48-.79 0-.91-.68-2.16-1.48-2.61-.8-.57-1.48-.11-1.48.79z\" fill=\"url(#E)\"/><path d=\"M53.61 78.23l4.57-2.66a.72.72 0 0 1-.2.09c-.05.02-.1.03-.15.04-.01 0-.02.01-.04.01-.06.01-.13.02-.19.02h-.04-.2-.02l-.21-.03h-.02l-.23-.06c-.01 0-.01 0-.02-.01l-.24-.1c-.01 0-.01-.01-.02-.01l-.25-.13-.26-.16c-.01 0-.01-.01-.02-.01a1.95 1.95 0 0 1-.23-.17c-.01-.01-.02-.01-.03-.02l-.22-.19c-.01-.01-.02-.02-.03-.02l-.21-.21-.02-.02-.22-.25-.21-.27-.18-.25-.11-.17c-.03-.04-.06-.09-.08-.13-.01-.02-.03-.05-.04-.07l-.13-.24c0-.01-.01-.02-.01-.03l-.14-.3-.13-.31c0-.01-.01-.01-.01-.02a2.81 2.81 0 0 1-.1-.31l-.08-.32c0-.01 0-.02-.01-.03l-.06-.3-.04-.31c-.01-.12-.01-.22-.01-.32l.01-.28c.01-.1.02-.18.04-.26 0-.01 0-.02.01-.03.02-.07.03-.15.06-.21 0-.01.01-.03.01-.04l.07-.19c0-.01 0-.01.01-.02.03-.07.07-.13.1-.18.051-.08.112-.154.18-.22l.05-.05a1.82 1.82 0 0 1 .22-.17l-4.57 2.66c-.08.048-.154.105-.22.17l-.05.05c-.06.07-.13.14-.18.22-.039.056-.073.117-.1.18 0 .02 0 .02-.01.03-.02.04-.04.08-.05.12-.01.02-.01.04-.02.06 0 .01-.01.02-.01.04 0 .01-.01.02-.01.04l-.03.13c0 .02-.01.03-.01.05 0 .01 0 .02-.01.03 0 .02-.01.03-.01.05-.01.04-.01.08-.02.12 0 .02 0 .05-.01.07v.05c0 .04-.01.08-.01.12v.12.13c0 .04 0 .08.01.12v.06.06c0 .04.01.08.01.13.01.04.01.09.02.13v.02c.01.04.01.08.02.12l.03.13c0 .02.01.03.01.05 0 .01 0 .02.01.03 0 .02.01.04.01.06.01.05.02.09.04.14l.03.1c0 .01 0 .01.01.02.01.06.03.11.04.15s.03.09.05.13c0 .01.01.02.01.03s0 .01.01.02l.03.08c.02.04.03.08.05.13.01.03.03.06.04.09 0 .01 0 .01.01.02 0 .01 0 .01.01.02l.06.12c.02.05.04.09.07.14 0 .01.01.01.01.02s.01.02.01.03c.02.04.04.07.05.11l.07.13c.01.02.02.05.04.07.01.01.01.02.01.03.02.04.05.07.07.11.03.06.07.11.11.17.01.01.01.02.02.03l.15.22c.05.06.09.11.12.16l.09.12c.03.04.07.08.1.12s.07.07.1.11l.02.02.02.02c.02.03.05.05.07.08l.11.11.03.03c.01.01.02.02.03.02.02.02.04.03.05.05.04.03.08.07.11.1.02.01.03.03.05.04.01.01.02.01.03.02s.03.02.04.03l.11.09c.03.02.05.04.08.06.01 0 .01.01.02.01.05.03.08.06.12.08s.07.04.11.07c.01 0 .02.01.03.01l.08.05c.04.02.07.04.1.05.02.01.05.02.07.03.01 0 .01.01.02.01s.01.01.02.01c.03.02.07.03.1.04s.07.03.1.04c.01 0 .01 0 .02.01.01 0 .01 0 .02.01.02.01.05.02.07.02l.11.03c.02 0 .03.01.05.01h.02c.01 0 .02 0 .03.01.04.01.08.01.11.02a.17.17 0 0 1 .07.01h.02.02.12.05.04.04c.05 0 .1-.01.15-.02.01 0 .02-.01.04-.01.05-.01.1-.02.14-.04.1-.1.16-.13.23-.17z\" fill=\"#fff\"/><path d=\"M60.17 74.48c0-.06 0-.12-.01-.18 0-.03 0-.06-.01-.09v-.04c0-.02 0-.04-.01-.06-.01-.06-.01-.12-.02-.19l-.03-.19v-.02l-.03-.18c-.01-.07-.03-.13-.04-.2-.01-.02-.01-.05-.02-.07 0-.01-.01-.03-.01-.04-.01-.03-.01-.06-.02-.08l-.05-.2c-.01-.05-.03-.1-.04-.15 0-.01 0-.02-.01-.03 0-.01 0-.02-.01-.02l-.06-.2c-.02-.06-.04-.13-.07-.19 0-.01-.01-.03-.01-.04s-.01-.02-.01-.03c-.01-.04-.03-.08-.04-.12l-.07-.19-.06-.13c0-.01-.01-.02-.01-.02 0-.01-.01-.02-.01-.02l-.08-.18c-.03-.07-.06-.13-.1-.2-.01-.01-.01-.02-.02-.03s-.01-.03-.02-.04c-.03-.05-.05-.11-.08-.16l-.11-.2-.06-.1c-.01-.01-.01-.03-.02-.04-.03-.06-.07-.11-.1-.16l-.16-.25c-.01-.01-.02-.03-.03-.04a3.72 3.72 0 0 0-.23-.32c0-.01-.01-.01-.01-.02l-.17-.22-.14-.17c-.045-.064-.095-.124-.15-.18s-.1-.11-.15-.16l-.02-.02c-.01-.01-.02-.02-.02-.03-.04-.04-.07-.08-.11-.11l-.16-.16-.05-.05c-.01-.01-.02-.02-.04-.03l-.08-.08-.17-.15c-.02-.02-.05-.04-.07-.06-.01-.01-.03-.02-.04-.03-.02-.02-.04-.03-.06-.05-.06-.04-.11-.09-.17-.13l-.12-.09c-.01-.01-.02-.01-.02-.02l-.02-.02c-.05-.04-.11-.07-.16-.11l-.16-.1c-.01-.01-.02-.01-.04-.02-.04-.02-.08-.05-.12-.07-.05-.03-.1-.06-.16-.08-.03-.02-.07-.03-.1-.05-.01 0-.02-.01-.02-.01-.01 0-.02-.01-.03-.01l-.15-.06-.15-.06c-.01 0-.02-.01-.03-.01s-.02-.01-.02-.01l-.1-.03c-.05-.02-.11-.03-.16-.04-.03-.01-.05-.01-.08-.02-.01 0-.02 0-.03-.01-.02 0-.03-.01-.05-.01l-.17-.03c-.03 0-.07-.01-.1-.01h-.03-.03c-.06 0-.12-.01-.18-.01h-.08-.06-.06l-.22.03c-.02 0-.03.01-.05.01-.07.02-.14.03-.21.06-.01 0-.01.01-.02.01-.1.04-.2.08-.29.14l-4.57 2.66c.094-.053.191-.099.29-.14.07-.03.15-.05.23-.07.02 0 .03-.01.05-.01.09-.02.19-.03.28-.04h.06l.29.01h.03c.1.01.21.03.32.05.01 0 .02 0 .03.01.11.02.22.06.33.09.01 0 .02.01.02.01l.36.14c.01 0 .02.01.02.01l.38.2c.13.07.26.16.38.24.01.01.02.01.02.02a4.36 4.36 0 0 1 .34.26c.01.01.03.02.04.03l.32.28c.01.01.03.02.04.03l.32.32.03.03.32.37.31.4c0 .01.01.01.01.02l.25.37.16.25.12.2.06.1.19.36c.01.01.01.03.02.04l.21.44c0 .01.01.01.01.02l.18.44c0 .01.01.02.01.03.06.15.11.3.15.45 0 .01 0 .02.01.03l.12.44c0 .01.01.03.01.04l.09.45.05.46v.04l.02.44-.02.42v.04c-.01.12-.03.24-.05.35 0 .02-.01.03-.01.04-.021.108-.047.215-.08.32-.01.02-.01.04-.02.06-.03.1-.07.19-.11.27 0 .01-.01.02-.01.03l-.15.28c-.01.01-.02.02-.03.04-.05.07-.09.13-.15.19l-.06.06c-.05.05-.09.1-.14.14-.02.02-.04.04-.06.05-.067.059-.141.109-.22.15l4.57-2.66c.08-.04.15-.1.22-.15.02-.02.04-.04.06-.05.05-.04.1-.09.14-.14l.06-.06.15-.19c.01-.01.02-.02.03-.04.058-.085.108-.176.15-.27 0-.02.01-.03.01-.04l.08-.18.03-.09c.01-.02.01-.04.02-.06s.01-.03.02-.05a1.34 1.34 0 0 0 .05-.19c.01-.02.01-.05.01-.07s.01-.03.01-.05.01-.05.01-.07l.03-.18c0-.03.01-.07.01-.1v-.04-.04c0-.06.01-.12.01-.18v-.18c.02-.09.02-.15.02-.2z\" fill=\"url(#F)\"/><path d=\"M51.8 70.72c2.1 1.21 3.81 4.16 3.8 6.58-.01 2.41-1.72 3.39-3.82 2.18s-3.81-4.16-3.8-6.58c0-2.41 1.72-3.39 3.82-2.18zm-.02 7.34c1.42.82 2.57.16 2.58-1.47 0-1.63-1.14-3.62-2.56-4.43-1.42-.82-2.57-.16-2.58 1.47-.01 1.62 1.14 3.61 2.56 4.43z\" fill=\"url(#G)\"/><path d=\"M50.31 74.32c0 .91.68 2.16 1.48 2.61.79.45 1.48.11 1.48-.79s-.68-2.16-1.48-2.61c-.8-.57-1.48-.12-1.48.79z\" fill=\"url(#H)\"/><path d=\"M16.87 52.29v.02c-.01-.01-.01-.01 0-.02z\" fill=\"url(#I)\"/><path d=\"M17.27 51.41c.03-.03.05-.07.08-.1a.7.7 0 0 0-.08.1z\" fill=\"url(#J)\"/><path d=\"M40.96 11.75c-.94-.5-2.07-.49-2.99.04L12.18 26.54a3.08 3.08 0 0 0-1.55 2.67l-.01 19.56c0 1.11.59 2.13 1.55 2.68l3.04 1.74c-.08-.42-.1-.74-.1-1.14.01-2.79 2.23-3.87 4.67-2.46s4.4 4.82 4.4 7.61c0 .38-.12 1.04-.12 1.04l18.86 10.77 28.89-40.7-30.85-16.56z\" fill=\"url(#K)\"/><path d=\"M49.57 70.93c.03-.03.05-.07.08-.1l-.08.1z\" fill=\"url(#L)\"/><path d=\"M83.8 32.2l-11.59-5.29a2.07 2.07 0 0 0-1.89.09L44.01 42.29l-.31.62a8.38 8.38 0 0 0-.9 3.74l-.06 23.1a2.07 2.07 0 0 0 1.02 1.78l3.72 2.15-.07-1.83c-.03-2.96 2.08-4.21 4.65-2.74 2.44 1.4 4.42 4.82 4.41 7.62 0 .29-.02.56-.07.81-.12.71.2 1.42.83 1.78l1.02.59 2.04 1.18c.31.18.68.18.99 0l26.34-15.12a.83.83 0 0 0 .42-.72l.03-12.2L83.8 32.2z\" fill=\"url(#M)\"/><path d=\"M89.37 48.88v-2.61l-.35-.19-.57.31v-.16l.9-.5-.01-3.87-.3-.16-.6.33-.01-.26-.42-.24-3.39 1.87v.31l.43.24 1.85-1.02.01 3.81.3.17.53-.29v.16l-.86.48.01 2.46-2.25 1.24v.31l.43.24 3.39-1.87v-.25l.91-.51z\" fill=\"url(#N)\"/><path d=\"M46.52 47.38v13.14c0 .11.06.22.16.27l11 6.35c.24.14.53-.07.47-.34l-3.32-15.06c-.009-.044-.027-.085-.053-.121a.32.32 0 0 0-.097-.089L47 47.11c-.21-.13-.48.03-.48.27z\" fill=\"#fff\"/><path d=\"M84.86 36.85L57.63 52.67l-.72-.41 3.23 16.22.72.41 27.23-15.82-3.23-16.22z\" fill=\"url(#O)\"/><path d=\"M66.95 75.39l-3.69 2.13v-1.61l3.69-2.13v1.61zm19.31-11.27l-3.69 2.13v-1.61l3.69-2.13v1.61z\" fill=\"#fff\"/><path d=\"M57.94 67.57l-.3-.17-2.21 1.22v-.44l.47-.26-.01-2.61-.34-.19-.13.07v-.17l.46-.25-.01-3.86-.2-.11 2.24-1.24v-.42l-.3-.16-2.88 1.59v.64l-1.3.71.01 3.86.3.17 1-.55v.16l-1.34.74.01 2.61.35.19.99-.54v.85l.3.17 2.89-1.6v-.41z\" fill=\"url(#P)\"/></g></g><defs><linearGradient id=\"A\" x1=\"70.778\" y1=\"68.565\" x2=\"39.968\" y2=\"68.565\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"36.565\" y1=\"47.98\" x2=\"8.002\" y2=\"47.98\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"8.389\" y1=\"54.113\" x2=\"35.477\" y2=\"54.113\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"12.984\" y1=\"55.57\" x2=\"37.787\" y2=\"55.57\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"15.787\" y1=\"55.668\" x2=\"22.195\" y2=\"55.668\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"39.973\" y1=\"73.647\" x2=\"67.061\" y2=\"73.647\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"45.286\" y1=\"75.104\" x2=\"70.09\" y2=\"75.104\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"48.271\" y1=\"75.202\" x2=\"54.678\" y2=\"75.202\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"16.863\" y1=\"52.307\" x2=\"16.863\" y2=\"52.287\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"17.306\" y1=\"51.407\" x2=\"17.306\" y2=\"51.29\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"19.56\" y1=\"69.485\" x2=\"54.523\" y2=\"3.153\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"49.607\" y1=\"70.934\" x2=\"49.604\" y2=\"70.803\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"27.275\" y1=\"53.978\" x2=\"93.716\" y2=\"53.978\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"76.68\" y1=\"46.521\" x2=\"97.572\" y2=\"46.521\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"54.499\" y1=\"52.871\" x2=\"156.232\" y2=\"52.871\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"48.368\" y1=\"64.276\" x2=\"73.264\" y2=\"64.276\" xlink:href=\"#S\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"Q\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"R\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"S\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgVehicleCollisionKasko = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#f)\"><g clip-path=\"url(#g)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M36.66 43.99l-.34-2.78 16.87 9.69-.06.32.38 2.5-16.85-9.73z\" fill=\"url(#A)\"/><path d=\"M55.38 24.38l12.48 7.07c.23.13.17.56.11.81l-2.68 10.22c-.09.36-.5.54-.83.36l-15.64-8.67c-.29-.16-.39-.54-.2-.82l5.84-8.62c.16-.26.66-.5.92-.35z\" fill=\"#fff\"/><path d=\"M86.19 31.09l4.2 2.14-.99 2.64-4.81-2.83 1.6-1.95z\" fill=\"url(#B)\"/><path d=\"M61.04 46.5l4.2 2.06-.46 3.28-4.81-2.67 1.07-2.67z\" fill=\"url(#C)\"/><path d=\"M56.25 54.69c0-2.06 1.45-4.58 3.29-5.65.69-.38 1.38-.53 1.91-.38.15 0 1.91.99 1.91 1.07.46.38.76.99.76 1.99 0 2.06-1.45 4.58-3.29 5.65-.76.46-1.45.53-2.06.38-.15-.08-1.83-.92-2.14-1.38-.22-.45-.38-.99-.38-1.68z\" fill=\"url(#D)\"/><path d=\"M64.43 51.87c0 2.06-1.45 4.58-3.29 5.65s-3.29.23-3.29-1.83 1.45-4.58 3.29-5.65 3.29-.31 3.29 1.83z\" fill=\"url(#E)\"/><path d=\"M62.9 52.63c0 1.15-.84 2.6-1.83 3.21s-1.83.15-1.83-1.07c0-1.15.84-2.6 1.83-3.21s1.83-.15 1.83 1.07z\" fill=\"#fff\"/><path d=\"M62.21 53.03c0 .61-.46 1.45-.99 1.76s-.99.08-.99-.53.46-1.45.99-1.76c.53-.39.99-.08.99.53z\" fill=\"url(#F)\"/><path d=\"M81.35 40.23c0-2.06 1.45-4.58 3.29-5.65.69-.38 1.38-.53 1.91-.38.15 0 1.91.99 1.91 1.07.46.38.76.99.76 1.99 0 2.06-1.45 4.58-3.29 5.65-.76.46-1.45.53-2.06.38-.15-.08-1.83-.92-2.14-1.38-.23-.45-.38-.99-.38-1.68z\" fill=\"url(#G)\"/><path d=\"M89.52 37.41c0 2.06-1.45 4.58-3.29 5.65s-3.29.23-3.29-1.83 1.45-4.58 3.29-5.65 3.29-.31 3.29 1.83z\" fill=\"url(#H)\"/><path d=\"M87.99 38.17c0 1.15-.84 2.6-1.83 3.21s-1.83.15-1.83-1.07c0-1.15.84-2.6 1.83-3.21s1.83-.15 1.83 1.07z\" fill=\"#fff\"/><path d=\"M87.3 38.57c0 .61-.46 1.45-.99 1.76s-.99.08-.99-.53.46-1.45.99-1.76c.54-.39.99-.08.99.53z\" fill=\"url(#I)\"/><path d=\"M51.07 51.11c0-.53.38-.69.76-.46.46.23.84.84.84 1.38s-.38.69-.76.46c-.46-.23-.77-.85-.84-1.38zm-14.05-8.26c0-.46.31-.69.76-.38.46.23.76.84.76 1.3s-.31.69-.76.38c-.38-.23-.76-.76-.76-1.3z\" fill=\"#fff\"/><path d=\"M53.18 51.54l-.05-.31.05-.32-16.86-9.69 11.74-7.6 6.6-9.96c.02-.03.05-.06.08-.08l12.9-7.4c.74-.42 1.64-.43 2.38-.01l12.48 6.97 7.74 5.71.49.34c.33.23.57.56.69.94l.08.24a2.64 2.64 0 0 1-.02 1.69l-1.11 3.23-.97.59c-.53-1.38-1.63-1.96-3.23-1.04-2.06 1.22-3.74 4.13-3.74 6.49v.08l-.15.46-17.27 9.93-.23.08v-.46c0-2.37-1.68-3.36-3.74-2.14-1.99 1.15-3.59 3.82-3.74 6.19l-.74.54c-.39.29-.83.73-1.23.73-.15 0-.41-.11-.74-.28l-.94-.54-1.75-1.02-2.13-1.24-2.33-1.35-2.35-1.36-2.18-1.27-1.84-1.07-1.32-.76-.61-.35c-.01 0-.01-.01-.02-.01a2.82 2.82 0 0 1-1.02-1.01l-1.4-2.39c-.01-.02-.02-.05-.03-.07l16.85 9.73-.34-2.21zm12.27-9.98l2.38-9.37a.8.8 0 0 0-.38-.89l-11.8-6.72c-.37-.21-.83-.1-1.06.26l-5.43 8.32c-.25.39-.12.91.29 1.14l14.52 7.92c.58.31 1.32-.01 1.48-.66z\" fill=\"url(#J)\"/><path d=\"M85.94 29.49c-.21-.52-.1-1.03.31-1.24s.93 0 1.13.52c.21.52.1 1.03-.31 1.24-.41.2-.92-.01-1.13-.52z\" fill=\"url(#K)\"/><path d=\"M68.86 31.68l10.13-5.85a1.1 1.1 0 0 1 1.29.14l4.01 3.63a1.11 1.11 0 0 1 .349.951 1.11 1.11 0 0 1-.569.839l-.41.22-17.04 9.85-.09-.24c-.14-.39-.17-.82-.07-1.22l1.87-7.63a1.15 1.15 0 0 1 .53-.69z\" fill=\"url(#L)\"/><path d=\"M73.71 28.87l1.48 7.64.6-.35-1.46-7.64-.62.35z\" fill=\"url(#M)\"/><path d=\"M27.05 38.92c-.13 0-.27-.02-.4-.07l-5.47-1.81c-.68-.22-1.04-.95-.82-1.63a1.28 1.28 0 0 1 .643-.751 1.28 1.28 0 0 1 .987-.069l5.47 1.81c.68.22 1.04.95.82 1.63-.19.54-.69.89-1.23.89z\" fill=\"url(#N)\"/><path d=\"M29.59 34.87c-.32 0-.64-.12-.89-.35-2.73-2.59-4.06-4.14-6.18-7.25-.4-.59-.25-1.39.34-1.79s1.39-.25 1.79.34c2.02 2.97 3.22 4.37 5.82 6.84.52.49.54 1.3.05 1.82-.24.26-.58.39-.93.39z\" fill=\"url(#O)\"/><path d=\"M32.89 31.4a1.29 1.29 0 0 1-1.25-.96l-2.95-11.39a1.29 1.29 0 0 1 .92-1.57 1.29 1.29 0 0 1 1.57.92l2.95 11.39a1.29 1.29 0 0 1-.92 1.57 1.22 1.22 0 0 1-.32.04z\" fill=\"url(#P)\"/><path d=\"M37.68 31.4c-.07 0-.14-.01-.21-.02-.7-.11-1.18-.78-1.06-1.48l1.45-8.82c.12-.7.77-1.19 1.48-1.06.7.11 1.18.78 1.06 1.48l-1.45 8.82c-.1.64-.65 1.08-1.27 1.08z\" fill=\"url(#Q)\"/><path d=\"M41.87 33.85c-.4 0-.79-.18-1.04-.53-.42-.57-.29-1.38.28-1.8 1.4-1.02 2.67-2.22 3.77-3.57.45-.55 1.26-.64 1.81-.18.55.45.63 1.26.19 1.81-1.24 1.52-2.67 2.87-4.25 4.03-.23.16-.49.24-.76.24z\" fill=\"url(#R)\"/><path d=\"M63.34 67.33l.34-2.78-16.87 9.69.06.32-.38 2.5 16.85-9.73z\" fill=\"url(#S)\"/><path d=\"M44.62 47.72l-12.48 7.07c-.23.13-.17.56-.11.81l2.68 10.22c.09.36.5.54.83.36l15.64-8.67c.29-.16.39-.54.2-.82l-5.84-8.62c-.16-.25-.66-.5-.92-.35z\" fill=\"url(#T)\"/><path d=\"M13.81 54.43l-4.2 2.14.99 2.64 4.81-2.83-1.6-1.95z\" fill=\"url(#U)\"/><path d=\"M38.96 69.85l-4.2 2.06.46 3.28 4.81-2.67-1.07-2.67z\" fill=\"url(#V)\"/><path d=\"M18.61 63.64c0-2.06-1.45-4.58-3.29-5.65-.69-.38-1.38-.53-1.91-.38-.15 0-1.91.99-1.91 1.07-.46.38-.76.99-.76 1.99 0 2.06 1.45 4.58 3.29 5.65.76.46 1.45.53 2.06.38.15-.08 1.83-.92 2.14-1.38.23-.46.38-1 .38-1.68z\" fill=\"url(#W)\"/><path d=\"M10.44 60.81c0 2.06 1.45 4.58 3.29 5.65s3.29.23 3.29-1.83-1.45-4.58-3.29-5.65-3.29-.31-3.29 1.83z\" fill=\"url(#X)\"/><path d=\"M11.96 61.57c0 1.15.84 2.6 1.83 3.21s1.83.15 1.83-1.07c0-1.15-.84-2.6-1.83-3.21s-1.83-.15-1.83 1.07z\" fill=\"#fff\"/><path d=\"M12.65 61.97c0 .61.46 1.45.99 1.76s.99.08.99-.53-.46-1.45-.99-1.76c-.53-.38-.99-.08-.99.53z\" fill=\"url(#Y)\"/><path d=\"M43.75 78.03c0-2.06-1.45-4.58-3.29-5.65-.69-.38-1.37-.53-1.91-.38-.15 0-1.91.99-1.91 1.07-.46.38-.76.99-.76 1.99 0 2.06 1.45 4.58 3.29 5.65.76.46 1.45.53 2.06.38.15-.08 1.83-.92 2.14-1.38.22-.45.38-.99.38-1.68z\" fill=\"url(#Z)\"/><path d=\"M35.57 75.21c0 2.06 1.45 4.58 3.28 5.65s3.29.23 3.29-1.83-1.45-4.58-3.29-5.65-3.28-.31-3.28 1.83z\" fill=\"url(#a)\"/><path d=\"M37.1 75.97c0 1.15.84 2.6 1.83 3.21s1.83.15 1.83-1.07c0-1.15-.84-2.6-1.83-3.21s-1.83-.15-1.83 1.07z\" fill=\"#fff\"/><path d=\"M37.79 76.37c0 .61.46 1.45.99 1.76s.99.08.99-.53-.46-1.45-.99-1.76c-.53-.39-.99-.08-.99.53z\" fill=\"url(#b)\"/><path d=\"M48.93 74.45c0-.53-.38-.69-.76-.46-.46.23-.84.84-.84 1.38 0 .53.38.69.76.46.46-.23.77-.84.84-1.38zm14.05-8.25c0-.46-.31-.69-.76-.38-.46.23-.76.84-.76 1.3s.31.69.76.38c.38-.24.76-.77.76-1.3z\" fill=\"#fff\"/><path d=\"M46.82 74.88l.05-.31-.05-.32 16.86-9.69-11.74-7.6-6.6-9.96c-.02-.03-.05-.06-.08-.08l-12.9-7.4c-.74-.42-1.64-.43-2.38-.01L17.5 46.48l-7.74 5.71-.49.34c-.33.23-.57.56-.69.94l-.09.23a2.64 2.64 0 0 0 .02 1.69l1.11 3.23.97.59c.53-1.38 1.63-1.96 3.23-1.04 2.06 1.22 3.74 4.13 3.74 6.49v.08l.15.46 17.27 9.93.23.08v-.46c0-2.37 1.68-3.36 3.74-2.14 1.99 1.15 3.59 3.82 3.74 6.19l.74.54c.39.29.83.73 1.23.73.15 0 .41-.11.74-.28l.94-.54 1.75-1.02 2.13-1.24 2.33-1.35 2.35-1.36 2.18-1.27 1.84-1.07 1.32-.76.61-.35c.01 0 .01-.01.02-.01a2.82 2.82 0 0 0 1.02-1.01l1.4-2.39c.01-.02.02-.05.03-.07l-16.85 9.73.35-2.2zM34.55 64.9l-2.38-9.37a.8.8 0 0 1 .38-.89l11.8-6.72c.37-.21.83-.1 1.06.26l5.43 8.32c.25.39.12.91-.29 1.14l-14.52 7.92c-.58.31-1.32-.01-1.48-.66z\" fill=\"url(#c)\"/><path d=\"M14.06 52.83c.21-.52.1-1.03-.31-1.24s-.93 0-1.13.52-.1 1.03.31 1.24.92-.01 1.13-.52z\" fill=\"url(#d)\"/><path d=\"M31.14 55.02l-10.13-5.85a1.1 1.1 0 0 0-1.29.14l-4.01 3.63a1.11 1.11 0 0 0-.349.951 1.11 1.11 0 0 0 .569.839l.41.22 17.04 9.85.09-.24c.14-.39.17-.82.07-1.22l-1.87-7.63a1.15 1.15 0 0 0-.53-.69z\" fill=\"#fff\"/><path d=\"M26.29 52.21l-1.48 7.64-.6-.35 1.46-7.64.62.35z\" fill=\"url(#e)\"/></g></g><defs><linearGradient id=\"A\" x1=\"-6.539\" y1=\"47.464\" x2=\"110.832\" y2=\"47.464\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"79.815\" y1=\"33.475\" x2=\"92.384\" y2=\"33.475\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"52.834\" y1=\"49.178\" x2=\"68.673\" y2=\"49.178\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"49.22\" y1=\"53.211\" x2=\"64.996\" y2=\"53.211\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"54.075\" y1=\"53.77\" x2=\"66.492\" y2=\"53.77\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"59.539\" y1=\"53.624\" x2=\"63.105\" y2=\"53.624\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"74.371\" y1=\"38.751\" x2=\"90.147\" y2=\"38.751\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"79.166\" y1=\"39.31\" x2=\"91.583\" y2=\"39.31\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"84.629\" y1=\"39.164\" x2=\"88.196\" y2=\"39.164\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"26.009\" y1=\"36.283\" x2=\"96.539\" y2=\"36.283\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"82.142\" y1=\"29.125\" x2=\"91.205\" y2=\"29.125\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"61.769\" y1=\"33.569\" x2=\"178.086\" y2=\"33.569\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"59.56\" y1=\"32.512\" x2=\"81.498\" y2=\"32.512\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"12.188\" y1=\"36.723\" x2=\"34.831\" y2=\"36.723\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"11.766\" y1=\"30.063\" x2=\"39.433\" y2=\"30.063\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"19.026\" y1=\"24.419\" x2=\"40.514\" y2=\"24.419\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"26.116\" y1=\"25.703\" x2=\"46.708\" y2=\"25.703\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"R\" x1=\"29.628\" y1=\"30.664\" x2=\"54.051\" y2=\"30.664\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"S\" x1=\"-51.123\" y1=\"70.806\" x2=\"66.248\" y2=\"70.806\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"T\" x1=\"29.92\" y1=\"56.962\" x2=\"132.844\" y2=\"56.962\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"U\" x1=\"7.681\" y1=\"56.816\" x2=\"20.251\" y2=\"56.816\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"V\" x1=\"34.06\" y1=\"72.519\" x2=\"41.989\" y2=\"72.519\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"W\" x1=\"5.315\" y1=\"62.153\" x2=\"21.091\" y2=\"62.153\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"X\" x1=\"8.978\" y1=\"62.712\" x2=\"21.396\" y2=\"62.712\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Y\" x1=\"11.334\" y1=\"62.567\" x2=\"14.901\" y2=\"62.567\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Z\" x1=\"30.451\" y1=\"76.552\" x2=\"46.227\" y2=\"76.552\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"a\" x1=\"33.849\" y1=\"77.111\" x2=\"46.266\" y2=\"77.111\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"b\" x1=\"36.47\" y1=\"76.965\" x2=\"40.037\" y2=\"76.965\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"c\" x1=\"-1.365\" y1=\"59.624\" x2=\"69.165\" y2=\"59.624\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"d\" x1=\"9.72\" y1=\"52.466\" x2=\"18.782\" y2=\"52.466\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"e\" x1=\"17.63\" y1=\"55.853\" x2=\"39.568\" y2=\"55.853\" xlink:href=\"#h\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"f\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"g\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"h\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgVehicleDriverInjuries = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#I)\"><g clip-path=\"url(#J)\"><g fill=\"#e3d4ff\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\"/><path d=\"M22.53 73.67a2.04 2.04 0 0 1-1.15-.33l.36-.55c.53.35 1.34.28 2.17-.2l38.17-22.04c1.81-1.04 3.27-3.57 3.26-5.64l-.08-27.93c0-.92-.3-1.62-.82-1.93l.33-.56c.73.44 1.14 1.32 1.14 2.49l.08 27.93c.01 2.28-1.61 5.07-3.59 6.21L24.24 73.16c-.59.34-1.18.51-1.71.51z\"/></g><path d=\"M72.49 21.31c0-1.08-.39-1.83-1-2.18h.01l-13.27-7.72c-.01 0-.01-.01-.02-.01-.06-.03-.11-.06-.17-.08s-.12-.05-.18-.06l-.12-.03c-.01 0-.02 0-.03-.01-.01 0-.03-.01-.04-.01l-.21-.02c-.07 0-.15-.01-.23 0-.02 0-.05.01-.08.01a.09.09 0 0 0-.05.01c-.04 0-.08.01-.13.01l-.3.06c-.04.01-.09.03-.13.04s-.08.03-.12.04c-.05.02-.1.03-.15.05-.16.07-.32.14-.48.24L17.93 33.51c-.22.13-.43.28-.64.44-.07.05-.13.12-.2.17l-.3.26-.13.14-.11.12c-.04.05-.09.09-.13.14l-.28.34-.09.12c-.02.02-.03.04-.05.06l-.09.12-.2.29-.18.29c0 .01-.01.02-.01.02 0 .01-.01.02-.01.02-.05.08-.09.16-.13.24l-.15.29-.12.27c-.01.01-.01.02-.02.02l-.12.3-.12.32c-.02.05-.03.11-.05.16-.01.02-.01.05-.02.07-.01.04-.02.08-.04.12l-.1.39c-.02.08-.03.16-.04.24-.01.04-.01.08-.02.12s-.01.08-.02.11a5.12 5.12 0 0 0-.04.67l.08 27.7c0 1.07.38 1.83.99 2.18l13.28 7.72c-.08-.05-.15-.12-.23-.19.63.53 1.57.57 2.65-.05l37.86-21.86c1.88-1.09 3.41-3.72 3.4-5.88l-.06-27.67z\" fill=\"url(#A)\"/><path d=\"M21.38 73.35c-.69-.45-1.07-1.31-1.07-2.43l-.08-27.93c-.01-2.28 1.6-5.06 3.58-6.21l38.18-22.04c.95-.55 2.11-.66 2.8-.25l-.33.57c-.49-.28-1.39-.18-2.14.25L24.14 37.35c-1.8 1.04-3.26 3.57-3.25 5.64l.08 27.93c0 .89.28 1.55.78 1.88l-.37.55z\" fill=\"#e3d4ff\"/><path d=\"M55.612 51.005c3.405-5.814 3.446-12.12.091-14.085s-8.835 1.155-12.241 6.969-3.446 12.12-.091 14.085 8.835-1.155 12.241-6.969z\" fill=\"#fff\"/><path d=\"M47.44 43.82l.01 2.45-2.13 1.22.02 4.79 2.13-1.23v2.44l4.17-2.4-.01-2.44 2.13-1.23-.02-4.79-2.12 1.23-.01-2.45-4.17 2.41z\" fill=\"url(#B)\"/><path d=\"M25.04 33.25l5.31 3.09 3.18-1.84-5.31-3.08-3.18 1.83z\" fill=\"url(#C)\"/><path d=\"M33.53 34.5l-3.18 1.84-5.31-3.09.01.86 5.31 3.09 3.18-1.84-.01-.86z\" fill=\"url(#D)\"/><path d=\"M53.04 16.57l5.32 3.08 3.18-1.83-5.32-3.09-3.18 1.84z\" fill=\"url(#E)\"/><path d=\"M61.54 17.82l-3.18 1.83-5.32-3.08.01.85 5.31 3.09 3.18-1.84v-.85z\" fill=\"url(#F)\"/><path d=\"M49.47 22.35c-.03-.02-.08-.01-.12-.03-.14-1.45-.79-3.14-1.77-3.71a1.43 1.43 0 0 0-1.48.01l-6.3 3.82c-1.59.92-1.95 4.29-2.03 5.82-.04.02-.09.01-.12.03-.22.13-.35.33-.35.56s.13.43.36.56c.17.1.38.15.59.15s.42-.05.59-.15c.22-.13.35-.33.35-.56s-.13-.43-.36-.56c-.02-.01-.05-.01-.07-.02.1-1.95.59-4.43 1.55-4.98l6.3-3.81a.42.42 0 0 1 .48 0c.58.34 1.14 1.63 1.27 2.86-.02.01-.05.01-.06.02-.22.13-.35.33-.35.56 0 .22.13.43.36.56.17.1.38.15.59.15s.42-.05.59-.15c.22-.13.35-.33.35-.56-.01-.23-.14-.44-.37-.57z\" fill=\"#e3d4ff\"/><path d=\"M85.35 67.51c-.01.02-.01.05-.02.07-.07.2-.17.4-.3.6-.02.04-.05.07-.07.11a3.75 3.75 0 0 1-.51.56c-.13.11-.29.22-.44.33l-.4.29-17.74 10.3c-.28.16-.58.3-.9.42l-.25.09c-.197.07-.397.131-.6.18l-.64.16-.79.14-.18.03c-.36.04-.72.06-1.08.06h-.17c-.36 0-.71-.02-1.07-.06-.05-.01-.11-.01-.16-.02-.35-.04-.7-.1-1.03-.18-.06-.01-.12-.03-.18-.04l-.89-.27c-.05-.02-.11-.03-.16-.05-.34-.13-.67-.28-.98-.46-.296-.167-.575-.365-.83-.59-.71-.62-1.07-1.35-1.06-2.07v.48c0 .96.63 1.92 1.89 2.65.296.169.603.316.92.44.02.01.04.01.05.02.05.02.11.04.16.05l.56.19.32.08c.06.02.12.03.18.04s.11.03.16.04l.64.11.23.03c.05.01.11.01.16.02l.24.03.64.03h.19.17.29l.72-.05c.02 0 .05-.01.07-.01l.18-.03.56-.08c.08-.01.15-.04.23-.06l.64-.16.35-.09c.09-.03.17-.07.25-.1l.25-.09.89-.42L83.6 69.94l.08-.05c.13-.08.22-.16.33-.24l.44-.32c.01-.01.03-.02.04-.03.144-.133.277-.277.4-.43.03-.03.05-.07.07-.11.03-.04.05-.07.07-.11l.12-.17c.07-.12.13-.24.17-.37.01-.02.01-.04.02-.06s.01-.05.02-.07c.02-.08.05-.15.07-.23.02-.12.04-.25.04-.37v-.06-.48a2.55 2.55 0 0 1-.12.67z\" fill=\"url(#G)\"/><path d=\"M83.57 64.2c2.51 1.45 2.53 3.82.04 5.26L65.87 79.77c-2.49 1.45-6.58 1.44-9.09 0-2.51-1.45-2.53-3.82-.04-5.26L74.48 64.2c2.49-1.46 6.58-1.45 9.09 0z\" fill=\"url(#H)\"/><g fill=\"#fff\"><path d=\"M77.77 67.33c.23.13.24.34.03.48-.22.15-.6.16-.86.03-.01 0-.02-.01-.03-.01-.23-.13-.23-.34-.03-.48.22-.15.61-.16.86-.03.02 0 .02 0 .03.01zM62.12 76.4c.24.14.23.36 0 .49-.24.14-.62.14-.86 0s-.24-.36 0-.5c.24-.13.62-.13.86.01zm1.71-1c.23.13.24.34.03.48-.22.15-.61.16-.86.03-.01 0-.02-.01-.03-.02-.22-.13-.24-.34-.03-.48.22-.15.61-.16.86-.03.02.01.03.02.03.02zm13.34-4.53l-8.64 5.02-5.54-3.19 8.64-5.03 5.54 3.2zm4.188-5.286c.001-.193-.272-.351-.609-.352s-.61.155-.611.348.272.351.609.352.611-.155.611-.348zm-1.878.756c.23.13.23.36 0 .49-.24.14-.62.14-.86 0s-.24-.36 0-.5c.24-.13.62-.13.86.01zm2.09 1.2c.23.13.23.36 0 .49-.24.14-.62.14-.86 0s-.24-.36 0-.5c.24-.12.62-.12.86.01zm-4.2-2.42c.24.14.23.36 0 .49-.24.14-.62.14-.86 0s-.24-.36 0-.5c.23-.13.62-.13.86.01zm2.5 3.42c.23.13.23.36 0 .5s-.62.14-.86 0-.24-.36 0-.5.62-.14.86 0zm-4.21-2.43c.24.14.23.36 0 .5-.24.14-.62.14-.86 0s-.24-.36 0-.5.62-.14.86 0zM60.42 77.4c.24.14.24.36 0 .5s-.62.14-.86 0-.24-.36 0-.5.62-.14.86 0zm-.39-2.21c.24.14.23.36 0 .49-.24.14-.62.14-.86 0s-.24-.36 0-.5c.24-.13.62-.13.86.01zm4.21 2.43c.23.13.23.36 0 .49-.24.14-.62.14-.86 0s-.24-.36 0-.5c.23-.13.62-.13.86.01zm-2.49-3.42c.24.14.23.36 0 .5s-.62.14-.86 0-.24-.36 0-.5c.23-.14.62-.14.86 0zm4.2 2.42c.23.13.23.36 0 .5-.24.14-.62.14-.86 0s-.24-.36 0-.5a1 1 0 0 1 .86 0z\"/></g></g></g><defs><linearGradient id=\"A\" x1=\"-10.245\" y1=\"44.19\" x2=\"74.588\" y2=\"44.19\" xlink:href=\"#K\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"7.731\" y1=\"47.453\" x2=\"56.35\" y2=\"47.453\" xlink:href=\"#K\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"20.836\" y1=\"33.879\" x2=\"41.14\" y2=\"33.879\" xlink:href=\"#K\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"22.054\" y1=\"35.225\" x2=\"47.054\" y2=\"35.225\" xlink:href=\"#K\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"48.838\" y1=\"17.192\" x2=\"69.142\" y2=\"17.192\" xlink:href=\"#K\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"50.056\" y1=\"18.538\" x2=\"75.055\" y2=\"18.538\" xlink:href=\"#K\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"48.064\" y1=\"74.089\" x2=\"102.621\" y2=\"74.089\" xlink:href=\"#K\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"43.558\" y1=\"71.981\" x2=\"88.561\" y2=\"71.981\" xlink:href=\"#K\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"I\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"J\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"K\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgVehicleFullKasko = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#R)\"><g clip-path=\"url(#S)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M83.7 61.1l-.01.25-.01.21-.02.25-.02.21-.03.25-.03.21c-.012.084-.028.168-.05.25l-.04.21-.05.25-.05.21-.07.25-.06.2c-.02.09-.05.17-.08.26l-.06.2-.09.26-.07.19-.15.39c-.01.02-.02.05-.03.07l-.2.45c-.02.05-.05.09-.07.14l-.15.31-.09.17-.15.27-.09.16-.18.31-.11.18-.18.29-.12.19-.2.28-.13.18-.22.29c-.04.05-.08.11-.13.16l-.41.5c-.02.03-.05.06-.07.08l-.37.41-.14.15-.36.37-.13.13-.5.48c-.06.06-.13.11-.19.17l-.25.22-.21.18-.26.22-.22.18-.26.21-.23.18-.27.21-.24.18-.28.2-.25.17-.29.2-.26.17-.3.19-.27.17-.3.19-.49.29-.74.42-.22.12-.59.31c-.07.03-.13.07-.2.1l-.78.38-.14.06-.67.3c-.08.04-.16.07-.24.1l-.66.28-.16.07-.82.32-.21.08-.66.24-.25.09-.8.27c-.02.01-.04.01-.06.02l-.73.23c-.05.02-.11.03-.16.05l-.57.17-.27.08-.47.13-.3.08-.45.12-.32.08-.43.1-.34.08-.43.1-.34.07-.43.09-.35.07-.42.08-.31.06-.72.12-.22.04-.93.14-.2.03-.75.1-.28.03-.78.09c-.06.01-.12.01-.18.02l-.85.08c-.05 0-.1.01-.14.01l-.71.05-.29.02-.56.03-.33.02-.53.02-.35.01-.45.01-.37.01-.45.01h-.36-.46-.36c-.16 0-.31-.01-.47-.01-.12 0-.23 0-.35-.01-.14 0-.29-.01-.43-.01-.12 0-.24-.01-.36-.01l-.44-.02-.36-.02-.45-.03-.34-.02-.47-.03-.33-.03-.49-.04-.3-.03-.55-.06-.23-.02-.78-.09c-.03 0-.06-.01-.09-.01l-.69-.09-.19-.03-.6-.09-.29-.05-.5-.08-.32-.06-.46-.08-.34-.07-.44-.09-.32-.07-.51-.11-.32-.07-.5-.12-.31-.08-.52-.13-.28-.07-.64-.18c-.05-.01-.1-.03-.15-.04l-.9-.27c-.08-.02-.16-.05-.24-.08l-.72-.23c-.07-.02-.13-.04-.2-.07l-.87-.31-.19-.07-.7-.27-.27-.11-.28-.12-.36-.15-.28-.12-.36-.16-.28-.12-.35-.16-.27-.13-.35-.17-.26-.13-.36-.19-.24-.12-.4-.21-.2-.11-.58-.33c-6.45-3.73-9.68-8.62-9.66-13.5l-.01 2.08c-.01 4.88 3.21 9.78 9.66 13.5l.58.33c.06.04.13.07.2.11l.4.21.24.12c.12.06.24.13.37.19.089.039.175.083.26.13.12.06.24.12.36.17.09.04.18.08.27.13.12.05.24.11.36.16l.28.12c.12.05.24.1.36.16l.28.12.36.15c.09.04.19.08.28.11.04.02.09.04.13.05.05.02.09.03.14.05l.7.27c.06.02.13.05.19.07l.87.31c.07.02.13.04.2.07l.72.23c.08.03.16.05.24.08l.9.27c.05.01.1.02.14.04l.64.18c.09.02.19.05.28.07l.52.13c.1.03.21.05.31.08l.5.12c.11.02.21.05.32.07.17.04.34.07.51.11.07.01.14.03.2.04.04.01.07.01.11.02l.44.09c.11.02.22.04.34.07.15.03.31.06.46.08l.32.06c.17.03.33.06.5.08.1.02.19.03.29.05l.6.09.18.03.7.09c.03 0 .06.01.09.01l.78.09.25.03.53.06.31.03c.16.01.32.03.48.04h.03a3.03 3.03 0 0 0 .31.02l.46.03c.12.01.23.01.35.02l.44.03c.12.01.24.01.36.02.14.01.29.01.43.02.12 0 .24.01.37.01.14 0 .29.01.43.01h.08.27c.16 0 .31.01.47.01h.36.46.36c.15 0 .3 0 .45-.01.12 0 .25 0 .37-.01.15 0 .3-.01.45-.01h.17c.06 0 .12-.01.18-.01.18-.01.35-.01.53-.02.11-.01.22-.01.33-.02l.56-.03c.1-.01.2-.01.29-.02l.71-.05c.05 0 .1-.01.14-.01.28-.02.56-.05.85-.08h.04c.05 0 .09-.01.14-.02l.78-.08.29-.03.75-.1.2-.03c.31-.04.62-.09.93-.14.08-.01.15-.02.23-.04l.72-.12.15-.03.16-.03c.14-.03.28-.05.42-.08.12-.02.23-.05.35-.07l.42-.09c.12-.02.23-.05.35-.07l.42-.09c.11-.03.23-.05.34-.08.14-.03.29-.07.43-.1.11-.03.22-.05.33-.08.15-.04.3-.08.44-.11.1-.03.21-.05.31-.08.16-.04.31-.09.47-.13.09-.03.19-.05.28-.08.19-.05.38-.11.57-.17.05-.02.11-.03.16-.05.24-.07.49-.15.73-.23.03-.01.04-.01.06-.02l.8-.27.25-.09.66-.24c.07-.03.14-.05.21-.08l.82-.32c.06-.02.11-.05.17-.07l.66-.28c.08-.03.16-.07.24-.1l.67-.3c.05-.02.09-.04.14-.06.26-.12.52-.25.78-.38.07-.03.13-.07.2-.1.2-.1.39-.2.59-.31.07-.04.15-.08.22-.12l.74-.42.4-.24.09-.06c.1-.06.2-.12.3-.19.09-.06.18-.11.27-.17.1-.06.2-.13.3-.19.09-.06.18-.11.26-.17l.29-.2c.08-.06.17-.12.25-.17.09-.07.19-.13.28-.2l.24-.18.27-.21c.08-.06.16-.12.23-.18.09-.07.17-.14.26-.21.07-.06.15-.12.22-.18a2.6 2.6 0 0 0 .25-.22l.21-.18.25-.22c.06-.05.12-.1.17-.16l.02-.02.5-.48.13-.13.36-.37c.05-.05.09-.1.14-.15.13-.14.25-.28.37-.42.02-.03.05-.05.07-.08.14-.17.28-.33.41-.5.01-.01.02-.03.03-.04l.09-.12c.07-.1.15-.19.22-.29.04-.06.09-.12.13-.18.07-.09.13-.19.2-.28l.13-.19c.06-.1.12-.19.18-.29a1.73 1.73 0 0 0 .11-.18l.18-.31c.02-.04.05-.08.07-.12.01-.01.01-.02.02-.04l.15-.28c.03-.06.06-.12.09-.17l.15-.31c.02-.05.05-.09.07-.14.07-.15.14-.3.2-.45.01-.02.02-.05.03-.07.05-.13.11-.26.15-.39 0-.01 0-.01.01-.02.02-.06.04-.11.06-.17l.09-.26.06-.2c.03-.09.05-.17.08-.26l.06-.2c.02-.08.05-.17.07-.25.02-.07.03-.14.05-.21.02-.08.04-.16.05-.25 0-.01.01-.03.01-.04l.03-.16c.02-.08.03-.17.04-.25l.03-.21.03-.25c.012-.069.018-.14.02-.21.012-.083.019-.166.02-.25a1.54 1.54 0 0 0 .01-.22c0-.08.01-.16.01-.25v-.08-.29l.01-2.08a3.47 3.47 0 0 0-.03.42z\" fill=\"url(#A)\"/><path d=\"M74.04 47.23c12.83 7.4 12.89 19.41.15 26.82s-33.47 7.41-46.3 0S15 54.64 27.74 47.23c12.75-7.41 33.48-7.41 46.3 0z\" fill=\"url(#B)\"/><path d=\"M72.13 60.5l.26-2.11-12.78 7.35.05.24-.29 1.89 12.76-7.37z\" fill=\"url(#C)\"/><path d=\"M57.96 45.64L48.5 51c-.17.1-.13.42-.08.61l2.03 7.74c.07.27.38.41.63.27l11.85-6.57c.22-.12.29-.41.15-.62l-4.43-6.53c-.12-.19-.5-.37-.69-.26z\" fill=\"url(#D)\"/><path d=\"M34.61 50.72l-3.18 1.62.75 2 3.65-2.14-1.22-1.48z\" fill=\"url(#E)\"/><path d=\"M53.66 62.4l-3.18 1.56.35 2.49 3.65-2.03-.82-2.02z\" fill=\"url(#F)\"/><path d=\"M38.24 57.7c0-1.56-1.1-3.47-2.49-4.28-.52-.29-1.04-.41-1.45-.29-.12 0-1.45.75-1.45.81-.35.29-.58.75-.58 1.5 0 1.56 1.1 3.47 2.49 4.28.58.35 1.1.41 1.56.29.12-.06 1.39-.69 1.62-1.04.19-.34.3-.75.3-1.27z\" fill=\"url(#G)\"/><path d=\"M32.05 55.56c0 1.56 1.1 3.47 2.49 4.28s2.49.17 2.49-1.39-1.1-3.47-2.49-4.28-2.49-.23-2.49 1.39z\" fill=\"url(#H)\"/><path d=\"M33.21 56.14c0 .87.64 1.97 1.39 2.43s1.39.12 1.39-.81c0-.87-.64-1.97-1.39-2.43-.76-.47-1.39-.12-1.39.81z\" fill=\"#fff\"/><path d=\"M33.73 56.44c0 .46.35 1.1.75 1.33.41.23.75.06.75-.41 0-.46-.35-1.1-.75-1.33-.4-.29-.75-.05-.75.41z\" fill=\"url(#I)\"/><path d=\"M57.29 68.61c0-1.56-1.1-3.47-2.49-4.28-.52-.29-1.04-.41-1.45-.29-.12 0-1.45.75-1.45.81-.35.29-.58.75-.58 1.5 0 1.56 1.1 3.47 2.49 4.28.58.35 1.1.41 1.56.29.12-.06 1.39-.69 1.62-1.04.18-.34.3-.75.3-1.27z\" fill=\"url(#J)\"/><path d=\"M51.1 66.47c0 1.56 1.1 3.47 2.49 4.28s2.49.17 2.49-1.39-1.1-3.47-2.49-4.28-2.49-.23-2.49 1.39z\" fill=\"url(#K)\"/><path d=\"M52.25 67.05c0 .87.64 1.97 1.39 2.43s1.39.12 1.39-.81c0-.87-.64-1.97-1.39-2.43s-1.39-.12-1.39.81z\" fill=\"#fff\"/><path d=\"M52.77 67.35c0 .46.35 1.1.75 1.33.41.23.75.06.75-.41s-.35-1.1-.75-1.33c-.4-.29-.75-.05-.75.41z\" fill=\"url(#L)\"/><path d=\"M61.22 65.89c0-.41-.29-.52-.58-.35-.35.18-.64.64-.64 1.05s.29.52.58.35c.35-.18.58-.64.64-1.05zm10.65-6.25c0-.35-.23-.52-.58-.29-.35.17-.58.64-.58.98 0 .35.23.52.58.29.29-.17.58-.58.58-.98z\" fill=\"#fff\"/><path d=\"M59.62 66.22l.04-.24-.04-.24L72.4 58.4l-8.89-5.76-5-7.55c-.02-.02-.04-.05-.06-.06l-9.77-5.61a1.85 1.85 0 0 0-1.81-.01l-9.45 5.28-5.86 4.33-.37.26a1.33 1.33 0 0 0-.52.71l-.06.18c-.13.42-.13.87.02 1.28l.84 2.44.74.44c.41-1.04 1.23-1.49 2.45-.79 1.56.93 2.84 3.13 2.84 4.92v.06l.12.35 13.08 7.52.17.06v-.35c0-1.79 1.27-2.55 2.84-1.62 1.5.87 2.72 2.89 2.84 4.69l.56.41c.3.22.63.55.93.55.11 0 .31-.08.56-.21l.71-.41 1.33-.77 1.62-.94 1.77-1.02 1.78-1.03 1.65-.96 1.39-.81 1-.58.46-.27c.01 0 .01-.01.02-.01.32-.18.58-.45.77-.77l1.06-1.81c.01-.02.01-.04.02-.06l-12.76 7.37.2-1.63zm-9.3-7.56l-1.8-7.1a.59.59 0 0 1 .29-.67l8.94-5.09a.6.6 0 0 1 .8.19l4.11 6.31c.19.3.09.69-.22.86l-11 6c-.44.23-.99-.01-1.12-.5z\" fill=\"url(#M)\"/><path d=\"M34.8 49.51c.16-.39.08-.78-.23-.94s-.7 0-.86.39-.08.78.23.94.7 0 .86-.39z\" fill=\"url(#N)\"/><path d=\"M47.74 51.17l-7.67-4.44c-.31-.18-.71-.14-.98.1l-3.04 2.75c-.43.39-.34 1.08.16 1.35l.31.17 12.91 7.47.07-.18c.11-.3.13-.62.05-.92l-1.42-5.78a.79.79 0 0 0-.39-.52z\" fill=\"#fff\"/><path d=\"M44.06 49.04l-1.12 5.79-.45-.26 1.11-5.8.46.27z\" fill=\"url(#O)\"/><path d=\"M78.18 42.49l.3-.34c.04-.04.06-.07.08-.1l.2-.24c.03-.04.06-.07.08-.11l.18-.23.09-.12.16-.22c.02-.04.05-.07.07-.11l.18-.28c.01-.02.02-.03.03-.05l.18-.31c.02-.03.03-.06.05-.09.04-.07.08-.15.11-.22l.05-.11.09-.2c.01-.03.03-.07.04-.1l.08-.23c.01-.02.02-.04.02-.07l.08-.29c.01-.02.01-.05.02-.07.02-.07.03-.14.04-.21.01-.03.01-.06.01-.1.01-.06.02-.12.02-.19 0-.03.01-.06.01-.1 0-.07.01-.13.01-.2v-.07c0-.09-.01-.17-.02-.26 0-.02 0-.03-.01-.05l-.04-.21c-.01-.03-.01-.06-.02-.08-.01-.06-.03-.11-.05-.17 0-.02-.01-.03-.01-.05l-1.05-2.74-1.15-2.37-1.46-2.47c-.01-.01-.02-.03-.03-.04l-1.04-1.48-.43-.58-1.85-2.18c-.94-1.02-2.01-2.03-3.15-2.98-.01-.01-.02-.02-.04-.03l-.81-.65-2.01-1.44-2.6-1.55c-.9-.52-2.16-1.1-3.14-1.47l-2.14-.78-2.31-.67c-1.92-.44-2.99-.66-5.19-.85l-.34-.03-.24-.02-1.89-.07c-.48-.01-1.12 0-1.59.02l-2.36.18-1.97.29-.42.08-1.97.43-.73.19-.7.2-.69.22-1.36.48-.7.27c-.01 0-.66.26-1.46.63-.66.3-1.97.94-3.34 1.78l-2.18 1.45c-.34.23-.77.56-1.09.82l-1.31 1.09-1.36 1.27-.05.05-1.28 1.33-.21.24-1.29 1.56-.44.56c-.82 1.07-1.76 2.61-2.44 3.78-.5.876-.948 1.781-1.34 2.71l-1.03 2.64-.71 2.36-.14.57-.06.25-.39 1.92c-.24 1.5-.39 3.52-.46 5.04-.04.85.02 1.99.09 2.84L16.7 53l1.23 4.99.03.11c.01.02.01.04.02.06s.02.04.02.06c.01.02.01.04.02.06a1.01 1.01 0 0 0 .07.15c.01.01.01.02.01.03l.1.18c.01.02.02.03.03.05l.06.1c.01.01.02.02.02.04.01.02.03.04.04.06.03.04.06.09.1.13.01.01.02.03.03.04l.14.16.04.04.13.12c.02.02.04.03.05.05.04.04.09.08.13.11.02.01.03.03.05.04l.19.15c.01.01.02.01.03.02l.18.12c.02.01.05.03.07.04l.16.1c.02.01.05.03.07.04l.24.12.27.12.08.03c.07.03.13.06.2.08a.35.35 0 0 1 .09.04l.25.09c.02.01.03.01.05.02l.31.1.09.03.24.07.11.03.27.07c.03.01.05.01.08.02l.36.08c.03.01.06.01.09.02l.29.06c.04.01.08.02.13.02l.29.05c.04.01.07.01.11.02l.41.06c.02 0 .04.01.07.01a4.36 4.36 0 0 0 .36.04c.046.008.093.012.14.01l.32.03c.05 0 .09.01.14.01l.46.04c3.71.25 8.37-.2 13.42-1.18 5.06-.98 10.51-2.5 15.8-4.39 5.29-1.9 10.41-4.17 14.82-6.67l.69-.4.21-.12a7.04 7.04 0 0 0 .46-.28c.08-.05.16-.09.23-.14l.44-.27c.07-.04.14-.09.21-.13.18-.11.35-.22.52-.33.03-.02.07-.04.1-.06l.59-.39.17-.11c.14-.09.28-.19.41-.28l.2-.14c.12-.09.25-.17.37-.26.06-.04.12-.09.19-.13l.4-.29.12-.09c.17-.13.34-.25.5-.38l.12-.09c.12-.1.24-.19.36-.28l.16-.13c.1-.08.2-.17.3-.25.05-.04.1-.09.16-.13.101-.09.204-.176.31-.26.04-.03.08-.07.12-.1a14.43 14.43 0 0 0 .4-.36c.02-.02.04-.04.07-.06.11-.1.21-.2.31-.3l.12-.12.24-.24c.043-.041.083-.084.12-.13.08-.08.15-.16.23-.24.07-.02.11-.06.14-.1z\" fill=\"url(#P)\"/><path d=\"M38.24 18a2.57 2.57 0 1 0 0-5.14 2.57 2.57 0 1 0 0 5.14z\" fill=\"url(#Q)\"/></g></g><defs><linearGradient id=\"A\" x1=\"7.052\" y1=\"71.112\" x2=\"145.246\" y2=\"71.112\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"-34\" y1=\"60.636\" x2=\"278.443\" y2=\"60.636\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"-14.592\" y1=\"63.132\" x2=\"74.339\" y2=\"63.132\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"46.954\" y1=\"52.643\" x2=\"124.939\" y2=\"52.643\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"29.963\" y1=\"52.532\" x2=\"39.487\" y2=\"52.532\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"49.951\" y1=\"64.43\" x2=\"55.958\" y2=\"64.43\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"28.17\" y1=\"56.576\" x2=\"40.124\" y2=\"56.576\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"30.946\" y1=\"57\" x2=\"40.355\" y2=\"57\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"32.731\" y1=\"56.889\" x2=\"35.433\" y2=\"56.889\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"47.216\" y1=\"67.485\" x2=\"59.169\" y2=\"67.485\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"49.79\" y1=\"67.909\" x2=\"59.199\" y2=\"67.909\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"51.777\" y1=\"67.799\" x2=\"54.479\" y2=\"67.799\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"23.109\" y1=\"54.66\" x2=\"76.549\" y2=\"54.66\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"31.508\" y1=\"49.236\" x2=\"38.375\" y2=\"49.236\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"37.501\" y1=\"51.802\" x2=\"54.124\" y2=\"51.802\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"-13.567\" y1=\"38.166\" x2=\"131.451\" y2=\"38.166\" xlink:href=\"#T\"><stop stop-color=\"#fff\" stop-opacity=\"0\"/><stop offset=\".22\" stop-color=\"#e3cef2\" stop-opacity=\".22\"/><stop offset=\".761\" stop-color=\"#9f5ad2\" stop-opacity=\".761\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"21.823\" y1=\"15.433\" x2=\"44.253\" y2=\"15.433\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"R\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"S\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"T\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgVehicleGlasses = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#R)\"><g clip-path=\"url(#S)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M69.789 24.741c.277-.522.245-1.081-.073-1.25s-.799.119-1.076.64-.244 1.082.073 1.25.799-.118 1.076-.64z\" fill=\"#8334c2\"/><path d=\"M99.07 41.77l-.32-.2-38.88-23.48-.33.2v1.08L97.53 42.3l-1.88 1.14.32.2.01 1.07 3.09-1.87v-1.07z\" fill=\"url(#A)\"/><path d=\"M58.75 16.83l-.98-.6c-.57-.28-1.12-.46-1.75-.34-1.38.27-2.76.78-3.98 1.5a11.02 11.02 0 0 0-3.25 2.95c-.13.17-.15.4-.06.59.33.73 1.29 2.46 2.98 2.21 0 0 .64-.22 1.06-.7l2.52-3c.19-.15.44-.43.78-.66.51-.34 1.16-.35 1.7-.07l.12.06 10.81 6.57c-.13-.08-.21-.25-.21-.48 0-.12.02-.25.06-.37a2.5 2.5 0 0 1 .15-.38c.06-.12.14-.22.22-.32.09-.1.19-.18.28-.24a.73.73 0 0 1 .28-.1c.1-.01.17.01.24.05l-10.97-6.67z\" fill=\"url(#B)\"/><path d=\"M69.72 23.49s-.33-.06-.53.05a1.6 1.6 0 0 0-.73 1.33c.01.24.09.41.22.5 0-.01-.1-1.32 1.04-1.88z\" fill=\"#8334c2\"/><path d=\"M96.91 48.35c.01-.07.01-.14.01-.22l.12-1.86c-.01-3.35-1.2-5.7-3.11-6.81l-1.15-.67c1.91 1.11 3.1 3.47 3.11 6.81a16.88 16.88 0 0 1-.12 1.86l-.05.45-.15.85-.12.59-.13.54-.2.76-.14.44-.29.85-.13.35-.47 1.17c-.02.05-.05.1-.07.15l-.48 1.02-.16.32-.52.96-.1.18-.67 1.09-.21.31-.53.76-.3.4-.48.62-.41.51-.41.46-.71.76-.35.35c-.472.464-.97.901-1.49 1.31l-.28.21c-.54.41-1.09.79-1.65 1.12a12.6 12.6 0 0 1-1.33.66l-.42.17-.75.26-.47.13c-.15.04-.29.07-.44.09l-.56.09-.32.03c-.23.02-.47.02-.69.01h-.15c-.265-.018-.529-.051-.79-.1l-.19-.04-.59-.17-.18-.06-.7-.33 1.15.67.06.03a3.36 3.36 0 0 0 .54.26c.03.01.07.02.1.04l.18.06.28.1.3.07.19.04c.04.01.07.02.1.02.21.04.43.06.64.08h.04.15a4.51 4.51 0 0 0 .52 0c.057-.001.114-.008.17-.02l.32-.03c.1-.01.2-.01.3-.03.09-.01.18-.04.26-.06l.43-.09.24-.05c.08-.02.16-.06.24-.08l.75-.26c.09-.03.18-.05.27-.09.05-.02.1-.05.15-.08a12.6 12.6 0 0 0 1.33-.66c.56-.33 1.11-.71 1.65-1.12l.28-.21c.52-.409 1.018-.846 1.49-1.31l.12-.11.23-.24.71-.76.23-.24.18-.22.41-.5.27-.33.21-.29.3-.4.2-.28.33-.49.21-.31.09-.13.55-.9.03-.06.1-.18.37-.66.15-.31.16-.32.15-.29.34-.74c.02-.05.05-.1.07-.15.01-.01.01-.03.02-.04l.39-.96.06-.17.13-.35.17-.49.11-.37.13-.44.09-.28.12-.48.13-.54c.01-.07.03-.13.05-.2l.07-.39.14-.84c.04-.04.06-.12.07-.2z\" fill=\"url(#C)\"/><path d=\"M75.92 56.29l.14-.84.12-.59.13-.54.2-.76.13-.44.29-.86.12-.35.47-1.17.06-.14.48-1.03.16-.32.52-.96a1.15 1.15 0 0 0 .1-.19l.67-1.09.21-.31.53-.76.3-.4.48-.61.42-.51.41-.46.71-.75.35-.35c.474-.466.974-.904 1.5-1.31l.28-.21c.529-.407 1.084-.782 1.66-1.12.45-.26.9-.47 1.33-.66l.42-.17.75-.26.47-.13c.15-.04.29-.07.44-.09l.57-.09.32-.03c.23-.02.46-.02.69-.01h.15c.265.018.529.051.79.1l.19.04.58.17.18.06.7.33-1.04-.6-.06-.03a4.49 4.49 0 0 0-.54-.26c-.03-.01-.07-.02-.11-.04l-.18-.06-.28-.1c-.1-.03-.2-.05-.31-.07l-.19-.04c-.04-.01-.07-.02-.1-.02l-.64-.08h-.04-.15a4.51 4.51 0 0 0-.52 0c-.057.001-.114.008-.17.02l-.32.03c-.1.01-.2.01-.3.03-.09.01-.18.04-.26.06l-.44.09-.24.05c-.08.02-.16.06-.24.08-.25.07-.5.16-.75.26-.09.03-.18.05-.27.09-.05.02-.1.05-.15.08a12.62 12.62 0 0 0-1.33.66c-.56.33-1.11.71-1.65 1.12l-.28.21a18.13 18.13 0 0 0-1.49 1.31l-.12.11-.23.24-.71.76-.22.24-.18.22-.42.51-.27.33-.21.29-.3.4-.2.27-.33.49-.21.31-.09.13-.55.9-.03.06c-.039.06-.073.124-.1.19l-.36.65-.16.31-.16.32-.14.28-.34.74a.61.61 0 0 1-.07.14c-.01.01-.01.03-.02.04l-.39.96-.06.17-.13.35-.17.48-.11.37-.13.44-.08.28-.12.48-.13.55a1.34 1.34 0 0 1-.05.19c-.03.13-.04.26-.07.39l-.15.85-.04.24c-.01.07-.01.14-.01.22l-.12 1.86c.01 3.35 1.2 5.72 3.11 6.83l1.04.6c-1.91-1.11-3.1-3.47-3.11-6.83.006-.622.046-1.243.12-1.86l.05-.48z\" fill=\"url(#D)\"/><path d=\"M86.3 40.18c5.88-3.39 10.66-.67 10.68 6.1.02 6.75-4.73 14.98-10.61 18.38-5.89 3.4-10.67.67-10.69-6.08-.02-6.77 4.74-15 10.62-18.4z\" fill=\"url(#E)\"/><path d=\"M76.64 53.18c.07-.07.11-.15.1-.25-.11-1.34-.65-2.36-1.49-2.79-.68-.35-1.49-.28-2.27.2-1.24.75-2.22 2.41-2.61 4.17-.62-.04-1.06.72-1.01 1.86.05 1.27.7 2.52 1.44 2.79s1.29-.54 1.24-1.81c-.05-1.05-.5-2.08-1.07-2.56.32-1.64 1.22-3.2 2.35-3.88.59-.36 1.16-.42 1.64-.17.45.23.78.72.97 1.38-.13-.11-.26-.21-.4-.26-.74-.27-1.29.54-1.24 1.81s.7 2.52 1.44 2.79 1.29-.54 1.24-1.81c-.03-.52-.15-1.03-.33-1.47z\" fill=\"url(#F)\"/><path d=\"M70.26 59.91c.01-.07.01-.13.01-.2.07-.58.11-1.15.11-1.71-.01-3.08-1.1-5.24-2.86-6.27l-1.06-.61c1.76 1.02 2.85 3.19 2.86 6.27 0 .56-.04 1.13-.11 1.71l-.05.42-.13.78-.11.54-.12.5-.19.7-.12.41-.26.78-.12.32-.43 1.08-.06.14-.44.94-.15.3-.48.88-.09.17-.62 1c-.06.1-.13.19-.19.28l-.49.7-.27.37-.44.57-.38.46-.37.42-.65.7-.33.32a17.21 17.21 0 0 1-1.37 1.21c-.08.07-.17.13-.25.19-.5.38-1 .73-1.52 1.03-.42.24-.82.44-1.22.61-.13.06-.26.1-.38.15l-.69.24-.44.12-.4.09-.52.08-.29.03-.64.01h-.14c-.25-.01-.49-.05-.72-.09-.06-.01-.12-.03-.17-.04a3.69 3.69 0 0 1-.54-.16l-.16-.06c-.22-.09-.44-.19-.64-.31l1.06.61c.02.01.04.02.05.03.158.09.322.17.49.24l.1.03.17.06c.09.03.17.07.26.09.09.03.19.04.28.06.06.01.12.03.18.04.03.01.06.02.1.02l.59.07h.04.14c.16.01.32.01.48 0 .05 0 .11-.01.16-.02l.29-.03c.09-.01.18-.01.28-.03.08-.01.16-.04.24-.05.13-.02.27-.05.4-.09.07-.02.15-.03.22-.05s.15-.05.22-.08l.69-.24.25-.08c.05-.02.09-.05.14-.07.4-.17.81-.37 1.23-.61.52-.3 1.02-.65 1.52-1.03.09-.06.17-.13.25-.19a17.21 17.21 0 0 0 1.37-1.21c.04-.04.08-.06.11-.1l.21-.22.65-.7.21-.22.17-.2.38-.46.25-.3.19-.26.27-.37c.06-.09.13-.17.19-.25l.3-.45.19-.28c.03-.04.05-.08.08-.12l.51-.83c.01-.02.02-.04.03-.05l.09-.16.34-.61.14-.28.15-.29.13-.26.31-.68.06-.14c.01-.01.01-.03.02-.04l.36-.88.06-.16.12-.32.16-.45c.04-.11.07-.22.1-.34l.12-.41c.02-.09.05-.17.08-.26l.11-.44.12-.5c.01-.06.03-.12.04-.18.03-.12.04-.24.06-.36l.13-.77c-.03-.06-.01-.13-.01-.2z\" fill=\"url(#G)\"/><path d=\"M49.92 67.56l.15-.86.12-.6.14-.55.21-.78.14-.45.29-.87.13-.35.48-1.19c.02-.05.04-.09.07-.14l.49-1.05.17-.33.53-.98c.04-.06.07-.13.11-.19l.68-1.11.21-.32.54-.78.3-.41.49-.62.42-.52.42-.47.72-.77.36-.36c.482-.474.99-.921 1.52-1.34l.28-.21c.55-.42 1.11-.81 1.69-1.14.46-.27.91-.48 1.36-.68l.43-.17.76-.26.48-.13.44-.1c.19-.04.39-.07.58-.09l.33-.03c.24-.02.47-.02.7-.01h.15c.28.02.54.05.8.1.07.01.13.03.19.04l.59.17.18.07a5.18 5.18 0 0 1 .71.34l-1.06-.61-.06-.03c-.178-.1-.362-.19-.55-.27-.03-.01-.07-.02-.11-.04l-.18-.06-.29-.1c-.1-.03-.21-.05-.31-.07l-.19-.04c-.04-.01-.07-.02-.11-.02l-.66-.08h-.04-.15c-.17-.01-.35-.01-.53 0a1.1 1.1 0 0 0-.18.02l-.33.03-.31.03c-.09.01-.18.04-.27.06l-.45.1-.24.05c-.08.02-.16.06-.24.08l-.76.26c-.09.04-.18.06-.27.09-.05.02-.1.05-.15.08-.45.19-.9.41-1.36.68-.57.33-1.13.72-1.69 1.14l-.28.21c-.53.419-1.038.867-1.52 1.34-.04.04-.09.07-.13.11l-.23.25-.72.77-.23.24-.18.22-.42.52-.27.33-.22.29-.3.41-.21.28-.33.5-.21.31-.09.13-.56.92-.03.06c-.04.06-.07.13-.11.19l-.37.66-.16.31-.17.33-.14.29-.35.76c-.02.05-.05.1-.07.15-.01.01-.01.03-.02.04l-.4.98-.06.18-.13.36-.18.49-.12.38-.14.45-.09.28c-.05.16-.08.33-.12.49l-.14.56c-.01.07-.03.13-.05.2-.03.13-.04.27-.07.4l-.15.86-.04.24c-.01.07-.01.15-.01.22l-.12 1.9c.01 3.42 1.22 5.83 3.17 6.96l1.06.61c-1.95-1.13-3.16-3.54-3.17-6.96 0-.62.05-1.26.12-1.9.05-.17.06-.32.09-.48z\" fill=\"url(#H)\"/><path d=\"M60.56 51.18c-5.99 3.46-10.84 11.86-10.82 18.74s4.9 9.66 10.89 6.21c5.99-3.46 10.84-11.86 10.82-18.74-.02-6.89-4.9-9.67-10.89-6.21zm.56 23.42c-.54-.91-1.11-1.91-1.11-2.04 0-.18-1.07 2.02-1.74 3.38-.27.08-.54.15-.81.19-.07-.43-.12-.86-.12-.86l-1.16.97c-.12 0-.23 0-.35-.01v-1.76l-.82 1.64c-.74-.17-1.41-.49-1.98-.96l.07-.1-.43-.99 1.08-.62.36-2.19c.07-.29-1.08 1.2-1.08 1.2l.72-2.64-2.48 2.64c-.3-.9-.47-1.96-.47-3.14-.01-2.9.96-6.11 2.53-9.02l4.24 5.44-2.03-8.19 1.01.77v-2.59c1.22-1.34 2.58-2.49 4.01-3.31.35-.2.69-.38 1.03-.53l-.36 3.83 1.57-1.79.31 3.14 2.47-3.17-.6-2.81c1.95.01 3.53.96 4.47 2.7l-1.17 2.12 1.77-.58c.01.03.01.05.02.08l-3.3 3.02 3.61-.11c-.03 1.27-.23 2.6-.59 3.93-1.87.62-4.53 1.59-4.53 1.59l2.3 2.46-1.51-.2.07 1.77c0 .25-2.01-.65-2.01-.65L65.96 70c-1.41 1.87-3.06 3.47-4.84 4.6z\" fill=\"url(#I)\"/><path d=\"M22.055 57.362c.277-.522.244-1.082-.073-1.25s-.799.118-1.076.64-.245 1.082.073 1.25.799-.118 1.076-.64z\" fill=\"#8334c2\"/><path d=\"M49.62 67.35c0 .07-.02.14-.07.2-.05.07-.11.13-.2.19-.08.05-.18.08-.28.11-.01 0-.03.01-.04.01-.1.02-.21.04-.32.04-.13 0-.24-.01-.35-.04-.12-.03-.23-.07-.32-.12-.18-.11-.27-.24-.27-.38L47.74 71c0 .14.09.28.27.38.044.029.09.053.14.07.04.01.08.03.12.04.02 0 .03.01.05.01s.03.01.04.01c.03.01.06.01.09.02.03 0 .06.01.09.01h.09.03.06c.03 0 .07 0 .1-.01.04 0 .08-.01.12-.02.02 0 .03-.01.05-.01s.03-.01.04-.01c.03-.01.06-.01.08-.02a.72.72 0 0 0 .2-.09c.046-.029.09-.063.13-.1l.06-.06c0-.01.01-.01.01-.02.02-.02.03-.03.03-.04.01-.02.02-.04.02-.05.01-.02.01-.03.02-.05 0-.02.01-.04.01-.05V71l.03-3.65z\" fill=\"url(#J)\"/><path d=\"M49.34 66.96c.37.22.37.56 0 .77-.36.21-.95.21-1.32-.01-.36-.21-.36-.55 0-.76.37-.21.96-.21 1.32 0z\" fill=\"url(#K)\"/><path d=\"M13.26 51.61l.32-.19 31.54 19.09 2.77-1.68.32.2.01 1.08-3.1 1.87L21 57.38l-7.74-4.69v-1.08z\" fill=\"url(#L)\"/><path d=\"M11.01 49.45l-.98-.6c-.57-.28-1.12-.46-1.75-.34-1.38.27-2.76.78-3.98 1.5a11.02 11.02 0 0 0-3.25 2.95c-.13.17-.15.4-.06.59.33.73 1.29 2.46 2.98 2.21 0 0 .64-.22 1.06-.7l2.52-3c.19-.15.44-.43.78-.66.51-.34 1.16-.35 1.7-.07l.12.06 10.81 6.57c-.13-.08-.21-.25-.21-.48 0-.12.02-.25.06-.37a2.51 2.51 0 0 1 .15-.38c.06-.12.14-.22.22-.32.09-.1.19-.18.28-.24a.73.73 0 0 1 .28-.1c.1-.01.17.01.24.05l-10.97-6.67z\" fill=\"url(#M)\"/><path d=\"M21.98 56.11s-.33-.06-.53.05a1.6 1.6 0 0 0-.73 1.33c.01.24.09.41.22.5 0-.01-.1-1.31 1.04-1.88z\" fill=\"#8334c2\"/><path d=\"M58.26 90l3.83 2-16.59.77 9.4-2.48 3.36-.29z\" fill=\"url(#N)\"/><path d=\"M64.31 78.6c-.19.08-.74 3.32-.86 3.39s-4.83-1.06-4.83-1.06l5.69-2.33z\" fill=\"url(#O)\"/><path d=\"M86.53 76.2l-2.28-1.17-8.63 4.27 8.24 2.99 2.67-6.09z\" fill=\"url(#P)\"/><path d=\"M29.5 77.46c.35.08 2.21 5.36 2.43 5.45s7.8-3.19 7.8-3.19L29.5 77.46z\" fill=\"url(#Q)\"/></g></g><defs><linearGradient id=\"A\" x1=\"42.833\" y1=\"31.404\" x2=\"200.329\" y2=\"31.404\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"43.698\" y1=\"20.598\" x2=\"71.787\" y2=\"20.598\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"47.119\" y1=\"52.456\" x2=\"114.333\" y2=\"52.456\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"62.453\" y1=\"51.798\" x2=\"117.069\" y2=\"51.798\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"58.771\" y1=\"52.418\" x2=\"104.912\" y2=\"52.418\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"65.677\" y1=\"54.566\" x2=\"85.303\" y2=\"54.566\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"30.18\" y1=\"63.683\" x2=\"90.049\" y2=\"63.683\" xlink:href=\"#T\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"H\" x1=\"29.727\" y1=\"62.982\" x2=\"116.736\" y2=\"62.982\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"34.973\" y1=\"63.654\" x2=\"79.825\" y2=\"63.654\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"47.018\" y1=\"69.448\" x2=\"51.224\" y2=\"69.448\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"46.673\" y1=\"67.35\" x2=\"50.638\" y2=\"67.35\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"10.775\" y1=\"61.697\" x2=\"114.455\" y2=\"61.697\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"-3.281\" y1=\"53.22\" x2=\"26.403\" y2=\"53.22\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"26.906\" y1=\"91.431\" x2=\"72.834\" y2=\"91.359\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"37.972\" y1=\"80.467\" x2=\"71.763\" y2=\"80.233\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"57.112\" y1=\"78.665\" x2=\"92.09\" y2=\"78.665\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"17.379\" y1=\"80.184\" x2=\"58.171\" y2=\"80.184\" xlink:href=\"#T\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"R\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"S\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"T\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgVehicleLegalProtection = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#O)\"><g clip-path=\"url(#P)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M62.5 56.65l4.9 2.84-31.86 18.4.01 3.44-4.9-2.85-.01-3.44L62.5 56.65z\" fill=\"url(#A)\"/><path d=\"M55.06 57.47l4.89 2.85-16.98 9.81.01 3.43-4.9-2.84-.01-3.44 16.99-9.81z\" fill=\"url(#B)\"/><path d=\"M44.95 15.79l4.9 2.85-1.74 5.34.12 43.19-4.9-2.84-.12-43.19 1.74-5.35z\" fill=\"url(#C)\"/><path d=\"M59.93 63.81l.02-3.49-8.02 4.63-.12-43.11-1.96-3.2-1.74 5.34.11 43.11-5.25 3.04.01 3.46.04-.02-7.48 4.32.01 3.44 31.8-18.47.05-3.37-7.47 4.32z\" fill=\"url(#D)\"/><path d=\"M64.11 48.55c.53.3 1.17.27 1.86-.14-.99-.56-1.47-1.31-1.42-2.05.04-.65.48-1.29 1.33-1.79 1.81-1.08 4.78-1.11 6.64-.07.9.5 1.37 1.16 1.42 1.84.05.72-.39 1.45-1.33 2.01-1.81 1.08-4.78 1.11-6.64.07-.69.4-1.33.43-1.86.13 2.1 1.16 4.17 1.22 4.19 1.22.16 0 .36.02.52.03l.52.01.52-.02a10.4 10.4 0 0 0 1.56-.19 9.73 9.73 0 0 0 2.65-.91 8.18 8.18 0 0 0 3.43-3.29 8.77 8.77 0 0 0 .77-1.88c.28-1.1.32-1.44.35-2.61 0-1.42-.96-2.83-2.85-3.89-3.72-2.09-9.67-2.03-13.29.13-1.78 1.06-2.66 2.44-2.66 3.81.01.59.03 1.27.29 2.32.27 1.11.76 1.98.78 2.02.84 1.46 1.77 2.4 3.22 3.25z\" fill=\"url(#E)\"/><path d=\"M59.83 40.96a2.85 2.85 0 0 0 .11.76.93.93 0 0 0 .04.13l.07.18c.06.18.13.36.22.53.09.18.2.35.33.52.01.01.01.02.02.03.03.04.06.07.08.11.01.02.03.04.04.05.137.172.287.333.45.48l.21.2.25.2.31.24.29.19.44.28c.84.47 1.79.81 2.8 1.07l.42.11c.51.11 1.04.2 1.57.25.02 0 .04.01.07.01l.33.02 1.11.05c.37.01.74-.01 1.11-.03l.41-.03.44-.03 1.05-.16.28-.05.32-.06c.03-.01.06-.02.1-.02l1.01-.29c.05-.02.11-.03.17-.05.05-.02.1-.03.15-.05s.1-.03.14-.05.09-.03.13-.05c.01 0 .02-.01.03-.01.04-.02.09-.03.13-.05.54-.21 1.06-.44 1.52-.72 1.78-1.06 2.66-2.44 2.66-3.81l-.04.91-.07.58-.14.73-.15.55-.19.54c-.02.05-.03.1-.05.14 0 .01-.01.02-.01.04l-.22.51-.13.24-.15.28-.11.2-.3.46c-.02.02-.04.05-.06.08l-.1.13-.44.56-.37.39c-.44.42-.54.49-1.08.89l-.46.3c-.09.06-.21.12-.34.19-.05.03-.1.05-.15.08-.01.01-.03.02-.05.02-.01.01-.02.01-.03.02l-.02.01-.18.09-.13.06c-.01 0-.02.01-.03.01l-.14.06c-.03.01-.06.03-.1.04-.04.02-.09.04-.13.05l-.31.12-.19.06-.08.03-.23.08-.52.14-.51.11-.52.09-.52.06-.34.02c-.06 0-.12.01-.17.01h-.07c-.13.01-.27.01-.41.01h-.05-.13c-.18 0-.36 0-.55-.01l-.18-.01c-.07 0-.13-.01-.2-.01-.03 0-.07-.01-.1-.01-.051-.002-.101-.008-.15-.02l-.26-.03-.14-.02-.3-.04-.07-.01-.53-.1h-.01l-.16-.04-.34-.09-.54-.17-.5-.19c-.366-.142-.72-.313-1.06-.51l-.25-.15c-.37-.22-.53-.34-.96-.67l-.41-.36-.12-.12c-.05-.04-.09-.09-.14-.14l-.2-.21-.21-.23-.07-.1c-.04-.04-.07-.09-.11-.14s-.08-.09-.11-.14l-.19-.27-.22-.34-.05-.08c0-.01-.01-.01-.01-.02l-.16-.29-.05-.09c.01.02.02.03.03.05l-.11-.2-.23-.52c-.02-.04-.03-.08-.05-.11-.01-.02-.02-.04-.02-.06l-.01-.02-.18-.52c-.02-.05-.04-.12-.05-.17 0 .01 0 .01.01.02l-.06-.19c0-.01-.01-.02-.01-.03l-.07-.26-.06-.27c-.01-.03-.01-.06-.02-.08l-.05-.29c-.02-.09-.03-.22-.05-.31 0 .01.01.02.01.04 0-.03-.01-.06-.01-.09l-.07-.63-.02-.49v-.03c-.02-.02-.02-.05-.02-.07z\" fill=\"url(#F)\"/><path d=\"M62.68 44.84c3.72 2.09 9.67 2.03 13.29-.13s3.53-5.61-.19-7.7-9.67-2.03-13.29.13c-3.62 2.17-3.53 5.62.19 7.7z\" fill=\"url(#G)\"/><path d=\"M62.85 45.89c-.05 0-.11-.01-.16-.02a.7.7 0 0 1-.52-.84l6.29-26.91c.07-.3.33-.52.65-.54a.67.67 0 0 1 .69.48l6.22 18.85c.12.36-.08.76-.44.88-.37.12-.76-.08-.88-.44l-5.44-16.5-5.73 24.5a.7.7 0 0 1-.68.54z\" fill=\"url(#H)\"/><path d=\"M24.05 40.26v-.1c0-.03 0-.07.01-.1 0-.03.01-.07.01-.1s.01-.07.01-.1c.01-.03.01-.07.02-.1.01-.04.01-.07.02-.11s.02-.07.02-.11l.03-.11c.01-.03.02-.05.02-.08 0-.02 0-.02.01-.03l.03-.11c.01-.03.02-.07.04-.1.01-.03.02-.07.04-.1.01-.03.03-.07.04-.1.01-.02.02-.05.03-.07 0-.02.01-.02.01-.03.01-.03.03-.07.04-.1l.05-.11.06-.12c.02-.04.05-.08.07-.12 0-.01.01-.02.01-.02.01-.01.01-.02.02-.03l.15-.24.12-.17.09-.12c.03-.03.05-.06.08-.1.03-.03.05-.06.08-.09s.05-.06.08-.09l.02-.02c.02-.02.04-.05.06-.07l.08-.08c.03-.03.06-.06.09-.08.03-.03.06-.05.09-.08.01-.01.03-.02.04-.04.02-.02.03-.03.05-.04.03-.02.06-.05.09-.07l.09-.06.09-.06.08-.05c.01 0 .01-.01.02-.01l43.99-25.4c.02-.01.04-.02.06-.04.03-.01.05-.03.08-.04s.05-.03.08-.04l.08-.03.08-.03c.01 0 .01 0 .02-.01.03-.01.05-.01.07-.02a.31.31 0 0 1 .08-.02c.03-.01.06-.01.08-.02.03-.01.06-.01.09-.01.02 0 .04 0 .06-.01h.03.1.1c.041.002.081.008.12.02.06.01.1.02.14.04.06.02.11.05.16.08l1.94 1.54c-.2-.16-.87-.49-1-.45a1.95 1.95 0 0 0-.42.19l-43.99 25.4c-.14.08-.27.17-.4.28-.14.11-.26.23-.38.36s-.242.273-.35.42l-.29.45c0 .01-.01.02-.01.02-.09.15-.17.31-.24.47-.07.17-.13.34-.18.51l-.12.51c-.03.17-.04.33-.04.49s.01.3.04.43c.03.14.07.26.12.37.03.07.08.12.12.18.09.12.19.23.31.3l-1.97-1.14c-.12-.07-.22-.18-.31-.3-.01-.02-.03-.02-.04-.04-.03-.04-.05-.09-.08-.14-.02-.03-.03-.07-.04-.11-.01-.03-.02-.07-.04-.11l-.03-.1c0-.01-.01-.03-.01-.04 0-.02-.01-.04-.01-.05-.01-.03-.01-.06-.01-.1 0-.03-.01-.06-.01-.1 0-.03 0-.06-.01-.09v-.1c.03-.04.03-.07.04-.1z\" fill=\"url(#I)\"/><path d=\"M21.37 63.57a2.85 2.85 0 0 0 .11.76c.01.044.023.088.04.13l.07.18c.06.18.13.36.22.53.09.18.2.35.33.52.01.01.01.02.02.03.03.04.06.07.08.11.01.02.03.04.04.05.137.172.287.333.45.48l.21.2.25.2.31.24.29.19.44.28c.84.47 1.79.81 2.8 1.07l.42.11c.51.11 1.04.2 1.57.25.02 0 .04.01.07.01l.33.02 1.11.05c.37.01.74-.01 1.11-.03l.41-.03.44-.03 1.05-.16.28-.05.32-.06c.03-.01.06-.02.1-.02l1.01-.29c.05-.02.11-.03.17-.05.05-.02.1-.03.15-.05s.1-.03.14-.05.09-.03.13-.05c.01 0 .02-.01.03-.01.04-.02.09-.03.13-.05.54-.21 1.06-.44 1.52-.72 1.78-1.06 2.66-2.44 2.66-3.81l-.04.91-.07.58-.14.73-.15.55-.19.54c-.02.05-.03.1-.05.14 0 .01-.01.02-.01.04l-.22.51-.13.24-.15.28-.11.2-.3.46c-.02.02-.04.05-.06.08l-.1.13-.44.56-.37.39c-.44.42-.54.49-1.08.89l-.46.3c-.09.06-.21.12-.34.19-.05.03-.1.05-.15.08-.01.01-.03.02-.05.02-.01.01-.02.01-.03.02l-.02.01-.18.09-.13.06c-.01 0-.02.01-.03.01l-.14.06c-.03.01-.06.03-.1.04-.04.02-.09.04-.13.05l-.31.12-.19.06-.08.03-.23.08-.52.14-.51.11-.52.09-.52.06-.34.02c-.06 0-.12.01-.17.01h-.07c-.13.01-.27.01-.41.01h-.05-.13c-.18 0-.36 0-.55-.01l-.18-.01c-.07 0-.13-.01-.2-.01-.03 0-.07-.01-.1-.01-.05 0-.1-.01-.15-.02l-.26-.03-.14-.02-.3-.04-.07-.01-.53-.1h-.01l-.16-.04-.34-.09-.54-.17-.5-.19c-.366-.142-.72-.313-1.06-.51l-.25-.15c-.37-.22-.53-.34-.96-.67l-.41-.36-.12-.12c-.05-.04-.09-.09-.14-.14l-.2-.21-.21-.23-.07-.1c-.04-.04-.07-.09-.11-.14s-.08-.09-.11-.14l-.19-.27-.22-.34-.05-.08c0-.01-.01-.01-.01-.02l-.16-.29-.05-.09c.01.02.02.03.03.05l-.11-.2-.23-.52c-.02-.04-.03-.08-.05-.11-.01-.02-.02-.04-.02-.06l-.03-.01-.18-.52c-.02-.05-.04-.12-.05-.17 0 .01 0 .01.01.02l-.06-.19c0-.01-.01-.02-.01-.03l-.07-.26-.06-.27c-.01-.03-.01-.06-.02-.08l-.05-.29c-.02-.09-.03-.22-.05-.31 0 .01.01.02.01.04 0-.03-.01-.06-.01-.09l-.07-.63-.02-.49v-.03-.08z\" fill=\"url(#J)\"/><path d=\"M24.22 67.46c3.72 2.09 9.67 2.03 13.29-.13s3.53-5.61-.19-7.7-9.67-2.03-13.29.13-3.53 5.61.19 7.7z\" fill=\"url(#K)\"/><path d=\"M24.4 68.43c-.05 0-.11-.01-.16-.02a.7.7 0 0 1-.52-.84L30 40.74c.07-.3.33-.52.65-.54s.59.18.69.48l6.23 18.9c.12.36-.08.76-.44.88-.37.12-.76-.08-.88-.44l-5.46-16.55-5.71 24.43c-.07.32-.36.53-.68.53z\" fill=\"url(#L)\"/><path d=\"M27.75 37.87c-1.11.64-2.01 2.2-2.01 3.49 0 1.28.91 1.79 2.02 1.15l43.87-25.33c1.11-.64 2.01-2.2 2.01-3.48 0-1.29-.91-1.8-2.02-1.16L27.75 37.87z\" fill=\"url(#M)\"/><path d=\"M50.61 25.92c-2.12 1.22-3.85 4.2-3.84 6.65s1.74 3.43 3.87 2.2 3.85-4.2 3.84-6.65-1.74-3.43-3.87-2.2z\" fill=\"url(#N)\"/></g></g><defs><linearGradient id=\"A\" x1=\"24.401\" y1=\"68.987\" x2=\"89.501\" y2=\"68.987\" xlink:href=\"#Q\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"33.959\" y1=\"65.519\" x2=\"73.926\" y2=\"65.519\" xlink:href=\"#Q\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"40.384\" y1=\"41.482\" x2=\"66.054\" y2=\"41.482\" xlink:href=\"#Q\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"20.605\" y1=\"49.982\" x2=\"72.683\" y2=\"49.982\" xlink:href=\"#Q\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"59.833\" y1=\"42.648\" x2=\"78.626\" y2=\"42.648\" xlink:href=\"#Q\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"52.928\" y1=\"45.356\" x2=\"84.067\" y2=\"45.356\" xlink:href=\"#Q\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"48.544\" y1=\"40.929\" x2=\"142.169\" y2=\"40.929\" xlink:href=\"#Q\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"44.467\" y1=\"31.742\" x2=\"93.603\" y2=\"31.742\" xlink:href=\"#Q\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"20.321\" y1=\"26.984\" x2=\"93.538\" y2=\"26.984\" xlink:href=\"#Q\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"14.795\" y1=\"67.971\" x2=\"48.936\" y2=\"67.971\" xlink:href=\"#Q\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"13.356\" y1=\"63.544\" x2=\"108.207\" y2=\"63.544\" xlink:href=\"#Q\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"8.676\" y1=\"54.321\" x2=\"57.526\" y2=\"54.321\" xlink:href=\"#Q\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"9.082\" y1=\"27.525\" x2=\"78.714\" y2=\"27.525\" xlink:href=\"#Q\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"45.411\" y1=\"30.341\" x2=\"87.831\" y2=\"30.341\" xlink:href=\"#Q\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"O\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"P\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"Q\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgVehicleNaturalEvents = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#J)\"><g clip-path=\"url(#K)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M52.27 51.75l6.19-3.57c.22-.13.48.1.38.33l-3.24 8.06c-.1.24.16.46.38.33l5.81-3.36a.27.27 0 0 1 .318.043.27.27 0 0 1 .052.317L50.12 76.88c-.15.28-.57.12-.5-.18l2.95-13.18c.05-.23-.19-.41-.4-.29L47.38 66c-.22.13-.48-.09-.39-.33l5.16-13.78c.02-.06.06-.11.12-.14z\" fill=\"url(#A)\"/><path d=\"M79.43 26.14c.24-.081.488-.134.74-.16.02 0 .04 0 .06-.01.25-.02.49-.01.72.04.01 0 .02.01.04.01.229.047.448.132.65.25l-4.25-2.47c-.01 0-.02-.01-.02-.01-.07-.04-.15-.08-.23-.11l-.24-.08-.16-.04c-.01 0-.02-.01-.04-.01s-.04-.01-.06-.01c-.089-.02-.179-.03-.27-.03-.1-.01-.2-.01-.3 0-.03 0-.06.01-.09.01-.02 0-.04 0-.07.01l-.17.02-.39.08c-.05.01-.11.04-.17.06-.05.02-.1.03-.16.05-.07.02-.13.04-.2.07-.2.08-.41.19-.62.31l-4.37 2.52 4.25 2.47 4.37-2.52c.28-.16.56-.28.82-.38.06-.03.11-.05.16-.07z\" fill=\"url(#B)\"/><path d=\"M65.77 21.07l.7-.24.45-.12.41-.09.53-.08.3-.03c.23-.02.45-.02.66-.01h.12c.25.01.5.05.74.09.06.01.12.03.18.04.19.04.37.1.55.16l.17.06c.23.09.45.19.66.31L67 18.7l-.06-.03-.51-.25-.1-.03-.17-.06-.27-.09c-.09-.03-.19-.04-.28-.06-.06-.01-.12-.03-.18-.04-.03-.01-.07-.02-.1-.02l-.61-.07h-.03-.12a4.34 4.34 0 0 0-.51 0c-.05 0-.1.01-.15.02l-.3.03-.29.03c-.08.01-.16.04-.24.05l-.41.09-.23.05c-.07.02-.15.05-.22.08l-.7.24c-.09.03-.17.05-.25.09-.05.02-.09.05-.14.07-.41.18-.82.37-1.24.62l-2.6 1.5 4.25 2.47 2.6-1.5c.42-.24.83-.44 1.24-.62.13-.1.26-.15.39-.2z\" fill=\"url(#C)\"/><path d=\"M36.84 34.17l.17-.99.13-.68.16-.64.24-.89.16-.52.33-.99.15-.41.55-1.37.07-.16.57-1.21.19-.38.6-1.12.12-.22.78-1.28.24-.36.62-.89.34-.47.56-.72.48-.59.48-.54.83-.88.53-.53.42-.39.7-.62.43-.35.78-.59.38-.27 1.19-.76c.506-.294 1.03-.554 1.57-.78l.49-.2.88-.3.56-.16.51-.11.66-.1.37-.04.8-.02h.18c.309.019.616.059.92.12a1.74 1.74 0 0 1 .22.05c.23.05.46.12.69.2l.21.07c.28.11.56.24.82.39L53.67 12c-.02-.01-.05-.03-.07-.04l-.63-.31c-.04-.02-.08-.03-.12-.04-.07-.03-.14-.05-.21-.07l-.33-.12-.36-.08a1.74 1.74 0 0 0-.22-.05l-.12-.03-.75-.09h-.05-.18c-.2-.01-.39-.01-.6 0-.07 0-.14.02-.2.02l-.37.04-.35.04-.31.07-.51.11-.28.06c-.09.02-.19.07-.28.1l-.88.3-.31.11c-.06.02-.12.06-.18.09-.51.22-1.03.47-1.57.78l-1.19.76-.38.27-.78.59-.43.36-.7.61-.42.39-.26.24-.27.28-.83.89-.26.28-.21.26-.49.59-.32.38-.24.33-.35.47-.24.32-.38.57-.24.36-.1.15-.64 1.06c-.01.02-.03.05-.04.07l-.12.22-.43.76-.18.36-.19.37-.17.33-.4.88-.07.16c-.01.01-.01.03-.02.04l-.46 1.12c-.03.07-.05.14-.07.2l-.15.41-.2.56-.13.44-.16.51-.1.32-.14.57-.16.64a1.74 1.74 0 0 0-.05.22l-.08.46-.17.99c-.01.09-.04.18-.05.28l-.02.25c-.09.723-.137 1.451-.14 2.18l.04.82-5.4 3.12c-.53.3-1.04.66-1.54 1.04l-.26.2c-.48.38-.94.79-1.4 1.23-.04.04-.08.06-.11.1l-.22.23-.67.71-.21.22-.18.21-.39.48-.25.3-.2.28-.28.38-.18.25-.31.46c-.06.1-.13.19-.2.29-.03.04-.05.08-.08.12l-.52.85-.03.06c-.03.06-.06.12-.1.17l-.34.62a2.59 2.59 0 0 0-.14.29l-.15.3c-.04.09-.09.18-.14.27l-.31.68c-.02.05-.05.1-.07.15-.01.01-.01.03-.02.04l-.37.9a.89.89 0 0 0-.05.15l-.12.33-.17.47c-.04.11-.07.22-.1.34l-.13.41-.08.27-.11.44-.13.51a1.31 1.31 0 0 1-.05.19c-.03.12-.04.24-.06.37l-.13.78-.04.23c-.01.07-.01.13-.01.2a14.78 14.78 0 0 0-.11 1.73c.01 3.14 1.13 5.35 2.93 6.4l4.25 2.47c-1.8-1.04-2.92-3.26-2.93-6.4 0-.57.05-1.15.11-1.73l.05-.43.13-.78.11-.56.13-.51.19-.71.13-.41.27-.81.12-.32.44-1.1c.02-.05.05-.1.07-.15l.45-.95.15-.3.49-.9a.95.95 0 0 1 .1-.17l.63-1.03.19-.29.5-.72.28-.38.45-.58.39-.48.39-.44.66-.71.33-.33c.45-.44.92-.85 1.4-1.23l.26-.2c.5-.38 1.02-.74 1.54-1.04l5.4-3.12-.04-.82c0-.71.06-1.45.14-2.18.05-.15.07-.32.09-.5z\" fill=\"url(#D)\"/><path d=\"M49.07 15.35c6.88-3.97 12.49-.78 12.51 7.13 0 .29-.03.58-.04.86l2.6-1.5c5.5-3.18 10.01-.59 10.03 5.73 0 .5-.03 1-.08 1.52l4.37-2.52c2.46-1.42 4.49-.28 4.5 2.56.01 2.83-2 6.3-4.47 7.72L31.15 64.19c-.7.41-1.35.58-1.93.6-4.49 1.45-7.9-1.19-7.92-6.68-.02-6.32 4.48-14.11 9.98-17.28l5.4-3.12c-.01-.27-.04-.53-.04-.82-.03-7.92 5.54-17.56 12.43-21.54z\" fill=\"url(#E)\"/><use xlink:href=\"#L\" fill=\"url(#F)\"/><path d=\"M68.75 57.24c-.36.82-.53 1.54-.53 2.26.01 2.05 1.53 2.82 3.4 1.73 1.87-1.08 3.3-3.55 3.29-5.6.09-.67-.09-1.18-.45-1.38-.35-.27-1.41-.98-2.14-1.46-.39-.26-.93-.14-1.16.27l-2.41 4.18z\" fill=\"url(#G)\"/><path d=\"M72.59 40.49c-.36.82-.53 1.54-.53 2.26.01 2.05 1.53 2.82 3.4 1.73 1.87-1.08 3.3-3.55 3.29-5.6.09-.67-.09-1.18-.45-1.38-.35-.27-1.41-.98-2.14-1.46-.39-.26-.93-.14-1.16.27l-2.41 4.18z\" fill=\"url(#H)\"/><path d=\"M31.41 76.85c-.36.82-.53 1.54-.53 2.26.01 2.05 1.53 2.82 3.4 1.73 1.87-1.08 3.3-3.55 3.29-5.6.09-.67-.09-1.18-.45-1.38-.35-.27-1.41-.98-2.14-1.46-.39-.26-.93-.14-1.16.27l-2.41 4.18z\" fill=\"url(#I)\"/></g></g><defs><linearGradient id=\"A\" x1=\"20.492\" y1=\"62.584\" x2=\"67.716\" y2=\"62.584\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"58.119\" y1=\"26.295\" x2=\"92.42\" y2=\"26.295\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"35.182\" y1=\"20.684\" x2=\"99.875\" y2=\"20.684\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"6.802\" y1=\"37.84\" x2=\"129.884\" y2=\"37.84\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".126\" stop-color=\"#f4ebfa\"/><stop offset=\".385\" stop-color=\"#d6b8ec\"/><stop offset=\".749\" stop-color=\"#a767d5\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"-1.336\" y1=\"39.413\" x2=\"106.071\" y2=\"39.413\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"27.29\" y1=\"60.821\" x2=\"43.685\" y2=\"60.821\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"61.893\" y1=\"57.188\" x2=\"78.288\" y2=\"57.188\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"68.812\" y1=\"40.434\" x2=\"102.743\" y2=\"40.434\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"27.317\" y1=\"76.793\" x2=\"61.248\" y2=\"76.793\" xlink:href=\"#M\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"J\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"K\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><path id=\"L\" d=\"M34.77 60.87c-.36.82-.53 1.54-.53 2.26.01 2.05 1.53 2.82 3.4 1.73 1.87-1.08 3.3-3.55 3.29-5.6.09-.67-.09-1.18-.45-1.38-.35-.27-1.41-.98-2.14-1.46-.39-.26-.93-.14-1.16.27l-2.41 4.18z\"/><linearGradient id=\"M\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgVehicleRicourseWaiver = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#H)\"><g clip-path=\"url(#I)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M40.37 17.75L22.33 28.17c-.36.21-.65-.01-.65-.49v-2.26c0-.48.29-1.04.65-1.25l18.04-10.42c.36-.21.65.01.65.49v2.26c0 .49-.29 1.05-.65 1.25z\" fill=\"url(#A)\"/><path d=\"M73.43 67.57c-.2 0-.38-.11-.47-.3a.52.52 0 0 1 .25-.69l.31-.16c1.32-.76 2.53-2.42 3.01-4.12.08-.28.36-.44.64-.36s.44.36.36.64c-.55 1.98-1.92 3.84-3.49 4.74-.13.08-.26.15-.4.21-.06.02-.13.04-.21.04z\" fill=\"#e3d4ff\"/><path d=\"M80.76 61.18c-.16-.71-.55-1.39-1.19-1.93-1.03-.86-2.51-1.06-3.72-.49a3.53 3.53 0 0 0-1.888 2.153 3.53 3.53 0 0 0 .33 2.845 3.53 3.53 0 0 0 2.331 1.664 3.53 3.53 0 0 0 2.798-.612c.15-.11.73-.68.82-1.1l.78.78.83-.57.57.91.88-.65.64.88 1.03-.51.64.87.92-.52.67.85c.05.07.15.08.22.03l1.46-1.17c.07-.05.09-.15.03-.23l-1.25-1.7-6.9-1.5zm-2.9 1.7c-.51.38-1.23.27-1.61-.25-.38-.51-.27-1.23.25-1.61.51-.38 1.23-.27 1.61.25.37.52.26 1.24-.25 1.61z\" fill=\"url(#B)\"/><path d=\"M72.38 66.82a.52.52 0 0 1-.42-.22c-.16-.23-.11-.56.13-.72l1.15-.81-4.09-2.27-1.88.2c-.31.03-.54-.18-.57-.46s.18-.54.46-.57l2.05-.21a.56.56 0 0 1 .31.06l4.95 2.75a.51.51 0 0 1 .26.42.5.5 0 0 1-.22.45l-1.82 1.28a.52.52 0 0 1-.31.1z\" fill=\"url(#C)\"/><path d=\"M72.22 67.86a2.33 2.33 0 0 1-1.25-.35c-.76-.49-1.18-1.42-1.18-2.62 0-2.4 1.64-5.23 3.73-6.44 1.1-.63 2.16-.72 2.98-.25s1.27 1.42 1.27 2.67a6.14 6.14 0 0 1-.25 1.7c-.08.27-.36.44-.64.36s-.44-.36-.36-.64c.14-.5.21-.97.21-1.42 0-.87-.27-1.5-.75-1.78-.49-.28-1.18-.2-1.95.25-1.77 1.02-3.22 3.51-3.22 5.54 0 .84.25 1.46.71 1.75.42.27 1.02.25 1.68-.06a.52.52 0 0 1 .69.25.52.52 0 0 1-.25.69c-.48.24-.97.35-1.42.35z\" fill=\"#e3d4ff\"/><path d=\"M73.3 66.68c.02-1.06-.72-2.19-2-2.93l-1.26-.73c-2.21-1.27-6.39-1.63-8.57-.36l-5.39 3.84c-1.09.64-1.64 1.47-1.64 2.3l-.01 3.52c0 .84.55 1.68 1.66 2.32l1.26.73c.25.15.52.28.81.39.01.01.03.01.05.02l.14.05.5.17c.09.03.19.05.28.07l.16.04c.05.01.09.02.14.04l.56.1.2.02c.05.01.09.01.14.02.07.01.13.02.2.02.183.02.366.03.55.03h.18.15.25l.62-.04c.02 0 .05-.01.07-.01.06-.01.11-.02.17-.02l.48-.07c.07-.01.13-.04.2-.05l.56-.14c.1-.03.2-.04.3-.07l.23-.09c.07-.03.15-.05.22-.08.28-.11.54-.23.79-.37l6.62-3.13c.02-.01.03-.02.05-.03.197-.118.381-.255.55-.41.02-.02.02-.02.02-.03.1-.09.19-.19.27-.29.04-.05.07-.11.11-.16.02-.02.03-.05.05-.07.01-.02.03-.04.04-.06.06-.1.1-.2.14-.3l.03-.11.03-.09c.01-.04.03-.08.03-.12.02-.12.04-.24.04-.36v-.06l.01-3.53c.02.01.01.02.01.03zm-.75 1.6c-.01.01-.04.02-.05.04.03-.02.05-.05.08-.07-.01.01-.01.01-.01.02-.01 0-.01.01-.02.01zm.41-.48l.05-.08c0 .01-.01.01-.01.02-.02.02-.03.04-.04.06zM55 70.22c.03.042.064.082.1.12-.036-.038-.07-.078-.1-.12zm-.54-1.24c0 .05 0 .1.01.15 0-.05 0-.1-.01-.15zm.06.32c.01.05.02.1.04.14-.02-.05-.03-.09-.04-.14zm.1.31l.06.14-.06-.14zm.16.31c.03.04.05.09.08.13l-.08-.13zm.94.96l-.12-.09.12.09zm-.33-.26c-.04-.04-.08-.07-.11-.11.03.03.06.07.11.11z\" fill=\"url(#D)\"/><path d=\"M69.64 64.42l-.96-.55c-1.71-.99-4.96-1.31-6.77-.26l-4.09 2.92c-.88.51-1.36 1.2-1.36 1.94 0 .75.49 1.44 1.38 1.95l.96.55c.87.5 2.01.75 3.15.75s2.27-.25 3.12-.75l5.07-2.4c.74-.43 1.14-1.06 1.14-1.78 0-.87-.63-1.79-1.64-2.37zm-4.77 6.17c-1.61.93-4.24.93-5.85 0l-.96-.55c-.75-.43-1.16-.99-1.16-1.58 0-.58.4-1.14 1.16-1.58l2.24-1.59 7.11 4.1-2.54 1.2zm5.06-2.39l-2.06.97-7.19-4.15 1.47-1.05c.69-.4 1.65-.58 2.64-.58 1.35 0 2.77.33 3.68.85l.96.55c.87.5 1.42 1.27 1.42 2 0 .58-.32 1.06-.92 1.41z\" fill=\"#fff\"/><path d=\"M58.32 73.19l-2.1-1.21c-.12-.07-.31-.07-.43 0l-4.1 2.38c-.06.03-.08.08-.08.12v.61c0 .04.03.09.08.12l.22.13-5.33 3.1-.07.07-.42.87c-.01.026-.01.054 0 .08 0-.01-.01-.02-.01-.03v.61c0 .05.03.09.09.12.01.01.03.01.04.02.01 0 .02.01.04.01.01 0 .02.01.03.01h.02.03.03.03.03l1.44-.13.17-.05 10.29-5.98c.01-.01.03-.02.04-.03l.02-.02c0-.01 0-.02.01-.02 0-.01.01-.01.01-.02v-.04-.61c0 .01-.01.03-.01.04.03-.04.01-.1-.07-.15zm-6.02 1.85c0-.04-.03-.09-.08-.12.06.04.08.08.08.12zm-.68-.52c0 .01 0 .02.01.02-.01 0-.01-.01-.01-.02zm-5.52 4.96c.01.03.04.05.07.07-.04-.02-.06-.04-.07-.07zm12.29-6.1c-.01.02-.04.04-.07.06.03-.02.05-.04.07-.06z\" fill=\"url(#E)\"/><path d=\"M49.28 62.94L17.67 81.19a.99.99 0 0 1-.987-.004.99.99 0 0 1-.493-.856V30.42a1.01 1.01 0 0 1 .49-.86l31.61-18.25a.99.99 0 0 1 .987.004.99.99 0 0 1 .493.856v49.91a.97.97 0 0 1-.49.86z\" fill=\"url(#F)\"/><g fill=\"#fff\"><path d=\"M20.98 37.17a.58.58 0 0 1-.49-.28c-.16-.27-.06-.61.21-.77l24.01-13.86c.26-.16.61-.06.77.21s.06.61-.21.77L21.26 37.1a.58.58 0 0 1-.28.07z\"/><path d=\"M20.98 43.54a.58.58 0 0 1-.49-.28c-.16-.27-.06-.61.21-.77l24.01-13.86c.26-.16.61-.06.77.21s.06.61-.21.77L21.26 43.46c-.09.05-.19.08-.28.08z\"/><path d=\"M20.98 49.9a.58.58 0 0 1-.49-.28c-.16-.27-.06-.61.21-.77l24.01-13.86c.26-.16.61-.06.77.21s.06.61-.21.77L21.26 49.83a.58.58 0 0 1-.28.07z\"/><path d=\"M20.98 56.27a.58.58 0 0 1-.49-.28c-.16-.27-.06-.61.21-.77l24.01-13.86c.26-.15.61-.06.77.21s.06.61-.21.77L21.26 56.19c-.09.05-.19.08-.28.08z\"/><path d=\"M20.98 62.63a.58.58 0 0 1-.49-.28c-.16-.27-.06-.61.21-.77l24.01-13.86c.26-.15.61-.06.77.21s.06.61-.21.77L21.26 62.56a.58.58 0 0 1-.28.07zm13.96 2.12a.23.23 0 0 1-.14-.04.27.27 0 0 1-.08-.37l.97-1.6c-.05-.93.08-2.27.96-3.5.25-.35.49-.49.73-.42.24.08.32.33.23.75-.24 1.12-.78 2.25-1.37 3.3.03.36.09.63.12.79.02.1.1.41.21.45.06.02.38.06 1.29-1.07l1.88-2.34c.1-.12.19-.23.32-.29.17-.08.3-.04.36-.01.2.1.25.33.29.53l.03.15c.02.06.04.07.06.07.1.03.34-.04.56-.23.39-.33.73-.86 1.02-1.33.05-.08.13-.12.23-.12.09 0 .18.05.22.12.09.14.23.22.43.22h.02c.4 0 1-.29 1.48-.96.02-.028.046-.052.076-.07s.063-.031.097-.036.069-.004.103.004.066.023.094.043.052.046.07.076.031.063.036.097.004.069-.004.103-.023.066-.043.094c-.53.74-1.26 1.19-1.95 1.18a1.17 1.17 0 0 1-.59-.18c-.27.42-.58.86-.95 1.17-.36.3-.75.42-1.06.33-.2-.06-.35-.22-.41-.43-.02-.06-.03-.12-.04-.19 0-.01 0-.02-.01-.03-.01.01-.02.03-.03.03l-1.88 2.33c-.56.69-1.27 1.45-1.89 1.24-.38-.14-.49-.59-.55-.83l-.04-.18-.62 1.02c-.05.09-.14.13-.23.13zm2.11-5.16c-.48.7-.71 1.43-.79 2.09.34-.69.62-1.39.79-2.09z\"/></g><path d=\"M41.68 14.03l-7.23 4.18c.24-.54.38-1.11.38-1.63 0-1.38-.97-1.93-2.17-1.24s-2.17 2.37-2.17 3.75c0 .52.14.93.38 1.19l-7.23 4.18c-.36.21-.65.77-.65 1.25v2.26c0 .48.29.7.65.49l18.04-10.42c.36-.21.65-.77.65-1.25v-2.26c.01-.48-.29-.7-.65-.5zm-9.02 2.68c.54-.31.97-.06.97.55s-.44 1.37-.97 1.68c-.54.31-.98.06-.98-.55.01-.61.44-1.37.98-1.68z\" fill=\"url(#G)\"/></g></g><defs><linearGradient id=\"A\" x1=\"1.16\" y1=\"20.959\" x2=\"44.577\" y2=\"20.959\" xlink:href=\"#J\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"61.028\" y1=\"62.128\" x2=\"101.387\" y2=\"62.128\" xlink:href=\"#J\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"62.453\" y1=\"64.281\" x2=\"78.218\" y2=\"64.281\" xlink:href=\"#J\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"50.569\" y1=\"69.11\" x2=\"75.624\" y2=\"69.11\" xlink:href=\"#J\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"41.556\" y1=\"76.067\" x2=\"69.836\" y2=\"76.067\" xlink:href=\"#J\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"8.195\" y1=\"46.252\" x2=\"55.487\" y2=\"46.252\" xlink:href=\"#J\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"17.744\" y1=\"21.245\" x2=\"87.323\" y2=\"21.245\" xlink:href=\"#J\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"H\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"I\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"J\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgVehicleRoadsideAssistance = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#j)\"><g clip-path=\"url(#k)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M74.18 53.94a4.66 4.66 0 0 1 .34-.58c.11-.16.23-.3.36-.44.06-.07.11-.14.18-.2.195-.186.41-.35.64-.49L48.37 68.11c-.23.13-.44.3-.64.48-.06.06-.12.13-.18.2-.13.14-.25.28-.36.44-.02.03-.05.05-.07.08-.1.15-.19.32-.27.49l-.17.41c-.05.12-.09.25-.13.38 0 .01-.01.02-.01.04l27.33-15.88c.09-.28.19-.55.31-.81z\" fill=\"url(#A)\"/><path d=\"M39.39 33.85a4.65 4.65 0 0 1 .34-.58c.11-.16.23-.3.36-.44.06-.07.11-.14.18-.2.2-.19.41-.35.64-.48L13.57 48.02a3.3 3.3 0 0 0-.64.49c-.06.06-.12.13-.18.2-.13.14-.25.28-.36.44-.02.03-.05.05-.07.08-.1.16-.19.32-.27.5l-.17.41c-.05.12-.09.25-.13.38 0 .01-.01.02-.01.04l27.33-15.88.32-.83z\" fill=\"url(#B)\"/><path d=\"M19.88 59.15l5.98-3.47c-.08.05-.17.09-.26.12l-.2.06c-.02 0-.03.01-.05.01a1.07 1.07 0 0 1-.25.03h-.05-.26-.03l-.28-.04c-.01 0-.02 0-.03-.01-.1-.02-.19-.05-.29-.08-.01 0-.01 0-.02-.01l-.32-.13c-.01 0-.01-.01-.02-.01l-.33-.17-.34-.21c-.01 0-.01-.01-.02-.02l-.3-.23-.03-.03c-.098-.078-.191-.162-.28-.25l-.03-.03-.28-.28c-.01-.01-.01-.02-.02-.02-.1-.1-.19-.21-.28-.32l-.27-.36c0-.01-.01-.01-.01-.02-.08-.1-.15-.21-.22-.32-.05-.07-.09-.15-.14-.22l-.11-.18c-.02-.03-.03-.06-.05-.09l-.17-.31c-.01-.01-.01-.02-.02-.03l-.18-.39c0-.01-.01-.01-.01-.02l-.16-.39c0-.01-.01-.02-.01-.03-.05-.13-.09-.27-.13-.4 0-.01 0-.01-.01-.02l-.1-.39c0-.01-.01-.02-.01-.04l-.08-.39-.05-.4v-.03l-.02-.39a4.35 4.35 0 0 1 .02-.37v-.03c.01-.11.03-.21.05-.31 0-.01.01-.03.01-.04l.07-.28c.01-.02.01-.03.02-.05.03-.08.06-.17.1-.24 0-.01.01-.01.01-.02.04-.09.09-.17.13-.24.07-.11.15-.2.23-.29l.06-.06c.09-.08.18-.16.28-.22l-5.98 3.47c-.1.06-.2.13-.28.22l-.06.06c-.08.09-.16.18-.23.29a1.71 1.71 0 0 0-.13.23c0 .02-.01.03-.01.03l-.07.16-.03.08c-.01.02-.01.03-.02.05 0 .02-.01.03-.02.05-.02.06-.03.11-.04.17 0 .02-.01.04-.01.06 0 .01-.01.03-.01.04 0 .02-.01.04-.01.06-.01.05-.02.11-.02.16 0 .03-.01.06-.01.09v.03.04c0 .05-.01.1-.01.16v.16.16c-.002.053.002.107.01.16-.002.027.002.054.01.08v.03.06c.01.05.01.11.02.16.01.06.02.11.02.17l.03.17c.01.06.02.12.04.17 0 .02.01.04.02.07 0 .01.01.02.01.04.01.02.01.05.02.07a1.21 1.21 0 0 0 .05.18c.01.04.03.09.04.13 0 .01 0 .02.01.02 0 .01 0 .01.01.02l.06.17.06.17c0 .01.01.02.01.03s.01.02.01.03c.01.03.03.07.04.1.02.05.04.11.07.16.02.04.03.08.05.12 0 .01.01.01.01.02s.01.01.01.02l.07.16.09.18c0 .01.01.02.01.03.01.01.01.02.02.04.02.05.05.09.07.14a.95.95 0 0 0 .1.17c.02.03.03.06.05.09.01.01.01.02.02.03l.09.14c.05.07.09.15.14.22.01.01.01.02.02.04.06.1.13.19.2.29 0 .01.01.01.01.02l.15.2.12.15c.04.06.09.11.13.16l.13.15.02.02.02.02c.03.03.06.07.1.1l.14.14.04.04.03.03.07.07.15.13c.02.02.04.03.06.05l.03.03c.02.01.03.03.05.04l.15.11c.03.03.07.05.11.07.01 0 .01.01.02.02.01 0 .01.01.02.01l.14.09.14.09c.01.01.02.01.03.02l.11.06c.05.02.09.05.14.07.03.01.06.03.09.04.01 0 .01.01.02.01s.02.01.02.01l.13.06c.05.02.09.04.14.05.01 0 .02.01.02.01.01 0 .01 0 .02.01l.09.03c.05.01.09.03.14.04.02.01.05.01.07.02.01 0 .02 0 .03.01.01 0 .03.01.04.01a.77.77 0 0 0 .15.02c.03 0 .06.01.09.01h.03.03c.05 0 .11.01.16.01h.07.05.05l.19-.03c.02 0 .03-.01.05-.01.06-.01.13-.03.18-.05l.24-.13z\" fill=\"#fff\"/><path d=\"M28.46 54.24l-.01-.24c0-.04-.01-.07-.01-.11v-.05c0-.03 0-.05-.01-.08l-.03-.24-.04-.25c-.01-.1-.03-.17-.04-.25l-.05-.26c-.01-.03-.01-.06-.02-.1 0-.02-.01-.04-.01-.06l-.03-.11-.07-.26-.06-.2c0-.01-.01-.02-.01-.03s-.01-.02-.01-.03l-.08-.26-.09-.25c-.01-.02-.01-.03-.02-.05 0-.01-.01-.03-.01-.04l-.06-.16-.1-.24c-.02-.06-.05-.12-.08-.18 0-.01-.01-.02-.01-.03s-.01-.02-.01-.03l-.11-.24-.13-.26c-.01-.01-.01-.03-.02-.04-.01-.02-.02-.03-.03-.05l-.11-.21-.14-.26-.07-.13c-.01-.02-.02-.03-.03-.05l-.13-.21-.21-.33c-.01-.02-.02-.04-.03-.05l-.3-.42-.02-.02-.22-.29-.18-.22c-.01-.01-.01-.01-.01-.02l-.19-.23-.19-.22-.03-.03-.03-.03-.14-.15-.21-.21-.06-.06-.05-.05c-.04-.03-.07-.07-.11-.1-.07-.07-.15-.13-.22-.19-.03-.03-.06-.05-.1-.08-.02-.01-.03-.03-.05-.04-.03-.02-.05-.04-.08-.06-.07-.06-.14-.11-.22-.17-.05-.04-.1-.08-.16-.11-.01-.01-.02-.01-.03-.02s-.02-.01-.03-.02l-.21-.14-.21-.13c-.02-.01-.03-.02-.05-.03l-.16-.09-.2-.11-.13-.06c-.01 0-.02-.01-.03-.01-.01-.01-.03-.01-.04-.02-.07-.03-.13-.06-.2-.08l-.2-.08c-.01 0-.02-.01-.04-.01-.01 0-.02-.01-.03-.01-.04-.01-.09-.03-.13-.04l-.21-.06c-.03-.01-.07-.01-.1-.02-.01 0-.03-.01-.04-.01-.02 0-.04-.01-.06-.01l-.22-.04c-.05-.01-.09-.01-.13-.01h-.04-.04c-.08-.01-.16-.01-.23-.01h-.1-.08H21l-.29.04c-.03 0-.05.01-.08.02-.09.02-.19.04-.28.08-.01 0-.01.01-.02.01a2.64 2.64 0 0 0-.38.18l-5.98 3.47a2.64 2.64 0 0 1 .38-.18c.1-.04.2-.06.3-.09.02-.01.04-.01.07-.02l.37-.05h.08l.38.01h.04c.14.01.27.03.41.06.01 0 .03.01.04.01a4.19 4.19 0 0 1 .44.12c.01 0 .02.01.03.01.16.05.31.12.47.19.01 0 .02.01.03.01l.49.26.5.32c.01.01.02.01.03.02l.45.34c.02.01.03.03.05.04l.42.37.05.05.41.41.03.03.42.48.41.53c.01.01.01.01.01.02l.33.48.21.33.16.27c.03.04.05.09.07.13l.25.46c.01.02.02.03.03.05l.27.58c0 .01.01.02.01.03l.23.58c0 .01.01.03.01.04l.2.59c0 .01.01.02.01.03l.15.57c0 .02.01.04.01.05l.12.59.07.6v.05c.017.193.023.386.02.58s-.01.37-.03.55v.05l-.07.46c0 .02-.01.04-.01.06-.03.14-.07.28-.11.41-.01.02-.02.05-.02.07-.039.123-.086.243-.14.36-.01.01-.01.02-.01.03-.06.13-.13.25-.2.36-.01.02-.02.03-.03.05-.058.087-.121.171-.19.25-.02.03-.05.06-.08.08l-.19.18c-.03.02-.05.05-.08.07-.09.07-.19.14-.29.2L27 57.66c.1-.06.2-.13.29-.2.03-.02.05-.05.08-.07l.19-.18c.03-.03.05-.06.08-.08.069-.079.132-.163.19-.25.01-.02.02-.03.03-.05.074-.112.141-.229.2-.35.01-.02.01-.03.01-.04.04-.08.07-.16.1-.24.01-.04.03-.08.04-.12.01-.02.02-.05.02-.07.01-.02.02-.04.02-.07l.07-.25c.01-.03.01-.06.02-.09 0-.02.01-.04.01-.06.01-.03.01-.06.02-.09l.04-.24c.01-.04.01-.09.01-.13v-.05c0-.02 0-.04.01-.06.01-.08.01-.15.01-.23l.01-.24c.01-.11.01-.19.01-.26z\" fill=\"url(#C)\"/><path d=\"M17.52 49.33c2.75 1.59 4.98 5.45 4.97 8.6-.01 3.16-2.25 4.44-5 2.85s-4.98-5.45-4.97-8.6c0-3.16 2.25-4.44 5-2.85zm-.03 9.59c1.85 1.07 3.36.21 3.37-1.92s-1.5-4.73-3.35-5.8-3.36-.21-3.37 1.92 1.5 4.73 3.35 5.8z\" fill=\"url(#D)\"/><use xlink:href=\"#l\" fill=\"url(#E)\"/><path d=\"M54.96 79.01l5.98-3.47c-.08.05-.17.09-.26.12l-.2.06c-.02 0-.03.01-.05.01a1.07 1.07 0 0 1-.25.03h-.05-.26-.03l-.28-.04c-.01 0-.02 0-.03-.01-.1-.02-.19-.05-.29-.08-.01 0-.01 0-.02-.01l-.32-.13c-.01 0-.01-.01-.02-.01l-.33-.17-.34-.21c-.01 0-.01-.01-.02-.02l-.3-.23-.03-.03a3.35 3.35 0 0 1-.28-.25l-.03-.03-.28-.28c-.01-.01-.01-.02-.02-.02-.1-.1-.19-.21-.28-.32l-.27-.36c0-.01-.01-.01-.01-.02-.08-.1-.15-.21-.22-.32-.05-.07-.09-.15-.14-.22l-.11-.18c-.02-.03-.03-.06-.05-.09l-.17-.31c-.01-.01-.01-.02-.02-.03L55.8 72c0-.01-.01-.01-.01-.02l-.16-.39c0-.01-.01-.02-.01-.03-.05-.13-.09-.27-.13-.4 0-.01 0-.01-.01-.02l-.1-.39c0-.01-.01-.02-.01-.04l-.08-.39-.05-.4v-.03l-.02-.39a4.35 4.35 0 0 1 .02-.37v-.03c.01-.11.03-.21.05-.31 0-.01.01-.03.01-.04l.07-.28c.01-.02.01-.03.02-.05.03-.08.06-.17.1-.24 0-.01.01-.01.01-.02.04-.09.09-.17.13-.24.07-.11.15-.2.23-.29l.06-.06c.09-.08.18-.16.28-.22l-5.98 3.47c-.1.06-.2.13-.28.22l-.06.06c-.08.09-.16.18-.23.29-.05.07-.09.15-.13.23 0 .02-.01.03-.01.03l-.07.16-.03.08c-.01.02-.01.03-.02.05 0 .02-.01.03-.02.05-.02.06-.03.11-.04.17 0 .02-.01.04-.01.06 0 .01-.01.03-.01.04 0 .02-.01.04-.01.06-.01.05-.02.11-.02.16 0 .03-.01.06-.01.09v.03.04c0 .05-.01.1-.01.16v.16.16c-.002.053.002.107.01.16-.002.027.002.054.01.08v.03.06c.01.05.01.11.02.16.01.06.02.11.02.17v.02l.03.15c.01.06.02.12.04.17 0 .02.01.04.02.07 0 .01.01.02.01.04.01.02.01.05.02.07.01.06.03.12.05.18.01.04.03.09.04.13 0 .01 0 .02.01.02 0 .01 0 .01.01.02l.06.17.06.17c0 .01.01.02.01.03s.01.02.01.03c.01.03.03.07.04.1.02.05.04.11.07.16.02.04.03.08.05.12 0 .01.01.01.01.02s.01.01.01.02l.07.16.09.18c0 .01.01.02.01.03.01.01.01.02.02.04.02.05.05.09.07.14.027.06.061.117.1.17.02.03.03.06.05.09.01.01.01.02.02.03l.09.14c.05.07.09.15.14.22.01.01.01.02.02.04.06.1.13.19.2.29 0 .01.01.01.01.02l.15.2.12.15c.04.06.09.11.13.16l.13.15.02.02.02.02c.03.03.06.07.1.1l.14.14.04.04.03.03.07.07.15.13c.02.02.04.03.06.05l.03.03c.02.01.03.03.05.04l.15.11c.03.03.07.05.11.07.01 0 .01.01.02.02.01 0 .01.01.02.01l.14.09.14.09c.01.01.02.01.03.02l.11.06c.05.02.09.05.14.07.03.01.06.03.09.04.01 0 .01.01.02.01s.02.01.02.01l.13.06c.05.02.09.04.14.05.01 0 .02.01.02.01.01 0 .01 0 .02.01l.09.03c.05.01.09.03.14.04.02.01.05.01.07.02.01 0 .02 0 .03.01.01 0 .03.01.04.01.049.012.099.018.15.02.03 0 .06.01.09.01h.03.03c.05 0 .11.01.16.01h.07.05.05l.19-.03c.02 0 .03-.01.05-.01.06-.01.13-.03.18-.05l.24-.13z\" fill=\"#fff\"/><path d=\"M63.54 74.1l-.01-.24c0-.04-.01-.07-.01-.11v-.05a.22.22 0 0 0-.01-.08l-.03-.24-.04-.25v-.02l-.04-.23-.05-.26c-.01-.03-.01-.06-.02-.1 0-.02-.01-.04-.01-.06l-.03-.11-.07-.26-.06-.2c0-.01-.01-.02-.01-.03s-.01-.02-.01-.03l-.08-.26-.09-.25c-.01-.02-.01-.03-.02-.05 0-.01-.01-.03-.01-.04l-.06-.16-.1-.24c-.02-.06-.05-.12-.08-.18 0-.01-.01-.02-.01-.03s-.01-.02-.01-.03l-.11-.24-.13-.26c-.01-.01-.01-.03-.02-.04-.01-.02-.02-.03-.03-.05l-.11-.21-.14-.26-.07-.13c-.01-.02-.02-.03-.03-.05l-.13-.21-.21-.33c-.01-.02-.02-.04-.03-.05l-.3-.42-.02-.02-.22-.29-.18-.22c-.01-.01-.01-.01-.01-.02l-.19-.23-.19-.22-.03-.03-.03-.03-.14-.15-.21-.21-.06-.06-.05-.05c-.04-.03-.07-.07-.11-.1-.07-.07-.15-.13-.22-.19-.03-.03-.06-.05-.1-.08-.02-.01-.03-.03-.05-.04-.03-.02-.05-.04-.08-.06-.07-.06-.14-.11-.22-.17-.05-.04-.1-.07-.16-.11-.01-.01-.02-.01-.03-.02s-.02-.01-.03-.02l-.21-.14-.21-.13c-.02-.01-.03-.02-.05-.03l-.16-.09-.2-.11-.13-.06c-.01 0-.02-.01-.03-.01-.01-.01-.03-.01-.04-.02-.07-.03-.13-.06-.2-.08l-.2-.08c-.01 0-.02-.01-.04-.01-.01 0-.02-.01-.03-.01-.04-.01-.09-.03-.13-.04l-.21-.06c-.03-.01-.07-.01-.1-.02-.01 0-.03-.01-.04-.01-.02 0-.04-.01-.06-.01l-.22-.04c-.05-.01-.09-.01-.13-.01h-.04-.04c-.08-.01-.16-.01-.23-.01h-.1-.08-.08l-.29.04c-.03 0-.05.01-.08.02-.09.02-.19.04-.28.08-.01 0-.01.01-.02.01-.131.05-.258.11-.38.18l-5.98 3.47c.122-.07.249-.13.38-.18.1-.04.2-.06.3-.09.02-.01.04-.01.07-.02l.37-.05h.08l.38.01h.04c.14.01.27.03.41.06.01 0 .03.01.04.01.149.032.296.072.44.12.01 0 .02.01.03.01.16.05.31.12.47.19.01 0 .02.01.03.01l.49.26.5.32c.01.01.02.01.03.02l.45.34c.02.01.03.03.05.04l.42.37.05.05.41.41.03.03.42.48.41.53c.01.01.01.01.01.02l.33.48.21.33.16.27c.03.04.05.09.07.13l.25.46c.01.02.02.03.03.05l.27.58c0 .01.01.02.01.03l.23.58c0 .01.01.03.01.04l.2.59c0 .01.01.02.01.03l.15.57c0 .02.01.04.01.05l.12.59.07.6v.05c.017.193.023.386.02.58s-.01.37-.03.55v.05l-.07.46c0 .02-.01.04-.01.06-.03.14-.07.28-.11.41-.01.02-.02.05-.02.07-.039.123-.086.243-.14.36-.01.01-.01.02-.01.03-.06.13-.13.25-.2.36-.01.02-.02.03-.03.05a2.34 2.34 0 0 1-.19.25c-.02.03-.05.06-.08.08l-.19.18c-.03.02-.05.05-.08.07-.09.07-.19.14-.29.2l5.98-3.47c.1-.06.2-.13.29-.2.03-.02.05-.05.08-.07l.19-.18c.03-.03.05-.06.08-.08.069-.079.132-.163.19-.25.01-.02.02-.03.03-.05a3.11 3.11 0 0 0 .2-.35c.01-.02.01-.03.01-.04.04-.08.07-.16.1-.24.01-.04.03-.08.04-.12.01-.02.02-.05.02-.07.01-.02.02-.04.02-.07l.07-.25c.01-.03.01-.06.02-.09 0-.02.01-.04.01-.06.01-.03.01-.06.02-.09l.04-.24c.01-.04.01-.09.01-.13v-.05c0-.02 0-.04.01-.06.01-.08.01-.15.01-.23l.01-.24c.05-.1.05-.18.05-.25z\" fill=\"url(#F)\"/><path d=\"M52.6 69.19c2.75 1.59 4.98 5.45 4.97 8.6-.01 3.16-2.25 4.44-5 2.85s-4.98-5.45-4.97-8.6c0-3.16 2.25-4.43 5-2.85zm-.03 9.59c1.85 1.07 3.36.21 3.37-1.92s-1.5-4.73-3.35-5.8-3.36-.21-3.37 1.92 1.5 4.73 3.35 5.8z\" fill=\"url(#G)\"/><path d=\"M50.65 73.89c0 1.19.89 2.82 1.93 3.41s1.93.15 1.93-1.04-.89-2.82-1.93-3.41c-1.04-.74-1.93-.15-1.93 1.04z\" fill=\"url(#H)\"/><path d=\"M8.45 39.32l26.01-15.11a2.62 2.62 0 0 1 2.65 0l33.95 19.6-27.34 15.87L8.45 39.32z\" fill=\"url(#I)\"/><path d=\"M13.06 44.55l22.41-13.02 28.91 16.69-22.4 13.02-28.92-16.69z\" fill=\"url(#J)\"/><path d=\"M91.58 44.25l-.06 19.56c0 .66-.35 1.27-.92 1.6L65.12 80.22c-.57.33-1.28.34-1.86 0l-4.19-2.38c-.82-3.95-2.2-7.33-5.49-9.23-3.28-1.9-6.06-.95-6.91 2.03L25.4 58.36c-.61-.35-1.1-.91-1.29-1.59-1.05-3.64-2.31-6.51-5.33-8.25-3.28-1.9-6.05-.95-6.9 2.04l-2.49-1.44a1.95 1.95 0 0 1-.97-1.68l.02-8.11 34.87 20.13c.18.1.4-.03.4-.23l.01-17.84c0-.87.46-1.67 1.21-2.11L69.84 24.8c.75-.43 1.67-.44 2.42-.02l12.44 7 6.85 12.44.03.03z\" fill=\"url(#K)\"/><path d=\"M57.79 61c1.07.62 2.4.57 3.43-.11.25-.16.41-.29.39-.32l-6.44-11.92c-.18-.28-.4-.51-.63-.64l-8.13-4.59c-.53-.3-.95-.06-.95.54v8.88a2.11 2.11 0 0 0 .95 1.64L57.79 61z\" fill=\"#fff\"/><path d=\"M57.53 47.53l25.91-15.06c.31-.18.72-.07.89.25l6.35 11.55c.17.31.06.7-.24.87l-25.9 15.05c-.49.28-1.11.11-1.38-.38l-6.01-10.93c-.26-.48-.09-1.08.38-1.35z\" fill=\"url(#L)\"/><path d=\"M66.83 75.48l.04 3.72L90.5 65.49c.65-.37.9-.8 1.01-1.44l.02-2.08v-.75l-24.7 14.26z\" fill=\"url(#M)\"/><path d=\"M70.93 76.04l-1.79 1.04c-.45.26-.81-.02-.81-.62s.37-1.3.81-1.56l1.79-1.04c.45-.26.81.02.81.62.01.61-.36 1.31-.81 1.56zM89.08 65.6l-1.79 1.04c-.45.26-.81-.02-.81-.62s.37-1.3.81-1.56l1.79-1.04c.45-.26.81.02.81.62 0 .61-.36 1.31-.81 1.56z\" fill=\"#fff\"/><path d=\"M27.06 31.48c-.66 0-1.33-.24-1.91-.67-1.32-1-1.79-2.88-1.12-4.45.21-.49.5-.89.79-1.28l.36-.5c1.18-1.8 1.2-4.26 1.22-6.24 0-.38.28-.7.69-.67a.67.67 0 0 1 .481.203.67.67 0 0 1 .189.487c-.02 2.16-.05 4.84-1.45 6.98l-.4.56c-.25.34-.49.66-.63 1.01-.43 1.01-.14 2.2.69 2.84.41.31.9.45 1.31.38s.76-.37.85-.72c.09-.36.46-.59.82-.5s.59.46.5.82c-.21.87-.99 1.57-1.93 1.74l-.46.01z\" fill=\"#8334c2\"/><path d=\"M28.86 15.38a7.67 7.67 0 0 1 .48.73 7.67 7.67 0 0 0-.48-.73z\" fill=\"url(#N)\"/><path d=\"M26.19 13.48c.04 0 .08.02.12.03-.04-.01-.08-.03-.12-.03z\" fill=\"url(#O)\"/><path d=\"M27.79 14.24c.19.156.37.323.54.5l-.54-.5z\" fill=\"url(#P)\"/><path d=\"M27.21 13.84c-.09-.05-.18-.09-.27-.13l.27.13c.19.11.38.24.56.39-.19-.15-.37-.28-.56-.39z\" fill=\"url(#Q)\"/><path d=\"M43.69 40.71c.04.02.07.05.11.07-.04-.02-.08-.05-.11-.07z\" fill=\"url(#R)\"/><path d=\"M42.7 40.27c.03.01.05.01.08.02-.03-.01-.05-.01-.08-.02z\" fill=\"url(#S)\"/><path d=\"M28.64 15.11l.23.27-.23-.27z\" fill=\"url(#T)\"/><path d=\"M40.52 40.39l2.63-1.53-13.81-22.75a7.67 7.67 0 0 0-.48-.73c-.07-.1-.15-.18-.23-.27l-.29-.35c-.19-.2-.37-.37-.55-.52-.2-.16-.39-.29-.57-.4-.09-.05-.18-.09-.27-.13l-.24-.11c-.14-.05-.26-.07-.38-.09l-.12-.03a1.4 1.4 0 0 0-.46.01c-.17.03-.3.07-.43.15-1.08.62-1.03 2.74.11 4.71l14.25 25.96-.33-2.11c.17-.85.59-1.47 1.17-1.81z\" fill=\"url(#U)\"/><path d=\"M41.63 40.12c.11 0 .2-.02.31-.01-.12-.01-.21.01-.31.01z\" fill=\"url(#V)\"/><path d=\"M41.17 40.15c-.1.02-.18.07-.28.1.1-.03.19-.09.29-.11l-.01.01z\" fill=\"url(#W)\"/><path d=\"M42.49 40.23c.07.02.14.02.21.05-.07-.03-.14-.04-.21-.05z\" fill=\"url(#X)\"/><path d=\"M26.19 13.48c.04 0 .08.02.12.03.215.044.423.115.62.21l.27.13c.19.11.38.24.56.39l.55.51c.11.11.2.24.31.36l.23.27a7.65 7.65 0 0 1 .48.73l13.81 22.75 3.93-2.28-13.8-22.75c-.01-.01-.01-.02-.02-.03l-.28-.44-.18-.25-.12-.17-.12-.15-.12-.14c-.037-.046-.078-.089-.12-.13-.01-.02-.03-.03-.04-.04-.03-.03-.05-.06-.08-.08l-.13-.13-.13-.12-.13-.12a.51.51 0 0 1-.08-.07c-.02-.02-.04-.03-.05-.04l-.13-.1-.13-.09c-.04-.03-.08-.05-.12-.08s-.08-.05-.12-.07c-.01-.01-.02-.01-.03-.02-.03-.02-.06-.03-.09-.05l-.11-.06-.11-.05-.11-.05-.09-.03c-.02 0-.02 0-.03-.01-.04-.01-.07-.03-.11-.04l-.11-.03-.11-.03c-.04-.01-.08-.01-.12-.02h-.03c-.04 0-.07-.01-.09-.01h-.13c-.05 0-.09 0-.13.01-.04 0-.07.01-.11.02h-.04c-.061.012-.121.029-.18.05l-.21.09-3.93 2.28c.26-.15.57-.19.89-.15z\" fill=\"url(#Y)\"/><path d=\"M28.33 14.75l.3.36-.3-.36z\" fill=\"url(#Z)\"/><path d=\"M26.69 13.6c.09.03.17.08.25.12a2.67 2.67 0 0 0-.62-.21c.12.02.24.04.37.09z\" fill=\"url(#a)\"/><path d=\"M25.73 13.48c.14-.02.29-.03.45-.01-.32-.04-.62.01-.88.16.13-.07.27-.12.41-.15.01.01.02.01.02 0z\" fill=\"url(#b)\"/><path d=\"M43.69 40.71a5.05 5.05 0 0 0-.9-.41c-.04-.01-.06-.01-.09-.02l-.21-.05c-.18-.05-.37-.1-.54-.12-.12-.01-.22.01-.32.01-.15 0-.3-.01-.44.02-.1.02-.19.07-.29.11-.13.04-.26.08-.37.14-.58.34-1 .96-1.19 1.81-.07.32-.12.67-.12 1.06l-.02 7.03 4.52 2.61v-5.81c-.14-.02-.29-.06-.45-.16-.69-.4-1.26-1.37-1.26-2.17s.56-1.12 1.26-.72c.16.09.31.22.45.37v-3.03c0-.2.03-.4.08-.6-.04-.02-.08-.05-.11-.07z\" fill=\"url(#c)\"/><path d=\"M50.86 35.81l-.18-.07c-.01 0-.02-.01-.03-.01-.05-.01-.1-.03-.14-.04-.06-.02-.12-.04-.18-.05-.06-.02-.12-.03-.18-.04l-.2-.03c-.04-.01-.09-.01-.13-.01h-.02-.05c-.07 0-.14-.01-.21-.01l-.23.01-.26.04a2.5 2.5 0 0 0-.32.08c-.13.04-.25.1-.36.17l-1.29.75-3.93 2.28-2.64 1.53c.12-.07.26-.1.38-.14.09-.03.18-.08.28-.1.16-.03.31-.02.46-.02.1 0 .2-.02.3-.02.19.02.37.07.56.12.07.02.14.02.21.05.03.01.05.01.07.02a4.9 4.9 0 0 1 .91.42c.04.02.07.05.11.07a2.41 2.41 0 0 1 1.14-1.51l5.94-3.45c0-.04-.01-.04-.01-.04z\" fill=\"url(#d)\"/><path d=\"M42.79 40.29c.29.1.59.24.9.41-.31-.17-.62-.31-.9-.41z\" fill=\"url(#e)\"/><path d=\"M41.94 40.11a3.6 3.6 0 0 1 .55.12c-.19-.05-.37-.11-.55-.12z\" fill=\"url(#f)\"/><path d=\"M40.89 40.25c-.13.04-.26.08-.37.14.12-.06.25-.09.37-.14z\" fill=\"url(#g)\"/><path d=\"M41.63 40.12c-.15 0-.3-.01-.44.02.13-.02.29-.01.44-.02z\" fill=\"url(#h)\"/><path d=\"M42 44.76c0 .8.56 1.77 1.26 2.17a1.29 1.29 0 0 0 .45.16v-2.67c-.14-.15-.29-.27-.45-.37-.69-.41-1.26-.09-1.26.71z\" fill=\"url(#i)\"/></g></g><defs><linearGradient id=\"A\" x1=\"54.912\" y1=\"66.069\" x2=\"45.14\" y2=\"73.378\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"20.137\" y1=\"45.859\" x2=\"10.13\" y2=\"53.166\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"3.224\" y1=\"53.153\" x2=\"38.65\" y2=\"53.153\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"9.679\" y1=\"55.058\" x2=\"42.118\" y2=\"55.058\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"12.9\" y1=\"55.187\" x2=\"21.28\" y2=\"55.187\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"38.304\" y1=\"73.013\" x2=\"73.73\" y2=\"73.013\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"44.682\" y1=\"74.919\" x2=\"77.12\" y2=\"74.919\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"47.98\" y1=\"75.047\" x2=\"56.36\" y2=\"75.047\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"-16.983\" y1=\"41.767\" x2=\"73.559\" y2=\"41.767\" xlink:href=\"#m\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"J\" x1=\"8.197\" y1=\"46.383\" x2=\"178.208\" y2=\"46.383\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"-27.378\" y1=\"52.463\" x2=\"101.187\" y2=\"52.463\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"L\" x1=\"54.976\" y1=\"46.355\" x2=\"175.991\" y2=\"46.355\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".098\" stop-color=\"#faf6fc\"/><stop offset=\".26\" stop-color=\"#ebdcf5\"/><stop offset=\".468\" stop-color=\"#d2b2ea\"/><stop offset=\".712\" stop-color=\"#b178da\"/><stop offset=\".985\" stop-color=\"#872fc6\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"M\" x1=\"-68.09\" y1=\"70.207\" x2=\"93.822\" y2=\"70.207\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"N\" x1=\"28.864\" y1=\"15.749\" x2=\"29.343\" y2=\"15.749\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"O\" x1=\"26.193\" y1=\"13.491\" x2=\"26.314\" y2=\"13.491\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"P\" x1=\"27.785\" y1=\"14.495\" x2=\"28.329\" y2=\"14.495\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Q\" x1=\"26.933\" y1=\"13.972\" x2=\"27.772\" y2=\"13.972\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"R\" x1=\"43.687\" y1=\"40.744\" x2=\"43.795\" y2=\"40.744\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"S\" x1=\"42.701\" y1=\"40.282\" x2=\"42.782\" y2=\"40.282\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"T\" x1=\"28.635\" y1=\"15.246\" x2=\"28.863\" y2=\"15.246\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"U\" x1=\"8.737\" y1=\"28.887\" x2=\"92.105\" y2=\"28.887\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"V\" x1=\"41.627\" y1=\"40.113\" x2=\"41.941\" y2=\"40.113\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"W\" x1=\"40.893\" y1=\"40.198\" x2=\"41.184\" y2=\"40.198\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"X\" x1=\"42.49\" y1=\"40.25\" x2=\"42.702\" y2=\"40.25\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Y\" x1=\"11.309\" y1=\"25.022\" x2=\"53.949\" y2=\"25.022\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"Z\" x1=\"28.329\" y1=\"14.929\" x2=\"28.635\" y2=\"14.929\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"a\" x1=\"26.314\" y1=\"13.609\" x2=\"26.933\" y2=\"13.609\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"b\" x1=\"25.303\" y1=\"13.548\" x2=\"26.193\" y2=\"13.548\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"c\" x1=\"19.5\" y1=\"46.501\" x2=\"51.14\" y2=\"46.501\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"d\" x1=\"35.4\" y1=\"38.156\" x2=\"53.696\" y2=\"38.156\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"e\" x1=\"42.782\" y1=\"40.499\" x2=\"43.687\" y2=\"40.499\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"f\" x1=\"41.941\" y1=\"40.167\" x2=\"42.49\" y2=\"40.167\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"g\" x1=\"40.521\" y1=\"40.322\" x2=\"40.893\" y2=\"40.322\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"h\" x1=\"41.184\" y1=\"40.133\" x2=\"41.627\" y2=\"40.133\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"i\" x1=\"40.682\" y1=\"45.476\" x2=\"55.903\" y2=\"45.476\" xlink:href=\"#m\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"j\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"k\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><path id=\"l\" d=\"M15.57 54.03c0 1.19.89 2.82 1.93 3.41s1.93.15 1.93-1.04-.89-2.82-1.93-3.41c-1.04-.74-1.93-.15-1.93 1.04z\"/><linearGradient id=\"m\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgVehicleSecureBonus = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#L)\"><g clip-path=\"url(#M)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M56.71 55.12l-5.46-3.03 7.46 16.18 5.45 3.03-7.45-16.18z\" fill=\"url(#A)\"/><path d=\"M65.58 48.16l-8.27 8.21 6.86 14.93 2.55-7.2 5.73-.99-6.87-14.95z\" fill=\"url(#B)\"/><path d=\"M43 75.43l-5.54-3.07 2.92 4.93 5.54 3.07L43 75.43z\" fill=\"url(#C)\"/><path d=\"M44.98 56.94l-5.48-3.05-7.38 24.39 5.49 3.05 7.37-24.39z\" fill=\"url(#D)\"/><path d=\"M44.36 58.86l-6.75 22.47L43.32 76l2.59 4.37 6.74-22.45-8.29.94z\" fill=\"url(#E)\"/><path d=\"M66.83 18.13c.04.02.07.03.11.04.098.034.198.06.3.08.01 0 .03 0 .05.01.02 0 .05.01.07.01l.19.03c.09.01.18.01.27.01h.05l.42-.01c.03 0 .06-.01.09-.01l.2-.02.21-.02.25-.03.76-.08.48-.03h.07c.2 0 .39.01.57.04.19.03.36.09.51.17l-5.46-3.02-.24-.11c-.08-.03-.16-.05-.25-.06h-.02c-.08-.01-.16-.03-.24-.03-.1-.01-.2-.01-.31-.01h-.09l-.34.01c-.05 0-.09.01-.14.01l-.76.08-.45.06-.2.02-.51.02h-.05c-.16 0-.31-.02-.45-.04-.02 0-.05-.01-.07-.01l4.98 2.89z\" fill=\"url(#F)\"/><path d=\"M34.18 61.52c-.05-.09-.11-.17-.17-.25l-.09-.11c-.1-.11-.2-.21-.32-.27l5.46 3.02c.12.06.22.16.32.27.03.03.06.07.09.11s.07.08.1.13c.02.04.04.08.07.12l.23.4.37.72.26.56.32.57.21.28.12.15a1.76 1.76 0 0 0 .4.32l-5.46-3.02c-.15-.08-.28-.19-.4-.32l-.12-.15-.19-.23c-.01-.01-.02-.03-.02-.04l-.32-.57-.26-.55-.37-.72-.23-.42z\" fill=\"url(#G)\"/><path d=\"M61.29 15.18c-.01.01-.03.02-.04.03l-.86.65c-.05.04-.11.08-.16.11l-.38.26-.29.2c-.02.01-.03.02-.05.03l-.4.25c-.09.06-.19.11-.28.16-.02.01-.04.02-.05.03-.03.02-.06.03-.09.05-.04.02-.07.04-.11.05l-.11.05c-.04.02-.07.03-.11.04l-.11.04-.11.03-.12.03-.14.03c-.36.07-.65.16-1.03.15-.43-.01-.86-.08-1.28-.21l-1.17-.41c-.58-.15-1.15-.05-1.67.24-.27.15-.54.35-.81.6-.26.24-.52.51-.77.8-.01.01-.02.03-.03.04-.2.23-.39.48-.58.74l-.88 1.19-.54.79c-.02.02-.03.05-.05.07l-.34.46c-.02.02-.03.04-.05.06-.01.01-.02.03-.03.04l-.11.14-.15.18-.13.15-.12.13-.12.12c-.04.04-.08.07-.11.11-.04.03-.07.07-.11.1l-.11.09c-.02.02-.05.04-.07.06a1.74 1.74 0 0 1-.14.12c-.04.03-.08.07-.13.11-.04.03-.07.06-.12.09l-.12.09c-.04.03-.08.05-.12.08-.04.02-.07.05-.11.07s-.07.04-.14.08l-.19.1-.32.16-.24.11-.13.06c-.03.01-.07.03-.1.04l-.64.26c-.29.08-.57.18-.86.29-.01.01-.03.01-.04.02-.29.12-.57.26-.86.41-.25.14-.53.31-.8.52-.26.21-.52.44-.74.72-.238.29-.449.601-.63.93a8.37 8.37 0 0 0-.48 1l-.36.99c-.01.04-.03.07-.04.11l-.32 1.02-.34 1.08-.19.57-.09.25-.09.23-.08.18-.07.16c-.02.05-.04.09-.07.14-.02.05-.05.09-.07.13-.02.05-.05.09-.08.14l-.09.16-.17.25-.25.33-.22.27-.23.27-.12.14c-.01.01-.02.03-.04.04-.04.04-.08.08-.11.13l-.34.36-.47.46-.23.22-.83.83-.76.83-.03.03c-.23.27-.45.56-.63.84-.01.02-.03.04-.04.06-.19.3-.36.61-.48.93-.15.34-.24.67-.3 1-.056.313-.083.631-.08.95a7.55 7.55 0 0 0 .05.83l.03.27.09.67.07.46.05.5.03.43.01.31v.28l-.01.24c-.002.07-.008.14-.02.21-.01.06-.01.12-.02.18-.01.05-.01.1-.02.16-.01.05-.02.09-.04.14a.88.88 0 0 1-.05.15l-.06.17-.07.19-.08.21c-.032.085-.069.169-.11.25l-.1.22c-.01.02-.01.03-.02.05s-.01.03-.02.05l-.22.46-.07.13-.47.93-.47.95-.09.18-.45 1.01-.33 1c-.22.93-.1 1.71.61 2.39.41.39.89.7 1.26 1.11.48.53.81 1.24.87 1.94 0 .05.01.1.01.18v.05l.01.27-.01.39c0 .11-.01.23-.02.34l-.03.32c0 .04-.01.07-.01.11v.06l-.07.59c0 .03-.01.06-.01.09l-.1.92c-.01.06-.01.11-.01.16l-.05.91c0 .3.02.59.09.84.06.25.16.48.3.66.11.16.24.27.4.36l-5.46-3.02c-.16-.09-.29-.2-.4-.36-.029-.029-.053-.063-.07-.1l-.09-.15a1.96 1.96 0 0 1-.06-.14c-.02-.04-.03-.09-.05-.13l-.04-.14-.03-.13c-.012-.049-.018-.099-.02-.15-.01-.05-.01-.11-.02-.16 0-.06-.01-.12-.01-.18v-.22-.24a3.65 3.65 0 0 1 .02-.33l.03-.33c0-.05.01-.11.01-.16 0-.03 0-.05.01-.07l.09-.84.09-.74c0-.04.01-.07.01-.11l.05-.7c.01-.24.01-.46-.01-.71a3.29 3.29 0 0 0-.07-.58c-.06-.15-.13-.29-.22-.42-.12-.18-.28-.35-.45-.51l-.13-.13-.53-.45-.55-.49c-.05-.05-.09-.11-.14-.17-.12-.13-.24-.25-.35-.42-.06-.09-.12-.19-.17-.29-.03-.07-.07-.14-.09-.21-.02-.04-.03-.09-.06-.17-.02-.05-.03-.1-.04-.15l-.03-.14c-.01-.04-.02-.09-.02-.13-.01-.04-.01-.08-.01-.13 0-.04-.01-.08-.01-.13v-.13-.11c0-.04 0-.08.01-.11 0-.04.01-.08.01-.12s.01-.08.01-.12c.01-.04.01-.09.02-.13l.03-.14.03-.15c0-.02.01-.04.02-.07s.01-.06.02-.09l.05-.17.06-.19.07-.21.08-.23c.01-.04.03-.07.05-.14.02-.04.03-.08.05-.12l.12-.29.17-.38.09-.19.09-.18.1-.21.37-.74.47-.93.31-.64c.01-.02.01-.03.02-.05l.29-.69c.085-.215.155-.435.21-.66a6.98 6.98 0 0 0 .07-1.38c-.02-.47-.08-.94-.15-1.38l-.07-.52c-.01-.05-.01-.1-.02-.15l-.03-.27-.02-.21-.02-.35-.01-.28v-.2c0-.06.01-.13.01-.19s.01-.12.01-.18c.01-.05.01-.11.02-.16s.01-.1.02-.15c0-.02.01-.04.01-.07 0-.02.01-.05.01-.07l.03-.14.03-.13c.01-.04.02-.08.04-.13.01-.04.02-.08.04-.12.01-.04.02-.08.04-.11.01-.04.03-.07.04-.11.01-.03.03-.07.04-.11.01-.02.02-.05.03-.07l.03-.08c.01-.03.03-.07.04-.1s.03-.07.05-.1.03-.07.05-.1l.06-.12c.02-.05.05-.09.07-.14l.13-.22.05-.08c.01-.02.03-.04.04-.06l.15-.23.22-.29.19-.23c.02-.03.05-.06.07-.09.01-.01.02-.02.03-.04.04-.04.07-.08.1-.12l.26-.29.39-.41.83-.83 1.16-1.18c.01-.01.02-.03.03-.04.362-.4.697-.824 1-1.27.25-.42.45-.89.64-1.42l.52-1.63.29-.94.03-.08c.01-.04.03-.07.04-.11l.11-.34.13-.36.12-.31.09-.21.09-.2.09-.19.09-.18.12-.22c.04-.08.09-.15.13-.22l.24-.37.16-.21.09-.11a.5.5 0 0 1 .07-.08.5.5 0 0 1 .07-.08c.02-.03.05-.05.07-.08s.05-.05.07-.08l.08-.08.09-.09c.03-.03.07-.06.11-.09s.08-.07.12-.1c.02-.02.04-.03.07-.06.02-.02.04-.03.06-.05.05-.04.1-.07.14-.1.05-.04.11-.07.16-.11l.18-.11.2-.12c.02-.01.03-.02.05-.03l.22-.12.29-.14.29-.13c.02-.01.05-.02.07-.03.01-.01.03-.01.04-.02l.18-.07.3-.11.31-.1c.03-.01.05-.01.08-.02l.74-.3.13-.06.75-.36a4.78 4.78 0 0 0 .5-.32l.38-.32c.192-.149.373-.313.54-.49a5.61 5.61 0 0 0 .49-.57c.01-.01.02-.03.03-.04l.44-.6.54-.79.88-1.19c.06-.07.11-.15.17-.22l.32-.4c.03-.04.06-.08.1-.11.01-.01.02-.03.03-.04.03-.04.06-.08.1-.11l.19-.21.17-.18.16-.15.16-.15.12-.11c.04-.04.09-.07.13-.11l.12-.09.11-.08.1-.07.1-.06c.03-.02.06-.04.12-.07.02-.01.05-.03.07-.04.03-.02.06-.03.09-.05a.3.3 0 0 1 .1-.04c.03-.01.07-.03.1-.04.01-.01.03-.01.06-.02.02-.01.03-.01.05-.02l.11-.03.12-.03c.04-.01.07-.02.13-.03.05-.01.1-.02.15-.02l.17-.02h.04.05.12c.06 0 .13 0 .19.01h.08c.04 0 .08.01.12.02l.3.04c.02 0 .03.01.04.01l.98.25c.157.069.317.129.48.18l.13.03a2.23 2.23 0 0 0 .37.09c.02 0 .04 0 .06.01.16.02.32.04.49.02.17-.01.35-.04.54-.1.132-.024.263-.057.39-.1a2.88 2.88 0 0 0 .49-.22l.78-.48c.1-.06.19-.13.28-.19l.55-.38c.04-.04.09-.07.13-.11l.34-.26.32-.23c.02-.02.05-.03.07-.05.01-.01.03-.02.05-.03l.19-.13.3-.19.29-.17c.02-.01.04-.02.07-.04.05-.03.11-.06.16-.08l.18-.09c.01-.01.03-.01.07-.03.03-.01.06-.03.09-.04l.14-.06c.04-.02.08-.03.17-.06.03-.01.05-.02.08-.02l.11-.03c.03-.01.07-.02.1-.02.03-.01.06-.01.1-.02.03 0 .06-.01.09-.01h.09.09c.03 0 .06.01.09.01s.06.01.1.02a1.31 1.31 0 0 1 .19.05c.08.03.16.06.24.11l5.46 3.02c-.16-.09-.33-.14-.52-.17a1.03 1.03 0 0 0-.35 0l-.4.09c-.13.04-.25.09-.41.16l-.38.19-.85.6z\" fill=\"url(#H)\"/><use xlink:href=\"#N\" fill=\"url(#I)\"/><use xlink:href=\"#N\" fill=\"url(#J)\"/><path d=\"M63.581 47.669c6.396-10.037 6.767-21.241.829-25.025s-15.937 1.285-22.333 11.321-6.767 21.241-.829 25.025 15.937-1.285 22.333-11.321z\" fill=\"#fff\"/><path d=\"M53.81 30.47l-7.55 7.1.02 7.42c-.02.38-.31 7.7 7.59 7.4 7.86-8.4 7.53-15.37 7.51-15.73l-.02-7.42-7.55 1.23z\" fill=\"url(#K)\"/><path d=\"M53.81 33.43l-5.39 5.07.02 5.29c-.01.27-.22 5.49 5.42 5.28 5.61-6 5.37-10.97 5.36-11.23l-.02-5.29-5.39.88z\" fill=\"#fff\"/></g></g><defs><linearGradient id=\"A\" x1=\"46.644\" y1=\"61.696\" x2=\"108.417\" y2=\"61.696\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"44.376\" y1=\"59.732\" x2=\"86.095\" y2=\"59.732\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"31.857\" y1=\"76.359\" x2=\"54.806\" y2=\"76.359\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"21.876\" y1=\"67.609\" x2=\"104.618\" y2=\"67.609\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"25.208\" y1=\"69.626\" x2=\"71.751\" y2=\"69.626\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"51.03\" y1=\"16.702\" x2=\"78.604\" y2=\"16.702\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"30.152\" y1=\"64.209\" x2=\"53.425\" y2=\"64.209\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"15.333\" y1=\"37.386\" x2=\"92.091\" y2=\"37.386\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"30.836\" y1=\"40.82\" x2=\"74.488\" y2=\"40.82\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"J\" x1=\"-6.518\" y1=\"40.82\" x2=\"87.039\" y2=\"40.82\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"K\" x1=\"28.475\" y1=\"40.82\" x2=\"71.818\" y2=\"40.82\" xlink:href=\"#O\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"L\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"M\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><path id=\"N\" d=\"M52.59 16.85c-.96.53-1.87 1.84-2.76 3.1-.74 1.05-1.51 2.14-2.32 2.83-.33.27-.67.5-1.03.69-.58.32-1.18.56-1.78.8l-1.68.75c-.5.28-.95.61-1.33 1.06-.8.95-1.21 2.31-1.64 3.75-.35 1.18-.71 2.39-1.32 3.39-.62 1.02-1.54 1.93-2.43 2.81-1.08 1.08-2.12 2.09-2.57 3.22-.45 1.12-.3 2.23-.13 3.41.15.97.29 1.98.06 3.04-.21 1.02-.82 2.19-1.39 3.32-.71 1.37-1.43 2.79-1.43 3.83 0 1.06.74 1.67 1.44 2.26.59.49 1.2.99 1.42 1.77.24.81.1 1.98-.04 3.1-.16 1.36-.31 2.63.15 3.25.46.63 1.49.5 2.58.38.89-.1 1.82-.21 2.44.13.61.33.98 1.14 1.34 1.93.44.96.86 1.86 1.66 1.93.39.03.84-.14 1.34-.41.52-.29 1.09-.69 1.68-1.11l1.78-1.17c.35-.2.7-.35 1.03-.44.81-.2 1.58.03 2.33.27.89.28 1.81.57 2.77.04s1.87-1.84 2.76-3.1c.74-1.05 1.5-2.13 2.32-2.83.33-.28.68-.51 1.03-.7.58-.32 1.18-.55 1.77-.79l1.68-.74c.5-.28.95-.61 1.34-1.07.8-.95 1.21-2.32 1.63-3.74.35-1.18.72-2.39 1.33-3.4.62-1.02 1.54-1.93 2.42-2.81 1.09-1.08 2.12-2.09 2.58-3.24.45-1.11.3-2.22.13-3.39-.14-.97-.29-1.98-.06-3.04.21-1.02.82-2.19 1.39-3.32.71-1.37 1.43-2.79 1.43-3.84s-.74-1.66-1.45-2.24c-.58-.49-1.19-.99-1.41-1.78-.24-.81-.1-1.98.04-3.1.16-1.36.31-2.63-.15-3.25-.47-.62-1.49-.5-2.59-.38-.88.1-1.81.21-2.43-.13s-.99-1.14-1.35-1.92c-.43-.97-.85-1.86-1.65-1.93-.39-.03-.84.14-1.34.41-.52.29-1.09.69-1.68 1.11l-1.78 1.17c-.35.2-.7.35-1.03.44-.82.21-1.58-.03-2.33-.27-.89-.28-1.81-.58-2.77-.05z\"/><linearGradient id=\"O\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgVehicleTheftFire = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#m)\"><g clip-path=\"url(#n)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M79.91 57.01l.77-.2c.03-.01.07-.02.1-.02l.91-.15.23-.03.81-.06c.05 0 .1-.01.15-.01l.94.01c.09.002.18.008.27.02l.68.07.41.06.88.17c.31.07.59.16.87.26l.44.17.45.19c.13.06.26.13.38.2l.37.21c.3.19.57.39.81.6.13.12.24.24.35.37.04.05.09.09.13.14.13.17.24.34.34.52l.06.13c.07.14.12.28.16.43.01.04.03.09.04.13.04.19.07.37.07.56v-.86-.06c0-.14-.02-.28-.05-.42a.31.31 0 0 1-.02-.08c-.01-.04-.02-.09-.04-.13-.02-.07-.03-.13-.06-.2-.03-.08-.07-.15-.11-.23l-.06-.12-.03-.06c-.09-.15-.18-.3-.3-.44-.05-.06-.1-.1-.14-.15-.1-.12-.2-.23-.32-.34-.01-.01-.02-.02-.03-.02-.252-.223-.523-.424-.81-.6-.03-.02-.04-.04-.07-.05l-.29-.15-.39-.2a4.7 4.7 0 0 0-.45-.19l-.44-.17c-.04-.01-.08-.03-.12-.04l-.75-.21-.65-.14-.24-.03-.41-.06-.29-.04-.39-.03-.27-.02c-.05 0-.09-.01-.14-.01a9.13 9.13 0 0 0-.74 0h-.06c-.05 0-.1.01-.15.01l-.5.03-.31.03-.23.03-.17.02-.73.13c-.06.01-.09.02-.13.03l-.65.16c-.04.01-.07.03-.11.04l-.42.14-.36.12c-.03.01-.06.03-.09.05-.34.14-.66.29-.96.46-.65.38-1.2.83-1.58 1.36-.39.54-.58 1.1-.58 1.64v.86c0-.27.05-.55.14-.83.1-.28.24-.55.44-.82.38-.52.92-.98 1.58-1.36.3-.17.62-.32.96-.46l.45-.16c.138-.09.29-.157.45-.2z\" fill=\"url(#A)\"/><path d=\"M75.63 64.21v-.86a5.98 5.98 0 0 1-.74-.66l-.25-.27c-.17-.19-.33-.39-.46-.6-.03-.05-.07-.09-.1-.14a4.47 4.47 0 0 1-.35-.78c-.02-.05-.03-.11-.05-.16-.08-.28-.13-.56-.13-.85v.86.08c.01.18.03.36.06.54.01.07.04.14.06.22.01.05.03.11.05.16l.05.17c.07.19.16.37.26.55.01.02.03.04.04.06.03.05.07.1.1.14l.26.38c.06.07.14.14.2.21l.25.27.17.18c.18.19.37.35.58.5z\" fill=\"url(#B)\"/><path d=\"M74.12 65.5v.86l6.05 1.46-.01-.85-6.04-1.47z\" fill=\"url(#C)\"/><path d=\"M70.1 71.07c-.07-.08-.13-.16-.17-.25a.8.8 0 0 1-.08-.33v.86c0 .06.01.1.01.15a.93.93 0 0 0 .04.13c.01.02.02.04.02.06.01.02.02.05.03.07l.09.14c.01.02.03.03.04.05l.02-.88z\" fill=\"url(#D)\"/><path d=\"M54.8 74.73c-.05-.07-.09-.15-.11-.23 0-.01 0-.02-.01-.03-.02-.08-.04-.15-.04-.23v.86c0 .06.01.11.01.15.01.03.01.05.02.08 0 .01 0 .02.01.03 0 .01 0 .01.01.02l.06.13c.01.03.03.05.05.08v-.86z\" fill=\"url(#E)\"/><path d=\"M51.35 76.29v.85l.44 2.23v-.86l-.44-2.22z\" fill=\"url(#F)\"/><path d=\"M59.85 79.83l.98.24.54.18.39.15.54.26.32.17c.09.05.16.11.25.17a5.88 5.88 0 0 1 .62.46c.13.11.25.23.36.35.05.06.11.11.15.17a3.68 3.68 0 0 1 .39.58c.02.03.03.07.05.1.1.208.177.426.23.65.03.16.05.32.05.48v-.86-.06c0-.14-.02-.28-.05-.42a3.31 3.31 0 0 0-.12-.42c-.03-.08-.07-.16-.11-.23l-.05-.11c-.01-.02-.02-.05-.04-.08-.08-.15-.18-.29-.29-.44-.02-.02-.04-.04-.06-.07-.05-.06-.1-.11-.15-.16l-.24-.26c-.04-.03-.09-.06-.12-.09a7.68 7.68 0 0 0-.62-.46c-.06-.04-.11-.09-.17-.13-.02-.01-.05-.02-.07-.04-.1-.06-.22-.11-.32-.17l-.54-.26-.39-.15-.38-.15c-.05-.02-.11-.02-.16-.04-.31-.1-.64-.17-.98-.24l-.23-.06c-.02 0-.05-.01-.07-.01l-.25-.03-.62-.09-.38-.03-.49-.02a9.63 9.63 0 0 0-.76 0l-.45.02c-.05 0-.11.01-.16.01l-.6.07-.81.14c-.03.01-.06.01-.09.02l-.73.18-.56.19-.21.07c-.04.01-.08.02-.11.04a8 8 0 0 0-1.06.51c-1.34.78-2.16 1.85-2.15 3v.86c0-1.16.81-2.23 2.15-3 .35-.2.75-.38 1.17-.54.07-.03.14-.05.21-.07l1.29-.37c.53-.11 1.07-.2 1.66-.24.57-.04 1.14-.03 1.7.01l1 .12.25.03.29.07z\" fill=\"url(#G)\"/><path d=\"M67.1 82.92c0 1.54-1.08 2.96-2.86 3.99-.425.24-.866.45-1.32.63l-1.26.44h-.02c-.43.12-.88.22-1.35.3l-.29.05-1.49.18-.85.03h-.51c-.16 0-.31 0-.47-.01l-.66-.04-.34-.03-1.1-.15-.17-.03c-.57-.11-1.12-.24-1.64-.41l-.21-.07-.95-.36-.15-.06c-.33-.15-.64-.31-.94-.49l-.27-.16c-.12-.07-.23-.15-.34-.23l-.27-.2-.3-.25a3.87 3.87 0 0 1-.21-.2c-.16-.15-.31-.31-.44-.48-.03-.04-.07-.08-.1-.12a4 4 0 0 1-.34-.5c-.01-.02-.02-.03-.03-.05-.1-.18-.19-.36-.26-.55-.07-.18-.12-.37-.16-.57-.04-.208-.06-.418-.06-.63v.86.08c.011.184.031.368.06.55.037.191.09.379.16.56.07.19.16.37.26.55.01.01.02.03.03.04a4 4 0 0 0 .34.5c.01.01.01.02.02.03.02.03.06.06.08.09a5.03 5.03 0 0 0 .45.48c.03.03.05.06.08.08.04.04.09.07.13.11l.3.25.27.2.35.23c.06.04.11.08.17.11.03.02.07.03.1.05l.94.49.15.06.94.36c.05.02.09.04.14.05.02.01.05.01.07.02.52.16 1.07.3 1.64.41.03.01.06.02.09.02.02 0 .05.01.07.01l1.1.15c.02 0 .04.01.06.01l.29.02.66.04c.04 0 .08.01.12.01h.35.51.13l.72-.03.24-.02.95-.11c.1-.01.2-.04.3-.05l.29-.05.36-.06.98-.24h.02l1.18-.39c.03-.01.05-.03.08-.04.453-.182.894-.392 1.32-.63 1.79-1.03 2.87-2.45 2.86-3.99v-.84z\" fill=\"url(#H)\"/><path d=\"M92.92 59.88c0 .73-.24 1.47-.76 2.19-.5.68-1.2 1.28-2.06 1.77-.41.24-.86.45-1.33.64-.41.17-.85.31-1.3.44-.06.02-.13.03-.19.05l-1.21.27-.29.05c-.48.08-.98.14-1.48.17l-1.5 2.06-1.69-.41v.86l1.69.41 1.5-2.06.26-.02.96-.11.25-.04.29-.05.43-.08.78-.19c.06-.02.13-.03.19-.05.02-.01.05-.01.07-.02l1.18-.4c.02-.01.04-.02.05-.03.47-.19.92-.4 1.33-.64.85-.49 1.56-1.09 2.06-1.77.52-.72.77-1.46.76-2.19l.01-.85z\" fill=\"url(#I)\"/><path d=\"M78.59 67.82c-.34-.01-.68-.06-1.02-.14-.255-.058-.503-.141-.74-.25l-.05.04-1.46 1.32v.86l1.46-1.32.05-.04c.13.06.27.11.41.16l.33.09.29.06.41.06.31.02.01-.86z\" fill=\"url(#J)\"/><path d=\"M75.81 66.54c0-.01-.01-.02-.01-.02-.04-.11-.07-.21-.07-.32v.86c0 .07.01.11.02.16s.02.09.04.14c0 .01.01.01.01.02s.01.02.01.02c.01.03.03.07.05.1.03.05.07.11.11.16.01.02.02.03.04.05v-.86a.82.82 0 0 1-.2-.31z\" fill=\"url(#K)\"/><path d=\"M76.55 70.43c-.33.04-.66.04-.98 0-.25-.03-.48-.09-.7-.17-.2-.07-.36-.16-.51-.26-.03-.02-.05-.04-.08-.06-.13-.1-.25-.22-.32-.34l-1.53.24v.86l1.53-.24c.02.04.05.08.08.12.04.05.09.1.14.15.03.03.07.05.1.08.03.02.05.04.08.06s.05.05.09.07a2.75 2.75 0 0 0 .42.2c.04.02.09.03.13.05.13.04.26.07.4.1l.17.03c.03 0 .07.01.1.01l.24.02h.23l.22-.01c.06-.01.13-.01.19-.02v-.89z\" fill=\"url(#L)\"/><path d=\"M70.13 69.87l-1.89-.39c-.01 0-.03-.01-.04-.01-.04-.01-.08-.01-.12-.02-.04 0-.07-.01-.11-.01h-.04v.86c.104 0 .208.01.31.03l1.89.39v-.85z\" fill=\"url(#M)\"/><path d=\"M66.31 69.6c-.03 0-.05-.01-.08-.01-.04 0-.07-.01-.11-.01h-.1c-.03 0-.06 0-.1.01-.03 0-.07.01-.1.01-.02 0-.03 0-.05.01-.02 0-.04.01-.06.01l-.1.03c-.02.01-.03.01-.05.02l-2.29.77v.86l2.29-.77.21-.05c.17-.03.35-.03.53-.01l.01-.87z\" fill=\"url(#N)\"/><path d=\"M61.75 71.64c.13 0 .26.02.38.05v-.86l-.12-.03c-.04-.01-.08-.01-.12-.02-.03 0-.07-.01-.1-.01h-.04-.06c-.03 0-.06 0-.1.01-.03 0-.06.01-.1.01-.03 0-.07.01-.1.02-.01 0-.02 0-.03.01-.03.01-.05.01-.08.02-.04.01-.08.03-.12.04a.61.61 0 0 0-.14.07c-.08.05-.15.1-.2.17l-.68.87v.86l.68-.87c.05-.07.12-.12.2-.17.1-.06.21-.1.34-.13a1.5 1.5 0 0 1 .37-.04h.02z\" fill=\"url(#O)\"/><path d=\"M62.28 72.04c-.25-.11-.47-.24-.63-.4-.1-.09-.17-.2-.22-.3 0-.01-.01-.02-.01-.02a.71.71 0 0 1-.07-.32v.86c0 .06.01.1.01.14.01.04.02.08.04.12.01.02.02.03.02.05 0 .01.01.02.01.02.01.02.01.03.02.05.03.04.05.09.09.13.03.04.06.08.1.11l.04.04c.08.08.18.15.28.21.09.06.2.11.31.16l.01-.85z\" fill=\"url(#P)\"/><path d=\"M58.88 72.49h-.04c-.03 0-.06 0-.09.01-.03 0-.06.01-.09.01s-.06.01-.09.02-.07.02-.1.02l-.08.03c-.01.01-.03.01-.04.02a1.01 1.01 0 0 0-.15.07l-2.02 1.19c-.18.1-.28.25-.28.4v.86c0-.15.1-.3.28-.4l2.02-1.19c.06-.04.13-.06.19-.09a1.59 1.59 0 0 1 .5-.08l-.01-.87z\" fill=\"url(#Q)\"/><path d=\"M58.99 74.66v-.86c-.08-.04-.14-.09-.2-.14-.04-.03-.09-.06-.12-.09-.08-.07-.16-.15-.21-.24a.79.79 0 0 1-.14-.45v.86c0 .06.01.1.01.15.01.04.02.08.04.12l.06.13.03.06c.01.02.03.04.05.07a1.1 1.1 0 0 0 .15.16c.01.01.01.01.02.01l.12.09c.05.03.09.07.14.1.01.01.03.02.05.03z\" fill=\"url(#R)\"/><path d=\"M58.43 76.02v-.86c-.269.146-.559.247-.86.3-.22.04-.45.06-.69.07-.26 0-.52-.03-.76-.08-.03-.01-.06-.02-.09-.02-.23-.05-.45-.12-.64-.22-.03-.02-.06-.03-.09-.05v.07l-.13.03a.58.58 0 0 0-.14.05c-.02.01-.05.01-.07.02-.01 0-.03.01-.04.01-.1.04-.2.09-.28.13-.25.15-.41.32-.45.52-.01.03-.01.06-.01.09v.86c0-.03 0-.06.01-.09.04-.19.2-.37.45-.52l.32-.15c.02-.01.04-.01.07-.02.11-.04.23-.08.37-.1.12.06.25.11.39.16l.24.06c.03.01.06.02.09.02.03.01.05.01.07.02.09.02.19.03.28.04l.25.02h.16.08l.23-.01c.07-.01.15-.01.22-.02l.17-.03c.13.08.23.17.29.27l.01-.35c.09-.03.17-.05.25-.09.1-.03.2-.08.3-.13z\" fill=\"url(#S)\"/><path d=\"M66.11 70.79c-.14-.11-.25-.23-.33-.36a.94.94 0 0 1-.11-.42v.86c0 .06.01.11.01.15a.93.93 0 0 0 .04.13l.06.13v.02c.02.04.05.08.08.12.04.05.09.1.14.15.03.03.07.06.1.09l.01-.87z\" fill=\"url(#T)\"/><path d=\"M68.29 71v-.86c0 .18-.06.36-.18.52-.07.1-.2.18-.31.26l.48.15c0-.02.01-.04.01-.07z\" fill=\"url(#U)\"/><path d=\"M79.84 67.77a.8.8 0 0 1-.09.36 1 1 0 0 1-.26.33l-1.54 1.4a1.16 1.16 0 0 1-.31.22c-.18.1-.39.19-.62.25a3.54 3.54 0 0 1-.47.09v.44c-.05.03-.08.07-.13.1-.12.07-.27.13-.42.18-.02.01-.05.02-.07.02-.16.05-.33.09-.51.12l-2.73.43v-.72c-.11.18-.29.34-.52.48-.18.1-.4.19-.63.26-.274.076-.556.116-.84.12-.3.01-.59-.02-.86-.07l-1.69-.35c.07-.12.11-.24.13-.36l-.48-.15c-.06.04-.09.1-.16.14a2.42 2.42 0 0 1-.4.18c-.02.01-.04.01-.06.02l-2.48.83c-.19.06-.39.11-.6.14a3.47 3.47 0 0 1-.64.03l-.88 1.13c-.11.14-.27.27-.46.38a2.88 2.88 0 0 1-.78.3c-.19.04-.38.07-.57.08h-.04c-.19.01-.38.01-.57-.01l-1.73 1.02v.86L60.16 75l.25.02h.22.09.04.08c.07-.01.14-.01.22-.02s.15-.02.22-.04c.01 0 .03-.01.04-.01l.16-.04.29-.1a2.52 2.52 0 0 0 .33-.16 1.76 1.76 0 0 0 .46-.38l.88-1.13h.21l.22-.01c.06-.01.13-.01.19-.02h.02c.08-.01.15-.02.22-.04l.24-.06c.04-.01.08-.02.12-.04l2.48-.83c.02-.01.04-.01.06-.02l2.61.54c.03.01.06.01.09.02.1.02.19.03.29.04l.24.02h.22l.21-.01.21-.02.22-.04c.07-.01.14-.03.21-.05.06.01.11.02.17.02l.23.02h.13.04.05l.21-.01.21-.02c.02 0 .05-.01.07-.01l2.77-.43.17-.03.25-.06.08-.03c.02-.01.05-.02.07-.02.04-.01.08-.02.11-.04.11-.04.21-.09.31-.15.3-.17.51-.39.6-.63.01 0 .02-.01.03-.01l.26-.09c.12-.05.23-.1.32-.16.11-.07.21-.14.31-.22l1.54-1.4c.23-.21.34-.45.34-.69l.07-.89z\" fill=\"url(#V)\"/><path d=\"M81.1 67.11c-.1.1-.23.2-.37.28-.124.072-.255.132-.39.18l-.08.03c-.13.05-.27.09-.42.12v.86l.23-.06.19-.06.08-.03c.01-.01.03-.01.04-.01.121-.046.238-.103.35-.17.14-.08.27-.18.37-.28v-.86z\" fill=\"url(#W)\"/><path d=\"M80.16 66.97l-3.41-.83 3.41.83z\" fill=\"url(#X)\"/><path d=\"M84.29 65.54c2.18-.15 4.24-.71 5.81-1.61.85-.49 1.56-1.09 2.06-1.77 2.08-2.86-.23-6.15-5.16-7.34-3.73-.91-7.88-.36-10.59 1.21-.87.5-1.59 1.11-2.1 1.8-1.41 1.94-.76 4.06 1.31 5.61l-1.5 2.06 1.7.41.93.22 3.42.83.93.23 1.69.41 1.5-2.06zm5.67-3.91c-.38.52-.92.97-1.57 1.35-1.65.95-4.02 1.4-6.36 1.18-.55-.05-1.1-.14-1.64-.26-.53-.13-1.02-.31-1.47-.5-2.67-1.13-3.76-3.2-2.42-5.04.38-.52.92-.98 1.58-1.36 2.04-1.18 5.18-1.59 7.98-.91 3.73.9 5.47 3.38 3.9 5.54z\" fill=\"url(#Y)\"/><path d=\"M54.18 76.09l-1.01.07-1.83.12.44 2.23c-.42.18-.82.37-1.18.58-2.02 1.17-3.15 2.83-2.8 4.59.6 3.08 5.4 5.28 10.72 4.92 2.25-.15 4.23-.74 5.72-1.6 2.03-1.17 3.15-2.85 2.8-4.62-.42-2.09-2.78-3.75-5.9-4.51l-.44-2.22-1.82.12-1.01.07-3.69.25zm10.49 6.45c.27 1.34-.58 2.6-2.11 3.48-1.12.65-2.62 1.09-4.32 1.21-4 .27-7.62-1.39-8.08-3.7-.26-1.33.58-2.59 2.11-3.47.74-.43 1.65-.77 2.67-.98.53-.11 1.07-.2 1.66-.24.57-.04 1.14-.03 1.7.01 3.28.21 5.98 1.7 6.37 3.69z\" fill=\"url(#Z)\"/><path d=\"M80.01 67.07c-.12.07-.27.13-.43.17-.18-.19-.44-.36-.77-.48-.51-.19-1.09-.25-1.68-.17l-.26.04c-.13-.17-.17-.34-.12-.5l-.93-.22c-.17.33-.11.69.18 1.02.01.01.01.02.02.02-.11.06-.2.13-.29.21l-1.54 1.4c-.117.107-.213.236-.28.38l-2.41.38-.35.07-2.5-.52a3.61 3.61 0 0 0-1.7.05c-.08.02-.15.04-.23.07-.02.01-.05.01-.08 0-.57-.09-1.18-.04-1.68.13l-2.49.84c-.161.057-.318.124-.47.2.22.02.44.05.65.11a2.84 2.84 0 0 0-.65-.1c-.68-.05-1.36.09-1.84.37a1.76 1.76 0 0 0-.46.38l-.73.94c-.6-.01-1.2.11-1.65.38l-2.03 1.2c-.64.38-.8.93-.48 1.39a3.85 3.85 0 0 0-.87.35c-.47.27-.75.62-.75 1l1.01-.07c.04-.19.2-.37.45-.52.2-.12.46-.21.75-.27.41.21.94.32 1.49.32.24 0 .47-.02.69-.07.13.08.24.18.3.28l1.01-.07c-.08-.19-.23-.37-.44-.52l.03-.02 1.7-1c.39.04.79.02 1.18-.07a2.88 2.88 0 0 0 .78-.3c.174-.1.33-.228.46-.38l.88-1.13c.42.01.85-.04 1.24-.17l2.48-.83c.02-.01.04-.01.06-.02l2.61.54c.56.12 1.16.1 1.7-.05.24-.07.45-.15.63-.26-.18.1-.4.19-.63.26.36.05.74.05 1.11-.01l2.77-.43c.39-.06.73-.17 1-.33.3-.17.51-.39.6-.63.23-.06.44-.15.62-.25.11-.07.21-.14.31-.22l1.54-1.4c.24-.23.36-.48.34-.74a2.84 2.84 0 0 0 .89-.33c.137-.074.261-.169.37-.28l-.93-.23c-.07.03-.12.06-.18.09zm-22.44 7.66c-.05.03-.11.05-.16.07-.442-.108-.895-.158-1.35-.15-.11-.09-.16-.2-.17-.31 0-.15.1-.3.28-.4l2.02-1.19c.06-.04.13-.06.19-.09-.11.25-.08.52.08.77.12.18.31.34.54.47l-1.43.83zm3.87-1.54c-.05.06-.12.12-.2.17l-.19.09c.18-.43-.02-.9-.6-1.23l-.3-.14.68-.87c.05-.07.12-.12.2-.17.1-.06.21-.1.34-.13-.06.28.03.56.28.8.16.16.38.3.63.4l-.84 1.08zm2.63-1.63c-.04.01-.08.03-.13.04.09-.4-.16-.81-.66-1.08l2.29-.77.21-.05c-.24.42-.09.86.33 1.18l-2.04.68zm5.86-.65c.04.09.1.17.17.25l-1.99-.41c.27-.36.25-.79-.12-1.16l-.06-.06c.104 0 .208.01.31.03l1.89.39c-.28.3-.35.64-.2.96zm5.18-.22l-2.4.38c.18-.32.15-.65-.1-.96-.05-.06-.11-.12-.18-.18l1.53-.24c.16.27.48.51.91.66.15.06.31.12.47.15.05.02.09.04.13.06a.96.96 0 0 1-.36.13zm3.33-2.53l-1.54 1.4-.03.03c-.19-.24-.5-.44-.91-.57a3.32 3.32 0 0 0-.64-.15l1.46-1.32.05-.04c.237.109.485.192.74.25.34.08.68.13 1.02.14-.01.1-.06.18-.15.26z\" fill=\"url(#a)\"/><path d=\"M9.92 56.96a1.04 1.04 0 0 1-.735-.305 1.04 1.04 0 0 1-.305-.735l-.03-2.86c-.15-9.63-.41-25.75 7.03-31.66 2.75-2.18 6.27-2.76 10.48-1.72 3.53.88 5.44 3.45 6.83 5.33.51.68.94 1.27 1.3 1.56.45.36.52 1.02.16 1.46-.36.45-1.01.52-1.46.16-.57-.46-1.08-1.14-1.66-1.94-1.27-1.72-2.86-3.85-5.66-4.55-3.6-.89-6.44-.46-8.68 1.33-6.64 5.28-6.38 21.36-6.24 30l.03 2.89c-.02.57-.49 1.04-1.06 1.04z\" fill=\"url(#b)\"/><path d=\"M34.76 81.33h-.36-.61l-1.51-.12-.17-.03-.4-.06-1.17-.19-.49-.14-1.35-.39-.72-.21c-.11-.04-.19-.11-.3-.15-.94-.38-1.85-.82-2.66-1.37-.06-.04-.11-.08-.17-.11-.26-.18-.44-.39-.68-.58l-.95-.82c-.03-.03-.06-.05-.09-.08-.309-.329-.59-.684-.84-1.06-.06-.08-.09-.17-.15-.25l-.15-.26-.25-.43c-.137-.293-.257-.593-.36-.9l-.03-.14c-.02-.06-.03-.12-.04-.17l-.14-.58c-.05-.301-.08-.605-.09-.91v-.14l-.02-7.35-.03-12.81-.2-13.84c-.16-7.47 6.49-13.83 13.94-13.83 7.44 0 14.09 6.36 13.94 13.83l-.2 13.84-.03 12.81-.02 7.35v.14a7.01 7.01 0 0 1-.09.91c-.03.19-.09.39-.14.58-.02.06-.03.12-.04.17l-.03.14a8.45 8.45 0 0 1-.36.9c-.07.15-.17.29-.25.43-.05.09-.1.17-.15.26-.05.08-.09.17-.15.25-.25.376-.531.731-.84 1.06-.03.03-.06.05-.09.08-.28.29-.62.55-.95.82-.23.19-.42.4-.68.58-.053.042-.11.079-.17.11-.81.55-1.72.98-2.66 1.37-.11.04-.19.11-.3.15-.23.09-.49.13-.72.21-.444.15-.895.28-1.35.39-.17.04-.32.11-.49.14-.38.08-.78.13-1.17.19-.13.02-.26.05-.4.06l-.17.03c-.5.06-1 .1-1.51.12-.2.01-.41 0-.61 0h-.38z\" fill=\"url(#c)\"/><path d=\"M40.29 48.64c.69-1.8.95-2.01.96-2.03 0 .02.06.34.08.95.06 1.16.39 2.47 1.29 2.69.32.08.71-.02 1.09-.24.49-.28.99-.77 1.36-1.36 1.19-1.89 1.11-3.81.9-5.33l-.36-2.65c.03-.01.66-.14 1.31.06.6.18 1.24.65 1.7 1.08l.15 4.46-.06 4.38-.22 3.54c-1 1.61-2.12 2.59-2.63 3-.4.33-.8.61-1.2.84-3.05 1.76-5.91.66-5.94-3.03-.02-1.94.77-4.25 1.57-6.36z\" fill=\"#fff\"/><path d=\"M35.2 23.2l-6.13-3.56c-.04-.01-.06-.03-.09-.04l-.08-.03c-.03-.01-.06-.02-.09-.02-.03-.01-.06-.01-.09-.01h-.1-.04c-.03 0-.05 0-.07.01l-.14.03-.19.06c-.07.03-.15.07-.22.11-.192.116-.37.253-.53.41-.02.02-.05.05-.07.08l-.03.03c-.02.03-.05.05-.07.08-.04.05-.09.1-.13.16-.04.05-.07.09-.1.14-.03.04-.06.09-.09.14-.03.04-.05.09-.08.13l-.07.12-.07.13-.06.14-.06.14a.88.88 0 0 0-.05.15l-.03.09c-.01.04-.01.06-.02.08-.02.06-.03.12-.04.18-.02.07-.03.15-.04.22l-.02.31c0 .5.18.85.46 1.01L33 27.06c-.09-.05-.15-.16-.22-.25.27.38.76.47 1.34.14.87-.5 1.57-1.72 1.57-2.72-.03-.52-.2-.87-.49-1.03zm-.5-.1c.06-.01.1.03.16.03-.05-.01-.1-.04-.16-.03zm-2.19 2.93a1.47 1.47 0 0 0 .13.63 1.47 1.47 0 0 1-.13-.63z\" fill=\"url(#d)\"/><path d=\"M9.83 63.92h-.07-.12a3.02 3.02 0 0 1-.3-.02h-.03c-.03 0-.05-.01-.08-.01-.08-.02-.15-.03-.23-.04l-.1-.03-.27-.07c-.05-.01-.1-.02-.14-.04l-.06-.03c-.19-.07-.37-.14-.53-.24-.01-.01-.02-.01-.03-.02-.05-.03-.09-.07-.13-.1-.06-.05-.13-.09-.19-.15-.01 0-.01-.01-.02-.01-.06-.06-.12-.12-.17-.19-.01-.01-.02-.03-.03-.04-.01-.02-.02-.03-.03-.05-.02-.03-.04-.05-.05-.08-.03-.05-.05-.11-.07-.16 0-.01 0-.02-.01-.02 0-.01-.01-.02-.01-.03l-.03-.1c-.01-.05-.02-.11-.02-.16v-.02V61l-.01-2.28-.04-2.46c-.03-1.33 1.28-2.46 2.75-2.46s2.78 1.13 2.75 2.46l-.04 2.46-.01 2.28v1.31.02c0 .05-.01.11-.02.16l-.03.1c0 .01-.01.02-.01.03s0 .02-.01.02c-.02.05-.04.11-.07.16-.01.03-.03.05-.05.08-.01.02-.02.03-.03.05-.01.01-.02.03-.03.04-.05.06-.1.13-.17.19 0 0-.01.01-.02.01-.05.05-.12.1-.19.15-.05.03-.08.07-.13.1-.01.01-.02.01-.03.02-.16.1-.34.17-.53.24l-.06.03c-.05.02-.1.02-.14.04-.09.03-.18.05-.27.07l-.1.03-.23.03c-.03 0-.05.01-.08.01h-.03l-.3.02h-.12c.02.01 0 .01-.03.01z\" fill=\"url(#e)\"/><path d=\"M34.76 27.61h-.1-.18l-.44-.03c-.02 0-.03-.01-.05-.01a.36.36 0 0 1-.11-.02l-.34-.05c-.05-.01-.09-.03-.14-.04l-.39-.11-.21-.06c-.03-.01-.06-.03-.09-.04-.27-.11-.53-.24-.77-.39-.02-.01-.03-.02-.05-.03-.07-.05-.13-.11-.2-.17-.09-.08-.2-.15-.28-.24-.01-.01-.02-.01-.03-.02-.089-.096-.169-.2-.24-.31-.02-.02-.03-.05-.04-.07-.017-.025-.031-.052-.04-.08-.02-.04-.05-.08-.07-.13-.04-.09-.08-.17-.1-.26 0-.01-.01-.03-.01-.04-.01-.02-.01-.03-.01-.05-.01-.06-.03-.11-.04-.17l-.03-.26v-.04c0-.71-.05-.47-.07-1.81-.05-2.16 1.88-4 4.03-4s4.07 1.84 4.03 4l-.07 1.81v.04c0 .087-.01.175-.03.26-.01.06-.03.11-.04.17 0 .02-.01.03-.01.05 0 .01-.01.03-.01.04l-.1.26c-.02.04-.05.08-.07.13-.01.03-.03.05-.04.08-.02.02-.03.05-.04.07l-.24.31c-.01.01-.02.01-.03.02-.08.08-.18.16-.28.24-.07.06-.12.12-.2.17-.02.01-.03.02-.05.03-.23.16-.5.28-.77.39-.03.01-.06.03-.09.04-.07.03-.14.04-.21.06l-.39.11c-.05.01-.09.03-.14.04l-.34.05c-.04.01-.08.01-.11.02-.02 0-.03.01-.05.01-.14.02-.29.03-.44.03h-.18-.1z\" fill=\"url(#f)\"/><path d=\"M32.13 21.75c-.08.04-.14.11-.19.19-.01.01-.01.03-.02.04-.02.02-.02.03-.03.04-.01.03-.02.06-.04.08l-.03.08c-.01.03-.02.06-.02.09-.01.03-.01.05-.02.08s-.01.06-.01.09-.01.06-.01.09v.02.05.06l3.7-2.14v-.13l.04-.29a1.02 1.02 0 0 1 .11-.29c.06-.1.13-.18.22-.24l-3.7 2.18z\" fill=\"url(#g)\"/><path d=\"M38.77 16.83l-4.42-2.55-3.42 2.71 4.11 2.02 9.04 15.6-.01.99 3.74-2.17v-.99l-9.04-15.61z\" fill=\"url(#h)\"/><path d=\"M29.76 13.83l3.44-2 1.05-.6-3.44 2-1.05.6z\" fill=\"url(#i)\"/><path d=\"M44.17 23.36l2.77-1.81-.03-1.68-9.45-7.44-3.21-1.25-3.43 1.99 3.21 1.25 10.14 7.97v.97z\" fill=\"url(#j)\"/><path d=\"M44.17 22.39l-10.14-7.97-3.21-1.25-1.06.65 1 2.92-.01 2.36-.01 2.99 1.02.59c0-.08-.01-1.51 1.18-.83s1.11 2.07 1.1 2.14l10.06 11.6v-.99l-9.07-15.61-1.86-1 10.99 5.36v-.96h.01z\" fill=\"url(#k)\"/><path d=\"M31.82 16.35a.45.45 0 1 0 0-.9.45.45 0 1 0 0 .9z\" fill=\"url(#l)\"/></g></g><defs><linearGradient id=\"A\" x1=\"91.785\" y1=\"58.226\" x2=\"70.877\" y2=\"58.226\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"B\" x1=\"80.299\" y1=\"62.054\" x2=\"72.27\" y2=\"62.054\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"C\" x1=\"87.246\" y1=\"66.663\" x2=\"68.762\" y2=\"66.663\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"D\" x1=\"69.236\" y1=\"71.211\" x2=\"70.458\" y2=\"71.211\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"E\" x1=\"54.639\" y1=\"74.917\" x2=\"54.801\" y2=\"74.917\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"F\" x1=\"54.802\" y1=\"77.828\" x2=\"50.892\" y2=\"77.828\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"G\" x1=\"70.717\" y1=\"81.274\" x2=\"48.896\" y2=\"81.274\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"H\" x1=\"68.611\" y1=\"86.163\" x2=\"46.267\" y2=\"86.163\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"I\" x1=\"94.283\" y1=\"64.128\" x2=\"53.825\" y2=\"64.128\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"J\" x1=\"70.857\" y1=\"68.537\" x2=\"80.801\" y2=\"68.537\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"K\" x1=\"75.404\" y1=\"66.953\" x2=\"77.214\" y2=\"66.953\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"L\" x1=\"70.77\" y1=\"70.461\" x2=\"77.676\" y2=\"70.461\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"M\" x1=\"66.329\" y1=\"70.085\" x2=\"72.271\" y2=\"70.085\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"N\" x1=\"61.797\" y1=\"70.433\" x2=\"67.607\" y2=\"70.433\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"O\" x1=\"57.994\" y1=\"71.818\" x2=\"64.329\" y2=\"71.818\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"P\" x1=\"59.407\" y1=\"71.943\" x2=\"65.549\" y2=\"71.943\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"Q\" x1=\"53.179\" y1=\"73.796\" x2=\"61.223\" y2=\"73.796\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"R\" x1=\"56.958\" y1=\"73.771\" x2=\"59.772\" y2=\"73.771\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"S\" x1=\"51.419\" y1=\"76.054\" x2=\"63.068\" y2=\"76.054\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"T\" x1=\"65.054\" y1=\"70.832\" x2=\"67.901\" y2=\"70.832\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"U\" x1=\"67.283\" y1=\"70.613\" x2=\"69.716\" y2=\"70.613\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"V\" x1=\"123.359\" y1=\"71.894\" x2=\"8.541\" y2=\"71.894\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"W\" x1=\"90.521\" y1=\"67.839\" x2=\"65.71\" y2=\"67.839\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"X\" x1=\"88.892\" y1=\"66.554\" x2=\"21.65\" y2=\"66.554\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"Y\" x1=\"103.052\" y1=\"60.994\" x2=\"52.32\" y2=\"60.994\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"Z\" x1=\"85.095\" y1=\"82.144\" x2=\"36.212\" y2=\"82.144\" xlink:href=\"#o\"><stop stop-color=\"#842bc5\"/><stop offset=\".239\" stop-color=\"#9f5ad2\"/><stop offset=\".78\" stop-color=\"#e3cef2\"/><stop offset=\"1\" stop-color=\"#fff\"/></linearGradient><linearGradient id=\"a\" x1=\"42.997\" y1=\"71.036\" x2=\"138.956\" y2=\"71.036\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"b\" x1=\".382\" y1=\"38.067\" x2=\"37.506\" y2=\"38.067\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"c\" x1=\"14.068\" y1=\"52.852\" x2=\"52.167\" y2=\"52.852\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"d\" x1=\"15.04\" y1=\"23.331\" x2=\"37.945\" y2=\"23.331\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"e\" x1=\"5.437\" y1=\"58.863\" x2=\"14.604\" y2=\"58.863\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"f\" x1=\"21.592\" y1=\"23.393\" x2=\"64.346\" y2=\"23.393\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"g\" x1=\"27.528\" y1=\"21.143\" x2=\"37.089\" y2=\"21.143\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"h\" x1=\"21.137\" y1=\"24.944\" x2=\"62.974\" y2=\"24.944\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"i\" x1=\"34.251\" y1=\"11.228\" x2=\"29.762\" y2=\"13.828\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"j\" x1=\"21.85\" y1=\"17.273\" x2=\"60.751\" y2=\"17.273\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"k\" x1=\"27.565\" y1=\"24.389\" x2=\"85.92\" y2=\"24.389\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"l\" x1=\"30.725\" y1=\"15.901\" x2=\"32.459\" y2=\"15.901\" xlink:href=\"#o\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"m\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"n\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"o\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgVehicleVandalism = '<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><g clip-path=\"url(#J)\"><g clip-path=\"url(#K)\"><path opacity=\".3\" d=\"M69.25 95.83l23.53-13.58c10.71-6.18 9.35-17.09-3.01-24.23l-17.05-9.84c-12.37-7.14-31.25-7.92-41.96-1.74L7.23 60.02c-10.71 6.18-9.35 17.09 3.01 24.23l17.05 9.84c12.36 7.14 31.25 7.92 41.96 1.74z\" fill=\"#e3d4ff\"/><path d=\"M14.1 72.88c.63-.6 1.58-.74 2.25-1.26.87-.67 1.45-1.7 2.27-2.49l5.66-5.54 51.35-51.05c-.06.06.73 1.19.69 1.27-.05.09-.07.18-.09.28-.01.12-.01.22-.01.34v.04c.012.121.032.241.06.36 0 .02.01.03.01.05.032.132.072.262.12.39l.03.09.16.39c.01.03.02.06.04.09.031.07.068.137.11.2l.2.37.33.54.58.81c.02.02.04.04.05.07l.62.73c.01.01.02.02.03.04.23.25.51.42.75.66l.74.67.02.02.72.56c.01.01.03.02.04.03.23.17.46.32.69.45.01.01.02.01.03.02.2.12.3.18.49.26.06.02.2.04.25.06.2.08.49.18.68.19.41.03 1.71.51 1.91.33-17.75 16.22-36.68 32-54.68 48.13l-5.44 4.86c-1.07.97-2.33 1.81-3.2 2.77-.54.6-.62 1.31-1.28 1.91-.17.16-.44.21-.82.13-.15-.03-.31-.09-.47-.15-.05-.02-.09-.04-.14-.06a1.01 1.01 0 0 1-.15-.07c-.1-.05-.21-.11-.32-.17-.01 0-.01-.01-.02-.01s-.01-.01-.02-.01l-.22-.13c-.08-.05-.15-.1-.23-.15-.04-.03-.09-.06-.13-.09-.01-.01-.02-.02-.03-.02-.02-.01-.04-.02-.05-.04a2.92 2.92 0 0 1-.21-.16c-.07-.05-.13-.11-.2-.16-.05-.04-.1-.08-.14-.12l-.02-.02-.03-.03c-.06-.06-.13-.11-.19-.17s-.13-.11-.19-.17-.13-.12-.19-.18l-.02-.02c-.06-.05-.11-.11-.16-.16-.06-.06-.12-.13-.18-.19-.06-.07-.12-.13-.18-.2-.02-.02-.04-.04-.05-.06l-.03-.03c-.04-.04-.07-.08-.11-.12-.07-.08-.14-.16-.21-.25-.07-.08-.14-.17-.2-.25-.01-.02-.03-.03-.04-.05-.01-.01-.02-.03-.03-.04-.16-.21-.32-.43-.46-.65-.1-.14-.18-.29-.26-.42-.01-.01-.01-.02-.02-.03-.06-.1-.11-.2-.16-.3-.03-.05-.06-.11-.09-.16 0-.01-.01-.01-.01-.02-.01-.02-.02-.04-.03-.07-.04-.08-.07-.16-.1-.23-.01-.03-.02-.07-.04-.1-.01-.02-.02-.05-.03-.07s-.02-.05-.03-.07l-.06-.2C14 74.03 14 74.01 14 74s-.01-.03-.01-.04c-.01-.03-.01-.05-.02-.08l-.03-.16c0-.02 0-.04-.01-.06v-.03-.05-.13c0-.03 0-.06.01-.09v-.03c.01-.04.01-.07.02-.11s.021-.069.04-.1v-.02c.01-.03.03-.05.04-.07\" fill=\"url(#A)\"/><path d=\"M75.47 12.58l-.02.02c0-.01.01-.01.02-.02a1.06 1.06 0 0 0-.1.12l.04-.04c-.03.04-.06.07-.08.12v.03c0 .01 0 .02-.01.03-.01.02-.01.03-.01.04s-.01.02-.01.03c0 .02 0 .03-.01.03v.05c0 .01 0 .03-.01.04v.03.06.07.04c0 .01.01.03.01.05v.07.05c0 .02.01.03.01.05v.05c0 .02 0 .02.01.03 0 .02.01.03.01.05s.01.03.01.04c.01.03.01.06.02.1 0 .01.01.03.01.04s0 .03.01.04.01.03.02.05.01.04.01.06c0 .01.01.02.01.04.01.02.01.04.02.05 0 .01.01.02.01.04.02.05.03.1.05.15.01.02.02.05.03.07s.01.03.02.05c.01 0 .01.02.02.03.03.07.05.13.09.2.01.03.03.06.04.09.04.1.09.19.14.28.03.05.05.1.08.16 0 .01.01.02.02.03l.36.61.47.71.76 1c.02.03.03.05.05.07l.35.42.17.2.12.14.02.02c.03.03.05.06.08.09.05.06.11.11.16.17l.03.03c.01.02.03.05.06.07.06.07.13.13.19.2.02.04.05.06.07.08l.13.13c.02.02.04.05.06.07l.06.06.12.12.08.08c.01.02.01.02.02.03l.05.05.13.12.07.07.03.03.12.11.09.09.03.03c.02.02.04.03.06.05a1.79 1.79 0 0 1 .14.13c.02.02.05.04.07.06l.02.02c.01.01.03.02.04.03.029.02.056.044.08.07.04.03.08.06.11.1l.03.03c.02.02.03.02.04.03l.11.09c.02.02.05.04.07.06.03.03.05.04.07.06.02.01.03.03.05.04.03.02.05.05.08.07.01.01.02.01.02.02.01.01.03.02.04.03s.02.02.03.02c.03.02.05.04.08.06.01.01.02.01.03.02s.02.02.04.03c.01.01.03.02.04.03.03.03.07.05.1.08.02.01.04.03.06.05.01.01.03.02.04.03.02.01.03.02.05.03.01.01.03.02.04.03.02.02.03.02.04.03.02.02.05.03.07.05.01.01.03.02.04.03.02.02.05.03.07.05.01 0 .01.01.02.01s.01.01.02.01c.02.01.02.02.03.02.03.01.04.02.06.03s.04.03.06.05c.01.01.02.01.03.02.02.01.04.03.06.04.01.01.02.01.03.02.01 0 .01.01.02.01s.01.01.02.01c.01.01.02.01.03.02s.02.01.03.02l.08.05c.02.01.05.03.07.04s.03.02.05.03.05.03.07.04c.01.01.03.02.04.02.01.01.02.01.03.02.02.01.04.02.06.04.01.01.02.01.02.01.01 0 .01.01.02.01.01.01.02.01.03.02l.06.03c.01.01.03.01.04.02s.02.01.03.02.02.01.04.02l.06.03c.01.01.02.02.04.02.02.01.03.02.03.02.01.01.02.01.04.02.01.01.02.01.03.02.01 0 .01.01.02.01s.02.01.03.01c.01.01.02.01.03.02.01 0 .02.01.02.01.01 0 .01.01.02.01s.02 0 .02.01l.47.18c.5.16.85.13 1.05-.05l.2-.19.19-.2.17-.2.17-.21.05-.07c.02-.02.03-.04.05-.06l.05-.07.14-.21.12-.21c.01-.01.01-.03.02-.04.01-.02.02-.03.03-.05.02-.03.03-.06.05-.09l.14-.3c.02-.06.05-.12.07-.17l.04-.12c0-.01.01-.03.01-.04l.01-.04.03-.12.05-.24.01-.09c0-.06.01-.13.01-.19v-.03-.04l-.01-.2c-.01-.12-.03-.24-.05-.36 0-.02 0-.03-.01-.05 0-.03-.01-.05-.01-.07l-.02-.09c-.17-.73-.57-1.43-1.06-2.15-.01-.02-.02-.03-.03-.05l-.06-.08.05.08-.13-.19-.24-.32c-.078-.111-.161-.218-.25-.32l-.26-.32-.26-.31-.27-.31-.1-.11c-.01-.01-.02-.02-.02-.03-.03-.03-.06-.07-.1-.1l-.06-.06c-.02-.02-.05-.06-.08-.08l.04.04-.25-.26c-.09-.08-.2-.2-.28-.28l-.29-.27-.29-.26-.29-.25-.29-.24-.19-.15c-.01 0-.01-.01-.02-.01l-.07-.05-.01-.01.02-.03.02.01-.28-.21-.28-.19-.28-.18-.19-.11-.04-.03-.04-.02-.16-.08.1.05c-.07-.04-.15-.08-.22-.11l-.26-.12a.61.61 0 0 1-.12-.05c-.01 0-.02-.01-.02-.01l-.1-.03-.05-.01h.01c-.01 0-.01 0-.02-.01-.01 0-.02 0-.02-.01h.01l-.28-.06-.19-.03c-.01 0-.03 0-.04-.01h-.05-.04c-.05 0-.08-.01-.1-.02h-.07-.05-.1c-.08.01-.19.01-.27.02l-.07.02c-.01 0-.02 0-.04.01l-.11.02-.24.06-.21.07-.18.07c.01 0 .02-.01.02-.01-.02.01-.05.02-.07.03l-.04.02c-.02.01-.05.02-.07.03l-.1.04c-.07.03-.16.08-.22.11l-.08.04c-.01.01-.02.01-.04.02l-.1.06-.18.11c-.01 0-.03.01-.04.03l-.21.15-.21.16-.21.17-.17.15a.5.5 0 0 1 .08-.07c-.03.02-.07.06-.11.1zm4.17-1c1.34.42 3.59 2.42 5.04 4.47s1.54 3.37.2 2.95c-.83-.26-2-1.12-3.12-2.23-.04-.04-.07-.08-.11-.11l-.46-.48-.19-.21-.5-.59-.16-.2-.49-.65c-.68-.96-1.05-1.75-1.12-2.29-.03-.32.06-.56.31-.69.14-.05.34-.05.6.03z\" fill=\"url(#B)\"/><path d=\"M79.85 14.53c1.45 2.05 3.7 4.05 5.04 4.47s1.25-.9-.2-2.95-3.7-4.05-5.04-4.47c-1.34-.41-1.25.9.2 2.95z\" fill=\"url(#C)\"/><path d=\"M36.09 64.77c-4.5 4.11-9.38 8.4-14 12.4-.14.12-.36-.05-.68-.13-.14-.044-.277-.097-.41-.16l-.12-.06c-.04-.02-.09-.04-.13-.06-.09-.05-.18-.1-.31-.18-.06-.04-.13-.08-.19-.12-.07-.04-.13-.09-.2-.14-.04-.03-.08-.06-.14-.1-.02-.01-.03-.02-.05-.03-.06-.05-.12-.09-.18-.14s-.12-.09-.18-.14c-.04-.04-.08-.07-.17-.15-.06-.05-.11-.1-.17-.15s-.11-.1-.17-.15-.11-.11-.19-.18l-.14-.14c-.05-.06-.11-.11-.16-.17a2.65 2.65 0 0 0-.16-.17c-.02-.02-.03-.04-.07-.08-.03-.04-.06-.07-.1-.11l-.19-.22c-.06-.07-.12-.15-.18-.22-.01-.02-.03-.03-.04-.05-.01-.01-.02-.02-.03-.04-.15-.19-.28-.38-.41-.57-.09-.13-.16-.25-.25-.4a6.01 6.01 0 0 0-.15-.26c-.02-.05-.05-.09-.09-.16l-.03-.06c-.03-.07-.07-.14-.09-.2l-.03-.09-.03-.06-.03-.06-.06-.18c0-.02-.01-.03-.02-.08-.01-.02-.01-.05-.02-.07-.009-.044-.019-.087-.03-.13 0-.02 0-.04-.01-.08 0-.01 0-.03-.01-.04v-.11c0-.03 0-.05.01-.1 0-.03.01-.06.02-.09a1.29 1.29 0 0 0 .03-.1l.03-.06c.02-.02.03-.05.07-.08l12.74-12.58c.08-.07.23-.23.3-.3l.06.11c.213.474.46.932.74 1.37a12.23 12.23 0 0 0 .96 1.31c.35.43.73.83 1.13 1.22a16.38 16.38 0 0 0 1.25 1.1c.42.34.86.65 1.32.94l.54.32c.13.06.28.17.42.18z\" fill=\"#fff\"/><path d=\"M65.21 47.56l-.03.13c-.11.38-.28.75-.49 1.11l-.11.2c-.22.36-.49.71-.81 1.04-.21.22-.47.41-.72.62-.21.17-.39.36-.63.52-.61.41-1.29.74-2 1.02l-.77.27-1.02.3-1.24.25c-.1.01-.2.04-.3.05-.57.07-1.14.11-1.71.11h-.27c-.57 0-1.13-.04-1.69-.11l-.25-.03c-.56-.08-1.1-.19-1.64-.33l-.29-.08c-.49-.14-.96-.31-1.41-.5-.08-.04-.17-.06-.25-.1-.55-.25-1.07-.53-1.55-.85-2.01-1.35-3.01-3.12-3-4.89l-.07 28.14c0 1.77 1 3.54 3 4.89.46.31.95.58 1.46.82l.08.03c.08.04.17.07.26.1l.89.35v-.04.04c.17.06.34.1.51.15l.29.08.26.07v-.02.02l1.01.2.37.05.25.03.37.05 1 .06h.32.27.46l1.13-.09c.04 0 .08-.02.13-.02.1-.01.2-.03.3-.05l.88-.14c.13-.03.24-.08.37-.11.35-.08.68-.19 1.02-.3l.54-.16c.08-.03.15-.08.23-.12.71-.29 1.39-.61 2-1.02l.12-.09c.19-.14.33-.29.51-.44l.72-.62c.02-.02.05-.04.07-.06.23-.246.441-.511.63-.79.04-.06.07-.13.11-.19l.11-.2.19-.33c.11-.22.2-.45.27-.68l.03-.1.03-.13.11-.43c.04-.23.06-.45.07-.68v-.1l.07-28.14c-.01.43-.08.84-.19 1.24z\" fill=\"url(#D)\"/><path d=\"M57.14 72.84l-.04-12.92c.1-.01.2-.03.3-.05.42-.06.83-.15 1.24-.25.35-.08.68-.19 1.02-.3l.77-.27c.71-.29 1.39-.61 2-1.02.24-.16.42-.35.63-.52l.72-.62c.32-.33.59-.68.81-1.04.042-.063.079-.13.11-.2.21-.36.37-.73.49-1.11l.03-.13a5.07 5.07 0 0 0 .18-1.22l-.05 13.11v.1c-.01.23-.03.46-.07.68l-.11.43-.03.13c-.01.03-.01.07-.03.1-.07.23-.16.45-.27.68-.97 2.01-3.01 3.25-5.05 3.95l-.17.06-1.45.41c-.31.07-.73.14-1.03 0z\" fill=\"#fff\"/><path d=\"M61.85 44.9l-.1-.06-.6-.35-2.27-1.29c-.03-.01-.05-.03-.08-.05l-.06-.03c-.02-.01-.04-.02-.06-.02-.02-.01-.04-.01-.07-.02-.02 0-.05-.01-.07-.01h-.12c-.02 0-.03 0-.05.01-.03.01-.07.01-.1.02-.05.01-.09.03-.14.05s-.11.05-.16.08c-.14.08-.28.19-.4.31l-.08.08-.06.06c-.03.04-.07.08-.1.12l-.08.11-.07.1c-.02.03-.04.07-.07.12-.02.03-.03.06-.05.09s-.04.07-.05.1c-.02.03-.03.07-.05.1-.02.04-.03.07-.04.11s-.03.08-.04.11c-.01.02-.01.04-.02.08 0 .02-.01.03-.01.05l-.03.14-.03.17-.02.24c0 .37.14.64.35.77l.26.15 1.52.85.68.39.43.25c.17.1.34.2.54.19.17-.01.33-.09.47-.17.65-.38 1.19-1.32 1.19-2.07 0-.34-.11-.6-.36-.78z\" fill=\"url(#E)\"/><path d=\"M62.36 41.42c3.98 2.68 4 7.04.03 9.73-3.95 2.68-10.4 2.68-14.38 0-3.99-2.69-4-7.04-.05-9.72 3.97-2.69 10.41-2.7 14.4-.01z\" fill=\"#fff\"/><path d=\"M63.51 45.69c-.16-2.2-.53-4.64-2.03-6.06-1.49-1.42-4.1-1.82-6.3-1.82-2.4 0-5.08.55-6.61 2.19-1.27 1.38-1.58 3.68-1.72 5.69-.03.14-.05.28-.05.43 0 2.13 3.77 4.91 8.35 4.94-.02 0 .02 0 0 0 4.63 0 8.41-2.78 8.41-4.94 0-.15-.02-.29-.05-.43z\" fill=\"url(#F)\"/><path d=\"M60.03 46.5c.06-.2.15-.39.25-.58a3.08 3.08 0 0 1 .37-.5l.02-.02c.14-.15.29-.28.46-.37.16-.09.32-.14.46-.16.15-.01.28.01.39.08l-3.04-1.74c-.03-.01-.05-.02-.07-.03s-.04-.02-.06-.02c-.02-.01-.04-.01-.07-.02-.02 0-.05-.01-.07-.01h-.08-.03c-.03 0-.04 0-.06.01-.03.01-.07.01-.1.02-.05.01-.09.03-.14.05s-.11.05-.16.08c-.14.08-.28.19-.4.31l-.06.06-.02.02-.06.06c-.03.04-.07.08-.1.12l-.08.11-.07.1-.06.1c-.03.04-.04.07-.06.1s-.04.07-.05.1c-.02.03-.03.07-.05.1-.02.04-.03.07-.04.11s-.03.08-.04.11c-.01.02-.01.04-.02.06 0 .03-.01.04-.01.06l-.03.14-.03.17-.02.24c0 .37.14.64.35.77l3.04 1.74c-.22-.13-.35-.39-.35-.77 0-.19.03-.39.09-.59v-.01z\" fill=\"url(#G)\"/><path d=\"M61.13 45.03c.65-.38 1.19-.07 1.2.69 0 .75-.53 1.69-1.19 2.07s-1.2.06-1.21-.69c0-.76.53-1.69 1.2-2.07z\" fill=\"url(#H)\"/><path d=\"M61.409 46.57c.091-.158.072-.34-.043-.406s-.282.008-.373.166-.072.34.043.406.282-.008.373-.166z\" fill=\"#fff\"/><path d=\"M78.8 50.08c-.92-.45-2.07-.29-2.91.28.72-.41 1.08-1.36.81-2.14s-1.14-1.31-1.96-1.19c-1 .15-1.68 1.07-2.24 1.92.04-.07-.36-.71-.41-.8-.38-.62-1.2-.92-1.9-.67-.62.22-1.12.77-1.28 1.42-.05.21-.06.43-.04.64l-7.63-3.13 6.25 3.99c-.05-.03-.28.44-.3.48-.08.2-.12.41-.12.62 0 .63.35 1.31.89 1.64.12.07.24.12.38.13.11.01.22 0 .34-.01-.56.04-.87.57-1.03 1.05-.32.91-.31 2.06.53 2.68.03.03.07.05.11.07.76.47 1.93.19 2.3-.62-.25 1.12.61 2.37 1.75 2.5s2.27-.97 2.12-2.11c.63 1.08 2.34 1.21 3.22.33.87-.89.79-2.49-.1-3.36.92.45 2.14-.18 2.43-1.16.29-.99-.29-2.11-1.21-2.56z\" fill=\"url(#I)\"/></g></g><defs><linearGradient id=\"A\" x1=\"-6.391\" y1=\"46.113\" x2=\"94.464\" y2=\"46.113\" xlink:href=\"#L\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"B\" x1=\"71.955\" y1=\"16.799\" x2=\"113.098\" y2=\"16.799\" xlink:href=\"#L\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"C\" x1=\"70.126\" y1=\"15.296\" x2=\"93.919\" y2=\"15.296\" xlink:href=\"#L\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"D\" x1=\"40.644\" y1=\"63.806\" x2=\"70.207\" y2=\"63.806\" xlink:href=\"#L\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"E\" x1=\"55.694\" y1=\"45.491\" x2=\"93.453\" y2=\"45.491\" xlink:href=\"#L\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"F\" x1=\"44.968\" y1=\"44.428\" x2=\"68.331\" y2=\"44.428\" xlink:href=\"#L\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"G\" x1=\"54.527\" y1=\"45.491\" x2=\"64.79\" y2=\"45.491\" xlink:href=\"#L\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"H\" x1=\"54.017\" y1=\"46.408\" x2=\"63.109\" y2=\"46.408\" xlink:href=\"#L\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><linearGradient id=\"I\" x1=\"59.169\" y1=\"52.676\" x2=\"97.26\" y2=\"52.676\" xlink:href=\"#L\"><stop stop-color=\"#fff\"/><stop offset=\".22\" stop-color=\"#e3cef2\"/><stop offset=\".761\" stop-color=\"#9f5ad2\"/><stop offset=\"1\" stop-color=\"#842bc5\"/></linearGradient><clipPath id=\"J\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><clipPath id=\"K\"><path fill=\"#fff\" d=\"M0 0h100v100H0z\"/></clipPath><linearGradient id=\"L\" gradientUnits=\"userSpaceOnUse\"/></defs></svg>';
var $author$project$Pyxis$Components$IllustrationSet$svgWallet = '<svg width=\"100\" height=\"100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_1819_54)\">\n<path opacity=\"0.3\" d=\"M69.25 95.83L92.78 82.25C103.49 76.07 102.13 65.16 89.77 58.02L72.72 48.18C60.35 41.04 41.47 40.26 30.76 46.44L7.22997 60.02C-3.48003 66.2 -2.12003 77.11 10.24 84.25L27.29 94.09C39.65 101.23 58.54 102.01 69.25 95.83Z\" fill=\"#E3D4FF\"/>\n<path d=\"M13.7999 45.57C11.8099 46.36 10.1899 48.6 10.1899 50.57C10.1999 52.54 11.8199 53.49 13.8199 52.7L26.2699 47.77L26.2499 40.64L13.7999 45.57Z\" fill=\"url(#paint0_linear_1819_54)\"/>\n<path d=\"M9.77003 50.09C9.77003 50.04 9.77003 49.99 9.78003 49.94C9.78003 49.89 9.79003 49.84 9.79003 49.79C9.80003 49.74 9.80003 49.69 9.81003 49.64L9.84003 49.48L9.87003 49.32C9.88003 49.26 9.90003 49.21 9.91003 49.15C9.92003 49.09 9.94003 49.04 9.96003 48.98L10.02 48.8L10.05 48.72C10.05 48.71 10.06 48.71 10.06 48.7L10.09 48.62C10.1124 48.555 10.1392 48.4915 10.17 48.43L10.27 48.22C10.31 48.15 10.34 48.07 10.38 48C10.38 47.99 10.39 47.99 10.39 47.98L10.52 47.76L10.7 47.47L10.78 47.36L10.92 47.17L11.07 46.96L11.25 46.75L11.32 46.68L11.44 46.56L11.65 46.34C11.7286 46.2615 11.8121 46.188 11.9 46.12C11.92 46.1 11.94 46.09 11.96 46.07L11.99 46.04C12.03 46.01 12.07 45.97 12.12 45.94L12.32 45.79L12.51 45.66C12.56 45.63 12.6 45.6 12.65 45.58C12.67 45.56 12.68 45.56 12.69 45.55C12.75 45.52 12.8 45.48 12.86 45.45C12.91 45.42 12.97 45.39 13.03 45.36C13.08 45.33 13.14 45.31 13.19 45.28L13.35 45.21C13.36 45.2 13.37 45.2 13.39 45.2L25.84 40.27L26.27 40.63L13.8 45.57C13.5505 45.6698 13.3096 45.7902 13.08 45.93C12.8505 46.0728 12.63 46.2298 12.42 46.4L12.39 46.43C12.21 46.58 12.04 46.74 11.87 46.91L11.75 47.04L11.35 47.53C11.3 47.59 11.25 47.66 11.21 47.72C11.07 47.92 10.94 48.12 10.83 48.33C10.69 48.58 10.59 48.82 10.5 49.06C10.5 49.07 10.49 49.08 10.49 49.08C10.4 49.33 10.33 49.57 10.28 49.82C10.232 50.0671 10.2085 50.3183 10.21 50.57C10.2109 50.7644 10.2276 50.9584 10.26 51.15V51.17C10.2888 51.3359 10.3392 51.4973 10.41 51.65C10.42 51.66 10.42 51.68 10.43 51.69C10.49 51.82 10.56 51.94 10.63 52.05C10.74 52.2 10.85 52.35 10.99 52.46L10.56 52.1C10.4219 51.9804 10.3007 51.8425 10.2 51.69C10.19 51.68 10.18 51.67 10.17 51.65C10.12 51.58 10.08 51.5 10.04 51.42C10.03 51.39 10.02 51.36 10 51.33C9.99003 51.32 9.99003 51.3 9.98003 51.29C9.97003 51.27 9.96003 51.24 9.95003 51.22L9.89003 51.04C9.87003 50.99 9.86003 50.93 9.85003 50.87C9.84003 50.85 9.84003 50.82 9.84003 50.8V50.78C9.84003 50.76 9.83003 50.73 9.83003 50.71C9.82003 50.66 9.81003 50.61 9.81003 50.55C9.80003 50.5 9.80003 50.45 9.80003 50.39C9.80003 50.34 9.80003 50.29 9.79003 50.23V50.19C9.76003 50.16 9.77003 50.13 9.77003 50.09Z\" fill=\"url(#paint1_linear_1819_54)\"/>\n<path d=\"M22.21 29.98L21.66 28.81C21.5 28.48 21.71 28.09 22.07 28.03L73.97 19.91C75.09 19.74 76.31 19.89 77.17 20.39C77.27 20.45 77.34 20.51 77.43 20.57L74.81 21.75L71.64 22.23L22.21 29.98Z\" fill=\"url(#paint2_linear_1819_54)\"/>\n<path d=\"M71.64 22.25L71.74 58.51L74.91 58.03L74.81 21.76L71.64 22.25Z\" fill=\"url(#paint3_linear_1819_54)\"/>\n<path d=\"M21.6299 28.46L21.45 64.42L22.3099 66.25L22.2099 29.98L21.6299 28.46Z\" fill=\"url(#paint4_linear_1819_54)\"/>\n<path d=\"M22.21 29.98L22.31 66.25L71.74 58.51L71.64 22.25L22.21 29.98Z\" fill=\"url(#paint5_linear_1819_54)\"/>\n<path d=\"M26.9401 19.36C25.5801 19.56 24.4801 20.66 24.4901 21.8L24.5401 38.29L73.3701 31.07L73.3201 14.58C73.3201 13.44 72.2001 12.67 70.8401 12.87L26.9401 19.36Z\" fill=\"url(#paint6_linear_1819_54)\"/>\n<path d=\"M26.96 35.61C25.6 35.81 24.5 36.91 24.51 38.05L24.53 44.83L73.36 37.61L73.34 30.83C73.34 29.69 72.22 28.92 70.86 29.12L26.96 35.61Z\" fill=\"url(#paint7_linear_1819_54)\"/>\n<path d=\"M26.96 41.03C25.6 41.23 24.5 42.33 24.51 43.47L24.53 50.25L73.36 43.03L73.34 36.25C73.34 35.11 72.22 34.34 70.86 34.54L26.96 41.03Z\" fill=\"url(#paint8_linear_1819_54)\"/>\n<path d=\"M77.14 23.12C77.8 22.74 78.13 22.24 78.13 21.74L78.23 58.01C78.23 58.51 77.9 59 77.24 59.39L38.61 81.69L38.51 45.42L77.14 23.12Z\" fill=\"url(#paint9_linear_1819_54)\"/>\n<path d=\"M36.49 44.0699L36.28 80.3399L38.61 81.6899L38.51 45.4199L36.49 44.0699Z\" fill=\"url(#paint10_linear_1819_54)\"/>\n<path d=\"M77.43 20.58L74.81 21.76L72.47 23.11L36.64 43.8C36.44 43.92 36.43 44.21 36.64 44.33L38.51 45.42L77.14 23.12C78.35 22.42 78.44 21.33 77.43 20.58Z\" fill=\"url(#paint11_linear_1819_54)\"/>\n<path d=\"M35.11 21.48C34.33 21.61 33.63 22.01 33.12 22.56C33.76 22.98 34.19 23.66 34.23 24.5C34.27 25.34 33.93 26.15 33.35 26.78C33.91 27.14 34.64 27.3 35.42 27.17C37.09 26.88 38.37 25.38 38.28 23.81C38.2 22.24 36.79 21.2 35.11 21.48Z\" fill=\"#8334C2\"/>\n<path d=\"M31.05 22.18C29.38 22.47 28.09 23.97 28.17 25.54C28.26 27.11 29.68 28.15 31.36 27.87C32.14 27.74 32.84 27.34 33.35 26.79C33.94 26.16 34.28 25.35 34.23 24.51C34.18 23.67 33.76 22.99 33.12 22.57C32.56 22.2 31.83 22.04 31.05 22.18Z\" fill=\"white\"/>\n</g>\n<defs>\n<linearGradient id=\"paint0_linear_1819_54\" x1=\"-2.54306\" y1=\"46.803\" x2=\"38.6989\" y2=\"46.803\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"white\"/>\n<stop offset=\"0.22\" stop-color=\"#E3CEF2\"/>\n<stop offset=\"0.761\" stop-color=\"#9F5AD2\"/>\n<stop offset=\"1\" stop-color=\"#842BC5\"/>\n</linearGradient>\n<linearGradient id=\"paint1_linear_1819_54\" x1=\"3.38003\" y1=\"46.367\" x2=\"48.855\" y2=\"46.367\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"white\"/>\n<stop offset=\"0.22\" stop-color=\"#E3CEF2\"/>\n<stop offset=\"0.761\" stop-color=\"#9F5AD2\"/>\n<stop offset=\"1\" stop-color=\"#842BC5\"/>\n</linearGradient>\n<linearGradient id=\"paint2_linear_1819_54\" x1=\"-14.279\" y1=\"24.917\" x2=\"137.763\" y2=\"24.917\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"white\"/>\n<stop offset=\"0.22\" stop-color=\"#E3CEF2\"/>\n<stop offset=\"0.761\" stop-color=\"#9F5AD2\"/>\n<stop offset=\"1\" stop-color=\"#842BC5\"/>\n</linearGradient>\n<linearGradient id=\"paint3_linear_1819_54\" x1=\"60.407\" y1=\"40.138\" x2=\"75.199\" y2=\"40.138\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"white\"/>\n<stop offset=\"0.22\" stop-color=\"#E3CEF2\"/>\n<stop offset=\"0.761\" stop-color=\"#9F5AD2\"/>\n<stop offset=\"1\" stop-color=\"#842BC5\"/>\n</linearGradient>\n<linearGradient id=\"paint4_linear_1819_54\" x1=\"20.842\" y1=\"47.355\" x2=\"26.7359\" y2=\"47.355\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"white\"/>\n<stop offset=\"0.22\" stop-color=\"#E3CEF2\"/>\n<stop offset=\"0.761\" stop-color=\"#9F5AD2\"/>\n<stop offset=\"1\" stop-color=\"#842BC5\"/>\n</linearGradient>\n<linearGradient id=\"paint5_linear_1819_54\" x1=\"-27.94\" y1=\"44.249\" x2=\"101.887\" y2=\"44.249\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"white\"/>\n<stop offset=\"0.22\" stop-color=\"#E3CEF2\"/>\n<stop offset=\"0.761\" stop-color=\"#9F5AD2\"/>\n<stop offset=\"1\" stop-color=\"#842BC5\"/>\n</linearGradient>\n<linearGradient id=\"paint6_linear_1819_54\" x1=\"0.0470577\" y1=\"25.56\" x2=\"129.945\" y2=\"25.56\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"white\"/>\n<stop offset=\"0.22\" stop-color=\"#E3CEF2\"/>\n<stop offset=\"0.761\" stop-color=\"#9F5AD2\"/>\n<stop offset=\"1\" stop-color=\"#842BC5\"/>\n</linearGradient>\n<linearGradient id=\"paint7_linear_1819_54\" x1=\"17.555\" y1=\"36.953\" x2=\"138.762\" y2=\"36.953\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"white\"/>\n<stop offset=\"0.22\" stop-color=\"#E3CEF2\"/>\n<stop offset=\"0.761\" stop-color=\"#9F5AD2\"/>\n<stop offset=\"1\" stop-color=\"#842BC5\"/>\n</linearGradient>\n<linearGradient id=\"paint8_linear_1819_54\" x1=\"8.96796\" y1=\"42.377\" x2=\"103.976\" y2=\"42.377\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"white\"/>\n<stop offset=\"0.22\" stop-color=\"#E3CEF2\"/>\n<stop offset=\"0.761\" stop-color=\"#9F5AD2\"/>\n<stop offset=\"1\" stop-color=\"#842BC5\"/>\n</linearGradient>\n<linearGradient id=\"paint9_linear_1819_54\" x1=\"-49.275\" y1=\"51.714\" x2=\"129.885\" y2=\"51.714\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"white\"/>\n<stop offset=\"0.22\" stop-color=\"#E3CEF2\"/>\n<stop offset=\"0.761\" stop-color=\"#9F5AD2\"/>\n<stop offset=\"1\" stop-color=\"#842BC5\"/>\n</linearGradient>\n<linearGradient id=\"paint10_linear_1819_54\" x1=\"33.853\" y1=\"62.8779\" x2=\"45.848\" y2=\"62.8779\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"white\"/>\n<stop offset=\"0.22\" stop-color=\"#E3CEF2\"/>\n<stop offset=\"0.761\" stop-color=\"#9F5AD2\"/>\n<stop offset=\"1\" stop-color=\"#842BC5\"/>\n</linearGradient>\n<linearGradient id=\"paint11_linear_1819_54\" x1=\"-15.811\" y1=\"33.002\" x2=\"137.64\" y2=\"33.002\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"white\"/>\n<stop offset=\"0.22\" stop-color=\"#E3CEF2\"/>\n<stop offset=\"0.761\" stop-color=\"#9F5AD2\"/>\n<stop offset=\"1\" stop-color=\"#842BC5\"/>\n</linearGradient>\n<clipPath id=\"clip0_1819_54\">\n<rect width=\"100\" height=\"100\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>\n';
var $author$project$Pyxis$Components$IllustrationSet$toString = function (illustration) {
	switch (illustration) {
		case 0:
			return $author$project$Pyxis$Components$IllustrationSet$svgWallet;
		case 1:
			return $author$project$Pyxis$Components$IllustrationSet$svgVehicleVandalism;
		case 2:
			return $author$project$Pyxis$Components$IllustrationSet$svgVehicleTheftFire;
		case 3:
			return $author$project$Pyxis$Components$IllustrationSet$svgVehicleSecureBonus;
		case 4:
			return $author$project$Pyxis$Components$IllustrationSet$svgVehicleRoadsideAssistance;
		case 5:
			return $author$project$Pyxis$Components$IllustrationSet$svgVehicleRicourseWaiver;
		case 6:
			return $author$project$Pyxis$Components$IllustrationSet$svgVehicleNaturalEvents;
		case 7:
			return $author$project$Pyxis$Components$IllustrationSet$svgVehicleLegalProtection;
		case 8:
			return $author$project$Pyxis$Components$IllustrationSet$svgVehicleGlasses;
		case 9:
			return $author$project$Pyxis$Components$IllustrationSet$svgVehicleFullKasko;
		case 10:
			return $author$project$Pyxis$Components$IllustrationSet$svgVehicleDriverInjuries;
		case 11:
			return $author$project$Pyxis$Components$IllustrationSet$svgVehicleCollisionKasko;
		case 12:
			return $author$project$Pyxis$Components$IllustrationSet$svgVan;
		case 13:
			return $author$project$Pyxis$Components$IllustrationSet$svgSteeringWheel;
		case 14:
			return $author$project$Pyxis$Components$IllustrationSet$svgSmartphoneGear;
		case 15:
			return $author$project$Pyxis$Components$IllustrationSet$svgMotorcycle;
		case 16:
			return $author$project$Pyxis$Components$IllustrationSet$svgMotorcycleCar;
		case 17:
			return $author$project$Pyxis$Components$IllustrationSet$svgMoped;
		case 18:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeTheftValuable;
		case 19:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeTelephoneLegal;
		case 20:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeRobberiesOutside;
		case 21:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeNaturalEvents;
		case 22:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeLegalProtection;
		case 23:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeInsuranceHome;
		case 24:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeInsuranceFamily;
		case 25:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeInjuriesFreetime;
		case 26:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeInjuriesFamily;
		case 27:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeFurnitureContent;
		case 28:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeFireExplosion;
		case 29:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeEmergenciesRepairs;
		case 30:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeDomesticThefts;
		case 31:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeDamageThirdParties;
		case 32:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeDamageThirdPartiesProperty;
		case 33:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeDamageRepair;
		case 34:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeDamagePets;
		case 35:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeDamageFamily;
		case 36:
			return $author$project$Pyxis$Components$IllustrationSet$svgHomeDamageEbikeScooter;
		case 37:
			return $author$project$Pyxis$Components$IllustrationSet$svgCar;
		case 38:
			return $author$project$Pyxis$Components$IllustrationSet$svgCarShiny;
		default:
			return $author$project$Pyxis$Components$IllustrationSet$svgCarProtected;
	}
};
var $author$project$Pyxis$Components$Illustration$render = function (configuration) {
	var illustration = configuration.gT;
	return $author$project$Pyxis$Commons$Render$renderMaybe(
		A2(
			$elm$core$Maybe$map,
			$author$project$Pyxis$Components$Illustration$buildSvg(configuration),
			$elm$core$Result$toMaybe(
				$Garados007$elm_svg_parser$SvgParser$parseToNodes(
					$author$project$Pyxis$Components$Illustration$replaceXlinkHref(
						A2(
							$author$project$Pyxis$Components$Illustration$prefixIdsWithName,
							$author$project$Pyxis$Components$IllustrationSet$toLabel(illustration),
							$author$project$Pyxis$Components$IllustrationSet$toString(illustration)))))));
};
var $author$project$Pyxis$Components$List$renderAddon = F2(
	function (tag, addon) {
		switch (addon.$) {
			case 0:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('list__item__addon', true),
									_Utils_Tuple2('list__item__addon--bullet', !tag),
									_Utils_Tuple2('list__item__addon--number', tag === 1)
								]))
						]),
					_List_Nil);
			case 1:
				var iconConf = addon.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('list__item__addon', true),
									_Utils_Tuple2('list__item__addon--icon', true)
								]))
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Icon$render(iconConf)
						]));
			default:
				var illustrationConf = addon.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('list__item__addon', true),
									_Utils_Tuple2('list__item__addon--icon', true)
								]))
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Illustration$render(illustrationConf)
						]));
		}
	});
var $author$project$Pyxis$Components$List$renderDlItemText = F2(
	function (action, text) {
		return A3(
			$author$project$Pyxis$Commons$Render$renderIfElse,
			$elm_community$maybe_extra$Maybe$Extra$isJust(action),
			text,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[text])));
	});
var $author$project$Pyxis$Components$List$renderDlItemTitle = F2(
	function (addon, title) {
		return A3(
			$author$project$Pyxis$Commons$Render$renderIfElse,
			$elm_community$maybe_extra$Maybe$Extra$isJust(addon),
			$elm$html$Html$text(title),
			A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					])));
	});
var $author$project$Pyxis$Components$List$renderDetailListItem = F4(
	function (listTag, emphasis, itemOrientation, _v0) {
		var text = _v0.pu;
		var title = _v0.iS;
		var addon = _v0.mf;
		var action = _v0.T;
		var classList = _v0.f6;
		var testId = _v0.fv;
		var dataAttrList = _v0.ej;
		return A2(
			$elm$html$Html$div,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_Utils_ap(
							_List_fromArray(
								[
									_Utils_Tuple2('list__item', true),
									_Utils_Tuple2('list__item__wrapper', true),
									_Utils_Tuple2(
									'list__item--with-action',
									$elm_community$maybe_extra$Maybe$Extra$isJust(action)),
									_Utils_Tuple2(
									'list__item--with-addon',
									$elm_community$maybe_extra$Maybe$Extra$isJust(addon)),
									_Utils_Tuple2('list__item--emphasis-text', emphasis === 1)
								]),
							classList)),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$dt,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list__item__title')
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Render$renderMaybe(
							A2(
								$elm$core$Maybe$map,
								$author$project$Pyxis$Components$List$renderAddon(listTag),
								addon)),
							A2(
							$author$project$Pyxis$Commons$Render$maybeMapRender,
							$author$project$Pyxis$Components$List$renderDlItemTitle(addon),
							title)
						])),
					A2(
					$elm$html$Html$dd,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('list__item__text', true),
									_Utils_Tuple2(
									'list__item__text--orientation-block',
									$elm_community$maybe_extra$Maybe$Extra$isJust(addon) && (!itemOrientation))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Pyxis$Commons$Render$maybeMapRender,
							$author$project$Pyxis$Components$List$renderDlItemText(action),
							text),
							A2($author$project$Pyxis$Commons$Render$maybeMapRender, $author$project$Pyxis$Components$List$renderAction, action)
						]))
				]));
	});
var $author$project$Pyxis$Components$Title$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Commons$TagBuilder$Tag = $elm$core$Basics$identity;
var $author$project$Pyxis$Commons$TagBuilder$h2 = 'h2';
var $author$project$Pyxis$Tokens$FontWeight$FontWeightBook = 1;
var $author$project$Pyxis$Tokens$FontWeight$tokenBook = 1;
var $author$project$Pyxis$Tokens$TitleSize$TitleSizeM = 4;
var $author$project$Pyxis$Tokens$TitleSize$tokenM = 4;
var $author$project$Pyxis$Components$Title$config = function (content) {
	return {f6: _List_Nil, ea: $elm$core$Maybe$Nothing, aX: content, ej: _List_Nil, gB: $author$project$Pyxis$Tokens$FontWeight$tokenBook, kg: $elm$core$Maybe$Nothing, hg: _List_Nil, iv: _List_Nil, aO: $author$project$Pyxis$Tokens$TitleSize$tokenM, iL: $author$project$Pyxis$Commons$TagBuilder$h2, fv: $elm$core$Maybe$Nothing};
};
var $author$project$Pyxis$Commons$TagBuilder$h3 = 'h3';
var $author$project$Pyxis$Commons$TagBuilder$h4 = 'h4';
var $author$project$Pyxis$Commons$TagBuilder$h5 = 'h5';
var $author$project$Pyxis$Commons$TagBuilder$h6 = 'h6';
var $author$project$Pyxis$Commons$TagBuilder$strong = 'strong';
var $author$project$Pyxis$Components$List$getTitleTag = function (titleTag) {
	switch (titleTag) {
		case 0:
			return $author$project$Pyxis$Commons$TagBuilder$strong;
		case 1:
			return $author$project$Pyxis$Commons$TagBuilder$h2;
		case 2:
			return $author$project$Pyxis$Commons$TagBuilder$h3;
		case 3:
			return $author$project$Pyxis$Commons$TagBuilder$h4;
		case 4:
			return $author$project$Pyxis$Commons$TagBuilder$h5;
		default:
			return $author$project$Pyxis$Commons$TagBuilder$h6;
	}
};
var $author$project$Pyxis$Tokens$FontWeight$toString = function (fontWeight) {
	if (!fontWeight) {
		return 'bold';
	} else {
		return 'book';
	}
};
var $author$project$Pyxis$Tokens$TitleSize$toString = function (titleSize) {
	switch (titleSize) {
		case 0:
			return '3xl';
		case 1:
			return '2xl';
		case 2:
			return 'xl';
		case 3:
			return 'l';
		case 4:
			return 'm';
		default:
			return 's';
	}
};
var $author$project$Pyxis$Components$Title$baseClass = F2(
	function (size, fontWeight) {
		return $elm$html$Html$Attributes$class(
			A2(
				$elm$core$String$join,
				'-',
				_List_fromArray(
					[
						'title',
						$author$project$Pyxis$Tokens$TitleSize$toString(size),
						$author$project$Pyxis$Tokens$FontWeight$toString(fontWeight)
					])));
	});
var $author$project$Pyxis$Tokens$Spacing$toString = function (spacing) {
	switch (spacing) {
		case 0:
			return '0';
		case 1:
			return '5xl';
		case 2:
			return '4xl';
		case 3:
			return '3xl';
		case 4:
			return '2xl';
		case 5:
			return 'xl';
		case 6:
			return 'l';
		case 7:
			return 'm';
		case 8:
			return 's';
		case 9:
			return 'xs';
		case 10:
			return '2xs';
		case 11:
			return '3xs';
		default:
			return '4xs';
	}
};
var $author$project$Pyxis$Commons$Attributes$Margin$toClass = function (margin) {
	switch (margin.$) {
		case 0:
			var s = margin.a;
			return 'margin-t-' + $author$project$Pyxis$Tokens$Spacing$toString(s);
		case 1:
			var s = margin.a;
			return 'margin-b-' + $author$project$Pyxis$Tokens$Spacing$toString(s);
		case 2:
			var s = margin.a;
			return 'margin-l-' + $author$project$Pyxis$Tokens$Spacing$toString(s);
		default:
			var s = margin.a;
			return 'margin-r-' + $author$project$Pyxis$Tokens$Spacing$toString(s);
	}
};
var $author$project$Pyxis$Components$Title$marginClassList = function (margins) {
	return $elm$html$Html$Attributes$classList(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Commons$Attributes$Margin$toClass,
				A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Tuple$pair, true)),
			margins));
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Pyxis$Commons$Responsive$pickBreakpoint = function (_v0) {
	var breakpoint = _v0.aV;
	return breakpoint;
};
var $author$project$Pyxis$Commons$Responsive$pickPropertyValue = function (_v0) {
	var propertyValue = _v0.be;
	return propertyValue;
};
var $author$project$Pyxis$Tokens$Breakpoint$toString = function (breakpoint) {
	switch (breakpoint) {
		case 0:
			return 'base';
		case 1:
			return '2xs';
		case 2:
			return 'xs';
		case 3:
			return 's';
		case 4:
			return 'm';
		case 5:
			return 'l';
		default:
			return 'xl';
	}
};
var $author$project$Pyxis$Components$Title$responsiveSizeClass = function (responsiveSize) {
	return A2(
		$elm$core$String$join,
		'-',
		_List_fromArray(
			[
				'title',
				$author$project$Pyxis$Tokens$TitleSize$toString(
				$author$project$Pyxis$Commons$Responsive$pickPropertyValue(responsiveSize)),
				'from',
				$author$project$Pyxis$Tokens$Breakpoint$toString(
				$author$project$Pyxis$Commons$Responsive$pickBreakpoint(responsiveSize))
			]));
};
var $author$project$Pyxis$Components$Title$responsiveSizeClassList = function (responsiveSizes) {
	return $elm$html$Html$Attributes$classList(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Title$responsiveSizeClass,
				A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Tuple$pair, true)),
			responsiveSizes));
};
var $author$project$Pyxis$Commons$Attributes$typographyColorClass = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Tokens$TypographyColor$toString,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Basics$append('c-'),
		$elm$html$Html$Attributes$class));
var $author$project$Pyxis$Commons$TagBuilder$unwrap = function (_v0) {
	var nodeName = _v0;
	return nodeName;
};
var $author$project$Pyxis$Components$Title$render = function (_v0) {
	var content = _v0.aX;
	var margins = _v0.hg;
	var id = _v0.kg;
	var classList = _v0.f6;
	var testId = _v0.fv;
	var dataAttrList = _v0.ej;
	var color = _v0.ea;
	var tag = _v0.iL;
	var fontWeight = _v0.gB;
	var size = _v0.aO;
	var responsiveSize = _v0.iv;
	return A3(
		$elm$html$Html$node,
		$author$project$Pyxis$Commons$TagBuilder$unwrap(tag),
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					A2($author$project$Pyxis$Components$Title$baseClass, size, fontWeight),
					$author$project$Pyxis$Components$Title$responsiveSizeClassList(responsiveSize),
					$author$project$Pyxis$Components$Title$marginClassList(margins),
					$elm$html$Html$Attributes$classList(classList),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$typographyColorClass, color)
				])),
		_List_fromArray(
			[content]));
};
var $author$project$Pyxis$Components$Title$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{f6: classList});
	});
var $author$project$Pyxis$Components$Title$withTag = F2(
	function (tag, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{iL: tag});
	});
var $author$project$Pyxis$Components$List$renderItemTitleWithTag = F2(
	function (titleTag, title) {
		return $author$project$Pyxis$Components$Title$render(
			A2(
				$author$project$Pyxis$Components$Title$withTag,
				$author$project$Pyxis$Components$List$getTitleTag(titleTag),
				A2(
					$author$project$Pyxis$Components$Title$withClassList,
					_List_fromArray(
						[
							_Utils_Tuple2('list__item__title', true)
						]),
					$author$project$Pyxis$Components$Title$config(
						$elm$html$Html$text(title)))));
	});
var $author$project$Pyxis$Components$List$renderLiItem = F4(
	function (listTag, titleTag, emphasis, _v0) {
		var text = _v0.pu;
		var title = _v0.iS;
		var addon = _v0.mf;
		var action = _v0.T;
		var classList = _v0.f6;
		var testId = _v0.fv;
		var dataAttrList = _v0.ej;
		return A2(
			$elm$html$Html$li,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_Utils_ap(
							_List_fromArray(
								[
									_Utils_Tuple2('list__item', true),
									_Utils_Tuple2(
									'list__item--with-addon',
									$elm_community$maybe_extra$Maybe$Extra$isJust(addon)),
									_Utils_Tuple2(
									'list__item--with-action',
									$elm_community$maybe_extra$Maybe$Extra$isJust(action)),
									_Utils_Tuple2('list__item--emphasis-text', emphasis === 1)
								]),
							classList)),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					])),
			_List_fromArray(
				[
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2(
						$elm$core$Maybe$map,
						$author$project$Pyxis$Components$List$renderAddon(listTag),
						addon)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list__item__wrapper')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Pyxis$Commons$Render$maybeMapRender,
							$author$project$Pyxis$Components$List$renderItemTitleWithTag(titleTag),
							title),
							$author$project$Pyxis$Commons$Render$renderMaybe(
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$singleton,
									$elm$html$Html$span(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('list__item__text')
											]))),
								text))
						])),
					A2($author$project$Pyxis$Commons$Render$maybeMapRender, $author$project$Pyxis$Components$List$renderAction, action)
				]));
	});
var $author$project$Pyxis$Components$List$renderListItem = F5(
	function (listTag, titleTag, emphasis, itemOrientation, itemConfig) {
		return (listTag === 2) ? A4($author$project$Pyxis$Components$List$renderDetailListItem, listTag, emphasis, itemOrientation, itemConfig) : A4($author$project$Pyxis$Components$List$renderLiItem, listTag, titleTag, emphasis, itemConfig);
	});
var $elm$html$Html$dl = _VirtualDom_node('dl');
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $author$project$Pyxis$Components$List$renderTag = function (tag) {
	switch (tag) {
		case 0:
			return $elm$html$Html$ul;
		case 1:
			return $elm$html$Html$ol;
		default:
			return $elm$html$Html$dl;
	}
};
var $author$project$Pyxis$Components$List$stylesForOrientation = F2(
	function (orientation, itemsLength) {
		switch (orientation.$) {
			case 0:
				return $elm$html$Html$Attributes$classList(_List_Nil);
			case 1:
				return $elm$html$Html$Attributes$classList(_List_Nil);
			case 2:
				var count = orientation.a;
				return A2(
					$elm$html$Html$Attributes$attribute,
					'style',
					A2(
						$elm$core$String$join,
						';',
						_List_fromArray(
							[
								'--list-item-counter: ' + $elm$core$String$fromInt(itemsLength),
								'--list-max-columns: ' + $elm$core$String$fromInt(count)
							])));
			default:
				var count = orientation.a;
				return A2(
					$elm$html$Html$Attributes$attribute,
					'style',
					A2(
						$elm$core$String$join,
						';',
						_List_fromArray(
							[
								'--list-item-counter: ' + $elm$core$String$fromInt(itemsLength),
								'--list-max-columns: ' + $elm$core$String$fromInt(count)
							])));
		}
	});
var $author$project$Pyxis$Components$List$render = function (_v0) {
	var listTag = _v0.kB;
	var dataAttrList = _v0.ej;
	var divider = _v0.gq;
	var orientation = _v0.h3;
	var itemOrientation = _v0.g5;
	var itemWidth = _v0.g6;
	var id = _v0.kg;
	var classList = _v0.f6;
	var testId = _v0.fv;
	var items = _v0.g7;
	var size = _v0.aO;
	var emphasis = _v0.er;
	var titleTag = _v0.iT;
	return A3(
		$author$project$Pyxis$Components$List$renderTag,
		listTag,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('list', true),
							_Utils_Tuple2(
							A3($author$project$Pyxis$Components$List$getItemWidthClass, itemWidth, orientation, itemOrientation),
							true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$List$getItemSizeClass(size),
							true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$List$getItemOrientationClass(itemOrientation),
							true),
							_Utils_Tuple2('list--with-divider', divider),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$List$orientationClass(orientation),
							true)
						])),
					A2(
					$author$project$Pyxis$Components$List$stylesForOrientation,
					orientation,
					$elm$core$List$length(items)),
					$elm$html$Html$Attributes$classList(classList),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
				])),
		A2(
			$elm$core$List$map,
			A4($author$project$Pyxis$Components$List$renderListItem, listTag, titleTag, emphasis, itemOrientation),
			items));
};
var $author$project$Pyxis$Components$List$Default = {$: 0};
var $author$project$Pyxis$Components$List$Item = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$List$item = {
	T: $elm$core$Maybe$Nothing,
	mf: $elm$core$Maybe$Just($author$project$Pyxis$Components$List$Default),
	f6: _List_Nil,
	ej: _List_Nil,
	fv: $elm$core$Maybe$Nothing,
	pu: $elm$core$Maybe$Nothing,
	iS: $elm$core$Maybe$Nothing
};
var $author$project$Pyxis$Components$List$Icon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pyxis$Components$List$withItemAddonIcon = F2(
	function (iconConfig, _v0) {
		var itemConf = _v0;
		return _Utils_update(
			itemConf,
			{
				mf: $elm$core$Maybe$Just(
					$author$project$Pyxis$Components$List$Icon(iconConfig))
			});
	});
var $author$project$Pyxis$Components$List$withItemTitle = F2(
	function (title, _v0) {
		var itemConfig = _v0;
		return _Utils_update(
			itemConfig,
			{
				iS: $elm$core$Maybe$Just(title)
			});
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$renderCover = function (cover) {
	return A2(
		$author$project$Pyxis$Components$List$withItemTitle,
		cover.jH,
		A2(
			$author$project$Pyxis$Components$List$withItemAddonIcon,
			$author$project$Pyxis$Components$Icon$config(cover.kf),
			$author$project$Pyxis$Components$List$item));
};
var $author$project$Common$ComponentUI$Modal$CoverPackages$SelectedPackage = F3(
	function (packageName, covers, tooltipText) {
		return {ee: covers, oN: packageName, py: tooltipText};
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$Cover = F2(
	function (coverName, icon) {
		return {jH: coverName, kf: icon};
	});
var $author$project$Translations$coversCoverageCivilLiability = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Mandatory and voluntary civil liability';
	} else {
		return 'Responsabilidad civil obligatoria y voluntaria';
	}
};
var $author$project$Translations$coversCoverageDriverProtection = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Third party damage';
	} else {
		return 'Protección al conductor';
	}
};
var $author$project$Translations$coversCoverageFreeWorkshopChoice = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Free choice of workshop';
	} else {
		return 'Libre elección de taller';
	}
};
var $author$project$Translations$coversCoverageLegalDefense = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Legal defense and damage claims';
	} else {
		return 'Defensa jurídica y reclamación de daños';
	}
};
var $author$project$Translations$coversCoverageRoadsideAssistanceV1 = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return '24h. roadside assistance with no km limit';
	} else {
		return 'Asistencia en viaje 24 h sin límite de km';
	}
};
var $author$project$Translations$coversCoverageRoadsideAssistanceV2 = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Basic roadside assistance';
	} else {
		return 'Asistencia en carretera básica';
	}
};
var $author$project$Pyxis$Components$IconSet$VehicleLegalProtection = 12;
var $author$project$Pyxis$Components$IconSet$vehicleLegalProtection = 12;
var $author$project$Pyxis$Components$IconSet$Wrench = 2;
var $author$project$Pyxis$Components$IconSet$wrench = 2;
var $author$project$Common$ComponentUI$Modal$CoverPackages$baseCoverPackage = F2(
	function (i18n, productVersion) {
		var roadAssistance = function () {
			if (!productVersion) {
				return $author$project$Translations$coversCoverageRoadsideAssistanceV1(i18n);
			} else {
				return $author$project$Translations$coversCoverageRoadsideAssistanceV2(i18n);
			}
		}();
		return _List_fromArray(
			[
				A2(
				$author$project$Common$ComponentUI$Modal$CoverPackages$Cover,
				$author$project$Translations$coversCoverageCivilLiability(i18n),
				$author$project$Pyxis$Components$IconSet$vehicleLegalProtection),
				A2($author$project$Common$ComponentUI$Modal$CoverPackages$Cover, roadAssistance, $author$project$Pyxis$Components$IconSet$vehicleRoadsideAssistance),
				A2(
				$author$project$Common$ComponentUI$Modal$CoverPackages$Cover,
				$author$project$Translations$coversCoverageFreeWorkshopChoice(i18n),
				$author$project$Pyxis$Components$IconSet$wrench),
				A2(
				$author$project$Common$ComponentUI$Modal$CoverPackages$Cover,
				$author$project$Translations$coversCoverageDriverProtection(i18n),
				$author$project$Pyxis$Components$IconSet$car),
				A2(
				$author$project$Common$ComponentUI$Modal$CoverPackages$Cover,
				$author$project$Translations$coversCoverageLegalDefense(i18n),
				$author$project$Pyxis$Components$IconSet$vehicleLegalProtection)
			]);
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$basePackage = F4(
	function (packageName, tooltipText, i18n, productVersion) {
		return A3(
			$author$project$Common$ComponentUI$Modal$CoverPackages$SelectedPackage,
			packageName,
			A2($author$project$Common$ComponentUI$Modal$CoverPackages$baseCoverPackage, i18n, productVersion),
			tooltipText);
	});
var $author$project$Translations$bundleSlugThirdPartyExtended = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Third party extended';
	} else {
		return 'Terceros ampliado';
	}
};
var $author$project$Translations$coversThirdPartyExtendedSubtitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Protect yourself against unforeseen events by adding glass, theft and fire coverage.';
	} else {
		return 'Protégete ante imprevistos añadiendo la cobertura de lunas, robo e incendio.';
	}
};
var $author$project$Translations$coversCoverageMisfortunes = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Glass, theft, fire';
	} else {
		return 'Lunas, robo, incendio';
	}
};
var $author$project$Pyxis$Components$IconSet$VehicleDriverInjuries = 16;
var $author$project$Pyxis$Components$IconSet$vehicleDriverInjuries = 16;
var $author$project$Common$ComponentUI$Modal$CoverPackages$tercerosAmpliadoCoverPackage = function (i18n) {
	return _List_fromArray(
		[
			A2(
			$author$project$Common$ComponentUI$Modal$CoverPackages$Cover,
			$author$project$Translations$coversCoverageMisfortunes(i18n),
			$author$project$Pyxis$Components$IconSet$vehicleDriverInjuries)
		]);
};
var $author$project$Common$ComponentUI$Modal$CoverPackages$withAdditionalCovers = F2(
	function (covers, selected) {
		return _Utils_update(
			selected,
			{
				ee: A2($elm$core$List$append, selected.ee, covers)
			});
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$tercerosAmpliadoPackage = F2(
	function (i18n, productVersion) {
		return A2(
			$author$project$Common$ComponentUI$Modal$CoverPackages$withAdditionalCovers,
			$author$project$Common$ComponentUI$Modal$CoverPackages$tercerosAmpliadoCoverPackage(i18n),
			A4(
				$author$project$Common$ComponentUI$Modal$CoverPackages$basePackage,
				$author$project$Translations$bundleSlugThirdPartyExtended(i18n),
				$author$project$Translations$coversThirdPartyExtendedSubtitle(i18n),
				i18n,
				productVersion));
	});
var $author$project$Translations$bundleSlugThirdPartyOnly = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Third party only';
	} else {
		return 'Terceros básico';
	}
};
var $author$project$Translations$coversThirdPartyBasicSubtitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Get a powerful third party insurance with top quality travel assistance.';
	} else {
		return 'Obtén un seguro a terceros potente, con asistencia en viaje de primera calidad.';
	}
};
var $author$project$Common$ComponentUI$Modal$CoverPackages$tercerosBasicoPackage = F2(
	function (i18n, productVersion) {
		return A4(
			$author$project$Common$ComponentUI$Modal$CoverPackages$basePackage,
			$author$project$Translations$bundleSlugThirdPartyOnly(i18n),
			$author$project$Translations$coversThirdPartyBasicSubtitle(i18n),
			i18n,
			productVersion);
	});
var $author$project$Translations$bundleSlugComprehensiveCover = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Comprehensive cover';
	} else {
		return 'Todo riesgo con franquicia';
	}
};
var $author$project$Translations$coversComprehensiveSubtitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Drive worry-free with our most complete insurance.';
	} else {
		return 'Conduce libre de preocupaciones con nuestro seguro más completo.';
	}
};
var $author$project$Translations$coversCoveragePersonalDamage = F2(
	function (excess, _v0) {
		var lang = _v0;
		if (!lang) {
			return 'Personal damage up to ' + excess;
		} else {
			return 'Daños propios con franquicia ' + excess;
		}
	});
var $author$project$Pyxis$Components$IconSet$HomeTheftValuable = 108;
var $author$project$Pyxis$Components$IconSet$homeTheftValuable = 108;
var $author$project$Common$Price$toStringSignLast = F2(
	function (i18n, _v0) {
		var amount = _v0.a;
		var currency = _v0.b;
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					A2($author$project$Common$Price$toAmountString, i18n, amount),
					$author$project$Common$Price$pickSign(currency)
				]));
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$tercerosTodoRiesgoCoverPackage = F2(
	function (i18n, chosenExcess) {
		return A2(
			$elm$core$List$append,
			$author$project$Common$ComponentUI$Modal$CoverPackages$tercerosAmpliadoCoverPackage(i18n),
			_List_fromArray(
				[
					A2(
					$author$project$Common$ComponentUI$Modal$CoverPackages$Cover,
					A2(
						$author$project$Translations$coversCoveragePersonalDamage,
						A2($author$project$Common$Price$toStringSignLast, i18n, chosenExcess),
						i18n),
					$author$project$Pyxis$Components$IconSet$homeTheftValuable)
				]));
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$tercerosTodoRiesgoConFranquicia = F3(
	function (i18n, productVersion, chosenExcess) {
		return A2(
			$author$project$Common$ComponentUI$Modal$CoverPackages$withAdditionalCovers,
			A2($author$project$Common$ComponentUI$Modal$CoverPackages$tercerosTodoRiesgoCoverPackage, i18n, chosenExcess),
			A4(
				$author$project$Common$ComponentUI$Modal$CoverPackages$basePackage,
				$author$project$Translations$bundleSlugComprehensiveCover(i18n),
				$author$project$Translations$coversComprehensiveSubtitle(i18n),
				i18n,
				productVersion));
	});
var $author$project$Pyxis$Components$List$withEmphasis = F2(
	function (emphasis, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{er: emphasis});
	});
var $author$project$Pyxis$Components$List$withItemOrientation = F2(
	function (orientation, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{g5: orientation});
	});
var $author$project$Pyxis$Components$List$withItems = F2(
	function (items, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{g7: items});
	});
var $author$project$Pyxis$Components$List$withOrientation = F2(
	function (orientation, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{h3: orientation});
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$content = F4(
	function (i18n, productSlug, productVersion, chosenExcess) {
		var _v0 = function () {
			switch (productSlug) {
				case 0:
					return A2($author$project$Common$ComponentUI$Modal$CoverPackages$tercerosBasicoPackage, i18n, productVersion);
				case 1:
					return A2($author$project$Common$ComponentUI$Modal$CoverPackages$tercerosAmpliadoPackage, i18n, productVersion);
				default:
					return A3($author$project$Common$ComponentUI$Modal$CoverPackages$tercerosTodoRiesgoConFranquicia, i18n, productVersion, chosenExcess);
			}
		}();
		var covers = _v0.ee;
		return $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withEmphasis,
				$author$project$Pyxis$Components$List$emphasisText,
				A2(
					$author$project$Pyxis$Components$List$withOrientation,
					$author$project$Pyxis$Components$List$block,
					A2(
						$author$project$Pyxis$Components$List$withItemOrientation,
						$author$project$Pyxis$Components$List$itemOrientationInline,
						A2(
							$author$project$Pyxis$Components$List$withItems,
							A2($elm$core$List$map, $author$project$Common$ComponentUI$Modal$CoverPackages$renderCover, covers),
							$author$project$Pyxis$Components$List$dl)))));
	});
var $author$project$Translations$coversIncludedCoversModalButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Got it';
	} else {
		return 'Entendido';
	}
};
var $author$project$Common$ComponentUI$Modal$CoverPackages$footer = F2(
	function (i18n, ctaMsg) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						ctaMsg,
						A2(
							$author$project$Pyxis$Components$Button$withText,
							$author$project$Translations$coversIncludedCoversModalButton(i18n),
							$author$project$Pyxis$Components$Button$primary)))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Common$Product$bundleSlugToString = F2(
	function (i18n, bundleSlug) {
		switch (bundleSlug) {
			case 0:
				return $author$project$Translations$bundleSlugThirdPartyOnly(i18n);
			case 1:
				return $author$project$Translations$bundleSlugThirdPartyExtended(i18n);
			default:
				return $author$project$Translations$bundleSlugComprehensiveCover(i18n);
		}
	});
var $author$project$Translations$coversIncludedCoversModalTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Included covers';
	} else {
		return 'Coberturas incluidas';
	}
};
var $author$project$Pyxis$Components$Modal$Header$withBadge = F2(
	function (badge, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				bu: $elm$core$Maybe$Just(badge)
			});
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$header = F2(
	function (i18n, bundleSlug) {
		return A2(
			$author$project$Pyxis$Components$Modal$Header$withTitle,
			$author$project$Translations$coversIncludedCoversModalTitle(i18n),
			A2(
				$author$project$Pyxis$Components$Modal$Header$withBadge,
				A2(
					$author$project$Pyxis$Components$Badge$withText,
					A2($author$project$Common$Product$bundleSlugToString, i18n, bundleSlug),
					$author$project$Pyxis$Components$Badge$brand),
				$author$project$Pyxis$Components$Modal$Header$config));
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$render = F4(
	function (i18n, bundleSlug, chosenExcess, _v0) {
		var modelData = _v0;
		return A2(
			$author$project$Common$Render$maybe,
			function (productVersion) {
				return A2(
					$author$project$Pyxis$Components$Modal$render,
					modelData.bX,
					A2(
						$author$project$Pyxis$Components$Modal$withFooter,
						A2($author$project$Common$ComponentUI$Modal$CoverPackages$footer, i18n, modelData.hK),
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							modelData.hK,
							'',
							A2(
								$author$project$Pyxis$Components$Modal$withContent,
								_List_fromArray(
									[
										A4($author$project$Common$ComponentUI$Modal$CoverPackages$content, i18n, bundleSlug, productVersion, chosenExcess)
									]),
								A2(
									$author$project$Pyxis$Components$Modal$withHeader,
									A2($author$project$Common$ComponentUI$Modal$CoverPackages$header, i18n, bundleSlug),
									A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
			},
			modelData.ij);
	});
var $author$project$Tracker$customActionAttributeName = 'dd-action-name';
var $author$project$Translations$greatLakesOptInConsentModalAcceptButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Yes, continue';
	} else {
		return 'Sí, continuemos';
	}
};
var $author$project$Translations$greatLakesOptInConsentModalDismissButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'No, I don\'t accept';
	} else {
		return 'No, no acepto';
	}
};
var $author$project$Pyxis$Components$Button$Secondary = 1;
var $author$project$Pyxis$Components$Button$secondary = $author$project$Pyxis$Components$Button$config(1);
var $author$project$Pyxis$Components$Button$L = 1;
var $author$project$Pyxis$Components$Button$sizeL = function (_v0) {
	var configuration = _v0;
	return _Utils_update(
		configuration,
		{aO: 1});
};
var $author$project$Pyxis$Components$Button$withDataAttrList = F2(
	function (attributes, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ej: attributes});
	});
var $author$project$Pyxis$Components$Button$withDisabled = F2(
	function (isDisabled, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{go: isDisabled});
	});
var $author$project$Pyxis$Components$Button$withLoading = F2(
	function (isLoading, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{bR: isLoading});
	});
var $author$project$Common$ComponentUI$Modal$GreatLakesOptInConsent$footer = F5(
	function (i18n, offerId, approveMsg, closeMsg, isLoading) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withDataAttrList,
						_List_fromArray(
							[
								_Utils_Tuple2($author$project$Tracker$customActionAttributeName, 'refuse-great-lakes-opt-in')
							]),
						A2(
							$author$project$Pyxis$Components$Button$withDisabled,
							isLoading,
							A2(
								$author$project$Pyxis$Components$Button$withOnClick,
								closeMsg,
								A2(
									$author$project$Pyxis$Components$Button$withSize,
									$author$project$Pyxis$Components$Button$sizeL,
									A2(
										$author$project$Pyxis$Components$Button$withText,
										$author$project$Translations$greatLakesOptInConsentModalDismissButton(i18n),
										$author$project$Pyxis$Components$Button$secondary)))))),
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withDataAttrList,
						_List_fromArray(
							[
								_Utils_Tuple2($author$project$Tracker$customActionAttributeName, 'accept-great-lakes-opt-in')
							]),
						A2(
							$author$project$Pyxis$Components$Button$withLoading,
							isLoading,
							A2(
								$author$project$Pyxis$Components$Button$withOnClick,
								approveMsg(offerId),
								A2(
									$author$project$Pyxis$Components$Button$withSize,
									$author$project$Pyxis$Components$Button$sizeL,
									A2(
										$author$project$Pyxis$Components$Button$withText,
										$author$project$Translations$greatLakesOptInConsentModalAcceptButton(i18n),
										$author$project$Pyxis$Components$Button$primary))))))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Translations$greatLakesOptInConsentModalBody = F2(
	function (extraAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					$elm$html$Html$text('In order to continue to offer you the same service as always, your new policy will be backed by '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, extraAttrs.mo),
					_List_fromArray(
						[
							$elm$html$Html$text('Great Lakes (Great Lakes Insurance SE, part of the Munich RE Group)')
						])),
					$elm$html$Html$text(' instead of iptiQ.'),
					A3(
					$elm$html$Html$node,
					'br',
					_Utils_ap(_List_Nil, extraAttrs.mr),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					A3(
					$elm$html$Html$node,
					'br',
					_Utils_ap(_List_Nil, extraAttrs.mr),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					$elm$html$Html$text('We will continue to accompany you and manage everything as before.'),
					A3(
					$elm$html$Html$node,
					'br',
					_Utils_ap(_List_Nil, extraAttrs.mr),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					A3(
					$elm$html$Html$node,
					'br',
					_Utils_ap(_List_Nil, extraAttrs.mr),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					$elm$html$Html$text('Two months before expiry, we\'ll send you an email with all the details if you want to take a look at it. Is it OK if we continue and I\'ll tell you the price and the next steps?')
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('Para seguir ofreciéndote el servicio de siempre, tu nueva póliza estará respaldada por '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, extraAttrs.mo),
					_List_fromArray(
						[
							$elm$html$Html$text('Great Lakes (Great Lakes Insurance SE, parte del grupo Munich RE)')
						])),
					$elm$html$Html$text(', en lugar de iptiQ.'),
					A3(
					$elm$html$Html$node,
					'br',
					_Utils_ap(_List_Nil, extraAttrs.mr),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					A3(
					$elm$html$Html$node,
					'br',
					_Utils_ap(_List_Nil, extraAttrs.mr),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					$elm$html$Html$text('Nosotros seguimos acompañándote y gestionando todo como hasta ahora.'),
					A3(
					$elm$html$Html$node,
					'br',
					_Utils_ap(_List_Nil, extraAttrs.mr),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					A3(
					$elm$html$Html$node,
					'br',
					_Utils_ap(_List_Nil, extraAttrs.mr),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					$elm$html$Html$text('Dos meses antes del vencimiento, te enviamos un email con todos los detalles, por si quieres echarle un vistazo. ¿Te parece bien que sigamos y te cuento el precio y los siguientes pasos?')
				]);
		}
	});
var $author$project$Translations$greatLakesOptInConsentModalHeader = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Same protection, with a new insurance partner';
	} else {
		return 'La misma protección, con un nuevo socio asegurador';
	}
};
var $author$project$Translations$greatLakesOptInConsentModalHeaderTag = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy update';
	} else {
		return 'Actualización de la póliza';
	}
};
var $author$project$Common$ComponentUI$Modal$GreatLakesOptInConsent$header = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withTitle,
		$author$project$Translations$greatLakesOptInConsentModalHeader(i18n),
		A2(
			$author$project$Pyxis$Components$Modal$Header$withBadge,
			A2(
				$author$project$Pyxis$Components$Badge$withText,
				$author$project$Translations$greatLakesOptInConsentModalHeaderTag(i18n),
				$author$project$Pyxis$Components$Badge$brand),
			$author$project$Pyxis$Components$Modal$Header$config));
};
var $author$project$Pyxis$Components$Modal$sizeM = 1;
var $author$project$Common$ComponentUI$Modal$GreatLakesOptInConsent$render = F6(
	function (i18n, offerId, approveMsg, closeMsg, isLoading, modelMessage) {
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			modelMessage,
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A5($author$project$Common$ComponentUI$Modal$GreatLakesOptInConsent$footer, i18n, offerId, approveMsg, closeMsg, isLoading),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					A2(
						$author$project$Translations$greatLakesOptInConsentModalBody,
						{mo: _List_Nil, mr: _List_Nil},
						i18n),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						$author$project$Common$ComponentUI$Modal$GreatLakesOptInConsent$header(i18n),
						A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeM, $author$project$Pyxis$Components$Modal$config)))));
	});
var $author$project$Common$Offer$pickStartDate = function (_v0) {
	var offer = _v0;
	return $author$project$Common$Locale$posixToCustomerDate(offer.lL);
};
var $author$project$Translations$recordingDisclaimerModalContent = F3(
	function (data, extraAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('\"I confirm that you will take out an insurance policy ('),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.lO),
							_List_fromArray(
								[
									$elm$html$Html$text(data.ji)
								])),
							$elm$html$Html$text('), which covers: '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.lO),
							_List_fromArray(
								[
									$elm$html$Html$text('compulsory and voluntary civil liability, basic travel assistance, free choice of garage, driver protection, legal defence and damage claims / windows, theft, fire / own damage with an excess of €200. ' + data.mj)
								]))
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('Drivers under 26 years of age and with less than 2 years of driving licence are not covered, unless explicitly declared.')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('Payment will be made today but the insurance will take effect on '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.lO),
							_List_fromArray(
								[
									$elm$html$Html$text(data.lL)
								])),
							$elm$html$Html$text('. The total price for your insurance is '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.lO),
							_List_fromArray(
								[
									$elm$html$Html$text(data.lW)
								])),
							$elm$html$Html$text(', including insurance premium tax and statutory surcharges.')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('You have 14 days to exercise your right of withdrawal, in which case the unearned premium will be refunded. You can find information on how to proceed on our website or contact our customer service.\"')
						])),
					A3(
					$elm$html$Html$node,
					'h2',
					_Utils_ap(_List_Nil, extraAttrs.kb),
					_List_fromArray(
						[
							$elm$html$Html$text('Call recording protocol')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('Pause the recording in Aircall before the customer\'s bank details and remember to resume it afterwards.')
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('\"Te confirmo que contratarás un seguro a ('),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.lO),
							_List_fromArray(
								[
									$elm$html$Html$text(data.ji)
								])),
							$elm$html$Html$text('), que cubre: '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.lO),
							_List_fromArray(
								[
									$elm$html$Html$text('responsabilidad civil obligatoria y voluntaria, asistencia en carretera básica, libre elección de taller, protección al conductor, defensa jurídica y reclamación de daños / lunas, robo, incendio / daños propios con franquicia 200€. ' + data.mj)
								]))
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('Los conductores menores de 26 años o con menos de 2 años de antigüedad de carnet no están cubiertos, salvo que estén declarados de manera explícita.')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('El pago se realizará hoy pero el seguro entrará en vigor el '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.lO),
							_List_fromArray(
								[
									$elm$html$Html$text(data.lL)
								])),
							$elm$html$Html$text('. El precio de su seguro es de '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.lO),
							_List_fromArray(
								[
									$elm$html$Html$text(data.lW)
								])),
							$elm$html$Html$text(', e incluye el Impuesto sobre las Primas de Seguros y los recargos legales.')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('Tienes 14 días para ejercer el derecho de desistimiento, y en ese caso se te devolverá la prima no consumida. Puedes encontrar la información sobre cómo proceder en nuestra página web o contactar con nuestro servicio de atención al cliente\"')
						])),
					A3(
					$elm$html$Html$node,
					'h2',
					_Utils_ap(_List_Nil, extraAttrs.kb),
					_List_fromArray(
						[
							$elm$html$Html$text('Protocolo de grabación de llamadas')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('Pausa la grabación en Aircall antes de los datos bancarios del cliente y recuerda reanudarla luego.')
						]))
				]);
		}
	});
var $author$project$Translations$recordingDisclaimerModalAncillarySentenceJoinWord = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'And';
	} else {
		return 'Y';
	}
};
var $author$project$Translations$recordingDisclaimerModalAncillarySentencePrefixSingluar = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'In addition, you have contracted the extra coverage of';
	} else {
		return 'Además has contratado la cobertura extra de';
	}
};
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$selectedAncillariesText = F2(
	function (i18n, selectedAncillaries) {
		if (!selectedAncillaries.b) {
			return '';
		} else {
			if (!selectedAncillaries.b.b) {
				var ancillary = selectedAncillaries.a;
				return $author$project$Translations$recordingDisclaimerModalAncillarySentencePrefixSingluar(i18n) + (' ' + ($elm$core$String$toLower(
					ancillary.ke(i18n)) + '.'));
			} else {
				var ancillaries = selectedAncillaries;
				return $author$project$Translations$recordingDisclaimerModalAncillarySentencePrefixSingluar(i18n) + (' ' + ($elm$core$String$toLower(
					A2(
						$elm$core$String$join,
						' ' + ($author$project$Translations$recordingDisclaimerModalAncillarySentenceJoinWord(i18n) + ' '),
						A2(
							$elm$core$List$map,
							function (ancillary) {
								return ancillary.ke(i18n);
							},
							ancillaries))) + '.'));
			}
		}
	});
var $author$project$Common$Price$toStringNoSpaceSignLast = F2(
	function (i18n, _v0) {
		var amount = _v0.a;
		var currency = _v0.b;
		return _Utils_ap(
			A2($author$project$Common$Price$toAmountString, i18n, amount),
			$author$project$Common$Price$pickSign(currency));
	});
var $cmditch$elm_bigint$BigInt$MagnitudePair = $elm$core$Basics$identity;
var $cmditch$elm_bigint$BigInt$sameSizeRaw = F2(
	function (xs, ys) {
		var _v0 = _Utils_Tuple2(xs, ys);
		if (!_v0.a.b) {
			if (!_v0.b.b) {
				return _List_Nil;
			} else {
				var _v2 = _v0.b;
				var y = _v2.a;
				var ys_ = _v2.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(0, y),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, _List_Nil, ys_));
			}
		} else {
			if (!_v0.b.b) {
				var _v1 = _v0.a;
				var x = _v1.a;
				var xs_ = _v1.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(x, 0),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs_, _List_Nil));
			} else {
				var _v3 = _v0.a;
				var x = _v3.a;
				var xs_ = _v3.b;
				var _v4 = _v0.b;
				var y = _v4.a;
				var ys_ = _v4.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(x, y),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs_, ys_));
			}
		}
	});
var $cmditch$elm_bigint$BigInt$sameSizeNotNormalized = F2(
	function (_v0, _v1) {
		var xs = _v0;
		var ys = _v1;
		return A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs, ys);
	});
var $cmditch$elm_bigint$BigInt$toPositiveSign = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return A2($cmditch$elm_bigint$BigInt$mkBigIntNotNormalised, 2, _List_Nil);
		case 1:
			var digits = bigInt.a;
			return A2(
				$cmditch$elm_bigint$BigInt$mkBigIntNotNormalised,
				0,
				$cmditch$elm_bigint$BigInt$reverseMagnitude(digits));
		default:
			var digits = bigInt.a;
			return A2($cmditch$elm_bigint$BigInt$mkBigIntNotNormalised, 0, digits);
	}
};
var $cmditch$elm_bigint$BigInt$add = F2(
	function (a, b) {
		var _v0 = $cmditch$elm_bigint$BigInt$toPositiveSign(b);
		var mb = _v0.b;
		var _v1 = $cmditch$elm_bigint$BigInt$toPositiveSign(a);
		var ma = _v1.b;
		var _v2 = A2($cmditch$elm_bigint$BigInt$sameSizeNotNormalized, ma, mb);
		var pairs = _v2;
		var added = A2(
			$elm$core$List$map,
			function (_v3) {
				var a_ = _v3.a;
				var b_ = _v3.b;
				return a_ + b_;
			},
			pairs);
		return $cmditch$elm_bigint$BigInt$normalise(
			A2($cmditch$elm_bigint$BigInt$BigIntNotNormalised, 0, added));
	});
var $cmditch$elm_bigint$BigInt$magnitude = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return _List_Nil;
		case 0:
			var mag = bigInt.a;
			return mag;
		default:
			var mag = bigInt.a;
			return mag;
	}
};
var $cmditch$elm_bigint$BigInt$mulSingleDigit = F2(
	function (_v0, d) {
		var xs = _v0;
		return $cmditch$elm_bigint$BigInt$normaliseMagnitude(
			A2(
				$elm$core$List$map,
				$elm$core$Basics$mul(d),
				xs));
	});
var $cmditch$elm_bigint$BigInt$mulMagnitudes = F2(
	function (_v0, _v1) {
		var mag1 = _v0;
		var mag2 = _v1;
		if (!mag1.b) {
			return _List_Nil;
		} else {
			if (!mag1.b.b) {
				var m = mag1.a;
				return A2($cmditch$elm_bigint$BigInt$mulSingleDigit, mag2, m);
			} else {
				var m = mag1.a;
				var mx = mag1.b;
				var accum = A2($cmditch$elm_bigint$BigInt$mulSingleDigit, mag2, m);
				var _v3 = A2($cmditch$elm_bigint$BigInt$mulMagnitudes, mx, mag2);
				var rest = _v3;
				var bigInt = A2(
					$cmditch$elm_bigint$BigInt$add,
					A2($cmditch$elm_bigint$BigInt$mkBigInt, 0, accum),
					A2(
						$cmditch$elm_bigint$BigInt$mkBigInt,
						0,
						A2($elm$core$List$cons, 0, rest)));
				return $cmditch$elm_bigint$BigInt$magnitude(bigInt);
			}
		}
	});
var $cmditch$elm_bigint$BigInt$sign = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return 2;
		case 0:
			return 0;
		default:
			return 1;
	}
};
var $cmditch$elm_bigint$BigInt$signProduct = F2(
	function (x, y) {
		return ((x === 2) || (y === 2)) ? 2 : (_Utils_eq(x, y) ? 0 : 1);
	});
var $cmditch$elm_bigint$BigInt$mul = F2(
	function (int1, int2) {
		return A2(
			$cmditch$elm_bigint$BigInt$mkBigInt,
			A2(
				$cmditch$elm_bigint$BigInt$signProduct,
				$cmditch$elm_bigint$BigInt$sign(int1),
				$cmditch$elm_bigint$BigInt$sign(int2)),
			A2(
				$cmditch$elm_bigint$BigInt$mulMagnitudes,
				$cmditch$elm_bigint$BigInt$magnitude(int1),
				$cmditch$elm_bigint$BigInt$magnitude(int2)));
	});
var $prikhi$decimal$Decimal$addDecimals = F2(
	function (i, _v0) {
		addDecimals:
		while (true) {
			var m = _v0.a;
			var e = _v0.b;
			var mul10 = function (x) {
				return A2(
					$cmditch$elm_bigint$BigInt$mul,
					x,
					$cmditch$elm_bigint$BigInt$fromInt(10));
			};
			if (!i) {
				return A2($prikhi$decimal$Decimal$Decimal, m, e);
			} else {
				if (i > 0) {
					var $temp$i = i - 1,
						$temp$_v0 = A2(
						$prikhi$decimal$Decimal$Decimal,
						mul10(m),
						e - 1);
					i = $temp$i;
					_v0 = $temp$_v0;
					continue addDecimals;
				} else {
					return A2($prikhi$decimal$Decimal$Decimal, m, e);
				}
			}
		}
	});
var $prikhi$decimal$Decimal$toExponent = F2(
	function (e, _v0) {
		var md = _v0.a;
		var ed = _v0.b;
		return A2(
			$prikhi$decimal$Decimal$addDecimals,
			ed - e,
			A2($prikhi$decimal$Decimal$Decimal, md, ed));
	});
var $prikhi$decimal$Decimal$toCommonExponent = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	var _v1 = b;
	var mb = _v1.a;
	var eb = _v1.b;
	var _v2 = a;
	var ma = _v2.a;
	var ea = _v2.b;
	var exponent = A2($elm$core$Basics$min, ea, eb);
	return _Utils_Tuple2(
		A2($prikhi$decimal$Decimal$toExponent, exponent, a),
		A2($prikhi$decimal$Decimal$toExponent, exponent, b));
};
var $prikhi$decimal$Decimal$add = F2(
	function (a, b) {
		var _v0 = $prikhi$decimal$Decimal$toCommonExponent(
			_Utils_Tuple2(a, b));
		var ra = _v0.a;
		var rb = _v0.b;
		var _v1 = rb;
		var mb = _v1.a;
		var eb = _v1.b;
		var _v2 = ra;
		var ma = _v2.a;
		var ea = _v2.b;
		return A2(
			$prikhi$decimal$Decimal$Decimal,
			A2($cmditch$elm_bigint$BigInt$add, ma, mb),
			ea);
	});
var $author$project$Common$Price$pickAmount = function (_v0) {
	var amount = _v0.a;
	return amount;
};
var $author$project$Common$Price$sum = F2(
	function (firstAddend, secondAddend) {
		return $author$project$Common$Price$euro(
			A2(
				$prikhi$decimal$Decimal$add,
				$author$project$Common$Price$pickAmount(firstAddend),
				$author$project$Common$Price$pickAmount(secondAddend)));
	});
var $prikhi$decimal$Decimal$zero = $prikhi$decimal$Decimal$fromInt(0);
var $author$project$Common$Price$zero = function (currency) {
	return A2($author$project$Common$Price$new, $prikhi$decimal$Decimal$zero, currency);
};
var $author$project$Common$Price$sumAll = function (prices) {
	return A3(
		$elm$core$List$foldl,
		$author$project$Common$Price$sum,
		$author$project$Common$Price$zero(0),
		prices);
};
var $author$project$Common$Offer$totalPrice = function (_v0) {
	var offer = _v0;
	return $author$project$Common$Price$sumAll(
		A2(
			$elm$core$List$map,
			function (product) {
				return product.jd.j8;
			},
			offer.dr));
};
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$defaultContent = F3(
	function (i18n, offer, coverSelection) {
		return A3(
			$author$project$Translations$recordingDisclaimerModalContent,
			{
				mj: A2($author$project$Common$ComponentUI$Modal$RecordingDisclaimer$selectedAncillariesText, i18n, coverSelection),
				ji: A2(
					$author$project$Common$Product$bundleSlugToString,
					i18n,
					$author$project$Common$Offer$pickSelectedBundle(offer)),
				lL: $author$project$Common$Locale$formatDate(
					$author$project$Common$Offer$pickStartDate(offer)),
				lW: A2(
					$author$project$Common$Price$toStringNoSpaceSignLast,
					i18n,
					$author$project$Common$Offer$totalPrice(offer))
			},
			{
				kb: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('recording-disclaimer-modal__subtitle')
					]),
				k9: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('recording-disclaimer-modal__paragraph')
					]),
				lO: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('recording-disclaimer-modal__strong')
					])
			},
			i18n);
	});
var $author$project$Translations$recordingDisclaimerModalPreAncillaryContent = F3(
	function (data, extraAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('\"I confirm that you will take out an insurance policy ('),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.lO),
							_List_fromArray(
								[
									$elm$html$Html$text(data.ji)
								])),
							$elm$html$Html$text('), which covers: '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.lO),
							_List_fromArray(
								[
									$elm$html$Html$text('compulsory and voluntary civil liability, 24-hour travel assistance with no km limit, free choice of garage, driver protection, legal defence and damage claims / windows, theft, fire / own damage with an excess of €200.')
								]))
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('Drivers under 26 years of age and with less than 2 years of driving licence are not covered, unless explicitly declared.')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('Payment will be made today but the insurance will take effect on '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.lO),
							_List_fromArray(
								[
									$elm$html$Html$text(data.lL)
								])),
							$elm$html$Html$text('. The total price for your insurance is '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.lO),
							_List_fromArray(
								[
									$elm$html$Html$text(data.lW)
								])),
							$elm$html$Html$text(', including insurance premium tax and statutory surcharges.')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('You have 14 days to exercise your right of withdrawal, in which case the unearned premium will be refunded. You can find information on how to proceed on our website or contact our customer service.\"')
						])),
					A3(
					$elm$html$Html$node,
					'h2',
					_Utils_ap(_List_Nil, extraAttrs.kb),
					_List_fromArray(
						[
							$elm$html$Html$text('Call recording protocol')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('Pause the recording in Aircall before the customer\'s bank details and remember to resume it afterwards.')
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('\"Te confirmo que contratarás un seguro a ('),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.lO),
							_List_fromArray(
								[
									$elm$html$Html$text(data.ji)
								])),
							$elm$html$Html$text('), que cubre: '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.lO),
							_List_fromArray(
								[
									$elm$html$Html$text('responsabilidad civil obligatoria y voluntaria, asistencia en viaje 24 h sin límite de km, libre elección de taller, protección al conductor, defensa jurídica y reclamación de daños / lunas, robo, incendio / daños propios con franquicia 200€.')
								]))
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('Los conductores menores de 26 años o con menos de 2 años de antigüedad de carnet no están cubiertos, salvo que estén declarados de manera explícita.')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('El pago se realizará hoy pero el seguro entrará en vigor el '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.lO),
							_List_fromArray(
								[
									$elm$html$Html$text(data.lL)
								])),
							$elm$html$Html$text('. El precio de su seguro es de '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.lO),
							_List_fromArray(
								[
									$elm$html$Html$text(data.lW)
								])),
							$elm$html$Html$text(', e incluye el Impuesto sobre las Primas de Seguros y los recargos legales.')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('Tienes 14 días para ejercer el derecho de desistimiento, y en ese caso se te devolverá la prima no consumida. Puedes encontrar la información sobre cómo proceder en nuestra página web o contactar con nuestro servicio de atención al cliente\"')
						])),
					A3(
					$elm$html$Html$node,
					'h2',
					_Utils_ap(_List_Nil, extraAttrs.kb),
					_List_fromArray(
						[
							$elm$html$Html$text('Protocolo de grabación de llamadas')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.k9),
					_List_fromArray(
						[
							$elm$html$Html$text('Pausa la grabación en Aircall antes de los datos bancarios del cliente y recuerda reanudarla luego.')
						]))
				]);
		}
	});
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$preAncillaryContent = F2(
	function (i18n, offer) {
		return A3(
			$author$project$Translations$recordingDisclaimerModalPreAncillaryContent,
			{
				ji: A2(
					$author$project$Common$Product$bundleSlugToString,
					i18n,
					$author$project$Common$Offer$pickSelectedBundle(offer)),
				lL: $author$project$Common$Locale$formatDate(
					$author$project$Common$Offer$pickStartDate(offer)),
				lW: A2(
					$author$project$Common$Price$toStringNoSpaceSignLast,
					i18n,
					$author$project$Common$Offer$totalPrice(offer))
			},
			{
				kb: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('recording-disclaimer-modal__subtitle')
					]),
				k9: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('recording-disclaimer-modal__paragraph')
					]),
				lO: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('recording-disclaimer-modal__strong')
					])
			},
			i18n);
	});
var $author$project$Translations$recordingDisclaimerModalRenewalContent = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Pause the recording in Aircall before the customer\'s bank details and remember to resume it afterwards.';
	} else {
		return 'Pausa la grabación en Aircall antes de los datos bancarios del cliente y recuerda reanudarla luego.';
	}
};
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$renewalContent = A2(
	$elm$core$Basics$composeR,
	$author$project$Translations$recordingDisclaimerModalRenewalContent,
	A2($elm$core$Basics$composeR, $elm$html$Html$text, $elm$core$List$singleton));
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$content = F3(
	function (i18n, offer, coverSelection) {
		if ($author$project$Common$Offer$pickIsRenewal(offer)) {
			return $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$renewalContent(i18n);
		} else {
			var _v0 = coverSelection.mi;
			if (!_v0.$) {
				return A2($author$project$Common$ComponentUI$Modal$RecordingDisclaimer$preAncillaryContent, i18n, offer);
			} else {
				var selectedAncillaries = _v0.a;
				return A3($author$project$Common$ComponentUI$Modal$RecordingDisclaimer$defaultContent, i18n, offer, selectedAncillaries);
			}
		}
	});
var $author$project$Translations$recordingDisclaimerModalButtonText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Purchase Offer';
	} else {
		return 'Comprar Oferta';
	}
};
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$footer = F2(
	function (i18n, msg) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withTestId,
						'purchase-button',
						A2(
							$author$project$Pyxis$Components$Button$withId,
							'purchase-button',
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$recordingDisclaimerModalButtonText(i18n),
								A2($author$project$Pyxis$Components$Button$withOnClick, msg, $author$project$Pyxis$Components$Button$primary)))))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Pyxis$Components$IconSet$HomeLegalProtection = 112;
var $author$project$Pyxis$Components$IconSet$homeLegalProtection = 112;
var $author$project$Translations$recordingDisclaimerModalTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Legal Text';
	} else {
		return 'Texto Legal';
	}
};
var $author$project$Pyxis$Tokens$TypographyColor$Brand = 2;
var $author$project$Pyxis$Tokens$TypographyColor$tokenBrand = 2;
var $author$project$Pyxis$Components$Icon$withColor = F2(
	function (color, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				ea: $elm$core$Maybe$Just(color)
			});
	});
var $author$project$Pyxis$Components$Modal$Header$withIcon = F2(
	function (icon, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				kf: $elm$core$Maybe$Just(icon)
			});
	});
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$defaultHeader = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withIcon,
		A2(
			$author$project$Pyxis$Components$Icon$withColor,
			$author$project$Pyxis$Tokens$TypographyColor$tokenBrand,
			$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$homeLegalProtection)),
		A2(
			$author$project$Pyxis$Components$Modal$Header$withTitle,
			$author$project$Translations$recordingDisclaimerModalTitle(i18n),
			$author$project$Pyxis$Components$Modal$Header$config));
};
var $author$project$Pyxis$Components$IconSet$Phone = 61;
var $author$project$Pyxis$Components$IconSet$phone = 61;
var $author$project$Translations$recordingDisclaimerModalRenewalTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Call recording protocol';
	} else {
		return 'Protocolo de grabación de llamadas';
	}
};
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$renewalHeader = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withIcon,
		A2(
			$author$project$Pyxis$Components$Icon$withColor,
			$author$project$Pyxis$Tokens$TypographyColor$tokenBrand,
			$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$phone)),
		A2(
			$author$project$Pyxis$Components$Modal$Header$withTitle,
			$author$project$Translations$recordingDisclaimerModalRenewalTitle(i18n),
			$author$project$Pyxis$Components$Modal$Header$config));
};
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$header = F2(
	function (i18n, offer) {
		return $author$project$Common$Offer$pickIsRenewal(offer) ? $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$renewalHeader(i18n) : $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$defaultHeader(i18n);
	});
var $author$project$Pyxis$Components$Modal$L = 2;
var $author$project$Pyxis$Components$Modal$sizeL = 2;
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$size = function (offer) {
	return $author$project$Common$Offer$pickIsRenewal(offer) ? $author$project$Pyxis$Components$Modal$sizeS : $author$project$Pyxis$Components$Modal$sizeL;
};
var $author$project$Pyxis$Components$Modal$withTestId = F2(
	function (id, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				fv: $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$render = F6(
	function (offer, coverSelection, i18n, closeMsg, ctaMsg, modalMessage) {
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			modalMessage,
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A2(
					$author$project$Common$ComponentUI$Modal$RecordingDisclaimer$footer,
					i18n,
					ctaMsg(offer)),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					A3($author$project$Common$ComponentUI$Modal$RecordingDisclaimer$content, i18n, offer, coverSelection),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						A2($author$project$Common$ComponentUI$Modal$RecordingDisclaimer$header, i18n, offer),
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							closeMsg,
							'',
							A2(
								$author$project$Pyxis$Components$Modal$withSize,
								$author$project$Common$ComponentUI$Modal$RecordingDisclaimer$size(offer),
								A2($author$project$Pyxis$Components$Modal$withTestId, 'stop-recording-disclaimer-modal', $author$project$Pyxis$Components$Modal$config)))))));
	});
var $author$project$Pyxis$Components$Loaders$Loader$getModifierClassForVariant = function (variant) {
	if (variant.$ === 1) {
		if (!variant.a) {
			var _v1 = variant.a;
			return 'loader--with-car';
		} else {
			var _v2 = variant.a;
			return 'loader--s';
		}
	} else {
		if (variant.a === 1) {
			var _v3 = variant.a;
			return 'loader--s';
		} else {
			var _v4 = variant.a;
			return '';
		}
	}
};
var $author$project$Pyxis$Components$Loaders$Loader$getVariantClass = function (variant) {
	if (variant.$ === 1) {
		return 'loader__car';
	} else {
		return 'loader__spinner';
	}
};
var $author$project$Pyxis$Components$Loaders$Loader$isCar = function (variant) {
	if (variant.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $author$project$Pyxis$Components$Loaders$LoaderCar$renderSvg = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
			$elm$svg$Svg$Attributes$class('loader__car__items-wrapper'),
			$elm$svg$Svg$Attributes$viewBox('0 0 33 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$clipPath('url(#clip0_104_19465)'),
					$elm$svg$Svg$Attributes$class('loader__car__body')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M22.1998 10.5H17.3997C16.8497 10.5 16.3998 10.05 16.3998 9.5C16.3998 8.95 16.8497 8.5 17.3997 8.5H22.1998C22.7498 8.5 23.1998 8.95 23.1998 9.5C23.1998 10.05 22.7498 10.5 22.1998 10.5ZM30.7798 10L26.6798 8.9L25.5798 7C25.0398 6.07 24.0498 5.5 22.9798 5.5H14.8398C14.0398 5.5 13.2798 5.82 12.7198 6.38L10.2198 8.88C9.45975 9.64 9.16975 10.74 9.43975 11.78L10.1098 14.28C10.2814 14.9176 10.6587 15.4808 11.183 15.8821C11.7073 16.2835 12.3494 16.5007 13.0098 16.5H13.8698V14.5H13.0098C12.5598 14.5 12.1598 14.2 12.0398 13.76L11.3698 11.26C11.2798 10.92 11.3698 10.55 11.6298 10.29L14.1298 7.79C14.2229 7.69687 14.3336 7.62325 14.4555 7.57345C14.5774 7.52366 14.7081 7.49869 14.8398 7.5H22.9798C23.3398 7.5 23.6698 7.69 23.8498 8L24.9498 9.9C25.2198 10.36 25.6498 10.69 26.1598 10.83L30.2598 11.93C30.6998 12.05 30.9998 12.44 30.9998 12.9V13.5C30.9998 14.05 30.5498 14.5 29.9998 14.5H29.1098V16.5H29.9998C31.6598 16.5 32.9998 15.16 32.9998 13.5V12.9C33.0005 12.2397 32.7833 11.5976 32.3819 11.0733C31.9805 10.5489 31.4174 10.1717 30.7798 10ZM16.0998 14.5H26.8798V16.5H16.0998V14.5Z')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('loader__car__wheel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M15 15C15.55 15 16 15.45 16 16C16 16.55 15.55 17 15 17C14.45 17 14 16.55 14 16C14 15.45 14.45 15 15 15ZM15 13C13.34 13 12 14.34 12 16C12 17.66 13.34 19 15 19C16.66 19 18 17.66 18 16C18 14.34 16.66 13 15 13Z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M28 15C28.55 15 29 15.45 29 16C29 16.55 28.55 17 28 17C27.45 17 27 16.55 27 16C27 15.45 27.45 15 28 15ZM28 13C26.34 13 25 14.34 25 16C25 17.66 26.34 19 28 19C29.66 19 31 17.66 31 16C31 14.34 29.66 13 28 13Z')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$clipPath('url(#clip1_104_19465)'),
					$elm$svg$Svg$Attributes$class('loader__car__line loader__car__line--top')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M1 11H2'),
							$elm$svg$Svg$Attributes$strokeWidth('2'),
							$elm$svg$Svg$Attributes$strokeLinecap('round')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$clipPath('url(#clip2_104_19465)'),
					$elm$svg$Svg$Attributes$class('loader__car__line loader__car__line--bottom')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M1 15H6'),
							$elm$svg$Svg$Attributes$strokeWidth('2'),
							$elm$svg$Svg$Attributes$strokeLinecap('round')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('clip0_104_19465')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$rect,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$width('24'),
									$elm$svg$Svg$Attributes$height('24'),
									$elm$svg$Svg$Attributes$fill('white'),
									$elm$svg$Svg$Attributes$transform('translate(9)')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('clip1_104_19465')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$rect,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$width('3'),
									$elm$svg$Svg$Attributes$height('2'),
									$elm$svg$Svg$Attributes$fill('white'),
									$elm$svg$Svg$Attributes$transform('translate(0 10)')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('clip2_104_19465')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$rect,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$width('7'),
									$elm$svg$Svg$Attributes$height('2'),
									$elm$svg$Svg$Attributes$fill('white'),
									$elm$svg$Svg$Attributes$transform('translate(0 14)')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$Pyxis$Components$Loaders$Loader$renderTitle = function (title) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('loader__title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(title)
			]));
};
var $author$project$Pyxis$Components$Loaders$Loader$renderTextBlock = F3(
	function (isHiddenText, title, label) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('loader__text-wrapper', true),
							_Utils_Tuple2('sr-only', isHiddenText)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Pyxis$Commons$Render$maybeMapRender, $author$project$Pyxis$Components$Loaders$Loader$renderTitle, title),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('loader__text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				]));
	});
var $author$project$Pyxis$Components$Loaders$Loader$render = function (_v0) {
	var configuration = _v0;
	return A2(
		$elm$html$Html$div,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			configuration.ej,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2('loader', true),
								_Utils_Tuple2(
								$author$project$Pyxis$Components$Loaders$Loader$getModifierClassForVariant(configuration.i_),
								true)
							]),
						configuration.f6)),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, configuration.kg),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, configuration.fv),
					$author$project$Pyxis$Commons$Attributes$ariaLivePolite
				])),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						$author$project$Pyxis$Components$Loaders$Loader$getVariantClass(configuration.i_))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Pyxis$Commons$Render$renderIf,
						$author$project$Pyxis$Components$Loaders$Loader$isCar(configuration.i_),
						$author$project$Pyxis$Components$Loaders$LoaderCar$renderSvg)
					])),
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Pyxis$Components$Loaders$Loader$renderTextBlock, configuration.eK, configuration.iS),
					configuration.pu))
			]));
};
var $author$project$Pyxis$Components$Loaders$Loader$M = 0;
var $author$project$Pyxis$Components$Loaders$Loader$Spinner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Loaders$Loader$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Loaders$Loader$config = function (variant) {
	return {f6: _List_Nil, ej: _List_Nil, kg: $elm$core$Maybe$Nothing, eK: false, fv: $elm$core$Maybe$Nothing, pu: $elm$core$Maybe$Nothing, iS: $elm$core$Maybe$Nothing, i_: variant};
};
var $author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM = $author$project$Pyxis$Components$Loaders$Loader$config(
	$author$project$Pyxis$Components$Loaders$Loader$Spinner(0));
var $author$project$Page$OfferDetails$Msg$AmendOfferCoverageEffectiveDate = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Page$OfferDetails$Msg$PurchaseOfferButtonPressed = function (a) {
	return {$: 11, a: a};
};
var $author$project$Common$Render$empty = $elm_community$html_extra$Html$Extra$nothing;
var $author$project$Common$Render$ifCondition = F2(
	function (content, condition) {
		return condition ? content : $author$project$Common$Render$empty;
	});
var $author$project$Common$Offer$isOfferGreatLakesRenewal = function (_v0) {
	var offer = _v0;
	return offer.g0;
};
var $author$project$Common$CoverContinuity$CurrentInsuranceInfo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Portfolio$Config = $elm$core$Basics$identity;
var $author$project$Common$Portfolio$config = function (vehicleOwner) {
	return function (mainDriver) {
		return function (additionalDriver) {
			return function (policyHolder) {
				return function (vehicle) {
					return function (claimsHistory) {
						return function (coversData) {
							return function (selectedBundleSlug) {
								return function (customerId) {
									return function (coverSelection) {
										return function (editAncillaryCoversUrl) {
											return {jb: additionalDriver, jr: claimsHistory, jI: coverSelection, jK: coversData, gi: customerId, jR: editAncillaryCoversUrl, eU: mainDriver, hI: $elm$core$Maybe$Nothing, ib: policyHolder, lD: selectedBundleSlug, i$: vehicle, l$: vehicleOwner};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Common$Offer$pickEditAncillaryCoversAction = function (action) {
	if (action.$ === 5) {
		var maybeUrl = action.a;
		return maybeUrl;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Common$Offer$mayEditAncillaryCovers = $author$project$Common$Offer$filterActionValue($author$project$Common$Offer$pickEditAncillaryCoversAction);
var $author$project$Page$OfferDetails$Model$pickCustomerId = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.gi;
	},
	A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$toMaybe, $elm_community$maybe_extra$Maybe$Extra$join));
var $author$project$Common$Offer$pickData = function (_v0) {
	var offer = _v0;
	return offer;
};
var $author$project$Page$OfferDetails$View$portfolioConfig = F2(
	function (model, offer) {
		var _v0 = $author$project$Common$Offer$pickData(offer);
		var vehicleOwner = _v0.l$;
		var mainDriver = _v0.eU;
		var additionalDriver = _v0.jb;
		var policyHolder = _v0.ib;
		var vehicle = _v0.i$;
		var coverContinuity = _v0.jG;
		var selectedBundle = _v0.iw;
		return $author$project$Common$Portfolio$config(vehicleOwner)(mainDriver)(additionalDriver)(policyHolder)(vehicle)(model.cF)(
			$author$project$Common$CoverContinuity$CurrentInsuranceInfo(coverContinuity))(selectedBundle)(
			$author$project$Page$OfferDetails$Model$pickCustomerId(model))(model.jI)(
			$author$project$Common$Offer$mayEditAncillaryCovers(offer));
	});
var $author$project$Common$Portfolio$OuterTabsChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Tabs$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Tabs$Left = 0;
var $author$project$Pyxis$Components$Tabs$Slide = 0;
var $author$project$Pyxis$Components$Tabs$Underline = 0;
var $author$project$Pyxis$Components$Tabs$underline = 0;
var $author$project$Pyxis$Components$Tabs$config = function (id) {
	return {dW: $elm$core$Maybe$Nothing, f6: _List_Nil, gh: $elm$core$Maybe$Nothing, ej: _List_Nil, gN: false, kg: id, h4: 0, Y: 0, dJ: _List_Nil, fv: $elm$core$Maybe$Nothing, i_: $author$project$Pyxis$Components$Tabs$underline};
};
var $author$project$Pyxis$Components$IconSet$Chart = 190;
var $author$project$Pyxis$Components$IconSet$chart = 190;
var $author$project$Translations$detailsPortfolioCoverLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Cover';
	} else {
		return 'Coberturas';
	}
};
var $author$project$Translations$detailsPortfolioDataLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Data';
	} else {
		return 'Datos';
	}
};
var $author$project$Pyxis$Components$Grid$Col = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Grid$Col$buildConfiguration = F2(
	function (options, config) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, c) {
					var mapper = _v0;
					return mapper(c);
				}),
			config,
			options);
	});
var $author$project$Pyxis$Components$Grid$SpanSize$Span1 = 0;
var $author$project$Pyxis$Components$Grid$SpanSize$span1 = 0;
var $author$project$Pyxis$Tokens$Breakpoint$Base = 0;
var $author$project$Pyxis$Tokens$Breakpoint$tokenBase = 0;
var $author$project$Pyxis$Components$Grid$initialColConfiguration = {aV: $author$project$Pyxis$Tokens$Breakpoint$tokenBase, cC: $author$project$Pyxis$Components$Grid$SpanSize$span1, ae: _List_Nil, f6: _List_Nil, dw: $author$project$Pyxis$Components$Grid$SpanSize$span1};
var $author$project$Pyxis$Components$Grid$col = F2(
	function (options, children) {
		var configuration = A2($author$project$Pyxis$Components$Grid$Col$buildConfiguration, options, $author$project$Pyxis$Components$Grid$initialColConfiguration);
		return {aV: configuration.aV, cC: configuration.cC, ae: children, f6: configuration.f6, dw: configuration.dw};
	});
var $author$project$Common$CoverContinuity$getCoverContinuityInfo = function (coverContinuity) {
	if (!coverContinuity.$) {
		var info = coverContinuity.a;
		return info;
	} else {
		var info = coverContinuity.a;
		return info;
	}
};
var $author$project$Common$CoverContinuity$hasPreviousCoverage = function (coverContinuityInfo) {
	var _v0 = $author$project$Common$CoverContinuity$getCoverContinuityInfo(coverContinuityInfo);
	if (!_v0.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Translations$detailsCurrentInsurerLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Current insurer';
	} else {
		return 'Aseguradora Actual';
	}
};
var $author$project$Translations$detailsPreviousInsurer = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Previous insurer';
	} else {
		return 'Aseguradora anterior';
	}
};
var $author$project$Pyxis$Components$Text$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Commons$TagBuilder$p = 'p';
var $author$project$Pyxis$Tokens$TextSize$TextSizeM = 1;
var $author$project$Pyxis$Tokens$TextSize$tokenM = 1;
var $author$project$Pyxis$Components$Text$config = function (content) {
	return {f6: _List_Nil, ea: $elm$core$Maybe$Nothing, aX: content, ej: _List_Nil, gB: $author$project$Pyxis$Tokens$FontWeight$tokenBook, kg: $elm$core$Maybe$Nothing, hg: _List_Nil, iv: _List_Nil, aO: $author$project$Pyxis$Tokens$TextSize$tokenM, iL: $author$project$Pyxis$Commons$TagBuilder$p, fv: $elm$core$Maybe$Nothing};
};
var $author$project$Translations$coversSummaryPendingCoversInfo = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Previous policy information is not available until it’s entered by the customer or agent.';
	} else {
		return 'La información sobre pólizas anteriores no está disponible hasta que el cliente o el agente la introduzca.';
	}
};
var $author$project$Translations$coversSummaryWithNoCoversInfo = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The information about previous policies is not available for this client, as we didn’t request this data at the time of their registration.';
	} else {
		return 'La información sobre pólizas anteriores no está disponible para este cliente, ya que no hemos solicitado estos datos al momento de su registro.';
	}
};
var $author$project$Translations$coversTercerosBasicoSummaryInfo = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'This package does not provide other covers.';
	} else {
		return 'Este paquete no proporciona otras coberturas.';
	}
};
var $author$project$Translations$coversCurrentCover = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Current cover';
	} else {
		return 'Cobertura actual';
	}
};
var $author$project$Pyxis$Components$List$withItemAddonNone = function (_v0) {
	var itemConfig = _v0;
	return _Utils_update(
		itemConfig,
		{mf: $elm$core$Maybe$Nothing});
};
var $author$project$Pyxis$Components$List$withItemText = F2(
	function (text, _v0) {
		var itemConfig = _v0;
		return _Utils_update(
			itemConfig,
			{
				pu: $elm$core$Maybe$Just(text)
			});
	});
var $author$project$Common$CoverContinuity$createInsurerInfoListItem = F2(
	function (title, text) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemTitle,
				title,
				A2(
					$author$project$Pyxis$Components$List$withItemText,
					$elm$html$Html$text(text),
					$author$project$Pyxis$Components$List$item)));
	});
var $author$project$Common$CoverContinuity$currentCoverListItem = F3(
	function (i18n, bundleSlug, company) {
		if (!company.$) {
			return $elm$core$Maybe$Just(
				A2(
					$author$project$Common$CoverContinuity$createInsurerInfoListItem,
					$author$project$Translations$coversCurrentCover(i18n),
					A2($author$project$Common$Product$bundleSlugToString, i18n, bundleSlug)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Translations$coversDanosProprios = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Daños propios';
	} else {
		return 'Daños propios';
	}
};
var $author$project$Pyxis$Components$IconSet$CrossCircle = 164;
var $author$project$Pyxis$Components$IconSet$crossCircle = 164;
var $author$project$Common$CoverContinuity$coverContinuityIcon = function (thereIsCoverContinuity) {
	return thereIsCoverContinuity ? A2(
		$author$project$Pyxis$Components$Icon$withColor,
		$author$project$Pyxis$Tokens$TypographyColor$tokenBrand,
		$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$checkCircle)) : A2(
		$author$project$Pyxis$Components$Icon$withColor,
		$author$project$Pyxis$Tokens$TypographyColor$tokenBrand,
		$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$crossCircle));
};
var $author$project$Common$CoverContinuity$declaredCoverListItem = F2(
	function (title, hasCover) {
		return A2(
			$author$project$Pyxis$Components$List$withItemAddonIcon,
			A2(
				$author$project$Pyxis$Components$Icon$withSize,
				$author$project$Pyxis$Components$Icon$sizeM,
				$author$project$Common$CoverContinuity$coverContinuityIcon(hasCover)),
			A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item));
	});
var $author$project$Common$CoverContinuity$danosPropriosCoverListItem = F2(
	function (i18n, danosProprios) {
		return A2(
			$author$project$Common$CoverContinuity$declaredCoverListItem,
			$author$project$Translations$coversDanosProprios(i18n),
			danosProprios);
	});
var $author$project$Pyxis$Components$Message$Neutral = 0;
var $author$project$Pyxis$Components$Message$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Message$defaultIcon = function (variant) {
	switch (variant) {
		case 1:
			return $author$project$Pyxis$Components$IconSet$thumbUp;
		case 3:
			return $author$project$Pyxis$Components$IconSet$checkCircle;
		case 2:
			return $author$project$Pyxis$Components$IconSet$exclamationTriangle;
		case 4:
			return $author$project$Pyxis$Components$IconSet$exclamationCircle;
		case 5:
			return $author$project$Pyxis$Components$IconSet$infoCircle;
		case 0:
			return $author$project$Pyxis$Components$IconSet$infoCircle;
		default:
			return $author$project$Pyxis$Components$IconSet$infoCircle;
	}
};
var $author$project$Pyxis$Components$Message$config = F2(
	function (variant, style) {
		return {
			cD: $elm$core$Maybe$Nothing,
			f6: _List_Nil,
			aX: _List_Nil,
			ej: _List_Nil,
			kf: $author$project$Pyxis$Components$Message$defaultIcon(variant),
			kg: $elm$core$Maybe$Nothing,
			hP: $elm$core$Maybe$Nothing,
			dA: style,
			fv: $elm$core$Maybe$Nothing,
			iS: $elm$core$Maybe$Nothing,
			i_: variant
		};
	});
var $author$project$Pyxis$Components$Message$neutral = function (style) {
	return A2($author$project$Pyxis$Components$Message$config, 0, style);
};
var $author$project$Pyxis$Components$Message$Bottom = 1;
var $author$project$Pyxis$Components$Message$getMessageStyleClass = function (style) {
	switch (style) {
		case 0:
			return 'message--background-surface-strong';
		case 1:
			return 'message--background-surface-on-surface-strong';
		default:
			return 'message--background-tint';
	}
};
var $author$project$Pyxis$Components$Message$getMessageVariantClass = function (variant) {
	switch (variant) {
		case 1:
			return 'message--brand';
		case 3:
			return 'message--success';
		case 2:
			return 'message--alert';
		case 4:
			return 'message--error';
		case 5:
			return 'message--ghost';
		case 6:
			return 'message--informative';
		default:
			return '';
	}
};
var $author$project$Pyxis$Components$Message$getRole = function (variant) {
	if (variant === 4) {
		return 'alert';
	} else {
		return 'status';
	}
};
var $author$project$Pyxis$Components$Message$renderButton = function (buttonConfig) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('message__button')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Button$render(buttonConfig)
			]));
};
var $author$project$Pyxis$Components$Message$renderClose = function (_v0) {
	var onDismiss = _v0.hP;
	var ariaLabel = _v0.fV;
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('message__close'),
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Events$onClick(onDismiss),
				$author$project$Pyxis$Commons$Attributes$ariaLabel(ariaLabel)
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Icon$render(
				$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$cross))
			]));
};
var $author$project$Pyxis$Components$Message$renderTitle = function (title) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('message__title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(title)
			]));
};
var $author$project$Pyxis$Components$Message$render = function (_v0) {
	var button = _v0.cD;
	var classList = _v0.f6;
	var icon = _v0.kf;
	var dataAttrList = _v0.ej;
	var id = _v0.kg;
	var testId = _v0.fv;
	var content = _v0.aX;
	var title = _v0.iS;
	var onDismiss = _v0.hP;
	var style = _v0.dA;
	var variant = _v0.i_;
	return A2(
		$elm$html$Html$div,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('message', true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Message$getMessageStyleClass(style),
							true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Message$getMessageVariantClass(variant),
							true),
							_Utils_Tuple2(
							'message--dismissable',
							$elm_community$maybe_extra$Maybe$Extra$isJust(onDismiss)),
							_Utils_Tuple2(
							'message--with-button',
							$elm_community$maybe_extra$Maybe$Extra$isJust(button)),
							_Utils_Tuple2(
							'message--with-button-bottom',
							_Utils_eq(
								A2($elm$core$Maybe$map, $elm$core$Tuple$second, button),
								$elm$core$Maybe$Just(1)))
						])),
					$elm$html$Html$Attributes$classList(classList),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
					$author$project$Pyxis$Commons$Attributes$role(
					$author$project$Pyxis$Components$Message$getRole(variant))
				])),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__icon')
					]),
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Icon$render(
						$author$project$Pyxis$Components$Icon$config(icon))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__content-wrapper')
							]),
						_List_fromArray(
							[
								$author$project$Pyxis$Commons$Render$renderMaybe(
								A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Message$renderTitle, title)),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__text')
									]),
								content)
							])),
						A2(
						$author$project$Pyxis$Commons$Render$maybeMapRender,
						$author$project$Pyxis$Components$Message$renderButton,
						A2($elm$core$Maybe$map, $elm$core$Tuple$first, button))
					])),
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Message$renderClose, onDismiss))
			]));
};
var $author$project$Pyxis$Components$Message$SurfaceStrong = 0;
var $author$project$Pyxis$Components$Message$surfaceStrongBackground = 0;
var $author$project$Pyxis$Components$Message$withContent = F2(
	function (htmlText, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aX: htmlText});
	});
var $author$project$Common$CoverContinuity$declaredCoverMessage = function (text) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('covers__declared-cover')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Message$render(
				A2(
					$author$project$Pyxis$Components$Message$withContent,
					_List_fromArray(
						[
							$elm$html$Html$text(text)
						]),
					$author$project$Pyxis$Components$Message$neutral($author$project$Pyxis$Components$Message$surfaceStrongBackground)))
			]));
};
var $author$project$Common$CoverContinuity$getCompanyName = function (company) {
	if (!company.$) {
		return 'Prima';
	} else {
		var companyName = company.a;
		return companyName;
	}
};
var $author$project$Common$CoverContinuity$insurerNameListItem = F2(
	function (title, insurerName) {
		return A2($author$project$Common$CoverContinuity$createInsurerInfoListItem, title, insurerName);
	});
var $author$project$Translations$coversLunas = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Lunas';
	} else {
		return 'Lunas';
	}
};
var $author$project$Common$CoverContinuity$lunasCoverListItem = F2(
	function (i18n, lunas) {
		return A2(
			$author$project$Common$CoverContinuity$declaredCoverListItem,
			$author$project$Translations$coversLunas(i18n),
			lunas);
	});
var $author$project$Pyxis$Tokens$TextSize$toString = function (textSize) {
	switch (textSize) {
		case 0:
			return 'l';
		case 1:
			return 'm';
		default:
			return 's';
	}
};
var $author$project$Pyxis$Components$Text$baseClass = F2(
	function (size, fontWeight) {
		return $elm$html$Html$Attributes$class(
			A2(
				$elm$core$String$join,
				'-',
				_List_fromArray(
					[
						'text',
						$author$project$Pyxis$Tokens$TextSize$toString(size),
						$author$project$Pyxis$Tokens$FontWeight$toString(fontWeight)
					])));
	});
var $author$project$Pyxis$Components$Text$marginClassList = function (margins) {
	return $elm$html$Html$Attributes$classList(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Commons$Attributes$Margin$toClass,
				A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Tuple$pair, true)),
			margins));
};
var $author$project$Pyxis$Components$Text$responsiveSizeClass = function (responsiveSize) {
	return A2(
		$elm$core$String$join,
		'-',
		_List_fromArray(
			[
				'text',
				$author$project$Pyxis$Tokens$TextSize$toString(
				$author$project$Pyxis$Commons$Responsive$pickPropertyValue(responsiveSize)),
				'from',
				$author$project$Pyxis$Tokens$Breakpoint$toString(
				$author$project$Pyxis$Commons$Responsive$pickBreakpoint(responsiveSize))
			]));
};
var $author$project$Pyxis$Components$Text$responsiveSizeClassList = function (responsiveSizes) {
	return $elm$html$Html$Attributes$classList(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Text$responsiveSizeClass,
				A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Tuple$pair, true)),
			responsiveSizes));
};
var $author$project$Pyxis$Components$Text$render = function (_v0) {
	var content = _v0.aX;
	var margins = _v0.hg;
	var id = _v0.kg;
	var classList = _v0.f6;
	var testId = _v0.fv;
	var dataAttrList = _v0.ej;
	var color = _v0.ea;
	var tag = _v0.iL;
	var fontWeight = _v0.gB;
	var size = _v0.aO;
	var responsiveSize = _v0.iv;
	return A3(
		$elm$html$Html$node,
		$author$project$Pyxis$Commons$TagBuilder$unwrap(tag),
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					A2($author$project$Pyxis$Components$Text$baseClass, size, fontWeight),
					$author$project$Pyxis$Components$Text$responsiveSizeClassList(responsiveSize),
					$author$project$Pyxis$Components$Text$marginClassList(margins),
					$elm$html$Html$Attributes$classList(classList),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$typographyColorClass, color)
				])),
		_List_fromArray(
			[content]));
};
var $author$project$Translations$coversDeclaredCoverTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Declared covers';
	} else {
		return 'Coberturas declaradas';
	}
};
var $author$project$Pyxis$Tokens$TypographyColor$ContentWeak = 17;
var $author$project$Pyxis$Tokens$TypographyColor$tokenContentWeak = 17;
var $author$project$Pyxis$Tokens$TextSize$TextSizeL = 0;
var $author$project$Pyxis$Tokens$TextSize$tokenL = 0;
var $author$project$Pyxis$Components$Text$withColor = F2(
	function (color, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				ea: $elm$core$Maybe$Just(color)
			});
	});
var $author$project$Pyxis$Components$Text$withSize = F2(
	function (size, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aO: size});
	});
var $author$project$Common$CoverContinuity$renderDeclaredCoversTitle = function (i18n) {
	return $author$project$Pyxis$Components$Text$render(
		A2(
			$author$project$Pyxis$Components$Text$withColor,
			$author$project$Pyxis$Tokens$TypographyColor$tokenContentWeak,
			A2(
				$author$project$Pyxis$Components$Text$withSize,
				$author$project$Pyxis$Tokens$TextSize$tokenL,
				$author$project$Pyxis$Components$Text$config(
					$elm$html$Html$text(
						$author$project$Translations$coversDeclaredCoverTitle(i18n))))));
};
var $author$project$Common$CoverContinuity$renderDeclaredCoversBox = F2(
	function (i18n, html) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('covers__declared-covers')
				]),
			_List_fromArray(
				[
					$author$project$Common$CoverContinuity$renderDeclaredCoversTitle(i18n),
					html
				]));
	});
var $elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
	if (m.$ === 1) {
		return _List_Nil;
	} else {
		var x = m.a;
		return _List_fromArray(
			[x]);
	}
};
var $author$project$Common$CoverContinuity$renderInsurerInfoList = F2(
	function (insurerNameItem, currentCoverItem) {
		return $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withEmphasis,
				$author$project$Pyxis$Components$List$emphasisText,
				A2(
					$author$project$Pyxis$Components$List$withItems,
					A2(
						$elm$core$List$cons,
						insurerNameItem,
						$elm_community$maybe_extra$Maybe$Extra$toList(currentCoverItem)),
					$author$project$Pyxis$Components$List$dl)));
	});
var $author$project$Common$CoverContinuity$renderCoverContinuityBox = F3(
	function (i18n, _v0, declaredCovers) {
		var insurerName = _v0.a;
		var currentCover = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cover__previous-coverage-container')
				]),
			_List_fromArray(
				[
					A2($author$project$Common$CoverContinuity$renderInsurerInfoList, insurerName, currentCover),
					A2($author$project$Common$CoverContinuity$renderDeclaredCoversBox, i18n, declaredCovers)
				]));
	});
var $author$project$Pyxis$Components$List$Inline = {$: 0};
var $author$project$Pyxis$Components$List$inline = $author$project$Pyxis$Components$List$Inline;
var $author$project$Pyxis$Components$List$ul = $author$project$Pyxis$Components$List$config(0);
var $author$project$Common$CoverContinuity$renderDeclaredCoversList = function (items) {
	return $author$project$Pyxis$Components$List$render(
		A2(
			$author$project$Pyxis$Components$List$withOrientation,
			$author$project$Pyxis$Components$List$inline,
			A2($author$project$Pyxis$Components$List$withItems, items, $author$project$Pyxis$Components$List$ul)));
};
var $author$project$Pyxis$Tokens$FontWeight$FontWeightBold = 0;
var $author$project$Pyxis$Tokens$FontWeight$tokenBold = 0;
var $author$project$Pyxis$Components$Text$withFontWeight = F2(
	function (fontWeight, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{gB: fontWeight});
	});
var $author$project$Common$CoverContinuity$renderCoverContinuityInfo = F4(
	function (i18n, referenceTypeText, bundleSlug, coverContinuityInfo) {
		switch (coverContinuityInfo.$) {
			case 2:
				var companyName = coverContinuityInfo.a;
				return A3(
					$author$project$Common$CoverContinuity$renderCoverContinuityBox,
					i18n,
					_Utils_Tuple2(
						A2($author$project$Common$CoverContinuity$insurerNameListItem, referenceTypeText, companyName),
						$elm$core$Maybe$Nothing),
					$author$project$Common$CoverContinuity$declaredCoverMessage(
						$author$project$Translations$coversSummaryWithNoCoversInfo(i18n)));
			case 3:
				var companyName = coverContinuityInfo.a;
				return A3(
					$author$project$Common$CoverContinuity$renderCoverContinuityBox,
					i18n,
					_Utils_Tuple2(
						A2($author$project$Common$CoverContinuity$insurerNameListItem, referenceTypeText, companyName),
						$elm$core$Maybe$Nothing),
					$author$project$Common$CoverContinuity$declaredCoverMessage(
						$author$project$Translations$coversSummaryPendingCoversInfo(i18n)));
			case 0:
				return $elm_community$html_extra$Html$Extra$nothing;
			case 1:
				var company = coverContinuityInfo.a;
				return A3(
					$author$project$Common$CoverContinuity$renderCoverContinuityBox,
					i18n,
					_Utils_Tuple2(
						A2(
							$author$project$Common$CoverContinuity$insurerNameListItem,
							referenceTypeText,
							$author$project$Common$CoverContinuity$getCompanyName(company)),
						A3($author$project$Common$CoverContinuity$currentCoverListItem, i18n, bundleSlug, company)),
					$author$project$Common$CoverContinuity$declaredCoverMessage(
						$author$project$Translations$coversTercerosBasicoSummaryInfo(i18n)));
			case 4:
				var info = coverContinuityInfo.a;
				return A3(
					$author$project$Common$CoverContinuity$renderCoverContinuityBox,
					i18n,
					_Utils_Tuple2(
						A2(
							$author$project$Common$CoverContinuity$insurerNameListItem,
							referenceTypeText,
							$author$project$Common$CoverContinuity$getCompanyName(info.I)),
						A3($author$project$Common$CoverContinuity$currentCoverListItem, i18n, bundleSlug, info.I)),
					$author$project$Common$CoverContinuity$renderDeclaredCoversList(
						_List_fromArray(
							[
								A2($author$project$Common$CoverContinuity$lunasCoverListItem, i18n, info.aH)
							])));
			case 5:
				var info = coverContinuityInfo.a;
				return A3(
					$author$project$Common$CoverContinuity$renderCoverContinuityBox,
					i18n,
					_Utils_Tuple2(
						A2(
							$author$project$Common$CoverContinuity$insurerNameListItem,
							referenceTypeText,
							$author$project$Common$CoverContinuity$getCompanyName(info.I)),
						A3($author$project$Common$CoverContinuity$currentCoverListItem, i18n, bundleSlug, info.I)),
					$author$project$Common$CoverContinuity$renderDeclaredCoversList(
						_List_fromArray(
							[
								A2($author$project$Common$CoverContinuity$lunasCoverListItem, i18n, info.aH),
								A2($author$project$Common$CoverContinuity$danosPropriosCoverListItem, i18n, info.ez)
							])));
			default:
				var info = coverContinuityInfo.a;
				var declaredCoversInfoBundle = $author$project$Pyxis$Components$Text$render(
					A2(
						$author$project$Pyxis$Components$Text$withSize,
						$author$project$Pyxis$Tokens$TextSize$tokenL,
						A2(
							$author$project$Pyxis$Components$Text$withFontWeight,
							$author$project$Pyxis$Tokens$FontWeight$tokenBold,
							$author$project$Pyxis$Components$Text$config(
								$elm$html$Html$text(info.f0)))));
				return A3(
					$author$project$Common$CoverContinuity$renderCoverContinuityBox,
					i18n,
					_Utils_Tuple2(
						A2(
							$author$project$Common$CoverContinuity$insurerNameListItem,
							referenceTypeText,
							$author$project$Common$CoverContinuity$getCompanyName(info.I)),
						A3($author$project$Common$CoverContinuity$currentCoverListItem, i18n, bundleSlug, info.I)),
					declaredCoversInfoBundle);
		}
	});
var $author$project$Common$CoverContinuity$render = F3(
	function (i18n, bundleSlug, coverContinuity) {
		var _v0 = function () {
			if (!coverContinuity.$) {
				var info = coverContinuity.a;
				return _Utils_Tuple2(
					$author$project$Translations$detailsCurrentInsurerLabel(i18n),
					info);
			} else {
				var info = coverContinuity.a;
				return _Utils_Tuple2(
					$author$project$Translations$detailsPreviousInsurer(i18n),
					info);
			}
		}();
		var referenceTypeText = _v0.a;
		var continuityInfo = _v0.b;
		return A4($author$project$Common$CoverContinuity$renderCoverContinuityInfo, i18n, referenceTypeText, bundleSlug, continuityInfo);
	});
var $author$project$Pyxis$Components$Grid$Gap$M = 1;
var $author$project$Pyxis$Components$Grid$Gap$sizeM = 1;
var $author$project$Pyxis$Components$Grid$initialConfiguration = {ae: _List_Nil, aF: $author$project$Pyxis$Components$Grid$Gap$sizeM};
var $author$project$Pyxis$Components$Grid$getRowColumnsFromClass = function (breakpointType) {
	var breakpoint = $author$project$Pyxis$Tokens$Breakpoint$toString(breakpointType);
	return 'grid__row--from-' + breakpoint;
};
var $author$project$Pyxis$Components$Grid$Row$M = 1;
var $author$project$Pyxis$Components$Grid$Row$isSizeM = $elm$core$Basics$eq(1);
var $author$project$Pyxis$Components$Grid$Row$S = 0;
var $author$project$Pyxis$Components$Grid$Row$isSizeS = $elm$core$Basics$eq(0);
var $author$project$Pyxis$Components$Grid$SpanSize$toInt = function (spanSize) {
	switch (spanSize) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		default:
			return 5;
	}
};
var $author$project$Pyxis$Components$Grid$SpanSize$toString = A2($elm$core$Basics$composeR, $author$project$Pyxis$Components$Grid$SpanSize$toInt, $elm$core$String$fromInt);
var $author$project$Pyxis$Components$Grid$getColumnSpanAtBreakpointClass = F2(
	function (spanSize, breakpointType) {
		var span = $author$project$Pyxis$Components$Grid$SpanSize$toString(spanSize);
		var breakpoint = $author$project$Pyxis$Tokens$Breakpoint$toString(breakpointType);
		return 'grid__row__column--span-' + (span + ('-from-' + breakpoint));
	});
var $author$project$Pyxis$Components$Grid$getColumnSpanClass = function (spanSize) {
	return 'grid__row__column--span-' + $author$project$Pyxis$Components$Grid$SpanSize$toString(spanSize);
};
var $author$project$Pyxis$Components$Grid$renderCol = function (_v0) {
	var configuration = _v0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2('grid__row__column', true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Grid$getColumnSpanClass(configuration.dw),
							true),
							_Utils_Tuple2(
							A2($author$project$Pyxis$Components$Grid$getColumnSpanAtBreakpointClass, configuration.cC, configuration.aV),
							true)
						]),
					configuration.f6))
			]),
		configuration.ae);
};
var $author$project$Pyxis$Components$Grid$renderRow = function (_v0) {
	var configuration = _v0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2('grid__row', true),
							_Utils_Tuple2(
							'grid__row--m',
							$author$project$Pyxis$Components$Grid$Row$isSizeM(configuration.aO)),
							_Utils_Tuple2(
							'grid__row--s',
							$author$project$Pyxis$Components$Grid$Row$isSizeS(configuration.aO)),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Grid$getRowColumnsFromClass(configuration.aV),
							true)
						]),
					configuration.f6))
			]),
		A2($elm$core$List$map, $author$project$Pyxis$Components$Grid$renderCol, configuration.ae));
};
var $author$project$Pyxis$Components$Grid$Gap$toString = function (gap) {
	switch (gap) {
		case 0:
			return 's';
		case 1:
			return 'm';
		case 2:
			return 'l';
		case 3:
			return 'xl';
		default:
			return '2xl';
	}
};
var $author$project$Pyxis$Components$Grid$toGapClass = function (gap) {
	return 'grid--gap-' + $author$project$Pyxis$Components$Grid$Gap$toString(gap);
};
var $author$project$Pyxis$Components$Grid$render = F2(
	function (options, children) {
		var configuration = A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, config) {
					var mapper = _v0;
					return mapper(config);
				}),
			$author$project$Pyxis$Components$Grid$initialConfiguration,
			options);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('grid', true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Grid$toGapClass(configuration.aF),
							true)
						]))
				]),
			A2($elm$core$List$map, $author$project$Pyxis$Components$Grid$renderRow, children));
	});
var $author$project$Translations$coversPreAncillariesDescription = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'This offer was calculated before the introduction of the additional covers. Therefore, some covers cannot be added.';
	} else {
		return 'Esta oferta se calculó antes de la introducción de los coberturas adicionales. Por lo tanto, algunas coberturas no se pueden añadir.';
	}
};
var $author$project$Common$CoverSelection$hasAncillaries = function (_v0) {
	var ancillaries = _v0.mi;
	if (!ancillaries.$) {
		return false;
	} else {
		if ((!ancillaries.a.b) && (!ancillaries.b.b)) {
			return false;
		} else {
			return true;
		}
	}
};
var $author$project$Common$CoverSelection$isUpdateAdditionalCoverButtonVisible = $author$project$Common$CoverSelection$hasAncillaries;
var $author$project$Pyxis$Components$Card$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Card$M = 1;
var $author$project$Pyxis$Components$Card$None = 0;
var $author$project$Pyxis$Components$IconSet$ChevronRight = 178;
var $author$project$Pyxis$Components$IconSet$chevronRight = 178;
var $author$project$Pyxis$Components$Card$config = {T: $elm$core$Maybe$Nothing, fH: $elm$core$Maybe$Nothing, dX: $author$project$Pyxis$Components$IconSet$chevronRight, mf: $elm$core$Maybe$Nothing, cz: 0, f6: _List_Nil, aX: $elm$core$Maybe$Nothing, ej: _List_Nil, ew: $elm$core$Maybe$Nothing, eB: $elm$core$Maybe$Nothing, kg: $elm$core$Maybe$Nothing, aO: 1, fv: $elm$core$Maybe$Nothing};
var $author$project$Pyxis$Components$Card$cardBackgroundClass = function (background) {
	switch (background) {
		case 0:
			return '';
		case 1:
			return 'card--neutral';
		case 2:
			return 'card--brand';
		case 3:
			return 'card--action';
		case 4:
			return 'card--success';
		case 5:
			return 'card--alert';
		case 6:
			return 'card--error';
		case 7:
			return 'card--surface-strong';
		default:
			return 'card--surface-on-surface-strong';
	}
};
var $author$project$Pyxis$Components$Card$cardSizeClass = function (size) {
	switch (size) {
		case 0:
			return '';
		case 1:
			return 'card--m';
		default:
			return 'card--l';
	}
};
var $author$project$Pyxis$Components$Card$childrenNumber = function (_v0) {
	var configuration = _v0;
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm_community$maybe_extra$Maybe$Extra$isJust(configuration.eB),
					$elm_community$maybe_extra$Maybe$Extra$isJust(configuration.aX),
					$elm_community$maybe_extra$Maybe$Extra$isJust(configuration.ew)
				])));
};
var $author$project$Pyxis$Components$Card$isAddonHeader = function (placement) {
	if (placement === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Components$Card$isAddonLeft = function (placement) {
	if (placement === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Components$Card$isAddonPlacement = F2(
	function (mapper, maybeAddon) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Y;
					},
					mapper),
				maybeAddon));
	});
var $author$project$Pyxis$Components$Card$isJustActionCard = function (maybeAction) {
	_v0$4:
	while (true) {
		if (!maybeAction.$) {
			switch (maybeAction.a.$) {
				case 0:
					return true;
				case 3:
					var _v1 = maybeAction.a;
					return true;
				case 5:
					var _v2 = maybeAction.a;
					return true;
				case 1:
					var _v3 = maybeAction.a;
					return true;
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return false;
};
var $author$project$Pyxis$Components$Card$isJustActionCardOnBottom = function (maybeAction) {
	_v0$2:
	while (true) {
		if (!maybeAction.$) {
			switch (maybeAction.a.$) {
				case 5:
					var _v1 = maybeAction.a;
					return true;
				case 1:
					var _v2 = maybeAction.a;
					return true;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return false;
};
var $author$project$Pyxis$Components$Card$getActionText = function (action) {
	_v0$2:
	while (true) {
		if (!action.$) {
			switch (action.a.$) {
				case 5:
					var _v1 = action.a;
					var text = _v1.c;
					return text;
				case 1:
					var _v2 = action.a;
					var text = _v2.a;
					return text;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Pyxis$Components$Card$renderActionIcon = function (icon) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card__action')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Icon$render(
				A2(
					$author$project$Pyxis$Components$Icon$withClassList,
					_List_fromArray(
						[
							_Utils_Tuple2('card__header__action__icon', true)
						]),
					$author$project$Pyxis$Components$Icon$config(icon)))
			]));
};
var $author$project$Pyxis$Components$Card$renderActionBottom = F2(
	function (icon, label) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card__action-wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pyxis$Commons$Render$maybeMapRender,
					function (text) {
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(text)
								]));
					},
					label),
					$author$project$Pyxis$Components$Card$renderActionIcon(icon)
				]));
	});
var $author$project$Pyxis$Components$Card$renderAction = F2(
	function (_v0, icon) {
		var action = _v0.T;
		return A3(
			$author$project$Pyxis$Commons$Basics$ternaryOperator,
			$author$project$Pyxis$Components$Card$isJustActionCardOnBottom(action),
			A2(
				$author$project$Pyxis$Components$Card$renderActionBottom,
				icon,
				$author$project$Pyxis$Components$Card$getActionText(action)),
			$author$project$Pyxis$Components$Card$renderActionIcon(icon));
	});
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $author$project$Pyxis$Components$Card$renderAddonByType = function (addonType) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card__addon')
			]),
		_List_fromArray(
			[
				function () {
				switch (addonType.$) {
					case 0:
						var iconConfig = addonType.a;
						return $author$project$Pyxis$Components$Icon$render(iconConfig);
					case 1:
						var url = addonType.a;
						return A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(url),
									$elm$html$Html$Attributes$height(48),
									$elm$html$Html$Attributes$width(48)
								]),
							_List_Nil);
					default:
						var html = addonType.a;
						return html;
				}
			}()
			]));
};
var $author$project$Pyxis$Components$Card$renderContent = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card__content')
			]),
		_List_fromArray(
			[content]));
};
var $author$project$Pyxis$Components$Card$renderFooter = function (footer) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card__footer')
			]),
		_List_fromArray(
			[footer]));
};
var $author$project$Pyxis$Components$Card$isAddonTop = function (placement) {
	if (!placement) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Components$Card$renderAddonIfPlacement = F2(
	function (mapper, addon) {
		return A2(
			$author$project$Pyxis$Commons$Render$renderIf,
			mapper(addon.Y),
			$author$project$Pyxis$Components$Card$renderAddonByType(addon.bk));
	});
var $author$project$Pyxis$Components$Card$AnchorCard = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pyxis$Components$Card$ButtonCard = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Button$Open = 0;
var $author$project$Pyxis$Components$Button$linkWithTarget = F2(
	function (href, linkTarget) {
		return A3(
			$author$project$Pyxis$Components$Button$Link,
			href,
			$elm$core$Maybe$Just(linkTarget),
			0);
	});
var $author$project$Pyxis$Components$Button$Append = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Button$withIconAppend = F2(
	function (icon, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				kf: $author$project$Pyxis$Components$Button$Append(icon)
			});
	});
var $author$project$Pyxis$Components$Card$renderInlineButton = F4(
	function (label, actionIcon, ariaLabel, buttonConfig) {
		return $author$project$Pyxis$Components$Button$render(
			buttonConfig(
				function (btn) {
					return A2(
						$elm$core$Maybe$withDefault,
						btn,
						A2(
							$elm$core$Maybe$map,
							function (text) {
								return A2($author$project$Pyxis$Components$Button$withAriaLabel, text, btn);
							},
							ariaLabel));
				}(
					A2(
						$author$project$Pyxis$Components$Button$withIconAppend,
						actionIcon,
						A2(
							$author$project$Pyxis$Components$Button$withSize,
							$author$project$Pyxis$Components$Button$sizeS,
							A2($author$project$Pyxis$Components$Button$withText, label, $author$project$Pyxis$Components$Button$ghost))))));
	});
var $author$project$Pyxis$Components$Card$renderSubtitle = function (subtitle) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card__header__subtitle')
			]),
		_List_fromArray(
			[subtitle]));
};
var $author$project$Pyxis$Components$Card$renderTitle = function (title) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card__header__title')
			]),
		_List_fromArray(
			[title]));
};
var $author$project$Pyxis$Components$Card$renderTitleAndSubtitle = function (_v0) {
	var configuration = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Card$renderTitle, configuration.iS)),
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Card$renderSubtitle, configuration.dI))
			]));
};
var $author$project$Pyxis$Components$Card$renderActionByType = F5(
	function (background, icon, headerConfig, ariaLabel, action) {
		renderActionByType:
		while (true) {
			var configuration = headerConfig;
			switch (action.$) {
				case 0:
					var msg = action.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(msg),
										$elm$html$Html$Attributes$class('card__header__action'),
										A2(
										$author$project$Pyxis$Commons$Attributes$maybe,
										$elm$html$Html$Attributes$attribute('aria-label'),
										ariaLabel)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('card__header__action__focus'),
												A2(
												$author$project$Pyxis$Commons$Attributes$renderIf,
												!(!background),
												A2($elm$html$Html$Attributes$attribute, 'data-style', 'default'))
											]),
										_List_Nil),
										$author$project$Pyxis$Commons$Render$renderMaybe(configuration.iS)
									])),
								$author$project$Pyxis$Commons$Render$renderMaybe(configuration.dI)
							]));
				case 3:
					var href = action.a;
					var linkTarget = action.b;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(href),
										$elm$html$Html$Attributes$class('card__header__action'),
										$author$project$Pyxis$Commons$Attributes$target(linkTarget),
										A2(
										$author$project$Pyxis$Commons$Attributes$maybe,
										$elm$html$Html$Attributes$attribute('aria-label'),
										ariaLabel)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('card__header__action__focus'),
												A2(
												$author$project$Pyxis$Commons$Attributes$renderIf,
												!(!background),
												A2($elm$html$Html$Attributes$attribute, 'data-style', 'default'))
											]),
										_List_Nil),
										$author$project$Pyxis$Commons$Render$renderMaybe(configuration.iS)
									])),
								$author$project$Pyxis$Commons$Render$renderMaybe(configuration.dI)
							]));
				case 2:
					var label = action.a;
					var msg = action.b;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card__header__content__inline-action')
							]),
						_List_fromArray(
							[
								$author$project$Pyxis$Components$Card$renderTitleAndSubtitle(headerConfig),
								A4(
								$author$project$Pyxis$Components$Card$renderInlineButton,
								label,
								icon,
								ariaLabel,
								$author$project$Pyxis$Components$Button$withOnClick(msg))
							]));
				case 4:
					var label = action.a;
					var href = action.b;
					var linkTarget = action.c;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card__header__content__inline-action')
							]),
						_List_fromArray(
							[
								$author$project$Pyxis$Components$Card$renderTitleAndSubtitle(headerConfig),
								A4(
								$author$project$Pyxis$Components$Card$renderInlineButton,
								label,
								icon,
								ariaLabel,
								$author$project$Pyxis$Components$Button$withType(
									A2($author$project$Pyxis$Components$Button$linkWithTarget, href, linkTarget)))
							]));
				case 5:
					var href = action.a;
					var linkTarget = action.b;
					var $temp$background = background,
						$temp$icon = icon,
						$temp$headerConfig = headerConfig,
						$temp$ariaLabel = ariaLabel,
						$temp$action = A2($author$project$Pyxis$Components$Card$AnchorCard, href, linkTarget);
					background = $temp$background;
					icon = $temp$icon;
					headerConfig = $temp$headerConfig;
					ariaLabel = $temp$ariaLabel;
					action = $temp$action;
					continue renderActionByType;
				default:
					var msg = action.b;
					var $temp$background = background,
						$temp$icon = icon,
						$temp$headerConfig = headerConfig,
						$temp$ariaLabel = ariaLabel,
						$temp$action = $author$project$Pyxis$Components$Card$ButtonCard(msg);
					background = $temp$background;
					icon = $temp$icon;
					headerConfig = $temp$headerConfig;
					ariaLabel = $temp$ariaLabel;
					action = $temp$action;
					continue renderActionByType;
			}
		}
	});
var $author$project$Pyxis$Components$Card$renderBadgeList = function (badgeList) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('display-flex gap-2xs')
			]),
		A2($elm$core$List$map, $author$project$Pyxis$Components$Badge$render, badgeList));
};
var $author$project$Pyxis$Components$Card$renderInternalHeader = F5(
	function (background, icon, maybeAction, headerConfig, ariaLabel) {
		var configuration = headerConfig;
		return _List_fromArray(
			[
				A2(
				$author$project$Pyxis$Commons$Render$renderIf,
				!$elm$core$List$isEmpty(configuration.dZ),
				$author$project$Pyxis$Components$Card$renderBadgeList(configuration.dZ)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Pyxis$Components$Card$renderTitleAndSubtitle(headerConfig),
				A2(
					$elm$core$Maybe$map,
					A4($author$project$Pyxis$Components$Card$renderActionByType, background, icon, headerConfig, ariaLabel),
					maybeAction)),
				$author$project$Pyxis$Commons$Render$renderMaybe(configuration.aX)
			]);
	});
var $author$project$Pyxis$Components$Card$renderHeader = F2(
	function (_v0, headerConfig) {
		var background = _v0.cz;
		var action = _v0.T;
		var addon = _v0.mf;
		var actionIcon = _v0.dX;
		var actionAriaLabel = _v0.fH;
		var renderMaybeAddonIfPlacement = function (condition) {
			return $author$project$Pyxis$Commons$Render$renderMaybe(
				A2(
					$elm$core$Maybe$map,
					$author$project$Pyxis$Components$Card$renderAddonIfPlacement(condition),
					addon));
		};
		var internalHeader = A5($author$project$Pyxis$Components$Card$renderInternalHeader, background, actionIcon, action, headerConfig, actionAriaLabel);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card__header')
				]),
			A2($author$project$Pyxis$Components$Card$isAddonPlacement, $author$project$Pyxis$Components$Card$isAddonHeader, addon) ? _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card__header__content')
						]),
					_List_fromArray(
						[
							renderMaybeAddonIfPlacement($author$project$Pyxis$Components$Card$isAddonHeader),
							A2($elm$html$Html$div, _List_Nil, internalHeader)
						]))
				]) : A2(
				$elm$core$List$cons,
				renderMaybeAddonIfPlacement($author$project$Pyxis$Components$Card$isAddonTop),
				internalHeader));
	});
var $author$project$Pyxis$Components$Card$setDataStyle = function (background) {
	switch (background) {
		case 0:
			return 'default';
		case 1:
			return 'vibrant';
		case 3:
			return 'vibrant';
		case 5:
			return 'vibrant';
		case 2:
			return 'vibrant';
		case 4:
			return 'vibrant';
		case 6:
			return 'vibrant';
		case 7:
			return 'default';
		default:
			return 'default';
	}
};
var $author$project$Pyxis$Components$Card$render = function (_v0) {
	var configuration = _v0;
	return A2(
		$elm$html$Html$div,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			configuration.ej,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('card', true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Card$cardSizeClass(configuration.aO),
							true),
							_Utils_Tuple2(
							'card--with-action',
							$author$project$Pyxis$Components$Card$isJustActionCard(configuration.T)),
							_Utils_Tuple2(
							'card--with-action-bottom',
							$author$project$Pyxis$Components$Card$isJustActionCardOnBottom(configuration.T)),
							_Utils_Tuple2(
							'card--with-addon',
							$elm_community$maybe_extra$Maybe$Extra$isJust(configuration.mf)),
							_Utils_Tuple2(
							'card--with-addon--left',
							A2($author$project$Pyxis$Components$Card$isAddonPlacement, $author$project$Pyxis$Components$Card$isAddonLeft, configuration.mf)),
							_Utils_Tuple2(
							'card--with-addon--header',
							A2($author$project$Pyxis$Components$Card$isAddonPlacement, $author$project$Pyxis$Components$Card$isAddonHeader, configuration.mf)),
							_Utils_Tuple2(
							'card--with-single-row',
							$author$project$Pyxis$Components$Card$childrenNumber(configuration) === 1),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Card$cardBackgroundClass(configuration.cz),
							true)
						])),
					$elm$html$Html$Attributes$classList(configuration.f6),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, configuration.kg),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, configuration.fv),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-style',
					$author$project$Pyxis$Components$Card$setDataStyle(configuration.cz))
				])),
		_List_fromArray(
			[
				A2(
				$author$project$Pyxis$Commons$Render$renderIf,
				A2($author$project$Pyxis$Components$Card$isAddonPlacement, $author$project$Pyxis$Components$Card$isAddonLeft, configuration.mf),
				$author$project$Pyxis$Commons$Render$renderMaybe(
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.bk;
							},
							$author$project$Pyxis$Components$Card$renderAddonByType),
						configuration.mf))),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card__wrapper')
					]),
				_List_fromArray(
					[
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2(
							$elm$core$Maybe$map,
							$author$project$Pyxis$Components$Card$renderHeader(configuration),
							configuration.eB)),
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Card$renderContent, configuration.aX)),
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Card$renderFooter, configuration.ew))
					])),
				A2(
				$author$project$Pyxis$Commons$Render$renderIf,
				$author$project$Pyxis$Components$Card$isJustActionCard(configuration.T),
				A2($author$project$Pyxis$Components$Card$renderAction, configuration, configuration.dX))
			]));
};
var $author$project$Pyxis$Components$Icon$default = $author$project$Pyxis$Components$Icon$Default;
var $author$project$Common$CoverSelection$renderIcon = function (icon) {
	return $author$project$Pyxis$Components$Icon$render(
		A2(
			$author$project$Pyxis$Components$Icon$withColor,
			$author$project$Pyxis$Tokens$TypographyColor$tokenBrand,
			A2(
				$author$project$Pyxis$Components$Icon$withStyle,
				$author$project$Pyxis$Components$Icon$default,
				A2(
					$author$project$Pyxis$Components$Icon$withSize,
					$author$project$Pyxis$Components$Icon$sizeM,
					$author$project$Pyxis$Components$Icon$config(icon)))));
};
var $author$project$Pyxis$Tokens$TypographyColor$Content = 3;
var $author$project$Pyxis$Tokens$TypographyColor$tokenContent = 3;
var $author$project$Common$CoverSelection$renderSelectableDescription = F2(
	function (i18n, _v0) {
		var icon = _v0.kf;
		var i18nDescription = _v0.ke;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('covers__selectable-cover__description')
				]),
			_List_fromArray(
				[
					$author$project$Common$CoverSelection$renderIcon(icon),
					$author$project$Pyxis$Components$Text$render(
					A2(
						$author$project$Pyxis$Components$Text$withFontWeight,
						$author$project$Pyxis$Tokens$FontWeight$tokenBold,
						A2(
							$author$project$Pyxis$Components$Text$withColor,
							$author$project$Pyxis$Tokens$TypographyColor$tokenContent,
							A2(
								$author$project$Pyxis$Components$Text$withSize,
								$author$project$Pyxis$Tokens$TextSize$tokenL,
								$author$project$Pyxis$Components$Text$config(
									$elm$html$Html$text(
										i18nDescription(i18n)))))))
				]));
	});
var $author$project$Pyxis$Components$Price$Bold = 1;
var $author$project$Pyxis$Components$Price$Bottom = 0;
var $author$project$Pyxis$Components$Price$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Price$L = 1;
var $author$project$Pyxis$Components$Price$Left = 0;
var $author$project$Pyxis$Commons$Locale$EN = 0;
var $author$project$Pyxis$Commons$Locale$enLocale = 0;
var $author$project$Pyxis$Commons$Currency$GBP = 1;
var $author$project$Pyxis$Commons$Currency$gbpCurrency = 1;
var $author$project$Pyxis$Components$Price$config = {dV: $elm$core$Maybe$Nothing, dY: 0, f6: _List_Nil, ef: $author$project$Pyxis$Commons$Currency$gbpCurrency, ek: _List_Nil, mP: $elm$core$Maybe$Nothing, el: 0, eD: false, kg: $elm$core$Maybe$Nothing, eT: $author$project$Pyxis$Commons$Locale$enLocale, bd: $elm$core$Maybe$Nothing, dq: $elm$core$Maybe$Nothing, aO: 1, fv: $elm$core$Maybe$Nothing, fF: 1};
var $author$project$Translations$coversAncillaryStatusAvailable = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Available';
	} else {
		return 'Disponible';
	}
};
var $author$project$Pyxis$Commons$Locale$ES = 2;
var $author$project$Pyxis$Commons$Locale$esLocale = 2;
var $author$project$Pyxis$Commons$Currency$EUR = 0;
var $author$project$Pyxis$Commons$Currency$euroCurrency = 0;
var $author$project$Common$Price$pickAmountAsFloat = function (_v0) {
	var amount = _v0.a;
	return $prikhi$decimal$Decimal$toFloat(amount);
};
var $author$project$Pyxis$Components$Price$Book = 0;
var $author$project$Pyxis$Components$Price$getPriceAlignmentClass = function (alignment) {
	switch (alignment) {
		case 0:
			return '';
		case 1:
			return 'price--center';
		default:
			return 'price--right';
	}
};
var $author$project$Pyxis$Components$Price$getPriceSizeClass = function (size) {
	switch (size) {
		case 3:
			return 'price--s';
		case 2:
			return 'price--m';
		case 1:
			return '';
		default:
			return 'price--xl';
	}
};
var $author$project$Pyxis$Commons$Currency$getCurrencySymbolFromCode = function (currencyCode) {
	if (!currencyCode) {
		return '€';
	} else {
		return '£';
	}
};
var $author$project$Pyxis$Commons$Locale$isEn = $elm$core$Basics$eq(0);
var $author$project$Pyxis$Commons$Currency$addCurrencyBaseOnLocale = F3(
	function (locale, currencyCode, value) {
		return $author$project$Pyxis$Commons$Locale$isEn(locale) ? _Utils_ap(
			$author$project$Pyxis$Commons$Currency$getCurrencySymbolFromCode(currencyCode),
			value) : (value + (' ' + $author$project$Pyxis$Commons$Currency$getCurrencySymbolFromCode(currencyCode)));
	});
var $author$project$Pyxis$Commons$Float$isInt = function (value) {
	return _Utils_eq(
		value,
		$elm$core$Basics$floor(value));
};
var $cuducos$elm_format_number$FormatNumber$Locales$spanishLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$base,
	{
		mK: ',',
		mL: $cuducos$elm_format_number$FormatNumber$Locales$Exact(3),
		aQ: '.'
	});
var $cuducos$elm_format_number$FormatNumber$Locales$usLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$base,
	{
		mL: $cuducos$elm_format_number$FormatNumber$Locales$Exact(2),
		aQ: ','
	});
var $author$project$Pyxis$Commons$Float$formatFloatBasedOnLocale = F3(
	function (locale, hideTrailingZero, value) {
		var usLocale = $cuducos$elm_format_number$FormatNumber$Locales$usLocale;
		var spanishLocale = $cuducos$elm_format_number$FormatNumber$Locales$spanishLocale;
		var numberOfDecimals = A3(
			$author$project$Pyxis$Commons$Basics$ternaryOperator,
			hideTrailingZero && $author$project$Pyxis$Commons$Float$isInt(value),
			0,
			2);
		return $author$project$Pyxis$Commons$Locale$isEn(locale) ? A2(
			$cuducos$elm_format_number$FormatNumber$format,
			_Utils_update(
				usLocale,
				{
					mL: $cuducos$elm_format_number$FormatNumber$Locales$Exact(numberOfDecimals)
				}),
			value) : A2(
			$cuducos$elm_format_number$FormatNumber$format,
			_Utils_update(
				spanishLocale,
				{
					mL: $cuducos$elm_format_number$FormatNumber$Locales$Exact(numberOfDecimals)
				}),
			value);
	});
var $author$project$Pyxis$Commons$Currency$formatCurrency = F3(
	function (locale, currencyCode, hideTrailingZero) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Pyxis$Commons$Float$formatFloatBasedOnLocale, locale, hideTrailingZero),
			A2($author$project$Pyxis$Commons$Currency$addCurrencyBaseOnLocale, locale, currencyCode));
	});
var $author$project$Pyxis$Components$Price$maybeFormatPrice = F2(
	function (_v0, price) {
		var locale = _v0.eT;
		var currencyCode = _v0.ef;
		var hideTrailingZero = _v0.eD;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A3($author$project$Pyxis$Commons$Currency$formatCurrency, locale, currencyCode, hideTrailingZero),
				price));
	});
var $author$project$Pyxis$Components$Price$applyLabelFormatter = F3(
	function (formattedPriceBeforeDiscount, formattedPrice, formatter) {
		return A2(formatter, formattedPriceBeforeDiscount, formattedPrice);
	});
var $author$project$Pyxis$Components$Price$defaultLabel = F2(
	function (formattedPrice, formattedPriceBeforeDiscount) {
		return formattedPrice + (' instead of ' + formattedPriceBeforeDiscount);
	});
var $author$project$Pyxis$Components$Price$getAccessibilityLabel = F3(
	function (accessibilityLabelFormatter, formattedPrice, formattedPriceBeforeDiscount) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Pyxis$Components$Price$defaultLabel, formattedPrice, formattedPriceBeforeDiscount),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Pyxis$Components$Price$applyLabelFormatter, formattedPriceBeforeDiscount, formattedPrice),
				accessibilityLabelFormatter));
	});
var $elm$html$Html$s = _VirtualDom_node('s');
var $author$project$Pyxis$Components$Price$renderPriceBeforeDiscountBlock = F3(
	function (accessibilityLabelFormatter, formattedPrice, formattedPriceBeforeDiscount) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sr-only')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3($author$project$Pyxis$Components$Price$getAccessibilityLabel, accessibilityLabelFormatter, formattedPrice, formattedPriceBeforeDiscount))
						])),
					A2(
					$elm$html$Html$s,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('price__discount'),
							$author$project$Pyxis$Commons$Attributes$ariaHidden(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(formattedPriceBeforeDiscount)
						]))
				]));
	});
var $author$project$Pyxis$Components$Price$maybeRenderPriceBeforeDiscountBlock = F3(
	function (accessibilityLabelFormatter, formattedPrice, formattedPriceBeforeDiscount) {
		return A2(
			$author$project$Pyxis$Commons$Render$renderIf,
			formattedPriceBeforeDiscount !== '',
			A3($author$project$Pyxis$Components$Price$renderPriceBeforeDiscountBlock, accessibilityLabelFormatter, formattedPrice, formattedPriceBeforeDiscount));
	});
var $author$project$Pyxis$Components$Price$DetailsRight = 1;
var $author$project$Pyxis$Components$Price$isDetailsToPositionRight = F2(
	function (details, alignment) {
		return $elm_community$maybe_extra$Maybe$Extra$isJust(details) && (alignment === 1);
	});
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Pyxis$Components$Price$renderDetails = function (details) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('price__details')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(details)
			]));
};
var $author$project$Pyxis$Components$Price$renderPriceBlock = F2(
	function (_v0, formattedPrice) {
		var priceBeforeDiscount = _v0.dq;
		var details = _v0.mP;
		var detailsPosition = _v0.el;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('price__wrapper', true),
							_Utils_Tuple2(
							'price__wrapper--details-right',
							A2($author$project$Pyxis$Components$Price$isDetailsToPositionRight, details, detailsPosition))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('price__value'),
							$author$project$Pyxis$Commons$Attributes$ariaHidden(
							$elm_community$maybe_extra$Maybe$Extra$isJust(priceBeforeDiscount))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(formattedPrice)
						])),
					A2($author$project$Pyxis$Commons$Render$maybeMapRender, $author$project$Pyxis$Components$Price$renderDetails, details)
				]));
	});
var $author$project$Pyxis$Components$Price$render = function (_v0) {
	var configuration = _v0;
	var id = configuration.kg;
	var testId = configuration.fv;
	var size = configuration.aO;
	var alignment = configuration.dY;
	var priceBeforeDiscount = configuration.dq;
	var price = configuration.bd;
	var accessibilityLabelFormatter = configuration.dV;
	var dataAttributeList = configuration.ek;
	var weight = configuration.fF;
	var formattedPriceBeforeDiscount = A2($author$project$Pyxis$Components$Price$maybeFormatPrice, configuration, priceBeforeDiscount);
	var formattedPrice = A2($author$project$Pyxis$Components$Price$maybeFormatPrice, configuration, price);
	return A2(
		$elm$html$Html$div,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttributeList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2('price', true),
								_Utils_Tuple2('price--book', !weight),
								_Utils_Tuple2(
								$author$project$Pyxis$Components$Price$getPriceSizeClass(size),
								size !== 1),
								_Utils_Tuple2(
								$author$project$Pyxis$Components$Price$getPriceAlignmentClass(alignment),
								!(!alignment))
							]),
						configuration.f6)),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
				])),
		_List_fromArray(
			[
				A3($author$project$Pyxis$Components$Price$maybeRenderPriceBeforeDiscountBlock, accessibilityLabelFormatter, formattedPrice, formattedPriceBeforeDiscount),
				A2($author$project$Pyxis$Components$Price$renderPriceBlock, configuration, formattedPrice)
			]));
};
var $author$project$Pyxis$Components$Price$S = 3;
var $author$project$Pyxis$Components$Price$sizeS = 3;
var $author$project$Pyxis$Components$Badge$Success = 4;
var $author$project$Pyxis$Components$Badge$success = $author$project$Pyxis$Components$Badge$config(4);
var $author$project$Pyxis$Components$Price$withFormatOptions = F3(
	function (locale, currency, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ef: currency, eT: locale});
	});
var $author$project$Pyxis$Components$Price$withPrice = F2(
	function (price, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				bd: $elm$core$Maybe$Just(price)
			});
	});
var $author$project$Pyxis$Components$Price$withSize = F2(
	function (s, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aO: s});
	});
var $author$project$Common$CoverSelection$renderSelectablePrice = F2(
	function (i18n, _v0) {
		var grossPrice = _v0.cT;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('covers__selectable-cover__price')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Price$render(
					A3(
						$author$project$Pyxis$Components$Price$withFormatOptions,
						$author$project$Pyxis$Commons$Locale$esLocale,
						$author$project$Pyxis$Commons$Currency$euroCurrency,
						A2(
							$author$project$Pyxis$Components$Price$withSize,
							$author$project$Pyxis$Components$Price$sizeS,
							A2(
								$author$project$Pyxis$Components$Price$withPrice,
								$author$project$Common$Price$pickAmountAsFloat(grossPrice),
								$author$project$Pyxis$Components$Price$config)))),
					$author$project$Pyxis$Components$Badge$render(
					A2(
						$author$project$Pyxis$Components$Badge$withText,
						$author$project$Translations$coversAncillaryStatusAvailable(i18n),
						$author$project$Pyxis$Components$Badge$success))
				]));
	});
var $author$project$Common$CoverSelection$renderSelectable = F2(
	function (i18n, ancillary) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('covers__selectable-cover')
				]),
			_List_fromArray(
				[
					A2($author$project$Common$CoverSelection$renderSelectableDescription, i18n, ancillary),
					A2($author$project$Common$CoverSelection$renderSelectablePrice, i18n, ancillary)
				]));
	});
var $author$project$Pyxis$Components$Card$S = 0;
var $author$project$Pyxis$Components$Card$sizeS = 0;
var $author$project$Pyxis$Components$Card$withClassList = F2(
	function (classes, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{f6: classes});
	});
var $author$project$Pyxis$Components$Card$withContent = F2(
	function (content, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				aX: $elm$core$Maybe$Just(content)
			});
	});
var $author$project$Pyxis$Components$Card$withSize = F2(
	function (size, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aO: size});
	});
var $author$project$Common$CoverSelection$renderSelectableContainer = F2(
	function (i18n, ancillary) {
		return $author$project$Pyxis$Components$Card$render(
			A2(
				$author$project$Pyxis$Components$Card$withSize,
				$author$project$Pyxis$Components$Card$sizeS,
				A2(
					$author$project$Pyxis$Components$Card$withContent,
					A2($author$project$Common$CoverSelection$renderSelectable, i18n, ancillary),
					A2(
						$author$project$Pyxis$Components$Card$withClassList,
						_List_fromArray(
							[
								_Utils_Tuple2('covers__selectable-cover-container', true)
							]),
						$author$project$Pyxis$Components$Card$config))));
	});
var $author$project$Common$CoverSelection$renderSelectableCovers = F2(
	function (i18n, ancillaryList) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('covers__selectable-covers-container')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Common$CoverSelection$renderSelectableContainer(i18n),
				ancillaryList));
	});
var $author$project$Pyxis$Components$Divider$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Divider$Horizontal = 0;
var $author$project$Pyxis$Components$Divider$S = 0;
var $author$project$Pyxis$Components$Divider$config = {f6: _List_Nil, ej: _List_Nil, kg: $elm$core$Maybe$Nothing, eR: $elm$core$Maybe$Nothing, h3: 0, fv: $elm$core$Maybe$Nothing, iQ: 0};
var $author$project$Pyxis$Components$Divider$M = 1;
var $author$project$Pyxis$Components$Divider$Vertical = 1;
var $author$project$Pyxis$Components$Divider$commonAttributes = function (_v0) {
	var classList = _v0.f6;
	var dataAttrList = _v0.ej;
	var id = _v0.kg;
	var testId = _v0.fv;
	var label = _v0.eR;
	var orientation = _v0.h3;
	var thickness = _v0.iQ;
	return A2(
		$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
		dataAttrList,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('divider', true),
						_Utils_Tuple2('divider--vertical', orientation === 1),
						_Utils_Tuple2('divider--horizontal', !orientation),
						_Utils_Tuple2('divider--border-s', !thickness),
						_Utils_Tuple2('divider--border-m', thickness === 1),
						_Utils_Tuple2(
						'divider--label',
						$elm_community$maybe_extra$Maybe$Extra$isJust(label))
					])),
				$elm$html$Html$Attributes$classList(classList),
				A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
				A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
				A2(
				$author$project$Pyxis$Commons$Attributes$renderIf,
				$elm_community$maybe_extra$Maybe$Extra$isJust(label),
				$author$project$Pyxis$Commons$Attributes$role('presentation'))
			]));
};
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$Pyxis$Components$Divider$renderDivider = function (configuration) {
	return A2(
		$elm$html$Html$hr,
		$author$project$Pyxis$Components$Divider$commonAttributes(configuration),
		_List_Nil);
};
var $author$project$Pyxis$Commons$Render$renderMaybeText = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($elm$html$Html$text),
	$author$project$Pyxis$Commons$Render$renderMaybe);
var $author$project$Pyxis$Components$Divider$renderDividerWithLabel = function (configuration) {
	var label = configuration.eR;
	return A2(
		$elm$html$Html$div,
		$author$project$Pyxis$Components$Divider$commonAttributes(configuration),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('divider__label')
					]),
				_List_fromArray(
					[
						$author$project$Pyxis$Commons$Render$renderMaybeText(label)
					]))
			]));
};
var $author$project$Pyxis$Components$Divider$render = function (configuration) {
	var label = configuration.eR;
	return $elm_community$maybe_extra$Maybe$Extra$isJust(label) ? $author$project$Pyxis$Components$Divider$renderDividerWithLabel(configuration) : $author$project$Pyxis$Components$Divider$renderDivider(configuration);
};
var $author$project$Common$CoverSelection$renderSelectedCover = F4(
	function (i18n, icon, i18nDescription, grossPrice) {
		return A2(
			$author$project$Pyxis$Components$List$withItemTitle,
			i18nDescription,
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				$elm$html$Html$text(
					A2($author$project$Common$Price$toStringSignLast, i18n, grossPrice)),
				A2(
					$author$project$Pyxis$Components$List$withItemAddonIcon,
					$author$project$Pyxis$Components$Icon$config(icon),
					$author$project$Pyxis$Components$List$item)));
	});
var $author$project$Common$CoverSelection$renderSelectedAncillary = F2(
	function (i18n, _v0) {
		var icon = _v0.kf;
		var i18nDescription = _v0.ke;
		var grossPrice = _v0.cT;
		return A4(
			$author$project$Common$CoverSelection$renderSelectedCover,
			i18n,
			icon,
			i18nDescription(i18n),
			grossPrice);
	});
var $author$project$Common$CoverSelection$renderSelectedAncillaries = A2($elm$core$Basics$composeL, $elm$core$List$map, $author$project$Common$CoverSelection$renderSelectedAncillary);
var $author$project$Pyxis$Components$IconSet$SteeringWheel = 40;
var $author$project$Pyxis$Components$IconSet$steeringWheel = 40;
var $author$project$Common$CoverSelection$renderSelectedBundle = F2(
	function (i18n, _v0) {
		var bundle = _v0.f0;
		var bundleGrossPrice = _v0.f1;
		return A4(
			$author$project$Common$CoverSelection$renderSelectedCover,
			i18n,
			$author$project$Pyxis$Components$IconSet$steeringWheel,
			A2($author$project$Common$Product$bundleSlugToString, i18n, bundle),
			bundleGrossPrice);
	});
var $author$project$Common$CoverSelection$renderSelections = F3(
	function (i18n, selectedAncillaries, coverSelection) {
		return $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withEmphasis,
				$author$project$Pyxis$Components$List$emphasisText,
				A2(
					$author$project$Pyxis$Components$List$withOrientation,
					$author$project$Pyxis$Components$List$block,
					A2(
						$author$project$Pyxis$Components$List$withItemOrientation,
						$author$project$Pyxis$Components$List$itemOrientationInline,
						A2(
							$author$project$Pyxis$Components$List$withItems,
							A2(
								$elm$core$List$cons,
								A2($author$project$Common$CoverSelection$renderSelectedBundle, i18n, coverSelection),
								A2($author$project$Common$CoverSelection$renderSelectedAncillaries, i18n, selectedAncillaries)),
							$author$project$Pyxis$Components$List$dl)))));
	});
var $author$project$Common$CoverSelection$calculateTotalPrice = function (_v0) {
	var bundleGrossPrice = _v0.f1;
	var ancillaries = _v0.mi;
	if (!ancillaries.$) {
		return bundleGrossPrice;
	} else {
		var selectedAncillaries = ancillaries.a;
		return A2(
			$author$project$Common$Price$sum,
			bundleGrossPrice,
			$author$project$Common$Price$sumAll(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.cT;
					},
					selectedAncillaries)));
	}
};
var $author$project$Pyxis$Components$Grid$Col$Option = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Grid$Col$classList = function (classes) {
	return function (config) {
		return _Utils_update(
			config,
			{f6: classes});
	};
};
var $author$project$Translations$coversTotalPrice = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Total';
	} else {
		return 'Total';
	}
};
var $author$project$Pyxis$Components$Grid$Row = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Grid$Row$buildConfiguration = F2(
	function (options, config) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, c) {
					var mapper = _v0;
					return mapper(c);
				}),
			config,
			options);
	});
var $author$project$Pyxis$Components$Grid$Row$L = 2;
var $author$project$Pyxis$Components$Grid$Row$rowSizeL = 2;
var $author$project$Pyxis$Components$Grid$initialRowConfiguration = {aV: $author$project$Pyxis$Tokens$Breakpoint$tokenBase, ae: _List_Nil, f6: _List_Nil, aO: $author$project$Pyxis$Components$Grid$Row$rowSizeL};
var $author$project$Pyxis$Components$Grid$row = F2(
	function (options, children) {
		var configuration = A2($author$project$Pyxis$Components$Grid$Row$buildConfiguration, options, $author$project$Pyxis$Components$Grid$initialRowConfiguration);
		return {aV: configuration.aV, ae: children, f6: configuration.f6, aO: configuration.aO};
	});
var $author$project$Pyxis$Tokens$TitleSize$TitleSizeS = 5;
var $author$project$Pyxis$Tokens$TitleSize$tokenS = 5;
var $author$project$Pyxis$Components$Title$withColor = F2(
	function (color, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				ea: $elm$core$Maybe$Just(color)
			});
	});
var $author$project$Pyxis$Components$Title$withSize = F2(
	function (size, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aO: size});
	});
var $author$project$Common$CoverSelection$renderTotalPrice = F2(
	function (i18n, coverSelection) {
		return A2(
			$author$project$Pyxis$Components$Grid$render,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Pyxis$Components$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Pyxis$Components$Grid$col,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Pyxis$Components$Title$render(
									A2(
										$author$project$Pyxis$Components$Title$withColor,
										$author$project$Pyxis$Tokens$TypographyColor$tokenContentWeak,
										A2(
											$author$project$Pyxis$Components$Title$withSize,
											$author$project$Pyxis$Tokens$TitleSize$tokenS,
											$author$project$Pyxis$Components$Title$config(
												$elm$html$Html$text(
													$author$project$Translations$coversTotalPrice(i18n))))))
								])),
							A2(
							$author$project$Pyxis$Components$Grid$col,
							_List_fromArray(
								[
									$author$project$Pyxis$Components$Grid$Col$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('display-grid justify-items-end', true)
										]))
								]),
							_List_fromArray(
								[
									$author$project$Pyxis$Components$Price$render(
									A3(
										$author$project$Pyxis$Components$Price$withFormatOptions,
										$author$project$Pyxis$Commons$Locale$esLocale,
										$author$project$Pyxis$Commons$Currency$euroCurrency,
										A2(
											$author$project$Pyxis$Components$Price$withPrice,
											$author$project$Common$Price$pickAmountAsFloat(
												$author$project$Common$CoverSelection$calculateTotalPrice(coverSelection)),
											$author$project$Pyxis$Components$Price$config)))
								]))
						]))
				]));
	});
var $author$project$Common$CoverSelection$renderSelectedCovers = F3(
	function (i18n, selectedAncillaries, coverSelection) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('covers__selected-cover-container')
				]),
			_List_fromArray(
				[
					A3($author$project$Common$CoverSelection$renderSelections, i18n, selectedAncillaries, coverSelection),
					$author$project$Pyxis$Components$Divider$render($author$project$Pyxis$Components$Divider$config),
					A2($author$project$Common$CoverSelection$renderTotalPrice, i18n, coverSelection)
				]));
	});
var $author$project$Translations$coversUpdateSelectedAncillariesButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Adding or removing additional covers';
	} else {
		return 'Agregar o quitar coberturas opcionales';
	}
};
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.oY;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.m0,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.ll,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.oS,
					_Utils_ap(http, url.ng)),
				url.oP)));
};
var $author$project$Common$CoverSelection$renderUpdateAncillariesButton = F2(
	function (i18n, editAncillaryCoversUrl) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(
					$elm$url$Url$toString(editAncillaryCoversUrl)),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withDataAttrList,
						_List_fromArray(
							[
								_Utils_Tuple2($author$project$Tracker$customActionAttributeName, 'update-ancillaries')
							]),
						A2(
							$author$project$Pyxis$Components$Button$withIconAppend,
							$author$project$Pyxis$Components$IconSet$externalLink,
							A2(
								$author$project$Pyxis$Components$Button$withSize,
								$author$project$Pyxis$Components$Button$sizeM,
								A2(
									$author$project$Pyxis$Components$Button$withText,
									$author$project$Translations$coversUpdateSelectedAncillariesButton(i18n),
									$author$project$Pyxis$Components$Button$secondary)))))
				]));
	});
var $elm_community$html_extra$Html$Extra$viewIf = F2(
	function (condition, html) {
		return condition ? html : $elm_community$html_extra$Html$Extra$nothing;
	});
var $elm_community$html_extra$Html$Extra$viewMaybe = F2(
	function (fn, maybeThing) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm_community$html_extra$Html$Extra$nothing,
			A2($elm$core$Maybe$map, fn, maybeThing));
	});
var $author$project$Common$CoverSelection$renderBody = F3(
	function (i18n, editAncillaryCoversUrl, coverSelection) {
		var ancillaries = coverSelection.mi;
		if (!ancillaries.$) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Message$render(
						A2(
							$author$project$Pyxis$Components$Message$withContent,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$coversPreAncillariesDescription(i18n))
								]),
							$author$project$Pyxis$Components$Message$neutral($author$project$Pyxis$Components$Message$surfaceStrongBackground)))
					]));
		} else {
			var selectedAncillaries = ancillaries.a;
			var selectableAncillaries = ancillaries.b;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('covers__cover-selection-container')
					]),
				_List_fromArray(
					[
						A3($author$project$Common$CoverSelection$renderSelectedCovers, i18n, selectedAncillaries, coverSelection),
						A2($author$project$Common$CoverSelection$renderSelectableCovers, i18n, selectableAncillaries),
						A2(
						$elm_community$html_extra$Html$Extra$viewIf,
						$author$project$Common$CoverSelection$isUpdateAdditionalCoverButtonVisible(coverSelection),
						A2(
							$elm_community$html_extra$Html$Extra$viewMaybe,
							$author$project$Common$CoverSelection$renderUpdateAncillariesButton(i18n),
							editAncillaryCoversUrl))
					]));
		}
	});
var $author$project$Translations$coversChosenExcessSubtitle = F3(
	function (excess, bAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					$elm$html$Html$text('Chosen excess'),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(excess)
						]))
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('Franquicia seleccionada'),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(excess)
						]))
				]);
		}
	});
var $author$project$Common$CoverSelection$renderChosenExcess = F2(
	function (i18n, excess) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('covers__chosen_excess_subtitle')
				]),
			A3(
				$author$project$Translations$coversChosenExcessSubtitle,
				A2($author$project$Common$Price$toStringSignLast, i18n, excess),
				_List_Nil,
				i18n));
	});
var $author$project$Translations$coversSelectedCoverage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Cover selected';
	} else {
		return 'Cobertura seleccionada';
	}
};
var $author$project$Common$CoverSelection$renderCoverSelectedBadge = function (i18n) {
	return $author$project$Pyxis$Components$Badge$render(
		A2(
			$author$project$Pyxis$Components$Badge$withText,
			$author$project$Translations$coversSelectedCoverage(i18n),
			A2($author$project$Pyxis$Components$Badge$withEmphasis, $author$project$Pyxis$Components$Badge$strong, $author$project$Pyxis$Components$Badge$brand)));
};
var $author$project$Pyxis$Components$Link$Action = 0;
var $author$project$Pyxis$Components$Link$Button = 0;
var $author$project$Pyxis$Components$Link$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Link$config = {
	d_: false,
	d$: 0,
	f6: _List_Nil,
	ea: 0,
	ej: _List_Nil,
	em: false,
	cU: $elm$core$Maybe$Nothing,
	kg: $elm$core$Maybe$Nothing,
	hJ: $elm$core$Maybe$Nothing,
	fc: $elm$core$Maybe$Nothing,
	ft: $elm$core$Maybe$Nothing,
	fv: $elm$core$Maybe$Nothing,
	pu: $elm$html$Html$text(''),
	fF: $author$project$Pyxis$Tokens$FontWeight$tokenBold
};
var $author$project$Translations$coversIncludedCoversLink = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'See included covers';
	} else {
		return 'Ver coberturas incluidas';
	}
};
var $author$project$Pyxis$Components$Link$CurrentColor = 1;
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$Pyxis$Components$Link$renderTag = function (buttonTag) {
	return buttonTag ? $elm$html$Html$button : $elm$html$Html$a;
};
var $author$project$Pyxis$Components$Link$typeToAttribute = function (type_) {
	switch (type_) {
		case 1:
			return $elm$html$Html$Attributes$type_('submit');
		case 2:
			return $elm$html$Html$Attributes$type_('reset');
		default:
			return $elm$html$Html$Attributes$type_('button');
	}
};
var $author$project$Pyxis$Components$Link$render = function (_v0) {
	var href = _v0.cU;
	var classList = _v0.f6;
	var dataAttrList = _v0.ej;
	var testId = _v0.fv;
	var text = _v0.pu;
	var target = _v0.ft;
	var download = _v0.em;
	var rel = _v0.fc;
	var buttonTag = _v0.d_;
	var buttonType = _v0.d$;
	var onClick = _v0.hJ;
	var id = _v0.kg;
	var color = _v0.ea;
	var weight = _v0.fF;
	return A3(
		$author$project$Pyxis$Components$Link$renderTag,
		buttonTag,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$href, href),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$target, target),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$rel, rel),
					A3(
					$author$project$Pyxis$Commons$Basics$ternaryOperator,
					download,
					$elm$html$Html$Attributes$download(''),
					$author$project$Pyxis$Commons$Attributes$none),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Events$onClick, onClick),
					A2(
					$author$project$Pyxis$Commons$Attributes$renderIf,
					buttonTag,
					$author$project$Pyxis$Components$Link$typeToAttribute(buttonType)),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('link', true),
							_Utils_Tuple2('link--current-color', color === 1),
							_Utils_Tuple2(
							'link--book',
							_Utils_eq(weight, $author$project$Pyxis$Tokens$FontWeight$tokenBook))
						])),
					$elm$html$Html$Attributes$classList(classList),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
				])),
		_List_fromArray(
			[text]));
};
var $author$project$Pyxis$Components$Link$withButtonTag = F2(
	function (buttonTag, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{d_: buttonTag});
	});
var $author$project$Pyxis$Components$Link$withOnClick = F2(
	function (onClick, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				hJ: $elm$core$Maybe$Just(onClick)
			});
	});
var $author$project$Pyxis$Components$Link$withText = F2(
	function (text, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{pu: text});
	});
var $author$project$Common$CoverSelection$renderTitle = F3(
	function (i18n, openModalMsg, bundle) {
		var linkToEditCoverage = $author$project$Pyxis$Components$Text$render(
			A2(
				$author$project$Pyxis$Components$Text$withFontWeight,
				$author$project$Pyxis$Tokens$FontWeight$tokenBold,
				$author$project$Pyxis$Components$Text$config(
					$elm$html$Html$text(
						$author$project$Translations$coversIncludedCoversLink(i18n)))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('covers__title')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Common$Product$bundleSlugToString, i18n, bundle)),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Link$render(
							A2(
								$author$project$Pyxis$Components$Link$withOnClick,
								openModalMsg,
								A2(
									$author$project$Pyxis$Components$Link$withButtonTag,
									true,
									A2($author$project$Pyxis$Components$Link$withText, linkToEditCoverage, $author$project$Pyxis$Components$Link$config))))
						]))
				]));
	});
var $author$project$Common$CoverSelection$render = F4(
	function (i18n, editAncillaryCoversUrl, openModalMsg, coverSelection) {
		var bundle = coverSelection.f0;
		var chosenExcess = coverSelection.f3;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Common$CoverSelection$renderCoverSelectedBadge(i18n),
					A3($author$project$Common$CoverSelection$renderTitle, i18n, openModalMsg, bundle),
					A2(
					$author$project$Common$Render$maybe,
					$author$project$Common$CoverSelection$renderChosenExcess(i18n),
					chosenExcess),
					A3($author$project$Common$CoverSelection$renderBody, i18n, editAncillaryCoversUrl, coverSelection)
				]));
	});
var $author$project$Common$ErrorContainer$resourceNotFound = A2($author$project$Common$ErrorContainer$custom, 1, 'Resource not found');
var $author$project$Common$Portfolio$renderCoverSelection = F4(
	function (i18n, editAncillaryCoversUrl, _v0, coverSelectionRemoteData) {
		var onShowIncludedCovers = _v0.k4;
		switch (coverSelectionRemoteData.$) {
			case 3:
				var coverSelection = coverSelectionRemoteData.a;
				return A4(
					$author$project$Common$CoverSelection$render,
					i18n,
					editAncillaryCoversUrl,
					onShowIncludedCovers(true),
					coverSelection);
			case 1:
				return $author$project$Pyxis$Components$Loaders$Loader$render($author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM);
			case 2:
				return $author$project$Common$ErrorContainer$generic;
			default:
				return $author$project$Common$ErrorContainer$resourceNotFound;
		}
	});
var $author$project$Pyxis$Components$Grid$Col$span1 = function (config) {
	return _Utils_update(
		config,
		{dw: $author$project$Pyxis$Components$Grid$SpanSize$span1});
};
var $author$project$Pyxis$Components$Grid$SpanSize$Span2 = 1;
var $author$project$Pyxis$Components$Grid$SpanSize$span2 = 1;
var $author$project$Pyxis$Components$Grid$Col$span2 = function (config) {
	return _Utils_update(
		config,
		{dw: $author$project$Pyxis$Components$Grid$SpanSize$span2});
};
var $author$project$Common$Portfolio$renderCoversTab = F3(
	function (i18n, portfolio, _v0) {
		var coverSelection = _v0.jI;
		var coversData = _v0.jK;
		var selectedBundleSlug = _v0.lD;
		var editAncillaryCoversUrl = _v0.jR;
		return A3(
			$primait$prima_elm_extra$PrimaFunction$ifThenElse,
			$author$project$Common$CoverContinuity$hasPreviousCoverage(coversData),
			A2(
				$author$project$Pyxis$Components$Grid$render,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Pyxis$Components$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Pyxis$Components$Grid$col,
								_List_fromArray(
									[$author$project$Pyxis$Components$Grid$Col$span1]),
								_List_fromArray(
									[
										A3($author$project$Common$CoverContinuity$render, i18n, selectedBundleSlug, coversData)
									])),
								A2(
								$author$project$Pyxis$Components$Grid$col,
								_List_fromArray(
									[$author$project$Pyxis$Components$Grid$Col$span2]),
								_List_fromArray(
									[
										A4($author$project$Common$Portfolio$renderCoverSelection, i18n, editAncillaryCoversUrl, portfolio, coverSelection)
									]))
							]))
					])),
			A2(
				$author$project$Pyxis$Components$Grid$render,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Pyxis$Components$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Pyxis$Components$Grid$col,
								_List_fromArray(
									[$author$project$Pyxis$Components$Grid$Col$span2]),
								_List_fromArray(
									[
										A4($author$project$Common$Portfolio$renderCoverSelection, i18n, editAncillaryCoversUrl, portfolio, coverSelection)
									])),
								A2(
								$author$project$Pyxis$Components$Grid$col,
								_List_fromArray(
									[$author$project$Pyxis$Components$Grid$Col$span1]),
								_List_fromArray(
									[
										A3($author$project$Common$CoverContinuity$render, i18n, selectedBundleSlug, coversData)
									]))
							]))
					])));
	});
var $author$project$Common$Portfolio$InnerTabsChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Translations$detailsClaimsActionNeededLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Princing action needed';
	} else {
		return 'Acción Pricing';
	}
};
var $author$project$Translations$detailsDocumentIdLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'DNI/NIE';
	} else {
		return 'DNI/NIE';
	}
};
var $author$project$Translations$detailsSincoInfoLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'SINCO info';
	} else {
		return 'Información de SINCO';
	}
};
var $author$project$Common$ClaimHistory$genericItem = F2(
	function (title, text) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				$elm$html$Html$text(text),
				A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Pyxis$Components$List$S = 0;
var $author$project$Pyxis$Components$List$sizeS = 0;
var $author$project$Translations$detailsPricingActionUnknownMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The information could not be retrieved';
	} else {
		return 'No se pudo recuperar la información';
	}
};
var $author$project$Common$PricingAction$toString = F2(
	function (i18n, pricingAction) {
		if (!pricingAction.$) {
			var value = pricingAction.a;
			return value;
		} else {
			return $author$project$Translations$detailsPricingActionUnknownMessage(i18n);
		}
	});
var $primait$prima_elm_extra$PrimaFunction$uncurry = F2(
	function (f, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return A2(f, x, y);
	});
var $author$project$Pyxis$Components$List$withSize = F2(
	function (size, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aO: size});
	});
var $author$project$Common$ClaimHistory$firstColumnElements = F2(
	function (i18n, claimHistory) {
		var items = A2(
			$elm$core$List$map,
			$primait$prima_elm_extra$PrimaFunction$uncurry($author$project$Common$ClaimHistory$genericItem),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Translations$detailsDocumentIdLabel(i18n),
					claimHistory.kg),
					_Utils_Tuple2(
					$author$project$Translations$detailsSincoInfoLabel(i18n),
					claimHistory.lH),
					_Utils_Tuple2(
					$author$project$Translations$detailsClaimsActionNeededLabel(i18n),
					A2($author$project$Common$PricingAction$toString, i18n, claimHistory.fI))
				]));
		return $elm$core$List$singleton(
			$author$project$Pyxis$Components$List$render(
				A2(
					$author$project$Pyxis$Components$List$withItems,
					items,
					A2(
						$author$project$Pyxis$Components$List$withEmphasis,
						$author$project$Pyxis$Components$List$emphasisText,
						A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl)))));
	});
var $author$project$Common$ComponentUI$ColumnedDetailsBox$ColumnedDetailsBox = $elm$core$Basics$identity;
var $author$project$Common$ComponentUI$ColumnedDetailsBox$ColumnedDetailsBoxData = F4(
	function (firstColumnElements, secondColumnElements, i18n, title) {
		return {jZ: firstColumnElements, ni: i18n, ly: secondColumnElements, iS: title};
	});
var $author$project$Common$ComponentUI$ColumnedDetailsBox$new = F3(
	function (firstColumnElements, secondColumnElements, i18n) {
		return A4($author$project$Common$ComponentUI$ColumnedDetailsBox$ColumnedDetailsBoxData, firstColumnElements, secondColumnElements, i18n, $elm$core$Maybe$Nothing);
	});
var $author$project$Translations$detailsClaimsDeclaredBySincoLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Claims declared by SINCO';
	} else {
		return 'Siniestros declarados por SINCO';
	}
};
var $author$project$Translations$detailsClaimsDeclaredWithFaultByCustomerLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'At-fault claims declared by the customer';
	} else {
		return 'Siniestros con culpa declarados por el cliente';
	}
};
var $author$project$Translations$detailsSincoNumberLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'SINCO number';
	} else {
		return 'Últimos cinco dígitos de la póliza actual';
	}
};
var $author$project$Translations$detailsClaimsCountApproximationSuffix = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'or more';
	} else {
		return 'o más';
	}
};
var $author$project$Common$Count$toString = F2(
	function (i18n, count) {
		switch (count.$) {
			case 0:
				var n = count.a;
				return $elm$core$String$fromInt(n);
			case 1:
				var n = count.a;
				return A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							$elm$core$String$fromInt(n),
							$author$project$Translations$detailsClaimsCountApproximationSuffix(i18n)
						]));
			default:
				return '';
		}
	});
var $author$project$Common$ClaimHistory$secondColumnElements = F2(
	function (i18n, claimHistory) {
		var items = A2(
			$elm$core$List$map,
			$primait$prima_elm_extra$PrimaFunction$uncurry($author$project$Common$ClaimHistory$genericItem),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Translations$detailsSincoNumberLabel(i18n),
					claimHistory.lI),
					_Utils_Tuple2(
					$author$project$Translations$detailsClaimsDeclaredWithFaultByCustomerLabel(i18n),
					A2($author$project$Common$Count$toString, i18n, claimHistory.f4)),
					_Utils_Tuple2(
					$author$project$Translations$detailsClaimsDeclaredBySincoLabel(i18n),
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '-', $elm$core$String$fromInt, claimHistory.jq))
				]));
		return $elm$core$List$singleton(
			$author$project$Pyxis$Components$List$render(
				A2(
					$author$project$Pyxis$Components$List$withItems,
					items,
					A2(
						$author$project$Pyxis$Components$List$withEmphasis,
						$author$project$Pyxis$Components$List$emphasisText,
						A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl)))));
	});
var $author$project$Common$ComponentUI$ColumnedDetailsBox$renderDataDetails = function (_v0) {
	var firstColumnElements = _v0.jZ;
	var secondColumnElements = _v0.ly;
	return _Utils_ap(firstColumnElements, secondColumnElements);
};
var $author$project$Pyxis$Components$Title$withFontWeight = F2(
	function (fontWeight, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{gB: fontWeight});
	});
var $author$project$Common$ComponentUI$ColumnedDetailsBox$renderTitle = function (label) {
	return A2(
		$elm_community$html_extra$Html$Extra$viewMaybe,
		A2(
			$elm$core$Basics$composeR,
			$elm$html$Html$text,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Title$config,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Title$withFontWeight($author$project$Pyxis$Tokens$FontWeight$tokenBold),
					A2(
						$elm$core$Basics$composeR,
						$author$project$Pyxis$Components$Title$withSize($author$project$Pyxis$Tokens$TitleSize$tokenM),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Pyxis$Components$Title$withClassList(
								_List_fromArray(
									[
										_Utils_Tuple2('column-info__label', true)
									])),
							$author$project$Pyxis$Components$Title$render))))),
		label);
};
var $author$project$Common$ComponentUI$ColumnedDetailsBox$view = function (_v0) {
	var columnedDetailsBoxData = _v0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('column-info')
			]),
		A2(
			$elm$core$List$cons,
			$author$project$Common$ComponentUI$ColumnedDetailsBox$renderTitle(columnedDetailsBoxData.iS),
			$author$project$Common$ComponentUI$ColumnedDetailsBox$renderDataDetails(columnedDetailsBoxData)));
};
var $author$project$Common$ClaimHistory$view = F2(
	function (i18n, claimHistory) {
		return $author$project$Common$ComponentUI$ColumnedDetailsBox$view(
			A3(
				$author$project$Common$ComponentUI$ColumnedDetailsBox$new,
				A2($author$project$Common$ClaimHistory$firstColumnElements, i18n, claimHistory),
				A2($author$project$Common$ClaimHistory$secondColumnElements, i18n, claimHistory),
				i18n));
	});
var $author$project$Common$Portfolio$renderClaimHistoryTab = F2(
	function (i18n, remoteData) {
		switch (remoteData.$) {
			case 3:
				if (!remoteData.a.$) {
					var claimHistory = remoteData.a.a;
					return A2($author$project$Common$ClaimHistory$view, i18n, claimHistory);
				} else {
					var _v1 = remoteData.a;
					return $author$project$Common$ErrorContainer$resourceNotFound;
				}
			case 1:
				return $author$project$Pyxis$Components$Loaders$Loader$render($author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM);
			case 2:
				return $author$project$Common$ErrorContainer$generic;
			default:
				return $author$project$Common$ErrorContainer$resourceNotFound;
		}
	});
var $author$project$Pyxis$Components$Tabs$Tab = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Tabs$tab = {bu: $elm$core$Maybe$Nothing, aX: _List_Nil, ej: _List_Nil, kf: $elm$core$Maybe$Nothing, eR: $elm$core$Maybe$Nothing, fv: $elm$core$Maybe$Nothing, pu: ''};
var $author$project$Common$Portfolio$tabContent = $elm$html$Html$div(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('multi-info-container__tab-content')
		]));
var $author$project$Pyxis$Components$Tabs$withContent = F2(
	function (content, _v0) {
		var tab_ = _v0;
		return _Utils_update(
			tab_,
			{aX: content});
	});
var $author$project$Pyxis$Components$Tabs$withText = F2(
	function (text, _v0) {
		var tab_ = _v0;
		return _Utils_update(
			tab_,
			{pu: text});
	});
var $author$project$Common$Portfolio$tabContainer = F2(
	function (label, content) {
		return A2(
			$author$project$Pyxis$Components$Tabs$withContent,
			_List_fromArray(
				[
					$author$project$Common$Portfolio$tabContent(content)
				]),
			A2($author$project$Pyxis$Components$Tabs$withText, label, $author$project$Pyxis$Components$Tabs$tab));
	});
var $author$project$Common$Portfolio$claimHistoryTab = F3(
	function (i18n, label, claimsHistoryData) {
		return A2(
			$author$project$Common$Portfolio$tabContainer,
			label,
			$elm$core$List$singleton(
				A2($author$project$Common$Portfolio$renderClaimHistoryTab, i18n, claimsHistoryData)));
	});
var $author$project$Translations$detailsAdditionalDriverLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Additional driver';
	} else {
		return 'Conductor adicional';
	}
};
var $author$project$Translations$detailsClaimHistoryLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Claims history';
	} else {
		return 'Historial de siniestros';
	}
};
var $author$project$Translations$detailsDriversLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Drivers';
	} else {
		return 'Conductores';
	}
};
var $author$project$Translations$detailsMainDriverLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Main driver';
	} else {
		return 'Conductor principal';
	}
};
var $author$project$Translations$detailsPolicyholderLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policyholder';
	} else {
		return 'Tomador del seguro';
	}
};
var $author$project$Translations$detailsVehicleLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Vehicle';
	} else {
		return 'Coche';
	}
};
var $author$project$Translations$detailsVehicleOwnerLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Vehicle Owner';
	} else {
		return 'Propietario del vehículo';
	}
};
var $author$project$Common$DefaultValues$date = $justinmimbs$date$Date$fromRataDie(1);
var $author$project$Common$DefaultValues$isDefaultDate = function (value) {
	return _Utils_eq(value, $author$project$Common$DefaultValues$date);
};
var $author$project$Common$DefaultValues$string = '';
var $author$project$Common$DefaultValues$isDefaultString = function (value) {
	return _Utils_eq(value, $author$project$Common$DefaultValues$string);
};
var $author$project$Common$Person$isEmptyAdditionalDriver = function (person) {
	if (person.$ === 1) {
		var firstName = person.a.aD;
		var lastName = person.a.aJ;
		var documentId = person.a.ar;
		var dateOfBirth = person.a.aq;
		return $author$project$Common$DefaultValues$isDefaultString(firstName) && ($author$project$Common$DefaultValues$isDefaultString(lastName) && ($author$project$Common$DefaultValues$isDefaultString(documentId) && $author$project$Common$DefaultValues$isDefaultDate(dateOfBirth)));
	} else {
		return false;
	}
};
var $author$project$Translations$detailsDateOfBirthLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Date of birth';
	} else {
		return 'Fecha de nacimiento';
	}
};
var $author$project$Common$Person$genericItem = F2(
	function (title, text) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				$elm$html$Html$text(text),
				A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Common$Person$pickPersonData = function (person) {
	switch (person.$) {
		case 1:
			var personData = person.a;
			return personData;
		case 0:
			var personData = person.a;
			return personData;
		case 2:
			var personData = person.a;
			return personData;
		default:
			var personData = person.a;
			return personData;
	}
};
var $author$project$Common$Person$dateOfBirthItem = function (i18n) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$author$project$Common$Person$genericItem(
					$author$project$Translations$detailsDateOfBirthLabel(i18n)),
				$author$project$Common$Locale$formatDate),
			function ($) {
				return $.aq;
			}),
		$author$project$Common$Person$pickPersonData);
};
var $author$project$Common$Person$documentIdItem = function (i18n) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$author$project$Common$Person$genericItem(
				$author$project$Translations$detailsDocumentIdLabel(i18n)),
			function ($) {
				return $.ar;
			}),
		$author$project$Common$Person$pickPersonData);
};
var $author$project$Translations$drivingLicenseDateLessThanOneYearText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Less than 1 year old';
	} else {
		return 'Menos de 1 año';
	}
};
var $author$project$Translations$drivingLicenseDateLessThanTwoYearsText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Less than 2 years old';
	} else {
		return 'Menos de 2 años';
	}
};
var $author$project$Translations$drivingLicenseDateMoreThanTwoYearsOld = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'More than 2 years old';
	} else {
		return 'Más de 2 años';
	}
};
var $author$project$Translations$drivingLicenseDateOneToThreeYearsOld = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return '1 to 3 years old';
	} else {
		return '1 a 3 años';
	}
};
var $author$project$Common$Person$additionalDriverDrivingLicenseText = F2(
	function (i18n, drivingLicenseYears) {
		switch (drivingLicenseYears) {
			case 0:
				return $author$project$Translations$drivingLicenseDateLessThanOneYearText(i18n);
			case 1:
				return $author$project$Translations$drivingLicenseDateLessThanTwoYearsText(i18n);
			case 2:
				return $author$project$Translations$drivingLicenseDateOneToThreeYearsOld(i18n);
			default:
				return $author$project$Translations$drivingLicenseDateMoreThanTwoYearsOld(i18n);
		}
	});
var $author$project$Common$Person$mainDriverDrivingLicenseDateText = F2(
	function (i18n, data) {
		var bracketedText = data.eL ? $author$project$Translations$drivingLicenseDateMoreThanTwoYearsOld(i18n) : $author$project$Translations$drivingLicenseDateLessThanTwoYearsText(i18n);
		return data.en + (' (' + (bracketedText + ')'));
	});
var $author$project$Common$Person$drivingLicenseDataText = F2(
	function (i18n, person) {
		switch (person.$) {
			case 1:
				var drivingLicenseYears = person.b;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Common$Person$additionalDriverDrivingLicenseText(i18n),
					drivingLicenseYears);
			case 0:
				var drivingLicenseData = person.d;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Common$Person$mainDriverDrivingLicenseDateText(i18n),
					drivingLicenseData);
			case 2:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Translations$drivingLicenseDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Date of driving license';
	} else {
		return 'Fecha del carné de conducir';
	}
};
var $author$project$Common$Person$drivingLicenseDateItem = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Common$Person$drivingLicenseDataText(i18n),
		$elm$core$Maybe$map(
			$author$project$Common$Person$genericItem(
				$author$project$Translations$drivingLicenseDateLabel(i18n))));
};
var $author$project$Translations$detailsFullNameLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Full name';
	} else {
		return 'Nombre completo';
	}
};
var $author$project$Common$Person$fullNameItem = function (i18n) {
	var fullName = function (_v0) {
		var firstName = _v0.aD;
		var lastName = _v0.aJ;
		return firstName + (' ' + lastName);
	};
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$author$project$Common$Person$genericItem(
				$author$project$Translations$detailsFullNameLabel(i18n)),
			fullName),
		$author$project$Common$Person$pickPersonData);
};
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (!item.$) {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$Common$Person$firstColumnElements = F2(
	function (i18n, person) {
		var items = $elm_community$maybe_extra$Maybe$Extra$values(
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2($author$project$Common$Person$fullNameItem, i18n, person)),
					$elm$core$Maybe$Just(
					A2($author$project$Common$Person$documentIdItem, i18n, person)),
					$elm$core$Maybe$Just(
					A2($author$project$Common$Person$dateOfBirthItem, i18n, person)),
					A2($author$project$Common$Person$drivingLicenseDateItem, i18n, person)
				]));
		return $elm$core$List$singleton(
			$author$project$Pyxis$Components$List$render(
				A2(
					$author$project$Pyxis$Components$List$withItems,
					items,
					A2(
						$author$project$Pyxis$Components$List$withEmphasis,
						$author$project$Pyxis$Components$List$emphasisText,
						A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl)))));
	});
var $author$project$Translations$detailsAddressLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Address';
	} else {
		return 'Dirección';
	}
};
var $author$project$Common$Person$defaultItemText = '-';
var $author$project$Common$Address$isDefaultAddress = $elm$core$Basics$eq($author$project$Common$Address$defaultAddress);
var $author$project$Common$Person$formatAddress = function (address) {
	return $author$project$Common$Address$isDefaultAddress(address) ? $author$project$Common$Person$defaultItemText : A2(
		$elm$core$String$join,
		', ',
		_List_fromArray(
			[address.pn, address.po, address.oT, address.oZ]));
};
var $author$project$Common$Person$pickAddress = function (person) {
	switch (person.$) {
		case 1:
			return $author$project$Common$Address$defaultAddress;
		case 0:
			var address = person.b;
			return address;
		case 2:
			var address = person.b;
			return address;
		default:
			var address = person.b;
			return address;
	}
};
var $author$project$Common$Person$addressItem = function (i18n) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$author$project$Common$Person$genericItem(
				$author$project$Translations$detailsAddressLabel(i18n)),
			$author$project$Common$Person$formatAddress),
		$author$project$Common$Person$pickAddress);
};
var $author$project$Translations$detailsEmailAddressLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Email address';
	} else {
		return 'Correo electrónico';
	}
};
var $author$project$Pyxis$Components$List$ItemAction = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$List$itemAction = F3(
	function (icon, label, msg) {
		return {kf: icon, eR: label, hJ: msg};
	});
var $author$project$Pyxis$Components$IconSet$Pen = 64;
var $author$project$Pyxis$Components$IconSet$pen = 64;
var $author$project$Pyxis$Components$List$withItemAction = F2(
	function (action, _v0) {
		var itemConfig = _v0;
		return _Utils_update(
			itemConfig,
			{
				T: $elm$core$Maybe$Just(action)
			});
	});
var $author$project$Pyxis$Components$List$withItemDataAttrList = F2(
	function (attributes, _v0) {
		var itemConfig = _v0;
		return _Utils_update(
			itemConfig,
			{ej: attributes});
	});
var $author$project$Common$Person$emailItem = F3(
	function (i18n, person, changeAction) {
		var email = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Common$Person$defaultItemText,
			function ($) {
				return $.eq;
			},
			$author$project$Common$Person$pickContacts(person));
		var addActionTo = F2(
			function (item, action) {
				return A2(
					$author$project$Pyxis$Components$List$withItemDataAttrList,
					_List_fromArray(
						[
							_Utils_Tuple2($author$project$Tracker$customActionAttributeName, 'edit-policyholder-email')
						]),
					A2(
						$author$project$Pyxis$Components$List$withItemAction,
						A3(
							$author$project$Pyxis$Components$List$itemAction,
							$author$project$Pyxis$Components$IconSet$pen,
							'',
							action(email)),
						item));
			});
		var maybeAddAction = function (item) {
			return A2(
				$elm$core$Maybe$withDefault,
				item,
				A2(
					$elm$core$Maybe$map,
					addActionTo(item),
					changeAction));
		};
		return maybeAddAction(
			A2(
				$author$project$Common$Person$genericItem,
				$author$project$Translations$detailsEmailAddressLabel(i18n),
				email));
	});
var $author$project$Pyxis$Components$List$itemOrientationBlock = 0;
var $author$project$Translations$detailsPhoneNumberLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Phone number';
	} else {
		return 'Número de teléfono';
	}
};
var $author$project$Common$Person$phoneNumberItem = function (i18n) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$author$project$Common$Person$genericItem(
				$author$project$Translations$detailsPhoneNumberLabel(i18n)),
			A2(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$author$project$Common$Person$defaultItemText,
				function ($) {
					return $.h8;
				})),
		$author$project$Common$Person$pickContacts);
};
var $author$project$Common$Person$secondColumnElements = F4(
	function (i18n, changeEmail, additionalFields, person) {
		var additionFieldsToItems = A2(
			$elm$core$List$map,
			$primait$prima_elm_extra$PrimaFunction$uncurry($author$project$Common$Person$genericItem),
			additionalFields);
		var items = A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					A2($author$project$Common$Person$addressItem, i18n, person),
					A3($author$project$Common$Person$emailItem, i18n, person, changeEmail),
					A2($author$project$Common$Person$phoneNumberItem, i18n, person)
				]),
			additionFieldsToItems);
		return $elm$core$List$singleton(
			$author$project$Pyxis$Components$List$render(
				A2(
					$author$project$Pyxis$Components$List$withItemOrientation,
					$author$project$Pyxis$Components$List$itemOrientationBlock,
					A2(
						$author$project$Pyxis$Components$List$withItems,
						items,
						A2(
							$author$project$Pyxis$Components$List$withEmphasis,
							$author$project$Pyxis$Components$List$emphasisText,
							A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl))))));
	});
var $author$project$Common$ComponentUI$ColumnedDetailsBox$withTitle = F2(
	function (title, _v0) {
		var columnedDetailsBoxData = _v0;
		return _Utils_update(
			columnedDetailsBoxData,
			{
				iS: $elm$core$Maybe$Just(title)
			});
	});
var $author$project$Common$ComponentUI$ColumnedDetailsBox$withMaybeTitle = F2(
	function (maybeTitle, columnedDetailsBox) {
		if (!maybeTitle.$) {
			var title = maybeTitle.a;
			return A2($author$project$Common$ComponentUI$ColumnedDetailsBox$withTitle, title, columnedDetailsBox);
		} else {
			return columnedDetailsBox;
		}
	});
var $author$project$Common$Person$render = F3(
	function (i18n, person, _v0) {
		var label = _v0.eR;
		var changeEmail = _v0.f2;
		var additionalFields = _v0.fK;
		return $author$project$Common$ComponentUI$ColumnedDetailsBox$view(
			A2(
				$author$project$Common$ComponentUI$ColumnedDetailsBox$withMaybeTitle,
				label,
				A3(
					$author$project$Common$ComponentUI$ColumnedDetailsBox$new,
					A2($author$project$Common$Person$firstColumnElements, i18n, person),
					A4($author$project$Common$Person$secondColumnElements, i18n, changeEmail, additionalFields, person),
					i18n)));
	});
var $author$project$Common$Person$ViewConfig = $elm$core$Basics$identity;
var $author$project$Common$Person$viewConfig = {fK: _List_Nil, f2: $elm$core$Maybe$Nothing, eR: $elm$core$Maybe$Nothing};
var $author$project$Common$Person$withLabel = F2(
	function (label, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				eR: $elm$core$Maybe$Just(label)
			});
	});
var $author$project$Common$Portfolio$renderPersonFromTuple = F2(
	function (i18n, _v0) {
		var label = _v0.a;
		var person = _v0.b;
		return A3(
			$author$project$Common$Person$render,
			i18n,
			person,
			A2($author$project$Common$Person$withLabel, label, $author$project$Common$Person$viewConfig));
	});
var $author$project$Common$Portfolio$multiPersonTab = F2(
	function (i18n, label) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				$author$project$Common$Portfolio$renderPersonFromTuple(i18n)),
			$author$project$Common$Portfolio$tabContainer(label));
	});
var $author$project$Common$Person$withChangeEmail = F2(
	function (changeEmail, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				f2: $elm$core$Maybe$Just(changeEmail)
			});
	});
var $author$project$Common$Portfolio$personTab = F4(
	function (i18n, changeEmail, label, person) {
		var maybeAddChangeEmail = A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($author$project$Common$Person$withChangeEmail),
			$elm$core$Maybe$withDefault($elm$core$Basics$identity));
		return A2(
			$author$project$Common$Portfolio$tabContainer,
			label,
			$elm$core$List$singleton(
				A3(
					$author$project$Common$Person$render,
					i18n,
					person,
					A2(maybeAddChangeEmail, changeEmail, $author$project$Common$Person$viewConfig))));
	});
var $author$project$Translations$detailsCustomerIdLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Customer Id';
	} else {
		return 'ID cliente';
	}
};
var $author$project$Common$Person$withAdditionalFields = F2(
	function (additionalFields, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{fK: additionalFields});
	});
var $author$project$Common$Portfolio$policyHolderTab = F5(
	function (i18n, changeEmail, label, customerId, person) {
		var maybeAddChangeEmail = A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($author$project$Common$Person$withChangeEmail),
			$elm$core$Maybe$withDefault($elm$core$Basics$identity));
		var additionalFields = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$pair(
						$author$project$Translations$detailsCustomerIdLabel(i18n)),
					$elm$core$List$singleton),
				customerId));
		return A2(
			$author$project$Common$Portfolio$tabContainer,
			label,
			$elm$core$List$singleton(
				A3(
					$author$project$Common$Person$render,
					i18n,
					person,
					A2(
						$author$project$Common$Person$withAdditionalFields,
						additionalFields,
						A2(maybeAddChangeEmail, changeEmail, $author$project$Common$Person$viewConfig)))));
	});
var $author$project$Translations$detailsPlateNumberLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Plate';
	} else {
		return 'Matrícula';
	}
};
var $author$project$Translations$detailsVehicleBrandLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Brand';
	} else {
		return 'Marca';
	}
};
var $author$project$Translations$detailsVehicleMileageLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Annual KM';
	} else {
		return 'Kilometraje anual';
	}
};
var $author$project$Translations$detailsVehicleRegistrationDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Registration';
	} else {
		return 'Fecha 1° matriculación';
	}
};
var $author$project$Common$Vehicle$genericItem = F2(
	function (title, text) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				$elm$html$Html$text(text),
				A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Common$Vehicle$pickBrand = function (_v0) {
	var vehicle = _v0;
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[vehicle.eV, vehicle.eY, vehicle.i4]));
};
var $author$project$Common$Vehicle$pickMileage = function (_v0) {
	var vehicle = _v0;
	return vehicle.hl;
};
var $author$project$Common$Vehicle$pickPlateNumber = function (_v0) {
	var vehicle = _v0;
	return vehicle.ia;
};
var $author$project$Common$Vehicle$pickRegistrationDate = function (_v0) {
	var vehicle = _v0;
	return vehicle.ip;
};
var $author$project$Common$Vehicle$firstColumnElements = F2(
	function (i18n, vehicle) {
		var items = A2(
			$elm$core$List$map,
			$primait$prima_elm_extra$PrimaFunction$uncurry($author$project$Common$Vehicle$genericItem),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Translations$detailsPlateNumberLabel(i18n),
					$author$project$Common$Vehicle$pickPlateNumber(vehicle)),
					_Utils_Tuple2(
					$author$project$Translations$detailsVehicleBrandLabel(i18n),
					$author$project$Common$Vehicle$pickBrand(vehicle)),
					_Utils_Tuple2(
					$author$project$Translations$detailsVehicleMileageLabel(i18n),
					$author$project$Common$Vehicle$pickMileage(vehicle)),
					_Utils_Tuple2(
					$author$project$Translations$detailsVehicleRegistrationDateLabel(i18n),
					$author$project$Common$Vehicle$pickRegistrationDate(vehicle))
				]));
		return $elm$core$List$singleton(
			$author$project$Pyxis$Components$List$render(
				A2(
					$author$project$Pyxis$Components$List$withItems,
					items,
					A2(
						$author$project$Pyxis$Components$List$withEmphasis,
						$author$project$Pyxis$Components$List$emphasisText,
						A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl)))));
	});
var $author$project$Translations$detailsVehicleAccessoriesLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Accessories';
	} else {
		return 'Accessories';
	}
};
var $author$project$Translations$detailsVehicleEnginePowerLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Power';
	} else {
		return 'Potencia';
	}
};
var $author$project$Translations$detailsVehicleFuelTypeLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Fuel type';
	} else {
		return 'Combustible';
	}
};
var $author$project$Translations$detailsVehicleUsageLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Usage';
	} else {
		return 'Uso';
	}
};
var $author$project$Common$Vehicle$enginePowerMeasureUnit = 'CV';
var $author$project$Common$Vehicle$formatEnginePower = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$fromInt,
	A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$String$append, ' ' + $author$project$Common$Vehicle$enginePowerMeasureUnit));
var $author$project$Common$Vehicle$pickAccessories = function (_v0) {
	var vehicle = _v0;
	return vehicle.fG;
};
var $author$project$Common$Vehicle$pickEnginePower = function (_v0) {
	var vehicle = _v0;
	return vehicle.gw;
};
var $author$project$Common$Vehicle$pickFuelType = function (_v0) {
	var vehicle = _v0;
	return vehicle.gG;
};
var $author$project$Common$Vehicle$pickUsage = function (_v0) {
	var vehicle = _v0;
	return vehicle.iW;
};
var $author$project$Common$Vehicle$secondColumnElements = F2(
	function (i18n, vehicle) {
		var items = A2(
			$elm$core$List$map,
			$primait$prima_elm_extra$PrimaFunction$uncurry($author$project$Common$Vehicle$genericItem),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Translations$detailsVehicleFuelTypeLabel(i18n),
					$author$project$Common$Vehicle$pickFuelType(vehicle)),
					_Utils_Tuple2(
					$author$project$Translations$detailsVehicleEnginePowerLabel(i18n),
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'-',
						$author$project$Common$Vehicle$formatEnginePower,
						$author$project$Common$Vehicle$pickEnginePower(vehicle))),
					_Utils_Tuple2(
					$author$project$Translations$detailsVehicleUsageLabel(i18n),
					$author$project$Common$Vehicle$pickUsage(vehicle)),
					_Utils_Tuple2(
					$author$project$Translations$detailsVehicleAccessoriesLabel(i18n),
					A2(
						$elm$core$String$join,
						', ',
						$author$project$Common$Vehicle$pickAccessories(vehicle)))
				]));
		return $elm$core$List$singleton(
			$author$project$Pyxis$Components$List$render(
				A2(
					$author$project$Pyxis$Components$List$withItems,
					items,
					A2(
						$author$project$Pyxis$Components$List$withEmphasis,
						$author$project$Pyxis$Components$List$emphasisText,
						A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl)))));
	});
var $author$project$Common$Vehicle$view = F2(
	function (i18n, vehicle) {
		return $author$project$Common$ComponentUI$ColumnedDetailsBox$view(
			A3(
				$author$project$Common$ComponentUI$ColumnedDetailsBox$new,
				A2($author$project$Common$Vehicle$firstColumnElements, i18n, vehicle),
				A2($author$project$Common$Vehicle$secondColumnElements, i18n, vehicle),
				i18n));
	});
var $author$project$Common$Portfolio$vehicleTab = F3(
	function (i18n, label, vehicle) {
		return A2(
			$author$project$Common$Portfolio$tabContainer,
			label,
			$elm$core$List$singleton(
				A2($author$project$Common$Vehicle$view, i18n, vehicle)));
	});
var $author$project$Common$Portfolio$multiInfoTabsConfig = F2(
	function (i18n, _v0) {
		var policyHolder = _v0.ib;
		var customerId = _v0.gi;
		var vehicle = _v0.i$;
		var vehicleOwner = _v0.l$;
		var mainDriver = _v0.eU;
		var additionalDriver = _v0.jb;
		var claimsHistory = _v0.jr;
		var onChangingEmail = _v0.hI;
		var additionalDriverTab = $author$project$Common$Person$isEmptyAdditionalDriver(additionalDriver) ? A4(
			$author$project$Common$Portfolio$personTab,
			i18n,
			$elm$core$Maybe$Nothing,
			$author$project$Translations$detailsMainDriverLabel(i18n),
			mainDriver) : A3(
			$author$project$Common$Portfolio$multiPersonTab,
			i18n,
			$author$project$Translations$detailsDriversLabel(i18n),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Translations$detailsMainDriverLabel(i18n),
					mainDriver),
					_Utils_Tuple2(
					$author$project$Translations$detailsAdditionalDriverLabel(i18n),
					additionalDriver)
				]));
		return _List_fromArray(
			[
				A5(
				$author$project$Common$Portfolio$policyHolderTab,
				i18n,
				onChangingEmail,
				$author$project$Translations$detailsPolicyholderLabel(i18n),
				customerId,
				policyHolder),
				A3(
				$author$project$Common$Portfolio$vehicleTab,
				i18n,
				$author$project$Translations$detailsVehicleLabel(i18n),
				vehicle),
				A4(
				$author$project$Common$Portfolio$personTab,
				i18n,
				$elm$core$Maybe$Nothing,
				$author$project$Translations$detailsVehicleOwnerLabel(i18n),
				vehicleOwner),
				additionalDriverTab,
				A3(
				$author$project$Common$Portfolio$claimHistoryTab,
				i18n,
				$author$project$Translations$detailsClaimHistoryLabel(i18n),
				claimsHistory)
			]);
	});
var $author$project$Pyxis$Components$Tabs$getAccessibleDescriptionId = function (id) {
	return id + '-accessible-description';
};
var $author$project$Pyxis$Components$Tabs$renderAccessibleDescription = function (id) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$html$Html$text,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$html$Html$span(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sr-only'),
						$elm$html$Html$Attributes$id(id)
					]))));
};
var $author$project$Pyxis$Components$Tabs$Center = 1;
var $author$project$Pyxis$Components$Tabs$Pill = 1;
var $author$project$Pyxis$Components$Tabs$Right = 2;
var $author$project$Pyxis$Components$Tabs$getTablistClasses = function (_v0) {
	var variant = _v0.i_;
	var hasBorder = _v0.gN;
	var placement = _v0.Y;
	return _List_fromArray(
		[
			_Utils_Tuple2('tabs__tablist', true),
			_Utils_Tuple2('tabs__tablist--with-pills', 1 === variant),
			_Utils_Tuple2('tabs__tablist--with-border', hasBorder),
			_Utils_Tuple2('justify-content-center', placement === 1),
			_Utils_Tuple2('justify-content-flex-end', placement === 2)
		]);
};
var $author$project$Pyxis$Components$Tabs$offsetAttribute = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$fromInt,
	A2(
		$elm$core$Basics$composeR,
		A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Basics$append, 'px'),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$append('--offset: '),
			$elm$html$Html$Attributes$attribute('style'))));
var $author$project$Pyxis$Components$Tabs$OnClick = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Tabs$OnKeyDown = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Pyxis$Components$Tabs$StopPanelAnimation = {$: 2};
var $author$project$Pyxis$Commons$Attributes$ariaSelected = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Commons$String$fromBool,
	$elm$html$Html$Attributes$attribute('aria-selected'));
var $author$project$Pyxis$Components$Tabs$getTabPanelId = function (id) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$String$fromInt,
		$elm$core$Basics$append(id + '-tabpanel-'));
};
var $author$project$Pyxis$Components$Tabs$handleKeyDown = F2(
	function (msg, key) {
		return _Utils_Tuple2(
			msg(key),
			A2(
				$elm$core$List$any,
				function (check) {
					return check(key);
				},
				_List_fromArray(
					[$author$project$Pyxis$Commons$Events$Keyboard$isArrowLeft, $author$project$Pyxis$Commons$Events$Keyboard$isArrowRight, $author$project$Pyxis$Commons$Events$Keyboard$isHome, $author$project$Pyxis$Commons$Events$Keyboard$isEnd])));
	});
var $author$project$Pyxis$Commons$Events$Keyboard$Event = $elm$core$Basics$identity;
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Pyxis$Commons$Events$Keyboard$decoder = function (tagger) {
	return A6(
		$elm$json$Json$Decode$map5,
		F5(
			function (keyCode, key, ctrlKey, shiftKey, innerHtml) {
				return tagger(
					{mG: ctrlKey, kj: innerHtml, kt: key, ku: keyCode, pi: shiftKey});
			}),
		A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
		A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool),
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A2($elm$json$Json$Decode$field, 'innerHTML', $elm$json$Json$Decode$string)));
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $author$project$Pyxis$Commons$Events$Keyboard$onPreventDefaultOn = F2(
	function (event, tagger) {
		return A2(
			$elm$html$Html$Events$preventDefaultOn,
			event,
			$author$project$Pyxis$Commons$Events$Keyboard$decoder(tagger));
	});
var $author$project$Pyxis$Components$Tabs$renderTabBadge = function (badge) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tab__addon')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Badge$render(badge)
			]));
};
var $author$project$Pyxis$Components$Tabs$renderTabIcon = function (icon) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tab__icon')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Icon$render(
				$author$project$Pyxis$Components$Icon$config(icon))
			]));
};
var $author$project$Pyxis$Components$Tabs$renderTabLabel = function (label) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tab__addon')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Pyxis$Components$Tabs$renderTabLine = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('tab__line')
		]),
	_List_Nil);
var $author$project$Pyxis$Components$Tabs$renderTab = F5(
	function (tagger, _v0, _v1, index, _v2) {
		var activeIndex = _v0.M;
		var previousActiveIndex = _v0.$7;
		var id = _v1.kg;
		var tabs = _v1.dJ;
		var variant = _v1.i_;
		var tabConfig = _v2;
		var isPanelTransitioning = _Utils_eq(activeIndex, index) && $elm_community$maybe_extra$Maybe$Extra$isJust(previousActiveIndex);
		var panelTransitionEndEvent = isPanelTransitioning ? _List_fromArray(
			[
				A2(
				$elm$html$Html$Events$on,
				'animationend',
				$elm$json$Json$Decode$succeed($author$project$Pyxis$Components$Tabs$StopPanelAnimation)),
				A2(
				$elm$html$Html$Events$on,
				'transitionend',
				$elm$json$Json$Decode$succeed($author$project$Pyxis$Components$Tabs$StopPanelAnimation))
			]) : _List_Nil;
		return A2(
			$elm$html$Html$map,
			tagger,
			A2(
				$elm$html$Html$button,
				A2(
					$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
					tabConfig.ej,
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Pyxis$Commons$Attributes$ariaSelected(
								_Utils_eq(activeIndex, index)),
								$author$project$Pyxis$Commons$Attributes$ariaControls(
								A2($author$project$Pyxis$Components$Tabs$getTabPanelId, id, index)),
								$author$project$Pyxis$Commons$Attributes$role('tab'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('tab', true),
										_Utils_Tuple2('tab--pills', variant === 1)
									])),
								$elm$html$Html$Attributes$id(
								A2($author$project$Pyxis$Components$Tabs$getTabId, id, index)),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, tabConfig.fv),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$tabindex(
								A3(
									$primait$prima_elm_extra$PrimaFunction$ifThenElse,
									_Utils_eq(activeIndex, index),
									0,
									-1)),
								$elm$html$Html$Events$onClick(
								$author$project$Pyxis$Components$Tabs$OnClick(index)),
								A2(
								$author$project$Pyxis$Commons$Events$Keyboard$onPreventDefaultOn,
								'keydown',
								$author$project$Pyxis$Components$Tabs$handleKeyDown(
									A2(
										$author$project$Pyxis$Components$Tabs$OnKeyDown,
										$elm$core$List$length(tabs),
										id)))
							]),
						panelTransitionEndEvent)),
				_List_fromArray(
					[
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Tabs$renderTabIcon, tabConfig.kf)),
						$elm$html$Html$text(tabConfig.pu),
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Tabs$renderTabBadge, tabConfig.bu)),
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Tabs$renderTabLabel, tabConfig.eR)),
						A2($author$project$Pyxis$Commons$Render$renderIf, !variant, $author$project$Pyxis$Components$Tabs$renderTabLine)
					])));
	});
var $author$project$Pyxis$Components$Tabs$renderTabList = F3(
	function (tagger, model, config_) {
		var accessibleDescription = config_.dW;
		var customMobileOffset = config_.gh;
		var id = config_.kg;
		var tabs = config_.dJ;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tabs__tablist-wrapper tabs__tablist-wrapper--mask-both-on-xs'),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Components$Tabs$offsetAttribute, customMobileOffset)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$author$project$Pyxis$Commons$Attributes$renderIf,
								$elm_community$maybe_extra$Maybe$Extra$isJust(accessibleDescription),
								$author$project$Pyxis$Commons$Attributes$ariaLabelledBy(
									$author$project$Pyxis$Components$Tabs$getAccessibleDescriptionId(id))),
								$author$project$Pyxis$Commons$Attributes$role('tablist'),
								$elm$html$Html$Attributes$classList(
								$author$project$Pyxis$Components$Tabs$getTablistClasses(config_))
							]),
						A2(
							$elm$core$List$indexedMap,
							A3($author$project$Pyxis$Components$Tabs$renderTab, tagger, model, config_),
							tabs))
					]))
			]);
	});
var $author$project$Pyxis$Components$Tabs$Fade = 1;
var $author$project$Pyxis$Components$Tabs$isTabPanelActive = $elm$core$Basics$eq;
var $author$project$Pyxis$Components$Tabs$isTabPanelEntering = F2(
	function (previousActiveIndex, panelIndex) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Pyxis$Components$Tabs$isTabPanelActive(panelIndex),
			$elm$core$Basics$and(
				$elm_community$maybe_extra$Maybe$Extra$isJust(previousActiveIndex)));
	});
var $author$project$Pyxis$Components$Tabs$isTabPanelEnteringLeftToRight = F2(
	function (previousActiveIndex, panelIndex) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Pyxis$Components$Tabs$isTabPanelEntering, previousActiveIndex, panelIndex),
			$elm$core$Basics$and(
				_Utils_cmp(
					A2($elm$core$Maybe$withDefault, 0, previousActiveIndex),
					panelIndex) > 0));
	});
var $author$project$Pyxis$Components$Tabs$isTabPanelEnteringRightToLeft = F2(
	function (previousActiveIndex, panelIndex) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Pyxis$Components$Tabs$isTabPanelEntering, previousActiveIndex, panelIndex),
			$elm$core$Basics$and(
				_Utils_cmp(
					A2($elm$core$Maybe$withDefault, 0, previousActiveIndex),
					panelIndex) < 0));
	});
var $author$project$Pyxis$Components$Tabs$isTabPanelExiting = F2(
	function (previousActiveIndex, panelIndex) {
		return $elm_community$maybe_extra$Maybe$Extra$isJust(previousActiveIndex) && _Utils_eq(
			A2($elm$core$Maybe$withDefault, 0, previousActiveIndex),
			panelIndex);
	});
var $author$project$Pyxis$Components$Tabs$isTabPanelExitingLeftToRight = F3(
	function (previousActiveIndex, panelIndex, activeIndex) {
		return A2($author$project$Pyxis$Components$Tabs$isTabPanelExiting, previousActiveIndex, panelIndex) && (_Utils_cmp(
			A2($elm$core$Maybe$withDefault, 0, previousActiveIndex),
			activeIndex) > 0);
	});
var $author$project$Pyxis$Components$Tabs$isTabPanelExitingRightToLeft = F3(
	function (previousActiveIndex, panelIndex, activeIndex) {
		return A2($author$project$Pyxis$Components$Tabs$isTabPanelExiting, previousActiveIndex, panelIndex) && (_Utils_cmp(
			A2($elm$core$Maybe$withDefault, 0, previousActiveIndex),
			activeIndex) < 0);
	});
var $author$project$Pyxis$Components$Tabs$isTabPanelExited = F2(
	function (previousActiveIndex, panelIndex) {
		return $elm_community$maybe_extra$Maybe$Extra$isNothing(previousActiveIndex) || (!A2($author$project$Pyxis$Components$Tabs$isTabPanelExiting, previousActiveIndex, panelIndex));
	});
var $author$project$Pyxis$Components$Tabs$isTabPanelHidden = F4(
	function (previousActiveIndex, panelIndex, activeIndex, panelTransition) {
		return (panelTransition === 1) ? (!A2($author$project$Pyxis$Components$Tabs$isTabPanelActive, panelIndex, activeIndex)) : ((!A2($author$project$Pyxis$Components$Tabs$isTabPanelActive, panelIndex, activeIndex)) && A2($author$project$Pyxis$Components$Tabs$isTabPanelExited, previousActiveIndex, panelIndex));
	});
var $author$project$Pyxis$Components$Tabs$renderTabPanel = F4(
	function (_v0, _v1, index, _v2) {
		var activeIndex = _v0.M;
		var previousActiveIndex = _v0.$7;
		var id = _v1.kg;
		var panelTransition = _v1.h4;
		var tabConfig = _v2;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Pyxis$Commons$Attributes$ariaLabelledBy(
					A2($author$project$Pyxis$Components$Tabs$getTabId, id, index)),
					$author$project$Pyxis$Commons$Attributes$role('tabpanel'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('tabs__tab-panel', true),
							_Utils_Tuple2(
							'tabs__tab-panel--hidden',
							A4($author$project$Pyxis$Components$Tabs$isTabPanelHidden, previousActiveIndex, index, activeIndex, panelTransition)),
							_Utils_Tuple2(
							'tabs__tab-panel--entering-left-to-right',
							(!panelTransition) && A3($author$project$Pyxis$Components$Tabs$isTabPanelEnteringLeftToRight, previousActiveIndex, index, activeIndex)),
							_Utils_Tuple2(
							'tabs__tab-panel--entering-right-to-left',
							(!panelTransition) && A3($author$project$Pyxis$Components$Tabs$isTabPanelEnteringRightToLeft, previousActiveIndex, index, activeIndex)),
							_Utils_Tuple2(
							'tabs__tab-panel--exiting-left-to-right',
							(!panelTransition) && A3($author$project$Pyxis$Components$Tabs$isTabPanelExitingLeftToRight, previousActiveIndex, index, activeIndex)),
							_Utils_Tuple2(
							'tabs__tab-panel--exiting-right-to-left',
							(!panelTransition) && A3($author$project$Pyxis$Components$Tabs$isTabPanelExitingRightToLeft, previousActiveIndex, index, activeIndex)),
							_Utils_Tuple2(
							'tabs__tab-panel--fading-in',
							(panelTransition === 1) && A3($author$project$Pyxis$Components$Tabs$isTabPanelEntering, previousActiveIndex, index, activeIndex))
						])),
					$elm$html$Html$Attributes$id(
					A2($author$project$Pyxis$Components$Tabs$getTabPanelId, id, index))
				]),
			tabConfig.aX);
	});
var $author$project$Pyxis$Components$Tabs$renderTabPanelList = F2(
	function (model, config_) {
		var tabs = config_.dJ;
		return A2(
			$elm$core$List$indexedMap,
			A2($author$project$Pyxis$Components$Tabs$renderTabPanel, model, config_),
			tabs);
	});
var $author$project$Pyxis$Components$Tabs$render = F3(
	function (tagger, model, config_) {
		var conf = config_;
		return A2(
			$elm$html$Html$div,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				conf.ej,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2('tabs', true),
							conf.f6)),
						$elm$html$Html$Attributes$id(conf.kg),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, conf.fv)
					])),
			$elm$core$List$concat(
				_List_fromArray(
					[
						$elm$core$List$singleton(
						$author$project$Pyxis$Commons$Render$renderMaybe(
							A2(
								$elm$core$Maybe$map,
								$author$project$Pyxis$Components$Tabs$renderAccessibleDescription(
									$author$project$Pyxis$Components$Tabs$getAccessibleDescriptionId(conf.kg)),
								conf.dW))),
						A3($author$project$Pyxis$Components$Tabs$renderTabList, tagger, model, config_),
						A2($author$project$Pyxis$Components$Tabs$renderTabPanelList, model, config_)
					])));
	});
var $author$project$Pyxis$Components$Tabs$withBorder = F2(
	function (hasBorder, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{gN: hasBorder});
	});
var $author$project$Pyxis$Components$Tabs$withClassList = F2(
	function (classList, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{f6: classList});
	});
var $author$project$Pyxis$Components$Tabs$withTabs = F2(
	function (tabs, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{dJ: tabs});
	});
var $author$project$Pyxis$Components$Tabs$withTestId = F2(
	function (id, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				fv: $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Common$Portfolio$renderMultiInfo = F3(
	function (i18n, _v0, configuration) {
		var innerTabs = _v0.eE;
		var tagger = _v0.iM;
		return A3(
			$author$project$Pyxis$Components$Tabs$render,
			A2($elm$core$Basics$composeR, $author$project$Common$Portfolio$InnerTabsChanged, tagger),
			innerTabs,
			A2(
				$author$project$Pyxis$Components$Tabs$withTabs,
				A2($author$project$Common$Portfolio$multiInfoTabsConfig, i18n, configuration),
				A2(
					$author$project$Pyxis$Components$Tabs$withBorder,
					true,
					A2(
						$author$project$Pyxis$Components$Tabs$withClassList,
						_List_fromArray(
							[
								_Utils_Tuple2('multi-info-container', true)
							]),
						A2(
							$author$project$Pyxis$Components$Tabs$withTestId,
							'multi-info',
							$author$project$Pyxis$Components$Tabs$config(''))))));
	});
var $author$project$Pyxis$Components$IconSet$ShieldCheck = 45;
var $author$project$Pyxis$Components$IconSet$shieldCheck = 45;
var $author$project$Pyxis$Components$Tabs$withIcon = F2(
	function (icon, _v0) {
		var tab_ = _v0;
		return _Utils_update(
			tab_,
			{
				kf: $elm$core$Maybe$Just(icon)
			});
	});
var $author$project$Common$Portfolio$outerTabsConfig = F3(
	function (i18n, portfolio, configuration) {
		return _List_fromArray(
			[
				A2(
				$author$project$Pyxis$Components$Tabs$withContent,
				_List_fromArray(
					[
						A3($author$project$Common$Portfolio$renderMultiInfo, i18n, portfolio, configuration)
					]),
				A2(
					$author$project$Pyxis$Components$Tabs$withIcon,
					$author$project$Pyxis$Components$IconSet$chart,
					A2(
						$author$project$Pyxis$Components$Tabs$withText,
						$author$project$Translations$detailsPortfolioDataLabel(i18n),
						$author$project$Pyxis$Components$Tabs$tab))),
				A2(
				$author$project$Pyxis$Components$Tabs$withContent,
				_List_fromArray(
					[
						A3($author$project$Common$Portfolio$renderCoversTab, i18n, portfolio, configuration)
					]),
				A2(
					$author$project$Pyxis$Components$Tabs$withIcon,
					$author$project$Pyxis$Components$IconSet$shieldCheck,
					A2(
						$author$project$Pyxis$Components$Tabs$withText,
						$author$project$Translations$detailsPortfolioCoverLabel(i18n),
						$author$project$Pyxis$Components$Tabs$tab)))
			]);
	});
var $author$project$Pyxis$Components$Tabs$pill = 1;
var $author$project$Translations$detailsPortfolioEditInformationLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Edit information';
	} else {
		return 'Edita la información';
	}
};
var $author$project$Common$Render$when = F2(
	function (condition, content) {
		return condition ? content : $author$project$Common$Render$empty;
	});
var $author$project$Common$Portfolio$renderEditButton = F3(
	function (i18n, isDataTabSelected, redirectUrl) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(redirectUrl),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Render$when,
					isDataTabSelected,
					$author$project$Pyxis$Components$Button$render(
						A2(
							$author$project$Pyxis$Components$Button$withDataAttrList,
							_List_fromArray(
								[
									_Utils_Tuple2($author$project$Tracker$customActionAttributeName, 'edit-offer-information')
								]),
							A2(
								$author$project$Pyxis$Components$Button$withIconAppend,
								$author$project$Pyxis$Components$IconSet$pen,
								A2(
									$author$project$Pyxis$Components$Button$withSize,
									$author$project$Pyxis$Components$Button$sizeS,
									A2(
										$author$project$Pyxis$Components$Button$withClassList,
										_List_fromArray(
											[
												_Utils_Tuple2('portfolio-container__edit-button', true)
											]),
										A2(
											$author$project$Pyxis$Components$Button$withText,
											$author$project$Translations$detailsPortfolioEditInformationLabel(i18n),
											$author$project$Pyxis$Components$Button$ghost)))))))
				]));
	});
var $author$project$Translations$detailsPortfolioEditCoverageLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Edit coverage';
	} else {
		return 'Edita la cobertura';
	}
};
var $author$project$Common$Portfolio$renderEditCoverageButton = F3(
	function (i18n, isCoverageTabSelected, redirectUrl) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(redirectUrl),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Render$when,
					isCoverageTabSelected,
					$author$project$Pyxis$Components$Button$render(
						A2(
							$author$project$Pyxis$Components$Button$withIconAppend,
							$author$project$Pyxis$Components$IconSet$pen,
							A2(
								$author$project$Pyxis$Components$Button$withSize,
								$author$project$Pyxis$Components$Button$sizeS,
								A2(
									$author$project$Pyxis$Components$Button$withClassList,
									_List_fromArray(
										[
											_Utils_Tuple2('portfolio-container__edit-button', true)
										]),
									A2(
										$author$project$Pyxis$Components$Button$withText,
										$author$project$Translations$detailsPortfolioEditCoverageLabel(i18n),
										$author$project$Pyxis$Components$Button$ghost))))))
				]));
	});
var $author$project$Pyxis$Components$Tabs$withVariant = F2(
	function (variant, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{i_: variant});
	});
var $author$project$Common$Portfolio$render = F3(
	function (i18n, model, configuration) {
		var tagger = model.iM;
		var outerTabs = model.b1;
		var editRedirectUrl = model.gs;
		var editCoverageUrl = model.gr;
		var isDataTabSelected = !$author$project$Pyxis$Components$Tabs$getActiveTabIndex(outerTabs);
		var isCoverageTabSelected = $author$project$Pyxis$Components$Tabs$getActiveTabIndex(outerTabs) === 1;
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('portfolio-container padding-xl radius-xl'),
					$elm$html$Html$Attributes$id('portfolio-container')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Render$maybe,
					A2($author$project$Common$Portfolio$renderEditButton, i18n, isDataTabSelected),
					editRedirectUrl),
					A2(
					$author$project$Common$Render$maybe,
					A2($author$project$Common$Portfolio$renderEditCoverageButton, i18n, isCoverageTabSelected),
					editCoverageUrl),
					A3(
					$author$project$Pyxis$Components$Tabs$render,
					A2($elm$core$Basics$composeR, $author$project$Common$Portfolio$OuterTabsChanged, tagger),
					outerTabs,
					A2(
						$author$project$Pyxis$Components$Tabs$withTabs,
						A3($author$project$Common$Portfolio$outerTabsConfig, i18n, model, configuration),
						A2(
							$author$project$Pyxis$Components$Tabs$withVariant,
							$author$project$Pyxis$Components$Tabs$pill,
							A2(
								$author$project$Pyxis$Components$Tabs$withClassList,
								_List_fromArray(
									[
										_Utils_Tuple2('portfolio-tabs-group', true)
									]),
								A2(
									$author$project$Pyxis$Components$Tabs$withTestId,
									'portfolio-tabs-group',
									$author$project$Pyxis$Components$Tabs$config('porfolio-tabs-group'))))))
				]));
	});
var $author$project$Pyxis$Components$Message$Alert = 2;
var $author$project$Pyxis$Components$Message$alert = function (style) {
	return A2($author$project$Pyxis$Components$Message$config, 2, style);
};
var $author$project$Translations$gliseRenewalBannerMessage = F2(
	function (bAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text('Attention!')
						])),
					$elm$html$Html$text(' This offer is from Great Lakes Insurance SE. We cannot refer to renewal.')
				]);
		} else {
			return _List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text('¡Atención!')
						])),
					$elm$html$Html$text(' Esta oferta es de Great Lakes Insurance SE. No podemos hablar de renovación.')
				]);
		}
	});
var $author$project$Pyxis$Components$Message$Tint = 2;
var $author$project$Pyxis$Components$Message$tintBackground = 2;
var $author$project$Pyxis$Components$Message$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{f6: classList});
	});
var $author$project$Page$OfferDetails$View$renderGreatLakesBanner = function (i18n) {
	return $author$project$Pyxis$Components$Message$render(
		A2(
			$author$project$Pyxis$Components$Message$withContent,
			A2($author$project$Translations$gliseRenewalBannerMessage, _List_Nil, i18n),
			A2(
				$author$project$Pyxis$Components$Message$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2('search-result__offer__great-lakes-banner', true)
					]),
				$author$project$Pyxis$Components$Message$alert($author$project$Pyxis$Components$Message$tintBackground))));
};
var $justinmimbs$date$Date$fromOrdinalDate = F2(
	function (y, od) {
		var daysInYear = $justinmimbs$date$Date$isLeapYear(y) ? 366 : 365;
		return $justinmimbs$date$Date$daysBeforeYear(y) + A3($elm$core$Basics$clamp, 1, daysInYear, od);
	});
var $elm_community$maybe_extra$Maybe$Extra$unpack = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default(0);
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Common$TimeHelper$tomorrow = function (currentDate) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unpack,
		function (_v0) {
			return A2($justinmimbs$date$Date$fromOrdinalDate, 1970, 1);
		},
		function (today) {
			return A3($justinmimbs$date$Date$add, 3, 1, today);
		},
		currentDate);
};
var $author$project$Common$ComponentUI$DetailsResultBox$Offer = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Common$Offer$pickIssuingCompany = function (_v0) {
	var offer = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		'iptQ',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.a3;
			},
			$elm$core$List$head(offer.dr)));
};
var $author$project$Common$ComponentUI$DetailsResultBox$newOfferViewConfiguration = F5(
	function (i18n, currentDate, actions, offer, isCoverSelectionLoading) {
		return A2(
			$author$project$Common$ComponentUI$DetailsResultBox$Offer,
			{
				ni: i18n,
				a3: $author$project$Common$Offer$pickIssuingCompany(offer),
				bd: $author$project$Common$Offer$totalPrice(offer)
			},
			{gf: currentDate, g_: isCoverSelectionLoading, F: offer, hF: actions.hE, hM: actions.hL, hZ: actions.hY});
	});
var $author$project$Pyxis$Components$Divider$orientationHorizontal = 0;
var $author$project$Pyxis$Components$Divider$thicknessS = 0;
var $author$project$Pyxis$Components$Divider$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{f6: classList});
	});
var $author$project$Pyxis$Components$Divider$withOrientation = F2(
	function (orientation, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{h3: orientation});
	});
var $author$project$Pyxis$Components$Divider$withThickness = F2(
	function (thickness, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{iQ: thickness});
	});
var $author$project$Common$ComponentUI$DetailsResultBox$horizontalDivider = $author$project$Pyxis$Components$Divider$render(
	A2(
		$author$project$Pyxis$Components$Divider$withClassList,
		_List_fromArray(
			[
				_Utils_Tuple2('details__divider-horizontal', true)
			]),
		A2(
			$author$project$Pyxis$Components$Divider$withOrientation,
			$author$project$Pyxis$Components$Divider$orientationHorizontal,
			A2($author$project$Pyxis$Components$Divider$withThickness, $author$project$Pyxis$Components$Divider$thicknessS, $author$project$Pyxis$Components$Divider$config))));
var $author$project$Translations$detailsAmendBoxLink = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Click here';
	} else {
		return 'Clica aquí';
	}
};
var $author$project$Translations$detailsAmendBoxMessageDateInfo = F2(
	function (tomorrow, _v0) {
		var lang = _v0;
		if (!lang) {
			return 'change the starting date to: ' + (tomorrow + ' 00:00 CET');
		} else {
			return 'para cambiar la fecha de entrada en vigor a: ' + (tomorrow + ' 00:00 CET');
		}
	});
var $author$project$Translations$detailsAmendBoxSubMessage = F2(
	function (strongAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					$elm$html$Html$text('If the customer prefers a start date other than tomorrow, you must go to the '),
					A3(
					$elm$html$Html$node,
					'strong',
					_Utils_ap(_List_Nil, strongAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text('Edit information')
						])),
					$elm$html$Html$text(' section to change it.')
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('Si el cliente prefiere una fecha de inicio distinta a la de mañana, debes dirigirte a la sección '),
					A3(
					$elm$html$Html$node,
					'strong',
					_Utils_ap(_List_Nil, strongAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(' Editar información')
						])),
					$elm$html$Html$text('para cambiarla.')
				]);
		}
	});
var $author$project$Common$ComponentUI$DetailsResultBox$renderAmendSubMessage = function (message) {
	return $author$project$Pyxis$Components$Text$render(
		A2(
			$author$project$Pyxis$Components$Text$withSize,
			$author$project$Pyxis$Tokens$TextSize$tokenM,
			$author$project$Pyxis$Components$Text$config(
				A2($elm$html$Html$div, _List_Nil, message))));
};
var $author$project$Common$ComponentUI$DetailsResultBox$tomorrowString = function (today) {
	return $author$project$Common$Locale$formatDate(
		$author$project$Common$TimeHelper$tomorrow(today));
};
var $author$project$Common$ComponentUI$DetailsResultBox$amendMessageWithLink = F3(
	function (i18n, currentDate, onClickEvent) {
		return $author$project$Pyxis$Components$Message$render(
			A2(
				$author$project$Pyxis$Components$Message$withContent,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__link'),
								$elm$html$Html$Events$onClick(onClickEvent)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$detailsAmendBoxLink(i18n))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('details__amend-date-message')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								' ' + A2(
									$author$project$Translations$detailsAmendBoxMessageDateInfo,
									$author$project$Common$ComponentUI$DetailsResultBox$tomorrowString(currentDate),
									i18n))
							])),
						$author$project$Common$ComponentUI$DetailsResultBox$renderAmendSubMessage(
						A2($author$project$Translations$detailsAmendBoxSubMessage, _List_Nil, i18n))
					]),
				$author$project$Pyxis$Components$Message$alert($author$project$Pyxis$Components$Message$tintBackground)));
	});
var $author$project$Common$Offer$isAmendStartDateAction = function (action) {
	if (action.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Common$Offer$canBeAmended = function (_v0) {
	var offer = _v0;
	return A2($elm$core$List$any, $author$project$Common$Offer$isAmendStartDateAction, offer.aS);
};
var $author$project$Common$ComponentUI$DetailsResultBox$isOfferAmendable = function (offer) {
	return $author$project$Common$Offer$canBeAmended(offer);
};
var $author$project$Common$ComponentUI$DetailsResultBox$viewAmendOfferIfAmendable = function (config) {
	if (config.$ === 2) {
		var i18n = config.a.ni;
		var offer = config.b.F;
		var currentDate = config.b.gf;
		var onAmendStartDateAction = config.b.hF;
		return A2(
			$author$project$Common$Render$ifCondition,
			A3($author$project$Common$ComponentUI$DetailsResultBox$amendMessageWithLink, i18n, currentDate, onAmendStartDateAction),
			$author$project$Common$ComponentUI$DetailsResultBox$isOfferAmendable(offer));
	} else {
		return $author$project$Common$Render$empty;
	}
};
var $author$project$Translations$detailsCancellationDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Cancellation date';
	} else {
		return 'Fecha de cancelación';
	}
};
var $author$project$Common$Locale$formatPosixDate = F2(
	function (tz, time) {
		var date = A2($justinmimbs$date$Date$fromPosix, tz, time);
		return $author$project$Common$Locale$formatDate(date);
	});
var $author$project$Common$ComponentUI$DetailsResultBox$createPolicyInterruptionDateInfo = F3(
	function (i18n, onAmendInterruption, _v0) {
		var at = _v0.ml;
		var interruptionDateAsString = A2($author$project$Common$Locale$formatPosixDate, $author$project$Common$Locale$customerTimeZone, at);
		var dateInfo = A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(interruptionDateAsString)
				]));
		var amendButton = function (onClick) {
			return $author$project$Pyxis$Components$Button$render(
				A2(
					$author$project$Pyxis$Components$Button$withOnClick,
					onClick,
					A2(
						$author$project$Pyxis$Components$Button$withIconOnly,
						$author$project$Pyxis$Components$IconSet$pen,
						A2($author$project$Pyxis$Components$Button$withSize, $author$project$Pyxis$Components$Button$sizeS, $author$project$Pyxis$Components$Button$ghost))));
		};
		return A2(
			$elm$core$Tuple$pair,
			$author$project$Translations$detailsCancellationDateLabel(i18n),
			A2(
				$elm$core$Maybe$withDefault,
				dateInfo,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						amendButton,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$singleton,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$append(
									_List_fromArray(
										[dateInfo])),
								$elm$html$Html$div(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('details__general-info-row__cancellation-date')
										]))))),
					onAmendInterruption)));
	});
var $author$project$Translations$detailsBundleLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Cover selected';
	} else {
		return 'Cobertura seleccionada';
	}
};
var $author$project$Translations$detailsEndDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'End date';
	} else {
		return 'Fecha de finalización';
	}
};
var $author$project$Translations$detailsPurchaseDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Purchase date';
	} else {
		return 'Fecha de contratación';
	}
};
var $author$project$Translations$detailsStartDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Start date';
	} else {
		return 'Fecha de inicio';
	}
};
var $author$project$Common$Policy$pickEndDate = function (_v0) {
	var policy = _v0;
	return policy.et;
};
var $author$project$Common$Policy$pickProduct = function (_v0) {
	var policy = _v0;
	return policy.av;
};
var $author$project$Common$Policy$pickPurchaseDate = function (_v0) {
	var policy = _v0;
	return policy.ik;
};
var $author$project$Common$Policy$pickStartDate = function (_v0) {
	var policy = _v0;
	return policy.lL;
};
var $author$project$Common$ComponentUI$DetailsResultBox$productName = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.mt;
		},
		$author$project$Common$Product$bundleSlugToString(i18n));
};
var $author$project$Common$ComponentUI$DetailsResultBox$generalInfoForInterruptedPolicy = F4(
	function (i18n, interruption, onAmendInterruption, policy) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Translations$detailsBundleLabel(i18n),
				$elm$html$Html$text(
					A2(
						$author$project$Common$ComponentUI$DetailsResultBox$productName,
						i18n,
						$author$project$Common$Policy$pickProduct(policy)))),
				_Utils_Tuple2(
				$author$project$Translations$detailsPurchaseDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Common$Policy$pickPurchaseDate(policy)))),
				_Utils_Tuple2(
				$author$project$Translations$detailsStartDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Common$Policy$pickStartDate(policy)))),
				_Utils_Tuple2(
				$author$project$Translations$detailsEndDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Common$Policy$pickEndDate(policy)))),
				A3($author$project$Common$ComponentUI$DetailsResultBox$createPolicyInterruptionDateInfo, i18n, onAmendInterruption, interruption)
			]);
	});
var $author$project$Translations$detailsCreationDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Creation date';
	} else {
		return 'Fecha de la oferta';
	}
};
var $author$project$Common$Offer$pickCreationDate = function (_v0) {
	var offer = _v0;
	return $author$project$Common$Locale$posixToCustomerDate(offer.gd);
};
var $author$project$Common$Offer$pickProducts = function (_v0) {
	var offer = _v0;
	return offer.dr;
};
var $author$project$Common$Offer$pickFirstProduct = A2($elm$core$Basics$composeL, $elm$core$List$head, $author$project$Common$Offer$pickProducts);
var $author$project$Common$ComponentUI$DetailsResultBox$generalInfoForOffer = F2(
	function (i18n, offer) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Translations$detailsBundleLabel(i18n),
				$elm$html$Html$text(
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						$author$project$Common$ComponentUI$DetailsResultBox$productName(i18n),
						$author$project$Common$Offer$pickFirstProduct(offer)))),
				_Utils_Tuple2(
				$author$project$Translations$detailsStartDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Common$Offer$pickStartDate(offer)))),
				_Utils_Tuple2(
				$author$project$Translations$detailsCreationDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Common$Offer$pickCreationDate(offer))))
			]);
	});
var $author$project$Common$ComponentUI$DetailsResultBox$generalInfoForPolicy = F2(
	function (i18n, policy) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Translations$detailsBundleLabel(i18n),
				$elm$html$Html$text(
					A2(
						$author$project$Common$ComponentUI$DetailsResultBox$productName,
						i18n,
						$author$project$Common$Policy$pickProduct(policy)))),
				_Utils_Tuple2(
				$author$project$Translations$detailsPurchaseDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Common$Policy$pickPurchaseDate(policy)))),
				_Utils_Tuple2(
				$author$project$Translations$detailsStartDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Common$Policy$pickStartDate(policy)))),
				_Utils_Tuple2(
				$author$project$Translations$detailsEndDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Common$Policy$pickEndDate(policy))))
			]);
	});
var $author$project$Common$ComponentUI$DetailsResultBox$generalInfo = function (config) {
	switch (config.$) {
		case 0:
			var i18n = config.a.ni;
			var policy = config.b.k;
			return A2($author$project$Common$ComponentUI$DetailsResultBox$generalInfoForPolicy, i18n, policy);
		case 1:
			var i18n = config.a.ni;
			var policy = config.b.k;
			var interruption = config.c.cV;
			var onAmendInterruptionIconClicked = config.c.hD;
			return A4($author$project$Common$ComponentUI$DetailsResultBox$generalInfoForInterruptedPolicy, i18n, interruption, onAmendInterruptionIconClicked, policy);
		default:
			var i18n = config.a.ni;
			var offer = config.b.F;
			return A2($author$project$Common$ComponentUI$DetailsResultBox$generalInfoForOffer, i18n, offer);
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$generalInfoItem = function (_v0) {
	var label = _v0.a;
	var value = _v0.b;
	return $author$project$Pyxis$Components$List$withItemAddonNone(
		A2(
			$author$project$Pyxis$Components$List$withItemText,
			value,
			A2($author$project$Pyxis$Components$List$withItemTitle, label, $author$project$Pyxis$Components$List$item)));
};
var $author$project$Common$ComponentUI$DetailsResultBox$generalInfoItems = A2(
	$elm$core$Basics$composeR,
	$author$project$Common$ComponentUI$DetailsResultBox$generalInfo,
	$elm$core$List$map($author$project$Common$ComponentUI$DetailsResultBox$generalInfoItem));
var $author$project$Pyxis$Components$List$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{f6: classList});
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewGeneralInfoRow = function (detailsInfo) {
	return $author$project$Pyxis$Components$List$render(
		A2(
			$author$project$Pyxis$Components$List$withEmphasis,
			$author$project$Pyxis$Components$List$emphasisText,
			A2(
				$author$project$Pyxis$Components$List$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2('details__general-info-row', true)
					]),
				A2(
					$author$project$Pyxis$Components$List$withSize,
					$author$project$Pyxis$Components$List$sizeS,
					A2(
						$author$project$Pyxis$Components$List$withItems,
						$author$project$Common$ComponentUI$DetailsResultBox$generalInfoItems(detailsInfo),
						A2($author$project$Pyxis$Components$List$withOrientation, $author$project$Pyxis$Components$List$inline, $author$project$Pyxis$Components$List$dl))))));
};
var $author$project$Common$Offer$pickSource = function (_v0) {
	var offer = _v0;
	return offer.iA;
};
var $author$project$Common$Policy$pickSource = function (_v0) {
	var policy = _v0;
	return policy.iA;
};
var $author$project$Common$ComponentUI$DetailsResultBox$fetchSource = function (config) {
	switch (config.$) {
		case 0:
			var policy = config.b.k;
			return $author$project$Common$Policy$pickSource(policy);
		case 1:
			var policy = config.b.k;
			return $author$project$Common$Policy$pickSource(policy);
		default:
			var offer = config.b.F;
			return $author$project$Common$Offer$pickSource(offer);
	}
};
var $author$project$Common$Offer$isCompleteAction = function (action) {
	if (action.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Common$Offer$mayBeCompleted = function (_v0) {
	var offer = _v0;
	return A2($elm$core$List$any, $author$project$Common$Offer$isCompleteAction, offer.aS);
};
var $author$project$Translations$detailsCompleteOfferLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Complete offer';
	} else {
		return 'Completar oferta';
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$viewCompleteOfferButton = F2(
	function (i18n, onCompleteAction) {
		return $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withOnClick,
				onCompleteAction,
				A2(
					$author$project$Pyxis$Components$Button$withType,
					$author$project$Pyxis$Components$Button$button,
					A2(
						$author$project$Pyxis$Components$Button$withText,
						$author$project$Translations$detailsCompleteOfferLabel(i18n),
						$author$project$Pyxis$Components$Button$secondary))));
	});
var $author$project$Common$Offer$isPurchaseAction = function (action) {
	if (!action.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Common$Offer$canBePurchased = function (_v0) {
	var offer = _v0;
	return A2($elm$core$List$any, $author$project$Common$Offer$isPurchaseAction, offer.aS);
};
var $author$project$Translations$detailsPurchaseButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Purchase offer';
	} else {
		return 'Comprar Oferta';
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$viewPurchaseButton = F4(
	function (i18n, onPurchasedButtonClicked, offer, isCoverSelectionLoading) {
		return A2(
			$author$project$Common$Render$ifCondition,
			$author$project$Pyxis$Components$Button$render(
				A2(
					$author$project$Pyxis$Components$Button$withLoading,
					isCoverSelectionLoading,
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						onPurchasedButtonClicked,
						A2(
							$author$project$Pyxis$Components$Button$withType,
							$author$project$Pyxis$Components$Button$button,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$detailsPurchaseButton(i18n),
								$author$project$Pyxis$Components$Button$primary))))),
			$author$project$Common$Offer$canBePurchased(offer));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$highlightRowCTA = function (config) {
	switch (config.$) {
		case 0:
			return $author$project$Common$Render$empty;
		case 1:
			return $author$project$Common$Render$empty;
		default:
			var i18n = config.a.ni;
			var offer = config.b.F;
			var onPurchaseAction = config.b.hZ;
			var onCompleteAction = config.b.hM;
			var isCoverSelectionLoading = config.b.g_;
			return $author$project$Common$Offer$mayBeCompleted(offer) ? A2($author$project$Common$ComponentUI$DetailsResultBox$viewCompleteOfferButton, i18n, onCompleteAction) : ($author$project$Common$Offer$canBeAmended(offer) ? $author$project$Common$Render$empty : A4($author$project$Common$ComponentUI$DetailsResultBox$viewPurchaseButton, i18n, onPurchaseAction, offer, isCoverSelectionLoading));
	}
};
var $author$project$Translations$detailsCompleteOfferNotesLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'By completing the offer you will create a new quotation';
	} else {
		return 'Al completar la oferta crearás una nueva cotización';
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$highlightRowNotes = function (config) {
	switch (config.$) {
		case 0:
			return $author$project$Common$Render$empty;
		case 1:
			return $author$project$Common$Render$empty;
		default:
			var i18n = config.a.ni;
			var offer = config.b.F;
			return A2(
				$author$project$Common$Render$when,
				$author$project$Common$Offer$mayBeCompleted(offer),
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('details__highlight-row__right-side__notes')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$detailsCompleteOfferNotesLabel(i18n))
						])));
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$highlightRowValue = function (config) {
	switch (config.$) {
		case 0:
			var policy = config.b.k;
			return $author$project$Common$Policy$pickCustomerFacingId(policy);
		case 1:
			var policy = config.b.k;
			return $author$project$Common$Policy$pickCustomerFacingId(policy);
		default:
			var offer = config.b.F;
			return $author$project$Common$Offer$pickCustomerFacingId(offer);
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$issuingCompanyValue = function (config) {
	switch (config.$) {
		case 0:
			var data = config.a;
			return data.a3;
		case 1:
			var data = config.a;
			return data.a3;
		default:
			var data = config.a;
			return data.a3;
	}
};
var $author$project$Translations$detailsOfferLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Offer by';
	} else {
		return 'Oferta de';
	}
};
var $author$project$Translations$detailsPolicyLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy by';
	} else {
		return 'Póliza de';
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$highlightRowLabel = function (config) {
	switch (config.$) {
		case 0:
			var i18n = config.a.ni;
			return $author$project$Translations$detailsPolicyLabel(i18n);
		case 1:
			var i18n = config.a.ni;
			return $author$project$Translations$detailsPolicyLabel(i18n);
		default:
			var i18n = config.a.ni;
			return $author$project$Translations$detailsOfferLabel(i18n);
	}
};
var $author$project$Common$Source$isPrimaSource = function (source) {
	return source === 2;
};
var $author$project$Common$Render$emptySpace = $elm$core$String$fromChar('\u00A0');
var $author$project$Common$Render$nonBreakingSpace = $elm$html$Html$text($author$project$Common$Render$emptySpace);
var $author$project$Common$Source$toString = function (source) {
	switch (source) {
		case 0:
			return 'Acierto';
		case 1:
			return 'Check24';
		case 2:
			return 'Prima';
		default:
			return 'Rastreator';
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$renderSourceInfo = F2(
	function (config, source) {
		return _List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Common$ComponentUI$DetailsResultBox$highlightRowLabel(config)),
				$author$project$Common$Render$nonBreakingSpace,
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'c-brand',
								$author$project$Common$Source$isPrimaSource(source)),
								_Utils_Tuple2('text-s-bold', true)
							]))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Common$Source$toString(source))
					]))
			]);
	});
var $author$project$Common$ComponentUI$DetailsResultBox$pickI18N = function (config) {
	switch (config.$) {
		case 0:
			var i18n = config.a.ni;
			return i18n;
		case 1:
			var i18n = config.a.ni;
			return i18n;
		default:
			var i18n = config.a.ni;
			return i18n;
	}
};
var $author$project$Common$Price$toPyxisCurrency = function (_v0) {
	return $author$project$Pyxis$Commons$Currency$euroCurrency;
};
var $author$project$Common$Locale$toPyxisLocal = function (i18n) {
	var _v0 = $author$project$Translations$currentLanguage(i18n);
	if (!_v0) {
		return $author$project$Pyxis$Commons$Locale$enLocale;
	} else {
		return $author$project$Pyxis$Commons$Locale$esLocale;
	}
};
var $author$project$Common$Price$commonConfiguration = F2(
	function (i18n, price) {
		return A2(
			$author$project$Pyxis$Components$Price$withPrice,
			$author$project$Common$Price$pickAmountAsFloat(price),
			A3(
				$author$project$Pyxis$Components$Price$withFormatOptions,
				$author$project$Common$Locale$toPyxisLocal(i18n),
				$author$project$Common$Price$toPyxisCurrency(price),
				$author$project$Pyxis$Components$Price$config));
	});
var $author$project$Pyxis$Components$Price$sizeL = 1;
var $author$project$Common$Price$toHtmlWithLargeSize = F2(
	function (i18n, price) {
		return $author$project$Pyxis$Components$Price$render(
			A2(
				$author$project$Pyxis$Components$Price$withSize,
				$author$project$Pyxis$Components$Price$sizeL,
				A2($author$project$Common$Price$commonConfiguration, i18n, price)));
	});
var $author$project$Translations$detailsNetLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Net';
	} else {
		return 'Prima neta';
	}
};
var $author$project$Translations$detailsTaxIpsLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'IPS';
	} else {
		return 'IPS';
	}
};
var $author$project$Translations$detailsTaxSurchargesLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Surcharges';
	} else {
		return 'Recargos';
	}
};
var $author$project$Translations$detailsTotalAnnualPaymentLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Total annual payment';
	} else {
		return 'Pago total anual';
	}
};
var $author$project$Common$Policy$gross = function (_v0) {
	var policy = _v0;
	return policy.av.jd.j8;
};
var $author$project$Common$Policy$net = function (_v0) {
	var policy = _v0;
	return policy.av.jd.nS;
};
var $author$project$Common$Policy$taxIps = function (_v0) {
	var policy = _v0;
	return policy.av.jd.ps;
};
var $author$project$Common$Policy$taxSurcharges = function (_v0) {
	var policy = _v0;
	return policy.av.jd.pt;
};
var $author$project$Common$Price$toHtmlWithSmallSize = F2(
	function (i18n, price) {
		return $author$project$Pyxis$Components$Price$render(
			A2(
				$author$project$Pyxis$Components$Price$withSize,
				$author$project$Pyxis$Components$Price$sizeS,
				A2($author$project$Common$Price$commonConfiguration, i18n, price)));
	});
var $author$project$Pyxis$Components$Tooltip$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Tooltip$M = 1;
var $author$project$Pyxis$Components$Tooltip$Right = 4;
var $author$project$Pyxis$Components$IconSet$QuestionCircle = 52;
var $author$project$Pyxis$Components$IconSet$questionCircle = 52;
var $author$project$Pyxis$Components$Tooltip$config_ = F2(
	function (id, isMobile) {
		return {f6: _List_Nil, f7: 'Close', aX: $author$project$Pyxis$Commons$Render$empty, eh: $elm$core$Maybe$Nothing, ej: _List_Nil, kf: $elm$core$Maybe$Nothing, kg: id, g1: isMobile, e8: 4, aO: 1, fv: $elm$core$Maybe$Nothing, iS: $elm$core$Maybe$Nothing, fx: $elm$core$Maybe$Nothing, fz: $author$project$Pyxis$Components$IconSet$questionCircle};
	});
var $author$project$Pyxis$Components$Tooltip$config = $author$project$Pyxis$Components$Tooltip$config_;
var $author$project$Pyxis$Components$Tooltip$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Tooltip$init = A2($elm$core$Basics$composeR, $author$project$Pyxis$Components$Modal$init, $elm$core$Basics$identity);
var $author$project$Pyxis$Components$Tooltip$BottomLeft = 1;
var $author$project$Pyxis$Components$Tooltip$positionBottomLeft = 1;
var $author$project$Pyxis$Components$Tooltip$S = 0;
var $author$project$Pyxis$Components$Tooltip$getTooltipPositionClass = function (position) {
	switch (position) {
		case 0:
			return 'tooltip--bottom';
		case 1:
			return 'tooltip--bottom-left';
		case 2:
			return 'tooltip--bottom-right';
		case 3:
			return 'tooltip--left';
		case 4:
			return 'tooltip--right';
		case 5:
			return 'tooltip--top';
		case 6:
			return 'tooltip--top-left';
		default:
			return 'tooltip--top-right';
	}
};
var $author$project$Pyxis$Components$Tooltip$getClassList = function (_v0) {
	var position = _v0.e8;
	var classList = _v0.f6;
	var size = _v0.aO;
	return _Utils_ap(
		_List_fromArray(
			[
				_Utils_Tuple2('tooltip', true),
				_Utils_Tuple2('tooltip--s', !size),
				_Utils_Tuple2(
				$author$project$Pyxis$Components$Tooltip$getTooltipPositionClass(position),
				true)
			]),
		classList);
};
var $author$project$Pyxis$Components$Tooltip$renderIcon = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Components$Icon$config,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeS),
		$author$project$Pyxis$Components$Icon$render));
var $author$project$Pyxis$Components$Tooltip$ShowModal = $elm$core$Basics$identity;
var $author$project$Pyxis$Commons$Basics$applyIfJust = F2(
	function (f, a) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Basics$identity,
			A2($elm$core$Maybe$map, f, a));
	});
var $author$project$Pyxis$Components$Tooltip$renderModal = F3(
	function (tagger, modalModel, _v0) {
		var icon = _v0.kf;
		var title = _v0.iS;
		var content = _v0.aX;
		var closeButtonLabel = _v0.f7;
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			modalModel,
			A2(
				$author$project$Pyxis$Components$Modal$withContent,
				_List_fromArray(
					[content]),
				A2(
					$author$project$Pyxis$Components$Modal$withHeader,
					A3(
						$author$project$Pyxis$Commons$Basics$applyIfJust,
						$author$project$Pyxis$Components$Modal$Header$withIcon,
						A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Icon$config, icon),
						A3($author$project$Pyxis$Commons$Basics$applyIfJust, $author$project$Pyxis$Components$Modal$Header$withTitle, title, $author$project$Pyxis$Components$Modal$Header$config)),
					A3(
						$author$project$Pyxis$Components$Modal$withCloseMsg,
						tagger(false),
						closeButtonLabel,
						$author$project$Pyxis$Components$Modal$config))));
	});
var $author$project$Pyxis$Components$Tooltip$renderTooltipTitle = function (toolTipTitle) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tooltip__title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(toolTipTitle)
			]));
};
var $author$project$Pyxis$Components$Button$withAriaLabelledBy = F2(
	function (ariaLabelledBy, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				fW: $elm$core$Maybe$Just(ariaLabelledBy)
			});
	});
var $author$project$Pyxis$Components$Tooltip$renderTrigger = F2(
	function (tagger, _v0) {
		var customTrigger = _v0.eh;
		var triggerIcon = _v0.fz;
		var id = _v0.kg;
		return $elm_community$maybe_extra$Maybe$Extra$isJust(customTrigger) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					tagger(true))
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Commons$Render$renderMaybe(customTrigger)
				])) : $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2('tooltip-trigger', true)
					]),
				A2(
					$author$project$Pyxis$Components$Button$withIconOnly,
					triggerIcon,
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						tagger(true),
						A2(
							$author$project$Pyxis$Components$Button$withSize,
							$author$project$Pyxis$Components$Button$sizeS,
							A2($author$project$Pyxis$Components$Button$withAriaLabelledBy, id, $author$project$Pyxis$Components$Button$ghost))))));
	});
var $author$project$Pyxis$Components$Tooltip$wrapperId = function (id) {
	return id + '-wrapper';
};
var $author$project$Pyxis$Components$Tooltip$render = F3(
	function (tagger, _v0, tooltipConfig) {
		var showModal = _v0;
		var content = tooltipConfig.aX;
		var dataAttrList = tooltipConfig.ej;
		var size = tooltipConfig.aO;
		var toolTipTitle = tooltipConfig.fx;
		var icon = tooltipConfig.kf;
		var id = tooltipConfig.kg;
		var testId = tooltipConfig.fv;
		var isMobile = tooltipConfig.g1;
		return A2(
			$elm$html$Html$span,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tooltip-wrapper'),
						$elm$html$Html$Attributes$id(
						$author$project$Pyxis$Components$Tooltip$wrapperId(id)),
						$author$project$Pyxis$Commons$Attributes$testId(
						$author$project$Pyxis$Components$Tooltip$wrapperId(id))
					])),
			_List_fromArray(
				[
					A2($author$project$Pyxis$Components$Tooltip$renderTrigger, tagger, tooltipConfig),
					function () {
					if (isMobile) {
						if (!size) {
							return $author$project$Pyxis$Commons$Render$empty;
						} else {
							return A3($author$project$Pyxis$Components$Tooltip$renderModal, tagger, showModal, tooltipConfig);
						}
					} else {
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									$author$project$Pyxis$Components$Tooltip$getClassList(tooltipConfig)),
									$author$project$Pyxis$Commons$Attributes$role('tooltip'),
									A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
									$elm$html$Html$Attributes$id(id)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Pyxis$Commons$Basics$ternaryOperator,
									size === 1,
									A2($author$project$Pyxis$Commons$Render$maybeMapRender, $author$project$Pyxis$Components$Tooltip$renderTooltipTitle, toolTipTitle),
									$elm$html$Html$text('')),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('tooltip__content')
										]),
									A2(
										$elm$core$List$filter,
										function (el) {
											return !_Utils_eq(el, $author$project$Pyxis$Commons$Render$empty);
										},
										_List_fromArray(
											[
												A3(
												$author$project$Pyxis$Commons$Basics$ternaryOperator,
												!(!size),
												$author$project$Pyxis$Commons$Render$renderMaybe(
													A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Tooltip$renderIcon, icon)),
												$author$project$Pyxis$Commons$Render$empty),
												content
											])))
								]));
					}
				}()
				]));
	});
var $author$project$Pyxis$Components$Tooltip$withContent = F2(
	function (content, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aX: content});
	});
var $author$project$Pyxis$Components$Tooltip$withPosition = F2(
	function (position, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{e8: position});
	});
var $author$project$Pyxis$Components$Tooltip$withTestId = F2(
	function (id, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				fv: $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Pyxis$Components$Tooltip$withTriggerIcon = F2(
	function (triggerIcon, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{fz: triggerIcon});
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewTooltip = F3(
	function (id, onClickTooltip, content) {
		return A3(
			$author$project$Pyxis$Components$Tooltip$render,
			onClickTooltip,
			$author$project$Pyxis$Components$Tooltip$init(id),
			A2(
				$author$project$Pyxis$Components$Tooltip$withContent,
				content,
				A2(
					$author$project$Pyxis$Components$Tooltip$withTestId,
					id,
					A2(
						$author$project$Pyxis$Components$Tooltip$withTriggerIcon,
						$author$project$Pyxis$Components$IconSet$infoCircle,
						A2(
							$author$project$Pyxis$Components$Tooltip$withPosition,
							$author$project$Pyxis$Components$Tooltip$positionBottomLeft,
							A2($author$project$Pyxis$Components$Tooltip$config, id, false))))));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewPolicyPriceTooltip = F3(
	function (i18n, onClickTooltip, policy) {
		return A3(
			$author$project$Common$ComponentUI$DetailsResultBox$viewTooltip,
			'payment-price-tooltip',
			onClickTooltip,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__tooltip__frame'),
						A2($elm$html$Html$Attributes$attribute, 'data-style', 'vibrant')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('details__tooltip__left-side')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$detailsNetLabel(i18n))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$detailsTaxIpsLabel(i18n))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$detailsTaxSurchargesLabel(i18n))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('tooltip__total-payment')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$detailsTotalAnnualPaymentLabel(i18n))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('details__tooltip__right-side')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Common$Price$toHtmlWithSmallSize,
								i18n,
								$author$project$Common$Policy$net(policy)),
								A2(
								$author$project$Common$Price$toHtmlWithSmallSize,
								i18n,
								$author$project$Common$Policy$taxIps(policy)),
								A2(
								$author$project$Common$Price$toHtmlWithSmallSize,
								i18n,
								$author$project$Common$Policy$taxSurcharges(policy)),
								A2(
								$author$project$Common$Price$toHtmlWithSmallSize,
								i18n,
								$author$project$Common$Policy$gross(policy))
							]))
					])));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewPolicyPrice = function (config) {
	var priceToShow = function (c) {
		switch (c.$) {
			case 2:
				var price = c.a.bd;
				return price;
			case 0:
				var price = c.a.bd;
				return price;
			default:
				var price = c.a.bd;
				return price;
		}
	};
	var i18n = $author$project$Common$ComponentUI$DetailsResultBox$pickI18N(config);
	var tooltip = function (c) {
		switch (c.$) {
			case 2:
				return $author$project$Common$Render$empty;
			case 0:
				var policy = c.b.k;
				var onTooltipClicked = c.b.b$;
				return A3($author$project$Common$ComponentUI$DetailsResultBox$viewPolicyPriceTooltip, i18n, onTooltipClicked, policy);
			default:
				var policy = c.b.k;
				var onTooltipClicked = c.b.b$;
				return A3($author$project$Common$ComponentUI$DetailsResultBox$viewPolicyPriceTooltip, i18n, onTooltipClicked, policy);
		}
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__policy-price')
			]),
		_List_fromArray(
			[
				tooltip(config),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__policy-price__amount')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__policy-price__amount__integers-text')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Common$Price$toHtmlWithLargeSize,
								i18n,
								priceToShow(config))
							]))
					]))
			]));
};
var $author$project$Translations$detailsRefundPriceAmountLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Refund';
	} else {
		return 'Reembolso';
	}
};
var $author$project$Translations$detailsInterruptionReasonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Reason';
	} else {
		return 'Motivo';
	}
};
var $author$project$Translations$interruptionDissatisfactionDocsRequest = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Dissatisfaction docs request';
	} else {
		return 'Insatisfacción - pedido doc.';
	}
};
var $author$project$Translations$interruptionIncorrectVehicleInfo = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Incorrect vehicle info';
	} else {
		return 'Datos vehículo incorrectos';
	}
};
var $author$project$Translations$interruptionInexactDeclaration = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Inexact declaration';
	} else {
		return 'Agravación de riesgo - SINCO';
	}
};
var $author$project$Translations$interruptionNoReason = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'No reason';
	} else {
		return 'Sin razón';
	}
};
var $author$project$Translations$interruptionRenewalNotProvided = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Renewal not provided';
	} else {
		return 'Renovación no disponible a tiempo';
	}
};
var $author$project$Translations$interruptionRenewalRejected = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Renewal rejected';
	} else {
		return 'Renovación rechazada';
	}
};
var $author$project$Translations$interruptionVehicleScrapped = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Vehicle scrapped';
	} else {
		return 'Vehículo - pérdida total';
	}
};
var $author$project$Common$InterruptionReason$reasonToString = F2(
	function (i18n, reason) {
		switch (reason) {
			case 0:
				return $author$project$Translations$interruptionChargeback(i18n);
			case 1:
				return $author$project$Translations$interruptionCompetitorOffer(i18n);
			case 2:
				return $author$project$Translations$interruptionCoverageChange(i18n);
			case 3:
				return $author$project$Translations$interruptionDeceasedPolicyHolder(i18n);
			case 4:
				return $author$project$Translations$interruptionDissatisfactionDocsRequest(i18n);
			case 5:
				return $author$project$Translations$interruptionDissatisfactionService(i18n);
			case 6:
				return $author$project$Translations$interruptionDoesNotKnow(i18n);
			case 7:
				return $author$project$Translations$interruptionFraud(i18n);
			case 8:
				return $author$project$Translations$interruptionIncorrectDataOther(i18n);
			case 9:
				return $author$project$Translations$interruptionIncorrectEffectiveDate(i18n);
			case 10:
				return $author$project$Translations$interruptionIncorrectPersonalData(i18n);
			case 11:
				return $author$project$Translations$interruptionIncorrectVehicleInfo(i18n);
			case 12:
				return $author$project$Translations$interruptionInexactDeclaration(i18n);
			case 13:
				return $author$project$Translations$interruptionInexactDeclarationDni(i18n);
			case 14:
				return $author$project$Translations$interruptionInexactDeclarationSinco(i18n);
			case 15:
				return $author$project$Translations$interruptionMovingToAnotherCountry(i18n);
			case 16:
				return $author$project$Translations$interruptionNoInsuranceWanted(i18n);
			case 17:
				return $author$project$Translations$interruptionNoReason(i18n);
			case 18:
				return $author$project$Translations$interruptionOther(i18n);
			case 19:
				return $author$project$Translations$interruptionPaymentMethodOrDate(i18n);
			case 20:
				return $author$project$Translations$interruptionPolicyHolderChange(i18n);
			case 21:
				return $author$project$Translations$interruptionProductService(i18n);
			case 22:
				return $author$project$Translations$interruptionRenewalNotProvided(i18n);
			case 23:
				return $author$project$Translations$interruptionRenewalRejected(i18n);
			case 24:
				return $author$project$Translations$interruptionRiskAggravation(i18n);
			case 25:
				return $author$project$Translations$interruptionUnderwritingRules(i18n);
			case 26:
				return $author$project$Translations$interruptionVehicleDeregistration(i18n);
			case 27:
				return $author$project$Translations$interruptionVehicleNotPurchased(i18n);
			case 28:
				return $author$project$Translations$interruptionVehicleScrapped(i18n);
			case 29:
				return $author$project$Translations$interruptionVehicleSold(i18n);
			case 30:
				return $author$project$Translations$interruptionWantsGreenCard(i18n);
			case 31:
				return $author$project$Translations$interruptionPriceIncrease(i18n);
			case 32:
				return $author$project$Translations$interruptionPhotoVericiationNotProvided(i18n);
			default:
				return $author$project$Translations$interruptionSwitchToGreatLakes(i18n);
		}
	});
var $author$project$Common$ComponentUI$DetailsResultBox$formatInterruptionReason = F2(
	function (i18n, interruption) {
		return _Utils_ap(
			A2($author$project$Common$InterruptionReason$reasonToString, i18n, interruption.im),
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				$elm$core$Basics$append(' - '),
				interruption.mN));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewRefundPriceTooltipBlock = F2(
	function (title, value) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('details__refund-tooltip__frame__block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('details__refund-tooltip__frame__block__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('details__refund-tooltip__frame__block__value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(value)
						]))
				]));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewRefundPriceTooltip = F3(
	function (i18n, onClickTooltip, interruption) {
		return A3(
			$author$project$Common$ComponentUI$DetailsResultBox$viewTooltip,
			'refund-price',
			onClickTooltip,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__refund-tooltip__frame')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Common$ComponentUI$DetailsResultBox$viewRefundPriceTooltipBlock,
						$author$project$Translations$detailsInterruptionReasonLabel(i18n),
						A2($author$project$Common$ComponentUI$DetailsResultBox$formatInterruptionReason, i18n, interruption))
					])));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewPriceForCompletedRefund = F4(
	function (i18n, onClickTooltip, interruption, refund) {
		var status = refund.b;
		if (status === 2) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__block')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__refund-price')
							]),
						_List_fromArray(
							[
								A3($author$project$Common$ComponentUI$DetailsResultBox$viewRefundPriceTooltip, i18n, onClickTooltip, interruption),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__refund-price__amount')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__refund-price__amount__label')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$detailsRefundPriceAmountLabel(i18n))
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__refund-price__amount__value')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Common$Price$toHtmlWithSmallSize,
												i18n,
												$author$project$Common$Refund$pickPrice(refund))
											]))
									]))
							]))
					]));
		} else {
			return $author$project$Common$Render$empty;
		}
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewRefundPrice = function (config) {
	if (config.$ === 1) {
		var i18n = config.a.ni;
		var onTooltipClicked = config.b.b$;
		var interruption = config.c.cV;
		var refundResult = config.c.ds;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Common$Render$empty,
			A2(
				$elm$core$Maybe$map,
				A3($author$project$Common$ComponentUI$DetailsResultBox$viewPriceForCompletedRefund, i18n, onTooltipClicked, interruption),
				$krisajenkins$remotedata$RemoteData$toMaybe(refundResult)));
	} else {
		return $author$project$Common$Render$empty;
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$viewHighlightRow = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('details__highlight-row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('align-items-flex-start display-flex flex-direction-column')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('details__highlight-row__left-side__offer-text')
							]),
						A2(
							$author$project$Common$ComponentUI$DetailsResultBox$renderSourceInfo,
							config,
							$author$project$Common$ComponentUI$DetailsResultBox$fetchSource(config))),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('align-items-baseline gap-3xs display-flex flex-direction-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('details__highlight-row__left-side__cfid-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Common$ComponentUI$DetailsResultBox$highlightRowValue(config))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('details__highlight-row__left-side__issuing-company-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										'(' + ($author$project$Common$ComponentUI$DetailsResultBox$issuingCompanyValue(config) + ')'))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__highlight-row__right-side')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('details__highlight-row__right-side__main')
							]),
						_List_fromArray(
							[
								$author$project$Common$ComponentUI$DetailsResultBox$viewRefundPrice(config),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__block')
									]),
								_List_fromArray(
									[
										$author$project$Common$ComponentUI$DetailsResultBox$viewPolicyPrice(config)
									])),
								$author$project$Common$ComponentUI$DetailsResultBox$highlightRowCTA(config)
							])),
						$author$project$Common$ComponentUI$DetailsResultBox$highlightRowNotes(config)
					]))
			]));
};
var $author$project$Translations$detailsRefundBoxRefundRetrievingErrorFirstLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Sorry, we are unable to access your refund details at this time due to a technical error.';
	} else {
		return 'Lo sentimos, no podemos acceder a los datos del reembolso en este momento debido a un error técnico.';
	}
};
var $author$project$Translations$detailsRefundBoxRefundRetrievingErrorSecondLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please wait a few minutes and refresh the page to try again.';
	} else {
		return 'Espera unos minutos y actualiza la página para intentarlo nuevamente.';
	}
};
var $author$project$Translations$detailsRefundBoxLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Refund management';
	} else {
		return 'Gestión de reembolsos';
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$refundBox = F2(
	function (i18n, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('details__refund-box details__box')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('details__refund-box__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$detailsRefundBoxLabel(i18n))
						])),
					content
				]));
	});
var $author$project$Pyxis$Components$Icon$Alert = 3;
var $author$project$Pyxis$Components$Icon$alert = A2($author$project$Pyxis$Components$Icon$Boxed, 3, 0);
var $author$project$Translations$detailsReloadButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Reload';
	} else {
		return 'Actualizar';
	}
};
var $author$project$Common$ComponentUI$ErrorBox$render = F3(
	function (i18n, errorMessageList, onRetryButtonClick) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('error-box')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Icon$render(
					A2(
						$author$project$Pyxis$Components$Icon$withStyle,
						$author$project$Pyxis$Components$Icon$alert,
						$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$exclamationTriangle))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('error-box__alert__message')
						]),
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$html$Html$text,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$singleton,
								$elm$html$Html$div(_List_Nil))),
						errorMessageList)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('error-box__retry-button')
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Button$render(
							A2(
								$author$project$Pyxis$Components$Button$withOnClick,
								onRetryButtonClick,
								A2(
									$author$project$Pyxis$Components$Button$withText,
									$author$project$Translations$detailsReloadButton(i18n),
									A2(
										$author$project$Pyxis$Components$Button$withType,
										$author$project$Pyxis$Components$Button$button,
										A2($author$project$Pyxis$Components$Button$withSize, $author$project$Pyxis$Components$Button$sizeM, $author$project$Pyxis$Components$Button$primary)))))
						]))
				]));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$refundBoxFailure = F3(
	function (i18n, policyData, interruptedData) {
		return A2(
			$author$project$Common$ComponentUI$DetailsResultBox$refundBox,
			i18n,
			A3(
				$author$project$Common$ComponentUI$ErrorBox$render,
				i18n,
				_List_fromArray(
					[
						$author$project$Translations$detailsRefundBoxRefundRetrievingErrorFirstLabel(i18n),
						$author$project$Translations$detailsRefundBoxRefundRetrievingErrorSecondLabel(i18n)
					]),
				interruptedData.hO(
					$author$project$Common$Policy$pickId(policyData.k))));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$refundBoxLoading = function (i18n) {
	return A2(
		$author$project$Common$ComponentUI$DetailsResultBox$refundBox,
		i18n,
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('details__refund-box__loading')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Loaders$Loader$render($author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM)
				])));
};
var $author$project$Translations$detailsRefundBoxNotAskedLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please manage the refund manually.';
	} else {
		return 'Gestione el reembolso manualmente.';
	}
};
var $author$project$Pyxis$Components$Icon$Neutral = 0;
var $author$project$Pyxis$Components$Icon$neutral = A2($author$project$Pyxis$Components$Icon$Boxed, 0, 0);
var $author$project$Common$ComponentUI$DetailsResultBox$refundBoxNotAsked = function (i18n) {
	return A2(
		$author$project$Common$ComponentUI$DetailsResultBox$refundBox,
		i18n,
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('details__refund-box__not-asked')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Icon$render(
					A2(
						$author$project$Pyxis$Components$Icon$withStyle,
						$author$project$Pyxis$Components$Icon$neutral,
						A2(
							$author$project$Pyxis$Components$Icon$withSize,
							$author$project$Pyxis$Components$Icon$sizeL,
							$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$infoCircle)))),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('details__refund-box__not-asked__message')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$detailsRefundBoxNotAskedLabel(i18n))
						]))
				])));
};
var $author$project$Translations$detailsRefundButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Refund';
	} else {
		return 'Reembolsar';
	}
};
var $author$project$Common$Refund$isNotRequired = function (_v0) {
	var status = _v0.b;
	return status === 4;
};
var $author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccessButton = F3(
	function (i18n, refund, _v0) {
		var onIssueRefundButtonClicked = _v0.hV;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('details__refund-box__info__refund_button')
				]),
			$elm$core$List$singleton(
				$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withDisabled,
						$author$project$Common$Refund$isNotRequired(refund),
						A2(
							$author$project$Pyxis$Components$Button$withOnClick,
							onIssueRefundButtonClicked(refund),
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$detailsRefundButton(i18n),
								A2(
									$author$project$Pyxis$Components$Button$withType,
									$author$project$Pyxis$Components$Button$button,
									A2($author$project$Pyxis$Components$Button$withSize, $author$project$Pyxis$Components$Button$sizeM, $author$project$Pyxis$Components$Button$primary))))))));
	});
var $author$project$Translations$detailsRefundBoxRefundEstimatedAmountLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Estimated amount';
	} else {
		return 'Reembolso estimado';
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccessDetailsItem = F2(
	function (label, value) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				value,
				A2($author$project$Pyxis$Components$List$withItemTitle, label, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccessDetails = F3(
	function (i18n, refund, _v0) {
		var interruption = _v0.cV;
		return $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withSize,
				$author$project$Pyxis$Components$List$sizeS,
				A2(
					$author$project$Pyxis$Components$List$withEmphasis,
					$author$project$Pyxis$Components$List$emphasisText,
					A2(
						$author$project$Pyxis$Components$List$withOrientation,
						$author$project$Pyxis$Components$List$inline,
						A2(
							$author$project$Pyxis$Components$List$withItems,
							_List_fromArray(
								[
									A2(
									$author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccessDetailsItem,
									$author$project$Translations$detailsRefundBoxRefundEstimatedAmountLabel(i18n),
									A2(
										$author$project$Common$Price$toHtmlWithSmallSize,
										i18n,
										$author$project$Common$Refund$pickPrice(refund))),
									A2(
									$author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccessDetailsItem,
									$author$project$Translations$detailsInterruptionReasonLabel(i18n),
									$elm$html$Html$text(
										A2($author$project$Common$ComponentUI$DetailsResultBox$formatInterruptionReason, i18n, interruption)))
								]),
							$author$project$Pyxis$Components$List$dl)))));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccess = F3(
	function (i18n, refund, interruptionData) {
		return A2(
			$author$project$Common$ComponentUI$DetailsResultBox$refundBox,
			i18n,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__refund-box__info')
					]),
				_List_fromArray(
					[
						A3($author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccessDetails, i18n, refund, interruptionData),
						A3($author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccessButton, i18n, refund, interruptionData)
					])));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$interruptionInfoByRemoteData = F3(
	function (i18n, policyData, interruptionData) {
		var _v0 = interruptionData.ds;
		switch (_v0.$) {
			case 0:
				return $author$project$Common$ComponentUI$DetailsResultBox$refundBoxNotAsked(i18n);
			case 1:
				return $author$project$Common$ComponentUI$DetailsResultBox$refundBoxLoading(i18n);
			case 2:
				return A3($author$project$Common$ComponentUI$DetailsResultBox$refundBoxFailure, i18n, policyData, interruptionData);
			default:
				switch (_v0.a.b) {
					case 0:
						var refund = _v0.a;
						var _v1 = refund.b;
						return A3($author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccess, i18n, refund, interruptionData);
					case 1:
						var refund = _v0.a;
						var _v2 = refund.b;
						return A3($author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccess, i18n, refund, interruptionData);
					case 4:
						var refund = _v0.a;
						var _v3 = refund.b;
						return A3($author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccess, i18n, refund, interruptionData);
					case 3:
						var refund = _v0.a;
						var _v4 = refund.b;
						return A3($author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccess, i18n, refund, interruptionData);
					default:
						return $author$project$Common$Render$empty;
				}
		}
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewInterruptionInfo = function (config) {
	if (config.$ === 1) {
		var i18n = config.a.ni;
		var policyData = config.b;
		var interruptionData = config.c;
		return A3($author$project$Common$ComponentUI$DetailsResultBox$interruptionInfoByRemoteData, i18n, policyData, interruptionData);
	} else {
		return $author$project$Common$Render$empty;
	}
};
var $author$project$Common$User$hasPermission = F2(
	function (user, permission) {
		if (!user.$) {
			return false;
		} else {
			var permissions = user.a.de;
			return A2($elm$core$List$member, permission, permissions);
		}
	});
var $author$project$Common$User$hasInterruptPolicyPermission = function (user) {
	return A2($author$project$Common$User$hasPermission, user, 'policy:cancel');
};
var $author$project$Common$Policy$pickLastWithdrawableDay = function (_v0) {
	var policy = _v0;
	return policy.c0;
};
var $author$project$Translations$policyCoolingOffPeriodEndDateMessage = F3(
	function (data, bAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					$elm$html$Html$text('Customer can withdraw from the contract until '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(data.mE + (' of ' + data.mD))
						]))
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('El cliente puede desistir del contrato hasta las ' + (data.mE + (' del día ' + data.mD)))
				]);
		}
	});
var $author$project$Translations$policyDoesNotRenewAction = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Deactivate automatic renewal';
	} else {
		return 'Desactiva la renovación automática';
	}
};
var $author$project$Pyxis$Tokens$TypographyColor$Action = 0;
var $author$project$Pyxis$Tokens$TypographyColor$tokenAction = 0;
var $author$project$Common$ComponentUI$DetailsResultBox$autoRenewalContent = F4(
	function (i18n, user, policy, detailsResultInterruptableData) {
		var withdrawMessage = function (lastWithdrawableDay) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__interruptions-row__cooling-off-period-message')
					]),
				A3(
					$author$project$Translations$policyCoolingOffPeriodEndDateMessage,
					{
						mD: $author$project$Common$Locale$formatDate(lastWithdrawableDay),
						mE: '23:59'
					},
					_List_Nil,
					i18n));
		};
		var renewalCanBeCancelled = $author$project$Common$User$hasInterruptPolicyPermission(user) && detailsResultInterruptableData.jm;
		var containerClass = 'details__interruptions-row__automatic-renewal';
		var cancelAutoRenewal = $author$project$Pyxis$Components$Text$render(
			A2(
				$author$project$Pyxis$Components$Text$withColor,
				$author$project$Pyxis$Tokens$TypographyColor$tokenAction,
				A2(
					$author$project$Pyxis$Components$Text$withFontWeight,
					$author$project$Pyxis$Tokens$FontWeight$tokenBold,
					A2(
						$author$project$Pyxis$Components$Text$withSize,
						$author$project$Pyxis$Tokens$TextSize$tokenM,
						$author$project$Pyxis$Components$Text$config(
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('does-not-renew-action'),
										$elm$html$Html$Events$onClick(
										detailsResultInterruptableData.k3(policy))
									]),
								$elm$core$List$singleton(
									$elm$html$Html$text(
										$author$project$Translations$policyDoesNotRenewAction(i18n)))))))));
		var _v0 = _Utils_Tuple2(
			$author$project$Common$Policy$pickLastWithdrawableDay(policy),
			renewalCanBeCancelled);
		if (!_v0.a.$) {
			if (_v0.b) {
				var lastWithdrawableDay = _v0.a.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(containerClass)
						]),
					_List_fromArray(
						[
							withdrawMessage(lastWithdrawableDay),
							cancelAutoRenewal
						]));
			} else {
				var lastWithdrawableDay = _v0.a.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(containerClass)
						]),
					_List_fromArray(
						[
							withdrawMessage(lastWithdrawableDay)
						]));
			}
		} else {
			if (_v0.b) {
				var _v1 = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(containerClass)
						]),
					_List_fromArray(
						[cancelAutoRenewal]));
			} else {
				var _v2 = _v0.a;
				return $author$project$Common$Render$empty;
			}
		}
	});
var $author$project$Common$ComponentUI$DetailsResultBox$TerminateByCustomer = 1;
var $author$project$Common$ComponentUI$DetailsResultBox$TerminateByPrima = 2;
var $author$project$Common$ComponentUI$DetailsResultBox$Withdraw = 0;
var $author$project$Common$ComponentUI$DetailsResultBox$interruptableActions = function (_v0) {
	var canBeWithdrawn = _v0.jl;
	var canBeTerminatedByCustomer = _v0.jj;
	var canBeTerminatedByPrima = _v0.jk;
	var _v1 = _Utils_Tuple3(canBeWithdrawn, canBeTerminatedByCustomer, canBeTerminatedByPrima);
	if (_v1.a) {
		if (!_v1.c) {
			return _List_fromArray(
				[0]);
		} else {
			return _List_fromArray(
				[0, 2]);
		}
	} else {
		if (_v1.b) {
			if (!_v1.c) {
				return _List_fromArray(
					[1]);
			} else {
				return _List_fromArray(
					[1, 2]);
			}
		} else {
			if (_v1.c) {
				return _List_fromArray(
					[2]);
			} else {
				return _List_Nil;
			}
		}
	}
};
var $author$project$Translations$policyCustomerCancellationButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Customer cancels';
	} else {
		return 'Cliente cancela';
	}
};
var $author$project$Translations$policyPrimaCancellationButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Prima cancels';
	} else {
		return 'Prima cancela';
	}
};
var $author$project$Translations$policyWithdrawButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Withdraw';
	} else {
		return 'Desistimiento';
	}
};
var $author$project$Pyxis$Components$Button$Tertiary = 2;
var $author$project$Pyxis$Components$Button$tertiary = $author$project$Pyxis$Components$Button$config(2);
var $author$project$Common$ComponentUI$DetailsResultBox$renderButton = F3(
	function (label, id, action) {
		return $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withTestId,
				id,
				A2(
					$author$project$Pyxis$Components$Button$withId,
					id,
					A2(
						$author$project$Pyxis$Components$Button$withText,
						label,
						A2(
							$author$project$Pyxis$Components$Button$withOnClick,
							action,
							$author$project$Pyxis$Components$Button$sizeM(
								A2($author$project$Pyxis$Components$Button$withType, $author$project$Pyxis$Components$Button$button, $author$project$Pyxis$Components$Button$tertiary)))))));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$renderInterruptionButton = F3(
	function (i18n, onInterruptionButtonPressed, action) {
		var _v0 = function () {
			switch (action) {
				case 0:
					return {
						kg: 'withdraw',
						eF: 0,
						eR: $author$project$Translations$policyWithdrawButton(i18n)
					};
				case 1:
					return {
						kg: 'interruption',
						eF: 1,
						eR: $author$project$Translations$policyCustomerCancellationButton(i18n)
					};
				default:
					return {
						kg: 'prima-interruption',
						eF: 2,
						eR: $author$project$Translations$policyPrimaCancellationButton(i18n)
					};
			}
		}();
		var interruptionKind = _v0.eF;
		var label = _v0.eR;
		var id = _v0.kg;
		return A3(
			$author$project$Common$ComponentUI$DetailsResultBox$renderButton,
			label,
			id,
			onInterruptionButtonPressed(interruptionKind));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$renderInterruptionButtons = F2(
	function (i18n, _v0) {
		var interruptionStatus = _v0.ko;
		var onInterruptionButtonClicked = _v0.kS;
		return A2(
			$elm$core$List$map,
			A2($author$project$Common$ComponentUI$DetailsResultBox$renderInterruptionButton, i18n, onInterruptionButtonClicked),
			$author$project$Common$ComponentUI$DetailsResultBox$interruptableActions(interruptionStatus));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewInterruptionButtons = F2(
	function (i18n, detailsResultInterruptableData) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('display-flex align-self-flex-end details__interruptions-row__ctas-group')
				]),
			A2($author$project$Common$ComponentUI$DetailsResultBox$renderInterruptionButtons, i18n, detailsResultInterruptableData));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewInterruptionsRow = function (config) {
	switch (config.$) {
		case 2:
			return $author$project$Common$Render$empty;
		case 1:
			return $author$project$Common$Render$empty;
		default:
			var i18n = config.a.ni;
			var policy = config.b.k;
			var detailsResultInterruptableData = config.c;
			var user = config.d;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__interruptions-row')
					]),
				_List_fromArray(
					[
						A4($author$project$Common$ComponentUI$DetailsResultBox$autoRenewalContent, i18n, user, policy, detailsResultInterruptableData),
						A2(
						$author$project$Common$Render$when,
						$author$project$Common$User$hasInterruptPolicyPermission(user),
						A2($author$project$Common$ComponentUI$DetailsResultBox$viewInterruptionButtons, i18n, detailsResultInterruptableData))
					]));
	}
};
var $author$project$Common$Policy$pickRenewalCancellation = function (_v0) {
	var policy = _v0;
	return policy.iq;
};
var $author$project$Common$Policy$pickStatus = function (_v0) {
	var policy = _v0;
	return policy.dx;
};
var $author$project$Translations$detailsRenewalCancellationForActivePolicyMessage = F3(
	function (renewalCancellationReason, bAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					$elm$html$Html$text('This policy will not be renewed due to a customer request. The reason for the renewal’s cancellation is: '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(renewalCancellationReason)
						])),
					$elm$html$Html$text('.')
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('Esta póliza no se renovará porque el cliente así lo ha solicitado. El motivo por el cual se cancela la renovación es: '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(renewalCancellationReason)
						])),
					$elm$html$Html$text('.')
				]);
		}
	});
var $author$project$Translations$detailsRenewalCancellationForNotRenewedPolicyMessage = F3(
	function (renewalCancellationReason, bAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					$elm$html$Html$text('The reason for the renewal’s cancellation is: '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(renewalCancellationReason)
						])),
					$elm$html$Html$text('.')
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('El motivo por el cual se cancela la renovación es: '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(renewalCancellationReason)
						])),
					$elm$html$Html$text('.')
				]);
		}
	});
var $author$project$Common$ComponentUI$DetailsResultBox$renewalCancellationMessageContent = F3(
	function (i18n, policyStatus, renewalCancellation) {
		if (policyStatus === 1) {
			return A3(
				$author$project$Translations$detailsRenewalCancellationForActivePolicyMessage,
				A2($author$project$Common$InterruptionReason$reasonToString, i18n, renewalCancellation.im),
				_List_Nil,
				i18n);
		} else {
			return A3(
				$author$project$Translations$detailsRenewalCancellationForNotRenewedPolicyMessage,
				A2($author$project$Common$InterruptionReason$reasonToString, i18n, renewalCancellation.im),
				_List_Nil,
				i18n);
		}
	});
var $author$project$Common$ComponentUI$DetailsResultBox$renewalsCancellationMessage = F3(
	function (i18n, policyStatus, renewalCancellation) {
		return $author$project$Pyxis$Components$Message$render(
			A2(
				$author$project$Pyxis$Components$Message$withContent,
				A3($author$project$Common$ComponentUI$DetailsResultBox$renewalCancellationMessageContent, i18n, policyStatus, renewalCancellation),
				$author$project$Pyxis$Components$Message$neutral($author$project$Pyxis$Components$Message$surfaceStrongBackground)));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewRenewalsCancellationInfoBox = function (config) {
	if (!config.$) {
		var i18n = config.a.ni;
		var policy = config.b.k;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Common$Render$empty,
			A2(
				$elm$core$Maybe$map,
				A2(
					$author$project$Common$ComponentUI$DetailsResultBox$renewalsCancellationMessage,
					i18n,
					$author$project$Common$Policy$pickStatus(policy)),
				$author$project$Common$Policy$pickRenewalCancellation(policy)));
	} else {
		return $author$project$Common$Render$empty;
	}
};
var $author$project$Common$Policy$pickRenewalPolicyId = function (_v0) {
	var policy = _v0;
	return policy.ir;
};
var $author$project$Translations$detailsRenewalsReminderLink = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'here';
	} else {
		return 'aquí';
	}
};
var $author$project$Translations$detailsRenewalsReminderMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Check if the client has a renewed policy and if he wants to cancel it as well. You can find the details of the other policy';
	} else {
		return 'Verifica si el cliente tiene una póliza renovada y si desea cancelarla también. Puedes consultar los datos de la otra póliza';
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$reminderMessage = F3(
	function (i18n, onRenewalsLinkClicked, renewlPolicyId) {
		return $author$project$Pyxis$Components$Message$render(
			A2(
				$author$project$Pyxis$Components$Message$withContent,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$detailsRenewalsReminderMessage(i18n)),
						$elm$html$Html$text(' '),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__link'),
								$elm$html$Html$Events$onClick(
								onRenewalsLinkClicked(renewlPolicyId))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$detailsRenewalsReminderLink(i18n))
							])),
						$elm$html$Html$text('.')
					]),
				$author$project$Pyxis$Components$Message$alert($author$project$Pyxis$Components$Message$tintBackground)));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewRenewalsReminderInfoBox = function (config) {
	if (config.$ === 1) {
		var i18n = config.a.ni;
		var policy = config.b.k;
		var onRenewalsLinkClicked = config.c.b_;
		return A2(
			$author$project$Common$Render$maybe,
			A2($author$project$Common$ComponentUI$DetailsResultBox$reminderMessage, i18n, onRenewalsLinkClicked),
			$author$project$Common$Policy$pickRenewalPolicyId(policy));
	} else {
		return $author$project$Common$Render$empty;
	}
};
var $author$project$Common$Offer$pickVehicle = function (_v0) {
	var offer = _v0;
	return offer.i$;
};
var $author$project$Common$Policy$pickVehicle = function (_v0) {
	var policy = _v0;
	return policy.i$;
};
var $author$project$Common$ComponentUI$DetailsResultBox$extractVehicleInfo = F2(
	function (pickerFunction, config) {
		switch (config.$) {
			case 0:
				var policy = config.b.k;
				return pickerFunction(
					$author$project$Common$Policy$pickVehicle(policy));
			case 1:
				var policy = config.b.k;
				return pickerFunction(
					$author$project$Common$Policy$pickVehicle(policy));
			default:
				var offer = config.b.F;
				return pickerFunction(
					$author$project$Common$Offer$pickVehicle(offer));
		}
	});
var $author$project$Common$ComponentUI$DetailsResultBox$renderVehicleInfo = function (config) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Common$ComponentUI$DetailsResultBox$extractVehicleInfo, $author$project$Common$Vehicle$pickPlateNumber, config))
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Common$ComponentUI$DetailsResultBox$extractVehicleInfo, $author$project$Common$Vehicle$pickBrand, config))
				]))
		]);
};
var $author$project$Common$ComponentUI$DetailsResultBox$infoBlock = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('details__status-row__info-block')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Icon$render(
				A2(
					$author$project$Pyxis$Components$Icon$withSize,
					$author$project$Pyxis$Components$Icon$sizeL,
					$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$car))),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pointed-text')
					]),
				$author$project$Common$ComponentUI$DetailsResultBox$renderVehicleInfo(config))
			]));
};
var $author$project$Pyxis$Components$Badge$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{f6: classList});
	});
var $author$project$Common$Refund$renderBadge = function (customClass) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Pyxis$Components$Badge$withClassList(
			_List_fromArray(
				[
					_Utils_Tuple2(customClass, true)
				])),
		$author$project$Pyxis$Components$Badge$render);
};
var $author$project$Pyxis$Components$Badge$Action = 2;
var $author$project$Pyxis$Components$Badge$action = $author$project$Pyxis$Components$Badge$config(2);
var $author$project$Translations$policyRefundStatusCompleted = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Refunded';
	} else {
		return 'Reembolsado';
	}
};
var $author$project$Translations$policyRefundStatusPending = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Ready to refund';
	} else {
		return 'Listo para reembolsar';
	}
};
var $author$project$Common$Refund$statusBadge = F2(
	function (i18n, _v0) {
		var status = _v0.b;
		switch (status) {
			case 0:
				return $elm$core$Maybe$Just(
					A2(
						$author$project$Pyxis$Components$Badge$withText,
						$author$project$Translations$policyRefundStatusPending(i18n),
						$author$project$Pyxis$Components$Badge$action));
			case 2:
				return $elm$core$Maybe$Just(
					A2(
						$author$project$Pyxis$Components$Badge$withText,
						$author$project$Translations$policyRefundStatusCompleted(i18n),
						$author$project$Pyxis$Components$Badge$success));
			case 3:
				return $elm$core$Maybe$Just(
					A2(
						$author$project$Pyxis$Components$Badge$withText,
						$author$project$Translations$policyRefundStatusPending(i18n),
						$author$project$Pyxis$Components$Badge$action));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Common$Refund$renderStatusBadge = F3(
	function (customClass, i18n, refund) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm_community$html_extra$Html$Extra$nothing,
			A2(
				$elm$core$Maybe$map,
				$author$project$Common$Refund$renderBadge(customClass),
				A2($author$project$Common$Refund$statusBadge, i18n, refund)));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$refundBadgeFromRefundData = F2(
	function (i18n, _v0) {
		var refundResult = _v0.ds;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Common$Render$empty,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Common$Refund$renderStatusBadge, 'align-self-flex-start', i18n),
				$krisajenkins$remotedata$RemoteData$toMaybe(refundResult)));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$refundBadge = function (config) {
	if (config.$ === 1) {
		var i18n = config.a.ni;
		var interruptionData = config.c;
		return A2($author$project$Common$ComponentUI$DetailsResultBox$refundBadgeFromRefundData, i18n, interruptionData);
	} else {
		return $author$project$Common$Render$empty;
	}
};
var $author$project$Translations$offerStatusRenewal = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Renewal';
	} else {
		return 'Renovación';
	}
};
var $author$project$Common$Offer$renewalBadge = F2(
	function (customClass, i18n) {
		return $author$project$Pyxis$Components$Badge$render(
			A2(
				$author$project$Pyxis$Components$Badge$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2(customClass, true)
					]),
				A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusRenewal(i18n),
					$author$project$Pyxis$Components$Badge$brand)));
	});
var $author$project$Common$Offer$renderRenewalBadge = F3(
	function (customClass, i18n, offer) {
		return A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			$author$project$Common$Offer$pickIsRenewal(offer),
			A2($author$project$Common$Offer$renewalBadge, customClass, i18n));
	});
var $author$project$Common$Policy$pickIsARenewal = function (_v0) {
	var policy = _v0;
	return policy.gZ;
};
var $author$project$Common$Policy$renewalBadge = F2(
	function (customClass, i18n) {
		return $author$project$Pyxis$Components$Badge$render(
			A2(
				$author$project$Pyxis$Components$Badge$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2(customClass, true)
					]),
				A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusRenewal(i18n),
					$author$project$Pyxis$Components$Badge$brand)));
	});
var $author$project$Common$Policy$renderRenewalBadge = F3(
	function (customClass, i18n, offer) {
		return A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			$author$project$Common$Policy$pickIsARenewal(offer),
			A2($author$project$Common$Policy$renewalBadge, customClass, i18n));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$renewalBadge = function (config) {
	switch (config.$) {
		case 2:
			var i18n = config.a.ni;
			var offer = config.b.F;
			return A3($author$project$Common$Offer$renderRenewalBadge, 'align-self-flex-start', i18n, offer);
		case 0:
			var i18n = config.a.ni;
			var policy = config.b.k;
			return A3($author$project$Common$Policy$renderRenewalBadge, 'align-self-flex-start', i18n, policy);
		default:
			var i18n = config.a.ni;
			var policy = config.b.k;
			return A3($author$project$Common$Policy$renderRenewalBadge, 'align-self-flex-start', i18n, policy);
	}
};
var $author$project$Pyxis$Components$Badge$Alert = 5;
var $author$project$Pyxis$Components$Badge$alert = $author$project$Pyxis$Components$Badge$config(5);
var $author$project$Pyxis$Components$Badge$Error = 3;
var $author$project$Pyxis$Components$Badge$error = $author$project$Pyxis$Components$Badge$config(3);
var $author$project$Pyxis$Components$Badge$Neutral = 0;
var $author$project$Pyxis$Components$Badge$neutral = $author$project$Pyxis$Components$Badge$config(0);
var $author$project$Translations$offerStatusBlocked = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Blocked';
	} else {
		return 'No contratable';
	}
};
var $author$project$Translations$offerStatusExpired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Expired';
	} else {
		return 'Oferta caducada';
	}
};
var $author$project$Translations$offerStatusMissingDocuments = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Missing documents';
	} else {
		return 'Documentos pendientes';
	}
};
var $author$project$Translations$offerStatusNewPrice = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'New price';
	} else {
		return 'Nuevo precio';
	}
};
var $author$project$Translations$offerStatusNewProduct = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'New product';
	} else {
		return 'Nueva modalidad';
	}
};
var $author$project$Translations$offerStatusPurchasable = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Available';
	} else {
		return 'Oferta disponible';
	}
};
var $author$project$Translations$offerStatusPurchased = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Purchased';
	} else {
		return 'Póliza contratada';
	}
};
var $author$project$Translations$offerStatusRequoted = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Requoted';
	} else {
		return 'Cotizado nuevamente';
	}
};
var $author$project$Translations$offerStatusStartDateExpired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Start Date Expired';
	} else {
		return 'Fecha de inicio expirada';
	}
};
var $author$project$Common$Offer$statusBadge = F2(
	function (i18n, _v0) {
		var offer = _v0;
		var _v1 = offer.dx;
		switch (_v1) {
			case 8:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusPurchasable(i18n),
					$author$project$Pyxis$Components$Badge$success);
			case 4:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusExpired(i18n),
					$author$project$Pyxis$Components$Badge$neutral);
			case 3:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusStartDateExpired(i18n),
					$author$project$Pyxis$Components$Badge$alert);
			case 7:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusPurchased(i18n),
					$author$project$Pyxis$Components$Badge$brand);
			case 5:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusBlocked(i18n),
					$author$project$Pyxis$Components$Badge$error);
			case 6:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusRequoted(i18n),
					$author$project$Pyxis$Components$Badge$error);
			case 0:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusNewPrice(i18n),
					$author$project$Pyxis$Components$Badge$success);
			case 1:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusNewProduct(i18n),
					$author$project$Pyxis$Components$Badge$success);
			default:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusMissingDocuments(i18n),
					$author$project$Pyxis$Components$Badge$alert);
		}
	});
var $author$project$Common$Offer$renderStatusBadge = F2(
	function (customClass, i18n) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Common$Offer$statusBadge(i18n),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Badge$withClassList(
					_List_fromArray(
						[
							_Utils_Tuple2(customClass, true)
						])),
				$author$project$Pyxis$Components$Badge$render));
	});
var $author$project$Translations$policyStatusActive = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Active';
	} else {
		return 'Activa';
	}
};
var $author$project$Translations$policyStatusExpired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Expired';
	} else {
		return 'Caducada';
	}
};
var $author$project$Translations$policyStatusGracePeriod = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Grace period';
	} else {
		return 'Periodo de gracia';
	}
};
var $author$project$Translations$policyStatusIssued = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Issued';
	} else {
		return 'Emitida';
	}
};
var $author$project$Translations$policyStatusNotRenewed = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Not renewed';
	} else {
		return 'No renovada';
	}
};
var $author$project$Translations$policyStatusTerminatedByCustomer = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Terminated by customer';
	} else {
		return 'Cliente cancela';
	}
};
var $author$project$Translations$policyStatusTerminatedByPrima = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Terminated by Prima';
	} else {
		return 'Prima cancela';
	}
};
var $author$project$Translations$policyStatusWithdrawn = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Withdrawn';
	} else {
		return 'Cancelada por desistimiento';
	}
};
var $author$project$Common$PolicyStatus$statusBadge = F2(
	function (i18n, status) {
		switch (status) {
			case 0:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$policyStatusIssued(i18n),
					$author$project$Pyxis$Components$Badge$success);
			case 1:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$policyStatusActive(i18n),
					$author$project$Pyxis$Components$Badge$success);
			case 2:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$policyStatusGracePeriod(i18n),
					$author$project$Pyxis$Components$Badge$alert);
			case 3:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$policyStatusExpired(i18n),
					$author$project$Pyxis$Components$Badge$neutral);
			case 4:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$policyStatusNotRenewed(i18n),
					$author$project$Pyxis$Components$Badge$neutral);
			case 5:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$policyStatusWithdrawn(i18n),
					$author$project$Pyxis$Components$Badge$error);
			case 6:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$policyStatusTerminatedByCustomer(i18n),
					$author$project$Pyxis$Components$Badge$error);
			default:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$policyStatusTerminatedByPrima(i18n),
					$author$project$Pyxis$Components$Badge$error);
		}
	});
var $author$project$Common$Policy$statusBadge = F2(
	function (i18n, _v0) {
		var policy = _v0;
		return A2($author$project$Common$PolicyStatus$statusBadge, i18n, policy.dx);
	});
var $author$project$Common$Policy$renderStatusBadge = F2(
	function (customClass, i18n) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Common$Policy$statusBadge(i18n),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Badge$withClassList(
					_List_fromArray(
						[
							_Utils_Tuple2(customClass, true)
						])),
				$author$project$Pyxis$Components$Badge$render));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$statusBadge = function (config) {
	switch (config.$) {
		case 0:
			var i18n = config.a.ni;
			var policy = config.b.k;
			return A3($author$project$Common$Policy$renderStatusBadge, 'align-self-flex-start', i18n, policy);
		case 1:
			var i18n = config.a.ni;
			var policy = config.b.k;
			return A3($author$project$Common$Policy$renderStatusBadge, 'align-self-flex-start', i18n, policy);
		default:
			var i18n = config.a.ni;
			var offer = config.b.F;
			return A3($author$project$Common$Offer$renderStatusBadge, 'align-self-flex-start', i18n, offer);
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$viewStatus = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('details__status-row')
			]),
		_List_fromArray(
			[
				$author$project$Common$ComponentUI$DetailsResultBox$statusBadge(config),
				$author$project$Common$ComponentUI$DetailsResultBox$refundBadge(config),
				$author$project$Common$ComponentUI$DetailsResultBox$renewalBadge(config),
				$author$project$Common$ComponentUI$DetailsResultBox$infoBlock(config)
			]));
};
var $author$project$Common$ComponentUI$DetailsResultBox$view = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('details__result_box details__box')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__result_box__general_info_box')
					]),
				_List_fromArray(
					[
						$author$project$Common$ComponentUI$DetailsResultBox$viewHighlightRow(config),
						$author$project$Common$ComponentUI$DetailsResultBox$horizontalDivider,
						$author$project$Common$ComponentUI$DetailsResultBox$viewStatus(config),
						$author$project$Common$ComponentUI$DetailsResultBox$viewAmendOfferIfAmendable(config),
						$author$project$Common$ComponentUI$DetailsResultBox$viewRenewalsReminderInfoBox(config),
						$author$project$Common$ComponentUI$DetailsResultBox$viewRenewalsCancellationInfoBox(config),
						$author$project$Common$ComponentUI$DetailsResultBox$viewGeneralInfoRow(config),
						$author$project$Common$ComponentUI$DetailsResultBox$viewInterruptionInfo(config),
						$author$project$Common$ComponentUI$DetailsResultBox$horizontalDivider,
						$author$project$Common$ComponentUI$DetailsResultBox$viewInterruptionsRow(config)
					]))
			]));
};
var $author$project$Common$ComponentUI$DetailsResultBox$viewFromOffer = F5(
	function (i18n, currentDate, actions, offer, isCoverSelectionLoading) {
		return $author$project$Common$ComponentUI$DetailsResultBox$view(
			A5($author$project$Common$ComponentUI$DetailsResultBox$newOfferViewConfiguration, i18n, currentDate, actions, offer, isCoverSelectionLoading));
	});
var $author$project$Page$OfferDetails$Msg$SendEmailModalSubmitted = function (a) {
	return {$: 22, a: a};
};
var $author$project$Page$OfferDetails$Msg$SendOfferEmailCheckBoxChecked = function (a) {
	return {$: 21, a: a};
};
var $author$project$Page$OfferDetails$Msg$ShowSendEmailModal = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pyxis$Components$IconSet$PaperPlane = 68;
var $author$project$Pyxis$Components$IconSet$paperPlane = 68;
var $author$project$Translations$sendOfferEmailsOpenModalButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Send emails';
	} else {
		return 'Enviar emails';
	}
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$renderModalButton = F2(
	function (i18n, showModal) {
		return $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withOnClick,
				showModal(true),
				A2(
					$author$project$Pyxis$Components$Button$withText,
					$author$project$Translations$sendOfferEmailsOpenModalButtonLabel(i18n),
					A2(
						$author$project$Pyxis$Components$Button$withIconPrepend,
						$author$project$Pyxis$Components$IconSet$paperPlane,
						A2($author$project$Pyxis$Components$Button$withSize, $author$project$Pyxis$Components$Button$sizeM, $author$project$Pyxis$Components$Button$tertiary)))));
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$SendNewBusinessOfferEmail = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$CheckboxGroup$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$CheckboxGroup$Default = 2;
var $author$project$Pyxis$Components$Field$CheckboxGroup$OptionList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Field$CheckboxGroup$config = function (name) {
	return {
		fJ: $elm$core$Maybe$Nothing,
		f6: _List_Nil,
		ej: _List_Nil,
		go: false,
		cM: $elm$core$Maybe$Nothing,
		gR: $elm$core$Maybe$Nothing,
		kg: 'id-' + name,
		cY: false,
		eR: $elm$core$Maybe$Nothing,
		c1: 2,
		kF: name,
		dd: $author$project$Pyxis$Components$Field$CheckboxGroup$OptionList(_List_Nil),
		pj: false,
		fv: $elm$core$Maybe$Nothing,
		dQ: $elm$core$Maybe$Nothing
	};
};
var $author$project$Pyxis$Components$Field$CheckboxGroup$OptionCard = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$OptionCard$AddonSizeMType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Field$OptionCard$addonSizeMType = $author$project$Pyxis$Components$Field$OptionCard$AddonSizeMType;
var $author$project$Pyxis$Components$Field$OptionCard$M = 0;
var $author$project$Pyxis$Components$Field$OptionCard$sizeM = 0;
var $author$project$Pyxis$Components$Field$CheckboxGroup$optionCardSizeM = function (_v0) {
	var addon = _v0.mf;
	var text = _v0.pu;
	var title = _v0.iS;
	var value = _v0.pB;
	return {
		mf: A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Field$OptionCard$addonSizeMType, addon),
		bu: $elm$core$Maybe$Nothing,
		go: false,
		is: false,
		aO: $author$project$Pyxis$Components$Field$OptionCard$sizeM,
		pu: text,
		iS: title,
		pB: value
	};
};
var $author$project$Pyxis$Components$Form$FormItem$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Form$FormItem$config = F2(
	function (fieldConfig, field) {
		return {fJ: $elm$core$Maybe$Nothing, f6: _List_Nil, jV: field, jW: fieldConfig, eR: $elm$core$Maybe$Nothing};
	});
var $author$project$Pyxis$Components$Field$Error$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Error$idFromFieldId = function (fieldId) {
	return fieldId + '-error';
};
var $author$project$Pyxis$Components$Field$Error$config = F3(
	function (id, validationResult, showingStrategy) {
		return {
			kg: $author$project$Pyxis$Components$Field$Error$idFromFieldId(id),
			kp: false,
			nr: false,
			cY: false,
			lG: showingStrategy,
			iY: validationResult
		};
	});
var $author$project$Pyxis$Components$Field$Error$withIsBlurred = F2(
	function (isBlurred, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{kp: isBlurred});
	});
var $author$project$Pyxis$Components$Field$Error$withIsDirty = F2(
	function (isDirty, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{nr: isDirty});
	});
var $author$project$Pyxis$Components$Field$Error$withIsSubmitted = F2(
	function (isSubmitted, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{cY: isSubmitted});
	});
var $author$project$Pyxis$Components$Field$Error$buildErrorConfig = F4(
	function (fieldStatus, configuration, validationResult, showingStrategy) {
		return A2(
			$author$project$Pyxis$Components$Field$Error$withIsSubmitted,
			configuration.cY,
			A2(
				$author$project$Pyxis$Components$Field$Error$withIsBlurred,
				fieldStatus.kp,
				A2(
					$author$project$Pyxis$Components$Field$Error$withIsDirty,
					fieldStatus.nr,
					A3($author$project$Pyxis$Components$Field$Error$config, configuration.kg, validationResult, showingStrategy))));
	});
var $author$project$Pyxis$Components$Field$Error$OnBlur = 1;
var $author$project$Pyxis$Components$Field$Error$isOnBlurShowingStrategy = function (strategy) {
	return strategy === 1;
};
var $author$project$Pyxis$Components$Field$Error$OnInput = 0;
var $author$project$Pyxis$Components$Field$Error$isOnInputShowingStrategy = function (strategy) {
	return !strategy;
};
var $author$project$Pyxis$Components$Field$Error$OnSubmit = 2;
var $author$project$Pyxis$Components$Field$Error$isOnSubmitShowingStrategy = function (strategy) {
	return strategy === 2;
};
var $author$project$Pyxis$Commons$ValidationResult$runValidationIf = F3(
	function (shouldRun, value, validation) {
		return shouldRun ? A2(
			$elm$core$Maybe$map,
			function (val) {
				return val(value);
			},
			validation) : $elm$core$Maybe$Nothing;
	});
var $author$project$Pyxis$Commons$Validation$generateValidationResult = F5(
	function (fieldStatus, isSubmitted, value, validation, errorShowingStrategy) {
		return ($author$project$Pyxis$Components$Field$Error$isOnSubmitShowingStrategy(errorShowingStrategy) || isSubmitted) ? A3($author$project$Pyxis$Commons$ValidationResult$runValidationIf, isSubmitted, value, validation) : ($author$project$Pyxis$Components$Field$Error$isOnInputShowingStrategy(errorShowingStrategy) ? A3($author$project$Pyxis$Commons$ValidationResult$runValidationIf, fieldStatus.nr && (!fieldStatus.kp), value, validation) : ($author$project$Pyxis$Components$Field$Error$isOnBlurShowingStrategy(errorShowingStrategy) ? A3($author$project$Pyxis$Commons$ValidationResult$runValidationIf, fieldStatus.kp, value, validation) : $elm$core$Maybe$Nothing));
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$generateErrorConfig = F2(
	function (_v0, _v1) {
		var fieldStatus = _v0.ev;
		var checkedValues = _v0.aA;
		var id = _v1.kg;
		var isSubmitted = _v1.cY;
		var validation = _v1.dQ;
		var errorShowingStrategy = _v1.cM;
		var validationRes = A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Maybe$map,
				A4($author$project$Pyxis$Commons$Validation$generateValidationResult, fieldStatus, isSubmitted, checkedValues, validation),
				errorShowingStrategy));
		return A3(
			$elm$core$Maybe$map2,
			A2(
				$author$project$Pyxis$Components$Field$Error$buildErrorConfig,
				fieldStatus,
				{kg: id, cY: isSubmitted}),
			validationRes,
			errorShowingStrategy);
	});
var $author$project$Pyxis$Commons$ValidationResult$getErrorMessage = function (result) {
	if (!result.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var errorMessage = result.a;
		return $elm$core$Maybe$Just(errorMessage);
	}
};
var $author$project$Pyxis$Components$Field$Error$getErrorIf = F2(
	function (condition, validationResult) {
		return condition ? $author$project$Pyxis$Commons$ValidationResult$getErrorMessage(validationResult) : $elm$core$Maybe$Nothing;
	});
var $author$project$Pyxis$Components$Field$Error$getErrorMessage = F2(
	function (_v0, validationResult) {
		var showingStrategy = _v0.lG;
		var isSubmitted = _v0.cY;
		var isDirty = _v0.nr;
		var isBlurred = _v0.kp;
		switch (showingStrategy) {
			case 0:
				return A2($author$project$Pyxis$Components$Field$Error$getErrorIf, isSubmitted || isDirty, validationResult);
			case 1:
				return A2($author$project$Pyxis$Components$Field$Error$getErrorIf, isSubmitted || isBlurred, validationResult);
			default:
				return A2($author$project$Pyxis$Components$Field$Error$getErrorIf, isSubmitted, validationResult);
		}
	});
var $author$project$Pyxis$Components$Field$Error$isVisible = function (maybeConfig) {
	return $elm_community$maybe_extra$Maybe$Extra$isJust(
		A2(
			$elm$core$Maybe$andThen,
			function (config_) {
				var validationResult = config_.iY;
				return A2($author$project$Pyxis$Components$Field$Error$getErrorMessage, config_, validationResult);
			},
			maybeConfig));
};
var $author$project$Pyxis$Components$Field$Error$idFromFieldIdIfVisible = F2(
	function (error, fieldId) {
		return $author$project$Pyxis$Components$Field$Error$isVisible(error) ? $elm$core$Maybe$Just(
			$author$project$Pyxis$Components$Field$Error$idFromFieldId(fieldId)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Pyxis$Components$Field$Label$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Label$withFor = F2(
	function (_for, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				ex: $elm$core$Maybe$Just(_for)
			});
	});
var $author$project$Pyxis$Components$Field$Label$withId = F2(
	function (id, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				kg: $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Pyxis$Components$Form$FormItem$customizeLabel = function (configData) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Pyxis$Components$Field$Label$withId(configData.kg + '-label'),
		$author$project$Pyxis$Components$Field$Label$withFor(configData.kg));
};
var $author$project$Pyxis$Components$Field$Label$pickShowAsterisk = function (_v0) {
	var showAsteriskOnRequired = _v0.pj;
	return showAsteriskOnRequired;
};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $author$project$Pyxis$Components$Field$Label$getFormLabelSizeClass = function (size) {
	if (!size) {
		return 'form-label--s';
	} else {
		return '';
	}
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$small = _VirtualDom_node('small');
var $author$project$Pyxis$Components$Field$Label$renderSubText = function (subText) {
	return A2(
		$elm$html$Html$small,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-label__sub')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(subText)
			]));
};
var $author$project$Pyxis$Components$Field$Label$wrapperId = $elm$core$Maybe$map(
	A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Basics$append, '-wrapper'));
var $author$project$Pyxis$Components$Field$Label$render = function (_v0) {
	var _for = _v0.ex;
	var classList = _v0.f6;
	var dataAttrList = _v0.ej;
	var id = _v0.kg;
	var testId = _v0.fv;
	var size = _v0.aO;
	var text = _v0.pu;
	var subText = _v0.fo;
	var tooltip = _v0.fy;
	var isHidden = _v0.eI;
	return A2(
		$elm$html$Html$div,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-label-wrapper'),
					$elm$html$Html$Attributes$classList(classList),
					A2(
					$author$project$Pyxis$Commons$Attributes$maybe,
					$author$project$Pyxis$Commons$Attributes$testId,
					$author$project$Pyxis$Components$Field$Label$wrapperId(id))
				])),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('form-label', true),
								_Utils_Tuple2('sr-only', isHidden),
								_Utils_Tuple2(
								$author$project$Pyxis$Components$Field$Label$getFormLabelSizeClass(size),
								true)
							])),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$for, _for),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-label__content')
							]),
						_List_fromArray(
							[
								$author$project$Pyxis$Commons$Render$renderMaybeText(text),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('asterisk'),
										$author$project$Pyxis$Commons$Attributes$ariaHidden(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('*')
									]))
							])),
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Field$Label$renderSubText, subText))
					])),
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2(
					$elm$core$Maybe$map,
					function (tooltipConfig) {
						return A3($author$project$Pyxis$Components$Tooltip$render, tooltipConfig.iM, tooltipConfig.eY, tooltipConfig.jz);
					},
					tooltip))
			]));
};
var $author$project$Pyxis$Components$IconSet$ExclamationCircleFilled = 145;
var $author$project$Pyxis$Components$IconSet$exclamationCircleFilled = 145;
var $author$project$Pyxis$Components$Field$Error$renderError = F2(
	function (id, error) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-item__error-message'),
					$elm$html$Html$Attributes$id(id),
					$author$project$Pyxis$Commons$Attributes$role('alert')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Icon$render(
					A2(
						$author$project$Pyxis$Components$Icon$withSize,
						$author$project$Pyxis$Components$Icon$sizeS,
						$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$exclamationCircleFilled))),
					$elm$html$Html$text(error)
				]));
	});
var $author$project$Pyxis$Components$Field$Error$render = function (config_) {
	var id = config_.kg;
	var validationResult = config_.iY;
	return $author$project$Pyxis$Commons$Render$renderMaybe(
		A2(
			$elm$core$Maybe$map,
			$author$project$Pyxis$Components$Field$Error$renderError(id),
			A2($author$project$Pyxis$Components$Field$Error$getErrorMessage, config_, validationResult)));
};
var $author$project$Pyxis$Components$Field$Hint$render = function (_v0) {
	var id = _v0.kg;
	var message = _v0.nH;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-item__hint'),
				A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(message)
			]));
};
var $author$project$Pyxis$Components$Field$Hint$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Hint$toId = function (fieldId) {
	return fieldId + '-hint';
};
var $author$project$Pyxis$Components$Field$Hint$withFieldId = F2(
	function (fieldId, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				kg: $elm$core$Maybe$Just(
					$author$project$Pyxis$Components$Field$Hint$toId(fieldId))
			});
	});
var $author$project$Pyxis$Components$Form$FormItem$renderErrorOrHint = F3(
	function (id, errorConfig, hintConfig) {
		return $author$project$Pyxis$Components$Field$Error$isVisible(errorConfig) ? $author$project$Pyxis$Commons$Render$renderMaybe(
			A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Field$Error$render, errorConfig)) : $author$project$Pyxis$Commons$Render$renderMaybe(
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Field$Hint$withFieldId(id),
					$author$project$Pyxis$Components$Field$Hint$render),
				hintConfig));
	});
var $author$project$Pyxis$Components$Form$FormItem$render = F2(
	function (error, _v0) {
		var label = _v0.eR;
		var field = _v0.jV;
		var fieldConfig = _v0.jW;
		var additionalContent = _v0.fJ;
		var classList = _v0.f6;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2('form-item', true),
								_Utils_Tuple2(
								'form-item--with-label-asterisk',
								function (showAsteriskOnRequired) {
									return fieldConfig.is && showAsteriskOnRequired;
								}(
									A2(
										$elm$core$Maybe$withDefault,
										false,
										A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Field$Label$pickShowAsterisk, label))))
							]),
						classList))
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Pyxis$Components$Form$FormItem$customizeLabel(fieldConfig),
							$author$project$Pyxis$Components$Field$Label$render),
						label)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-item__wrapper')
						]),
					_List_fromArray(
						[
							field,
							A3($author$project$Pyxis$Components$Form$FormItem$renderErrorOrHint, fieldConfig.kg, error, fieldConfig.gR)
						])),
					$author$project$Pyxis$Commons$Render$renderMaybe(additionalContent)
				]));
	});
var $author$project$Pyxis$Commons$Attributes$ariaDescribedByErrorOrHint = F2(
	function (errorId, hintId) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Pyxis$Commons$Attributes$none,
			A2(
				$elm$core$Maybe$map,
				$author$project$Pyxis$Commons$Attributes$ariaDescribedBy,
				A2($elm_community$maybe_extra$Maybe$Extra$or, errorId, hintId)));
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$getFormCardControlLayoutClass = function (layout) {
	switch (layout) {
		case 2:
			return '';
		case 0:
			return '';
		default:
			return 'form-control-group--column';
	}
};
var $author$project$Pyxis$Components$Field$CheckboxGroup$labelId = function (id) {
	return id + '-label';
};
var $author$project$Pyxis$Components$Field$CheckboxGroup$Option = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$CheckboxGroup$OnBlur = {$: 2};
var $author$project$Pyxis$Components$Field$CheckboxGroup$OnCheck = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$OnFocus = {$: 1};
var $author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$Option = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$config = F4(
	function (onCheck, onFocus, onBlur, value) {
		return {fR: $elm$core$Maybe$Nothing, go: false, kg: $elm$core$Maybe$Nothing, eR: $elm$core$Maybe$Nothing, hH: onBlur, kN: onCheck, hQ: onFocus, is: false, fv: $elm$core$Maybe$Nothing, pB: value};
	});
var $author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$withDisabled = F2(
	function (isDisabled, _v0) {
		var option = _v0;
		return _Utils_update(
			option,
			{go: isDisabled});
	});
var $author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$withLabel = F2(
	function (label, _v0) {
		var option = _v0;
		return _Utils_update(
			option,
			{
				eR: $elm$core$Maybe$Just(label)
			});
	});
var $author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$withRequired = F2(
	function (isRequired, _v0) {
		var option = _v0;
		return _Utils_update(
			option,
			{is: isRequired});
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$mapCheckboxValues = F2(
	function (tagger, _v0) {
		var optionData = _v0;
		return A2(
			$author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$withRequired,
			optionData.is,
			A2(
				$author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$withDisabled,
				optionData.go,
				A2(
					$author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$withLabel,
					optionData.eR,
					A4(
						$author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$config,
						F2(
							function (val, checked) {
								return tagger(
									A2($author$project$Pyxis$Components$Field$CheckboxGroup$OnCheck, val, checked));
							}),
						tagger($author$project$Pyxis$Components$Field$CheckboxGroup$OnFocus),
						tagger($author$project$Pyxis$Components$Field$CheckboxGroup$OnBlur),
						optionData.pB))));
	});
var $author$project$Pyxis$Commons$Attributes$ariaInvalid = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Commons$String$fromBool,
	$elm$html$Html$Attributes$attribute('aria-invalid'));
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$renderAsterisk = function (isToRenderAsterisk) {
	return A2(
		$author$project$Pyxis$Commons$Render$renderIf,
		isToRenderAsterisk,
		A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-control__label-asterisk'),
					$author$project$Pyxis$Commons$Attributes$ariaHidden(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('*')
				])));
};
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$render = F4(
	function (configData, isChecked, hasError, _v0) {
		var disabled = _v0.go;
		var value = _v0.pB;
		var label = _v0.eR;
		var ariaDescribedBy = _v0.fR;
		var required = _v0.is;
		var onBlur = _v0.hH;
		var onFocus = _v0.hQ;
		var onCheck = _v0.kN;
		var testId = _v0.fv;
		var id = _v0.kg;
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-control', true),
							_Utils_Tuple2('form-control-option--error', hasError)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					A2(
						$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
						configData.ej,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('form-control__checkbox', true),
										_Utils_Tuple2('form-control--disabled', disabled || configData.go)
									])),
								$elm$html$Html$Attributes$checked(isChecked),
								$elm$html$Html$Attributes$disabled(disabled || configData.go),
								$elm$html$Html$Attributes$name(configData.kF),
								$elm$html$Html$Attributes$required(required),
								$elm$html$Html$Events$onCheck(
								function (checked) {
									return A2(onCheck, value, checked);
								}),
								$elm$html$Html$Events$onFocus(onFocus),
								$elm$html$Html$Events$onBlur(onBlur),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaDescribedBy, ariaDescribedBy),
								$author$project$Pyxis$Commons$Attributes$ariaInvalid(hasError),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id)
							])),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-control__active-indicator')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-control__text')
						]),
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$text(''),
							label),
							$author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$renderAsterisk(required && configData.pj)
						]))
				]));
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$renderCheckbox = F5(
	function (tagger, configData, checkedValues, hasError, _v0) {
		var optionValues = _v0;
		var isChecked = A2($elm$core$List$member, optionValues.pB, checkedValues);
		return A4(
			$author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$render,
			configData,
			isChecked,
			hasError,
			A2($author$project$Pyxis$Components$Field$CheckboxGroup$mapCheckboxValues, tagger, optionValues));
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$renderOptions = F5(
	function (tagger, configData, errorId, checkedValues, options) {
		var renderer = A4(
			$author$project$Pyxis$Components$Field$CheckboxGroup$renderCheckbox,
			tagger,
			configData,
			checkedValues,
			$elm_community$maybe_extra$Maybe$Extra$isJust(errorId));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-control-group', true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Field$CheckboxGroup$getFormCardControlLayoutClass(configData.c1),
							true)
						])),
					$elm$html$Html$Attributes$id(configData.kg),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, configData.fv),
					A2(
					$author$project$Pyxis$Commons$Attributes$renderIf,
					$elm$core$List$length(options) > 1,
					$author$project$Pyxis$Commons$Attributes$role('group')),
					$author$project$Pyxis$Commons$Attributes$ariaDisabled(configData.go),
					A2(
					$author$project$Pyxis$Commons$Attributes$ariaDescribedByErrorOrHint,
					errorId,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always(
							$author$project$Pyxis$Components$Field$Hint$toId(configData.kg)),
						configData.gR)),
					$author$project$Pyxis$Commons$Attributes$ariaLabelledBy(
					$author$project$Pyxis$Components$Field$CheckboxGroup$labelId(configData.kg))
				]),
			A2($elm$core$List$map, renderer, options));
	});
var $author$project$Pyxis$Components$Field$OptionCard$Config = F5(
	function (name, fieldId, label, groupDisabled, withShowAsteriskOnRequired) {
		return {jX: fieldId, j9: groupDisabled, eR: label, kF: name, i6: withShowAsteriskOnRequired};
	});
var $author$project$Pyxis$Components$Field$OptionCard$config = $author$project$Pyxis$Components$Field$OptionCard$Config;
var $author$project$Pyxis$Components$Field$CheckboxGroup$getFormCardGroupLayoutClass = function (layout) {
	switch (layout) {
		case 2:
			return '';
		case 1:
			return 'form-card-group--column';
		default:
			return 'form-card-group--row';
	}
};
var $author$project$Pyxis$Components$Field$OptionCard$Checkbox = 1;
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Pyxis$Commons$String$toKebabCase = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toLower,
	A2($elm$core$String$replace, ' ', '-'));
var $author$project$Pyxis$Components$Field$OptionCard$generateOptionId = F3(
	function (_v0, _v1, index) {
		var fieldId = _v0.jX;
		var text = _v1.pu;
		var title = _v1.iS;
		return A2(
			$elm$core$String$join,
			'-',
			_List_fromArray(
				[
					fieldId,
					$author$project$Pyxis$Commons$String$toKebabCase(
					A2(
						$elm$core$String$left,
						25,
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$String$fromInt(index),
							A2($elm_community$maybe_extra$Maybe$Extra$or, title, text)))),
					'option'
				]));
	});
var $author$project$Pyxis$Components$Field$OptionCard$getFormCardSizeClass = function (size) {
	if (size === 1) {
		return 'form-card--l';
	} else {
		return '';
	}
};
var $author$project$Pyxis$Components$Field$OptionCard$isAsteriskToShowOnTitle = F2(
	function (showAsteriskOnrequired, required) {
		return showAsteriskOnrequired && required;
	});
var $author$project$Pyxis$Components$Field$OptionCard$isToAshowAsteriskOnText = F3(
	function (showAsteriskOnrequired, required, title) {
		return showAsteriskOnrequired && (required && (!$elm_community$maybe_extra$Maybe$Extra$isJust(title)));
	});
var $author$project$Pyxis$Components$Field$OptionCard$renderContent = F3(
	function (identifier, showAsterisk, str) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-card__' + identifier)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(str),
					A2(
					$author$project$Pyxis$Commons$Render$renderIf,
					showAsterisk,
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-control__label-asterisk'),
								$author$project$Pyxis$Commons$Attributes$ariaHidden(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('*')
							])))
				]));
	});
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $author$project$Pyxis$Components$Field$OptionCard$renderSizeLargePrependAddon = function (_v0) {
	var url = _v0;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-card__addon')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(url),
						$elm$html$Html$Attributes$width(72),
						$elm$html$Html$Attributes$height(72),
						$elm$html$Html$Attributes$alt(''),
						$author$project$Pyxis$Commons$Attributes$ariaHidden(true)
					]),
				_List_Nil)
			]));
};
var $author$project$Pyxis$Components$Field$OptionCard$renderSizeMediumPrependAddon = function (_v0) {
	var icon = _v0;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-card__addon form-card__addon--with-icon'),
				$author$project$Pyxis$Commons$Attributes$testId(
				$author$project$Pyxis$Components$IconSet$toLabel(icon))
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Icon$render(
				A2(
					$author$project$Pyxis$Components$Icon$withSize,
					$author$project$Pyxis$Components$Icon$sizeM,
					$author$project$Pyxis$Components$Icon$config(icon)))
			]));
};
var $author$project$Pyxis$Components$Field$OptionCard$renderPrependAddon = function (addon) {
	if (!addon.$) {
		var addonSizeM = addon.a;
		return $author$project$Pyxis$Components$Field$OptionCard$renderSizeMediumPrependAddon(addonSizeM);
	} else {
		var addonSizeL = addon.a;
		return $author$project$Pyxis$Components$Field$OptionCard$renderSizeLargePrependAddon(addonSizeL);
	}
};
var $author$project$Pyxis$Components$Field$OptionCard$toType = function (type_) {
	if (!type_) {
		return 'radio';
	} else {
		return 'checkbox';
	}
};
var $author$project$Pyxis$Components$Field$OptionCard$render = F6(
	function (type_, hasError, attributes, configData, index, option) {
		var name = configData.kF;
		var groupDisabled = configData.j9;
		var id = A3($author$project$Pyxis$Components$Field$OptionCard$generateOptionId, configData, option, index);
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-card', true),
							_Utils_Tuple2(
							'form-card--with-badge',
							$elm_community$maybe_extra$Maybe$Extra$isJust(option.bu)),
							_Utils_Tuple2('form-card--error', hasError),
							_Utils_Tuple2('form-card--checked', option.nq),
							_Utils_Tuple2('form-card--disabled', option.go || groupDisabled),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Field$OptionCard$getFormCardSizeClass(option.aO),
							true)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Pyxis$Commons$Render$maybeMapRender, $author$project$Pyxis$Components$Badge$render, option.bu),
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Field$OptionCard$renderPrependAddon, option.mf)),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-card__content-wrapper')
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Render$renderMaybe(
							A2(
								$elm$core$Maybe$map,
								A2(
									$author$project$Pyxis$Components$Field$OptionCard$renderContent,
									'title',
									A2($author$project$Pyxis$Components$Field$OptionCard$isAsteriskToShowOnTitle, configData.i6, option.is)),
								option.iS)),
							$author$project$Pyxis$Commons$Render$renderMaybe(
							A2(
								$elm$core$Maybe$map,
								A2(
									$author$project$Pyxis$Components$Field$OptionCard$renderContent,
									'text',
									A3($author$project$Pyxis$Components$Field$OptionCard$isToAshowAsteriskOnText, configData.i6, option.is, option.iS)),
								option.pu))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-card__input')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							A2(
								$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
								attributes,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_(
										$author$project$Pyxis$Components$Field$OptionCard$toType(type_)),
										$elm$html$Html$Attributes$class(
										'form-control__' + $author$project$Pyxis$Components$Field$OptionCard$toType(type_)),
										$elm$html$Html$Attributes$checked(option.nq),
										$elm$html$Html$Attributes$disabled(option.go || groupDisabled),
										$elm$html$Html$Attributes$id(id),
										$elm$html$Html$Attributes$required(option.is),
										$author$project$Pyxis$Commons$Attributes$testId(id),
										$elm$html$Html$Attributes$name(name),
										$elm$html$Html$Events$onCheck(option.kN),
										$elm$html$Html$Events$onFocus(option.hQ),
										$elm$html$Html$Events$onBlur(option.hH)
									])),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-control__active-indicator')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Pyxis$Components$Field$OptionCard$renderCheckbox = $author$project$Pyxis$Components$Field$OptionCard$render(1);
var $author$project$Pyxis$Components$Field$CheckboxGroup$renderOptionsCard = F3(
	function (_v0, errorId, options) {
		var name = _v0.kF;
		var layout = _v0.c1;
		var id = _v0.kg;
		var disabled = _v0.go;
		var hint = _v0.gR;
		var testId = _v0.fv;
		var dataAttrList = _v0.ej;
		var showAsteriskOnRequired = _v0.pj;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-card-group', true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Field$CheckboxGroup$getFormCardGroupLayoutClass(layout),
							true)
						])),
					$elm$html$Html$Attributes$id(id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
					$author$project$Pyxis$Commons$Attributes$role('group'),
					$author$project$Pyxis$Commons$Attributes$ariaLabelledBy(
					$author$project$Pyxis$Components$Field$CheckboxGroup$labelId(id)),
					$author$project$Pyxis$Commons$Attributes$ariaDisabled(disabled),
					A2(
					$author$project$Pyxis$Commons$Attributes$ariaDescribedByErrorOrHint,
					errorId,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always(
							$author$project$Pyxis$Components$Field$Hint$toId(id)),
						hint))
				]),
			A2(
				$elm$core$List$indexedMap,
				A3(
					$author$project$Pyxis$Components$Field$OptionCard$renderCheckbox,
					$elm_community$maybe_extra$Maybe$Extra$isJust(errorId),
					dataAttrList,
					A5($author$project$Pyxis$Components$Field$OptionCard$config, name, id, $elm$core$Maybe$Nothing, disabled, showAsteriskOnRequired)),
				options));
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$toInternal = F3(
	function (tagger, checkedValues, _v0) {
		var addon = _v0.mf;
		var text = _v0.pu;
		var title = _v0.iS;
		var value = _v0.pB;
		var size = _v0.aO;
		var disabled = _v0.go;
		var required = _v0.is;
		var badge = _v0.bu;
		var isChecked = A2($elm$core$List$member, value, checkedValues);
		return {
			mf: addon,
			bu: badge,
			go: disabled,
			nq: isChecked,
			hH: tagger($author$project$Pyxis$Components$Field$CheckboxGroup$OnBlur),
			kN: A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Field$CheckboxGroup$OnCheck(value),
				tagger),
			hQ: tagger($author$project$Pyxis$Components$Field$CheckboxGroup$OnFocus),
			is: required,
			aO: size,
			pu: text,
			iS: title,
			pB: value
		};
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$renderControlGroup = F5(
	function (tagger, configData, errorId, checkedValues, options) {
		if (!options.$) {
			var optionSimples = options.a;
			return A5($author$project$Pyxis$Components$Field$CheckboxGroup$renderOptions, tagger, configData, errorId, checkedValues, optionSimples);
		} else {
			var optionsCard = options.a;
			return A3(
				$author$project$Pyxis$Components$Field$CheckboxGroup$renderOptionsCard,
				configData,
				errorId,
				A2(
					$elm$core$List$map,
					A2($author$project$Pyxis$Components$Field$CheckboxGroup$toInternal, tagger, checkedValues),
					optionsCard));
		}
	});
var $author$project$Pyxis$Components$Form$FormItem$withAdditionalContent = F2(
	function (additionalContent, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{fJ: additionalContent});
	});
var $author$project$Pyxis$Components$Form$FormItem$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{f6: classList});
	});
var $author$project$Pyxis$Components$Form$FormItem$withLabel = F2(
	function (label, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{eR: label});
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$render = F3(
	function (tagger, model, config_) {
		var checkedValues = model.aA;
		var configData = config_;
		var error = A2($author$project$Pyxis$Components$Field$CheckboxGroup$generateErrorConfig, model, config_);
		return A2(
			$author$project$Pyxis$Components$Form$FormItem$render,
			error,
			A2(
				$author$project$Pyxis$Components$Form$FormItem$withAdditionalContent,
				configData.fJ,
				A2(
					$author$project$Pyxis$Components$Form$FormItem$withClassList,
					configData.f6,
					A2(
						$author$project$Pyxis$Components$Form$FormItem$withLabel,
						configData.eR,
						A2(
							$author$project$Pyxis$Components$Form$FormItem$config,
							{gR: configData.gR, kg: configData.kg, is: false},
							A5(
								$author$project$Pyxis$Components$Field$CheckboxGroup$renderControlGroup,
								tagger,
								configData,
								A2($author$project$Pyxis$Components$Field$Error$idFromFieldIdIfVisible, error, configData.kg),
								checkedValues,
								configData.dd))))));
	});
var $author$project$Translations$sendOfferEmailsOfferCheckbox = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Email offer';
	} else {
		return 'Email de la oferta';
	}
};
var $author$project$Translations$sendOfferEmailsSelectionError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'You need to select an email';
	} else {
		return 'Debes seleccionar un email';
	}
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$validation = F2(
	function (i18n, selected) {
		if (!selected.b) {
			return $elm$core$Result$Err(
				$author$project$Translations$sendOfferEmailsSelectionError(i18n));
		} else {
			return $elm$core$Result$Ok(selected);
		}
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$OptionCardList = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pyxis$Components$Field$CheckboxGroup$withOptionsCard = F2(
	function (options, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				dd: $author$project$Pyxis$Components$Field$CheckboxGroup$OptionCardList(options)
			});
	});
var $author$project$Pyxis$Commons$ValidationResult$Invalid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pyxis$Commons$ValidationResult$Valid = {$: 0};
var $author$project$Pyxis$Commons$ValidationResult$fromResult = function (result) {
	if (!result.$) {
		return $author$project$Pyxis$Commons$ValidationResult$Valid;
	} else {
		var error = result.a;
		return $author$project$Pyxis$Commons$ValidationResult$Invalid(error);
	}
};
var $author$project$Pyxis$Components$Field$Error$onSubmit = 2;
var $author$project$Pyxis$Components$Field$CheckboxGroup$withValidationOnSubmit = F3(
	function (validation, isSubmitted, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				cM: $elm$core$Maybe$Just($author$project$Pyxis$Components$Field$Error$onSubmit),
				cY: isSubmitted,
				dQ: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeR, validation, $author$project$Pyxis$Commons$ValidationResult$fromResult))
			});
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$checkboxGroup = F4(
	function (i18n, onCheckBoxChange, offer, model) {
		return A3(
			$author$project$Pyxis$Components$Field$CheckboxGroup$render,
			onCheckBoxChange,
			model.cd,
			A2(
				$author$project$Pyxis$Components$Field$CheckboxGroup$withOptionsCard,
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Field$CheckboxGroup$optionCardSizeM(
						{
							mf: $elm$core$Maybe$Nothing,
							pu: $elm$core$Maybe$Nothing,
							iS: $elm$core$Maybe$Just(
								$author$project$Translations$sendOfferEmailsOfferCheckbox(i18n)),
							pB: $author$project$Common$Offer$pickId(offer)
						})
					]),
				A3(
					$author$project$Pyxis$Components$Field$CheckboxGroup$withValidationOnSubmit,
					$author$project$Common$ComponentUI$Modal$SendOfferEmail$validation(i18n),
					model.g4,
					$author$project$Pyxis$Components$Field$CheckboxGroup$config('checkbox-name'))));
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$emailAddressText = function (email) {
	return $author$project$Pyxis$Components$Text$render(
		A2(
			$author$project$Pyxis$Components$Text$withFontWeight,
			$author$project$Pyxis$Tokens$FontWeight$tokenBold,
			A2(
				$author$project$Pyxis$Components$Text$withSize,
				$author$project$Pyxis$Tokens$TextSize$tokenL,
				$author$project$Pyxis$Components$Text$config(
					$elm$html$Html$text(email)))));
};
var $author$project$Translations$sendOfferEmailsReceiver = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Emails will be sent to';
	} else {
		return 'El email se enviará a';
	}
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$senderReceiverText = function (i18n) {
	return $author$project$Pyxis$Components$Text$render(
		A2(
			$author$project$Pyxis$Components$Text$withSize,
			$author$project$Pyxis$Tokens$TextSize$tokenL,
			$author$project$Pyxis$Components$Text$config(
				$elm$html$Html$text(
					$author$project$Translations$sendOfferEmailsReceiver(i18n)))));
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$renderReceiverBlock = F2(
	function (i18n, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('send-offer-email__receiver-block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Common$ComponentUI$Modal$SendOfferEmail$senderReceiverText(i18n)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Common$ComponentUI$Modal$SendOfferEmail$emailAddressText(model.$9)
						]))
				]));
	});
var $author$project$Translations$sendOfferEmailsWhichEmailText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Which email do you want to send to the customer?';
	} else {
		return '¿Qué email quieres enviarle al cliente?';
	}
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$whichEmailText = function (i18n) {
	return $author$project$Pyxis$Components$Text$render(
		A2(
			$author$project$Pyxis$Components$Text$withSize,
			$author$project$Pyxis$Tokens$TextSize$tokenL,
			$author$project$Pyxis$Components$Text$config(
				$elm$html$Html$text(
					$author$project$Translations$sendOfferEmailsWhichEmailText(i18n)))));
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$sendEmailModalContent = F4(
	function (i18n, onCheckBoxChange, offer, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('send-offer-email__which-email-text')
					]),
				_List_fromArray(
					[
						$author$project$Common$ComponentUI$Modal$SendOfferEmail$whichEmailText(i18n)
					])),
				A4($author$project$Common$ComponentUI$Modal$SendOfferEmail$checkboxGroup, i18n, onCheckBoxChange, offer, model),
				A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$renderReceiverBlock, i18n, model)
			]);
	});
var $author$project$Translations$sendOfferEmailsBackButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Back';
	} else {
		return 'Atrás';
	}
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$renderBackButton = F2(
	function (i18n, showModal) {
		return $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withSize,
				$author$project$Pyxis$Components$Button$sizeL,
				A2(
					$author$project$Pyxis$Components$Button$withOnClick,
					showModal(false),
					A2(
						$author$project$Pyxis$Components$Button$withText,
						$author$project$Translations$sendOfferEmailsBackButtonLabel(i18n),
						$author$project$Pyxis$Components$Button$secondary))));
	});
var $author$project$Translations$sendOfferEmailsSendButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Send emails';
	} else {
		return 'Enviar emails';
	}
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$renderSendEmailButton = F3(
	function (i18n, onSubmit, model) {
		return $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withSize,
				$author$project$Pyxis$Components$Button$sizeL,
				A2(
					$author$project$Pyxis$Components$Button$withOnClick,
					onSubmit(
						$author$project$Pyxis$Components$Field$CheckboxGroup$getValue(model.cd)),
					A2(
						$author$project$Pyxis$Components$Button$withText,
						$author$project$Translations$sendOfferEmailsSendButtonLabel(i18n),
						$author$project$Pyxis$Components$Button$primary))));
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$sendEmailModalFooter = F4(
	function (i18n, onSubmit, showModal, model) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$renderBackButton, i18n, showModal),
					A3($author$project$Common$ComponentUI$Modal$SendOfferEmail$renderSendEmailButton, i18n, onSubmit, model)
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$iconModalHeder = A2(
	$author$project$Pyxis$Components$Icon$withColor,
	$author$project$Pyxis$Tokens$TypographyColor$tokenBrand,
	$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$paperPlane));
var $author$project$Translations$sendOfferEmailsTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Set up email sending';
	} else {
		return 'Configurar el envío de emails';
	}
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$sendEmailModalHeader = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withIcon,
		$author$project$Common$ComponentUI$Modal$SendOfferEmail$iconModalHeder,
		A2(
			$author$project$Pyxis$Components$Modal$Header$withTitle,
			$author$project$Translations$sendOfferEmailsTitle(i18n),
			$author$project$Pyxis$Components$Modal$Header$config));
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$renderSendEmailModal = F6(
	function (i18n, onCheckBoxChange, onSubmit, showModal, offer, model) {
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			model.ig,
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A4($author$project$Common$ComponentUI$Modal$SendOfferEmail$sendEmailModalFooter, i18n, onSubmit, showModal, model),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					A4($author$project$Common$ComponentUI$Modal$SendOfferEmail$sendEmailModalContent, i18n, onCheckBoxChange, offer, model),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						$author$project$Common$ComponentUI$Modal$SendOfferEmail$sendEmailModalHeader(i18n),
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							showModal(false),
							'Close',
							A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$render = F6(
	function (i18n, showModal, onCheckBoxChange, onSubmit, offer, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$renderModalButton, i18n, showModal),
					A6($author$project$Common$ComponentUI$Modal$SendOfferEmail$renderSendEmailModal, i18n, onCheckBoxChange, onSubmit, showModal, offer, model)
				]));
	});
var $author$project$Page$OfferDetails$View$buttonWithSendEmailModal = F3(
	function (i18n, model, offer) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('feature-flag--sendEmail')
				]),
			_List_fromArray(
				[
					A6($author$project$Common$ComponentUI$Modal$SendOfferEmail$render, i18n, $author$project$Page$OfferDetails$Msg$ShowSendEmailModal, $author$project$Page$OfferDetails$Msg$SendOfferEmailCheckBoxChecked, $author$project$Page$OfferDetails$Msg$SendEmailModalSubmitted, offer, model.B)
				]));
	});
var $author$project$Page$OfferDetails$Msg$RedirectToSearch = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$OfferDetails$View$navigateToResults = A2(
	$elm$core$Basics$composeR,
	$author$project$Common$Offer$pickPolicyHolder,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Common$Person$pickPersonData,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.ar;
			},
			A2(
				$elm$core$Basics$composeR,
				$author$project$Page$Search$SearchQueryParam$DocumentId,
				A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$Page$OfferDetails$Msg$RedirectToSearch)))));
var $author$project$Common$Offer$pickComebackLink = function (_v0) {
	var offer = _v0;
	return offer.ga;
};
var $author$project$Common$ComponentUI$CustomElements$CopyButton$Config = $elm$core$Basics$identity;
var $author$project$Translations$copyComebackLinkCopiedLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Link copied!';
	} else {
		return 'Link copiado!';
	}
};
var $author$project$Translations$copyComebackLinkCopyLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Copy link of the offer';
	} else {
		return 'Copia link de la oferta';
	}
};
var $author$project$Common$ComponentUI$CustomElements$CopyButton$config = F2(
	function (i18n, copyTarget) {
		return {
			f6: _List_Nil,
			jC: $author$project$Translations$copyComebackLinkCopiedLabel(i18n),
			jD: $author$project$Translations$copyComebackLinkCopyLabel(i18n),
			jE: copyTarget
		};
	});
var $author$project$Tracker$actionName = function (name) {
	return A2($elm$html$Html$Attributes$attribute, 'data-' + $author$project$Tracker$customActionAttributeName, name);
};
var $author$project$Common$ComponentUI$CustomElements$CopyButton$render = function (_v0) {
	var configuration = _v0;
	return A3(
		$elm$html$Html$node,
		'copy-button',
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'data-text', configuration.jD),
				A2($elm$html$Html$Attributes$attribute, 'data-text-copied', configuration.jC),
				A2($elm$html$Html$Attributes$attribute, 'data-copy', configuration.jE),
				$author$project$Tracker$actionName('copy-offer-link'),
				$elm$html$Html$Attributes$classList(configuration.f6)
			]),
		_List_Nil);
};
var $author$project$Common$ComponentUI$CustomElements$CopyButton$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{f6: classList});
	});
var $author$project$Page$OfferDetails$View$buttonWithCopyComebackLink = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Common$ComponentUI$CustomElements$CopyButton$config(i18n),
		A2(
			$elm$core$Basics$composeR,
			$author$project$Common$ComponentUI$CustomElements$CopyButton$withClassList(
				_List_fromArray(
					[
						_Utils_Tuple2('padding-h-xs', true)
					])),
			$author$project$Common$ComponentUI$CustomElements$CopyButton$render));
};
var $author$project$Translations$copyComebackLinkCopyLabelError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Link not available: please contact support team';
	} else {
		return 'Link no disponible: póngase en contacto con el equipo de asistencia';
	}
};
var $author$project$Pyxis$Components$Message$Error = 4;
var $author$project$Pyxis$Components$Message$error = function (style) {
	return A2($author$project$Pyxis$Components$Message$config, 4, style);
};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Common$ComebackLink$toString = function (_v0) {
	var url = _v0.iV;
	var nonce = _v0.hx;
	var utmCampaign = _v0.fC;
	var utmMedium = _v0.fD;
	var utmSource = _v0.fE;
	return $elm$url$Url$toString(
		_Utils_update(
			url,
			{
				ll: $elm$core$Maybe$Just(
					A2(
						$elm$core$String$filter,
						$elm$core$Basics$neq('?'),
						$elm$url$Url$Builder$toQuery(
							$elm_community$maybe_extra$Maybe$Extra$values(
								_List_fromArray(
									[
										$elm$core$Maybe$Just(
										A2($elm$url$Url$Builder$string, $author$project$Common$ComebackLink$nonceQueryParamKey, nonce)),
										A2(
										$elm$core$Maybe$map,
										$elm$url$Url$Builder$string('utm_source'),
										utmSource),
										A2(
										$elm$core$Maybe$map,
										$elm$url$Url$Builder$string('utm_medium'),
										utmMedium),
										A2(
										$elm$core$Maybe$map,
										$elm$url$Url$Builder$string('utm_campaign'),
										utmCampaign)
									])))))
			}));
};
var $author$project$Pyxis$Components$Message$withTitle = F2(
	function (title, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				iS: $elm$core$Maybe$Just(title)
			});
	});
var $author$project$Common$ComebackLink$withUTMCampaign = F2(
	function (campaign, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				fC: $elm$core$Maybe$Just(campaign)
			});
	});
var $author$project$Common$ComebackLink$withUTMMedium = F2(
	function (medium, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				fD: $elm$core$Maybe$Just(medium)
			});
	});
var $author$project$Common$ComebackLink$withUTMSource = F2(
	function (source, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				fE: $elm$core$Maybe$Just(source)
			});
	});
var $author$project$Page$OfferDetails$View$renderComebackLink = F2(
	function (i18n, comebackLinkStatus) {
		switch (comebackLinkStatus.$) {
			case 0:
				return $author$project$Common$Render$empty;
			case 1:
				return $author$project$Pyxis$Components$Message$render(
					A2(
						$author$project$Pyxis$Components$Message$withTitle,
						$author$project$Translations$copyComebackLinkCopyLabelError(i18n),
						$author$project$Pyxis$Components$Message$error($author$project$Pyxis$Components$Message$tintBackground)));
			default:
				var comebackLink = comebackLinkStatus.a;
				return A2(
					$author$project$Page$OfferDetails$View$buttonWithCopyComebackLink,
					i18n,
					$author$project$Common$ComebackLink$toString(
						A2(
							$author$project$Common$ComebackLink$withUTMCampaign,
							'copy_link_of_the_offer',
							A2(
								$author$project$Common$ComebackLink$withUTMMedium,
								'manual_share',
								A2($author$project$Common$ComebackLink$withUTMSource, 'backoffice', comebackLink)))));
		}
	});
var $author$project$Pyxis$Components$IconSet$ChevronLeft = 179;
var $author$project$Pyxis$Components$IconSet$chevronLeft = 179;
var $author$project$Translations$detailsBackToResultsButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Back to results';
	} else {
		return 'Volver a los resultados';
	}
};
var $author$project$Common$ComponentUI$BackToResults$view = F2(
	function (i18n, onClickHandler) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('back-to-results-container')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withIconPrepend,
						$author$project$Pyxis$Components$IconSet$chevronLeft,
						A2(
							$author$project$Pyxis$Components$Button$withSize,
							$author$project$Pyxis$Components$Button$sizeM,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$detailsBackToResultsButton(i18n),
								A2($author$project$Pyxis$Components$Button$withOnClick, onClickHandler, $author$project$Pyxis$Components$Button$ghost)))))
				]));
	});
var $author$project$Page$OfferDetails$View$viewHeaderContainer = F3(
	function (i18n, model, offer) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('offer-details-header-container')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$ComponentUI$BackToResults$view,
					i18n,
					$author$project$Page$OfferDetails$View$navigateToResults(offer)),
					A2(
					$author$project$Page$OfferDetails$View$renderComebackLink,
					i18n,
					$author$project$Common$Offer$pickComebackLink(offer)),
					A3($author$project$Page$OfferDetails$View$buttonWithSendEmailModal, i18n, model, offer)
				]));
	});
var $author$project$Page$OfferDetails$Msg$RetryGetPaymentMethod = function (a) {
	return {$: 18, a: a};
};
var $author$project$Translations$paymentDetailsPaymentDetailsError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The payment method information couldn’t be loaded. Please try again in a moment.';
	} else {
		return 'La información del método de pago no pudo ser cargada. Inténtalo de nuevo en un momento.';
	}
};
var $author$project$Translations$paymentDetailsPaymentMethodDetails = F2(
	function (data, _v0) {
		var lang = _v0;
		if (!lang) {
			return data.bv + (' ' + (data.cE + (' | Expire date: ' + data.cO)));
		} else {
			return data.bv + (' ' + (data.cE + (' | Caducidad: ' + data.cO)));
		}
	});
var $author$project$Common$PaymentMethod$pickName = function (brand) {
	switch (brand.$) {
		case 0:
			return 'Visa';
		case 1:
			return 'MasterCard';
		case 2:
			return 'Maestro';
		default:
			var name = brand.a;
			return name;
	}
};
var $author$project$Common$PaymentMethod$paymentMethodContent = F2(
	function (i18n, paymentMethod) {
		return $author$project$Pyxis$Components$Text$render(
			A2(
				$author$project$Pyxis$Components$Text$withColor,
				$author$project$Pyxis$Tokens$TypographyColor$tokenContentWeak,
				$author$project$Pyxis$Components$Text$config(
					$elm$html$Html$text(
						A2(
							$author$project$Translations$paymentDetailsPaymentMethodDetails,
							{
								bv: $author$project$Common$PaymentMethod$pickName(paymentMethod.bv),
								cE: paymentMethod.cE,
								cO: paymentMethod.cO
							},
							i18n)))));
	});
var $author$project$Pyxis$Components$Card$Header = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Card$header = {dZ: _List_Nil, aX: $elm$core$Maybe$Nothing, dI: $elm$core$Maybe$Nothing, iS: $elm$core$Maybe$Nothing};
var $author$project$Translations$paymentDetailsPaymentMethodExpired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Expired card';
	} else {
		return 'Tarjeta expirada';
	}
};
var $author$project$Translations$paymentDetailsPaymentMethodTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Payment method';
	} else {
		return 'Método de pago';
	}
};
var $author$project$Common$PaymentMethod$paymentMethodTitleConfig = function (title) {
	return A2(
		$author$project$Pyxis$Components$Title$withFontWeight,
		$author$project$Pyxis$Tokens$FontWeight$tokenBold,
		A2(
			$author$project$Pyxis$Components$Title$withSize,
			$author$project$Pyxis$Tokens$TitleSize$tokenM,
			$author$project$Pyxis$Components$Title$config(
				$elm$html$Html$text(title))));
};
var $author$project$Pyxis$Tokens$TypographyColor$Error = 18;
var $author$project$Pyxis$Tokens$TypographyColor$tokenError = 18;
var $author$project$Common$PaymentMethod$paymentMethodTitle = F2(
	function (i18n, creditCardExpiration) {
		if (!creditCardExpiration) {
			return $author$project$Pyxis$Components$Title$render(
				$author$project$Common$PaymentMethod$paymentMethodTitleConfig(
					$author$project$Translations$paymentDetailsPaymentMethodTitle(i18n)));
		} else {
			return $author$project$Pyxis$Components$Title$render(
				A2(
					$author$project$Pyxis$Components$Title$withColor,
					$author$project$Pyxis$Tokens$TypographyColor$tokenError,
					$author$project$Common$PaymentMethod$paymentMethodTitleConfig(
						$author$project$Translations$paymentDetailsPaymentMethodExpired(i18n))));
		}
	});
var $author$project$Pyxis$Components$Card$withHeaderTitle = F2(
	function (title, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				iS: $elm$core$Maybe$Just(title)
			});
	});
var $author$project$Common$PaymentMethod$paymentMethodHeader = F2(
	function (i18n, paymentMethod) {
		return A2(
			$author$project$Pyxis$Components$Card$withHeaderTitle,
			A2($author$project$Common$PaymentMethod$paymentMethodTitle, i18n, paymentMethod.d5),
			$author$project$Pyxis$Components$Card$header);
	});
var $author$project$Pyxis$Components$Card$withHeader = F2(
	function (header_, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				eB: $elm$core$Maybe$Just(header_)
			});
	});
var $author$project$Pyxis$Components$IconSet$CreditCard = 166;
var $author$project$Pyxis$Components$IconSet$creditCard = 166;
var $author$project$Common$PaymentMethod$buildIconForOtherCard = A2(
	$author$project$Pyxis$Components$Icon$withSize,
	$author$project$Pyxis$Components$Icon$sizeM,
	A2(
		$author$project$Pyxis$Components$Icon$withStyle,
		$author$project$Pyxis$Components$Icon$neutral,
		$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$creditCard)));
var $author$project$Pyxis$Components$Card$IconAddon = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Card$InHeader = 2;
var $author$project$Pyxis$Components$Card$withAddonIconOnHeader = F2(
	function (icon, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				mf: $elm$core$Maybe$Just(
					{
						Y: 2,
						bk: $author$project$Pyxis$Components$Card$IconAddon(icon)
					})
			});
	});
var $author$project$Pyxis$Components$Card$ImageAddon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pyxis$Components$Card$withAddonImageOnHeader = F2(
	function (url, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				mf: $elm$core$Maybe$Just(
					{
						Y: 2,
						bk: $author$project$Pyxis$Components$Card$ImageAddon(url)
					})
			});
	});
var $author$project$Common$PaymentMethod$withPaymentImage = F2(
	function (brand, config) {
		switch (brand.$) {
			case 0:
				return A2($author$project$Pyxis$Components$Card$withAddonImageOnHeader, '/assets/visa-s.svg', config);
			case 1:
				return A2($author$project$Pyxis$Components$Card$withAddonImageOnHeader, '/assets/mastercard-s.svg', config);
			case 2:
				return A2($author$project$Pyxis$Components$Card$withAddonImageOnHeader, '/assets/maestro-s.svg', config);
			default:
				return A2($author$project$Pyxis$Components$Card$withAddonIconOnHeader, $author$project$Common$PaymentMethod$buildIconForOtherCard, config);
		}
	});
var $author$project$Common$PaymentMethod$render = F2(
	function (i18n, paymentMethod) {
		return $author$project$Pyxis$Components$Card$render(
			A2(
				$author$project$Pyxis$Components$Card$withContent,
				A2($author$project$Common$PaymentMethod$paymentMethodContent, i18n, paymentMethod),
				A2(
					$author$project$Common$PaymentMethod$withPaymentImage,
					paymentMethod.bv,
					A2(
						$author$project$Pyxis$Components$Card$withHeader,
						A2($author$project$Common$PaymentMethod$paymentMethodHeader, i18n, paymentMethod),
						$author$project$Pyxis$Components$Card$config))));
	});
var $author$project$Common$ComponentUI$PaymentBox$viewPaymentMethodBox = F3(
	function (i18n, paymentMethodRemoteData, onRetryButtonClick) {
		switch (paymentMethodRemoteData.$) {
			case 3:
				var paymentMethod = paymentMethodRemoteData.a;
				return A2($author$project$Common$PaymentMethod$render, i18n, paymentMethod);
			case 1:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('payment-container__payment-method-box__loading')
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Loaders$Loader$render($author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM)
						]));
			case 2:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('es-fe-bo-border--neutral2 es-fe-bo-border-radius--2xl')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Common$ComponentUI$ErrorBox$render,
							i18n,
							_List_fromArray(
								[
									$author$project$Translations$paymentDetailsPaymentDetailsError(i18n)
								]),
							onRetryButtonClick)
						]));
			default:
				return $elm_community$html_extra$Html$Extra$nothing;
		}
	});
var $author$project$Common$ComponentUI$PaymentBox$view = F3(
	function (i18n, paymentMethodRemoteData, onRetryButtonClick) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('payment-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('payment-container__payment-method-box')
						]),
					_List_fromArray(
						[
							A3($author$project$Common$ComponentUI$PaymentBox$viewPaymentMethodBox, i18n, paymentMethodRemoteData, onRetryButtonClick)
						]))
				]));
	});
var $author$project$Page$OfferDetails$View$viewPaymentBox = F3(
	function (i18n, model, offer) {
		return A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			$author$project$Common$Offer$pickIsRenewal(offer),
			A3(
				$author$project$Common$ComponentUI$PaymentBox$view,
				i18n,
				model.lc,
				$author$project$Page$OfferDetails$Msg$RetryGetPaymentMethod(
					$author$project$Common$Offer$pickId(offer))));
	});
var $author$project$Page$OfferDetails$View$viewOffer = F3(
	function (i18n, model, offer) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('offer-details__primary-container container-responsive padding-v-3xl')
				]),
			_List_fromArray(
				[
					A3($author$project$Page$OfferDetails$View$viewHeaderContainer, i18n, model, offer),
					A2(
					$author$project$Common$Render$ifCondition,
					$author$project$Page$OfferDetails$View$renderGreatLakesBanner(i18n),
					$author$project$Common$Offer$isOfferGreatLakesRenewal(offer)),
					A5(
					$author$project$Common$ComponentUI$DetailsResultBox$viewFromOffer,
					i18n,
					model.gf,
					{
						hE: A2(
							$author$project$Page$OfferDetails$Msg$AmendOfferCoverageEffectiveDate,
							offer,
							$author$project$Common$TimeHelper$tomorrow(model.gf)),
						hL: $author$project$Page$OfferDetails$Msg$ShowCompleteOfferLegalInformationModal(true),
						hY: $author$project$Page$OfferDetails$Msg$PurchaseOfferButtonPressed(offer)
					},
					offer,
					$krisajenkins$remotedata$RemoteData$isLoading(model.jI)),
					A3(
					$author$project$Common$Portfolio$render,
					i18n,
					model.dn,
					A2($author$project$Page$OfferDetails$View$portfolioConfig, model, offer)),
					A3($author$project$Page$OfferDetails$View$viewPaymentBox, i18n, model, offer)
				]));
	});
var $author$project$Page$OfferDetails$View$renderOfferDetails = F3(
	function (i18n, env, model) {
		var _v0 = model.F;
		switch (_v0.$) {
			case 0:
				return _List_Nil;
			case 1:
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('offer-details__loading')
							]),
						_List_fromArray(
							[
								$author$project$Pyxis$Components$Loaders$Loader$render($author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM)
							]))
					]);
			case 2:
				return _List_fromArray(
					[$author$project$Common$ErrorContainer$generic]);
			default:
				if (_v0.a.$ === 1) {
					var _v1 = _v0.a;
					return _List_fromArray(
						[$author$project$Common$ErrorContainer$notFound]);
				} else {
					var offer = _v0.a.a;
					var chosenExcess = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Common$CoverSelection$defaultExcess,
						A2(
							$elm$core$Maybe$map,
							$author$project$Common$CoverSelection$pickExcess,
							$krisajenkins$remotedata$RemoteData$toMaybe(model.jI)));
					return _List_fromArray(
						[
							A3($author$project$Page$OfferDetails$View$viewOffer, i18n, model, offer),
							A2(
							$author$project$Common$Render$maybe,
							function (coverSelection) {
								return A6($author$project$Common$ComponentUI$Modal$RecordingDisclaimer$render, offer, coverSelection, i18n, $author$project$Page$OfferDetails$Msg$RecordingDisclaimerDismissed, $author$project$Page$OfferDetails$Msg$RedirectToPayment, model.dy);
							},
							$krisajenkins$remotedata$RemoteData$toMaybe(model.jI)),
							A6(
							$author$project$Common$ComponentUI$Modal$GreatLakesOptInConsent$render,
							i18n,
							$author$project$Common$Offer$pickId(offer),
							$author$project$Page$OfferDetails$Msg$GreatLakesOptInConsentGiven(0),
							$author$project$Page$OfferDetails$Msg$GreatLakesOptInConsentDismissed(0),
							$krisajenkins$remotedata$RemoteData$isLoading(model.dt),
							model.bI),
							A6(
							$author$project$Common$ComponentUI$Modal$GreatLakesOptInConsent$render,
							i18n,
							$author$project$Common$Offer$pickId(offer),
							$author$project$Page$OfferDetails$Msg$GreatLakesOptInConsentGiven(1),
							$author$project$Page$OfferDetails$Msg$GreatLakesOptInConsentDismissed(1),
							$krisajenkins$remotedata$RemoteData$isLoading(model.dt),
							model.bJ),
							A5(
							$author$project$Common$ComponentUI$Modal$CompleteOfferLegalInformation$render,
							offer,
							i18n,
							$author$project$ExternalUrl$FunnelOffer(env),
							$author$project$Page$OfferDetails$Msg$ShowCompleteOfferLegalInformationModal(false),
							model.eb),
							A4(
							$author$project$Common$ComponentUI$Modal$CoverPackages$render,
							i18n,
							$author$project$Common$Offer$pickSelectedBundle(offer),
							chosenExcess,
							model.ed)
						]);
				}
		}
	});
var $author$project$Pyxis$Components$Toasts$Bottom = 2;
var $author$project$Pyxis$Components$Toasts$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Toasts$config = function (id) {
	return {fV: 'Notifications', ej: _List_Nil, kg: id, hA: $elm$core$Maybe$Nothing, hB: $elm$core$Maybe$Nothing, Y: 2, fv: $elm$core$Maybe$Nothing};
};
var $author$project$Pyxis$Components$Toasts$offsetBottomAttribute = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$fromInt,
	A2(
		$elm$core$Basics$composeR,
		A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Basics$append, 'px'),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$append('--toaster-offset-bottom: '),
			$elm$html$Html$Attributes$attribute('style'))));
var $author$project$Pyxis$Components$Toasts$offsetTopAttribute = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$fromInt,
	A2(
		$elm$core$Basics$composeR,
		A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Basics$append, 'px'),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$append('--toaster-offset-top: '),
			$elm$html$Html$Attributes$attribute('style'))));
var $author$project$Pyxis$Components$Toasts$placementToClass = function (placement) {
	switch (placement) {
		case 0:
			return 'toaster--top';
		case 2:
			return 'toaster--bottom';
		default:
			return 'toaster--top-right';
	}
};
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $elm$html$Html$Lazy$lazy3 = $elm$virtual_dom$VirtualDom$lazy3;
var $author$project$Pyxis$Components$Toasts$AutoRemove = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pyxis$Components$Toasts$Hold = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pyxis$Components$Toasts$Resume = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pyxis$Components$Toasts$internalIdToAccessibleId = function (internalUuid) {
	return A2(
		$elm$core$String$join,
		'-',
		_List_fromArray(
			['toast', internalUuid]));
};
var $author$project$Pyxis$Components$Toasts$isAlertDialog = F2(
	function (maybeAction, content) {
		var _v0 = _Utils_Tuple2(maybeAction, content);
		if (!_v0.a.$) {
			return true;
		} else {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return true;
			} else {
				return false;
			}
		}
	});
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Pyxis$Components$Toasts$prefixToastClass = function (variant) {
	return A2(
		$elm$core$String$join,
		'--',
		_List_fromArray(
			['toast', variant]));
};
var $author$project$Pyxis$Components$Toasts$Remove = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pyxis$Components$Toasts$renderIcon = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Components$Icon$config,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeM),
		$author$project$Pyxis$Components$Icon$render));
var $author$project$Pyxis$Components$Toasts$renderCloseButton = F3(
	function (tagger, id, closeButtonLabel) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('toast__close'),
					$elm$html$Html$Events$onClick(
					tagger(
						$author$project$Pyxis$Components$Toasts$Remove(id))),
					$author$project$Pyxis$Commons$Attributes$ariaLabel(closeButtonLabel)
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Toasts$renderIcon($author$project$Pyxis$Components$IconSet$cross)
				]));
	});
var $author$project$Pyxis$Components$Toasts$renderAction = function (_v0) {
	var label = _v0.a;
	var onClickHandler = _v0.b;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('toast__action')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						onClickHandler,
						A2(
							$author$project$Pyxis$Components$Button$withText,
							label,
							A2($author$project$Pyxis$Components$Button$withSize, $author$project$Pyxis$Components$Button$sizeS, $author$project$Pyxis$Components$Button$primary))))
				]))
		]);
};
var $author$project$Pyxis$Components$Toasts$renderText = F2(
	function (toastId, text) {
		if (!text.$) {
			var string = text.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('toast__text'),
							$elm$html$Html$Attributes$id(
							$author$project$Pyxis$Components$Toasts$internalIdToAccessibleId(toastId))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(string)
						]))
				]);
		} else {
			var content = text.a;
			var title = text.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('toast__content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(
									$author$project$Pyxis$Components$Toasts$internalIdToAccessibleId(toastId))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('toast__text')
								]),
							_List_fromArray(
								[content]))
						]))
				]);
		}
	});
var $author$project$Pyxis$Components$Toasts$renderContentWrapper = F3(
	function (id, content, maybeCustomAction) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('toast__content-wrapper')
				]),
			A2(
				$elm$core$List$append,
				A2($author$project$Pyxis$Components$Toasts$renderText, id, content),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Toasts$renderAction, maybeCustomAction))));
	});
var $author$project$Pyxis$Components$Toasts$renderIconContainer = function (icon) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('toast__icon')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Toasts$renderIcon(icon)
			]));
};
var $elm$svg$Svg$Attributes$color = _VirtualDom_attribute('color');
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $elm$svg$Svg$Attributes$pathLength = _VirtualDom_attribute('pathLength');
var $elm$svg$Svg$Attributes$preserveAspectRatio = _VirtualDom_attribute('preserveAspectRatio');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$Pyxis$Components$Toasts$renderToastLoader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('toast__loader')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('0 0 100 2'),
					$elm$svg$Svg$Attributes$preserveAspectRatio('none'),
					$elm$svg$Svg$Attributes$class('toast__loader')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x1('0'),
							$elm$svg$Svg$Attributes$y1('0'),
							$elm$svg$Svg$Attributes$x2('100'),
							$elm$svg$Svg$Attributes$y2('0'),
							$elm$svg$Svg$Attributes$strokeWidth('12'),
							$elm$svg$Svg$Attributes$strokeLinecap('round'),
							$elm$svg$Svg$Attributes$color('transparent'),
							$elm$svg$Svg$Attributes$pathLength('1'),
							$elm$svg$Svg$Attributes$class('toast__loader__background')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x1('0'),
							$elm$svg$Svg$Attributes$y1('0'),
							$elm$svg$Svg$Attributes$x2('100'),
							$elm$svg$Svg$Attributes$y2('0'),
							$elm$svg$Svg$Attributes$stroke('purple'),
							$elm$svg$Svg$Attributes$strokeWidth('12'),
							$elm$svg$Svg$Attributes$strokeLinecap('round'),
							$elm$svg$Svg$Attributes$color('transparent'),
							$elm$svg$Svg$Attributes$pathLength('100'),
							$elm$svg$Svg$Attributes$class('toast__loader__line')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Pyxis$Components$Toasts$toastRole = F2(
	function (maybeAction, content) {
		return A2($author$project$Pyxis$Components$Toasts$isAlertDialog, maybeAction, content) ? 'alertdialog' : 'alert';
	});
var $author$project$Pyxis$Components$Toasts$variantToString = function (variant) {
	switch (variant) {
		case 0:
			return 'neutral';
		case 1:
			return 'brand';
		case 2:
			return 'alert';
		case 3:
			return 'success';
		case 4:
			return 'error';
		default:
			return 'informative';
	}
};
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$visibilityTimeAsStyleString = function (duration) {
	return A3(
		$primait$prima_elm_extra$PrimaFunction$flip,
		$elm$core$Basics$append,
		'ms',
		$elm$core$String$fromInt(duration));
};
var $author$project$Pyxis$Components$Toasts$renderToast = F2(
	function (tagger, _v0) {
		var action = _v0.T;
		var classList = _v0.f6;
		var closeButtonLabel = _v0.f7;
		var dataAttrList = _v0.ej;
		var duration = _v0.eo;
		var icon = _v0.kf;
		var id = _v0.kg;
		var isSticky = _v0.eQ;
		var testId = _v0.fv;
		var text = _v0.pu;
		var variant = _v0.i_;
		var onAnimationEnd = _v0.hG;
		return A2(
			$elm$html$Html$div,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('toast', true),
								_Utils_Tuple2(
								$author$project$Pyxis$Components$Toasts$prefixToastClass(
									$author$project$Pyxis$Components$Toasts$variantToString(variant)),
								true),
								_Utils_Tuple2(
								'toast--with-icon',
								$elm_community$maybe_extra$Maybe$Extra$isJust(icon))
							])),
						$elm$html$Html$Attributes$classList(classList),
						$author$project$Pyxis$Commons$Attributes$role(
						A2($author$project$Pyxis$Components$Toasts$toastRole, action, text)),
						A2(
						$author$project$Pyxis$Commons$Attributes$renderIf,
						A2($author$project$Pyxis$Components$Toasts$isAlertDialog, action, text),
						$author$project$Pyxis$Commons$Attributes$ariaLabelledBy(
							$author$project$Pyxis$Components$Toasts$internalIdToAccessibleId(id))),
						A2(
						$author$project$Pyxis$Commons$Attributes$maybe,
						A2(
							$elm$core$Basics$composeR,
							$elm$json$Json$Decode$succeed,
							$elm$html$Html$Events$on('transitionend')),
						onAnimationEnd),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
						A2(
						$elm$html$Html$Attributes$attribute,
						'style',
						'--toast-duration: ' + $author$project$Pyxis$Components$Toasts$ToastsHelpers$visibilityTimeAsStyleString(duration)),
						$elm$html$Html$Events$onMouseEnter(
						tagger(
							$author$project$Pyxis$Components$Toasts$Hold(id))),
						$elm$html$Html$Events$onMouseLeave(
						tagger(
							$author$project$Pyxis$Components$Toasts$Resume(id)))
					])),
			_List_fromArray(
				[
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Toasts$renderIconContainer, icon)),
					A3($author$project$Pyxis$Components$Toasts$renderContentWrapper, id, text, action),
					A3($author$project$Pyxis$Components$Toasts$renderCloseButton, tagger, id, closeButtonLabel),
					A2($author$project$Pyxis$Commons$Render$renderIf, !isSticky, $author$project$Pyxis$Components$Toasts$renderToastLoader)
				]));
	});
var $author$project$Pyxis$Components$Toasts$withToastAnimationEnd = F2(
	function (tagger, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				hG: $elm$core$Maybe$Just(tagger)
			});
	});
var $author$project$Pyxis$Components$Toasts$withToastClassList = F2(
	function (classes, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{f6: classes});
	});
var $author$project$Pyxis$Components$Toasts$renderTimedToast = F3(
	function (tagger, id, timedToast) {
		switch (timedToast.$) {
			case 0:
				var toastElement = timedToast.b;
				return A2($author$project$Pyxis$Components$Toasts$renderToast, tagger, toastElement);
			case 1:
				var toastElement = timedToast.a;
				return A2(
					$author$project$Pyxis$Components$Toasts$renderToast,
					tagger,
					A2(
						$author$project$Pyxis$Components$Toasts$withToastAnimationEnd,
						tagger(
							$author$project$Pyxis$Components$Toasts$AutoRemove(id)),
						A2(
							$author$project$Pyxis$Components$Toasts$withToastClassList,
							_List_fromArray(
								[
									_Utils_Tuple2('toast--fade-out', true)
								]),
							toastElement)));
			case 2:
				var toastElement = timedToast.a;
				return A2($author$project$Pyxis$Components$Toasts$renderToast, tagger, toastElement);
			default:
				var toastElement = timedToast.b;
				return A2($author$project$Pyxis$Components$Toasts$renderToast, tagger, toastElement);
		}
	});
var $author$project$Pyxis$Components$Toasts$renderToastList = F2(
	function (tagger, _v0) {
		var uuid = _v0.a;
		var timedToast = _v0.b;
		return _Utils_Tuple2(
			uuid,
			A4($elm$html$Html$Lazy$lazy3, $author$project$Pyxis$Components$Toasts$renderTimedToast, tagger, uuid, timedToast));
	});
var $author$project$Pyxis$Components$Toasts$render = F3(
	function (tagger, _v0, _v1) {
		var toasts = _v0.s;
		var ariaLabel = _v1.fV;
		var id = _v1.kg;
		var dataAttrList = _v1.ej;
		var placement = _v1.Y;
		var offsetBottom = _v1.hA;
		var offsetTop = _v1.hB;
		var testId = _v1.fv;
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('toaster', true),
								_Utils_Tuple2(
								$author$project$Pyxis$Components$Toasts$placementToClass(placement),
								true),
								_Utils_Tuple2(
								'toaster--with-offset',
								$elm_community$maybe_extra$Maybe$Extra$isJust(offsetTop)),
								_Utils_Tuple2(
								'toaster--with-bottom-offset',
								$elm_community$maybe_extra$Maybe$Extra$isJust(offsetBottom))
							])),
						$elm$html$Html$Attributes$id(id),
						$author$project$Pyxis$Commons$Attributes$role('region'),
						$author$project$Pyxis$Commons$Attributes$ariaLabel(ariaLabel),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Components$Toasts$offsetBottomAttribute, offsetBottom),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Components$Toasts$offsetTopAttribute, offsetTop),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					])),
			A2(
				$elm$core$List$map,
				$author$project$Pyxis$Components$Toasts$renderToastList(tagger),
				$elm$core$Dict$toList(toasts)));
	});
var $author$project$Pyxis$Components$Toasts$TopRight = 1;
var $author$project$Pyxis$Components$Toasts$topRightPlacement = 1;
var $author$project$Pyxis$Components$Toasts$withPlacement = F2(
	function (placement, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{Y: placement});
	});
var $author$project$Page$OfferDetails$View$viewToasts = function (model) {
	return A3(
		$author$project$Pyxis$Components$Toasts$render,
		$author$project$Page$OfferDetails$Msg$ToastMsg,
		model.s,
		A2(
			$author$project$Pyxis$Components$Toasts$withPlacement,
			$author$project$Pyxis$Components$Toasts$topRightPlacement,
			$author$project$Pyxis$Components$Toasts$config('offer-details-toaster')));
};
var $author$project$Page$OfferDetails$View$view = F3(
	function (i18n, env, model) {
		return A2(
			$elm$core$List$cons,
			$author$project$Page$OfferDetails$View$viewToasts(model),
			A3($author$project$Page$OfferDetails$View$renderOfferDetails, i18n, env, model));
	});
var $author$project$Page$OfferDetails$view = F3(
	function (i18n, env, model) {
		return {
			f$: A3($author$project$Page$OfferDetails$View$view, i18n, env, model),
			iS: $author$project$Translations$routeOfferDetails(i18n)
		};
	});
var $author$project$Translations$routePayment = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Payment';
	} else {
		return 'Pago';
	}
};
var $author$project$Common$ErrorContainer$productsNotFound = A2($author$project$Common$ErrorContainer$custom, 1, 'Oops! We couldn\'t find any product for this offer');
var $author$project$Translations$paymentSpinnerText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Loading checkout...';
	} else {
		return 'Procesando...';
	}
};
var $author$project$Pyxis$Components$Loaders$Loader$withText = F2(
	function (text, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				pu: $elm$core$Maybe$Just(text)
			});
	});
var $author$project$Page$Payment$View$renderLoadingPage = function (i18n) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('justify-content-center display-flex')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Loaders$Loader$render(
				A2(
					$author$project$Pyxis$Components$Loaders$Loader$withText,
					$author$project$Translations$paymentSpinnerText(i18n),
					$author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM))
			]));
};
var $author$project$Page$Payment$Msg$PaymentSubmit = {$: 6};
var $author$project$Pyxis$Components$Form$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Form$config = {dT: $elm$core$Maybe$Nothing, T: $elm$core$Maybe$Nothing, fY: $elm$core$Maybe$Nothing, f6: _List_Nil, ej: _List_Nil, es: $elm$core$Maybe$Nothing, cS: _List_Nil, kg: $elm$core$Maybe$Nothing, eX: $elm$core$Maybe$Nothing, kF: $elm$core$Maybe$Nothing, e_: $elm$core$Maybe$Nothing, k5: $elm$core$Maybe$Nothing, ft: $elm$core$Maybe$Nothing, fv: $elm$core$Maybe$Nothing};
var $author$project$Pyxis$Components$Form$Fieldset$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Form$Fieldset$L = 2;
var $author$project$Pyxis$Components$Form$Fieldset$config = {fJ: _List_Nil, f6: _List_Nil, aX: _List_Nil, ej: _List_Nil, ew: _List_Nil, eB: _List_Nil, kg: $elm$core$Maybe$Nothing, eJ: false, a5: $elm$core$Maybe$Nothing, c2: 2};
var $elm$html$Html$Attributes$acceptCharset = $elm$html$Html$Attributes$stringProperty('acceptCharset');
var $elm$html$Html$Attributes$action = function (uri) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'action',
		_VirtualDom_noJavaScriptUri(uri));
};
var $elm$html$Html$Attributes$enctype = $elm$html$Html$Attributes$stringProperty('enctype');
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$html$Html$Attributes$method = $elm$html$Html$Attributes$stringProperty('method');
var $elm$html$Html$Attributes$novalidate = $elm$html$Html$Attributes$boolProperty('noValidate');
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $elm$html$Html$fieldset = _VirtualDom_node('fieldset');
var $author$project$Pyxis$Components$Grid$Option = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Grid$Gap$L = 2;
var $author$project$Pyxis$Components$Grid$Gap$sizeL = 2;
var $author$project$Pyxis$Components$Grid$gapL = function (c) {
	return _Utils_update(
		c,
		{aF: $author$project$Pyxis$Components$Grid$Gap$sizeL});
};
var $author$project$Pyxis$Components$Grid$Gap$S = 0;
var $author$project$Pyxis$Components$Grid$Gap$sizeS = 0;
var $author$project$Pyxis$Components$Grid$gapS = function (c) {
	return _Utils_update(
		c,
		{aF: $author$project$Pyxis$Components$Grid$Gap$sizeS});
};
var $author$project$Pyxis$Components$Grid$oneColRowFullWidth = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Components$Grid$col(_List_Nil),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$author$project$Pyxis$Components$Grid$row(_List_Nil)));
var $author$project$Pyxis$Components$Form$Fieldset$renderContent = function (content) {
	return _List_fromArray(
		[
			$author$project$Pyxis$Components$Grid$oneColRowFullWidth(
			_List_fromArray(
				[
					A2(
					$author$project$Pyxis$Components$Grid$render,
					_List_fromArray(
						[$author$project$Pyxis$Components$Grid$gapS]),
					content)
				]))
		]);
};
var $author$project$Pyxis$Components$Grid$Row$Option = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Grid$Row$sizeL = function (config) {
	return _Utils_update(
		config,
		{aO: 2});
};
var $author$project$Pyxis$Components$Grid$Row$sizeM = function (config) {
	return _Utils_update(
		config,
		{aO: 1});
};
var $author$project$Pyxis$Components$Grid$Row$sizeS = function (config) {
	return _Utils_update(
		config,
		{aO: 0});
};
var $author$project$Pyxis$Components$Form$Fieldset$getRowSize = function (rowSize) {
	switch (rowSize) {
		case 0:
			return $author$project$Pyxis$Components$Grid$Row$sizeS;
		case 1:
			return $author$project$Pyxis$Components$Grid$Row$sizeM;
		default:
			return $author$project$Pyxis$Components$Grid$Row$sizeL;
	}
};
var $author$project$Pyxis$Components$Form$Fieldset$renderLegendRow = F2(
	function (rowSize, legend) {
		return _List_fromArray(
			[
				A2(
				$author$project$Pyxis$Components$Grid$row,
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Form$Fieldset$getRowSize(rowSize)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Pyxis$Components$Grid$col,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pyxis$Components$Form$Legend$render(legend)
							]))
					]))
			]);
	});
var $author$project$Pyxis$Components$Form$Fieldset$renderVisualLegend = function (rowSize) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(
			$author$project$Pyxis$Components$Form$Fieldset$renderLegendRow(rowSize)),
		$elm$core$Maybe$withDefault(_List_Nil));
};
var $author$project$Pyxis$Components$Form$Legend$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{f6: classList});
	});
var $author$project$Pyxis$Components$Form$Fieldset$render = function (_v0) {
	var classList = _v0.f6;
	var dataAttrList = _v0.ej;
	var header = _v0.eB;
	var content = _v0.aX;
	var footer = _v0.ew;
	var legend = _v0.a5;
	var additionalContent = _v0.fJ;
	var isHiddenLegend = _v0.eJ;
	var legendRowSize = _v0.c2;
	var id = _v0.kg;
	return A2(
		$elm$html$Html$fieldset,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(classList),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, id)
				])),
		_List_fromArray(
			[
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Pyxis$Components$Form$Legend$withClassList(
							_List_fromArray(
								[
									_Utils_Tuple2('sr-only', true)
								])),
						$author$project$Pyxis$Components$Form$Legend$render),
					legend)),
				A2(
				$author$project$Pyxis$Components$Grid$render,
				_List_fromArray(
					[$author$project$Pyxis$Components$Grid$gapL]),
				_Utils_ap(
					additionalContent,
					_Utils_ap(
						(!isHiddenLegend) ? A2($author$project$Pyxis$Components$Form$Fieldset$renderVisualLegend, legendRowSize, legend) : _List_Nil,
						_Utils_ap(
							header,
							_Utils_ap(
								$author$project$Pyxis$Components$Form$Fieldset$renderContent(content),
								footer)))))
			]));
};
var $author$project$Pyxis$Components$Form$render = function (_v0) {
	var onSubmit = _v0.k5;
	var dataAttrList = _v0.ej;
	var gridContent = _v0.cS;
	var classList = _v0.f6;
	var id = _v0.kg;
	var testId = _v0.fv;
	var acceptCharset = _v0.dT;
	var action = _v0.T;
	var autocomplete = _v0.fY;
	var encType = _v0.es;
	var method = _v0.eX;
	var name = _v0.kF;
	var noValidate = _v0.e_;
	var target = _v0.ft;
	return A2(
		$elm$html$Html$form,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form'),
					$elm$html$Html$Attributes$classList(classList),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$acceptCharset, acceptCharset),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$action, action),
					A2(
					$author$project$Pyxis$Commons$Attributes$maybe,
					$elm$html$Html$Attributes$attribute('autocomplete'),
					autocomplete),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$enctype, encType),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$method, method),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$name, name),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$novalidate, noValidate),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$target, target),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Events$onSubmit, onSubmit)
				])),
		A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Pyxis$Components$Form$Fieldset$render),
			A2($elm$core$List$filter, $elm$core$Tuple$second, gridContent)));
};
var $author$project$Page$Payment$View$acceptedCardsStaticInfo = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('payment__static-info')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('payment__credit-cards'),
					$elm$html$Html$Attributes$class('display-flex')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/assets/visa-s.svg'),
							$elm$html$Html$Attributes$class('space-h-xs')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/assets/mastercard-s.svg'),
							$elm$html$Html$Attributes$class('space-h-xs')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/assets/maestro-s.svg'),
							$elm$html$Html$Attributes$class('space-h-xs')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Pyxis$Components$Grid$oneColRowSizeS = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Components$Grid$col(_List_Nil),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$author$project$Pyxis$Components$Grid$row(
			_List_fromArray(
				[$author$project$Pyxis$Components$Grid$Row$sizeS]))));
var $author$project$Translations$paymentCardExpirationDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Expiration Date';
	} else {
		return 'Caducidad';
	}
};
var $author$project$Translations$paymentCardNumberLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Card Number';
	} else {
		return 'Número de la tarjeta';
	}
};
var $author$project$Translations$paymentFetchProductsErrorMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Couldn\'t fetch products';
	} else {
		return 'No se pudieron obtener los productos';
	}
};
var $author$project$Page$Payment$View$securePaymentStaticInfo = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('display-flex')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src('/assets/secure-payment.svg')
				]),
			_List_Nil)
		]));
var $author$project$Translations$paymentTaxeslabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Including taxes';
	} else {
		return 'Incluye impuestos';
	}
};
var $author$project$Translations$paymentTotalPriceLabel = F2(
	function (refundPrice, _v0) {
		var lang = _v0;
		if (!lang) {
			return 'Total Price: ' + refundPrice;
		} else {
			return 'Precio total: ' + refundPrice;
		}
	});
var $author$project$Common$Price$toStringNoSpaceSignFirst = F2(
	function (i18n, _v0) {
		var amount = _v0.a;
		var currency = _v0.b;
		return _Utils_ap(
			$author$project$Common$Price$pickSign(currency),
			A2($author$project$Common$Price$toAmountString, i18n, amount));
	});
var $author$project$Common$Price$zeroEuro = $author$project$Common$Price$zero(0);
var $author$project$Page$Payment$View$totalPrice = F2(
	function (i18n, _v0) {
		var gotOfferProductResult = _v0.gJ;
		var sumProductsPrices = function (offerProducts) {
			return $author$project$Common$Price$sumAll(
				A2(
					$elm$core$List$map,
					function (product) {
						return product.jd.j8;
					},
					offerProducts));
		};
		var calculatedPrice = A3($krisajenkins$remotedata$RemoteData$unwrap, $author$project$Common$Price$zeroEuro, sumProductsPrices, gotOfferProductResult);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title-m-bold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Translations$paymentTotalPriceLabel,
								A2($author$project$Common$Price$toStringNoSpaceSignFirst, i18n, calculatedPrice),
								i18n))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-l-book c-content-weak')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$paymentTaxeslabel(i18n))
						]))
				]));
	});
var $author$project$Pyxis$Components$Field$Label$M = 1;
var $author$project$Pyxis$Components$Field$Label$config = {f6: _List_Nil, ej: _List_Nil, ex: $elm$core$Maybe$Nothing, kg: $elm$core$Maybe$Nothing, eI: false, pj: false, aO: 1, fo: $elm$core$Maybe$Nothing, fv: $elm$core$Maybe$Nothing, pu: $elm$core$Maybe$Nothing, fy: $elm$core$Maybe$Nothing};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Pyxis$Components$Field$Label$withText = F2(
	function (text, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				pu: $elm$core$Maybe$Just(text)
			});
	});
var $author$project$Page$Payment$View$viewCardField = F2(
	function (label, _v0) {
		var id = _v0.kg;
		var isValid = _v0.bQ;
		var isPristine = _v0.eM;
		return A2(
			$author$project$Pyxis$Components$Grid$col,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Field$Label$render(
					A2(
						$author$project$Pyxis$Components$Field$Label$withFor,
						id,
						A2($author$project$Pyxis$Components$Field$Label$withText, label, $author$project$Pyxis$Components$Field$Label$config))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(id),
							A2($elm$html$Html$Attributes$style, 'padding', '0'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('form-field form-field__text', true),
									_Utils_Tuple2('form-field--error', !(isValid || isPristine))
								]))
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$Payment$View$viewProduct = F2(
	function (i18n, _v0) {
		var bundleSlug = _v0.mt;
		var annualPrice = _v0.jd;
		return A2(
			$author$project$Pyxis$Components$Grid$row,
			_List_fromArray(
				[$author$project$Pyxis$Components$Grid$Row$sizeS]),
			_List_fromArray(
				[
					A2(
					$author$project$Pyxis$Components$Grid$col,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('product-card product-card--checkout product-card--selected')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('product-card__header')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('/assets/motorcycle-car.svg')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('title-s-bold')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($author$project$Common$Product$bundleSlugToString, i18n, bundleSlug))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('product-card__price')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($author$project$Common$Price$toStringSignFirst, i18n, annualPrice.j8))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Payment$View$viewProducts = F2(
	function (i18n, offerProducts) {
		return A2(
			$elm$core$List$map,
			function (product) {
				return A2($author$project$Page$Payment$View$viewProduct, i18n, product);
			},
			offerProducts);
	});
var $author$project$Page$Payment$View$renderFormContent = F2(
	function (i18n, model) {
		var viewStaticFields = _List_fromArray(
			[
				A2(
				$author$project$Pyxis$Components$Grid$row,
				_List_fromArray(
					[$author$project$Pyxis$Components$Grid$Row$sizeS]),
				_List_fromArray(
					[
						A2(
						$author$project$Pyxis$Components$Grid$col,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('display-flex justify-content-space-between align-items-center')
									]),
								_List_fromArray(
									[$author$project$Page$Payment$View$acceptedCardsStaticInfo, $author$project$Page$Payment$View$securePaymentStaticInfo]))
							]))
					]))
			]);
		var viewSelectedProductsCards = A3(
			$krisajenkins$remotedata$RemoteData$unwrap,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Grid$oneColRowSizeS(
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$paymentFetchProductsErrorMessage(i18n))
						]))
				]),
			function (offerProducts) {
				return A2($author$project$Page$Payment$View$viewProducts, i18n, offerProducts);
			},
			model.gJ);
		var viewPaymentFields = _List_fromArray(
			[
				A2(
				$author$project$Pyxis$Components$Grid$row,
				_List_fromArray(
					[$author$project$Pyxis$Components$Grid$Row$sizeS]),
				_List_fromArray(
					[
						A2(
						$author$project$Page$Payment$View$viewCardField,
						$author$project$Translations$paymentCardNumberLabel(i18n),
						model.d4.cE)
					])),
				A2(
				$author$project$Pyxis$Components$Grid$row,
				_List_fromArray(
					[$author$project$Pyxis$Components$Grid$Row$sizeS]),
				_List_fromArray(
					[
						A2(
						$author$project$Page$Payment$View$viewCardField,
						$author$project$Translations$paymentCardExpirationDateLabel(i18n),
						model.d4.cO)
					])),
				$author$project$Pyxis$Components$Grid$oneColRowSizeS(
				_List_fromArray(
					[
						A2($author$project$Page$Payment$View$totalPrice, i18n, model)
					]))
			]);
		return $elm$core$List$concat(
			_List_fromArray(
				[viewSelectedProductsCards, viewPaymentFields, viewStaticFields]));
	});
var $author$project$Page$Payment$Msg$GoBackToPreviousPage = {$: 2};
var $author$project$Translations$paymentBackButtonText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Back';
	} else {
		return 'Regresar';
	}
};
var $author$project$Page$Payment$View$renderBackButton = function (i18n) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('payment__back-button')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Button$render(
				A2(
					$author$project$Pyxis$Components$Button$withIconPrepend,
					$author$project$Pyxis$Components$IconSet$chevronLeft,
					A2(
						$author$project$Pyxis$Components$Button$withSize,
						$author$project$Pyxis$Components$Button$sizeM,
						A2(
							$author$project$Pyxis$Components$Button$withText,
							$author$project$Translations$paymentBackButtonText(i18n),
							A2($author$project$Pyxis$Components$Button$withOnClick, $author$project$Page$Payment$Msg$GoBackToPreviousPage, $author$project$Pyxis$Components$Button$ghost)))))
			]));
};
var $author$project$Page$Payment$Model$hasValidCreditCardField = function (fields) {
	return fields.cE.bQ && fields.cO.bQ;
};
var $author$project$Pyxis$Components$Button$inherit = function (_v0) {
	var configuration = _v0;
	return _Utils_update(
		configuration,
		{dR: 2});
};
var $author$project$Page$Payment$Model$isStatusPayingWithCreditCard = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.dx;
	},
	$elm$core$Basics$eq(3));
var $author$project$Page$Payment$Model$isStatusPaymentReady = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.dx;
	},
	$elm$core$Basics$eq(1));
var $author$project$Translations$paymentPurchaseButtonText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Pay now';
	} else {
		return 'Pagar ahora';
	}
};
var $author$project$Pyxis$Components$Button$Submit = {$: 1};
var $author$project$Pyxis$Components$Button$submit = $author$project$Pyxis$Components$Button$Submit;
var $author$project$Page$Payment$View$renderPayNowButton = F2(
	function (i18n, model) {
		var cardFields = model.d4;
		var isLoading = $author$project$Page$Payment$Model$isStatusPayingWithCreditCard(model);
		var isEnabled = $author$project$Page$Payment$Model$hasValidCreditCardField(cardFields) && $author$project$Page$Payment$Model$isStatusPaymentReady(model);
		var isDisabled = !isEnabled;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('payment__pay-now-button')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withTestId,
						'payment-button',
						A2(
							$author$project$Pyxis$Components$Button$withId,
							'payment-button',
							A2(
								$author$project$Pyxis$Components$Button$withType,
								$author$project$Pyxis$Components$Button$submit,
								A2(
									$author$project$Pyxis$Components$Button$withWidth,
									$author$project$Pyxis$Components$Button$inherit,
									A2(
										$author$project$Pyxis$Components$Button$withSize,
										$author$project$Pyxis$Components$Button$sizeXL,
										A2(
											$author$project$Pyxis$Components$Button$withDisabled,
											isDisabled,
											A2(
												$author$project$Pyxis$Components$Button$withLoading,
												isLoading,
												A2(
													$author$project$Pyxis$Components$Button$withText,
													$author$project$Translations$paymentPurchaseButtonText(i18n),
													$author$project$Pyxis$Components$Button$primary)))))))))
				]));
	});
var $author$project$Page$Payment$View$renderFormFooter = F2(
	function (i18n, model) {
		return _List_fromArray(
			[
				A2(
				$author$project$Pyxis$Components$Grid$row,
				_List_fromArray(
					[$author$project$Pyxis$Components$Grid$Row$sizeS]),
				_List_fromArray(
					[
						A2(
						$author$project$Pyxis$Components$Grid$col,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('display-flex justify-content-space-between align-items-center')
									]),
								_List_fromArray(
									[
										$author$project$Page$Payment$View$renderBackButton(i18n),
										A2($author$project$Page$Payment$View$renderPayNowButton, i18n, model)
									]))
							]))
					]))
			]);
	});
var $author$project$Translations$paymentCurrentRiskAlreadyCoveredLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy with current risk already covered';
	} else {
		return 'Una póliza para el mismo vehículo ya existe';
	}
};
var $author$project$Translations$paymentFailedCardCallIssuer = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Card declined - Please try again or contact your bank';
	} else {
		return 'Transacción denegada - Inténtelo nuevamente o contactar al banco';
	}
};
var $author$project$Translations$paymentFailedCardDeclined = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Card declined - Please contact bank';
	} else {
		return 'Transacción denegada - Por favor contactar al banco';
	}
};
var $author$project$Translations$paymentFailedCardExpired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Card expired';
	} else {
		return 'Tarjeta expirada';
	}
};
var $author$project$Translations$paymentFailedCardInsufficientFunds = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Card declined(insufficient funds) - Please contact your bank';
	} else {
		return 'Transacción denegada (fondos insuf.) - Contactar al banco';
	}
};
var $author$project$Translations$paymentFailedCardLimitExceeded = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Card declined(limit exceeded) - Please contact your bank';
	} else {
		return 'Transacción denegada (límite excedido) - Contactar al banco';
	}
};
var $author$project$Page$Payment$PaymentFailed$errorMessage = F2(
	function (i18n, code) {
		switch (code) {
			case 'ALREADY_COVERED':
				return $elm$core$Maybe$Just(
					$author$project$Translations$paymentCurrentRiskAlreadyCoveredLabel(i18n));
			case 'Limit Exceeded':
				return $elm$core$Maybe$Just(
					$author$project$Translations$paymentFailedCardLimitExceeded(i18n));
			case 'Insufficient Funds':
				return $elm$core$Maybe$Just(
					$author$project$Translations$paymentFailedCardInsufficientFunds(i18n));
			case 'Declined - Call Issuer':
				return $elm$core$Maybe$Just(
					$author$project$Translations$paymentFailedCardCallIssuer(i18n));
			case 'Do Not Honor':
				return $elm$core$Maybe$Just(
					$author$project$Translations$paymentFailedCardDeclined(i18n));
			case 'Processor Declined':
				return $elm$core$Maybe$Just(
					$author$project$Translations$paymentFailedCardDeclined(i18n));
			case 'Expired Card':
				return $elm$core$Maybe$Just(
					$author$project$Translations$paymentFailedCardExpired(i18n));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Payment$PaymentFailed$jsonToErrorCode = function (json) {
	return $elm$core$Result$toMaybe(
		A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
			json));
};
var $author$project$Translations$paymentFailedContent = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Something went wrong. Purchase not available.';
	} else {
		return 'Algo ha salido mal. La compra no está disponible.';
	}
};
var $author$project$Page$Payment$PaymentFailed$content = F2(
	function (i18n, errorList) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Translations$paymentFailedContent(i18n),
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Page$Payment$PaymentFailed$errorMessage(i18n),
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Page$Payment$PaymentFailed$jsonToErrorCode,
					A2(
						$elm$core$Maybe$andThen,
						$elm$core$Dict$get('extensions'),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.mP;
							},
							$elm$core$List$head(errorList))))));
	});
var $krisajenkins$remotedata$RemoteData$isFailure = function (data) {
	if (data.$ === 2) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Page$Payment$Model$isStatusPaymentFailed = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.dx;
	},
	$elm$core$Basics$eq(4));
var $author$project$Pyxis$Components$Grid$oneColRowSizeM = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Components$Grid$col(_List_Nil),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$author$project$Pyxis$Components$Grid$row(
			_List_fromArray(
				[$author$project$Pyxis$Components$Grid$Row$sizeM]))));
var $author$project$Translations$paymentCardDeclinedContent = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please re-enter your card details and try again.';
	} else {
		return 'No se ha podido realizar la operación. Inténtalo de nuevo.';
	}
};
var $author$project$Translations$paymentCardDeclinedTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Card declined';
	} else {
		return 'Tarjeta denegada';
	}
};
var $author$project$Translations$paymentFailedTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Purchase failed';
	} else {
		return 'Compra fallida';
	}
};
var $author$project$Translations$paymentFormHeader = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Make Payment';
	} else {
		return 'Pago de la póliza';
	}
};
var $author$project$Page$Payment$View$renderFormHeader = F2(
	function (i18n, model) {
		var paymentClientError = model.h6;
		var gotPolicyResult = model.gK;
		var viewPaymentFormHead = _List_fromArray(
			[
				$author$project$Pyxis$Components$Grid$oneColRowSizeM(
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Form$Legend$render(
						A2(
							$author$project$Pyxis$Components$Form$Legend$withTitle,
							$author$project$Translations$paymentFormHeader(i18n),
							$author$project$Pyxis$Components$Form$Legend$config))
					]))
			]);
		var renderErrorMessageContainer = function () {
			var paymentFailedContent = function () {
				if (gotPolicyResult.$ === 2) {
					var payload = gotPolicyResult.a;
					if (!payload.$) {
						var errorList = payload.b;
						return A2($author$project$Page$Payment$PaymentFailed$content, i18n, errorList);
					} else {
						return $author$project$Translations$paymentFailedContent(i18n);
					}
				} else {
					return $author$project$Translations$paymentFailedContent(i18n);
				}
			}();
			var _v0 = $author$project$Page$Payment$Model$isStatusPaymentFailed(model) ? _Utils_Tuple2(
				$author$project$Translations$paymentFailedTitle(i18n),
				paymentFailedContent) : _Utils_Tuple2(
				$author$project$Translations$paymentCardDeclinedTitle(i18n),
				$author$project$Translations$paymentCardDeclinedContent(i18n));
			var title = _v0.a;
			var content = _v0.b;
			return _List_fromArray(
				[
					$author$project$Pyxis$Components$Grid$oneColRowSizeM(
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Message$render(
							A2(
								$author$project$Pyxis$Components$Message$withContent,
								_List_fromArray(
									[
										$elm$html$Html$text(content)
									]),
								A2(
									$author$project$Pyxis$Components$Message$withTitle,
									title,
									$author$project$Pyxis$Components$Message$error($author$project$Pyxis$Components$Message$tintBackground))))
						]))
				]);
		}();
		var viewErrorMessage = function () {
			var hasPaymentFailed = $krisajenkins$remotedata$RemoteData$isFailure(gotPolicyResult);
			var hasPaymentClientError = $elm_community$maybe_extra$Maybe$Extra$isJust(paymentClientError);
			return (hasPaymentClientError || hasPaymentFailed) ? renderErrorMessageContainer : _List_Nil;
		}();
		return $elm$core$List$concat(
			_List_fromArray(
				[viewErrorMessage, viewPaymentFormHead]));
	});
var $author$project$Pyxis$Components$Form$Fieldset$withContent = F2(
	function (grid, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aX: grid});
	});
var $author$project$Pyxis$Components$Form$withFieldsets = F2(
	function (gridContent, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				cS: A2(
					$elm$core$List$map,
					A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Tuple$pair, true),
					gridContent)
			});
	});
var $author$project$Pyxis$Components$Form$Fieldset$withFooter = F2(
	function (rows, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ew: rows});
	});
var $author$project$Pyxis$Components$Form$Fieldset$withHeader = F2(
	function (rows, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{eB: rows});
	});
var $author$project$Pyxis$Components$Form$withOnSubmit = F2(
	function (onSubmit, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				k5: $elm$core$Maybe$Just(onSubmit)
			});
	});
var $author$project$Page$Payment$View$renderPaymentForm = F2(
	function (i18n, model) {
		return $author$project$Pyxis$Components$Form$render(
			A2(
				$author$project$Pyxis$Components$Form$withFieldsets,
				_List_fromArray(
					[
						A2(
						$author$project$Pyxis$Components$Form$Fieldset$withFooter,
						A2($author$project$Page$Payment$View$renderFormFooter, i18n, model),
						A2(
							$author$project$Pyxis$Components$Form$Fieldset$withContent,
							A2($author$project$Page$Payment$View$renderFormContent, i18n, model),
							A2(
								$author$project$Pyxis$Components$Form$Fieldset$withHeader,
								A2($author$project$Page$Payment$View$renderFormHeader, i18n, model),
								$author$project$Pyxis$Components$Form$Fieldset$config)))
					]),
				A2($author$project$Pyxis$Components$Form$withOnSubmit, $author$project$Page$Payment$Msg$PaymentSubmit, $author$project$Pyxis$Components$Form$config)));
	});
var $author$project$Page$Payment$View$view = F2(
	function (i18n, model) {
		var viewFetchBraintreeToken = function () {
			var _v1 = model.gI;
			switch (_v1.$) {
				case 2:
					return _List_fromArray(
						[$author$project$Common$ErrorContainer$generic]);
				case 3:
					return _List_fromArray(
						[
							A2($author$project$Page$Payment$View$renderPaymentForm, i18n, model)
						]);
				default:
					return _List_fromArray(
						[
							$author$project$Page$Payment$View$renderLoadingPage(i18n)
						]);
			}
		}();
		var content = function () {
			var _v0 = model.gJ;
			switch (_v0.$) {
				case 0:
					return _List_fromArray(
						[
							$author$project$Page$Payment$View$renderLoadingPage(i18n)
						]);
				case 1:
					return _List_fromArray(
						[
							$author$project$Page$Payment$View$renderLoadingPage(i18n)
						]);
				case 2:
					return _List_fromArray(
						[$author$project$Common$ErrorContainer$generic]);
				default:
					if (!_v0.a.b) {
						return _List_fromArray(
							[$author$project$Common$ErrorContainer$productsNotFound]);
					} else {
						return viewFetchBraintreeToken;
					}
			}
		}();
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container-responsive padding-v-3xl')
					]),
				content)
			]);
	});
var $author$project$Page$Payment$view = F2(
	function (i18n, model) {
		return {
			f$: A2($author$project$Page$Payment$View$view, i18n, model),
			iS: $author$project$Translations$routePayment(i18n)
		};
	});
var $author$project$Translations$routePolicyDetails = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy details';
	} else {
		return 'Detalles de Poliza';
	}
};
var $author$project$Page$PolicyDetails$Msg$IssueRefundConfirmation = function (a) {
	return {$: 26, a: a};
};
var $author$project$Page$PolicyDetails$Msg$IssueRefundDismissed = {$: 25};
var $author$project$Common$Policy$pickSelectedBundle = function (_v0) {
	var policy = _v0;
	return policy.av.mt;
};
var $author$project$Common$Price$amountString = F2(
	function (i18n, price) {
		return A2(
			$author$project$Common$Price$toAmountString,
			i18n,
			$author$project$Common$Price$pickAmount(price));
	});
var $author$project$Common$Price$pickCurrencySign = function (_v0) {
	var currency = _v0.b;
	return $author$project$Common$Price$pickSign(currency);
};
var $author$project$Translations$policyInterruptionModalExpectedNoRefundAmountMessage = F3(
	function (data, bAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					$elm$html$Html$text('Customer should not be eligible for a '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(data.lo + (' ' + data.ln))
						])),
					$elm$html$Html$text(' refund.')
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('El cliente no tendría derecho a un reembolso de '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(data.ln + (' ' + data.lo))
						])),
					$elm$html$Html$text('.')
				]);
		}
	});
var $author$project$Translations$policyInterruptionModalExpectedRefundAmountMessage = F3(
	function (data, bAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					$elm$html$Html$text('Customer\'s eligible for a '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(data.lo + (' ' + data.ln))
						])),
					$elm$html$Html$text(' refund.')
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('El cliente tiene derecho a un reembolso de '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(data.ln + (' ' + data.lo))
						])),
					$elm$html$Html$text('.')
				]);
		}
	});
var $author$project$Translations$policyInterruptionModalExpectedRefundNotAvailableMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The refund estimate could not be processed';
	} else {
		return 'No se pudo procesar la estimación del reembolso';
	}
};
var $author$project$Pyxis$Components$Message$Success = 3;
var $author$project$Pyxis$Components$Message$success = function (style) {
	return A2($author$project$Pyxis$Components$Message$config, 3, style);
};
var $author$project$Pyxis$Components$Loaders$Loader$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{f6: classList});
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$expectedRefundMessage = F2(
	function (i18n, remoteData) {
		switch (remoteData.$) {
			case 0:
				return $elm_community$html_extra$Html$Extra$nothing;
			case 1:
				return $author$project$Pyxis$Components$Loaders$Loader$render(
					A2(
						$author$project$Pyxis$Components$Loaders$Loader$withClassList,
						_List_fromArray(
							[
								_Utils_Tuple2('margin-t-l es-fe-bo--full-width', true)
							]),
						$author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM));
			case 2:
				return $author$project$Pyxis$Components$Message$render(
					A2(
						$author$project$Pyxis$Components$Message$withClassList,
						_List_fromArray(
							[
								_Utils_Tuple2('policy-details__policy-interruption__refund-amount-message', true)
							]),
						A2(
							$author$project$Pyxis$Components$Message$withContent,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$policyInterruptionModalExpectedRefundNotAvailableMessage(i18n))
								]),
							$author$project$Pyxis$Components$Message$alert($author$project$Pyxis$Components$Message$tintBackground))));
			default:
				if (!remoteData.a.$) {
					var price = remoteData.a.a;
					return $author$project$Pyxis$Components$Message$render(
						A2(
							$author$project$Pyxis$Components$Message$withClassList,
							_List_fromArray(
								[
									_Utils_Tuple2('policy-details__policy-interruption__refund-amount-message', true)
								]),
							A2(
								$author$project$Pyxis$Components$Message$withContent,
								A3(
									$author$project$Translations$policyInterruptionModalExpectedNoRefundAmountMessage,
									{
										ln: A2($author$project$Common$Price$amountString, i18n, price),
										lo: $author$project$Common$Price$pickCurrencySign(price)
									},
									_List_Nil,
									i18n),
								$author$project$Pyxis$Components$Message$error($author$project$Pyxis$Components$Message$tintBackground))));
				} else {
					var price = remoteData.a.a;
					return $author$project$Pyxis$Components$Message$render(
						A2(
							$author$project$Pyxis$Components$Message$withClassList,
							_List_fromArray(
								[
									_Utils_Tuple2('policy-details__policy-interruption__refund-amount-message', true)
								]),
							A2(
								$author$project$Pyxis$Components$Message$withContent,
								A3(
									$author$project$Translations$policyInterruptionModalExpectedRefundAmountMessage,
									{
										ln: A2($author$project$Common$Price$amountString, i18n, price),
										lo: $author$project$Common$Price$pickCurrencySign(price)
									},
									_List_Nil,
									i18n),
								$author$project$Pyxis$Components$Message$success($author$project$Pyxis$Components$Message$tintBackground))));
				}
		}
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$formId = 'amend-policy-interruption-form';
var $primait$prima_elm_extra$PrimaFunction$ifThenMap = F3(
	function (condition, mapper, m) {
		return condition(m) ? mapper(m) : m;
	});
var $author$project$Common$ReasonDescriptionStatus$isDescriptionValid = F2(
	function (text, status) {
		return (!(!status)) || ((!_Utils_eq(text, $elm$core$Maybe$Nothing)) && (!_Utils_eq(
			text,
			$elm$core$Maybe$Just(''))));
	});
var $elm$core$Maybe$map4 = F5(
	function (func, ma, mb, mc, md) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					if (md.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var d = md.a;
						return $elm$core$Maybe$Just(
							A4(func, a, b, c, d));
					}
				}
			}
		}
	});
var $author$project$Pyxis$Components$Field$Autocomplete$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Autocomplete$M = 1;
var $author$project$Pyxis$Components$Field$Autocomplete$config = function (name) {
	return {fJ: $elm$core$Maybe$Nothing, f6: _List_Nil, ej: _List_Nil, go: false, cM: $elm$core$Maybe$Nothing, gC: $elm$core$Maybe$Nothing, gR: $elm$core$Maybe$Nothing, kg: 'id-' + name, cY: false, eR: $elm$core$Maybe$Nothing, kF: name, hw: 'No results found.', h9: '', is: false, iu: 'Reset', aO: 1, fq: $elm$core$Maybe$Nothing, fv: $elm$core$Maybe$Nothing, dQ: $elm$core$Maybe$Nothing};
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$formIsSubmitted = function (status) {
	if (status === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Translations$policyInterruptionModalReasonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Reason';
	} else {
		return 'Motivo';
	}
};
var $author$project$Translations$policyInterruptionModalReasonPlaceholder = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Select the reason';
	} else {
		return 'Seleccionar el motivo';
	}
};
var $author$project$Pyxis$Components$Field$Autocomplete$generateErrorConfig = F2(
	function (_v0, _v1) {
		var fieldStatus = _v0.ev;
		var value = _v0.pB;
		var id = _v1.kg;
		var isSubmitted = _v1.cY;
		var validation = _v1.dQ;
		var errorShowingStrategy = _v1.cM;
		var validationRes = A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Maybe$map,
				A4($author$project$Pyxis$Commons$Validation$generateValidationResult, fieldStatus, isSubmitted, value, validation),
				errorShowingStrategy));
		return A3(
			$elm$core$Maybe$map2,
			A2(
				$author$project$Pyxis$Components$Field$Error$buildErrorConfig,
				fieldStatus,
				{kg: id, cY: isSubmitted}),
			validationRes,
			errorShowingStrategy);
	});
var $author$project$Pyxis$Components$Field$Label$sizeM = 1;
var $author$project$Pyxis$Components$Field$Label$S = 0;
var $author$project$Pyxis$Components$Field$Label$sizeS = 0;
var $author$project$Pyxis$Components$Field$Autocomplete$mapLabelSize = function (size) {
	if (!size) {
		return $author$project$Pyxis$Components$Field$Label$sizeS;
	} else {
		return $author$project$Pyxis$Components$Field$Label$sizeM;
	}
};
var $author$project$Pyxis$Components$Field$Autocomplete$OnMouseDown = {$: 7};
var $author$project$Pyxis$Components$Form$Dropdown$M = 1;
var $author$project$Pyxis$Components$Form$Dropdown$sizeM = 1;
var $author$project$Pyxis$Components$Form$Dropdown$S = 0;
var $author$project$Pyxis$Components$Form$Dropdown$sizeS = 0;
var $author$project$Pyxis$Components$Field$Autocomplete$mapDropdownSize = function (size) {
	if (!size) {
		return $author$project$Pyxis$Components$Form$Dropdown$sizeS;
	} else {
		return $author$project$Pyxis$Components$Form$Dropdown$sizeM;
	}
};
var $author$project$Pyxis$Components$Form$Dropdown$NoResult = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Form$Dropdown$noResult = $author$project$Pyxis$Components$Form$Dropdown$NoResult;
var $author$project$Pyxis$Components$Form$Dropdown$Options = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pyxis$Components$Form$Dropdown$options = $author$project$Pyxis$Components$Form$Dropdown$Options;
var $author$project$Pyxis$Commons$Events$preventDefaultOn = F2(
	function (event, msg) {
		return A2(
			$elm$html$Html$Events$preventDefaultOn,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (msg_) {
					return _Utils_Tuple2(msg_, true);
				},
				$elm$json$Json$Decode$succeed(msg)));
	});
var $author$project$Pyxis$Components$Form$Dropdown$renderNoResult = function (_v0) {
	var label = _v0.eR;
	var action = _v0.T;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-dropdown__no-results')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label),
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$singleton,
						$elm$html$Html$div(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-dropdown__no-results__action')
								]))),
					action))
			]));
};
var $author$project$Pyxis$Components$Form$Dropdown$renderSuggestionIcon = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Components$Icon$config,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeM),
		A2(
			$elm$core$Basics$composeR,
			$author$project$Pyxis$Components$Icon$withClassList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-dropdown__suggestion__icon', true)
					])),
			$author$project$Pyxis$Components$Icon$render)));
var $author$project$Pyxis$Components$Form$Dropdown$renderSuggestionSubtitle = function (subtitle) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-dropdown__suggestion__subtitle')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(subtitle)
			]));
};
var $author$project$Pyxis$Components$Form$Dropdown$renderSuggestionTitle = function (title) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-dropdown__suggestion__title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(title)
			]));
};
var $author$project$Pyxis$Components$Form$Dropdown$renderSuggestion = function (_v0) {
	var icon = _v0.kf;
	var title = _v0.iS;
	var subtitle = _v0.dI;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-dropdown__suggestion')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Form$Dropdown$renderSuggestionIcon(icon),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-dropdown__suggestion__wrapper')
					]),
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Form$Dropdown$renderSuggestionTitle(title),
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Form$Dropdown$renderSuggestionSubtitle, subtitle))
					]))
			]));
};
var $author$project$Pyxis$Components$Form$Dropdown$renderContent = function (content_) {
	switch (content_.$) {
		case 1:
			var options_ = content_.a;
			return options_;
		case 0:
			var noResultData = content_.a;
			return _List_fromArray(
				[
					$author$project$Pyxis$Components$Form$Dropdown$renderNoResult(noResultData)
				]);
		default:
			var config = content_.a;
			return _List_fromArray(
				[
					$author$project$Pyxis$Components$Form$Dropdown$renderSuggestion(config)
				]);
	}
};
var $author$project$Pyxis$Components$Form$Dropdown$render = F3(
	function (id, size, content_) {
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'role', 'listbox'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-dropdown', true),
							_Utils_Tuple2('form-dropdown--with-animation', true),
							_Utils_Tuple2('form-dropdown--s', !size)
						])),
					$elm$html$Html$Attributes$id(id + '-dropdown-list')
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, item) {
						return _Utils_Tuple2(
							$elm$core$String$fromInt(index),
							item);
					}),
				$author$project$Pyxis$Components$Form$Dropdown$renderContent(content_)));
	});
var $author$project$Pyxis$Components$Field$Autocomplete$OnHover = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pyxis$Components$Field$Autocomplete$OnSelect = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pyxis$Components$IconSet$Check = 185;
var $author$project$Pyxis$Components$IconSet$check = 185;
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $author$project$Pyxis$Components$Field$Autocomplete$renderOptionText = F3(
	function (filteringValue, isSelected, label) {
		var _v0 = _Utils_Tuple2(
			isSelected,
			!$elm$core$String$length(filteringValue));
		if (_v0.a) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-l-bold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				]);
		} else {
			if (_v0.b) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-l-book')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]))
					]);
			} else {
				var matchStartIndex = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$List$head(
						A2(
							$elm$core$String$indexes,
							$elm$core$String$toLower(filteringValue),
							$elm$core$String$toLower(label))));
				var matchEndIndex = matchStartIndex + $elm$core$String$length(filteringValue);
				var labelStart = A3($elm$core$String$slice, 0, matchStartIndex, label);
				var labelEnd = A3(
					$elm$core$String$slice,
					matchEndIndex,
					$elm$core$String$length(label),
					label);
				var labelCenter = A3($elm$core$String$slice, matchStartIndex, matchEndIndex, label);
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-l-bold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(labelStart)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-l-book')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(labelCenter)
							])),
						A2(
						$elm$html$Html$strong,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-l-bold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(labelEnd)
							]))
					]);
			}
		}
	});
var $author$project$Pyxis$Tokens$TypographyColor$ContentOnActionSurface = 5;
var $author$project$Pyxis$Tokens$TypographyColor$tokenContentOnActionSurface = 5;
var $elm$core$String$trim = _String_trim;
var $author$project$Pyxis$Components$Field$Autocomplete$renderOptionsItem = F3(
	function (msgMapper, _v0, option_) {
		var modelData = _v0;
		var value = option_.pB;
		var label = option_.eR;
		var id = option_.kg;
		var isSelectedOption = _Utils_eq(
			modelData.pB,
			$elm$core$Maybe$Just(value));
		var isActiveOption = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pB;
						},
						$elm$core$Basics$eq(value))),
				modelData.H));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-dropdown__item'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-dropdown__item--active', isSelectedOption),
							_Utils_Tuple2('form-dropdown__item--hover', isActiveOption && (!isSelectedOption))
						])),
					$elm$html$Html$Attributes$id(id),
					$author$project$Pyxis$Commons$Attributes$role('option'),
					A2(
					$author$project$Pyxis$Commons$Events$preventDefaultOn,
					'mousedown',
					msgMapper(
						$author$project$Pyxis$Components$Field$Autocomplete$OnSelect(value))),
					$elm$html$Html$Events$onMouseEnter(
					msgMapper(
						$author$project$Pyxis$Components$Field$Autocomplete$OnHover(option_)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					A3(
						$author$project$Pyxis$Components$Field$Autocomplete$renderOptionText,
						modelData.E,
						isSelectedOption,
						$elm$core$String$trim(label))),
					A2(
					$author$project$Pyxis$Commons$Render$renderIf,
					isSelectedOption,
					$author$project$Pyxis$Components$Icon$render(
						A2(
							$author$project$Pyxis$Components$Icon$withColor,
							$author$project$Pyxis$Tokens$TypographyColor$tokenContentOnActionSurface,
							A2(
								$author$project$Pyxis$Components$Icon$withSize,
								$author$project$Pyxis$Components$Icon$sizeL,
								$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$check)))))
				]));
	});
var $author$project$Pyxis$Components$Form$Dropdown$Suggestion = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pyxis$Components$Form$Dropdown$suggestion = $author$project$Pyxis$Components$Form$Dropdown$Suggestion;
var $author$project$Pyxis$Components$Field$Autocomplete$renderDropdown = F3(
	function (msgMapper, model, _v0) {
		var modelData = model;
		var configData = _v0;
		var wrap = function (html) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$author$project$Pyxis$Commons$Events$preventDefaultOn,
						'mousedown',
						msgMapper($author$project$Pyxis$Components$Field$Autocomplete$OnMouseDown))
					]),
				_List_fromArray(
					[html]));
		};
		var renderedOptions = A2(
			$elm$core$List$map,
			A2($author$project$Pyxis$Components$Field$Autocomplete$renderOptionsItem, msgMapper, model),
			$author$project$Pyxis$Components$Field$Autocomplete$getOptions(model));
		var noAvailableOptions = (!$elm$core$List$length(
			$author$project$Pyxis$Components$Field$Autocomplete$getOptions(model))) && $krisajenkins$remotedata$RemoteData$isSuccess(modelData.aw);
		return ($elm$core$String$isEmpty(modelData.E) && $elm$core$List$isEmpty(renderedOptions)) ? A2(
			$elm$core$Maybe$map,
			wrap,
			A2(
				$elm$core$Maybe$map,
				A2(
					$author$project$Pyxis$Components$Form$Dropdown$render,
					configData.kg,
					$author$project$Pyxis$Components$Field$Autocomplete$mapDropdownSize(configData.aO)),
				A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Form$Dropdown$suggestion, configData.fq))) : (modelData.eA ? $elm$core$Maybe$Just(
			wrap(
				A3(
					$author$project$Pyxis$Components$Form$Dropdown$render,
					configData.kg,
					$author$project$Pyxis$Components$Field$Autocomplete$mapDropdownSize(configData.aO),
					function () {
						if (noAvailableOptions) {
							return $author$project$Pyxis$Components$Form$Dropdown$noResult(
								{T: configData.gC, eR: configData.hw});
						} else {
							var _v1 = configData.fq;
							if (!_v1.$) {
								var suggestionConfig = _v1.a;
								return ((!$krisajenkins$remotedata$RemoteData$isSuccess(modelData.aw)) && $elm$core$String$isEmpty(modelData.E)) ? $author$project$Pyxis$Components$Form$Dropdown$suggestion(suggestionConfig) : $author$project$Pyxis$Components$Form$Dropdown$options(renderedOptions);
							} else {
								return $author$project$Pyxis$Components$Form$Dropdown$options(renderedOptions);
							}
						}
					}()))) : $elm$core$Maybe$Nothing);
	});
var $author$project$Pyxis$Components$Field$Autocomplete$OnBlur = {$: 0};
var $author$project$Pyxis$Components$Field$Autocomplete$OnFocus = {$: 1};
var $author$project$Pyxis$Components$Field$Autocomplete$OnInput = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pyxis$Components$Field$Autocomplete$OnInputMouseDown = {$: 8};
var $author$project$Pyxis$Commons$Attributes$ariaActiveDescendant = $elm$html$Html$Attributes$attribute('aria-activedescendant');
var $author$project$Pyxis$Commons$Attributes$ariaAutocomplete = $elm$html$Html$Attributes$attribute('aria-autocomplete');
var $author$project$Pyxis$Commons$Attributes$ariaOwns = $elm$html$Html$Attributes$attribute('aria-owns');
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $author$project$Pyxis$Components$Field$Autocomplete$getFormFieldSizeClass = function (size) {
	if (!size) {
		return 'form-field__autocomplete--s';
	} else {
		return '';
	}
};
var $author$project$Pyxis$Components$Field$Autocomplete$OnKeyDown = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pyxis$Components$Field$Autocomplete$handleSelectKeydown = function (key) {
	return _Utils_Tuple2(
		$author$project$Pyxis$Components$Field$Autocomplete$OnKeyDown(key),
		A2(
			$elm$core$List$any,
			function (check) {
				return check(key);
			},
			_List_fromArray(
				[$author$project$Pyxis$Commons$Events$Keyboard$isArrowUp, $author$project$Pyxis$Commons$Events$Keyboard$isArrowDown, $author$project$Pyxis$Commons$Events$Keyboard$isEnter])));
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Events$onMouseDown = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mousedown',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$Pyxis$Components$Field$Autocomplete$OnReset = {$: 4};
var $author$project$Pyxis$Components$IconSet$MagnifyingGlass = 82;
var $author$project$Pyxis$Components$IconSet$magnifyingGlass = 82;
var $author$project$Pyxis$Components$Field$Autocomplete$getFieldAddonIcon = function (_v0) {
	var modelData = _v0;
	return $elm_community$maybe_extra$Maybe$Extra$isJust(modelData.pB) ? $author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$cross) : $author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$magnifyingGlass);
};
var $author$project$Pyxis$Components$Field$Autocomplete$iconSizeByAutocompleteSize = function (size) {
	if (!size) {
		return $author$project$Pyxis$Components$Icon$sizeS;
	} else {
		return $author$project$Pyxis$Components$Icon$sizeM;
	}
};
var $author$project$Pyxis$Commons$Events$stopPropagationOn = F2(
	function (event, msg) {
		return A2(
			$elm$html$Html$Events$stopPropagationOn,
			event,
			$elm$json$Json$Decode$succeed(
				_Utils_Tuple2(msg, true)));
	});
var $author$project$Pyxis$Components$Field$Autocomplete$renderFieldIconAddon = F4(
	function (size, resetLabel, disabled, model) {
		var modelData = model;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-field__addon', true),
							_Utils_Tuple2(
							'form-field__addon--loading',
							$krisajenkins$remotedata$RemoteData$isLoading(modelData.aw))
						])),
					A2($author$project$Pyxis$Commons$Events$stopPropagationOn, 'mousedown', $author$project$Pyxis$Components$Field$Autocomplete$OnMouseDown)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pyxis$Commons$Render$renderIf,
					$elm_community$maybe_extra$Maybe$Extra$isNothing(modelData.pB),
					$author$project$Pyxis$Components$Icon$render(
						A2(
							$author$project$Pyxis$Components$Icon$withSize,
							$author$project$Pyxis$Components$Field$Autocomplete$iconSizeByAutocompleteSize(size),
							$author$project$Pyxis$Components$Field$Autocomplete$getFieldAddonIcon(model)))),
					A2(
					$author$project$Pyxis$Commons$Render$renderIf,
					$elm_community$maybe_extra$Maybe$Extra$isJust(modelData.pB) && (!disabled),
					$author$project$Pyxis$Components$Button$render(
						A2(
							$author$project$Pyxis$Components$Button$withIconOnly,
							$author$project$Pyxis$Components$IconSet$cross,
							A2(
								$author$project$Pyxis$Components$Button$withOnClick,
								$author$project$Pyxis$Components$Field$Autocomplete$OnReset,
								A2(
									$author$project$Pyxis$Components$Button$withSize,
									$author$project$Pyxis$Components$Button$sizeS,
									A2($author$project$Pyxis$Components$Button$withAriaLabel, resetLabel, $author$project$Pyxis$Components$Button$ghost))))))
				]));
	});
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Pyxis$Components$Field$Autocomplete$renderField = F4(
	function (error, msgMapper, model, _v0) {
		var modelData = model;
		var configData = _v0;
		var activeOptionId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
					function ($) {
						return $.kg;
					}),
				modelData.H));
		return A2(
			$elm$html$Html$map,
			msgMapper,
			A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-field__wrapper'),
						$elm$html$Html$Events$onMouseDown($author$project$Pyxis$Components$Field$Autocomplete$OnInputMouseDown)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						A2(
							$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
							configData.ej,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('form-field__autocomplete', true),
											_Utils_Tuple2(
											'form-field__autocomplete--filled',
											$elm_community$maybe_extra$Maybe$Extra$isJust(modelData.pB)),
											_Utils_Tuple2(
											$author$project$Pyxis$Components$Field$Autocomplete$getFormFieldSizeClass(configData.aO),
											true)
										])),
									A2($author$project$Pyxis$Commons$Events$Keyboard$onPreventDefaultOn, 'keydown', $author$project$Pyxis$Components$Field$Autocomplete$handleSelectKeydown),
									$elm$html$Html$Events$onFocus($author$project$Pyxis$Components$Field$Autocomplete$OnFocus),
									$elm$html$Html$Events$onBlur($author$project$Pyxis$Components$Field$Autocomplete$OnBlur),
									$elm$html$Html$Events$onInput($author$project$Pyxis$Components$Field$Autocomplete$OnInput),
									$elm$html$Html$Attributes$id(configData.kg),
									A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, configData.fv),
									$elm$html$Html$Attributes$name(configData.kF),
									$author$project$Pyxis$Commons$Attributes$ariaAutocomplete('both'),
									A2(
									$author$project$Pyxis$Commons$Attributes$renderIf,
									modelData.a2,
									$author$project$Pyxis$Commons$Attributes$ariaExpanded(true)),
									$author$project$Pyxis$Commons$Attributes$role('combobox'),
									$author$project$Pyxis$Commons$Attributes$ariaOwns(configData.kg + '-dropdown-list'),
									$author$project$Pyxis$Commons$Attributes$ariaActiveDescendant(activeOptionId),
									$elm$html$Html$Attributes$autocomplete(false),
									$elm$html$Html$Attributes$disabled(configData.go),
									$elm$html$Html$Attributes$required(configData.is),
									$elm$html$Html$Attributes$placeholder(configData.h9),
									$elm$html$Html$Attributes$type_('text'),
									A2(
									$author$project$Pyxis$Commons$Attributes$renderIf,
									!modelData.bO,
									$elm$html$Html$Attributes$value(modelData.E)),
									A2(
									$author$project$Pyxis$Commons$Attributes$renderIf,
									modelData.bO,
									$elm$html$Html$Attributes$value(modelData.E)),
									$author$project$Pyxis$Commons$Attributes$ariaInvalid(
									$author$project$Pyxis$Components$Field$Error$isVisible(error)),
									A2(
									$author$project$Pyxis$Commons$Attributes$ariaDescribedByErrorOrHint,
									A2($author$project$Pyxis$Components$Field$Error$idFromFieldIdIfVisible, error, configData.kg),
									A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$always(
											$author$project$Pyxis$Components$Field$Hint$toId(configData.kg)),
										configData.gR))
								])),
						_List_Nil),
						A4($author$project$Pyxis$Components$Field$Autocomplete$renderFieldIconAddon, configData.aO, configData.iu, configData.go, model)
					])));
	});
var $author$project$Pyxis$Components$Field$Label$withSize = F2(
	function (a, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aO: a});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$render = F3(
	function (msgMapper, model, config_) {
		var modelData = model;
		var configData = config_;
		var error = A2($author$project$Pyxis$Components$Field$Autocomplete$generateErrorConfig, model, config_);
		var dropdown = A3($author$project$Pyxis$Components$Field$Autocomplete$renderDropdown, msgMapper, model, config_);
		var customizedLabel = A2(
			$elm$core$Maybe$map,
			$author$project$Pyxis$Components$Field$Label$withSize(
				$author$project$Pyxis$Components$Field$Autocomplete$mapLabelSize(configData.aO)),
			configData.eR);
		return A2(
			$author$project$Pyxis$Components$Form$FormItem$render,
			error,
			A2(
				$author$project$Pyxis$Components$Form$FormItem$withAdditionalContent,
				configData.fJ,
				A2(
					$author$project$Pyxis$Components$Form$FormItem$withLabel,
					customizedLabel,
					A2(
						$author$project$Pyxis$Components$Form$FormItem$withClassList,
						configData.f6,
						A2(
							$author$project$Pyxis$Components$Form$FormItem$config,
							configData,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('form-field', true),
												_Utils_Tuple2(
												'form-field--with-opened-dropdown',
												modelData.a2 && ($elm_community$maybe_extra$Maybe$Extra$isJust(dropdown) && $krisajenkins$remotedata$RemoteData$isSuccess(modelData.aw))),
												_Utils_Tuple2(
												'form-field--error',
												$author$project$Pyxis$Components$Field$Error$isVisible(error)),
												_Utils_Tuple2('form-field--disabled', configData.go)
											]))
									]),
								_List_fromArray(
									[
										A4($author$project$Pyxis$Components$Field$Autocomplete$renderField, error, msgMapper, model, config_),
										$author$project$Pyxis$Commons$Render$renderMaybe(dropdown)
									])))))));
	});
var $author$project$Pyxis$Components$Field$Autocomplete$S = 0;
var $author$project$Pyxis$Components$Field$Autocomplete$sizeS = 0;
var $author$project$Translations$validationErrorsRequired = F2(
	function (fieldName, _v0) {
		var lang = _v0;
		if (!lang) {
			return fieldName + ' is required';
		} else {
			return fieldName + ' es obligatorio';
		}
	});
var $author$project$Functions$whenElse = F3(
	function (ifTrue, ifFalse, condition) {
		return condition ? ifTrue : ifFalse;
	});
var $author$project$Pyxis$Components$Field$Autocomplete$withLabel = F2(
	function (label, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				eR: $elm$core$Maybe$Just(label)
			});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$withPlaceholder = F2(
	function (placeholder, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{h9: placeholder});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$withSize = F2(
	function (size, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aO: size});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$withValidationOnSubmit = F3(
	function (validation, isSubmitted, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				cM: $elm$core$Maybe$Just($author$project$Pyxis$Components$Field$Error$onSubmit),
				cY: isSubmitted,
				dQ: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeR, validation, $author$project$Pyxis$Commons$ValidationResult$fromResult))
			});
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$reasonSelect = F3(
	function (i18n, _v0, onReasonSelected) {
		var reasonInput = _v0.aN;
		var formStatus = _v0.aE;
		var errorMessage = A2(
			$author$project$Translations$validationErrorsRequired,
			$author$project$Translations$policyInterruptionModalReasonLabel(i18n),
			i18n);
		var reasonToValidationResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$Result$fromMaybe(errorMessage),
			$elm$core$Result$map(
				$elm$core$Basics$always(0)));
		var validation = function (reason) {
			return A3(
				$author$project$Functions$whenElse,
				reasonToValidationResult(reason),
				$elm$core$Result$Ok(0),
				true);
		};
		return A3(
			$author$project$Pyxis$Components$Field$Autocomplete$render,
			onReasonSelected,
			reasonInput,
			A2(
				$author$project$Pyxis$Components$Field$Autocomplete$withLabel,
				A2(
					$author$project$Pyxis$Components$Field$Label$withText,
					$author$project$Translations$policyInterruptionModalReasonLabel(i18n),
					$author$project$Pyxis$Components$Field$Label$config),
				A3(
					$author$project$Pyxis$Components$Field$Autocomplete$withValidationOnSubmit,
					validation,
					$author$project$Page$PolicyDetails$AmendInterruptionModal$formIsSubmitted(formStatus),
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$withSize,
						$author$project$Pyxis$Components$Field$Autocomplete$sizeS,
						A2(
							$author$project$Pyxis$Components$Field$Autocomplete$withPlaceholder,
							$author$project$Translations$policyInterruptionModalReasonPlaceholder(i18n),
							$author$project$Pyxis$Components$Field$Autocomplete$config('reason-kind'))))));
	});
var $author$project$Pyxis$Components$Field$Textarea$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Textarea$M = 1;
var $author$project$Pyxis$Components$Field$Textarea$config = function (name) {
	return {fJ: $elm$core$Maybe$Nothing, fY: $elm$core$Maybe$Nothing, f6: _List_Nil, ej: _List_Nil, go: false, cM: $elm$core$Maybe$Nothing, gQ: $elm$core$Maybe$Nothing, gR: $elm$core$Maybe$Nothing, kg: 'id-' + name, cY: false, eR: $elm$core$Maybe$Nothing, kF: name, h9: $elm$core$Maybe$Nothing, is: false, aO: 1, fv: $elm$core$Maybe$Nothing, dQ: $elm$core$Maybe$Nothing, iZ: $elm$core$Basics$identity};
};
var $author$project$Common$ReasonDescriptionStatus$descriptionIsDisabled = A2(
	$primait$prima_elm_extra$PrimaFunction$flip,
	$elm$core$List$member,
	_List_fromArray(
		[2, 3]));
var $author$project$Translations$policyInterruptionModalReasonDescriptionLabelMandatory = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Additional note (mandatory)';
	} else {
		return 'Notas adicionales (obligatório)';
	}
};
var $author$project$Translations$policyInterruptionModalReasonDescriptionLabelNotRequired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Additional note is not required for this reason';
	} else {
		return 'Por este motivo, no es necesaria una nota adicional';
	}
};
var $author$project$Translations$policyInterruptionModalReasonDescriptionLabelNotSet = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Additional note (select the reason first)';
	} else {
		return 'Nota adicional (seleccione primero el motivo)';
	}
};
var $author$project$Translations$policyInterruptionModalReasonDescriptionLabelOptional = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Additional note (optional)';
	} else {
		return 'Notas adicionales (opcional)';
	}
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$descriptionTextareaLabel = F2(
	function (i18n, _v0) {
		var descriptionStatus = _v0.bD;
		switch (descriptionStatus) {
			case 0:
				return $author$project$Translations$policyInterruptionModalReasonDescriptionLabelMandatory(i18n);
			case 1:
				return $author$project$Translations$policyInterruptionModalReasonDescriptionLabelOptional(i18n);
			case 2:
				return $author$project$Translations$policyInterruptionModalReasonDescriptionLabelNotRequired(i18n);
			default:
				return $author$project$Translations$policyInterruptionModalReasonDescriptionLabelNotSet(i18n);
		}
	});
var $author$project$Pyxis$Components$Field$Textarea$generateErrorConfig = F2(
	function (_v0, _v1) {
		var fieldStatus = _v0.ev;
		var value = _v0.pB;
		var id = _v1.kg;
		var isSubmitted = _v1.cY;
		var validation = _v1.dQ;
		var errorShowingStrategy = _v1.cM;
		var validationRes = A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Maybe$map,
				A4($author$project$Pyxis$Commons$Validation$generateValidationResult, fieldStatus, isSubmitted, value, validation),
				errorShowingStrategy));
		return A3(
			$elm$core$Maybe$map2,
			A2(
				$author$project$Pyxis$Components$Field$Error$buildErrorConfig,
				fieldStatus,
				{kg: id, cY: isSubmitted}),
			validationRes,
			errorShowingStrategy);
	});
var $author$project$Pyxis$Components$Field$Textarea$mapLabelSize = function (size) {
	if (!size) {
		return $author$project$Pyxis$Components$Field$Label$sizeS;
	} else {
		return $author$project$Pyxis$Components$Field$Label$sizeM;
	}
};
var $author$project$Pyxis$Components$Field$Textarea$OnBlur = {$: 2};
var $author$project$Pyxis$Components$Field$Textarea$OnFocus = {$: 1};
var $author$project$Pyxis$Components$Field$Textarea$OnInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Field$Textarea$getFormFieldTextareaSizeClass = function (size) {
	if (!size) {
		return 'form-field__textarea--s';
	} else {
		return '';
	}
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Pyxis$Components$Field$Textarea$toTextareaHeightCssVariable = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$fromInt,
	A2(
		$elm$core$Basics$composeR,
		A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Basics$append, 'px'),
		$elm$core$Basics$append('--textarea-min-height: ')));
var $author$project$Pyxis$Components$Field$Textarea$renderTextarea = F3(
	function (error, _v0, _v1) {
		var modelData = _v0;
		var configData = _v1;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-field', true),
							_Utils_Tuple2(
							'form-field--error',
							$author$project$Pyxis$Components$Field$Error$isVisible(error)),
							_Utils_Tuple2('form-field--disabled', configData.go)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$textarea,
					A2(
						$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
						configData.ej,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id(configData.kg),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('form-field__textarea', true),
										_Utils_Tuple2(
										$author$project$Pyxis$Components$Field$Textarea$getFormFieldTextareaSizeClass(configData.aO),
										true)
									])),
								$elm$html$Html$Attributes$disabled(configData.go),
								$elm$html$Html$Attributes$required(configData.is),
								$elm$html$Html$Attributes$name(configData.kF),
								$elm$html$Html$Attributes$value(modelData.pB),
								A2(
								$author$project$Pyxis$Commons$Attributes$maybe,
								$elm$html$Html$Attributes$attribute('autocomplete'),
								configData.fY),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, configData.fv),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$placeholder, configData.h9),
								$author$project$Pyxis$Commons$Attributes$ariaInvalid(
								$author$project$Pyxis$Components$Field$Error$isVisible(error)),
								A2(
								$author$project$Pyxis$Commons$Attributes$ariaDescribedByErrorOrHint,
								A2($author$project$Pyxis$Components$Field$Error$idFromFieldIdIfVisible, error, configData.kg),
								A2(
									$elm$core$Maybe$map,
									$elm$core$Basics$always(
										$author$project$Pyxis$Components$Field$Hint$toId(configData.kg)),
									configData.gR)),
								A2(
								$author$project$Pyxis$Commons$Attributes$maybe,
								$elm$html$Html$Attributes$attribute('style'),
								A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Field$Textarea$toTextareaHeightCssVariable, configData.gQ)),
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeR, configData.iZ, $author$project$Pyxis$Components$Field$Textarea$OnInput)),
								$elm$html$Html$Events$onFocus($author$project$Pyxis$Components$Field$Textarea$OnFocus),
								$elm$html$Html$Events$onBlur($author$project$Pyxis$Components$Field$Textarea$OnBlur)
							])),
					_List_Nil)
				]));
	});
var $author$project$Pyxis$Components$Field$Textarea$render = F3(
	function (tagger, model, config_) {
		var configData = config_;
		var error = A2($author$project$Pyxis$Components$Field$Textarea$generateErrorConfig, model, config_);
		var customizedLabel = A2(
			$elm$core$Maybe$map,
			$author$project$Pyxis$Components$Field$Label$withSize(
				$author$project$Pyxis$Components$Field$Textarea$mapLabelSize(configData.aO)),
			configData.eR);
		return A2(
			$author$project$Pyxis$Components$Form$FormItem$render,
			error,
			A2(
				$author$project$Pyxis$Components$Form$FormItem$withAdditionalContent,
				configData.fJ,
				A2(
					$author$project$Pyxis$Components$Form$FormItem$withClassList,
					configData.f6,
					A2(
						$author$project$Pyxis$Components$Form$FormItem$withLabel,
						customizedLabel,
						A2(
							$author$project$Pyxis$Components$Form$FormItem$config,
							configData,
							A2(
								$elm$html$Html$map,
								tagger,
								A3($author$project$Pyxis$Components$Field$Textarea$renderTextarea, error, model, config_)))))));
	});
var $author$project$Pyxis$Components$Field$Textarea$sizeM = 1;
var $author$project$Pyxis$Components$Field$Textarea$withDisabled = F2(
	function (isDisabled, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{go: isDisabled});
	});
var $author$project$Pyxis$Components$Field$Textarea$withLabel = F2(
	function (label, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				eR: $elm$core$Maybe$Just(label)
			});
	});
var $author$project$Pyxis$Components$Field$Textarea$withSize = F2(
	function (size, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aO: size});
	});
var $author$project$Pyxis$Components$Field$Textarea$withValidationOnSubmit = F3(
	function (validation, isSubmitted, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				cM: $elm$core$Maybe$Just($author$project$Pyxis$Components$Field$Error$onSubmit),
				cY: isSubmitted,
				dQ: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeR, validation, $author$project$Pyxis$Commons$ValidationResult$fromResult))
			});
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$renderDescriptionInput = F2(
	function (i18n, model) {
		var onDescriptionChanges = model.kR;
		var descriptionInput = model.aC;
		var descriptionStatus = model.bD;
		var formStatus = model.aE;
		var errorMessage = A2(
			$author$project$Translations$validationErrorsRequired,
			$author$project$Translations$policyInterruptionModalReasonLabel(i18n),
			i18n);
		var validation = function (string) {
			return A3(
				$author$project$Functions$whenElse,
				$elm$core$Result$Ok(0),
				$elm$core$Result$Err(errorMessage),
				A2(
					$author$project$Common$ReasonDescriptionStatus$isDescriptionValid,
					$elm$core$Maybe$Just(string),
					descriptionStatus));
		};
		var descriptionInputDisabled = $author$project$Common$ReasonDescriptionStatus$descriptionIsDisabled(descriptionStatus);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Pyxis$Components$Field$Textarea$render,
					onDescriptionChanges,
					descriptionInput,
					A2(
						$author$project$Pyxis$Components$Field$Textarea$withLabel,
						A2(
							$author$project$Pyxis$Components$Field$Label$withText,
							A2($author$project$Page$PolicyDetails$AmendInterruptionModal$descriptionTextareaLabel, i18n, model),
							$author$project$Pyxis$Components$Field$Label$config),
						A3(
							$author$project$Pyxis$Components$Field$Textarea$withValidationOnSubmit,
							validation,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$formIsSubmitted(formStatus),
							A2(
								$author$project$Pyxis$Components$Field$Textarea$withDisabled,
								descriptionInputDisabled,
								A2(
									$author$project$Pyxis$Components$Field$Textarea$withSize,
									$author$project$Pyxis$Components$Field$Textarea$sizeM,
									$author$project$Pyxis$Components$Field$Textarea$config('reason-description'))))))
				]));
	});
var $author$project$Pyxis$Components$Field$DateInput$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$DateInput$M = 1;
var $author$project$Pyxis$Components$Field$DateInput$config = function (name) {
	return {fJ: $elm$core$Maybe$Nothing, f6: _List_Nil, ej: _List_Nil, go: false, cM: $elm$core$Maybe$Nothing, gR: $elm$core$Maybe$Nothing, kg: 'id-' + name, cY: false, eR: $elm$core$Maybe$Nothing, hh: $elm$core$Maybe$Nothing, hm: $elm$core$Maybe$Nothing, kF: name, is: false, aO: 1, iD: $elm$core$Maybe$Nothing, fv: $elm$core$Maybe$Nothing, dQ: $elm$core$Maybe$Nothing, iZ: $elm$core$Basics$identity};
};
var $justinmimbs$date$Date$isBetween = F3(
	function (_v0, _v1, _v2) {
		var a = _v0;
		var b = _v1;
		var x = _v2;
		return A3($justinmimbs$date$Date$isBetweenInt, a, b, x);
	});
var $justinmimbs$time_extra$Time$Extra$Minute = 13;
var $justinmimbs$time_extra$Time$Extra$Day = 11;
var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
var $justinmimbs$time_extra$Time$Extra$Month = 2;
var $justinmimbs$time_extra$Time$Extra$add = F4(
	function (interval, n, zone, posix) {
		add:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(posix) + n);
				case 14:
					var $temp$interval = 15,
						$temp$n = n * 1000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 13:
					var $temp$interval = 15,
						$temp$n = n * 60000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 12:
					var $temp$interval = 15,
						$temp$n = n * 3600000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 11:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							3,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 2:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							1,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 0:
					var $temp$interval = 2,
						$temp$n = n * 12,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 1:
					var $temp$interval = 2,
						$temp$n = n * 3,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 3:
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				default:
					var weekday = interval;
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
			}
		}
	});
var $author$project$Common$Locale$beforeEndOfDayAtCustomerDate = A2(
	$elm$core$Basics$composeR,
	$author$project$Common$Locale$midnightAtCustomerDate,
	A3($justinmimbs$time_extra$Time$Extra$add, 13, -1, $author$project$Common$Locale$customerTimeZone));
var $author$project$Common$Locale$formatPosixTime = F2(
	function (tz, time) {
		var minute = $elm$core$String$fromInt(
			A2($elm$time$Time$toMinute, tz, time));
		var hour = $elm$core$String$fromInt(
			A2($elm$time$Time$toHour, tz, time));
		return A3($elm$core$String$padLeft, 2, '0', hour) + (':' + A3($elm$core$String$padLeft, 2, '0', minute));
	});
var $author$project$Translations$policyInterruptionModalActivityLabel = F2(
	function (data, _v0) {
		var lang = _v0;
		if (!lang) {
			return 'Policy will be active until ' + (data.ma + (' at ' + data.mb));
		} else {
			return 'Póliza en vigor hasta el ' + (data.ma + (' a las ' + data.mb));
		}
	});
var $author$project$Translations$policyInterruptionModalNoActivityLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy will never be active';
	} else {
		return 'Póliza no entrará en vigor';
	}
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$policyActivityHint = F2(
	function (i18n, _v0) {
		var interruptionDateInput = _v0.aI;
		var policyStartDate = _v0.lg;
		var isBeforePolicyStartDate = function (posixDate) {
			return _Utils_cmp(
				$elm$time$Time$posixToMillis(posixDate),
				$elm$time$Time$posixToMillis(policyStartDate)) < 0;
		};
		var activeUntilTime = $author$project$Common$Locale$formatPosixTime($author$project$Common$Locale$customerTimeZone);
		var activeUntilDate = $author$project$Common$Locale$formatPosixDate($author$project$Common$Locale$customerTimeZone);
		var renderActivityMessage = function (date) {
			return isBeforePolicyStartDate(date) ? $author$project$Translations$policyInterruptionModalNoActivityLabel(i18n) : A2(
				$author$project$Translations$policyInterruptionModalActivityLabel,
				{
					ma: activeUntilDate(date),
					mb: activeUntilTime(date)
				},
				i18n);
		};
		var activeUntil = A2(
			$elm$core$Maybe$map,
			$author$project$Common$Locale$beforeEndOfDayAtCustomerDate,
			$elm$core$Result$toMaybe(
				$justinmimbs$date$Date$fromIsoString(
					$author$project$Pyxis$Components$Field$DateInput$getValue(interruptionDateInput))));
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, renderActivityMessage, activeUntil));
	});
var $author$project$Translations$policyInterruptionModalCancellationDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Cancellation date';
	} else {
		return 'Fecha de cancelación';
	}
};
var $author$project$Translations$policyInterruptionModalInvalidCancellationDateError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Invalid cancellation date';
	} else {
		return 'Fecha de cancelación no válida';
	}
};
var $author$project$Pyxis$Components$Field$DateInput$generateErrorConfig = F2(
	function (_v0, _v1) {
		var fieldStatus = _v0.ev;
		var value = _v0.pB;
		var id = _v1.kg;
		var isSubmitted = _v1.cY;
		var validation = _v1.dQ;
		var errorShowingStrategy = _v1.cM;
		var validationRes = A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Maybe$map,
				A4($author$project$Pyxis$Commons$Validation$generateValidationResult, fieldStatus, isSubmitted, value, validation),
				errorShowingStrategy));
		return A3(
			$elm$core$Maybe$map2,
			A2(
				$author$project$Pyxis$Components$Field$Error$buildErrorConfig,
				fieldStatus,
				{kg: id, cY: isSubmitted}),
			validationRes,
			errorShowingStrategy);
	});
var $author$project$Pyxis$Components$Field$DateInput$mapLabelSize = function (size) {
	if (!size) {
		return $author$project$Pyxis$Components$Field$Label$sizeS;
	} else {
		return $author$project$Pyxis$Components$Field$Label$sizeM;
	}
};
var $author$project$Pyxis$Components$IconSet$Calendar = 195;
var $author$project$Pyxis$Components$IconSet$calendar = 195;
var $author$project$Pyxis$Components$Field$DateInput$iconSizeByInputSize = function (size) {
	if (!size) {
		return $author$project$Pyxis$Components$Icon$sizeS;
	} else {
		return $author$project$Pyxis$Components$Icon$sizeM;
	}
};
var $author$project$Pyxis$Components$Field$DateInput$renderAddon = function (_v0) {
	var size = _v0.aO;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-field__addon')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Icon$render(
				A2(
					$author$project$Pyxis$Components$Icon$withSize,
					$author$project$Pyxis$Components$Field$DateInput$iconSizeByInputSize(size),
					$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$calendar)))
			]));
};
var $author$project$Pyxis$Components$Field$DateInput$OnBlur = {$: 2};
var $author$project$Pyxis$Components$Field$DateInput$OnFocus = {$: 1};
var $author$project$Pyxis$Components$Field$DateInput$OnInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Field$DateInput$getFormFieldDateSizeClass = function (size) {
	if (!size) {
		return 'form-field__date--s';
	} else {
		return '';
	}
};
var $elm_community$result_extra$Result$Extra$isOk = function (x) {
	if (!x.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $author$project$Pyxis$Components$Field$DateInput$renderInput = F3(
	function (error, _v0, _v1) {
		var modelData = _v0;
		var configData = _v1;
		return A2(
			$elm$html$Html$input,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				configData.ej,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id(configData.kg),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('form-field__date', true),
								_Utils_Tuple2(
								'form-field__date--filled',
								$elm_community$result_extra$Result$Extra$isOk(
									$justinmimbs$date$Date$fromIsoString(modelData.pB))),
								_Utils_Tuple2(
								$author$project$Pyxis$Components$Field$DateInput$getFormFieldDateSizeClass(configData.aO),
								true)
							])),
						$elm$html$Html$Attributes$disabled(configData.go),
						$elm$html$Html$Attributes$value(modelData.pB),
						$elm$html$Html$Attributes$type_('date'),
						$elm$html$Html$Attributes$required(configData.is),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, configData.fv),
						$elm$html$Html$Attributes$name(configData.kF),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$min, configData.hm),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$max, configData.hh),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$step, configData.iD),
						$author$project$Pyxis$Commons$Attributes$ariaInvalid(
						$author$project$Pyxis$Components$Field$Error$isVisible(error)),
						A2(
						$author$project$Pyxis$Commons$Attributes$ariaDescribedByErrorOrHint,
						A2($author$project$Pyxis$Components$Field$Error$idFromFieldIdIfVisible, error, configData.kg),
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$always(
								$author$project$Pyxis$Components$Field$Hint$toId(configData.kg)),
							configData.gR)),
						$elm$html$Html$Events$onInput(
						A2($elm$core$Basics$composeR, configData.iZ, $author$project$Pyxis$Components$Field$DateInput$OnInput)),
						$elm$html$Html$Events$onFocus($author$project$Pyxis$Components$Field$DateInput$OnFocus),
						$elm$html$Html$Events$onBlur($author$project$Pyxis$Components$Field$DateInput$OnBlur)
					])),
			_List_Nil);
	});
var $author$project$Pyxis$Components$Field$DateInput$renderField = F3(
	function (error, model, configuration) {
		var disabled = configuration.go;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-field', true),
							_Utils_Tuple2(
							'form-field--error',
							$author$project$Pyxis$Components$Field$Error$isVisible(error)),
							_Utils_Tuple2('form-field--disabled', disabled),
							_Utils_Tuple2('form-field--with-prepend-icon', true)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-field__wrapper')
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Field$DateInput$renderAddon(configuration),
							A3($author$project$Pyxis$Components$Field$DateInput$renderInput, error, model, configuration)
						]))
				]));
	});
var $author$project$Pyxis$Components$Field$DateInput$render = F3(
	function (tagger, model, config_) {
		var configData = config_;
		var error = A2($author$project$Pyxis$Components$Field$DateInput$generateErrorConfig, model, config_);
		var customizedLabel = A2(
			$elm$core$Maybe$map,
			$author$project$Pyxis$Components$Field$Label$withSize(
				$author$project$Pyxis$Components$Field$DateInput$mapLabelSize(configData.aO)),
			configData.eR);
		return A2(
			$author$project$Pyxis$Components$Form$FormItem$render,
			error,
			A2(
				$author$project$Pyxis$Components$Form$FormItem$withAdditionalContent,
				configData.fJ,
				A2(
					$author$project$Pyxis$Components$Form$FormItem$withLabel,
					customizedLabel,
					A2(
						$author$project$Pyxis$Components$Form$FormItem$withClassList,
						configData.f6,
						A2(
							$author$project$Pyxis$Components$Form$FormItem$config,
							configData,
							A2(
								$elm$html$Html$map,
								tagger,
								A3($author$project$Pyxis$Components$Field$DateInput$renderField, error, model, config_)))))));
	});
var $author$project$Pyxis$Components$Field$DateInput$S = 0;
var $author$project$Pyxis$Components$Field$DateInput$sizeS = 0;
var $author$project$Pyxis$Components$Field$Hint$config = function (message) {
	return {kg: $elm$core$Maybe$Nothing, nH: message};
};
var $author$project$Pyxis$Components$Field$DateInput$withHint = F2(
	function (hintMessage, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				gR: $elm$core$Maybe$Just(
					A2(
						$author$project$Pyxis$Components$Field$Hint$withFieldId,
						configuration.kg,
						$author$project$Pyxis$Components$Field$Hint$config(hintMessage)))
			});
	});
var $author$project$Pyxis$Components$Field$DateInput$withLabel = F2(
	function (a, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				eR: $elm$core$Maybe$Just(a)
			});
	});
var $author$project$Pyxis$Components$Field$DateInput$withMax = F2(
	function (max, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				hh: $elm$core$Maybe$Just(max)
			});
	});
var $author$project$Pyxis$Components$Field$DateInput$withMin = F2(
	function (min, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				hm: $elm$core$Maybe$Just(min)
			});
	});
var $author$project$Pyxis$Components$Field$DateInput$withSize = F2(
	function (size, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aO: size});
	});
var $author$project$Pyxis$Components$Field$DateInput$withStep = F2(
	function (step, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				iD: $elm$core$Maybe$Just(step)
			});
	});
var $author$project$Pyxis$Components$Field$DateInput$withTestId = F2(
	function (id, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				fv: $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Pyxis$Components$Field$DateInput$withValidationOnSubmit = F3(
	function (validation, isSubmitted, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				cM: $elm$core$Maybe$Just($author$project$Pyxis$Components$Field$Error$onSubmit),
				cY: isSubmitted,
				dQ: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeR, validation, $author$project$Pyxis$Commons$ValidationResult$fromResult))
			});
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$viewInterruptionDateInput = F2(
	function (i18n, model) {
		var onInterruptionDateChanges = model.kT;
		var interruptionDateInput = model.aI;
		var earliestSelectableDate = model.aZ;
		var formStatus = model.aE;
		var latestSelectableDate = model.a4;
		var errorMessage = $author$project$Translations$policyInterruptionModalInvalidCancellationDateError(i18n);
		var validation = A2(
			$elm$core$Basics$composeR,
			$justinmimbs$date$Date$fromIsoString,
			$elm$core$Result$andThen(
				A2(
					$elm$core$Basics$composeR,
					A2($justinmimbs$date$Date$isBetween, earliestSelectableDate, latestSelectableDate),
					A2(
						$author$project$Functions$whenElse,
						$elm$core$Result$Ok(0),
						$elm$core$Result$Err(errorMessage)))));
		return A3(
			$author$project$Pyxis$Components$Field$DateInput$render,
			onInterruptionDateChanges,
			interruptionDateInput,
			A2(
				$author$project$Pyxis$Components$Field$DateInput$withTestId,
				'interruption-date',
				A2(
					$author$project$Pyxis$Components$Field$DateInput$withHint,
					A2($author$project$Page$PolicyDetails$AmendInterruptionModal$policyActivityHint, i18n, model),
					A2(
						$author$project$Pyxis$Components$Field$DateInput$withStep,
						'1',
						A2(
							$author$project$Pyxis$Components$Field$DateInput$withMax,
							$justinmimbs$date$Date$toIsoString(latestSelectableDate),
							A2(
								$author$project$Pyxis$Components$Field$DateInput$withMin,
								$justinmimbs$date$Date$toIsoString(earliestSelectableDate),
								A3(
									$author$project$Pyxis$Components$Field$DateInput$withValidationOnSubmit,
									validation,
									$author$project$Page$PolicyDetails$AmendInterruptionModal$formIsSubmitted(formStatus),
									A2(
										$author$project$Pyxis$Components$Field$DateInput$withLabel,
										A2(
											$author$project$Pyxis$Components$Field$Label$withText,
											$author$project$Translations$policyInterruptionModalCancellationDateLabel(i18n),
											$author$project$Pyxis$Components$Field$Label$config),
										A2(
											$author$project$Pyxis$Components$Field$DateInput$withSize,
											$author$project$Pyxis$Components$Field$DateInput$sizeS,
											$author$project$Pyxis$Components$Field$DateInput$config('interruption-date'))))))))));
	});
var $author$project$Pyxis$Components$Form$withId = F2(
	function (id, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				kg: $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$content = F2(
	function (i18n, model) {
		var onReasonChanged = model.k2;
		var expectedRefund = model.mY;
		var onSubmit = model.k5;
		var descriptionInput = model.aC;
		var descriptionStatus = model.bD;
		var onSubmitError = model.k6;
		var initialValues = model.gW;
		var maybeReasonValue = $author$project$Page$PolicyDetails$AmendInterruptionModal$pickReasonValue(model);
		var maybeInterruptionAt = $author$project$Page$PolicyDetails$AmendInterruptionModal$pickDateValue(model);
		var maybeDescriptionValue = A3(
			$primait$prima_elm_extra$PrimaFunction$ifThenMap,
			A2($primait$prima_elm_extra$PrimaFunction$flip, $author$project$Common$ReasonDescriptionStatus$isDescriptionValid, descriptionStatus),
			$elm$core$Basics$identity,
			$elm$core$Maybe$Just(
				$author$project$Pyxis$Components$Field$Textarea$getValue(descriptionInput)));
		var hasInterruptionAtChanged = $elm$core$Maybe$Just(
			!_Utils_eq(
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.gX;
					},
					initialValues),
				maybeInterruptionAt));
		var pyxisOnSubmit = A2(
			$elm$core$Maybe$withDefault,
			onSubmitError,
			A5($elm$core$Maybe$map4, onSubmit, maybeDescriptionValue, maybeInterruptionAt, maybeReasonValue, hasInterruptionAtChanged));
		return _List_fromArray(
			[
				$author$project$Pyxis$Components$Form$render(
				A2(
					$author$project$Pyxis$Components$Form$withId,
					$author$project$Page$PolicyDetails$AmendInterruptionModal$formId,
					A2(
						$author$project$Pyxis$Components$Form$withOnSubmit,
						pyxisOnSubmit,
						A2(
							$author$project$Pyxis$Components$Form$withFieldsets,
							_List_fromArray(
								[
									A2(
									$author$project$Pyxis$Components$Form$Fieldset$withContent,
									_List_fromArray(
										[
											$author$project$Pyxis$Components$Grid$oneColRowFullWidth(
											_List_fromArray(
												[
													A2($author$project$Page$PolicyDetails$AmendInterruptionModal$viewInterruptionDateInput, i18n, model)
												])),
											$author$project$Pyxis$Components$Grid$oneColRowFullWidth(
											_List_fromArray(
												[
													A3($author$project$Page$PolicyDetails$AmendInterruptionModal$reasonSelect, i18n, model, onReasonChanged)
												])),
											$author$project$Pyxis$Components$Grid$oneColRowFullWidth(
											_List_fromArray(
												[
													A2($author$project$Page$PolicyDetails$AmendInterruptionModal$renderDescriptionInput, i18n, model)
												])),
											$author$project$Pyxis$Components$Grid$oneColRowFullWidth(
											_List_fromArray(
												[
													A2($author$project$Page$PolicyDetails$AmendInterruptionModal$expectedRefundMessage, i18n, expectedRefund)
												]))
										]),
									$author$project$Pyxis$Components$Form$Fieldset$config)
								]),
							$author$project$Pyxis$Components$Form$config))))
			]);
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$formIsLoading = function (status) {
	if (status === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Translations$policyInterruptionModalCancelButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Back';
	} else {
		return 'Atrás';
	}
};
var $author$project$Translations$policyInterruptionModalProceedButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Confirm';
	} else {
		return 'Confirmar';
	}
};
var $author$project$Pyxis$Components$Button$withTargetFormId = F2(
	function (formId, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				gE: $elm$core$Maybe$Just(formId)
			});
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$footer = F2(
	function (i18n, _v0) {
		var onDismiss = _v0.hP;
		var formStatus = _v0.aE;
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						onDismiss,
						A2(
							$author$project$Pyxis$Components$Button$withText,
							$author$project$Translations$policyInterruptionModalCancelButton(i18n),
							$author$project$Pyxis$Components$Button$secondary))),
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withLoading,
						$author$project$Page$PolicyDetails$AmendInterruptionModal$formIsLoading(formStatus),
						A2(
							$author$project$Pyxis$Components$Button$withTargetFormId,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$formId,
							A2(
								$author$project$Pyxis$Components$Button$withType,
								$author$project$Pyxis$Components$Button$submit,
								A2(
									$author$project$Pyxis$Components$Button$withText,
									$author$project$Translations$policyInterruptionModalProceedButton(i18n),
									$author$project$Pyxis$Components$Button$primary)))))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Translations$policyInterruptionModalAmendTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Edit cancellation date';
	} else {
		return 'Modifica la fecha de cancelación';
	}
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$render = F2(
	function (i18n, model) {
		var onDismiss = model.hP;
		var visibility = model.cq;
		var headerConfig = A2(
			$author$project$Pyxis$Components$Modal$Header$withTitle,
			$author$project$Translations$policyInterruptionModalAmendTitle(i18n),
			$author$project$Pyxis$Components$Modal$Header$config);
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			visibility,
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A2($author$project$Page$PolicyDetails$AmendInterruptionModal$footer, i18n, model),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					A2($author$project$Page$PolicyDetails$AmendInterruptionModal$content, i18n, model),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						headerConfig,
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							onDismiss,
							'',
							A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
	});
var $author$project$Page$PolicyDetails$ChangeEmailModal$ChangeEmailInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$Validate = {$: 3};
var $author$project$Pyxis$Components$Field$Input$Email = 0;
var $author$project$Pyxis$Components$Field$Input$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Input$M = 1;
var $author$project$Pyxis$Components$Field$Input$config = F2(
	function (inputType, name) {
		return {fJ: $elm$core$Maybe$Nothing, mf: $elm$core$Maybe$Nothing, fY: $elm$core$Maybe$Nothing, f6: _List_Nil, ej: _List_Nil, go: false, cM: $elm$core$Maybe$Nothing, gR: $elm$core$Maybe$Nothing, kg: 'id-' + name, cY: false, eR: $elm$core$Maybe$Nothing, hh: $elm$core$Maybe$Nothing, hm: $elm$core$Maybe$Nothing, kF: name, h9: $elm$core$Maybe$Nothing, is: false, aO: 1, iD: $elm$core$Maybe$Nothing, fv: $elm$core$Maybe$Nothing, bk: inputType, dQ: $elm$core$Maybe$Nothing, iZ: $elm$core$Basics$identity};
	});
var $author$project$Pyxis$Components$Field$Input$email = $author$project$Pyxis$Components$Field$Input$config(0);
var $author$project$Page$PolicyDetails$ChangeEmailModal$formId = 'change-form-email';
var $author$project$Pyxis$Components$Field$Input$generateErrorConfig = F2(
	function (_v0, _v1) {
		var fieldStatus = _v0.ev;
		var value = _v0.pB;
		var id = _v1.kg;
		var isSubmitted = _v1.cY;
		var validation = _v1.dQ;
		var errorShowingStrategy = _v1.cM;
		var validationRes = A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Maybe$map,
				A4($author$project$Pyxis$Commons$Validation$generateValidationResult, fieldStatus, isSubmitted, value, validation),
				errorShowingStrategy));
		return A3(
			$elm$core$Maybe$map2,
			A2(
				$author$project$Pyxis$Components$Field$Error$buildErrorConfig,
				fieldStatus,
				{kg: id, cY: isSubmitted}),
			validationRes,
			errorShowingStrategy);
	});
var $author$project$Pyxis$Components$Field$Input$mapLabelSize = function (size) {
	if (!size) {
		return $author$project$Pyxis$Components$Field$Label$sizeS;
	} else {
		return $author$project$Pyxis$Components$Field$Label$sizeM;
	}
};
var $author$project$Pyxis$Components$Field$Input$addonTypeToString = function (addonType) {
	switch (addonType.$) {
		case 0:
			return 'icon';
		case 1:
			return 'text';
		default:
			return 'button';
	}
};
var $author$project$Pyxis$Components$Field$Input$placementToString = function (placement) {
	if (!placement) {
		return 'prepend';
	} else {
		return 'append';
	}
};
var $author$project$Pyxis$Components$Field$Input$addonToAttribute = function (_v0) {
	var type_ = _v0.bk;
	var placement = _v0.Y;
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			'-',
			_List_fromArray(
				[
					'form-field--with',
					$author$project$Pyxis$Components$Field$Input$placementToString(placement),
					$author$project$Pyxis$Components$Field$Input$addonTypeToString(type_)
				])));
};
var $author$project$Pyxis$Components$Field$Input$isAppend = function (placement) {
	if (placement === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Components$Field$Input$isPrepend = function (placement) {
	if (!placement) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Components$Field$Input$iconSizeByInputSize = function (size) {
	if (!size) {
		return $author$project$Pyxis$Components$Icon$sizeS;
	} else {
		return $author$project$Pyxis$Components$Icon$sizeM;
	}
};
var $author$project$Pyxis$Components$Field$Input$renderAddonByType = F2(
	function (size, type_) {
		switch (type_.$) {
			case 0:
				var icon = type_.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-field__addon')
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Icon$render(
							A2(
								$author$project$Pyxis$Components$Icon$withSize,
								$author$project$Pyxis$Components$Field$Input$iconSizeByInputSize(size),
								$author$project$Pyxis$Components$Icon$config(icon)))
						]));
			case 1:
				var str = type_.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-field__addon')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(str)
						]));
			default:
				var buttonConfig = type_.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-field__addon')
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Button$render(buttonConfig)
						]));
		}
	});
var $author$project$Pyxis$Components$Field$Input$OnBlur = {$: 2};
var $author$project$Pyxis$Components$Field$Input$OnFocus = {$: 1};
var $author$project$Pyxis$Components$Field$Input$OnInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Field$Input$OnKeyDown = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pyxis$Components$Field$Input$getFormFieldTextSizeClass = function (size) {
	if (!size) {
		return 'form-field__text--s';
	} else {
		return '';
	}
};
var $author$project$Pyxis$Commons$Events$Keyboard$on = F2(
	function (event, tagger) {
		return A2(
			$elm$html$Html$Events$on,
			event,
			$author$project$Pyxis$Commons$Events$Keyboard$decoder(tagger));
	});
var $author$project$Pyxis$Components$Field$Input$typeToAttribute = function (a) {
	switch (a) {
		case 0:
			return $elm$html$Html$Attributes$type_('email');
		case 1:
			return $elm$html$Html$Attributes$type_('number');
		case 2:
			return $elm$html$Html$Attributes$type_('password');
		case 3:
			return $elm$html$Html$Attributes$type_('text');
		default:
			return $elm$html$Html$Attributes$type_('search');
	}
};
var $author$project$Pyxis$Components$Field$Input$renderInput = F4(
	function (tagger, error, _v0, _v1) {
		var modelData = _v0;
		var configData = _v1;
		return A2(
			$elm$html$Html$map,
			tagger,
			A2(
				$elm$html$Html$input,
				A2(
					$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
					configData.ej,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(configData.kg),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('form-field__text', true),
									_Utils_Tuple2(
									$author$project$Pyxis$Components$Field$Input$getFormFieldTextSizeClass(configData.aO),
									true)
								])),
							$elm$html$Html$Attributes$disabled(configData.go),
							$elm$html$Html$Attributes$value(modelData.pB),
							$author$project$Pyxis$Components$Field$Input$typeToAttribute(configData.bk),
							A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, configData.fv),
							$elm$html$Html$Attributes$name(configData.kF),
							$elm$html$Html$Attributes$required(configData.is),
							A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$placeholder, configData.h9),
							A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$min, configData.hm),
							A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$max, configData.hh),
							A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$step, configData.iD),
							A2(
							$author$project$Pyxis$Commons$Attributes$maybe,
							$elm$html$Html$Attributes$attribute('autocomplete'),
							configData.fY),
							$author$project$Pyxis$Commons$Attributes$ariaInvalid(
							$author$project$Pyxis$Components$Field$Error$isVisible(error)),
							A2(
							$author$project$Pyxis$Commons$Attributes$ariaDescribedByErrorOrHint,
							A2($author$project$Pyxis$Components$Field$Error$idFromFieldIdIfVisible, error, configData.kg),
							A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$always(
									$author$project$Pyxis$Components$Field$Hint$toId(configData.kg)),
								configData.gR)),
							$elm$html$Html$Events$onInput(
							A2($elm$core$Basics$composeR, configData.iZ, $author$project$Pyxis$Components$Field$Input$OnInput)),
							$elm$html$Html$Events$onFocus($author$project$Pyxis$Components$Field$Input$OnFocus),
							$elm$html$Html$Events$onBlur($author$project$Pyxis$Components$Field$Input$OnBlur),
							A2($author$project$Pyxis$Commons$Events$Keyboard$on, 'keydown', $author$project$Pyxis$Components$Field$Input$OnKeyDown)
						])),
				_List_Nil));
	});
var $author$project$Pyxis$Components$Field$Input$renderAddon = F5(
	function (tagger, error, model, configuration, addon) {
		var size = configuration.aO;
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-field__wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pyxis$Commons$Render$renderIf,
					$author$project$Pyxis$Components$Field$Input$isPrepend(addon.Y),
					A2($author$project$Pyxis$Components$Field$Input$renderAddonByType, size, addon.bk)),
					A4($author$project$Pyxis$Components$Field$Input$renderInput, tagger, error, model, configuration),
					A2(
					$author$project$Pyxis$Commons$Render$renderIf,
					$author$project$Pyxis$Components$Field$Input$isAppend(addon.Y),
					A2($author$project$Pyxis$Components$Field$Input$renderAddonByType, size, addon.bk))
				]));
	});
var $author$project$Pyxis$Components$Field$Input$renderField = F4(
	function (tagger, error, model, configuration) {
		var disabled = configuration.go;
		var addon = configuration.mf;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-field', true),
							_Utils_Tuple2(
							'form-field--error',
							$author$project$Pyxis$Components$Field$Error$isVisible(error)),
							_Utils_Tuple2('form-field--disabled', disabled)
						])),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Components$Field$Input$addonToAttribute, addon)
				]),
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					A4($author$project$Pyxis$Components$Field$Input$renderInput, tagger, error, model, configuration),
					A2(
						$elm$core$Maybe$map,
						A4($author$project$Pyxis$Components$Field$Input$renderAddon, tagger, error, model, configuration),
						addon))
				]));
	});
var $author$project$Pyxis$Components$Field$Input$render = F3(
	function (tagger, model, config_) {
		var configData = config_;
		var error = A2($author$project$Pyxis$Components$Field$Input$generateErrorConfig, model, config_);
		var customizedLabel = A2(
			$elm$core$Maybe$map,
			$author$project$Pyxis$Components$Field$Label$withSize(
				$author$project$Pyxis$Components$Field$Input$mapLabelSize(configData.aO)),
			configData.eR);
		return A2(
			$author$project$Pyxis$Components$Form$FormItem$render,
			error,
			A2(
				$author$project$Pyxis$Components$Form$FormItem$withAdditionalContent,
				configData.fJ,
				A2(
					$author$project$Pyxis$Components$Form$FormItem$withLabel,
					customizedLabel,
					A2(
						$author$project$Pyxis$Components$Form$FormItem$withClassList,
						configData.f6,
						A2(
							$author$project$Pyxis$Components$Form$FormItem$config,
							configData,
							A4($author$project$Pyxis$Components$Field$Input$renderField, tagger, error, model, config_))))));
	});
var $author$project$Pyxis$Components$Grid$SpanSize$Span5 = 4;
var $author$project$Pyxis$Components$Grid$SpanSize$span5 = 4;
var $author$project$Pyxis$Components$Grid$Col$span5 = function (config) {
	return _Utils_update(
		config,
		{dw: $author$project$Pyxis$Components$Grid$SpanSize$span5});
};
var $author$project$Translations$changeEmailModalInputError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid email address.';
	} else {
		return 'Por favor, introduce una dirección de correo electrónico válida.';
	}
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$validateInputFn = F2(
	function (i18n, userInput) {
		return $author$project$Page$PolicyDetails$ChangeEmailModal$isInputValid(userInput) ? $elm$core$Result$Ok(userInput) : $elm$core$Result$Err(
			$author$project$Translations$changeEmailModalInputError(i18n));
	});
var $author$project$Pyxis$Components$Form$withNoValidate = F2(
	function (noValidate, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				e_: $elm$core$Maybe$Just(noValidate)
			});
	});
var $author$project$Pyxis$Components$Field$Input$withValidationOnSubmit = F3(
	function (validation, isSubmitted, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				cM: $elm$core$Maybe$Just($author$project$Pyxis$Components$Field$Error$onSubmit),
				cY: isSubmitted,
				dQ: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeR, validation, $author$project$Pyxis$Commons$ValidationResult$fromResult))
			});
	});
var $author$project$Page$PolicyDetails$ChangeEmailModal$changeEmailFormConfiguration = F2(
	function (i18n, _v0) {
		var emailInput = _v0.a_;
		var tagger = _v0.iM;
		var isSubmitted = _v0.cY;
		return A2(
			$author$project$Pyxis$Components$Form$withOnSubmit,
			tagger($author$project$Page$PolicyDetails$ChangeEmailModal$Validate),
			A2(
				$author$project$Pyxis$Components$Form$withNoValidate,
				true,
				A2(
					$author$project$Pyxis$Components$Form$withId,
					$author$project$Page$PolicyDetails$ChangeEmailModal$formId,
					A2(
						$author$project$Pyxis$Components$Form$withFieldsets,
						_List_fromArray(
							[
								A2(
								$author$project$Pyxis$Components$Form$Fieldset$withContent,
								_List_fromArray(
									[
										A2(
										$author$project$Pyxis$Components$Grid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Pyxis$Components$Grid$col,
												_List_fromArray(
													[$author$project$Pyxis$Components$Grid$Col$span5]),
												_List_fromArray(
													[
														A3(
														$author$project$Pyxis$Components$Field$Input$render,
														A2($elm$core$Basics$composeR, $author$project$Page$PolicyDetails$ChangeEmailModal$ChangeEmailInputMsg, tagger),
														emailInput,
														A3(
															$author$project$Pyxis$Components$Field$Input$withValidationOnSubmit,
															$author$project$Page$PolicyDetails$ChangeEmailModal$validateInputFn(i18n),
															isSubmitted,
															$author$project$Pyxis$Components$Field$Input$email('change-email')))
													]))
											]))
									]),
								$author$project$Pyxis$Components$Form$Fieldset$config)
							]),
						$author$project$Pyxis$Components$Form$config))));
	});
var $author$project$Page$PolicyDetails$ChangeEmailModal$content = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$PolicyDetails$ChangeEmailModal$changeEmailFormConfiguration(i18n),
		$author$project$Pyxis$Components$Form$render);
};
var $author$project$Translations$changeEmailModalBackButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Back';
	} else {
		return 'Atrás';
	}
};
var $author$project$Translations$changeEmailModalConfirmButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Confirm';
	} else {
		return 'Confirmar';
	}
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$footer = F2(
	function (i18n, tagger) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						tagger($author$project$Page$PolicyDetails$ChangeEmailModal$Dismiss),
						A2(
							$author$project$Pyxis$Components$Button$withWidth,
							$author$project$Pyxis$Components$Button$inherit,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$changeEmailModalBackButtonLabel(i18n),
								$author$project$Pyxis$Components$Button$secondary)))),
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withTargetFormId,
						$author$project$Page$PolicyDetails$ChangeEmailModal$formId,
						A2(
							$author$project$Pyxis$Components$Button$withWidth,
							$author$project$Pyxis$Components$Button$inherit,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$changeEmailModalConfirmButtonLabel(i18n),
								A2($author$project$Pyxis$Components$Button$withType, $author$project$Pyxis$Components$Button$submit, $author$project$Pyxis$Components$Button$primary)))))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Translations$changeEmailModalTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Change email address';
	} else {
		return 'Cambia el dirección de email';
	}
};
var $author$project$Pyxis$Components$IconSet$Mail = 81;
var $author$project$Pyxis$Components$IconSet$mail = 81;
var $author$project$Page$PolicyDetails$ChangeEmailModal$modalIcon = A2(
	$author$project$Pyxis$Components$Icon$withColor,
	$author$project$Pyxis$Tokens$TypographyColor$tokenBrand,
	$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$mail));
var $author$project$Page$PolicyDetails$ChangeEmailModal$header = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withTitle,
		$author$project$Translations$changeEmailModalTitle(i18n),
		A2(
			$author$project$Pyxis$Components$Modal$Header$withIcon,
			$author$project$Page$PolicyDetails$ChangeEmailModal$modalIcon,
			A2($author$project$Pyxis$Components$Modal$Header$withIcon, $author$project$Page$PolicyDetails$ChangeEmailModal$modalIcon, $author$project$Pyxis$Components$Modal$Header$config)));
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$render = F2(
	function (i18n, model) {
		var tagger = model.iM;
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			$author$project$Page$PolicyDetails$ChangeEmailModal$modalVisibility(model),
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A2($author$project$Page$PolicyDetails$ChangeEmailModal$footer, i18n, tagger),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					_List_fromArray(
						[
							A2($author$project$Page$PolicyDetails$ChangeEmailModal$content, i18n, model)
						]),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						$author$project$Page$PolicyDetails$ChangeEmailModal$header(i18n),
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							tagger($author$project$Page$PolicyDetails$ChangeEmailModal$Dismiss),
							'',
							A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
	});
var $author$project$Common$Render$maybe2 = F3(
	function (fn, maybeValue1, maybeValue2) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Common$Render$empty,
			A3($elm$core$Maybe$map2, fn, maybeValue1, maybeValue2));
	});
var $author$project$Page$PolicyDetails$Msg$InterruptionDismissed = {$: 18};
var $author$project$Common$ReasonDescriptionStatus$couldDescriptionBeSet = A2(
	$primait$prima_elm_extra$PrimaFunction$flip,
	$elm$core$List$member,
	_List_fromArray(
		[1, 0]));
var $author$project$Page$PolicyDetails$InterruptionModal$Data$pickDescriptionStatus = function (data) {
	switch (data.$) {
		case 0:
			var descriptionStatus = data.a.bD;
			return descriptionStatus;
		case 1:
			var descriptionStatus = data.a.bD;
			return descriptionStatus;
		default:
			var descriptionStatus = data.a.bD;
			return descriptionStatus;
	}
};
var $author$project$Page$PolicyDetails$InterruptionModal$Data$couldDescriptionBeSet = A2($elm$core$Basics$composeR, $author$project$Page$PolicyDetails$InterruptionModal$Data$pickDescriptionStatus, $author$project$Common$ReasonDescriptionStatus$couldDescriptionBeSet);
var $author$project$Page$PolicyDetails$Msg$InterruptionReasonDescriptionChanged = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$PolicyDetails$InterruptionModal$View$descriptionTextareaLabel = F2(
	function (i18n, data) {
		var _v0 = $author$project$Page$PolicyDetails$InterruptionModal$Data$pickDescriptionStatus(data);
		switch (_v0) {
			case 0:
				return $author$project$Translations$policyInterruptionModalReasonDescriptionLabelMandatory(i18n);
			case 1:
				return $author$project$Translations$policyInterruptionModalReasonDescriptionLabelOptional(i18n);
			default:
				return '';
		}
	});
var $author$project$Pyxis$Components$Field$Textarea$S = 0;
var $author$project$Pyxis$Components$Field$Textarea$sizeS = 0;
var $author$project$Page$PolicyDetails$InterruptionModal$View$descriptionInput = F3(
	function (i18n, textAreaModel, kindData) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('policy-details__policy-interruption__reason-description')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Pyxis$Components$Field$Textarea$render,
					$author$project$Page$PolicyDetails$Msg$InterruptionReasonDescriptionChanged,
					textAreaModel,
					A2(
						$author$project$Pyxis$Components$Field$Textarea$withLabel,
						A2(
							$author$project$Pyxis$Components$Field$Label$withText,
							A2($author$project$Page$PolicyDetails$InterruptionModal$View$descriptionTextareaLabel, i18n, kindData),
							$author$project$Pyxis$Components$Field$Label$config),
						A2(
							$author$project$Pyxis$Components$Field$Textarea$withSize,
							$author$project$Pyxis$Components$Field$Textarea$sizeS,
							$author$project$Pyxis$Components$Field$Textarea$config('reason-description'))))
				]));
	});
var $author$project$Page$PolicyDetails$InterruptionModal$View$expectedRefundMessage = F2(
	function (i18n, remoteData) {
		switch (remoteData.$) {
			case 0:
				return $elm_community$html_extra$Html$Extra$nothing;
			case 1:
				return $author$project$Pyxis$Components$Loaders$Loader$render(
					A2(
						$author$project$Pyxis$Components$Loaders$Loader$withClassList,
						_List_fromArray(
							[
								_Utils_Tuple2('margin-t-l es-fe-bo--full-width', true)
							]),
						$author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM));
			case 2:
				return $author$project$Pyxis$Components$Message$render(
					A2(
						$author$project$Pyxis$Components$Message$withClassList,
						_List_fromArray(
							[
								_Utils_Tuple2('policy-details__policy-interruption__refund-amount-message', true)
							]),
						A2(
							$author$project$Pyxis$Components$Message$withContent,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$policyInterruptionModalExpectedRefundNotAvailableMessage(i18n))
								]),
							$author$project$Pyxis$Components$Message$alert($author$project$Pyxis$Components$Message$tintBackground))));
			default:
				if (!remoteData.a.$) {
					var price = remoteData.a.a;
					return $author$project$Pyxis$Components$Message$render(
						A2(
							$author$project$Pyxis$Components$Message$withClassList,
							_List_fromArray(
								[
									_Utils_Tuple2('policy-details__policy-interruption__refund-amount-message', true)
								]),
							A2(
								$author$project$Pyxis$Components$Message$withContent,
								A3(
									$author$project$Translations$policyInterruptionModalExpectedNoRefundAmountMessage,
									{
										ln: A2($author$project$Common$Price$amountString, i18n, price),
										lo: $author$project$Common$Price$pickCurrencySign(price)
									},
									_List_Nil,
									i18n),
								$author$project$Pyxis$Components$Message$error($author$project$Pyxis$Components$Message$tintBackground))));
				} else {
					var price = remoteData.a.a;
					return $author$project$Pyxis$Components$Message$render(
						A2(
							$author$project$Pyxis$Components$Message$withClassList,
							_List_fromArray(
								[
									_Utils_Tuple2('policy-details__policy-interruption__refund-amount-message', true)
								]),
							A2(
								$author$project$Pyxis$Components$Message$withContent,
								A3(
									$author$project$Translations$policyInterruptionModalExpectedRefundAmountMessage,
									{
										ln: A2($author$project$Common$Price$amountString, i18n, price),
										lo: $author$project$Common$Price$pickCurrencySign(price)
									},
									_List_Nil,
									i18n),
								$author$project$Pyxis$Components$Message$success($author$project$Pyxis$Components$Message$tintBackground))));
				}
		}
	});
var $author$project$Page$PolicyDetails$Msg$InterruptionReasonSelected = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$PolicyDetails$InterruptionModal$View$reasonSelect = F2(
	function (i18n, autoCompleteModel) {
		return A3(
			$author$project$Pyxis$Components$Field$Autocomplete$render,
			$author$project$Page$PolicyDetails$Msg$InterruptionReasonSelected,
			autoCompleteModel,
			A2(
				$author$project$Pyxis$Components$Field$Autocomplete$withLabel,
				A2(
					$author$project$Pyxis$Components$Field$Label$withText,
					$author$project$Translations$policyInterruptionModalReasonLabel(i18n),
					$author$project$Pyxis$Components$Field$Label$config),
				A2(
					$author$project$Pyxis$Components$Field$Autocomplete$withSize,
					$author$project$Pyxis$Components$Field$Autocomplete$sizeS,
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$withPlaceholder,
						$author$project$Translations$policyInterruptionModalReasonPlaceholder(i18n),
						$author$project$Pyxis$Components$Field$Autocomplete$config('reason-kind')))));
	});
var $author$project$Page$PolicyDetails$Msg$InterruptionDateChanged = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pyxis$Components$Field$Error$onInput = 0;
var $author$project$Pyxis$Components$Field$DateInput$withValidationOnInput = F3(
	function (validation, isSubmitted, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				cM: $elm$core$Maybe$Just($author$project$Pyxis$Components$Field$Error$onInput),
				cY: isSubmitted,
				dQ: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeR, validation, $author$project$Pyxis$Commons$ValidationResult$fromResult))
			});
	});
var $author$project$Page$PolicyDetails$InterruptionModal$View$renderDateInput = F3(
	function (i18n, dateInputModel, _v0) {
		var minDate = _v0.hn;
		var maxDate = _v0.hi;
		var validation = function (date) {
			return A2(
				$elm$core$Result$andThen,
				function (value) {
					return A3($justinmimbs$date$Date$isBetween, minDate, maxDate, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
						$author$project$Translations$policyInterruptionModalInvalidCancellationDateError(i18n));
				},
				$justinmimbs$date$Date$fromIsoString(date));
		};
		return A3(
			$author$project$Pyxis$Components$Field$DateInput$render,
			$author$project$Page$PolicyDetails$Msg$InterruptionDateChanged,
			dateInputModel,
			A2(
				$author$project$Pyxis$Components$Field$DateInput$withTestId,
				'interruption-date',
				A2(
					$author$project$Pyxis$Components$Field$DateInput$withStep,
					'1',
					A2(
						$author$project$Pyxis$Components$Field$DateInput$withMax,
						$justinmimbs$date$Date$toIsoString(maxDate),
						A2(
							$author$project$Pyxis$Components$Field$DateInput$withMin,
							$justinmimbs$date$Date$toIsoString(minDate),
							A3(
								$author$project$Pyxis$Components$Field$DateInput$withValidationOnInput,
								validation,
								false,
								A2(
									$author$project$Pyxis$Components$Field$DateInput$withLabel,
									A2(
										$author$project$Pyxis$Components$Field$Label$withText,
										$author$project$Translations$policyInterruptionModalCancellationDateLabel(i18n),
										$author$project$Pyxis$Components$Field$Label$config),
									A2(
										$author$project$Pyxis$Components$Field$DateInput$withSize,
										$author$project$Pyxis$Components$Field$DateInput$sizeS,
										$author$project$Pyxis$Components$Field$DateInput$config('interruption-date')))))))));
	});
var $author$project$Page$PolicyDetails$InterruptionModal$View$viewInterruptionDateInput = F4(
	function (i18n, policy, kind, dateInputModel) {
		var dates = function () {
			switch (kind.$) {
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					return $elm$core$Maybe$Just(
						{
							hi: $author$project$Common$Policy$pickEndDate(policy),
							hn: $author$project$Common$Locale$posixToCustomerDate(
								$author$project$Common$Policy$earliestCustomerTerminationDate(policy))
						});
				default:
					return $elm$core$Maybe$Just(
						{
							hi: $author$project$Common$Policy$pickEndDate(policy),
							hn: $author$project$Common$Locale$posixToCustomerDate(
								$author$project$Common$Policy$earliestPrimaTerminationDate(policy))
						});
			}
		}();
		return A2(
			$author$project$Common$Render$maybe,
			A2($author$project$Page$PolicyDetails$InterruptionModal$View$renderDateInput, i18n, dateInputModel),
			dates);
	});
var $author$project$Common$Policy$isBeforeStartDate = F2(
	function (policy, time) {
		return _Utils_cmp(
			$elm$time$Time$posixToMillis(time),
			$elm$time$Time$posixToMillis(
				$author$project$Common$Policy$startDateTime(policy))) < 0;
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Data$pickInterruptionAt = function (data) {
	switch (data.$) {
		case 0:
			var requestAt = data.a.o6;
			return requestAt;
		case 1:
			var interruptionAt = data.a.a1;
			return interruptionAt;
		default:
			var interruptionAt = data.a.a1;
			return interruptionAt;
	}
};
var $author$project$Page$PolicyDetails$InterruptionModal$View$viewPolicyActivityRow = F3(
	function (i18n, policy, kindData) {
		var interruptionAt = $author$project$Page$PolicyDetails$InterruptionModal$Data$pickInterruptionAt(kindData);
		var activeUntil = A4($justinmimbs$time_extra$Time$Extra$add, 13, -1, $author$project$Common$Locale$customerTimeZone, interruptionAt);
		var activeUntilDate = A2($author$project$Common$Locale$formatPosixDate, $author$project$Common$Locale$customerTimeZone, activeUntil);
		var activeUntilTime = A2($author$project$Common$Locale$formatPosixTime, $author$project$Common$Locale$customerTimeZone, activeUntil);
		var activityMessage = A2($author$project$Common$Policy$isBeforeStartDate, policy, activeUntil) ? _List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Translations$policyInterruptionModalNoActivityLabel(i18n))
			]) : _List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$author$project$Translations$policyInterruptionModalActivityLabel,
					{ma: activeUntilDate, mb: activeUntilTime},
					i18n))
			]);
		if (!kindData.$) {
			return $author$project$Pyxis$Commons$Render$empty;
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('policy-details__interruptions_modal__activity-row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('policy-details__interruptions_modal__text')
							]),
						activityMessage)
					]));
		}
	});
var $author$project$Page$PolicyDetails$InterruptionModal$View$content = F7(
	function (i18n, policy, kindData, expectedRefundRemote, dateInputModel, autocompleteModel, textAreaModel) {
		return _List_fromArray(
			[
				A4($author$project$Page$PolicyDetails$InterruptionModal$View$viewInterruptionDateInput, i18n, policy, kindData, dateInputModel),
				A3($author$project$Page$PolicyDetails$InterruptionModal$View$viewPolicyActivityRow, i18n, policy, kindData),
				A2($author$project$Page$PolicyDetails$InterruptionModal$View$reasonSelect, i18n, autocompleteModel),
				A2(
				$author$project$Common$Render$ifCondition,
				A3($author$project$Page$PolicyDetails$InterruptionModal$View$descriptionInput, i18n, textAreaModel, kindData),
				$author$project$Page$PolicyDetails$InterruptionModal$Data$couldDescriptionBeSet(kindData)),
				A2($author$project$Page$PolicyDetails$InterruptionModal$View$expectedRefundMessage, i18n, expectedRefundRemote)
			]);
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Data$canInterrupt = F2(
	function (data, fn) {
		switch (data.$) {
			case 0:
				var requestAt = data.a.o6;
				var maybeReason = data.a.kC;
				var description = data.a.mN;
				var descriptionStatus = data.a.bD;
				return fn(requestAt) && ($elm_community$maybe_extra$Maybe$Extra$isJust(maybeReason) && A2($author$project$Common$ReasonDescriptionStatus$isDescriptionValid, description, descriptionStatus));
			case 1:
				var interruptionAt = data.a.a1;
				var maybeReason = data.a.kC;
				var description = data.a.mN;
				var descriptionStatus = data.a.bD;
				return fn(interruptionAt) && ($elm_community$maybe_extra$Maybe$Extra$isJust(maybeReason) && A2($author$project$Common$ReasonDescriptionStatus$isDescriptionValid, description, descriptionStatus));
			default:
				var interruptionAt = data.a.a1;
				var maybeReason = data.a.kC;
				var description = data.a.mN;
				var descriptionStatus = data.a.bD;
				return fn(interruptionAt) && ($elm_community$maybe_extra$Maybe$Extra$isJust(maybeReason) && A2($author$project$Common$ReasonDescriptionStatus$isDescriptionValid, description, descriptionStatus));
		}
	});
var $author$project$Common$Policy$isInterrupted = A2($elm$core$Basics$composeL, $elm_community$maybe_extra$Maybe$Extra$isJust, $author$project$Common$Policy$pickInterruption);
var $author$project$Common$Policy$isRenewalCancelled = A2($elm$core$Basics$composeL, $elm_community$maybe_extra$Maybe$Extra$isJust, $author$project$Common$Policy$pickRenewalCancellation);
var $author$project$Common$Policy$isStatusIn = F2(
	function (_v0, statuses) {
		var status = _v0.dx;
		return A2($elm$core$List$member, status, statuses);
	});
var $author$project$Common$Policy$canBeInterrupted = function (policy) {
	return A2(
		$author$project$Common$Policy$isStatusIn,
		policy,
		_List_fromArray(
			[1, 0])) && ((!$author$project$Common$Policy$isInterrupted(policy)) && (!$author$project$Common$Policy$isRenewalCancelled(policy)));
};
var $author$project$Common$Policy$endDateTime = function (_v0) {
	var policy = _v0;
	return $author$project$Common$Locale$midnightAtCustomerDate(policy.et);
};
var $author$project$Common$Policy$isBeforeOrEqualEndDate = F2(
	function (policy, time) {
		return _Utils_cmp(
			$elm$time$Time$posixToMillis(time),
			$elm$time$Time$posixToMillis(
				$author$project$Common$Policy$endDateTime(policy))) < 1;
	});
var $author$project$Common$Policy$isInsideCoolingOffPeriod = F2(
	function (_v0, time) {
		var policy = _v0;
		var timeMillis = $elm$time$Time$posixToMillis(time);
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$le(timeMillis),
				A2(
					$elm$core$Maybe$map,
					$elm$time$Time$posixToMillis,
					A2(
						$elm$core$Maybe$map,
						$author$project$Common$Locale$midnightAtCustomerDate,
						A2(
							$elm$core$Maybe$map,
							A2($justinmimbs$date$Date$add, 3, 1),
							policy.c0)))));
	});
var $author$project$Common$Policy$canBeTerminatedByCustomer = F2(
	function (policy, requestAt) {
		return $author$project$Common$Policy$canBeInterrupted(policy) && ((!A2($author$project$Common$Policy$isInsideCoolingOffPeriod, policy, requestAt)) && A2($author$project$Common$Policy$isBeforeOrEqualEndDate, policy, requestAt));
	});
var $author$project$Common$Policy$canBeTerminatedByPrima = F2(
	function (policy, requestAt) {
		return $author$project$Common$Policy$canBeInterrupted(policy) && A2($author$project$Common$Policy$isBeforeOrEqualEndDate, policy, requestAt);
	});
var $author$project$Common$Policy$isBeforeEndDate = F2(
	function (policy, time) {
		return _Utils_cmp(
			$elm$time$Time$posixToMillis(time),
			$elm$time$Time$posixToMillis(
				$author$project$Common$Policy$endDateTime(policy))) < 0;
	});
var $author$project$Common$Policy$canBeWithdrawn = F2(
	function (policy, requestAt) {
		return $author$project$Common$Policy$canBeInterrupted(policy) && (A2($author$project$Common$Policy$isInsideCoolingOffPeriod, policy, requestAt) && A2($author$project$Common$Policy$isBeforeEndDate, policy, requestAt));
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Data$canInterruptMapper = function (data) {
	switch (data.$) {
		case 0:
			return $author$project$Common$Policy$canBeWithdrawn;
		case 1:
			return $author$project$Common$Policy$canBeTerminatedByCustomer;
		default:
			return $author$project$Common$Policy$canBeTerminatedByPrima;
	}
};
var $author$project$Page$PolicyDetails$InterruptionModal$View$isInterruptionButtonDisabled = F2(
	function (policy, kindData) {
		return !A2(
			$author$project$Page$PolicyDetails$InterruptionModal$Data$canInterrupt,
			kindData,
			A2($author$project$Page$PolicyDetails$InterruptionModal$Data$canInterruptMapper, kindData, policy));
	});
var $author$project$Page$PolicyDetails$Msg$CustomerTerminationConfirmationButtonPressed = function (a) {
	return {$: 20, a: a};
};
var $author$project$Page$PolicyDetails$Msg$PrimaTerminationConfirmationButtonPressed = function (a) {
	return {$: 21, a: a};
};
var $author$project$Page$PolicyDetails$Msg$WithdrawalConfirmationButtonPressed = function (a) {
	return {$: 19, a: a};
};
var $author$project$Page$PolicyDetails$InterruptionModal$View$onSubmit = F2(
	function (id, inputData) {
		switch (inputData.$) {
			case 0:
				var maybeReason = inputData.a.kC;
				var requestAt = inputData.a.o6;
				var description = inputData.a.mN;
				return $author$project$Page$PolicyDetails$Msg$WithdrawalConfirmationButtonPressed(
					{
						mN: description,
						kg: id,
						im: A2($elm$core$Maybe$withDefault, 16, maybeReason),
						h: requestAt
					});
			case 1:
				var maybeReason = inputData.a.kC;
				var requestAt = inputData.a.o6;
				var interruptionAt = inputData.a.a1;
				var description = inputData.a.mN;
				return $author$project$Page$PolicyDetails$Msg$CustomerTerminationConfirmationButtonPressed(
					{
						mN: description,
						kg: id,
						a1: interruptionAt,
						im: A2($elm$core$Maybe$withDefault, 19, maybeReason),
						h: requestAt
					});
			default:
				var maybeReason = inputData.a.kC;
				var requestAt = inputData.a.o6;
				var interruptionAt = inputData.a.a1;
				var description = inputData.a.mN;
				return $author$project$Page$PolicyDetails$Msg$PrimaTerminationConfirmationButtonPressed(
					{
						mN: description,
						kg: id,
						a1: interruptionAt,
						im: A2($elm$core$Maybe$withDefault, 4, maybeReason),
						h: requestAt
					});
		}
	});
var $author$project$Page$PolicyDetails$InterruptionModal$View$footer = F3(
	function (i18n, policy, kindData) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						$author$project$Page$PolicyDetails$Msg$InterruptionDismissed,
						A2(
							$author$project$Pyxis$Components$Button$withText,
							$author$project$Translations$policyInterruptionModalCancelButton(i18n),
							$author$project$Pyxis$Components$Button$secondary))),
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withDisabled,
						A2($author$project$Page$PolicyDetails$InterruptionModal$View$isInterruptionButtonDisabled, policy, kindData),
						A2(
							$author$project$Pyxis$Components$Button$withOnClick,
							A2(
								$author$project$Page$PolicyDetails$InterruptionModal$View$onSubmit,
								$author$project$Common$Policy$pickId(policy),
								kindData),
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$policyInterruptionModalProceedButton(i18n),
								$author$project$Pyxis$Components$Button$primary))))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Translations$policyInterruptionModalCancellationByCompanyTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy cancellation by Prima';
	} else {
		return 'Prima cancela póliza';
	}
};
var $author$project$Translations$policyInterruptionModalCancellationByCustomerTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy cancellation by customer';
	} else {
		return 'Cliente cancela póliza';
	}
};
var $author$project$Translations$policyInterruptionModalWithdrawTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Confirm Policy Withdraw';
	} else {
		return 'Confirmar Desistimiento';
	}
};
var $author$project$Page$PolicyDetails$InterruptionModal$View$headerTitle = F2(
	function (i18n, kindData) {
		switch (kindData.$) {
			case 0:
				return $author$project$Translations$policyInterruptionModalWithdrawTitle(i18n);
			case 1:
				return $author$project$Translations$policyInterruptionModalCancellationByCustomerTitle(i18n);
			default:
				return $author$project$Translations$policyInterruptionModalCancellationByCompanyTitle(i18n);
		}
	});
var $author$project$Page$PolicyDetails$InterruptionModal$View$header = F2(
	function (i18n, kindData) {
		return A2(
			$author$project$Pyxis$Components$Modal$Header$withTitle,
			A2($author$project$Page$PolicyDetails$InterruptionModal$View$headerTitle, i18n, kindData),
			$author$project$Pyxis$Components$Modal$Header$config);
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$pickDateInput = function (_v0) {
	var model = _v0;
	return model.aI;
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$pickDescriptionInput = function (_v0) {
	var model = _v0;
	return model.aC;
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$pickExpectedRefund = function (_v0) {
	var model = _v0;
	return model.mY;
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$pickReasonInput = function (_v0) {
	var model = _v0;
	return model.aN;
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$pickVisibilityState = function (_v0) {
	var model = _v0;
	return model.cq;
};
var $author$project$Page$PolicyDetails$InterruptionModal$View$renderModal = F4(
	function (i18n, model, policy, kindData) {
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			$author$project$Page$PolicyDetails$InterruptionModal$Model$pickVisibilityState(model),
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A3($author$project$Page$PolicyDetails$InterruptionModal$View$footer, i18n, policy, kindData),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					A7(
						$author$project$Page$PolicyDetails$InterruptionModal$View$content,
						i18n,
						policy,
						kindData,
						$author$project$Page$PolicyDetails$InterruptionModal$Model$pickExpectedRefund(model),
						$author$project$Page$PolicyDetails$InterruptionModal$Model$pickDateInput(model),
						$author$project$Page$PolicyDetails$InterruptionModal$Model$pickReasonInput(model),
						$author$project$Page$PolicyDetails$InterruptionModal$Model$pickDescriptionInput(model)),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						A2($author$project$Page$PolicyDetails$InterruptionModal$View$header, i18n, kindData),
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							$author$project$Page$PolicyDetails$Msg$InterruptionDismissed,
							'',
							A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
	});
var $author$project$Page$PolicyDetails$InterruptionModal$View$render = F2(
	function (i18n, modalState) {
		return A3(
			$author$project$Common$Render$maybe2,
			A2($author$project$Page$PolicyDetails$InterruptionModal$View$renderModal, i18n, modalState),
			$author$project$Page$PolicyDetails$InterruptionModal$Model$pickPolicy(modalState),
			$author$project$Page$PolicyDetails$InterruptionModal$Model$pickKindData(modalState));
	});
var $author$project$Translations$refundIssuingModalContent = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'By confirming, you cannot undo this action.';
	} else {
		return 'Al confirmar, no podrás deshacer esta acción.';
	}
};
var $author$project$Page$PolicyDetails$RefundIssuingModal$content = function (i18n) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('details__refund-modal')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$refundIssuingModalContent(i18n))
				]))
		]);
};
var $author$project$Translations$refundIssuingModalNoButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'No';
	} else {
		return 'No';
	}
};
var $author$project$Translations$refundIssuingModalYesButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Yes';
	} else {
		return 'Sí';
	}
};
var $author$project$Page$PolicyDetails$RefundIssuingModal$footer = F4(
	function (i18n, dismissMsg, confirmMsg, refund) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						dismissMsg,
						A2(
							$author$project$Pyxis$Components$Button$withWidth,
							$author$project$Pyxis$Components$Button$inherit,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$refundIssuingModalNoButton(i18n),
								$author$project$Pyxis$Components$Button$secondary)))),
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						confirmMsg(refund),
						A2(
							$author$project$Pyxis$Components$Button$withWidth,
							$author$project$Pyxis$Components$Button$inherit,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$refundIssuingModalYesButton(i18n),
								$author$project$Pyxis$Components$Button$primary))))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Translations$refundIssuingModalTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Do you want to proceed with the refund?';
	} else {
		return '¿Quieres proceder con el reembolso?';
	}
};
var $author$project$Page$PolicyDetails$RefundIssuingModal$header = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withTitle,
		$author$project$Translations$refundIssuingModalTitle(i18n),
		$author$project$Pyxis$Components$Modal$Header$config);
};
var $author$project$Page$PolicyDetails$RefundIssuingModal$renderModal = F5(
	function (i18n, dismissMsg, confirmMsg, visibility, refund) {
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			visibility,
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A4($author$project$Page$PolicyDetails$RefundIssuingModal$footer, i18n, dismissMsg, confirmMsg, refund),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					$author$project$Page$PolicyDetails$RefundIssuingModal$content(i18n),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						$author$project$Page$PolicyDetails$RefundIssuingModal$header(i18n),
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							dismissMsg,
							'',
							A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
	});
var $author$project$Page$PolicyDetails$RefundIssuingModal$render = F4(
	function (i18n, dismissMsg, confirmMsg, _v0) {
		var visibility = _v0.cq;
		var refund = _v0.o4;
		return A2(
			$author$project$Common$Render$maybe,
			A4($author$project$Page$PolicyDetails$RefundIssuingModal$renderModal, i18n, dismissMsg, confirmMsg, visibility),
			refund);
	});
var $author$project$Page$PolicyDetails$RenewalCancellationModal$pickPolicy = function (_v0) {
	var model = _v0;
	return model.k;
};
var $author$project$Page$PolicyDetails$Msg$RenewalCancellationDismissed = {$: 32};
var $author$project$Page$PolicyDetails$Msg$RenewalCancellationReasonDescriptionChanged = function (a) {
	return {$: 34, a: a};
};
var $author$project$Translations$renewalCancellationModalReasonDescriptionLabelMandatory = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Additional note (mandatory)';
	} else {
		return 'Notas adicionales (obligatório)';
	}
};
var $author$project$Translations$renewalCancellationModalReasonDescriptionLabelOptional = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Additional note (optional)';
	} else {
		return 'Notas adicionales (opcional)';
	}
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$descriptionTextareaLabel = F2(
	function (i18n, status) {
		switch (status) {
			case 0:
				return $author$project$Translations$renewalCancellationModalReasonDescriptionLabelMandatory(i18n);
			case 1:
				return $author$project$Translations$renewalCancellationModalReasonDescriptionLabelOptional(i18n);
			default:
				return '';
		}
	});
var $author$project$Page$PolicyDetails$RenewalCancellationModal$descriptionInput = F2(
	function (i18n, _v0) {
		var model = _v0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('policy-details__renewal-cancellation__additional-notes')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Pyxis$Components$Field$Textarea$render,
					$author$project$Page$PolicyDetails$Msg$RenewalCancellationReasonDescriptionChanged,
					model.aC,
					A2(
						$author$project$Pyxis$Components$Field$Textarea$withLabel,
						A2(
							$author$project$Pyxis$Components$Field$Label$withText,
							A2($author$project$Page$PolicyDetails$RenewalCancellationModal$descriptionTextareaLabel, i18n, model.bD),
							$author$project$Pyxis$Components$Field$Label$config),
						A2(
							$author$project$Pyxis$Components$Field$Textarea$withSize,
							$author$project$Pyxis$Components$Field$Textarea$sizeS,
							$author$project$Pyxis$Components$Field$Textarea$config('additional-notes'))))
				]));
	});
var $author$project$Page$PolicyDetails$Msg$RenewalCancellationReasonSelected = function (a) {
	return {$: 33, a: a};
};
var $author$project$Translations$renewalCancellationModalReasonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Reason';
	} else {
		return 'Motivo';
	}
};
var $author$project$Translations$renewalCancellationModalReasonPlaceholder = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Select the reason';
	} else {
		return 'Seleccionar el motivo';
	}
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$reasonSelect = F2(
	function (i18n, _v0) {
		var model = _v0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('policy-details__renewal-cancellation__reason')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Pyxis$Components$Field$Autocomplete$render,
					$author$project$Page$PolicyDetails$Msg$RenewalCancellationReasonSelected,
					model.aN,
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$withLabel,
						A2(
							$author$project$Pyxis$Components$Field$Label$withText,
							$author$project$Translations$renewalCancellationModalReasonLabel(i18n),
							$author$project$Pyxis$Components$Field$Label$config),
						A2(
							$author$project$Pyxis$Components$Field$Autocomplete$withSize,
							$author$project$Pyxis$Components$Field$Autocomplete$sizeS,
							A2(
								$author$project$Pyxis$Components$Field$Autocomplete$withPlaceholder,
								$author$project$Translations$renewalCancellationModalReasonPlaceholder(i18n),
								$author$project$Pyxis$Components$Field$Autocomplete$config('reason-kind')))))
				]));
	});
var $author$project$Translations$renewalCancellationModalDescriptionLabel = F2(
	function (expiryDate, _v0) {
		var lang = _v0;
		if (!lang) {
			return 'The cancellation date corresponds to the original expiry date of the policy: ' + (expiryDate + '.');
		} else {
			return 'La fecha de cancelación corresponde a la fecha de vencimiento original de la póliza: ' + (expiryDate + '.');
		}
	});
var $author$project$Page$PolicyDetails$RenewalCancellationModal$content = F3(
	function (i18n, model, policy) {
		var isDescriptionEditable = function (_v0) {
			var descriptionStatus = _v0.bD;
			return $author$project$Common$ReasonDescriptionStatus$couldDescriptionBeSet(descriptionStatus);
		};
		var descriptionLabel = A2(
			$author$project$Translations$renewalCancellationModalDescriptionLabel,
			$author$project$Common$Locale$formatDate(
				$author$project$Common$Policy$pickEndDate(policy)),
			i18n);
		return _List_fromArray(
			[
				$elm$html$Html$text(descriptionLabel),
				A2($author$project$Page$PolicyDetails$RenewalCancellationModal$reasonSelect, i18n, model),
				A2(
				$author$project$Common$Render$ifCondition,
				A2($author$project$Page$PolicyDetails$RenewalCancellationModal$descriptionInput, i18n, model),
				isDescriptionEditable(model))
			]);
	});
var $author$project$Common$Policy$canRenewalBeCancelled = function (policy) {
	return A2(
		$author$project$Common$Policy$isStatusIn,
		policy,
		_List_fromArray(
			[1, 2])) && ((!$author$project$Common$Policy$isInterrupted(policy)) && (!$author$project$Common$Policy$isRenewalCancelled(policy)));
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$isDataInputValid = function (_v0) {
	var selectedReason = _v0.fk;
	var additionalNotes = _v0.me;
	var descriptionStatus = _v0.bD;
	return $elm_community$maybe_extra$Maybe$Extra$isJust(selectedReason) && A2($author$project$Common$ReasonDescriptionStatus$isDescriptionValid, additionalNotes, descriptionStatus);
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$isConfirmButtonDisabled = F2(
	function (model, policy) {
		return !($author$project$Common$Policy$canRenewalBeCancelled(policy) && $author$project$Page$PolicyDetails$RenewalCancellationModal$isDataInputValid(model));
	});
var $author$project$Page$PolicyDetails$Msg$RenewalCancellationConfirmationButtonPressed = function (a) {
	return {$: 35, a: a};
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$onSubmit = F2(
	function (policy, _v0) {
		var selectedReason = _v0.fk;
		var additionalNotes = _v0.me;
		return $author$project$Page$PolicyDetails$Msg$RenewalCancellationConfirmationButtonPressed(
			{
				me: additionalNotes,
				kg: $author$project$Common$Policy$pickId(policy),
				im: A2($elm$core$Maybe$withDefault, 19, selectedReason),
				h: $author$project$Common$Locale$midnightAtCustomerDate(
					$author$project$Common$Policy$pickEndDate(policy))
			});
	});
var $author$project$Translations$renewalCancellationModalBackButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Back';
	} else {
		return 'Atrás';
	}
};
var $author$project$Translations$renewalCancellationModalConfirmButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Confirm';
	} else {
		return 'Confirmar';
	}
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$footer = F3(
	function (i18n, model, policy) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						$author$project$Page$PolicyDetails$Msg$RenewalCancellationDismissed,
						A2(
							$author$project$Pyxis$Components$Button$withText,
							$author$project$Translations$renewalCancellationModalBackButton(i18n),
							$author$project$Pyxis$Components$Button$secondary))),
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withDisabled,
						A2($author$project$Page$PolicyDetails$RenewalCancellationModal$isConfirmButtonDisabled, model, policy),
						A2(
							$author$project$Pyxis$Components$Button$withOnClick,
							A2($author$project$Page$PolicyDetails$RenewalCancellationModal$onSubmit, policy, model),
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$renewalCancellationModalConfirmButton(i18n),
								$author$project$Pyxis$Components$Button$primary))))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Translations$renewalCancellationModalHeaderTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Renewal’s cancellation';
	} else {
		return 'Cancelación de la renovación';
	}
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$header = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withTitle,
		$author$project$Translations$renewalCancellationModalHeaderTitle(i18n),
		$author$project$Pyxis$Components$Modal$Header$config);
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$pickVisibilityState = function (_v0) {
	var model = _v0;
	return model.cq;
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$renderModal = F3(
	function (i18n, model, policy) {
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			$author$project$Page$PolicyDetails$RenewalCancellationModal$pickVisibilityState(model),
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A3($author$project$Page$PolicyDetails$RenewalCancellationModal$footer, i18n, model, policy),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					A3($author$project$Page$PolicyDetails$RenewalCancellationModal$content, i18n, model, policy),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						$author$project$Page$PolicyDetails$RenewalCancellationModal$header(i18n),
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							$author$project$Page$PolicyDetails$Msg$RenewalCancellationDismissed,
							'',
							A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
	});
var $author$project$Page$PolicyDetails$RenewalCancellationModal$render = F2(
	function (i18n, modalState) {
		return A2(
			$author$project$Common$Render$maybe,
			A2($author$project$Page$PolicyDetails$RenewalCancellationModal$renderModal, i18n, modalState),
			$author$project$Page$PolicyDetails$RenewalCancellationModal$pickPolicy(modalState));
	});
var $author$project$Page$PolicyDetails$SendEmailModal$ModalDismissed = {$: 1};
var $author$project$Page$PolicyDetails$SendEmailModal$CheckboxGroupUpdate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$PolicyDetails$SendEmailModal$PolicyContract = 0;
var $author$project$Translations$sendPolicyEmailModalPolicyContractEmailLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy documents';
	} else {
		return 'Documentos de la póliza';
	}
};
var $author$project$Translations$sendPolicyEmailModalSelectionErrorMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'You need to select an email';
	} else {
		return 'Debes seleccionar un email';
	}
};
var $author$project$Page$PolicyDetails$SendEmailModal$validation = F2(
	function (i18n, selected) {
		if (!selected.b) {
			return $elm$core$Result$Err(
				$author$project$Translations$sendPolicyEmailModalSelectionErrorMessage(i18n));
		} else {
			return $elm$core$Result$Ok(selected);
		}
	});
var $author$project$Page$PolicyDetails$SendEmailModal$emailCheckBoxGroup = F3(
	function (i18n, tagger, _v0) {
		var isSubmitted = _v0.cY;
		var checkboxModel = _v0.aW;
		return A3(
			$author$project$Pyxis$Components$Field$CheckboxGroup$render,
			A2($elm$core$Basics$composeL, tagger, $author$project$Page$PolicyDetails$SendEmailModal$CheckboxGroupUpdate),
			checkboxModel,
			A2(
				$author$project$Pyxis$Components$Field$CheckboxGroup$withOptionsCard,
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Field$CheckboxGroup$optionCardSizeM(
						{
							mf: $elm$core$Maybe$Nothing,
							pu: $elm$core$Maybe$Nothing,
							iS: $elm$core$Maybe$Just(
								$author$project$Translations$sendPolicyEmailModalPolicyContractEmailLabel(i18n)),
							pB: 0
						})
					]),
				A3(
					$author$project$Pyxis$Components$Field$CheckboxGroup$withValidationOnSubmit,
					$author$project$Page$PolicyDetails$SendEmailModal$validation(i18n),
					isSubmitted,
					$author$project$Pyxis$Components$Field$CheckboxGroup$config('policy-email-selection'))));
	});
var $author$project$Page$PolicyDetails$SendEmailModal$emailRecipientText = function (email) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('text-l-bold', true)
					]))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(email)
			]));
};
var $author$project$Translations$sendPolicyEmailModalEmailRecipientLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Emails will be sent to';
	} else {
		return 'El email se enviará a';
	}
};
var $author$project$Page$PolicyDetails$SendEmailModal$emailRecipientBlock = F2(
	function (i18n, emailRecipient) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('send-policy-email-modal__receiver-block')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$sendPolicyEmailModalEmailRecipientLabel(i18n)),
					A2($author$project$Common$Render$maybe, $author$project$Page$PolicyDetails$SendEmailModal$emailRecipientText, emailRecipient)
				]));
	});
var $author$project$Translations$sendPolicyEmailModalCheckboxSelectionTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Which email do you want to send to the customer?';
	} else {
		return '¿Qué email quieres enviarle al cliente?';
	}
};
var $author$project$Page$PolicyDetails$SendEmailModal$content = F3(
	function (i18n, tagger, model) {
		var emailRecipient = model.gt;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('send-policy-email-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('send-policy-email-modal__which-email-text')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$sendPolicyEmailModalCheckboxSelectionTitle(i18n))
							])),
						A3($author$project$Page$PolicyDetails$SendEmailModal$emailCheckBoxGroup, i18n, tagger, model),
						A2($author$project$Page$PolicyDetails$SendEmailModal$emailRecipientBlock, i18n, emailRecipient)
					]))
			]);
	});
var $author$project$Page$PolicyDetails$SendEmailModal$Validate = {$: 2};
var $author$project$Translations$sendPolicyEmailModalDismissButtonText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Back';
	} else {
		return 'Atrás';
	}
};
var $author$project$Translations$sendPolicyEmailModalSubmitButtonText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Send email';
	} else {
		return 'Enviar email';
	}
};
var $author$project$Page$PolicyDetails$SendEmailModal$footer = F2(
	function (i18n, tagger) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						tagger($author$project$Page$PolicyDetails$SendEmailModal$ModalDismissed),
						A2(
							$author$project$Pyxis$Components$Button$withWidth,
							$author$project$Pyxis$Components$Button$inherit,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$sendPolicyEmailModalDismissButtonText(i18n),
								$author$project$Pyxis$Components$Button$secondary)))),
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						tagger($author$project$Page$PolicyDetails$SendEmailModal$Validate),
						A2(
							$author$project$Pyxis$Components$Button$withWidth,
							$author$project$Pyxis$Components$Button$inherit,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$sendPolicyEmailModalSubmitButtonText(i18n),
								$author$project$Pyxis$Components$Button$primary))))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Page$PolicyDetails$SendEmailModal$modalIcon = A2(
	$author$project$Pyxis$Components$Icon$withColor,
	$author$project$Pyxis$Tokens$TypographyColor$tokenBrand,
	$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$paperPlane));
var $author$project$Translations$sendPolicyEmailModalTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Set up email sending';
	} else {
		return 'Configurar el envío de emails';
	}
};
var $author$project$Page$PolicyDetails$SendEmailModal$header = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withTitle,
		$author$project$Translations$sendPolicyEmailModalTitle(i18n),
		A2(
			$author$project$Pyxis$Components$Modal$Header$withIcon,
			$author$project$Page$PolicyDetails$SendEmailModal$modalIcon,
			A2($author$project$Pyxis$Components$Modal$Header$withIcon, $author$project$Page$PolicyDetails$SendEmailModal$modalIcon, $author$project$Pyxis$Components$Modal$Header$config)));
};
var $author$project$Page$PolicyDetails$SendEmailModal$render = F2(
	function (i18n, model) {
		var visibility = model.cq;
		var tagger = model.iM;
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			visibility,
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A2($author$project$Page$PolicyDetails$SendEmailModal$footer, i18n, tagger),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					A3($author$project$Page$PolicyDetails$SendEmailModal$content, i18n, tagger, model),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						$author$project$Page$PolicyDetails$SendEmailModal$header(i18n),
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							tagger($author$project$Page$PolicyDetails$SendEmailModal$ModalDismissed),
							'',
							A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
	});
var $author$project$Page$PolicyDetails$Msg$CreateRefundButtonPressed = function (a) {
	return {$: 23, a: a};
};
var $author$project$Page$PolicyDetails$Msg$InterruptionButtonPressed = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$PolicyDetails$Msg$IssueRefundRequest = function (a) {
	return {$: 24, a: a};
};
var $author$project$Page$PolicyDetails$Msg$OpenAmendModal = function (a) {
	return {$: 50, a: a};
};
var $author$project$Page$PolicyDetails$Msg$RenewalCancellationButtonPressed = function (a) {
	return {$: 31, a: a};
};
var $author$project$Page$PolicyDetails$Msg$RenewalsLinkClicked = function (a) {
	return {$: 37, a: a};
};
var $author$project$Page$PolicyDetails$Msg$RetryGetPaymentMethod = function (a) {
	return {$: 40, a: a};
};
var $author$project$Page$PolicyDetails$Msg$ShowTooltip = function (a) {
	return {$: 6, a: a};
};
var $author$project$Common$CoverContinuity$PreviousInsuranceInfo = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$PolicyDetails$Msg$ChangeEmail = function (a) {
	return {$: 46, a: a};
};
var $author$project$Common$User$hasChangeEmailPermission = function (user) {
	return A2($author$project$Common$User$hasPermission, user, 'policy:update');
};
var $author$project$Common$Portfolio$withOnChangeEmailAction = F2(
	function (action, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				hI: $elm$core$Maybe$Just(action)
			});
	});
var $author$project$Page$PolicyDetails$View$maybeAddChangeEmailActionToPortfolioConfig = F2(
	function (user, conf) {
		return $author$project$Common$User$hasChangeEmailPermission(user) ? A2($author$project$Common$Portfolio$withOnChangeEmailAction, $author$project$Page$PolicyDetails$Msg$ChangeEmail, conf) : conf;
	});
var $author$project$Page$PolicyDetails$Model$pickCustomerId = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.gi;
	},
	A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$toMaybe, $elm_community$maybe_extra$Maybe$Extra$join));
var $author$project$Common$Policy$pickData = function (_v0) {
	var policy = _v0;
	return policy;
};
var $author$project$Page$PolicyDetails$View$portfolioConfig = F3(
	function (user, policy, model) {
		var _v0 = $author$project$Common$Policy$pickData(policy);
		var vehicleOwner = _v0.l$;
		var mainDriver = _v0.eU;
		var additionalDriver = _v0.jb;
		var policyHolder = _v0.ib;
		var vehicle = _v0.i$;
		var coverContinuity = _v0.jG;
		var product = _v0.av;
		return A2(
			$author$project$Page$PolicyDetails$View$maybeAddChangeEmailActionToPortfolioConfig,
			user,
			$author$project$Common$Portfolio$config(vehicleOwner)(mainDriver)(additionalDriver)(policyHolder)(vehicle)(model.cF)(
				$author$project$Common$CoverContinuity$PreviousInsuranceInfo(coverContinuity))(product.mt)(
				$author$project$Page$PolicyDetails$Model$pickCustomerId(model))(model.jI)($elm$core$Maybe$Nothing));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$InterruptedPolicy = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Common$IssuingCompany$toString = function (issuingCompany) {
	if (!issuingCompany) {
		return 'Iptiq';
	} else {
		return 'Great Lakes';
	}
};
var $author$project$Common$Policy$pickIssuingCompany = function (_v0) {
	var policy = _v0;
	return $author$project$Common$IssuingCompany$toString(policy.av.a3);
};
var $author$project$Common$ComponentUI$DetailsResultBox$newInterruptedPolicyConfiguration = F5(
	function (i18n, actions, refundData, policy, interruption) {
		return A3(
			$author$project$Common$ComponentUI$DetailsResultBox$InterruptedPolicy,
			{
				ni: i18n,
				a3: $author$project$Common$Policy$pickIssuingCompany(policy),
				bd: $author$project$Common$Policy$gross(policy)
			},
			{b$: actions.e3, k: policy},
			{cV: interruption, hD: actions.e0, hO: actions.hN, hV: actions.hU, b_: actions.b_, ds: refundData});
	});
var $author$project$Common$ComponentUI$DetailsResultBox$DetailsResultInterruptableData = F4(
	function (onInterruptionButtonClicked, interruptionStatus, onRenewalCancellationButtonClicked, canRenewalBeCancelled) {
		return {jm: canRenewalBeCancelled, ko: interruptionStatus, kS: onInterruptionButtonClicked, k3: onRenewalCancellationButtonClicked};
	});
var $author$project$Common$ComponentUI$DetailsResultBox$Policy = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Common$ComponentUI$DetailsResultBox$InterruptionStatus = F3(
	function (canBeWithdrawn, canBeTerminatedByCustomer, canBeTerminatedByPrima) {
		return {jj: canBeTerminatedByCustomer, jk: canBeTerminatedByPrima, jl: canBeWithdrawn};
	});
var $author$project$Common$ComponentUI$DetailsResultBox$newInterruptionStatus = F2(
	function (time, policy) {
		return A3(
			$author$project$Common$ComponentUI$DetailsResultBox$InterruptionStatus,
			A2($author$project$Common$Policy$canBeWithdrawn, policy, time),
			A2($author$project$Common$Policy$canBeTerminatedByCustomer, policy, time),
			A2($author$project$Common$Policy$canBeTerminatedByPrima, policy, time));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$newPolicyConfiguration = F5(
	function (i18n, actions, user, time, policy) {
		return A4(
			$author$project$Common$ComponentUI$DetailsResultBox$Policy,
			{
				ni: i18n,
				a3: $author$project$Common$Policy$pickIssuingCompany(policy),
				bd: $author$project$Common$Policy$gross(policy)
			},
			{b$: actions.e3, k: policy},
			A4(
				$author$project$Common$ComponentUI$DetailsResultBox$DetailsResultInterruptableData,
				actions.hT,
				A2($author$project$Common$ComponentUI$DetailsResultBox$newInterruptionStatus, time, policy),
				actions.h_,
				$author$project$Common$Policy$canRenewalBeCancelled(policy)),
			user);
	});
var $author$project$Common$ComponentUI$DetailsResultBox$newPolicyViewConfiguration = F6(
	function (i18n, actions, user, time, refundData, policy) {
		return A2(
			$elm$core$Maybe$withDefault,
			A5($author$project$Common$ComponentUI$DetailsResultBox$newPolicyConfiguration, i18n, actions, user, time, policy),
			A2(
				$elm$core$Maybe$map,
				A4($author$project$Common$ComponentUI$DetailsResultBox$newInterruptedPolicyConfiguration, i18n, actions, refundData, policy),
				$author$project$Common$Policy$pickInterruption(policy)));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewFromPolicy = F6(
	function (i18n, actions, user, time, refundData, policy) {
		return $author$project$Common$ComponentUI$DetailsResultBox$view(
			A6($author$project$Common$ComponentUI$DetailsResultBox$newPolicyViewConfiguration, i18n, actions, user, time, refundData, policy));
	});
var $author$project$Page$PolicyDetails$Msg$SendEmailButtonClicked = F2(
	function (a, b) {
		return {$: 42, a: a, b: b};
	});
var $author$project$Page$PolicyDetails$View$emailSendButton = F3(
	function (i18n, policyId, email) {
		return $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withOnClick,
				A2($author$project$Page$PolicyDetails$Msg$SendEmailButtonClicked, policyId, email),
				A2(
					$author$project$Pyxis$Components$Button$withIconPrepend,
					$author$project$Pyxis$Components$IconSet$paperPlane,
					A2(
						$author$project$Pyxis$Components$Button$withSize,
						$author$project$Pyxis$Components$Button$sizeM,
						A2(
							$author$project$Pyxis$Components$Button$withText,
							$author$project$Translations$sendPolicyEmailModalSubmitButtonText(i18n),
							$author$project$Pyxis$Components$Button$tertiary)))));
	});
var $author$project$Page$PolicyDetails$Msg$RedirectToSearch = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$PolicyDetails$View$navigateToResults = A2(
	$elm$core$Basics$composeR,
	$author$project$Common$Policy$pickPolicyHolder,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Common$Person$pickPersonData,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.ar;
			},
			A2($elm$core$Basics$composeR, $author$project$Page$Search$SearchQueryParam$DocumentId, $author$project$Page$PolicyDetails$Msg$RedirectToSearch))));
var $author$project$Page$PolicyDetails$View$viewHeaderContainer = F3(
	function (i18n, model, policy) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('policy-details-header-container')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$ComponentUI$BackToResults$view,
					i18n,
					$author$project$Page$PolicyDetails$View$navigateToResults(policy)),
					A3(
					$author$project$Page$PolicyDetails$View$emailSendButton,
					i18n,
					$author$project$Common$Policy$pickId(policy),
					$author$project$Page$PolicyDetails$Model$pickEmailRecipient(model))
				]));
	});
var $author$project$Page$PolicyDetails$View$viewPolicy = F5(
	function (i18n, user, model, policy, time) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('policy-details__primary-container container-responsive padding-v-3xl')
				]),
			_List_fromArray(
				[
					A3($author$project$Page$PolicyDetails$View$viewHeaderContainer, i18n, model, policy),
					A6(
					$author$project$Common$ComponentUI$DetailsResultBox$viewFromPolicy,
					i18n,
					{
						e0: A2(
							$elm$core$Maybe$map,
							$author$project$Page$PolicyDetails$Msg$OpenAmendModal,
							$author$project$Common$Policy$pickAmendTerminationAction(policy)),
						hN: $author$project$Page$PolicyDetails$Msg$CreateRefundButtonPressed,
						e3: $author$project$Page$PolicyDetails$Msg$ShowTooltip,
						hT: $author$project$Page$PolicyDetails$Msg$InterruptionButtonPressed,
						hU: $author$project$Page$PolicyDetails$Msg$IssueRefundRequest,
						h_: $author$project$Page$PolicyDetails$Msg$RenewalCancellationButtonPressed,
						b_: $author$project$Page$PolicyDetails$Msg$RenewalsLinkClicked
					},
					user,
					time,
					model.o4,
					policy),
					A3(
					$author$project$Common$Portfolio$render,
					i18n,
					model.dn,
					A3($author$project$Page$PolicyDetails$View$portfolioConfig, user, policy, model)),
					A3(
					$author$project$Common$ComponentUI$PaymentBox$view,
					i18n,
					model.lc,
					$author$project$Page$PolicyDetails$Msg$RetryGetPaymentMethod(
						$author$project$Common$Policy$pickId(policy)))
				]));
	});
var $author$project$Page$PolicyDetails$View$viewToasts = function (model) {
	return A3(
		$author$project$Pyxis$Components$Toasts$render,
		$author$project$Page$PolicyDetails$Msg$ToastMsg,
		model.s,
		A2(
			$author$project$Pyxis$Components$Toasts$withPlacement,
			$author$project$Pyxis$Components$Toasts$topRightPlacement,
			$author$project$Pyxis$Components$Toasts$config('policy-details-toaster')));
};
var $author$project$Page$PolicyDetails$View$view = F3(
	function (i18n, user, model) {
		var _v0 = _Utils_Tuple2(model.k, model.gg);
		_v0$2:
		while (true) {
			switch (_v0.a.$) {
				case 3:
					if (!_v0.b.$) {
						var policy = _v0.a.a;
						var time = _v0.b.a;
						var chosenExcess = A2(
							$elm$core$Maybe$withDefault,
							$author$project$Common$CoverSelection$defaultExcess,
							A2(
								$elm$core$Maybe$map,
								$author$project$Common$CoverSelection$pickExcess,
								$krisajenkins$remotedata$RemoteData$toMaybe(model.jI)));
						return _List_fromArray(
							[
								$author$project$Page$PolicyDetails$View$viewToasts(model),
								A5($author$project$Page$PolicyDetails$View$viewPolicy, i18n, user, model, policy, time),
								A2($author$project$Page$PolicyDetails$InterruptionModal$View$render, i18n, model.p),
								A2($author$project$Page$PolicyDetails$RenewalCancellationModal$render, i18n, model.am),
								A2($author$project$Page$PolicyDetails$SendEmailModal$render, i18n, model.ce),
								A4($author$project$Page$PolicyDetails$RefundIssuingModal$render, i18n, $author$project$Page$PolicyDetails$Msg$IssueRefundDismissed, $author$project$Page$PolicyDetails$Msg$IssueRefundConfirmation, model.b9),
								A2($author$project$Page$PolicyDetails$ChangeEmailModal$render, i18n, model.bx),
								A4(
								$author$project$Common$ComponentUI$Modal$CoverPackages$render,
								i18n,
								$author$project$Common$Policy$pickSelectedBundle(policy),
								chosenExcess,
								model.ed),
								A2(
								$author$project$Common$Render$maybe,
								$author$project$Page$PolicyDetails$AmendInterruptionModal$render(i18n),
								model.U)
							]);
					} else {
						break _v0$2;
					}
				case 2:
					return _List_fromArray(
						[$author$project$Common$ErrorContainer$generic]);
				default:
					break _v0$2;
			}
		}
		return _List_fromArray(
			[
				$author$project$Page$PolicyDetails$View$viewToasts(model),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('policy-details__loading')
					]),
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Loaders$Loader$render($author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM)
					]))
			]);
	});
var $author$project$Page$PolicyDetails$view = F3(
	function (i18n, user, model) {
		return {
			f$: A3($author$project$Page$PolicyDetails$View$view, i18n, user, model),
			iS: $author$project$Translations$routePolicyDetails(i18n)
		};
	});
var $author$project$Translations$routeSearch = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Search';
	} else {
		return 'Busqueda';
	}
};
var $author$project$Common$User$canSearchByCustomerId = function (user) {
	return A2($author$project$Common$User$hasPermission, user, 'offer:searchbycustomerid') && A2($author$project$Common$User$hasPermission, user, 'policy:searchbycustomerid');
};
var $author$project$Page$Search$Msg$Submitted = {$: 0};
var $author$project$Pyxis$Components$Form$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{f6: classList});
	});
var $author$project$Page$Search$SearchBar$formContainer = F3(
	function (searchInput, onSubmit, isButtonLoading) {
		return $author$project$Pyxis$Components$Form$render(
			A2(
				$author$project$Pyxis$Components$Form$withOnSubmit,
				onSubmit,
				A2(
					$author$project$Pyxis$Components$Form$withFieldsets,
					_List_fromArray(
						[
							A2(
							$author$project$Pyxis$Components$Form$Fieldset$withContent,
							_List_fromArray(
								[
									A2(
									$author$project$Pyxis$Components$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Pyxis$Components$Grid$col,
											_List_fromArray(
												[$author$project$Pyxis$Components$Grid$Col$span5]),
											_List_fromArray(
												[searchInput])),
											A2(
											$author$project$Pyxis$Components$Grid$col,
											_List_fromArray(
												[$author$project$Pyxis$Components$Grid$Col$span1]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('search-bar__button-container')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('search-bar__button-spacer')
																]),
															_List_Nil),
															$author$project$Pyxis$Components$Button$render(
															A2(
																$author$project$Pyxis$Components$Button$withLoading,
																isButtonLoading,
																A2(
																	$author$project$Pyxis$Components$Button$withType,
																	$author$project$Pyxis$Components$Button$submit,
																	A2(
																		$author$project$Pyxis$Components$Button$withSize,
																		$author$project$Pyxis$Components$Button$sizeL,
																		A2($author$project$Pyxis$Components$Button$withIconOnly, $author$project$Pyxis$Components$IconSet$magnifyingGlass, $author$project$Pyxis$Components$Button$primary)))))
														]))
												]))
										]))
								]),
							$author$project$Pyxis$Components$Form$Fieldset$config)
						]),
					A2(
						$author$project$Pyxis$Components$Form$withClassList,
						_List_fromArray(
							[
								_Utils_Tuple2('es-fe-bo--full-width', true)
							]),
						$author$project$Pyxis$Components$Form$config))));
	});
var $author$project$Page$Search$Msg$ChangedPersonalIdNumber = function (a) {
	return {$: 1, a: a};
};
var $author$project$Translations$searchBarInputCustomerIDError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid Customer ID';
	} else {
		return 'Por favor, introduce un ID Cliente válido.';
	}
};
var $author$project$Translations$searchBarInputDniError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid DNI/NIE';
	} else {
		return 'Por favor, introduce un DNI/NIE válido.';
	}
};
var $author$project$Translations$searchBarInputEmailError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid email address.';
	} else {
		return 'Por favor, introduce una dirección de correo electrónico válida.';
	}
};
var $author$project$Translations$searchBarInputGenericError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid value and search again.';
	} else {
		return 'Por favor, introduce un valor válido y busca de nuevo.';
	}
};
var $author$project$Translations$searchBarInputOfferError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid offer ID.';
	} else {
		return 'Por favor, introduce un número de oferta válido.';
	}
};
var $author$project$Translations$searchBarInputPhoneError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid phone number.';
	} else {
		return 'Por favor, introduce un número de teléfono válido.';
	}
};
var $author$project$Translations$searchBarInputPlateNumberError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid plate number.';
	} else {
		return 'Por favor, introduce un número de matrícula válido.';
	}
};
var $author$project$Translations$searchBarInputPolicyError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid policy ID.';
	} else {
		return 'Por favor, introduce un número de póliza válido.';
	}
};
var $author$project$Translations$searchBarInputQuoteError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid quote ID.';
	} else {
		return 'Por favor, introduce un número de presupuesto válido.';
	}
};
var $author$project$Page$Search$SearchBar$validationErrorMessage = F2(
	function (i18n, error) {
		switch (error.$) {
			case 1:
				return $author$project$Translations$searchBarInputPolicyError(i18n);
			case 2:
				return $author$project$Translations$searchBarInputOfferError(i18n);
			case 3:
				return $author$project$Translations$searchBarInputQuoteError(i18n);
			case 0:
				return $author$project$Translations$searchBarInputGenericError(i18n);
			case 4:
				return $author$project$Translations$searchBarInputEmailError(i18n);
			case 5:
				return $author$project$Translations$searchBarInputDniError(i18n);
			case 6:
				return $author$project$Translations$searchBarInputPlateNumberError(i18n);
			case 7:
				return $author$project$Translations$searchBarInputPhoneError(i18n);
			case 9:
				return $author$project$Translations$searchBarInputGenericError(i18n);
			case 10:
				return $author$project$Translations$searchBarInputGenericError(i18n);
			default:
				return $author$project$Translations$searchBarInputCustomerIDError(i18n);
		}
	});
var $author$project$Page$Search$SearchBar$inputFieldValidations = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$Search$SearchQueryParam$fromStringInputToSearchInput,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Page$Search$SearchQueryParam$validateSearchInput,
			$elm$core$Result$mapError(
				$author$project$Page$Search$SearchBar$validationErrorMessage(i18n))));
};
var $author$project$Translations$searchBarInputHint = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'You can search for: DNI/NIE, policy, offer, quote, email, phone or registration number';
	} else {
		return 'Puedes buscar por: DNI/NIE, póliza, oferta, presupuesto, email, teléfono o matrícula';
	}
};
var $author$project$Translations$searchBarInputPlaceholder = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Enter the customer\'s details to start searching';
	} else {
		return 'Ingresa los datos del cliente para empezar la búsqueda';
	}
};
var $author$project$Pyxis$Components$IconSet$DocumentSigned = 149;
var $author$project$Pyxis$Components$IconSet$documentSigned = 149;
var $author$project$Pyxis$Components$IconSet$Key = 99;
var $author$project$Pyxis$Components$IconSet$key = 99;
var $author$project$Pyxis$Components$IconSet$Plate = 59;
var $author$project$Pyxis$Components$IconSet$plate = 59;
var $author$project$Page$Search$SearchQueryParam$searchInputToIcon = function (searchInput) {
	switch (searchInput.$) {
		case 0:
			return $author$project$Pyxis$Components$IconSet$user;
		case 1:
			return $author$project$Pyxis$Components$IconSet$documentSigned;
		case 2:
			return $author$project$Pyxis$Components$IconSet$mail;
		case 3:
			return $author$project$Pyxis$Components$IconSet$magnifyingGlass;
		case 4:
			return $author$project$Pyxis$Components$IconSet$plate;
		case 5:
			return $author$project$Pyxis$Components$IconSet$phone;
		default:
			return $author$project$Pyxis$Components$IconSet$key;
	}
};
var $author$project$Page$Search$SearchQueryParam$searchInputIcon = A2($elm$core$Basics$composeR, $author$project$Page$Search$SearchQueryParam$fromStringInputToSearchInput, $author$project$Page$Search$SearchQueryParam$searchInputToIcon);
var $author$project$Pyxis$Components$Field$Input$sizeM = 1;
var $author$project$Pyxis$Components$Field$Input$Text = 3;
var $author$project$Pyxis$Components$Field$Input$text = $author$project$Pyxis$Components$Field$Input$config(3);
var $author$project$Pyxis$Components$Field$Input$withClassList = F2(
	function (classes, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{f6: classes});
	});
var $author$project$Pyxis$Components$Field$Input$withHint = F2(
	function (hintMessage, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				gR: $elm$core$Maybe$Just(
					A2(
						$author$project$Pyxis$Components$Field$Hint$withFieldId,
						configuration.kg,
						$author$project$Pyxis$Components$Field$Hint$config(hintMessage)))
			});
	});
var $author$project$Pyxis$Components$Field$Input$IconAddon = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Field$Input$Prepend = 0;
var $author$project$Pyxis$Components$Field$Input$withIconPrepend = F2(
	function (icon, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				mf: $elm$core$Maybe$Just(
					{
						Y: 0,
						bk: $author$project$Pyxis$Components$Field$Input$IconAddon(icon)
					})
			});
	});
var $author$project$Pyxis$Components$Field$Input$withId = F2(
	function (id, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{kg: id});
	});
var $author$project$Pyxis$Components$Field$Input$withPlaceholder = F2(
	function (placeholder, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				h9: $elm$core$Maybe$Just(placeholder)
			});
	});
var $author$project$Pyxis$Components$Field$Input$withSize = F2(
	function (size, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aO: size});
	});
var $author$project$Page$Search$SearchBar$searchField = F2(
	function (i18n, model) {
		return A3(
			$author$project$Pyxis$Components$Field$Input$render,
			$author$project$Page$Search$Msg$ChangedPersonalIdNumber,
			model.du,
			A2(
				$author$project$Pyxis$Components$Field$Input$withHint,
				$author$project$Translations$searchBarInputHint(i18n),
				A2(
					$author$project$Pyxis$Components$Field$Input$withSize,
					$author$project$Pyxis$Components$Field$Input$sizeM,
					A3(
						$author$project$Pyxis$Components$Field$Input$withValidationOnSubmit,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$trim,
							$author$project$Page$Search$SearchBar$inputFieldValidations(i18n)),
						model.eO,
						A2(
							$author$project$Pyxis$Components$Field$Input$withPlaceholder,
							$author$project$Translations$searchBarInputPlaceholder(i18n),
							A2(
								$author$project$Pyxis$Components$Field$Input$withClassList,
								_List_fromArray(
									[
										_Utils_Tuple2('search-bar__input', true)
									]),
								A2(
									$author$project$Pyxis$Components$Field$Input$withIconPrepend,
									$author$project$Page$Search$SearchQueryParam$searchInputIcon(
										$author$project$Pyxis$Components$Field$Input$getValue(model.du)),
									A2(
										$author$project$Pyxis$Components$Field$Input$withId,
										model.lv,
										$author$project$Pyxis$Components$Field$Input$text('')))))))));
	});
var $author$project$Page$Search$SearchBar$genericSearchConfiguration = F2(
	function (i18n, model) {
		return A3(
			$author$project$Page$Search$SearchBar$formContainer,
			A2($author$project$Page$Search$SearchBar$searchField, i18n, model),
			$author$project$Page$Search$Msg$Submitted,
			$krisajenkins$remotedata$RemoteData$isLoading(model.lw) || $krisajenkins$remotedata$RemoteData$isLoading(model.kJ));
	});
var $author$project$Page$Search$SearchBar$render = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$Search$SearchBar$genericSearchConfiguration(i18n),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$html$Html$div(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('search-bar')
					]))));
};
var $author$project$Common$Offer$isCustomerInformationComplete = function (_v0) {
	var offer = _v0;
	var _v1 = offer.e$;
	switch (_v1) {
		case 0:
			return false;
		case 2:
			return false;
		case 1:
			return true;
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return true;
		case 6:
			return true;
		default:
			return true;
	}
};
var $author$project$Common$Offer$pickGrossPrice = function (offer) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Common$Price$zeroEuro,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.j8;
			},
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.jd;
				},
				$author$project$Common$Offer$pickFirstProduct(offer))));
};
var $author$project$Common$Person$pickBirthDate = function (person) {
	return $author$project$Common$Person$pickPersonData(person).aq;
};
var $author$project$Common$Offer$pickMainDriver = function (_v0) {
	var offer = _v0;
	return offer.eU;
};
var $author$project$Common$Offer$pickMainDriverBirthDate = function (offer) {
	return $author$project$Common$Person$pickBirthDate(
		$author$project$Common$Offer$pickMainDriver(offer));
};
var $author$project$Common$Offer$pickMainDriverProvince = function (offer) {
	return $author$project$Common$Person$pickAddress(
		$author$project$Common$Offer$pickMainDriver(offer)).oZ;
};
var $author$project$Common$Person$pickDocumentId = function (person) {
	return $author$project$Common$Person$pickPersonData(person).ar;
};
var $author$project$Common$Offer$pickPolicyHolderDni = function (offer) {
	return $author$project$Common$Person$pickDocumentId(
		$author$project$Common$Offer$pickPolicyHolder(offer));
};
var $author$project$Common$Person$pickRecentInsuranceCompanyName = function (person) {
	switch (person.$) {
		case 1:
			return $elm$core$Maybe$Nothing;
		case 0:
			var recentInsuranceCompanyName = person.c;
			return $elm$core$Maybe$Just(recentInsuranceCompanyName);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Common$Offer$pickRecentInsuranceCompanyName = function (_v0) {
	var offer = _v0;
	return offer.eN ? '' : A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Common$Person$pickRecentInsuranceCompanyName(offer.eU));
};
var $author$project$Common$Offer$pickStatus = function (_v0) {
	var offer = _v0;
	return offer.dx;
};
var $author$project$Common$Vehicle$pickMaker = function (_v0) {
	var vehicle = _v0;
	return vehicle.eV;
};
var $author$project$Common$Offer$pickVehicleMaker = function (offer) {
	return $author$project$Common$Vehicle$pickMaker(
		$author$project$Common$Offer$pickVehicle(offer));
};
var $author$project$Common$Vehicle$pickModel = function (_v0) {
	var vehicle = _v0;
	return vehicle.eY;
};
var $author$project$Common$Offer$pickVehicleModel = function (offer) {
	return $author$project$Common$Vehicle$pickModel(
		$author$project$Common$Offer$pickVehicle(offer));
};
var $author$project$Common$Offer$pickVehiclePlateNumber = function (offer) {
	return $author$project$Common$Vehicle$pickPlateNumber(
		$author$project$Common$Offer$pickVehicle(offer));
};
var $author$project$Page$Search$OfferSearchResult$fromOffer = function (offer) {
	return $author$project$Page$Search$OfferSearchResult$new(
		$author$project$Common$Offer$pickId(offer))(
		$author$project$Common$Offer$pickCustomerFacingId(offer))(
		$author$project$Common$Offer$pickStatus(offer))(
		$author$project$Common$Offer$pickGrossPrice(offer))(
		$elm$core$Maybe$Just(
			$author$project$Common$Offer$pickVehiclePlateNumber(offer)))(
		$author$project$Common$Offer$pickVehicleModel(offer))(
		$author$project$Common$Offer$pickVehicleMaker(offer))(
		$author$project$Common$Offer$pickPolicyHolderDni(offer))(
		$author$project$Common$Offer$pickMainDriverBirthDate(offer))(
		$author$project$Common$Offer$pickSelectedBundle(offer))(
		$author$project$Common$Offer$pickSource(offer))(
		$author$project$Common$Offer$pickStartDate(offer))(
		$author$project$Common$Offer$pickCreationDate(offer))(
		$elm$core$Maybe$Just(
			$author$project$Common$Offer$pickRecentInsuranceCompanyName(offer)))(
		$author$project$Common$Offer$pickMainDriverProvince(offer))(
		$author$project$Common$Offer$pickIsRenewal(offer))(
		$author$project$Common$Offer$isOfferGreatLakesRenewal(offer))(
		$author$project$Common$Offer$isCustomerInformationComplete(offer));
};
var $author$project$Page$Search$PolicySearchResult$fromOldPolicyModel = function (policy) {
	var product = $author$project$Common$Policy$pickProduct(policy);
	return $author$project$Page$Search$PolicySearchResult$new(
		$author$project$Common$Policy$pickId(policy))(
		$author$project$Common$Policy$pickCustomerFacingId(policy))(product.mt)(product.jd.j8)(
		$author$project$Common$Policy$pickSource(policy))(
		$author$project$Common$Policy$pickStartDate(policy))(
		$author$project$Common$Policy$pickEndDate(policy))(
		$author$project$Common$Vehicle$pickPlateNumber(
			$author$project$Common$Policy$pickVehicle(policy)))(
		$author$project$Common$Vehicle$pickMaker(
			$author$project$Common$Policy$pickVehicle(policy)))(
		$author$project$Common$Vehicle$pickModel(
			$author$project$Common$Policy$pickVehicle(policy)))(
		$author$project$Common$Person$pickDocumentId(
			$author$project$Common$Policy$pickPolicyHolder(policy)))(
		$author$project$Common$Person$pickBirthDate(
			$author$project$Common$Policy$pickPolicyHolder(policy)))(
		$author$project$Common$Person$pickPersonData(
			$author$project$Common$Policy$pickPolicyHolder(policy)).aD)(
		$author$project$Common$Person$pickPersonData(
			$author$project$Common$Policy$pickPolicyHolder(policy)).aJ)(
		$author$project$Common$Policy$pickStatus(policy))(
		$author$project$Common$Policy$pickIsARenewal(policy));
};
var $elm_community$list_extra$List$Extra$filterNot = F2(
	function (pred, list) {
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, pred),
			list);
	});
var $author$project$Common$Policy$hasApplicationId = F2(
	function (applicationId, _v0) {
		var policy = _v0;
		return _Utils_eq(policy.fO, applicationId);
	});
var $author$project$Page$Search$View$isOfferApplicationCompletedByPolicies = F2(
	function (policies, applicationId) {
		return A2(
			$elm$core$List$any,
			$author$project$Common$Policy$hasApplicationId(applicationId),
			policies);
	});
var $author$project$Common$Offer$pickApplicationId = function (_v0) {
	var offer = _v0;
	return offer.fO;
};
var $author$project$Page$Search$View$removeOffersWithApplicationsCompletedByPolicies = function (policies) {
	return $elm_community$list_extra$List$Extra$filterNot(
		A2(
			$elm$core$Basics$composeR,
			$author$project$Common$Offer$pickApplicationId,
			$author$project$Page$Search$View$isOfferApplicationCompletedByPolicies(policies)));
};
var $author$project$Page$Search$View$renderEmptyTitle = function (title) {
	return $author$project$Pyxis$Components$Title$render(
		A2(
			$author$project$Pyxis$Components$Title$withFontWeight,
			$author$project$Pyxis$Tokens$FontWeight$tokenBold,
			A2(
				$author$project$Pyxis$Components$Title$withSize,
				$author$project$Pyxis$Tokens$TitleSize$tokenM,
				$author$project$Pyxis$Components$Title$config(
					A2($elm$html$Html$div, _List_Nil, title)))));
};
var $author$project$Translations$searchResultsBeforeSearchText = F2(
	function (divAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'div',
					_Utils_ap(_List_Nil, divAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text('Hey, it\'s a bit empty here.')
						])),
					A3(
					$elm$html$Html$node,
					'div',
					_Utils_ap(_List_Nil, divAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text('Ready to change that?')
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'div',
					_Utils_ap(_List_Nil, divAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text('Oye, esto está algo vacío.')
						])),
					A3(
					$elm$html$Html$node,
					'div',
					_Utils_ap(_List_Nil, divAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text('¿Te apetece transformarlo?')
						]))
				]);
		}
	});
var $author$project$Page$Search$View$renderBeforeSearch = function (i18n) {
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-result__no-search-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src('/assets/bag.svg'),
						$elm$html$Html$Attributes$class('search-result-status-image')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('search-result__no-search-text')
					]),
				_List_fromArray(
					[
						$author$project$Page$Search$View$renderEmptyTitle(
						A2($author$project$Translations$searchResultsBeforeSearchText, _List_Nil, i18n))
					]))
			]));
};
var $author$project$Page$Search$Msg$ResetSearch = {$: 10};
var $author$project$Translations$searchResultsClearSearchButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Clear search';
	} else {
		return 'Buscar nuevamente';
	}
};
var $author$project$Translations$searchResultsNoResultsText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'We couldn’t find any result. Try again.';
	} else {
		return 'No hemos encontrado ningun resultado con que coincida con esos datos. Asegúrate de que son correctos y busca de nuevo.';
	}
};
var $author$project$Translations$searchResultsNoResultsTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Sorry, no results!';
	} else {
		return 'Lo siento, no hay resultados a la vista.';
	}
};
var $author$project$Pyxis$Components$Text$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{f6: classList});
	});
var $author$project$Page$Search$View$renderNoResults = function (i18n) {
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-result__no-results-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src('/assets/box.svg'),
						$elm$html$Html$Attributes$class('search-result-status-image')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('search-result__no-results-info')
					]),
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Title$render(
						A2(
							$author$project$Pyxis$Components$Title$withFontWeight,
							$author$project$Pyxis$Tokens$FontWeight$tokenBold,
							A2(
								$author$project$Pyxis$Components$Title$withSize,
								$author$project$Pyxis$Tokens$TitleSize$tokenM,
								A2(
									$author$project$Pyxis$Components$Title$withClassList,
									_List_fromArray(
										[
											_Utils_Tuple2('no-results-info-typo', true)
										]),
									$author$project$Pyxis$Components$Title$config(
										$elm$html$Html$text(
											$author$project$Translations$searchResultsNoResultsTitle(i18n))))))),
						$author$project$Pyxis$Components$Text$render(
						A2(
							$author$project$Pyxis$Components$Text$withFontWeight,
							$author$project$Pyxis$Tokens$FontWeight$tokenBook,
							A2(
								$author$project$Pyxis$Components$Text$withSize,
								$author$project$Pyxis$Tokens$TextSize$tokenL,
								A2(
									$author$project$Pyxis$Components$Text$withClassList,
									_List_fromArray(
										[
											_Utils_Tuple2('no-results-info-typo', true)
										]),
									A2(
										$author$project$Pyxis$Components$Text$withColor,
										$author$project$Pyxis$Tokens$TypographyColor$tokenContentWeak,
										$author$project$Pyxis$Components$Text$config(
											$elm$html$Html$text(
												$author$project$Translations$searchResultsNoResultsText(i18n)))))))),
						$author$project$Pyxis$Components$Button$render(
						A2(
							$author$project$Pyxis$Components$Button$withOnClick,
							$author$project$Page$Search$Msg$ResetSearch,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$searchResultsClearSearchButtonLabel(i18n),
								A2($author$project$Pyxis$Components$Button$withSize, $author$project$Pyxis$Components$Button$sizeL, $author$project$Pyxis$Components$Button$ghost))))
					]))
			]));
};
var $author$project$Page$Search$Msg$RedirectToOfferDetails = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Search$OfferSearchResult$pickCustomerFacingId = function (_v0) {
	var offer = _v0;
	return offer.mI;
};
var $author$project$Page$Search$OfferSearchResult$pickBundleSlug = function (_v0) {
	var offer = _v0;
	return offer.mt;
};
var $author$project$Page$Search$OfferResults$coverageName = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$Search$OfferSearchResult$pickBundleSlug,
		$author$project$Common$Product$bundleSlugToString(i18n));
};
var $author$project$Page$Search$OfferResults$offerSourceLabel = function (source) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('text-l-bold', true),
						_Utils_Tuple2(
						'c-brand',
						$author$project$Common$Source$isPrimaSource(source))
					]))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Common$Source$toString(source))
			]));
};
var $author$project$Page$Search$OfferSearchResult$pickCreationDate = function (_v0) {
	var offer = _v0;
	return offer.gd;
};
var $author$project$Page$Search$OfferSearchResult$pickOfferBy = function (_v0) {
	var offer = _v0;
	return offer.hz;
};
var $author$project$Page$Search$OfferSearchResult$pickStartDate = function (_v0) {
	var offer = _v0;
	return offer.lL;
};
var $author$project$Page$Search$OfferResults$renderBottomRowItem = F2(
	function (title, text) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				text,
				A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Pyxis$Components$Button$Min = 0;
var $author$project$Pyxis$Components$Button$min = function (_v0) {
	var configuration = _v0;
	return _Utils_update(
		configuration,
		{dR: 0});
};
var $author$project$Translations$searchResultsViewOfferButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'View offer';
	} else {
		return 'Ver oferta';
	}
};
var $author$project$Page$Search$OfferResults$renderViewButton = F2(
	function (i18n, actions) {
		return $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withWidth,
				$author$project$Pyxis$Components$Button$min,
				A2(
					$author$project$Pyxis$Components$Button$withOnClick,
					actions.e6,
					A2(
						$author$project$Pyxis$Components$Button$withSize,
						$author$project$Pyxis$Components$Button$sizeM,
						A2(
							$author$project$Pyxis$Components$Button$withType,
							$author$project$Pyxis$Components$Button$button,
							A2(
								$author$project$Pyxis$Components$Button$withClassList,
								_List_fromArray(
									[
										_Utils_Tuple2('search-result__offer__bottomrow__buttons__cta', true)
									]),
								A2(
									$author$project$Pyxis$Components$Button$withText,
									$author$project$Translations$searchResultsViewOfferButtonLabel(i18n),
									$author$project$Pyxis$Components$Button$tertiary)))))));
	});
var $author$project$Page$Search$OfferResults$renderButtons = F2(
	function (i18n, actions) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-result__offer__bottomrow__cell search-result__offer__bottomrow__buttons')
				]),
			_List_fromArray(
				[
					A2($author$project$Page$Search$OfferResults$renderViewButton, i18n, actions)
				]));
	});
var $author$project$Translations$searchResultsCoverTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Cover selected';
	} else {
		return 'Cobertura seleccionada';
	}
};
var $author$project$Translations$searchResultsCreationDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Creation date';
	} else {
		return 'Fecha de la oferta';
	}
};
var $author$project$Translations$searchResultsOfferSourceLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Offer by';
	} else {
		return 'Oferta de';
	}
};
var $author$project$Translations$searchResultsStartDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Start date';
	} else {
		return 'Fecha de inicio';
	}
};
var $author$project$Pyxis$Components$List$withDivider = F2(
	function (divider, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{gq: divider});
	});
var $author$project$Page$Search$OfferResults$bottomRow = F3(
	function (i18n, actions, offer) {
		var items = _List_fromArray(
			[
				A2(
				$author$project$Page$Search$OfferResults$renderBottomRowItem,
				$author$project$Translations$searchResultsCoverTitle(i18n),
				$elm$html$Html$text(
					A2($author$project$Page$Search$OfferResults$coverageName, i18n, offer))),
				A2(
				$author$project$Page$Search$OfferResults$renderBottomRowItem,
				$author$project$Translations$searchResultsOfferSourceLabel(i18n),
				$author$project$Page$Search$OfferResults$offerSourceLabel(
					$author$project$Page$Search$OfferSearchResult$pickOfferBy(offer))),
				A2(
				$author$project$Page$Search$OfferResults$renderBottomRowItem,
				$author$project$Translations$searchResultsStartDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Page$Search$OfferSearchResult$pickStartDate(offer)))),
				A2(
				$author$project$Page$Search$OfferResults$renderBottomRowItem,
				$author$project$Translations$searchResultsCreationDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Page$Search$OfferSearchResult$pickCreationDate(offer))))
			]);
		var list = $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withItems,
				items,
				A2(
					$author$project$Pyxis$Components$List$withEmphasis,
					$author$project$Pyxis$Components$List$emphasisText,
					A2(
						$author$project$Pyxis$Components$List$withDivider,
						true,
						A2(
							$author$project$Pyxis$Components$List$withItemOrientation,
							$author$project$Pyxis$Components$List$itemOrientationBlock,
							A2(
								$author$project$Pyxis$Components$List$withOrientation,
								$author$project$Pyxis$Components$List$inline,
								A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl)))))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('display-flex search-result__bottomrow')
				]),
			_List_fromArray(
				[
					list,
					A2($author$project$Page$Search$OfferResults$renderButtons, i18n, actions)
				]));
	});
var $author$project$Page$Search$OfferResults$renderCustomerFacingIdLabel = A2($elm$core$Basics$composeL, $elm$html$Html$text, $author$project$Page$Search$OfferSearchResult$pickCustomerFacingId);
var $author$project$Page$Search$OfferSearchResult$pickVehicleMake = function (_v0) {
	var offer = _v0;
	return offer.i0;
};
var $author$project$Page$Search$OfferSearchResult$pickVehicleModel = function (_v0) {
	var offer = _v0;
	return offer.i2;
};
var $author$project$Page$Search$OfferSearchResult$pickVehiclePlateNumber = function (_v0) {
	var offer = _v0;
	return offer.i3;
};
var $author$project$Page$Search$OfferResults$renderVehicleInfo = function (offer) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pointed-text')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Page$Search$OfferSearchResult$pickVehiclePlateNumber(offer)))
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								[
									$author$project$Page$Search$OfferSearchResult$pickVehicleMake(offer),
									$author$project$Page$Search$OfferSearchResult$pickVehicleModel(offer)
								])))
					]))
			]));
};
var $author$project$Page$Search$OfferResults$renderInfoBlock = function (offer) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-results__offer__info-block')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Icon$render(
				A2(
					$author$project$Pyxis$Components$Icon$withSize,
					$author$project$Pyxis$Components$Icon$sizeL,
					$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$car))),
				$author$project$Page$Search$OfferResults$renderVehicleInfo(offer)
			]));
};
var $author$project$Page$Search$OfferSearchResult$pickIsARenewal = function (_v0) {
	var offer = _v0;
	return offer.gZ;
};
var $author$project$Page$Search$OfferSearchResult$renewalBadge = F2(
	function (customClass, i18n) {
		return $author$project$Pyxis$Components$Badge$render(
			A2(
				$author$project$Pyxis$Components$Badge$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2(customClass, true)
					]),
				A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusRenewal(i18n),
					$author$project$Pyxis$Components$Badge$brand)));
	});
var $author$project$Page$Search$OfferSearchResult$renderRenewalBadge = F3(
	function (customClass, i18n, offer) {
		return A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			$author$project$Page$Search$OfferSearchResult$pickIsARenewal(offer),
			A2($author$project$Page$Search$OfferSearchResult$renewalBadge, customClass, i18n));
	});
var $author$project$Page$Search$OfferSearchResult$statusBadge = F2(
	function (i18n, _v0) {
		var offer = _v0;
		var _v1 = offer.dx;
		switch (_v1) {
			case 8:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusPurchasable(i18n),
					$author$project$Pyxis$Components$Badge$success);
			case 4:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusExpired(i18n),
					$author$project$Pyxis$Components$Badge$neutral);
			case 3:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusStartDateExpired(i18n),
					$author$project$Pyxis$Components$Badge$alert);
			case 7:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusPurchased(i18n),
					$author$project$Pyxis$Components$Badge$brand);
			case 5:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusBlocked(i18n),
					$author$project$Pyxis$Components$Badge$error);
			case 6:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusRequoted(i18n),
					$author$project$Pyxis$Components$Badge$error);
			case 0:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusNewPrice(i18n),
					$author$project$Pyxis$Components$Badge$success);
			case 1:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusNewProduct(i18n),
					$author$project$Pyxis$Components$Badge$success);
			default:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusMissingDocuments(i18n),
					$author$project$Pyxis$Components$Badge$alert);
		}
	});
var $author$project$Page$Search$OfferSearchResult$renderStatusBadge = F2(
	function (customClass, i18n) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Page$Search$OfferSearchResult$statusBadge(i18n),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Badge$withClassList(
					_List_fromArray(
						[
							_Utils_Tuple2(customClass, true)
						])),
				$author$project$Pyxis$Components$Badge$render));
	});
var $author$project$Page$Search$OfferResults$identifierRow = F2(
	function (i18n, offer) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-result__offer__identifier-row')
				]),
			_List_fromArray(
				[
					$author$project$Page$Search$OfferResults$renderCustomerFacingIdLabel(offer),
					A3($author$project$Page$Search$OfferSearchResult$renderStatusBadge, 'search-results__offer__status-badge', i18n, offer),
					A3($author$project$Page$Search$OfferSearchResult$renderRenewalBadge, 'search-results__offer__status-badge', i18n, offer),
					$author$project$Page$Search$OfferResults$renderInfoBlock(offer)
				]));
	});
var $author$project$Page$Search$OfferSearchResult$pickMainDriverBirthDate = function (_v0) {
	var offer = _v0;
	return offer.hd;
};
var $author$project$Page$Search$OfferSearchResult$pickMainDriverProvince = function (_v0) {
	var offer = _v0;
	return offer.he;
};
var $author$project$Page$Search$OfferSearchResult$pickMainDriverRecentInsuranceCompanyName = function (_v0) {
	var offer = _v0;
	return offer.hf;
};
var $author$project$Page$Search$OfferSearchResult$pickPolicyholderDni = function (_v0) {
	var offer = _v0;
	return offer.id;
};
var $author$project$Page$Search$OfferResults$renderSecondaryRowItem = F2(
	function (title, text) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				$elm$html$Html$text(text),
				A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Translations$searchResultsCurrentInsuranceLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Current insurance';
	} else {
		return 'Aseguradora actual';
	}
};
var $author$project$Translations$searchResultsDateOfBirthLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Driver date of birth';
	} else {
		return 'Fecha de nacimiento del cliente';
	}
};
var $author$project$Translations$searchResultsDocumentLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'DNI/NIE';
	} else {
		return 'DNI/NIE';
	}
};
var $author$project$Translations$searchResultsProvinceLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Province';
	} else {
		return 'Provincia';
	}
};
var $author$project$Page$Search$OfferResults$secondaryRow = F2(
	function (i18n, offer) {
		var items = _List_fromArray(
			[
				A2(
				$author$project$Page$Search$OfferResults$renderSecondaryRowItem,
				$author$project$Translations$searchResultsDocumentLabel(i18n),
				$author$project$Page$Search$OfferSearchResult$pickPolicyholderDni(offer)),
				A2(
				$author$project$Page$Search$OfferResults$renderSecondaryRowItem,
				$author$project$Translations$searchResultsDateOfBirthLabel(i18n),
				$author$project$Common$Locale$formatDate(
					$author$project$Page$Search$OfferSearchResult$pickMainDriverBirthDate(offer))),
				A2(
				$author$project$Page$Search$OfferResults$renderSecondaryRowItem,
				$author$project$Translations$searchResultsCurrentInsuranceLabel(i18n),
				A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$Page$Search$OfferSearchResult$pickMainDriverRecentInsuranceCompanyName(offer))),
				A2(
				$author$project$Page$Search$OfferResults$renderSecondaryRowItem,
				$author$project$Translations$searchResultsProvinceLabel(i18n),
				$author$project$Page$Search$OfferSearchResult$pickMainDriverProvince(offer))
			]);
		return $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withItemOrientation,
				$author$project$Pyxis$Components$List$itemOrientationInline,
				A2(
					$author$project$Pyxis$Components$List$withItems,
					items,
					A2(
						$author$project$Pyxis$Components$List$withEmphasis,
						$author$project$Pyxis$Components$List$emphasisText,
						A2(
							$author$project$Pyxis$Components$List$withOrientation,
							$author$project$Pyxis$Components$List$inline,
							A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl))))));
	});
var $author$project$Page$Search$OfferResults$detailsColumn = F2(
	function (i18n, offer) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-result__offer__details-column')
				]),
			_List_fromArray(
				[
					A2($author$project$Page$Search$OfferResults$identifierRow, i18n, offer),
					A2($author$project$Page$Search$OfferResults$secondaryRow, i18n, offer)
				]));
	});
var $author$project$Page$Search$OfferSearchResult$pickGrossPrice = function (_v0) {
	var offer = _v0;
	return offer.cT;
};
var $author$project$Page$Search$OfferResults$priceColumn = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$Search$OfferSearchResult$pickGrossPrice,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Common$Price$toHtmlWithLargeSize(i18n),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$singleton,
				$elm$html$Html$div(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('search-result__offer__price-column')
						])))));
};
var $author$project$Page$Search$OfferResults$detailsAndPriceRow = F2(
	function (i18n, offer) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-result__offer__details-and-price-row')
				]),
			_List_fromArray(
				[
					A2($author$project$Page$Search$OfferResults$detailsColumn, i18n, offer),
					A2($author$project$Page$Search$OfferResults$priceColumn, i18n, offer)
				]));
	});
var $author$project$Page$Search$OfferSearchResult$pickStatus = function (_v0) {
	var offer = _v0;
	return offer.dx;
};
var $author$project$Page$Search$OfferSearchResult$pickIsCustomerInformationComplete = function (_v0) {
	var offer = _v0;
	return offer.g$;
};
var $author$project$Translations$searchResultsCustomerInformationMissing = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Customer information missing';
	} else {
		return 'Información del cliente pendiente';
	}
};
var $author$project$Page$Search$OfferResults$renderBadgeForIncompleteCustomerInfo = function (i18n) {
	return $author$project$Pyxis$Components$Badge$render(
		A2(
			$author$project$Pyxis$Components$Badge$withClassList,
			_List_fromArray(
				[
					_Utils_Tuple2('search-result__offer-tag-missing-row', true)
				]),
			A2(
				$author$project$Pyxis$Components$Badge$withText,
				$author$project$Translations$searchResultsCustomerInformationMissing(i18n),
				$author$project$Pyxis$Components$Badge$error)));
};
var $author$project$Page$Search$OfferResults$renderOfferInfoTag = F2(
	function (i18n, offer) {
		return A2(
			$author$project$Pyxis$Commons$Render$renderIf,
			$author$project$Page$Search$OfferSearchResult$pickIsCustomerInformationComplete(offer),
			$author$project$Page$Search$OfferResults$renderBadgeForIncompleteCustomerInfo(i18n));
	});
var $author$project$Page$Search$OfferResults$labelRow = F2(
	function (i18n, offer) {
		var _v0 = $author$project$Page$Search$OfferSearchResult$pickStatus(offer);
		switch (_v0) {
			case 8:
				return A2($author$project$Page$Search$OfferResults$renderOfferInfoTag, i18n, offer);
			case 4:
				return $author$project$Pyxis$Commons$Render$empty;
			case 3:
				return A2($author$project$Page$Search$OfferResults$renderOfferInfoTag, i18n, offer);
			case 7:
				return $author$project$Pyxis$Commons$Render$empty;
			case 5:
				return $author$project$Pyxis$Commons$Render$empty;
			case 6:
				return $author$project$Pyxis$Commons$Render$empty;
			case 0:
				return A2($author$project$Page$Search$OfferResults$renderOfferInfoTag, i18n, offer);
			case 1:
				return A2($author$project$Page$Search$OfferResults$renderOfferInfoTag, i18n, offer);
			default:
				return A2($author$project$Page$Search$OfferResults$renderOfferInfoTag, i18n, offer);
		}
	});
var $author$project$Page$Search$OfferSearchResult$pickIsAGreatLakesRenewal = function (_v0) {
	var offer = _v0;
	return offer.gY;
};
var $author$project$Page$Search$OfferResults$renderGreatLakesBanner = function (i18n) {
	return $author$project$Pyxis$Components$Message$render(
		A2(
			$author$project$Pyxis$Components$Message$withContent,
			A2($author$project$Translations$gliseRenewalBannerMessage, _List_Nil, i18n),
			A2(
				$author$project$Pyxis$Components$Message$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2('search-result__offer__great-lakes-banner', true)
					]),
				$author$project$Pyxis$Components$Message$alert($author$project$Pyxis$Components$Message$tintBackground))));
};
var $author$project$Page$Search$OfferResults$viewResult = F3(
	function (i18n, actions, offer) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-results__offer-result radius-xl padding-h-m padding-v-xs')
				]),
			_List_fromArray(
				[
					A2($author$project$Page$Search$OfferResults$labelRow, i18n, offer),
					A2($author$project$Page$Search$OfferResults$detailsAndPriceRow, i18n, offer),
					A2(
					$author$project$Common$Render$ifCondition,
					$author$project$Page$Search$OfferResults$renderGreatLakesBanner(i18n),
					$author$project$Page$Search$OfferSearchResult$pickIsAGreatLakesRenewal(offer)),
					A3($author$project$Page$Search$OfferResults$bottomRow, i18n, actions, offer)
				]));
	});
var $author$project$Page$Search$OfferResults$toOfferResult = F2(
	function (i18n, offer) {
		return A3(
			$author$project$Page$Search$OfferResults$viewResult,
			i18n,
			{
				e6: $author$project$Page$Search$Msg$RedirectToOfferDetails(
					$author$project$Page$Search$OfferSearchResult$pickCustomerFacingId(offer))
			},
			offer);
	});
var $author$project$Page$Search$OfferResults$view = F2(
	function (i18n, offers) {
		return A2(
			$elm$core$List$map,
			$author$project$Page$Search$OfferResults$toOfferResult(i18n),
			offers);
	});
var $author$project$Page$Search$Msg$OnViewPolicyClicked = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Search$PolicySearchResult$pickId = function (_v0) {
	var policy = _v0;
	return policy.kg;
};
var $author$project$Page$Search$PolicyResults$onClickViewPolicy = function (policy) {
	return $author$project$Page$Search$Msg$OnViewPolicyClicked(
		$author$project$Page$Search$PolicySearchResult$pickId(policy));
};
var $author$project$Page$Search$PolicySearchResult$pickBundleSlug = function (_v0) {
	var policy = _v0;
	return policy.mt;
};
var $author$project$Page$Search$PolicySearchResult$pickCustomerFacingId = function (_v0) {
	var policy = _v0;
	return policy.mI;
};
var $author$project$Page$Search$PolicySearchResult$pickEndDate = function (_v0) {
	var policy = _v0;
	return policy.et;
};
var $author$project$Page$Search$PolicySearchResult$pickGrossPrice = function (_v0) {
	var policy = _v0;
	return policy.cT;
};
var $author$project$Page$Search$PolicySearchResult$pickPolicyholderDateOfBirth = function (_v0) {
	var policy = _v0;
	return policy.ic;
};
var $author$project$Page$Search$PolicySearchResult$pickPolicyholderDni = function (_v0) {
	var policy = _v0;
	return policy.id;
};
var $author$project$Page$Search$PolicySearchResult$pickPolicyholderFirstName = function (_v0) {
	var policy = _v0;
	return policy.ie;
};
var $author$project$Page$Search$PolicySearchResult$pickPolicyholderLastName = function (_v0) {
	var policy = _v0;
	return policy.$8;
};
var $author$project$Page$Search$PolicySearchResult$pickSource = function (_v0) {
	var policy = _v0;
	return policy.iA;
};
var $author$project$Page$Search$PolicySearchResult$pickStartDate = function (_v0) {
	var policy = _v0;
	return policy.lL;
};
var $author$project$Page$Search$PolicyResults$policySourceLabel = function (source) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('text-l-bold', true),
						_Utils_Tuple2(
						'c-brand',
						$author$project$Common$Source$isPrimaSource(source))
					]))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Common$Source$toString(source))
			]));
};
var $author$project$Page$Search$PolicySearchResult$pickIsARenewal = function (_v0) {
	var policy = _v0;
	return policy.gZ;
};
var $author$project$Page$Search$PolicySearchResult$renewalBadge = F2(
	function (customClass, i18n) {
		return $author$project$Pyxis$Components$Badge$render(
			A2(
				$author$project$Pyxis$Components$Badge$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2(customClass, true)
					]),
				A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusRenewal(i18n),
					$author$project$Pyxis$Components$Badge$brand)));
	});
var $author$project$Page$Search$PolicySearchResult$renderRenewalBadge = F3(
	function (customClass, i18n, offer) {
		return A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			$author$project$Page$Search$PolicySearchResult$pickIsARenewal(offer),
			A2($author$project$Page$Search$PolicySearchResult$renewalBadge, customClass, i18n));
	});
var $author$project$Page$Search$PolicySearchResult$statusBadge = F2(
	function (i18n, _v0) {
		var policy = _v0;
		return A2($author$project$Common$PolicyStatus$statusBadge, i18n, policy.dx);
	});
var $author$project$Page$Search$PolicySearchResult$renderStatusBadge = F2(
	function (customClass, i18n) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Page$Search$PolicySearchResult$statusBadge(i18n),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Badge$withClassList(
					_List_fromArray(
						[
							_Utils_Tuple2(customClass, true)
						])),
				$author$project$Pyxis$Components$Badge$render));
	});
var $author$project$Translations$searchResultsEndDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'End date';
	} else {
		return 'Fecha de finalización';
	}
};
var $author$project$Translations$searchResultsPolicySourceLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy by';
	} else {
		return 'Póliza de';
	}
};
var $author$project$Translations$searchResultsPolicyholderDateOfBirthLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Customer date of birth';
	} else {
		return 'Fecha de nacimiento del cliente';
	}
};
var $author$project$Translations$searchResultsPolicyholderName = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy holder name ';
	} else {
		return 'Nombre del tomador';
	}
};
var $author$project$Page$Search$PolicyResults$viewBottomRowItem = F2(
	function (title, value) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				value,
				A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Page$Search$PolicySearchResult$pickVehicleMaker = function (_v0) {
	var policy = _v0;
	return policy.i1;
};
var $author$project$Page$Search$PolicySearchResult$pickVehicleModel = function (_v0) {
	var policy = _v0;
	return policy.i2;
};
var $author$project$Page$Search$PolicySearchResult$pickVehiclePlateNumber = function (_v0) {
	var policy = _v0;
	return policy.i3;
};
var $author$project$Page$Search$PolicyResults$renderVehicleInfo = function (vehicle) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pointed-text')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Page$Search$PolicySearchResult$pickVehiclePlateNumber(vehicle))
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								[
									$author$project$Page$Search$PolicySearchResult$pickVehicleMaker(vehicle),
									$author$project$Page$Search$PolicySearchResult$pickVehicleModel(vehicle)
								])))
					]))
			]));
};
var $author$project$Page$Search$PolicyResults$viewInfoBlock = function (policy) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-results__policy__info-block')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Icon$render(
				A2(
					$author$project$Pyxis$Components$Icon$withSize,
					$author$project$Pyxis$Components$Icon$sizeL,
					$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$car))),
				$author$project$Page$Search$PolicyResults$renderVehicleInfo(policy)
			]));
};
var $author$project$Translations$searchResultsViewPolicyButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'View policy';
	} else {
		return 'Ver póliza';
	}
};
var $author$project$Page$Search$PolicyResults$viewPolicyButton = F2(
	function (i18n, action) {
		return $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withWidth,
				$author$project$Pyxis$Components$Button$min,
				A2(
					$author$project$Pyxis$Components$Button$withTestId,
					'view-policy',
					A2(
						$author$project$Pyxis$Components$Button$withId,
						'view-policy',
						A2(
							$author$project$Pyxis$Components$Button$withOnClick,
							action.e7,
							A2(
								$author$project$Pyxis$Components$Button$withSize,
								$author$project$Pyxis$Components$Button$sizeM,
								A2(
									$author$project$Pyxis$Components$Button$withType,
									$author$project$Pyxis$Components$Button$button,
									A2(
										$author$project$Pyxis$Components$Button$withText,
										$author$project$Translations$searchResultsViewPolicyButtonLabel(i18n),
										$author$project$Pyxis$Components$Button$tertiary))))))));
	});
var $author$project$Translations$searchResultsPolicyBadgeText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy';
	} else {
		return 'Póliza';
	}
};
var $author$project$Page$Search$PolicyResults$viewPolicyTag = function (i18n) {
	return $author$project$Pyxis$Components$Badge$render(
		A2(
			$author$project$Pyxis$Components$Badge$withClassList,
			_List_fromArray(
				[
					_Utils_Tuple2('search-result__tag-policy-row', true)
				]),
			A2(
				$author$project$Pyxis$Components$Badge$withText,
				$author$project$Translations$searchResultsPolicyBadgeText(i18n),
				A2($author$project$Pyxis$Components$Badge$withEmphasis, $author$project$Pyxis$Components$Badge$strong, $author$project$Pyxis$Components$Badge$brand))));
};
var $author$project$Page$Search$PolicyResults$viewSecondaryRowItem = F2(
	function (title, value) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				$elm$html$Html$text(value),
				A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Page$Search$PolicyResults$viewResult = F3(
	function (i18n, action, policy) {
		var secondaryRowItems = _List_fromArray(
			[
				A2(
				$author$project$Page$Search$PolicyResults$viewSecondaryRowItem,
				$author$project$Translations$searchResultsDocumentLabel(i18n),
				$author$project$Page$Search$PolicySearchResult$pickPolicyholderDni(policy)),
				A2(
				$author$project$Page$Search$PolicyResults$viewSecondaryRowItem,
				$author$project$Translations$searchResultsPolicyholderDateOfBirthLabel(i18n),
				$author$project$Common$Locale$formatDate(
					$author$project$Page$Search$PolicySearchResult$pickPolicyholderDateOfBirth(policy))),
				A2(
				$author$project$Page$Search$PolicyResults$viewSecondaryRowItem,
				$author$project$Translations$searchResultsPolicyholderName(i18n),
				$author$project$Page$Search$PolicySearchResult$pickPolicyholderFirstName(policy) + (' ' + $author$project$Page$Search$PolicySearchResult$pickPolicyholderLastName(policy)))
			]);
		var secondaryRow = $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2('search-result__policy__secondary-row', true)
					]),
				A2(
					$author$project$Pyxis$Components$List$withItems,
					secondaryRowItems,
					A2(
						$author$project$Pyxis$Components$List$withEmphasis,
						$author$project$Pyxis$Components$List$emphasisText,
						A2(
							$author$project$Pyxis$Components$List$withItemOrientation,
							$author$project$Pyxis$Components$List$itemOrientationInline,
							A2(
								$author$project$Pyxis$Components$List$withOrientation,
								$author$project$Pyxis$Components$List$inline,
								A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl)))))));
		var labelRow = $author$project$Page$Search$PolicyResults$viewPolicyTag(i18n);
		var identifierRow = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-result__policy__identifier-row')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Page$Search$PolicySearchResult$pickCustomerFacingId(policy)),
					A3($author$project$Page$Search$PolicySearchResult$renderStatusBadge, 'search-results__policy__status-badge', i18n, policy),
					A3($author$project$Page$Search$PolicySearchResult$renderRenewalBadge, 'search-results__policy__status-badge', i18n, policy),
					$author$project$Page$Search$PolicyResults$viewInfoBlock(policy),
					secondaryRow
				]));
		var topRow = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-result__policy__top-row')
				]),
			_List_fromArray(
				[
					identifierRow,
					A2(
					$author$project$Common$Price$toHtmlWithLargeSize,
					i18n,
					$author$project$Page$Search$PolicySearchResult$pickGrossPrice(policy))
				]));
		var bottomRowItems = _List_fromArray(
			[
				A2(
				$author$project$Page$Search$PolicyResults$viewBottomRowItem,
				$author$project$Translations$searchResultsCoverTitle(i18n),
				$elm$html$Html$text(
					A2(
						$author$project$Common$Product$bundleSlugToString,
						i18n,
						$author$project$Page$Search$PolicySearchResult$pickBundleSlug(policy)))),
				A2(
				$author$project$Page$Search$PolicyResults$viewBottomRowItem,
				$author$project$Translations$searchResultsPolicySourceLabel(i18n),
				$author$project$Page$Search$PolicyResults$policySourceLabel(
					$author$project$Page$Search$PolicySearchResult$pickSource(policy))),
				A2(
				$author$project$Page$Search$PolicyResults$viewBottomRowItem,
				$author$project$Translations$searchResultsStartDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Page$Search$PolicySearchResult$pickStartDate(policy)))),
				A2(
				$author$project$Page$Search$PolicyResults$viewBottomRowItem,
				$author$project$Translations$searchResultsEndDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Page$Search$PolicySearchResult$pickEndDate(policy))))
			]);
		var bottomRowList = $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withItems,
				bottomRowItems,
				A2(
					$author$project$Pyxis$Components$List$withEmphasis,
					$author$project$Pyxis$Components$List$emphasisText,
					A2(
						$author$project$Pyxis$Components$List$withDivider,
						true,
						A2(
							$author$project$Pyxis$Components$List$withItemOrientation,
							$author$project$Pyxis$Components$List$itemOrientationBlock,
							A2(
								$author$project$Pyxis$Components$List$withOrientation,
								$author$project$Pyxis$Components$List$inline,
								A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl)))))));
		var bottomRow = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('display-flex align-items-flex-end')
				]),
			_List_fromArray(
				[
					bottomRowList,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('search-result__bottomrow__cell display-flex')
						]),
					_List_fromArray(
						[
							A2($author$project$Page$Search$PolicyResults$viewPolicyButton, i18n, action)
						]))
				]));
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-results__policy-result radius-xl padding-xl')
				]),
			_List_fromArray(
				[labelRow, topRow, bottomRow]));
	});
var $author$project$Page$Search$PolicyResults$toPolicyResult = F2(
	function (i18n, policy) {
		return A3(
			$author$project$Page$Search$PolicyResults$viewResult,
			i18n,
			{
				e7: $author$project$Page$Search$PolicyResults$onClickViewPolicy(policy)
			},
			policy);
	});
var $author$project$Page$Search$PolicyResults$view = F2(
	function (i18n, results) {
		return A2(
			$elm$core$List$map,
			$author$project$Page$Search$PolicyResults$toPolicyResult(i18n),
			results);
	});
var $author$project$Page$Search$View$renderOffersAndPoliciesResults = F3(
	function (i18n, policies, offers) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-results display-grid')
				]),
			A2(
				$elm$core$List$append,
				A2($author$project$Page$Search$PolicyResults$view, i18n, policies),
				A2($author$project$Page$Search$OfferResults$view, i18n, offers)));
	});
var $author$project$Translations$searchResultsCreateOfferButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Create offer';
	} else {
		return 'Crear oferta';
	}
};
var $author$project$Page$Search$QuoteResults$createOfferButton = F2(
	function (i18n, quote) {
		var _v0 = quote.dx;
		if (!_v0) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(quote.m4),
						$elm$html$Html$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Button$render(
						A2(
							$author$project$Pyxis$Components$Button$withIconAppend,
							$author$project$Pyxis$Components$IconSet$externalLink,
							A2(
								$author$project$Pyxis$Components$Button$withSize,
								$author$project$Pyxis$Components$Button$sizeM,
								A2(
									$author$project$Pyxis$Components$Button$withText,
									$author$project$Translations$searchResultsCreateOfferButtonLabel(i18n),
									$author$project$Pyxis$Components$Button$tertiary))))
					]));
		} else {
			return $author$project$Common$Render$empty;
		}
	});
var $author$project$Page$Search$QuoteResults$listItem = F2(
	function (title, text) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				$elm$html$Html$text(text),
				A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Translations$searchResultsQuoteCreationDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Creation date';
	} else {
		return 'Fecha del presupuesto';
	}
};
var $author$project$Translations$searchResultsQuoteEmailLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Email';
	} else {
		return 'Email';
	}
};
var $author$project$Translations$searchResultsQuoteEndLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'End date';
	} else {
		return 'Fecha de finalización';
	}
};
var $author$project$Translations$searchResultsQuoteSourceLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Source by';
	} else {
		return 'Presupuesto de';
	}
};
var $author$project$Page$Search$QuoteResults$quoteDetailsContentList = F2(
	function (i18n, quote) {
		return $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withSize,
				$author$project$Pyxis$Components$List$sizeS,
				A2(
					$author$project$Pyxis$Components$List$withEmphasis,
					$author$project$Pyxis$Components$List$emphasisText,
					A2(
						$author$project$Pyxis$Components$List$withItemOrientation,
						$author$project$Pyxis$Components$List$itemOrientationInline,
						A2(
							$author$project$Pyxis$Components$List$withItems,
							_List_fromArray(
								[
									A2(
									$author$project$Page$Search$QuoteResults$listItem,
									$author$project$Translations$searchResultsQuoteSourceLabel(i18n),
									$author$project$Common$Source$toString(quote.iA)),
									A2(
									$author$project$Page$Search$QuoteResults$listItem,
									$author$project$Translations$searchResultsQuoteCreationDateLabel(i18n),
									$author$project$Common$Locale$formatDate(quote.gd)),
									A2(
									$author$project$Page$Search$QuoteResults$listItem,
									$author$project$Translations$searchResultsQuoteEndLabel(i18n),
									$author$project$Common$Locale$formatDate(quote.et)),
									A2(
									$author$project$Page$Search$QuoteResults$listItem,
									$author$project$Translations$searchResultsQuoteEmailLabel(i18n),
									A2($elm$core$Maybe$withDefault, '-', quote.oR))
								]),
							$author$project$Pyxis$Components$List$dl)))));
	});
var $author$project$Page$Search$QuoteResults$quoteIdentifier = function (quote) {
	return $author$project$Pyxis$Components$Title$render(
		A2(
			$author$project$Pyxis$Components$Title$withSize,
			$author$project$Pyxis$Tokens$TitleSize$tokenS,
			A2(
				$author$project$Pyxis$Components$Title$withFontWeight,
				$author$project$Pyxis$Tokens$FontWeight$tokenBold,
				$author$project$Pyxis$Components$Title$config(
					A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(quote.mI)
							]))))));
};
var $author$project$Translations$quoteStatusActive = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Active';
	} else {
		return 'Disponible';
	}
};
var $author$project$Translations$quoteStatusBlocked = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Blocked';
	} else {
		return 'No contratable';
	}
};
var $author$project$Translations$quoteStatusExpired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Expired';
	} else {
		return 'Caducado';
	}
};
var $author$project$Common$Quote$statusBadge = F2(
	function (i18n, quote) {
		var _v0 = quote.dx;
		switch (_v0) {
			case 0:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$quoteStatusActive(i18n),
					$author$project$Pyxis$Components$Badge$success);
			case 1:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$quoteStatusExpired(i18n),
					$author$project$Pyxis$Components$Badge$neutral);
			default:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$quoteStatusBlocked(i18n),
					$author$project$Pyxis$Components$Badge$error);
		}
	});
var $author$project$Common$Quote$renderStatusBadge = F2(
	function (customClass, i18n) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Common$Quote$statusBadge(i18n),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Badge$withClassList(
					_List_fromArray(
						[
							_Utils_Tuple2(customClass, true)
						])),
				$author$project$Pyxis$Components$Badge$render));
	});
var $author$project$Page$Search$QuoteResults$generalInfo = F2(
	function (i18n, quote) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-results__quote-result__header__general-info')
				]),
			_List_fromArray(
				[
					A3($author$project$Common$Quote$renderStatusBadge, '', i18n, quote),
					$author$project$Page$Search$QuoteResults$quoteIdentifier(quote)
				]));
	});
var $author$project$Page$Search$QuoteResults$vehicleInfo = function (vehicle) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pointed-text')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Common$Vehicle$pickPlateNumber(vehicle))
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								[
									$author$project$Common$Vehicle$pickMaker(vehicle),
									$author$project$Common$Vehicle$pickModel(vehicle)
								])))
					]))
			]));
};
var $author$project$Page$Search$QuoteResults$infoBlock = function (quote) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-results__quote-result__content__vehicle-info')
			]),
		_List_fromArray(
			[
				$author$project$Page$Search$QuoteResults$vehicleInfo(quote.i$)
			]));
};
var $author$project$Page$Search$QuoteResults$quoteDetailsHeader = F2(
	function (i18n, quote) {
		return A2(
			$author$project$Pyxis$Components$Card$withHeaderTitle,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Page$Search$QuoteResults$generalInfo, i18n, quote),
						$author$project$Page$Search$QuoteResults$infoBlock(quote)
					])),
			$author$project$Pyxis$Components$Card$header);
	});
var $author$project$Pyxis$Components$Card$withFooter = F2(
	function (footer, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				ew: $elm$core$Maybe$Just(footer)
			});
	});
var $author$project$Page$Search$QuoteResults$viewQuoteDetails = F2(
	function (i18n, quote) {
		return $author$project$Pyxis$Components$Card$render(
			A2(
				$author$project$Pyxis$Components$Card$withFooter,
				A2($author$project$Page$Search$QuoteResults$createOfferButton, i18n, quote),
				A2(
					$author$project$Pyxis$Components$Card$withContent,
					A2($author$project$Page$Search$QuoteResults$quoteDetailsContentList, i18n, quote),
					A2(
						$author$project$Pyxis$Components$Card$withHeader,
						A2($author$project$Page$Search$QuoteResults$quoteDetailsHeader, i18n, quote),
						A2(
							$author$project$Pyxis$Components$Card$withClassList,
							_List_fromArray(
								[
									_Utils_Tuple2('search-results__quote-result', true)
								]),
							$author$project$Pyxis$Components$Card$config)))));
	});
var $author$project$Page$Search$QuoteResults$view = function (i18n) {
	return $elm$core$List$map(
		$author$project$Page$Search$QuoteResults$viewQuoteDetails(i18n));
};
var $author$project$Page$Search$View$renderResults = F2(
	function (i18n, model) {
		var _v0 = _Utils_Tuple2(model.lw, model.kJ);
		_v0$1:
		while (true) {
			_v0$2:
			while (true) {
				_v0$3:
				while (true) {
					_v0$5:
					while (true) {
						switch (_v0.a.$) {
							case 3:
								var policies = _v0.a.a.lf;
								var offers = _v0.a.a.kM;
								var quotes = _v0.a.a.o$;
								if ($elm$core$List$isEmpty(offers) && ($elm$core$List$isEmpty(policies) && $elm$core$List$isEmpty(quotes))) {
									return $author$project$Page$Search$View$renderNoResults(i18n);
								} else {
									var mappedPolicies = A2($elm$core$List$map, $author$project$Page$Search$PolicySearchResult$fromOldPolicyModel, policies);
									var mappedOffers = A2(
										$elm$core$List$map,
										$author$project$Page$Search$OfferSearchResult$fromOffer,
										A2($author$project$Page$Search$View$removeOffersWithApplicationsCompletedByPolicies, policies, offers));
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('container-responsive search-results-container')
											]),
										A2(
											$elm$core$List$append,
											A2($author$project$Page$Search$QuoteResults$view, i18n, quotes),
											_List_fromArray(
												[
													A3($author$project$Page$Search$View$renderOffersAndPoliciesResults, i18n, mappedPolicies, mappedOffers)
												])));
								}
							case 1:
								switch (_v0.b.$) {
									case 3:
										break _v0$1;
									case 1:
										break _v0$2;
									default:
										break _v0$2;
								}
							case 0:
								switch (_v0.b.$) {
									case 3:
										break _v0$1;
									case 1:
										break _v0$3;
									case 0:
										var _v3 = _v0.a;
										var _v4 = _v0.b;
										return $author$project$Page$Search$View$renderBeforeSearch(i18n);
									default:
										break _v0$5;
								}
							default:
								switch (_v0.b.$) {
									case 3:
										break _v0$1;
									case 1:
										break _v0$3;
									default:
										break _v0$5;
								}
						}
					}
					return $author$project$Common$Render$empty;
				}
				var _v2 = _v0.b;
				return $author$project$Common$Render$empty;
			}
			var _v1 = _v0.a;
			return $author$project$Common$Render$empty;
		}
		var policies = _v0.b.a.lf;
		var offers = _v0.b.a.kM;
		return ($elm$core$List$isEmpty(offers) && $elm$core$List$isEmpty(policies)) ? $author$project$Page$Search$View$renderNoResults(i18n) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container-responsive search-results-container')
				]),
			A2(
				$elm$core$List$append,
				A2($author$project$Page$Search$QuoteResults$view, i18n, _List_Nil),
				_List_fromArray(
					[
						A3($author$project$Page$Search$View$renderOffersAndPoliciesResults, i18n, policies, offers)
					])));
	});
var $author$project$Page$Search$Msg$AdminSearchBar = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$Search$Msg$DisputesSearchSubmitted = {$: 13};
var $author$project$Page$Search$Msg$DisputeSearchChanged = function (a) {
	return {$: 12, a: a};
};
var $author$project$Page$Search$SearchQueryParam$paymentDisputeIcon = A2(
	$elm$core$Basics$composeR,
	$author$project$Page$Search$SearchQueryParam$fromStringInputToPaymentDispute,
	A2($elm_community$result_extra$Result$Extra$unwrap, $author$project$Pyxis$Components$IconSet$questionCircle, $author$project$Page$Search$SearchQueryParam$searchInputToIcon));
var $author$project$Page$Search$SearchBar$paymentDisputedValidations = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$Search$SearchQueryParam$fromStringInputToPaymentDispute,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Page$Search$SearchQueryParam$validatePaymentDisputes,
			$elm$core$Result$mapError(
				$author$project$Page$Search$SearchBar$validationErrorMessage(i18n))));
};
var $author$project$Translations$searchBarPaymentDisputesHint = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'You can search for: email or Customer ID';
	} else {
		return 'Puedes buscar por email o ID cliente';
	}
};
var $author$project$Translations$searchBarPaymentDisputesPlaceholder = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Enter the payment dispute\'s details to start searching';
	} else {
		return 'Ingresa los datos de las disputa para empezar la búsqueda';
	}
};
var $author$project$Page$Search$SearchBar$disputesSearchField = F2(
	function (i18n, model) {
		return A3(
			$author$project$Pyxis$Components$Field$Input$render,
			$author$project$Page$Search$Msg$DisputeSearchChanged,
			model.h7,
			A2(
				$author$project$Pyxis$Components$Field$Input$withHint,
				$author$project$Translations$searchBarPaymentDisputesHint(i18n),
				A2(
					$author$project$Pyxis$Components$Field$Input$withSize,
					$author$project$Pyxis$Components$Field$Input$sizeM,
					A3(
						$author$project$Pyxis$Components$Field$Input$withValidationOnSubmit,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$trim,
							$author$project$Page$Search$SearchBar$paymentDisputedValidations(i18n)),
						model.g3,
						A2(
							$author$project$Pyxis$Components$Field$Input$withPlaceholder,
							$author$project$Translations$searchBarPaymentDisputesPlaceholder(i18n),
							A2(
								$author$project$Pyxis$Components$Field$Input$withClassList,
								_List_fromArray(
									[
										_Utils_Tuple2('search-bar__input', true)
									]),
								A2(
									$author$project$Pyxis$Components$Field$Input$withIconPrepend,
									$author$project$Page$Search$SearchQueryParam$paymentDisputeIcon(
										$author$project$Pyxis$Components$Field$Input$getValue(model.h7)),
									A2(
										$author$project$Pyxis$Components$Field$Input$withId,
										model.lb,
										$author$project$Pyxis$Components$Field$Input$text('')))))))));
	});
var $author$project$Page$Search$SearchBar$paymentDisputesSearchConfiguration = F2(
	function (i18n, model) {
		return A3(
			$author$project$Page$Search$SearchBar$formContainer,
			A2($author$project$Page$Search$SearchBar$disputesSearchField, i18n, model),
			$author$project$Page$Search$Msg$DisputesSearchSubmitted,
			$krisajenkins$remotedata$RemoteData$isLoading(model.lw));
	});
var $author$project$Translations$searchBarTabDisputesLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Disputes';
	} else {
		return 'Disputas';
	}
};
var $author$project$Translations$searchBarTabInquiriesLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Inquiries';
	} else {
		return 'Consultas';
	}
};
var $author$project$Page$Search$SearchBar$renderTabbed = F2(
	function (i18n, model) {
		return A3(
			$author$project$Pyxis$Components$Tabs$render,
			$author$project$Page$Search$Msg$AdminSearchBar,
			model.fL,
			A2(
				$author$project$Pyxis$Components$Tabs$withVariant,
				$author$project$Pyxis$Components$Tabs$pill,
				A2(
					$author$project$Pyxis$Components$Tabs$withClassList,
					_List_fromArray(
						[
							_Utils_Tuple2('search-bar-tabbed', true)
						]),
					A2(
						$author$project$Pyxis$Components$Tabs$withTabs,
						_List_fromArray(
							[
								A2(
								$author$project$Pyxis$Components$Tabs$withContent,
								_List_fromArray(
									[
										A2($author$project$Page$Search$SearchBar$genericSearchConfiguration, i18n, model)
									]),
								A2(
									$author$project$Pyxis$Components$Tabs$withText,
									$author$project$Translations$searchBarTabInquiriesLabel(i18n),
									$author$project$Pyxis$Components$Tabs$tab)),
								A2(
								$author$project$Pyxis$Components$Tabs$withContent,
								_List_fromArray(
									[
										A2($author$project$Page$Search$SearchBar$paymentDisputesSearchConfiguration, i18n, model)
									]),
								A2(
									$author$project$Pyxis$Components$Tabs$withText,
									$author$project$Translations$searchBarTabDisputesLabel(i18n),
									$author$project$Pyxis$Components$Tabs$tab))
							]),
						$author$project$Pyxis$Components$Tabs$config('admin-search-bar')))));
	});
var $author$project$Page$Search$View$view = F3(
	function (i18n, user, model) {
		var searchBarSection = $author$project$Common$User$canSearchByCustomerId(user) ? A2($author$project$Page$Search$SearchBar$renderTabbed, i18n, model) : A2($author$project$Page$Search$SearchBar$render, i18n, model);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container-responsive padding-v-3xl search-page')
					]),
				_List_fromArray(
					[
						searchBarSection,
						A2($author$project$Page$Search$View$renderResults, i18n, model),
						A3(
						$author$project$Pyxis$Components$Toasts$render,
						$author$project$Page$Search$Msg$ToastMsg,
						model.s,
						A2(
							$author$project$Pyxis$Components$Toasts$withPlacement,
							$author$project$Pyxis$Components$Toasts$topRightPlacement,
							$author$project$Pyxis$Components$Toasts$config('search-page-toaster')))
					]))
			]);
	});
var $author$project$Page$Search$view = F3(
	function (i18n, user, model) {
		return {
			f$: A3($author$project$Page$Search$View$view, i18n, user, model),
			iS: $author$project$Translations$routeSearch(i18n)
		};
	});
var $author$project$Main$view = function (model) {
	var i18n = model.ni;
	var user = model.fB;
	var env = model.mU;
	var _v0 = model.oO;
	switch (_v0.$) {
		case 0:
			var notFoundModel = _v0.a;
			return A2(
				$author$project$Main$mapDocument,
				$author$project$Msg$NotFound,
				A2($author$project$Page$NotFound$view, i18n, notFoundModel));
		case 1:
			var notAuthorizedModel = _v0.a;
			return A2(
				$author$project$Main$mapDocument,
				$author$project$Msg$NotAuthorized,
				A2($author$project$Page$NotAuthorized$view, i18n, notAuthorizedModel));
		case 2:
			var loginModel = _v0.a;
			return A2(
				$author$project$Main$mapDocument,
				$author$project$Msg$Login,
				A3($author$project$Page$Login$view, i18n, env, loginModel));
		case 3:
			var searchModel = _v0.a;
			return A2(
				$author$project$Main$addHeaderToBody,
				model,
				A2(
					$author$project$Main$mapDocument,
					$author$project$Msg$Search,
					A3($author$project$Page$Search$view, i18n, user, searchModel)));
		case 4:
			var paymentModel = _v0.a;
			return A2(
				$author$project$Main$addHeaderToBody,
				model,
				A2(
					$author$project$Main$mapDocument,
					$author$project$Msg$Payment,
					A2($author$project$Page$Payment$view, i18n, paymentModel)));
		case 5:
			var policyModel = _v0.a;
			return A2(
				$author$project$Main$addHeaderToBody,
				model,
				A2(
					$author$project$Main$mapDocument,
					$author$project$Msg$PolicyDetails,
					A3($author$project$Page$PolicyDetails$view, i18n, user, policyModel)));
		default:
			var offerDetailsModel = _v0.a;
			return A2(
				$author$project$Main$addHeaderToBody,
				model,
				A2(
					$author$project$Main$mapDocument,
					$author$project$Msg$OfferDetails,
					A3($author$project$Page$OfferDetails$view, i18n, env, offerDetailsModel)));
	}
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{nk: $author$project$Main$init, oH: $author$project$Msg$OnUrlChange, oI: $author$project$Msg$OnUrlRequest, pp: $author$project$Main$subscriptions, pA: $author$project$Main$handle, pC: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (newSearchApiEnabled) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (newApiUrl) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (logoutPath) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (loginPath) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (localTimeZone) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (languages) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (funnelUrl) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (externalApiUrl) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (apiUrl) {
																			return $elm$json$Json$Decode$succeed(
																				{cy: apiUrl, cP: externalApiUrl, cR: funnelUrl, g8: languages, c3: localTimeZone, c4: loginPath, c5: logoutPath, c7: newApiUrl, c9: newSearchApiEnabled});
																		},
																		A2($elm$json$Json$Decode$field, 'apiUrl', $elm$json$Json$Decode$string));
																},
																A2($elm$json$Json$Decode$field, 'externalApiUrl', $elm$json$Json$Decode$string));
														},
														A2($elm$json$Json$Decode$field, 'funnelUrl', $elm$json$Json$Decode$string));
												},
												A2(
													$elm$json$Json$Decode$field,
													'languages',
													$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
										},
										A2($elm$json$Json$Decode$field, 'localTimeZone', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'loginPath', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'logoutPath', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'newApiUrl', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'newSearchApiEnabled', $elm$json$Json$Decode$bool)))(0)}});}(this));